(window["webpackJsonp"] = window["webpackJsonp"] || []).push([[0],Array(36).concat([
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "44bc83424347a76cc138db6a5e819bd2.svg";

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(794);
__webpack_require__(0);
__webpack_require__(26);
__webpack_require__(139);
__webpack_require__(980);
__webpack_require__(140);
__webpack_require__(141);
__webpack_require__(748);
__webpack_require__(749);
__webpack_require__(750);
__webpack_require__(751);
__webpack_require__(752);
__webpack_require__(753);
__webpack_require__(754);
__webpack_require__(755);
__webpack_require__(756);
__webpack_require__(991);
__webpack_require__(993);
__webpack_require__(65);
__webpack_require__(66);
if (false) {}
var i18next = __webpack_require__(18);
var i18nLanguageDetector = __webpack_require__(994);
i18next.use(i18nLanguageDetector).init({
  detection: {},
  debug: true,
  lng: 'en-US',
  nsSeparator: '|'
});
var uirouter = __webpack_require__(53);
__webpack_require__(1004);
var ngCookies = __webpack_require__(1005);
__webpack_require__(50);
var angularFileSaver = __webpack_require__(1008);
var uiBootstrap = __webpack_require__(56);
var angularSanitize = __webpack_require__(55);
var ngIdle = __webpack_require__(54);
var uiSelect = __webpack_require__(57);
var relativeDate = __webpack_require__(73);
angular.module('umCore', [angularSanitize, 'ngAnimate', ngIdle, uirouter.default, ngCookies, uiBootstrap, uiSelect, relativeDate.default.name, 'ui-notification', 'currencyFilter', 'isoCurrency', 'dibari.angular-ellipsis', 'readableTime', 'umFormViewer', 'umUser', angularFileSaver, 'ui.router.state.events']).config(["NotificationProvider", function (NotificationProvider) {
  NotificationProvider.setOptions({
    verticalSpacing: 0,
    horizontalSpacing: 30
  });
}]).run(function () {});
__webpack_require__(1009);
__webpack_require__(1010);
__webpack_require__(1011);
__webpack_require__(1012);
__webpack_require__(1013);
__webpack_require__(1014);
__webpack_require__(1015);
__webpack_require__(1016);
__webpack_require__(1017);
__webpack_require__(1018);
__webpack_require__(1019);

// require('./decorators/inputDecorator');
// require('./decorators/uibTooltipDecorator');
// require('./decorators/uiSelectDirectiveDecorator');

__webpack_require__(1020);
__webpack_require__(1021);
__webpack_require__(1022);
__webpack_require__(1023);
__webpack_require__(1024);
__webpack_require__(1025);
__webpack_require__(1026);
__webpack_require__(1027);
__webpack_require__(1028);
__webpack_require__(1029);
__webpack_require__(1030);
__webpack_require__(1031);
__webpack_require__(1032);
__webpack_require__(1033);
__webpack_require__(1034);
__webpack_require__(1035);
__webpack_require__(1036);
__webpack_require__(1037);
__webpack_require__(1038);
__webpack_require__(1040);
__webpack_require__(1041);
__webpack_require__(1042);
__webpack_require__(1043);
__webpack_require__(1044);
__webpack_require__(1045);
__webpack_require__(1046);
__webpack_require__(1047);
__webpack_require__(1048);
__webpack_require__(1049);
__webpack_require__(1050);
__webpack_require__(1051);
__webpack_require__(1052);
__webpack_require__(1053);
__webpack_require__(1054);
__webpack_require__(1055);
__webpack_require__(1056);
__webpack_require__(1057);
__webpack_require__(1058);
__webpack_require__(1059);
__webpack_require__(1060);
__webpack_require__(1073);
__webpack_require__(1074);
__webpack_require__(1075);
__webpack_require__(1076);
__webpack_require__(1077);
__webpack_require__(1078);
__webpack_require__(1081);
__webpack_require__(1082);
__webpack_require__(1083);
__webpack_require__(1084);
__webpack_require__(1085);
__webpack_require__(1086);
__webpack_require__(1087);
__webpack_require__(1088);
__webpack_require__(1089);
__webpack_require__(1090);
__webpack_require__(1091);
__webpack_require__(1092);
__webpack_require__(1093);
__webpack_require__(1094);
__webpack_require__(1095);
__webpack_require__(1096);
__webpack_require__(1097);
__webpack_require__(1098);
__webpack_require__(1099);
__webpack_require__(1100);
__webpack_require__(1101);
__webpack_require__(1102);
__webpack_require__(1103);
__webpack_require__(1104);
__webpack_require__(1105);
__webpack_require__(1106);
__webpack_require__(1108);
__webpack_require__(1109);
__webpack_require__(1110);
__webpack_require__(1111);
__webpack_require__(1112);
__webpack_require__(1113);
__webpack_require__(1114);
__webpack_require__(1115);
__webpack_require__(1116);
__webpack_require__(1117);
__webpack_require__(1118);
__webpack_require__(1119);
__webpack_require__(1121);
__webpack_require__(1122);
__webpack_require__(1123);
__webpack_require__(1124);
__webpack_require__(1125);
__webpack_require__(1126);
__webpack_require__(1127);
__webpack_require__(1128);
__webpack_require__(1129);
__webpack_require__(1130);
__webpack_require__(1131);
__webpack_require__(1132);
__webpack_require__(1133);
__webpack_require__(1134);
__webpack_require__(1138);
__webpack_require__(1139);
__webpack_require__(1141);
__webpack_require__(1142);
__webpack_require__(1143);
__webpack_require__(1144);
__webpack_require__(1145);
__webpack_require__(1146);
__webpack_require__(1147);
__webpack_require__(1148);
__webpack_require__(1149);
__webpack_require__(1150);
__webpack_require__(1151);
__webpack_require__(1152);
__webpack_require__(1153);
__webpack_require__(1154);
__webpack_require__(1155);
__webpack_require__(1156);
__webpack_require__(1158);
__webpack_require__(1159);
__webpack_require__(1160);
__webpack_require__(1161);
__webpack_require__(1162);
__webpack_require__(1163);
__webpack_require__(1164);
__webpack_require__(1165);
__webpack_require__(1166);
__webpack_require__(1167);
__webpack_require__(1168);
__webpack_require__(1169);
__webpack_require__(1170);
__webpack_require__(1171);
__webpack_require__(1172);
__webpack_require__(1173);
__webpack_require__(1174);
__webpack_require__(1175);
__webpack_require__(1176);
__webpack_require__(1177);
__webpack_require__(1178);
__webpack_require__(1179);
__webpack_require__(1180);
__webpack_require__(1181);
__webpack_require__(1182);
__webpack_require__(1183);
__webpack_require__(1184);
__webpack_require__(1185);
__webpack_require__(1186);
__webpack_require__(1187);
__webpack_require__(1188);
__webpack_require__(1189);
__webpack_require__(1190);
__webpack_require__(1191);
__webpack_require__(1192);
__webpack_require__(1193);
__webpack_require__(1194);
__webpack_require__(1195);
__webpack_require__(1196);
__webpack_require__(1197);
__webpack_require__(1198);
__webpack_require__(1199);
__webpack_require__(1200);
__webpack_require__(1201);
__webpack_require__(1202);
__webpack_require__(1203);
__webpack_require__(1204);
__webpack_require__(1205);
__webpack_require__(1206);
__webpack_require__(1207);
__webpack_require__(1208);
__webpack_require__(1209);
__webpack_require__(1210);
__webpack_require__(1211);
__webpack_require__(1212);
__webpack_require__(1213);
__webpack_require__(1214);
__webpack_require__(1215);
__webpack_require__(1216);
__webpack_require__(1217);
__webpack_require__(1218);
__webpack_require__(1219);
__webpack_require__(1220);
__webpack_require__(1221);
__webpack_require__(1222);
__webpack_require__(1223);
__webpack_require__(1224);
__webpack_require__(1225);
__webpack_require__(1226);
__webpack_require__(1227);
__webpack_require__(1228);
__webpack_require__(1229);
__webpack_require__(1230);
__webpack_require__(1231);
__webpack_require__(1232);
__webpack_require__(1233);
__webpack_require__(1234);
__webpack_require__(1235);
__webpack_require__(1236);
__webpack_require__(1237);
__webpack_require__(1238);
__webpack_require__(1239);
__webpack_require__(1240);
__webpack_require__(1241);
__webpack_require__(1244);
__webpack_require__(1245);
__webpack_require__(1246);
__webpack_require__(1247);
__webpack_require__(1248);
__webpack_require__(1249);
__webpack_require__(1251);
__webpack_require__(1252);
__webpack_require__(1253);
__webpack_require__(1254);
__webpack_require__(1255);
__webpack_require__(1256);
__webpack_require__(1257);
__webpack_require__(1258);
__webpack_require__(1259);
__webpack_require__(1260);
__webpack_require__(1261);
__webpack_require__(1262);
__webpack_require__(1263);
__webpack_require__(1264);
__webpack_require__(1265);
__webpack_require__(1266);
__webpack_require__(1267);
__webpack_require__(1268);
__webpack_require__(1269);
__webpack_require__(1270);
__webpack_require__(1271);
__webpack_require__(1272);
__webpack_require__(1273);
__webpack_require__(1274);
__webpack_require__(1275);
__webpack_require__(1276);
__webpack_require__(1277);
__webpack_require__(1278);
__webpack_require__(1279);
__webpack_require__(1280);
__webpack_require__(1281);
__webpack_require__(1282);
__webpack_require__(1283);
__webpack_require__(1284);
__webpack_require__(1285);
__webpack_require__(1286);
__webpack_require__(1288);
__webpack_require__(1289);
__webpack_require__(1290);
__webpack_require__(1291);
__webpack_require__(1292);
__webpack_require__(1293);
__webpack_require__(1294);
__webpack_require__(1295);
__webpack_require__(1296);
__webpack_require__(1297);
__webpack_require__(1298);
__webpack_require__(1299);
__webpack_require__(1300);
__webpack_require__(1301);
__webpack_require__(1302);
__webpack_require__(1303);
__webpack_require__(1304);
__webpack_require__(1305);
__webpack_require__(1306);
__webpack_require__(1307);
__webpack_require__(1308);
__webpack_require__(1309);
__webpack_require__(1310);
__webpack_require__(1311);
__webpack_require__(1312);
__webpack_require__(1313);
__webpack_require__(1314);
__webpack_require__(1315);
__webpack_require__(1316);
__webpack_require__(1317);
__webpack_require__(1318);
__webpack_require__(1319);
__webpack_require__(1320);
__webpack_require__(1321);
__webpack_require__(1322);
__webpack_require__(1323);
__webpack_require__(1324);
__webpack_require__(1325);
__webpack_require__(1328);
__webpack_require__(1329);
__webpack_require__(1330);
__webpack_require__(1331);
__webpack_require__(1332);
__webpack_require__(1333);
__webpack_require__(1334);
__webpack_require__(1335);
__webpack_require__(1336);
__webpack_require__(1337);
__webpack_require__(1339);
__webpack_require__(1340);
__webpack_require__(1341);
__webpack_require__(1342);
__webpack_require__(1343);
__webpack_require__(1344);
__webpack_require__(1345);
__webpack_require__(1346);
__webpack_require__(1347);
__webpack_require__(1348);
__webpack_require__(1349);
__webpack_require__(1350);
__webpack_require__(1355);
__webpack_require__(1356);
__webpack_require__(1357);
__webpack_require__(1358);
__webpack_require__(1359);
__webpack_require__(1360);
__webpack_require__(1361);
__webpack_require__(1362);
__webpack_require__(1363);
__webpack_require__(1364);
__webpack_require__(1365);
__webpack_require__(1366);
__webpack_require__(1367);
__webpack_require__(1368);
__webpack_require__(1369);
__webpack_require__(1370);
__webpack_require__(1371);
__webpack_require__(1372);
__webpack_require__(1373);
__webpack_require__(1374);
__webpack_require__(1375);
__webpack_require__(1376);
__webpack_require__(1377);
__webpack_require__(1378);
__webpack_require__(1379);
__webpack_require__(1380);
__webpack_require__(1381);
__webpack_require__(1382);
__webpack_require__(1383);
__webpack_require__(1384);
__webpack_require__(1385);
__webpack_require__(1386);
__webpack_require__(1387);
__webpack_require__(1388);
__webpack_require__(1389);
__webpack_require__(1390);
__webpack_require__(1391);
__webpack_require__(1392);
__webpack_require__(1393);
__webpack_require__(1394);
__webpack_require__(1395);
__webpack_require__(759);
__webpack_require__(760);
__webpack_require__(759);
__webpack_require__(760);
__webpack_require__(1397);
__webpack_require__(1398);
__webpack_require__(1403);
__webpack_require__(1404);
__webpack_require__(1405);
__webpack_require__(1406);
__webpack_require__(1407);
__webpack_require__(1408);
__webpack_require__(1409);
__webpack_require__(1410);
__webpack_require__(1411);
__webpack_require__(1412);
__webpack_require__(1413);
__webpack_require__(1414);
__webpack_require__(1415);
__webpack_require__(1416);
__webpack_require__(1417);
__webpack_require__(1424);
__webpack_require__(1425);
__webpack_require__(1426);
__webpack_require__(1433);
__webpack_require__(1434);
__webpack_require__(1435);
__webpack_require__(1436);
__webpack_require__(1437);
__webpack_require__(1438);
__webpack_require__(1439);
__webpack_require__(1440);
__webpack_require__(1441);
__webpack_require__(1442);
__webpack_require__(1443);
__webpack_require__(1444);
__webpack_require__(1445);
__webpack_require__(1446);
__webpack_require__(1447);
__webpack_require__(1448);
__webpack_require__(1449);
__webpack_require__(1450);
__webpack_require__(1451);
__webpack_require__(1452);
__webpack_require__(1453);
__webpack_require__(1454);
__webpack_require__(1455);
__webpack_require__(1456);
__webpack_require__(1457);
__webpack_require__(1458);
__webpack_require__(1459);
__webpack_require__(1460);
__webpack_require__(1461);
__webpack_require__(1462);
__webpack_require__(1463);
__webpack_require__(1464);
__webpack_require__(1466);
__webpack_require__(1467);
__webpack_require__(1468);
__webpack_require__(1469);
__webpack_require__(1470);
__webpack_require__(1471);
__webpack_require__(1472);
__webpack_require__(1473);
__webpack_require__(1475);
__webpack_require__(1476);
__webpack_require__(1477);
__webpack_require__(1478);
__webpack_require__(1479);
__webpack_require__(1480);
__webpack_require__(1481);
__webpack_require__(1482);
__webpack_require__(1483);
__webpack_require__(1484);
__webpack_require__(1485);
__webpack_require__(1486);
__webpack_require__(1487);
__webpack_require__(1488);
__webpack_require__(1489);
__webpack_require__(1490);
__webpack_require__(1491);
__webpack_require__(1492);
__webpack_require__(1493);
__webpack_require__(1494);
__webpack_require__(1495);
__webpack_require__(1496);
__webpack_require__(1497);
__webpack_require__(1498);
__webpack_require__(1499);
__webpack_require__(1500);
__webpack_require__(1501);
__webpack_require__(1502);
__webpack_require__(1503);
__webpack_require__(1504);
__webpack_require__(1505);
__webpack_require__(1506);
__webpack_require__(1507);
__webpack_require__(1508);
__webpack_require__(1509);
__webpack_require__(1510);
__webpack_require__(1511);
__webpack_require__(762);
__webpack_require__(763);
__webpack_require__(1512);
__webpack_require__(764);
__webpack_require__(765);
__webpack_require__(1514);
__webpack_require__(1522);
__webpack_require__(1523);
__webpack_require__(1544);
module.exports = 'umCore';

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery, module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof2(o) { "@babel/helpers - typeof"; return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof2(o); }
/*!
 * 
 * Super simple wysiwyg editor v0.8.18
 * https://summernote.org
 * 
 * 
 * Copyright 2013- Alan Hong. and other contributors
 * summernote may be freely distributed under the MIT license.
 * 
 * Date: 2020-05-20T18:09Z
 * 
 */
(function webpackUniversalModuleDefinition(root, factory) {
  if (( false ? undefined : _typeof2(exports)) === 'object' && ( false ? undefined : _typeof2(module)) === 'object') module.exports = factory(__webpack_require__(4));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else { var i, a; }
})(window, function (__WEBPACK_EXTERNAL_MODULE__0__) {
  return /******/function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/ // The require function
    /******/
    function __webpack_require__(moduleId) {
      /******/
      /******/ // Check if module is in cache
      /******/if (installedModules[moduleId]) {
        /******/return installedModules[moduleId].exports;
        /******/
      }
      /******/ // Create a new module (and put it into the cache)
      /******/
      var module = installedModules[moduleId] = {
        /******/i: moduleId,
        /******/l: false,
        /******/exports: {}
        /******/
      };
      /******/
      /******/ // Execute the module function
      /******/
      modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
      /******/
      /******/ // Flag the module as loaded
      /******/
      module.l = true;
      /******/
      /******/ // Return the exports of the module
      /******/
      return module.exports;
      /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/
    __webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/
    __webpack_require__.c = installedModules;
    /******/
    /******/ // define getter function for harmony exports
    /******/
    __webpack_require__.d = function (exports, name, getter) {
      /******/if (!__webpack_require__.o(exports, name)) {
        /******/Object.defineProperty(exports, name, {
          enumerable: true,
          get: getter
        });
        /******/
      }
      /******/
    };
    /******/
    /******/ // define __esModule on exports
    /******/
    __webpack_require__.r = function (exports) {
      /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
        /******/Object.defineProperty(exports, Symbol.toStringTag, {
          value: 'Module'
        });
        /******/
      }
      /******/
      Object.defineProperty(exports, '__esModule', {
        value: true
      });
      /******/
    };
    /******/
    /******/ // create a fake namespace object
    /******/ // mode & 1: value is a module id, require it
    /******/ // mode & 2: merge all properties of value into the ns
    /******/ // mode & 4: return value when already ns object
    /******/ // mode & 8|1: behave like require
    /******/
    __webpack_require__.t = function (value, mode) {
      /******/if (mode & 1) value = __webpack_require__(value);
      /******/
      if (mode & 8) return value;
      /******/
      if (mode & 4 && _typeof2(value) === 'object' && value && value.__esModule) return value;
      /******/
      var ns = Object.create(null);
      /******/
      __webpack_require__.r(ns);
      /******/
      Object.defineProperty(ns, 'default', {
        enumerable: true,
        value: value
      });
      /******/
      if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
      /******/
      return ns;
      /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/
    __webpack_require__.n = function (module) {
      /******/var getter = module && module.__esModule ? /******/function getDefault() {
        return module['default'];
      } : /******/function getModuleExports() {
        return module;
      };
      /******/
      __webpack_require__.d(getter, 'a', getter);
      /******/
      return getter;
      /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/
    __webpack_require__.o = function (object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/
    __webpack_require__.p = "";
    /******/
    /******/
    /******/ // Load entry module and return exports
    /******/
    return __webpack_require__(__webpack_require__.s = 52);
    /******/
  }
  /************************************************************************/
  /******/({
    /***/0: (/***/function _(module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

      /***/
    }),
    /***/1: (/***/function _(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      function _typeof(obj) {
        "@babel/helpers - typeof";

        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof = function _typeof(obj) {
            return typeof obj;
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var Renderer = /*#__PURE__*/function () {
        function Renderer(markup, children, options, callback) {
          _classCallCheck(this, Renderer);
          this.markup = markup;
          this.children = children;
          this.options = options;
          this.callback = callback;
        }
        _createClass(Renderer, [{
          key: "render",
          value: function render($parent) {
            var $node = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.markup);
            if (this.options && this.options.contents) {
              $node.html(this.options.contents);
            }
            if (this.options && this.options.className) {
              $node.addClass(this.options.className);
            }
            if (this.options && this.options.data) {
              jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(this.options.data, function (k, v) {
                $node.attr('data-' + k, v);
              });
            }
            if (this.options && this.options.click) {
              $node.on('click', this.options.click);
            }
            if (this.children) {
              var $container = $node.find('.note-children-container');
              this.children.forEach(function (child) {
                child.render($container.length ? $container : $node);
              });
            }
            if (this.callback) {
              this.callback($node, this.options);
            }
            if (this.options && this.options.callback) {
              this.options.callback($node);
            }
            if ($parent) {
              $parent.append($node);
            }
            return $node;
          }
        }]);
        return Renderer;
      }();

      /* harmony default export */
      __webpack_exports__["a"] = {
        create: function create(markup, callback) {
          return function () {
            var options = _typeof(arguments[1]) === 'object' ? arguments[1] : arguments[0];
            var children = Array.isArray(arguments[0]) ? arguments[0] : [];
            if (options && options.children) {
              children = options.children;
            }
            return new Renderer(markup, children, options, callback);
          };
        }
      };

      /***/
    }),
    /***/2: (/***/function _(module, exports) {
      /* WEBPACK VAR INJECTION */(function (__webpack_amd_options__) {
        /* globals __webpack_amd_options__ */
        module.exports = __webpack_amd_options__;

        /* WEBPACK VAR INJECTION */
      }).call(this, {});

      /***/
    }),
    /***/3: (/***/function _(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      // EXTERNAL MODULE: external {"root":"jQuery","commonjs2":"jquery","commonjs":"jquery","amd":"jquery"}
      var external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_ = __webpack_require__(0);
      var external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default = /*#__PURE__*/__webpack_require__.n(external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_);

      // CONCATENATED MODULE: ./src/js/base/summernote-en-US.js

      external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote || {
        lang: {}
      };
      external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.extend(external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote.lang, {
        'en-US': {
          font: {
            bold: 'Bold',
            italic: 'Italic',
            underline: 'Underline',
            clear: 'Remove Font Style',
            height: 'Line Height',
            name: 'Font Family',
            strikethrough: 'Strikethrough',
            subscript: 'Subscript',
            superscript: 'Superscript',
            size: 'Font Size',
            sizeunit: 'Font Size Unit'
          },
          image: {
            image: 'Picture',
            insert: 'Insert Image',
            resizeFull: 'Resize full',
            resizeHalf: 'Resize half',
            resizeQuarter: 'Resize quarter',
            resizeNone: 'Original size',
            floatLeft: 'Float Left',
            floatRight: 'Float Right',
            floatNone: 'Remove float',
            shapeRounded: 'Shape: Rounded',
            shapeCircle: 'Shape: Circle',
            shapeThumbnail: 'Shape: Thumbnail',
            shapeNone: 'Shape: None',
            dragImageHere: 'Drag image or text here',
            dropImage: 'Drop image or Text',
            selectFromFiles: 'Select from files',
            maximumFileSize: 'Maximum file size',
            maximumFileSizeError: 'Maximum file size exceeded.',
            url: 'Image URL',
            remove: 'Remove Image',
            original: 'Original'
          },
          video: {
            video: 'Video',
            videoLink: 'Video Link',
            insert: 'Insert Video',
            url: 'Video URL',
            providers: '(YouTube, Vimeo, Vine, Instagram, DailyMotion or Youku)'
          },
          link: {
            link: 'Link',
            insert: 'Insert Link',
            unlink: 'Unlink',
            edit: 'Edit',
            textToDisplay: 'Text to display',
            url: 'To what URL should this link go?',
            openInNewWindow: 'Open in new window',
            useProtocol: 'Use default protocol'
          },
          table: {
            table: 'Table',
            addRowAbove: 'Add row above',
            addRowBelow: 'Add row below',
            addColLeft: 'Add column left',
            addColRight: 'Add column right',
            delRow: 'Delete row',
            delCol: 'Delete column',
            delTable: 'Delete table'
          },
          hr: {
            insert: 'Insert Horizontal Rule'
          },
          style: {
            style: 'Style',
            p: 'Normal',
            blockquote: 'Quote',
            pre: 'Code',
            h1: 'Header 1',
            h2: 'Header 2',
            h3: 'Header 3',
            h4: 'Header 4',
            h5: 'Header 5',
            h6: 'Header 6'
          },
          lists: {
            unordered: 'Unordered list',
            ordered: 'Ordered list'
          },
          options: {
            help: 'Help',
            fullscreen: 'Full Screen',
            codeview: 'Code View'
          },
          paragraph: {
            paragraph: 'Paragraph',
            outdent: 'Outdent',
            indent: 'Indent',
            left: 'Align left',
            center: 'Align center',
            right: 'Align right',
            justify: 'Justify full'
          },
          color: {
            recent: 'Recent Color',
            more: 'More Color',
            background: 'Background Color',
            foreground: 'Text Color',
            transparent: 'Transparent',
            setTransparent: 'Set transparent',
            reset: 'Reset',
            resetToDefault: 'Reset to default',
            cpSelect: 'Select'
          },
          shortcut: {
            shortcuts: 'Keyboard shortcuts',
            close: 'Close',
            textFormatting: 'Text formatting',
            action: 'Action',
            paragraphFormatting: 'Paragraph formatting',
            documentStyle: 'Document Style',
            extraKeys: 'Extra keys'
          },
          help: {
            'escape': 'Escape',
            'insertParagraph': 'Insert Paragraph',
            'undo': 'Undo the last command',
            'redo': 'Redo the last command',
            'tab': 'Tab',
            'untab': 'Untab',
            'bold': 'Set a bold style',
            'italic': 'Set a italic style',
            'underline': 'Set a underline style',
            'strikethrough': 'Set a strikethrough style',
            'removeFormat': 'Clean a style',
            'justifyLeft': 'Set left align',
            'justifyCenter': 'Set center align',
            'justifyRight': 'Set right align',
            'justifyFull': 'Set full align',
            'insertUnorderedList': 'Toggle unordered list',
            'insertOrderedList': 'Toggle ordered list',
            'outdent': 'Outdent on current paragraph',
            'indent': 'Indent on current paragraph',
            'formatPara': 'Change current block\'s format as a paragraph(P tag)',
            'formatH1': 'Change current block\'s format as H1',
            'formatH2': 'Change current block\'s format as H2',
            'formatH3': 'Change current block\'s format as H3',
            'formatH4': 'Change current block\'s format as H4',
            'formatH5': 'Change current block\'s format as H5',
            'formatH6': 'Change current block\'s format as H6',
            'insertHorizontalRule': 'Insert horizontal rule',
            'linkDialog.show': 'Show Link Dialog'
          },
          history: {
            undo: 'Undo',
            redo: 'Redo'
          },
          specialChar: {
            specialChar: 'SPECIAL CHARACTERS',
            select: 'Select Special characters'
          },
          output: {
            noSelection: 'No Selection Made!'
          }
        }
      });
      // CONCATENATED MODULE: ./src/js/base/core/env.js

      var isSupportAmd =  true && __webpack_require__(2); // eslint-disable-line

      /**
       * returns whether font is installed or not.
       *
       * @param {String} fontName
       * @return {Boolean}
       */

      var genericFontFamilies = ['sans-serif', 'serif', 'monospace', 'cursive', 'fantasy'];
      function validFontName(fontName) {
        return external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.inArray(fontName.toLowerCase(), genericFontFamilies) === -1 ? "'".concat(fontName, "'") : fontName;
      }
      function env_isFontInstalled(fontName) {
        var testFontName = fontName === 'Comic Sans MS' ? 'Courier New' : 'Comic Sans MS';
        var testText = 'mmmmmmmmmmwwwww';
        var testSize = '200px';
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        context.font = testSize + " '" + testFontName + "'";
        var originalWidth = context.measureText(testText).width;
        context.font = testSize + ' ' + validFontName(fontName) + ', "' + testFontName + '"';
        var width = context.measureText(testText).width;
        return originalWidth !== width;
      }
      var userAgent = navigator.userAgent;
      var isMSIE = /MSIE|Trident/i.test(userAgent);
      var browserVersion;
      if (isMSIE) {
        var matches = /MSIE (\d+[.]\d+)/.exec(userAgent);
        if (matches) {
          browserVersion = parseFloat(matches[1]);
        }
        matches = /Trident\/.*rv:([0-9]{1,}[.0-9]{0,})/.exec(userAgent);
        if (matches) {
          browserVersion = parseFloat(matches[1]);
        }
      }
      var isEdge = /Edge\/\d+/.test(userAgent);
      var isSupportTouch = 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0; // [workaround] IE doesn't have input events for contentEditable
      // - see: https://goo.gl/4bfIvA

      var inputEventName = isMSIE ? 'DOMCharacterDataModified DOMSubtreeModified DOMNodeInserted' : 'input';
      /**
       * @class core.env
       *
       * Object which check platform and agent
       *
       * @singleton
       * @alternateClassName env
       */

      /* harmony default export */
      var env = {
        isMac: navigator.appVersion.indexOf('Mac') > -1,
        isMSIE: isMSIE,
        isEdge: isEdge,
        isFF: !isEdge && /firefox/i.test(userAgent),
        isPhantom: /PhantomJS/i.test(userAgent),
        isWebkit: !isEdge && /webkit/i.test(userAgent),
        isChrome: !isEdge && /chrome/i.test(userAgent),
        isSafari: !isEdge && /safari/i.test(userAgent) && !/chrome/i.test(userAgent),
        browserVersion: browserVersion,
        jqueryVersion: parseFloat(external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.fn.jquery),
        isSupportAmd: isSupportAmd,
        isSupportTouch: isSupportTouch,
        isFontInstalled: env_isFontInstalled,
        isW3CRangeSupport: !!document.createRange,
        inputEventName: inputEventName,
        genericFontFamilies: genericFontFamilies,
        validFontName: validFontName
      };
      // CONCATENATED MODULE: ./src/js/base/core/func.js

      /**
       * @class core.func
       *
       * func utils (for high-order func's arg)
       *
       * @singleton
       * @alternateClassName func
       */

      function eq(itemA) {
        return function (itemB) {
          return itemA === itemB;
        };
      }
      function eq2(itemA, itemB) {
        return itemA === itemB;
      }
      function peq2(propName) {
        return function (itemA, itemB) {
          return itemA[propName] === itemB[propName];
        };
      }
      function ok() {
        return true;
      }
      function fail() {
        return false;
      }
      function not(f) {
        return function () {
          return !f.apply(f, arguments);
        };
      }
      function and(fA, fB) {
        return function (item) {
          return fA(item) && fB(item);
        };
      }
      function func_self(a) {
        return a;
      }
      function func_invoke(obj, method) {
        return function () {
          return obj[method].apply(obj, arguments);
        };
      }
      var idCounter = 0;
      /**
       * reset globally-unique id
       *
       */

      function resetUniqueId() {
        idCounter = 0;
      }
      /**
       * generate a globally-unique id
       *
       * @param {String} [prefix]
       */

      function uniqueId(prefix) {
        var id = ++idCounter + '';
        return prefix ? prefix + id : id;
      }
      /**
       * returns bnd (bounds) from rect
       *
       * - IE Compatibility Issue: http://goo.gl/sRLOAo
       * - Scroll Issue: http://goo.gl/sNjUc
       *
       * @param {Rect} rect
       * @return {Object} bounds
       * @return {Number} bounds.top
       * @return {Number} bounds.left
       * @return {Number} bounds.width
       * @return {Number} bounds.height
       */

      function rect2bnd(rect) {
        var $document = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(document);
        return {
          top: rect.top + $document.scrollTop(),
          left: rect.left + $document.scrollLeft(),
          width: rect.right - rect.left,
          height: rect.bottom - rect.top
        };
      }
      /**
       * returns a copy of the object where the keys have become the values and the values the keys.
       * @param {Object} obj
       * @return {Object}
       */

      function invertObject(obj) {
        var inverted = {};
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            inverted[obj[key]] = key;
          }
        }
        return inverted;
      }
      /**
       * @param {String} namespace
       * @param {String} [prefix]
       * @return {String}
       */

      function namespaceToCamel(namespace, prefix) {
        prefix = prefix || '';
        return prefix + namespace.split('.').map(function (name) {
          return name.substring(0, 1).toUpperCase() + name.substring(1);
        }).join('');
      }
      /**
       * Returns a function, that, as long as it continues to be invoked, will not
       * be triggered. The function will be called after it stops being called for
       * N milliseconds. If `immediate` is passed, trigger the function on the
       * leading edge, instead of the trailing.
       * @param {Function} func
       * @param {Number} wait
       * @param {Boolean} immediate
       * @return {Function}
       */

      function debounce(func, wait, immediate) {
        var timeout;
        return function () {
          var context = this;
          var args = arguments;
          var later = function later() {
            timeout = null;
            if (!immediate) {
              func.apply(context, args);
            }
          };
          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) {
            func.apply(context, args);
          }
        };
      }
      /**
       *
       * @param {String} url
       * @return {Boolean}
       */

      function isValidUrl(url) {
        var expression = /[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi;
        return expression.test(url);
      }

      /* harmony default export */
      var func = {
        eq: eq,
        eq2: eq2,
        peq2: peq2,
        ok: ok,
        fail: fail,
        self: func_self,
        not: not,
        and: and,
        invoke: func_invoke,
        resetUniqueId: resetUniqueId,
        uniqueId: uniqueId,
        rect2bnd: rect2bnd,
        invertObject: invertObject,
        namespaceToCamel: namespaceToCamel,
        debounce: debounce,
        isValidUrl: isValidUrl
      };
      // CONCATENATED MODULE: ./src/js/base/core/lists.js

      /**
       * returns the first item of an array.
       *
       * @param {Array} array
       */

      function lists_head(array) {
        return array[0];
      }
      /**
       * returns the last item of an array.
       *
       * @param {Array} array
       */

      function lists_last(array) {
        return array[array.length - 1];
      }
      /**
       * returns everything but the last entry of the array.
       *
       * @param {Array} array
       */

      function initial(array) {
        return array.slice(0, array.length - 1);
      }
      /**
       * returns the rest of the items in an array.
       *
       * @param {Array} array
       */

      function tail(array) {
        return array.slice(1);
      }
      /**
       * returns item of array
       */

      function find(array, pred) {
        for (var idx = 0, len = array.length; idx < len; idx++) {
          var item = array[idx];
          if (pred(item)) {
            return item;
          }
        }
      }
      /**
       * returns true if all of the values in the array pass the predicate truth test.
       */

      function lists_all(array, pred) {
        for (var idx = 0, len = array.length; idx < len; idx++) {
          if (!pred(array[idx])) {
            return false;
          }
        }
        return true;
      }
      /**
       * returns true if the value is present in the list.
       */

      function contains(array, item) {
        if (array && array.length && item) {
          if (array.indexOf) {
            return array.indexOf(item) !== -1;
          } else if (array.contains) {
            // `DOMTokenList` doesn't implement `.indexOf`, but it implements `.contains`
            return array.contains(item);
          }
        }
        return false;
      }
      /**
       * get sum from a list
       *
       * @param {Array} array - array
       * @param {Function} fn - iterator
       */

      function sum(array, fn) {
        fn = fn || func.self;
        return array.reduce(function (memo, v) {
          return memo + fn(v);
        }, 0);
      }
      /**
       * returns a copy of the collection with array type.
       * @param {Collection} collection - collection eg) node.childNodes, ...
       */

      function from(collection) {
        var result = [];
        var length = collection.length;
        var idx = -1;
        while (++idx < length) {
          result[idx] = collection[idx];
        }
        return result;
      }
      /**
       * returns whether list is empty or not
       */

      function lists_isEmpty(array) {
        return !array || !array.length;
      }
      /**
       * cluster elements by predicate function.
       *
       * @param {Array} array - array
       * @param {Function} fn - predicate function for cluster rule
       * @param {Array[]}
       */

      function clusterBy(array, fn) {
        if (!array.length) {
          return [];
        }
        var aTail = tail(array);
        return aTail.reduce(function (memo, v) {
          var aLast = lists_last(memo);
          if (fn(lists_last(aLast), v)) {
            aLast[aLast.length] = v;
          } else {
            memo[memo.length] = [v];
          }
          return memo;
        }, [[lists_head(array)]]);
      }
      /**
       * returns a copy of the array with all false values removed
       *
       * @param {Array} array - array
       * @param {Function} fn - predicate function for cluster rule
       */

      function compact(array) {
        var aResult = [];
        for (var idx = 0, len = array.length; idx < len; idx++) {
          if (array[idx]) {
            aResult.push(array[idx]);
          }
        }
        return aResult;
      }
      /**
       * produces a duplicate-free version of the array
       *
       * @param {Array} array
       */

      function unique(array) {
        var results = [];
        for (var idx = 0, len = array.length; idx < len; idx++) {
          if (!contains(results, array[idx])) {
            results.push(array[idx]);
          }
        }
        return results;
      }
      /**
       * returns next item.
       * @param {Array} array
       */

      function lists_next(array, item) {
        if (array && array.length && item) {
          var idx = array.indexOf(item);
          return idx === -1 ? null : array[idx + 1];
        }
        return null;
      }
      /**
       * returns prev item.
       * @param {Array} array
       */

      function prev(array, item) {
        if (array && array.length && item) {
          var idx = array.indexOf(item);
          return idx === -1 ? null : array[idx - 1];
        }
        return null;
      }
      /**
       * @class core.list
       *
       * list utils
       *
       * @singleton
       * @alternateClassName list
       */

      /* harmony default export */
      var lists = {
        head: lists_head,
        last: lists_last,
        initial: initial,
        tail: tail,
        prev: prev,
        next: lists_next,
        find: find,
        contains: contains,
        all: lists_all,
        sum: sum,
        from: from,
        isEmpty: lists_isEmpty,
        clusterBy: clusterBy,
        compact: compact,
        unique: unique
      };
      // CONCATENATED MODULE: ./src/js/base/core/dom.js

      var NBSP_CHAR = String.fromCharCode(160);
      var ZERO_WIDTH_NBSP_CHAR = "\uFEFF";
      /**
       * @method isEditable
       *
       * returns whether node is `note-editable` or not.
       *
       * @param {Node} node
       * @return {Boolean}
       */

      function isEditable(node) {
        return node && external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(node).hasClass('note-editable');
      }
      /**
       * @method isControlSizing
       *
       * returns whether node is `note-control-sizing` or not.
       *
       * @param {Node} node
       * @return {Boolean}
       */

      function isControlSizing(node) {
        return node && external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(node).hasClass('note-control-sizing');
      }
      /**
       * @method makePredByNodeName
       *
       * returns predicate which judge whether nodeName is same
       *
       * @param {String} nodeName
       * @return {Function}
       */

      function makePredByNodeName(nodeName) {
        nodeName = nodeName.toUpperCase();
        return function (node) {
          return node && node.nodeName.toUpperCase() === nodeName;
        };
      }
      /**
       * @method isText
       *
       *
       *
       * @param {Node} node
       * @return {Boolean} true if node's type is text(3)
       */

      function isText(node) {
        return node && node.nodeType === 3;
      }
      /**
       * @method isElement
       *
       *
       *
       * @param {Node} node
       * @return {Boolean} true if node's type is element(1)
       */

      function isElement(node) {
        return node && node.nodeType === 1;
      }
      /**
       * ex) br, col, embed, hr, img, input, ...
       * @see http://www.w3.org/html/wg/drafts/html/master/syntax.html#void-elements
       */

      function isVoid(node) {
        return node && /^BR|^IMG|^HR|^IFRAME|^BUTTON|^INPUT|^AUDIO|^VIDEO|^EMBED/.test(node.nodeName.toUpperCase());
      }
      function isPara(node) {
        if (isEditable(node)) {
          return false;
        } // Chrome(v31.0), FF(v25.0.1) use DIV for paragraph

        return node && /^DIV|^P|^LI|^H[1-7]/.test(node.nodeName.toUpperCase());
      }
      function isHeading(node) {
        return node && /^H[1-7]/.test(node.nodeName.toUpperCase());
      }
      var isPre = makePredByNodeName('PRE');
      var isLi = makePredByNodeName('LI');
      function isPurePara(node) {
        return isPara(node) && !isLi(node);
      }
      var isTable = makePredByNodeName('TABLE');
      var isData = makePredByNodeName('DATA');
      function dom_isInline(node) {
        return !isBodyContainer(node) && !isList(node) && !isHr(node) && !isPara(node) && !isTable(node) && !isBlockquote(node) && !isData(node);
      }
      function isList(node) {
        return node && /^UL|^OL/.test(node.nodeName.toUpperCase());
      }
      var isHr = makePredByNodeName('HR');
      function dom_isCell(node) {
        return node && /^TD|^TH/.test(node.nodeName.toUpperCase());
      }
      var isBlockquote = makePredByNodeName('BLOCKQUOTE');
      function isBodyContainer(node) {
        return dom_isCell(node) || isBlockquote(node) || isEditable(node);
      }
      var isAnchor = makePredByNodeName('A');
      function isParaInline(node) {
        return dom_isInline(node) && !!dom_ancestor(node, isPara);
      }
      function isBodyInline(node) {
        return dom_isInline(node) && !dom_ancestor(node, isPara);
      }
      var isBody = makePredByNodeName('BODY');
      /**
       * returns whether nodeB is closest sibling of nodeA
       *
       * @param {Node} nodeA
       * @param {Node} nodeB
       * @return {Boolean}
       */

      function isClosestSibling(nodeA, nodeB) {
        return nodeA.nextSibling === nodeB || nodeA.previousSibling === nodeB;
      }
      /**
       * returns array of closest siblings with node
       *
       * @param {Node} node
       * @param {function} [pred] - predicate function
       * @return {Node[]}
       */

      function withClosestSiblings(node, pred) {
        pred = pred || func.ok;
        var siblings = [];
        if (node.previousSibling && pred(node.previousSibling)) {
          siblings.push(node.previousSibling);
        }
        siblings.push(node);
        if (node.nextSibling && pred(node.nextSibling)) {
          siblings.push(node.nextSibling);
        }
        return siblings;
      }
      /**
       * blank HTML for cursor position
       * - [workaround] old IE only works with &nbsp;
       * - [workaround] IE11 and other browser works with bogus br
       */

      var blankHTML = env.isMSIE && env.browserVersion < 11 ? '&nbsp;' : '<br>';
      /**
       * @method nodeLength
       *
       * returns #text's text size or element's childNodes size
       *
       * @param {Node} node
       */

      function nodeLength(node) {
        if (isText(node)) {
          return node.nodeValue.length;
        }
        if (node) {
          return node.childNodes.length;
        }
        return 0;
      }
      /**
       * returns whether deepest child node is empty or not.
       *
       * @param {Node} node
       * @return {Boolean}
       */

      function deepestChildIsEmpty(node) {
        do {
          if (node.firstElementChild === null || node.firstElementChild.innerHTML === '') break;
        } while (node = node.firstElementChild);
        return dom_isEmpty(node);
      }
      /**
       * returns whether node is empty or not.
       *
       * @param {Node} node
       * @return {Boolean}
       */

      function dom_isEmpty(node) {
        var len = nodeLength(node);
        if (len === 0) {
          return true;
        } else if (!isText(node) && len === 1 && node.innerHTML === blankHTML) {
          // ex) <p><br></p>, <span><br></span>
          return true;
        } else if (lists.all(node.childNodes, isText) && node.innerHTML === '') {
          // ex) <p></p>, <span></span>
          return true;
        }
        return false;
      }
      /**
       * padding blankHTML if node is empty (for cursor position)
       */

      function paddingBlankHTML(node) {
        if (!isVoid(node) && !nodeLength(node)) {
          node.innerHTML = blankHTML;
        }
      }
      /**
       * find nearest ancestor predicate hit
       *
       * @param {Node} node
       * @param {Function} pred - predicate function
       */

      function dom_ancestor(node, pred) {
        while (node) {
          if (pred(node)) {
            return node;
          }
          if (isEditable(node)) {
            break;
          }
          node = node.parentNode;
        }
        return null;
      }
      /**
       * find nearest ancestor only single child blood line and predicate hit
       *
       * @param {Node} node
       * @param {Function} pred - predicate function
       */

      function singleChildAncestor(node, pred) {
        node = node.parentNode;
        while (node) {
          if (nodeLength(node) !== 1) {
            break;
          }
          if (pred(node)) {
            return node;
          }
          if (isEditable(node)) {
            break;
          }
          node = node.parentNode;
        }
        return null;
      }
      /**
       * returns new array of ancestor nodes (until predicate hit).
       *
       * @param {Node} node
       * @param {Function} [optional] pred - predicate function
       */

      function listAncestor(node, pred) {
        pred = pred || func.fail;
        var ancestors = [];
        dom_ancestor(node, function (el) {
          if (!isEditable(el)) {
            ancestors.push(el);
          }
          return pred(el);
        });
        return ancestors;
      }
      /**
       * find farthest ancestor predicate hit
       */

      function lastAncestor(node, pred) {
        var ancestors = listAncestor(node);
        return lists.last(ancestors.filter(pred));
      }
      /**
       * returns common ancestor node between two nodes.
       *
       * @param {Node} nodeA
       * @param {Node} nodeB
       */

      function dom_commonAncestor(nodeA, nodeB) {
        var ancestors = listAncestor(nodeA);
        for (var n = nodeB; n; n = n.parentNode) {
          if (ancestors.indexOf(n) > -1) return n;
        }
        return null; // difference document area
      }
      /**
       * listing all previous siblings (until predicate hit).
       *
       * @param {Node} node
       * @param {Function} [optional] pred - predicate function
       */

      function listPrev(node, pred) {
        pred = pred || func.fail;
        var nodes = [];
        while (node) {
          if (pred(node)) {
            break;
          }
          nodes.push(node);
          node = node.previousSibling;
        }
        return nodes;
      }
      /**
       * listing next siblings (until predicate hit).
       *
       * @param {Node} node
       * @param {Function} [pred] - predicate function
       */

      function listNext(node, pred) {
        pred = pred || func.fail;
        var nodes = [];
        while (node) {
          if (pred(node)) {
            break;
          }
          nodes.push(node);
          node = node.nextSibling;
        }
        return nodes;
      }
      /**
       * listing descendant nodes
       *
       * @param {Node} node
       * @param {Function} [pred] - predicate function
       */

      function listDescendant(node, pred) {
        var descendants = [];
        pred = pred || func.ok; // start DFS(depth first search) with node

        (function fnWalk(current) {
          if (node !== current && pred(current)) {
            descendants.push(current);
          }
          for (var idx = 0, len = current.childNodes.length; idx < len; idx++) {
            fnWalk(current.childNodes[idx]);
          }
        })(node);
        return descendants;
      }
      /**
       * wrap node with new tag.
       *
       * @param {Node} node
       * @param {Node} tagName of wrapper
       * @return {Node} - wrapper
       */

      function wrap(node, wrapperName) {
        var parent = node.parentNode;
        var wrapper = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<' + wrapperName + '>')[0];
        parent.insertBefore(wrapper, node);
        wrapper.appendChild(node);
        return wrapper;
      }
      /**
       * insert node after preceding
       *
       * @param {Node} node
       * @param {Node} preceding - predicate function
       */

      function insertAfter(node, preceding) {
        var next = preceding.nextSibling;
        var parent = preceding.parentNode;
        if (next) {
          parent.insertBefore(node, next);
        } else {
          parent.appendChild(node);
        }
        return node;
      }
      /**
       * append elements.
       *
       * @param {Node} node
       * @param {Collection} aChild
       */

      function appendChildNodes(node, aChild) {
        external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(aChild, function (idx, child) {
          node.appendChild(child);
        });
        return node;
      }
      /**
       * returns whether boundaryPoint is left edge or not.
       *
       * @param {BoundaryPoint} point
       * @return {Boolean}
       */

      function isLeftEdgePoint(point) {
        return point.offset === 0;
      }
      /**
       * returns whether boundaryPoint is right edge or not.
       *
       * @param {BoundaryPoint} point
       * @return {Boolean}
       */

      function isRightEdgePoint(point) {
        return point.offset === nodeLength(point.node);
      }
      /**
       * returns whether boundaryPoint is edge or not.
       *
       * @param {BoundaryPoint} point
       * @return {Boolean}
       */

      function isEdgePoint(point) {
        return isLeftEdgePoint(point) || isRightEdgePoint(point);
      }
      /**
       * returns whether node is left edge of ancestor or not.
       *
       * @param {Node} node
       * @param {Node} ancestor
       * @return {Boolean}
       */

      function dom_isLeftEdgeOf(node, ancestor) {
        while (node && node !== ancestor) {
          if (dom_position(node) !== 0) {
            return false;
          }
          node = node.parentNode;
        }
        return true;
      }
      /**
       * returns whether node is right edge of ancestor or not.
       *
       * @param {Node} node
       * @param {Node} ancestor
       * @return {Boolean}
       */

      function isRightEdgeOf(node, ancestor) {
        if (!ancestor) {
          return false;
        }
        while (node && node !== ancestor) {
          if (dom_position(node) !== nodeLength(node.parentNode) - 1) {
            return false;
          }
          node = node.parentNode;
        }
        return true;
      }
      /**
       * returns whether point is left edge of ancestor or not.
       * @param {BoundaryPoint} point
       * @param {Node} ancestor
       * @return {Boolean}
       */

      function isLeftEdgePointOf(point, ancestor) {
        return isLeftEdgePoint(point) && dom_isLeftEdgeOf(point.node, ancestor);
      }
      /**
       * returns whether point is right edge of ancestor or not.
       * @param {BoundaryPoint} point
       * @param {Node} ancestor
       * @return {Boolean}
       */

      function isRightEdgePointOf(point, ancestor) {
        return isRightEdgePoint(point) && isRightEdgeOf(point.node, ancestor);
      }
      /**
       * returns offset from parent.
       *
       * @param {Node} node
       */

      function dom_position(node) {
        var offset = 0;
        while (node = node.previousSibling) {
          offset += 1;
        }
        return offset;
      }
      function hasChildren(node) {
        return !!(node && node.childNodes && node.childNodes.length);
      }
      /**
       * returns previous boundaryPoint
       *
       * @param {BoundaryPoint} point
       * @param {Boolean} isSkipInnerOffset
       * @return {BoundaryPoint}
       */

      function dom_prevPoint(point, isSkipInnerOffset) {
        var node;
        var offset;
        if (point.offset === 0) {
          if (isEditable(point.node)) {
            return null;
          }
          node = point.node.parentNode;
          offset = dom_position(point.node);
        } else if (hasChildren(point.node)) {
          node = point.node.childNodes[point.offset - 1];
          offset = nodeLength(node);
        } else {
          node = point.node;
          offset = isSkipInnerOffset ? 0 : point.offset - 1;
        }
        return {
          node: node,
          offset: offset
        };
      }
      /**
       * returns next boundaryPoint
       *
       * @param {BoundaryPoint} point
       * @param {Boolean} isSkipInnerOffset
       * @return {BoundaryPoint}
       */

      function dom_nextPoint(point, isSkipInnerOffset) {
        var node, offset;
        if (nodeLength(point.node) === point.offset) {
          if (isEditable(point.node)) {
            return null;
          }
          var nextTextNode = getNextTextNode(point.node);
          if (nextTextNode) {
            node = nextTextNode;
            offset = 0;
          } else {
            node = point.node.parentNode;
            offset = dom_position(point.node) + 1;
          }
        } else if (hasChildren(point.node)) {
          node = point.node.childNodes[point.offset];
          offset = 0;
        } else {
          node = point.node;
          offset = isSkipInnerOffset ? nodeLength(point.node) : point.offset + 1;
        }
        return {
          node: node,
          offset: offset
        };
      }
      /**
       * returns next boundaryPoint with empty node
       *
       * @param {BoundaryPoint} point
       * @param {Boolean} isSkipInnerOffset
       * @return {BoundaryPoint}
       */

      function nextPointWithEmptyNode(point, isSkipInnerOffset) {
        var node, offset; // if node is empty string node, return current node's sibling.

        if (dom_isEmpty(point.node)) {
          node = point.node.nextSibling;
          offset = 0;
          return {
            node: node,
            offset: offset
          };
        }
        if (nodeLength(point.node) === point.offset) {
          if (isEditable(point.node)) {
            return null;
          }
          var nextTextNode = getNextTextNode(point.node);
          if (nextTextNode) {
            node = nextTextNode;
            offset = 0;
          } else {
            node = point.node.parentNode;
            offset = dom_position(point.node) + 1;
          } // if next node is editable, return current node's sibling node.

          if (isEditable(node)) {
            node = point.node.nextSibling;
            offset = 0;
          }
        } else if (hasChildren(point.node)) {
          node = point.node.childNodes[point.offset];
          offset = 0;
          if (dom_isEmpty(node)) {
            return null;
          }
        } else {
          node = point.node;
          offset = isSkipInnerOffset ? nodeLength(point.node) : point.offset + 1;
          if (dom_isEmpty(node)) {
            return null;
          }
        }
        return {
          node: node,
          offset: offset
        };
      }
      /*
      * returns the next Text node index or 0 if not found.
      */

      function getNextTextNode(actual) {
        if (!actual.nextSibling) return undefined;
        if (actual.parent !== actual.nextSibling.parent) return undefined;
        if (isText(actual.nextSibling)) return actual.nextSibling;
        return getNextTextNode(actual.nextSibling);
      }
      /**
       * returns whether pointA and pointB is same or not.
       *
       * @param {BoundaryPoint} pointA
       * @param {BoundaryPoint} pointB
       * @return {Boolean}
       */

      function isSamePoint(pointA, pointB) {
        return pointA.node === pointB.node && pointA.offset === pointB.offset;
      }
      /**
       * returns whether point is visible (can set cursor) or not.
       *
       * @param {BoundaryPoint} point
       * @return {Boolean}
       */

      function isVisiblePoint(point) {
        if (isText(point.node) || !hasChildren(point.node) || dom_isEmpty(point.node)) {
          return true;
        }
        var leftNode = point.node.childNodes[point.offset - 1];
        var rightNode = point.node.childNodes[point.offset];
        if ((!leftNode || isVoid(leftNode)) && (!rightNode || isVoid(rightNode))) {
          return true;
        }
        return false;
      }
      /**
       * @method prevPointUtil
       *
       * @param {BoundaryPoint} point
       * @param {Function} pred
       * @return {BoundaryPoint}
       */

      function prevPointUntil(point, pred) {
        while (point) {
          if (pred(point)) {
            return point;
          }
          point = dom_prevPoint(point);
        }
        return null;
      }
      /**
       * @method nextPointUntil
       *
       * @param {BoundaryPoint} point
       * @param {Function} pred
       * @return {BoundaryPoint}
       */

      function nextPointUntil(point, pred) {
        while (point) {
          if (pred(point)) {
            return point;
          }
          point = dom_nextPoint(point);
        }
        return null;
      }
      /**
       * returns whether point has character or not.
       *
       * @param {Point} point
       * @return {Boolean}
       */

      function isCharPoint(point) {
        if (!isText(point.node)) {
          return false;
        }
        var ch = point.node.nodeValue.charAt(point.offset - 1);
        return ch && ch !== ' ' && ch !== NBSP_CHAR;
      }
      /**
       * returns whether point has space or not.
       *
       * @param {Point} point
       * @return {Boolean}
       */

      function isSpacePoint(point) {
        if (!isText(point.node)) {
          return false;
        }
        var ch = point.node.nodeValue.charAt(point.offset - 1);
        return ch === ' ' || ch === NBSP_CHAR;
      }
      /**
       * @method walkPoint
       *
       * @param {BoundaryPoint} startPoint
       * @param {BoundaryPoint} endPoint
       * @param {Function} handler
       * @param {Boolean} isSkipInnerOffset
       */

      function walkPoint(startPoint, endPoint, handler, isSkipInnerOffset) {
        var point = startPoint;
        while (point) {
          handler(point);
          if (isSamePoint(point, endPoint)) {
            break;
          }
          var isSkipOffset = isSkipInnerOffset && startPoint.node !== point.node && endPoint.node !== point.node;
          point = nextPointWithEmptyNode(point, isSkipOffset);
        }
      }
      /**
       * @method makeOffsetPath
       *
       * return offsetPath(array of offset) from ancestor
       *
       * @param {Node} ancestor - ancestor node
       * @param {Node} node
       */

      function makeOffsetPath(ancestor, node) {
        var ancestors = listAncestor(node, func.eq(ancestor));
        return ancestors.map(dom_position).reverse();
      }
      /**
       * @method fromOffsetPath
       *
       * return element from offsetPath(array of offset)
       *
       * @param {Node} ancestor - ancestor node
       * @param {array} offsets - offsetPath
       */

      function fromOffsetPath(ancestor, offsets) {
        var current = ancestor;
        for (var i = 0, len = offsets.length; i < len; i++) {
          if (current.childNodes.length <= offsets[i]) {
            current = current.childNodes[current.childNodes.length - 1];
          } else {
            current = current.childNodes[offsets[i]];
          }
        }
        return current;
      }
      /**
       * @method splitNode
       *
       * split element or #text
       *
       * @param {BoundaryPoint} point
       * @param {Object} [options]
       * @param {Boolean} [options.isSkipPaddingBlankHTML] - default: false
       * @param {Boolean} [options.isNotSplitEdgePoint] - default: false
       * @param {Boolean} [options.isDiscardEmptySplits] - default: false
       * @return {Node} right node of boundaryPoint
       */

      function splitNode(point, options) {
        var isSkipPaddingBlankHTML = options && options.isSkipPaddingBlankHTML;
        var isNotSplitEdgePoint = options && options.isNotSplitEdgePoint;
        var isDiscardEmptySplits = options && options.isDiscardEmptySplits;
        if (isDiscardEmptySplits) {
          isSkipPaddingBlankHTML = true;
        } // edge case

        if (isEdgePoint(point) && (isText(point.node) || isNotSplitEdgePoint)) {
          if (isLeftEdgePoint(point)) {
            return point.node;
          } else if (isRightEdgePoint(point)) {
            return point.node.nextSibling;
          }
        } // split #text

        if (isText(point.node)) {
          return point.node.splitText(point.offset);
        } else {
          var childNode = point.node.childNodes[point.offset];
          var clone = insertAfter(point.node.cloneNode(false), point.node);
          appendChildNodes(clone, listNext(childNode));
          if (!isSkipPaddingBlankHTML) {
            paddingBlankHTML(point.node);
            paddingBlankHTML(clone);
          }
          if (isDiscardEmptySplits) {
            if (dom_isEmpty(point.node)) {
              remove(point.node);
            }
            if (dom_isEmpty(clone)) {
              remove(clone);
              return point.node.nextSibling;
            }
          }
          return clone;
        }
      }
      /**
       * @method splitTree
       *
       * split tree by point
       *
       * @param {Node} root - split root
       * @param {BoundaryPoint} point
       * @param {Object} [options]
       * @param {Boolean} [options.isSkipPaddingBlankHTML] - default: false
       * @param {Boolean} [options.isNotSplitEdgePoint] - default: false
       * @return {Node} right node of boundaryPoint
       */

      function splitTree(root, point, options) {
        // ex) [#text, <span>, <p>]
        var ancestors = listAncestor(point.node, func.eq(root));
        if (!ancestors.length) {
          return null;
        } else if (ancestors.length === 1) {
          return splitNode(point, options);
        }
        return ancestors.reduce(function (node, parent) {
          if (node === point.node) {
            node = splitNode(point, options);
          }
          return splitNode({
            node: parent,
            offset: node ? dom_position(node) : nodeLength(parent)
          }, options);
        });
      }
      /**
       * split point
       *
       * @param {Point} point
       * @param {Boolean} isInline
       * @return {Object}
       */

      function splitPoint(point, isInline) {
        // find splitRoot, container
        //  - inline: splitRoot is a child of paragraph
        //  - block: splitRoot is a child of bodyContainer
        var pred = isInline ? isPara : isBodyContainer;
        var ancestors = listAncestor(point.node, pred);
        var topAncestor = lists.last(ancestors) || point.node;
        var splitRoot, container;
        if (pred(topAncestor)) {
          splitRoot = ancestors[ancestors.length - 2];
          container = topAncestor;
        } else {
          splitRoot = topAncestor;
          container = splitRoot.parentNode;
        } // if splitRoot is exists, split with splitTree

        var pivot = splitRoot && splitTree(splitRoot, point, {
          isSkipPaddingBlankHTML: isInline,
          isNotSplitEdgePoint: isInline
        }); // if container is point.node, find pivot with point.offset

        if (!pivot && container === point.node) {
          pivot = point.node.childNodes[point.offset];
        }
        return {
          rightNode: pivot,
          container: container
        };
      }
      function dom_create(nodeName) {
        return document.createElement(nodeName);
      }
      function createText(text) {
        return document.createTextNode(text);
      }
      /**
       * @method remove
       *
       * remove node, (isRemoveChild: remove child or not)
       *
       * @param {Node} node
       * @param {Boolean} isRemoveChild
       */

      function remove(node, isRemoveChild) {
        if (!node || !node.parentNode) {
          return;
        }
        if (node.removeNode) {
          return node.removeNode(isRemoveChild);
        }
        var parent = node.parentNode;
        if (!isRemoveChild) {
          var nodes = [];
          for (var i = 0, len = node.childNodes.length; i < len; i++) {
            nodes.push(node.childNodes[i]);
          }
          for (var _i = 0, _len = nodes.length; _i < _len; _i++) {
            parent.insertBefore(nodes[_i], node);
          }
        }
        parent.removeChild(node);
      }
      /**
       * @method removeWhile
       *
       * @param {Node} node
       * @param {Function} pred
       */

      function removeWhile(node, pred) {
        while (node) {
          if (isEditable(node) || !pred(node)) {
            break;
          }
          var parent = node.parentNode;
          remove(node);
          node = parent;
        }
      }
      /**
       * @method replace
       *
       * replace node with provided nodeName
       *
       * @param {Node} node
       * @param {String} nodeName
       * @return {Node} - new node
       */

      function dom_replace(node, nodeName) {
        if (node.nodeName.toUpperCase() === nodeName.toUpperCase()) {
          return node;
        }
        var newNode = dom_create(nodeName);
        if (node.style.cssText) {
          newNode.style.cssText = node.style.cssText;
        }
        appendChildNodes(newNode, lists.from(node.childNodes));
        insertAfter(newNode, node);
        remove(node);
        return newNode;
      }
      var isTextarea = makePredByNodeName('TEXTAREA');
      /**
       * @param {jQuery} $node
       * @param {Boolean} [stripLinebreaks] - default: false
       */

      function dom_value($node, stripLinebreaks) {
        var val = isTextarea($node[0]) ? $node.val() : $node.html();
        if (stripLinebreaks) {
          return val.replace(/[\n\r]/g, '');
        }
        return val;
      }
      /**
       * @method html
       *
       * get the HTML contents of node
       *
       * @param {jQuery} $node
       * @param {Boolean} [isNewlineOnBlock]
       */

      function dom_html($node, isNewlineOnBlock) {
        var markup = dom_value($node);
        if (isNewlineOnBlock) {
          var regexTag = /<(\/?)(\b(?!!)[^>\s]*)(.*?)(\s*\/?>)/g;
          markup = markup.replace(regexTag, function (match, endSlash, name) {
            name = name.toUpperCase();
            var isEndOfInlineContainer = /^DIV|^TD|^TH|^P|^LI|^H[1-7]/.test(name) && !!endSlash;
            var isBlockNode = /^BLOCKQUOTE|^TABLE|^TBODY|^TR|^HR|^UL|^OL/.test(name);
            return match + (isEndOfInlineContainer || isBlockNode ? '\n' : '');
          });
          markup = markup.trim();
        }
        return markup;
      }
      function posFromPlaceholder(placeholder) {
        var $placeholder = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(placeholder);
        var pos = $placeholder.offset();
        var height = $placeholder.outerHeight(true); // include margin

        return {
          left: pos.left,
          top: pos.top + height
        };
      }
      function attachEvents($node, events) {
        Object.keys(events).forEach(function (key) {
          $node.on(key, events[key]);
        });
      }
      function detachEvents($node, events) {
        Object.keys(events).forEach(function (key) {
          $node.off(key, events[key]);
        });
      }
      /**
       * @method isCustomStyleTag
       *
       * assert if a node contains a "note-styletag" class,
       * which implies that's a custom-made style tag node
       *
       * @param {Node} an HTML DOM node
       */

      function isCustomStyleTag(node) {
        return node && !isText(node) && lists.contains(node.classList, 'note-styletag');
      }

      /* harmony default export */
      var dom = {
        /** @property {String} NBSP_CHAR */
        NBSP_CHAR: NBSP_CHAR,
        /** @property {String} ZERO_WIDTH_NBSP_CHAR */
        ZERO_WIDTH_NBSP_CHAR: ZERO_WIDTH_NBSP_CHAR,
        /** @property {String} blank */
        blank: blankHTML,
        /** @property {String} emptyPara */
        emptyPara: "<p>".concat(blankHTML, "</p>"),
        makePredByNodeName: makePredByNodeName,
        isEditable: isEditable,
        isControlSizing: isControlSizing,
        isText: isText,
        isElement: isElement,
        isVoid: isVoid,
        isPara: isPara,
        isPurePara: isPurePara,
        isHeading: isHeading,
        isInline: dom_isInline,
        isBlock: func.not(dom_isInline),
        isBodyInline: isBodyInline,
        isBody: isBody,
        isParaInline: isParaInline,
        isPre: isPre,
        isList: isList,
        isTable: isTable,
        isData: isData,
        isCell: dom_isCell,
        isBlockquote: isBlockquote,
        isBodyContainer: isBodyContainer,
        isAnchor: isAnchor,
        isDiv: makePredByNodeName('DIV'),
        isLi: isLi,
        isBR: makePredByNodeName('BR'),
        isSpan: makePredByNodeName('SPAN'),
        isB: makePredByNodeName('B'),
        isU: makePredByNodeName('U'),
        isS: makePredByNodeName('S'),
        isI: makePredByNodeName('I'),
        isImg: makePredByNodeName('IMG'),
        isTextarea: isTextarea,
        deepestChildIsEmpty: deepestChildIsEmpty,
        isEmpty: dom_isEmpty,
        isEmptyAnchor: func.and(isAnchor, dom_isEmpty),
        isClosestSibling: isClosestSibling,
        withClosestSiblings: withClosestSiblings,
        nodeLength: nodeLength,
        isLeftEdgePoint: isLeftEdgePoint,
        isRightEdgePoint: isRightEdgePoint,
        isEdgePoint: isEdgePoint,
        isLeftEdgeOf: dom_isLeftEdgeOf,
        isRightEdgeOf: isRightEdgeOf,
        isLeftEdgePointOf: isLeftEdgePointOf,
        isRightEdgePointOf: isRightEdgePointOf,
        prevPoint: dom_prevPoint,
        nextPoint: dom_nextPoint,
        nextPointWithEmptyNode: nextPointWithEmptyNode,
        isSamePoint: isSamePoint,
        isVisiblePoint: isVisiblePoint,
        prevPointUntil: prevPointUntil,
        nextPointUntil: nextPointUntil,
        isCharPoint: isCharPoint,
        isSpacePoint: isSpacePoint,
        walkPoint: walkPoint,
        ancestor: dom_ancestor,
        singleChildAncestor: singleChildAncestor,
        listAncestor: listAncestor,
        lastAncestor: lastAncestor,
        listNext: listNext,
        listPrev: listPrev,
        listDescendant: listDescendant,
        commonAncestor: dom_commonAncestor,
        wrap: wrap,
        insertAfter: insertAfter,
        appendChildNodes: appendChildNodes,
        position: dom_position,
        hasChildren: hasChildren,
        makeOffsetPath: makeOffsetPath,
        fromOffsetPath: fromOffsetPath,
        splitTree: splitTree,
        splitPoint: splitPoint,
        create: dom_create,
        createText: createText,
        remove: remove,
        removeWhile: removeWhile,
        replace: dom_replace,
        html: dom_html,
        value: dom_value,
        posFromPlaceholder: posFromPlaceholder,
        attachEvents: attachEvents,
        detachEvents: detachEvents,
        isCustomStyleTag: isCustomStyleTag
      };
      // CONCATENATED MODULE: ./src/js/base/Context.js
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var Context_Context = /*#__PURE__*/function () {
        /**
         * @param {jQuery} $note
         * @param {Object} options
         */
        function Context($note, options) {
          _classCallCheck(this, Context);
          this.$note = $note;
          this.memos = {};
          this.modules = {};
          this.layoutInfo = {};
          this.options = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.extend(true, {}, options); // init ui with options

          external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote.ui = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote.ui_template(this.options);
          this.ui = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote.ui;
          this.initialize();
        }
        /**
         * create layout and initialize modules and other resources
         */

        _createClass(Context, [{
          key: "initialize",
          value: function initialize() {
            this.layoutInfo = this.ui.createLayout(this.$note);
            this._initialize();
            this.$note.hide();
            return this;
          }
          /**
           * destroy modules and other resources and remove layout
           */
        }, {
          key: "destroy",
          value: function destroy() {
            this._destroy();
            this.$note.removeData('summernote');
            this.ui.removeLayout(this.$note, this.layoutInfo);
          }
          /**
           * destory modules and other resources and initialize it again
           */
        }, {
          key: "reset",
          value: function reset() {
            var disabled = this.isDisabled();
            this.code(dom.emptyPara);
            this._destroy();
            this._initialize();
            if (disabled) {
              this.disable();
            }
          }
        }, {
          key: "_initialize",
          value: function _initialize() {
            var _this = this;

            // set own id
            this.options.id = func.uniqueId(external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.now()); // set default container for tooltips, popovers, and dialogs

            this.options.container = this.options.container || this.layoutInfo.editor; // add optional buttons

            var buttons = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.extend({}, this.options.buttons);
            Object.keys(buttons).forEach(function (key) {
              _this.memo('button.' + key, buttons[key]);
            });
            var modules = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.extend({}, this.options.modules, external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote.plugins || {}); // add and initialize modules

            Object.keys(modules).forEach(function (key) {
              _this.module(key, modules[key], true);
            });
            Object.keys(this.modules).forEach(function (key) {
              _this.initializeModule(key);
            });
          }
        }, {
          key: "_destroy",
          value: function _destroy() {
            var _this2 = this;

            // destroy modules with reversed order
            Object.keys(this.modules).reverse().forEach(function (key) {
              _this2.removeModule(key);
            });
            Object.keys(this.memos).forEach(function (key) {
              _this2.removeMemo(key);
            }); // trigger custom onDestroy callback

            this.triggerEvent('destroy', this);
          }
        }, {
          key: "code",
          value: function code(html) {
            var isActivated = this.invoke('codeview.isActivated');
            if (html === undefined) {
              this.invoke('codeview.sync');
              return isActivated ? this.layoutInfo.codable.val() : this.layoutInfo.editable.html();
            } else {
              if (isActivated) {
                this.invoke('codeview.sync', html);
              } else {
                this.layoutInfo.editable.html(html);
              }
              this.$note.val(html);
              this.triggerEvent('change', html, this.layoutInfo.editable);
            }
          }
        }, {
          key: "isDisabled",
          value: function isDisabled() {
            return this.layoutInfo.editable.attr('contenteditable') === 'false';
          }
        }, {
          key: "enable",
          value: function enable() {
            this.layoutInfo.editable.attr('contenteditable', true);
            this.invoke('toolbar.activate', true);
            this.triggerEvent('disable', false);
            this.options.editing = true;
          }
        }, {
          key: "disable",
          value: function disable() {
            // close codeview if codeview is opend
            if (this.invoke('codeview.isActivated')) {
              this.invoke('codeview.deactivate');
            }
            this.layoutInfo.editable.attr('contenteditable', false);
            this.options.editing = false;
            this.invoke('toolbar.deactivate', true);
            this.triggerEvent('disable', true);
          }
        }, {
          key: "triggerEvent",
          value: function triggerEvent() {
            var namespace = lists.head(arguments);
            var args = lists.tail(lists.from(arguments));
            var callback = this.options.callbacks[func.namespaceToCamel(namespace, 'on')];
            if (callback) {
              callback.apply(this.$note[0], args);
            }
            this.$note.trigger('summernote.' + namespace, args);
          }
        }, {
          key: "initializeModule",
          value: function initializeModule(key) {
            var module = this.modules[key];
            module.shouldInitialize = module.shouldInitialize || func.ok;
            if (!module.shouldInitialize()) {
              return;
            } // initialize module

            if (module.initialize) {
              module.initialize();
            } // attach events

            if (module.events) {
              dom.attachEvents(this.$note, module.events);
            }
          }
        }, {
          key: "module",
          value: function module(key, ModuleClass, withoutIntialize) {
            if (arguments.length === 1) {
              return this.modules[key];
            }
            this.modules[key] = new ModuleClass(this);
            if (!withoutIntialize) {
              this.initializeModule(key);
            }
          }
        }, {
          key: "removeModule",
          value: function removeModule(key) {
            var module = this.modules[key];
            if (module.shouldInitialize()) {
              if (module.events) {
                dom.detachEvents(this.$note, module.events);
              }
              if (module.destroy) {
                module.destroy();
              }
            }
            delete this.modules[key];
          }
        }, {
          key: "memo",
          value: function memo(key, obj) {
            if (arguments.length === 1) {
              return this.memos[key];
            }
            this.memos[key] = obj;
          }
        }, {
          key: "removeMemo",
          value: function removeMemo(key) {
            if (this.memos[key] && this.memos[key].destroy) {
              this.memos[key].destroy();
            }
            delete this.memos[key];
          }
          /**
           * Some buttons need to change their visual style immediately once they get pressed
           */
        }, {
          key: "createInvokeHandlerAndUpdateState",
          value: function createInvokeHandlerAndUpdateState(namespace, value) {
            var _this3 = this;
            return function (event) {
              _this3.createInvokeHandler(namespace, value)(event);
              _this3.invoke('buttons.updateCurrentStyle');
            };
          }
        }, {
          key: "createInvokeHandler",
          value: function createInvokeHandler(namespace, value) {
            var _this4 = this;
            return function (event) {
              event.preventDefault();
              var $target = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(event.target);
              _this4.invoke(namespace, value || $target.closest('[data-value]').data('value'), $target);
            };
          }
        }, {
          key: "invoke",
          value: function invoke() {
            var namespace = lists.head(arguments);
            var args = lists.tail(lists.from(arguments));
            var splits = namespace.split('.');
            var hasSeparator = splits.length > 1;
            var moduleName = hasSeparator && lists.head(splits);
            var methodName = hasSeparator ? lists.last(splits) : lists.head(splits);
            var module = this.modules[moduleName || 'editor'];
            if (!moduleName && this[methodName]) {
              return this[methodName].apply(this, args);
            } else if (module && module[methodName] && module.shouldInitialize()) {
              return module[methodName].apply(module, args);
            }
          }
        }]);
        return Context;
      }();

      // CONCATENATED MODULE: ./src/js/summernote.js

      external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.fn.extend({
        /**
         * Summernote API
         *
         * @param {Object|String}
         * @return {this}
         */
        summernote: function summernote() {
          var type = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.type(lists.head(arguments));
          var isExternalAPICalled = type === 'string';
          var hasInitOptions = type === 'object';
          var options = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.extend({}, external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote.options, hasInitOptions ? lists.head(arguments) : {}); // Update options

          options.langInfo = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.extend(true, {}, external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote.lang['en-US'], external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote.lang[options.lang]);
          options.icons = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.extend(true, {}, external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote.options.icons, options.icons);
          options.tooltip = options.tooltip === 'auto' ? !env.isSupportTouch : options.tooltip;
          this.each(function (idx, note) {
            var $note = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(note);
            if (!$note.data('summernote')) {
              var context = new Context_Context($note, options);
              $note.data('summernote', context);
              $note.data('summernote').triggerEvent('init', context.layoutInfo);
            }
          });
          var $note = this.first();
          if ($note.length) {
            var context = $note.data('summernote');
            if (isExternalAPICalled) {
              return context.invoke.apply(context, lists.from(arguments));
            } else if (options.focus) {
              context.invoke('editor.focus');
            }
          }
          return this;
        }
      });
      // CONCATENATED MODULE: ./src/js/base/core/range.js
      function range_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function range_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function range_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) range_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) range_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      /**
       * return boundaryPoint from TextRange, inspired by Andy Na's HuskyRange.js
       *
       * @param {TextRange} textRange
       * @param {Boolean} isStart
       * @return {BoundaryPoint}
       *
       * @see http://msdn.microsoft.com/en-us/library/ie/ms535872(v=vs.85).aspx
       */

      function textRangeToPoint(textRange, isStart) {
        var container = textRange.parentElement();
        var offset;
        var tester = document.body.createTextRange();
        var prevContainer;
        var childNodes = lists.from(container.childNodes);
        for (offset = 0; offset < childNodes.length; offset++) {
          if (dom.isText(childNodes[offset])) {
            continue;
          }
          tester.moveToElementText(childNodes[offset]);
          if (tester.compareEndPoints('StartToStart', textRange) >= 0) {
            break;
          }
          prevContainer = childNodes[offset];
        }
        if (offset !== 0 && dom.isText(childNodes[offset - 1])) {
          var textRangeStart = document.body.createTextRange();
          var curTextNode = null;
          textRangeStart.moveToElementText(prevContainer || container);
          textRangeStart.collapse(!prevContainer);
          curTextNode = prevContainer ? prevContainer.nextSibling : container.firstChild;
          var pointTester = textRange.duplicate();
          pointTester.setEndPoint('StartToStart', textRangeStart);
          var textCount = pointTester.text.replace(/[\r\n]/g, '').length;
          while (textCount > curTextNode.nodeValue.length && curTextNode.nextSibling) {
            textCount -= curTextNode.nodeValue.length;
            curTextNode = curTextNode.nextSibling;
          } // [workaround] enforce IE to re-reference curTextNode, hack

          var dummy = curTextNode.nodeValue; // eslint-disable-line

          if (isStart && curTextNode.nextSibling && dom.isText(curTextNode.nextSibling) && textCount === curTextNode.nodeValue.length) {
            textCount -= curTextNode.nodeValue.length;
            curTextNode = curTextNode.nextSibling;
          }
          container = curTextNode;
          offset = textCount;
        }
        return {
          cont: container,
          offset: offset
        };
      }
      /**
       * return TextRange from boundary point (inspired by google closure-library)
       * @param {BoundaryPoint} point
       * @return {TextRange}
       */

      function pointToTextRange(point) {
        var textRangeInfo = function textRangeInfo(container, offset) {
          var node, isCollapseToStart;
          if (dom.isText(container)) {
            var prevTextNodes = dom.listPrev(container, func.not(dom.isText));
            var prevContainer = lists.last(prevTextNodes).previousSibling;
            node = prevContainer || container.parentNode;
            offset += lists.sum(lists.tail(prevTextNodes), dom.nodeLength);
            isCollapseToStart = !prevContainer;
          } else {
            node = container.childNodes[offset] || container;
            if (dom.isText(node)) {
              return textRangeInfo(node, 0);
            }
            offset = 0;
            isCollapseToStart = false;
          }
          return {
            node: node,
            collapseToStart: isCollapseToStart,
            offset: offset
          };
        };
        var textRange = document.body.createTextRange();
        var info = textRangeInfo(point.node, point.offset);
        textRange.moveToElementText(info.node);
        textRange.collapse(info.collapseToStart);
        textRange.moveStart('character', info.offset);
        return textRange;
      }
      /**
         * Wrapped Range
         *
         * @constructor
         * @param {Node} sc - start container
         * @param {Number} so - start offset
         * @param {Node} ec - end container
         * @param {Number} eo - end offset
         */

      var range_WrappedRange = /*#__PURE__*/function () {
        function WrappedRange(sc, so, ec, eo) {
          range_classCallCheck(this, WrappedRange);
          this.sc = sc;
          this.so = so;
          this.ec = ec;
          this.eo = eo; // isOnEditable: judge whether range is on editable or not

          this.isOnEditable = this.makeIsOn(dom.isEditable); // isOnList: judge whether range is on list node or not

          this.isOnList = this.makeIsOn(dom.isList); // isOnAnchor: judge whether range is on anchor node or not

          this.isOnAnchor = this.makeIsOn(dom.isAnchor); // isOnCell: judge whether range is on cell node or not

          this.isOnCell = this.makeIsOn(dom.isCell); // isOnData: judge whether range is on data node or not

          this.isOnData = this.makeIsOn(dom.isData);
        } // nativeRange: get nativeRange from sc, so, ec, eo

        range_createClass(WrappedRange, [{
          key: "nativeRange",
          value: function nativeRange() {
            if (env.isW3CRangeSupport) {
              var w3cRange = document.createRange();
              w3cRange.setStart(this.sc, this.so);
              w3cRange.setEnd(this.ec, this.eo);
              return w3cRange;
            } else {
              var textRange = pointToTextRange({
                node: this.sc,
                offset: this.so
              });
              textRange.setEndPoint('EndToEnd', pointToTextRange({
                node: this.ec,
                offset: this.eo
              }));
              return textRange;
            }
          }
        }, {
          key: "getPoints",
          value: function getPoints() {
            return {
              sc: this.sc,
              so: this.so,
              ec: this.ec,
              eo: this.eo
            };
          }
        }, {
          key: "getStartPoint",
          value: function getStartPoint() {
            return {
              node: this.sc,
              offset: this.so
            };
          }
        }, {
          key: "getEndPoint",
          value: function getEndPoint() {
            return {
              node: this.ec,
              offset: this.eo
            };
          }
          /**
           * select update visible range
           */
        }, {
          key: "select",
          value: function select() {
            var nativeRng = this.nativeRange();
            if (env.isW3CRangeSupport) {
              var selection = document.getSelection();
              if (selection.rangeCount > 0) {
                selection.removeAllRanges();
              }
              selection.addRange(nativeRng);
            } else {
              nativeRng.select();
            }
            return this;
          }
          /**
           * Moves the scrollbar to start container(sc) of current range
           *
           * @return {WrappedRange}
           */
        }, {
          key: "scrollIntoView",
          value: function scrollIntoView(container) {
            var height = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(container).height();
            if (container.scrollTop + height < this.sc.offsetTop) {
              container.scrollTop += Math.abs(container.scrollTop + height - this.sc.offsetTop);
            }
            return this;
          }
          /**
           * @return {WrappedRange}
           */
        }, {
          key: "normalize",
          value: function normalize() {
            /**
             * @param {BoundaryPoint} point
             * @param {Boolean} isLeftToRight - true: prefer to choose right node
             *                                - false: prefer to choose left node
             * @return {BoundaryPoint}
             */
            var getVisiblePoint = function getVisiblePoint(point, isLeftToRight) {
              if (!point) {
                return point;
              } // Just use the given point [XXX:Adhoc]
              //  - case 01. if the point is on the middle of the node
              //  - case 02. if the point is on the right edge and prefer to choose left node
              //  - case 03. if the point is on the left edge and prefer to choose right node
              //  - case 04. if the point is on the right edge and prefer to choose right node but the node is void
              //  - case 05. if the point is on the left edge and prefer to choose left node but the node is void
              //  - case 06. if the point is on the block node and there is no children

              if (dom.isVisiblePoint(point)) {
                if (!dom.isEdgePoint(point) || dom.isRightEdgePoint(point) && !isLeftToRight || dom.isLeftEdgePoint(point) && isLeftToRight || dom.isRightEdgePoint(point) && isLeftToRight && dom.isVoid(point.node.nextSibling) || dom.isLeftEdgePoint(point) && !isLeftToRight && dom.isVoid(point.node.previousSibling) || dom.isBlock(point.node) && dom.isEmpty(point.node)) {
                  return point;
                }
              } // point on block's edge

              var block = dom.ancestor(point.node, dom.isBlock);
              var hasRightNode = false;
              if (!hasRightNode) {
                var prevPoint = dom.prevPoint(point) || {
                  node: null
                };
                hasRightNode = (dom.isLeftEdgePointOf(point, block) || dom.isVoid(prevPoint.node)) && !isLeftToRight;
              }
              var hasLeftNode = false;
              if (!hasLeftNode) {
                var _nextPoint = dom.nextPoint(point) || {
                  node: null
                };
                hasLeftNode = (dom.isRightEdgePointOf(point, block) || dom.isVoid(_nextPoint.node)) && isLeftToRight;
              }
              if (hasRightNode || hasLeftNode) {
                // returns point already on visible point
                if (dom.isVisiblePoint(point)) {
                  return point;
                } // reverse direction

                isLeftToRight = !isLeftToRight;
              }
              var nextPoint = isLeftToRight ? dom.nextPointUntil(dom.nextPoint(point), dom.isVisiblePoint) : dom.prevPointUntil(dom.prevPoint(point), dom.isVisiblePoint);
              return nextPoint || point;
            };
            var endPoint = getVisiblePoint(this.getEndPoint(), false);
            var startPoint = this.isCollapsed() ? endPoint : getVisiblePoint(this.getStartPoint(), true);
            return new WrappedRange(startPoint.node, startPoint.offset, endPoint.node, endPoint.offset);
          }
          /**
           * returns matched nodes on range
           *
           * @param {Function} [pred] - predicate function
           * @param {Object} [options]
           * @param {Boolean} [options.includeAncestor]
           * @param {Boolean} [options.fullyContains]
           * @return {Node[]}
           */
        }, {
          key: "nodes",
          value: function nodes(pred, options) {
            pred = pred || func.ok;
            var includeAncestor = options && options.includeAncestor;
            var fullyContains = options && options.fullyContains; // TODO compare points and sort

            var startPoint = this.getStartPoint();
            var endPoint = this.getEndPoint();
            var nodes = [];
            var leftEdgeNodes = [];
            dom.walkPoint(startPoint, endPoint, function (point) {
              if (dom.isEditable(point.node)) {
                return;
              }
              var node;
              if (fullyContains) {
                if (dom.isLeftEdgePoint(point)) {
                  leftEdgeNodes.push(point.node);
                }
                if (dom.isRightEdgePoint(point) && lists.contains(leftEdgeNodes, point.node)) {
                  node = point.node;
                }
              } else if (includeAncestor) {
                node = dom.ancestor(point.node, pred);
              } else {
                node = point.node;
              }
              if (node && pred(node)) {
                nodes.push(node);
              }
            }, true);
            return lists.unique(nodes);
          }
          /**
           * returns commonAncestor of range
           * @return {Element} - commonAncestor
           */
        }, {
          key: "commonAncestor",
          value: function commonAncestor() {
            return dom.commonAncestor(this.sc, this.ec);
          }
          /**
           * returns expanded range by pred
           *
           * @param {Function} pred - predicate function
           * @return {WrappedRange}
           */
        }, {
          key: "expand",
          value: function expand(pred) {
            var startAncestor = dom.ancestor(this.sc, pred);
            var endAncestor = dom.ancestor(this.ec, pred);
            if (!startAncestor && !endAncestor) {
              return new WrappedRange(this.sc, this.so, this.ec, this.eo);
            }
            var boundaryPoints = this.getPoints();
            if (startAncestor) {
              boundaryPoints.sc = startAncestor;
              boundaryPoints.so = 0;
            }
            if (endAncestor) {
              boundaryPoints.ec = endAncestor;
              boundaryPoints.eo = dom.nodeLength(endAncestor);
            }
            return new WrappedRange(boundaryPoints.sc, boundaryPoints.so, boundaryPoints.ec, boundaryPoints.eo);
          }
          /**
           * @param {Boolean} isCollapseToStart
           * @return {WrappedRange}
           */
        }, {
          key: "collapse",
          value: function collapse(isCollapseToStart) {
            if (isCollapseToStart) {
              return new WrappedRange(this.sc, this.so, this.sc, this.so);
            } else {
              return new WrappedRange(this.ec, this.eo, this.ec, this.eo);
            }
          }
          /**
           * splitText on range
           */
        }, {
          key: "splitText",
          value: function splitText() {
            var isSameContainer = this.sc === this.ec;
            var boundaryPoints = this.getPoints();
            if (dom.isText(this.ec) && !dom.isEdgePoint(this.getEndPoint())) {
              this.ec.splitText(this.eo);
            }
            if (dom.isText(this.sc) && !dom.isEdgePoint(this.getStartPoint())) {
              boundaryPoints.sc = this.sc.splitText(this.so);
              boundaryPoints.so = 0;
              if (isSameContainer) {
                boundaryPoints.ec = boundaryPoints.sc;
                boundaryPoints.eo = this.eo - this.so;
              }
            }
            return new WrappedRange(boundaryPoints.sc, boundaryPoints.so, boundaryPoints.ec, boundaryPoints.eo);
          }
          /**
           * delete contents on range
           * @return {WrappedRange}
           */
        }, {
          key: "deleteContents",
          value: function deleteContents() {
            if (this.isCollapsed()) {
              return this;
            }
            var rng = this.splitText();
            var nodes = rng.nodes(null, {
              fullyContains: true
            }); // find new cursor point

            var point = dom.prevPointUntil(rng.getStartPoint(), function (point) {
              return !lists.contains(nodes, point.node);
            });
            var emptyParents = [];
            external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(nodes, function (idx, node) {
              // find empty parents
              var parent = node.parentNode;
              if (point.node !== parent && dom.nodeLength(parent) === 1) {
                emptyParents.push(parent);
              }
              dom.remove(node, false);
            }); // remove empty parents

            external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(emptyParents, function (idx, node) {
              dom.remove(node, false);
            });
            return new WrappedRange(point.node, point.offset, point.node, point.offset).normalize();
          }
          /**
           * makeIsOn: return isOn(pred) function
           */
        }, {
          key: "makeIsOn",
          value: function makeIsOn(pred) {
            return function () {
              var ancestor = dom.ancestor(this.sc, pred);
              return !!ancestor && ancestor === dom.ancestor(this.ec, pred);
            };
          }
          /**
           * @param {Function} pred
           * @return {Boolean}
           */
        }, {
          key: "isLeftEdgeOf",
          value: function isLeftEdgeOf(pred) {
            if (!dom.isLeftEdgePoint(this.getStartPoint())) {
              return false;
            }
            var node = dom.ancestor(this.sc, pred);
            return node && dom.isLeftEdgeOf(this.sc, node);
          }
          /**
           * returns whether range was collapsed or not
           */
        }, {
          key: "isCollapsed",
          value: function isCollapsed() {
            return this.sc === this.ec && this.so === this.eo;
          }
          /**
           * wrap inline nodes which children of body with paragraph
           *
           * @return {WrappedRange}
           */
        }, {
          key: "wrapBodyInlineWithPara",
          value: function wrapBodyInlineWithPara() {
            if (dom.isBodyContainer(this.sc) && dom.isEmpty(this.sc)) {
              this.sc.innerHTML = dom.emptyPara;
              return new WrappedRange(this.sc.firstChild, 0, this.sc.firstChild, 0);
            }
            /**
             * [workaround] firefox often create range on not visible point. so normalize here.
             *  - firefox: |<p>text</p>|
             *  - chrome: <p>|text|</p>
             */

            var rng = this.normalize();
            if (dom.isParaInline(this.sc) || dom.isPara(this.sc)) {
              return rng;
            } // find inline top ancestor

            var topAncestor;
            if (dom.isInline(rng.sc)) {
              var ancestors = dom.listAncestor(rng.sc, func.not(dom.isInline));
              topAncestor = lists.last(ancestors);
              if (!dom.isInline(topAncestor)) {
                topAncestor = ancestors[ancestors.length - 2] || rng.sc.childNodes[rng.so];
              }
            } else {
              topAncestor = rng.sc.childNodes[rng.so > 0 ? rng.so - 1 : 0];
            }
            if (topAncestor) {
              // siblings not in paragraph
              var inlineSiblings = dom.listPrev(topAncestor, dom.isParaInline).reverse();
              inlineSiblings = inlineSiblings.concat(dom.listNext(topAncestor.nextSibling, dom.isParaInline)); // wrap with paragraph

              if (inlineSiblings.length) {
                var para = dom.wrap(lists.head(inlineSiblings), 'p');
                dom.appendChildNodes(para, lists.tail(inlineSiblings));
              }
            }
            return this.normalize();
          }
          /**
           * insert node at current cursor
           *
           * @param {Node} node
           * @return {Node}
           */
        }, {
          key: "insertNode",
          value: function insertNode(node) {
            var rng = this;
            if (dom.isText(node) || dom.isInline(node)) {
              rng = this.wrapBodyInlineWithPara().deleteContents();
            }
            var info = dom.splitPoint(rng.getStartPoint(), dom.isInline(node));
            if (info.rightNode) {
              info.rightNode.parentNode.insertBefore(node, info.rightNode);
              if (dom.isEmpty(info.rightNode) && dom.isPara(node)) {
                info.rightNode.parentNode.removeChild(info.rightNode);
              }
            } else {
              info.container.appendChild(node);
            }
            return node;
          }
          /**
           * insert html at current cursor
           */
        }, {
          key: "pasteHTML",
          value: function pasteHTML(markup) {
            markup = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.trim(markup);
            var contentsContainer = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<div></div>').html(markup)[0];
            var childNodes = lists.from(contentsContainer.childNodes); // const rng = this.wrapBodyInlineWithPara().deleteContents();

            var rng = this;
            var reversed = false;
            if (rng.so >= 0) {
              childNodes = childNodes.reverse();
              reversed = true;
            }
            childNodes = childNodes.map(function (childNode) {
              return rng.insertNode(childNode);
            });
            if (reversed) {
              childNodes = childNodes.reverse();
            }
            return childNodes;
          }
          /**
           * returns text in range
           *
           * @return {String}
           */
        }, {
          key: "toString",
          value: function toString() {
            var nativeRng = this.nativeRange();
            return env.isW3CRangeSupport ? nativeRng.toString() : nativeRng.text;
          }
          /**
           * returns range for word before cursor
           *
           * @param {Boolean} [findAfter] - find after cursor, default: false
           * @return {WrappedRange}
           */
        }, {
          key: "getWordRange",
          value: function getWordRange(findAfter) {
            var endPoint = this.getEndPoint();
            if (!dom.isCharPoint(endPoint)) {
              return this;
            }
            var startPoint = dom.prevPointUntil(endPoint, function (point) {
              return !dom.isCharPoint(point);
            });
            if (findAfter) {
              endPoint = dom.nextPointUntil(endPoint, function (point) {
                return !dom.isCharPoint(point);
              });
            }
            return new WrappedRange(startPoint.node, startPoint.offset, endPoint.node, endPoint.offset);
          }
          /**
           * returns range for words before cursor
           *
           * @param {Boolean} [findAfter] - find after cursor, default: false
           * @return {WrappedRange}
           */
        }, {
          key: "getWordsRange",
          value: function getWordsRange(findAfter) {
            var endPoint = this.getEndPoint();
            var isNotTextPoint = function isNotTextPoint(point) {
              return !dom.isCharPoint(point) && !dom.isSpacePoint(point);
            };
            if (isNotTextPoint(endPoint)) {
              return this;
            }
            var startPoint = dom.prevPointUntil(endPoint, isNotTextPoint);
            if (findAfter) {
              endPoint = dom.nextPointUntil(endPoint, isNotTextPoint);
            }
            return new WrappedRange(startPoint.node, startPoint.offset, endPoint.node, endPoint.offset);
          }
          /**
           * returns range for words before cursor that match with a Regex
           *
           * example:
           *  range: 'hi @Peter Pan'
           *  regex: '/@[a-z ]+/i'
           *  return range: '@Peter Pan'
           *
           * @param {RegExp} [regex]
           * @return {WrappedRange|null}
           */
        }, {
          key: "getWordsMatchRange",
          value: function getWordsMatchRange(regex) {
            var endPoint = this.getEndPoint();
            var startPoint = dom.prevPointUntil(endPoint, function (point) {
              if (!dom.isCharPoint(point) && !dom.isSpacePoint(point)) {
                return true;
              }
              var rng = new WrappedRange(point.node, point.offset, endPoint.node, endPoint.offset);
              var result = regex.exec(rng.toString());
              return result && result.index === 0;
            });
            var rng = new WrappedRange(startPoint.node, startPoint.offset, endPoint.node, endPoint.offset);
            var text = rng.toString();
            var result = regex.exec(text);
            if (result && result[0].length === text.length) {
              return rng;
            } else {
              return null;
            }
          }
          /**
           * create offsetPath bookmark
           *
           * @param {Node} editable
           */
        }, {
          key: "bookmark",
          value: function bookmark(editable) {
            return {
              s: {
                path: dom.makeOffsetPath(editable, this.sc),
                offset: this.so
              },
              e: {
                path: dom.makeOffsetPath(editable, this.ec),
                offset: this.eo
              }
            };
          }
          /**
           * create offsetPath bookmark base on paragraph
           *
           * @param {Node[]} paras
           */
        }, {
          key: "paraBookmark",
          value: function paraBookmark(paras) {
            return {
              s: {
                path: lists.tail(dom.makeOffsetPath(lists.head(paras), this.sc)),
                offset: this.so
              },
              e: {
                path: lists.tail(dom.makeOffsetPath(lists.last(paras), this.ec)),
                offset: this.eo
              }
            };
          }
          /**
           * getClientRects
           * @return {Rect[]}
           */
        }, {
          key: "getClientRects",
          value: function getClientRects() {
            var nativeRng = this.nativeRange();
            return nativeRng.getClientRects();
          }
        }]);
        return WrappedRange;
      }();
      /**
       * Data structure
       *  * BoundaryPoint: a point of dom tree
       *  * BoundaryPoints: two boundaryPoints corresponding to the start and the end of the Range
       *
       * See to http://www.w3.org/TR/DOM-Level-2-Traversal-Range/ranges.html#Level-2-Range-Position
       */

      /* harmony default export */
      var range = {
        /**
         * create Range Object From arguments or Browser Selection
         *
         * @param {Node} sc - start container
         * @param {Number} so - start offset
         * @param {Node} ec - end container
         * @param {Number} eo - end offset
         * @return {WrappedRange}
         */
        create: function create(sc, so, ec, eo) {
          if (arguments.length === 4) {
            return new range_WrappedRange(sc, so, ec, eo);
          } else if (arguments.length === 2) {
            // collapsed
            ec = sc;
            eo = so;
            return new range_WrappedRange(sc, so, ec, eo);
          } else {
            var wrappedRange = this.createFromSelection();
            if (!wrappedRange && arguments.length === 1) {
              var bodyElement = arguments[0];
              if (dom.isEditable(bodyElement)) {
                bodyElement = bodyElement.lastChild;
              }
              return this.createFromBodyElement(bodyElement, dom.emptyPara === arguments[0].innerHTML);
            }
            return wrappedRange;
          }
        },
        createFromBodyElement: function createFromBodyElement(bodyElement) {
          var isCollapseToStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          var wrappedRange = this.createFromNode(bodyElement);
          return wrappedRange.collapse(isCollapseToStart);
        },
        createFromSelection: function createFromSelection() {
          var sc, so, ec, eo;
          if (env.isW3CRangeSupport) {
            var selection = document.getSelection();
            if (!selection || selection.rangeCount === 0) {
              return null;
            } else if (dom.isBody(selection.anchorNode)) {
              // Firefox: returns entire body as range on initialization.
              // We won't never need it.
              return null;
            }
            var nativeRng = selection.getRangeAt(0);
            sc = nativeRng.startContainer;
            so = nativeRng.startOffset;
            ec = nativeRng.endContainer;
            eo = nativeRng.endOffset;
          } else {
            // IE8: TextRange
            var textRange = document.selection.createRange();
            var textRangeEnd = textRange.duplicate();
            textRangeEnd.collapse(false);
            var textRangeStart = textRange;
            textRangeStart.collapse(true);
            var startPoint = textRangeToPoint(textRangeStart, true);
            var endPoint = textRangeToPoint(textRangeEnd, false); // same visible point case: range was collapsed.

            if (dom.isText(startPoint.node) && dom.isLeftEdgePoint(startPoint) && dom.isTextNode(endPoint.node) && dom.isRightEdgePoint(endPoint) && endPoint.node.nextSibling === startPoint.node) {
              startPoint = endPoint;
            }
            sc = startPoint.cont;
            so = startPoint.offset;
            ec = endPoint.cont;
            eo = endPoint.offset;
          }
          return new range_WrappedRange(sc, so, ec, eo);
        },
        /**
         * @method
         *
         * create WrappedRange from node
         *
         * @param {Node} node
         * @return {WrappedRange}
         */
        createFromNode: function createFromNode(node) {
          var sc = node;
          var so = 0;
          var ec = node;
          var eo = dom.nodeLength(ec); // browsers can't target a picture or void node

          if (dom.isVoid(sc)) {
            so = dom.listPrev(sc).length - 1;
            sc = sc.parentNode;
          }
          if (dom.isBR(ec)) {
            eo = dom.listPrev(ec).length - 1;
            ec = ec.parentNode;
          } else if (dom.isVoid(ec)) {
            eo = dom.listPrev(ec).length;
            ec = ec.parentNode;
          }
          return this.create(sc, so, ec, eo);
        },
        /**
         * create WrappedRange from node after position
         *
         * @param {Node} node
         * @return {WrappedRange}
         */
        createFromNodeBefore: function createFromNodeBefore(node) {
          return this.createFromNode(node).collapse(true);
        },
        /**
         * create WrappedRange from node after position
         *
         * @param {Node} node
         * @return {WrappedRange}
         */
        createFromNodeAfter: function createFromNodeAfter(node) {
          return this.createFromNode(node).collapse();
        },
        /**
         * @method
         *
         * create WrappedRange from bookmark
         *
         * @param {Node} editable
         * @param {Object} bookmark
         * @return {WrappedRange}
         */
        createFromBookmark: function createFromBookmark(editable, bookmark) {
          var sc = dom.fromOffsetPath(editable, bookmark.s.path);
          var so = bookmark.s.offset;
          var ec = dom.fromOffsetPath(editable, bookmark.e.path);
          var eo = bookmark.e.offset;
          return new range_WrappedRange(sc, so, ec, eo);
        },
        /**
         * @method
         *
         * create WrappedRange from paraBookmark
         *
         * @param {Object} bookmark
         * @param {Node[]} paras
         * @return {WrappedRange}
         */
        createFromParaBookmark: function createFromParaBookmark(bookmark, paras) {
          var so = bookmark.s.offset;
          var eo = bookmark.e.offset;
          var sc = dom.fromOffsetPath(lists.head(paras), bookmark.s.path);
          var ec = dom.fromOffsetPath(lists.last(paras), bookmark.e.path);
          return new range_WrappedRange(sc, so, ec, eo);
        }
      };
      // CONCATENATED MODULE: ./src/js/base/core/key.js

      var KEY_MAP = {
        'BACKSPACE': 8,
        'TAB': 9,
        'ENTER': 13,
        'ESCAPE': 27,
        'SPACE': 32,
        'DELETE': 46,
        // Arrow
        'LEFT': 37,
        'UP': 38,
        'RIGHT': 39,
        'DOWN': 40,
        // Number: 0-9
        'NUM0': 48,
        'NUM1': 49,
        'NUM2': 50,
        'NUM3': 51,
        'NUM4': 52,
        'NUM5': 53,
        'NUM6': 54,
        'NUM7': 55,
        'NUM8': 56,
        // Alphabet: a-z
        'B': 66,
        'E': 69,
        'I': 73,
        'J': 74,
        'K': 75,
        'L': 76,
        'R': 82,
        'S': 83,
        'U': 85,
        'V': 86,
        'Y': 89,
        'Z': 90,
        'SLASH': 191,
        'LEFTBRACKET': 219,
        'BACKSLASH': 220,
        'RIGHTBRACKET': 221,
        // Navigation
        'HOME': 36,
        'END': 35,
        'PAGEUP': 33,
        'PAGEDOWN': 34
      };
      /**
       * @class core.key
       *
       * Object for keycodes.
       *
       * @singleton
       * @alternateClassName key
       */

      /* harmony default export */
      var core_key = {
        /**
         * @method isEdit
         *
         * @param {Number} keyCode
         * @return {Boolean}
         */
        isEdit: function isEdit(keyCode) {
          return lists.contains([KEY_MAP.BACKSPACE, KEY_MAP.TAB, KEY_MAP.ENTER, KEY_MAP.SPACE, KEY_MAP.DELETE], keyCode);
        },
        /**
         * @method isMove
         *
         * @param {Number} keyCode
         * @return {Boolean}
         */
        isMove: function isMove(keyCode) {
          return lists.contains([KEY_MAP.LEFT, KEY_MAP.UP, KEY_MAP.RIGHT, KEY_MAP.DOWN], keyCode);
        },
        /**
         * @method isNavigation
         *
         * @param {Number} keyCode
         * @return {Boolean}
         */
        isNavigation: function isNavigation(keyCode) {
          return lists.contains([KEY_MAP.HOME, KEY_MAP.END, KEY_MAP.PAGEUP, KEY_MAP.PAGEDOWN], keyCode);
        },
        /**
         * @property {Object} nameFromCode
         * @property {String} nameFromCode.8 "BACKSPACE"
         */
        nameFromCode: func.invertObject(KEY_MAP),
        code: KEY_MAP
      };
      // CONCATENATED MODULE: ./src/js/base/core/async.js

      /**
       * @method readFileAsDataURL
       *
       * read contents of file as representing URL
       *
       * @param {File} file
       * @return {Promise} - then: dataUrl
       */

      function readFileAsDataURL(file) {
        return external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.Deferred(function (deferred) {
          external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.extend(new FileReader(), {
            onload: function onload(e) {
              var dataURL = e.target.result;
              deferred.resolve(dataURL);
            },
            onerror: function onerror(err) {
              deferred.reject(err);
            }
          }).readAsDataURL(file);
        }).promise();
      }
      /**
       * @method createImage
       *
       * create `<image>` from url string
       *
       * @param {String} url
       * @return {Promise} - then: $image
       */

      function createImage(url) {
        return external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.Deferred(function (deferred) {
          var $img = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<img>');
          $img.one('load', function () {
            $img.off('error abort');
            deferred.resolve($img);
          }).one('error abort', function () {
            $img.off('load').detach();
            deferred.reject($img);
          }).css({
            display: 'none'
          }).appendTo(document.body).attr('src', url);
        }).promise();
      }
      // CONCATENATED MODULE: ./src/js/base/editing/History.js
      function History_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function History_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function History_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) History_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) History_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var History_History = /*#__PURE__*/function () {
        function History(context) {
          History_classCallCheck(this, History);
          this.stack = [];
          this.stackOffset = -1;
          this.context = context;
          this.$editable = context.layoutInfo.editable;
          this.editable = this.$editable[0];
        }
        History_createClass(History, [{
          key: "makeSnapshot",
          value: function makeSnapshot() {
            var rng = range.create(this.editable);
            var emptyBookmark = {
              s: {
                path: [],
                offset: 0
              },
              e: {
                path: [],
                offset: 0
              }
            };
            return {
              contents: this.$editable.html(),
              bookmark: rng && rng.isOnEditable() ? rng.bookmark(this.editable) : emptyBookmark
            };
          }
        }, {
          key: "applySnapshot",
          value: function applySnapshot(snapshot) {
            if (snapshot.contents !== null) {
              this.$editable.html(snapshot.contents);
            }
            if (snapshot.bookmark !== null) {
              range.createFromBookmark(this.editable, snapshot.bookmark).select();
            }
          }
          /**
          * @method rewind
          * Rewinds the history stack back to the first snapshot taken.
          * Leaves the stack intact, so that "Redo" can still be used.
          */
        }, {
          key: "rewind",
          value: function rewind() {
            // Create snap shot if not yet recorded
            if (this.$editable.html() !== this.stack[this.stackOffset].contents) {
              this.recordUndo();
            } // Return to the first available snapshot.

            this.stackOffset = 0; // Apply that snapshot.

            this.applySnapshot(this.stack[this.stackOffset]);
          }
          /**
          *  @method commit
          *  Resets history stack, but keeps current editor's content.
          */
        }, {
          key: "commit",
          value: function commit() {
            // Clear the stack.
            this.stack = []; // Restore stackOffset to its original value.

            this.stackOffset = -1; // Record our first snapshot (of nothing).

            this.recordUndo();
          }
          /**
          * @method reset
          * Resets the history stack completely; reverting to an empty editor.
          */
        }, {
          key: "reset",
          value: function reset() {
            // Clear the stack.
            this.stack = []; // Restore stackOffset to its original value.

            this.stackOffset = -1; // Clear the editable area.

            this.$editable.html(''); // Record our first snapshot (of nothing).

            this.recordUndo();
          }
          /**
           * undo
           */
        }, {
          key: "undo",
          value: function undo() {
            // Create snap shot if not yet recorded
            if (this.$editable.html() !== this.stack[this.stackOffset].contents) {
              this.recordUndo();
            }
            if (this.stackOffset > 0) {
              this.stackOffset--;
              this.applySnapshot(this.stack[this.stackOffset]);
            }
          }
          /**
           * redo
           */
        }, {
          key: "redo",
          value: function redo() {
            if (this.stack.length - 1 > this.stackOffset) {
              this.stackOffset++;
              this.applySnapshot(this.stack[this.stackOffset]);
            }
          }
          /**
           * recorded undo
           */
        }, {
          key: "recordUndo",
          value: function recordUndo() {
            this.stackOffset++; // Wash out stack after stackOffset

            if (this.stack.length > this.stackOffset) {
              this.stack = this.stack.slice(0, this.stackOffset);
            } // Create new snapshot and push it to the end

            this.stack.push(this.makeSnapshot()); // If the stack size reachs to the limit, then slice it

            if (this.stack.length > this.context.options.historyLimit) {
              this.stack.shift();
              this.stackOffset -= 1;
            }
          }
        }]);
        return History;
      }();

      // CONCATENATED MODULE: ./src/js/base/editing/Style.js
      function Style_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function Style_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function Style_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) Style_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Style_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var Style_Style = /*#__PURE__*/function () {
        function Style() {
          Style_classCallCheck(this, Style);
        }
        Style_createClass(Style, [{
          key: "jQueryCSS",
          /**
           * @method jQueryCSS
           *
           * [workaround] for old jQuery
           * passing an array of style properties to .css()
           * will result in an object of property-value pairs.
           * (compability with version < 1.9)
           *
           * @private
           * @param  {jQuery} $obj
           * @param  {Array} propertyNames - An array of one or more CSS properties.
           * @return {Object}
           */
          value: function jQueryCSS($obj, propertyNames) {
            if (env.jqueryVersion < 1.9) {
              var result = {};
              external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(propertyNames, function (idx, propertyName) {
                result[propertyName] = $obj.css(propertyName);
              });
              return result;
            }
            return $obj.css(propertyNames);
          }
          /**
           * returns style object from node
           *
           * @param {jQuery} $node
           * @return {Object}
           */
        }, {
          key: "fromNode",
          value: function fromNode($node) {
            var properties = ['font-family', 'font-size', 'text-align', 'list-style-type', 'line-height'];
            var styleInfo = this.jQueryCSS($node, properties) || {};
            var fontSize = $node[0].style.fontSize || styleInfo['font-size'];
            styleInfo['font-size'] = parseInt(fontSize, 10);
            styleInfo['font-size-unit'] = fontSize.match(/[a-z%]+$/);
            return styleInfo;
          }
          /**
           * paragraph level style
           *
           * @param {WrappedRange} rng
           * @param {Object} styleInfo
           */
        }, {
          key: "stylePara",
          value: function stylePara(rng, styleInfo) {
            external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(rng.nodes(dom.isPara, {
              includeAncestor: true
            }), function (idx, para) {
              external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(para).css(styleInfo);
            });
          }
          /**
           * insert and returns styleNodes on range.
           *
           * @param {WrappedRange} rng
           * @param {Object} [options] - options for styleNodes
           * @param {String} [options.nodeName] - default: `SPAN`
           * @param {Boolean} [options.expandClosestSibling] - default: `false`
           * @param {Boolean} [options.onlyPartialContains] - default: `false`
           * @return {Node[]}
           */
        }, {
          key: "styleNodes",
          value: function styleNodes(rng, options) {
            rng = rng.splitText();
            var nodeName = options && options.nodeName || 'SPAN';
            var expandClosestSibling = !!(options && options.expandClosestSibling);
            var onlyPartialContains = !!(options && options.onlyPartialContains);
            if (rng.isCollapsed()) {
              return [rng.insertNode(dom.create(nodeName))];
            }
            var pred = dom.makePredByNodeName(nodeName);
            var nodes = rng.nodes(dom.isText, {
              fullyContains: true
            }).map(function (text) {
              return dom.singleChildAncestor(text, pred) || dom.wrap(text, nodeName);
            });
            if (expandClosestSibling) {
              if (onlyPartialContains) {
                var nodesInRange = rng.nodes(); // compose with partial contains predication

                pred = func.and(pred, function (node) {
                  return lists.contains(nodesInRange, node);
                });
              }
              return nodes.map(function (node) {
                var siblings = dom.withClosestSiblings(node, pred);
                var head = lists.head(siblings);
                var tails = lists.tail(siblings);
                external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(tails, function (idx, elem) {
                  dom.appendChildNodes(head, elem.childNodes);
                  dom.remove(elem);
                });
                return lists.head(siblings);
              });
            } else {
              return nodes;
            }
          }
          /**
           * get current style on cursor
           *
           * @param {WrappedRange} rng
           * @return {Object} - object contains style properties.
           */
        }, {
          key: "current",
          value: function current(rng) {
            var $cont = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(!dom.isElement(rng.sc) ? rng.sc.parentNode : rng.sc);
            var styleInfo = this.fromNode($cont); // document.queryCommandState for toggle state
            // [workaround] prevent Firefox nsresult: "0x80004005 (NS_ERROR_FAILURE)"

            try {
              styleInfo = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.extend(styleInfo, {
                'font-bold': document.queryCommandState('bold') ? 'bold' : 'normal',
                'font-italic': document.queryCommandState('italic') ? 'italic' : 'normal',
                'font-underline': document.queryCommandState('underline') ? 'underline' : 'normal',
                'font-subscript': document.queryCommandState('subscript') ? 'subscript' : 'normal',
                'font-superscript': document.queryCommandState('superscript') ? 'superscript' : 'normal',
                'font-strikethrough': document.queryCommandState('strikethrough') ? 'strikethrough' : 'normal',
                'font-family': document.queryCommandValue('fontname') || styleInfo['font-family']
              });
            } catch (e) {} // eslint-disable-next-line
            // list-style-type to list-style(unordered, ordered)

            if (!rng.isOnList()) {
              styleInfo['list-style'] = 'none';
            } else {
              var orderedTypes = ['circle', 'disc', 'disc-leading-zero', 'square'];
              var isUnordered = orderedTypes.indexOf(styleInfo['list-style-type']) > -1;
              styleInfo['list-style'] = isUnordered ? 'unordered' : 'ordered';
            }
            var para = dom.ancestor(rng.sc, dom.isPara);
            if (para && para.style['line-height']) {
              styleInfo['line-height'] = para.style.lineHeight;
            } else {
              var lineHeight = parseInt(styleInfo['line-height'], 10) / parseInt(styleInfo['font-size'], 10);
              styleInfo['line-height'] = lineHeight.toFixed(1);
            }
            styleInfo.anchor = rng.isOnAnchor() && dom.ancestor(rng.sc, dom.isAnchor);
            styleInfo.ancestors = dom.listAncestor(rng.sc, dom.isEditable);
            styleInfo.range = rng;
            return styleInfo;
          }
        }]);
        return Style;
      }();

      // CONCATENATED MODULE: ./src/js/base/editing/Bullet.js
      function Bullet_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function Bullet_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function Bullet_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) Bullet_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Bullet_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var Bullet_Bullet = /*#__PURE__*/function () {
        function Bullet() {
          Bullet_classCallCheck(this, Bullet);
        }
        Bullet_createClass(Bullet, [{
          key: "insertOrderedList",
          /**
           * toggle ordered list
           */
          value: function insertOrderedList(editable) {
            this.toggleList('OL', editable);
          }
          /**
           * toggle unordered list
           */
        }, {
          key: "insertUnorderedList",
          value: function insertUnorderedList(editable) {
            this.toggleList('UL', editable);
          }
          /**
           * indent
           */
        }, {
          key: "indent",
          value: function indent(editable) {
            var _this = this;
            var rng = range.create(editable).wrapBodyInlineWithPara();
            var paras = rng.nodes(dom.isPara, {
              includeAncestor: true
            });
            var clustereds = lists.clusterBy(paras, func.peq2('parentNode'));
            external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(clustereds, function (idx, paras) {
              var head = lists.head(paras);
              if (dom.isLi(head)) {
                var previousList = _this.findList(head.previousSibling);
                if (previousList) {
                  paras.map(function (para) {
                    return previousList.appendChild(para);
                  });
                } else {
                  _this.wrapList(paras, head.parentNode.nodeName);
                  paras.map(function (para) {
                    return para.parentNode;
                  }).map(function (para) {
                    return _this.appendToPrevious(para);
                  });
                }
              } else {
                external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(paras, function (idx, para) {
                  external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(para).css('marginLeft', function (idx, val) {
                    return (parseInt(val, 10) || 0) + 25;
                  });
                });
              }
            });
            rng.select();
          }
          /**
           * outdent
           */
        }, {
          key: "outdent",
          value: function outdent(editable) {
            var _this2 = this;
            var rng = range.create(editable).wrapBodyInlineWithPara();
            var paras = rng.nodes(dom.isPara, {
              includeAncestor: true
            });
            var clustereds = lists.clusterBy(paras, func.peq2('parentNode'));
            external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(clustereds, function (idx, paras) {
              var head = lists.head(paras);
              if (dom.isLi(head)) {
                _this2.releaseList([paras]);
              } else {
                external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(paras, function (idx, para) {
                  external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(para).css('marginLeft', function (idx, val) {
                    val = parseInt(val, 10) || 0;
                    return val > 25 ? val - 25 : '';
                  });
                });
              }
            });
            rng.select();
          }
          /**
           * toggle list
           *
           * @param {String} listName - OL or UL
           */
        }, {
          key: "toggleList",
          value: function toggleList(listName, editable) {
            var _this3 = this;
            var rng = range.create(editable).wrapBodyInlineWithPara();
            var paras = rng.nodes(dom.isPara, {
              includeAncestor: true
            });
            var bookmark = rng.paraBookmark(paras);
            var clustereds = lists.clusterBy(paras, func.peq2('parentNode')); // paragraph to list

            if (lists.find(paras, dom.isPurePara)) {
              var wrappedParas = [];
              external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(clustereds, function (idx, paras) {
                wrappedParas = wrappedParas.concat(_this3.wrapList(paras, listName));
              });
              paras = wrappedParas; // list to paragraph or change list style
            } else {
              var diffLists = rng.nodes(dom.isList, {
                includeAncestor: true
              }).filter(function (listNode) {
                return !external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.nodeName(listNode, listName);
              });
              if (diffLists.length) {
                external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(diffLists, function (idx, listNode) {
                  dom.replace(listNode, listName);
                });
              } else {
                paras = this.releaseList(clustereds, true);
              }
            }
            range.createFromParaBookmark(bookmark, paras).select();
          }
          /**
           * @param {Node[]} paras
           * @param {String} listName
           * @return {Node[]}
           */
        }, {
          key: "wrapList",
          value: function wrapList(paras, listName) {
            var head = lists.head(paras);
            var last = lists.last(paras);
            var prevList = dom.isList(head.previousSibling) && head.previousSibling;
            var nextList = dom.isList(last.nextSibling) && last.nextSibling;
            var listNode = prevList || dom.insertAfter(dom.create(listName || 'UL'), last); // P to LI

            paras = paras.map(function (para) {
              return dom.isPurePara(para) ? dom.replace(para, 'LI') : para;
            }); // append to list(<ul>, <ol>)

            dom.appendChildNodes(listNode, paras);
            if (nextList) {
              dom.appendChildNodes(listNode, lists.from(nextList.childNodes));
              dom.remove(nextList);
            }
            return paras;
          }
          /**
           * @method releaseList
           *
           * @param {Array[]} clustereds
           * @param {Boolean} isEscapseToBody
           * @return {Node[]}
           */
        }, {
          key: "releaseList",
          value: function releaseList(clustereds, isEscapseToBody) {
            var _this4 = this;
            var releasedParas = [];
            external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(clustereds, function (idx, paras) {
              var head = lists.head(paras);
              var last = lists.last(paras);
              var headList = isEscapseToBody ? dom.lastAncestor(head, dom.isList) : head.parentNode;
              var parentItem = headList.parentNode;
              if (headList.parentNode.nodeName === 'LI') {
                paras.map(function (para) {
                  var newList = _this4.findNextSiblings(para);
                  if (parentItem.nextSibling) {
                    parentItem.parentNode.insertBefore(para, parentItem.nextSibling);
                  } else {
                    parentItem.parentNode.appendChild(para);
                  }
                  if (newList.length) {
                    _this4.wrapList(newList, headList.nodeName);
                    para.appendChild(newList[0].parentNode);
                  }
                });
                if (headList.children.length === 0) {
                  parentItem.removeChild(headList);
                }
                if (parentItem.childNodes.length === 0) {
                  parentItem.parentNode.removeChild(parentItem);
                }
              } else {
                var lastList = headList.childNodes.length > 1 ? dom.splitTree(headList, {
                  node: last.parentNode,
                  offset: dom.position(last) + 1
                }, {
                  isSkipPaddingBlankHTML: true
                }) : null;
                var middleList = dom.splitTree(headList, {
                  node: head.parentNode,
                  offset: dom.position(head)
                }, {
                  isSkipPaddingBlankHTML: true
                });
                paras = isEscapseToBody ? dom.listDescendant(middleList, dom.isLi) : lists.from(middleList.childNodes).filter(dom.isLi); // LI to P

                if (isEscapseToBody || !dom.isList(headList.parentNode)) {
                  paras = paras.map(function (para) {
                    return dom.replace(para, 'P');
                  });
                }
                external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(lists.from(paras).reverse(), function (idx, para) {
                  dom.insertAfter(para, headList);
                }); // remove empty lists

                var rootLists = lists.compact([headList, middleList, lastList]);
                external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(rootLists, function (idx, rootList) {
                  var listNodes = [rootList].concat(dom.listDescendant(rootList, dom.isList));
                  external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(listNodes.reverse(), function (idx, listNode) {
                    if (!dom.nodeLength(listNode)) {
                      dom.remove(listNode, true);
                    }
                  });
                });
              }
              releasedParas = releasedParas.concat(paras);
            });
            return releasedParas;
          }
          /**
           * @method appendToPrevious
           *
           * Appends list to previous list item, if
           * none exist it wraps the list in a new list item.
           *
           * @param {HTMLNode} ListItem
           * @return {HTMLNode}
           */
        }, {
          key: "appendToPrevious",
          value: function appendToPrevious(node) {
            return node.previousSibling ? dom.appendChildNodes(node.previousSibling, [node]) : this.wrapList([node], 'LI');
          }
          /**
           * @method findList
           *
           * Finds an existing list in list item
           *
           * @param {HTMLNode} ListItem
           * @return {Array[]}
           */
        }, {
          key: "findList",
          value: function findList(node) {
            return node ? lists.find(node.children, function (child) {
              return ['OL', 'UL'].indexOf(child.nodeName) > -1;
            }) : null;
          }
          /**
           * @method findNextSiblings
           *
           * Finds all list item siblings that follow it
           *
           * @param {HTMLNode} ListItem
           * @return {HTMLNode}
           */
        }, {
          key: "findNextSiblings",
          value: function findNextSiblings(node) {
            var siblings = [];
            while (node.nextSibling) {
              siblings.push(node.nextSibling);
              node = node.nextSibling;
            }
            return siblings;
          }
        }]);
        return Bullet;
      }();

      // CONCATENATED MODULE: ./src/js/base/editing/Typing.js
      function Typing_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function Typing_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function Typing_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) Typing_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Typing_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      /**
       * @class editing.Typing
       *
       * Typing
       *
       */

      var Typing_Typing = /*#__PURE__*/function () {
        function Typing(context) {
          Typing_classCallCheck(this, Typing);

          // a Bullet instance to toggle lists off
          this.bullet = new Bullet_Bullet();
          this.options = context.options;
        }
        /**
         * insert tab
         *
         * @param {WrappedRange} rng
         * @param {Number} tabsize
         */

        Typing_createClass(Typing, [{
          key: "insertTab",
          value: function insertTab(rng, tabsize) {
            var tab = dom.createText(new Array(tabsize + 1).join(dom.NBSP_CHAR));
            rng = rng.deleteContents();
            rng.insertNode(tab, true);
            rng = range.create(tab, tabsize);
            rng.select();
          }
          /**
           * insert paragraph
           *
           * @param {jQuery} $editable
           * @param {WrappedRange} rng Can be used in unit tests to "mock" the range
           *
           * blockquoteBreakingLevel
           *   0 - No break, the new paragraph remains inside the quote
           *   1 - Break the first blockquote in the ancestors list
           *   2 - Break all blockquotes, so that the new paragraph is not quoted (this is the default)
           */
        }, {
          key: "insertParagraph",
          value: function insertParagraph(editable, rng) {
            rng = rng || range.create(editable); // deleteContents on range.

            rng = rng.deleteContents(); // Wrap range if it needs to be wrapped by paragraph

            rng = rng.wrapBodyInlineWithPara(); // finding paragraph

            var splitRoot = dom.ancestor(rng.sc, dom.isPara);
            var nextPara; // on paragraph: split paragraph

            if (splitRoot) {
              // if it is an empty line with li
              if (dom.isLi(splitRoot) && (dom.isEmpty(splitRoot) || dom.deepestChildIsEmpty(splitRoot))) {
                // toggle UL/OL and escape
                this.bullet.toggleList(splitRoot.parentNode.nodeName);
                return;
              } else {
                var blockquote = null;
                if (this.options.blockquoteBreakingLevel === 1) {
                  blockquote = dom.ancestor(splitRoot, dom.isBlockquote);
                } else if (this.options.blockquoteBreakingLevel === 2) {
                  blockquote = dom.lastAncestor(splitRoot, dom.isBlockquote);
                }
                if (blockquote) {
                  // We're inside a blockquote and options ask us to break it
                  nextPara = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(dom.emptyPara)[0]; // If the split is right before a <br>, remove it so that there's no "empty line"
                  // after the split in the new blockquote created

                  if (dom.isRightEdgePoint(rng.getStartPoint()) && dom.isBR(rng.sc.nextSibling)) {
                    external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(rng.sc.nextSibling).remove();
                  }
                  var split = dom.splitTree(blockquote, rng.getStartPoint(), {
                    isDiscardEmptySplits: true
                  });
                  if (split) {
                    split.parentNode.insertBefore(nextPara, split);
                  } else {
                    dom.insertAfter(nextPara, blockquote); // There's no split if we were at the end of the blockquote
                  }
                } else {
                  nextPara = dom.splitTree(splitRoot, rng.getStartPoint()); // not a blockquote, just insert the paragraph

                  var emptyAnchors = dom.listDescendant(splitRoot, dom.isEmptyAnchor);
                  emptyAnchors = emptyAnchors.concat(dom.listDescendant(nextPara, dom.isEmptyAnchor));
                  external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(emptyAnchors, function (idx, anchor) {
                    dom.remove(anchor);
                  }); // replace empty heading, pre or custom-made styleTag with P tag

                  if ((dom.isHeading(nextPara) || dom.isPre(nextPara) || dom.isCustomStyleTag(nextPara)) && dom.isEmpty(nextPara)) {
                    nextPara = dom.replace(nextPara, 'p');
                  }
                }
              } // no paragraph: insert empty paragraph
            } else {
              var next = rng.sc.childNodes[rng.so];
              nextPara = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(dom.emptyPara)[0];
              if (next) {
                rng.sc.insertBefore(nextPara, next);
              } else {
                rng.sc.appendChild(nextPara);
              }
            }
            range.create(nextPara, 0).normalize().select().scrollIntoView(editable);
          }
        }]);
        return Typing;
      }();

      // CONCATENATED MODULE: ./src/js/base/editing/Table.js
      function Table_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function Table_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function Table_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) Table_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Table_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      /**
       * @class Create a virtual table to create what actions to do in change.
       * @param {object} startPoint Cell selected to apply change.
       * @param {enum} where  Where change will be applied Row or Col. Use enum: TableResultAction.where
       * @param {enum} action Action to be applied. Use enum: TableResultAction.requestAction
       * @param {object} domTable Dom element of table to make changes.
       */

      var TableResultAction = function TableResultAction(startPoint, where, action, domTable) {
        var _startPoint = {
          'colPos': 0,
          'rowPos': 0
        };
        var _virtualTable = [];
        var _actionCellList = []; /// ///////////////////////////////////////////
        // Private functions
        /// ///////////////////////////////////////////

        /**
         * Set the startPoint of action.
         */

        function setStartPoint() {
          if (!startPoint || !startPoint.tagName || startPoint.tagName.toLowerCase() !== 'td' && startPoint.tagName.toLowerCase() !== 'th') {
            // Impossible to identify start Cell point
            return;
          }
          _startPoint.colPos = startPoint.cellIndex;
          if (!startPoint.parentElement || !startPoint.parentElement.tagName || startPoint.parentElement.tagName.toLowerCase() !== 'tr') {
            // Impossible to identify start Row point
            return;
          }
          _startPoint.rowPos = startPoint.parentElement.rowIndex;
        }
        /**
         * Define virtual table position info object.
         *
         * @param {int} rowIndex Index position in line of virtual table.
         * @param {int} cellIndex Index position in column of virtual table.
         * @param {object} baseRow Row affected by this position.
         * @param {object} baseCell Cell affected by this position.
         * @param {bool} isSpan Inform if it is an span cell/row.
         */

        function setVirtualTablePosition(rowIndex, cellIndex, baseRow, baseCell, isRowSpan, isColSpan, isVirtualCell) {
          var objPosition = {
            'baseRow': baseRow,
            'baseCell': baseCell,
            'isRowSpan': isRowSpan,
            'isColSpan': isColSpan,
            'isVirtual': isVirtualCell
          };
          if (!_virtualTable[rowIndex]) {
            _virtualTable[rowIndex] = [];
          }
          _virtualTable[rowIndex][cellIndex] = objPosition;
        }
        /**
         * Create action cell object.
         *
         * @param {object} virtualTableCellObj Object of specific position on virtual table.
         * @param {enum} resultAction Action to be applied in that item.
         */

        function getActionCell(virtualTableCellObj, resultAction, virtualRowPosition, virtualColPosition) {
          return {
            'baseCell': virtualTableCellObj.baseCell,
            'action': resultAction,
            'virtualTable': {
              'rowIndex': virtualRowPosition,
              'cellIndex': virtualColPosition
            }
          };
        }
        /**
         * Recover free index of row to append Cell.
         *
         * @param {int} rowIndex Index of row to find free space.
         * @param {int} cellIndex Index of cell to find free space in table.
         */

        function recoverCellIndex(rowIndex, cellIndex) {
          if (!_virtualTable[rowIndex]) {
            return cellIndex;
          }
          if (!_virtualTable[rowIndex][cellIndex]) {
            return cellIndex;
          }
          var newCellIndex = cellIndex;
          while (_virtualTable[rowIndex][newCellIndex]) {
            newCellIndex++;
            if (!_virtualTable[rowIndex][newCellIndex]) {
              return newCellIndex;
            }
          }
        }
        /**
         * Recover info about row and cell and add information to virtual table.
         *
         * @param {object} row Row to recover information.
         * @param {object} cell Cell to recover information.
         */

        function addCellInfoToVirtual(row, cell) {
          var cellIndex = recoverCellIndex(row.rowIndex, cell.cellIndex);
          var cellHasColspan = cell.colSpan > 1;
          var cellHasRowspan = cell.rowSpan > 1;
          var isThisSelectedCell = row.rowIndex === _startPoint.rowPos && cell.cellIndex === _startPoint.colPos;
          setVirtualTablePosition(row.rowIndex, cellIndex, row, cell, cellHasRowspan, cellHasColspan, false); // Add span rows to virtual Table.

          var rowspanNumber = cell.attributes.rowSpan ? parseInt(cell.attributes.rowSpan.value, 10) : 0;
          if (rowspanNumber > 1) {
            for (var rp = 1; rp < rowspanNumber; rp++) {
              var rowspanIndex = row.rowIndex + rp;
              adjustStartPoint(rowspanIndex, cellIndex, cell, isThisSelectedCell);
              setVirtualTablePosition(rowspanIndex, cellIndex, row, cell, true, cellHasColspan, true);
            }
          } // Add span cols to virtual table.

          var colspanNumber = cell.attributes.colSpan ? parseInt(cell.attributes.colSpan.value, 10) : 0;
          if (colspanNumber > 1) {
            for (var cp = 1; cp < colspanNumber; cp++) {
              var cellspanIndex = recoverCellIndex(row.rowIndex, cellIndex + cp);
              adjustStartPoint(row.rowIndex, cellspanIndex, cell, isThisSelectedCell);
              setVirtualTablePosition(row.rowIndex, cellspanIndex, row, cell, cellHasRowspan, true, true);
            }
          }
        }
        /**
         * Process validation and adjust of start point if needed
         *
         * @param {int} rowIndex
         * @param {int} cellIndex
         * @param {object} cell
         * @param {bool} isSelectedCell
         */

        function adjustStartPoint(rowIndex, cellIndex, cell, isSelectedCell) {
          if (rowIndex === _startPoint.rowPos && _startPoint.colPos >= cell.cellIndex && cell.cellIndex <= cellIndex && !isSelectedCell) {
            _startPoint.colPos++;
          }
        }
        /**
         * Create virtual table of cells with all cells, including span cells.
         */

        function createVirtualTable() {
          var rows = domTable.rows;
          for (var rowIndex = 0; rowIndex < rows.length; rowIndex++) {
            var cells = rows[rowIndex].cells;
            for (var cellIndex = 0; cellIndex < cells.length; cellIndex++) {
              addCellInfoToVirtual(rows[rowIndex], cells[cellIndex]);
            }
          }
        }
        /**
         * Get action to be applied on the cell.
         *
         * @param {object} cell virtual table cell to apply action
         */

        function getDeleteResultActionToCell(cell) {
          switch (where) {
            case TableResultAction.where.Column:
              if (cell.isColSpan) {
                return TableResultAction.resultAction.SubtractSpanCount;
              }
              break;
            case TableResultAction.where.Row:
              if (!cell.isVirtual && cell.isRowSpan) {
                return TableResultAction.resultAction.AddCell;
              } else if (cell.isRowSpan) {
                return TableResultAction.resultAction.SubtractSpanCount;
              }
              break;
          }
          return TableResultAction.resultAction.RemoveCell;
        }
        /**
         * Get action to be applied on the cell.
         *
         * @param {object} cell virtual table cell to apply action
         */

        function getAddResultActionToCell(cell) {
          switch (where) {
            case TableResultAction.where.Column:
              if (cell.isColSpan) {
                return TableResultAction.resultAction.SumSpanCount;
              } else if (cell.isRowSpan && cell.isVirtual) {
                return TableResultAction.resultAction.Ignore;
              }
              break;
            case TableResultAction.where.Row:
              if (cell.isRowSpan) {
                return TableResultAction.resultAction.SumSpanCount;
              } else if (cell.isColSpan && cell.isVirtual) {
                return TableResultAction.resultAction.Ignore;
              }
              break;
          }
          return TableResultAction.resultAction.AddCell;
        }
        function init() {
          setStartPoint();
          createVirtualTable();
        } /// ///////////////////////////////////////////
        // Public functions
        /// ///////////////////////////////////////////

        /**
         * Recover array os what to do in table.
         */

        this.getActionList = function () {
          var fixedRow = where === TableResultAction.where.Row ? _startPoint.rowPos : -1;
          var fixedCol = where === TableResultAction.where.Column ? _startPoint.colPos : -1;
          var actualPosition = 0;
          var canContinue = true;
          while (canContinue) {
            var rowPosition = fixedRow >= 0 ? fixedRow : actualPosition;
            var colPosition = fixedCol >= 0 ? fixedCol : actualPosition;
            var row = _virtualTable[rowPosition];
            if (!row) {
              canContinue = false;
              return _actionCellList;
            }
            var cell = row[colPosition];
            if (!cell) {
              canContinue = false;
              return _actionCellList;
            } // Define action to be applied in this cell

            var resultAction = TableResultAction.resultAction.Ignore;
            switch (action) {
              case TableResultAction.requestAction.Add:
                resultAction = getAddResultActionToCell(cell);
                break;
              case TableResultAction.requestAction.Delete:
                resultAction = getDeleteResultActionToCell(cell);
                break;
            }
            _actionCellList.push(getActionCell(cell, resultAction, rowPosition, colPosition));
            actualPosition++;
          }
          return _actionCellList;
        };
        init();
      };
      /**
      *
      * Where action occours enum.
      */

      TableResultAction.where = {
        'Row': 0,
        'Column': 1
      };
      /**
      *
      * Requested action to apply enum.
      */

      TableResultAction.requestAction = {
        'Add': 0,
        'Delete': 1
      };
      /**
      *
      * Result action to be executed enum.
      */

      TableResultAction.resultAction = {
        'Ignore': 0,
        'SubtractSpanCount': 1,
        'RemoveCell': 2,
        'AddCell': 3,
        'SumSpanCount': 4
      };
      /**
       *
       * @class editing.Table
       *
       * Table
       *
       */

      var Table_Table = /*#__PURE__*/function () {
        function Table() {
          Table_classCallCheck(this, Table);
        }
        Table_createClass(Table, [{
          key: "tab",
          /**
           * handle tab key
           *
           * @param {WrappedRange} rng
           * @param {Boolean} isShift
           */
          value: function tab(rng, isShift) {
            var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
            var table = dom.ancestor(cell, dom.isTable);
            var cells = dom.listDescendant(table, dom.isCell);
            var nextCell = lists[isShift ? 'prev' : 'next'](cells, cell);
            if (nextCell) {
              range.create(nextCell, 0).select();
            }
          }
          /**
           * Add a new row
           *
           * @param {WrappedRange} rng
           * @param {String} position (top/bottom)
           * @return {Node}
           */
        }, {
          key: "addRow",
          value: function addRow(rng, position) {
            var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
            var currentTr = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(cell).closest('tr');
            var trAttributes = this.recoverAttributes(currentTr);
            var html = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<tr' + trAttributes + '></tr>');
            var vTable = new TableResultAction(cell, TableResultAction.where.Row, TableResultAction.requestAction.Add, external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(currentTr).closest('table')[0]);
            var actions = vTable.getActionList();
            for (var idCell = 0; idCell < actions.length; idCell++) {
              var currentCell = actions[idCell];
              var tdAttributes = this.recoverAttributes(currentCell.baseCell);
              switch (currentCell.action) {
                case TableResultAction.resultAction.AddCell:
                  html.append('<td' + tdAttributes + '>' + dom.blank + '</td>');
                  break;
                case TableResultAction.resultAction.SumSpanCount:
                  {
                    if (position === 'top') {
                      var baseCellTr = currentCell.baseCell.parent;
                      var isTopFromRowSpan = (!baseCellTr ? 0 : currentCell.baseCell.closest('tr').rowIndex) <= currentTr[0].rowIndex;
                      if (isTopFromRowSpan) {
                        var newTd = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<div></div>').append(external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<td' + tdAttributes + '>' + dom.blank + '</td>').removeAttr('rowspan')).html();
                        html.append(newTd);
                        break;
                      }
                    }
                    var rowspanNumber = parseInt(currentCell.baseCell.rowSpan, 10);
                    rowspanNumber++;
                    currentCell.baseCell.setAttribute('rowSpan', rowspanNumber);
                  }
                  break;
              }
            }
            if (position === 'top') {
              currentTr.before(html);
            } else {
              var cellHasRowspan = cell.rowSpan > 1;
              if (cellHasRowspan) {
                var lastTrIndex = currentTr[0].rowIndex + (cell.rowSpan - 2);
                external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(currentTr).parent().find('tr')[lastTrIndex]).after(external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(html));
                return;
              }
              currentTr.after(html);
            }
          }
          /**
           * Add a new col
           *
           * @param {WrappedRange} rng
           * @param {String} position (left/right)
           * @return {Node}
           */
        }, {
          key: "addCol",
          value: function addCol(rng, position) {
            var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
            var row = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(cell).closest('tr');
            var rowsGroup = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(row).siblings();
            rowsGroup.push(row);
            var vTable = new TableResultAction(cell, TableResultAction.where.Column, TableResultAction.requestAction.Add, external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(row).closest('table')[0]);
            var actions = vTable.getActionList();
            for (var actionIndex = 0; actionIndex < actions.length; actionIndex++) {
              var currentCell = actions[actionIndex];
              var tdAttributes = this.recoverAttributes(currentCell.baseCell);
              switch (currentCell.action) {
                case TableResultAction.resultAction.AddCell:
                  if (position === 'right') {
                    external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(currentCell.baseCell).after('<td' + tdAttributes + '>' + dom.blank + '</td>');
                  } else {
                    external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(currentCell.baseCell).before('<td' + tdAttributes + '>' + dom.blank + '</td>');
                  }
                  break;
                case TableResultAction.resultAction.SumSpanCount:
                  if (position === 'right') {
                    var colspanNumber = parseInt(currentCell.baseCell.colSpan, 10);
                    colspanNumber++;
                    currentCell.baseCell.setAttribute('colSpan', colspanNumber);
                  } else {
                    external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(currentCell.baseCell).before('<td' + tdAttributes + '>' + dom.blank + '</td>');
                  }
                  break;
              }
            }
          }
          /*
          * Copy attributes from element.
          *
          * @param {object} Element to recover attributes.
          * @return {string} Copied string elements.
          */
        }, {
          key: "recoverAttributes",
          value: function recoverAttributes(el) {
            var resultStr = '';
            if (!el) {
              return resultStr;
            }
            var attrList = el.attributes || [];
            for (var i = 0; i < attrList.length; i++) {
              if (attrList[i].name.toLowerCase() === 'id') {
                continue;
              }
              if (attrList[i].specified) {
                resultStr += ' ' + attrList[i].name + '=\'' + attrList[i].value + '\'';
              }
            }
            return resultStr;
          }
          /**
           * Delete current row
           *
           * @param {WrappedRange} rng
           * @return {Node}
           */
        }, {
          key: "deleteRow",
          value: function deleteRow(rng) {
            var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
            var row = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(cell).closest('tr');
            var cellPos = row.children('td, th').index(external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(cell));
            var rowPos = row[0].rowIndex;
            var vTable = new TableResultAction(cell, TableResultAction.where.Row, TableResultAction.requestAction.Delete, external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(row).closest('table')[0]);
            var actions = vTable.getActionList();
            for (var actionIndex = 0; actionIndex < actions.length; actionIndex++) {
              if (!actions[actionIndex]) {
                continue;
              }
              var baseCell = actions[actionIndex].baseCell;
              var virtualPosition = actions[actionIndex].virtualTable;
              var hasRowspan = baseCell.rowSpan && baseCell.rowSpan > 1;
              var rowspanNumber = hasRowspan ? parseInt(baseCell.rowSpan, 10) : 0;
              switch (actions[actionIndex].action) {
                case TableResultAction.resultAction.Ignore:
                  continue;
                case TableResultAction.resultAction.AddCell:
                  {
                    var nextRow = row.next('tr')[0];
                    if (!nextRow) {
                      continue;
                    }
                    var cloneRow = row[0].cells[cellPos];
                    if (hasRowspan) {
                      if (rowspanNumber > 2) {
                        rowspanNumber--;
                        nextRow.insertBefore(cloneRow, nextRow.cells[cellPos]);
                        nextRow.cells[cellPos].setAttribute('rowSpan', rowspanNumber);
                        nextRow.cells[cellPos].innerHTML = '';
                      } else if (rowspanNumber === 2) {
                        nextRow.insertBefore(cloneRow, nextRow.cells[cellPos]);
                        nextRow.cells[cellPos].removeAttribute('rowSpan');
                        nextRow.cells[cellPos].innerHTML = '';
                      }
                    }
                  }
                  continue;
                case TableResultAction.resultAction.SubtractSpanCount:
                  if (hasRowspan) {
                    if (rowspanNumber > 2) {
                      rowspanNumber--;
                      baseCell.setAttribute('rowSpan', rowspanNumber);
                      if (virtualPosition.rowIndex !== rowPos && baseCell.cellIndex === cellPos) {
                        baseCell.innerHTML = '';
                      }
                    } else if (rowspanNumber === 2) {
                      baseCell.removeAttribute('rowSpan');
                      if (virtualPosition.rowIndex !== rowPos && baseCell.cellIndex === cellPos) {
                        baseCell.innerHTML = '';
                      }
                    }
                  }
                  continue;
                case TableResultAction.resultAction.RemoveCell:
                  // Do not need remove cell because row will be deleted.
                  continue;
              }
            }
            row.remove();
          }
          /**
           * Delete current col
           *
           * @param {WrappedRange} rng
           * @return {Node}
           */
        }, {
          key: "deleteCol",
          value: function deleteCol(rng) {
            var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
            var row = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(cell).closest('tr');
            var cellPos = row.children('td, th').index(external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(cell));
            var vTable = new TableResultAction(cell, TableResultAction.where.Column, TableResultAction.requestAction.Delete, external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(row).closest('table')[0]);
            var actions = vTable.getActionList();
            for (var actionIndex = 0; actionIndex < actions.length; actionIndex++) {
              if (!actions[actionIndex]) {
                continue;
              }
              switch (actions[actionIndex].action) {
                case TableResultAction.resultAction.Ignore:
                  continue;
                case TableResultAction.resultAction.SubtractSpanCount:
                  {
                    var baseCell = actions[actionIndex].baseCell;
                    var hasColspan = baseCell.colSpan && baseCell.colSpan > 1;
                    if (hasColspan) {
                      var colspanNumber = baseCell.colSpan ? parseInt(baseCell.colSpan, 10) : 0;
                      if (colspanNumber > 2) {
                        colspanNumber--;
                        baseCell.setAttribute('colSpan', colspanNumber);
                        if (baseCell.cellIndex === cellPos) {
                          baseCell.innerHTML = '';
                        }
                      } else if (colspanNumber === 2) {
                        baseCell.removeAttribute('colSpan');
                        if (baseCell.cellIndex === cellPos) {
                          baseCell.innerHTML = '';
                        }
                      }
                    }
                  }
                  continue;
                case TableResultAction.resultAction.RemoveCell:
                  dom.remove(actions[actionIndex].baseCell, true);
                  continue;
              }
            }
          }
          /**
           * create empty table element
           *
           * @param {Number} rowCount
           * @param {Number} colCount
           * @return {Node}
           */
        }, {
          key: "createTable",
          value: function createTable(colCount, rowCount, options) {
            var tds = [];
            var tdHTML;
            for (var idxCol = 0; idxCol < colCount; idxCol++) {
              tds.push('<td>' + dom.blank + '</td>');
            }
            tdHTML = tds.join('');
            var trs = [];
            var trHTML;
            for (var idxRow = 0; idxRow < rowCount; idxRow++) {
              trs.push('<tr>' + tdHTML + '</tr>');
            }
            trHTML = trs.join('');
            var $table = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<table>' + trHTML + '</table>');
            if (options && options.tableClassName) {
              $table.addClass(options.tableClassName);
            }
            return $table[0];
          }
          /**
           * Delete current table
           *
           * @param {WrappedRange} rng
           * @return {Node}
           */
        }, {
          key: "deleteTable",
          value: function deleteTable(rng) {
            var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
            external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(cell).closest('table').remove();
          }
        }]);
        return Table;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/Editor.js
      function Editor_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function Editor_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function Editor_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) Editor_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Editor_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var KEY_BOGUS = 'bogus';
      /**
       * @class Editor
       */

      var Editor_Editor = /*#__PURE__*/function () {
        function Editor(context) {
          var _this = this;
          Editor_classCallCheck(this, Editor);
          this.context = context;
          this.$note = context.layoutInfo.note;
          this.$editor = context.layoutInfo.editor;
          this.$editable = context.layoutInfo.editable;
          this.options = context.options;
          this.lang = this.options.langInfo;
          this.editable = this.$editable[0];
          this.lastRange = null;
          this.snapshot = null;
          this.style = new Style_Style();
          this.table = new Table_Table();
          this.typing = new Typing_Typing(context);
          this.bullet = new Bullet_Bullet();
          this.history = new History_History(context);
          this.context.memo('help.escape', this.lang.help.escape);
          this.context.memo('help.undo', this.lang.help.undo);
          this.context.memo('help.redo', this.lang.help.redo);
          this.context.memo('help.tab', this.lang.help.tab);
          this.context.memo('help.untab', this.lang.help.untab);
          this.context.memo('help.insertParagraph', this.lang.help.insertParagraph);
          this.context.memo('help.insertOrderedList', this.lang.help.insertOrderedList);
          this.context.memo('help.insertUnorderedList', this.lang.help.insertUnorderedList);
          this.context.memo('help.indent', this.lang.help.indent);
          this.context.memo('help.outdent', this.lang.help.outdent);
          this.context.memo('help.formatPara', this.lang.help.formatPara);
          this.context.memo('help.insertHorizontalRule', this.lang.help.insertHorizontalRule);
          this.context.memo('help.fontName', this.lang.help.fontName); // native commands(with execCommand), generate function for execCommand

          var commands = ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'formatBlock', 'removeFormat', 'backColor'];
          for (var idx = 0, len = commands.length; idx < len; idx++) {
            this[commands[idx]] = function (sCmd) {
              return function (value) {
                _this.beforeCommand();
                document.execCommand(sCmd, false, value);
                _this.afterCommand(true);
              };
            }(commands[idx]);
            this.context.memo('help.' + commands[idx], this.lang.help[commands[idx]]);
          }
          this.fontName = this.wrapCommand(function (value) {
            return _this.fontStyling('font-family', env.validFontName(value));
          });
          this.fontSize = this.wrapCommand(function (value) {
            var unit = _this.currentStyle()['font-size-unit'];
            return _this.fontStyling('font-size', value + unit);
          });
          this.fontSizeUnit = this.wrapCommand(function (value) {
            var size = _this.currentStyle()['font-size'];
            return _this.fontStyling('font-size', size + value);
          });
          for (var _idx = 1; _idx <= 6; _idx++) {
            this['formatH' + _idx] = function (idx) {
              return function () {
                _this.formatBlock('H' + idx);
              };
            }(_idx);
            this.context.memo('help.formatH' + _idx, this.lang.help['formatH' + _idx]);
          }
          this.insertParagraph = this.wrapCommand(function () {
            _this.typing.insertParagraph(_this.editable);
          });
          this.insertOrderedList = this.wrapCommand(function () {
            _this.bullet.insertOrderedList(_this.editable);
          });
          this.insertUnorderedList = this.wrapCommand(function () {
            _this.bullet.insertUnorderedList(_this.editable);
          });
          this.indent = this.wrapCommand(function () {
            _this.bullet.indent(_this.editable);
          });
          this.outdent = this.wrapCommand(function () {
            _this.bullet.outdent(_this.editable);
          });
          /**
           * insertNode
           * insert node
           * @param {Node} node
           */

          this.insertNode = this.wrapCommand(function (node) {
            if (_this.isLimited(external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(node).text().length)) {
              return;
            }
            var rng = _this.getLastRange();
            rng.insertNode(node);
            _this.setLastRange(range.createFromNodeAfter(node).select());
          });
          /**
           * insert text
           * @param {String} text
           */

          this.insertText = this.wrapCommand(function (text) {
            if (_this.isLimited(text.length)) {
              return;
            }
            var rng = _this.getLastRange();
            var textNode = rng.insertNode(dom.createText(text));
            _this.setLastRange(range.create(textNode, dom.nodeLength(textNode)).select());
          });
          /**
           * paste HTML
           * @param {String} markup
           */

          this.pasteHTML = this.wrapCommand(function (markup) {
            if (_this.isLimited(markup.length)) {
              return;
            }
            markup = _this.context.invoke('codeview.purify', markup);
            var contents = _this.getLastRange().pasteHTML(markup);
            _this.setLastRange(range.createFromNodeAfter(lists.last(contents)).select());
          });
          /**
           * formatBlock
           *
           * @param {String} tagName
           */

          this.formatBlock = this.wrapCommand(function (tagName, $target) {
            var onApplyCustomStyle = _this.options.callbacks.onApplyCustomStyle;
            if (onApplyCustomStyle) {
              onApplyCustomStyle.call(_this, $target, _this.context, _this.onFormatBlock);
            } else {
              _this.onFormatBlock(tagName, $target);
            }
          });
          /**
           * insert horizontal rule
           */

          this.insertHorizontalRule = this.wrapCommand(function () {
            var hrNode = _this.getLastRange().insertNode(dom.create('HR'));
            if (hrNode.nextSibling) {
              _this.setLastRange(range.create(hrNode.nextSibling, 0).normalize().select());
            }
          });
          /**
           * lineHeight
           * @param {String} value
           */

          this.lineHeight = this.wrapCommand(function (value) {
            _this.style.stylePara(_this.getLastRange(), {
              lineHeight: value
            });
          });
          /**
           * create link (command)
           *
           * @param {Object} linkInfo
           */

          this.createLink = this.wrapCommand(function (linkInfo) {
            var linkUrl = linkInfo.url;
            var linkText = linkInfo.text;
            var isNewWindow = linkInfo.isNewWindow;
            var checkProtocol = linkInfo.checkProtocol;
            var rng = linkInfo.range || _this.getLastRange();
            var additionalTextLength = linkText.length - rng.toString().length;
            if (additionalTextLength > 0 && _this.isLimited(additionalTextLength)) {
              return;
            }
            var isTextChanged = rng.toString() !== linkText; // handle spaced urls from input

            if (typeof linkUrl === 'string') {
              linkUrl = linkUrl.trim();
            }
            if (_this.options.onCreateLink) {
              linkUrl = _this.options.onCreateLink(linkUrl);
            } else if (checkProtocol) {
              // if url doesn't have any protocol and not even a relative or a label, use http:// as default
              linkUrl = /^([A-Za-z][A-Za-z0-9+-.]*\:|#|\/)/.test(linkUrl) ? linkUrl : _this.options.defaultProtocol + linkUrl;
            }
            var anchors = [];
            if (isTextChanged) {
              rng = rng.deleteContents();
              var anchor = rng.insertNode(external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<A>' + linkText + '</A>')[0]);
              anchors.push(anchor);
            } else {
              anchors = _this.style.styleNodes(rng, {
                nodeName: 'A',
                expandClosestSibling: true,
                onlyPartialContains: true
              });
            }
            external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(anchors, function (idx, anchor) {
              external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(anchor).attr('href', linkUrl);
              if (isNewWindow) {
                external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(anchor).attr('target', '_blank');
              } else {
                external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(anchor).removeAttr('target');
              }
            });
            _this.setLastRange(_this.createRangeFromList(anchors).select());
          });
          /**
           * setting color
           *
           * @param {Object} sObjColor  color code
           * @param {String} sObjColor.foreColor foreground color
           * @param {String} sObjColor.backColor background color
           */

          this.color = this.wrapCommand(function (colorInfo) {
            var foreColor = colorInfo.foreColor;
            var backColor = colorInfo.backColor;
            if (foreColor) {
              document.execCommand('foreColor', false, foreColor);
            }
            if (backColor) {
              document.execCommand('backColor', false, backColor);
            }
          });
          /**
           * Set foreground color
           *
           * @param {String} colorCode foreground color code
           */

          this.foreColor = this.wrapCommand(function (colorInfo) {
            document.execCommand('foreColor', false, colorInfo);
          });
          /**
           * insert Table
           *
           * @param {String} dimension of table (ex : "5x5")
           */

          this.insertTable = this.wrapCommand(function (dim) {
            var dimension = dim.split('x');
            var rng = _this.getLastRange().deleteContents();
            rng.insertNode(_this.table.createTable(dimension[0], dimension[1], _this.options));
          });
          /**
           * remove media object and Figure Elements if media object is img with Figure.
           */

          this.removeMedia = this.wrapCommand(function () {
            var $target = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(_this.restoreTarget()).parent();
            if ($target.closest('figure').length) {
              $target.closest('figure').remove();
            } else {
              $target = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(_this.restoreTarget()).detach();
            }
            _this.context.triggerEvent('media.delete', $target, _this.$editable);
          });
          /**
           * float me
           *
           * @param {String} value
           */

          this.floatMe = this.wrapCommand(function (value) {
            var $target = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(_this.restoreTarget());
            $target.toggleClass('note-float-left', value === 'left');
            $target.toggleClass('note-float-right', value === 'right');
            $target.css('float', value === 'none' ? '' : value);
          });
          /**
           * resize overlay element
           * @param {String} value
           */

          this.resize = this.wrapCommand(function (value) {
            var $target = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(_this.restoreTarget());
            value = parseFloat(value);
            if (value === 0) {
              $target.css('width', '');
            } else {
              $target.css({
                width: value * 100 + '%',
                height: ''
              });
            }
          });
        }
        Editor_createClass(Editor, [{
          key: "initialize",
          value: function initialize() {
            var _this2 = this;

            // bind custom events
            this.$editable.on('keydown', function (event) {
              if (event.keyCode === core_key.code.ENTER) {
                _this2.context.triggerEvent('enter', event);
              }
              _this2.context.triggerEvent('keydown', event); // keep a snapshot to limit text on input event

              _this2.snapshot = _this2.history.makeSnapshot();
              _this2.hasKeyShortCut = false;
              if (!event.isDefaultPrevented()) {
                if (_this2.options.shortcuts) {
                  _this2.hasKeyShortCut = _this2.handleKeyMap(event);
                } else {
                  _this2.preventDefaultEditableShortCuts(event);
                }
              }
              if (_this2.isLimited(1, event)) {
                var lastRange = _this2.getLastRange();
                if (lastRange.eo - lastRange.so === 0) {
                  return false;
                }
              }
              _this2.setLastRange(); // record undo in the key event except keyMap.

              if (_this2.options.recordEveryKeystroke) {
                if (_this2.hasKeyShortCut === false) {
                  _this2.history.recordUndo();
                }
              }
            }).on('keyup', function (event) {
              _this2.setLastRange();
              _this2.context.triggerEvent('keyup', event);
            }).on('focus', function (event) {
              _this2.setLastRange();
              _this2.context.triggerEvent('focus', event);
            }).on('blur', function (event) {
              _this2.context.triggerEvent('blur', event);
            }).on('mousedown', function (event) {
              _this2.context.triggerEvent('mousedown', event);
            }).on('mouseup', function (event) {
              _this2.setLastRange();
              _this2.history.recordUndo();
              _this2.context.triggerEvent('mouseup', event);
            }).on('scroll', function (event) {
              _this2.context.triggerEvent('scroll', event);
            }).on('paste', function (event) {
              _this2.setLastRange();
              _this2.context.triggerEvent('paste', event);
            }).on('input', function () {
              // To limit composition characters (e.g. Korean)
              if (_this2.isLimited(0) && _this2.snapshot) {
                _this2.history.applySnapshot(_this2.snapshot);
              }
            });
            this.$editable.attr('spellcheck', this.options.spellCheck);
            this.$editable.attr('autocorrect', this.options.spellCheck);
            if (this.options.disableGrammar) {
              this.$editable.attr('data-gramm', false);
            } // init content before set event

            this.$editable.html(dom.html(this.$note) || dom.emptyPara);
            this.$editable.on(env.inputEventName, func.debounce(function () {
              _this2.context.triggerEvent('change', _this2.$editable.html(), _this2.$editable);
            }, 10));
            this.$editable.on('focusin', function (event) {
              _this2.context.triggerEvent('focusin', event);
            }).on('focusout', function (event) {
              _this2.context.triggerEvent('focusout', event);
            });
            if (this.options.airMode) {
              if (this.options.overrideContextMenu) {
                this.$editor.on('contextmenu', function (event) {
                  _this2.context.triggerEvent('contextmenu', event);
                  return false;
                });
              }
            } else {
              if (this.options.width) {
                this.$editor.outerWidth(this.options.width);
              }
              if (this.options.height) {
                this.$editable.outerHeight(this.options.height);
              }
              if (this.options.maxHeight) {
                this.$editable.css('max-height', this.options.maxHeight);
              }
              if (this.options.minHeight) {
                this.$editable.css('min-height', this.options.minHeight);
              }
            }
            this.history.recordUndo();
            this.setLastRange();
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.$editable.off();
          }
        }, {
          key: "handleKeyMap",
          value: function handleKeyMap(event) {
            var keyMap = this.options.keyMap[env.isMac ? 'mac' : 'pc'];
            var keys = [];
            if (event.metaKey) {
              keys.push('CMD');
            }
            if (event.ctrlKey && !event.altKey) {
              keys.push('CTRL');
            }
            if (event.shiftKey) {
              keys.push('SHIFT');
            }
            var keyName = core_key.nameFromCode[event.keyCode];
            if (keyName) {
              keys.push(keyName);
            }
            var eventName = keyMap[keys.join('+')];
            if (keyName === 'TAB' && !this.options.tabDisable) {
              this.afterCommand();
            } else if (eventName) {
              if (this.context.invoke(eventName) !== false) {
                event.preventDefault(); // if keyMap action was invoked

                return true;
              }
            } else if (core_key.isEdit(event.keyCode)) {
              this.afterCommand();
            }
            return false;
          }
        }, {
          key: "preventDefaultEditableShortCuts",
          value: function preventDefaultEditableShortCuts(event) {
            // B(Bold, 66) / I(Italic, 73) / U(Underline, 85)
            if ((event.ctrlKey || event.metaKey) && lists.contains([66, 73, 85], event.keyCode)) {
              event.preventDefault();
            }
          }
        }, {
          key: "isLimited",
          value: function isLimited(pad, event) {
            pad = pad || 0;
            if (typeof event !== 'undefined') {
              if (core_key.isMove(event.keyCode) || core_key.isNavigation(event.keyCode) || event.ctrlKey || event.metaKey || lists.contains([core_key.code.BACKSPACE, core_key.code.DELETE], event.keyCode)) {
                return false;
              }
            }
            if (this.options.maxTextLength > 0) {
              if (this.$editable.text().length + pad > this.options.maxTextLength) {
                return true;
              }
            }
            return false;
          }
          /**
           * create range
           * @return {WrappedRange}
           */
        }, {
          key: "createRange",
          value: function createRange() {
            this.focus();
            this.setLastRange();
            return this.getLastRange();
          }
          /**
           * create a new range from the list of elements
           *
           * @param {list} dom element list
           * @return {WrappedRange}
           */
        }, {
          key: "createRangeFromList",
          value: function createRangeFromList(lst) {
            var startRange = range.createFromNodeBefore(lists.head(lst));
            var startPoint = startRange.getStartPoint();
            var endRange = range.createFromNodeAfter(lists.last(lst));
            var endPoint = endRange.getEndPoint();
            return range.create(startPoint.node, startPoint.offset, endPoint.node, endPoint.offset);
          }
          /**
           * set the last range
           *
           * if given rng is exist, set rng as the last range
           * or create a new range at the end of the document
           *
           * @param {WrappedRange} rng
           */
        }, {
          key: "setLastRange",
          value: function setLastRange(rng) {
            if (rng) {
              this.lastRange = rng;
            } else {
              this.lastRange = range.create(this.editable);
              if (external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(this.lastRange.sc).closest('.note-editable').length === 0) {
                this.lastRange = range.createFromBodyElement(this.editable);
              }
            }
          }
          /**
           * get the last range
           *
           * if there is a saved last range, return it
           * or create a new range and return it
           *
           * @return {WrappedRange}
           */
        }, {
          key: "getLastRange",
          value: function getLastRange() {
            if (!this.lastRange) {
              this.setLastRange();
            }
            return this.lastRange;
          }
          /**
           * saveRange
           *
           * save current range
           *
           * @param {Boolean} [thenCollapse=false]
           */
        }, {
          key: "saveRange",
          value: function saveRange(thenCollapse) {
            if (thenCollapse) {
              this.getLastRange().collapse().select();
            }
          }
          /**
           * restoreRange
           *
           * restore lately range
           */
        }, {
          key: "restoreRange",
          value: function restoreRange() {
            if (this.lastRange) {
              this.lastRange.select();
              this.focus();
            }
          }
        }, {
          key: "saveTarget",
          value: function saveTarget(node) {
            this.$editable.data('target', node);
          }
        }, {
          key: "clearTarget",
          value: function clearTarget() {
            this.$editable.removeData('target');
          }
        }, {
          key: "restoreTarget",
          value: function restoreTarget() {
            return this.$editable.data('target');
          }
          /**
           * currentStyle
           *
           * current style
           * @return {Object|Boolean} unfocus
           */
        }, {
          key: "currentStyle",
          value: function currentStyle() {
            var rng = range.create();
            if (rng) {
              rng = rng.normalize();
            }
            return rng ? this.style.current(rng) : this.style.fromNode(this.$editable);
          }
          /**
           * style from node
           *
           * @param {jQuery} $node
           * @return {Object}
           */
        }, {
          key: "styleFromNode",
          value: function styleFromNode($node) {
            return this.style.fromNode($node);
          }
          /**
           * undo
           */
        }, {
          key: "undo",
          value: function undo() {
            this.context.triggerEvent('before.command', this.$editable.html());
            this.history.undo();
            this.context.triggerEvent('change', this.$editable.html(), this.$editable);
          }
          /*
          * commit
          */
        }, {
          key: "commit",
          value: function commit() {
            this.context.triggerEvent('before.command', this.$editable.html());
            this.history.commit();
            this.context.triggerEvent('change', this.$editable.html(), this.$editable);
          }
          /**
           * redo
           */
        }, {
          key: "redo",
          value: function redo() {
            this.context.triggerEvent('before.command', this.$editable.html());
            this.history.redo();
            this.context.triggerEvent('change', this.$editable.html(), this.$editable);
          }
          /**
           * before command
           */
        }, {
          key: "beforeCommand",
          value: function beforeCommand() {
            this.context.triggerEvent('before.command', this.$editable.html()); // Set styleWithCSS before run a command

            document.execCommand('styleWithCSS', false, this.options.styleWithCSS); // keep focus on editable before command execution

            this.focus();
          }
          /**
           * after command
           * @param {Boolean} isPreventTrigger
           */
        }, {
          key: "afterCommand",
          value: function afterCommand(isPreventTrigger) {
            this.normalizeContent();
            this.history.recordUndo();
            if (!isPreventTrigger) {
              this.context.triggerEvent('change', this.$editable.html(), this.$editable);
            }
          }
          /**
           * handle tab key
           */
        }, {
          key: "tab",
          value: function tab() {
            var rng = this.getLastRange();
            if (rng.isCollapsed() && rng.isOnCell()) {
              this.table.tab(rng);
            } else {
              if (this.options.tabSize === 0) {
                return false;
              }
              if (!this.isLimited(this.options.tabSize)) {
                this.beforeCommand();
                this.typing.insertTab(rng, this.options.tabSize);
                this.afterCommand();
              }
            }
          }
          /**
           * handle shift+tab key
           */
        }, {
          key: "untab",
          value: function untab() {
            var rng = this.getLastRange();
            if (rng.isCollapsed() && rng.isOnCell()) {
              this.table.tab(rng, true);
            } else {
              if (this.options.tabSize === 0) {
                return false;
              }
            }
          }
          /**
           * run given function between beforeCommand and afterCommand
           */
        }, {
          key: "wrapCommand",
          value: function wrapCommand(fn) {
            return function () {
              this.beforeCommand();
              fn.apply(this, arguments);
              this.afterCommand();
            };
          }
          /**
           * insert image
           *
           * @param {String} src
           * @param {String|Function} param
           * @return {Promise}
           */
        }, {
          key: "insertImage",
          value: function insertImage(src, param) {
            var _this3 = this;
            return createImage(src, param).then(function ($image) {
              _this3.beforeCommand();
              if (typeof param === 'function') {
                param($image);
              } else {
                if (typeof param === 'string') {
                  $image.attr('data-filename', param);
                }
                $image.css('width', Math.min(_this3.$editable.width(), $image.width()));
              }
              $image.show();
              _this3.getLastRange().insertNode($image[0]);
              _this3.setLastRange(range.createFromNodeAfter($image[0]).select());
              _this3.afterCommand();
            }).fail(function (e) {
              _this3.context.triggerEvent('image.upload.error', e);
            });
          }
          /**
           * insertImages
           * @param {File[]} files
           */
        }, {
          key: "insertImagesAsDataURL",
          value: function insertImagesAsDataURL(files) {
            var _this4 = this;
            external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(files, function (idx, file) {
              var filename = file.name;
              if (_this4.options.maximumImageFileSize && _this4.options.maximumImageFileSize < file.size) {
                _this4.context.triggerEvent('image.upload.error', _this4.lang.image.maximumFileSizeError);
              } else {
                readFileAsDataURL(file).then(function (dataURL) {
                  return _this4.insertImage(dataURL, filename);
                }).fail(function () {
                  _this4.context.triggerEvent('image.upload.error');
                });
              }
            });
          }
          /**
           * insertImagesOrCallback
           * @param {File[]} files
           */
        }, {
          key: "insertImagesOrCallback",
          value: function insertImagesOrCallback(files) {
            var callbacks = this.options.callbacks; // If onImageUpload set,

            if (callbacks.onImageUpload) {
              this.context.triggerEvent('image.upload', files); // else insert Image as dataURL
            } else {
              this.insertImagesAsDataURL(files);
            }
          }
          /**
           * return selected plain text
           * @return {String} text
           */
        }, {
          key: "getSelectedText",
          value: function getSelectedText() {
            var rng = this.getLastRange(); // if range on anchor, expand range with anchor

            if (rng.isOnAnchor()) {
              rng = range.createFromNode(dom.ancestor(rng.sc, dom.isAnchor));
            }
            return rng.toString();
          }
        }, {
          key: "onFormatBlock",
          value: function onFormatBlock(tagName, $target) {
            // [workaround] for MSIE, IE need `<`
            document.execCommand('FormatBlock', false, env.isMSIE ? '<' + tagName + '>' : tagName); // support custom class

            if ($target && $target.length) {
              // find the exact element has given tagName
              if ($target[0].tagName.toUpperCase() !== tagName.toUpperCase()) {
                $target = $target.find(tagName);
              }
              if ($target && $target.length) {
                var className = $target[0].className || '';
                if (className) {
                  var currentRange = this.createRange();
                  var $parent = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()([currentRange.sc, currentRange.ec]).closest(tagName);
                  $parent.addClass(className);
                }
              }
            }
          }
        }, {
          key: "formatPara",
          value: function formatPara() {
            this.formatBlock('P');
          }
        }, {
          key: "fontStyling",
          value: function fontStyling(target, value) {
            var rng = this.getLastRange();
            if (rng !== '') {
              var spans = this.style.styleNodes(rng);
              this.$editor.find('.note-status-output').html('');
              external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(spans).css(target, value); // [workaround] added styled bogus span for style
              //  - also bogus character needed for cursor position

              if (rng.isCollapsed()) {
                var firstSpan = lists.head(spans);
                if (firstSpan && !dom.nodeLength(firstSpan)) {
                  firstSpan.innerHTML = dom.ZERO_WIDTH_NBSP_CHAR;
                  range.createFromNode(firstSpan.firstChild).select();
                  this.setLastRange();
                  this.$editable.data(KEY_BOGUS, firstSpan);
                }
              } else {
                this.setLastRange(this.createRangeFromList(spans).select());
              }
            } else {
              var noteStatusOutput = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.now();
              this.$editor.find('.note-status-output').html('<div id="note-status-output-' + noteStatusOutput + '" class="alert alert-info">' + this.lang.output.noSelection + '</div>');
              setTimeout(function () {
                external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('#note-status-output-' + noteStatusOutput).remove();
              }, 5000);
            }
          }
          /**
           * unlink
           *
           * @type command
           */
        }, {
          key: "unlink",
          value: function unlink() {
            var rng = this.getLastRange();
            if (rng.isOnAnchor()) {
              var anchor = dom.ancestor(rng.sc, dom.isAnchor);
              rng = range.createFromNode(anchor);
              rng.select();
              this.setLastRange();
              this.beforeCommand();
              document.execCommand('unlink');
              this.afterCommand();
            }
          }
          /**
           * returns link info
           *
           * @return {Object}
           * @return {WrappedRange} return.range
           * @return {String} return.text
           * @return {Boolean} [return.isNewWindow=true]
           * @return {String} [return.url=""]
           */
        }, {
          key: "getLinkInfo",
          value: function getLinkInfo() {
            var rng = this.getLastRange().expand(dom.isAnchor); // Get the first anchor on range(for edit).

            var $anchor = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(lists.head(rng.nodes(dom.isAnchor)));
            var linkInfo = {
              range: rng,
              text: rng.toString(),
              url: $anchor.length ? $anchor.attr('href') : ''
            }; // When anchor exists,

            if ($anchor.length) {
              // Set isNewWindow by checking its target.
              linkInfo.isNewWindow = $anchor.attr('target') === '_blank';
            }
            return linkInfo;
          }
        }, {
          key: "addRow",
          value: function addRow(position) {
            var rng = this.getLastRange(this.$editable);
            if (rng.isCollapsed() && rng.isOnCell()) {
              this.beforeCommand();
              this.table.addRow(rng, position);
              this.afterCommand();
            }
          }
        }, {
          key: "addCol",
          value: function addCol(position) {
            var rng = this.getLastRange(this.$editable);
            if (rng.isCollapsed() && rng.isOnCell()) {
              this.beforeCommand();
              this.table.addCol(rng, position);
              this.afterCommand();
            }
          }
        }, {
          key: "deleteRow",
          value: function deleteRow() {
            var rng = this.getLastRange(this.$editable);
            if (rng.isCollapsed() && rng.isOnCell()) {
              this.beforeCommand();
              this.table.deleteRow(rng);
              this.afterCommand();
            }
          }
        }, {
          key: "deleteCol",
          value: function deleteCol() {
            var rng = this.getLastRange(this.$editable);
            if (rng.isCollapsed() && rng.isOnCell()) {
              this.beforeCommand();
              this.table.deleteCol(rng);
              this.afterCommand();
            }
          }
        }, {
          key: "deleteTable",
          value: function deleteTable() {
            var rng = this.getLastRange(this.$editable);
            if (rng.isCollapsed() && rng.isOnCell()) {
              this.beforeCommand();
              this.table.deleteTable(rng);
              this.afterCommand();
            }
          }
          /**
           * @param {Position} pos
           * @param {jQuery} $target - target element
           * @param {Boolean} [bKeepRatio] - keep ratio
           */
        }, {
          key: "resizeTo",
          value: function resizeTo(pos, $target, bKeepRatio) {
            var imageSize;
            if (bKeepRatio) {
              var newRatio = pos.y / pos.x;
              var ratio = $target.data('ratio');
              imageSize = {
                width: ratio > newRatio ? pos.x : pos.y / ratio,
                height: ratio > newRatio ? pos.x * ratio : pos.y
              };
            } else {
              imageSize = {
                width: pos.x,
                height: pos.y
              };
            }
            $target.css(imageSize);
          }
          /**
           * returns whether editable area has focus or not.
           */
        }, {
          key: "hasFocus",
          value: function hasFocus() {
            return this.$editable.is(':focus');
          }
          /**
           * set focus
           */
        }, {
          key: "focus",
          value: function focus() {
            // [workaround] Screen will move when page is scolled in IE.
            //  - do focus when not focused
            if (!this.hasFocus()) {
              this.$editable.focus();
            }
          }
          /**
           * returns whether contents is empty or not.
           * @return {Boolean}
           */
        }, {
          key: "isEmpty",
          value: function isEmpty() {
            return dom.isEmpty(this.$editable[0]) || dom.emptyPara === this.$editable.html();
          }
          /**
           * Removes all contents and restores the editable instance to an _emptyPara_.
           */
        }, {
          key: "empty",
          value: function empty() {
            this.context.invoke('code', dom.emptyPara);
          }
          /**
           * normalize content
           */
        }, {
          key: "normalizeContent",
          value: function normalizeContent() {
            this.$editable[0].normalize();
          }
        }]);
        return Editor;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/Clipboard.js
      function Clipboard_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function Clipboard_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function Clipboard_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) Clipboard_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Clipboard_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var Clipboard_Clipboard = /*#__PURE__*/function () {
        function Clipboard(context) {
          Clipboard_classCallCheck(this, Clipboard);
          this.context = context;
          this.$editable = context.layoutInfo.editable;
        }
        Clipboard_createClass(Clipboard, [{
          key: "initialize",
          value: function initialize() {
            this.$editable.on('paste', this.pasteByEvent.bind(this));
          }
          /**
           * paste by clipboard event
           *
           * @param {Event} event
           */
        }, {
          key: "pasteByEvent",
          value: function pasteByEvent(event) {
            var _this = this;
            var clipboardData = event.originalEvent.clipboardData;
            if (clipboardData && clipboardData.items && clipboardData.items.length) {
              var item = clipboardData.items.length > 1 ? clipboardData.items[1] : lists.head(clipboardData.items);
              if (item.kind === 'file' && item.type.indexOf('image/') !== -1) {
                // paste img file
                this.context.invoke('editor.insertImagesOrCallback', [item.getAsFile()]);
                event.preventDefault();
              } else if (item.kind === 'string') {
                // paste text with maxTextLength check
                if (this.context.invoke('editor.isLimited', clipboardData.getData('Text').length)) {
                  event.preventDefault();
                }
              }
            } else if (window.clipboardData) {
              // for IE
              var text = window.clipboardData.getData('text');
              if (this.context.invoke('editor.isLimited', text.length)) {
                event.preventDefault();
              }
            } // Call editor.afterCommand after proceeding default event handler

            setTimeout(function () {
              _this.context.invoke('editor.afterCommand');
            }, 10);
          }
        }]);
        return Clipboard;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/Dropzone.js
      function Dropzone_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function Dropzone_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function Dropzone_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) Dropzone_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Dropzone_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var Dropzone_Dropzone = /*#__PURE__*/function () {
        function Dropzone(context) {
          Dropzone_classCallCheck(this, Dropzone);
          this.context = context;
          this.$eventListener = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(document);
          this.$editor = context.layoutInfo.editor;
          this.$editable = context.layoutInfo.editable;
          this.options = context.options;
          this.lang = this.options.langInfo;
          this.documentEventHandlers = {};
          this.$dropzone = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(['<div class="note-dropzone">', '<div class="note-dropzone-message"></div>', '</div>'].join('')).prependTo(this.$editor);
        }
        /**
         * attach Drag and Drop Events
         */

        Dropzone_createClass(Dropzone, [{
          key: "initialize",
          value: function initialize() {
            if (this.options.disableDragAndDrop) {
              // prevent default drop event
              this.documentEventHandlers.onDrop = function (e) {
                e.preventDefault();
              }; // do not consider outside of dropzone

              this.$eventListener = this.$dropzone;
              this.$eventListener.on('drop', this.documentEventHandlers.onDrop);
            } else {
              this.attachDragAndDropEvent();
            }
          }
          /**
           * attach Drag and Drop Events
           */
        }, {
          key: "attachDragAndDropEvent",
          value: function attachDragAndDropEvent() {
            var _this = this;
            var collection = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()();
            var $dropzoneMessage = this.$dropzone.find('.note-dropzone-message');
            this.documentEventHandlers.onDragenter = function (e) {
              var isCodeview = _this.context.invoke('codeview.isActivated');
              var hasEditorSize = _this.$editor.width() > 0 && _this.$editor.height() > 0;
              if (!isCodeview && !collection.length && hasEditorSize) {
                _this.$editor.addClass('dragover');
                _this.$dropzone.width(_this.$editor.width());
                _this.$dropzone.height(_this.$editor.height());
                $dropzoneMessage.text(_this.lang.image.dragImageHere);
              }
              collection = collection.add(e.target);
            };
            this.documentEventHandlers.onDragleave = function (e) {
              collection = collection.not(e.target); // If nodeName is BODY, then just make it over (fix for IE)

              if (!collection.length || e.target.nodeName === 'BODY') {
                collection = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()();
                _this.$editor.removeClass('dragover');
              }
            };
            this.documentEventHandlers.onDrop = function () {
              collection = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()();
              _this.$editor.removeClass('dragover');
            }; // show dropzone on dragenter when dragging a object to document
            // -but only if the editor is visible, i.e. has a positive width and height

            this.$eventListener.on('dragenter', this.documentEventHandlers.onDragenter).on('dragleave', this.documentEventHandlers.onDragleave).on('drop', this.documentEventHandlers.onDrop); // change dropzone's message on hover.

            this.$dropzone.on('dragenter', function () {
              _this.$dropzone.addClass('hover');
              $dropzoneMessage.text(_this.lang.image.dropImage);
            }).on('dragleave', function () {
              _this.$dropzone.removeClass('hover');
              $dropzoneMessage.text(_this.lang.image.dragImageHere);
            }); // attach dropImage

            this.$dropzone.on('drop', function (event) {
              var dataTransfer = event.originalEvent.dataTransfer; // stop the browser from opening the dropped content

              event.preventDefault();
              if (dataTransfer && dataTransfer.files && dataTransfer.files.length) {
                _this.$editable.focus();
                _this.context.invoke('editor.insertImagesOrCallback', dataTransfer.files);
              } else {
                external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(dataTransfer.types, function (idx, type) {
                  // skip moz-specific types
                  if (type.toLowerCase().indexOf('_moz_') > -1) {
                    return;
                  }
                  var content = dataTransfer.getData(type);
                  if (type.toLowerCase().indexOf('text') > -1) {
                    _this.context.invoke('editor.pasteHTML', content);
                  } else {
                    external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(content).each(function (idx, item) {
                      _this.context.invoke('editor.insertNode', item);
                    });
                  }
                });
              }
            }).on('dragover', false); // prevent default dragover event
          }
        }, {
          key: "destroy",
          value: function destroy() {
            var _this2 = this;
            Object.keys(this.documentEventHandlers).forEach(function (key) {
              _this2.$eventListener.off(key.substr(2).toLowerCase(), _this2.documentEventHandlers[key]);
            });
            this.documentEventHandlers = {};
          }
        }]);
        return Dropzone;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/Codeview.js
      function _createForOfIteratorHelper(o) {
        if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
          if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) {
            var i = 0;
            var F = function F() {};
            return {
              s: F,
              n: function n() {
                if (i >= o.length) return {
                  done: true
                };
                return {
                  done: false,
                  value: o[i++]
                };
              },
              e: function e(_e) {
                throw _e;
              },
              f: F
            };
          }
          throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var it,
          normalCompletion = true,
          didErr = false,
          err;
        return {
          s: function s() {
            it = o[Symbol.iterator]();
          },
          n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
          },
          e: function e(_e2) {
            didErr = true;
            err = _e2;
          },
          f: function f() {
            try {
              if (!normalCompletion && it["return"] != null) it["return"]();
            } finally {
              if (didErr) throw err;
            }
          }
        };
      }
      function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(n);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
      }
      function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for (var i = 0, arr2 = new Array(len); i < len; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      }
      function Codeview_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function Codeview_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function Codeview_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) Codeview_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Codeview_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      /**
       * @class Codeview
       */

      var Codeview_CodeView = /*#__PURE__*/function () {
        function CodeView(context) {
          Codeview_classCallCheck(this, CodeView);
          this.context = context;
          this.$editor = context.layoutInfo.editor;
          this.$editable = context.layoutInfo.editable;
          this.$codable = context.layoutInfo.codable;
          this.options = context.options;
          this.CodeMirrorConstructor = window.CodeMirror;
          if (this.options.codemirror.CodeMirrorConstructor) {
            this.CodeMirrorConstructor = this.options.codemirror.CodeMirrorConstructor;
          }
        }
        Codeview_createClass(CodeView, [{
          key: "sync",
          value: function sync(html) {
            var isCodeview = this.isActivated();
            var CodeMirror = this.CodeMirrorConstructor;
            if (isCodeview) {
              if (html) {
                if (CodeMirror) {
                  this.$codable.data('cmEditor').getDoc().setValue(html);
                } else {
                  this.$codable.val(html);
                }
              } else {
                if (CodeMirror) {
                  this.$codable.data('cmEditor').save();
                }
              }
            }
          }
        }, {
          key: "initialize",
          value: function initialize() {
            var _this = this;
            this.$codable.on('keyup', function (event) {
              if (event.keyCode === core_key.code.ESCAPE) {
                _this.deactivate();
              }
            });
          }
          /**
           * @return {Boolean}
           */
        }, {
          key: "isActivated",
          value: function isActivated() {
            return this.$editor.hasClass('codeview');
          }
          /**
           * toggle codeview
           */
        }, {
          key: "toggle",
          value: function toggle() {
            if (this.isActivated()) {
              this.deactivate();
            } else {
              this.activate();
            }
            this.context.triggerEvent('codeview.toggled');
          }
          /**
           * purify input value
           * @param value
           * @returns {*}
           */
        }, {
          key: "purify",
          value: function purify(value) {
            if (this.options.codeviewFilter) {
              // filter code view regex
              value = value.replace(this.options.codeviewFilterRegex, ''); // allow specific iframe tag

              if (this.options.codeviewIframeFilter) {
                var whitelist = this.options.codeviewIframeWhitelistSrc.concat(this.options.codeviewIframeWhitelistSrcBase);
                value = value.replace(/(<iframe.*?>.*?(?:<\/iframe>)?)/gi, function (tag) {
                  // remove if src attribute is duplicated
                  if (/<.+src(?==?('|"|\s)?)[\s\S]+src(?=('|"|\s)?)[^>]*?>/i.test(tag)) {
                    return '';
                  }
                  var _iterator = _createForOfIteratorHelper(whitelist),
                    _step;
                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      var src = _step.value;

                      // pass if src is trusted
                      if (new RegExp('src="(https?:)?\/\/' + src.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + '\/(.+)"').test(tag)) {
                        return tag;
                      }
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                  return '';
                });
              }
            }
            return value;
          }
          /**
           * activate code view
           */
        }, {
          key: "activate",
          value: function activate() {
            var _this2 = this;
            var CodeMirror = this.CodeMirrorConstructor;
            this.$codable.val(dom.html(this.$editable, this.options.prettifyHtml));
            this.$codable.height(this.$editable.height());
            this.context.invoke('toolbar.updateCodeview', true);
            this.context.invoke('airPopover.updateCodeview', true);
            this.$editor.addClass('codeview');
            this.$codable.focus(); // activate CodeMirror as codable

            if (CodeMirror) {
              var cmEditor = CodeMirror.fromTextArea(this.$codable[0], this.options.codemirror); // CodeMirror TernServer

              if (this.options.codemirror.tern) {
                var server = new CodeMirror.TernServer(this.options.codemirror.tern);
                cmEditor.ternServer = server;
                cmEditor.on('cursorActivity', function (cm) {
                  server.updateArgHints(cm);
                });
              }
              cmEditor.on('blur', function (event) {
                _this2.context.triggerEvent('blur.codeview', cmEditor.getValue(), event);
              });
              cmEditor.on('change', function () {
                _this2.context.triggerEvent('change.codeview', cmEditor.getValue(), cmEditor);
              }); // CodeMirror hasn't Padding.

              cmEditor.setSize(null, this.$editable.outerHeight());
              this.$codable.data('cmEditor', cmEditor);
            } else {
              this.$codable.on('blur', function (event) {
                _this2.context.triggerEvent('blur.codeview', _this2.$codable.val(), event);
              });
              this.$codable.on('input', function () {
                _this2.context.triggerEvent('change.codeview', _this2.$codable.val(), _this2.$codable);
              });
            }
          }
          /**
           * deactivate code view
           */
        }, {
          key: "deactivate",
          value: function deactivate() {
            var CodeMirror = this.CodeMirrorConstructor; // deactivate CodeMirror as codable

            if (CodeMirror) {
              var cmEditor = this.$codable.data('cmEditor');
              this.$codable.val(cmEditor.getValue());
              cmEditor.toTextArea();
            }
            var value = this.purify(dom.value(this.$codable, this.options.prettifyHtml) || dom.emptyPara);
            var isChange = this.$editable.html() !== value;
            this.$editable.html(value);
            this.$editable.height(this.options.height ? this.$codable.height() : 'auto');
            this.$editor.removeClass('codeview');
            if (isChange) {
              this.context.triggerEvent('change', this.$editable.html(), this.$editable);
            }
            this.$editable.focus();
            this.context.invoke('toolbar.updateCodeview', false);
            this.context.invoke('airPopover.updateCodeview', false);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            if (this.isActivated()) {
              this.deactivate();
            }
          }
        }]);
        return CodeView;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/Statusbar.js
      function Statusbar_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function Statusbar_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function Statusbar_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) Statusbar_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Statusbar_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var EDITABLE_PADDING = 24;
      var Statusbar_Statusbar = /*#__PURE__*/function () {
        function Statusbar(context) {
          Statusbar_classCallCheck(this, Statusbar);
          this.$document = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(document);
          this.$statusbar = context.layoutInfo.statusbar;
          this.$editable = context.layoutInfo.editable;
          this.options = context.options;
        }
        Statusbar_createClass(Statusbar, [{
          key: "initialize",
          value: function initialize() {
            var _this = this;
            if (this.options.airMode || this.options.disableResizeEditor) {
              this.destroy();
              return;
            }
            this.$statusbar.on('mousedown', function (event) {
              event.preventDefault();
              event.stopPropagation();
              var editableTop = _this.$editable.offset().top - _this.$document.scrollTop();
              var onMouseMove = function onMouseMove(event) {
                var height = event.clientY - (editableTop + EDITABLE_PADDING);
                height = _this.options.minheight > 0 ? Math.max(height, _this.options.minheight) : height;
                height = _this.options.maxHeight > 0 ? Math.min(height, _this.options.maxHeight) : height;
                _this.$editable.height(height);
              };
              _this.$document.on('mousemove', onMouseMove).one('mouseup', function () {
                _this.$document.off('mousemove', onMouseMove);
              });
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.$statusbar.off();
            this.$statusbar.addClass('locked');
          }
        }]);
        return Statusbar;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/Fullscreen.js
      function Fullscreen_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function Fullscreen_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function Fullscreen_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) Fullscreen_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Fullscreen_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var Fullscreen_Fullscreen = /*#__PURE__*/function () {
        function Fullscreen(context) {
          var _this = this;
          Fullscreen_classCallCheck(this, Fullscreen);
          this.context = context;
          this.$editor = context.layoutInfo.editor;
          this.$toolbar = context.layoutInfo.toolbar;
          this.$editable = context.layoutInfo.editable;
          this.$codable = context.layoutInfo.codable;
          this.$window = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(window);
          this.$scrollbar = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('html, body');
          this.onResize = function () {
            _this.resizeTo({
              h: _this.$window.height() - _this.$toolbar.outerHeight()
            });
          };
        }
        Fullscreen_createClass(Fullscreen, [{
          key: "resizeTo",
          value: function resizeTo(size) {
            this.$editable.css('height', size.h);
            this.$codable.css('height', size.h);
            if (this.$codable.data('cmeditor')) {
              this.$codable.data('cmeditor').setsize(null, size.h);
            }
          }
          /**
           * toggle fullscreen
           */
        }, {
          key: "toggle",
          value: function toggle() {
            this.$editor.toggleClass('fullscreen');
            if (this.isFullscreen()) {
              this.$editable.data('orgHeight', this.$editable.css('height'));
              this.$editable.data('orgMaxHeight', this.$editable.css('maxHeight'));
              this.$editable.css('maxHeight', '');
              this.$window.on('resize', this.onResize).trigger('resize');
              this.$scrollbar.css('overflow', 'hidden');
            } else {
              this.$window.off('resize', this.onResize);
              this.resizeTo({
                h: this.$editable.data('orgHeight')
              });
              this.$editable.css('maxHeight', this.$editable.css('orgMaxHeight'));
              this.$scrollbar.css('overflow', 'visible');
            }
            this.context.invoke('toolbar.updateFullscreen', this.isFullscreen());
          }
        }, {
          key: "isFullscreen",
          value: function isFullscreen() {
            return this.$editor.hasClass('fullscreen');
          }
        }]);
        return Fullscreen;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/Handle.js
      function Handle_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function Handle_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function Handle_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) Handle_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Handle_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var Handle_Handle = /*#__PURE__*/function () {
        function Handle(context) {
          var _this = this;
          Handle_classCallCheck(this, Handle);
          this.context = context;
          this.$document = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(document);
          this.$editingArea = context.layoutInfo.editingArea;
          this.options = context.options;
          this.lang = this.options.langInfo;
          this.events = {
            'summernote.mousedown': function summernoteMousedown(we, e) {
              if (_this.update(e.target, e)) {
                e.preventDefault();
              }
            },
            'summernote.keyup summernote.scroll summernote.change summernote.dialog.shown': function summernoteKeyupSummernoteScrollSummernoteChangeSummernoteDialogShown() {
              _this.update();
            },
            'summernote.disable summernote.blur': function summernoteDisableSummernoteBlur() {
              _this.hide();
            },
            'summernote.codeview.toggled': function summernoteCodeviewToggled() {
              _this.update();
            }
          };
        }
        Handle_createClass(Handle, [{
          key: "initialize",
          value: function initialize() {
            var _this2 = this;
            this.$handle = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(['<div class="note-handle">', '<div class="note-control-selection">', '<div class="note-control-selection-bg"></div>', '<div class="note-control-holder note-control-nw"></div>', '<div class="note-control-holder note-control-ne"></div>', '<div class="note-control-holder note-control-sw"></div>', '<div class="', this.options.disableResizeImage ? 'note-control-holder' : 'note-control-sizing', ' note-control-se"></div>', this.options.disableResizeImage ? '' : '<div class="note-control-selection-info"></div>', '</div>', '</div>'].join('')).prependTo(this.$editingArea);
            this.$handle.on('mousedown', function (event) {
              if (dom.isControlSizing(event.target)) {
                event.preventDefault();
                event.stopPropagation();
                var $target = _this2.$handle.find('.note-control-selection').data('target');
                var posStart = $target.offset();
                var scrollTop = _this2.$document.scrollTop();
                var onMouseMove = function onMouseMove(event) {
                  _this2.context.invoke('editor.resizeTo', {
                    x: event.clientX - posStart.left,
                    y: event.clientY - (posStart.top - scrollTop)
                  }, $target, !event.shiftKey);
                  _this2.update($target[0], event);
                };
                _this2.$document.on('mousemove', onMouseMove).one('mouseup', function (e) {
                  e.preventDefault();
                  _this2.$document.off('mousemove', onMouseMove);
                  _this2.context.invoke('editor.afterCommand');
                });
                if (!$target.data('ratio')) {
                  // original ratio.
                  $target.data('ratio', $target.height() / $target.width());
                }
              }
            }); // Listen for scrolling on the handle overlay.

            this.$handle.on('wheel', function (e) {
              e.preventDefault();
              _this2.update();
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.$handle.remove();
          }
        }, {
          key: "update",
          value: function update(target, event) {
            if (this.context.isDisabled()) {
              return false;
            }
            var isImage = dom.isImg(target);
            var $selection = this.$handle.find('.note-control-selection');
            this.context.invoke('imagePopover.update', target, event);
            if (isImage) {
              var $image = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(target);
              var position = $image.position();
              var pos = {
                left: position.left + parseInt($image.css('marginLeft'), 10),
                top: position.top + parseInt($image.css('marginTop'), 10)
              }; // exclude margin

              var imageSize = {
                w: $image.outerWidth(false),
                h: $image.outerHeight(false)
              };
              $selection.css({
                display: 'block',
                left: pos.left,
                top: pos.top,
                width: imageSize.w,
                height: imageSize.h
              }).data('target', $image); // save current image element.

              var origImageObj = new Image();
              origImageObj.src = $image.attr('src');
              var sizingText = imageSize.w + 'x' + imageSize.h + ' (' + this.lang.image.original + ': ' + origImageObj.width + 'x' + origImageObj.height + ')';
              $selection.find('.note-control-selection-info').text(sizingText);
              this.context.invoke('editor.saveTarget', target);
            } else {
              this.hide();
            }
            return isImage;
          }
          /**
           * hide
           *
           * @param {jQuery} $handle
           */
        }, {
          key: "hide",
          value: function hide() {
            this.context.invoke('editor.clearTarget');
            this.$handle.children().hide();
          }
        }]);
        return Handle;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/AutoLink.js
      function AutoLink_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function AutoLink_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function AutoLink_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) AutoLink_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) AutoLink_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var defaultScheme = 'http://';
      var linkPattern = /^([A-Za-z][A-Za-z0-9+-.]*\:[\/]{2}|tel:|mailto:[A-Z0-9._%+-]+@)?(www\.)?(.+)$/i;
      var AutoLink_AutoLink = /*#__PURE__*/function () {
        function AutoLink(context) {
          var _this = this;
          AutoLink_classCallCheck(this, AutoLink);
          this.context = context;
          this.options = context.options;
          this.events = {
            'summernote.keyup': function summernoteKeyup(we, e) {
              if (!e.isDefaultPrevented()) {
                _this.handleKeyup(e);
              }
            },
            'summernote.keydown': function summernoteKeydown(we, e) {
              _this.handleKeydown(e);
            }
          };
        }
        AutoLink_createClass(AutoLink, [{
          key: "initialize",
          value: function initialize() {
            this.lastWordRange = null;
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.lastWordRange = null;
          }
        }, {
          key: "replace",
          value: function replace() {
            if (!this.lastWordRange) {
              return;
            }
            var keyword = this.lastWordRange.toString();
            var match = keyword.match(linkPattern);
            if (match && (match[1] || match[2])) {
              var link = match[1] ? keyword : defaultScheme + keyword;
              var urlText = this.options.showDomainOnlyForAutolink ? keyword.replace(/^(?:https?:\/\/)?(?:tel?:?)?(?:mailto?:?)?(?:www\.)?/i, '').split('/')[0] : keyword;
              var node = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<a />').html(urlText).attr('href', link)[0];
              if (this.context.options.linkTargetBlank) {
                external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(node).attr('target', '_blank');
              }
              this.lastWordRange.insertNode(node);
              this.lastWordRange = null;
              this.context.invoke('editor.focus');
            }
          }
        }, {
          key: "handleKeydown",
          value: function handleKeydown(e) {
            if (lists.contains([core_key.code.ENTER, core_key.code.SPACE], e.keyCode)) {
              var wordRange = this.context.invoke('editor.createRange').getWordRange();
              this.lastWordRange = wordRange;
            }
          }
        }, {
          key: "handleKeyup",
          value: function handleKeyup(e) {
            if (lists.contains([core_key.code.ENTER, core_key.code.SPACE], e.keyCode)) {
              this.replace();
            }
          }
        }]);
        return AutoLink;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/AutoSync.js
      function AutoSync_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function AutoSync_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function AutoSync_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) AutoSync_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) AutoSync_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      /**
       * textarea auto sync.
       */

      var AutoSync_AutoSync = /*#__PURE__*/function () {
        function AutoSync(context) {
          var _this = this;
          AutoSync_classCallCheck(this, AutoSync);
          this.$note = context.layoutInfo.note;
          this.events = {
            'summernote.change': function summernoteChange() {
              _this.$note.val(context.invoke('code'));
            }
          };
        }
        AutoSync_createClass(AutoSync, [{
          key: "shouldInitialize",
          value: function shouldInitialize() {
            return dom.isTextarea(this.$note[0]);
          }
        }]);
        return AutoSync;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/AutoReplace.js
      function AutoReplace_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function AutoReplace_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function AutoReplace_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) AutoReplace_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) AutoReplace_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var AutoReplace_AutoReplace = /*#__PURE__*/function () {
        function AutoReplace(context) {
          var _this = this;
          AutoReplace_classCallCheck(this, AutoReplace);
          this.context = context;
          this.options = context.options.replace || {};
          this.keys = [core_key.code.ENTER, core_key.code.SPACE, core_key.code.PERIOD, core_key.code.COMMA, core_key.code.SEMICOLON, core_key.code.SLASH];
          this.previousKeydownCode = null;
          this.events = {
            'summernote.keyup': function summernoteKeyup(we, e) {
              if (!e.isDefaultPrevented()) {
                _this.handleKeyup(e);
              }
            },
            'summernote.keydown': function summernoteKeydown(we, e) {
              _this.handleKeydown(e);
            }
          };
        }
        AutoReplace_createClass(AutoReplace, [{
          key: "shouldInitialize",
          value: function shouldInitialize() {
            return !!this.options.match;
          }
        }, {
          key: "initialize",
          value: function initialize() {
            this.lastWord = null;
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.lastWord = null;
          }
        }, {
          key: "replace",
          value: function replace() {
            if (!this.lastWord) {
              return;
            }
            var self = this;
            var keyword = this.lastWord.toString();
            this.options.match(keyword, function (match) {
              if (match) {
                var node = '';
                if (typeof match === 'string') {
                  node = dom.createText(match);
                } else if (match instanceof jQuery) {
                  node = match[0];
                } else if (match instanceof Node) {
                  node = match;
                }
                if (!node) return;
                self.lastWord.insertNode(node);
                self.lastWord = null;
                self.context.invoke('editor.focus');
              }
            });
          }
        }, {
          key: "handleKeydown",
          value: function handleKeydown(e) {
            // this forces it to remember the last whole word, even if multiple termination keys are pressed
            // before the previous key is let go.
            if (this.previousKeydownCode && lists.contains(this.keys, this.previousKeydownCode)) {
              this.previousKeydownCode = e.keyCode;
              return;
            }
            if (lists.contains(this.keys, e.keyCode)) {
              var wordRange = this.context.invoke('editor.createRange').getWordRange();
              this.lastWord = wordRange;
            }
            this.previousKeydownCode = e.keyCode;
          }
        }, {
          key: "handleKeyup",
          value: function handleKeyup(e) {
            if (lists.contains(this.keys, e.keyCode)) {
              this.replace();
            }
          }
        }]);
        return AutoReplace;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/Placeholder.js
      function Placeholder_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function Placeholder_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function Placeholder_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) Placeholder_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Placeholder_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var Placeholder_Placeholder = /*#__PURE__*/function () {
        function Placeholder(context) {
          var _this = this;
          Placeholder_classCallCheck(this, Placeholder);
          this.context = context;
          this.$editingArea = context.layoutInfo.editingArea;
          this.options = context.options;
          if (this.options.inheritPlaceholder === true) {
            // get placeholder value from the original element
            this.options.placeholder = this.context.$note.attr('placeholder') || this.options.placeholder;
          }
          this.events = {
            'summernote.init summernote.change': function summernoteInitSummernoteChange() {
              _this.update();
            },
            'summernote.codeview.toggled': function summernoteCodeviewToggled() {
              _this.update();
            }
          };
        }
        Placeholder_createClass(Placeholder, [{
          key: "shouldInitialize",
          value: function shouldInitialize() {
            return !!this.options.placeholder;
          }
        }, {
          key: "initialize",
          value: function initialize() {
            var _this2 = this;
            this.$placeholder = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<div class="note-placeholder">');
            this.$placeholder.on('click', function () {
              _this2.context.invoke('focus');
            }).html(this.options.placeholder).prependTo(this.$editingArea);
            this.update();
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.$placeholder.remove();
          }
        }, {
          key: "update",
          value: function update() {
            var isShow = !this.context.invoke('codeview.isActivated') && this.context.invoke('editor.isEmpty');
            this.$placeholder.toggle(isShow);
          }
        }]);
        return Placeholder;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/Buttons.js
      function Buttons_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function Buttons_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function Buttons_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) Buttons_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Buttons_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var Buttons_Buttons = /*#__PURE__*/function () {
        function Buttons(context) {
          Buttons_classCallCheck(this, Buttons);
          this.ui = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote.ui;
          this.context = context;
          this.$toolbar = context.layoutInfo.toolbar;
          this.options = context.options;
          this.lang = this.options.langInfo;
          this.invertedKeyMap = func.invertObject(this.options.keyMap[env.isMac ? 'mac' : 'pc']);
        }
        Buttons_createClass(Buttons, [{
          key: "representShortcut",
          value: function representShortcut(editorMethod) {
            var shortcut = this.invertedKeyMap[editorMethod];
            if (!this.options.shortcuts || !shortcut) {
              return '';
            }
            if (env.isMac) {
              shortcut = shortcut.replace('CMD', '⌘').replace('SHIFT', '⇧');
            }
            shortcut = shortcut.replace('BACKSLASH', '\\').replace('SLASH', '/').replace('LEFTBRACKET', '[').replace('RIGHTBRACKET', ']');
            return ' (' + shortcut + ')';
          }
        }, {
          key: "button",
          value: function button(o) {
            if (!this.options.tooltip && o.tooltip) {
              delete o.tooltip;
            }
            o.container = this.options.container;
            return this.ui.button(o);
          }
        }, {
          key: "initialize",
          value: function initialize() {
            this.addToolbarButtons();
            this.addImagePopoverButtons();
            this.addLinkPopoverButtons();
            this.addTablePopoverButtons();
            this.fontInstalledMap = {};
          }
        }, {
          key: "destroy",
          value: function destroy() {
            delete this.fontInstalledMap;
          }
        }, {
          key: "isFontInstalled",
          value: function isFontInstalled(name) {
            if (!Object.prototype.hasOwnProperty.call(this.fontInstalledMap, name)) {
              this.fontInstalledMap[name] = env.isFontInstalled(name) || lists.contains(this.options.fontNamesIgnoreCheck, name);
            }
            return this.fontInstalledMap[name];
          }
        }, {
          key: "isFontDeservedToAdd",
          value: function isFontDeservedToAdd(name) {
            name = name.toLowerCase();
            return name !== '' && this.isFontInstalled(name) && env.genericFontFamilies.indexOf(name) === -1;
          }
        }, {
          key: "colorPalette",
          value: function colorPalette(className, tooltip, backColor, foreColor) {
            var _this = this;
            return this.ui.buttonGroup({
              className: 'note-color ' + className,
              children: [this.button({
                className: 'note-current-color-button',
                contents: this.ui.icon(this.options.icons.font + ' note-recent-color'),
                tooltip: tooltip,
                click: function click(e) {
                  var $button = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(e.currentTarget);
                  if (backColor && foreColor) {
                    _this.context.invoke('editor.color', {
                      backColor: $button.attr('data-backColor'),
                      foreColor: $button.attr('data-foreColor')
                    });
                  } else if (backColor) {
                    _this.context.invoke('editor.color', {
                      backColor: $button.attr('data-backColor')
                    });
                  } else if (foreColor) {
                    _this.context.invoke('editor.color', {
                      foreColor: $button.attr('data-foreColor')
                    });
                  }
                },
                callback: function callback($button) {
                  var $recentColor = $button.find('.note-recent-color');
                  if (backColor) {
                    $recentColor.css('background-color', _this.options.colorButton.backColor);
                    $button.attr('data-backColor', _this.options.colorButton.backColor);
                  }
                  if (foreColor) {
                    $recentColor.css('color', _this.options.colorButton.foreColor);
                    $button.attr('data-foreColor', _this.options.colorButton.foreColor);
                  } else {
                    $recentColor.css('color', 'transparent');
                  }
                }
              }), this.button({
                className: 'dropdown-toggle',
                contents: this.ui.dropdownButtonContents('', this.options),
                tooltip: this.lang.color.more,
                data: {
                  toggle: 'dropdown'
                }
              }), this.ui.dropdown({
                items: (backColor ? ['<div class="note-palette">', '<div class="note-palette-title">' + this.lang.color.background + '</div>', '<div>', '<button type="button" class="note-color-reset btn btn-light btn-default" data-event="backColor" data-value="transparent">', this.lang.color.transparent, '</button>', '</div>', '<div class="note-holder" data-event="backColor"><!-- back colors --></div>', '<div>', '<button type="button" class="note-color-select btn btn-light btn-default" data-event="openPalette" data-value="backColorPicker">', this.lang.color.cpSelect, '</button>', '<input type="color" id="backColorPicker" class="note-btn note-color-select-btn" value="' + this.options.colorButton.backColor + '" data-event="backColorPalette">', '</div>', '<div class="note-holder-custom" id="backColorPalette" data-event="backColor"></div>', '</div>'].join('') : '') + (foreColor ? ['<div class="note-palette">', '<div class="note-palette-title">' + this.lang.color.foreground + '</div>', '<div>', '<button type="button" class="note-color-reset btn btn-light btn-default" data-event="removeFormat" data-value="foreColor">', this.lang.color.resetToDefault, '</button>', '</div>', '<div class="note-holder" data-event="foreColor"><!-- fore colors --></div>', '<div>', '<button type="button" class="note-color-select btn btn-light btn-default" data-event="openPalette" data-value="foreColorPicker">', this.lang.color.cpSelect, '</button>', '<input type="color" id="foreColorPicker" class="note-btn note-color-select-btn" value="' + this.options.colorButton.foreColor + '" data-event="foreColorPalette">', '</div>',
                // Fix missing Div, Commented to find easily if it's wrong
                '<div class="note-holder-custom" id="foreColorPalette" data-event="foreColor"></div>', '</div>'].join('') : ''),
                callback: function callback($dropdown) {
                  $dropdown.find('.note-holder').each(function (idx, item) {
                    var $holder = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(item);
                    $holder.append(_this.ui.palette({
                      colors: _this.options.colors,
                      colorsName: _this.options.colorsName,
                      eventName: $holder.data('event'),
                      container: _this.options.container,
                      tooltip: _this.options.tooltip
                    }).render());
                  });
                  /* TODO: do we have to record recent custom colors within cookies? */

                  var customColors = [['#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF']];
                  $dropdown.find('.note-holder-custom').each(function (idx, item) {
                    var $holder = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(item);
                    $holder.append(_this.ui.palette({
                      colors: customColors,
                      colorsName: customColors,
                      eventName: $holder.data('event'),
                      container: _this.options.container,
                      tooltip: _this.options.tooltip
                    }).render());
                  });
                  $dropdown.find('input[type=color]').each(function (idx, item) {
                    external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(item).change(function () {
                      var $chip = $dropdown.find('#' + external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(this).data('event')).find('.note-color-btn').first();
                      var color = this.value.toUpperCase();
                      $chip.css('background-color', color).attr('aria-label', color).attr('data-value', color).attr('data-original-title', color);
                      $chip.click();
                    });
                  });
                },
                click: function click(event) {
                  event.stopPropagation();
                  var $parent = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('.' + className).find('.note-dropdown-menu');
                  var $button = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(event.target);
                  var eventName = $button.data('event');
                  var value = $button.attr('data-value');
                  if (eventName === 'openPalette') {
                    var $picker = $parent.find('#' + value);
                    var $palette = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()($parent.find('#' + $picker.data('event')).find('.note-color-row')[0]); // Shift palette chips

                    var $chip = $palette.find('.note-color-btn').last().detach(); // Set chip attributes

                    var color = $picker.val();
                    $chip.css('background-color', color).attr('aria-label', color).attr('data-value', color).attr('data-original-title', color);
                    $palette.prepend($chip);
                    $picker.click();
                  } else {
                    if (lists.contains(['backColor', 'foreColor'], eventName)) {
                      var key = eventName === 'backColor' ? 'background-color' : 'color';
                      var $color = $button.closest('.note-color').find('.note-recent-color');
                      var $currentButton = $button.closest('.note-color').find('.note-current-color-button');
                      $color.css(key, value);
                      $currentButton.attr('data-' + eventName, value);
                    }
                    _this.context.invoke('editor.' + eventName, value);
                  }
                }
              })]
            }).render();
          }
        }, {
          key: "addToolbarButtons",
          value: function addToolbarButtons() {
            var _this2 = this;
            this.context.memo('button.style', function () {
              return _this2.ui.buttonGroup([_this2.button({
                className: 'dropdown-toggle',
                contents: _this2.ui.dropdownButtonContents(_this2.ui.icon(_this2.options.icons.magic), _this2.options),
                tooltip: _this2.lang.style.style,
                data: {
                  toggle: 'dropdown'
                }
              }), _this2.ui.dropdown({
                className: 'dropdown-style',
                items: _this2.options.styleTags,
                title: _this2.lang.style.style,
                template: function template(item) {
                  // TBD: need to be simplified
                  if (typeof item === 'string') {
                    item = {
                      tag: item,
                      title: Object.prototype.hasOwnProperty.call(_this2.lang.style, item) ? _this2.lang.style[item] : item
                    };
                  }
                  var tag = item.tag;
                  var title = item.title;
                  var style = item.style ? ' style="' + item.style + '" ' : '';
                  var className = item.className ? ' class="' + item.className + '"' : '';
                  return '<' + tag + style + className + '>' + title + '</' + tag + '>';
                },
                click: _this2.context.createInvokeHandler('editor.formatBlock')
              })]).render();
            });
            var _loop = function _loop(styleIdx, styleLen) {
              var item = _this2.options.styleTags[styleIdx];
              _this2.context.memo('button.style.' + item, function () {
                return _this2.button({
                  className: 'note-btn-style-' + item,
                  contents: '<div data-value="' + item + '">' + item.toUpperCase() + '</div>',
                  tooltip: _this2.lang.style[item],
                  click: _this2.context.createInvokeHandler('editor.formatBlock')
                }).render();
              });
            };
            for (var styleIdx = 0, styleLen = this.options.styleTags.length; styleIdx < styleLen; styleIdx++) {
              _loop(styleIdx, styleLen);
            }
            this.context.memo('button.bold', function () {
              return _this2.button({
                className: 'note-btn-bold',
                contents: _this2.ui.icon(_this2.options.icons.bold),
                tooltip: _this2.lang.font.bold + _this2.representShortcut('bold'),
                click: _this2.context.createInvokeHandlerAndUpdateState('editor.bold')
              }).render();
            });
            this.context.memo('button.italic', function () {
              return _this2.button({
                className: 'note-btn-italic',
                contents: _this2.ui.icon(_this2.options.icons.italic),
                tooltip: _this2.lang.font.italic + _this2.representShortcut('italic'),
                click: _this2.context.createInvokeHandlerAndUpdateState('editor.italic')
              }).render();
            });
            this.context.memo('button.underline', function () {
              return _this2.button({
                className: 'note-btn-underline',
                contents: _this2.ui.icon(_this2.options.icons.underline),
                tooltip: _this2.lang.font.underline + _this2.representShortcut('underline'),
                click: _this2.context.createInvokeHandlerAndUpdateState('editor.underline')
              }).render();
            });
            this.context.memo('button.clear', function () {
              return _this2.button({
                contents: _this2.ui.icon(_this2.options.icons.eraser),
                tooltip: _this2.lang.font.clear + _this2.representShortcut('removeFormat'),
                click: _this2.context.createInvokeHandler('editor.removeFormat')
              }).render();
            });
            this.context.memo('button.strikethrough', function () {
              return _this2.button({
                className: 'note-btn-strikethrough',
                contents: _this2.ui.icon(_this2.options.icons.strikethrough),
                tooltip: _this2.lang.font.strikethrough + _this2.representShortcut('strikethrough'),
                click: _this2.context.createInvokeHandlerAndUpdateState('editor.strikethrough')
              }).render();
            });
            this.context.memo('button.superscript', function () {
              return _this2.button({
                className: 'note-btn-superscript',
                contents: _this2.ui.icon(_this2.options.icons.superscript),
                tooltip: _this2.lang.font.superscript,
                click: _this2.context.createInvokeHandlerAndUpdateState('editor.superscript')
              }).render();
            });
            this.context.memo('button.subscript', function () {
              return _this2.button({
                className: 'note-btn-subscript',
                contents: _this2.ui.icon(_this2.options.icons.subscript),
                tooltip: _this2.lang.font.subscript,
                click: _this2.context.createInvokeHandlerAndUpdateState('editor.subscript')
              }).render();
            });
            this.context.memo('button.fontname', function () {
              var styleInfo = _this2.context.invoke('editor.currentStyle');
              if (_this2.options.addDefaultFonts) {
                // Add 'default' fonts into the fontnames array if not exist
                external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(styleInfo['font-family'].split(','), function (idx, fontname) {
                  fontname = fontname.trim().replace(/['"]+/g, '');
                  if (_this2.isFontDeservedToAdd(fontname)) {
                    if (_this2.options.fontNames.indexOf(fontname) === -1) {
                      _this2.options.fontNames.push(fontname);
                    }
                  }
                });
              }
              return _this2.ui.buttonGroup([_this2.button({
                className: 'dropdown-toggle',
                contents: _this2.ui.dropdownButtonContents('<span class="note-current-fontname"></span>', _this2.options),
                tooltip: _this2.lang.font.name,
                data: {
                  toggle: 'dropdown'
                }
              }), _this2.ui.dropdownCheck({
                className: 'dropdown-fontname',
                checkClassName: _this2.options.icons.menuCheck,
                items: _this2.options.fontNames.filter(_this2.isFontInstalled.bind(_this2)),
                title: _this2.lang.font.name,
                template: function template(item) {
                  return '<span style="font-family: ' + env.validFontName(item) + '">' + item + '</span>';
                },
                click: _this2.context.createInvokeHandlerAndUpdateState('editor.fontName')
              })]).render();
            });
            this.context.memo('button.fontsize', function () {
              return _this2.ui.buttonGroup([_this2.button({
                className: 'dropdown-toggle',
                contents: _this2.ui.dropdownButtonContents('<span class="note-current-fontsize"></span>', _this2.options),
                tooltip: _this2.lang.font.size,
                data: {
                  toggle: 'dropdown'
                }
              }), _this2.ui.dropdownCheck({
                className: 'dropdown-fontsize',
                checkClassName: _this2.options.icons.menuCheck,
                items: _this2.options.fontSizes,
                title: _this2.lang.font.size,
                click: _this2.context.createInvokeHandlerAndUpdateState('editor.fontSize')
              })]).render();
            });
            this.context.memo('button.fontsizeunit', function () {
              return _this2.ui.buttonGroup([_this2.button({
                className: 'dropdown-toggle',
                contents: _this2.ui.dropdownButtonContents('<span class="note-current-fontsizeunit"></span>', _this2.options),
                tooltip: _this2.lang.font.sizeunit,
                data: {
                  toggle: 'dropdown'
                }
              }), _this2.ui.dropdownCheck({
                className: 'dropdown-fontsizeunit',
                checkClassName: _this2.options.icons.menuCheck,
                items: _this2.options.fontSizeUnits,
                title: _this2.lang.font.sizeunit,
                click: _this2.context.createInvokeHandlerAndUpdateState('editor.fontSizeUnit')
              })]).render();
            });
            this.context.memo('button.color', function () {
              return _this2.colorPalette('note-color-all', _this2.lang.color.recent, true, true);
            });
            this.context.memo('button.forecolor', function () {
              return _this2.colorPalette('note-color-fore', _this2.lang.color.foreground, false, true);
            });
            this.context.memo('button.backcolor', function () {
              return _this2.colorPalette('note-color-back', _this2.lang.color.background, true, false);
            });
            this.context.memo('button.ul', function () {
              return _this2.button({
                contents: _this2.ui.icon(_this2.options.icons.unorderedlist),
                tooltip: _this2.lang.lists.unordered + _this2.representShortcut('insertUnorderedList'),
                click: _this2.context.createInvokeHandler('editor.insertUnorderedList')
              }).render();
            });
            this.context.memo('button.ol', function () {
              return _this2.button({
                contents: _this2.ui.icon(_this2.options.icons.orderedlist),
                tooltip: _this2.lang.lists.ordered + _this2.representShortcut('insertOrderedList'),
                click: _this2.context.createInvokeHandler('editor.insertOrderedList')
              }).render();
            });
            var justifyLeft = this.button({
              contents: this.ui.icon(this.options.icons.alignLeft),
              tooltip: this.lang.paragraph.left + this.representShortcut('justifyLeft'),
              click: this.context.createInvokeHandler('editor.justifyLeft')
            });
            var justifyCenter = this.button({
              contents: this.ui.icon(this.options.icons.alignCenter),
              tooltip: this.lang.paragraph.center + this.representShortcut('justifyCenter'),
              click: this.context.createInvokeHandler('editor.justifyCenter')
            });
            var justifyRight = this.button({
              contents: this.ui.icon(this.options.icons.alignRight),
              tooltip: this.lang.paragraph.right + this.representShortcut('justifyRight'),
              click: this.context.createInvokeHandler('editor.justifyRight')
            });
            var justifyFull = this.button({
              contents: this.ui.icon(this.options.icons.alignJustify),
              tooltip: this.lang.paragraph.justify + this.representShortcut('justifyFull'),
              click: this.context.createInvokeHandler('editor.justifyFull')
            });
            var outdent = this.button({
              contents: this.ui.icon(this.options.icons.outdent),
              tooltip: this.lang.paragraph.outdent + this.representShortcut('outdent'),
              click: this.context.createInvokeHandler('editor.outdent')
            });
            var indent = this.button({
              contents: this.ui.icon(this.options.icons.indent),
              tooltip: this.lang.paragraph.indent + this.representShortcut('indent'),
              click: this.context.createInvokeHandler('editor.indent')
            });
            this.context.memo('button.justifyLeft', func.invoke(justifyLeft, 'render'));
            this.context.memo('button.justifyCenter', func.invoke(justifyCenter, 'render'));
            this.context.memo('button.justifyRight', func.invoke(justifyRight, 'render'));
            this.context.memo('button.justifyFull', func.invoke(justifyFull, 'render'));
            this.context.memo('button.outdent', func.invoke(outdent, 'render'));
            this.context.memo('button.indent', func.invoke(indent, 'render'));
            this.context.memo('button.paragraph', function () {
              return _this2.ui.buttonGroup([_this2.button({
                className: 'dropdown-toggle',
                contents: _this2.ui.dropdownButtonContents(_this2.ui.icon(_this2.options.icons.alignLeft), _this2.options),
                tooltip: _this2.lang.paragraph.paragraph,
                data: {
                  toggle: 'dropdown'
                }
              }), _this2.ui.dropdown([_this2.ui.buttonGroup({
                className: 'note-align',
                children: [justifyLeft, justifyCenter, justifyRight, justifyFull]
              }), _this2.ui.buttonGroup({
                className: 'note-list',
                children: [outdent, indent]
              })])]).render();
            });
            this.context.memo('button.height', function () {
              return _this2.ui.buttonGroup([_this2.button({
                className: 'dropdown-toggle',
                contents: _this2.ui.dropdownButtonContents(_this2.ui.icon(_this2.options.icons.textHeight), _this2.options),
                tooltip: _this2.lang.font.height,
                data: {
                  toggle: 'dropdown'
                }
              }), _this2.ui.dropdownCheck({
                items: _this2.options.lineHeights,
                checkClassName: _this2.options.icons.menuCheck,
                className: 'dropdown-line-height',
                title: _this2.lang.font.height,
                click: _this2.context.createInvokeHandler('editor.lineHeight')
              })]).render();
            });
            this.context.memo('button.table', function () {
              return _this2.ui.buttonGroup([_this2.button({
                className: 'dropdown-toggle',
                contents: _this2.ui.dropdownButtonContents(_this2.ui.icon(_this2.options.icons.table), _this2.options),
                tooltip: _this2.lang.table.table,
                data: {
                  toggle: 'dropdown'
                }
              }), _this2.ui.dropdown({
                title: _this2.lang.table.table,
                className: 'note-table',
                items: ['<div class="note-dimension-picker">', '<div class="note-dimension-picker-mousecatcher" data-event="insertTable" data-value="1x1"></div>', '<div class="note-dimension-picker-highlighted"></div>', '<div class="note-dimension-picker-unhighlighted"></div>', '</div>', '<div class="note-dimension-display">1 x 1</div>'].join('')
              })], {
                callback: function callback($node) {
                  var $catcher = $node.find('.note-dimension-picker-mousecatcher');
                  $catcher.css({
                    width: _this2.options.insertTableMaxSize.col + 'em',
                    height: _this2.options.insertTableMaxSize.row + 'em'
                  }).mousedown(_this2.context.createInvokeHandler('editor.insertTable')).on('mousemove', _this2.tableMoveHandler.bind(_this2));
                }
              }).render();
            });
            this.context.memo('button.link', function () {
              return _this2.button({
                contents: _this2.ui.icon(_this2.options.icons.link),
                tooltip: _this2.lang.link.link + _this2.representShortcut('linkDialog.show'),
                click: _this2.context.createInvokeHandler('linkDialog.show')
              }).render();
            });
            this.context.memo('button.picture', function () {
              return _this2.button({
                contents: _this2.ui.icon(_this2.options.icons.picture),
                tooltip: _this2.lang.image.image,
                click: _this2.context.createInvokeHandler('imageDialog.show')
              }).render();
            });
            this.context.memo('button.video', function () {
              return _this2.button({
                contents: _this2.ui.icon(_this2.options.icons.video),
                tooltip: _this2.lang.video.video,
                click: _this2.context.createInvokeHandler('videoDialog.show')
              }).render();
            });
            this.context.memo('button.hr', function () {
              return _this2.button({
                contents: _this2.ui.icon(_this2.options.icons.minus),
                tooltip: _this2.lang.hr.insert + _this2.representShortcut('insertHorizontalRule'),
                click: _this2.context.createInvokeHandler('editor.insertHorizontalRule')
              }).render();
            });
            this.context.memo('button.fullscreen', function () {
              return _this2.button({
                className: 'btn-fullscreen note-codeview-keep',
                contents: _this2.ui.icon(_this2.options.icons.arrowsAlt),
                tooltip: _this2.lang.options.fullscreen,
                click: _this2.context.createInvokeHandler('fullscreen.toggle')
              }).render();
            });
            this.context.memo('button.codeview', function () {
              return _this2.button({
                className: 'btn-codeview note-codeview-keep',
                contents: _this2.ui.icon(_this2.options.icons.code),
                tooltip: _this2.lang.options.codeview,
                click: _this2.context.createInvokeHandler('codeview.toggle')
              }).render();
            });
            this.context.memo('button.redo', function () {
              return _this2.button({
                contents: _this2.ui.icon(_this2.options.icons.redo),
                tooltip: _this2.lang.history.redo + _this2.representShortcut('redo'),
                click: _this2.context.createInvokeHandler('editor.redo')
              }).render();
            });
            this.context.memo('button.undo', function () {
              return _this2.button({
                contents: _this2.ui.icon(_this2.options.icons.undo),
                tooltip: _this2.lang.history.undo + _this2.representShortcut('undo'),
                click: _this2.context.createInvokeHandler('editor.undo')
              }).render();
            });
            this.context.memo('button.help', function () {
              return _this2.button({
                contents: _this2.ui.icon(_this2.options.icons.question),
                tooltip: _this2.lang.options.help,
                click: _this2.context.createInvokeHandler('helpDialog.show')
              }).render();
            });
          }
          /**
           * image: [
           *   ['imageResize', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']],
           *   ['float', ['floatLeft', 'floatRight', 'floatNone']],
           *   ['remove', ['removeMedia']],
           * ],
           */
        }, {
          key: "addImagePopoverButtons",
          value: function addImagePopoverButtons() {
            var _this3 = this;

            // Image Size Buttons
            this.context.memo('button.resizeFull', function () {
              return _this3.button({
                contents: '<span class="note-fontsize-10">100%</span>',
                tooltip: _this3.lang.image.resizeFull,
                click: _this3.context.createInvokeHandler('editor.resize', '1')
              }).render();
            });
            this.context.memo('button.resizeHalf', function () {
              return _this3.button({
                contents: '<span class="note-fontsize-10">50%</span>',
                tooltip: _this3.lang.image.resizeHalf,
                click: _this3.context.createInvokeHandler('editor.resize', '0.5')
              }).render();
            });
            this.context.memo('button.resizeQuarter', function () {
              return _this3.button({
                contents: '<span class="note-fontsize-10">25%</span>',
                tooltip: _this3.lang.image.resizeQuarter,
                click: _this3.context.createInvokeHandler('editor.resize', '0.25')
              }).render();
            });
            this.context.memo('button.resizeNone', function () {
              return _this3.button({
                contents: _this3.ui.icon(_this3.options.icons.rollback),
                tooltip: _this3.lang.image.resizeNone,
                click: _this3.context.createInvokeHandler('editor.resize', '0')
              }).render();
            }); // Float Buttons

            this.context.memo('button.floatLeft', function () {
              return _this3.button({
                contents: _this3.ui.icon(_this3.options.icons.floatLeft),
                tooltip: _this3.lang.image.floatLeft,
                click: _this3.context.createInvokeHandler('editor.floatMe', 'left')
              }).render();
            });
            this.context.memo('button.floatRight', function () {
              return _this3.button({
                contents: _this3.ui.icon(_this3.options.icons.floatRight),
                tooltip: _this3.lang.image.floatRight,
                click: _this3.context.createInvokeHandler('editor.floatMe', 'right')
              }).render();
            });
            this.context.memo('button.floatNone', function () {
              return _this3.button({
                contents: _this3.ui.icon(_this3.options.icons.rollback),
                tooltip: _this3.lang.image.floatNone,
                click: _this3.context.createInvokeHandler('editor.floatMe', 'none')
              }).render();
            }); // Remove Buttons

            this.context.memo('button.removeMedia', function () {
              return _this3.button({
                contents: _this3.ui.icon(_this3.options.icons.trash),
                tooltip: _this3.lang.image.remove,
                click: _this3.context.createInvokeHandler('editor.removeMedia')
              }).render();
            });
          }
        }, {
          key: "addLinkPopoverButtons",
          value: function addLinkPopoverButtons() {
            var _this4 = this;
            this.context.memo('button.linkDialogShow', function () {
              return _this4.button({
                contents: _this4.ui.icon(_this4.options.icons.link),
                tooltip: _this4.lang.link.edit,
                click: _this4.context.createInvokeHandler('linkDialog.show')
              }).render();
            });
            this.context.memo('button.unlink', function () {
              return _this4.button({
                contents: _this4.ui.icon(_this4.options.icons.unlink),
                tooltip: _this4.lang.link.unlink,
                click: _this4.context.createInvokeHandler('editor.unlink')
              }).render();
            });
          }
          /**
           * table : [
           *  ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
           *  ['delete', ['deleteRow', 'deleteCol', 'deleteTable']]
           * ],
           */
        }, {
          key: "addTablePopoverButtons",
          value: function addTablePopoverButtons() {
            var _this5 = this;
            this.context.memo('button.addRowUp', function () {
              return _this5.button({
                className: 'btn-md',
                contents: _this5.ui.icon(_this5.options.icons.rowAbove),
                tooltip: _this5.lang.table.addRowAbove,
                click: _this5.context.createInvokeHandler('editor.addRow', 'top')
              }).render();
            });
            this.context.memo('button.addRowDown', function () {
              return _this5.button({
                className: 'btn-md',
                contents: _this5.ui.icon(_this5.options.icons.rowBelow),
                tooltip: _this5.lang.table.addRowBelow,
                click: _this5.context.createInvokeHandler('editor.addRow', 'bottom')
              }).render();
            });
            this.context.memo('button.addColLeft', function () {
              return _this5.button({
                className: 'btn-md',
                contents: _this5.ui.icon(_this5.options.icons.colBefore),
                tooltip: _this5.lang.table.addColLeft,
                click: _this5.context.createInvokeHandler('editor.addCol', 'left')
              }).render();
            });
            this.context.memo('button.addColRight', function () {
              return _this5.button({
                className: 'btn-md',
                contents: _this5.ui.icon(_this5.options.icons.colAfter),
                tooltip: _this5.lang.table.addColRight,
                click: _this5.context.createInvokeHandler('editor.addCol', 'right')
              }).render();
            });
            this.context.memo('button.deleteRow', function () {
              return _this5.button({
                className: 'btn-md',
                contents: _this5.ui.icon(_this5.options.icons.rowRemove),
                tooltip: _this5.lang.table.delRow,
                click: _this5.context.createInvokeHandler('editor.deleteRow')
              }).render();
            });
            this.context.memo('button.deleteCol', function () {
              return _this5.button({
                className: 'btn-md',
                contents: _this5.ui.icon(_this5.options.icons.colRemove),
                tooltip: _this5.lang.table.delCol,
                click: _this5.context.createInvokeHandler('editor.deleteCol')
              }).render();
            });
            this.context.memo('button.deleteTable', function () {
              return _this5.button({
                className: 'btn-md',
                contents: _this5.ui.icon(_this5.options.icons.trash),
                tooltip: _this5.lang.table.delTable,
                click: _this5.context.createInvokeHandler('editor.deleteTable')
              }).render();
            });
          }
        }, {
          key: "build",
          value: function build($container, groups) {
            for (var groupIdx = 0, groupLen = groups.length; groupIdx < groupLen; groupIdx++) {
              var group = groups[groupIdx];
              var groupName = Array.isArray(group) ? group[0] : group;
              var buttons = Array.isArray(group) ? group.length === 1 ? [group[0]] : group[1] : [group];
              var $group = this.ui.buttonGroup({
                className: 'note-' + groupName
              }).render();
              for (var idx = 0, len = buttons.length; idx < len; idx++) {
                var btn = this.context.memo('button.' + buttons[idx]);
                if (btn) {
                  $group.append(typeof btn === 'function' ? btn(this.context) : btn);
                }
              }
              $group.appendTo($container);
            }
          }
          /**
           * @param {jQuery} [$container]
           */
        }, {
          key: "updateCurrentStyle",
          value: function updateCurrentStyle($container) {
            var _this6 = this;
            var $cont = $container || this.$toolbar;
            var styleInfo = this.context.invoke('editor.currentStyle');
            this.updateBtnStates($cont, {
              '.note-btn-bold': function noteBtnBold() {
                return styleInfo['font-bold'] === 'bold';
              },
              '.note-btn-italic': function noteBtnItalic() {
                return styleInfo['font-italic'] === 'italic';
              },
              '.note-btn-underline': function noteBtnUnderline() {
                return styleInfo['font-underline'] === 'underline';
              },
              '.note-btn-subscript': function noteBtnSubscript() {
                return styleInfo['font-subscript'] === 'subscript';
              },
              '.note-btn-superscript': function noteBtnSuperscript() {
                return styleInfo['font-superscript'] === 'superscript';
              },
              '.note-btn-strikethrough': function noteBtnStrikethrough() {
                return styleInfo['font-strikethrough'] === 'strikethrough';
              }
            });
            if (styleInfo['font-family']) {
              var fontNames = styleInfo['font-family'].split(',').map(function (name) {
                return name.replace(/[\'\"]/g, '').replace(/\s+$/, '').replace(/^\s+/, '');
              });
              var fontName = lists.find(fontNames, this.isFontInstalled.bind(this));
              $cont.find('.dropdown-fontname a').each(function (idx, item) {
                var $item = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(item); // always compare string to avoid creating another func.

                var isChecked = $item.data('value') + '' === fontName + '';
                $item.toggleClass('checked', isChecked);
              });
              $cont.find('.note-current-fontname').text(fontName).css('font-family', fontName);
            }
            if (styleInfo['font-size']) {
              var fontSize = styleInfo['font-size'];
              $cont.find('.dropdown-fontsize a').each(function (idx, item) {
                var $item = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(item); // always compare with string to avoid creating another func.

                var isChecked = $item.data('value') + '' === fontSize + '';
                $item.toggleClass('checked', isChecked);
              });
              $cont.find('.note-current-fontsize').text(fontSize);
              var fontSizeUnit = styleInfo['font-size-unit'];
              $cont.find('.dropdown-fontsizeunit a').each(function (idx, item) {
                var $item = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(item);
                var isChecked = $item.data('value') + '' === fontSizeUnit + '';
                $item.toggleClass('checked', isChecked);
              });
              $cont.find('.note-current-fontsizeunit').text(fontSizeUnit);
            }
            if (styleInfo['line-height']) {
              var lineHeight = styleInfo['line-height'];
              $cont.find('.dropdown-line-height li a').each(function (idx, item) {
                // always compare with string to avoid creating another func.
                var isChecked = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(item).data('value') + '' === lineHeight + '';
                _this6.className = isChecked ? 'checked' : '';
              });
            }
          }
        }, {
          key: "updateBtnStates",
          value: function updateBtnStates($container, infos) {
            var _this7 = this;
            external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.each(infos, function (selector, pred) {
              _this7.ui.toggleBtnActive($container.find(selector), pred());
            });
          }
        }, {
          key: "tableMoveHandler",
          value: function tableMoveHandler(event) {
            var PX_PER_EM = 18;
            var $picker = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(event.target.parentNode); // target is mousecatcher

            var $dimensionDisplay = $picker.next();
            var $catcher = $picker.find('.note-dimension-picker-mousecatcher');
            var $highlighted = $picker.find('.note-dimension-picker-highlighted');
            var $unhighlighted = $picker.find('.note-dimension-picker-unhighlighted');
            var posOffset; // HTML5 with jQuery - e.offsetX is undefined in Firefox

            if (event.offsetX === undefined) {
              var posCatcher = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(event.target).offset();
              posOffset = {
                x: event.pageX - posCatcher.left,
                y: event.pageY - posCatcher.top
              };
            } else {
              posOffset = {
                x: event.offsetX,
                y: event.offsetY
              };
            }
            var dim = {
              c: Math.ceil(posOffset.x / PX_PER_EM) || 1,
              r: Math.ceil(posOffset.y / PX_PER_EM) || 1
            };
            $highlighted.css({
              width: dim.c + 'em',
              height: dim.r + 'em'
            });
            $catcher.data('value', dim.c + 'x' + dim.r);
            if (dim.c > 3 && dim.c < this.options.insertTableMaxSize.col) {
              $unhighlighted.css({
                width: dim.c + 1 + 'em'
              });
            }
            if (dim.r > 3 && dim.r < this.options.insertTableMaxSize.row) {
              $unhighlighted.css({
                height: dim.r + 1 + 'em'
              });
            }
            $dimensionDisplay.html(dim.c + ' x ' + dim.r);
          }
        }]);
        return Buttons;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/Toolbar.js
      function Toolbar_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function Toolbar_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function Toolbar_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) Toolbar_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) Toolbar_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var Toolbar_Toolbar = /*#__PURE__*/function () {
        function Toolbar(context) {
          Toolbar_classCallCheck(this, Toolbar);
          this.context = context;
          this.$window = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(window);
          this.$document = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(document);
          this.ui = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote.ui;
          this.$note = context.layoutInfo.note;
          this.$editor = context.layoutInfo.editor;
          this.$toolbar = context.layoutInfo.toolbar;
          this.$editable = context.layoutInfo.editable;
          this.$statusbar = context.layoutInfo.statusbar;
          this.options = context.options;
          this.isFollowing = false;
          this.followScroll = this.followScroll.bind(this);
        }
        Toolbar_createClass(Toolbar, [{
          key: "shouldInitialize",
          value: function shouldInitialize() {
            return !this.options.airMode;
          }
        }, {
          key: "initialize",
          value: function initialize() {
            var _this = this;
            this.options.toolbar = this.options.toolbar || [];
            if (!this.options.toolbar.length) {
              this.$toolbar.hide();
            } else {
              this.context.invoke('buttons.build', this.$toolbar, this.options.toolbar);
            }
            if (this.options.toolbarContainer) {
              this.$toolbar.appendTo(this.options.toolbarContainer);
            }
            this.changeContainer(false);
            this.$note.on('summernote.keyup summernote.mouseup summernote.change', function () {
              _this.context.invoke('buttons.updateCurrentStyle');
            });
            this.context.invoke('buttons.updateCurrentStyle');
            if (this.options.followingToolbar) {
              this.$window.on('scroll resize', this.followScroll);
            }
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.$toolbar.children().remove();
            if (this.options.followingToolbar) {
              this.$window.off('scroll resize', this.followScroll);
            }
          }
        }, {
          key: "followScroll",
          value: function followScroll() {
            if (this.$editor.hasClass('fullscreen')) {
              return false;
            }
            var editorHeight = this.$editor.outerHeight();
            var editorWidth = this.$editor.width();
            var toolbarHeight = this.$toolbar.height();
            var statusbarHeight = this.$statusbar.height(); // check if the web app is currently using another static bar

            var otherBarHeight = 0;
            if (this.options.otherStaticBar) {
              otherBarHeight = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(this.options.otherStaticBar).outerHeight();
            }
            var currentOffset = this.$document.scrollTop();
            var editorOffsetTop = this.$editor.offset().top;
            var editorOffsetBottom = editorOffsetTop + editorHeight;
            var activateOffset = editorOffsetTop - otherBarHeight;
            var deactivateOffsetBottom = editorOffsetBottom - otherBarHeight - toolbarHeight - statusbarHeight;
            if (!this.isFollowing && currentOffset > activateOffset && currentOffset < deactivateOffsetBottom - toolbarHeight) {
              this.isFollowing = true;
              this.$editable.css({
                marginTop: this.$toolbar.outerHeight()
              });
              this.$toolbar.css({
                position: 'fixed',
                top: otherBarHeight,
                width: editorWidth,
                zIndex: 1000
              });
            } else if (this.isFollowing && (currentOffset < activateOffset || currentOffset > deactivateOffsetBottom)) {
              this.isFollowing = false;
              this.$toolbar.css({
                position: 'relative',
                top: 0,
                width: '100%',
                zIndex: 'auto'
              });
              this.$editable.css({
                marginTop: ''
              });
            }
          }
        }, {
          key: "changeContainer",
          value: function changeContainer(isFullscreen) {
            if (isFullscreen) {
              this.$toolbar.prependTo(this.$editor);
            } else {
              if (this.options.toolbarContainer) {
                this.$toolbar.appendTo(this.options.toolbarContainer);
              }
            }
            if (this.options.followingToolbar) {
              this.followScroll();
            }
          }
        }, {
          key: "updateFullscreen",
          value: function updateFullscreen(isFullscreen) {
            this.ui.toggleBtnActive(this.$toolbar.find('.btn-fullscreen'), isFullscreen);
            this.changeContainer(isFullscreen);
          }
        }, {
          key: "updateCodeview",
          value: function updateCodeview(isCodeview) {
            this.ui.toggleBtnActive(this.$toolbar.find('.btn-codeview'), isCodeview);
            if (isCodeview) {
              this.deactivate();
            } else {
              this.activate();
            }
          }
        }, {
          key: "activate",
          value: function activate(isIncludeCodeview) {
            var $btn = this.$toolbar.find('button');
            if (!isIncludeCodeview) {
              $btn = $btn.not('.note-codeview-keep');
            }
            this.ui.toggleBtn($btn, true);
          }
        }, {
          key: "deactivate",
          value: function deactivate(isIncludeCodeview) {
            var $btn = this.$toolbar.find('button');
            if (!isIncludeCodeview) {
              $btn = $btn.not('.note-codeview-keep');
            }
            this.ui.toggleBtn($btn, false);
          }
        }]);
        return Toolbar;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/LinkDialog.js
      function LinkDialog_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function LinkDialog_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function LinkDialog_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) LinkDialog_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) LinkDialog_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var LinkDialog_LinkDialog = /*#__PURE__*/function () {
        function LinkDialog(context) {
          LinkDialog_classCallCheck(this, LinkDialog);
          this.context = context;
          this.ui = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote.ui;
          this.$body = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(document.body);
          this.$editor = context.layoutInfo.editor;
          this.options = context.options;
          this.lang = this.options.langInfo;
          context.memo('help.linkDialog.show', this.options.langInfo.help['linkDialog.show']);
        }
        LinkDialog_createClass(LinkDialog, [{
          key: "initialize",
          value: function initialize() {
            var $container = this.options.dialogsInBody ? this.$body : this.options.container;
            var body = ['<div class="form-group note-form-group">', "<label for=\"note-dialog-link-txt-".concat(this.options.id, "\" class=\"note-form-label\">").concat(this.lang.link.textToDisplay, "</label>"), "<input id=\"note-dialog-link-txt-".concat(this.options.id, "\" class=\"note-link-text form-control note-form-control note-input\" type=\"text\"/>"), '</div>', '<div class="form-group note-form-group">', "<label for=\"note-dialog-link-url-".concat(this.options.id, "\" class=\"note-form-label\">").concat(this.lang.link.url, "</label>"), "<input id=\"note-dialog-link-url-".concat(this.options.id, "\" class=\"note-link-url form-control note-form-control note-input\" type=\"text\" value=\"http://\"/>"), '</div>', !this.options.disableLinkTarget ? external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<div/>').append(this.ui.checkbox({
              className: 'sn-checkbox-open-in-new-window',
              text: this.lang.link.openInNewWindow,
              checked: true
            }).render()).html() : '', external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<div/>').append(this.ui.checkbox({
              className: 'sn-checkbox-use-protocol',
              text: this.lang.link.useProtocol,
              checked: true
            }).render()).html()].join('');
            var buttonClass = 'btn btn-primary note-btn note-btn-primary note-link-btn';
            var footer = "<input type=\"button\" href=\"#\" class=\"".concat(buttonClass, "\" value=\"").concat(this.lang.link.insert, "\" disabled>");
            this.$dialog = this.ui.dialog({
              className: 'link-dialog',
              title: this.lang.link.insert,
              fade: this.options.dialogsFade,
              body: body,
              footer: footer
            }).render().appendTo($container);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.ui.hideDialog(this.$dialog);
            this.$dialog.remove();
          }
        }, {
          key: "bindEnterKey",
          value: function bindEnterKey($input, $btn) {
            $input.on('keypress', function (event) {
              if (event.keyCode === core_key.code.ENTER) {
                event.preventDefault();
                $btn.trigger('click');
              }
            });
          }
          /**
           * toggle update button
           */
        }, {
          key: "toggleLinkBtn",
          value: function toggleLinkBtn($linkBtn, $linkText, $linkUrl) {
            this.ui.toggleBtn($linkBtn, $linkText.val() && $linkUrl.val());
          }
          /**
           * Show link dialog and set event handlers on dialog controls.
           *
           * @param {Object} linkInfo
           * @return {Promise}
           */
        }, {
          key: "showLinkDialog",
          value: function showLinkDialog(linkInfo) {
            var _this = this;
            return external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.Deferred(function (deferred) {
              var $linkText = _this.$dialog.find('.note-link-text');
              var $linkUrl = _this.$dialog.find('.note-link-url');
              var $linkBtn = _this.$dialog.find('.note-link-btn');
              var $openInNewWindow = _this.$dialog.find('.sn-checkbox-open-in-new-window input[type=checkbox]');
              var $useProtocol = _this.$dialog.find('.sn-checkbox-use-protocol input[type=checkbox]');
              _this.ui.onDialogShown(_this.$dialog, function () {
                _this.context.triggerEvent('dialog.shown'); // If no url was given and given text is valid URL then copy that into URL Field

                if (!linkInfo.url && func.isValidUrl(linkInfo.text)) {
                  linkInfo.url = linkInfo.text;
                }
                $linkText.on('input paste propertychange', function () {
                  // If linktext was modified by input events,
                  // cloning text from linkUrl will be stopped.
                  linkInfo.text = $linkText.val();
                  _this.toggleLinkBtn($linkBtn, $linkText, $linkUrl);
                }).val(linkInfo.text);
                $linkUrl.on('input paste propertychange', function () {
                  // Display same text on `Text to display` as default
                  // when linktext has no text
                  if (!linkInfo.text) {
                    $linkText.val($linkUrl.val());
                  }
                  _this.toggleLinkBtn($linkBtn, $linkText, $linkUrl);
                }).val(linkInfo.url);
                if (!env.isSupportTouch) {
                  $linkUrl.trigger('focus');
                }
                _this.toggleLinkBtn($linkBtn, $linkText, $linkUrl);
                _this.bindEnterKey($linkUrl, $linkBtn);
                _this.bindEnterKey($linkText, $linkBtn);
                var isNewWindowChecked = linkInfo.isNewWindow !== undefined ? linkInfo.isNewWindow : _this.context.options.linkTargetBlank;
                $openInNewWindow.prop('checked', isNewWindowChecked);
                var useProtocolChecked = linkInfo.url ? false : _this.context.options.useProtocol;
                $useProtocol.prop('checked', useProtocolChecked);
                $linkBtn.one('click', function (event) {
                  event.preventDefault();
                  deferred.resolve({
                    range: linkInfo.range,
                    url: $linkUrl.val(),
                    text: $linkText.val(),
                    isNewWindow: $openInNewWindow.is(':checked'),
                    checkProtocol: $useProtocol.is(':checked')
                  });
                  _this.ui.hideDialog(_this.$dialog);
                });
              });
              _this.ui.onDialogHidden(_this.$dialog, function () {
                // detach events
                $linkText.off();
                $linkUrl.off();
                $linkBtn.off();
                if (deferred.state() === 'pending') {
                  deferred.reject();
                }
              });
              _this.ui.showDialog(_this.$dialog);
            }).promise();
          }
          /**
           * @param {Object} layoutInfo
           */
        }, {
          key: "show",
          value: function show() {
            var _this2 = this;
            var linkInfo = this.context.invoke('editor.getLinkInfo');
            this.context.invoke('editor.saveRange');
            this.showLinkDialog(linkInfo).then(function (linkInfo) {
              _this2.context.invoke('editor.restoreRange');
              _this2.context.invoke('editor.createLink', linkInfo);
            }).fail(function () {
              _this2.context.invoke('editor.restoreRange');
            });
          }
        }]);
        return LinkDialog;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/LinkPopover.js
      function LinkPopover_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function LinkPopover_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function LinkPopover_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) LinkPopover_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) LinkPopover_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var LinkPopover_LinkPopover = /*#__PURE__*/function () {
        function LinkPopover(context) {
          var _this = this;
          LinkPopover_classCallCheck(this, LinkPopover);
          this.context = context;
          this.ui = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote.ui;
          this.options = context.options;
          this.events = {
            'summernote.keyup summernote.mouseup summernote.change summernote.scroll': function summernoteKeyupSummernoteMouseupSummernoteChangeSummernoteScroll() {
              _this.update();
            },
            'summernote.disable summernote.dialog.shown summernote.blur': function summernoteDisableSummernoteDialogShownSummernoteBlur() {
              _this.hide();
            }
          };
        }
        LinkPopover_createClass(LinkPopover, [{
          key: "shouldInitialize",
          value: function shouldInitialize() {
            return !lists.isEmpty(this.options.popover.link);
          }
        }, {
          key: "initialize",
          value: function initialize() {
            this.$popover = this.ui.popover({
              className: 'note-link-popover',
              callback: function callback($node) {
                var $content = $node.find('.popover-content,.note-popover-content');
                $content.prepend('<span><a target="_blank"></a>&nbsp;</span>');
              }
            }).render().appendTo(this.options.container);
            var $content = this.$popover.find('.popover-content,.note-popover-content');
            this.context.invoke('buttons.build', $content, this.options.popover.link);
            this.$popover.on('mousedown', function (e) {
              e.preventDefault();
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.$popover.remove();
          }
        }, {
          key: "update",
          value: function update() {
            // Prevent focusing on editable when invoke('code') is executed
            if (!this.context.invoke('editor.hasFocus')) {
              this.hide();
              return;
            }
            var rng = this.context.invoke('editor.getLastRange');
            if (rng.isCollapsed() && rng.isOnAnchor()) {
              var anchor = dom.ancestor(rng.sc, dom.isAnchor);
              var href = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(anchor).attr('href');
              this.$popover.find('a').attr('href', href).text(href);
              var pos = dom.posFromPlaceholder(anchor);
              var containerOffset = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(this.options.container).offset();
              pos.top -= containerOffset.top;
              pos.left -= containerOffset.left;
              this.$popover.css({
                display: 'block',
                left: pos.left,
                top: pos.top
              });
            } else {
              this.hide();
            }
          }
        }, {
          key: "hide",
          value: function hide() {
            this.$popover.hide();
          }
        }]);
        return LinkPopover;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/ImageDialog.js
      function ImageDialog_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function ImageDialog_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function ImageDialog_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) ImageDialog_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) ImageDialog_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var ImageDialog_ImageDialog = /*#__PURE__*/function () {
        function ImageDialog(context) {
          ImageDialog_classCallCheck(this, ImageDialog);
          this.context = context;
          this.ui = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote.ui;
          this.$body = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(document.body);
          this.$editor = context.layoutInfo.editor;
          this.options = context.options;
          this.lang = this.options.langInfo;
        }
        ImageDialog_createClass(ImageDialog, [{
          key: "initialize",
          value: function initialize() {
            var imageLimitation = '';
            if (this.options.maximumImageFileSize) {
              var unit = Math.floor(Math.log(this.options.maximumImageFileSize) / Math.log(1024));
              var readableSize = (this.options.maximumImageFileSize / Math.pow(1024, unit)).toFixed(2) * 1 + ' ' + ' KMGTP'[unit] + 'B';
              imageLimitation = "<small>".concat(this.lang.image.maximumFileSize + ' : ' + readableSize, "</small>");
            }
            var $container = this.options.dialogsInBody ? this.$body : this.options.container;
            var body = ['<div class="form-group note-form-group note-group-select-from-files">', '<label for="note-dialog-image-file-' + this.options.id + '" class="note-form-label">' + this.lang.image.selectFromFiles + '</label>', '<input id="note-dialog-image-file-' + this.options.id + '" class="note-image-input form-control-file note-form-control note-input" ', ' type="file" name="files" accept="image/*" multiple="multiple"/>', imageLimitation, '</div>', '<div class="form-group note-group-image-url">', '<label for="note-dialog-image-url-' + this.options.id + '" class="note-form-label">' + this.lang.image.url + '</label>', '<input id="note-dialog-image-url-' + this.options.id + '" class="note-image-url form-control note-form-control note-input" type="text"/>', '</div>'].join('');
            var buttonClass = 'btn btn-primary note-btn note-btn-primary note-image-btn';
            var footer = "<input type=\"button\" href=\"#\" class=\"".concat(buttonClass, "\" value=\"").concat(this.lang.image.insert, "\" disabled>");
            this.$dialog = this.ui.dialog({
              title: this.lang.image.insert,
              fade: this.options.dialogsFade,
              body: body,
              footer: footer
            }).render().appendTo($container);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.ui.hideDialog(this.$dialog);
            this.$dialog.remove();
          }
        }, {
          key: "bindEnterKey",
          value: function bindEnterKey($input, $btn) {
            $input.on('keypress', function (event) {
              if (event.keyCode === core_key.code.ENTER) {
                event.preventDefault();
                $btn.trigger('click');
              }
            });
          }
        }, {
          key: "show",
          value: function show() {
            var _this = this;
            this.context.invoke('editor.saveRange');
            this.showImageDialog().then(function (data) {
              // [workaround] hide dialog before restore range for IE range focus
              _this.ui.hideDialog(_this.$dialog);
              _this.context.invoke('editor.restoreRange');
              if (typeof data === 'string') {
                // image url
                // If onImageLinkInsert set,
                if (_this.options.callbacks.onImageLinkInsert) {
                  _this.context.triggerEvent('image.link.insert', data);
                } else {
                  _this.context.invoke('editor.insertImage', data);
                }
              } else {
                // array of files
                _this.context.invoke('editor.insertImagesOrCallback', data);
              }
            }).fail(function () {
              _this.context.invoke('editor.restoreRange');
            });
          }
          /**
           * show image dialog
           *
           * @param {jQuery} $dialog
           * @return {Promise}
           */
        }, {
          key: "showImageDialog",
          value: function showImageDialog() {
            var _this2 = this;
            return external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.Deferred(function (deferred) {
              var $imageInput = _this2.$dialog.find('.note-image-input');
              var $imageUrl = _this2.$dialog.find('.note-image-url');
              var $imageBtn = _this2.$dialog.find('.note-image-btn');
              _this2.ui.onDialogShown(_this2.$dialog, function () {
                _this2.context.triggerEvent('dialog.shown'); // Cloning imageInput to clear element.

                $imageInput.replaceWith($imageInput.clone().on('change', function (event) {
                  deferred.resolve(event.target.files || event.target.value);
                }).val(''));
                $imageUrl.on('input paste propertychange', function () {
                  _this2.ui.toggleBtn($imageBtn, $imageUrl.val());
                }).val('');
                if (!env.isSupportTouch) {
                  $imageUrl.trigger('focus');
                }
                $imageBtn.click(function (event) {
                  event.preventDefault();
                  deferred.resolve($imageUrl.val());
                });
                _this2.bindEnterKey($imageUrl, $imageBtn);
              });
              _this2.ui.onDialogHidden(_this2.$dialog, function () {
                $imageInput.off();
                $imageUrl.off();
                $imageBtn.off();
                if (deferred.state() === 'pending') {
                  deferred.reject();
                }
              });
              _this2.ui.showDialog(_this2.$dialog);
            });
          }
        }]);
        return ImageDialog;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/ImagePopover.js
      function ImagePopover_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function ImagePopover_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function ImagePopover_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) ImagePopover_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) ImagePopover_defineProperties(Constructor, staticProps);
        return Constructor;
      }

      /**
       * Image popover module
       *  mouse events that show/hide popover will be handled by Handle.js.
       *  Handle.js will receive the events and invoke 'imagePopover.update'.
       */

      var ImagePopover_ImagePopover = /*#__PURE__*/function () {
        function ImagePopover(context) {
          var _this = this;
          ImagePopover_classCallCheck(this, ImagePopover);
          this.context = context;
          this.ui = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote.ui;
          this.editable = context.layoutInfo.editable[0];
          this.options = context.options;
          this.events = {
            'summernote.disable summernote.blur': function summernoteDisableSummernoteBlur() {
              _this.hide();
            }
          };
        }
        ImagePopover_createClass(ImagePopover, [{
          key: "shouldInitialize",
          value: function shouldInitialize() {
            return !lists.isEmpty(this.options.popover.image);
          }
        }, {
          key: "initialize",
          value: function initialize() {
            this.$popover = this.ui.popover({
              className: 'note-image-popover'
            }).render().appendTo(this.options.container);
            var $content = this.$popover.find('.popover-content,.note-popover-content');
            this.context.invoke('buttons.build', $content, this.options.popover.image);
            this.$popover.on('mousedown', function (e) {
              e.preventDefault();
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.$popover.remove();
          }
        }, {
          key: "update",
          value: function update(target, event) {
            if (dom.isImg(target)) {
              var position = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(target).offset();
              var containerOffset = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(this.options.container).offset();
              var pos = {};
              if (this.options.popatmouse) {
                pos.left = event.pageX - 20;
                pos.top = event.pageY;
              } else {
                pos = position;
              }
              pos.top -= containerOffset.top;
              pos.left -= containerOffset.left;
              this.$popover.css({
                display: 'block',
                left: pos.left,
                top: pos.top
              });
            } else {
              this.hide();
            }
          }
        }, {
          key: "hide",
          value: function hide() {
            this.$popover.hide();
          }
        }]);
        return ImagePopover;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/TablePopover.js
      function TablePopover_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function TablePopover_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function TablePopover_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) TablePopover_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) TablePopover_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var TablePopover_TablePopover = /*#__PURE__*/function () {
        function TablePopover(context) {
          var _this = this;
          TablePopover_classCallCheck(this, TablePopover);
          this.context = context;
          this.ui = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote.ui;
          this.options = context.options;
          this.events = {
            'summernote.mousedown': function summernoteMousedown(we, e) {
              _this.update(e.target);
            },
            'summernote.keyup summernote.scroll summernote.change': function summernoteKeyupSummernoteScrollSummernoteChange() {
              _this.update();
            },
            'summernote.disable summernote.blur': function summernoteDisableSummernoteBlur() {
              _this.hide();
            }
          };
        }
        TablePopover_createClass(TablePopover, [{
          key: "shouldInitialize",
          value: function shouldInitialize() {
            return !lists.isEmpty(this.options.popover.table);
          }
        }, {
          key: "initialize",
          value: function initialize() {
            this.$popover = this.ui.popover({
              className: 'note-table-popover'
            }).render().appendTo(this.options.container);
            var $content = this.$popover.find('.popover-content,.note-popover-content');
            this.context.invoke('buttons.build', $content, this.options.popover.table); // [workaround] Disable Firefox's default table editor

            if (env.isFF) {
              document.execCommand('enableInlineTableEditing', false, false);
            }
            this.$popover.on('mousedown', function (e) {
              e.preventDefault();
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.$popover.remove();
          }
        }, {
          key: "update",
          value: function update(target) {
            if (this.context.isDisabled()) {
              return false;
            }
            var isCell = dom.isCell(target);
            if (isCell) {
              var pos = dom.posFromPlaceholder(target);
              var containerOffset = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(this.options.container).offset();
              pos.top -= containerOffset.top;
              pos.left -= containerOffset.left;
              this.$popover.css({
                display: 'block',
                left: pos.left,
                top: pos.top
              });
            } else {
              this.hide();
            }
            return isCell;
          }
        }, {
          key: "hide",
          value: function hide() {
            this.$popover.hide();
          }
        }]);
        return TablePopover;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/VideoDialog.js
      function VideoDialog_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function VideoDialog_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function VideoDialog_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) VideoDialog_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) VideoDialog_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var VideoDialog_VideoDialog = /*#__PURE__*/function () {
        function VideoDialog(context) {
          VideoDialog_classCallCheck(this, VideoDialog);
          this.context = context;
          this.ui = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote.ui;
          this.$body = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(document.body);
          this.$editor = context.layoutInfo.editor;
          this.options = context.options;
          this.lang = this.options.langInfo;
        }
        VideoDialog_createClass(VideoDialog, [{
          key: "initialize",
          value: function initialize() {
            var $container = this.options.dialogsInBody ? this.$body : this.options.container;
            var body = ['<div class="form-group note-form-group row-fluid">', "<label for=\"note-dialog-video-url-".concat(this.options.id, "\" class=\"note-form-label\">").concat(this.lang.video.url, " <small class=\"text-muted\">").concat(this.lang.video.providers, "</small></label>"), "<input id=\"note-dialog-video-url-".concat(this.options.id, "\" class=\"note-video-url form-control note-form-control note-input\" type=\"text\"/>"), '</div>'].join('');
            var buttonClass = 'btn btn-primary note-btn note-btn-primary note-video-btn';
            var footer = "<input type=\"button\" href=\"#\" class=\"".concat(buttonClass, "\" value=\"").concat(this.lang.video.insert, "\" disabled>");
            this.$dialog = this.ui.dialog({
              title: this.lang.video.insert,
              fade: this.options.dialogsFade,
              body: body,
              footer: footer
            }).render().appendTo($container);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.ui.hideDialog(this.$dialog);
            this.$dialog.remove();
          }
        }, {
          key: "bindEnterKey",
          value: function bindEnterKey($input, $btn) {
            $input.on('keypress', function (event) {
              if (event.keyCode === core_key.code.ENTER) {
                event.preventDefault();
                $btn.trigger('click');
              }
            });
          }
        }, {
          key: "createVideoNode",
          value: function createVideoNode(url) {
            // video url patterns(youtube, instagram, vimeo, dailymotion, youku, mp4, ogg, webm)
            var ytRegExp = /\/\/(?:(?:www|m)\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w|-]{11})(?:(?:[\?&]t=)(\S+))?$/;
            var ytRegExpForStart = /^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/;
            var ytMatch = url.match(ytRegExp);
            var igRegExp = /(?:www\.|\/\/)instagram\.com\/p\/(.[a-zA-Z0-9_-]*)/;
            var igMatch = url.match(igRegExp);
            var vRegExp = /\/\/vine\.co\/v\/([a-zA-Z0-9]+)/;
            var vMatch = url.match(vRegExp);
            var vimRegExp = /\/\/(player\.)?vimeo\.com\/([a-z]*\/)*(\d+)[?]?.*/;
            var vimMatch = url.match(vimRegExp);
            var dmRegExp = /.+dailymotion.com\/(video|hub)\/([^_]+)[^#]*(#video=([^_&]+))?/;
            var dmMatch = url.match(dmRegExp);
            var youkuRegExp = /\/\/v\.youku\.com\/v_show\/id_(\w+)=*\.html/;
            var youkuMatch = url.match(youkuRegExp);
            var qqRegExp = /\/\/v\.qq\.com.*?vid=(.+)/;
            var qqMatch = url.match(qqRegExp);
            var qqRegExp2 = /\/\/v\.qq\.com\/x?\/?(page|cover).*?\/([^\/]+)\.html\??.*/;
            var qqMatch2 = url.match(qqRegExp2);
            var mp4RegExp = /^.+.(mp4|m4v)$/;
            var mp4Match = url.match(mp4RegExp);
            var oggRegExp = /^.+.(ogg|ogv)$/;
            var oggMatch = url.match(oggRegExp);
            var webmRegExp = /^.+.(webm)$/;
            var webmMatch = url.match(webmRegExp);
            var fbRegExp = /(?:www\.|\/\/)facebook\.com\/([^\/]+)\/videos\/([0-9]+)/;
            var fbMatch = url.match(fbRegExp);
            var $video;
            if (ytMatch && ytMatch[1].length === 11) {
              var youtubeId = ytMatch[1];
              var start = 0;
              if (typeof ytMatch[2] !== 'undefined') {
                var ytMatchForStart = ytMatch[2].match(ytRegExpForStart);
                if (ytMatchForStart) {
                  for (var n = [3600, 60, 1], i = 0, r = n.length; i < r; i++) {
                    start += typeof ytMatchForStart[i + 1] !== 'undefined' ? n[i] * parseInt(ytMatchForStart[i + 1], 10) : 0;
                  }
                }
              }
              $video = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<iframe>').attr('frameborder', 0).attr('src', '//www.youtube.com/embed/' + youtubeId + (start > 0 ? '?start=' + start : '')).attr('width', '640').attr('height', '360');
            } else if (igMatch && igMatch[0].length) {
              $video = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<iframe>').attr('frameborder', 0).attr('src', 'https://instagram.com/p/' + igMatch[1] + '/embed/').attr('width', '612').attr('height', '710').attr('scrolling', 'no').attr('allowtransparency', 'true');
            } else if (vMatch && vMatch[0].length) {
              $video = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<iframe>').attr('frameborder', 0).attr('src', vMatch[0] + '/embed/simple').attr('width', '600').attr('height', '600').attr('class', 'vine-embed');
            } else if (vimMatch && vimMatch[3].length) {
              $video = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<iframe webkitallowfullscreen mozallowfullscreen allowfullscreen>').attr('frameborder', 0).attr('src', '//player.vimeo.com/video/' + vimMatch[3]).attr('width', '640').attr('height', '360');
            } else if (dmMatch && dmMatch[2].length) {
              $video = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<iframe>').attr('frameborder', 0).attr('src', '//www.dailymotion.com/embed/video/' + dmMatch[2]).attr('width', '640').attr('height', '360');
            } else if (youkuMatch && youkuMatch[1].length) {
              $video = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<iframe webkitallowfullscreen mozallowfullscreen allowfullscreen>').attr('frameborder', 0).attr('height', '498').attr('width', '510').attr('src', '//player.youku.com/embed/' + youkuMatch[1]);
            } else if (qqMatch && qqMatch[1].length || qqMatch2 && qqMatch2[2].length) {
              var vid = qqMatch && qqMatch[1].length ? qqMatch[1] : qqMatch2[2];
              $video = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<iframe webkitallowfullscreen mozallowfullscreen allowfullscreen>').attr('frameborder', 0).attr('height', '310').attr('width', '500').attr('src', 'https://v.qq.com/txp/iframe/player.html?vid=' + vid + '&amp;auto=0');
            } else if (mp4Match || oggMatch || webmMatch) {
              $video = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<video controls>').attr('src', url).attr('width', '640').attr('height', '360');
            } else if (fbMatch && fbMatch[0].length) {
              $video = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<iframe>').attr('frameborder', 0).attr('src', 'https://www.facebook.com/plugins/video.php?href=' + encodeURIComponent(fbMatch[0]) + '&show_text=0&width=560').attr('width', '560').attr('height', '301').attr('scrolling', 'no').attr('allowtransparency', 'true');
            } else {
              // this is not a known video link. Now what, Cat? Now what?
              return false;
            }
            $video.addClass('note-video-clip');
            return $video[0];
          }
        }, {
          key: "show",
          value: function show() {
            var _this = this;
            var text = this.context.invoke('editor.getSelectedText');
            this.context.invoke('editor.saveRange');
            this.showVideoDialog(text).then(function (url) {
              // [workaround] hide dialog before restore range for IE range focus
              _this.ui.hideDialog(_this.$dialog);
              _this.context.invoke('editor.restoreRange'); // build node

              var $node = _this.createVideoNode(url);
              if ($node) {
                // insert video node
                _this.context.invoke('editor.insertNode', $node);
              }
            }).fail(function () {
              _this.context.invoke('editor.restoreRange');
            });
          }
          /**
           * show video dialog
           *
           * @param {jQuery} $dialog
           * @return {Promise}
           */
        }, {
          key: "showVideoDialog",
          value: function showVideoDialog() /* text */
          {
            var _this2 = this;
            return external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.Deferred(function (deferred) {
              var $videoUrl = _this2.$dialog.find('.note-video-url');
              var $videoBtn = _this2.$dialog.find('.note-video-btn');
              _this2.ui.onDialogShown(_this2.$dialog, function () {
                _this2.context.triggerEvent('dialog.shown');
                $videoUrl.on('input paste propertychange', function () {
                  _this2.ui.toggleBtn($videoBtn, $videoUrl.val());
                });
                if (!env.isSupportTouch) {
                  $videoUrl.trigger('focus');
                }
                $videoBtn.click(function (event) {
                  event.preventDefault();
                  deferred.resolve($videoUrl.val());
                });
                _this2.bindEnterKey($videoUrl, $videoBtn);
              });
              _this2.ui.onDialogHidden(_this2.$dialog, function () {
                $videoUrl.off();
                $videoBtn.off();
                if (deferred.state() === 'pending') {
                  deferred.reject();
                }
              });
              _this2.ui.showDialog(_this2.$dialog);
            });
          }
        }]);
        return VideoDialog;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/HelpDialog.js
      function HelpDialog_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function HelpDialog_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function HelpDialog_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) HelpDialog_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) HelpDialog_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var HelpDialog_HelpDialog = /*#__PURE__*/function () {
        function HelpDialog(context) {
          HelpDialog_classCallCheck(this, HelpDialog);
          this.context = context;
          this.ui = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote.ui;
          this.$body = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(document.body);
          this.$editor = context.layoutInfo.editor;
          this.options = context.options;
          this.lang = this.options.langInfo;
        }
        HelpDialog_createClass(HelpDialog, [{
          key: "initialize",
          value: function initialize() {
            var $container = this.options.dialogsInBody ? this.$body : this.options.container;
            var body = ['<p class="text-center">', '<a href="http://summernote.org/" target="_blank">Summernote 0.8.18</a> · ', '<a href="https://github.com/summernote/summernote" target="_blank">Project</a> · ', '<a href="https://github.com/summernote/summernote/issues" target="_blank">Issues</a>', '</p>'].join('');
            this.$dialog = this.ui.dialog({
              title: this.lang.options.help,
              fade: this.options.dialogsFade,
              body: this.createShortcutList(),
              footer: body,
              callback: function callback($node) {
                $node.find('.modal-body,.note-modal-body').css({
                  'max-height': 300,
                  'overflow': 'scroll'
                });
              }
            }).render().appendTo($container);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.ui.hideDialog(this.$dialog);
            this.$dialog.remove();
          }
        }, {
          key: "createShortcutList",
          value: function createShortcutList() {
            var _this = this;
            var keyMap = this.options.keyMap[env.isMac ? 'mac' : 'pc'];
            return Object.keys(keyMap).map(function (key) {
              var command = keyMap[key];
              var $row = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<div><div class="help-list-item"></div></div>');
              $row.append(external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<label><kbd>' + key + '</kdb></label>').css({
                'width': 180,
                'margin-right': 10
              })).append(external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<span/>').html(_this.context.memo('help.' + command) || command));
              return $row.html();
            }).join('');
          }
          /**
           * show help dialog
           *
           * @return {Promise}
           */
        }, {
          key: "showHelpDialog",
          value: function showHelpDialog() {
            var _this2 = this;
            return external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.Deferred(function (deferred) {
              _this2.ui.onDialogShown(_this2.$dialog, function () {
                _this2.context.triggerEvent('dialog.shown');
                deferred.resolve();
              });
              _this2.ui.showDialog(_this2.$dialog);
            }).promise();
          }
        }, {
          key: "show",
          value: function show() {
            var _this3 = this;
            this.context.invoke('editor.saveRange');
            this.showHelpDialog().then(function () {
              _this3.context.invoke('editor.restoreRange');
            });
          }
        }]);
        return HelpDialog;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/AirPopover.js
      function AirPopover_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function AirPopover_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function AirPopover_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) AirPopover_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) AirPopover_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var AIRMODE_POPOVER_X_OFFSET = -5;
      var AIRMODE_POPOVER_Y_OFFSET = 5;
      var AirPopover_AirPopover = /*#__PURE__*/function () {
        function AirPopover(context) {
          var _this = this;
          AirPopover_classCallCheck(this, AirPopover);
          this.context = context;
          this.ui = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote.ui;
          this.options = context.options;
          this.hidable = true;
          this.onContextmenu = false;
          this.pageX = null;
          this.pageY = null;
          this.events = {
            'summernote.contextmenu': function summernoteContextmenu(e) {
              if (_this.options.editing) {
                e.preventDefault();
                e.stopPropagation();
                _this.onContextmenu = true;
                _this.update(true);
              }
            },
            'summernote.mousedown': function summernoteMousedown(we, e) {
              _this.pageX = e.pageX;
              _this.pageY = e.pageY;
            },
            'summernote.keyup summernote.mouseup summernote.scroll': function summernoteKeyupSummernoteMouseupSummernoteScroll(we, e) {
              if (_this.options.editing && !_this.onContextmenu) {
                _this.pageX = e.pageX;
                _this.pageY = e.pageY;
                _this.update();
              }
              _this.onContextmenu = false;
            },
            'summernote.disable summernote.change summernote.dialog.shown summernote.blur': function summernoteDisableSummernoteChangeSummernoteDialogShownSummernoteBlur() {
              _this.hide();
            },
            'summernote.focusout': function summernoteFocusout() {
              if (!_this.$popover.is(':active,:focus')) {
                _this.hide();
              }
            }
          };
        }
        AirPopover_createClass(AirPopover, [{
          key: "shouldInitialize",
          value: function shouldInitialize() {
            return this.options.airMode && !lists.isEmpty(this.options.popover.air);
          }
        }, {
          key: "initialize",
          value: function initialize() {
            var _this2 = this;
            this.$popover = this.ui.popover({
              className: 'note-air-popover'
            }).render().appendTo(this.options.container);
            var $content = this.$popover.find('.popover-content');
            this.context.invoke('buttons.build', $content, this.options.popover.air); // disable hiding this popover preemptively by 'summernote.blur' event.

            this.$popover.on('mousedown', function () {
              _this2.hidable = false;
            }); // (re-)enable hiding after 'summernote.blur' has been handled (aka. ignored).

            this.$popover.on('mouseup', function () {
              _this2.hidable = true;
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.$popover.remove();
          }
        }, {
          key: "update",
          value: function update(forcelyOpen) {
            var styleInfo = this.context.invoke('editor.currentStyle');
            if (styleInfo.range && (!styleInfo.range.isCollapsed() || forcelyOpen)) {
              var rect = {
                left: this.pageX,
                top: this.pageY
              };
              var containerOffset = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(this.options.container).offset();
              rect.top -= containerOffset.top;
              rect.left -= containerOffset.left;
              this.$popover.css({
                display: 'block',
                left: Math.max(rect.left, 0) + AIRMODE_POPOVER_X_OFFSET,
                top: rect.top + AIRMODE_POPOVER_Y_OFFSET
              });
              this.context.invoke('buttons.updateCurrentStyle', this.$popover);
            } else {
              this.hide();
            }
          }
        }, {
          key: "updateCodeview",
          value: function updateCodeview(isCodeview) {
            this.ui.toggleBtnActive(this.$popover.find('.btn-codeview'), isCodeview);
            if (isCodeview) {
              this.hide();
            }
          }
        }, {
          key: "hide",
          value: function hide() {
            if (this.hidable) {
              this.$popover.hide();
            }
          }
        }]);
        return AirPopover;
      }();

      // CONCATENATED MODULE: ./src/js/base/module/HintPopover.js
      function HintPopover_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function HintPopover_defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function HintPopover_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) HintPopover_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) HintPopover_defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var POPOVER_DIST = 5;
      var HintPopover_HintPopover = /*#__PURE__*/function () {
        function HintPopover(context) {
          var _this = this;
          HintPopover_classCallCheck(this, HintPopover);
          this.context = context;
          this.ui = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote.ui;
          this.$editable = context.layoutInfo.editable;
          this.options = context.options;
          this.hint = this.options.hint || [];
          this.direction = this.options.hintDirection || 'bottom';
          this.hints = Array.isArray(this.hint) ? this.hint : [this.hint];
          this.events = {
            'summernote.keyup': function summernoteKeyup(we, e) {
              if (!e.isDefaultPrevented()) {
                _this.handleKeyup(e);
              }
            },
            'summernote.keydown': function summernoteKeydown(we, e) {
              _this.handleKeydown(e);
            },
            'summernote.disable summernote.dialog.shown summernote.blur': function summernoteDisableSummernoteDialogShownSummernoteBlur() {
              _this.hide();
            }
          };
        }
        HintPopover_createClass(HintPopover, [{
          key: "shouldInitialize",
          value: function shouldInitialize() {
            return this.hints.length > 0;
          }
        }, {
          key: "initialize",
          value: function initialize() {
            var _this2 = this;
            this.lastWordRange = null;
            this.matchingWord = null;
            this.$popover = this.ui.popover({
              className: 'note-hint-popover',
              hideArrow: true,
              direction: ''
            }).render().appendTo(this.options.container);
            this.$popover.hide();
            this.$content = this.$popover.find('.popover-content,.note-popover-content');
            this.$content.on('click', '.note-hint-item', function (e) {
              _this2.$content.find('.active').removeClass('active');
              external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(e.currentTarget).addClass('active');
              _this2.replace();
            });
            this.$popover.on('mousedown', function (e) {
              e.preventDefault();
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.$popover.remove();
          }
        }, {
          key: "selectItem",
          value: function selectItem($item) {
            this.$content.find('.active').removeClass('active');
            $item.addClass('active');
            this.$content[0].scrollTop = $item[0].offsetTop - this.$content.innerHeight() / 2;
          }
        }, {
          key: "moveDown",
          value: function moveDown() {
            var $current = this.$content.find('.note-hint-item.active');
            var $next = $current.next();
            if ($next.length) {
              this.selectItem($next);
            } else {
              var $nextGroup = $current.parent().next();
              if (!$nextGroup.length) {
                $nextGroup = this.$content.find('.note-hint-group').first();
              }
              this.selectItem($nextGroup.find('.note-hint-item').first());
            }
          }
        }, {
          key: "moveUp",
          value: function moveUp() {
            var $current = this.$content.find('.note-hint-item.active');
            var $prev = $current.prev();
            if ($prev.length) {
              this.selectItem($prev);
            } else {
              var $prevGroup = $current.parent().prev();
              if (!$prevGroup.length) {
                $prevGroup = this.$content.find('.note-hint-group').last();
              }
              this.selectItem($prevGroup.find('.note-hint-item').last());
            }
          }
        }, {
          key: "replace",
          value: function replace() {
            var $item = this.$content.find('.note-hint-item.active');
            if ($item.length) {
              var node = this.nodeFromItem($item); // If matchingWord length = 0 -> capture OK / open hint / but as mention capture "" (\w*)

              if (this.matchingWord !== null && this.matchingWord.length === 0) {
                this.lastWordRange.so = this.lastWordRange.eo; // Else si > 0 and normal case -> adjust range "before" for correct position of insertion
              } else if (this.matchingWord !== null && this.matchingWord.length > 0 && !this.lastWordRange.isCollapsed()) {
                var rangeCompute = this.lastWordRange.eo - this.lastWordRange.so - this.matchingWord.length;
                if (rangeCompute > 0) {
                  this.lastWordRange.so += rangeCompute;
                }
              }
              this.lastWordRange.insertNode(node);
              if (this.options.hintSelect === 'next') {
                var blank = document.createTextNode('');
                external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(node).after(blank);
                range.createFromNodeBefore(blank).select();
              } else {
                range.createFromNodeAfter(node).select();
              }
              this.lastWordRange = null;
              this.hide();
              this.context.invoke('editor.focus');
            }
          }
        }, {
          key: "nodeFromItem",
          value: function nodeFromItem($item) {
            var hint = this.hints[$item.data('index')];
            var item = $item.data('item');
            var node = hint.content ? hint.content(item) : item;
            if (typeof node === 'string') {
              node = dom.createText(node);
            }
            return node;
          }
        }, {
          key: "createItemTemplates",
          value: function createItemTemplates(hintIdx, items) {
            var hint = this.hints[hintIdx];
            return items.map(function (item
            /*, idx */) {
              var $item = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<div class="note-hint-item"/>');
              $item.append(hint.template ? hint.template(item) : item + '');
              $item.data({
                'index': hintIdx,
                'item': item
              });
              return $item;
            });
          }
        }, {
          key: "handleKeydown",
          value: function handleKeydown(e) {
            if (!this.$popover.is(':visible')) {
              return;
            }
            if (e.keyCode === core_key.code.ENTER) {
              e.preventDefault();
              this.replace();
            } else if (e.keyCode === core_key.code.UP) {
              e.preventDefault();
              this.moveUp();
            } else if (e.keyCode === core_key.code.DOWN) {
              e.preventDefault();
              this.moveDown();
            }
          }
        }, {
          key: "searchKeyword",
          value: function searchKeyword(index, keyword, callback) {
            var hint = this.hints[index];
            if (hint && hint.match.test(keyword) && hint.search) {
              var matches = hint.match.exec(keyword);
              this.matchingWord = matches[0];
              hint.search(matches[1], callback);
            } else {
              callback();
            }
          }
        }, {
          key: "createGroup",
          value: function createGroup(idx, keyword) {
            var _this3 = this;
            var $group = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()('<div class="note-hint-group note-hint-group-' + idx + '"></div>');
            this.searchKeyword(idx, keyword, function (items) {
              items = items || [];
              if (items.length) {
                $group.html(_this3.createItemTemplates(idx, items));
                _this3.show();
              }
            });
            return $group;
          }
        }, {
          key: "handleKeyup",
          value: function handleKeyup(e) {
            var _this4 = this;
            if (!lists.contains([core_key.code.ENTER, core_key.code.UP, core_key.code.DOWN], e.keyCode)) {
              var _range = this.context.invoke('editor.getLastRange');
              var wordRange, keyword;
              if (this.options.hintMode === 'words') {
                wordRange = _range.getWordsRange(_range);
                keyword = wordRange.toString();
                this.hints.forEach(function (hint) {
                  if (hint.match.test(keyword)) {
                    wordRange = _range.getWordsMatchRange(hint.match);
                    return false;
                  }
                });
                if (!wordRange) {
                  this.hide();
                  return;
                }
                keyword = wordRange.toString();
              } else {
                wordRange = _range.getWordRange();
                keyword = wordRange.toString();
              }
              if (this.hints.length && keyword) {
                this.$content.empty();
                var bnd = func.rect2bnd(lists.last(wordRange.getClientRects()));
                var containerOffset = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(this.options.container).offset();
                if (bnd) {
                  bnd.top -= containerOffset.top;
                  bnd.left -= containerOffset.left;
                  this.$popover.hide();
                  this.lastWordRange = wordRange;
                  this.hints.forEach(function (hint, idx) {
                    if (hint.match.test(keyword)) {
                      _this4.createGroup(idx, keyword).appendTo(_this4.$content);
                    }
                  }); // select first .note-hint-item

                  this.$content.find('.note-hint-item:first').addClass('active'); // set position for popover after group is created

                  if (this.direction === 'top') {
                    this.$popover.css({
                      left: bnd.left,
                      top: bnd.top - this.$popover.outerHeight() - POPOVER_DIST
                    });
                  } else {
                    this.$popover.css({
                      left: bnd.left,
                      top: bnd.top + bnd.height + POPOVER_DIST
                    });
                  }
                }
              } else {
                this.hide();
              }
            }
          }
        }, {
          key: "show",
          value: function show() {
            this.$popover.show();
          }
        }, {
          key: "hide",
          value: function hide() {
            this.$popover.hide();
          }
        }]);
        return HintPopover;
      }();

      // CONCATENATED MODULE: ./src/js/base/settings.js

      external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.extend(external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote, {
        version: '0.8.18',
        plugins: {},
        dom: dom,
        range: range,
        lists: lists,
        options: {
          langInfo: external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote.lang['en-US'],
          editing: true,
          modules: {
            'editor': Editor_Editor,
            'clipboard': Clipboard_Clipboard,
            'dropzone': Dropzone_Dropzone,
            'codeview': Codeview_CodeView,
            'statusbar': Statusbar_Statusbar,
            'fullscreen': Fullscreen_Fullscreen,
            'handle': Handle_Handle,
            // FIXME: HintPopover must be front of autolink
            //  - Script error about range when Enter key is pressed on hint popover
            'hintPopover': HintPopover_HintPopover,
            'autoLink': AutoLink_AutoLink,
            'autoSync': AutoSync_AutoSync,
            'autoReplace': AutoReplace_AutoReplace,
            'placeholder': Placeholder_Placeholder,
            'buttons': Buttons_Buttons,
            'toolbar': Toolbar_Toolbar,
            'linkDialog': LinkDialog_LinkDialog,
            'linkPopover': LinkPopover_LinkPopover,
            'imageDialog': ImageDialog_ImageDialog,
            'imagePopover': ImagePopover_ImagePopover,
            'tablePopover': TablePopover_TablePopover,
            'videoDialog': VideoDialog_VideoDialog,
            'helpDialog': HelpDialog_HelpDialog,
            'airPopover': AirPopover_AirPopover
          },
          buttons: {},
          lang: 'en-US',
          followingToolbar: false,
          toolbarPosition: 'top',
          otherStaticBar: '',
          // toolbar
          codeviewKeepButton: false,
          toolbar: [['style', ['style']], ['font', ['bold', 'underline', 'clear']], ['fontname', ['fontname']], ['color', ['color']], ['para', ['ul', 'ol', 'paragraph']], ['table', ['table']], ['insert', ['link', 'picture', 'video']], ['view', ['fullscreen', 'codeview', 'help']]],
          // popover
          popatmouse: true,
          popover: {
            image: [['resize', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']], ['float', ['floatLeft', 'floatRight', 'floatNone']], ['remove', ['removeMedia']]],
            link: [['link', ['linkDialogShow', 'unlink']]],
            table: [['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']], ['delete', ['deleteRow', 'deleteCol', 'deleteTable']]],
            air: [['color', ['color']], ['font', ['bold', 'underline', 'clear']], ['para', ['ul', 'paragraph']], ['table', ['table']], ['insert', ['link', 'picture']], ['view', ['fullscreen', 'codeview']]]
          },
          // air mode: inline editor
          airMode: false,
          overrideContextMenu: false,
          // TBD
          width: null,
          height: null,
          linkTargetBlank: true,
          useProtocol: true,
          defaultProtocol: 'http://',
          focus: false,
          tabDisabled: false,
          tabSize: 4,
          styleWithCSS: false,
          shortcuts: true,
          textareaAutoSync: true,
          tooltip: 'auto',
          container: null,
          maxTextLength: 0,
          blockquoteBreakingLevel: 2,
          spellCheck: true,
          disableGrammar: false,
          placeholder: null,
          inheritPlaceholder: false,
          // TODO: need to be documented
          recordEveryKeystroke: false,
          historyLimit: 200,
          // TODO: need to be documented
          showDomainOnlyForAutolink: false,
          // TODO: need to be documented
          hintMode: 'word',
          hintSelect: 'after',
          hintDirection: 'bottom',
          styleTags: ['p', 'blockquote', 'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
          fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Helvetica Neue', 'Helvetica', 'Impact', 'Lucida Grande', 'Tahoma', 'Times New Roman', 'Verdana'],
          fontNamesIgnoreCheck: [],
          addDefaultFonts: true,
          fontSizes: ['8', '9', '10', '11', '12', '14', '18', '24', '36'],
          fontSizeUnits: ['px', 'pt'],
          // pallete colors(n x n)
          colors: [['#000000', '#424242', '#636363', '#9C9C94', '#CEC6CE', '#EFEFEF', '#F7F7F7', '#FFFFFF'], ['#FF0000', '#FF9C00', '#FFFF00', '#00FF00', '#00FFFF', '#0000FF', '#9C00FF', '#FF00FF'], ['#F7C6CE', '#FFE7CE', '#FFEFC6', '#D6EFD6', '#CEDEE7', '#CEE7F7', '#D6D6E7', '#E7D6DE'], ['#E79C9C', '#FFC69C', '#FFE79C', '#B5D6A5', '#A5C6CE', '#9CC6EF', '#B5A5D6', '#D6A5BD'], ['#E76363', '#F7AD6B', '#FFD663', '#94BD7B', '#73A5AD', '#6BADDE', '#8C7BC6', '#C67BA5'], ['#CE0000', '#E79439', '#EFC631', '#6BA54A', '#4A7B8C', '#3984C6', '#634AA5', '#A54A7B'], ['#9C0000', '#B56308', '#BD9400', '#397B21', '#104A5A', '#085294', '#311873', '#731842'], ['#630000', '#7B3900', '#846300', '#295218', '#083139', '#003163', '#21104A', '#4A1031']],
          // http://chir.ag/projects/name-that-color/
          colorsName: [['Black', 'Tundora', 'Dove Gray', 'Star Dust', 'Pale Slate', 'Gallery', 'Alabaster', 'White'], ['Red', 'Orange Peel', 'Yellow', 'Green', 'Cyan', 'Blue', 'Electric Violet', 'Magenta'], ['Azalea', 'Karry', 'Egg White', 'Zanah', 'Botticelli', 'Tropical Blue', 'Mischka', 'Twilight'], ['Tonys Pink', 'Peach Orange', 'Cream Brulee', 'Sprout', 'Casper', 'Perano', 'Cold Purple', 'Careys Pink'], ['Mandy', 'Rajah', 'Dandelion', 'Olivine', 'Gulf Stream', 'Viking', 'Blue Marguerite', 'Puce'], ['Guardsman Red', 'Fire Bush', 'Golden Dream', 'Chelsea Cucumber', 'Smalt Blue', 'Boston Blue', 'Butterfly Bush', 'Cadillac'], ['Sangria', 'Mai Tai', 'Buddha Gold', 'Forest Green', 'Eden', 'Venice Blue', 'Meteorite', 'Claret'], ['Rosewood', 'Cinnamon', 'Olive', 'Parsley', 'Tiber', 'Midnight Blue', 'Valentino', 'Loulou']],
          colorButton: {
            foreColor: '#000000',
            backColor: '#FFFF00'
          },
          lineHeights: ['1.0', '1.2', '1.4', '1.5', '1.6', '1.8', '2.0', '3.0'],
          tableClassName: 'table table-bordered',
          insertTableMaxSize: {
            col: 10,
            row: 10
          },
          // By default, dialogs are attached in container.
          dialogsInBody: false,
          dialogsFade: false,
          maximumImageFileSize: null,
          callbacks: {
            onBeforeCommand: null,
            onBlur: null,
            onBlurCodeview: null,
            onChange: null,
            onChangeCodeview: null,
            onDialogShown: null,
            onEnter: null,
            onFocus: null,
            onImageLinkInsert: null,
            onImageUpload: null,
            onImageUploadError: null,
            onInit: null,
            onKeydown: null,
            onKeyup: null,
            onMousedown: null,
            onMouseup: null,
            onPaste: null,
            onScroll: null
          },
          codemirror: {
            mode: 'text/html',
            htmlMode: true,
            lineNumbers: true
          },
          codeviewFilter: false,
          codeviewFilterRegex: /<\/*(?:applet|b(?:ase|gsound|link)|embed|frame(?:set)?|ilayer|l(?:ayer|ink)|meta|object|s(?:cript|tyle)|t(?:itle|extarea)|xml)[^>]*?>/gi,
          codeviewIframeFilter: true,
          codeviewIframeWhitelistSrc: [],
          codeviewIframeWhitelistSrcBase: ['www.youtube.com', 'www.youtube-nocookie.com', 'www.facebook.com', 'vine.co', 'instagram.com', 'player.vimeo.com', 'www.dailymotion.com', 'player.youku.com', 'v.qq.com'],
          keyMap: {
            pc: {
              'ESC': 'escape',
              'ENTER': 'insertParagraph',
              'CTRL+Z': 'undo',
              'CTRL+Y': 'redo',
              'TAB': 'tab',
              'SHIFT+TAB': 'untab',
              'CTRL+B': 'bold',
              'CTRL+I': 'italic',
              'CTRL+U': 'underline',
              'CTRL+SHIFT+S': 'strikethrough',
              'CTRL+BACKSLASH': 'removeFormat',
              'CTRL+SHIFT+L': 'justifyLeft',
              'CTRL+SHIFT+E': 'justifyCenter',
              'CTRL+SHIFT+R': 'justifyRight',
              'CTRL+SHIFT+J': 'justifyFull',
              'CTRL+SHIFT+NUM7': 'insertUnorderedList',
              'CTRL+SHIFT+NUM8': 'insertOrderedList',
              'CTRL+LEFTBRACKET': 'outdent',
              'CTRL+RIGHTBRACKET': 'indent',
              'CTRL+NUM0': 'formatPara',
              'CTRL+NUM1': 'formatH1',
              'CTRL+NUM2': 'formatH2',
              'CTRL+NUM3': 'formatH3',
              'CTRL+NUM4': 'formatH4',
              'CTRL+NUM5': 'formatH5',
              'CTRL+NUM6': 'formatH6',
              'CTRL+ENTER': 'insertHorizontalRule',
              'CTRL+K': 'linkDialog.show'
            },
            mac: {
              'ESC': 'escape',
              'ENTER': 'insertParagraph',
              'CMD+Z': 'undo',
              'CMD+SHIFT+Z': 'redo',
              'TAB': 'tab',
              'SHIFT+TAB': 'untab',
              'CMD+B': 'bold',
              'CMD+I': 'italic',
              'CMD+U': 'underline',
              'CMD+SHIFT+S': 'strikethrough',
              'CMD+BACKSLASH': 'removeFormat',
              'CMD+SHIFT+L': 'justifyLeft',
              'CMD+SHIFT+E': 'justifyCenter',
              'CMD+SHIFT+R': 'justifyRight',
              'CMD+SHIFT+J': 'justifyFull',
              'CMD+SHIFT+NUM7': 'insertUnorderedList',
              'CMD+SHIFT+NUM8': 'insertOrderedList',
              'CMD+LEFTBRACKET': 'outdent',
              'CMD+RIGHTBRACKET': 'indent',
              'CMD+NUM0': 'formatPara',
              'CMD+NUM1': 'formatH1',
              'CMD+NUM2': 'formatH2',
              'CMD+NUM3': 'formatH3',
              'CMD+NUM4': 'formatH4',
              'CMD+NUM5': 'formatH5',
              'CMD+NUM6': 'formatH6',
              'CMD+ENTER': 'insertHorizontalRule',
              'CMD+K': 'linkDialog.show'
            }
          },
          icons: {
            'align': 'note-icon-align',
            'alignCenter': 'note-icon-align-center',
            'alignJustify': 'note-icon-align-justify',
            'alignLeft': 'note-icon-align-left',
            'alignRight': 'note-icon-align-right',
            'rowBelow': 'note-icon-row-below',
            'colBefore': 'note-icon-col-before',
            'colAfter': 'note-icon-col-after',
            'rowAbove': 'note-icon-row-above',
            'rowRemove': 'note-icon-row-remove',
            'colRemove': 'note-icon-col-remove',
            'indent': 'note-icon-align-indent',
            'outdent': 'note-icon-align-outdent',
            'arrowsAlt': 'note-icon-arrows-alt',
            'bold': 'note-icon-bold',
            'caret': 'note-icon-caret',
            'circle': 'note-icon-circle',
            'close': 'note-icon-close',
            'code': 'note-icon-code',
            'eraser': 'note-icon-eraser',
            'floatLeft': 'note-icon-float-left',
            'floatRight': 'note-icon-float-right',
            'font': 'note-icon-font',
            'frame': 'note-icon-frame',
            'italic': 'note-icon-italic',
            'link': 'note-icon-link',
            'unlink': 'note-icon-chain-broken',
            'magic': 'note-icon-magic',
            'menuCheck': 'note-icon-menu-check',
            'minus': 'note-icon-minus',
            'orderedlist': 'note-icon-orderedlist',
            'pencil': 'note-icon-pencil',
            'picture': 'note-icon-picture',
            'question': 'note-icon-question',
            'redo': 'note-icon-redo',
            'rollback': 'note-icon-rollback',
            'square': 'note-icon-square',
            'strikethrough': 'note-icon-strikethrough',
            'subscript': 'note-icon-subscript',
            'superscript': 'note-icon-superscript',
            'table': 'note-icon-table',
            'textHeight': 'note-icon-text-height',
            'trash': 'note-icon-trash',
            'underline': 'note-icon-underline',
            'undo': 'note-icon-undo',
            'unorderedlist': 'note-icon-unorderedlist',
            'video': 'note-icon-video'
          }
        }
      });

      /***/
    }),
    /***/4: (/***/function _(module, exports, __webpack_require__) {

      // extracted by mini-css-extract-plugin

      /***/}),
    /***/52: (/***/function _(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      // ESM COMPAT FLAG
      __webpack_require__.r(__webpack_exports__);

      // EXTERNAL MODULE: external {"root":"jQuery","commonjs2":"jquery","commonjs":"jquery","amd":"jquery"}
      var external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_ = __webpack_require__(0);
      var external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default = /*#__PURE__*/__webpack_require__.n(external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_);

      // EXTERNAL MODULE: ./src/js/base/renderer.js
      var renderer = __webpack_require__(1);

      // CONCATENATED MODULE: ./src/js/bs3/ui.js
      function _typeof(obj) {
        "@babel/helpers - typeof";

        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof = function _typeof(obj) {
            return typeof obj;
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
        }
        return _typeof(obj);
      }
      var editor = renderer["a" /* default */].create('<div class="note-editor note-frame panel panel-default"/>');
      var toolbar = renderer["a" /* default */].create('<div class="panel-heading note-toolbar" role="toolbar"/>');
      var editingArea = renderer["a" /* default */].create('<div class="note-editing-area"/>');
      var codable = renderer["a" /* default */].create('<textarea class="note-codable" aria-multiline="true"/>');
      var editable = renderer["a" /* default */].create('<div class="note-editable" contentEditable="true" role="textbox" aria-multiline="true"/>');
      var statusbar = renderer["a" /* default */].create(['<output class="note-status-output" role="status" aria-live="polite"></output>', '<div class="note-statusbar" role="status">', '<div class="note-resizebar" aria-label="Resize">', '<div class="note-icon-bar"></div>', '<div class="note-icon-bar"></div>', '<div class="note-icon-bar"></div>', '</div>', '</div>'].join(''));
      var airEditor = renderer["a" /* default */].create('<div class="note-editor note-airframe"/>');
      var airEditable = renderer["a" /* default */].create(['<div class="note-editable" contentEditable="true" role="textbox" aria-multiline="true"></div>', '<output class="note-status-output" role="status" aria-live="polite"></output>'].join(''));
      var buttonGroup = renderer["a" /* default */].create('<div class="note-btn-group btn-group">');
      var dropdown = renderer["a" /* default */].create('<ul class="note-dropdown-menu dropdown-menu">', function ($node, options) {
        var markup = Array.isArray(options.items) ? options.items.map(function (item) {
          var value = typeof item === 'string' ? item : item.value || '';
          var content = options.template ? options.template(item) : item;
          var option = _typeof(item) === 'object' ? item.option : undefined;
          var dataValue = 'data-value="' + value + '"';
          var dataOption = option !== undefined ? ' data-option="' + option + '"' : '';
          return '<li aria-label="' + value + '"><a href="#" ' + (dataValue + dataOption) + '>' + content + '</a></li>';
        }).join('') : options.items;
        $node.html(markup).attr({
          'aria-label': options.title
        });
        if (options && options.codeviewKeepButton) {
          $node.addClass('note-codeview-keep');
        }
      });
      var dropdownButtonContents = function dropdownButtonContents(contents, options) {
        return contents + ' ' + icon(options.icons.caret, 'span');
      };
      var dropdownCheck = renderer["a" /* default */].create('<ul class="note-dropdown-menu dropdown-menu note-check">', function ($node, options) {
        var markup = Array.isArray(options.items) ? options.items.map(function (item) {
          var value = typeof item === 'string' ? item : item.value || '';
          var content = options.template ? options.template(item) : item;
          return '<li aria-label="' + item + '"><a href="#" data-value="' + value + '">' + icon(options.checkClassName) + ' ' + content + '</a></li>';
        }).join('') : options.items;
        $node.html(markup).attr({
          'aria-label': options.title
        });
        if (options && options.codeviewKeepButton) {
          $node.addClass('note-codeview-keep');
        }
      });
      var dialog = renderer["a" /* default */].create('<div class="modal note-modal" aria-hidden="false" tabindex="-1" role="dialog"/>', function ($node, options) {
        if (options.fade) {
          $node.addClass('fade');
        }
        $node.attr({
          'aria-label': options.title
        });
        $node.html(['<div class="modal-dialog">', '<div class="modal-content">', options.title ? '<div class="modal-header">' + '<button type="button" class="close" data-dismiss="modal" aria-label="Close" aria-hidden="true">&times;</button>' + '<h4 class="modal-title">' + options.title + '</h4>' + '</div>' : '', '<div class="modal-body">' + options.body + '</div>', options.footer ? '<div class="modal-footer">' + options.footer + '</div>' : '', '</div>', '</div>'].join(''));
      });
      var popover = renderer["a" /* default */].create(['<div class="note-popover popover in">', '<div class="arrow"></div>', '<div class="popover-content note-children-container"></div>', '</div>'].join(''), function ($node, options) {
        var direction = typeof options.direction !== 'undefined' ? options.direction : 'bottom';
        $node.addClass(direction);
        if (options.hideArrow) {
          $node.find('.arrow').hide();
        }
      });
      var ui_checkbox = renderer["a" /* default */].create('<div class="checkbox"></div>', function ($node, options) {
        $node.html(['<label' + (options.id ? ' for="note-' + options.id + '"' : '') + '>', '<input type="checkbox"' + (options.id ? ' id="note-' + options.id + '"' : ''), options.checked ? ' checked' : '', ' aria-checked="' + (options.checked ? 'true' : 'false') + '"/>', options.text ? options.text : '', '</label>'].join(''));
      });
      var icon = function icon(iconClassName, tagName) {
        tagName = tagName || 'i';
        return '<' + tagName + ' class="' + iconClassName + '"></' + tagName + '>';
      };
      var ui_ui = function ui(editorOptions) {
        return {
          editor: editor,
          toolbar: toolbar,
          editingArea: editingArea,
          codable: codable,
          editable: editable,
          statusbar: statusbar,
          airEditor: airEditor,
          airEditable: airEditable,
          buttonGroup: buttonGroup,
          dropdown: dropdown,
          dropdownButtonContents: dropdownButtonContents,
          dropdownCheck: dropdownCheck,
          dialog: dialog,
          popover: popover,
          checkbox: ui_checkbox,
          icon: icon,
          options: editorOptions,
          palette: function palette($node, options) {
            return renderer["a" /* default */].create('<div class="note-color-palette"/>', function ($node, options) {
              var contents = [];
              for (var row = 0, rowSize = options.colors.length; row < rowSize; row++) {
                var eventName = options.eventName;
                var colors = options.colors[row];
                var colorsName = options.colorsName[row];
                var buttons = [];
                for (var col = 0, colSize = colors.length; col < colSize; col++) {
                  var color = colors[col];
                  var colorName = colorsName[col];
                  buttons.push(['<button type="button" class="note-color-btn"', 'style="background-color:', color, '" ', 'data-event="', eventName, '" ', 'data-value="', color, '" ', 'title="', colorName, '" ', 'aria-label="', colorName, '" ', 'data-toggle="button" tabindex="-1"></button>'].join(''));
                }
                contents.push('<div class="note-color-row">' + buttons.join('') + '</div>');
              }
              $node.html(contents.join(''));
              if (options.tooltip) {
                $node.find('.note-color-btn').tooltip({
                  container: options.container || editorOptions.container,
                  trigger: 'hover',
                  placement: 'bottom'
                });
              }
            })($node, options);
          },
          button: function button($node, options) {
            return renderer["a" /* default */].create('<button type="button" class="note-btn btn btn-default btn-sm" tabindex="-1">', function ($node, options) {
              if (options && options.tooltip) {
                $node.attr({
                  title: options.tooltip,
                  'aria-label': options.tooltip
                }).tooltip({
                  container: options.container || editorOptions.container,
                  trigger: 'hover',
                  placement: 'bottom'
                }).on('click', function (e) {
                  external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default()(e.currentTarget).tooltip('hide');
                });
              }
              if (options && options.codeviewButton) {
                $node.addClass('note-codeview-keep');
              }
            })($node, options);
          },
          toggleBtn: function toggleBtn($btn, isEnable) {
            $btn.toggleClass('disabled', !isEnable);
            $btn.attr('disabled', !isEnable);
          },
          toggleBtnActive: function toggleBtnActive($btn, isActive) {
            $btn.toggleClass('active', isActive);
          },
          onDialogShown: function onDialogShown($dialog, handler) {
            $dialog.one('shown.bs.modal', handler);
          },
          onDialogHidden: function onDialogHidden($dialog, handler) {
            $dialog.one('hidden.bs.modal', handler);
          },
          showDialog: function showDialog($dialog) {
            $dialog.modal('show');
          },
          hideDialog: function hideDialog($dialog) {
            $dialog.modal('hide');
          },
          createLayout: function createLayout($note) {
            var $editor = (editorOptions.airMode ? airEditor([editingArea([codable(), airEditable()])]) : editorOptions.toolbarPosition === 'bottom' ? editor([editingArea([codable(), editable()]), toolbar(), statusbar()]) : editor([toolbar(), editingArea([codable(), editable()]), statusbar()])).render();
            $editor.insertAfter($note);
            return {
              note: $note,
              editor: $editor,
              toolbar: $editor.find('.note-toolbar'),
              editingArea: $editor.find('.note-editing-area'),
              editable: $editor.find('.note-editable'),
              codable: $editor.find('.note-codable'),
              statusbar: $editor.find('.note-statusbar')
            };
          },
          removeLayout: function removeLayout($note, layoutInfo) {
            $note.html(layoutInfo.editable.html());
            layoutInfo.editor.remove();
            $note.show();
          }
        };
      };

      /* harmony default export */
      var bs3_ui = ui_ui;
      // EXTERNAL MODULE: ./src/js/base/settings.js + 37 modules
      var settings = __webpack_require__(3);

      // EXTERNAL MODULE: ./src/styles/summernote-bs3.scss
      var summernote_bs3 = __webpack_require__(4);

      // CONCATENATED MODULE: ./src/js/bs3/settings.js

      external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote = external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.extend(external_root_jQuery_commonjs2_jquery_commonjs_jquery_amd_jquery_default.a.summernote, {
        ui_template: bs3_ui,
        "interface": 'bs3'
      });

      /***/
    })

    /******/
  });
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(95)(module)))

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2d499ab556d929865f461acb8f2a13bf.svg";

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module) {

module.exports = JSON.parse("{\"genericLabels\":{\"loading\":\"Loading...\"},\"genericButtons\":{\"cancel\":\"Cancel\",\"continue\":\"Continue\"},\"advancedFilter\":{\"dateRange\":{\"startDatePlaceHolder\":\"Start Date\",\"endDatePlaceHolder\":\"End Date\",\"to\":\"to\"},\"saveFilterLabel\":\"Save Filter\",\"saveFilterAsLabel\":\"Save Filter As...\",\"saveFilterAs\":{\"title\":\"Save Filter As\",\"filterLabel\":\"New Filter Name\",\"cancelButton\":\"Cancel\",\"saveAsButton\":\"Save\",\"loadingBar\":\"Saving Filter...\",\"duplicateWarning\":\"That name is already in use.\"},\"deleteFilterLabel\":\"Delete Filter\",\"deleteFilter\":{\"title\":\"Delete Filter\",\"summary\":\"Are you sure you want to delete the selected filter?\",\"cancelButton\":\"Cancel\",\"deleteButton\":\"Delete\",\"loadingBar\":\"Deleting Filter...\"},\"unselectedFilter\":{\"placeholder\":\"Additional Criteria\"},\"placeholder\":\"Please Enter\",\"selected\":\"Selected\",\"clearSelected\":\"Clear Selected\",\"removeButtonTooltip\":\"Remove Criterion\",\"clearButton\":\"Clear Criteria\",\"resetFilter\":\"Reset Filter\",\"editedFilter\":\"(Edited)\"},\"alert\":{\"confirmActionButtonLabel\":\"Yes\",\"cancelActionButtonLabel\":\"No\",\"genericErrorMessage\":\"The operation did not complete successfully.\",\"genericErrorTitle\":\"Error\",\"genericAlertTitle\":\"Alert\",\"okButtonLabel\":\"OK\",\"unableToRouteAction\":\"Unable to route action \",\"exceptions\":{\"exception.db.noResult\":\"No entity was found for the query.\",\"exception.db.notFound\":\"The requested data was not found. Please try again.\",\"exception.db.staleState\":\"The submission status was changed by another user. Please check the latest status and retry.\",\"exception.db.lockAcquisition\":\"Another user was accessing information required for this request so it could not be completed. Please try again.\",\"exception.db.cannotAcquireLock\":\"Another user was accessing information required for this request so it could not be completed. Please try again.\",\"exception.user.notFound\":\"The user was not found.\",\"exception.rules.invalid\":\"The rules are not valid.\",\"exception.editableField\":\"The operation failed because it was attempting to modify the value of a field that is no longer editable at this point in the workflow.\",\"exception.server\":\"No match could be found. Please verify the information supplied or use an alternative search criteria.\",\"exception.security.accessDenied\":\"In your current role, you are not authorized to perform this action.\",\"exception.security.disabled\":\"The user was not found.\",\"exception.workflow\":\"The operation that you are attempting to perform is no longer valid. Click OK to continue.\",\"exception.workflow.invalidTransition\":\"The operation that you are attempting to perform is no longer valid. Click OK to continue.\",\"exception.underwriting.backdate\":\"This submission cannot be quoted because it is backdated.\",\"exception.product.authorization\":\"Access not permitted because you are not authorized for any of the submission's products.\",\"exception.webservice.resourceNotFound\":\"Resource not found\",\"exception.uiFormTemplate.upload.failure\":\"An error occurred while importing the file. Ensure that you are importing the correct file type.\"}},\"businessCard\":{\"sendEmailButton\":\"Send Email \",\"work\":\"Work\",\"mobile\":\"Mobile\",\"code\":\"Code\",\"address\":\"Address\",\"parent\":\"PARENT\"},\"changePassword\":{\"loadingBar\":\"Updating...\"},\"externalAccount\":{\"title\":\"External Accounts\",\"okButton\":\"Save\",\"cancelButton\":\"Cancel\",\"savingLoadingBar\":\"Saving External Accounts\",\"passwordMismatch\":\"The passwords do not match.\",\"description\":\"Description\",\"username\":\"Username\",\"password\":\"Password\",\"verifyPassword\":\"Verify Password\"},\"gridPaging\":{\"back\":\"Back\",\"next\":\"Next\"},\"forceLogout\":{\"title\":\"Force Logout\"},\"forgotPassword\":{\"loadingBar\":\"Sending email...\"},\"formsViewer\":{\"printFormTooltip\":\"Print form.\",\"controls\":{\"umsClassCodeFinder\":{\"itemHelper\":\"Please enter {0} or more characters\",\"noResults\":\"No Codes Found\"},\"functionButton\":{\"yesButton\":\"Yes\",\"noButton\":\"No\",\"title\":\"Confirm Action\"},\"dropdown\":{\"longListWarning\":\"Too many results ({0} items). Please revise your search\",\"loading\":\"loading...\",\"searchPrompt\":\"Please type at least {0} characters to start search\",\"noMatchFound\":\"No matches found. Please try again.\",\"longListLimit\":150,\"searchDelay\":500,\"searchCharLimit\":3,\"dropdownExecutorDefaultConfirmYesButton\":\"Yes\",\"dropdownExecutorDefaultConfirmNoButton\":\"No\",\"dropdownExecutorDefaultConfirmTitle\":\"Confirm Action\"},\"uploadAttachment\":{\"loadingBar\":\"Uploading File...\"},\"multiSelectClassCode\":{\"selectClassCodePrompt\":\"Select Class Code\",\"stateClassCodeMinimumSearchCharacters\":2,\"classCodeMinimumSearchCharacters\":3,\"filterTextPromptSingular\":\"Enter state code or description to search for a class code. Please enter at least 1 character.\",\"filterTextPromptPlural\":\"Enter state code or description to search for a class code. Please enter at least {minimumSearchCharacters} characters.\"}},\"hiddenFieldDetailsModal\":{\"title\":\"Hidden Field Details\",\"name\":\"Name\",\"id\":\"Id\",\"value\":\"Value\"},\"fieldDetailsModal\":{\"title\":\"Field Details\",\"okButtonLabel\":\"OK\",\"fieldInstanceDoesNotExist\":\"Field instance does not exist.\",\"fieldAttributes\":\"Field Attributes\",\"fieldId\":\"fieldId:\",\"rowId\":\"rowId:\",\"requiredFieldLevel\":\"requiredFieldLevel:\",\"name\":\"name:\",\"value\":\"value:\",\"valueLabel\":\"valueLabel:\",\"fieldTemplateAttributes\":\"Field Template Attributes\",\"fieldTemplateId\":\"fieldTemplateId:\",\"variableName\":\"variableName:\",\"dataSetName\":\"dataSetName:\",\"agencyVisible\":\"agencyVisible:\",\"carrierVisible\":\"carrierVisible:\",\"hidden\":\"hidden:\",\"agencyEditableFieldLevel\":\"agencyEditableFieldLevel:\",\"carrierEditableFieldLevel\":\"carrierEditableFieldLevel:\",\"formAttributes\":\"Form Attributes\",\"formId\":\"formId:\",\"referenceId\":\"referenceId:\",\"formName\":\"formName:\",\"rootFormId\":\"rootFormId:\",\"rootFormName\":\"rootFormName:\",\"editableFieldLevel\":\"editableFieldLevel:\",\"requiredFieldCount\":\"requiredFieldCount:\",\"totalRequiredFieldCount\":\"totalRequiredFieldCount:\",\"requiredFieldToCreateApplicationCount\":\"requiredFieldToCreateApplicationCount:\",\"requiredFieldToSubmitCount\":\"requiredFieldToSubmitCount:\",\"requiredFieldToRateCount\":\"requiredFieldToRateCount:\",\"requiredFieldToPriceCount\":\"requiredFieldToPriceCount:\",\"requiredFieldToQuoteCount\":\"requiredFieldToQuoteCount:\",\"requiredFieldToIssueCount\":\"requiredFieldToIssueCount:\",\"requiredFieldToRequestCancellationCount\":\"requiredFieldToRequestCancellationCount:\",\"requiredFieldToSubmitCancellationCount\":\"requiredFieldToSubmitCancellationCount:\",\"requiredFieldToCancelCount\":\"requiredFieldToCancelCount:\",\"linkedFieldsResolved\":\"linkedFieldsResolved:\",\"formTemplateAttributes\":\"Form Template Attributes\",\"formTemplateId\":\"formTemplateId:\",\"formTemplateDisplayName\":\"formTemplateDisplayName:\",\"formTemplateUniqueName\":\"formTemplateUniqueName:\",\"version\":\"version:\",\"effectiveDateRangeBegin\":\"effectiveDateRangeBegin:\",\"effectiveDateRangeEnd\":\"effectiveDateRangeEnd:\",\"root\":\"root:\",\"includedInEndorsement\":\"includedInEndorsement:\",\"proposalLevel\":\"proposalLevel:\",\"ordering\":\"ordering:\",\"deferLinkedFields\":\"deferLinkedFields:\",\"requiredFieldToBindCount\":\"requiredFieldToBindCount:\"},\"editableFieldLevel\":{\"0\":\"Always Editable\",\"5\":\"Create Application\",\"10\":\"Submit\",\"15\":\"Rating\",\"20\":\"Pricing\",\"25\":\"Quoting\",\"30\":\"Binding\",\"35\":\"Issuance\",\"100\":\"Post Issuance\",\"101\":\"Submit Cancellation\",\"102\":\"Cancellation\",\"200\":\"Post Cancellation\",\"-1\":\"Not Editable\"},\"requiredFieldLevel\":{\"0\":\"Not Required\",\"5\":\"Create Application\",\"10\":\"Submit\",\"15\":\"Rate\",\"20\":\"Price\",\"25\":\"Quote\",\"30\":\"Bind\",\"35\":\"Issue\",\"101\":\"Request Cancellation\",\"102\":\"Submit Cancellation\",\"103\":\"Cancel\"},\"errors\":{\"amountOutOfRange\":\"This value must be between {0} and {1}\",\"currencySymbolPlacementError\":\"The currency symbol occurs in an invalid location\",\"exceedsMaxValue\":\"This value cannot be more than {0}\",\"internalEmailError\":\"Email error\",\"invalidChar\":\"An invalid character was entered\",\"invalidCurrencyChar\":\"A character that was entered is not valid for currency. Please enter only numbers, decimal points, or valid currency symbols\",\"invalidCurrencyFormatChar\":\"Invalid currency format\",\"invalidDataItemValue\":\"This data item is not valid. Please select another item\",\"invalidEmailChar\":\"The email address contains invalid characters\",\"invalidEmailDomain\":\"The domain in the email address is incorrectly formatted\",\"invalidEmailPeriodPosition\":\"The domain in the email address is incorrectly formatted\",\"invalidInteger\":\"The number must be an integer\",\"invalidIPDomain\":\"The IP domain for the email address is not formatted correctly\",\"invalidNumber\":\"The value is not a valid number\",\"invalidNumberChar\":\"This value is not a valid number\",\"invalidNumberFormatChar\":\"This value contains characters that are not valid. Please use only numbers\",\"invalidOtherValue\":\"You must enter text in the Other field\",\"invalidPeriodsInDomain\":\"The domain includes consecutive periods (.) Please remove the extra periods\",\"invalidPhoneNoChar\":\"The telephone number contains invalid characters\",\"invalidSSNChar\":\"You entered invalid characters in your Social Security number\",\"invalidUrl\":\"The URL is not valid. Please enter a URL in the format: 'http://www.yourDomain.com/additionalParameters'\",\"invalidYesNoValue\":\"The field is invalid - the '{0}' is incomplete\",\"invalidZipCodeChar\":\"The ZIP code contains invalid characters\",\"invalidZipCodeDomain\":\"The ZIP code domain is invalid. Use 'US Only', 'Canada Only', or 'US or Canada'\",\"invalidZipcodeFormatChars\":\"The ZIP code contains invalid characters. Please enter only numbers between 0 and 9 and the dash (-) symbol\",\"lowerThanMinValue\":\"The Value cannot be less than {0}\",\"minPhoneNoDigits\":\"Your telephone number must contain at least 10 digits\",\"missingAtSign\":\"An at sign (@) is missing in the email address\",\"missingEmailBackslash\":\"The email address is missing the backslash character\",\"missingEmailDomain\":\"The email domain is not specified\",\"missingEmailGreaterThanSign\":\"The email address is missing the greater than sign. Please format the email address as 'FirstName Last Name' <email@domain.com.>\",\"missingEmailQuote\":\"The email address is missing quotation marks. Please format the email address as 'FirstName Last Name' <email@domain.com>\",\"missingLocalPart\":\"\",\"missingPeriodInDomain\":\"The domain in the email address is missing a period\",\"missingUsername\":\"The username is not specified. Please enter a username\",\"negativeNumber\":\"This value cannot be negative\",\"noExpression\":\"The expression is missing\",\"noMatch\":\"The field is invalid\",\"nonexistentClassCode\":\"This class code does not exist. Please select another class code\",\"noNumError\":\"The value is not a number. Please enter a number\",\"noType\":\"The value does not include a type. Please enter a type\",\"numberOutOfRange\":\"The number must be between {0} and {1}\",\"percentageOutOfRange\":\"Please enter a value between {0}% and {1}%\",\"requiredField\":\"This field is required\",\"tooManyAtSigns\":\"The email address includes more than one @ symbol. Please remove the extra @ symbols\",\"wrongCAFormatZipcode\":\"The Canadian postal code format must be 'A1B 2C3'\",\"wrongDateFormat\":\"The date format is incorrect. Date must be in {0} format\",\"wrongDateLength\":\"Please enter the date in the format {requiredDateFormat}\",\"wrongDay\":\"The value for day must be between 1 and 31\",\"wrongDecimalPlacing\":\"The decimal point is located in the wrong place\",\"wrongDecimalPointCount\":\"The maximum number of decimal points for this field is one; please verify that the value includes zero or one decimal points\",\"wrongMonth\":\"The value for month must be between 1 and 12\",\"wrongPhoneNoLength\":\"No phone number was entered. The phone number must contain a minimum of 10 digits\",\"wrongPrecision\":\"The amount entered has too many digits beyond the decimal point.\",\"wrongSSNFormat\":\"The Social Security number must be 9 digits or in the form NNN-NN-NNNN\",\"wrongThousandsSeparation\":\"The thousands separator must be followed by three digits\",\"wrongType\":\"The type is invalid\",\"wrongUSFormatZipcode\":\"The ZIP+4 code must be formatted '12345-6789'\",\"wrongYear\":\"The value for year must be between 0 and 9999\",\"wrongYearLength\":\"Please enter YY or YYYY to indicate the year\",\"wrongZipcodeLength\":\"The ZIP code must be 5 digits or 5+4 digits\",\"yearOutOfRange\":\"The year cannot be more than one year in the future\",\"zeroStartSSN\":\"Invalid Social Security number; the number cannot start with 000\",\"maxCharsExceeded\":\"The value entered exceeds the maximum characters allowed\"},\"formSummary\":{\"confirm\":\"Delete\",\"cancel\":\"Cancel\",\"deleteSingleFormTitle\":\"Delete Form\",\"deleteConfirmationTitle\":\"Delete Rows\",\"deleteConfirmationMessage\":\"Are you sure you want to delete {1} row{2}?\",\"deleteSingleForm\":\"Are you sure you want to delete this form?\",\"deleteTooltip\":\"Select one or more rows to delete and then click on the Delete button\",\"import\":\"Import\",\"importLoadingBar\":\"Importing...\",\"deleteLoadingBar\":\"Deleting...\",\"export\":\"Export\",\"unacceptableType\":{\"unacceptableTypeMessage\":\"File {name} is not a supported document type for import.\",\"unacceptableTypeTitle\":\"Alert\",\"unacceptableTypeConfirmActionButtonLabel\":\"OK\"},\"addFormTooltip\":\"Add a form.\",\"trashIconTooltip\":\"Delete forms.\",\"notEditableRowTooltip\":\"This form is not editable.\"},\"rowRepeater\":{\"confirm\":\"Delete\",\"cancel\":\"Cancel\",\"deleteConfirmationTitle\":\"Delete Rows\",\"deleteConfirmationMessage\":\"Are you sure you want to delete {1} row{2}?\",\"deleteTooltip\":\"Select one or more rows to delete and then click on the Delete button\",\"addButtonTooltip\":\"Add a row.\",\"trashIconTooltip\":\"Delete rows.\"},\"formUpgrade\":{\"title\":\"Forms Upgraded\",\"singularMessage\":\" form has\",\"pluralMessage\":\" forms have\",\"message\":\"{1}{2} been upgraded.\",\"confirmActionButtonLabel\":\"OK\"},\"yesNoRadio\":{\"yes\":\"Yes\",\"no\":\"No\",\"pleaseExplain\":\"Please Explain\"}},\"homePage\":{\"createSubmissionButton\":\"Create Submission\",\"myAgencySubmissions\":\"My Agency's Submissions\",\"mySubmissions\":\"My Submissions\",\"myBranch\":\"My Branch\",\"myTasks\":\"My Tasks\",\"viewActiveOnly\":\"View Active Only\",\"searchPlaceholder\":\"search…\",\"defaultTitle\":\"Guidewire UM\",\"agentTitle\":\"UM Agent\",\"underwriterTitle\":\"Underwriting Management\",\"umStudioTitle\":\"UM Studio\",\"appreaderTitle\":\"AppReader\",\"widgets\":{\"submissionGrid\":{\"title\":\"Submission List\",\"bulkReassign\":{\"bulkReassign\":\"Bulk Reassign\",\"maximumSelectionWarning\":\"Only {1} selections will be reassigned at a time\",\"headerTitle\":\"Submissions Selected\",\"cogMenuLabel\":\"Bulk Reassign\",\"reassign\":\"Reassign\",\"resolve\":\"Resolve\",\"cancel\":\"Cancel\",\"userSelectionModal\":{\"title\":\"Reassign Submissions\",\"assignedToGroupLabel\":\"Assigned To\",\"responsibleUnderwriterGroupLabel\":\"Underwriter\",\"serviceTeamGroupLabel\":\"Service Team\",\"addMemberServiceDropdownLabel\":\"Add Member\",\"removeMemberServiceDropdownLabel\":\"Remove Member\"},\"confirmationModal\":{\"title\":\"Reassign Submissions\",\"closeButton\":\"Close\",\"error\":{\"title\":\"Submissions not Processed\",\"urlStructure\":\"/Submission/\"},\"message\":{\"of\":\"of\",\"successfullyProcessed\":\"Submissions Successfully Processed\"}}}},\"taskGrid\":{\"instructions\":\"Select one or more rows to make changes\",\"title\":\"Task List\",\"reassignTitle\":\"Reassign Task{1}\",\"reassignButton\":\"Reassign\",\"resolveTitle\":\"Resolve Task{1}\",\"resolveButton\":\"Resolve\",\"reassignMessage\":\"Reassign {1} task{2} to:\",\"resolveMessage\":\"Resolution notes for {1} task{2}:\",\"cancel\":\"Cancel\",\"resolutionsNotes\":\"Resolution Notes\",\"assignTo\":\"Assign To\",\"bulkUpdate\":\"Bulk Update\",\"downloadCsv\":\"Download CSV\",\"bulkReassign\":{\"headerTitle\":\"Tasks Selected\",\"cogMenuLabel\":\"Bulk Update\"},\"pageSizeLabel\":\"Results per Page\"}},\"grid\":{\"title\":\"Submission List\",\"header\":{\"insured\":\"Insured\",\"submission\":\"Submission\",\"effective\":\"Effective\",\"expiration\":\"Expiration\",\"status\":\"Status\",\"statusReason\":\"Status Reason\",\"premium\":\"Premium\",\"nextAction\":\"Next Action\",\"actionDate\":\"Action Date\",\"assignedTo\":\"Assigned To\",\"underwriter\":\"Underwriter\",\"coverage\":\"Product\",\"agency\":\"Agency\",\"receivedDate\":\"Received Date\",\"quoteNeededBy\":\"Needed By\",\"priority\":\"Priority\",\"riskState\":\"Risk State\",\"totalLimit\":\"Total Limit\",\"nameOfObligation\":\"Name of Obligation\",\"quoteNeededByDate\":\"Needed By\",\"taskSummary\":\"Task Summary\",\"assignedBy\":\"Assigned By\",\"taskDetails\":\"Task Details\",\"dueDate\":\"Due Date\",\"resolved\":\"Resolved\",\"createdDate\":\"Assigned Date\",\"resolvedDate\":\"Resolved Date\"},\"itemCount\":\"Showing startIndex to endIndex of total item\",\"itemsCount\":\"Showing startIndex to endIndex of total items\",\"submissionCount\":\"Showing startIndex to endIndex of total Submission\",\"submissionsCount\":\"Showing startIndex to endIndex of total Submissions\",\"taskCount\":\"Showing startIndex to endIndex of total Task\",\"tasksCount\":\"Showing startIndex to endIndex of total Tasks\",\"showOrHideToolsTooltip\":\"Show/hide tools.\",\"searchIconTooltip\":\"Show/hide filters.\",\"emptyTaskMessage\":\"No matching tasks.\",\"details\":{\"submissionDetails\":{\"title\":\"New Submission\",\"submissionNumber\":\"Submission Number:\",\"policyNumber\":\"Policy Number:\",\"account\":\"Account#:\",\"location\":\"Location:\",\"effective\":\"Effective:\",\"expiration\":\"Expiration:\",\"renewal\":\"Renewal On:\",\"priority\":\"Priority:\",\"product\":\"Product:\",\"insuredName\":\"Insured Name:\",\"status\":\"Status:\",\"products\":\"Products:\",\"effectiveDate\":\"Effective Date:\"},\"workflowDetails\":{\"title\":\"Workflow\",\"status\":\"Status:\",\"statusReason\":\"Status Reason:\",\"statusDetails\":\"Status Details:\",\"nextAction\":\"Next Action:\",\"dueOn\":\"Due On:\",\"premium\":\"Premium:\"},\"carrierTeamDetails\":{\"title\":\"Carrier Team\",\"carrierBranch\":\"Carrier Branch:\",\"underwriter\":\"Underwriter:\",\"assignedTo\":\"Assigned To:\",\"referredTo\":\"Referred to Underwriter:\"},\"agencyTeamDetails\":{\"title\":\"Agency Team\",\"agency\":\"Agency/Brokerage:\",\"producer\":\"Producer:\",\"agencyContact\":\"Agency Contact:\"},\"historyDetails\":{\"title\":\"History\",\"createdBy\":\"Created By:\",\"received\":\"Received:\",\"lastModified\":\"Last Modified:\"},\"taskDetails\":{\"title\":\"Task Details\",\"priority\":\"Priority:\",\"dueDate\":\"Due Date:\",\"taskDetails\":\"Task Details:\",\"assignedTo\":\"Assigned To:\"},\"taskResolution\":{\"title\":\"Task Resolution\",\"comments\":\"Comments:\",\"resolved\":\"Resolved:\",\"resolvedBy\":\"Resolved By:\",\"resolutionDate\":\"Resolution Date:\"},\"taskHistory\":{\"title\":\"Task History\",\"assignedBy\":\"Assigned By:\",\"assignedDate\":\"Assigned Date:\"}}}},\"loadingBar\":{\"defaultMessage\":\"Loading...\"},\"termsAndCondition\":{\"title\":\"Terms and Conditions\",\"confirm\":\"Accept\",\"cancel\":\"Do not accept\"},\"okCancelModal\":{\"confirmButton\":\"OK\",\"cancelButton\":\"Cancel\"},\"rangeModal\":{\"title\":\"Please select the data range to download\",\"description\":\"Input the start row number and end row number to download: Limit to ${batch} rows\",\"okButton\":\"Download\",\"cancelButton\":\"Close\",\"minPlaceHolder\":\"Start number\",\"maxPlaceHolder\":\"End number\"},\"recentActivity\":{\"title\":\"Recent Activity\"},\"serverReconnectModal\":{\"title\":\"Network Connection\",\"summary\":\"This application needs to be restarted. Please click Ok to restart it now or click Cancel to restart later.\"},\"serverDisconnectedModal\":{\"title\":\"Network Connection\",\"summary\":\"The connection was lost on ${dayOfWeek} at ${time}.\",\"additionalSummary\":\"The system has been unable to re-establish your connection to the server. You may wait for additional attempts to connect or close the browser tab to close this session.\"},\"persistentConnectionFailedModal\":{\"title\":\"Connection Failed\",\"summary\":\"At this time, your browser cannot properly establish an HTTP streaming connection to the application. Please contact your local IT resource or your help desk for assistance.\"},\"sessionTimeout\":{\"idleWarningTitle\":\"Warning - Automatic Logout\",\"inactivityLogOutTitle\":\"Inactivity Log Out\",\"okButton\":\"OK\",\"agent\":\"Agent Workspace\",\"underwriter\":\"Underwriting Workstation\",\"systemUser\":\"UM Studio\",\"autoLogoutWarning\":\"{umsType} has been inactive for {autoLogoutWarningMinutes} minutes.  You will be logged off in {countDown}\",\"autoLogoutRedirectMessage\":\"You have been logged out of your {umsType} due to inactivity\"},\"systemAnnouncement\":{\"title\":\"System Announcement\"},\"taskListWidget\":{\"title\":\"Tasks\"},\"userMenu\":{\"help\":\"Help\",\"settings\":\"Settings\",\"profile\":\"Profile\",\"fullScreen\":\"Full Screen\",\"chatAvailability\":\"Chat Availability\",\"aboutUms\":\"About UM\",\"logout\":\"Logout\"},\"userProfile\":{\"title\":\"My Profile\",\"firstNameLabel\":\"First Name:\",\"firstNameTooltip\":\"Needed to select first name\",\"middleNameLabel\":\"Middle Name:\",\"lastNameLabel\":\"Last Name:\",\"lastNameTooltip\":\"Needed to select last name\",\"jobTitleLabel\":\"Job Title:\",\"emailLabel\":\"Email:\",\"workPhoneLabel\":\"Phone (Work):\",\"cellPhoneLabel\":\"Phone (Mobile):\",\"extLabel\":\"Ext:\",\"faxLabel\":\"Fax:\",\"addressLine1\":\"Address 1:\",\"addressLine2\":\"Address 2:\",\"cityLabel\":\"City:\",\"stateLabel\":\"State:\",\"zipLabel\":\"Zip:\",\"countryLabel\":\"Country:\",\"cancelButton\":\"Cancel\",\"okButton\":\"Save\",\"updateUserProfileLoadingBar\":\"Updating...\",\"pictureLabel\":\"Picture:\",\"error\":{\"zipCode\":\"The ZIP code must be 5 digits or 5+4 digits.\",\"phoneNumber\":\"The work phone number must be at least 10 digits in length.\",\"cellPhoneNumber\":\"The mobile phone number must be at least 10 digits in length.\",\"faxNumber\":\"The fax number must be at least 10 digits in length.\"},\"cancelUpload\":\"Cancel Upload\",\"uploadProfilePhoto\":\"Upload Profile Photo\",\"deletePhoto\":\"Delete Profile Photo\",\"userImage\":{\"change\":\"Change\",\"dragAndDrop\":\"Drag and Drop File Here\",\"or\":\"or\",\"addFile\":\"New File\",\"unacceptableType\":{\"unacceptableTypeMessage\":\"File {name} is not a supported document type for upload.\",\"unacceptableTypeTitle\":\"Alert\",\"unacceptableTypeConfirmActionButtonLabel\":\"OK\"},\"chooseFile\":\"Choose File\",\"pleaseChoose\":\"Please Choose\",\"uploadFile\":\"Upload File\",\"cancel\":\"Cancel\",\"type\":\"Type\",\"maxFileSizeTitle\":\"File Too Big\",\"maxFileSizeMessage\":\"The file you are trying to upload exceeds the maximum allowed file size of {maxSize} KB.\",\"imageSizeTitle\":\"Upload Image\",\"imageSizeMessage\":\"The height and width of the selected image must be the same. Please select a file with equal height and width (for example, 100 x 100 pixels) and then try again.\",\"imageUploadingLoadingBar\":\"Image uploading...\"}},\"widgetActions\":{\"configureColumns\":\"Configure Columns\",\"minimize\":\"Minimize\",\"maximize\":\"Maximize\",\"returnToDefaultSize\":\"Return to Default Size\"},\"downloadExcel\":\"Download Excel\",\"userList\":{\"actions\":{\"name\":\"Actions\",\"createUser\":\"New User\",\"importUWLOAs\":\"Import Underwriter LOAs\",\"exportUWLOAs\":\"Export Underwriter LOAs\"},\"manageAgencyUsersLabel\":\"Manage Agency Users\",\"manageUnderwriters\":\"Manage Underwriters\",\"manageServiceUsers\":\"Manage Service Users\",\"manageSystemUsers\":\"Manage System Users\",\"title\":\"Manage Users\",\"newUserButtonLabel\":\"New User\",\"showOnlyActiveUsers\":\"Show Only Active Users:\",\"showOnlyAdminUsers\":\"Show Only Admin Users:\",\"draftUserName\":\"Draft\",\"showActive\":\"Show Active Users\",\"userCount\":\"Showing startIndex to endIndex of total User\",\"usersCount\":\"Showing startIndex to endIndex of total Users\",\"status\":{\"0\":\"Inactive\",\"1\":\"Active\",\"2\":\"Draft\"},\"columns\":{\"name\":\"Name\",\"username\":\"Username\",\"status\":\"Status\",\"organization\":\"Organization\",\"agencyNumber\":\"Agency Number\",\"latestLogin\":\"Latest Login\"},\"lockedLabel\":\"(Locked)\",\"lockedDetail\":\"Account locked as of \",\"emptyGrid\":\"No matching users\",\"importUWLOAs\":{\"loadingBar\":\"Importing forms...\",\"successMessageSingular\":\"Successfully imported 1 form\",\"successMessagePlural\":\"Successfully imported {0} forms\",\"errorModal\":{\"confirmActionButtonLabel\":\"OK\",\"summary\":\"{0} form(s) were successfully imported, however {1} form(s) had failures:\\n\\n{2}\",\"title\":\"Import Forms\"}},\"exportUWLOAs\":{\"loadingBar\":\"Exporting forms...\",\"successMessage\":\"Successfully exported forms\"},\"userSearchTermPlaceholder\":\"Search\"},\"user\":{\"dropdown\":{\"label\":\"Users\"},\"manage\":{\"backButton\":\"Back\",\"statusLabel\":\"Status\",\"status\":{\"0\":\"Inactive\",\"1\":\"Active\",\"2\":\"Draft\"},\"formTemplateType\":{\"7\":\"Underwriting Authority\",\"42\":\"User Form\"}},\"actions\":{\"name\":\"Actions\",\"deactivate\":\"Deactivate\",\"reset password\":\"Reset Password\",\"create password\":\"Create Password\",\"cancel\":\"Cancel\",\"activate\":\"Activate\",\"startChanges\":\"Edit\",\"applyChanges\":\"Save\",\"discardChanges\":\"Discard\",\"unlock\":\"Unlock User\"},\"activate\":{\"loadingBar\":\"Activating user...\",\"sendPasswordModal\":{\"cancel\":\"No\",\"confirm\":\"Yes\",\"summary\":\"The user has been stored, but does not yet have a password. Do you want to notify the user of their username and send them a link to establish a password?\",\"title\":\"Activate User\",\"loadingBar\":\"Sending Password...\"}},\"cancelModal\":{\"cancel\":\"No\",\"confirm\":\"Yes\",\"summary\":\"Are you sure you want to delete this user?\",\"title\":\"Delete User\",\"loadingBar\":\"Deleting user...\"},\"deactivateModal\":{\"cancel\":\"No\",\"confirm\":\"Yes\",\"summary\":\"Are you sure you want to deactivate this user?\",\"title\":\"Deactivate User\",\"loadingBar\":\"Deactivating user...\"},\"resetPasswordModal\":{\"cancel\":\"No\",\"confirm\":\"Yes\",\"summary\":\"This user already has a password. Are you sure you want to create a new password?\",\"title\":\"Reset Password\",\"loadingBar\":\"Resetting Password...\"},\"unlockUserModal\":{\"cancel\":\"No\",\"confirm\":\"Yes\",\"summary\":\"Are you sure you want to unlock this user?\",\"title\":\"Unlock User\",\"loadingBar\":\"Unlocking user...\"},\"createPasswordModal\":{\"cancel\":\"No\",\"confirm\":\"Yes\",\"summary\":\"Are you sure you want to create a new password?\",\"title\":\"Create Password\",\"loadingBar\":\"Creating Password...\"},\"discard\":{\"title\":\"Discard Changes\",\"summary\":\"Are you sure you want to discard your changes?\",\"cancel\":\"No\",\"confirm\":\"Yes\",\"success\":\"Your changes have been discarded.\"},\"discardUserChangesLoadingBar\":\"Discarding changes\",\"discardUserChangesSuccessLoadingBar\":\"Successfully discarded changes\"},\"filter\":{\"yesNo\":{\"yes\":\"Yes\",\"no\":\"No\"}},\"submission\":{\"wizard\":{\"commentsModal\":{\"declineReferralModal\":{\"cancel\":\"Cancel\",\"primaryAction\":\"Decline Risk\",\"primaryActionLoadingBar\":\"Declining Risk...\",\"summary\":\"\",\"title\":\"Decline Referral\"},\"clearReferralModal\":{\"cancel\":\"Cancel\",\"clearingReferralLoadingBar\":\"Clearing Referral...\",\"clearReferralAction\":\"Clear\",\"partiallyClearingReferralLoadingBar\":\"Partially Clearing Referral...\",\"partiallyClearReferralAction\":\"Partially Clear\",\"summary\":\"\",\"title\":\"Clear Referral\"}}},\"attachment\":{\"fileNotPreviewed\":\"Document preview is not available for this type of document. Please click on the link below in order to open the document in a new browser window.\"},\"status\":{\"0\":\"Invalid\",\"1\":\"Draft\",\"2\":\"Submitted\",\"3\":\"Clear\",\"4\":\"Quoted\",\"5\":\"Bind Requested\",\"6\":\"Bound\",\"7\":\"Issued\",\"8\":\"Not Clear\",\"9\":\"Lost\",\"10\":\"Declined\",\"11\":\"Quote Withdrawn\",\"12\":\"Expired\",\"13\":\"Started Pre-Qualification\",\"14\":\"Failed Pre-Qualification\",\"15\":\"Pending Issuance\",\"16\":\"Declined Quote\",\"18\":\"Cancelled\",\"20\":\"Clear Awaiting Rate\",\"21\":\"Renewed\",\"22\":\"Non-Renewed\",\"23\":\"Succeeded Pre-Qualification\",\"24\":\"Submit Pending\",\"25\":\"Clear-Ready to Underwrite\",\"26\":\"Rejected\",\"27\":\"Created\",\"uploadStatus\":{\"1\":\"Upload in Progress\",\"2\":\"Upload in Progress\",\"4\":\"Application Uploaded\"}}}}");

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(24)(__webpack_require__(1694))

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var angular = __webpack_require__(26);
var ngIdle = __webpack_require__(54);
var angularSanitize = __webpack_require__(55);
var uirouter = __webpack_require__(53);
var uiBootstrap = __webpack_require__(56);
var uiSelect = __webpack_require__(57);
var coreModule = __webpack_require__(58);
var j2js = __webpack_require__(143);

/*@ngInject*/
angular.module('gw-um-auth', [angularSanitize, ngIdle, uirouter.default, uiBootstrap, uiSelect, coreModule, j2js]).config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state('login', {
    url: '/login',
    views: {
      'content': {
        templateUrl: '/login/login.tpl.html',
        controller: 'loginController'
      }
    },
    params: {
      username: null,
      login: null,
      externalToken: null
    },
    data: {
      noAuth: true
    }
  }).state('password', {
    url: '/password',
    views: {
      'content': {
        templateUrl: '/changePassword/changePassword.tpl.html',
        controller: 'changePasswordController'
      }
    },
    params: {
      username: null,
      oldPassword: null,
      messageKey: null
    },
    data: {
      noAuth: true
    }
  });
}]).run(["$rootScope", "coreMediator", "coreConstant", function ($rootScope, coreMediator, coreConstant) {
  $rootScope.$on('$stateChangeStart', function (event, toState) {
    // On a state change, check to see if the route requires authentication. If it does, check that we are auth'ed,
    // and if we aren't broadcast an INVALID_SESSION event to take care of it (and also block the state change event).
    if (!toState.data || !toState.data.noAuth) {
      if (_.isNil(coreMediator.getLoginToken())) {
        event.preventDefault();
        $rootScope.$broadcast(coreConstant.event.INVALID_SESSION);
      }
    }
  });
}]);
__webpack_require__(1665);
__webpack_require__(1666);
__webpack_require__(1667);
__webpack_require__(1668);
__webpack_require__(1669);
__webpack_require__(1670);
__webpack_require__(1671);
__webpack_require__(1672);
__webpack_require__(1673);
__webpack_require__(1674);
__webpack_require__(1675);
__webpack_require__(1676);
__webpack_require__(1677);
__webpack_require__(1678);
__webpack_require__(1680);
__webpack_require__(1681);
__webpack_require__(1682);
__webpack_require__(1684);
__webpack_require__(1685);
__webpack_require__(1686);
__webpack_require__(1687);
__webpack_require__(1688);
__webpack_require__(1690);
__webpack_require__(1691);
__webpack_require__(1692);
module.exports = 'gw-um-auth';
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7a688d8e91c6c0e0ab9a0ed1b3b0d4d0.svg";

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

/*@ngInject*/
angular.module('gw-um-j2js', []).run(function () {});
__webpack_require__(1547);
__webpack_require__(1548);
__webpack_require__(1549);
__webpack_require__(1550);
__webpack_require__(1551);
__webpack_require__(1552);
__webpack_require__(1553);
__webpack_require__(1554);
__webpack_require__(1555);
__webpack_require__(1556);
__webpack_require__(1557);
__webpack_require__(1558);
__webpack_require__(1559);
__webpack_require__(1560);
__webpack_require__(1561);
__webpack_require__(1562);
__webpack_require__(1563);
__webpack_require__(1564);
__webpack_require__(1565);
__webpack_require__(1566);
__webpack_require__(1567);
__webpack_require__(1568);
__webpack_require__(1569);
__webpack_require__(1570);
__webpack_require__(1571);
__webpack_require__(1572);
__webpack_require__(1573);
__webpack_require__(1574);
__webpack_require__(1575);
__webpack_require__(1576);
__webpack_require__(1577);
__webpack_require__(1578);
__webpack_require__(1579);
__webpack_require__(1580);
__webpack_require__(1581);
__webpack_require__(1582);
__webpack_require__(1583);
__webpack_require__(1584);
__webpack_require__(1585);
__webpack_require__(1586);
__webpack_require__(1587);
__webpack_require__(1588);
__webpack_require__(1589);
__webpack_require__(1590);
__webpack_require__(1591);
__webpack_require__(1592);
__webpack_require__(1593);
__webpack_require__(1594);
__webpack_require__(1595);
__webpack_require__(1596);
__webpack_require__(1597);
__webpack_require__(1598);
__webpack_require__(1599);
__webpack_require__(1600);
__webpack_require__(1601);
__webpack_require__(1602);
__webpack_require__(766);
__webpack_require__(766);
__webpack_require__(1603);
__webpack_require__(1604);
__webpack_require__(1605);
__webpack_require__(1606);
__webpack_require__(1607);
__webpack_require__(1608);
__webpack_require__(1609);
__webpack_require__(1610);
__webpack_require__(1611);
__webpack_require__(1612);
__webpack_require__(1613);
__webpack_require__(1614);
__webpack_require__(1615);
__webpack_require__(1616);
__webpack_require__(1617);
__webpack_require__(1618);
__webpack_require__(1619);
__webpack_require__(1620);
__webpack_require__(1621);
__webpack_require__(1622);
__webpack_require__(1623);
__webpack_require__(1624);
__webpack_require__(1625);
__webpack_require__(1626);
__webpack_require__(1627);
__webpack_require__(1628);
__webpack_require__(1629);
__webpack_require__(1630);
__webpack_require__(1631);
__webpack_require__(1632);
__webpack_require__(1633);
__webpack_require__(1634);
__webpack_require__(1635);
__webpack_require__(1636);
__webpack_require__(1637);
__webpack_require__(1638);
__webpack_require__(1639);
__webpack_require__(1640);
__webpack_require__(1641);
__webpack_require__(1642);
__webpack_require__(1643);
__webpack_require__(1644);
__webpack_require__(1645);
__webpack_require__(1646);
__webpack_require__(1647);
__webpack_require__(1648);
__webpack_require__(1649);
__webpack_require__(1650);
__webpack_require__(1651);
__webpack_require__(1652);
__webpack_require__(1653);
__webpack_require__(1654);
__webpack_require__(1655);
__webpack_require__(1656);
__webpack_require__(1657);
__webpack_require__(1658);
__webpack_require__(1659);
__webpack_require__(1660);
__webpack_require__(1661);
__webpack_require__(1662);
__webpack_require__(1663);
__webpack_require__(1664);
module.exports = 'gw-um-j2js';

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(108);
__webpack_require__(65);
__webpack_require__(66);
__webpack_require__(78);

/*@ngInject*/
angular.module('gw-um-email-editor', ['umCore', 'summernote']).value('emailEditorConstant', {
  event: {
    EMAIL_UPDATE_COMPLETE: 'emailEditorModule.EmailUpdateComplete',
    PEOPLE_LIST_LOADED: 'emailModule.PeopleListLoaded'
  }
}).run(function () {});
__webpack_require__(1708);
module.exports = 'gw-um-email-editor';

/***/ }),
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

/*@ngInject*/
angular.module('gw-um-header', ['umCore', 'gw-um-j2js']).constant('headerConstant', {
  event: {
    CLOSE_USER_PROFILE_DROPDOWN: 'headerModule.CloseUserProfileDropdown'
  }
}).run(function () {});
__webpack_require__(1713);
__webpack_require__(1714);
__webpack_require__(1715);
__webpack_require__(1716);
__webpack_require__(1717);
__webpack_require__(1718);
__webpack_require__(1719);
__webpack_require__(770);
__webpack_require__(1720);
__webpack_require__(1721);
__webpack_require__(1722);
__webpack_require__(1723);
__webpack_require__(771);
__webpack_require__(1724);
__webpack_require__(1725);
__webpack_require__(1726);
__webpack_require__(1727);
__webpack_require__(1728);
__webpack_require__(1729);
__webpack_require__(1730);
__webpack_require__(1731);
__webpack_require__(1732);
__webpack_require__(1733);
__webpack_require__(1734);
__webpack_require__(772);
__webpack_require__(1735);
__webpack_require__(1736);
__webpack_require__(1737);
__webpack_require__(1738);
__webpack_require__(1739);
__webpack_require__(1740);
__webpack_require__(1741);
__webpack_require__(1742);
__webpack_require__(1743);
__webpack_require__(1744);
__webpack_require__(1745);
__webpack_require__(1746);
__webpack_require__(1747);
__webpack_require__(1748);
module.exports = 'gw-um-header';

/***/ }),
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(24)(__webpack_require__(982))

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(24)(__webpack_require__(983))

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(24)(__webpack_require__(984))

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(24)(__webpack_require__(985))

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(24)(__webpack_require__(986))

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(24)(__webpack_require__(987))

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(24)(__webpack_require__(988))

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(24)(__webpack_require__(989))

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(24)(__webpack_require__(990))

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var DropdownMediator = function DropdownMediator() {
  this.getDropdownSelectedValueState = function (changes, currentSelectedOption, currentOptionList, placeholder) {
    var isSelectedValueChange = !_.isEmpty(changes.selectedValue);
    var isOptionListChange = !_.isEmpty(changes.optionList);
    if (isSelectedValueChange || isOptionListChange) {
      var selectedValue = _.get(currentSelectedOption, 'value');
      var selectedName = _.get(currentSelectedOption, 'name');
      if (isSelectedValueChange) {
        selectedValue = _.get(changes, 'selectedValue.currentValue');
        selectedName = _.get(changes, 'selectedName.currentValue') || selectedValue;
      }
      var selectedOption = this.findNewSelectedOption(selectedValue, selectedName, currentOptionList);
      var hasSelection = !_.isEmpty(selectedOption);
      var dropdownButtonDisplayText = hasSelection ? selectedOption.name.replace(/</g, '&lt;').replace(/>/g, '&gt;') : placeholder;
      return {
        hasSelection: hasSelection,
        selectedOption: selectedOption,
        dropdownButtonDisplayText: dropdownButtonDisplayText
      };
    }
    return null;
  };
  this.findNewSelectedOption = function (newSelectedValue, newSelectedName, optionList) {
    var isSelectedNewValueEmpty = _.isEmpty(newSelectedValue);
    var result = {};
    if (!isSelectedNewValueEmpty) {
      result = _.find(optionList, {
        value: newSelectedValue
      });
      var missingNewValueObject = _.isEmpty(result);
      if (missingNewValueObject) {
        result = {
          name: newSelectedName,
          value: newSelectedValue
        };
      }
    }
    return result;
  };
};
angular.module('umCore').service('dropdownMediator', DropdownMediator);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 758 */
/***/ (function(module) {

module.exports = JSON.parse("{\"dropdown\":{\"noneOption\":\"(None)\",\"minimumSearchLengthMessage\":\"Please type at least {{ minChars }} character to start search\",\"minimumSearchLengthMessage_plural\":\"Please type at least {{ minChars }} characters to start search\",\"maximumOptionsLimitMessage\":\"Too many results ({{ maxOptions }} items). Please revise your search\",\"remoteSearchCountWarning\":\"Too many results ({{ maxResults }} items). Please revise your search\",\"noMatchesFoundMessage\":\"No matches found. Please try again.\"}}");

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {var PDFObject = __webpack_require__(1396);

/*@ngInject*/
var AttachmentViewerDirective = function AttachmentViewerDirective($timeout, $window, coreConstant, attachmentUtil, mimeType, browserUtil, configuredFileUtil) {
  return {
    restrict: 'AE',
    replace: true,
    templateUrl: '/ui/attachmentViewer/attachmentViewer.tpl.html',
    link: function link($scope, $elem, $attr) {
      $scope.isIE11 = browserUtil.isIE11();
      var timeoutList = [];
      var closing = 0;
      function onClosingModal() {
        closing++;
        setPdfVisibility();
      }
      function setPdfVisibility() {
        // Add timeout to ensure the scope is applied and we immediately hide/show the pdf
        timeoutList.push($timeout(function () {
          var showPdf = !isModalOpen() || $scope.isInModal;
          if (showPdf !== $scope.showPdf) {
            $scope.showPdf = showPdf;
          }
        }, 0));
      }
      function isModalOpen() {
        var modalOpen = false;
        _.each($('.modal'), function (modal) {
          var wrappedModal = $(modal);
          if (wrappedModal.css('visible') !== 'false' && wrappedModal.css('display') !== 'none') {
            // If we are closing modals, ignore the number of modals currently closing
            if (closing > 0) {
              closing--;
            } else {
              modalOpen = true;
            }
          }
        });
        return modalOpen;
      }
      function registerInternetExplorerListeners() {
        setPdfVisibility();
        $scope.$on(coreConstant.event.MODAL_OPENED, setPdfVisibility);
        $scope.$on(coreConstant.event.MODAL_CLOSED, onClosingModal);
      }
      $attr.$observe('attachmentId', function (attachmentId) {
        if (attachmentId) {
          attachmentUtil.getAttachmentLinkURL(attachmentId, $scope.viewModel.attachmentName).then(function (url) {
            $scope.url = url;
            $scope.attachmentId = attachmentId;
            processAttachment();
          });
        }
      });
      $attr.$observe('configuredFileId', function (configuredFileId) {
        if (!_.isNil(configuredFileId)) {
          configuredFileUtil.getConfiguredFileLinkURL(configuredFileId, $scope.viewModel.attachmentName).then(function (url) {
            $scope.url = url;
            $scope.configuredFileId = configuredFileId;
            processAttachment();
          });
        }
      });
      function processAttachment() {
        if ($scope.viewModel.attachmentMimeType === mimeType.PDF || _.endsWith(_.toUpper($scope.viewModel.attachmentName), '.PDF')) {
          $scope.viewModel.showEmbeddedPdf = true;
          if ($scope.isIE11) {
            registerInternetExplorerListeners();
          } else {
            PDFObject.embed($scope.url, '.attachmentViewerEmbed');
          }
        } else {
          $scope.viewModel.showEmbeddedPdf = false;
        }
      }
      $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
          $timeout.cancel(item);
        });
      });
      $scope.onAttachmentOpenClick = function () {
        if (!_.isNil($scope.attachmentId)) {
          attachmentUtil.getAttachmentLinkURL($scope.attachmentId, $scope.viewModel.attachmentName).then(function (url) {
            $window.open(url, '_blank');
          });
        } else if (!_.isNil($scope.configuredFileId)) {
          configuredFileUtil.getConfiguredFileLinkURL($scope.configuredFileId, $scope.viewModel.attachmentName).then(function (url) {
            $window.open(url, '_blank');
          });
        }
      };
    }
  };
};
AttachmentViewerDirective.$inject = ["$timeout", "$window", "coreConstant", "attachmentUtil", "mimeType", "browserUtil", "configuredFileUtil"];
angular.module('umCore').directive('attachmentViewer', AttachmentViewerDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4)))

/***/ }),
/* 760 */
/***/ (function(module, exports) {

var path = '/ui/attachmentViewer/attachmentViewer.tpl.html';
var html = "<div class=\"attachmentViewerContainer\">\n\n    <div ng-show=\"viewModel.showEmbeddedPdf\"\n         ng-class=\"{ 'pdfFrame': showPdf, 'hidePdfFrame': !showPdf }\"\n         class=\"attachmentViewerEmbed\">\n\n        <iframe ng-if=\"isIE11\"\n                ng-src=\"{{ url }}\"\n                class=\"attachmentViewerIFrame\"></iframe>\n    </div>\n\n    <div class=\"attachmentViewerText\"\n         ng-if=\"viewModel.showEmbeddedPdf === false\">\n\n        <span ui-translate>submission.attachment.fileNotPreviewed</span>\n\n        <a class=\"attachmentLink\"\n           ng-click=\"onAttachmentOpenClick()\">{{ viewModel.attachmentName }}</a>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1f84582152b473b3977b2352d9e14cb7.png";

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/ui/userGroupsBrowser/userGroupsBrowser.tpl.html';
var html = "<div class=\"userGroupsBrowser\">\n\n    <!-- Header -->\n    <div class=\"header\">\n        <div class=\"headerContent\">\n            <div class=\"headerLabel\">{{ ::viewModel.title }}</div>\n\n            <action-buttons-bar context=\"context\"\n                                actions=\"actions\"\n                                notify-action-clicked=\"handleAction(action, file)\"\n                                time-last-modified=\"actionsTimeLastModified\"></action-buttons-bar>\n        </div>\n    </div>\n\n    <!-- Tools -->\n    <div class=\"tools\">\n\n        <div class=\"toolsContent\">\n\n            <div class=\"nameSearchStringInput\">\n                <span class=\"glyphicon glyphicon-search\"></span>\n                <input type=\"text\"\n                       ng-model=\"viewModel.nameSearchString\"\n                       ng-model-options=\"{ debounce: viewModel.searchDelayInMilliSeconds }\"\n                       ng-change=\"onNameSearchStringChanged()\"\n                       placeholder=\"{{ ::viewModel.nameSearchStringPlaceholder }}\"></div>\n        </div>\n    </div>\n\n    <!-- Grid -->\n    <div class=\"grid\">\n\n        <div class=\"gridContainer\">\n\n            <!-- Grid Header -->\n            <div class=\"columnHeader\">\n\n                <div class=\"columnRow\">\n\n                    <div class=\"colHover\"></div>\n\n                    <div class=\"colName\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"name\"\n                         item-label=\"userGroupsBrowser.columns.name\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colAutoAssign\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"autoAssign\"\n                         item-label=\"userGroupsBrowser.columns.autoAssign\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colStatus\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"status\"\n                         item-label=\"userGroupsBrowser.columns.status\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colLastEditedBy\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"lastModifiedBy\"\n                         item-label=\"userGroupsBrowser.columns.lastModifiedBy\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colLastModifiedDate\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"timeLastModified\"\n                         item-label=\"userGroupsBrowser.columns.timeLastModified\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n                </div>\n            </div>\n\n\n            <div class=\"datagrid table\"\n                 ux-datagrid=\"viewModel.userGroups\"\n                 ng-if=\"!viewModel.isLoading\"\n                 ui-scroll-detection\n                 ui-scroll-detection-target=\".columnHeader\">\n\n                <script type=\"template/html\"\n                        data-template-item=\"item\"\n                        data-template-name=\"default\">\n\n                    <div class=\"columnRow\">\n\n                        <div class=\"columnRowWrapper\">\n\n                            <div class=\"col colName\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.name }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.name }}\"\n                                      ui-is-tooltip-enabled=\"item.nameTooltip\">{{ ::item.name }}</span>\n                            </div>\n\n                            <div class=\"col colAutoAssign\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.autoAssign }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.autoAssign }}\"\n                                      ui-is-tooltip-enabled=\"item.parentNameTooltip\">{{ ::item.autoAssign }}</span>\n                            </div>\n\n                            <div class=\"col colStatus\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::getStatus(item) }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.codeTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.parentNameTooltip\">{{ ::getStatus(item) }}</span>\n                            </div>\n\n                            <div class=\"col colLastEditedBy\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.lastModifiedBy }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.lastModifiedBy }}\"\n                                      ng-class=\"{'draftStatus': item.isDraftStatus}\"\n                                      ui-is-tooltip-enabled=\"item.lastModifiedByTooltip\">{{ ::item.lastModifiedBy | date: viewModel.shortDateTimeFormat  }}</span>\n                            </div>\n\n                            <div class=\"col colLastModifiedDate\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.timeLastModified | date: viewModel.shortDateTimeFormat }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.timeLastModified }}\"\n                                      ui-is-tooltip-enabled=\"item.timeLastModifiedTooltip\">{{ ::item.timeLastModified | date: viewModel.shortDateTimeFormat }}</span>\n                            </div>\n                        </div>\n                    </div>\n                </script>\n            </div>\n\n            <ui-grid-paging-component\n                ng-hide=\"viewModel.totalUserGroups === 0\"\n                start-index=\"viewModel.requestParams.startIndex\"\n                page-size=\"viewModel.requestParams.pageSize\"\n                total-records=\"viewModel.totalUserGroups\"\n                record-count-text=\"viewModel.recordCountText\"\n                records-count-text=\"viewModel.recordsCountText\"\n                on-change=\"onPagingChange($event, params)\"></ui-grid-paging-component>\n\n            <div class=\"gridEmpty\"\n                 ng-if=\"viewModel.isGridEmpty && !viewModel.isLoading\">{{ ::viewModel.emptyGridLabel }}\n            </div>\n\n            <div class=\"icon-spinner\"\n                 ng-if=\"viewModel.isLoading\">\n                <img src=\"" + __webpack_require__(67) + "\"/>\n            </div>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 763 */
/***/ (function(module, exports) {

/*@ngInject*/
var UserGroupsBrowserRepository = function UserGroupsBrowserRepository(baseRepository, coreMediator) {
  angular.extend(this, baseRepository);
  this.loadUserGroupsActions = function () {
    var url = '/rest/Actions',
      config = {
        params: {
          uri: 'com.firstbest.user.UserGroup:null'
        }
      };
    return this.get(url, config);
  };
  this.getUserGroups = function (nameSearchString, params) {
    var url = '/rest/UserGroup/List',
      config = {
        params: {
          name: nameSearchString,
          startIndex: params.startIndex,
          numberOfRows: params.pageSize,
          sortBy: params.key,
          sortDirection: params.sortType
        }
      };
    return this.get(url, config);
  };
};
UserGroupsBrowserRepository.$inject = ["baseRepository", "coreMediator"];
angular.module('umCore').service('userGroupsBrowserRepository', UserGroupsBrowserRepository);

/***/ }),
/* 764 */
/***/ (function(module, exports) {

var path = '/ui/userGroupEditor/userGroupEditor.tpl.html';
var html = "<div class=\"userGroupEditor\">\n    <div class=\"header\">\n        <ui-user-group-editor-header\n            user-group-name=\"viewModel.userGroup.name\">\n        </ui-user-group-editor-header>\n    </div>\n    <div class=\"formContainer\">\n        <fieldset class=\"subContainer\" ng-disabled=\"{{::!viewModel.hasManagePermission}}\">\n\n            <div class=\"content\">\n                <div class=\"groupInfo\">\n                    <!--User Group Name -->\n                    <div class=\"requiredRow\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.userGroup.name}}\">\n                        </ui-required-indicator>\n                        <div class=\"rowItem\">\n                            <span class=\"userGroupNameLabel\"\n                                  ui-translate>userGroupInformation.userGroupName</span>\n                        </div>\n\n                        <input type=\"text\"\n                               class=\"groupName\"\n                               ng-model=\"viewModel.userGroup.name\"\n                               ng-change=\"onChange()\"\n                               value=\"{{ viewModel.userGroup.name }}\"\n                               placeholder=\"{{::viewModel.userGroup.namePrompt}}\">\n                    </div>\n\n                    <!--User Group Status-->\n                    <div class=\"groupRow\">\n                        <div class=\"rowItem\">\n                            <span class=\"statusLabel\"\n                                  ui-translate>userGroupInformation.statusLabel</span>\n                        </div>\n\n                        <div>\n                            <input type=\"radio\"\n                                   ng-model=\"viewModel.userGroup.status\"\n                                   ng-value=\"viewModel.active\"\n                                   ng-change=\"onChange()\">\n                            <span class=\"radioButtonLabel radioButtonLabelActive\"\n                                  ui-translate>userGroupInformation.active</span>\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle\"\n                                   ng-model=\"viewModel.userGroup.status\"\n                                   ng-value=\"viewModel.inactive\"\n                                   ng-change=\"onChange()\">\n                            <span class=\"radioButtonLabel radioButtonLabelInactive\" ui-translate>userGroupInformation.inactive</span>\n                        </div>\n                    </div>\n\n                    <!--User Group AutoAssign-->\n                    <div class=\"groupRow\">\n                        <div class=\"rowItem\">\n                            <span class=\"taskAssignmentLabel\"\n                                  ui-translate>userGroupInformation.taskAssignment</span>\n                        </div>\n                        <label>\n                            <input type=\"checkbox\"\n                                   ng-model=\"viewModel.userGroup.autoAssign\"\n                                   ng-change=\"onChange()\">\n                            <span class=\"autoAssignTasksCheckboxLabel\"\n                                  ui-translate>userGroupInformation.autoAssignTasks</span>\n                        </label>\n                    </div>\n\n\n                    <div class=\"requiredRow\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.selectedUsersRole.length === 0 ? null : viewModel.selectedUsersRole.length}}\">\n                        </ui-required-indicator>\n\n                        <div class=\"rowItem\">\n                            <span class=\"manageUsersNameLabel\"\n                                  ui-translate>userGroupInformation.manageUsersName</span>\n                        </div>\n\n                        <ui-multi-select\n                            ng-if=\"viewModel.displayList\"\n                            class=\"multiSelect manageUsersNameSelections\"\n                                         items-list=\"viewModel.userList\"\n                                         prompt-value=\"viewModel.searchForStep2\"\n                                         selected-value=\"viewModel.selectedUsers\"\n                                         append-to-body=\"false\"\n                                         auto-expand=\"false\"\n                                         item-name=\"viewModel.itemName\">\n                        </ui-multi-select>\n                    </div>\n                </div>\n\n                <!-- Grid -->\n                <div class=\"grid\">\n\n                    <div class=\"gridContainer\">\n\n                        <!-- Grid Header -->\n                        <div class=\"columnHeader\">\n\n                            <div class=\"users\" ui-translate>userRoleList.title</div>\n\n                            <div class=\"columnRow\">\n\n                                <div class=\"colHover\"></div>\n\n                                <div class=\"colName\"\n                                     ui-grid-sortable-header\n                                     request-params=\"viewModel.requestParams\"\n                                     item-name=\"firstName\"\n                                     item-label=\"userRoleList.columns.name\"\n                                     on-toggle=\"onSortChange($event, params)\"></div>\n\n                                <div class=\"colStatus\"\n                                     ui-grid-sortable-header\n                                     request-params=\"viewModel.requestParams\"\n                                     item-name=\"status\"\n                                     item-label=\"userRoleList.columns.status\"\n                                     on-toggle=\"onSortChange($event, params)\"></div>\n\n                                <div class=\"colUserRole\"\n                                     ui-grid-sortable-header\n                                     request-params=\"viewModel.requestParams\"\n                                     item-name=\"roles\"\n                                     item-label=\"userRoleList.columns.userRole\"\n                                     on-toggle=\"onSortChange($event, params)\"></div>\n\n                                <div class=\"colBranch\"\n                                     ui-grid-sortable-header\n                                     request-params=\"viewModel.requestParams\"\n                                     item-name=\"branchName\"\n                                     item-label=\"userRoleList.columns.branch\"\n                                     on-toggle=\"onSortChange($event, params)\"></div>\n\n                                <div class=\"colAvailable\"\n                                     ui-grid-sortable-header\n                                     request-params=\"viewModel.requestParams\"\n                                     item-name=\"available\"\n                                     item-label=\"userRoleList.columns.available\"\n                                     on-toggle=\"onSortChange($event, params)\"></div>\n                            </div>\n                        </div>\n\n\n                        <div class=\"datagrid table\"\n                             ux-datagrid=\"viewModel.selectedUsersRole\"\n                             ng-if=\"!viewModel.isLoading\"\n                             ui-scroll-detection\n                             ui-scroll-detection-target=\".columnHeader\">\n\n                            <script type=\"template/html\"\n                                    data-template-item=\"item\"\n                                    data-template-name=\"default\">\n\n                                <div class=\"columnRow\">\n\n                                    <div class=\"columnRowWrapper\">\n\n                                        <div class=\"col colName\">\n                                            <span class=\"columnText\">{{ item.firstName}} {{item.lastName}}</span>\n                                        </div>\n\n                                        <div class=\"col colStatus\">\n                                            <span class=\"columnText\">{{ getStatus(item) }}</span>\n                                        </div>\n\n                                        <div class=\"col colUserRole\">\n                                            <span class=\"columnText\">{{ item.roles }}</span>\n                                        </div>\n\n                                        <div class=\"col colBranch\">\n                                            <span class=\"columnText\">{{ item.branchName }}</span>\n                                        </div>\n\n                                        <div class=\"col colAvailable\">\n                                            <label>\n                                                <input type=\"checkbox\"\n                                                       ng-change=\"onChange()\"\n                                                       ng-model=\"item.available\"\n                                                       ng-checked=\"item.available\">\n                                            </label>\n                                        </div>\n                                    </div>\n                                </div>\n                            </script>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </fieldset>\n    </div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UserGroupEditorRepository = function UserGroupEditorRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadUserGroupActions = function (userGroupId) {
    var url = '/rest/Actions',
      config = {
        params: {
          uri: 'com.firstbest.user.UserGroup:' + userGroupId
        }
      };
    return this.get(url, config);
  };
  this.loadUserGroupById = function (userGroupId) {
    var url = '/rest/UserGroup/' + userGroupId;
    return this.get(url);
  };
  this.loadCarrierUserRoles = function () {
    var url = '/rest/UnderwritingUser/carrierUserRoleInfos';
    return this.get(url);
  };
  this.createUserGroup = function (userGroup) {
    var url = '/rest/UserGroup/createUserGroup';
    return this.post(url, userGroup);
  };
  this.saveUserGroup = function (userGroup) {
    var url = '/rest/UserGroup/';
    if (!_.isNil(userGroup.id)) {
      url += userGroup.id;
    }
    return this.post(url, userGroup);
  };
};
UserGroupEditorRepository.$inject = ["baseRepository"];
angular.module('umCore').service('userGroupEditorRepository', UserGroupEditorRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 766 */
/***/ (function(module, exports) {

var notificationType = {
  REGULAR: 0,
  CHAT: 1
};
angular.module('gw-um-j2js').constant('notificationType', notificationType);

/***/ }),
/* 767 */,
/* 768 */,
/* 769 */
/***/ (function(module) {

module.exports = JSON.parse("{\"attachmentTooltip\":\"Add an attachment\",\"type\":\"Type\",\"draftTitle\":\"Draft\",\"invalidEmailAddressTooltip\":\"The email address is incorrectly formatted\",\"cancel\":\"No\",\"confirm\":\"Yes\",\"deleteConfirmationMessage\":\"Are you sure you want to delete this draft email?\",\"deleteConfirmationTitle\":\"Delete Draft\",\"to\":\"To:\",\"bcc\":\"Bcc:\",\"cc\":\"Cc:\",\"ccLink\":\"Cc\",\"bccLink\":\"Bcc\",\"subject\":\"Subject:\",\"saveDraft\":\"Save Draft\",\"send\":\"Send\",\"closeConfirmation\":{\"alternate\":\"No\",\"cancel\":\"Cancel\",\"closeConfirmationMessage\":\"Do you want to save your changes to this email?\",\"closeConfirmationTitle\":\"Close Email\",\"confirm\":\"Yes\",\"invalidCloseConfirmationMessage\":\"You have invalid recipients. Are you sure you want to discard your changes to this email?\"},\"unacceptableTypeAndSize\":{\"unacceptableTypeMessage\":\"File {name} is not a supported document type for upload.\",\"unacceptableTypeTitle\":\"Alert\",\"unacceptableTypeConfirmActionButtonLabel\":\"OK\",\"maxFileSizeMessage\":\"The file you are trying to upload exceeds the maximum allowed file size of {maxSize} MB.\",\"maxFileSizeTitle\":\"File Too Big\"},\"longListMessage\":\"Please revise your search to display users other than submission participants.\"}");

/***/ }),
/* 770 */
/***/ (function(module) {

module.exports = JSON.parse("{\"helpMenu\":{\"onlineHelp\":\"Online Help\",\"aboutUm\":\"About UM\",\"aboutUmStudio\":\"About UM Studio\"},\"url\":{\"prefix\":\"umhelp\",\"index\":\"index.html\",\"Underwriter\":\"UnderwriterHelp\",\"ServiceUser\":\"UnderwriterHelp\",\"Agent\":\"AgentHelp\",\"SystemUser\":\"UMStudioHelp\"},\"tooltip\":\"View help for this system.\"}");

/***/ }),
/* 771 */
/***/ (function(module) {

module.exports = JSON.parse("{\"titleUM\":\"About UM\",\"titleUMStudio\":\"About UM Studio\",\"svnRevision\":\"SVN Revision:\",\"browserInfo\":\"Your Browser:\",\"okButton\":\"OK\",\"umVersionNumber\":\"UM version number:\",\"umStudioVersionNumber\":\"UM Studio version number:\",\"copyright\":\"Copyright &copy; 2006-2017, Guidewire Software, Inc. Additional material Copyright &copy; 2006-2017 World Insurance Company.<b>US Patent 8,073,716 and 8,073,717</b>\"}");

/***/ }),
/* 772 */
/***/ (function(module) {

module.exports = JSON.parse("{\"tooltip\":\"View user profile.\"}");

/***/ }),
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 578,
	"./af.js": 578,
	"./ar": 579,
	"./ar-dz": 580,
	"./ar-dz.js": 580,
	"./ar-kw": 581,
	"./ar-kw.js": 581,
	"./ar-ly": 582,
	"./ar-ly.js": 582,
	"./ar-ma": 583,
	"./ar-ma.js": 583,
	"./ar-ps": 584,
	"./ar-ps.js": 584,
	"./ar-sa": 585,
	"./ar-sa.js": 585,
	"./ar-tn": 586,
	"./ar-tn.js": 586,
	"./ar.js": 579,
	"./az": 587,
	"./az.js": 587,
	"./be": 588,
	"./be.js": 588,
	"./bg": 589,
	"./bg.js": 589,
	"./bm": 590,
	"./bm.js": 590,
	"./bn": 591,
	"./bn-bd": 592,
	"./bn-bd.js": 592,
	"./bn.js": 591,
	"./bo": 593,
	"./bo.js": 593,
	"./br": 594,
	"./br.js": 594,
	"./bs": 595,
	"./bs.js": 595,
	"./ca": 596,
	"./ca.js": 596,
	"./cs": 597,
	"./cs.js": 597,
	"./cv": 598,
	"./cv.js": 598,
	"./cy": 599,
	"./cy.js": 599,
	"./da": 600,
	"./da.js": 600,
	"./de": 601,
	"./de-at": 602,
	"./de-at.js": 602,
	"./de-ch": 603,
	"./de-ch.js": 603,
	"./de.js": 601,
	"./dv": 604,
	"./dv.js": 604,
	"./el": 605,
	"./el.js": 605,
	"./en-au": 606,
	"./en-au.js": 606,
	"./en-ca": 607,
	"./en-ca.js": 607,
	"./en-gb": 608,
	"./en-gb.js": 608,
	"./en-ie": 609,
	"./en-ie.js": 609,
	"./en-il": 610,
	"./en-il.js": 610,
	"./en-in": 611,
	"./en-in.js": 611,
	"./en-nz": 612,
	"./en-nz.js": 612,
	"./en-sg": 613,
	"./en-sg.js": 613,
	"./eo": 614,
	"./eo.js": 614,
	"./es": 615,
	"./es-do": 616,
	"./es-do.js": 616,
	"./es-mx": 617,
	"./es-mx.js": 617,
	"./es-us": 618,
	"./es-us.js": 618,
	"./es.js": 615,
	"./et": 619,
	"./et.js": 619,
	"./eu": 620,
	"./eu.js": 620,
	"./fa": 621,
	"./fa.js": 621,
	"./fi": 622,
	"./fi.js": 622,
	"./fil": 623,
	"./fil.js": 623,
	"./fo": 624,
	"./fo.js": 624,
	"./fr": 625,
	"./fr-ca": 626,
	"./fr-ca.js": 626,
	"./fr-ch": 627,
	"./fr-ch.js": 627,
	"./fr.js": 625,
	"./fy": 628,
	"./fy.js": 628,
	"./ga": 629,
	"./ga.js": 629,
	"./gd": 630,
	"./gd.js": 630,
	"./gl": 631,
	"./gl.js": 631,
	"./gom-deva": 632,
	"./gom-deva.js": 632,
	"./gom-latn": 633,
	"./gom-latn.js": 633,
	"./gu": 634,
	"./gu.js": 634,
	"./he": 635,
	"./he.js": 635,
	"./hi": 636,
	"./hi.js": 636,
	"./hr": 637,
	"./hr.js": 637,
	"./hu": 638,
	"./hu.js": 638,
	"./hy-am": 639,
	"./hy-am.js": 639,
	"./id": 640,
	"./id.js": 640,
	"./is": 641,
	"./is.js": 641,
	"./it": 642,
	"./it-ch": 643,
	"./it-ch.js": 643,
	"./it.js": 642,
	"./ja": 644,
	"./ja.js": 644,
	"./jv": 645,
	"./jv.js": 645,
	"./ka": 646,
	"./ka.js": 646,
	"./kk": 647,
	"./kk.js": 647,
	"./km": 648,
	"./km.js": 648,
	"./kn": 649,
	"./kn.js": 649,
	"./ko": 650,
	"./ko.js": 650,
	"./ku": 651,
	"./ku-kmr": 652,
	"./ku-kmr.js": 652,
	"./ku.js": 651,
	"./ky": 653,
	"./ky.js": 653,
	"./lb": 654,
	"./lb.js": 654,
	"./lo": 655,
	"./lo.js": 655,
	"./lt": 656,
	"./lt.js": 656,
	"./lv": 657,
	"./lv.js": 657,
	"./me": 658,
	"./me.js": 658,
	"./mi": 659,
	"./mi.js": 659,
	"./mk": 660,
	"./mk.js": 660,
	"./ml": 661,
	"./ml.js": 661,
	"./mn": 662,
	"./mn.js": 662,
	"./mr": 663,
	"./mr.js": 663,
	"./ms": 664,
	"./ms-my": 665,
	"./ms-my.js": 665,
	"./ms.js": 664,
	"./mt": 666,
	"./mt.js": 666,
	"./my": 667,
	"./my.js": 667,
	"./nb": 668,
	"./nb.js": 668,
	"./ne": 669,
	"./ne.js": 669,
	"./nl": 670,
	"./nl-be": 671,
	"./nl-be.js": 671,
	"./nl.js": 670,
	"./nn": 672,
	"./nn.js": 672,
	"./oc-lnc": 673,
	"./oc-lnc.js": 673,
	"./pa-in": 674,
	"./pa-in.js": 674,
	"./pl": 675,
	"./pl.js": 675,
	"./pt": 676,
	"./pt-br": 677,
	"./pt-br.js": 677,
	"./pt.js": 676,
	"./ro": 678,
	"./ro.js": 678,
	"./ru": 679,
	"./ru.js": 679,
	"./sd": 680,
	"./sd.js": 680,
	"./se": 681,
	"./se.js": 681,
	"./si": 682,
	"./si.js": 682,
	"./sk": 683,
	"./sk.js": 683,
	"./sl": 684,
	"./sl.js": 684,
	"./sq": 685,
	"./sq.js": 685,
	"./sr": 686,
	"./sr-cyrl": 687,
	"./sr-cyrl.js": 687,
	"./sr.js": 686,
	"./ss": 688,
	"./ss.js": 688,
	"./sv": 689,
	"./sv.js": 689,
	"./sw": 690,
	"./sw.js": 690,
	"./ta": 691,
	"./ta.js": 691,
	"./te": 692,
	"./te.js": 692,
	"./tet": 693,
	"./tet.js": 693,
	"./tg": 694,
	"./tg.js": 694,
	"./th": 695,
	"./th.js": 695,
	"./tk": 696,
	"./tk.js": 696,
	"./tl-ph": 697,
	"./tl-ph.js": 697,
	"./tlh": 698,
	"./tlh.js": 698,
	"./tr": 699,
	"./tr.js": 699,
	"./tzl": 700,
	"./tzl.js": 700,
	"./tzm": 701,
	"./tzm-latn": 702,
	"./tzm-latn.js": 702,
	"./tzm.js": 701,
	"./ug-cn": 703,
	"./ug-cn.js": 703,
	"./uk": 704,
	"./uk.js": 704,
	"./ur": 705,
	"./ur.js": 705,
	"./uz": 706,
	"./uz-latn": 707,
	"./uz-latn.js": 707,
	"./uz.js": 706,
	"./vi": 708,
	"./vi.js": 708,
	"./x-pseudo": 709,
	"./x-pseudo.js": 709,
	"./yo": 710,
	"./yo.js": 710,
	"./zh-cn": 711,
	"./zh-cn.js": 711,
	"./zh-hk": 712,
	"./zh-hk.js": 712,
	"./zh-mo": 713,
	"./zh-mo.js": 713,
	"./zh-tw": 714,
	"./zh-tw.js": 714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 787;

/***/ }),
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */
/***/ (function(module, exports) {

module.exports = "/*global toString */\n(function (angular) {\n  'use strict';\n\n  var isBoolean = function isBoolean(obj) {\n    return obj === true || obj === false || Object.prototype.toString.call(obj) === '[object Boolean]';\n  };\n  angular.module('currencyFilter', []).filter('currency', ['$injector', '$locale', function ($injector, $locale) {\n    var $filter = $injector.get('$filter');\n    var numberFilter = $filter('number');\n    var formats = $locale.NUMBER_FORMATS;\n    var pattern = formats.PATTERNS[1];\n    // https://github.com/angular/angular.js/pull/3642\n    formats.DEFAULT_PRECISION = angular.isUndefined(formats.DEFAULT_PRECISION) ? 2 : formats.DEFAULT_PRECISION;\n    return function (amount, currencySymbol, fractionSize, suffixSymbol, customFormat) {\n      if (!angular.isNumber(amount)) {\n        amount = 0;\n      }\n      if (angular.isObject(currencySymbol)) {\n        customFormat = currencySymbol;\n      }\n      if (angular.isUndefined(currencySymbol) || angular.isObject(currencySymbol)) {\n        currencySymbol = formats.CURRENCY_SYM;\n      }\n      var isNegative = amount < 0;\n      var parts = [];\n      suffixSymbol = isBoolean(fractionSize) ? fractionSize : suffixSymbol;\n      fractionSize = isBoolean(fractionSize) ? formats.DEFAULT_PRECISION : fractionSize;\n      fractionSize = angular.isUndefined(fractionSize) ? formats.DEFAULT_PRECISION : fractionSize;\n      amount = Math.abs(amount);\n      var groupSep = customFormat && angular.isString(customFormat.GROUP_SEP) ? customFormat.GROUP_SEP : formats.GROUP_SEP;\n      var decimalSep = customFormat && angular.isString(customFormat.DECIMAL_SEP) ? customFormat.DECIMAL_SEP : formats.DECIMAL_SEP;\n      var number = numberFilter(amount, fractionSize);\n      var formattedNumber = [];\n      for (var i = 0; i < number.length; i++) {\n        if (number[i] === formats.GROUP_SEP) formattedNumber.push(groupSep);else if (number[i] === formats.DECIMAL_SEP) formattedNumber.push(decimalSep);else formattedNumber.push(number[i]);\n      }\n      formattedNumber = formattedNumber.join('');\n      parts.push(isNegative ? pattern.negPre : pattern.posPre);\n      parts.push(!suffixSymbol ? currencySymbol : formattedNumber);\n      parts.push(suffixSymbol ? currencySymbol : formattedNumber);\n      parts.push(isNegative ? pattern.negSuf : pattern.posSuf);\n      return parts.join('').replace(/\\u00A4/g, '');\n    };\n  }]);\n})(angular);"

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports = "\"use strict\";\n\nangular.module(\"isoCurrency.common\", []).factory(\"iso4217\", function () {\n  var t = {\n    AFN: {\n      text: \"Afghani\",\n      fraction: 2,\n      symbol: \"؋\"\n    },\n    EUR: {\n      text: \"Euro\",\n      fraction: 2,\n      symbol: \"€\"\n    },\n    ALL: {\n      text: \"Lek\",\n      fraction: 2,\n      symbol: \"Lek\"\n    },\n    DZD: {\n      text: \"Algerian Dinar\",\n      fraction: 2,\n      symbol: \"د.ج\"\n    },\n    USD: {\n      text: \"US Dollar\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    AOA: {\n      text: \"Kwanza\",\n      fraction: 2,\n      symbol: \"Kz\"\n    },\n    XCD: {\n      text: \"East Caribbean Dollar\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    ARS: {\n      text: \"Argentine Peso\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    AMD: {\n      text: \"Armenian Dram\",\n      fraction: 2,\n      symbol: !1\n    },\n    AWG: {\n      text: \"Aruban Florin\",\n      fraction: 2,\n      symbol: \"ƒ\"\n    },\n    AUD: {\n      text: \"Australian Dollar\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    AZN: {\n      text: \"Azerbaijani Manat\",\n      fraction: 2,\n      symbol: \"ман\"\n    },\n    BSD: {\n      text: \"Bahamian Dollar\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    BHD: {\n      text: \"Bahraini Dinar\",\n      fraction: 3,\n      symbol: \"BD\"\n    },\n    BDT: {\n      text: \"Taka\",\n      fraction: 2,\n      symbol: \"৳\"\n    },\n    BBD: {\n      text: \"Barbados Dollar\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    BYR: {\n      text: \"Belarusian Ruble\",\n      fraction: 0,\n      symbol: \"p.\"\n    },\n    BZD: {\n      text: \"Belize Dollar\",\n      fraction: 2,\n      symbol: \"BZ$\"\n    },\n    XOF: {\n      text: \"CFA Franc BCEAO\",\n      fraction: 0,\n      symbol: \"CFA\"\n    },\n    BMD: {\n      text: \"Bermudian Dollar\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    BTN: {\n      text: \"Ngultrum\",\n      fraction: 2,\n      symbol: \"Nu\"\n    },\n    INR: {\n      text: \"Indian Rupee\",\n      fraction: 2,\n      symbol: \"₹\"\n    },\n    BOB: {\n      text: \"Boliviano\",\n      fraction: 2,\n      symbol: \"$b\"\n    },\n    BOV: {\n      text: \"Mvdol\",\n      fraction: 2,\n      symbol: \"$b\"\n    },\n    BAM: {\n      text: \"Convertible Mark\",\n      fraction: 2,\n      symbol: \"KM\"\n    },\n    BWP: {\n      text: \"Pula\",\n      fraction: 2,\n      symbol: \"P\"\n    },\n    NOK: {\n      text: \"Norwegian Krone\",\n      fraction: 2,\n      symbol: \"kr\"\n    },\n    BRL: {\n      text: \"Brazilian Real\",\n      fraction: 2,\n      symbol: \"R$\"\n    },\n    BND: {\n      text: \"Brunei Dollar\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    BGN: {\n      text: \"Bulgarian Lev\",\n      fraction: 2,\n      symbol: \"лв\"\n    },\n    BIF: {\n      text: \"Burundian Franc\",\n      fraction: 0,\n      symbol: \"BIF\"\n    },\n    KHR: {\n      text: \"Riel\",\n      fraction: 2,\n      symbol: \"៛\"\n    },\n    XAF: {\n      text: \"CFA Franc BEAC\",\n      fraction: 0,\n      symbol: !1\n    },\n    CAD: {\n      text: \"Canadian Dollar\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    CVE: {\n      text: \"Cabo Verde Escudo\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    KYD: {\n      text: \"Cayman Islands Dollar\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    CLF: {\n      text: \"Unidad de Fomento\",\n      fraction: 4,\n      symbol: !1\n    },\n    CLP: {\n      text: \"Chilean Peso\",\n      fraction: 0,\n      symbol: \"$\"\n    },\n    CNY: {\n      text: \"Yuan Renminbi\",\n      fraction: 2,\n      symbol: \"¥\"\n    },\n    COP: {\n      text: \"Colombian Peso\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    COU: {\n      text: \"Unidad de Valor Real\",\n      fraction: 2,\n      symbol: !1\n    },\n    KMF: {\n      text: \"Comoro Franc\",\n      fraction: 0,\n      symbol: !1\n    },\n    CDF: {\n      text: \"Congolese Franc\",\n      fraction: 2,\n      symbol: !1\n    },\n    NZD: {\n      text: \"New Zealand Dollar\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    CRC: {\n      text: \"Costa Rican Colon\",\n      fraction: 2,\n      symbol: \"₡\"\n    },\n    HRK: {\n      text: \"Croatian Kuna\",\n      fraction: 2,\n      symbol: \"kn\"\n    },\n    CUC: {\n      text: \"Peso Convertible\",\n      fraction: 2,\n      symbol: !1\n    },\n    CUP: {\n      text: \"Cuban Peso\",\n      fraction: 2,\n      symbol: \"₱\"\n    },\n    ANG: {\n      text: \"Netherlands Antillean Guilder\",\n      fraction: 2,\n      symbol: \"ƒ\"\n    },\n    CZK: {\n      text: \"Czech Koruna\",\n      fraction: 2,\n      symbol: \"Kč\"\n    },\n    DKK: {\n      text: \"Danish Krone\",\n      fraction: 2,\n      symbol: \"kr\"\n    },\n    DJF: {\n      text: \"Djibouti Franc\",\n      fraction: 0,\n      symbol: !1\n    },\n    DOP: {\n      text: \"Dominican Peso\",\n      fraction: 2,\n      symbol: \"RD$\"\n    },\n    EGP: {\n      text: \"Egyptian Pound\",\n      fraction: 2,\n      symbol: \"£\"\n    },\n    SVC: {\n      text: \"El Salvador Colon\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    ERN: {\n      text: \"Nakfa\",\n      fraction: 2,\n      symbol: !1\n    },\n    ETB: {\n      text: \"Ethiopian Birr\",\n      fraction: 2,\n      symbol: !1\n    },\n    FKP: {\n      text: \"Falkland Islands Pound\",\n      fraction: 2,\n      symbol: \"£\"\n    },\n    FJD: {\n      text: \"Fiji Dollar\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    XPF: {\n      text: \"CFP Franc\",\n      fraction: 0,\n      symbol: !1\n    },\n    GMD: {\n      text: \"Dalasi\",\n      fraction: 2,\n      symbol: !1\n    },\n    GEL: {\n      text: \"Lari\",\n      fraction: 2,\n      symbol: !1\n    },\n    GHS: {\n      text: \"Ghan Cedi\",\n      fraction: 2,\n      symbol: !1\n    },\n    GIP: {\n      text: \"Gibraltar Pound\",\n      fraction: 2,\n      symbol: \"£\"\n    },\n    GTQ: {\n      text: \"Quetzal\",\n      fraction: 2,\n      symbol: \"Q\"\n    },\n    GBP: {\n      text: \"Pound Sterling\",\n      fraction: 2,\n      symbol: \"£\"\n    },\n    GNF: {\n      text: \"Guinean Franc\",\n      fraction: 0,\n      symbol: !1\n    },\n    GYD: {\n      text: \"Guyanese Dollar\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    HTG: {\n      text: \"Gourde\",\n      fraction: 2,\n      symbol: !1\n    },\n    HNL: {\n      text: \"Lempira\",\n      fraction: 2,\n      symbol: \"L\"\n    },\n    HKD: {\n      text: \"Hong Kong Dollar\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    HUF: {\n      text: \"Forint\",\n      fraction: 2,\n      symbol: \"Ft\"\n    },\n    ISK: {\n      text: \"Iceland Krona\",\n      fraction: 0,\n      symbol: \"kr\"\n    },\n    IDR: {\n      text: \"Rupiah\",\n      fraction: 2,\n      symbol: \"Rp\"\n    },\n    XDR: {\n      text: \"SDR (Special Drawing Right)\",\n      fraction: 0,\n      symbol: !1\n    },\n    IRR: {\n      text: \"Iranian Rial\",\n      fraction: 2,\n      symbol: \"﷼\"\n    },\n    IQD: {\n      text: \"Iraqi Dinar\",\n      fraction: 3,\n      symbol: !1\n    },\n    ILS: {\n      text: \"New Israeli Sheqel\",\n      fraction: 2,\n      symbol: \"₪\"\n    },\n    JMD: {\n      text: \"Jamaican Dollar\",\n      fraction: 2,\n      symbol: \"J$\"\n    },\n    JPY: {\n      text: \"Yen\",\n      fraction: 0,\n      symbol: \"¥\"\n    },\n    JOD: {\n      text: \"Jordanian Dinar\",\n      fraction: 3,\n      symbol: !1\n    },\n    KZT: {\n      text: \"Tenge\",\n      fraction: 2,\n      symbol: \"₸\"\n    },\n    KES: {\n      text: \"Kenyan Shilling\",\n      fraction: 2,\n      symbol: !1\n    },\n    KPW: {\n      text: \"North Korean Won\",\n      fraction: 2,\n      symbol: \"₩\"\n    },\n    KRW: {\n      text: \"Won\",\n      fraction: 0,\n      symbol: \"₩\"\n    },\n    KWD: {\n      text: \"Kuwaiti Dinar\",\n      fraction: 3,\n      symbol: !1\n    },\n    KGS: {\n      text: \"Som\",\n      fraction: 2,\n      symbol: \"som\"\n    },\n    LAK: {\n      text: \"Kip\",\n      fraction: 2,\n      symbol: \"₭\"\n    },\n    LBP: {\n      text: \"Lebanese Pound\",\n      fraction: 2,\n      symbol: \"£\"\n    },\n    LSL: {\n      text: \"Loti\",\n      fraction: 2,\n      symbol: !1\n    },\n    ZAR: {\n      text: \"Rand\",\n      fraction: 2,\n      symbol: \"R\"\n    },\n    LRD: {\n      text: \"Liberian Dollar\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    LYD: {\n      text: \"Libyan Dinar\",\n      fraction: 3,\n      symbol: !1\n    },\n    CHF: {\n      text: \"Swiss Franc\",\n      fraction: 2,\n      symbol: \"CHF\"\n    },\n    LTL: {\n      text: \"Lithuanian Litas\",\n      fraction: 2,\n      symbol: \"Lt\"\n    },\n    MOP: {\n      text: \"Pataca\",\n      fraction: 2,\n      symbol: !1\n    },\n    MKD: {\n      text: \"Denar\",\n      fraction: 2,\n      symbol: \"ден\"\n    },\n    MGA: {\n      text: \"Malagasy riary\",\n      fraction: 2,\n      symbol: !1\n    },\n    MWK: {\n      text: \"Kwacha\",\n      fraction: 2,\n      symbol: !1\n    },\n    MYR: {\n      text: \"Malaysian Ringgit\",\n      fraction: 2,\n      symbol: \"RM\"\n    },\n    MVR: {\n      text: \"Rufiyaa\",\n      fraction: 2,\n      symbol: !1\n    },\n    MRO: {\n      text: \"Ouguiya\",\n      fraction: 2,\n      symbol: !1\n    },\n    MUR: {\n      text: \"Mauritius Rupee\",\n      fraction: 2,\n      symbol: \"₨\"\n    },\n    XUA: {\n      text: \"ADB Unit of account\",\n      fraction: 0,\n      symbol: !1\n    },\n    MXN: {\n      text: \"Mexican Peso\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    MXV: {\n      text: \"Mexican Unidad de Inversion (UDI)\",\n      fraction: 2,\n      symbol: !1\n    },\n    MDL: {\n      text: \"Moldovan Leu\",\n      fraction: 2,\n      symbol: !1\n    },\n    MNT: {\n      text: \"Tugrik\",\n      fraction: 2,\n      symbol: \"₮\"\n    },\n    MAD: {\n      text: \"Moroccan Dirham\",\n      fraction: 2,\n      symbol: !1\n    },\n    MZN: {\n      text: \"Mozambique Metical\",\n      fraction: 2,\n      symbol: \"MT\"\n    },\n    MMK: {\n      text: \"Kyat\",\n      fraction: 2,\n      symbol: !1\n    },\n    NAD: {\n      text: \"Namibian Dollar\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    NPR: {\n      text: \"Nepalese Rupee\",\n      fraction: 2,\n      symbol: \"₨\"\n    },\n    NIO: {\n      text: \"Cordob Oro\",\n      fraction: 2,\n      symbol: \"C$\"\n    },\n    NGN: {\n      text: \"Naira\",\n      fraction: 2,\n      symbol: \"₦\"\n    },\n    OMR: {\n      text: \"Rial Omani\",\n      fraction: 3,\n      symbol: \"﷼\"\n    },\n    PKR: {\n      text: \"Pakistan Rupee\",\n      fraction: 2,\n      symbol: \"₨\"\n    },\n    PAB: {\n      text: \"Balboa\",\n      fraction: 2,\n      symbol: \"B/.\"\n    },\n    PGK: {\n      text: \"Kina\",\n      fraction: 2,\n      symbol: \"K\"\n    },\n    PYG: {\n      text: \"Guarani\",\n      fraction: 0,\n      symbol: \"Gs\"\n    },\n    PEN: {\n      text: \"Nuevo Sol\",\n      fraction: 2,\n      symbol: \"S/.\"\n    },\n    PHP: {\n      text: \"Philippine Peso\",\n      fraction: 2,\n      symbol: \"₱\"\n    },\n    PLN: {\n      text: \"Zloty\",\n      fraction: 2,\n      symbol: \"zł\"\n    },\n    QAR: {\n      text: \"Qatari Rial\",\n      fraction: 2,\n      symbol: \"﷼\"\n    },\n    RON: {\n      text: \"New Romanian Leu\",\n      fraction: 2,\n      symbol: \"lei\"\n    },\n    RUB: {\n      text: \"Russian Ruble\",\n      fraction: 2,\n      symbol: \"руб\"\n    },\n    RWF: {\n      text: \"Rwandan Franc\",\n      fraction: 0,\n      symbol: \"R₣\"\n    },\n    SHP: {\n      text: \"Saint Helena Pound\",\n      fraction: 2,\n      symbol: \"£\"\n    },\n    WST: {\n      text: \"Tala\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    STD: {\n      text: \"Dobra\",\n      fraction: 2,\n      symbol: !1\n    },\n    SAR: {\n      text: \"Saudi Riyal\",\n      fraction: 2,\n      symbol: \"﷼\"\n    },\n    RSD: {\n      text: \"Serbian Dinar\",\n      fraction: 2,\n      symbol: \"Дин.\"\n    },\n    SCR: {\n      text: \"Seychelles Rupee\",\n      fraction: 2,\n      symbol: \"₨\"\n    },\n    SLL: {\n      text: \"Leone\",\n      fraction: 2,\n      symbol: \"Le\"\n    },\n    SGD: {\n      text: \"Singapore Dollar\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    XSU: {\n      text: \"Sucre\",\n      fraction: 0,\n      symbol: !1\n    },\n    SBD: {\n      text: \"Solomon Islands Dollar\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    SOS: {\n      text: \"Somali Shilling\",\n      fraction: 2,\n      symbol: \"S\"\n    },\n    SSP: {\n      text: \"South Sudanese Pound\",\n      fraction: 2,\n      symbol: !1\n    },\n    LKR: {\n      text: \"Sri Lankan Rupee\",\n      fraction: 2,\n      symbol: \"₨\"\n    },\n    SDG: {\n      text: \"Sudanese Pound\",\n      fraction: 2,\n      symbol: !1\n    },\n    SRD: {\n      text: \"Surinam Dollar\",\n      fraction: 2,\n      symbol: \"$\"\n    },\n    SZL: {\n      text: \"Lilangeni\",\n      fraction: 2,\n      symbol: !1\n    },\n    SEK: {\n      text: \"Swedish Krona\",\n      fraction: 2,\n      symbol: \"kr\"\n    },\n    CHE: {\n      text: \"WIR Euro\",\n      fraction: 2,\n      symbol: !1\n    },\n    CHW: {\n      text: \"WIR Franc\",\n      fraction: 2,\n      symbol: !1\n    },\n    SYP: {\n      text: \"Syrian Pound\",\n      fraction: 2,\n      symbol: \"£\"\n    },\n    TWD: {\n      text: \"New Taiwan Dollar\",\n      fraction: 2,\n      symbol: \"NT$\"\n    },\n    TJS: {\n      text: \"Somoni\",\n      fraction: 2,\n      symbol: !1\n    },\n    TZS: {\n      text: \"Tanzanian Shilling\",\n      fraction: 2,\n      symbol: !1\n    },\n    THB: {\n      text: \"Baht\",\n      fraction: 2,\n      symbol: \"฿\"\n    },\n    TOP: {\n      text: \"Pa’anga\",\n      fraction: 2,\n      symbol: !1\n    },\n    TTD: {\n      text: \"Trinidad and Tobago Dollar\",\n      fraction: 2,\n      symbol: \"TT$\"\n    },\n    TND: {\n      text: \"Tunisian Dinar\",\n      fraction: 3,\n      symbol: !1\n    },\n    TRY: {\n      text: \"Turkish Lira\",\n      fraction: 2,\n      symbol: \"₺\"\n    },\n    TMT: {\n      text: \"Turkmenistan New Manat\",\n      fraction: 2,\n      symbol: !1\n    },\n    UGX: {\n      text: \"Ugandan Shilling\",\n      fraction: 0,\n      symbol: !1\n    },\n    UAH: {\n      text: \"Hryvnia\",\n      fraction: 2,\n      symbol: \"₴\"\n    },\n    AED: {\n      text: \"UAE Dirham\",\n      fraction: 2,\n      symbol: !1\n    },\n    USN: {\n      text: \"US Dollar (Next day)\",\n      fraction: 2,\n      symbol: !1\n    },\n    UYI: {\n      text: \"Uruguay Peso en Unidades Indexadas (URUIURUI)\",\n      fraction: 0,\n      symbol: !1\n    },\n    UYU: {\n      text: \"Peso Uruguayo\",\n      fraction: 2,\n      symbol: \"$U\"\n    },\n    UZS: {\n      text: \"Uzbekistan Sum\",\n      fraction: 2,\n      symbol: \"som\"\n    },\n    VUV: {\n      text: \"Vatu\",\n      fraction: 0,\n      symbol: !1\n    },\n    VEF: {\n      text: \"Bolivar\",\n      fraction: 2,\n      symbol: \"Bs\"\n    },\n    VND: {\n      text: \"Dong\",\n      fraction: 0,\n      symbol: \"₫\"\n    },\n    YER: {\n      text: \"Yemeni Rial\",\n      fraction: 2,\n      symbol: \"﷼\"\n    },\n    ZMW: {\n      text: \"Zambian Kwacha\",\n      fraction: 2,\n      symbol: !1\n    },\n    ZWL: {\n      text: \"Zimbabwe Dollar\",\n      fraction: 2,\n      symbol: \"$\"\n    }\n  };\n  return {\n    getCurrencyByCode: function getCurrencyByCode(o) {\n      return o && \"string\" == typeof o ? t[o.toUpperCase()] : void 0;\n    },\n    getCurrencies: function getCurrencies() {\n      return t;\n    }\n  };\n}), angular.module(\"isoCurrency\", [\"isoCurrency.common\"]).filter(\"isoCurrency\", [\"$filter\", \"iso4217\", function (t, o) {\n  return function (a, n, i) {\n    var r = o.getCurrencyByCode(n);\n    if (!r) return a;\n    var e = void 0 === i ? r.fraction : i;\n    return t(\"currency\")(a, r.symbol || n + \" \", e);\n  };\n}]);"

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports = "/*\n * angular-ui-bootstrap\n * http://angular-ui.github.io/bootstrap/\n\n * Version: 2.3.0 - 2016-11-26\n * License: MIT\n */angular.module(\"ui.bootstrap\", [\"ui.bootstrap.tpls\", \"ui.bootstrap.collapse\", \"ui.bootstrap.tabindex\", \"ui.bootstrap.accordion\", \"ui.bootstrap.alert\", \"ui.bootstrap.buttons\", \"ui.bootstrap.carousel\", \"ui.bootstrap.dateparser\", \"ui.bootstrap.isClass\", \"ui.bootstrap.datepicker\", \"ui.bootstrap.position\", \"ui.bootstrap.datepickerPopup\", \"ui.bootstrap.debounce\", \"ui.bootstrap.dropdown\", \"ui.bootstrap.stackedMap\", \"ui.bootstrap.modal\", \"ui.bootstrap.paging\", \"ui.bootstrap.pager\", \"ui.bootstrap.pagination\", \"ui.bootstrap.tooltip\", \"ui.bootstrap.popover\", \"ui.bootstrap.progressbar\", \"ui.bootstrap.rating\", \"ui.bootstrap.tabs\", \"ui.bootstrap.timepicker\", \"ui.bootstrap.typeahead\"]);\nangular.module(\"ui.bootstrap.tpls\", [\"uib/template/accordion/accordion-group.html\", \"uib/template/accordion/accordion.html\", \"uib/template/alert/alert.html\", \"uib/template/carousel/carousel.html\", \"uib/template/carousel/slide.html\", \"uib/template/datepicker/datepicker.html\", \"uib/template/datepicker/day.html\", \"uib/template/datepicker/month.html\", \"uib/template/datepicker/year.html\", \"uib/template/datepickerPopup/popup.html\", \"uib/template/modal/window.html\", \"uib/template/pager/pager.html\", \"uib/template/pagination/pagination.html\", \"uib/template/tooltip/tooltip-html-popup.html\", \"uib/template/tooltip/tooltip-popup.html\", \"uib/template/tooltip/tooltip-template-popup.html\", \"uib/template/popover/popover-html.html\", \"uib/template/popover/popover-template.html\", \"uib/template/popover/popover.html\", \"uib/template/progressbar/bar.html\", \"uib/template/progressbar/progress.html\", \"uib/template/progressbar/progressbar.html\", \"uib/template/rating/rating.html\", \"uib/template/tabs/tab.html\", \"uib/template/tabs/tabset.html\", \"uib/template/timepicker/timepicker.html\", \"uib/template/typeahead/typeahead-match.html\", \"uib/template/typeahead/typeahead-popup.html\"]);\nangular.module('ui.bootstrap.collapse', []).directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function ($animate, $q, $parse, $injector) {\n  var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;\n  return {\n    link: function link(scope, element, attrs) {\n      var expandingExpr = $parse(attrs.expanding),\n        expandedExpr = $parse(attrs.expanded),\n        collapsingExpr = $parse(attrs.collapsing),\n        collapsedExpr = $parse(attrs.collapsed),\n        horizontal = false,\n        css = {},\n        cssTo = {};\n      init();\n      function init() {\n        horizontal = !!('horizontal' in attrs);\n        if (horizontal) {\n          css = {\n            width: ''\n          };\n          cssTo = {\n            width: '0'\n          };\n        } else {\n          css = {\n            height: ''\n          };\n          cssTo = {\n            height: '0'\n          };\n        }\n        if (!scope.$eval(attrs.uibCollapse)) {\n          element.addClass('in').addClass('collapse').attr('aria-expanded', true).attr('aria-hidden', false).css(css);\n        }\n      }\n      function getScrollFromElement(element) {\n        if (horizontal) {\n          return {\n            width: element.scrollWidth + 'px'\n          };\n        }\n        return {\n          height: element.scrollHeight + 'px'\n        };\n      }\n      function expand() {\n        if (element.hasClass('collapse') && element.hasClass('in')) {\n          return;\n        }\n        $q.resolve(expandingExpr(scope)).then(function () {\n          element.removeClass('collapse').addClass('collapsing').attr('aria-expanded', true).attr('aria-hidden', false);\n          if ($animateCss) {\n            $animateCss(element, {\n              addClass: 'in',\n              easing: 'ease',\n              css: {\n                overflow: 'hidden'\n              },\n              to: getScrollFromElement(element[0])\n            }).start()['finally'](expandDone);\n          } else {\n            $animate.addClass(element, 'in', {\n              css: {\n                overflow: 'hidden'\n              },\n              to: getScrollFromElement(element[0])\n            }).then(expandDone);\n          }\n        });\n      }\n      function expandDone() {\n        element.removeClass('collapsing').addClass('collapse').css(css);\n        expandedExpr(scope);\n      }\n      function collapse() {\n        if (!element.hasClass('collapse') && !element.hasClass('in')) {\n          return collapseDone();\n        }\n        $q.resolve(collapsingExpr(scope)).then(function () {\n          element\n          // IMPORTANT: The width must be set before adding \"collapsing\" class.\n          // Otherwise, the browser attempts to animate from width 0 (in\n          // collapsing class) to the given width here.\n          .css(getScrollFromElement(element[0]))\n          // initially all panel collapse have the collapse class, this removal\n          // prevents the animation from jumping to collapsed state\n          .removeClass('collapse').addClass('collapsing').attr('aria-expanded', false).attr('aria-hidden', true);\n          if ($animateCss) {\n            $animateCss(element, {\n              removeClass: 'in',\n              to: cssTo\n            }).start()['finally'](collapseDone);\n          } else {\n            $animate.removeClass(element, 'in', {\n              to: cssTo\n            }).then(collapseDone);\n          }\n        });\n      }\n      function collapseDone() {\n        element.css(cssTo); // Required so that collapse works when animation is disabled\n        element.removeClass('collapsing').addClass('collapse');\n        collapsedExpr(scope);\n      }\n      scope.$watch(attrs.uibCollapse, function (shouldCollapse) {\n        if (shouldCollapse) {\n          collapse();\n        } else {\n          expand();\n        }\n      });\n    }\n  };\n}]);\nangular.module('ui.bootstrap.tabindex', []).directive('uibTabindexToggle', function () {\n  return {\n    restrict: 'A',\n    link: function link(scope, elem, attrs) {\n      attrs.$observe('disabled', function (disabled) {\n        attrs.$set('tabindex', disabled ? -1 : null);\n      });\n    }\n  };\n});\nangular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse', 'ui.bootstrap.tabindex']).constant('uibAccordionConfig', {\n  closeOthers: true\n}).controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function ($scope, $attrs, accordionConfig) {\n  // This array keeps track of the accordion groups\n  this.groups = [];\n\n  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to\n  this.closeOthers = function (openGroup) {\n    var closeOthers = angular.isDefined($attrs.closeOthers) ? $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;\n    if (closeOthers) {\n      angular.forEach(this.groups, function (group) {\n        if (group !== openGroup) {\n          group.isOpen = false;\n        }\n      });\n    }\n  };\n\n  // This is called from the accordion-group directive to add itself to the accordion\n  this.addGroup = function (groupScope) {\n    var that = this;\n    this.groups.push(groupScope);\n    groupScope.$on('$destroy', function (event) {\n      that.removeGroup(groupScope);\n    });\n  };\n\n  // This is called from the accordion-group directive when to remove itself\n  this.removeGroup = function (group) {\n    var index = this.groups.indexOf(group);\n    if (index !== -1) {\n      this.groups.splice(index, 1);\n    }\n  };\n}])\n\n// The accordion directive simply sets up the directive controller\n// and adds an accordion CSS class to itself element.\n.directive('uibAccordion', function () {\n  return {\n    controller: 'UibAccordionController',\n    controllerAs: 'accordion',\n    transclude: true,\n    templateUrl: function templateUrl(element, attrs) {\n      return attrs.templateUrl || 'uib/template/accordion/accordion.html';\n    }\n  };\n})\n\n// The accordion-group directive indicates a block of html that will expand and collapse in an accordion\n.directive('uibAccordionGroup', function () {\n  return {\n    require: '^uibAccordion',\n    // We need this directive to be inside an accordion\n    transclude: true,\n    // It transcludes the contents of the directive into the template\n    restrict: 'A',\n    templateUrl: function templateUrl(element, attrs) {\n      return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';\n    },\n    scope: {\n      heading: '@',\n      // Interpolate the heading attribute onto this scope\n      panelClass: '@?',\n      // Ditto with panelClass\n      isOpen: '=?',\n      isDisabled: '=?'\n    },\n    controller: function controller() {\n      this.setHeading = function (element) {\n        this.heading = element;\n      };\n    },\n    link: function link(scope, element, attrs, accordionCtrl) {\n      element.addClass('panel');\n      accordionCtrl.addGroup(scope);\n      scope.openClass = attrs.openClass || 'panel-open';\n      scope.panelClass = attrs.panelClass || 'panel-default';\n      scope.$watch('isOpen', function (value) {\n        element.toggleClass(scope.openClass, !!value);\n        if (value) {\n          accordionCtrl.closeOthers(scope);\n        }\n      });\n      scope.toggleOpen = function ($event) {\n        if (!scope.isDisabled) {\n          if (!$event || $event.which === 32) {\n            scope.isOpen = !scope.isOpen;\n          }\n        }\n      };\n      var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);\n      scope.headingId = id + '-tab';\n      scope.panelId = id + '-panel';\n    }\n  };\n})\n\n// Use accordion-heading below an accordion-group to provide a heading containing HTML\n.directive('uibAccordionHeading', function () {\n  return {\n    transclude: true,\n    // Grab the contents to be used as the heading\n    template: '',\n    // In effect remove this element!\n    replace: true,\n    require: '^uibAccordionGroup',\n    link: function link(scope, element, attrs, accordionGroupCtrl, transclude) {\n      // Pass the heading to the accordion-group controller\n      // so that it can be transcluded into the right place in the template\n      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]\n      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));\n    }\n  };\n})\n\n// Use in the accordion-group template to indicate where you want the heading to be transcluded\n// You must provide the property on the accordion-group controller that will hold the transcluded element\n.directive('uibAccordionTransclude', function () {\n  return {\n    require: '^uibAccordionGroup',\n    link: function link(scope, element, attrs, controller) {\n      scope.$watch(function () {\n        return controller[attrs.uibAccordionTransclude];\n      }, function (heading) {\n        if (heading) {\n          var elem = angular.element(element[0].querySelector(getHeaderSelectors()));\n          elem.html('');\n          elem.append(heading);\n        }\n      });\n    }\n  };\n  function getHeaderSelectors() {\n    return 'uib-accordion-header,' + 'data-uib-accordion-header,' + 'x-uib-accordion-header,' + 'uib\\\\:accordion-header,' + '[uib-accordion-header],' + '[data-uib-accordion-header],' + '[x-uib-accordion-header]';\n  }\n});\nangular.module('ui.bootstrap.alert', []).controller('UibAlertController', ['$scope', '$element', '$attrs', '$interpolate', '$timeout', function ($scope, $element, $attrs, $interpolate, $timeout) {\n  $scope.closeable = !!$attrs.close;\n  $element.addClass('alert');\n  $attrs.$set('role', 'alert');\n  if ($scope.closeable) {\n    $element.addClass('alert-dismissible');\n  }\n  var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ? $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;\n  if (dismissOnTimeout) {\n    $timeout(function () {\n      $scope.close();\n    }, parseInt(dismissOnTimeout, 10));\n  }\n}]).directive('uibAlert', function () {\n  return {\n    controller: 'UibAlertController',\n    controllerAs: 'alert',\n    restrict: 'A',\n    templateUrl: function templateUrl(element, attrs) {\n      return attrs.templateUrl || 'uib/template/alert/alert.html';\n    },\n    transclude: true,\n    scope: {\n      close: '&'\n    }\n  };\n});\nangular.module('ui.bootstrap.buttons', []).constant('uibButtonConfig', {\n  activeClass: 'active',\n  toggleEvent: 'click'\n}).controller('UibButtonsController', ['uibButtonConfig', function (buttonConfig) {\n  this.activeClass = buttonConfig.activeClass || 'active';\n  this.toggleEvent = buttonConfig.toggleEvent || 'click';\n}]).directive('uibBtnRadio', ['$parse', function ($parse) {\n  return {\n    require: ['uibBtnRadio', 'ngModel'],\n    controller: 'UibButtonsController',\n    controllerAs: 'buttons',\n    link: function link(scope, element, attrs, ctrls) {\n      var buttonsCtrl = ctrls[0],\n        ngModelCtrl = ctrls[1];\n      var uncheckableExpr = $parse(attrs.uibUncheckable);\n      element.find('input').css({\n        display: 'none'\n      });\n\n      //model -> UI\n      ngModelCtrl.$render = function () {\n        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));\n      };\n\n      //ui->model\n      element.on(buttonsCtrl.toggleEvent, function () {\n        if (attrs.disabled) {\n          return;\n        }\n        var isActive = element.hasClass(buttonsCtrl.activeClass);\n        if (!isActive || angular.isDefined(attrs.uncheckable)) {\n          scope.$apply(function () {\n            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));\n            ngModelCtrl.$render();\n          });\n        }\n      });\n      if (attrs.uibUncheckable) {\n        scope.$watch(uncheckableExpr, function (uncheckable) {\n          attrs.$set('uncheckable', uncheckable ? '' : undefined);\n        });\n      }\n    }\n  };\n}]).directive('uibBtnCheckbox', function () {\n  return {\n    require: ['uibBtnCheckbox', 'ngModel'],\n    controller: 'UibButtonsController',\n    controllerAs: 'button',\n    link: function link(scope, element, attrs, ctrls) {\n      var buttonsCtrl = ctrls[0],\n        ngModelCtrl = ctrls[1];\n      element.find('input').css({\n        display: 'none'\n      });\n      function getTrueValue() {\n        return getCheckboxValue(attrs.btnCheckboxTrue, true);\n      }\n      function getFalseValue() {\n        return getCheckboxValue(attrs.btnCheckboxFalse, false);\n      }\n      function getCheckboxValue(attribute, defaultValue) {\n        return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;\n      }\n\n      //model -> UI\n      ngModelCtrl.$render = function () {\n        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));\n      };\n\n      //ui->model\n      element.on(buttonsCtrl.toggleEvent, function () {\n        if (attrs.disabled) {\n          return;\n        }\n        scope.$apply(function () {\n          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());\n          ngModelCtrl.$render();\n        });\n      });\n    }\n  };\n});\nangular.module('ui.bootstrap.carousel', []).controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function ($scope, $element, $interval, $timeout, $animate) {\n  var self = this,\n    slides = self.slides = $scope.slides = [],\n    SLIDE_DIRECTION = 'uib-slideDirection',\n    currentIndex = $scope.active,\n    currentInterval,\n    isPlaying,\n    bufferedTransitions = [];\n  var destroyed = false;\n  $element.addClass('carousel');\n  self.addSlide = function (slide, element) {\n    slides.push({\n      slide: slide,\n      element: element\n    });\n    slides.sort(function (a, b) {\n      return +a.slide.index - +b.slide.index;\n    });\n    //if this is the first slide or the slide is set to active, select it\n    if (slide.index === $scope.active || slides.length === 1 && !angular.isNumber($scope.active)) {\n      if ($scope.$currentTransition) {\n        $scope.$currentTransition = null;\n      }\n      currentIndex = slide.index;\n      $scope.active = slide.index;\n      setActive(currentIndex);\n      self.select(slides[findSlideIndex(slide)]);\n      if (slides.length === 1) {\n        $scope.play();\n      }\n    }\n  };\n  self.getCurrentIndex = function () {\n    for (var i = 0; i < slides.length; i++) {\n      if (slides[i].slide.index === currentIndex) {\n        return i;\n      }\n    }\n  };\n  self.next = $scope.next = function () {\n    var newIndex = (self.getCurrentIndex() + 1) % slides.length;\n    if (newIndex === 0 && $scope.noWrap()) {\n      $scope.pause();\n      return;\n    }\n    return self.select(slides[newIndex], 'next');\n  };\n  self.prev = $scope.prev = function () {\n    var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;\n    if ($scope.noWrap() && newIndex === slides.length - 1) {\n      $scope.pause();\n      return;\n    }\n    return self.select(slides[newIndex], 'prev');\n  };\n  self.removeSlide = function (slide) {\n    var index = findSlideIndex(slide);\n    var bufferedIndex = bufferedTransitions.indexOf(slides[index]);\n    if (bufferedIndex !== -1) {\n      bufferedTransitions.splice(bufferedIndex, 1);\n    }\n\n    //get the index of the slide inside the carousel\n    slides.splice(index, 1);\n    if (slides.length > 0 && currentIndex === index) {\n      if (index >= slides.length) {\n        currentIndex = slides.length - 1;\n        $scope.active = currentIndex;\n        setActive(currentIndex);\n        self.select(slides[slides.length - 1]);\n      } else {\n        currentIndex = index;\n        $scope.active = currentIndex;\n        setActive(currentIndex);\n        self.select(slides[index]);\n      }\n    } else if (currentIndex > index) {\n      currentIndex--;\n      $scope.active = currentIndex;\n    }\n\n    //clean the active value when no more slide\n    if (slides.length === 0) {\n      currentIndex = null;\n      $scope.active = null;\n      clearBufferedTransitions();\n    }\n  };\n\n  /* direction: \"prev\" or \"next\" */\n  self.select = $scope.select = function (nextSlide, direction) {\n    var nextIndex = findSlideIndex(nextSlide.slide);\n    //Decide direction if it's not given\n    if (direction === undefined) {\n      direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';\n    }\n    //Prevent this user-triggered transition from occurring if there is already one in progress\n    if (nextSlide.slide.index !== currentIndex && !$scope.$currentTransition) {\n      goNext(nextSlide.slide, nextIndex, direction);\n    } else if (nextSlide && nextSlide.slide.index !== currentIndex && $scope.$currentTransition) {\n      bufferedTransitions.push(slides[nextIndex]);\n    }\n  };\n\n  /* Allow outside people to call indexOf on slides array */\n  $scope.indexOfSlide = function (slide) {\n    return +slide.slide.index;\n  };\n  $scope.isActive = function (slide) {\n    return $scope.active === slide.slide.index;\n  };\n  $scope.isPrevDisabled = function () {\n    return $scope.active === 0 && $scope.noWrap();\n  };\n  $scope.isNextDisabled = function () {\n    return $scope.active === slides.length - 1 && $scope.noWrap();\n  };\n  $scope.pause = function () {\n    if (!$scope.noPause) {\n      isPlaying = false;\n      resetTimer();\n    }\n  };\n  $scope.play = function () {\n    if (!isPlaying) {\n      isPlaying = true;\n      restartTimer();\n    }\n  };\n  $element.on('mouseenter', $scope.pause);\n  $element.on('mouseleave', $scope.play);\n  $scope.$on('$destroy', function () {\n    destroyed = true;\n    resetTimer();\n  });\n  $scope.$watch('noTransition', function (noTransition) {\n    $animate.enabled($element, !noTransition);\n  });\n  $scope.$watch('interval', restartTimer);\n  $scope.$watchCollection('slides', resetTransition);\n  $scope.$watch('active', function (index) {\n    if (angular.isNumber(index) && currentIndex !== index) {\n      for (var i = 0; i < slides.length; i++) {\n        if (slides[i].slide.index === index) {\n          index = i;\n          break;\n        }\n      }\n      var slide = slides[index];\n      if (slide) {\n        setActive(index);\n        self.select(slides[index]);\n        currentIndex = index;\n      }\n    }\n  });\n  function clearBufferedTransitions() {\n    while (bufferedTransitions.length) {\n      bufferedTransitions.shift();\n    }\n  }\n  function getSlideByIndex(index) {\n    for (var i = 0, l = slides.length; i < l; ++i) {\n      if (slides[i].index === index) {\n        return slides[i];\n      }\n    }\n  }\n  function setActive(index) {\n    for (var i = 0; i < slides.length; i++) {\n      slides[i].slide.active = i === index;\n    }\n  }\n  function goNext(slide, index, direction) {\n    if (destroyed) {\n      return;\n    }\n    angular.extend(slide, {\n      direction: direction\n    });\n    angular.extend(slides[currentIndex].slide || {}, {\n      direction: direction\n    });\n    if ($animate.enabled($element) && !$scope.$currentTransition && slides[index].element && self.slides.length > 1) {\n      slides[index].element.data(SLIDE_DIRECTION, slide.direction);\n      var currentIdx = self.getCurrentIndex();\n      if (angular.isNumber(currentIdx) && slides[currentIdx].element) {\n        slides[currentIdx].element.data(SLIDE_DIRECTION, slide.direction);\n      }\n      $scope.$currentTransition = true;\n      $animate.on('addClass', slides[index].element, function (element, phase) {\n        if (phase === 'close') {\n          $scope.$currentTransition = null;\n          $animate.off('addClass', element);\n          if (bufferedTransitions.length) {\n            var nextSlide = bufferedTransitions.pop().slide;\n            var nextIndex = nextSlide.index;\n            var nextDirection = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';\n            clearBufferedTransitions();\n            goNext(nextSlide, nextIndex, nextDirection);\n          }\n        }\n      });\n    }\n    $scope.active = slide.index;\n    currentIndex = slide.index;\n    setActive(index);\n\n    //every time you change slides, reset the timer\n    restartTimer();\n  }\n  function findSlideIndex(slide) {\n    for (var i = 0; i < slides.length; i++) {\n      if (slides[i].slide === slide) {\n        return i;\n      }\n    }\n  }\n  function resetTimer() {\n    if (currentInterval) {\n      $interval.cancel(currentInterval);\n      currentInterval = null;\n    }\n  }\n  function resetTransition(slides) {\n    if (!slides.length) {\n      $scope.$currentTransition = null;\n      clearBufferedTransitions();\n    }\n  }\n  function restartTimer() {\n    resetTimer();\n    var interval = +$scope.interval;\n    if (!isNaN(interval) && interval > 0) {\n      currentInterval = $interval(timerFn, interval);\n    }\n  }\n  function timerFn() {\n    var interval = +$scope.interval;\n    if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {\n      $scope.next();\n    } else {\n      $scope.pause();\n    }\n  }\n}]).directive('uibCarousel', function () {\n  return {\n    transclude: true,\n    controller: 'UibCarouselController',\n    controllerAs: 'carousel',\n    restrict: 'A',\n    templateUrl: function templateUrl(element, attrs) {\n      return attrs.templateUrl || 'uib/template/carousel/carousel.html';\n    },\n    scope: {\n      active: '=',\n      interval: '=',\n      noTransition: '=',\n      noPause: '=',\n      noWrap: '&'\n    }\n  };\n}).directive('uibSlide', ['$animate', function ($animate) {\n  return {\n    require: '^uibCarousel',\n    restrict: 'A',\n    transclude: true,\n    templateUrl: function templateUrl(element, attrs) {\n      return attrs.templateUrl || 'uib/template/carousel/slide.html';\n    },\n    scope: {\n      actual: '=?',\n      index: '=?'\n    },\n    link: function link(scope, element, attrs, carouselCtrl) {\n      element.addClass('item');\n      carouselCtrl.addSlide(scope, element);\n      //when the scope is destroyed then remove the slide from the current slides array\n      scope.$on('$destroy', function () {\n        carouselCtrl.removeSlide(scope);\n      });\n      scope.$watch('active', function (active) {\n        $animate[active ? 'addClass' : 'removeClass'](element, 'active');\n      });\n    }\n  };\n}]).animation('.item', ['$animateCss', function ($animateCss) {\n  var SLIDE_DIRECTION = 'uib-slideDirection';\n  function removeClass(element, className, callback) {\n    element.removeClass(className);\n    if (callback) {\n      callback();\n    }\n  }\n  return {\n    beforeAddClass: function beforeAddClass(element, className, done) {\n      if (className === 'active') {\n        var stopped = false;\n        var direction = element.data(SLIDE_DIRECTION);\n        var directionClass = direction === 'next' ? 'left' : 'right';\n        var removeClassFn = removeClass.bind(this, element, directionClass + ' ' + direction, done);\n        element.addClass(direction);\n        $animateCss(element, {\n          addClass: directionClass\n        }).start().done(removeClassFn);\n        return function () {\n          stopped = true;\n        };\n      }\n      done();\n    },\n    beforeRemoveClass: function beforeRemoveClass(element, className, done) {\n      if (className === 'active') {\n        var stopped = false;\n        var direction = element.data(SLIDE_DIRECTION);\n        var directionClass = direction === 'next' ? 'left' : 'right';\n        var removeClassFn = removeClass.bind(this, element, directionClass, done);\n        $animateCss(element, {\n          addClass: directionClass\n        }).start().done(removeClassFn);\n        return function () {\n          stopped = true;\n        };\n      }\n      done();\n    }\n  };\n}]);\nangular.module('ui.bootstrap.dateparser', []).service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', function ($log, $locale, dateFilter, orderByFilter) {\n  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js\n  var SPECIAL_CHARACTERS_REGEXP = /[\\\\\\^\\$\\*\\+\\?\\|\\[\\]\\(\\)\\.\\{\\}]/g;\n  var localeId;\n  var formatCodeToRegex;\n  this.init = function () {\n    localeId = $locale.id;\n    this.parsers = {};\n    this.formatters = {};\n    formatCodeToRegex = [{\n      key: 'yyyy',\n      regex: '\\\\d{4}',\n      apply: function apply(value) {\n        this.year = +value;\n      },\n      formatter: function formatter(date) {\n        var _date = new Date();\n        _date.setFullYear(Math.abs(date.getFullYear()));\n        return dateFilter(_date, 'yyyy');\n      }\n    }, {\n      key: 'yy',\n      regex: '\\\\d{2}',\n      apply: function apply(value) {\n        value = +value;\n        this.year = value < 69 ? value + 2000 : value + 1900;\n      },\n      formatter: function formatter(date) {\n        var _date = new Date();\n        _date.setFullYear(Math.abs(date.getFullYear()));\n        return dateFilter(_date, 'yy');\n      }\n    }, {\n      key: 'y',\n      regex: '\\\\d{1,4}',\n      apply: function apply(value) {\n        this.year = +value;\n      },\n      formatter: function formatter(date) {\n        var _date = new Date();\n        _date.setFullYear(Math.abs(date.getFullYear()));\n        return dateFilter(_date, 'y');\n      }\n    }, {\n      key: 'M!',\n      regex: '0?[1-9]|1[0-2]',\n      apply: function apply(value) {\n        this.month = value - 1;\n      },\n      formatter: function formatter(date) {\n        var value = date.getMonth();\n        if (/^[0-9]$/.test(value)) {\n          return dateFilter(date, 'MM');\n        }\n        return dateFilter(date, 'M');\n      }\n    }, {\n      key: 'MMMM',\n      regex: $locale.DATETIME_FORMATS.MONTH.join('|'),\n      apply: function apply(value) {\n        this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value);\n      },\n      formatter: function formatter(date) {\n        return dateFilter(date, 'MMMM');\n      }\n    }, {\n      key: 'MMM',\n      regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),\n      apply: function apply(value) {\n        this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value);\n      },\n      formatter: function formatter(date) {\n        return dateFilter(date, 'MMM');\n      }\n    }, {\n      key: 'MM',\n      regex: '0[1-9]|1[0-2]',\n      apply: function apply(value) {\n        this.month = value - 1;\n      },\n      formatter: function formatter(date) {\n        return dateFilter(date, 'MM');\n      }\n    }, {\n      key: 'M',\n      regex: '[1-9]|1[0-2]',\n      apply: function apply(value) {\n        this.month = value - 1;\n      },\n      formatter: function formatter(date) {\n        return dateFilter(date, 'M');\n      }\n    }, {\n      key: 'LLLL',\n      regex: $locale.DATETIME_FORMATS.STANDALONEMONTH.join('|'),\n      apply: function apply(value) {\n        this.month = $locale.DATETIME_FORMATS.STANDALONEMONTH.indexOf(value);\n      },\n      formatter: function formatter(date) {\n        return dateFilter(date, 'LLLL');\n      }\n    }, {\n      key: 'd!',\n      regex: '[0-2]?[0-9]{1}|3[0-1]{1}',\n      apply: function apply(value) {\n        this.date = +value;\n      },\n      formatter: function formatter(date) {\n        var value = date.getDate();\n        if (/^[1-9]$/.test(value)) {\n          return dateFilter(date, 'dd');\n        }\n        return dateFilter(date, 'd');\n      }\n    }, {\n      key: 'dd',\n      regex: '[0-2][0-9]{1}|3[0-1]{1}',\n      apply: function apply(value) {\n        this.date = +value;\n      },\n      formatter: function formatter(date) {\n        return dateFilter(date, 'dd');\n      }\n    }, {\n      key: 'd',\n      regex: '[1-2]?[0-9]{1}|3[0-1]{1}',\n      apply: function apply(value) {\n        this.date = +value;\n      },\n      formatter: function formatter(date) {\n        return dateFilter(date, 'd');\n      }\n    }, {\n      key: 'EEEE',\n      regex: $locale.DATETIME_FORMATS.DAY.join('|'),\n      formatter: function formatter(date) {\n        return dateFilter(date, 'EEEE');\n      }\n    }, {\n      key: 'EEE',\n      regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),\n      formatter: function formatter(date) {\n        return dateFilter(date, 'EEE');\n      }\n    }, {\n      key: 'HH',\n      regex: '(?:0|1)[0-9]|2[0-3]',\n      apply: function apply(value) {\n        this.hours = +value;\n      },\n      formatter: function formatter(date) {\n        return dateFilter(date, 'HH');\n      }\n    }, {\n      key: 'hh',\n      regex: '0[0-9]|1[0-2]',\n      apply: function apply(value) {\n        this.hours = +value;\n      },\n      formatter: function formatter(date) {\n        return dateFilter(date, 'hh');\n      }\n    }, {\n      key: 'H',\n      regex: '1?[0-9]|2[0-3]',\n      apply: function apply(value) {\n        this.hours = +value;\n      },\n      formatter: function formatter(date) {\n        return dateFilter(date, 'H');\n      }\n    }, {\n      key: 'h',\n      regex: '[0-9]|1[0-2]',\n      apply: function apply(value) {\n        this.hours = +value;\n      },\n      formatter: function formatter(date) {\n        return dateFilter(date, 'h');\n      }\n    }, {\n      key: 'mm',\n      regex: '[0-5][0-9]',\n      apply: function apply(value) {\n        this.minutes = +value;\n      },\n      formatter: function formatter(date) {\n        return dateFilter(date, 'mm');\n      }\n    }, {\n      key: 'm',\n      regex: '[0-9]|[1-5][0-9]',\n      apply: function apply(value) {\n        this.minutes = +value;\n      },\n      formatter: function formatter(date) {\n        return dateFilter(date, 'm');\n      }\n    }, {\n      key: 'sss',\n      regex: '[0-9][0-9][0-9]',\n      apply: function apply(value) {\n        this.milliseconds = +value;\n      },\n      formatter: function formatter(date) {\n        return dateFilter(date, 'sss');\n      }\n    }, {\n      key: 'ss',\n      regex: '[0-5][0-9]',\n      apply: function apply(value) {\n        this.seconds = +value;\n      },\n      formatter: function formatter(date) {\n        return dateFilter(date, 'ss');\n      }\n    }, {\n      key: 's',\n      regex: '[0-9]|[1-5][0-9]',\n      apply: function apply(value) {\n        this.seconds = +value;\n      },\n      formatter: function formatter(date) {\n        return dateFilter(date, 's');\n      }\n    }, {\n      key: 'a',\n      regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),\n      apply: function apply(value) {\n        if (this.hours === 12) {\n          this.hours = 0;\n        }\n        if (value === 'PM') {\n          this.hours += 12;\n        }\n      },\n      formatter: function formatter(date) {\n        return dateFilter(date, 'a');\n      }\n    }, {\n      key: 'Z',\n      regex: '[+-]\\\\d{4}',\n      apply: function apply(value) {\n        var matches = value.match(/([+-])(\\d{2})(\\d{2})/),\n          sign = matches[1],\n          hours = matches[2],\n          minutes = matches[3];\n        this.hours += toInt(sign + hours);\n        this.minutes += toInt(sign + minutes);\n      },\n      formatter: function formatter(date) {\n        return dateFilter(date, 'Z');\n      }\n    }, {\n      key: 'ww',\n      regex: '[0-4][0-9]|5[0-3]',\n      formatter: function formatter(date) {\n        return dateFilter(date, 'ww');\n      }\n    }, {\n      key: 'w',\n      regex: '[0-9]|[1-4][0-9]|5[0-3]',\n      formatter: function formatter(date) {\n        return dateFilter(date, 'w');\n      }\n    }, {\n      key: 'GGGG',\n      regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\\s/g, '\\\\s'),\n      formatter: function formatter(date) {\n        return dateFilter(date, 'GGGG');\n      }\n    }, {\n      key: 'GGG',\n      regex: $locale.DATETIME_FORMATS.ERAS.join('|'),\n      formatter: function formatter(date) {\n        return dateFilter(date, 'GGG');\n      }\n    }, {\n      key: 'GG',\n      regex: $locale.DATETIME_FORMATS.ERAS.join('|'),\n      formatter: function formatter(date) {\n        return dateFilter(date, 'GG');\n      }\n    }, {\n      key: 'G',\n      regex: $locale.DATETIME_FORMATS.ERAS.join('|'),\n      formatter: function formatter(date) {\n        return dateFilter(date, 'G');\n      }\n    }];\n  };\n  this.init();\n  function createParser(format) {\n    var map = [],\n      regex = format.split('');\n\n    // check for literal values\n    var quoteIndex = format.indexOf('\\'');\n    if (quoteIndex > -1) {\n      var inLiteral = false;\n      format = format.split('');\n      for (var i = quoteIndex; i < format.length; i++) {\n        if (inLiteral) {\n          if (format[i] === '\\'') {\n            if (i + 1 < format.length && format[i + 1] === '\\'') {\n              // escaped single quote\n              format[i + 1] = '$';\n              regex[i + 1] = '';\n            } else {\n              // end of literal\n              regex[i] = '';\n              inLiteral = false;\n            }\n          }\n          format[i] = '$';\n        } else {\n          if (format[i] === '\\'') {\n            // start of literal\n            format[i] = '$';\n            regex[i] = '';\n            inLiteral = true;\n          }\n        }\n      }\n      format = format.join('');\n    }\n    angular.forEach(formatCodeToRegex, function (data) {\n      var index = format.indexOf(data.key);\n      if (index > -1) {\n        format = format.split('');\n        regex[index] = '(' + data.regex + ')';\n        format[index] = '$'; // Custom symbol to define consumed part of format\n        for (var i = index + 1, n = index + data.key.length; i < n; i++) {\n          regex[i] = '';\n          format[i] = '$';\n        }\n        format = format.join('');\n        map.push({\n          index: index,\n          key: data.key,\n          apply: data.apply,\n          matcher: data.regex\n        });\n      }\n    });\n    return {\n      regex: new RegExp('^' + regex.join('') + '$'),\n      map: orderByFilter(map, 'index')\n    };\n  }\n  function createFormatter(format) {\n    var formatters = [];\n    var i = 0;\n    var formatter, literalIdx;\n    while (i < format.length) {\n      if (angular.isNumber(literalIdx)) {\n        if (format.charAt(i) === '\\'') {\n          if (i + 1 >= format.length || format.charAt(i + 1) !== '\\'') {\n            formatters.push(constructLiteralFormatter(format, literalIdx, i));\n            literalIdx = null;\n          }\n        } else if (i === format.length) {\n          while (literalIdx < format.length) {\n            formatter = constructFormatterFromIdx(format, literalIdx);\n            formatters.push(formatter);\n            literalIdx = formatter.endIdx;\n          }\n        }\n        i++;\n        continue;\n      }\n      if (format.charAt(i) === '\\'') {\n        literalIdx = i;\n        i++;\n        continue;\n      }\n      formatter = constructFormatterFromIdx(format, i);\n      formatters.push(formatter.parser);\n      i = formatter.endIdx;\n    }\n    return formatters;\n  }\n  function constructLiteralFormatter(format, literalIdx, endIdx) {\n    return function () {\n      return format.substr(literalIdx + 1, endIdx - literalIdx - 1);\n    };\n  }\n  function constructFormatterFromIdx(format, i) {\n    var currentPosStr = format.substr(i);\n    for (var j = 0; j < formatCodeToRegex.length; j++) {\n      if (new RegExp('^' + formatCodeToRegex[j].key).test(currentPosStr)) {\n        var data = formatCodeToRegex[j];\n        return {\n          endIdx: i + data.key.length,\n          parser: data.formatter\n        };\n      }\n    }\n    return {\n      endIdx: i + 1,\n      parser: function parser() {\n        return currentPosStr.charAt(0);\n      }\n    };\n  }\n  this.filter = function (date, format) {\n    if (!angular.isDate(date) || isNaN(date) || !format) {\n      return '';\n    }\n    format = $locale.DATETIME_FORMATS[format] || format;\n    if ($locale.id !== localeId) {\n      this.init();\n    }\n    if (!this.formatters[format]) {\n      this.formatters[format] = createFormatter(format);\n    }\n    var formatters = this.formatters[format];\n    return formatters.reduce(function (str, formatter) {\n      return str + formatter(date);\n    }, '');\n  };\n  this.parse = function (input, format, baseDate) {\n    if (!angular.isString(input) || !format) {\n      return input;\n    }\n    format = $locale.DATETIME_FORMATS[format] || format;\n    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\\\$&');\n    if ($locale.id !== localeId) {\n      this.init();\n    }\n    if (!this.parsers[format]) {\n      this.parsers[format] = createParser(format, 'apply');\n    }\n    var parser = this.parsers[format],\n      regex = parser.regex,\n      map = parser.map,\n      results = input.match(regex),\n      tzOffset = false;\n    if (results && results.length) {\n      var fields, dt;\n      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {\n        fields = {\n          year: baseDate.getFullYear(),\n          month: baseDate.getMonth(),\n          date: baseDate.getDate(),\n          hours: baseDate.getHours(),\n          minutes: baseDate.getMinutes(),\n          seconds: baseDate.getSeconds(),\n          milliseconds: baseDate.getMilliseconds()\n        };\n      } else {\n        if (baseDate) {\n          $log.warn('dateparser:', 'baseDate is not a valid date');\n        }\n        fields = {\n          year: 1900,\n          month: 0,\n          date: 1,\n          hours: 0,\n          minutes: 0,\n          seconds: 0,\n          milliseconds: 0\n        };\n      }\n      for (var i = 1, n = results.length; i < n; i++) {\n        var mapper = map[i - 1];\n        if (mapper.matcher === 'Z') {\n          tzOffset = true;\n        }\n        if (mapper.apply) {\n          mapper.apply.call(fields, results[i]);\n        }\n      }\n      var datesetter = tzOffset ? Date.prototype.setUTCFullYear : Date.prototype.setFullYear;\n      var timesetter = tzOffset ? Date.prototype.setUTCHours : Date.prototype.setHours;\n      if (isValid(fields.year, fields.month, fields.date)) {\n        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {\n          dt = new Date(baseDate);\n          datesetter.call(dt, fields.year, fields.month, fields.date);\n          timesetter.call(dt, fields.hours, fields.minutes, fields.seconds, fields.milliseconds);\n        } else {\n          dt = new Date(0);\n          datesetter.call(dt, fields.year, fields.month, fields.date);\n          timesetter.call(dt, fields.hours || 0, fields.minutes || 0, fields.seconds || 0, fields.milliseconds || 0);\n        }\n      }\n      return dt;\n    }\n  };\n\n  // Check if date is valid for specific month (and year for February).\n  // Month: 0 = Jan, 1 = Feb, etc\n  function isValid(year, month, date) {\n    if (date < 1) {\n      return false;\n    }\n    if (month === 1 && date > 28) {\n      return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);\n    }\n    if (month === 3 || month === 5 || month === 8 || month === 10) {\n      return date < 31;\n    }\n    return true;\n  }\n  function toInt(str) {\n    return parseInt(str, 10);\n  }\n  this.toTimezone = toTimezone;\n  this.fromTimezone = fromTimezone;\n  this.timezoneToOffset = timezoneToOffset;\n  this.addDateMinutes = addDateMinutes;\n  this.convertTimezoneToLocal = convertTimezoneToLocal;\n  function toTimezone(date, timezone) {\n    return date && timezone ? convertTimezoneToLocal(date, timezone) : date;\n  }\n  function fromTimezone(date, timezone) {\n    return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;\n  }\n\n  //https://github.com/angular/angular.js/blob/622c42169699ec07fc6daaa19fe6d224e5d2f70e/src/Angular.js#L1207\n  function timezoneToOffset(timezone, fallback) {\n    timezone = timezone.replace(/:/g, '');\n    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;\n    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;\n  }\n  function addDateMinutes(date, minutes) {\n    date = new Date(date.getTime());\n    date.setMinutes(date.getMinutes() + minutes);\n    return date;\n  }\n  function convertTimezoneToLocal(date, timezone, reverse) {\n    reverse = reverse ? -1 : 1;\n    var dateTimezoneOffset = date.getTimezoneOffset();\n    var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);\n    return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));\n  }\n}]);\n\n// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to\n// at most one element.\nangular.module('ui.bootstrap.isClass', []).directive('uibIsClass', ['$animate', function ($animate) {\n  //                    11111111          22222222\n  var ON_REGEXP = /^\\s*([\\s\\S]+?)\\s+on\\s+([\\s\\S]+?)\\s*$/;\n  //                    11111111           22222222\n  var IS_REGEXP = /^\\s*([\\s\\S]+?)\\s+for\\s+([\\s\\S]+?)\\s*$/;\n  var dataPerTracked = {};\n  return {\n    restrict: 'A',\n    compile: function compile(tElement, tAttrs) {\n      var linkedScopes = [];\n      var instances = [];\n      var expToData = {};\n      var lastActivated = null;\n      var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);\n      var onExp = onExpMatches[2];\n      var expsStr = onExpMatches[1];\n      var exps = expsStr.split(',');\n      return linkFn;\n      function linkFn(scope, element, attrs) {\n        linkedScopes.push(scope);\n        instances.push({\n          scope: scope,\n          element: element\n        });\n        exps.forEach(function (exp, k) {\n          addForExp(exp, scope);\n        });\n        scope.$on('$destroy', removeScope);\n      }\n      function addForExp(exp, scope) {\n        var matches = exp.match(IS_REGEXP);\n        var clazz = scope.$eval(matches[1]);\n        var compareWithExp = matches[2];\n        var data = expToData[exp];\n        if (!data) {\n          var watchFn = function watchFn(compareWithVal) {\n            var newActivated = null;\n            instances.some(function (instance) {\n              var thisVal = instance.scope.$eval(onExp);\n              if (thisVal === compareWithVal) {\n                newActivated = instance;\n                return true;\n              }\n            });\n            if (data.lastActivated !== newActivated) {\n              if (data.lastActivated) {\n                $animate.removeClass(data.lastActivated.element, clazz);\n              }\n              if (newActivated) {\n                $animate.addClass(newActivated.element, clazz);\n              }\n              data.lastActivated = newActivated;\n            }\n          };\n          expToData[exp] = data = {\n            lastActivated: null,\n            scope: scope,\n            watchFn: watchFn,\n            compareWithExp: compareWithExp,\n            watcher: scope.$watch(compareWithExp, watchFn)\n          };\n        }\n        data.watchFn(scope.$eval(compareWithExp));\n      }\n      function removeScope(e) {\n        var removedScope = e.targetScope;\n        var index = linkedScopes.indexOf(removedScope);\n        linkedScopes.splice(index, 1);\n        instances.splice(index, 1);\n        if (linkedScopes.length) {\n          var newWatchScope = linkedScopes[0];\n          angular.forEach(expToData, function (data) {\n            if (data.scope === removedScope) {\n              data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);\n              data.scope = newWatchScope;\n            }\n          });\n        } else {\n          expToData = {};\n        }\n      }\n    }\n  };\n}]);\nangular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass']).value('$datepickerSuppressError', false).value('$datepickerLiteralWarning', true).constant('uibDatepickerConfig', {\n  datepickerMode: 'day',\n  formatDay: 'dd',\n  formatMonth: 'MMMM',\n  formatYear: 'yyyy',\n  formatDayHeader: 'EEE',\n  formatDayTitle: 'MMMM yyyy',\n  formatMonthTitle: 'yyyy',\n  maxDate: null,\n  maxMode: 'year',\n  minDate: null,\n  minMode: 'day',\n  monthColumns: 3,\n  ngModelOptions: {},\n  shortcutPropagation: false,\n  showWeeks: true,\n  yearColumns: 5,\n  yearRows: 4\n}).controller('UibDatepickerController', ['$scope', '$element', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerLiteralWarning', '$datepickerSuppressError', 'uibDateParser', function ($scope, $element, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerLiteralWarning, $datepickerSuppressError, dateParser) {\n  var self = this,\n    ngModelCtrl = {\n      $setViewValue: angular.noop\n    },\n    // nullModelCtrl;\n    ngModelOptions = {},\n    watchListeners = [];\n  $element.addClass('uib-datepicker');\n  $attrs.$set('role', 'application');\n  if (!$scope.datepickerOptions) {\n    $scope.datepickerOptions = {};\n  }\n\n  // Modes chain\n  this.modes = ['day', 'month', 'year'];\n  ['customClass', 'dateDisabled', 'datepickerMode', 'formatDay', 'formatDayHeader', 'formatDayTitle', 'formatMonth', 'formatMonthTitle', 'formatYear', 'maxDate', 'maxMode', 'minDate', 'minMode', 'monthColumns', 'showWeeks', 'shortcutPropagation', 'startingDay', 'yearColumns', 'yearRows'].forEach(function (key) {\n    switch (key) {\n      case 'customClass':\n      case 'dateDisabled':\n        $scope[key] = $scope.datepickerOptions[key] || angular.noop;\n        break;\n      case 'datepickerMode':\n        $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ? $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;\n        break;\n      case 'formatDay':\n      case 'formatDayHeader':\n      case 'formatDayTitle':\n      case 'formatMonth':\n      case 'formatMonthTitle':\n      case 'formatYear':\n        self[key] = angular.isDefined($scope.datepickerOptions[key]) ? $interpolate($scope.datepickerOptions[key])($scope.$parent) : datepickerConfig[key];\n        break;\n      case 'monthColumns':\n      case 'showWeeks':\n      case 'shortcutPropagation':\n      case 'yearColumns':\n      case 'yearRows':\n        self[key] = angular.isDefined($scope.datepickerOptions[key]) ? $scope.datepickerOptions[key] : datepickerConfig[key];\n        break;\n      case 'startingDay':\n        if (angular.isDefined($scope.datepickerOptions.startingDay)) {\n          self.startingDay = $scope.datepickerOptions.startingDay;\n        } else if (angular.isNumber(datepickerConfig.startingDay)) {\n          self.startingDay = datepickerConfig.startingDay;\n        } else {\n          self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;\n        }\n        break;\n      case 'maxDate':\n      case 'minDate':\n        $scope.$watch('datepickerOptions.' + key, function (value) {\n          if (value) {\n            if (angular.isDate(value)) {\n              self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.timezone);\n            } else {\n              if ($datepickerLiteralWarning) {\n                $log.warn('Literal date support has been deprecated, please switch to date object usage');\n              }\n              self[key] = new Date(dateFilter(value, 'medium'));\n            }\n          } else {\n            self[key] = datepickerConfig[key] ? dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.timezone) : null;\n          }\n          self.refreshView();\n        });\n        break;\n      case 'maxMode':\n      case 'minMode':\n        if ($scope.datepickerOptions[key]) {\n          $scope.$watch(function () {\n            return $scope.datepickerOptions[key];\n          }, function (value) {\n            self[key] = $scope[key] = angular.isDefined(value) ? value : $scope.datepickerOptions[key];\n            if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) || key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {\n              $scope.datepickerMode = self[key];\n              $scope.datepickerOptions.datepickerMode = self[key];\n            }\n          });\n        } else {\n          self[key] = $scope[key] = datepickerConfig[key] || null;\n        }\n        break;\n    }\n  });\n  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);\n  $scope.disabled = angular.isDefined($attrs.disabled) || false;\n  if (angular.isDefined($attrs.ngDisabled)) {\n    watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function (disabled) {\n      $scope.disabled = disabled;\n      self.refreshView();\n    }));\n  }\n  $scope.isActive = function (dateObject) {\n    if (self.compare(dateObject.date, self.activeDate) === 0) {\n      $scope.activeDateId = dateObject.uid;\n      return true;\n    }\n    return false;\n  };\n  this.init = function (ngModelCtrl_) {\n    ngModelCtrl = ngModelCtrl_;\n    ngModelOptions = ngModelCtrl_.$options || $scope.datepickerOptions.ngModelOptions || datepickerConfig.ngModelOptions;\n    if ($scope.datepickerOptions.initDate) {\n      self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.timezone) || new Date();\n      $scope.$watch('datepickerOptions.initDate', function (initDate) {\n        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {\n          self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.timezone);\n          self.refreshView();\n        }\n      });\n    } else {\n      self.activeDate = new Date();\n    }\n    var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date();\n    this.activeDate = !isNaN(date) ? dateParser.fromTimezone(date, ngModelOptions.timezone) : dateParser.fromTimezone(new Date(), ngModelOptions.timezone);\n    ngModelCtrl.$render = function () {\n      self.render();\n    };\n  };\n  this.render = function () {\n    if (ngModelCtrl.$viewValue) {\n      var date = new Date(ngModelCtrl.$viewValue),\n        isValid = !isNaN(date);\n      if (isValid) {\n        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.timezone);\n      } else if (!$datepickerSuppressError) {\n        $log.error('Datepicker directive: \"ng-model\" value must be a Date object');\n      }\n    }\n    this.refreshView();\n  };\n  this.refreshView = function () {\n    if (this.element) {\n      $scope.selectedDt = null;\n      this._refreshView();\n      if ($scope.activeDt) {\n        $scope.activeDateId = $scope.activeDt.uid;\n      }\n      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;\n      date = dateParser.fromTimezone(date, ngModelOptions.timezone);\n      ngModelCtrl.$setValidity('dateDisabled', !date || this.element && !this.isDisabled(date));\n    }\n  };\n  this.createDateObject = function (date, format) {\n    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;\n    model = dateParser.fromTimezone(model, ngModelOptions.timezone);\n    var today = new Date();\n    today = dateParser.fromTimezone(today, ngModelOptions.timezone);\n    var time = this.compare(date, today);\n    var dt = {\n      date: date,\n      label: dateParser.filter(date, format),\n      selected: model && this.compare(date, model) === 0,\n      disabled: this.isDisabled(date),\n      past: time < 0,\n      current: time === 0,\n      future: time > 0,\n      customClass: this.customClass(date) || null\n    };\n    if (model && this.compare(date, model) === 0) {\n      $scope.selectedDt = dt;\n    }\n    if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {\n      $scope.activeDt = dt;\n    }\n    return dt;\n  };\n  this.isDisabled = function (date) {\n    return $scope.disabled || this.minDate && this.compare(date, this.minDate) < 0 || this.maxDate && this.compare(date, this.maxDate) > 0 || $scope.dateDisabled && $scope.dateDisabled({\n      date: date,\n      mode: $scope.datepickerMode\n    });\n  };\n  this.customClass = function (date) {\n    return $scope.customClass({\n      date: date,\n      mode: $scope.datepickerMode\n    });\n  };\n\n  // Split array into smaller arrays\n  this.split = function (arr, size) {\n    var arrays = [];\n    while (arr.length > 0) {\n      arrays.push(arr.splice(0, size));\n    }\n    return arrays;\n  };\n  $scope.select = function (date) {\n    if ($scope.datepickerMode === self.minMode) {\n      var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.timezone) : new Date(0, 0, 0, 0, 0, 0, 0);\n      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());\n      dt = dateParser.toTimezone(dt, ngModelOptions.timezone);\n      ngModelCtrl.$setViewValue(dt);\n      ngModelCtrl.$render();\n    } else {\n      self.activeDate = date;\n      setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);\n      $scope.$emit('uib:datepicker.mode');\n    }\n    $scope.$broadcast('uib:datepicker.focus');\n  };\n  $scope.move = function (direction) {\n    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),\n      month = self.activeDate.getMonth() + direction * (self.step.months || 0);\n    self.activeDate.setFullYear(year, month, 1);\n    self.refreshView();\n  };\n  $scope.toggleMode = function (direction) {\n    direction = direction || 1;\n    if ($scope.datepickerMode === self.maxMode && direction === 1 || $scope.datepickerMode === self.minMode && direction === -1) {\n      return;\n    }\n    setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);\n    $scope.$emit('uib:datepicker.mode');\n  };\n\n  // Key event mapper\n  $scope.keys = {\n    13: 'enter',\n    32: 'space',\n    33: 'pageup',\n    34: 'pagedown',\n    35: 'end',\n    36: 'home',\n    37: 'left',\n    38: 'up',\n    39: 'right',\n    40: 'down'\n  };\n  var focusElement = function focusElement() {\n    self.element[0].focus();\n  };\n\n  // Listen for focus requests from popup directive\n  $scope.$on('uib:datepicker.focus', focusElement);\n  $scope.keydown = function (evt) {\n    var key = $scope.keys[evt.which];\n    if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {\n      return;\n    }\n    evt.preventDefault();\n    if (!self.shortcutPropagation) {\n      evt.stopPropagation();\n    }\n    if (key === 'enter' || key === 'space') {\n      if (self.isDisabled(self.activeDate)) {\n        return; // do nothing\n      }\n      $scope.select(self.activeDate);\n    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {\n      $scope.toggleMode(key === 'up' ? 1 : -1);\n    } else {\n      self.handleKeyDown(key, evt);\n      self.refreshView();\n    }\n  };\n  $element.on('keydown', function (evt) {\n    $scope.$apply(function () {\n      $scope.keydown(evt);\n    });\n  });\n  $scope.$on('$destroy', function () {\n    //Clear all watch listeners on destroy\n    while (watchListeners.length) {\n      watchListeners.shift()();\n    }\n  });\n  function setMode(mode) {\n    $scope.datepickerMode = mode;\n    $scope.datepickerOptions.datepickerMode = mode;\n  }\n}]).controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {\n  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];\n  this.step = {\n    months: 1\n  };\n  this.element = $element;\n  function getDaysInMonth(year, month) {\n    return month === 1 && year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];\n  }\n  this.init = function (ctrl) {\n    angular.extend(ctrl, this);\n    scope.showWeeks = ctrl.showWeeks;\n    ctrl.refreshView();\n  };\n  this.getDates = function (startDate, n) {\n    var dates = new Array(n),\n      current = new Date(startDate),\n      i = 0,\n      date;\n    while (i < n) {\n      date = new Date(current);\n      dates[i++] = date;\n      current.setDate(current.getDate() + 1);\n    }\n    return dates;\n  };\n  this._refreshView = function () {\n    var year = this.activeDate.getFullYear(),\n      month = this.activeDate.getMonth(),\n      firstDayOfMonth = new Date(this.activeDate);\n    firstDayOfMonth.setFullYear(year, month, 1);\n    var difference = this.startingDay - firstDayOfMonth.getDay(),\n      numDisplayedFromPreviousMonth = difference > 0 ? 7 - difference : -difference,\n      firstDate = new Date(firstDayOfMonth);\n    if (numDisplayedFromPreviousMonth > 0) {\n      firstDate.setDate(-numDisplayedFromPreviousMonth + 1);\n    }\n\n    // 42 is the number of days on a six-week calendar\n    var days = this.getDates(firstDate, 42);\n    for (var i = 0; i < 42; i++) {\n      days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {\n        secondary: days[i].getMonth() !== month,\n        uid: scope.uniqueId + '-' + i\n      });\n    }\n    scope.labels = new Array(7);\n    for (var j = 0; j < 7; j++) {\n      scope.labels[j] = {\n        abbr: dateFilter(days[j].date, this.formatDayHeader),\n        full: dateFilter(days[j].date, 'EEEE')\n      };\n    }\n    scope.title = dateFilter(this.activeDate, this.formatDayTitle);\n    scope.rows = this.split(days, 7);\n    if (scope.showWeeks) {\n      scope.weekNumbers = [];\n      var thursdayIndex = (4 + 7 - this.startingDay) % 7,\n        numWeeks = scope.rows.length;\n      for (var curWeek = 0; curWeek < numWeeks; curWeek++) {\n        scope.weekNumbers.push(getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));\n      }\n    }\n  };\n  this.compare = function (date1, date2) {\n    var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());\n    var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());\n    _date1.setFullYear(date1.getFullYear());\n    _date2.setFullYear(date2.getFullYear());\n    return _date1 - _date2;\n  };\n  function getISO8601WeekNumber(date) {\n    var checkDate = new Date(date);\n    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday\n    var time = checkDate.getTime();\n    checkDate.setMonth(0); // Compare with Jan 1\n    checkDate.setDate(1);\n    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;\n  }\n  this.handleKeyDown = function (key, evt) {\n    var date = this.activeDate.getDate();\n    if (key === 'left') {\n      date = date - 1;\n    } else if (key === 'up') {\n      date = date - 7;\n    } else if (key === 'right') {\n      date = date + 1;\n    } else if (key === 'down') {\n      date = date + 7;\n    } else if (key === 'pageup' || key === 'pagedown') {\n      var month = this.activeDate.getMonth() + (key === 'pageup' ? -1 : 1);\n      this.activeDate.setMonth(month, 1);\n      date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);\n    } else if (key === 'home') {\n      date = 1;\n    } else if (key === 'end') {\n      date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());\n    }\n    this.activeDate.setDate(date);\n  };\n}]).controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {\n  this.step = {\n    years: 1\n  };\n  this.element = $element;\n  this.init = function (ctrl) {\n    angular.extend(ctrl, this);\n    ctrl.refreshView();\n  };\n  this._refreshView = function () {\n    var months = new Array(12),\n      year = this.activeDate.getFullYear(),\n      date;\n    for (var i = 0; i < 12; i++) {\n      date = new Date(this.activeDate);\n      date.setFullYear(year, i, 1);\n      months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {\n        uid: scope.uniqueId + '-' + i\n      });\n    }\n    scope.title = dateFilter(this.activeDate, this.formatMonthTitle);\n    scope.rows = this.split(months, this.monthColumns);\n    scope.yearHeaderColspan = this.monthColumns > 3 ? this.monthColumns - 2 : 1;\n  };\n  this.compare = function (date1, date2) {\n    var _date1 = new Date(date1.getFullYear(), date1.getMonth());\n    var _date2 = new Date(date2.getFullYear(), date2.getMonth());\n    _date1.setFullYear(date1.getFullYear());\n    _date2.setFullYear(date2.getFullYear());\n    return _date1 - _date2;\n  };\n  this.handleKeyDown = function (key, evt) {\n    var date = this.activeDate.getMonth();\n    if (key === 'left') {\n      date = date - 1;\n    } else if (key === 'up') {\n      date = date - this.monthColumns;\n    } else if (key === 'right') {\n      date = date + 1;\n    } else if (key === 'down') {\n      date = date + this.monthColumns;\n    } else if (key === 'pageup' || key === 'pagedown') {\n      var year = this.activeDate.getFullYear() + (key === 'pageup' ? -1 : 1);\n      this.activeDate.setFullYear(year);\n    } else if (key === 'home') {\n      date = 0;\n    } else if (key === 'end') {\n      date = 11;\n    }\n    this.activeDate.setMonth(date);\n  };\n}]).controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {\n  var columns, range;\n  this.element = $element;\n  function getStartingYear(year) {\n    return parseInt((year - 1) / range, 10) * range + 1;\n  }\n  this.yearpickerInit = function () {\n    columns = this.yearColumns;\n    range = this.yearRows * columns;\n    this.step = {\n      years: range\n    };\n  };\n  this._refreshView = function () {\n    var years = new Array(range),\n      date;\n    for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {\n      date = new Date(this.activeDate);\n      date.setFullYear(start + i, 0, 1);\n      years[i] = angular.extend(this.createDateObject(date, this.formatYear), {\n        uid: scope.uniqueId + '-' + i\n      });\n    }\n    scope.title = [years[0].label, years[range - 1].label].join(' - ');\n    scope.rows = this.split(years, columns);\n    scope.columns = columns;\n  };\n  this.compare = function (date1, date2) {\n    return date1.getFullYear() - date2.getFullYear();\n  };\n  this.handleKeyDown = function (key, evt) {\n    var date = this.activeDate.getFullYear();\n    if (key === 'left') {\n      date = date - 1;\n    } else if (key === 'up') {\n      date = date - columns;\n    } else if (key === 'right') {\n      date = date + 1;\n    } else if (key === 'down') {\n      date = date + columns;\n    } else if (key === 'pageup' || key === 'pagedown') {\n      date += (key === 'pageup' ? -1 : 1) * range;\n    } else if (key === 'home') {\n      date = getStartingYear(this.activeDate.getFullYear());\n    } else if (key === 'end') {\n      date = getStartingYear(this.activeDate.getFullYear()) + range - 1;\n    }\n    this.activeDate.setFullYear(date);\n  };\n}]).directive('uibDatepicker', function () {\n  return {\n    templateUrl: function templateUrl(element, attrs) {\n      return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';\n    },\n    scope: {\n      datepickerOptions: '=?'\n    },\n    require: ['uibDatepicker', '^ngModel'],\n    restrict: 'A',\n    controller: 'UibDatepickerController',\n    controllerAs: 'datepicker',\n    link: function link(scope, element, attrs, ctrls) {\n      var datepickerCtrl = ctrls[0],\n        ngModelCtrl = ctrls[1];\n      datepickerCtrl.init(ngModelCtrl);\n    }\n  };\n}).directive('uibDaypicker', function () {\n  return {\n    templateUrl: function templateUrl(element, attrs) {\n      return attrs.templateUrl || 'uib/template/datepicker/day.html';\n    },\n    require: ['^uibDatepicker', 'uibDaypicker'],\n    restrict: 'A',\n    controller: 'UibDaypickerController',\n    link: function link(scope, element, attrs, ctrls) {\n      var datepickerCtrl = ctrls[0],\n        daypickerCtrl = ctrls[1];\n      daypickerCtrl.init(datepickerCtrl);\n    }\n  };\n}).directive('uibMonthpicker', function () {\n  return {\n    templateUrl: function templateUrl(element, attrs) {\n      return attrs.templateUrl || 'uib/template/datepicker/month.html';\n    },\n    require: ['^uibDatepicker', 'uibMonthpicker'],\n    restrict: 'A',\n    controller: 'UibMonthpickerController',\n    link: function link(scope, element, attrs, ctrls) {\n      var datepickerCtrl = ctrls[0],\n        monthpickerCtrl = ctrls[1];\n      monthpickerCtrl.init(datepickerCtrl);\n    }\n  };\n}).directive('uibYearpicker', function () {\n  return {\n    templateUrl: function templateUrl(element, attrs) {\n      return attrs.templateUrl || 'uib/template/datepicker/year.html';\n    },\n    require: ['^uibDatepicker', 'uibYearpicker'],\n    restrict: 'A',\n    controller: 'UibYearpickerController',\n    link: function link(scope, element, attrs, ctrls) {\n      var ctrl = ctrls[0];\n      angular.extend(ctrl, ctrls[1]);\n      ctrl.yearpickerInit();\n      ctrl.refreshView();\n    }\n  };\n});\nangular.module('ui.bootstrap.position', [])\n\n/**\n * A set of utility methods for working with the DOM.\n * It is meant to be used where we need to absolute-position elements in\n * relation to another element (this is the case for tooltips, popovers,\n * typeahead suggestions etc.).\n */.factory('$uibPosition', ['$document', '$window', function ($document, $window) {\n  /**\n   * Used by scrollbarWidth() function to cache scrollbar's width.\n   * Do not access this variable directly, use scrollbarWidth() instead.\n   */\n  var SCROLLBAR_WIDTH;\n  /**\n   * scrollbar on body and html element in IE and Edge overlay\n   * content and should be considered 0 width.\n   */\n  var BODY_SCROLLBAR_WIDTH;\n  var OVERFLOW_REGEX = {\n    normal: /(auto|scroll)/,\n    hidden: /(auto|scroll|hidden)/\n  };\n  var PLACEMENT_REGEX = {\n    auto: /\\s?auto?\\s?/i,\n    primary: /^(top|bottom|left|right)$/,\n    secondary: /^(top|bottom|left|right|center)$/,\n    vertical: /^(top|bottom)$/\n  };\n  var BODY_REGEX = /(HTML|BODY)/;\n  return {\n    /**\n     * Provides a raw DOM element from a jQuery/jQLite element.\n     *\n     * @param {element} elem - The element to convert.\n     *\n     * @returns {element} A HTML element.\n     */\n    getRawNode: function getRawNode(elem) {\n      return elem.nodeName ? elem : elem[0] || elem;\n    },\n    /**\n     * Provides a parsed number for a style property.  Strips\n     * units and casts invalid numbers to 0.\n     *\n     * @param {string} value - The style value to parse.\n     *\n     * @returns {number} A valid number.\n     */\n    parseStyle: function parseStyle(value) {\n      value = parseFloat(value);\n      return isFinite(value) ? value : 0;\n    },\n    /**\n     * Provides the closest positioned ancestor.\n     *\n     * @param {element} element - The element to get the offest parent for.\n     *\n     * @returns {element} The closest positioned ancestor.\n     */\n    offsetParent: function offsetParent(elem) {\n      elem = this.getRawNode(elem);\n      var offsetParent = elem.offsetParent || $document[0].documentElement;\n      function isStaticPositioned(el) {\n        return ($window.getComputedStyle(el).position || 'static') === 'static';\n      }\n      while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {\n        offsetParent = offsetParent.offsetParent;\n      }\n      return offsetParent || $document[0].documentElement;\n    },\n    /**\n     * Provides the scrollbar width, concept from TWBS measureScrollbar()\n     * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js\n     * In IE and Edge, scollbar on body and html element overlay and should\n     * return a width of 0.\n     *\n     * @returns {number} The width of the browser scollbar.\n     */\n    scrollbarWidth: function scrollbarWidth(isBody) {\n      if (isBody) {\n        if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {\n          var bodyElem = $document.find('body');\n          bodyElem.addClass('uib-position-body-scrollbar-measure');\n          BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;\n          BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;\n          bodyElem.removeClass('uib-position-body-scrollbar-measure');\n        }\n        return BODY_SCROLLBAR_WIDTH;\n      }\n      if (angular.isUndefined(SCROLLBAR_WIDTH)) {\n        var scrollElem = angular.element('<div class=\"uib-position-scrollbar-measure\"></div>');\n        $document.find('body').append(scrollElem);\n        SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;\n        SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;\n        scrollElem.remove();\n      }\n      return SCROLLBAR_WIDTH;\n    },\n    /**\n     * Provides the padding required on an element to replace the scrollbar.\n     *\n     * @returns {object} An object with the following properties:\n     *   <ul>\n     *     <li>**scrollbarWidth**: the width of the scrollbar</li>\n     *     <li>**widthOverflow**: whether the the width is overflowing</li>\n     *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>\n     *     <li>**rightOriginal**: the amount of right padding currently on the element</li>\n     *     <li>**heightOverflow**: whether the the height is overflowing</li>\n     *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>\n     *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>\n     *   </ul>\n     */\n    scrollbarPadding: function scrollbarPadding(elem) {\n      elem = this.getRawNode(elem);\n      var elemStyle = $window.getComputedStyle(elem);\n      var paddingRight = this.parseStyle(elemStyle.paddingRight);\n      var paddingBottom = this.parseStyle(elemStyle.paddingBottom);\n      var scrollParent = this.scrollParent(elem, false, true);\n      var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));\n      return {\n        scrollbarWidth: scrollbarWidth,\n        widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,\n        right: paddingRight + scrollbarWidth,\n        originalRight: paddingRight,\n        heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,\n        bottom: paddingBottom + scrollbarWidth,\n        originalBottom: paddingBottom\n      };\n    },\n    /**\n     * Checks to see if the element is scrollable.\n     *\n     * @param {element} elem - The element to check.\n     * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,\n     *   default is false.\n     *\n     * @returns {boolean} Whether the element is scrollable.\n     */\n    isScrollable: function isScrollable(elem, includeHidden) {\n      elem = this.getRawNode(elem);\n      var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;\n      var elemStyle = $window.getComputedStyle(elem);\n      return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);\n    },\n    /**\n     * Provides the closest scrollable ancestor.\n     * A port of the jQuery UI scrollParent method:\n     * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js\n     *\n     * @param {element} elem - The element to find the scroll parent of.\n     * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,\n     *   default is false.\n     * @param {boolean=} [includeSelf=false] - Should the element being passed be\n     * included in the scrollable llokup.\n     *\n     * @returns {element} A HTML element.\n     */\n    scrollParent: function scrollParent(elem, includeHidden, includeSelf) {\n      elem = this.getRawNode(elem);\n      var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;\n      var documentEl = $document[0].documentElement;\n      var elemStyle = $window.getComputedStyle(elem);\n      if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {\n        return elem;\n      }\n      var excludeStatic = elemStyle.position === 'absolute';\n      var scrollParent = elem.parentElement || documentEl;\n      if (scrollParent === documentEl || elemStyle.position === 'fixed') {\n        return documentEl;\n      }\n      while (scrollParent.parentElement && scrollParent !== documentEl) {\n        var spStyle = $window.getComputedStyle(scrollParent);\n        if (excludeStatic && spStyle.position !== 'static') {\n          excludeStatic = false;\n        }\n        if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {\n          break;\n        }\n        scrollParent = scrollParent.parentElement;\n      }\n      return scrollParent;\n    },\n    /**\n     * Provides read-only equivalent of jQuery's position function:\n     * http://api.jquery.com/position/ - distance to closest positioned\n     * ancestor.  Does not account for margins by default like jQuery position.\n     *\n     * @param {element} elem - The element to caclulate the position on.\n     * @param {boolean=} [includeMargins=false] - Should margins be accounted\n     * for, default is false.\n     *\n     * @returns {object} An object with the following properties:\n     *   <ul>\n     *     <li>**width**: the width of the element</li>\n     *     <li>**height**: the height of the element</li>\n     *     <li>**top**: distance to top edge of offset parent</li>\n     *     <li>**left**: distance to left edge of offset parent</li>\n     *   </ul>\n     */\n    position: function position(elem, includeMagins) {\n      elem = this.getRawNode(elem);\n      var elemOffset = this.offset(elem);\n      if (includeMagins) {\n        var elemStyle = $window.getComputedStyle(elem);\n        elemOffset.top -= this.parseStyle(elemStyle.marginTop);\n        elemOffset.left -= this.parseStyle(elemStyle.marginLeft);\n      }\n      var parent = this.offsetParent(elem);\n      var parentOffset = {\n        top: 0,\n        left: 0\n      };\n      if (parent !== $document[0].documentElement) {\n        parentOffset = this.offset(parent);\n        parentOffset.top += parent.clientTop - parent.scrollTop;\n        parentOffset.left += parent.clientLeft - parent.scrollLeft;\n      }\n      return {\n        width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),\n        height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),\n        top: Math.round(elemOffset.top - parentOffset.top),\n        left: Math.round(elemOffset.left - parentOffset.left)\n      };\n    },\n    /**\n     * Provides read-only equivalent of jQuery's offset function:\n     * http://api.jquery.com/offset/ - distance to viewport.  Does\n     * not account for borders, margins, or padding on the body\n     * element.\n     *\n     * @param {element} elem - The element to calculate the offset on.\n     *\n     * @returns {object} An object with the following properties:\n     *   <ul>\n     *     <li>**width**: the width of the element</li>\n     *     <li>**height**: the height of the element</li>\n     *     <li>**top**: distance to top edge of viewport</li>\n     *     <li>**right**: distance to bottom edge of viewport</li>\n     *   </ul>\n     */\n    offset: function offset(elem) {\n      elem = this.getRawNode(elem);\n      var elemBCR = elem.getBoundingClientRect();\n      return {\n        width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),\n        height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),\n        top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),\n        left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))\n      };\n    },\n    /**\n     * Provides offset distance to the closest scrollable ancestor\n     * or viewport.  Accounts for border and scrollbar width.\n     *\n     * Right and bottom dimensions represent the distance to the\n     * respective edge of the viewport element.  If the element\n     * edge extends beyond the viewport, a negative value will be\n     * reported.\n     *\n     * @param {element} elem - The element to get the viewport offset for.\n     * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead\n     * of the first scrollable element, default is false.\n     * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element\n     * be accounted for, default is true.\n     *\n     * @returns {object} An object with the following properties:\n     *   <ul>\n     *     <li>**top**: distance to the top content edge of viewport element</li>\n     *     <li>**bottom**: distance to the bottom content edge of viewport element</li>\n     *     <li>**left**: distance to the left content edge of viewport element</li>\n     *     <li>**right**: distance to the right content edge of viewport element</li>\n     *   </ul>\n     */\n    viewportOffset: function viewportOffset(elem, useDocument, includePadding) {\n      elem = this.getRawNode(elem);\n      includePadding = includePadding !== false ? true : false;\n      var elemBCR = elem.getBoundingClientRect();\n      var offsetBCR = {\n        top: 0,\n        left: 0,\n        bottom: 0,\n        right: 0\n      };\n      var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);\n      var offsetParentBCR = offsetParent.getBoundingClientRect();\n      offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;\n      offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;\n      if (offsetParent === $document[0].documentElement) {\n        offsetBCR.top += $window.pageYOffset;\n        offsetBCR.left += $window.pageXOffset;\n      }\n      offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;\n      offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;\n      if (includePadding) {\n        var offsetParentStyle = $window.getComputedStyle(offsetParent);\n        offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);\n        offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);\n        offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);\n        offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);\n      }\n      return {\n        top: Math.round(elemBCR.top - offsetBCR.top),\n        bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),\n        left: Math.round(elemBCR.left - offsetBCR.left),\n        right: Math.round(offsetBCR.right - elemBCR.right)\n      };\n    },\n    /**\n     * Provides an array of placement values parsed from a placement string.\n     * Along with the 'auto' indicator, supported placement strings are:\n     *   <ul>\n     *     <li>top: element on top, horizontally centered on host element.</li>\n     *     <li>top-left: element on top, left edge aligned with host element left edge.</li>\n     *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>\n     *     <li>bottom: element on bottom, horizontally centered on host element.</li>\n     *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>\n     *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>\n     *     <li>left: element on left, vertically centered on host element.</li>\n     *     <li>left-top: element on left, top edge aligned with host element top edge.</li>\n     *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>\n     *     <li>right: element on right, vertically centered on host element.</li>\n     *     <li>right-top: element on right, top edge aligned with host element top edge.</li>\n     *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>\n     *   </ul>\n     * A placement string with an 'auto' indicator is expected to be\n     * space separated from the placement, i.e: 'auto bottom-left'  If\n     * the primary and secondary placement values do not match 'top,\n     * bottom, left, right' then 'top' will be the primary placement and\n     * 'center' will be the secondary placement.  If 'auto' is passed, true\n     * will be returned as the 3rd value of the array.\n     *\n     * @param {string} placement - The placement string to parse.\n     *\n     * @returns {array} An array with the following values\n     * <ul>\n     *   <li>**[0]**: The primary placement.</li>\n     *   <li>**[1]**: The secondary placement.</li>\n     *   <li>**[2]**: If auto is passed: true, else undefined.</li>\n     * </ul>\n     */\n    parsePlacement: function parsePlacement(placement) {\n      var autoPlace = PLACEMENT_REGEX.auto.test(placement);\n      if (autoPlace) {\n        placement = placement.replace(PLACEMENT_REGEX.auto, '');\n      }\n      placement = placement.split('-');\n      placement[0] = placement[0] || 'top';\n      if (!PLACEMENT_REGEX.primary.test(placement[0])) {\n        placement[0] = 'top';\n      }\n      placement[1] = placement[1] || 'center';\n      if (!PLACEMENT_REGEX.secondary.test(placement[1])) {\n        placement[1] = 'center';\n      }\n      if (autoPlace) {\n        placement[2] = true;\n      } else {\n        placement[2] = false;\n      }\n      return placement;\n    },\n    /**\n     * Provides coordinates for an element to be positioned relative to\n     * another element.  Passing 'auto' as part of the placement parameter\n     * will enable smart placement - where the element fits. i.e:\n     * 'auto left-top' will check to see if there is enough space to the left\n     * of the hostElem to fit the targetElem, if not place right (same for secondary\n     * top placement).  Available space is calculated using the viewportOffset\n     * function.\n     *\n     * @param {element} hostElem - The element to position against.\n     * @param {element} targetElem - The element to position.\n     * @param {string=} [placement=top] - The placement for the targetElem,\n     *   default is 'top'. 'center' is assumed as secondary placement for\n     *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:\n     *   <ul>\n     *     <li>top</li>\n     *     <li>top-right</li>\n     *     <li>top-left</li>\n     *     <li>bottom</li>\n     *     <li>bottom-left</li>\n     *     <li>bottom-right</li>\n     *     <li>left</li>\n     *     <li>left-top</li>\n     *     <li>left-bottom</li>\n     *     <li>right</li>\n     *     <li>right-top</li>\n     *     <li>right-bottom</li>\n     *   </ul>\n     * @param {boolean=} [appendToBody=false] - Should the top and left values returned\n     *   be calculated from the body element, default is false.\n     *\n     * @returns {object} An object with the following properties:\n     *   <ul>\n     *     <li>**top**: Value for targetElem top.</li>\n     *     <li>**left**: Value for targetElem left.</li>\n     *     <li>**placement**: The resolved placement.</li>\n     *   </ul>\n     */\n    positionElements: function positionElements(hostElem, targetElem, placement, appendToBody) {\n      hostElem = this.getRawNode(hostElem);\n      targetElem = this.getRawNode(targetElem);\n\n      // need to read from prop to support tests.\n      var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');\n      var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');\n      placement = this.parsePlacement(placement);\n      var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);\n      var targetElemPos = {\n        top: 0,\n        left: 0,\n        placement: ''\n      };\n      if (placement[2]) {\n        var viewportOffset = this.viewportOffset(hostElem, appendToBody);\n        var targetElemStyle = $window.getComputedStyle(targetElem);\n        var adjustedSize = {\n          width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),\n          height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))\n        };\n        placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' : placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' : placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' : placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' : placement[0];\n        placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' : placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' : placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' : placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' : placement[1];\n        if (placement[1] === 'center') {\n          if (PLACEMENT_REGEX.vertical.test(placement[0])) {\n            var xOverflow = hostElemPos.width / 2 - targetWidth / 2;\n            if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {\n              placement[1] = 'left';\n            } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {\n              placement[1] = 'right';\n            }\n          } else {\n            var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;\n            if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {\n              placement[1] = 'top';\n            } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {\n              placement[1] = 'bottom';\n            }\n          }\n        }\n      }\n      switch (placement[0]) {\n        case 'top':\n          targetElemPos.top = hostElemPos.top - targetHeight;\n          break;\n        case 'bottom':\n          targetElemPos.top = hostElemPos.top + hostElemPos.height;\n          break;\n        case 'left':\n          targetElemPos.left = hostElemPos.left - targetWidth;\n          break;\n        case 'right':\n          targetElemPos.left = hostElemPos.left + hostElemPos.width;\n          break;\n      }\n      switch (placement[1]) {\n        case 'top':\n          targetElemPos.top = hostElemPos.top;\n          break;\n        case 'bottom':\n          targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;\n          break;\n        case 'left':\n          targetElemPos.left = hostElemPos.left;\n          break;\n        case 'right':\n          targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;\n          break;\n        case 'center':\n          if (PLACEMENT_REGEX.vertical.test(placement[0])) {\n            targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;\n          } else {\n            targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;\n          }\n          break;\n      }\n      targetElemPos.top = Math.round(targetElemPos.top);\n      targetElemPos.left = Math.round(targetElemPos.left);\n      targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];\n      return targetElemPos;\n    },\n    /**\n     * Provides a way to adjust the top positioning after first\n     * render to correctly align element to top after content\n     * rendering causes resized element height\n     *\n     * @param {array} placementClasses - The array of strings of classes\n     * element should have.\n     * @param {object} containerPosition - The object with container\n     * position information\n     * @param {number} initialHeight - The initial height for the elem.\n     * @param {number} currentHeight - The current height for the elem.\n     */\n    adjustTop: function adjustTop(placementClasses, containerPosition, initialHeight, currentHeight) {\n      if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {\n        return {\n          top: containerPosition.top - currentHeight + 'px'\n        };\n      }\n    },\n    /**\n     * Provides a way for positioning tooltip & dropdown\n     * arrows when using placement options beyond the standard\n     * left, right, top, or bottom.\n     *\n     * @param {element} elem - The tooltip/dropdown element.\n     * @param {string} placement - The placement for the elem.\n     */\n    positionArrow: function positionArrow(elem, placement) {\n      elem = this.getRawNode(elem);\n      var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');\n      if (!innerElem) {\n        return;\n      }\n      var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');\n      var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');\n      if (!arrowElem) {\n        return;\n      }\n      var arrowCss = {\n        top: '',\n        bottom: '',\n        left: '',\n        right: ''\n      };\n      placement = this.parsePlacement(placement);\n      if (placement[1] === 'center') {\n        // no adjustment necessary - just reset styles\n        angular.element(arrowElem).css(arrowCss);\n        return;\n      }\n      var borderProp = 'border-' + placement[0] + '-width';\n      var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];\n      var borderRadiusProp = 'border-';\n      if (PLACEMENT_REGEX.vertical.test(placement[0])) {\n        borderRadiusProp += placement[0] + '-' + placement[1];\n      } else {\n        borderRadiusProp += placement[1] + '-' + placement[0];\n      }\n      borderRadiusProp += '-radius';\n      var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];\n      switch (placement[0]) {\n        case 'top':\n          arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;\n          break;\n        case 'bottom':\n          arrowCss.top = isTooltip ? '0' : '-' + borderWidth;\n          break;\n        case 'left':\n          arrowCss.right = isTooltip ? '0' : '-' + borderWidth;\n          break;\n        case 'right':\n          arrowCss.left = isTooltip ? '0' : '-' + borderWidth;\n          break;\n      }\n      arrowCss[placement[1]] = borderRadius;\n      angular.element(arrowElem).css(arrowCss);\n    }\n  };\n}]);\nangular.module('ui.bootstrap.datepickerPopup', ['ui.bootstrap.datepicker', 'ui.bootstrap.position']).value('$datepickerPopupLiteralWarning', true).constant('uibDatepickerPopupConfig', {\n  altInputFormats: [],\n  appendToBody: false,\n  clearText: 'Clear',\n  closeOnDateSelection: true,\n  closeText: 'Done',\n  currentText: 'Today',\n  datepickerPopup: 'yyyy-MM-dd',\n  datepickerPopupTemplateUrl: 'uib/template/datepickerPopup/popup.html',\n  datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',\n  html5Types: {\n    date: 'yyyy-MM-dd',\n    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',\n    'month': 'yyyy-MM'\n  },\n  onOpenFocus: true,\n  showButtonBar: true,\n  placement: 'auto bottom-left'\n}).controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', '$datepickerPopupLiteralWarning', function ($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, $datepickerPopupLiteralWarning) {\n  var cache = {},\n    isHtml5DateInput = false;\n  var dateFormat,\n    closeOnDateSelection,\n    appendToBody,\n    onOpenFocus,\n    datepickerPopupTemplateUrl,\n    datepickerTemplateUrl,\n    popupEl,\n    datepickerEl,\n    scrollParentEl,\n    ngModel,\n    ngModelOptions,\n    $popup,\n    altInputFormats,\n    watchListeners = [];\n  this.init = function (_ngModel_) {\n    ngModel = _ngModel_;\n    ngModelOptions = angular.isObject(_ngModel_.$options) ? _ngModel_.$options : {\n      timezone: null\n    };\n    closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ? $scope.$parent.$eval($attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection;\n    appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ? $scope.$parent.$eval($attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody;\n    onOpenFocus = angular.isDefined($attrs.onOpenFocus) ? $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;\n    datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ? $attrs.datepickerPopupTemplateUrl : datepickerPopupConfig.datepickerPopupTemplateUrl;\n    datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ? $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;\n    altInputFormats = angular.isDefined($attrs.altInputFormats) ? $scope.$parent.$eval($attrs.altInputFormats) : datepickerPopupConfig.altInputFormats;\n    $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ? $scope.$parent.$eval($attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;\n    if (datepickerPopupConfig.html5Types[$attrs.type]) {\n      dateFormat = datepickerPopupConfig.html5Types[$attrs.type];\n      isHtml5DateInput = true;\n    } else {\n      dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;\n      $attrs.$observe('uibDatepickerPopup', function (value, oldValue) {\n        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;\n        // Invalidate the $modelValue to ensure that formatters re-run\n        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764\n        if (newDateFormat !== dateFormat) {\n          dateFormat = newDateFormat;\n          ngModel.$modelValue = null;\n          if (!dateFormat) {\n            throw new Error('uibDatepickerPopup must have a date format specified.');\n          }\n        }\n      });\n    }\n    if (!dateFormat) {\n      throw new Error('uibDatepickerPopup must have a date format specified.');\n    }\n    if (isHtml5DateInput && $attrs.uibDatepickerPopup) {\n      throw new Error('HTML5 date input types do not support custom formats.');\n    }\n\n    // popup element used to display calendar\n    popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');\n    popupEl.attr({\n      'ng-model': 'date',\n      'ng-change': 'dateSelection(date)',\n      'template-url': datepickerPopupTemplateUrl\n    });\n\n    // datepicker element\n    datepickerEl = angular.element(popupEl.children()[0]);\n    datepickerEl.attr('template-url', datepickerTemplateUrl);\n    if (!$scope.datepickerOptions) {\n      $scope.datepickerOptions = {};\n    }\n    if (isHtml5DateInput) {\n      if ($attrs.type === 'month') {\n        $scope.datepickerOptions.datepickerMode = 'month';\n        $scope.datepickerOptions.minMode = 'month';\n      }\n    }\n    datepickerEl.attr('datepicker-options', 'datepickerOptions');\n    if (!isHtml5DateInput) {\n      // Internal API to maintain the correct ng-invalid-[key] class\n      ngModel.$$parserName = 'date';\n      ngModel.$validators.date = validator;\n      ngModel.$parsers.unshift(parseDate);\n      ngModel.$formatters.push(function (value) {\n        if (ngModel.$isEmpty(value)) {\n          $scope.date = value;\n          return value;\n        }\n        if (angular.isNumber(value)) {\n          value = new Date(value);\n        }\n        $scope.date = dateParser.fromTimezone(value, ngModelOptions.timezone);\n        return dateParser.filter($scope.date, dateFormat);\n      });\n    } else {\n      ngModel.$formatters.push(function (value) {\n        $scope.date = dateParser.fromTimezone(value, ngModelOptions.timezone);\n        return value;\n      });\n    }\n\n    // Detect changes in the view from the text box\n    ngModel.$viewChangeListeners.push(function () {\n      $scope.date = parseDateString(ngModel.$viewValue);\n    });\n    $element.on('keydown', inputKeydownBind);\n    $popup = $compile(popupEl)($scope);\n    // Prevent jQuery cache memory leak (template is now redundant after linking)\n    popupEl.remove();\n    if (appendToBody) {\n      $document.find('body').append($popup);\n    } else {\n      $element.after($popup);\n    }\n    $scope.$on('$destroy', function () {\n      if ($scope.isOpen === true) {\n        if (!$rootScope.$$phase) {\n          $scope.$apply(function () {\n            $scope.isOpen = false;\n          });\n        }\n      }\n      $popup.remove();\n      $element.off('keydown', inputKeydownBind);\n      $document.off('click', documentClickBind);\n      if (scrollParentEl) {\n        scrollParentEl.off('scroll', positionPopup);\n      }\n      angular.element($window).off('resize', positionPopup);\n\n      //Clear all watch listeners on destroy\n      while (watchListeners.length) {\n        watchListeners.shift()();\n      }\n    });\n  };\n  $scope.getText = function (key) {\n    return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];\n  };\n  $scope.isDisabled = function (date) {\n    if (date === 'today') {\n      date = dateParser.fromTimezone(new Date(), ngModelOptions.timezone);\n    }\n    var dates = {};\n    angular.forEach(['minDate', 'maxDate'], function (key) {\n      if (!$scope.datepickerOptions[key]) {\n        dates[key] = null;\n      } else if (angular.isDate($scope.datepickerOptions[key])) {\n        dates[key] = new Date($scope.datepickerOptions[key]);\n      } else {\n        if ($datepickerPopupLiteralWarning) {\n          $log.warn('Literal date support has been deprecated, please switch to date object usage');\n        }\n        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));\n      }\n    });\n    return $scope.datepickerOptions && dates.minDate && $scope.compare(date, dates.minDate) < 0 || dates.maxDate && $scope.compare(date, dates.maxDate) > 0;\n  };\n  $scope.compare = function (date1, date2) {\n    return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());\n  };\n\n  // Inner change\n  $scope.dateSelection = function (dt) {\n    $scope.date = dt;\n    var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function\n    $element.val(date);\n    ngModel.$setViewValue(date);\n    if (closeOnDateSelection) {\n      $scope.isOpen = false;\n      $element[0].focus();\n    }\n  };\n  $scope.keydown = function (evt) {\n    if (evt.which === 27) {\n      evt.stopPropagation();\n      $scope.isOpen = false;\n      $element[0].focus();\n    }\n  };\n  $scope.select = function (date, evt) {\n    evt.stopPropagation();\n    if (date === 'today') {\n      var today = new Date();\n      if (angular.isDate($scope.date)) {\n        date = new Date($scope.date);\n        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());\n      } else {\n        date = dateParser.fromTimezone(today, ngModelOptions.timezone);\n        date.setHours(0, 0, 0, 0);\n      }\n    }\n    $scope.dateSelection(date);\n  };\n  $scope.close = function (evt) {\n    evt.stopPropagation();\n    $scope.isOpen = false;\n    $element[0].focus();\n  };\n  $scope.disabled = angular.isDefined($attrs.disabled) || false;\n  if ($attrs.ngDisabled) {\n    watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (disabled) {\n      $scope.disabled = disabled;\n    }));\n  }\n  $scope.$watch('isOpen', function (value) {\n    if (value) {\n      if (!$scope.disabled) {\n        $timeout(function () {\n          positionPopup();\n          if (onOpenFocus) {\n            $scope.$broadcast('uib:datepicker.focus');\n          }\n          $document.on('click', documentClickBind);\n          var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;\n          if (appendToBody || $position.parsePlacement(placement)[2]) {\n            scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));\n            if (scrollParentEl) {\n              scrollParentEl.on('scroll', positionPopup);\n            }\n          } else {\n            scrollParentEl = null;\n          }\n          angular.element($window).on('resize', positionPopup);\n        }, 0, false);\n      } else {\n        $scope.isOpen = false;\n      }\n    } else {\n      $document.off('click', documentClickBind);\n      if (scrollParentEl) {\n        scrollParentEl.off('scroll', positionPopup);\n      }\n      angular.element($window).off('resize', positionPopup);\n    }\n  });\n  function cameltoDash(string) {\n    return string.replace(/([A-Z])/g, function ($1) {\n      return '-' + $1.toLowerCase();\n    });\n  }\n  function parseDateString(viewValue) {\n    var date = dateParser.parse(viewValue, dateFormat, $scope.date);\n    if (isNaN(date)) {\n      for (var i = 0; i < altInputFormats.length; i++) {\n        date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);\n        if (!isNaN(date)) {\n          return date;\n        }\n      }\n    }\n    return date;\n  }\n  function parseDate(viewValue) {\n    if (angular.isNumber(viewValue)) {\n      // presumably timestamp to date object\n      viewValue = new Date(viewValue);\n    }\n    if (!viewValue) {\n      return null;\n    }\n    if (angular.isDate(viewValue) && !isNaN(viewValue)) {\n      return viewValue;\n    }\n    if (angular.isString(viewValue)) {\n      var date = parseDateString(viewValue);\n      if (!isNaN(date)) {\n        return dateParser.fromTimezone(date, ngModelOptions.timezone);\n      }\n    }\n    return ngModel.$options && ngModel.$options.allowInvalid ? viewValue : undefined;\n  }\n  function validator(modelValue, viewValue) {\n    var value = modelValue || viewValue;\n    if (!$attrs.ngRequired && !value) {\n      return true;\n    }\n    if (angular.isNumber(value)) {\n      value = new Date(value);\n    }\n    if (!value) {\n      return true;\n    }\n    if (angular.isDate(value) && !isNaN(value)) {\n      return true;\n    }\n    if (angular.isString(value)) {\n      return !isNaN(parseDateString(value));\n    }\n    return false;\n  }\n  function documentClickBind(event) {\n    if (!$scope.isOpen && $scope.disabled) {\n      return;\n    }\n    var popup = $popup[0];\n    var dpContainsTarget = $element[0].contains(event.target);\n    // The popup node may not be an element node\n    // In some browsers (IE) only element nodes have the 'contains' function\n    var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);\n    if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {\n      $scope.$apply(function () {\n        $scope.isOpen = false;\n      });\n    }\n  }\n  function inputKeydownBind(evt) {\n    if (evt.which === 27 && $scope.isOpen) {\n      evt.preventDefault();\n      evt.stopPropagation();\n      $scope.$apply(function () {\n        $scope.isOpen = false;\n      });\n      $element[0].focus();\n    } else if (evt.which === 40 && !$scope.isOpen) {\n      evt.preventDefault();\n      evt.stopPropagation();\n      $scope.$apply(function () {\n        $scope.isOpen = true;\n      });\n    }\n  }\n  function positionPopup() {\n    if ($scope.isOpen) {\n      var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));\n      var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;\n      var position = $position.positionElements($element, dpElement, placement, appendToBody);\n      dpElement.css({\n        top: position.top + 'px',\n        left: position.left + 'px'\n      });\n      if (dpElement.hasClass('uib-position-measure')) {\n        dpElement.removeClass('uib-position-measure');\n      }\n    }\n  }\n  $scope.$on('uib:datepicker.mode', function () {\n    $timeout(positionPopup, 0, false);\n  });\n}]).directive('uibDatepickerPopup', function () {\n  return {\n    require: ['ngModel', 'uibDatepickerPopup'],\n    controller: 'UibDatepickerPopupController',\n    scope: {\n      datepickerOptions: '=?',\n      isOpen: '=?',\n      currentText: '@',\n      clearText: '@',\n      closeText: '@'\n    },\n    link: function link(scope, element, attrs, ctrls) {\n      var ngModel = ctrls[0],\n        ctrl = ctrls[1];\n      ctrl.init(ngModel);\n    }\n  };\n}).directive('uibDatepickerPopupWrap', function () {\n  return {\n    restrict: 'A',\n    transclude: true,\n    templateUrl: function templateUrl(element, attrs) {\n      return attrs.templateUrl || 'uib/template/datepickerPopup/popup.html';\n    }\n  };\n});\nangular.module('ui.bootstrap.debounce', [])\n/**\n * A helper, internal service that debounces a function\n */.factory('$$debounce', ['$timeout', function ($timeout) {\n  return function (callback, debounceTime) {\n    var timeoutPromise;\n    return function () {\n      var self = this;\n      var args = Array.prototype.slice.call(arguments);\n      if (timeoutPromise) {\n        $timeout.cancel(timeoutPromise);\n      }\n      timeoutPromise = $timeout(function () {\n        callback.apply(self, args);\n      }, debounceTime);\n    };\n  };\n}]);\nangular.module('ui.bootstrap.dropdown', ['ui.bootstrap.position']).constant('uibDropdownConfig', {\n  appendToOpenClass: 'uib-dropdown-open',\n  openClass: 'open'\n}).service('uibDropdownService', ['$document', '$rootScope', function ($document, $rootScope) {\n  var openScope = null;\n  this.open = function (dropdownScope, element) {\n    if (!openScope) {\n      $document.on('click', closeDropdown);\n    }\n    if (openScope && openScope !== dropdownScope) {\n      openScope.isOpen = false;\n    }\n    openScope = dropdownScope;\n  };\n  this.close = function (dropdownScope, element) {\n    if (openScope === dropdownScope) {\n      $document.off('click', closeDropdown);\n      $document.off('keydown', this.keybindFilter);\n      openScope = null;\n    }\n  };\n  var closeDropdown = function closeDropdown(evt) {\n    // This method may still be called during the same mouse event that\n    // unbound this event handler. So check openScope before proceeding.\n    if (!openScope) {\n      return;\n    }\n    if (evt && openScope.getAutoClose() === 'disabled') {\n      return;\n    }\n    if (evt && evt.which === 3) {\n      return;\n    }\n    var toggleElement = openScope.getToggleElement();\n    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {\n      return;\n    }\n    var dropdownElement = openScope.getDropdownElement();\n    if (evt && openScope.getAutoClose() === 'outsideClick' && dropdownElement && dropdownElement[0].contains(evt.target)) {\n      return;\n    }\n    openScope.focusToggleElement();\n    openScope.isOpen = false;\n    if (!$rootScope.$$phase) {\n      openScope.$apply();\n    }\n  };\n  this.keybindFilter = function (evt) {\n    if (!openScope) {\n      // see this.close as ESC could have been pressed which kills the scope so we can not proceed\n      return;\n    }\n    var dropdownElement = openScope.getDropdownElement();\n    var toggleElement = openScope.getToggleElement();\n    var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);\n    var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);\n    if (evt.which === 27) {\n      evt.stopPropagation();\n      openScope.focusToggleElement();\n      closeDropdown();\n    } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {\n      evt.preventDefault();\n      evt.stopPropagation();\n      openScope.focusDropdownEntry(evt.which);\n    }\n  };\n}]).controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function ($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {\n  var self = this,\n    scope = $scope.$new(),\n    // create a child scope so we are not polluting original one\n    templateScope,\n    appendToOpenClass = dropdownConfig.appendToOpenClass,\n    openClass = dropdownConfig.openClass,\n    getIsOpen,\n    setIsOpen = angular.noop,\n    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,\n    appendToBody = false,\n    appendTo = null,\n    keynavEnabled = false,\n    selectedOption = null,\n    body = $document.find('body');\n  $element.addClass('dropdown');\n  this.init = function () {\n    if ($attrs.isOpen) {\n      getIsOpen = $parse($attrs.isOpen);\n      setIsOpen = getIsOpen.assign;\n      $scope.$watch(getIsOpen, function (value) {\n        scope.isOpen = !!value;\n      });\n    }\n    if (angular.isDefined($attrs.dropdownAppendTo)) {\n      var appendToEl = $parse($attrs.dropdownAppendTo)(scope);\n      if (appendToEl) {\n        appendTo = angular.element(appendToEl);\n      }\n    }\n    appendToBody = angular.isDefined($attrs.dropdownAppendToBody);\n    keynavEnabled = angular.isDefined($attrs.keyboardNav);\n    if (appendToBody && !appendTo) {\n      appendTo = body;\n    }\n    if (appendTo && self.dropdownMenu) {\n      appendTo.append(self.dropdownMenu);\n      $element.on('$destroy', function handleDestroyEvent() {\n        self.dropdownMenu.remove();\n      });\n    }\n  };\n  this.toggle = function (open) {\n    scope.isOpen = arguments.length ? !!open : !scope.isOpen;\n    if (angular.isFunction(setIsOpen)) {\n      setIsOpen(scope, scope.isOpen);\n    }\n    return scope.isOpen;\n  };\n\n  // Allow other directives to watch status\n  this.isOpen = function () {\n    return scope.isOpen;\n  };\n  scope.getToggleElement = function () {\n    return self.toggleElement;\n  };\n  scope.getAutoClose = function () {\n    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'\n  };\n  scope.getElement = function () {\n    return $element;\n  };\n  scope.isKeynavEnabled = function () {\n    return keynavEnabled;\n  };\n  scope.focusDropdownEntry = function (keyCode) {\n    var elems = self.dropdownMenu ?\n    //If append to body is used.\n    angular.element(self.dropdownMenu).find('a') : $element.find('ul').eq(0).find('a');\n    switch (keyCode) {\n      case 40:\n        {\n          if (!angular.isNumber(self.selectedOption)) {\n            self.selectedOption = 0;\n          } else {\n            self.selectedOption = self.selectedOption === elems.length - 1 ? self.selectedOption : self.selectedOption + 1;\n          }\n          break;\n        }\n      case 38:\n        {\n          if (!angular.isNumber(self.selectedOption)) {\n            self.selectedOption = elems.length - 1;\n          } else {\n            self.selectedOption = self.selectedOption === 0 ? 0 : self.selectedOption - 1;\n          }\n          break;\n        }\n    }\n    elems[self.selectedOption].focus();\n  };\n  scope.getDropdownElement = function () {\n    return self.dropdownMenu;\n  };\n  scope.focusToggleElement = function () {\n    if (self.toggleElement) {\n      self.toggleElement[0].focus();\n    }\n  };\n  scope.$watch('isOpen', function (isOpen, wasOpen) {\n    if (appendTo && self.dropdownMenu) {\n      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),\n        css,\n        rightalign,\n        scrollbarPadding,\n        scrollbarWidth = 0;\n      css = {\n        top: pos.top + 'px',\n        display: isOpen ? 'block' : 'none'\n      };\n      rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');\n      if (!rightalign) {\n        css.left = pos.left + 'px';\n        css.right = 'auto';\n      } else {\n        css.left = 'auto';\n        scrollbarPadding = $position.scrollbarPadding(appendTo);\n        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {\n          scrollbarWidth = scrollbarPadding.scrollbarWidth;\n        }\n        css.right = window.innerWidth - scrollbarWidth - (pos.left + $element.prop('offsetWidth')) + 'px';\n      }\n\n      // Need to adjust our positioning to be relative to the appendTo container\n      // if it's not the body element\n      if (!appendToBody) {\n        var appendOffset = $position.offset(appendTo);\n        css.top = pos.top - appendOffset.top + 'px';\n        if (!rightalign) {\n          css.left = pos.left - appendOffset.left + 'px';\n        } else {\n          css.right = window.innerWidth - (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';\n        }\n      }\n      self.dropdownMenu.css(css);\n    }\n    var openContainer = appendTo ? appendTo : $element;\n    var hasOpenClass = openContainer.hasClass(appendTo ? appendToOpenClass : openClass);\n    if (hasOpenClass === !isOpen) {\n      $animate[isOpen ? 'addClass' : 'removeClass'](openContainer, appendTo ? appendToOpenClass : openClass).then(function () {\n        if (angular.isDefined(isOpen) && isOpen !== wasOpen) {\n          toggleInvoker($scope, {\n            open: !!isOpen\n          });\n        }\n      });\n    }\n    if (isOpen) {\n      if (self.dropdownMenuTemplateUrl) {\n        $templateRequest(self.dropdownMenuTemplateUrl).then(function (tplContent) {\n          templateScope = scope.$new();\n          $compile(tplContent.trim())(templateScope, function (dropdownElement) {\n            var newEl = dropdownElement;\n            self.dropdownMenu.replaceWith(newEl);\n            self.dropdownMenu = newEl;\n            $document.on('keydown', uibDropdownService.keybindFilter);\n          });\n        });\n      } else {\n        $document.on('keydown', uibDropdownService.keybindFilter);\n      }\n      scope.focusToggleElement();\n      uibDropdownService.open(scope, $element);\n    } else {\n      uibDropdownService.close(scope, $element);\n      if (self.dropdownMenuTemplateUrl) {\n        if (templateScope) {\n          templateScope.$destroy();\n        }\n        var newEl = angular.element('<ul class=\"dropdown-menu\"></ul>');\n        self.dropdownMenu.replaceWith(newEl);\n        self.dropdownMenu = newEl;\n      }\n      self.selectedOption = null;\n    }\n    if (angular.isFunction(setIsOpen)) {\n      setIsOpen($scope, isOpen);\n    }\n  });\n}]).directive('uibDropdown', function () {\n  return {\n    controller: 'UibDropdownController',\n    link: function link(scope, element, attrs, dropdownCtrl) {\n      dropdownCtrl.init();\n    }\n  };\n}).directive('uibDropdownMenu', function () {\n  return {\n    restrict: 'A',\n    require: '?^uibDropdown',\n    link: function link(scope, element, attrs, dropdownCtrl) {\n      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {\n        return;\n      }\n      element.addClass('dropdown-menu');\n      var tplUrl = attrs.templateUrl;\n      if (tplUrl) {\n        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;\n      }\n      if (!dropdownCtrl.dropdownMenu) {\n        dropdownCtrl.dropdownMenu = element;\n      }\n    }\n  };\n}).directive('uibDropdownToggle', function () {\n  return {\n    require: '?^uibDropdown',\n    link: function link(scope, element, attrs, dropdownCtrl) {\n      if (!dropdownCtrl) {\n        return;\n      }\n      element.addClass('dropdown-toggle');\n      dropdownCtrl.toggleElement = element;\n      var toggleDropdown = function toggleDropdown(event) {\n        event.preventDefault();\n        if (!element.hasClass('disabled') && !attrs.disabled) {\n          scope.$apply(function () {\n            dropdownCtrl.toggle();\n          });\n        }\n      };\n      element.bind('click', toggleDropdown);\n\n      // WAI-ARIA\n      element.attr({\n        'aria-haspopup': true,\n        'aria-expanded': false\n      });\n      scope.$watch(dropdownCtrl.isOpen, function (isOpen) {\n        element.attr('aria-expanded', !!isOpen);\n      });\n      scope.$on('$destroy', function () {\n        element.unbind('click', toggleDropdown);\n      });\n    }\n  };\n});\nangular.module('ui.bootstrap.stackedMap', [])\n/**\n * A helper, internal data structure that acts as a map but also allows getting / removing\n * elements in the LIFO order\n */.factory('$$stackedMap', function () {\n  return {\n    createNew: function createNew() {\n      var stack = [];\n      return {\n        add: function add(key, value) {\n          stack.push({\n            key: key,\n            value: value\n          });\n        },\n        get: function get(key) {\n          for (var i = 0; i < stack.length; i++) {\n            if (key === stack[i].key) {\n              return stack[i];\n            }\n          }\n        },\n        keys: function keys() {\n          var keys = [];\n          for (var i = 0; i < stack.length; i++) {\n            keys.push(stack[i].key);\n          }\n          return keys;\n        },\n        top: function top() {\n          return stack[stack.length - 1];\n        },\n        remove: function remove(key) {\n          var idx = -1;\n          for (var i = 0; i < stack.length; i++) {\n            if (key === stack[i].key) {\n              idx = i;\n              break;\n            }\n          }\n          return stack.splice(idx, 1)[0];\n        },\n        removeTop: function removeTop() {\n          return stack.pop();\n        },\n        length: function length() {\n          return stack.length;\n        }\n      };\n    }\n  };\n});\nangular.module('ui.bootstrap.modal', ['ui.bootstrap.stackedMap', 'ui.bootstrap.position'])\n/**\n * A helper, internal data structure that stores all references attached to key\n */.factory('$$multiMap', function () {\n  return {\n    createNew: function createNew() {\n      var map = {};\n      return {\n        entries: function entries() {\n          return Object.keys(map).map(function (key) {\n            return {\n              key: key,\n              value: map[key]\n            };\n          });\n        },\n        get: function get(key) {\n          return map[key];\n        },\n        hasKey: function hasKey(key) {\n          return !!map[key];\n        },\n        keys: function keys() {\n          return Object.keys(map);\n        },\n        put: function put(key, value) {\n          if (!map[key]) {\n            map[key] = [];\n          }\n          map[key].push(value);\n        },\n        remove: function remove(key, value) {\n          var values = map[key];\n          if (!values) {\n            return;\n          }\n          var idx = values.indexOf(value);\n          if (idx !== -1) {\n            values.splice(idx, 1);\n          }\n          if (!values.length) {\n            delete map[key];\n          }\n        }\n      };\n    }\n  };\n})\n\n/**\n * Pluggable resolve mechanism for the modal resolve resolution\n * Supports UI Router's $resolve service\n */.provider('$uibResolve', function () {\n  var resolve = this;\n  this.resolver = null;\n  this.setResolver = function (resolver) {\n    this.resolver = resolver;\n  };\n  this.$get = ['$injector', '$q', function ($injector, $q) {\n    var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;\n    return {\n      resolve: function resolve(invocables, locals, parent, self) {\n        if (resolver) {\n          return resolver.resolve(invocables, locals, parent, self);\n        }\n        var promises = [];\n        angular.forEach(invocables, function (value) {\n          if (angular.isFunction(value) || angular.isArray(value)) {\n            promises.push($q.resolve($injector.invoke(value)));\n          } else if (angular.isString(value)) {\n            promises.push($q.resolve($injector.get(value)));\n          } else {\n            promises.push($q.resolve(value));\n          }\n        });\n        return $q.all(promises).then(function (resolves) {\n          var resolveObj = {};\n          var resolveIter = 0;\n          angular.forEach(invocables, function (value, key) {\n            resolveObj[key] = resolves[resolveIter++];\n          });\n          return resolveObj;\n        });\n      }\n    };\n  }];\n})\n\n/**\n * A helper directive for the $modal service. It creates a backdrop element.\n */.directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack', function ($animate, $injector, $modalStack) {\n  return {\n    restrict: 'A',\n    compile: function compile(tElement, tAttrs) {\n      tElement.addClass(tAttrs.backdropClass);\n      return linkFn;\n    }\n  };\n  function linkFn(scope, element, attrs) {\n    if (attrs.modalInClass) {\n      $animate.addClass(element, attrs.modalInClass);\n      scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {\n        var done = setIsAsync();\n        if (scope.modalOptions.animation) {\n          $animate.removeClass(element, attrs.modalInClass).then(done);\n        } else {\n          done();\n        }\n      });\n    }\n  }\n}]).directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document', function ($modalStack, $q, $animateCss, $document) {\n  return {\n    scope: {\n      index: '@'\n    },\n    restrict: 'A',\n    transclude: true,\n    templateUrl: function templateUrl(tElement, tAttrs) {\n      return tAttrs.templateUrl || 'uib/template/modal/window.html';\n    },\n    link: function link(scope, element, attrs) {\n      element.addClass(attrs.windowTopClass || '');\n      scope.size = attrs.size;\n      scope.close = function (evt) {\n        var modal = $modalStack.getTop();\n        if (modal && modal.value.backdrop && modal.value.backdrop !== 'static' && evt.target === evt.currentTarget) {\n          evt.preventDefault();\n          evt.stopPropagation();\n          $modalStack.dismiss(modal.key, 'backdrop click');\n        }\n      };\n\n      // moved from template to fix issue #2280\n      element.on('click', scope.close);\n\n      // This property is only added to the scope for the purpose of detecting when this directive is rendered.\n      // We can detect that by using this property in the template associated with this directive and then use\n      // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.\n      scope.$isRendered = true;\n\n      // Deferred object that will be resolved when this modal is rendered.\n      var modalRenderDeferObj = $q.defer();\n      // Resolve render promise post-digest\n      scope.$$postDigest(function () {\n        modalRenderDeferObj.resolve();\n      });\n      modalRenderDeferObj.promise.then(function () {\n        var animationPromise = null;\n        if (attrs.modalInClass) {\n          animationPromise = $animateCss(element, {\n            addClass: attrs.modalInClass\n          }).start();\n          scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {\n            var done = setIsAsync();\n            $animateCss(element, {\n              removeClass: attrs.modalInClass\n            }).start().then(done);\n          });\n        }\n        $q.when(animationPromise).then(function () {\n          // Notify {@link $modalStack} that modal is rendered.\n          var modal = $modalStack.getTop();\n          if (modal) {\n            $modalStack.modalRendered(modal.key);\n          }\n\n          /**\n           * If something within the freshly-opened modal already has focus (perhaps via a\n           * directive that causes focus) then there's no need to try to focus anything.\n           */\n          if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {\n            var inputWithAutofocus = element[0].querySelector('[autofocus]');\n            /**\n             * Auto-focusing of a freshly-opened modal element causes any child elements\n             * with the autofocus attribute to lose focus. This is an issue on touch\n             * based devices which will show and then hide the onscreen keyboard.\n             * Attempts to refocus the autofocus element via JavaScript will not reopen\n             * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus\n             * the modal element if the modal does not contain an autofocus element.\n             */\n            if (inputWithAutofocus) {\n              inputWithAutofocus.focus();\n            } else {\n              element[0].focus();\n            }\n          }\n        });\n      });\n    }\n  };\n}]).directive('uibModalAnimationClass', function () {\n  return {\n    compile: function compile(tElement, tAttrs) {\n      if (tAttrs.modalAnimation) {\n        tElement.addClass(tAttrs.uibModalAnimationClass);\n      }\n    }\n  };\n}).directive('uibModalTransclude', ['$animate', function ($animate) {\n  return {\n    link: function link(scope, element, attrs, controller, transclude) {\n      transclude(scope.$parent, function (clone) {\n        element.empty();\n        $animate.enter(clone, element);\n      });\n    }\n  };\n}]).factory('$uibModalStack', ['$animate', '$animateCss', '$document', '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition', function ($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {\n  var OPENED_MODAL_CLASS = 'modal-open';\n  var backdropDomEl, backdropScope;\n  var openedWindows = $$stackedMap.createNew();\n  var openedClasses = $$multiMap.createNew();\n  var $modalStack = {\n    NOW_CLOSING_EVENT: 'modal.stack.now-closing'\n  };\n  var topModalIndex = 0;\n  var previousTopOpenedModal = null;\n  var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';\n\n  //Modal focus behavior\n  var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\\'-1\\']), ' + 'button:not([disabled]):not([tabindex=\\'-1\\']),select:not([disabled]):not([tabindex=\\'-1\\']), textarea:not([disabled]):not([tabindex=\\'-1\\']), ' + 'iframe, object, embed, *[tabindex]:not([tabindex=\\'-1\\']), *[contenteditable=true]';\n  var scrollbarPadding;\n  var SNAKE_CASE_REGEXP = /[A-Z]/g;\n\n  // TODO: extract into common dependency with tooltip\n  function snake_case(name) {\n    var separator = '-';\n    return name.replace(SNAKE_CASE_REGEXP, function (letter, pos) {\n      return (pos ? separator : '') + letter.toLowerCase();\n    });\n  }\n  function isVisible(element) {\n    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);\n  }\n  function backdropIndex() {\n    var topBackdropIndex = -1;\n    var opened = openedWindows.keys();\n    for (var i = 0; i < opened.length; i++) {\n      if (openedWindows.get(opened[i]).value.backdrop) {\n        topBackdropIndex = i;\n      }\n    }\n\n    // If any backdrop exist, ensure that it's index is always\n    // right below the top modal\n    if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {\n      topBackdropIndex = topModalIndex;\n    }\n    return topBackdropIndex;\n  }\n  $rootScope.$watch(backdropIndex, function (newBackdropIndex) {\n    if (backdropScope) {\n      backdropScope.index = newBackdropIndex;\n    }\n  });\n  function removeModalWindow(modalInstance, elementToReceiveFocus) {\n    var modalWindow = openedWindows.get(modalInstance).value;\n    var appendToElement = modalWindow.appendTo;\n\n    //clean up the stack\n    openedWindows.remove(modalInstance);\n    previousTopOpenedModal = openedWindows.top();\n    if (previousTopOpenedModal) {\n      topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);\n    }\n    removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function () {\n      var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;\n      openedClasses.remove(modalBodyClass, modalInstance);\n      var areAnyOpen = openedClasses.hasKey(modalBodyClass);\n      appendToElement.toggleClass(modalBodyClass, areAnyOpen);\n      if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {\n        if (scrollbarPadding.originalRight) {\n          appendToElement.css({\n            paddingRight: scrollbarPadding.originalRight + 'px'\n          });\n        } else {\n          appendToElement.css({\n            paddingRight: ''\n          });\n        }\n        scrollbarPadding = null;\n      }\n      toggleTopWindowClass(true);\n    }, modalWindow.closedDeferred);\n    checkRemoveBackdrop();\n\n    //move focus to specified element if available, or else to body\n    if (elementToReceiveFocus && elementToReceiveFocus.focus) {\n      elementToReceiveFocus.focus();\n    } else if (appendToElement.focus) {\n      appendToElement.focus();\n    }\n  }\n\n  // Add or remove \"windowTopClass\" from the top window in the stack\n  function toggleTopWindowClass(toggleSwitch) {\n    var modalWindow;\n    if (openedWindows.length() > 0) {\n      modalWindow = openedWindows.top().value;\n      modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);\n    }\n  }\n  function checkRemoveBackdrop() {\n    //remove backdrop if no longer needed\n    if (backdropDomEl && backdropIndex() === -1) {\n      var backdropScopeRef = backdropScope;\n      removeAfterAnimate(backdropDomEl, backdropScope, function () {\n        backdropScopeRef = null;\n      });\n      backdropDomEl = undefined;\n      backdropScope = undefined;\n    }\n  }\n  function removeAfterAnimate(domEl, scope, done, closedDeferred) {\n    var asyncDeferred;\n    var asyncPromise = null;\n    var setIsAsync = function setIsAsync() {\n      if (!asyncDeferred) {\n        asyncDeferred = $q.defer();\n        asyncPromise = asyncDeferred.promise;\n      }\n      return function asyncDone() {\n        asyncDeferred.resolve();\n      };\n    };\n    scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);\n\n    // Note that it's intentional that asyncPromise might be null.\n    // That's when setIsAsync has not been called during the\n    // NOW_CLOSING_EVENT broadcast.\n    return $q.when(asyncPromise).then(afterAnimating);\n    function afterAnimating() {\n      if (afterAnimating.done) {\n        return;\n      }\n      afterAnimating.done = true;\n      $animate.leave(domEl).then(function () {\n        if (done) {\n          done();\n        }\n        domEl.remove();\n        if (closedDeferred) {\n          closedDeferred.resolve();\n        }\n      });\n      scope.$destroy();\n    }\n  }\n  $document.on('keydown', keydownListener);\n  $rootScope.$on('$destroy', function () {\n    $document.off('keydown', keydownListener);\n  });\n  function keydownListener(evt) {\n    if (evt.isDefaultPrevented()) {\n      return evt;\n    }\n    var modal = openedWindows.top();\n    if (modal) {\n      switch (evt.which) {\n        case 27:\n          {\n            if (modal.value.keyboard) {\n              evt.preventDefault();\n              $rootScope.$apply(function () {\n                $modalStack.dismiss(modal.key, 'escape key press');\n              });\n            }\n            break;\n          }\n        case 9:\n          {\n            var list = $modalStack.loadFocusElementList(modal);\n            var focusChanged = false;\n            if (evt.shiftKey) {\n              if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {\n                focusChanged = $modalStack.focusLastFocusableElement(list);\n              }\n            } else {\n              if ($modalStack.isFocusInLastItem(evt, list)) {\n                focusChanged = $modalStack.focusFirstFocusableElement(list);\n              }\n            }\n            if (focusChanged) {\n              evt.preventDefault();\n              evt.stopPropagation();\n            }\n            break;\n          }\n      }\n    }\n  }\n  $modalStack.open = function (modalInstance, modal) {\n    var modalOpener = $document[0].activeElement,\n      modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;\n    toggleTopWindowClass(false);\n\n    // Store the current top first, to determine what index we ought to use\n    // for the current top modal\n    previousTopOpenedModal = openedWindows.top();\n    openedWindows.add(modalInstance, {\n      deferred: modal.deferred,\n      renderDeferred: modal.renderDeferred,\n      closedDeferred: modal.closedDeferred,\n      modalScope: modal.scope,\n      backdrop: modal.backdrop,\n      keyboard: modal.keyboard,\n      openedClass: modal.openedClass,\n      windowTopClass: modal.windowTopClass,\n      animation: modal.animation,\n      appendTo: modal.appendTo\n    });\n    openedClasses.put(modalBodyClass, modalInstance);\n    var appendToElement = modal.appendTo,\n      currBackdropIndex = backdropIndex();\n    if (!appendToElement.length) {\n      throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');\n    }\n    if (currBackdropIndex >= 0 && !backdropDomEl) {\n      backdropScope = $rootScope.$new(true);\n      backdropScope.modalOptions = modal;\n      backdropScope.index = currBackdropIndex;\n      backdropDomEl = angular.element('<div uib-modal-backdrop=\"modal-backdrop\"></div>');\n      backdropDomEl.attr({\n        'class': 'modal-backdrop',\n        'ng-style': '{\\'z-index\\': 1040 + (index && 1 || 0) + index*10}',\n        'uib-modal-animation-class': 'fade',\n        'modal-in-class': 'in'\n      });\n      if (modal.backdropClass) {\n        backdropDomEl.addClass(modal.backdropClass);\n      }\n      if (modal.animation) {\n        backdropDomEl.attr('modal-animation', 'true');\n      }\n      $compile(backdropDomEl)(backdropScope);\n      $animate.enter(backdropDomEl, appendToElement);\n      if ($uibPosition.isScrollable(appendToElement)) {\n        scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);\n        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {\n          appendToElement.css({\n            paddingRight: scrollbarPadding.right + 'px'\n          });\n        }\n      }\n    }\n    var content;\n    if (modal.component) {\n      content = document.createElement(snake_case(modal.component.name));\n      content = angular.element(content);\n      content.attr({\n        resolve: '$resolve',\n        'modal-instance': '$uibModalInstance',\n        close: '$close($value)',\n        dismiss: '$dismiss($value)'\n      });\n    } else {\n      content = modal.content;\n    }\n\n    // Set the top modal index based on the index of the previous top modal\n    topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;\n    var angularDomEl = angular.element('<div uib-modal-window=\"modal-window\"></div>');\n    angularDomEl.attr({\n      'class': 'modal',\n      'template-url': modal.windowTemplateUrl,\n      'window-top-class': modal.windowTopClass,\n      'role': 'dialog',\n      'aria-labelledby': modal.ariaLabelledBy,\n      'aria-describedby': modal.ariaDescribedBy,\n      'size': modal.size,\n      'index': topModalIndex,\n      'animate': 'animate',\n      'ng-style': '{\\'z-index\\': 1050 + $$topModalIndex*10, display: \\'block\\'}',\n      'tabindex': -1,\n      'uib-modal-animation-class': 'fade',\n      'modal-in-class': 'in'\n    }).append(content);\n    if (modal.windowClass) {\n      angularDomEl.addClass(modal.windowClass);\n    }\n    if (modal.animation) {\n      angularDomEl.attr('modal-animation', 'true');\n    }\n    appendToElement.addClass(modalBodyClass);\n    if (modal.scope) {\n      // we need to explicitly add the modal index to the modal scope\n      // because it is needed by ngStyle to compute the zIndex property.\n      modal.scope.$$topModalIndex = topModalIndex;\n    }\n    $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);\n    openedWindows.top().value.modalDomEl = angularDomEl;\n    openedWindows.top().value.modalOpener = modalOpener;\n    applyAriaHidden(angularDomEl);\n    function applyAriaHidden(el) {\n      if (!el || el[0].tagName === 'BODY') {\n        return;\n      }\n      getSiblings(el).forEach(function (sibling) {\n        var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',\n          ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);\n        if (!ariaHiddenCount) {\n          ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;\n        }\n        sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);\n        sibling.setAttribute('aria-hidden', 'true');\n      });\n      return applyAriaHidden(el.parent());\n      function getSiblings(el) {\n        var children = el.parent() ? el.parent().children() : [];\n        return Array.prototype.filter.call(children, function (child) {\n          return child !== el[0];\n        });\n      }\n    }\n  };\n  function broadcastClosing(modalWindow, resultOrReason, closing) {\n    return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;\n  }\n  function unhideBackgroundElements() {\n    Array.prototype.forEach.call(document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'), function (hiddenEl) {\n      var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),\n        newHiddenCount = ariaHiddenCount - 1;\n      hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);\n      if (!newHiddenCount) {\n        hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);\n        hiddenEl.removeAttribute('aria-hidden');\n      }\n    });\n  }\n  $modalStack.close = function (modalInstance, result) {\n    var modalWindow = openedWindows.get(modalInstance);\n    unhideBackgroundElements();\n    if (modalWindow && broadcastClosing(modalWindow, result, true)) {\n      modalWindow.value.modalScope.$$uibDestructionScheduled = true;\n      modalWindow.value.deferred.resolve(result);\n      removeModalWindow(modalInstance, modalWindow.value.modalOpener);\n      return true;\n    }\n    return !modalWindow;\n  };\n  $modalStack.dismiss = function (modalInstance, reason) {\n    var modalWindow = openedWindows.get(modalInstance);\n    unhideBackgroundElements();\n    if (modalWindow && broadcastClosing(modalWindow, reason, false)) {\n      modalWindow.value.modalScope.$$uibDestructionScheduled = true;\n      modalWindow.value.deferred.reject(reason);\n      removeModalWindow(modalInstance, modalWindow.value.modalOpener);\n      return true;\n    }\n    return !modalWindow;\n  };\n  $modalStack.dismissAll = function (reason) {\n    var topModal = this.getTop();\n    while (topModal && this.dismiss(topModal.key, reason)) {\n      topModal = this.getTop();\n    }\n  };\n  $modalStack.getTop = function () {\n    return openedWindows.top();\n  };\n  $modalStack.modalRendered = function (modalInstance) {\n    var modalWindow = openedWindows.get(modalInstance);\n    $modalStack.focusFirstFocusableElement($modalStack.loadFocusElementList(modalWindow));\n    if (modalWindow) {\n      modalWindow.value.renderDeferred.resolve();\n    }\n  };\n  $modalStack.focusFirstFocusableElement = function (list) {\n    if (list.length > 0) {\n      list[0].focus();\n      return true;\n    }\n    return false;\n  };\n  $modalStack.focusLastFocusableElement = function (list) {\n    if (list.length > 0) {\n      list[list.length - 1].focus();\n      return true;\n    }\n    return false;\n  };\n  $modalStack.isModalFocused = function (evt, modalWindow) {\n    if (evt && modalWindow) {\n      var modalDomEl = modalWindow.value.modalDomEl;\n      if (modalDomEl && modalDomEl.length) {\n        return (evt.target || evt.srcElement) === modalDomEl[0];\n      }\n    }\n    return false;\n  };\n  $modalStack.isFocusInFirstItem = function (evt, list) {\n    if (list.length > 0) {\n      return (evt.target || evt.srcElement) === list[0];\n    }\n    return false;\n  };\n  $modalStack.isFocusInLastItem = function (evt, list) {\n    if (list.length > 0) {\n      return (evt.target || evt.srcElement) === list[list.length - 1];\n    }\n    return false;\n  };\n  $modalStack.loadFocusElementList = function (modalWindow) {\n    if (modalWindow) {\n      var modalDomE1 = modalWindow.value.modalDomEl;\n      if (modalDomE1 && modalDomE1.length) {\n        var elements = modalDomE1[0].querySelectorAll(tabbableSelector);\n        return elements ? Array.prototype.filter.call(elements, function (element) {\n          return isVisible(element);\n        }) : elements;\n      }\n    }\n  };\n  return $modalStack;\n}]).provider('$uibModal', function () {\n  var $modalProvider = {\n    options: {\n      animation: true,\n      backdrop: true,\n      //can also be false or 'static'\n      keyboard: true\n    },\n    $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack', function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {\n      var $modal = {};\n      function getTemplatePromise(options) {\n        return options.template ? $q.when(options.template) : $templateRequest(angular.isFunction(options.templateUrl) ? options.templateUrl() : options.templateUrl);\n      }\n      var promiseChain = null;\n      $modal.getPromiseChain = function () {\n        return promiseChain;\n      };\n      $modal.open = function (modalOptions) {\n        var modalResultDeferred = $q.defer();\n        var modalOpenedDeferred = $q.defer();\n        var modalClosedDeferred = $q.defer();\n        var modalRenderDeferred = $q.defer();\n\n        //prepare an instance of a modal to be injected into controllers and returned to a caller\n        var modalInstance = {\n          result: modalResultDeferred.promise,\n          opened: modalOpenedDeferred.promise,\n          closed: modalClosedDeferred.promise,\n          rendered: modalRenderDeferred.promise,\n          close: function close(result) {\n            return $modalStack.close(modalInstance, result);\n          },\n          dismiss: function dismiss(reason) {\n            return $modalStack.dismiss(modalInstance, reason);\n          }\n        };\n\n        //merge and clean up options\n        modalOptions = angular.extend({}, $modalProvider.options, modalOptions);\n        modalOptions.resolve = modalOptions.resolve || {};\n        modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);\n\n        //verify options\n        if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {\n          throw new Error('One of component or template or templateUrl options is required.');\n        }\n        var templateAndResolvePromise;\n        if (modalOptions.component) {\n          templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));\n        } else {\n          templateAndResolvePromise = $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);\n        }\n        function resolveWithTemplate() {\n          return templateAndResolvePromise;\n        }\n\n        // Wait for the resolution of the existing promise chain.\n        // Then switch to our own combined promise dependency (regardless of how the previous modal fared).\n        // Then add to $modalStack and resolve opened.\n        // Finally clean up the chain variable if no subsequent modal has overwritten it.\n        var samePromise;\n        samePromise = promiseChain = $q.all([promiseChain]).then(resolveWithTemplate, resolveWithTemplate).then(function resolveSuccess(tplAndVars) {\n          var providedScope = modalOptions.scope || $rootScope;\n          var modalScope = providedScope.$new();\n          modalScope.$close = modalInstance.close;\n          modalScope.$dismiss = modalInstance.dismiss;\n          modalScope.$on('$destroy', function () {\n            if (!modalScope.$$uibDestructionScheduled) {\n              modalScope.$dismiss('$uibUnscheduledDestruction');\n            }\n          });\n          var modal = {\n            scope: modalScope,\n            deferred: modalResultDeferred,\n            renderDeferred: modalRenderDeferred,\n            closedDeferred: modalClosedDeferred,\n            animation: modalOptions.animation,\n            backdrop: modalOptions.backdrop,\n            keyboard: modalOptions.keyboard,\n            backdropClass: modalOptions.backdropClass,\n            windowTopClass: modalOptions.windowTopClass,\n            windowClass: modalOptions.windowClass,\n            windowTemplateUrl: modalOptions.windowTemplateUrl,\n            ariaLabelledBy: modalOptions.ariaLabelledBy,\n            ariaDescribedBy: modalOptions.ariaDescribedBy,\n            size: modalOptions.size,\n            openedClass: modalOptions.openedClass,\n            appendTo: modalOptions.appendTo\n          };\n          var component = {};\n          var ctrlInstance,\n            ctrlInstantiate,\n            ctrlLocals = {};\n          if (modalOptions.component) {\n            constructLocals(component, false, true, false);\n            component.name = modalOptions.component;\n            modal.component = component;\n          } else if (modalOptions.controller) {\n            constructLocals(ctrlLocals, true, false, true);\n\n            // the third param will make the controller instantiate later,private api\n            // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126\n            ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);\n            if (modalOptions.controllerAs && modalOptions.bindToController) {\n              ctrlInstance = ctrlInstantiate.instance;\n              ctrlInstance.$close = modalScope.$close;\n              ctrlInstance.$dismiss = modalScope.$dismiss;\n              angular.extend(ctrlInstance, {\n                $resolve: ctrlLocals.$scope.$resolve\n              }, providedScope);\n            }\n            ctrlInstance = ctrlInstantiate();\n            if (angular.isFunction(ctrlInstance.$onInit)) {\n              ctrlInstance.$onInit();\n            }\n          }\n          if (!modalOptions.component) {\n            modal.content = tplAndVars[0];\n          }\n          $modalStack.open(modalInstance, modal);\n          modalOpenedDeferred.resolve(true);\n          function constructLocals(obj, template, instanceOnScope, injectable) {\n            obj.$scope = modalScope;\n            obj.$scope.$resolve = {};\n            if (instanceOnScope) {\n              obj.$scope.$uibModalInstance = modalInstance;\n            } else {\n              obj.$uibModalInstance = modalInstance;\n            }\n            var resolves = template ? tplAndVars[1] : tplAndVars;\n            angular.forEach(resolves, function (value, key) {\n              if (injectable) {\n                obj[key] = value;\n              }\n              obj.$scope.$resolve[key] = value;\n            });\n          }\n        }, function resolveError(reason) {\n          modalOpenedDeferred.reject(reason);\n          modalResultDeferred.reject(reason);\n        })['finally'](function () {\n          if (promiseChain === samePromise) {\n            promiseChain = null;\n          }\n        });\n        return modalInstance;\n      };\n      return $modal;\n    }]\n  };\n  return $modalProvider;\n});\nangular.module('ui.bootstrap.paging', [])\n/**\n * Helper internal service for generating common controller code between the\n * pager and pagination components\n */.factory('uibPaging', ['$parse', function ($parse) {\n  return {\n    create: function create(ctrl, $scope, $attrs) {\n      ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;\n      ctrl.ngModelCtrl = {\n        $setViewValue: angular.noop\n      }; // nullModelCtrl\n      ctrl._watchers = [];\n      ctrl.init = function (ngModelCtrl, config) {\n        ctrl.ngModelCtrl = ngModelCtrl;\n        ctrl.config = config;\n        ngModelCtrl.$render = function () {\n          ctrl.render();\n        };\n        if ($attrs.itemsPerPage) {\n          ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function (value) {\n            ctrl.itemsPerPage = parseInt(value, 10);\n            $scope.totalPages = ctrl.calculateTotalPages();\n            ctrl.updatePage();\n          }));\n        } else {\n          ctrl.itemsPerPage = config.itemsPerPage;\n        }\n        $scope.$watch('totalItems', function (newTotal, oldTotal) {\n          if (angular.isDefined(newTotal) || newTotal !== oldTotal) {\n            $scope.totalPages = ctrl.calculateTotalPages();\n            ctrl.updatePage();\n          }\n        });\n      };\n      ctrl.calculateTotalPages = function () {\n        var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);\n        return Math.max(totalPages || 0, 1);\n      };\n      ctrl.render = function () {\n        $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;\n      };\n      $scope.selectPage = function (page, evt) {\n        if (evt) {\n          evt.preventDefault();\n        }\n        var clickAllowed = !$scope.ngDisabled || !evt;\n        if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {\n          if (evt && evt.target) {\n            evt.target.blur();\n          }\n          ctrl.ngModelCtrl.$setViewValue(page);\n          ctrl.ngModelCtrl.$render();\n        }\n      };\n      $scope.getText = function (key) {\n        return $scope[key + 'Text'] || ctrl.config[key + 'Text'];\n      };\n      $scope.noPrevious = function () {\n        return $scope.page === 1;\n      };\n      $scope.noNext = function () {\n        return $scope.page === $scope.totalPages;\n      };\n      ctrl.updatePage = function () {\n        ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable\n\n        if ($scope.page > $scope.totalPages) {\n          $scope.selectPage($scope.totalPages);\n        } else {\n          ctrl.ngModelCtrl.$render();\n        }\n      };\n      $scope.$on('$destroy', function () {\n        while (ctrl._watchers.length) {\n          ctrl._watchers.shift()();\n        }\n      });\n    }\n  };\n}]);\nangular.module('ui.bootstrap.pager', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex']).controller('UibPagerController', ['$scope', '$attrs', 'uibPaging', 'uibPagerConfig', function ($scope, $attrs, uibPaging, uibPagerConfig) {\n  $scope.align = angular.isDefined($attrs.align) ? $scope.$parent.$eval($attrs.align) : uibPagerConfig.align;\n  uibPaging.create(this, $scope, $attrs);\n}]).constant('uibPagerConfig', {\n  itemsPerPage: 10,\n  previousText: '« Previous',\n  nextText: 'Next »',\n  align: true\n}).directive('uibPager', ['uibPagerConfig', function (uibPagerConfig) {\n  return {\n    scope: {\n      totalItems: '=',\n      previousText: '@',\n      nextText: '@',\n      ngDisabled: '='\n    },\n    require: ['uibPager', '?ngModel'],\n    restrict: 'A',\n    controller: 'UibPagerController',\n    controllerAs: 'pager',\n    templateUrl: function templateUrl(element, attrs) {\n      return attrs.templateUrl || 'uib/template/pager/pager.html';\n    },\n    link: function link(scope, element, attrs, ctrls) {\n      element.addClass('pager');\n      var paginationCtrl = ctrls[0],\n        ngModelCtrl = ctrls[1];\n      if (!ngModelCtrl) {\n        return; // do nothing if no ng-model\n      }\n      paginationCtrl.init(ngModelCtrl, uibPagerConfig);\n    }\n  };\n}]);\nangular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex']).controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function ($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {\n  var ctrl = this;\n  // Setup configuration parameters\n  var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,\n    rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,\n    forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,\n    boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,\n    pageLabel = angular.isDefined($attrs.pageLabel) ? function (idx) {\n      return $scope.$parent.$eval($attrs.pageLabel, {\n        $page: idx\n      });\n    } : angular.identity;\n  $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;\n  $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;\n  uibPaging.create(this, $scope, $attrs);\n  if ($attrs.maxSize) {\n    ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function (value) {\n      maxSize = parseInt(value, 10);\n      ctrl.render();\n    }));\n  }\n\n  // Create page object used in template\n  function makePage(number, text, isActive) {\n    return {\n      number: number,\n      text: text,\n      active: isActive\n    };\n  }\n  function getPages(currentPage, totalPages) {\n    var pages = [];\n\n    // Default page limits\n    var startPage = 1,\n      endPage = totalPages;\n    var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;\n\n    // recompute if maxSize\n    if (isMaxSized) {\n      if (rotate) {\n        // Current page is displayed in the middle of the visible ones\n        startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);\n        endPage = startPage + maxSize - 1;\n\n        // Adjust if limit is exceeded\n        if (endPage > totalPages) {\n          endPage = totalPages;\n          startPage = endPage - maxSize + 1;\n        }\n      } else {\n        // Visible pages are paginated with maxSize\n        startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;\n\n        // Adjust last page if limit is exceeded\n        endPage = Math.min(startPage + maxSize - 1, totalPages);\n      }\n    }\n\n    // Add page number links\n    for (var number = startPage; number <= endPage; number++) {\n      var page = makePage(number, pageLabel(number), number === currentPage);\n      pages.push(page);\n    }\n\n    // Add links to move between page sets\n    if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {\n      if (startPage > 1) {\n        if (!boundaryLinkNumbers || startPage > 3) {\n          //need ellipsis for all options unless range is too close to beginning\n          var previousPageSet = makePage(startPage - 1, '...', false);\n          pages.unshift(previousPageSet);\n        }\n        if (boundaryLinkNumbers) {\n          if (startPage === 3) {\n            //need to replace ellipsis when the buttons would be sequential\n            var secondPageLink = makePage(2, '2', false);\n            pages.unshift(secondPageLink);\n          }\n          //add the first page\n          var firstPageLink = makePage(1, '1', false);\n          pages.unshift(firstPageLink);\n        }\n      }\n      if (endPage < totalPages) {\n        if (!boundaryLinkNumbers || endPage < totalPages - 2) {\n          //need ellipsis for all options unless range is too close to end\n          var nextPageSet = makePage(endPage + 1, '...', false);\n          pages.push(nextPageSet);\n        }\n        if (boundaryLinkNumbers) {\n          if (endPage === totalPages - 2) {\n            //need to replace ellipsis when the buttons would be sequential\n            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);\n            pages.push(secondToLastPageLink);\n          }\n          //add the last page\n          var lastPageLink = makePage(totalPages, totalPages, false);\n          pages.push(lastPageLink);\n        }\n      }\n    }\n    return pages;\n  }\n  var originalRender = this.render;\n  this.render = function () {\n    originalRender();\n    if ($scope.page > 0 && $scope.page <= $scope.totalPages) {\n      $scope.pages = getPages($scope.page, $scope.totalPages);\n    }\n  };\n}]).constant('uibPaginationConfig', {\n  itemsPerPage: 10,\n  boundaryLinks: false,\n  boundaryLinkNumbers: false,\n  directionLinks: true,\n  firstText: 'First',\n  previousText: 'Previous',\n  nextText: 'Next',\n  lastText: 'Last',\n  rotate: true,\n  forceEllipses: false\n}).directive('uibPagination', ['$parse', 'uibPaginationConfig', function ($parse, uibPaginationConfig) {\n  return {\n    scope: {\n      totalItems: '=',\n      firstText: '@',\n      previousText: '@',\n      nextText: '@',\n      lastText: '@',\n      ngDisabled: '='\n    },\n    require: ['uibPagination', '?ngModel'],\n    restrict: 'A',\n    controller: 'UibPaginationController',\n    controllerAs: 'pagination',\n    templateUrl: function templateUrl(element, attrs) {\n      return attrs.templateUrl || 'uib/template/pagination/pagination.html';\n    },\n    link: function link(scope, element, attrs, ctrls) {\n      element.addClass('pagination');\n      var paginationCtrl = ctrls[0],\n        ngModelCtrl = ctrls[1];\n      if (!ngModelCtrl) {\n        return; // do nothing if no ng-model\n      }\n      paginationCtrl.init(ngModelCtrl, uibPaginationConfig);\n    }\n  };\n}]);\n\n/**\n * The following features are still outstanding: animation as a\n * function, placement as a function, inside, support for more triggers than\n * just mouse enter/leave, html tooltips, and selector delegation.\n */\nangular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])\n\n/**\n * The $tooltip service creates tooltip- and popover-like directives as well as\n * houses global options for them.\n */.provider('$uibTooltip', function () {\n  // The default options tooltip and popover.\n  var defaultOptions = {\n    placement: 'top',\n    placementClassPrefix: '',\n    animation: true,\n    popupDelay: 0,\n    popupCloseDelay: 0,\n    useContentExp: false\n  };\n\n  // Default hide triggers for each show trigger\n  var triggerMap = {\n    'mouseenter': 'mouseleave',\n    'click': 'click',\n    'outsideClick': 'outsideClick',\n    'focus': 'blur',\n    'none': ''\n  };\n\n  // The options specified to the provider globally.\n  var globalOptions = {};\n\n  /**\n   * `options({})` allows global configuration of all tooltips in the\n   * application.\n   *\n   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {\n   *     // place tooltips left instead of top by default\n   *     $tooltipProvider.options( { placement: 'left' } );\n   *   });\n   */\n  this.options = function (value) {\n    angular.extend(globalOptions, value);\n  };\n\n  /**\n   * This allows you to extend the set of trigger mappings available. E.g.:\n   *\n   *   $tooltipProvider.setTriggers( { 'openTrigger': 'closeTrigger' } );\n   */\n  this.setTriggers = function setTriggers(triggers) {\n    angular.extend(triggerMap, triggers);\n  };\n\n  /**\n   * This is a helper function for translating camel-case to snake_case.\n   */\n  function snake_case(name) {\n    var regexp = /[A-Z]/g;\n    var separator = '-';\n    return name.replace(regexp, function (letter, pos) {\n      return (pos ? separator : '') + letter.toLowerCase();\n    });\n  }\n\n  /**\n   * Returns the actual instance of the $tooltip service.\n   * TODO support multiple triggers\n   */\n  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function ($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {\n    var openedTooltips = $$stackedMap.createNew();\n    $document.on('keyup', keypressListener);\n    $rootScope.$on('$destroy', function () {\n      $document.off('keyup', keypressListener);\n    });\n    function keypressListener(e) {\n      if (e.which === 27) {\n        var last = openedTooltips.top();\n        if (last) {\n          last.value.close();\n          last = null;\n        }\n      }\n    }\n    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {\n      options = angular.extend({}, defaultOptions, globalOptions, options);\n\n      /**\n       * Returns an object of show and hide triggers.\n       *\n       * If a trigger is supplied,\n       * it is used to show the tooltip; otherwise, it will use the `trigger`\n       * option passed to the `$tooltipProvider.options` method; else it will\n       * default to the trigger supplied to this directive factory.\n       *\n       * The hide trigger is based on the show trigger. If the `trigger` option\n       * was passed to the `$tooltipProvider.options` method, it will use the\n       * mapped trigger from `triggerMap` or the passed trigger if the map is\n       * undefined; otherwise, it uses the `triggerMap` value of the show\n       * trigger; else it will just use the show trigger.\n       */\n      function getTriggers(trigger) {\n        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');\n        var hide = show.map(function (trigger) {\n          return triggerMap[trigger] || trigger;\n        });\n        return {\n          show: show,\n          hide: hide\n        };\n      }\n      var directiveName = snake_case(ttType);\n      var startSym = $interpolate.startSymbol();\n      var endSym = $interpolate.endSymbol();\n      var template = '<div ' + directiveName + '-popup ' + 'uib-title=\"' + startSym + 'title' + endSym + '\" ' + (options.useContentExp ? 'content-exp=\"contentExp()\" ' : 'content=\"' + startSym + 'content' + endSym + '\" ') + 'origin-scope=\"origScope\" ' + 'class=\"uib-position-measure ' + prefix + '\" ' + 'tooltip-animation-class=\"fade\"' + 'uib-tooltip-classes ' + 'ng-class=\"{ in: isOpen }\" ' + '>' + '</div>';\n      return {\n        compile: function compile(tElem, tAttrs) {\n          var tooltipLinker = $compile(template);\n          return function link(scope, element, attrs, tooltipCtrl) {\n            var tooltip;\n            var tooltipLinkedScope;\n            var transitionTimeout;\n            var showTimeout;\n            var hideTimeout;\n            var positionTimeout;\n            var adjustmentTimeout;\n            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;\n            var triggers = getTriggers(undefined);\n            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);\n            var ttScope = scope.$new(true);\n            var repositionScheduled = false;\n            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;\n            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;\n            var observers = [];\n            var lastPlacement;\n            var positionTooltip = function positionTooltip() {\n              // check if tooltip exists and is not empty\n              if (!tooltip || !tooltip.html()) {\n                return;\n              }\n              if (!positionTimeout) {\n                positionTimeout = $timeout(function () {\n                  var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);\n                  var initialHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');\n                  var elementPos = appendToBody ? $position.offset(element) : $position.position(element);\n                  tooltip.css({\n                    top: ttPosition.top + 'px',\n                    left: ttPosition.left + 'px'\n                  });\n                  var placementClasses = ttPosition.placement.split('-');\n                  if (!tooltip.hasClass(placementClasses[0])) {\n                    tooltip.removeClass(lastPlacement.split('-')[0]);\n                    tooltip.addClass(placementClasses[0]);\n                  }\n                  if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {\n                    tooltip.removeClass(options.placementClassPrefix + lastPlacement);\n                    tooltip.addClass(options.placementClassPrefix + ttPosition.placement);\n                  }\n                  adjustmentTimeout = $timeout(function () {\n                    var currentHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');\n                    var adjustment = $position.adjustTop(placementClasses, elementPos, initialHeight, currentHeight);\n                    if (adjustment) {\n                      tooltip.css(adjustment);\n                    }\n                    adjustmentTimeout = null;\n                  }, 0, false);\n\n                  // first time through tt element will have the\n                  // uib-position-measure class or if the placement\n                  // has changed we need to position the arrow.\n                  if (tooltip.hasClass('uib-position-measure')) {\n                    $position.positionArrow(tooltip, ttPosition.placement);\n                    tooltip.removeClass('uib-position-measure');\n                  } else if (lastPlacement !== ttPosition.placement) {\n                    $position.positionArrow(tooltip, ttPosition.placement);\n                  }\n                  lastPlacement = ttPosition.placement;\n                  positionTimeout = null;\n                }, 0, false);\n              }\n            };\n\n            // Set up the correct scope to allow transclusion later\n            ttScope.origScope = scope;\n\n            // By default, the tooltip is not open.\n            // TODO add ability to start tooltip opened\n            ttScope.isOpen = false;\n            function toggleTooltipBind() {\n              if (!ttScope.isOpen) {\n                showTooltipBind();\n              } else {\n                hideTooltipBind();\n              }\n            }\n\n            // Show the tooltip with delay if specified, otherwise show it immediately\n            function showTooltipBind() {\n              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {\n                return;\n              }\n              cancelHide();\n              prepareTooltip();\n              if (ttScope.popupDelay) {\n                // Do nothing if the tooltip was already scheduled to pop-up.\n                // This happens if show is triggered multiple times before any hide is triggered.\n                if (!showTimeout) {\n                  showTimeout = $timeout(show, ttScope.popupDelay, false);\n                }\n              } else {\n                show();\n              }\n            }\n            function hideTooltipBind() {\n              cancelShow();\n              if (ttScope.popupCloseDelay) {\n                if (!hideTimeout) {\n                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);\n                }\n              } else {\n                hide();\n              }\n            }\n\n            // Show the tooltip popup element.\n            function show() {\n              cancelShow();\n              cancelHide();\n\n              // Don't show empty tooltips.\n              if (!ttScope.content) {\n                return angular.noop;\n              }\n              createTooltip();\n\n              // And show the tooltip.\n              ttScope.$evalAsync(function () {\n                ttScope.isOpen = true;\n                assignIsOpen(true);\n                positionTooltip();\n              });\n            }\n            function cancelShow() {\n              if (showTimeout) {\n                $timeout.cancel(showTimeout);\n                showTimeout = null;\n              }\n              if (positionTimeout) {\n                $timeout.cancel(positionTimeout);\n                positionTimeout = null;\n              }\n            }\n\n            // Hide the tooltip popup element.\n            function hide() {\n              if (!ttScope) {\n                return;\n              }\n\n              // First things first: we don't show it anymore.\n              ttScope.$evalAsync(function () {\n                if (ttScope) {\n                  ttScope.isOpen = false;\n                  assignIsOpen(false);\n                  // And now we remove it from the DOM. However, if we have animation, we\n                  // need to wait for it to expire beforehand.\n                  // FIXME: this is a placeholder for a port of the transitions library.\n                  // The fade transition in TWBS is 150ms.\n                  if (ttScope.animation) {\n                    if (!transitionTimeout) {\n                      transitionTimeout = $timeout(removeTooltip, 150, false);\n                    }\n                  } else {\n                    removeTooltip();\n                  }\n                }\n              });\n            }\n            function cancelHide() {\n              if (hideTimeout) {\n                $timeout.cancel(hideTimeout);\n                hideTimeout = null;\n              }\n              if (transitionTimeout) {\n                $timeout.cancel(transitionTimeout);\n                transitionTimeout = null;\n              }\n            }\n            function createTooltip() {\n              // There can only be one tooltip element per directive shown at once.\n              if (tooltip) {\n                return;\n              }\n              tooltipLinkedScope = ttScope.$new();\n              tooltip = tooltipLinker(tooltipLinkedScope, function (tooltip) {\n                if (appendToBody) {\n                  $document.find('body').append(tooltip);\n                } else {\n                  element.after(tooltip);\n                }\n              });\n              openedTooltips.add(ttScope, {\n                close: hide\n              });\n              prepObservers();\n            }\n            function removeTooltip() {\n              cancelShow();\n              cancelHide();\n              unregisterObservers();\n              if (tooltip) {\n                tooltip.remove();\n                tooltip = null;\n                if (adjustmentTimeout) {\n                  $timeout.cancel(adjustmentTimeout);\n                }\n              }\n              openedTooltips.remove(ttScope);\n              if (tooltipLinkedScope) {\n                tooltipLinkedScope.$destroy();\n                tooltipLinkedScope = null;\n              }\n            }\n\n            /**\n             * Set the initial scope values. Once\n             * the tooltip is created, the observers\n             * will be added to keep things in sync.\n             */\n            function prepareTooltip() {\n              ttScope.title = attrs[prefix + 'Title'];\n              if (contentParse) {\n                ttScope.content = contentParse(scope);\n              } else {\n                ttScope.content = attrs[ttType];\n              }\n              ttScope.popupClass = attrs[prefix + 'Class'];\n              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;\n              var placement = $position.parsePlacement(ttScope.placement);\n              lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];\n              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);\n              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);\n              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;\n              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;\n            }\n            function assignIsOpen(isOpen) {\n              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {\n                isOpenParse.assign(scope, isOpen);\n              }\n            }\n            ttScope.contentExp = function () {\n              return ttScope.content;\n            };\n\n            /**\n             * Observe the relevant attributes.\n             */\n            attrs.$observe('disabled', function (val) {\n              if (val) {\n                cancelShow();\n              }\n              if (val && ttScope.isOpen) {\n                hide();\n              }\n            });\n            if (isOpenParse) {\n              scope.$watch(isOpenParse, function (val) {\n                if (ttScope && !val === ttScope.isOpen) {\n                  toggleTooltipBind();\n                }\n              });\n            }\n            function prepObservers() {\n              observers.length = 0;\n              if (contentParse) {\n                observers.push(scope.$watch(contentParse, function (val) {\n                  ttScope.content = val;\n                  if (!val && ttScope.isOpen) {\n                    hide();\n                  }\n                }));\n                observers.push(tooltipLinkedScope.$watch(function () {\n                  if (!repositionScheduled) {\n                    repositionScheduled = true;\n                    tooltipLinkedScope.$$postDigest(function () {\n                      repositionScheduled = false;\n                      if (ttScope && ttScope.isOpen) {\n                        positionTooltip();\n                      }\n                    });\n                  }\n                }));\n              } else {\n                observers.push(attrs.$observe(ttType, function (val) {\n                  ttScope.content = val;\n                  if (!val && ttScope.isOpen) {\n                    hide();\n                  } else {\n                    positionTooltip();\n                  }\n                }));\n              }\n              observers.push(attrs.$observe(prefix + 'Title', function (val) {\n                ttScope.title = val;\n                if (ttScope.isOpen) {\n                  positionTooltip();\n                }\n              }));\n              observers.push(attrs.$observe(prefix + 'Placement', function (val) {\n                ttScope.placement = val ? val : options.placement;\n                if (ttScope.isOpen) {\n                  positionTooltip();\n                }\n              }));\n            }\n            function unregisterObservers() {\n              if (observers.length) {\n                angular.forEach(observers, function (observer) {\n                  observer();\n                });\n                observers.length = 0;\n              }\n            }\n\n            // hide tooltips/popovers for outsideClick trigger\n            function bodyHideTooltipBind(e) {\n              if (!ttScope || !ttScope.isOpen || !tooltip) {\n                return;\n              }\n              // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked\n              if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {\n                hideTooltipBind();\n              }\n            }\n            var unregisterTriggers = function unregisterTriggers() {\n              triggers.show.forEach(function (trigger) {\n                if (trigger === 'outsideClick') {\n                  element.off('click', toggleTooltipBind);\n                } else {\n                  element.off(trigger, showTooltipBind);\n                  element.off(trigger, toggleTooltipBind);\n                }\n              });\n              triggers.hide.forEach(function (trigger) {\n                if (trigger === 'outsideClick') {\n                  $document.off('click', bodyHideTooltipBind);\n                } else {\n                  element.off(trigger, hideTooltipBind);\n                }\n              });\n            };\n            function prepTriggers() {\n              var showTriggers = [],\n                hideTriggers = [];\n              var val = scope.$eval(attrs[prefix + 'Trigger']);\n              unregisterTriggers();\n              if (angular.isObject(val)) {\n                Object.keys(val).forEach(function (key) {\n                  showTriggers.push(key);\n                  hideTriggers.push(val[key]);\n                });\n                triggers = {\n                  show: showTriggers,\n                  hide: hideTriggers\n                };\n              } else {\n                triggers = getTriggers(val);\n              }\n              if (triggers.show !== 'none') {\n                triggers.show.forEach(function (trigger, idx) {\n                  if (trigger === 'outsideClick') {\n                    element.on('click', toggleTooltipBind);\n                    $document.on('click', bodyHideTooltipBind);\n                  } else if (trigger === triggers.hide[idx]) {\n                    element.on(trigger, toggleTooltipBind);\n                  } else if (trigger) {\n                    element.on(trigger, showTooltipBind);\n                    element.on(triggers.hide[idx], hideTooltipBind);\n                  }\n                  element.on('keypress', function (e) {\n                    if (e.which === 27) {\n                      hideTooltipBind();\n                    }\n                  });\n                });\n              }\n            }\n            prepTriggers();\n            var animation = scope.$eval(attrs[prefix + 'Animation']);\n            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;\n            var appendToBodyVal;\n            var appendKey = prefix + 'AppendToBody';\n            if (appendKey in attrs && attrs[appendKey] === undefined) {\n              appendToBodyVal = true;\n            } else {\n              appendToBodyVal = scope.$eval(attrs[appendKey]);\n            }\n            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;\n\n            // Make sure tooltip is destroyed and removed.\n            scope.$on('$destroy', function onDestroyTooltip() {\n              unregisterTriggers();\n              removeTooltip();\n              ttScope = null;\n            });\n          };\n        }\n      };\n    };\n  }];\n})\n\n// This is mostly ngInclude code but with a custom scope\n.directive('uibTooltipTemplateTransclude', ['$animate', '$sce', '$compile', '$templateRequest', function ($animate, $sce, $compile, $templateRequest) {\n  return {\n    link: function link(scope, elem, attrs) {\n      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);\n      var changeCounter = 0,\n        currentScope,\n        previousElement,\n        currentElement;\n      var cleanupLastIncludeContent = function cleanupLastIncludeContent() {\n        if (previousElement) {\n          previousElement.remove();\n          previousElement = null;\n        }\n        if (currentScope) {\n          currentScope.$destroy();\n          currentScope = null;\n        }\n        if (currentElement) {\n          $animate.leave(currentElement).then(function () {\n            previousElement = null;\n          });\n          previousElement = currentElement;\n          currentElement = null;\n        }\n      };\n      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function (src) {\n        var thisChangeId = ++changeCounter;\n        if (src) {\n          //set the 2nd param to true to ignore the template request error so that the inner\n          //contents and scope can be cleaned up.\n          $templateRequest(src, true).then(function (response) {\n            if (thisChangeId !== changeCounter) {\n              return;\n            }\n            var newScope = origScope.$new();\n            var template = response;\n            var clone = $compile(template)(newScope, function (clone) {\n              cleanupLastIncludeContent();\n              $animate.enter(clone, elem);\n            });\n            currentScope = newScope;\n            currentElement = clone;\n            currentScope.$emit('$includeContentLoaded', src);\n          }, function () {\n            if (thisChangeId === changeCounter) {\n              cleanupLastIncludeContent();\n              scope.$emit('$includeContentError', src);\n            }\n          });\n          scope.$emit('$includeContentRequested', src);\n        } else {\n          cleanupLastIncludeContent();\n        }\n      });\n      scope.$on('$destroy', cleanupLastIncludeContent);\n    }\n  };\n}])\n\n/**\n * Note that it's intentional that these classes are *not* applied through $animate.\n * They must not be animated as they're expected to be present on the tooltip on\n * initialization.\n */.directive('uibTooltipClasses', ['$uibPosition', function ($uibPosition) {\n  return {\n    restrict: 'A',\n    link: function link(scope, element, attrs) {\n      // need to set the primary position so the\n      // arrow has space during position measure.\n      // tooltip.positionTooltip()\n      if (scope.placement) {\n        // // There are no top-left etc... classes\n        // // in TWBS, so we need the primary position.\n        var position = $uibPosition.parsePlacement(scope.placement);\n        element.addClass(position[0]);\n      }\n      if (scope.popupClass) {\n        element.addClass(scope.popupClass);\n      }\n      if (scope.animation) {\n        element.addClass(attrs.tooltipAnimationClass);\n      }\n    }\n  };\n}]).directive('uibTooltipPopup', function () {\n  return {\n    restrict: 'A',\n    scope: {\n      content: '@'\n    },\n    templateUrl: 'uib/template/tooltip/tooltip-popup.html'\n  };\n}).directive('uibTooltip', ['$uibTooltip', function ($uibTooltip) {\n  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');\n}]).directive('uibTooltipTemplatePopup', function () {\n  return {\n    restrict: 'A',\n    scope: {\n      contentExp: '&',\n      originScope: '&'\n    },\n    templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'\n  };\n}).directive('uibTooltipTemplate', ['$uibTooltip', function ($uibTooltip) {\n  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {\n    useContentExp: true\n  });\n}]).directive('uibTooltipHtmlPopup', function () {\n  return {\n    restrict: 'A',\n    scope: {\n      contentExp: '&'\n    },\n    templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'\n  };\n}).directive('uibTooltipHtml', ['$uibTooltip', function ($uibTooltip) {\n  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {\n    useContentExp: true\n  });\n}]);\n\n/**\n * The following features are still outstanding: popup delay, animation as a\n * function, placement as a function, inside, support for more triggers than\n * just mouse enter/leave, and selector delegatation.\n */\nangular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip']).directive('uibPopoverTemplatePopup', function () {\n  return {\n    restrict: 'A',\n    scope: {\n      uibTitle: '@',\n      contentExp: '&',\n      originScope: '&'\n    },\n    templateUrl: 'uib/template/popover/popover-template.html'\n  };\n}).directive('uibPopoverTemplate', ['$uibTooltip', function ($uibTooltip) {\n  return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {\n    useContentExp: true\n  });\n}]).directive('uibPopoverHtmlPopup', function () {\n  return {\n    restrict: 'A',\n    scope: {\n      contentExp: '&',\n      uibTitle: '@'\n    },\n    templateUrl: 'uib/template/popover/popover-html.html'\n  };\n}).directive('uibPopoverHtml', ['$uibTooltip', function ($uibTooltip) {\n  return $uibTooltip('uibPopoverHtml', 'popover', 'click', {\n    useContentExp: true\n  });\n}]).directive('uibPopoverPopup', function () {\n  return {\n    restrict: 'A',\n    scope: {\n      uibTitle: '@',\n      content: '@'\n    },\n    templateUrl: 'uib/template/popover/popover.html'\n  };\n}).directive('uibPopover', ['$uibTooltip', function ($uibTooltip) {\n  return $uibTooltip('uibPopover', 'popover', 'click');\n}]);\nangular.module('ui.bootstrap.progressbar', []).constant('uibProgressConfig', {\n  animate: true,\n  max: 100\n}).controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function ($scope, $attrs, progressConfig) {\n  var self = this,\n    animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;\n  this.bars = [];\n  $scope.max = getMaxOrDefault();\n  this.addBar = function (bar, element, attrs) {\n    if (!animate) {\n      element.css({\n        'transition': 'none'\n      });\n    }\n    this.bars.push(bar);\n    bar.max = getMaxOrDefault();\n    bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';\n    bar.$watch('value', function (value) {\n      bar.recalculatePercentage();\n    });\n    bar.recalculatePercentage = function () {\n      var totalPercentage = self.bars.reduce(function (total, bar) {\n        bar.percent = +(100 * bar.value / bar.max).toFixed(2);\n        return total + bar.percent;\n      }, 0);\n      if (totalPercentage > 100) {\n        bar.percent -= totalPercentage - 100;\n      }\n    };\n    bar.$on('$destroy', function () {\n      element = null;\n      self.removeBar(bar);\n    });\n  };\n  this.removeBar = function (bar) {\n    this.bars.splice(this.bars.indexOf(bar), 1);\n    this.bars.forEach(function (bar) {\n      bar.recalculatePercentage();\n    });\n  };\n\n  //$attrs.$observe('maxParam', function(maxParam) {\n  $scope.$watch('maxParam', function (maxParam) {\n    self.bars.forEach(function (bar) {\n      bar.max = getMaxOrDefault();\n      bar.recalculatePercentage();\n    });\n  });\n  function getMaxOrDefault() {\n    return angular.isDefined($scope.maxParam) ? $scope.maxParam : progressConfig.max;\n  }\n}]).directive('uibProgress', function () {\n  return {\n    replace: true,\n    transclude: true,\n    controller: 'UibProgressController',\n    require: 'uibProgress',\n    scope: {\n      maxParam: '=?max'\n    },\n    templateUrl: 'uib/template/progressbar/progress.html'\n  };\n}).directive('uibBar', function () {\n  return {\n    replace: true,\n    transclude: true,\n    require: '^uibProgress',\n    scope: {\n      value: '=',\n      type: '@'\n    },\n    templateUrl: 'uib/template/progressbar/bar.html',\n    link: function link(scope, element, attrs, progressCtrl) {\n      progressCtrl.addBar(scope, element, attrs);\n    }\n  };\n}).directive('uibProgressbar', function () {\n  return {\n    replace: true,\n    transclude: true,\n    controller: 'UibProgressController',\n    scope: {\n      value: '=',\n      maxParam: '=?max',\n      type: '@'\n    },\n    templateUrl: 'uib/template/progressbar/progressbar.html',\n    link: function link(scope, element, attrs, progressCtrl) {\n      progressCtrl.addBar(scope, angular.element(element.children()[0]), {\n        title: attrs.title\n      });\n    }\n  };\n});\nangular.module('ui.bootstrap.rating', []).constant('uibRatingConfig', {\n  max: 5,\n  stateOn: null,\n  stateOff: null,\n  enableReset: true,\n  titles: ['one', 'two', 'three', 'four', 'five']\n}).controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function ($scope, $attrs, ratingConfig) {\n  var ngModelCtrl = {\n      $setViewValue: angular.noop\n    },\n    self = this;\n  this.init = function (ngModelCtrl_) {\n    ngModelCtrl = ngModelCtrl_;\n    ngModelCtrl.$render = this.render;\n    ngModelCtrl.$formatters.push(function (value) {\n      if (angular.isNumber(value) && value << 0 !== value) {\n        value = Math.round(value);\n      }\n      return value;\n    });\n    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;\n    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;\n    this.enableReset = angular.isDefined($attrs.enableReset) ? $scope.$parent.$eval($attrs.enableReset) : ratingConfig.enableReset;\n    var tmpTitles = angular.isDefined($attrs.titles) ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles;\n    this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ? tmpTitles : ratingConfig.titles;\n    var ratingStates = angular.isDefined($attrs.ratingStates) ? $scope.$parent.$eval($attrs.ratingStates) : new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);\n    $scope.range = this.buildTemplateObjects(ratingStates);\n  };\n  this.buildTemplateObjects = function (states) {\n    for (var i = 0, n = states.length; i < n; i++) {\n      states[i] = angular.extend({\n        index: i\n      }, {\n        stateOn: this.stateOn,\n        stateOff: this.stateOff,\n        title: this.getTitle(i)\n      }, states[i]);\n    }\n    return states;\n  };\n  this.getTitle = function (index) {\n    if (index >= this.titles.length) {\n      return index + 1;\n    }\n    return this.titles[index];\n  };\n  $scope.rate = function (value) {\n    if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {\n      var newViewValue = self.enableReset && ngModelCtrl.$viewValue === value ? 0 : value;\n      ngModelCtrl.$setViewValue(newViewValue);\n      ngModelCtrl.$render();\n    }\n  };\n  $scope.enter = function (value) {\n    if (!$scope.readonly) {\n      $scope.value = value;\n    }\n    $scope.onHover({\n      value: value\n    });\n  };\n  $scope.reset = function () {\n    $scope.value = ngModelCtrl.$viewValue;\n    $scope.onLeave();\n  };\n  $scope.onKeydown = function (evt) {\n    if (/(37|38|39|40)/.test(evt.which)) {\n      evt.preventDefault();\n      evt.stopPropagation();\n      $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));\n    }\n  };\n  this.render = function () {\n    $scope.value = ngModelCtrl.$viewValue;\n    $scope.title = self.getTitle($scope.value - 1);\n  };\n}]).directive('uibRating', function () {\n  return {\n    require: ['uibRating', 'ngModel'],\n    restrict: 'A',\n    scope: {\n      readonly: '=?readOnly',\n      onHover: '&',\n      onLeave: '&'\n    },\n    controller: 'UibRatingController',\n    templateUrl: 'uib/template/rating/rating.html',\n    link: function link(scope, element, attrs, ctrls) {\n      var ratingCtrl = ctrls[0],\n        ngModelCtrl = ctrls[1];\n      ratingCtrl.init(ngModelCtrl);\n    }\n  };\n});\nangular.module('ui.bootstrap.tabs', []).controller('UibTabsetController', ['$scope', function ($scope) {\n  var ctrl = this,\n    oldIndex;\n  ctrl.tabs = [];\n  ctrl.select = function (index, evt) {\n    if (!destroyed) {\n      var previousIndex = findTabIndex(oldIndex);\n      var previousSelected = ctrl.tabs[previousIndex];\n      if (previousSelected) {\n        previousSelected.tab.onDeselect({\n          $event: evt,\n          $selectedIndex: index\n        });\n        if (evt && evt.isDefaultPrevented()) {\n          return;\n        }\n        previousSelected.tab.active = false;\n      }\n      var selected = ctrl.tabs[index];\n      if (selected) {\n        selected.tab.onSelect({\n          $event: evt\n        });\n        selected.tab.active = true;\n        ctrl.active = selected.index;\n        oldIndex = selected.index;\n      } else if (!selected && angular.isDefined(oldIndex)) {\n        ctrl.active = null;\n        oldIndex = null;\n      }\n    }\n  };\n  ctrl.addTab = function addTab(tab) {\n    ctrl.tabs.push({\n      tab: tab,\n      index: tab.index\n    });\n    ctrl.tabs.sort(function (t1, t2) {\n      if (t1.index > t2.index) {\n        return 1;\n      }\n      if (t1.index < t2.index) {\n        return -1;\n      }\n      return 0;\n    });\n    if (tab.index === ctrl.active || !angular.isDefined(ctrl.active) && ctrl.tabs.length === 1) {\n      var newActiveIndex = findTabIndex(tab.index);\n      ctrl.select(newActiveIndex);\n    }\n  };\n  ctrl.removeTab = function removeTab(tab) {\n    var index;\n    for (var i = 0; i < ctrl.tabs.length; i++) {\n      if (ctrl.tabs[i].tab === tab) {\n        index = i;\n        break;\n      }\n    }\n    if (ctrl.tabs[index].index === ctrl.active) {\n      var newActiveTabIndex = index === ctrl.tabs.length - 1 ? index - 1 : index + 1 % ctrl.tabs.length;\n      ctrl.select(newActiveTabIndex);\n    }\n    ctrl.tabs.splice(index, 1);\n  };\n  $scope.$watch('tabset.active', function (val) {\n    if (angular.isDefined(val) && val !== oldIndex) {\n      ctrl.select(findTabIndex(val));\n    }\n  });\n  var destroyed;\n  $scope.$on('$destroy', function () {\n    destroyed = true;\n  });\n  function findTabIndex(index) {\n    for (var i = 0; i < ctrl.tabs.length; i++) {\n      if (ctrl.tabs[i].index === index) {\n        return i;\n      }\n    }\n  }\n}]).directive('uibTabset', function () {\n  return {\n    transclude: true,\n    replace: true,\n    scope: {},\n    bindToController: {\n      active: '=?',\n      type: '@'\n    },\n    controller: 'UibTabsetController',\n    controllerAs: 'tabset',\n    templateUrl: function templateUrl(element, attrs) {\n      return attrs.templateUrl || 'uib/template/tabs/tabset.html';\n    },\n    link: function link(scope, element, attrs) {\n      scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;\n      scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;\n    }\n  };\n}).directive('uibTab', ['$parse', function ($parse) {\n  return {\n    require: '^uibTabset',\n    replace: true,\n    templateUrl: function templateUrl(element, attrs) {\n      return attrs.templateUrl || 'uib/template/tabs/tab.html';\n    },\n    transclude: true,\n    scope: {\n      heading: '@',\n      index: '=?',\n      classes: '@?',\n      onSelect: '&select',\n      //This callback is called in contentHeadingTransclude\n      //once it inserts the tab's content into the dom\n      onDeselect: '&deselect'\n    },\n    controller: function controller() {\n      //Empty controller so other directives can require being 'under' a tab\n    },\n    controllerAs: 'tab',\n    link: function link(scope, elm, attrs, tabsetCtrl, transclude) {\n      scope.disabled = false;\n      if (attrs.disable) {\n        scope.$parent.$watch($parse(attrs.disable), function (value) {\n          scope.disabled = !!value;\n        });\n      }\n      if (angular.isUndefined(attrs.index)) {\n        if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {\n          scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function (t) {\n            return t.index;\n          })) + 1;\n        } else {\n          scope.index = 0;\n        }\n      }\n      if (angular.isUndefined(attrs.classes)) {\n        scope.classes = '';\n      }\n      scope.select = function (evt) {\n        if (!scope.disabled) {\n          var index;\n          for (var i = 0; i < tabsetCtrl.tabs.length; i++) {\n            if (tabsetCtrl.tabs[i].tab === scope) {\n              index = i;\n              break;\n            }\n          }\n          tabsetCtrl.select(index, evt);\n        }\n      };\n      tabsetCtrl.addTab(scope);\n      scope.$on('$destroy', function () {\n        tabsetCtrl.removeTab(scope);\n      });\n\n      //We need to transclude later, once the content container is ready.\n      //when this link happens, we're inside a tab heading.\n      scope.$transcludeFn = transclude;\n    }\n  };\n}]).directive('uibTabHeadingTransclude', function () {\n  return {\n    restrict: 'A',\n    require: '^uibTab',\n    link: function link(scope, elm) {\n      scope.$watch('headingElement', function updateHeadingElement(heading) {\n        if (heading) {\n          elm.html('');\n          elm.append(heading);\n        }\n      });\n    }\n  };\n}).directive('uibTabContentTransclude', function () {\n  return {\n    restrict: 'A',\n    require: '^uibTabset',\n    link: function link(scope, elm, attrs) {\n      var tab = scope.$eval(attrs.uibTabContentTransclude).tab;\n\n      //Now our tab is ready to be transcluded: both the tab heading area\n      //and the tab content area are loaded.  Transclude 'em both.\n      tab.$transcludeFn(tab.$parent, function (contents) {\n        angular.forEach(contents, function (node) {\n          if (isTabHeading(node)) {\n            //Let tabHeadingTransclude know.\n            tab.headingElement = node;\n          } else {\n            elm.append(node);\n          }\n        });\n      });\n    }\n  };\n  function isTabHeading(node) {\n    return node.tagName && (node.hasAttribute('uib-tab-heading') || node.hasAttribute('data-uib-tab-heading') || node.hasAttribute('x-uib-tab-heading') || node.tagName.toLowerCase() === 'uib-tab-heading' || node.tagName.toLowerCase() === 'data-uib-tab-heading' || node.tagName.toLowerCase() === 'x-uib-tab-heading' || node.tagName.toLowerCase() === 'uib:tab-heading');\n  }\n});\nangular.module('ui.bootstrap.timepicker', []).constant('uibTimepickerConfig', {\n  hourStep: 1,\n  minuteStep: 1,\n  secondStep: 1,\n  showMeridian: true,\n  showSeconds: false,\n  meridians: null,\n  readonlyInput: false,\n  mousewheel: true,\n  arrowkeys: true,\n  showSpinners: true,\n  templateUrl: 'uib/template/timepicker/timepicker.html'\n}).controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function ($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {\n  var hoursModelCtrl, minutesModelCtrl, secondsModelCtrl;\n  var selected = new Date(),\n    watchers = [],\n    ngModelCtrl = {\n      $setViewValue: angular.noop\n    },\n    // nullModelCtrl\n    meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,\n    padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;\n  $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;\n  $element.removeAttr('tabindex');\n  this.init = function (ngModelCtrl_, inputs) {\n    ngModelCtrl = ngModelCtrl_;\n    ngModelCtrl.$render = this.render;\n    ngModelCtrl.$formatters.unshift(function (modelValue) {\n      return modelValue ? new Date(modelValue) : null;\n    });\n    var hoursInputEl = inputs.eq(0),\n      minutesInputEl = inputs.eq(1),\n      secondsInputEl = inputs.eq(2);\n    hoursModelCtrl = hoursInputEl.controller('ngModel');\n    minutesModelCtrl = minutesInputEl.controller('ngModel');\n    secondsModelCtrl = secondsInputEl.controller('ngModel');\n    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;\n    if (mousewheel) {\n      this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);\n    }\n    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;\n    if (arrowkeys) {\n      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);\n    }\n    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;\n    this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);\n  };\n  var hourStep = timepickerConfig.hourStep;\n  if ($attrs.hourStep) {\n    watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function (value) {\n      hourStep = +value;\n    }));\n  }\n  var minuteStep = timepickerConfig.minuteStep;\n  if ($attrs.minuteStep) {\n    watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function (value) {\n      minuteStep = +value;\n    }));\n  }\n  var min;\n  watchers.push($scope.$parent.$watch($parse($attrs.min), function (value) {\n    var dt = new Date(value);\n    min = isNaN(dt) ? undefined : dt;\n  }));\n  var max;\n  watchers.push($scope.$parent.$watch($parse($attrs.max), function (value) {\n    var dt = new Date(value);\n    max = isNaN(dt) ? undefined : dt;\n  }));\n  var disabled = false;\n  if ($attrs.ngDisabled) {\n    watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (value) {\n      disabled = value;\n    }));\n  }\n  $scope.noIncrementHours = function () {\n    var incrementedSelected = addMinutes(selected, hourStep * 60);\n    return disabled || incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;\n  };\n  $scope.noDecrementHours = function () {\n    var decrementedSelected = addMinutes(selected, -hourStep * 60);\n    return disabled || decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;\n  };\n  $scope.noIncrementMinutes = function () {\n    var incrementedSelected = addMinutes(selected, minuteStep);\n    return disabled || incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;\n  };\n  $scope.noDecrementMinutes = function () {\n    var decrementedSelected = addMinutes(selected, -minuteStep);\n    return disabled || decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;\n  };\n  $scope.noIncrementSeconds = function () {\n    var incrementedSelected = addSeconds(selected, secondStep);\n    return disabled || incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;\n  };\n  $scope.noDecrementSeconds = function () {\n    var decrementedSelected = addSeconds(selected, -secondStep);\n    return disabled || decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;\n  };\n  $scope.noToggleMeridian = function () {\n    if (selected.getHours() < 12) {\n      return disabled || addMinutes(selected, 12 * 60) > max;\n    }\n    return disabled || addMinutes(selected, -12 * 60) < min;\n  };\n  var secondStep = timepickerConfig.secondStep;\n  if ($attrs.secondStep) {\n    watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function (value) {\n      secondStep = +value;\n    }));\n  }\n  $scope.showSeconds = timepickerConfig.showSeconds;\n  if ($attrs.showSeconds) {\n    watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function (value) {\n      $scope.showSeconds = !!value;\n    }));\n  }\n\n  // 12H / 24H mode\n  $scope.showMeridian = timepickerConfig.showMeridian;\n  if ($attrs.showMeridian) {\n    watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function (value) {\n      $scope.showMeridian = !!value;\n      if (ngModelCtrl.$error.time) {\n        // Evaluate from template\n        var hours = getHoursFromTemplate(),\n          minutes = getMinutesFromTemplate();\n        if (angular.isDefined(hours) && angular.isDefined(minutes)) {\n          selected.setHours(hours);\n          refresh();\n        }\n      } else {\n        updateTemplate();\n      }\n    }));\n  }\n\n  // Get $scope.hours in 24H mode if valid\n  function getHoursFromTemplate() {\n    var hours = +$scope.hours;\n    var valid = $scope.showMeridian ? hours > 0 && hours < 13 : hours >= 0 && hours < 24;\n    if (!valid || $scope.hours === '') {\n      return undefined;\n    }\n    if ($scope.showMeridian) {\n      if (hours === 12) {\n        hours = 0;\n      }\n      if ($scope.meridian === meridians[1]) {\n        hours = hours + 12;\n      }\n    }\n    return hours;\n  }\n  function getMinutesFromTemplate() {\n    var minutes = +$scope.minutes;\n    var valid = minutes >= 0 && minutes < 60;\n    if (!valid || $scope.minutes === '') {\n      return undefined;\n    }\n    return minutes;\n  }\n  function getSecondsFromTemplate() {\n    var seconds = +$scope.seconds;\n    return seconds >= 0 && seconds < 60 ? seconds : undefined;\n  }\n  function pad(value, noPad) {\n    if (value === null) {\n      return '';\n    }\n    return angular.isDefined(value) && value.toString().length < 2 && !noPad ? '0' + value : value.toString();\n  }\n\n  // Respond on mousewheel spin\n  this.setupMousewheelEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {\n    var isScrollingUp = function isScrollingUp(e) {\n      if (e.originalEvent) {\n        e = e.originalEvent;\n      }\n      //pick correct delta variable depending on event\n      var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;\n      return e.detail || delta > 0;\n    };\n    hoursInputEl.bind('mousewheel wheel', function (e) {\n      if (!disabled) {\n        $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());\n      }\n      e.preventDefault();\n    });\n    minutesInputEl.bind('mousewheel wheel', function (e) {\n      if (!disabled) {\n        $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());\n      }\n      e.preventDefault();\n    });\n    secondsInputEl.bind('mousewheel wheel', function (e) {\n      if (!disabled) {\n        $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());\n      }\n      e.preventDefault();\n    });\n  };\n\n  // Respond on up/down arrowkeys\n  this.setupArrowkeyEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {\n    hoursInputEl.bind('keydown', function (e) {\n      if (!disabled) {\n        if (e.which === 38) {\n          // up\n          e.preventDefault();\n          $scope.incrementHours();\n          $scope.$apply();\n        } else if (e.which === 40) {\n          // down\n          e.preventDefault();\n          $scope.decrementHours();\n          $scope.$apply();\n        }\n      }\n    });\n    minutesInputEl.bind('keydown', function (e) {\n      if (!disabled) {\n        if (e.which === 38) {\n          // up\n          e.preventDefault();\n          $scope.incrementMinutes();\n          $scope.$apply();\n        } else if (e.which === 40) {\n          // down\n          e.preventDefault();\n          $scope.decrementMinutes();\n          $scope.$apply();\n        }\n      }\n    });\n    secondsInputEl.bind('keydown', function (e) {\n      if (!disabled) {\n        if (e.which === 38) {\n          // up\n          e.preventDefault();\n          $scope.incrementSeconds();\n          $scope.$apply();\n        } else if (e.which === 40) {\n          // down\n          e.preventDefault();\n          $scope.decrementSeconds();\n          $scope.$apply();\n        }\n      }\n    });\n  };\n  this.setupInputEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {\n    if ($scope.readonlyInput) {\n      $scope.updateHours = angular.noop;\n      $scope.updateMinutes = angular.noop;\n      $scope.updateSeconds = angular.noop;\n      return;\n    }\n    var invalidate = function invalidate(invalidHours, invalidMinutes, invalidSeconds) {\n      ngModelCtrl.$setViewValue(null);\n      ngModelCtrl.$setValidity('time', false);\n      if (angular.isDefined(invalidHours)) {\n        $scope.invalidHours = invalidHours;\n        if (hoursModelCtrl) {\n          hoursModelCtrl.$setValidity('hours', false);\n        }\n      }\n      if (angular.isDefined(invalidMinutes)) {\n        $scope.invalidMinutes = invalidMinutes;\n        if (minutesModelCtrl) {\n          minutesModelCtrl.$setValidity('minutes', false);\n        }\n      }\n      if (angular.isDefined(invalidSeconds)) {\n        $scope.invalidSeconds = invalidSeconds;\n        if (secondsModelCtrl) {\n          secondsModelCtrl.$setValidity('seconds', false);\n        }\n      }\n    };\n    $scope.updateHours = function () {\n      var hours = getHoursFromTemplate(),\n        minutes = getMinutesFromTemplate();\n      ngModelCtrl.$setDirty();\n      if (angular.isDefined(hours) && angular.isDefined(minutes)) {\n        selected.setHours(hours);\n        selected.setMinutes(minutes);\n        if (selected < min || selected > max) {\n          invalidate(true);\n        } else {\n          refresh('h');\n        }\n      } else {\n        invalidate(true);\n      }\n    };\n    hoursInputEl.bind('blur', function (e) {\n      ngModelCtrl.$setTouched();\n      if (modelIsEmpty()) {\n        makeValid();\n      } else if ($scope.hours === null || $scope.hours === '') {\n        invalidate(true);\n      } else if (!$scope.invalidHours && $scope.hours < 10) {\n        $scope.$apply(function () {\n          $scope.hours = pad($scope.hours, !padHours);\n        });\n      }\n    });\n    $scope.updateMinutes = function () {\n      var minutes = getMinutesFromTemplate(),\n        hours = getHoursFromTemplate();\n      ngModelCtrl.$setDirty();\n      if (angular.isDefined(minutes) && angular.isDefined(hours)) {\n        selected.setHours(hours);\n        selected.setMinutes(minutes);\n        if (selected < min || selected > max) {\n          invalidate(undefined, true);\n        } else {\n          refresh('m');\n        }\n      } else {\n        invalidate(undefined, true);\n      }\n    };\n    minutesInputEl.bind('blur', function (e) {\n      ngModelCtrl.$setTouched();\n      if (modelIsEmpty()) {\n        makeValid();\n      } else if ($scope.minutes === null) {\n        invalidate(undefined, true);\n      } else if (!$scope.invalidMinutes && $scope.minutes < 10) {\n        $scope.$apply(function () {\n          $scope.minutes = pad($scope.minutes);\n        });\n      }\n    });\n    $scope.updateSeconds = function () {\n      var seconds = getSecondsFromTemplate();\n      ngModelCtrl.$setDirty();\n      if (angular.isDefined(seconds)) {\n        selected.setSeconds(seconds);\n        refresh('s');\n      } else {\n        invalidate(undefined, undefined, true);\n      }\n    };\n    secondsInputEl.bind('blur', function (e) {\n      if (modelIsEmpty()) {\n        makeValid();\n      } else if (!$scope.invalidSeconds && $scope.seconds < 10) {\n        $scope.$apply(function () {\n          $scope.seconds = pad($scope.seconds);\n        });\n      }\n    });\n  };\n  this.render = function () {\n    var date = ngModelCtrl.$viewValue;\n    if (isNaN(date)) {\n      ngModelCtrl.$setValidity('time', false);\n      $log.error('Timepicker directive: \"ng-model\" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');\n    } else {\n      if (date) {\n        selected = date;\n      }\n      if (selected < min || selected > max) {\n        ngModelCtrl.$setValidity('time', false);\n        $scope.invalidHours = true;\n        $scope.invalidMinutes = true;\n      } else {\n        makeValid();\n      }\n      updateTemplate();\n    }\n  };\n\n  // Call internally when we know that model is valid.\n  function refresh(keyboardChange) {\n    makeValid();\n    ngModelCtrl.$setViewValue(new Date(selected));\n    updateTemplate(keyboardChange);\n  }\n  function makeValid() {\n    if (hoursModelCtrl) {\n      hoursModelCtrl.$setValidity('hours', true);\n    }\n    if (minutesModelCtrl) {\n      minutesModelCtrl.$setValidity('minutes', true);\n    }\n    if (secondsModelCtrl) {\n      secondsModelCtrl.$setValidity('seconds', true);\n    }\n    ngModelCtrl.$setValidity('time', true);\n    $scope.invalidHours = false;\n    $scope.invalidMinutes = false;\n    $scope.invalidSeconds = false;\n  }\n  function updateTemplate(keyboardChange) {\n    if (!ngModelCtrl.$modelValue) {\n      $scope.hours = null;\n      $scope.minutes = null;\n      $scope.seconds = null;\n      $scope.meridian = meridians[0];\n    } else {\n      var hours = selected.getHours(),\n        minutes = selected.getMinutes(),\n        seconds = selected.getSeconds();\n      if ($scope.showMeridian) {\n        hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system\n      }\n      $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);\n      if (keyboardChange !== 'm') {\n        $scope.minutes = pad(minutes);\n      }\n      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];\n      if (keyboardChange !== 's') {\n        $scope.seconds = pad(seconds);\n      }\n      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];\n    }\n  }\n  function addSecondsToSelected(seconds) {\n    selected = addSeconds(selected, seconds);\n    refresh();\n  }\n  function addMinutes(selected, minutes) {\n    return addSeconds(selected, minutes * 60);\n  }\n  function addSeconds(date, seconds) {\n    var dt = new Date(date.getTime() + seconds * 1000);\n    var newDate = new Date(date);\n    newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());\n    return newDate;\n  }\n  function modelIsEmpty() {\n    return ($scope.hours === null || $scope.hours === '') && ($scope.minutes === null || $scope.minutes === '') && (!$scope.showSeconds || $scope.showSeconds && ($scope.seconds === null || $scope.seconds === ''));\n  }\n  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ? $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;\n  $scope.incrementHours = function () {\n    if (!$scope.noIncrementHours()) {\n      addSecondsToSelected(hourStep * 60 * 60);\n    }\n  };\n  $scope.decrementHours = function () {\n    if (!$scope.noDecrementHours()) {\n      addSecondsToSelected(-hourStep * 60 * 60);\n    }\n  };\n  $scope.incrementMinutes = function () {\n    if (!$scope.noIncrementMinutes()) {\n      addSecondsToSelected(minuteStep * 60);\n    }\n  };\n  $scope.decrementMinutes = function () {\n    if (!$scope.noDecrementMinutes()) {\n      addSecondsToSelected(-minuteStep * 60);\n    }\n  };\n  $scope.incrementSeconds = function () {\n    if (!$scope.noIncrementSeconds()) {\n      addSecondsToSelected(secondStep);\n    }\n  };\n  $scope.decrementSeconds = function () {\n    if (!$scope.noDecrementSeconds()) {\n      addSecondsToSelected(-secondStep);\n    }\n  };\n  $scope.toggleMeridian = function () {\n    var minutes = getMinutesFromTemplate(),\n      hours = getHoursFromTemplate();\n    if (!$scope.noToggleMeridian()) {\n      if (angular.isDefined(minutes) && angular.isDefined(hours)) {\n        addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));\n      } else {\n        $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];\n      }\n    }\n  };\n  $scope.blur = function () {\n    ngModelCtrl.$setTouched();\n  };\n  $scope.$on('$destroy', function () {\n    while (watchers.length) {\n      watchers.shift()();\n    }\n  });\n}]).directive('uibTimepicker', ['uibTimepickerConfig', function (uibTimepickerConfig) {\n  return {\n    require: ['uibTimepicker', '?^ngModel'],\n    restrict: 'A',\n    controller: 'UibTimepickerController',\n    controllerAs: 'timepicker',\n    scope: {},\n    templateUrl: function templateUrl(element, attrs) {\n      return attrs.templateUrl || uibTimepickerConfig.templateUrl;\n    },\n    link: function link(scope, element, attrs, ctrls) {\n      var timepickerCtrl = ctrls[0],\n        ngModelCtrl = ctrls[1];\n      if (ngModelCtrl) {\n        timepickerCtrl.init(ngModelCtrl, element.find('input'));\n      }\n    }\n  };\n}]);\nangular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])\n\n/**\n * A helper service that can parse typeahead's syntax (string provided by users)\n * Extracted to a separate service for ease of unit testing\n */.factory('uibTypeaheadParser', ['$parse', function ($parse) {\n  //                      000001111111100000000000002222222200000000000000003333333333333330000000000044444444000\n  var TYPEAHEAD_REGEXP = /^\\s*([\\s\\S]+?)(?:\\s+as\\s+([\\s\\S]+?))?\\s+for\\s+(?:([\\$\\w][\\$\\w\\d]*))\\s+in\\s+([\\s\\S]+?)$/;\n  return {\n    parse: function parse(input) {\n      var match = input.match(TYPEAHEAD_REGEXP);\n      if (!match) {\n        throw new Error('Expected typeahead specification in form of \"_modelValue_ (as _label_)? for _item_ in _collection_\"' + ' but got \"' + input + '\".');\n      }\n      return {\n        itemName: match[3],\n        source: $parse(match[4]),\n        viewMapper: $parse(match[2] || match[1]),\n        modelMapper: $parse(match[1])\n      };\n    }\n  };\n}]).controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser', function (originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {\n  var HOT_KEYS = [9, 13, 27, 38, 40];\n  var eventDebounceTime = 200;\n  var modelCtrl, ngModelOptions;\n  //SUPPORTED ATTRIBUTES (OPTIONS)\n\n  //minimal no of characters that needs to be entered before typeahead kicks-in\n  var minLength = originalScope.$eval(attrs.typeaheadMinLength);\n  if (!minLength && minLength !== 0) {\n    minLength = 1;\n  }\n  originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {\n    minLength = !newVal && newVal !== 0 ? 1 : newVal;\n  });\n\n  //minimal wait time after last character typed before typeahead kicks-in\n  var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;\n\n  //should it restrict model values to the ones selected from the popup only?\n  var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;\n  originalScope.$watch(attrs.typeaheadEditable, function (newVal) {\n    isEditable = newVal !== false;\n  });\n\n  //binding to a variable that indicates if matches are being retrieved asynchronously\n  var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;\n\n  //a function to determine if an event should cause selection\n  var isSelectEvent = attrs.typeaheadShouldSelect ? $parse(attrs.typeaheadShouldSelect) : function (scope, vals) {\n    var evt = vals.$event;\n    return evt.which === 13 || evt.which === 9;\n  };\n\n  //a callback executed when a match is selected\n  var onSelectCallback = $parse(attrs.typeaheadOnSelect);\n\n  //should it select highlighted popup value when losing focus?\n  var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;\n\n  //binding to a variable that indicates if there were no results after the query is completed\n  var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;\n  var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;\n  var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;\n  var appendTo = attrs.typeaheadAppendTo ? originalScope.$eval(attrs.typeaheadAppendTo) : null;\n  var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;\n\n  //If input matches an item of the list exactly, select it automatically\n  var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;\n\n  //binding to a variable that indicates if dropdown is open\n  var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;\n  var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;\n\n  //INTERNAL VARIABLES\n\n  //model setter executed upon match selection\n  var parsedModel = $parse(attrs.ngModel);\n  var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');\n  var $setModelValue = function $setModelValue(scope, newValue) {\n    if (angular.isFunction(parsedModel(originalScope)) && ngModelOptions && ngModelOptions.$options && ngModelOptions.$options.getterSetter) {\n      return invokeModelSetter(scope, {\n        $$$p: newValue\n      });\n    }\n    return parsedModel.assign(scope, newValue);\n  };\n\n  //expressions used by typeahead\n  var parserResult = typeaheadParser.parse(attrs.uibTypeahead);\n  var hasFocus;\n\n  //Used to avoid bug in iOS webview where iOS keyboard does not fire\n  //mousedown & mouseup events\n  //Issue #3699\n  var selected;\n\n  //create a child scope for the typeahead directive so we are not polluting original scope\n  //with typeahead-specific data (matches, query etc.)\n  var scope = originalScope.$new();\n  var offDestroy = originalScope.$on('$destroy', function () {\n    scope.$destroy();\n  });\n  scope.$on('$destroy', offDestroy);\n\n  // WAI-ARIA\n  var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);\n  element.attr({\n    'aria-autocomplete': 'list',\n    'aria-expanded': false,\n    'aria-owns': popupId\n  });\n  var inputsContainer, hintInputElem;\n  //add read-only input to show hint\n  if (showHint) {\n    inputsContainer = angular.element('<div></div>');\n    inputsContainer.css('position', 'relative');\n    element.after(inputsContainer);\n    hintInputElem = element.clone();\n    hintInputElem.attr('placeholder', '');\n    hintInputElem.attr('tabindex', '-1');\n    hintInputElem.val('');\n    hintInputElem.css({\n      'position': 'absolute',\n      'top': '0px',\n      'left': '0px',\n      'border-color': 'transparent',\n      'box-shadow': 'none',\n      'opacity': 1,\n      'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',\n      'color': '#999'\n    });\n    element.css({\n      'position': 'relative',\n      'vertical-align': 'top',\n      'background-color': 'transparent'\n    });\n    if (hintInputElem.attr('id')) {\n      hintInputElem.removeAttr('id'); // remove duplicate id if present.\n    }\n    inputsContainer.append(hintInputElem);\n    hintInputElem.after(element);\n  }\n\n  //pop-up element used to display matches\n  var popUpEl = angular.element('<div uib-typeahead-popup></div>');\n  popUpEl.attr({\n    id: popupId,\n    matches: 'matches',\n    active: 'activeIdx',\n    select: 'select(activeIdx, evt)',\n    'move-in-progress': 'moveInProgress',\n    query: 'query',\n    position: 'position',\n    'assign-is-open': 'assignIsOpen(isOpen)',\n    debounce: 'debounceUpdate'\n  });\n  //custom item template\n  if (angular.isDefined(attrs.typeaheadTemplateUrl)) {\n    popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);\n  }\n  if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {\n    popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);\n  }\n  var resetHint = function resetHint() {\n    if (showHint) {\n      hintInputElem.val('');\n    }\n  };\n  var resetMatches = function resetMatches() {\n    scope.matches = [];\n    scope.activeIdx = -1;\n    element.attr('aria-expanded', false);\n    resetHint();\n  };\n  var getMatchId = function getMatchId(index) {\n    return popupId + '-option-' + index;\n  };\n\n  // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.\n  // This attribute is added or removed automatically when the `activeIdx` changes.\n  scope.$watch('activeIdx', function (index) {\n    if (index < 0) {\n      element.removeAttr('aria-activedescendant');\n    } else {\n      element.attr('aria-activedescendant', getMatchId(index));\n    }\n  });\n  var inputIsExactMatch = function inputIsExactMatch(inputValue, index) {\n    if (scope.matches.length > index && inputValue) {\n      return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();\n    }\n    return false;\n  };\n  var getMatchesAsync = function getMatchesAsync(inputValue, evt) {\n    var locals = {\n      $viewValue: inputValue\n    };\n    isLoadingSetter(originalScope, true);\n    isNoResultsSetter(originalScope, false);\n    $q.when(parserResult.source(originalScope, locals)).then(function (matches) {\n      //it might happen that several async queries were in progress if a user were typing fast\n      //but we are interested only in responses that correspond to the current view value\n      var onCurrentRequest = inputValue === modelCtrl.$viewValue;\n      if (onCurrentRequest && hasFocus) {\n        if (matches && matches.length > 0) {\n          scope.activeIdx = focusFirst ? 0 : -1;\n          isNoResultsSetter(originalScope, false);\n          scope.matches.length = 0;\n\n          //transform labels\n          for (var i = 0; i < matches.length; i++) {\n            locals[parserResult.itemName] = matches[i];\n            scope.matches.push({\n              id: getMatchId(i),\n              label: parserResult.viewMapper(scope, locals),\n              model: matches[i]\n            });\n          }\n          scope.query = inputValue;\n          //position pop-up with matches - we need to re-calculate its position each time we are opening a window\n          //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page\n          //due to other elements being rendered\n          recalculatePosition();\n          element.attr('aria-expanded', true);\n\n          //Select the single remaining option if user input matches\n          if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {\n            if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {\n              $$debounce(function () {\n                scope.select(0, evt);\n              }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);\n            } else {\n              scope.select(0, evt);\n            }\n          }\n          if (showHint) {\n            var firstLabel = scope.matches[0].label;\n            if (angular.isString(inputValue) && inputValue.length > 0 && firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {\n              hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));\n            } else {\n              hintInputElem.val('');\n            }\n          }\n        } else {\n          resetMatches();\n          isNoResultsSetter(originalScope, true);\n        }\n      }\n      if (onCurrentRequest) {\n        isLoadingSetter(originalScope, false);\n      }\n    }, function () {\n      resetMatches();\n      isLoadingSetter(originalScope, false);\n      isNoResultsSetter(originalScope, true);\n    });\n  };\n\n  // bind events only if appendToBody params exist - performance feature\n  if (appendToBody) {\n    angular.element($window).on('resize', fireRecalculating);\n    $document.find('body').on('scroll', fireRecalculating);\n  }\n\n  // Declare the debounced function outside recalculating for\n  // proper debouncing\n  var debouncedRecalculate = $$debounce(function () {\n    // if popup is visible\n    if (scope.matches.length) {\n      recalculatePosition();\n    }\n    scope.moveInProgress = false;\n  }, eventDebounceTime);\n\n  // Default progress type\n  scope.moveInProgress = false;\n  function fireRecalculating() {\n    if (!scope.moveInProgress) {\n      scope.moveInProgress = true;\n      scope.$digest();\n    }\n    debouncedRecalculate();\n  }\n\n  // recalculate actual position and set new values to scope\n  // after digest loop is popup in right position\n  function recalculatePosition() {\n    scope.position = appendToBody ? $position.offset(element) : $position.position(element);\n    scope.position.top += element.prop('offsetHeight');\n  }\n\n  //we need to propagate user's query so we can higlight matches\n  scope.query = undefined;\n\n  //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later\n  var timeoutPromise;\n  var scheduleSearchWithTimeout = function scheduleSearchWithTimeout(inputValue) {\n    timeoutPromise = $timeout(function () {\n      getMatchesAsync(inputValue);\n    }, waitTime);\n  };\n  var cancelPreviousTimeout = function cancelPreviousTimeout() {\n    if (timeoutPromise) {\n      $timeout.cancel(timeoutPromise);\n    }\n  };\n  resetMatches();\n  scope.assignIsOpen = function (isOpen) {\n    isOpenSetter(originalScope, isOpen);\n  };\n  scope.select = function (activeIdx, evt) {\n    //called from within the $digest() cycle\n    var locals = {};\n    var model, item;\n    selected = true;\n    locals[parserResult.itemName] = item = scope.matches[activeIdx].model;\n    model = parserResult.modelMapper(originalScope, locals);\n    $setModelValue(originalScope, model);\n    modelCtrl.$setValidity('editable', true);\n    modelCtrl.$setValidity('parse', true);\n    onSelectCallback(originalScope, {\n      $item: item,\n      $model: model,\n      $label: parserResult.viewMapper(originalScope, locals),\n      $event: evt\n    });\n    resetMatches();\n\n    //return focus to the input element if a match was selected via a mouse click event\n    // use timeout to avoid $rootScope:inprog error\n    if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {\n      $timeout(function () {\n        element[0].focus();\n      }, 0, false);\n    }\n  };\n\n  //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)\n  element.on('keydown', function (evt) {\n    //typeahead is open and an \"interesting\" key was pressed\n    if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {\n      return;\n    }\n    var shouldSelect = isSelectEvent(originalScope, {\n      $event: evt\n    });\n\n    /**\n     * if there's nothing selected (i.e. focusFirst) and enter or tab is hit\n     * or\n     * shift + tab is pressed to bring focus to the previous element\n     * then clear the results\n     */\n    if (scope.activeIdx === -1 && shouldSelect || evt.which === 9 && !!evt.shiftKey) {\n      resetMatches();\n      scope.$digest();\n      return;\n    }\n    evt.preventDefault();\n    var target;\n    switch (evt.which) {\n      case 27:\n        // escape\n        evt.stopPropagation();\n        resetMatches();\n        originalScope.$digest();\n        break;\n      case 38:\n        // up arrow\n        scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;\n        scope.$digest();\n        target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];\n        target.parentNode.scrollTop = target.offsetTop;\n        break;\n      case 40:\n        // down arrow\n        scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;\n        scope.$digest();\n        target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];\n        target.parentNode.scrollTop = target.offsetTop;\n        break;\n      default:\n        if (shouldSelect) {\n          scope.$apply(function () {\n            if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {\n              $$debounce(function () {\n                scope.select(scope.activeIdx, evt);\n              }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);\n            } else {\n              scope.select(scope.activeIdx, evt);\n            }\n          });\n        }\n    }\n  });\n  element.bind('focus', function (evt) {\n    hasFocus = true;\n    if (minLength === 0 && !modelCtrl.$viewValue) {\n      $timeout(function () {\n        getMatchesAsync(modelCtrl.$viewValue, evt);\n      }, 0);\n    }\n  });\n  element.bind('blur', function (evt) {\n    if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {\n      selected = true;\n      scope.$apply(function () {\n        if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {\n          $$debounce(function () {\n            scope.select(scope.activeIdx, evt);\n          }, scope.debounceUpdate.blur);\n        } else {\n          scope.select(scope.activeIdx, evt);\n        }\n      });\n    }\n    if (!isEditable && modelCtrl.$error.editable) {\n      modelCtrl.$setViewValue();\n      scope.$apply(function () {\n        // Reset validity as we are clearing\n        modelCtrl.$setValidity('editable', true);\n        modelCtrl.$setValidity('parse', true);\n      });\n      element.val('');\n    }\n    hasFocus = false;\n    selected = false;\n  });\n\n  // Keep reference to click handler to unbind it.\n  var dismissClickHandler = function dismissClickHandler(evt) {\n    // Issue #3973\n    // Firefox treats right click as a click on document\n    if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {\n      resetMatches();\n      if (!$rootScope.$$phase) {\n        originalScope.$digest();\n      }\n    }\n  };\n  $document.on('click', dismissClickHandler);\n  originalScope.$on('$destroy', function () {\n    $document.off('click', dismissClickHandler);\n    if (appendToBody || appendTo) {\n      $popup.remove();\n    }\n    if (appendToBody) {\n      angular.element($window).off('resize', fireRecalculating);\n      $document.find('body').off('scroll', fireRecalculating);\n    }\n    // Prevent jQuery cache memory leak\n    popUpEl.remove();\n    if (showHint) {\n      inputsContainer.remove();\n    }\n  });\n  var $popup = $compile(popUpEl)(scope);\n  if (appendToBody) {\n    $document.find('body').append($popup);\n  } else if (appendTo) {\n    angular.element(appendTo).eq(0).append($popup);\n  } else {\n    element.after($popup);\n  }\n  this.init = function (_modelCtrl, _ngModelOptions) {\n    modelCtrl = _modelCtrl;\n    ngModelOptions = _ngModelOptions;\n    scope.debounceUpdate = modelCtrl.$options && $parse(modelCtrl.$options.debounce)(originalScope);\n\n    //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM\n    //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue\n    modelCtrl.$parsers.unshift(function (inputValue) {\n      hasFocus = true;\n      if (minLength === 0 || inputValue && inputValue.length >= minLength) {\n        if (waitTime > 0) {\n          cancelPreviousTimeout();\n          scheduleSearchWithTimeout(inputValue);\n        } else {\n          getMatchesAsync(inputValue);\n        }\n      } else {\n        isLoadingSetter(originalScope, false);\n        cancelPreviousTimeout();\n        resetMatches();\n      }\n      if (isEditable) {\n        return inputValue;\n      }\n      if (!inputValue) {\n        // Reset in case user had typed something previously.\n        modelCtrl.$setValidity('editable', true);\n        return null;\n      }\n      modelCtrl.$setValidity('editable', false);\n      return undefined;\n    });\n    modelCtrl.$formatters.push(function (modelValue) {\n      var candidateViewValue, emptyViewValue;\n      var locals = {};\n\n      // The validity may be set to false via $parsers (see above) if\n      // the model is restricted to selected values. If the model\n      // is set manually it is considered to be valid.\n      if (!isEditable) {\n        modelCtrl.$setValidity('editable', true);\n      }\n      if (inputFormatter) {\n        locals.$model = modelValue;\n        return inputFormatter(originalScope, locals);\n      }\n\n      //it might happen that we don't have enough info to properly render input value\n      //we need to check for this situation and simply return model value if we can't apply custom formatting\n      locals[parserResult.itemName] = modelValue;\n      candidateViewValue = parserResult.viewMapper(originalScope, locals);\n      locals[parserResult.itemName] = undefined;\n      emptyViewValue = parserResult.viewMapper(originalScope, locals);\n      return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;\n    });\n  };\n}]).directive('uibTypeahead', function () {\n  return {\n    controller: 'UibTypeaheadController',\n    require: ['ngModel', '^?ngModelOptions', 'uibTypeahead'],\n    link: function link(originalScope, element, attrs, ctrls) {\n      ctrls[2].init(ctrls[0], ctrls[1]);\n    }\n  };\n}).directive('uibTypeaheadPopup', ['$$debounce', function ($$debounce) {\n  return {\n    scope: {\n      matches: '=',\n      query: '=',\n      active: '=',\n      position: '&',\n      moveInProgress: '=',\n      select: '&',\n      assignIsOpen: '&',\n      debounce: '&'\n    },\n    replace: true,\n    templateUrl: function templateUrl(element, attrs) {\n      return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';\n    },\n    link: function link(scope, element, attrs) {\n      scope.templateUrl = attrs.templateUrl;\n      scope.isOpen = function () {\n        var isDropdownOpen = scope.matches.length > 0;\n        scope.assignIsOpen({\n          isOpen: isDropdownOpen\n        });\n        return isDropdownOpen;\n      };\n      scope.isActive = function (matchIdx) {\n        return scope.active === matchIdx;\n      };\n      scope.selectActive = function (matchIdx) {\n        scope.active = matchIdx;\n      };\n      scope.selectMatch = function (activeIdx, evt) {\n        var debounce = scope.debounce();\n        if (angular.isNumber(debounce) || angular.isObject(debounce)) {\n          $$debounce(function () {\n            scope.select({\n              activeIdx: activeIdx,\n              evt: evt\n            });\n          }, angular.isNumber(debounce) ? debounce : debounce['default']);\n        } else {\n          scope.select({\n            activeIdx: activeIdx,\n            evt: evt\n          });\n        }\n      };\n    }\n  };\n}]).directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function ($templateRequest, $compile, $parse) {\n  return {\n    scope: {\n      index: '=',\n      match: '=',\n      query: '='\n    },\n    link: function link(scope, element, attrs) {\n      var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';\n      $templateRequest(tplUrl).then(function (tplContent) {\n        var tplEl = angular.element(tplContent.trim());\n        element.replaceWith(tplEl);\n        $compile(tplEl)(scope);\n      });\n    }\n  };\n}]).filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function ($sce, $injector, $log) {\n  var isSanitizePresent;\n  isSanitizePresent = $injector.has('$sanitize');\n  function escapeRegexp(queryToEscape) {\n    // Regex: capture the whole query string and replace it with the string that will be used to match\n    // the results, for example if the capture is \"a\" the result will be \\a\n    return queryToEscape.replace(/([.?*+^$[\\]\\\\(){}|-])/g, '\\\\$1');\n  }\n  function containsHtml(matchItem) {\n    return /<.*>/g.test(matchItem);\n  }\n  return function (matchItem, query) {\n    if (!isSanitizePresent && containsHtml(matchItem)) {\n      $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger\n    }\n    matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a \"strong\" tag\n    if (!isSanitizePresent) {\n      matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive\n    }\n    return matchItem;\n  };\n}]);\nangular.module(\"uib/template/accordion/accordion-group.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/accordion/accordion-group.html\", \"<div role=\\\"tab\\\" id=\\\"{{::headingId}}\\\" aria-selected=\\\"{{isOpen}}\\\" class=\\\"panel-heading\\\" ng-keypress=\\\"toggleOpen($event)\\\">\\n\" + \"  <h4 class=\\\"panel-title\\\">\\n\" + \"    <a role=\\\"button\\\" data-toggle=\\\"collapse\\\" href aria-expanded=\\\"{{isOpen}}\\\" aria-controls=\\\"{{::panelId}}\\\" tabindex=\\\"0\\\" class=\\\"accordion-toggle\\\" ng-click=\\\"toggleOpen()\\\" uib-accordion-transclude=\\\"heading\\\" ng-disabled=\\\"isDisabled\\\" uib-tabindex-toggle><span uib-accordion-header ng-class=\\\"{'text-muted': isDisabled}\\\">{{heading}}</span></a>\\n\" + \"  </h4>\\n\" + \"</div>\\n\" + \"<div id=\\\"{{::panelId}}\\\" aria-labelledby=\\\"{{::headingId}}\\\" aria-hidden=\\\"{{!isOpen}}\\\" role=\\\"tabpanel\\\" class=\\\"panel-collapse collapse\\\" uib-collapse=\\\"!isOpen\\\">\\n\" + \"  <div class=\\\"panel-body\\\" ng-transclude></div>\\n\" + \"</div>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/accordion/accordion.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/accordion/accordion.html\", \"<div role=\\\"tablist\\\" class=\\\"panel-group\\\" ng-transclude></div>\");\n}]);\nangular.module(\"uib/template/alert/alert.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/alert/alert.html\", \"<button ng-show=\\\"closeable\\\" type=\\\"button\\\" class=\\\"close\\\" ng-click=\\\"close({$event: $event})\\\">\\n\" + \"  <span aria-hidden=\\\"true\\\">&times;</span>\\n\" + \"  <span class=\\\"sr-only\\\">Close</span>\\n\" + \"</button>\\n\" + \"<div ng-transclude></div>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/carousel/carousel.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/carousel/carousel.html\", \"<div class=\\\"carousel-inner\\\" ng-transclude></div>\\n\" + \"<a role=\\\"button\\\" href class=\\\"left carousel-control\\\" ng-click=\\\"prev()\\\" ng-class=\\\"{ disabled: isPrevDisabled() }\\\" ng-show=\\\"slides.length > 1\\\">\\n\" + \"  <span aria-hidden=\\\"true\\\" class=\\\"glyphicon glyphicon-chevron-left\\\"></span>\\n\" + \"  <span class=\\\"sr-only\\\">previous</span>\\n\" + \"</a>\\n\" + \"<a role=\\\"button\\\" href class=\\\"right carousel-control\\\" ng-click=\\\"next()\\\" ng-class=\\\"{ disabled: isNextDisabled() }\\\" ng-show=\\\"slides.length > 1\\\">\\n\" + \"  <span aria-hidden=\\\"true\\\" class=\\\"glyphicon glyphicon-chevron-right\\\"></span>\\n\" + \"  <span class=\\\"sr-only\\\">next</span>\\n\" + \"</a>\\n\" + \"<ol class=\\\"carousel-indicators\\\" ng-show=\\\"slides.length > 1\\\">\\n\" + \"  <li ng-repeat=\\\"slide in slides | orderBy:indexOfSlide track by $index\\\" ng-class=\\\"{ active: isActive(slide) }\\\" ng-click=\\\"select(slide)\\\">\\n\" + \"    <span class=\\\"sr-only\\\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\\\"isActive(slide)\\\">, currently active</span></span>\\n\" + \"  </li>\\n\" + \"</ol>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/carousel/slide.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/carousel/slide.html\", \"<div class=\\\"text-center\\\" ng-transclude></div>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/datepicker/datepicker.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/datepicker/datepicker.html\", \"<div ng-switch=\\\"datepickerMode\\\">\\n\" + \"  <div uib-daypicker ng-switch-when=\\\"day\\\" tabindex=\\\"0\\\" class=\\\"uib-daypicker\\\"></div>\\n\" + \"  <div uib-monthpicker ng-switch-when=\\\"month\\\" tabindex=\\\"0\\\" class=\\\"uib-monthpicker\\\"></div>\\n\" + \"  <div uib-yearpicker ng-switch-when=\\\"year\\\" tabindex=\\\"0\\\" class=\\\"uib-yearpicker\\\"></div>\\n\" + \"</div>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/datepicker/day.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/datepicker/day.html\", \"<table role=\\\"grid\\\" aria-labelledby=\\\"{{::uniqueId}}-title\\\" aria-activedescendant=\\\"{{activeDateId}}\\\">\\n\" + \"  <thead>\\n\" + \"    <tr>\\n\" + \"      <th><button type=\\\"button\\\" class=\\\"btn btn-default btn-sm pull-left uib-left\\\" ng-click=\\\"move(-1)\\\" tabindex=\\\"-1\\\"><i aria-hidden=\\\"true\\\" class=\\\"glyphicon glyphicon-chevron-left\\\"></i><span class=\\\"sr-only\\\">previous</span></button></th>\\n\" + \"      <th colspan=\\\"{{::5 + showWeeks}}\\\"><button id=\\\"{{::uniqueId}}-title\\\" role=\\\"heading\\\" aria-live=\\\"assertive\\\" aria-atomic=\\\"true\\\" type=\\\"button\\\" class=\\\"btn btn-default btn-sm uib-title\\\" ng-click=\\\"toggleMode()\\\" ng-disabled=\\\"datepickerMode === maxMode\\\" tabindex=\\\"-1\\\"><strong>{{title}}</strong></button></th>\\n\" + \"      <th><button type=\\\"button\\\" class=\\\"btn btn-default btn-sm pull-right uib-right\\\" ng-click=\\\"move(1)\\\" tabindex=\\\"-1\\\"><i aria-hidden=\\\"true\\\" class=\\\"glyphicon glyphicon-chevron-right\\\"></i><span class=\\\"sr-only\\\">next</span></button></th>\\n\" + \"    </tr>\\n\" + \"    <tr>\\n\" + \"      <th ng-if=\\\"showWeeks\\\" class=\\\"text-center\\\"></th>\\n\" + \"      <th ng-repeat=\\\"label in ::labels track by $index\\\" class=\\\"text-center\\\"><small aria-label=\\\"{{::label.full}}\\\">{{::label.abbr}}</small></th>\\n\" + \"    </tr>\\n\" + \"  </thead>\\n\" + \"  <tbody>\\n\" + \"    <tr class=\\\"uib-weeks\\\" ng-repeat=\\\"row in rows track by $index\\\" role=\\\"row\\\">\\n\" + \"      <td ng-if=\\\"showWeeks\\\" class=\\\"text-center h6\\\"><em>{{ weekNumbers[$index] }}</em></td>\\n\" + \"      <td ng-repeat=\\\"dt in row\\\" class=\\\"uib-day text-center\\\" role=\\\"gridcell\\\"\\n\" + \"        id=\\\"{{::dt.uid}}\\\"\\n\" + \"        ng-class=\\\"::dt.customClass\\\">\\n\" + \"        <button type=\\\"button\\\" class=\\\"btn btn-default btn-sm\\\"\\n\" + \"          uib-is-class=\\\"\\n\" + \"            'btn-info' for selectedDt,\\n\" + \"            'active' for activeDt\\n\" + \"            on dt\\\"\\n\" + \"          ng-click=\\\"select(dt.date)\\\"\\n\" + \"          ng-disabled=\\\"::dt.disabled\\\"\\n\" + \"          tabindex=\\\"-1\\\"><span ng-class=\\\"::{'text-muted': dt.secondary, 'text-info': dt.current}\\\">{{::dt.label}}</span></button>\\n\" + \"      </td>\\n\" + \"    </tr>\\n\" + \"  </tbody>\\n\" + \"</table>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/datepicker/month.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/datepicker/month.html\", \"<table role=\\\"grid\\\" aria-labelledby=\\\"{{::uniqueId}}-title\\\" aria-activedescendant=\\\"{{activeDateId}}\\\">\\n\" + \"  <thead>\\n\" + \"    <tr>\\n\" + \"      <th><button type=\\\"button\\\" class=\\\"btn btn-default btn-sm pull-left uib-left\\\" ng-click=\\\"move(-1)\\\" tabindex=\\\"-1\\\"><i aria-hidden=\\\"true\\\" class=\\\"glyphicon glyphicon-chevron-left\\\"></i><span class=\\\"sr-only\\\">previous</span></button></th>\\n\" + \"      <th colspan=\\\"{{::yearHeaderColspan}}\\\"><button id=\\\"{{::uniqueId}}-title\\\" role=\\\"heading\\\" aria-live=\\\"assertive\\\" aria-atomic=\\\"true\\\" type=\\\"button\\\" class=\\\"btn btn-default btn-sm uib-title\\\" ng-click=\\\"toggleMode()\\\" ng-disabled=\\\"datepickerMode === maxMode\\\" tabindex=\\\"-1\\\"><strong>{{title}}</strong></button></th>\\n\" + \"      <th><button type=\\\"button\\\" class=\\\"btn btn-default btn-sm pull-right uib-right\\\" ng-click=\\\"move(1)\\\" tabindex=\\\"-1\\\"><i aria-hidden=\\\"true\\\" class=\\\"glyphicon glyphicon-chevron-right\\\"></i><span class=\\\"sr-only\\\">next</span></i></button></th>\\n\" + \"    </tr>\\n\" + \"  </thead>\\n\" + \"  <tbody>\\n\" + \"    <tr class=\\\"uib-months\\\" ng-repeat=\\\"row in rows track by $index\\\" role=\\\"row\\\">\\n\" + \"      <td ng-repeat=\\\"dt in row\\\" class=\\\"uib-month text-center\\\" role=\\\"gridcell\\\"\\n\" + \"        id=\\\"{{::dt.uid}}\\\"\\n\" + \"        ng-class=\\\"::dt.customClass\\\">\\n\" + \"        <button type=\\\"button\\\" class=\\\"btn btn-default\\\"\\n\" + \"          uib-is-class=\\\"\\n\" + \"            'btn-info' for selectedDt,\\n\" + \"            'active' for activeDt\\n\" + \"            on dt\\\"\\n\" + \"          ng-click=\\\"select(dt.date)\\\"\\n\" + \"          ng-disabled=\\\"::dt.disabled\\\"\\n\" + \"          tabindex=\\\"-1\\\"><span ng-class=\\\"::{'text-info': dt.current}\\\">{{::dt.label}}</span></button>\\n\" + \"      </td>\\n\" + \"    </tr>\\n\" + \"  </tbody>\\n\" + \"</table>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/datepicker/year.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/datepicker/year.html\", \"<table role=\\\"grid\\\" aria-labelledby=\\\"{{::uniqueId}}-title\\\" aria-activedescendant=\\\"{{activeDateId}}\\\">\\n\" + \"  <thead>\\n\" + \"    <tr>\\n\" + \"      <th><button type=\\\"button\\\" class=\\\"btn btn-default btn-sm pull-left uib-left\\\" ng-click=\\\"move(-1)\\\" tabindex=\\\"-1\\\"><i aria-hidden=\\\"true\\\" class=\\\"glyphicon glyphicon-chevron-left\\\"></i><span class=\\\"sr-only\\\">previous</span></button></th>\\n\" + \"      <th colspan=\\\"{{::columns - 2}}\\\"><button id=\\\"{{::uniqueId}}-title\\\" role=\\\"heading\\\" aria-live=\\\"assertive\\\" aria-atomic=\\\"true\\\" type=\\\"button\\\" class=\\\"btn btn-default btn-sm uib-title\\\" ng-click=\\\"toggleMode()\\\" ng-disabled=\\\"datepickerMode === maxMode\\\" tabindex=\\\"-1\\\"><strong>{{title}}</strong></button></th>\\n\" + \"      <th><button type=\\\"button\\\" class=\\\"btn btn-default btn-sm pull-right uib-right\\\" ng-click=\\\"move(1)\\\" tabindex=\\\"-1\\\"><i aria-hidden=\\\"true\\\" class=\\\"glyphicon glyphicon-chevron-right\\\"></i><span class=\\\"sr-only\\\">next</span></button></th>\\n\" + \"    </tr>\\n\" + \"  </thead>\\n\" + \"  <tbody>\\n\" + \"    <tr class=\\\"uib-years\\\" ng-repeat=\\\"row in rows track by $index\\\" role=\\\"row\\\">\\n\" + \"      <td ng-repeat=\\\"dt in row\\\" class=\\\"uib-year text-center\\\" role=\\\"gridcell\\\"\\n\" + \"        id=\\\"{{::dt.uid}}\\\"\\n\" + \"        ng-class=\\\"::dt.customClass\\\">\\n\" + \"        <button type=\\\"button\\\" class=\\\"btn btn-default\\\"\\n\" + \"          uib-is-class=\\\"\\n\" + \"            'btn-info' for selectedDt,\\n\" + \"            'active' for activeDt\\n\" + \"            on dt\\\"\\n\" + \"          ng-click=\\\"select(dt.date)\\\"\\n\" + \"          ng-disabled=\\\"::dt.disabled\\\"\\n\" + \"          tabindex=\\\"-1\\\"><span ng-class=\\\"::{'text-info': dt.current}\\\">{{::dt.label}}</span></button>\\n\" + \"      </td>\\n\" + \"    </tr>\\n\" + \"  </tbody>\\n\" + \"</table>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/datepickerPopup/popup.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/datepickerPopup/popup.html\", \"<ul role=\\\"presentation\\\" class=\\\"uib-datepicker-popup dropdown-menu uib-position-measure\\\" dropdown-nested ng-if=\\\"isOpen\\\" ng-keydown=\\\"keydown($event)\\\" ng-click=\\\"$event.stopPropagation()\\\">\\n\" + \"  <li ng-transclude></li>\\n\" + \"  <li ng-if=\\\"showButtonBar\\\" class=\\\"uib-button-bar\\\">\\n\" + \"    <span class=\\\"btn-group pull-left\\\">\\n\" + \"      <button type=\\\"button\\\" class=\\\"btn btn-sm btn-info uib-datepicker-current\\\" ng-click=\\\"select('today', $event)\\\" ng-disabled=\\\"isDisabled('today')\\\">{{ getText('current') }}</button>\\n\" + \"      <button type=\\\"button\\\" class=\\\"btn btn-sm btn-danger uib-clear\\\" ng-click=\\\"select(null, $event)\\\">{{ getText('clear') }}</button>\\n\" + \"    </span>\\n\" + \"    <button type=\\\"button\\\" class=\\\"btn btn-sm btn-success pull-right uib-close\\\" ng-click=\\\"close($event)\\\">{{ getText('close') }}</button>\\n\" + \"  </li>\\n\" + \"</ul>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/modal/window.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/modal/window.html\", \"<div class=\\\"modal-dialog {{size ? 'modal-' + size : ''}}\\\"><div class=\\\"modal-content\\\" uib-modal-transclude></div></div>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/pager/pager.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/pager/pager.html\", \"<li ng-class=\\\"{disabled: noPrevious()||ngDisabled, previous: align}\\\"><a href ng-click=\\\"selectPage(page - 1, $event)\\\" ng-disabled=\\\"noPrevious()||ngDisabled\\\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\\n\" + \"<li ng-class=\\\"{disabled: noNext()||ngDisabled, next: align}\\\"><a href ng-click=\\\"selectPage(page + 1, $event)\\\" ng-disabled=\\\"noNext()||ngDisabled\\\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/pagination/pagination.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/pagination/pagination.html\", \"<li ng-if=\\\"::boundaryLinks\\\" ng-class=\\\"{disabled: noPrevious()||ngDisabled}\\\" class=\\\"pagination-first\\\"><a href ng-click=\\\"selectPage(1, $event)\\\" ng-disabled=\\\"noPrevious()||ngDisabled\\\" uib-tabindex-toggle>{{::getText('first')}}</a></li>\\n\" + \"<li ng-if=\\\"::directionLinks\\\" ng-class=\\\"{disabled: noPrevious()||ngDisabled}\\\" class=\\\"pagination-prev\\\"><a href ng-click=\\\"selectPage(page - 1, $event)\\\" ng-disabled=\\\"noPrevious()||ngDisabled\\\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\\n\" + \"<li ng-repeat=\\\"page in pages track by $index\\\" ng-class=\\\"{active: page.active,disabled: ngDisabled&&!page.active}\\\" class=\\\"pagination-page\\\"><a href ng-click=\\\"selectPage(page.number, $event)\\\" ng-disabled=\\\"ngDisabled&&!page.active\\\" uib-tabindex-toggle>{{page.text}}</a></li>\\n\" + \"<li ng-if=\\\"::directionLinks\\\" ng-class=\\\"{disabled: noNext()||ngDisabled}\\\" class=\\\"pagination-next\\\"><a href ng-click=\\\"selectPage(page + 1, $event)\\\" ng-disabled=\\\"noNext()||ngDisabled\\\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\\n\" + \"<li ng-if=\\\"::boundaryLinks\\\" ng-class=\\\"{disabled: noNext()||ngDisabled}\\\" class=\\\"pagination-last\\\"><a href ng-click=\\\"selectPage(totalPages, $event)\\\" ng-disabled=\\\"noNext()||ngDisabled\\\" uib-tabindex-toggle>{{::getText('last')}}</a></li>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/tooltip/tooltip-html-popup.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/tooltip/tooltip-html-popup.html\", \"<div class=\\\"tooltip-arrow\\\"></div>\\n\" + \"<div class=\\\"tooltip-inner\\\" ng-bind-html=\\\"contentExp()\\\"></div>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/tooltip/tooltip-popup.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/tooltip/tooltip-popup.html\", \"<div class=\\\"tooltip-arrow\\\"></div>\\n\" + \"<div class=\\\"tooltip-inner\\\" ng-bind=\\\"content\\\"></div>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/tooltip/tooltip-template-popup.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/tooltip/tooltip-template-popup.html\", \"<div class=\\\"tooltip-arrow\\\"></div>\\n\" + \"<div class=\\\"tooltip-inner\\\"\\n\" + \"  uib-tooltip-template-transclude=\\\"contentExp()\\\"\\n\" + \"  tooltip-template-transclude-scope=\\\"originScope()\\\"></div>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/popover/popover-html.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/popover/popover-html.html\", \"<div class=\\\"arrow\\\"></div>\\n\" + \"\\n\" + \"<div class=\\\"popover-inner\\\">\\n\" + \"    <h3 class=\\\"popover-title\\\" ng-bind=\\\"uibTitle\\\" ng-if=\\\"uibTitle\\\"></h3>\\n\" + \"    <div class=\\\"popover-content\\\" ng-bind-html=\\\"contentExp()\\\"></div>\\n\" + \"</div>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/popover/popover-template.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/popover/popover-template.html\", \"<div class=\\\"arrow\\\"></div>\\n\" + \"\\n\" + \"<div class=\\\"popover-inner\\\">\\n\" + \"    <h3 class=\\\"popover-title\\\" ng-bind=\\\"uibTitle\\\" ng-if=\\\"uibTitle\\\"></h3>\\n\" + \"    <div class=\\\"popover-content\\\"\\n\" + \"      uib-tooltip-template-transclude=\\\"contentExp()\\\"\\n\" + \"      tooltip-template-transclude-scope=\\\"originScope()\\\"></div>\\n\" + \"</div>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/popover/popover.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/popover/popover.html\", \"<div class=\\\"arrow\\\"></div>\\n\" + \"\\n\" + \"<div class=\\\"popover-inner\\\">\\n\" + \"    <h3 class=\\\"popover-title\\\" ng-bind=\\\"uibTitle\\\" ng-if=\\\"uibTitle\\\"></h3>\\n\" + \"    <div class=\\\"popover-content\\\" ng-bind=\\\"content\\\"></div>\\n\" + \"</div>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/progressbar/bar.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/progressbar/bar.html\", \"<div class=\\\"progress-bar\\\" ng-class=\\\"type && 'progress-bar-' + type\\\" role=\\\"progressbar\\\" aria-valuenow=\\\"{{value}}\\\" aria-valuemin=\\\"0\\\" aria-valuemax=\\\"{{max}}\\\" ng-style=\\\"{width: (percent < 100 ? percent : 100) + '%'}\\\" aria-valuetext=\\\"{{percent | number:0}}%\\\" aria-labelledby=\\\"{{::title}}\\\" ng-transclude></div>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/progressbar/progress.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/progressbar/progress.html\", \"<div class=\\\"progress\\\" ng-transclude aria-labelledby=\\\"{{::title}}\\\"></div>\");\n}]);\nangular.module(\"uib/template/progressbar/progressbar.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/progressbar/progressbar.html\", \"<div class=\\\"progress\\\">\\n\" + \"  <div class=\\\"progress-bar\\\" ng-class=\\\"type && 'progress-bar-' + type\\\" role=\\\"progressbar\\\" aria-valuenow=\\\"{{value}}\\\" aria-valuemin=\\\"0\\\" aria-valuemax=\\\"{{max}}\\\" ng-style=\\\"{width: (percent < 100 ? percent : 100) + '%'}\\\" aria-valuetext=\\\"{{percent | number:0}}%\\\" aria-labelledby=\\\"{{::title}}\\\" ng-transclude></div>\\n\" + \"</div>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/rating/rating.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/rating/rating.html\", \"<span ng-mouseleave=\\\"reset()\\\" ng-keydown=\\\"onKeydown($event)\\\" tabindex=\\\"0\\\" role=\\\"slider\\\" aria-valuemin=\\\"0\\\" aria-valuemax=\\\"{{range.length}}\\\" aria-valuenow=\\\"{{value}}\\\" aria-valuetext=\\\"{{title}}\\\">\\n\" + \"    <span ng-repeat-start=\\\"r in range track by $index\\\" class=\\\"sr-only\\\">({{ $index < value ? '*' : ' ' }})</span>\\n\" + \"    <i ng-repeat-end ng-mouseenter=\\\"enter($index + 1)\\\" ng-click=\\\"rate($index + 1)\\\" class=\\\"glyphicon\\\" ng-class=\\\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\\\" ng-attr-title=\\\"{{r.title}}\\\"></i>\\n\" + \"</span>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/tabs/tab.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/tabs/tab.html\", \"<li ng-class=\\\"[{active: active, disabled: disabled}, classes]\\\" class=\\\"uib-tab nav-item\\\">\\n\" + \"  <a href ng-click=\\\"select($event)\\\" class=\\\"nav-link\\\" uib-tab-heading-transclude>{{heading}}</a>\\n\" + \"</li>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/tabs/tabset.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/tabs/tabset.html\", \"<div>\\n\" + \"  <ul class=\\\"nav nav-{{tabset.type || 'tabs'}}\\\" ng-class=\\\"{'nav-stacked': vertical, 'nav-justified': justified}\\\" ng-transclude></ul>\\n\" + \"  <div class=\\\"tab-content\\\">\\n\" + \"    <div class=\\\"tab-pane\\\"\\n\" + \"         ng-repeat=\\\"tab in tabset.tabs\\\"\\n\" + \"         ng-class=\\\"{active: tabset.active === tab.index}\\\"\\n\" + \"         uib-tab-content-transclude=\\\"tab\\\">\\n\" + \"    </div>\\n\" + \"  </div>\\n\" + \"</div>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/timepicker/timepicker.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/timepicker/timepicker.html\", \"<table class=\\\"uib-timepicker\\\">\\n\" + \"  <tbody>\\n\" + \"    <tr class=\\\"text-center\\\" ng-show=\\\"::showSpinners\\\">\\n\" + \"      <td class=\\\"uib-increment hours\\\"><a ng-click=\\\"incrementHours()\\\" ng-class=\\\"{disabled: noIncrementHours()}\\\" class=\\\"btn btn-link\\\" ng-disabled=\\\"noIncrementHours()\\\" tabindex=\\\"-1\\\"><span class=\\\"glyphicon glyphicon-chevron-up\\\"></span></a></td>\\n\" + \"      <td>&nbsp;</td>\\n\" + \"      <td class=\\\"uib-increment minutes\\\"><a ng-click=\\\"incrementMinutes()\\\" ng-class=\\\"{disabled: noIncrementMinutes()}\\\" class=\\\"btn btn-link\\\" ng-disabled=\\\"noIncrementMinutes()\\\" tabindex=\\\"-1\\\"><span class=\\\"glyphicon glyphicon-chevron-up\\\"></span></a></td>\\n\" + \"      <td ng-show=\\\"showSeconds\\\">&nbsp;</td>\\n\" + \"      <td ng-show=\\\"showSeconds\\\" class=\\\"uib-increment seconds\\\"><a ng-click=\\\"incrementSeconds()\\\" ng-class=\\\"{disabled: noIncrementSeconds()}\\\" class=\\\"btn btn-link\\\" ng-disabled=\\\"noIncrementSeconds()\\\" tabindex=\\\"-1\\\"><span class=\\\"glyphicon glyphicon-chevron-up\\\"></span></a></td>\\n\" + \"      <td ng-show=\\\"showMeridian\\\"></td>\\n\" + \"    </tr>\\n\" + \"    <tr>\\n\" + \"      <td class=\\\"form-group uib-time hours\\\" ng-class=\\\"{'has-error': invalidHours}\\\">\\n\" + \"        <input type=\\\"text\\\" placeholder=\\\"HH\\\" ng-model=\\\"hours\\\" ng-change=\\\"updateHours()\\\" class=\\\"form-control text-center\\\" ng-readonly=\\\"::readonlyInput\\\" maxlength=\\\"2\\\" tabindex=\\\"{{::tabindex}}\\\" ng-disabled=\\\"noIncrementHours()\\\" ng-blur=\\\"blur()\\\">\\n\" + \"      </td>\\n\" + \"      <td class=\\\"uib-separator\\\">:</td>\\n\" + \"      <td class=\\\"form-group uib-time minutes\\\" ng-class=\\\"{'has-error': invalidMinutes}\\\">\\n\" + \"        <input type=\\\"text\\\" placeholder=\\\"MM\\\" ng-model=\\\"minutes\\\" ng-change=\\\"updateMinutes()\\\" class=\\\"form-control text-center\\\" ng-readonly=\\\"::readonlyInput\\\" maxlength=\\\"2\\\" tabindex=\\\"{{::tabindex}}\\\" ng-disabled=\\\"noIncrementMinutes()\\\" ng-blur=\\\"blur()\\\">\\n\" + \"      </td>\\n\" + \"      <td ng-show=\\\"showSeconds\\\" class=\\\"uib-separator\\\">:</td>\\n\" + \"      <td class=\\\"form-group uib-time seconds\\\" ng-class=\\\"{'has-error': invalidSeconds}\\\" ng-show=\\\"showSeconds\\\">\\n\" + \"        <input type=\\\"text\\\" placeholder=\\\"SS\\\" ng-model=\\\"seconds\\\" ng-change=\\\"updateSeconds()\\\" class=\\\"form-control text-center\\\" ng-readonly=\\\"readonlyInput\\\" maxlength=\\\"2\\\" tabindex=\\\"{{::tabindex}}\\\" ng-disabled=\\\"noIncrementSeconds()\\\" ng-blur=\\\"blur()\\\">\\n\" + \"      </td>\\n\" + \"      <td ng-show=\\\"showMeridian\\\" class=\\\"uib-time am-pm\\\"><button type=\\\"button\\\" ng-class=\\\"{disabled: noToggleMeridian()}\\\" class=\\\"btn btn-default text-center\\\" ng-click=\\\"toggleMeridian()\\\" ng-disabled=\\\"noToggleMeridian()\\\" tabindex=\\\"{{::tabindex}}\\\">{{meridian}}</button></td>\\n\" + \"    </tr>\\n\" + \"    <tr class=\\\"text-center\\\" ng-show=\\\"::showSpinners\\\">\\n\" + \"      <td class=\\\"uib-decrement hours\\\"><a ng-click=\\\"decrementHours()\\\" ng-class=\\\"{disabled: noDecrementHours()}\\\" class=\\\"btn btn-link\\\" ng-disabled=\\\"noDecrementHours()\\\" tabindex=\\\"-1\\\"><span class=\\\"glyphicon glyphicon-chevron-down\\\"></span></a></td>\\n\" + \"      <td>&nbsp;</td>\\n\" + \"      <td class=\\\"uib-decrement minutes\\\"><a ng-click=\\\"decrementMinutes()\\\" ng-class=\\\"{disabled: noDecrementMinutes()}\\\" class=\\\"btn btn-link\\\" ng-disabled=\\\"noDecrementMinutes()\\\" tabindex=\\\"-1\\\"><span class=\\\"glyphicon glyphicon-chevron-down\\\"></span></a></td>\\n\" + \"      <td ng-show=\\\"showSeconds\\\">&nbsp;</td>\\n\" + \"      <td ng-show=\\\"showSeconds\\\" class=\\\"uib-decrement seconds\\\"><a ng-click=\\\"decrementSeconds()\\\" ng-class=\\\"{disabled: noDecrementSeconds()}\\\" class=\\\"btn btn-link\\\" ng-disabled=\\\"noDecrementSeconds()\\\" tabindex=\\\"-1\\\"><span class=\\\"glyphicon glyphicon-chevron-down\\\"></span></a></td>\\n\" + \"      <td ng-show=\\\"showMeridian\\\"></td>\\n\" + \"    </tr>\\n\" + \"  </tbody>\\n\" + \"</table>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/typeahead/typeahead-match.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/typeahead/typeahead-match.html\", \"<a href\\n\" + \"   tabindex=\\\"-1\\\"\\n\" + \"   ng-bind-html=\\\"match.label | uibTypeaheadHighlight:query\\\"\\n\" + \"   ng-attr-title=\\\"{{match.label}}\\\"></a>\\n\" + \"\");\n}]);\nangular.module(\"uib/template/typeahead/typeahead-popup.html\", []).run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"uib/template/typeahead/typeahead-popup.html\", \"<ul class=\\\"dropdown-menu\\\" ng-show=\\\"isOpen() && !moveInProgress\\\" ng-style=\\\"{top: position().top+'px', left: position().left+'px'}\\\" role=\\\"listbox\\\" aria-hidden=\\\"{{!isOpen()}}\\\">\\n\" + \"    <li class=\\\"uib-typeahead-match\\\" ng-repeat=\\\"match in matches track by $index\\\" ng-class=\\\"{active: isActive($index) }\\\" ng-mouseenter=\\\"selectActive($index)\\\" ng-click=\\\"selectMatch($index, $event)\\\" role=\\\"option\\\" id=\\\"{{::match.id}}\\\">\\n\" + \"        <div uib-typeahead-match index=\\\"$index\\\" match=\\\"match\\\" query=\\\"query\\\" template-url=\\\"templateUrl\\\"></div>\\n\" + \"    </li>\\n\" + \"</ul>\\n\" + \"\");\n}]);\nangular.module('ui.bootstrap.carousel').run(function () {\n  !angular.$$csp().noInlineStyle && !angular.$$uibCarouselCss && angular.element(document).find('head').prepend('<style type=\"text/css\">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>');\n  angular.$$uibCarouselCss = true;\n});\nangular.module('ui.bootstrap.datepicker').run(function () {\n  !angular.$$csp().noInlineStyle && !angular.$$uibDatepickerCss && angular.element(document).find('head').prepend('<style type=\"text/css\">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-left,.uib-right{width:100%}</style>');\n  angular.$$uibDatepickerCss = true;\n});\nangular.module('ui.bootstrap.position').run(function () {\n  !angular.$$csp().noInlineStyle && !angular.$$uibPositionCss && angular.element(document).find('head').prepend('<style type=\"text/css\">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute !important;top:-9999px !important;width:50px !important;height:50px !important;overflow:scroll !important;}.uib-position-body-scrollbar-measure{overflow:scroll !important;}</style>');\n  angular.$$uibPositionCss = true;\n});\nangular.module('ui.bootstrap.datepickerPopup').run(function () {\n  !angular.$$csp().noInlineStyle && !angular.$$uibDatepickerpopupCss && angular.element(document).find('head').prepend('<style type=\"text/css\">.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}</style>');\n  angular.$$uibDatepickerpopupCss = true;\n});\nangular.module('ui.bootstrap.tooltip').run(function () {\n  !angular.$$csp().noInlineStyle && !angular.$$uibTooltipCss && angular.element(document).find('head').prepend('<style type=\"text/css\">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow,[uib-popover-html-popup].popover.top-left > .arrow,[uib-popover-html-popup].popover.top-right > .arrow,[uib-popover-html-popup].popover.bottom-left > .arrow,[uib-popover-html-popup].popover.bottom-right > .arrow,[uib-popover-html-popup].popover.left-top > .arrow,[uib-popover-html-popup].popover.left-bottom > .arrow,[uib-popover-html-popup].popover.right-top > .arrow,[uib-popover-html-popup].popover.right-bottom > .arrow,[uib-popover-template-popup].popover.top-left > .arrow,[uib-popover-template-popup].popover.top-right > .arrow,[uib-popover-template-popup].popover.bottom-left > .arrow,[uib-popover-template-popup].popover.bottom-right > .arrow,[uib-popover-template-popup].popover.left-top > .arrow,[uib-popover-template-popup].popover.left-bottom > .arrow,[uib-popover-template-popup].popover.right-top > .arrow,[uib-popover-template-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-html-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>');\n  angular.$$uibTooltipCss = true;\n});\nangular.module('ui.bootstrap.timepicker').run(function () {\n  !angular.$$csp().noInlineStyle && !angular.$$uibTimepickerCss && angular.element(document).find('head').prepend('<style type=\"text/css\">.uib-time input{width:50px;}</style>');\n  angular.$$uibTimepickerCss = true;\n});\nangular.module('ui.bootstrap.typeahead').run(function () {\n  !angular.$$csp().noInlineStyle && !angular.$$uibTypeaheadCss && angular.element(document).find('head').prepend('<style type=\"text/css\">[uib-typeahead-popup].dropdown-menu{display:block;}</style>');\n  angular.$$uibTypeaheadCss = true;\n});"

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports = "function _typeof(o) { \"@babel/helpers - typeof\"; return _typeof = \"function\" == typeof Symbol && \"symbol\" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && \"function\" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? \"symbol\" : typeof o; }, _typeof(o); }\n/*\n Copyright 2011-2013 Abdulla Abdurakhmanov\n Original sources are available at https://code.google.com/p/x2js/\n\n Licensed under the Apache License, Version 2.0 (the \"License\");\n you may not use this file except in compliance with the License.\n You may obtain a copy of the License at\n\n http://www.apache.org/licenses/LICENSE-2.0\n\n Unless required by applicable law or agreed to in writing, software\n distributed under the License is distributed on an \"AS IS\" BASIS,\n WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n See the License for the specific language governing permissions and\n limitations under the License.\n */\n\n(function (root, factory) {\n  if (typeof define === \"function\" && define.amd) {\n    define([], factory);\n  } else if ((typeof exports === \"undefined\" ? \"undefined\" : _typeof(exports)) === \"object\") {\n    module.exports = factory();\n  } else {\n    root.X2JS = factory();\n  }\n})(this, function () {\n  return function (config) {\n    'use strict';\n\n    var VERSION = \"1.2.0\";\n    config = config || {};\n    initConfigDefaults();\n    initRequiredPolyfills();\n    function initConfigDefaults() {\n      if (config.escapeMode === undefined) {\n        config.escapeMode = true;\n      }\n      config.attributePrefix = config.attributePrefix || \"_\";\n      config.arrayAccessForm = config.arrayAccessForm || \"none\";\n      config.emptyNodeForm = config.emptyNodeForm || \"text\";\n      if (config.enableToStringFunc === undefined) {\n        config.enableToStringFunc = true;\n      }\n      config.arrayAccessFormPaths = config.arrayAccessFormPaths || [];\n      if (config.skipEmptyTextNodesForObj === undefined) {\n        config.skipEmptyTextNodesForObj = true;\n      }\n      if (config.stripWhitespaces === undefined) {\n        config.stripWhitespaces = true;\n      }\n      config.datetimeAccessFormPaths = config.datetimeAccessFormPaths || [];\n      if (config.useDoubleQuotes === undefined) {\n        config.useDoubleQuotes = false;\n      }\n      config.xmlElementsFilter = config.xmlElementsFilter || [];\n      config.jsonPropertiesFilter = config.jsonPropertiesFilter || [];\n      if (config.keepCData === undefined) {\n        config.keepCData = false;\n      }\n    }\n    var DOMNodeTypes = {\n      ELEMENT_NODE: 1,\n      TEXT_NODE: 3,\n      CDATA_SECTION_NODE: 4,\n      COMMENT_NODE: 8,\n      DOCUMENT_NODE: 9\n    };\n    function initRequiredPolyfills() {}\n    function getNodeLocalName(node) {\n      var nodeLocalName = node.localName;\n      if (nodeLocalName == null)\n        // Yeah, this is IE!! \n        nodeLocalName = node.baseName;\n      if (nodeLocalName == null || nodeLocalName == \"\")\n        // ==\"\" is IE too\n        nodeLocalName = node.nodeName;\n      return nodeLocalName;\n    }\n    function getNodePrefix(node) {\n      return node.prefix;\n    }\n    function escapeXmlChars(str) {\n      if (typeof str == \"string\") return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\"/g, '&quot;').replace(/'/g, '&apos;');else return str;\n    }\n    function unescapeXmlChars(str) {\n      return str.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '\"').replace(/&apos;/g, \"'\").replace(/&amp;/g, '&');\n    }\n    function checkInStdFiltersArrayForm(stdFiltersArrayForm, obj, name, path) {\n      var idx = 0;\n      for (; idx < stdFiltersArrayForm.length; idx++) {\n        var filterPath = stdFiltersArrayForm[idx];\n        if (typeof filterPath === \"string\") {\n          if (filterPath == path) break;\n        } else if (filterPath instanceof RegExp) {\n          if (filterPath.test(path)) break;\n        } else if (typeof filterPath === \"function\") {\n          if (filterPath(obj, name, path)) break;\n        }\n      }\n      return idx != stdFiltersArrayForm.length;\n    }\n    function toArrayAccessForm(obj, childName, path) {\n      switch (config.arrayAccessForm) {\n        case \"property\":\n          if (!(obj[childName] instanceof Array)) obj[childName + \"_asArray\"] = [obj[childName]];else obj[childName + \"_asArray\"] = obj[childName];\n          break;\n        /*case \"none\":\n            break;*/\n      }\n      if (!(obj[childName] instanceof Array) && config.arrayAccessFormPaths.length > 0) {\n        if (checkInStdFiltersArrayForm(config.arrayAccessFormPaths, obj, childName, path)) {\n          obj[childName] = [obj[childName]];\n        }\n      }\n    }\n    function fromXmlDateTime(prop) {\n      // Implementation based up on http://stackoverflow.com/questions/8178598/xml-datetime-to-javascript-date-object\n      // Improved to support full spec and optional parts\n      var bits = prop.split(/[-T:+Z]/g);\n      var d = new Date(bits[0], bits[1] - 1, bits[2]);\n      var secondBits = bits[5].split(\"\\.\");\n      d.setHours(bits[3], bits[4], secondBits[0]);\n      if (secondBits.length > 1) d.setMilliseconds(secondBits[1]);\n\n      // Get supplied time zone offset in minutes\n      if (bits[6] && bits[7]) {\n        var offsetMinutes = bits[6] * 60 + Number(bits[7]);\n        var sign = /\\d\\d-\\d\\d:\\d\\d$/.test(prop) ? '-' : '+';\n\n        // Apply the sign\n        offsetMinutes = 0 + (sign == '-' ? -1 * offsetMinutes : offsetMinutes);\n\n        // Apply offset and local timezone\n        d.setMinutes(d.getMinutes() - offsetMinutes - d.getTimezoneOffset());\n      } else if (prop.indexOf(\"Z\", prop.length - 1) !== -1) {\n        d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()));\n      }\n\n      // d is now a local time equivalent to the supplied time\n      return d;\n    }\n    function checkFromXmlDateTimePaths(value, childName, fullPath) {\n      if (config.datetimeAccessFormPaths.length > 0) {\n        var path = fullPath.split(\"\\.#\")[0];\n        if (checkInStdFiltersArrayForm(config.datetimeAccessFormPaths, value, childName, path)) {\n          return fromXmlDateTime(value);\n        } else return value;\n      } else return value;\n    }\n    function checkXmlElementsFilter(obj, childType, childName, childPath) {\n      if (childType == DOMNodeTypes.ELEMENT_NODE && config.xmlElementsFilter.length > 0) {\n        return checkInStdFiltersArrayForm(config.xmlElementsFilter, obj, childName, childPath);\n      } else return true;\n    }\n    function parseDOMChildren(node, path) {\n      if (node.nodeType == DOMNodeTypes.DOCUMENT_NODE) {\n        var result = new Object();\n        var nodeChildren = node.childNodes;\n        // Alternative for firstElementChild which is not supported in some environments\n        for (var cidx = 0; cidx < nodeChildren.length; cidx++) {\n          var child = nodeChildren.item(cidx);\n          if (child.nodeType == DOMNodeTypes.ELEMENT_NODE) {\n            var childName = getNodeLocalName(child);\n            result[childName] = parseDOMChildren(child, childName);\n          }\n        }\n        return result;\n      } else if (node.nodeType == DOMNodeTypes.ELEMENT_NODE) {\n        var result = new Object();\n        result.__cnt = 0;\n        var nodeChildren = node.childNodes;\n\n        // Children nodes\n        for (var cidx = 0; cidx < nodeChildren.length; cidx++) {\n          var child = nodeChildren.item(cidx); // nodeChildren[cidx];\n          var childName = getNodeLocalName(child);\n          if (child.nodeType != DOMNodeTypes.COMMENT_NODE) {\n            var childPath = path + \".\" + childName;\n            if (checkXmlElementsFilter(result, child.nodeType, childName, childPath)) {\n              result.__cnt++;\n              if (result[childName] == null) {\n                result[childName] = parseDOMChildren(child, childPath);\n                toArrayAccessForm(result, childName, childPath);\n              } else {\n                if (result[childName] != null) {\n                  if (!(result[childName] instanceof Array)) {\n                    result[childName] = [result[childName]];\n                    toArrayAccessForm(result, childName, childPath);\n                  }\n                }\n                result[childName][result[childName].length] = parseDOMChildren(child, childPath);\n              }\n            }\n          }\n        }\n\n        // Attributes\n        for (var aidx = 0; aidx < node.attributes.length; aidx++) {\n          var attr = node.attributes.item(aidx); // [aidx];\n          result.__cnt++;\n          result[config.attributePrefix + attr.name] = attr.value;\n        }\n\n        // Node namespace prefix\n        var nodePrefix = getNodePrefix(node);\n        if (nodePrefix != null && nodePrefix != \"\") {\n          result.__cnt++;\n          result.__prefix = nodePrefix;\n        }\n        if (result[\"#text\"] != null) {\n          result.__text = result[\"#text\"];\n          if (result.__text instanceof Array) {\n            result.__text = result.__text.join(\"\\n\");\n          }\n          //if(config.escapeMode)\n          //  result.__text = unescapeXmlChars(result.__text);\n          if (config.stripWhitespaces) result.__text = result.__text.trim();\n          delete result[\"#text\"];\n          if (config.arrayAccessForm == \"property\") delete result[\"#text_asArray\"];\n          result.__text = checkFromXmlDateTimePaths(result.__text, childName, path + \".\" + childName);\n        }\n        if (result[\"#cdata-section\"] != null) {\n          result.__cdata = result[\"#cdata-section\"];\n          delete result[\"#cdata-section\"];\n          if (config.arrayAccessForm == \"property\") delete result[\"#cdata-section_asArray\"];\n        }\n        if (result.__cnt == 0 && config.emptyNodeForm == \"text\") {\n          result = '';\n        } else if (result.__cnt == 1 && result.__text != null) {\n          result = result.__text;\n        } else if (result.__cnt == 1 && result.__cdata != null && !config.keepCData) {\n          result = result.__cdata;\n        } else if (result.__cnt > 1 && result.__text != null && config.skipEmptyTextNodesForObj) {\n          if (config.stripWhitespaces && result.__text == \"\" || result.__text.trim() == \"\") {\n            delete result.__text;\n          }\n        }\n        delete result.__cnt;\n        if (config.enableToStringFunc && (result.__text != null || result.__cdata != null)) {\n          result.toString = function () {\n            return (this.__text != null ? this.__text : '') + (this.__cdata != null ? this.__cdata : '');\n          };\n        }\n        return result;\n      } else if (node.nodeType == DOMNodeTypes.TEXT_NODE || node.nodeType == DOMNodeTypes.CDATA_SECTION_NODE) {\n        return node.nodeValue;\n      }\n    }\n    function startTag(jsonObj, element, attrList, closed) {\n      var resultStr = \"<\" + (jsonObj != null && jsonObj.__prefix != null ? jsonObj.__prefix + \":\" : \"\") + element;\n      if (attrList != null) {\n        for (var aidx = 0; aidx < attrList.length; aidx++) {\n          var attrName = attrList[aidx];\n          var attrVal = jsonObj[attrName];\n          if (config.escapeMode) attrVal = escapeXmlChars(attrVal);\n          resultStr += \" \" + attrName.substr(config.attributePrefix.length) + \"=\";\n          if (config.useDoubleQuotes) resultStr += '\"' + attrVal + '\"';else resultStr += \"'\" + attrVal + \"'\";\n        }\n      }\n      if (!closed) resultStr += \">\";else resultStr += \"/>\";\n      return resultStr;\n    }\n    function endTag(jsonObj, elementName) {\n      return \"</\" + (jsonObj.__prefix != null ? jsonObj.__prefix + \":\" : \"\") + elementName + \">\";\n    }\n    function endsWith(str, suffix) {\n      return str.indexOf(suffix, str.length - suffix.length) !== -1;\n    }\n    function jsonXmlSpecialElem(jsonObj, jsonObjField) {\n      if (config.arrayAccessForm == \"property\" && endsWith(jsonObjField.toString(), \"_asArray\") || jsonObjField.toString().indexOf(config.attributePrefix) == 0 || jsonObjField.toString().indexOf(\"__\") == 0 || jsonObj[jsonObjField] instanceof Function) return true;else return false;\n    }\n    function jsonXmlElemCount(jsonObj) {\n      var elementsCnt = 0;\n      if (jsonObj instanceof Object) {\n        for (var it in jsonObj) {\n          if (jsonXmlSpecialElem(jsonObj, it)) continue;\n          elementsCnt++;\n        }\n      }\n      return elementsCnt;\n    }\n    function checkJsonObjPropertiesFilter(jsonObj, propertyName, jsonObjPath) {\n      return config.jsonPropertiesFilter.length == 0 || jsonObjPath == \"\" || checkInStdFiltersArrayForm(config.jsonPropertiesFilter, jsonObj, propertyName, jsonObjPath);\n    }\n    function parseJSONAttributes(jsonObj) {\n      var attrList = [];\n      if (jsonObj instanceof Object) {\n        for (var ait in jsonObj) {\n          if (ait.toString().indexOf(\"__\") == -1 && ait.toString().indexOf(config.attributePrefix) == 0) {\n            attrList.push(ait);\n          }\n        }\n      }\n      return attrList;\n    }\n    function parseJSONTextAttrs(jsonTxtObj) {\n      var result = \"\";\n      if (jsonTxtObj.__cdata != null) {\n        result += \"<![CDATA[\" + jsonTxtObj.__cdata + \"]]>\";\n      }\n      if (jsonTxtObj.__text != null) {\n        if (config.escapeMode) result += escapeXmlChars(jsonTxtObj.__text);else result += jsonTxtObj.__text;\n      }\n      return result;\n    }\n    function parseJSONTextObject(jsonTxtObj) {\n      var result = \"\";\n      if (jsonTxtObj instanceof Object) {\n        result += parseJSONTextAttrs(jsonTxtObj);\n      } else if (jsonTxtObj != null) {\n        if (config.escapeMode) result += escapeXmlChars(jsonTxtObj);else result += jsonTxtObj;\n      }\n      return result;\n    }\n    function getJsonPropertyPath(jsonObjPath, jsonPropName) {\n      if (jsonObjPath === \"\") {\n        return jsonPropName;\n      } else return jsonObjPath + \".\" + jsonPropName;\n    }\n    function parseJSONArray(jsonArrRoot, jsonArrObj, attrList, jsonObjPath) {\n      var result = \"\";\n      if (jsonArrRoot.length == 0) {\n        result += startTag(jsonArrRoot, jsonArrObj, attrList, true);\n      } else {\n        for (var arIdx = 0; arIdx < jsonArrRoot.length; arIdx++) {\n          result += startTag(jsonArrRoot[arIdx], jsonArrObj, parseJSONAttributes(jsonArrRoot[arIdx]), false);\n          result += parseJSONObject(jsonArrRoot[arIdx], getJsonPropertyPath(jsonObjPath, jsonArrObj));\n          result += endTag(jsonArrRoot[arIdx], jsonArrObj);\n        }\n      }\n      return result;\n    }\n    function parseJSONObject(jsonObj, jsonObjPath) {\n      var result = \"\";\n      var elementsCnt = jsonXmlElemCount(jsonObj);\n      if (elementsCnt > 0) {\n        for (var it in jsonObj) {\n          if (jsonXmlSpecialElem(jsonObj, it) || jsonObjPath != \"\" && !checkJsonObjPropertiesFilter(jsonObj, it, getJsonPropertyPath(jsonObjPath, it))) continue;\n          var subObj = jsonObj[it];\n          var attrList = parseJSONAttributes(subObj);\n          if (subObj == null || subObj == undefined) {\n            result += startTag(subObj, it, attrList, true);\n          } else if (subObj instanceof Object) {\n            if (subObj instanceof Array) {\n              result += parseJSONArray(subObj, it, attrList, jsonObjPath);\n            } else if (subObj instanceof Date) {\n              result += startTag(subObj, it, attrList, false);\n              result += subObj.toISOString();\n              result += endTag(subObj, it);\n            } else {\n              var subObjElementsCnt = jsonXmlElemCount(subObj);\n              if (subObjElementsCnt > 0 || subObj.__text != null || subObj.__cdata != null) {\n                result += startTag(subObj, it, attrList, false);\n                result += parseJSONObject(subObj, getJsonPropertyPath(jsonObjPath, it));\n                result += endTag(subObj, it);\n              } else {\n                result += startTag(subObj, it, attrList, true);\n              }\n            }\n          } else {\n            result += startTag(subObj, it, attrList, false);\n            result += parseJSONTextObject(subObj);\n            result += endTag(subObj, it);\n          }\n        }\n      }\n      result += parseJSONTextObject(jsonObj);\n      return result;\n    }\n    this.parseXmlString = function (xmlDocStr) {\n      var isIEParser = window.ActiveXObject || \"ActiveXObject\" in window;\n      if (xmlDocStr === undefined) {\n        return null;\n      }\n      var xmlDoc;\n      if (window.DOMParser) {\n        var parser = new window.DOMParser();\n        var parsererrorNS = null;\n        // IE9+ now is here\n        if (!isIEParser) {\n          try {\n            parsererrorNS = parser.parseFromString(\"INVALID\", \"text/xml\").getElementsByTagName(\"parsererror\")[0].namespaceURI;\n          } catch (err) {\n            parsererrorNS = null;\n          }\n        }\n        try {\n          xmlDoc = parser.parseFromString(xmlDocStr, \"text/xml\");\n          if (parsererrorNS != null && xmlDoc.getElementsByTagNameNS(parsererrorNS, \"parsererror\").length > 0) {\n            //throw new Error('Error parsing XML: '+xmlDocStr);\n            xmlDoc = null;\n          }\n        } catch (err) {\n          xmlDoc = null;\n        }\n      } else {\n        // IE :(\n        if (xmlDocStr.indexOf(\"<?\") == 0) {\n          xmlDocStr = xmlDocStr.substr(xmlDocStr.indexOf(\"?>\") + 2);\n        }\n        xmlDoc = new ActiveXObject(\"Microsoft.XMLDOM\");\n        xmlDoc.async = \"false\";\n        xmlDoc.loadXML(xmlDocStr);\n      }\n      return xmlDoc;\n    };\n    this.asArray = function (prop) {\n      if (prop === undefined || prop == null) return [];else if (prop instanceof Array) return prop;else return [prop];\n    };\n    this.toXmlDateTime = function (dt) {\n      if (dt instanceof Date) return dt.toISOString();else if (typeof dt === 'number') return new Date(dt).toISOString();else return null;\n    };\n    this.asDateTime = function (prop) {\n      if (typeof prop == \"string\") {\n        return fromXmlDateTime(prop);\n      } else return prop;\n    };\n    this.xml2json = function (xmlDoc) {\n      return parseDOMChildren(xmlDoc);\n    };\n    this.xml_str2json = function (xmlDocStr) {\n      var xmlDoc = this.parseXmlString(xmlDocStr);\n      if (xmlDoc != null) return this.xml2json(xmlDoc);else return null;\n    };\n    this.json2xml_str = function (jsonObj) {\n      return parseJSONObject(jsonObj, \"\");\n    };\n    this.json2xml = function (jsonObj) {\n      var xmlDocStr = this.json2xml_str(jsonObj);\n      return this.parseXmlString(xmlDocStr);\n    };\n    this.getVersion = function () {\n      return VERSION;\n    };\n  };\n});"

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports = "var b64map = \"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/\";\nvar b64padchar = \"=\";\nfunction hex2b64(h) {\n  var i;\n  var c;\n  var ret = \"\";\n  for (i = 0; i + 3 <= h.length; i += 3) {\n    c = parseInt(h.substring(i, i + 3), 16);\n    ret += b64map.charAt(c >> 6) + b64map.charAt(c & 63);\n  }\n  if (i + 1 == h.length) {\n    c = parseInt(h.substring(i, i + 1), 16);\n    ret += b64map.charAt(c << 2);\n  } else if (i + 2 == h.length) {\n    c = parseInt(h.substring(i, i + 2), 16);\n    ret += b64map.charAt(c >> 2) + b64map.charAt((c & 3) << 4);\n  }\n  while ((ret.length & 3) > 0) ret += b64padchar;\n  return ret;\n}\n\n// convert a base64 string to hex\nfunction b64tohex(s) {\n  var ret = \"\";\n  var i;\n  var k = 0; // b64 state, 0-3\n  var slop;\n  for (i = 0; i < s.length; ++i) {\n    if (s.charAt(i) == b64padchar) break;\n    v = b64map.indexOf(s.charAt(i));\n    if (v < 0) continue;\n    if (k == 0) {\n      ret += int2char(v >> 2);\n      slop = v & 3;\n      k = 1;\n    } else if (k == 1) {\n      ret += int2char(slop << 2 | v >> 4);\n      slop = v & 0xf;\n      k = 2;\n    } else if (k == 2) {\n      ret += int2char(slop);\n      ret += int2char(v >> 2);\n      slop = v & 3;\n      k = 3;\n    } else {\n      ret += int2char(slop << 2 | v >> 4);\n      ret += int2char(v & 0xf);\n      k = 0;\n    }\n  }\n  if (k == 1) ret += int2char(slop << 2);\n  return ret;\n}\n\n// convert a base64 string to a byte/number array\nfunction b64toBA(s) {\n  //piggyback on b64tohex for now, optimize later\n  var h = b64tohex(s);\n  var i;\n  var a = new Array();\n  for (i = 0; 2 * i < h.length; ++i) {\n    a[i] = parseInt(h.substring(2 * i, 2 * i + 2), 16);\n  }\n  return a;\n}"

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports = "// prng4.js - uses Arcfour as a PRNG\n\nfunction Arcfour() {\n  this.i = 0;\n  this.j = 0;\n  this.S = new Array();\n}\n\n// Initialize arcfour context from key, an array of ints, each from [0..255]\nfunction ARC4init(key) {\n  var i, j, t;\n  for (i = 0; i < 256; ++i) this.S[i] = i;\n  j = 0;\n  for (i = 0; i < 256; ++i) {\n    j = j + this.S[i] + key[i % key.length] & 255;\n    t = this.S[i];\n    this.S[i] = this.S[j];\n    this.S[j] = t;\n  }\n  this.i = 0;\n  this.j = 0;\n}\nfunction ARC4next() {\n  var t;\n  this.i = this.i + 1 & 255;\n  this.j = this.j + this.S[this.i] & 255;\n  t = this.S[this.i];\n  this.S[this.i] = this.S[this.j];\n  this.S[this.j] = t;\n  return this.S[t + this.S[this.i] & 255];\n}\nArcfour.prototype.init = ARC4init;\nArcfour.prototype.next = ARC4next;\n\n// Plug in your RNG constructor here\nfunction prng_newstate() {\n  return new Arcfour();\n}\n\n// Pool size must be a multiple of 4 and greater than 32.\n// An array of bytes the size of the pool will be passed to init()\nvar rng_psize = 256;"

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports = "/*\n * Copyright (c) 2003-2005  Tom Wu\n * All Rights Reserved.\n *\n * Permission is hereby granted, free of charge, to any person obtaining\n * a copy of this software and associated documentation files (the\n * \"Software\"), to deal in the Software without restriction, including\n * without limitation the rights to use, copy, modify, merge, publish,\n * distribute, sublicense, and/or sell copies of the Software, and to\n * permit persons to whom the Software is furnished to do so, subject to\n * the following conditions:\n *\n * The above copyright notice and this permission notice shall be\n * included in all copies or substantial portions of the Software.\n *\n * THE SOFTWARE IS PROVIDED \"AS-IS\" AND WITHOUT WARRANTY OF ANY KIND,\n * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY\n * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.\n *\n * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,\n * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER\n * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF\n * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT\n * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.\n *\n * In addition, the following condition applies:\n *\n * All redistributions must retain an intact copy of this copyright notice\n * and disclaimer.\n */\n\n// Basic JavaScript BN library - subset useful for RSA encryption.\n\n// Bits per digit\nvar dbits;\n\n// JavaScript engine analysis\nvar canary = 0xdeadbeefcafe;\nvar j_lm = (canary & 0xffffff) == 0xefcafe;\n\n// (public) Constructor\nfunction BigInteger(a, b, c) {\n  if (a != null) if (\"number\" == typeof a) this.fromNumber(a, b, c);else if (b == null && \"string\" != typeof a) this.fromString(a, 256);else this.fromString(a, b);\n}\n\n// return new, unset BigInteger\nfunction nbi() {\n  return new BigInteger(null);\n}\n\n// am: Compute w_j += (x*this_i), propagate carries,\n// c is initial carry, returns final carry.\n// c < 3*dvalue, x < 2*dvalue, this_i < dvalue\n// We need to select the fastest one that works in this environment.\n\n// am1: use a single mult and divide to get the high bits,\n// max digit bits should be 26 because\n// max internal value = 2*dvalue^2-2*dvalue (< 2^53)\nfunction am1(i, x, w, j, c, n) {\n  while (--n >= 0) {\n    var v = x * this[i++] + w[j] + c;\n    c = Math.floor(v / 0x4000000);\n    w[j++] = v & 0x3ffffff;\n  }\n  return c;\n}\n// am2 avoids a big mult-and-extract completely.\n// Max digit bits should be <= 30 because we do bitwise ops\n// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)\nfunction am2(i, x, w, j, c, n) {\n  var xl = x & 0x7fff,\n    xh = x >> 15;\n  while (--n >= 0) {\n    var l = this[i] & 0x7fff;\n    var h = this[i++] >> 15;\n    var m = xh * l + h * xl;\n    l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);\n    c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);\n    w[j++] = l & 0x3fffffff;\n  }\n  return c;\n}\n// Alternately, set max digit bits to 28 since some\n// browsers slow down when dealing with 32-bit numbers.\nfunction am3(i, x, w, j, c, n) {\n  var xl = x & 0x3fff,\n    xh = x >> 14;\n  while (--n >= 0) {\n    var l = this[i] & 0x3fff;\n    var h = this[i++] >> 14;\n    var m = xh * l + h * xl;\n    l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;\n    c = (l >> 28) + (m >> 14) + xh * h;\n    w[j++] = l & 0xfffffff;\n  }\n  return c;\n}\nif (j_lm && navigator.appName == \"Microsoft Internet Explorer\") {\n  BigInteger.prototype.am = am2;\n  dbits = 30;\n} else if (j_lm && navigator.appName != \"Netscape\") {\n  BigInteger.prototype.am = am1;\n  dbits = 26;\n} else {\n  // Mozilla/Netscape seems to prefer am3\n  BigInteger.prototype.am = am3;\n  dbits = 28;\n}\nBigInteger.prototype.DB = dbits;\nBigInteger.prototype.DM = (1 << dbits) - 1;\nBigInteger.prototype.DV = 1 << dbits;\nvar BI_FP = 52;\nBigInteger.prototype.FV = Math.pow(2, BI_FP);\nBigInteger.prototype.F1 = BI_FP - dbits;\nBigInteger.prototype.F2 = 2 * dbits - BI_FP;\n\n// Digit conversions\nvar BI_RM = \"0123456789abcdefghijklmnopqrstuvwxyz\";\nvar BI_RC = new Array();\nvar rr, vv;\nrr = \"0\".charCodeAt(0);\nfor (vv = 0; vv <= 9; ++vv) BI_RC[rr++] = vv;\nrr = \"a\".charCodeAt(0);\nfor (vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;\nrr = \"A\".charCodeAt(0);\nfor (vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;\nfunction int2char(n) {\n  return BI_RM.charAt(n);\n}\nfunction intAt(s, i) {\n  var c = BI_RC[s.charCodeAt(i)];\n  return c == null ? -1 : c;\n}\n\n// (protected) copy this to r\nfunction bnpCopyTo(r) {\n  for (var i = this.t - 1; i >= 0; --i) r[i] = this[i];\n  r.t = this.t;\n  r.s = this.s;\n}\n\n// (protected) set from integer value x, -DV <= x < DV\nfunction bnpFromInt(x) {\n  this.t = 1;\n  this.s = x < 0 ? -1 : 0;\n  if (x > 0) this[0] = x;else if (x < -1) this[0] = x + this.DV;else this.t = 0;\n}\n\n// return bigint initialized to value\nfunction nbv(i) {\n  var r = nbi();\n  r.fromInt(i);\n  return r;\n}\n\n// (protected) set from string and radix\nfunction bnpFromString(s, b) {\n  var k;\n  if (b == 16) k = 4;else if (b == 8) k = 3;else if (b == 256) k = 8; // byte array\n  else if (b == 2) k = 1;else if (b == 32) k = 5;else if (b == 4) k = 2;else {\n    this.fromRadix(s, b);\n    return;\n  }\n  this.t = 0;\n  this.s = 0;\n  var i = s.length,\n    mi = false,\n    sh = 0;\n  while (--i >= 0) {\n    var x = k == 8 ? s[i] & 0xff : intAt(s, i);\n    if (x < 0) {\n      if (s.charAt(i) == \"-\") mi = true;\n      continue;\n    }\n    mi = false;\n    if (sh == 0) this[this.t++] = x;else if (sh + k > this.DB) {\n      this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;\n      this[this.t++] = x >> this.DB - sh;\n    } else this[this.t - 1] |= x << sh;\n    sh += k;\n    if (sh >= this.DB) sh -= this.DB;\n  }\n  if (k == 8 && (s[0] & 0x80) != 0) {\n    this.s = -1;\n    if (sh > 0) this[this.t - 1] |= (1 << this.DB - sh) - 1 << sh;\n  }\n  this.clamp();\n  if (mi) BigInteger.ZERO.subTo(this, this);\n}\n\n// (protected) clamp off excess high words\nfunction bnpClamp() {\n  var c = this.s & this.DM;\n  while (this.t > 0 && this[this.t - 1] == c) --this.t;\n}\n\n// (public) return string representation in given radix\nfunction bnToString(b) {\n  if (this.s < 0) return \"-\" + this.negate().toString(b);\n  var k;\n  if (b == 16) k = 4;else if (b == 8) k = 3;else if (b == 2) k = 1;else if (b == 32) k = 5;else if (b == 4) k = 2;else return this.toRadix(b);\n  var km = (1 << k) - 1,\n    d,\n    m = false,\n    r = \"\",\n    i = this.t;\n  var p = this.DB - i * this.DB % k;\n  if (i-- > 0) {\n    if (p < this.DB && (d = this[i] >> p) > 0) {\n      m = true;\n      r = int2char(d);\n    }\n    while (i >= 0) {\n      if (p < k) {\n        d = (this[i] & (1 << p) - 1) << k - p;\n        d |= this[--i] >> (p += this.DB - k);\n      } else {\n        d = this[i] >> (p -= k) & km;\n        if (p <= 0) {\n          p += this.DB;\n          --i;\n        }\n      }\n      if (d > 0) m = true;\n      if (m) r += int2char(d);\n    }\n  }\n  return m ? r : \"0\";\n}\n\n// (public) -this\nfunction bnNegate() {\n  var r = nbi();\n  BigInteger.ZERO.subTo(this, r);\n  return r;\n}\n\n// (public) |this|\nfunction bnAbs() {\n  return this.s < 0 ? this.negate() : this;\n}\n\n// (public) return + if this > a, - if this < a, 0 if equal\nfunction bnCompareTo(a) {\n  var r = this.s - a.s;\n  if (r != 0) return r;\n  var i = this.t;\n  r = i - a.t;\n  if (r != 0) return this.s < 0 ? -r : r;\n  while (--i >= 0) if ((r = this[i] - a[i]) != 0) return r;\n  return 0;\n}\n\n// returns bit length of the integer x\nfunction nbits(x) {\n  var r = 1,\n    t;\n  if ((t = x >>> 16) != 0) {\n    x = t;\n    r += 16;\n  }\n  if ((t = x >> 8) != 0) {\n    x = t;\n    r += 8;\n  }\n  if ((t = x >> 4) != 0) {\n    x = t;\n    r += 4;\n  }\n  if ((t = x >> 2) != 0) {\n    x = t;\n    r += 2;\n  }\n  if ((t = x >> 1) != 0) {\n    x = t;\n    r += 1;\n  }\n  return r;\n}\n\n// (public) return the number of bits in \"this\"\nfunction bnBitLength() {\n  if (this.t <= 0) return 0;\n  return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);\n}\n\n// (protected) r = this << n*DB\nfunction bnpDLShiftTo(n, r) {\n  var i;\n  for (i = this.t - 1; i >= 0; --i) r[i + n] = this[i];\n  for (i = n - 1; i >= 0; --i) r[i] = 0;\n  r.t = this.t + n;\n  r.s = this.s;\n}\n\n// (protected) r = this >> n*DB\nfunction bnpDRShiftTo(n, r) {\n  for (var i = n; i < this.t; ++i) r[i - n] = this[i];\n  r.t = Math.max(this.t - n, 0);\n  r.s = this.s;\n}\n\n// (protected) r = this << n\nfunction bnpLShiftTo(n, r) {\n  var bs = n % this.DB;\n  var cbs = this.DB - bs;\n  var bm = (1 << cbs) - 1;\n  var ds = Math.floor(n / this.DB),\n    c = this.s << bs & this.DM,\n    i;\n  for (i = this.t - 1; i >= 0; --i) {\n    r[i + ds + 1] = this[i] >> cbs | c;\n    c = (this[i] & bm) << bs;\n  }\n  for (i = ds - 1; i >= 0; --i) r[i] = 0;\n  r[ds] = c;\n  r.t = this.t + ds + 1;\n  r.s = this.s;\n  r.clamp();\n}\n\n// (protected) r = this >> n\nfunction bnpRShiftTo(n, r) {\n  r.s = this.s;\n  var ds = Math.floor(n / this.DB);\n  if (ds >= this.t) {\n    r.t = 0;\n    return;\n  }\n  var bs = n % this.DB;\n  var cbs = this.DB - bs;\n  var bm = (1 << bs) - 1;\n  r[0] = this[ds] >> bs;\n  for (var i = ds + 1; i < this.t; ++i) {\n    r[i - ds - 1] |= (this[i] & bm) << cbs;\n    r[i - ds] = this[i] >> bs;\n  }\n  if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;\n  r.t = this.t - ds;\n  r.clamp();\n}\n\n// (protected) r = this - a\nfunction bnpSubTo(a, r) {\n  var i = 0,\n    c = 0,\n    m = Math.min(a.t, this.t);\n  while (i < m) {\n    c += this[i] - a[i];\n    r[i++] = c & this.DM;\n    c >>= this.DB;\n  }\n  if (a.t < this.t) {\n    c -= a.s;\n    while (i < this.t) {\n      c += this[i];\n      r[i++] = c & this.DM;\n      c >>= this.DB;\n    }\n    c += this.s;\n  } else {\n    c += this.s;\n    while (i < a.t) {\n      c -= a[i];\n      r[i++] = c & this.DM;\n      c >>= this.DB;\n    }\n    c -= a.s;\n  }\n  r.s = c < 0 ? -1 : 0;\n  if (c < -1) r[i++] = this.DV + c;else if (c > 0) r[i++] = c;\n  r.t = i;\n  r.clamp();\n}\n\n// (protected) r = this * a, r != this,a (HAC 14.12)\n// \"this\" should be the larger one if appropriate.\nfunction bnpMultiplyTo(a, r) {\n  var x = this.abs(),\n    y = a.abs();\n  var i = x.t;\n  r.t = i + y.t;\n  while (--i >= 0) r[i] = 0;\n  for (i = 0; i < y.t; ++i) r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);\n  r.s = 0;\n  r.clamp();\n  if (this.s != a.s) BigInteger.ZERO.subTo(r, r);\n}\n\n// (protected) r = this^2, r != this (HAC 14.16)\nfunction bnpSquareTo(r) {\n  var x = this.abs();\n  var i = r.t = 2 * x.t;\n  while (--i >= 0) r[i] = 0;\n  for (i = 0; i < x.t - 1; ++i) {\n    var c = x.am(i, x[i], r, 2 * i, 0, 1);\n    if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {\n      r[i + x.t] -= x.DV;\n      r[i + x.t + 1] = 1;\n    }\n  }\n  if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);\n  r.s = 0;\n  r.clamp();\n}\n\n// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)\n// r != q, this != m.  q or r may be null.\nfunction bnpDivRemTo(m, q, r) {\n  var pm = m.abs();\n  if (pm.t <= 0) return;\n  var pt = this.abs();\n  if (pt.t < pm.t) {\n    if (q != null) q.fromInt(0);\n    if (r != null) this.copyTo(r);\n    return;\n  }\n  if (r == null) r = nbi();\n  var y = nbi(),\n    ts = this.s,\n    ms = m.s;\n  var nsh = this.DB - nbits(pm[pm.t - 1]); // normalize modulus\n  if (nsh > 0) {\n    pm.lShiftTo(nsh, y);\n    pt.lShiftTo(nsh, r);\n  } else {\n    pm.copyTo(y);\n    pt.copyTo(r);\n  }\n  var ys = y.t;\n  var y0 = y[ys - 1];\n  if (y0 == 0) return;\n  var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);\n  var d1 = this.FV / yt,\n    d2 = (1 << this.F1) / yt,\n    e = 1 << this.F2;\n  var i = r.t,\n    j = i - ys,\n    t = q == null ? nbi() : q;\n  y.dlShiftTo(j, t);\n  if (r.compareTo(t) >= 0) {\n    r[r.t++] = 1;\n    r.subTo(t, r);\n  }\n  BigInteger.ONE.dlShiftTo(ys, t);\n  t.subTo(y, y); // \"negative\" y so we can replace sub with am later\n  while (y.t < ys) y[y.t++] = 0;\n  while (--j >= 0) {\n    // Estimate quotient digit\n    var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);\n    if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {\n      // Try it out\n      y.dlShiftTo(j, t);\n      r.subTo(t, r);\n      while (r[i] < --qd) r.subTo(t, r);\n    }\n  }\n  if (q != null) {\n    r.drShiftTo(ys, q);\n    if (ts != ms) BigInteger.ZERO.subTo(q, q);\n  }\n  r.t = ys;\n  r.clamp();\n  if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder\n  if (ts < 0) BigInteger.ZERO.subTo(r, r);\n}\n\n// (public) this mod a\nfunction bnMod(a) {\n  var r = nbi();\n  this.abs().divRemTo(a, null, r);\n  if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);\n  return r;\n}\n\n// Modular reduction using \"classic\" algorithm\nfunction Classic(m) {\n  this.m = m;\n}\nfunction cConvert(x) {\n  if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);else return x;\n}\nfunction cRevert(x) {\n  return x;\n}\nfunction cReduce(x) {\n  x.divRemTo(this.m, null, x);\n}\nfunction cMulTo(x, y, r) {\n  x.multiplyTo(y, r);\n  this.reduce(r);\n}\nfunction cSqrTo(x, r) {\n  x.squareTo(r);\n  this.reduce(r);\n}\nClassic.prototype.convert = cConvert;\nClassic.prototype.revert = cRevert;\nClassic.prototype.reduce = cReduce;\nClassic.prototype.mulTo = cMulTo;\nClassic.prototype.sqrTo = cSqrTo;\n\n// (protected) return \"-1/this % 2^DB\"; useful for Mont. reduction\n// justification:\n//         xy == 1 (mod m)\n//         xy =  1+km\n//   xy(2-xy) = (1+km)(1-km)\n// x[y(2-xy)] = 1-k^2m^2\n// x[y(2-xy)] == 1 (mod m^2)\n// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2\n// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.\n// JS multiply \"overflows\" differently from C/C++, so care is needed here.\nfunction bnpInvDigit() {\n  if (this.t < 1) return 0;\n  var x = this[0];\n  if ((x & 1) == 0) return 0;\n  var y = x & 3; // y == 1/x mod 2^2\n  y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4\n  y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8\n  y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16\n  // last step - calculate inverse mod DV directly;\n  // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints\n  y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits\n  // we really want the negative inverse, and -DV < y < DV\n  return y > 0 ? this.DV - y : -y;\n}\n\n// Montgomery reduction\nfunction Montgomery(m) {\n  this.m = m;\n  this.mp = m.invDigit();\n  this.mpl = this.mp & 0x7fff;\n  this.mph = this.mp >> 15;\n  this.um = (1 << m.DB - 15) - 1;\n  this.mt2 = 2 * m.t;\n}\n\n// xR mod m\nfunction montConvert(x) {\n  var r = nbi();\n  x.abs().dlShiftTo(this.m.t, r);\n  r.divRemTo(this.m, null, r);\n  if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);\n  return r;\n}\n\n// x/R mod m\nfunction montRevert(x) {\n  var r = nbi();\n  x.copyTo(r);\n  this.reduce(r);\n  return r;\n}\n\n// x = x/R mod m (HAC 14.32)\nfunction montReduce(x) {\n  while (x.t <= this.mt2)\n  // pad x so am has enough room later\n  x[x.t++] = 0;\n  for (var i = 0; i < this.m.t; ++i) {\n    // faster way of calculating u0 = x[i]*mp mod DV\n    var j = x[i] & 0x7fff;\n    var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;\n    // use am to combine the multiply-shift-add into one call\n    j = i + this.m.t;\n    x[j] += this.m.am(0, u0, x, i, 0, this.m.t);\n    // propagate carry\n    while (x[j] >= x.DV) {\n      x[j] -= x.DV;\n      x[++j]++;\n    }\n  }\n  x.clamp();\n  x.drShiftTo(this.m.t, x);\n  if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);\n}\n\n// r = \"x^2/R mod m\"; x != r\nfunction montSqrTo(x, r) {\n  x.squareTo(r);\n  this.reduce(r);\n}\n\n// r = \"xy/R mod m\"; x,y != r\nfunction montMulTo(x, y, r) {\n  x.multiplyTo(y, r);\n  this.reduce(r);\n}\nMontgomery.prototype.convert = montConvert;\nMontgomery.prototype.revert = montRevert;\nMontgomery.prototype.reduce = montReduce;\nMontgomery.prototype.mulTo = montMulTo;\nMontgomery.prototype.sqrTo = montSqrTo;\n\n// (protected) true iff this is even\nfunction bnpIsEven() {\n  return (this.t > 0 ? this[0] & 1 : this.s) == 0;\n}\n\n// (protected) this^e, e < 2^32, doing sqr and mul with \"r\" (HAC 14.79)\nfunction bnpExp(e, z) {\n  if (e > 0xffffffff || e < 1) return BigInteger.ONE;\n  var r = nbi(),\n    r2 = nbi(),\n    g = z.convert(this),\n    i = nbits(e) - 1;\n  g.copyTo(r);\n  while (--i >= 0) {\n    z.sqrTo(r, r2);\n    if ((e & 1 << i) > 0) z.mulTo(r2, g, r);else {\n      var t = r;\n      r = r2;\n      r2 = t;\n    }\n  }\n  return z.revert(r);\n}\n\n// (public) this^e % m, 0 <= e < 2^32\nfunction bnModPowInt(e, m) {\n  var z;\n  if (e < 256 || m.isEven()) z = new Classic(m);else z = new Montgomery(m);\n  return this.exp(e, z);\n}\n\n// protected\nBigInteger.prototype.copyTo = bnpCopyTo;\nBigInteger.prototype.fromInt = bnpFromInt;\nBigInteger.prototype.fromString = bnpFromString;\nBigInteger.prototype.clamp = bnpClamp;\nBigInteger.prototype.dlShiftTo = bnpDLShiftTo;\nBigInteger.prototype.drShiftTo = bnpDRShiftTo;\nBigInteger.prototype.lShiftTo = bnpLShiftTo;\nBigInteger.prototype.rShiftTo = bnpRShiftTo;\nBigInteger.prototype.subTo = bnpSubTo;\nBigInteger.prototype.multiplyTo = bnpMultiplyTo;\nBigInteger.prototype.squareTo = bnpSquareTo;\nBigInteger.prototype.divRemTo = bnpDivRemTo;\nBigInteger.prototype.invDigit = bnpInvDigit;\nBigInteger.prototype.isEven = bnpIsEven;\nBigInteger.prototype.exp = bnpExp;\n\n// public\nBigInteger.prototype.toString = bnToString;\nBigInteger.prototype.negate = bnNegate;\nBigInteger.prototype.abs = bnAbs;\nBigInteger.prototype.compareTo = bnCompareTo;\nBigInteger.prototype.bitLength = bnBitLength;\nBigInteger.prototype.mod = bnMod;\nBigInteger.prototype.modPowInt = bnModPowInt;\n\n// \"constants\"\nBigInteger.ZERO = nbv(0);\nBigInteger.ONE = nbv(1);"

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports = "// Random number generator - requires a PRNG backend, e.g. prng4.js\n\n// For best results, put code like\n// <body onClick='rng_seed_time();' onKeyPress='rng_seed_time();'>\n// in your main HTML document.\n\nvar rng_state;\nvar rng_pool;\nvar rng_pptr;\nvar rng_psize = rng_psize ? rng_psize : 256;\n\n// Mix in a 32-bit integer into the pool\nfunction rng_seed_int(x) {\n  rng_pool[rng_pptr++] ^= x & 255;\n  rng_pool[rng_pptr++] ^= x >> 8 & 255;\n  rng_pool[rng_pptr++] ^= x >> 16 & 255;\n  rng_pool[rng_pptr++] ^= x >> 24 & 255;\n  if (rng_pptr >= rng_psize) rng_pptr -= rng_psize;\n}\n\n// Mix in the current time (w/milliseconds) into the pool\nfunction rng_seed_time() {\n  rng_seed_int(new Date().getTime());\n}\n\n// Initialize the pool with junk if needed.\nif (rng_pool == null) {\n  rng_pool = new Array();\n  rng_pptr = 0;\n  var t;\n  if (window.crypto && window.crypto.getRandomValues) {\n    // Use webcrypto if available\n    var ua = new Uint8Array(32);\n    window.crypto.getRandomValues(ua);\n    for (t = 0; t < 32; ++t) rng_pool[rng_pptr++] = ua[t];\n  }\n  if (navigator.appName == \"Netscape\" && navigator.appVersion < \"5\" && window.crypto) {\n    // Extract entropy (256 bits) from NS4 RNG if available\n    var z = window.crypto.random(32);\n    for (t = 0; t < z.length; ++t) rng_pool[rng_pptr++] = z.charCodeAt(t) & 255;\n  }\n  while (rng_pptr < rng_psize) {\n    // extract some randomness from Math.random()\n    t = Math.floor(65536 * Math.random());\n    rng_pool[rng_pptr++] = t >>> 8;\n    rng_pool[rng_pptr++] = t & 255;\n  }\n  rng_pptr = 0;\n  rng_seed_time();\n  //rng_seed_int(window.screenX);\n  //rng_seed_int(window.screenY);\n}\nfunction rng_get_byte() {\n  if (rng_state == null) {\n    rng_seed_time();\n    rng_state = prng_newstate();\n    rng_state.init(rng_pool);\n    for (rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr) rng_pool[rng_pptr] = 0;\n    rng_pptr = 0;\n    //rng_pool = null;\n  }\n  // TODO: allow reseeding after first request\n  return rng_state.next();\n}\nfunction rng_get_bytes(ba) {\n  var i;\n  for (i = 0; i < ba.length; ++i) ba[i] = rng_get_byte();\n}\nfunction SecureRandom() {}\nSecureRandom.prototype.nextBytes = rng_get_bytes;"

/***/ }),
/* 990 */
/***/ (function(module, exports) {

module.exports = "// Depends on jsbn.js and rng.js\n\n// Version 1.1: support utf-8 encoding in pkcs1pad2\n\n// convert a (hex) string to a bignum object\nfunction parseBigInt(str, r) {\n  return new BigInteger(str, r);\n}\nfunction linebrk(s, n) {\n  var ret = \"\";\n  var i = 0;\n  while (i + n < s.length) {\n    ret += s.substring(i, i + n) + \"\\n\";\n    i += n;\n  }\n  return ret + s.substring(i, s.length);\n}\nfunction byte2Hex(b) {\n  if (b < 0x10) return \"0\" + b.toString(16);else return b.toString(16);\n}\n\n// PKCS#1 (type 2, random) pad input string s to n bytes, and return a bigint\nfunction pkcs1pad2(s, n) {\n  if (n < s.length + 11) {\n    // TODO: fix for utf-8\n    alert(\"Message too long for RSA\");\n    return null;\n  }\n  var ba = new Array();\n  var i = s.length - 1;\n  while (i >= 0 && n > 0) {\n    var c = s.charCodeAt(i--);\n    if (c < 128) {\n      // encode using utf-8\n      ba[--n] = c;\n    } else if (c > 127 && c < 2048) {\n      ba[--n] = c & 63 | 128;\n      ba[--n] = c >> 6 | 192;\n    } else {\n      ba[--n] = c & 63 | 128;\n      ba[--n] = c >> 6 & 63 | 128;\n      ba[--n] = c >> 12 | 224;\n    }\n  }\n  ba[--n] = 0;\n  var rng = new SecureRandom();\n  var x = new Array();\n  while (n > 2) {\n    // random non-zero pad\n    x[0] = 0;\n    while (x[0] == 0) rng.nextBytes(x);\n    ba[--n] = x[0];\n  }\n  ba[--n] = 2;\n  ba[--n] = 0;\n  return new BigInteger(ba);\n}\n\n// \"empty\" RSA key constructor\nfunction RSAKey() {\n  this.n = null;\n  this.e = 0;\n  this.d = null;\n  this.p = null;\n  this.q = null;\n  this.dmp1 = null;\n  this.dmq1 = null;\n  this.coeff = null;\n}\n\n// Set the public key fields N and e from hex strings\nfunction RSASetPublic(N, E) {\n  if (N != null && E != null && N.length > 0 && E.length > 0) {\n    this.n = parseBigInt(N, 16);\n    this.e = parseInt(E, 16);\n  } else alert(\"Invalid RSA public key\");\n}\n\n// Perform raw public operation on \"x\": return x^e (mod n)\nfunction RSADoPublic(x) {\n  return x.modPowInt(this.e, this.n);\n}\n\n// Return the PKCS#1 RSA encryption of \"text\" as an even-length hex string\nfunction RSAEncrypt(text) {\n  var m = pkcs1pad2(text, this.n.bitLength() + 7 >> 3);\n  if (m == null) return null;\n  var c = this.doPublic(m);\n  if (c == null) return null;\n  var h = c.toString(16);\n  if ((h.length & 1) == 0) return h;else return \"0\" + h;\n}\n\n// Return the PKCS#1 RSA encryption of \"text\" as a Base64-encoded string\n//function RSAEncryptB64(text) {\n//  var h = this.encrypt(text);\n//  if(h) return hex2b64(h); else return null;\n//}\n\n// protected\nRSAKey.prototype.doPublic = RSADoPublic;\n\n// public\nRSAKey.prototype.setPublic = RSASetPublic;\nRSAKey.prototype.encrypt = RSAEncrypt;\n//RSAKey.prototype.encrypt_b64 = RSAEncryptB64;"

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(24)(__webpack_require__(992))

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports = "function _typeof(o) { \"@babel/helpers - typeof\"; return _typeof = \"function\" == typeof Symbol && \"symbol\" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && \"function\" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? \"symbol\" : typeof o; }, _typeof(o); }\n/**\n * angular-ui-notification - Angular.js service providing simple notifications using Bootstrap 3 styles with css transitions for animating\n * @author Alex_Crack\n * @version v0.3.6\n * @link https://github.com/alexcrack/angular-ui-notification\n * @license MIT\n */\nangular.module('ui-notification', []);\nangular.module('ui-notification').provider('Notification', function () {\n  this.options = {\n    delay: 5000,\n    startTop: 10,\n    startRight: 10,\n    verticalSpacing: 10,\n    horizontalSpacing: 10,\n    positionX: 'right',\n    positionY: 'top',\n    replaceMessage: false,\n    templateUrl: 'angular-ui-notification.html',\n    onClose: undefined,\n    closeOnClick: true,\n    maxCount: 0,\n    // 0 - Infinite\n    container: 'body',\n    priority: 10\n  };\n  this.setOptions = function (options) {\n    if (!angular.isObject(options)) throw new Error(\"Options should be an object!\");\n    this.options = angular.extend({}, this.options, options);\n  };\n  this.$get = [\"$timeout\", \"$http\", \"$compile\", \"$templateCache\", \"$rootScope\", \"$injector\", \"$sce\", \"$q\", \"$window\", function ($timeout, $http, $compile, $templateCache, $rootScope, $injector, $sce, $q, $window) {\n    var options = this.options;\n    var startRight = options.startRight;\n    var verticalSpacing = options.verticalSpacing;\n    var horizontalSpacing = options.horizontalSpacing;\n    var delay = options.delay;\n    var messageElements = [];\n    var isResizeBound = false;\n    var notify = function notify(args, t) {\n      var deferred = $q.defer();\n      if (_typeof(args) !== 'object' || args === null) {\n        args = {\n          message: args\n        };\n      }\n      args.scope = args.scope ? args.scope : $rootScope;\n      args.template = args.templateUrl ? args.templateUrl : options.templateUrl;\n      args.delay = !angular.isUndefined(args.delay) ? args.delay : delay;\n      args.type = t || args.type || options.type || '';\n      args.startTop = args.startTop ? args.startTop : options.startTop;\n      args.positionY = args.positionY ? args.positionY : options.positionY;\n      args.positionX = args.positionX ? args.positionX : options.positionX;\n      args.replaceMessage = args.replaceMessage ? args.replaceMessage : options.replaceMessage;\n      args.onClose = args.onClose ? args.onClose : options.onClose;\n      args.closeOnClick = args.closeOnClick !== null && args.closeOnClick !== undefined ? args.closeOnClick : options.closeOnClick;\n      args.container = args.container ? args.container : options.container;\n      args.priority = args.priority ? args.priority : options.priority;\n      var template = $templateCache.get(args.template);\n      if (template) {\n        processNotificationTemplate(template);\n      } else {\n        // load it via $http only if it isn't default template and template isn't exist in template cache\n        // cache:true means cache it for later access.\n        $http.get(args.template, {\n          cache: true\n        }).then(function (response) {\n          processNotificationTemplate(response.data);\n        }).catch(function (data) {\n          throw new Error('Template (' + args.template + ') could not be loaded. ' + data);\n        });\n      }\n      function processNotificationTemplate(template) {\n        var scope = args.scope.$new();\n        scope.message = $sce.trustAsHtml(args.message);\n        scope.title = $sce.trustAsHtml(args.title);\n        scope.t = args.type.substr(0, 1);\n        scope.delay = args.delay;\n        scope.onClose = args.onClose;\n        var priorityCompareTop = function priorityCompareTop(a, b) {\n          return a._priority - b._priority;\n        };\n        var priorityCompareBtm = function priorityCompareBtm(a, b) {\n          return b._priority - a._priority;\n        };\n        var reposite = function reposite() {\n          var j = 0;\n          var k = 0;\n          var lastTop = args.startTop;\n          var lastRight = startRight;\n          var lastPosition = [];\n          if (args.positionY === 'top') {\n            messageElements.sort(priorityCompareTop);\n          } else if (args.positionY === 'bottom') {\n            messageElements.sort(priorityCompareBtm);\n          }\n          for (var i = messageElements.length - 1; i >= 0; i--) {\n            var element = messageElements[i];\n            if (args.replaceMessage && i < messageElements.length - 1) {\n              element.addClass('killed');\n              continue;\n            }\n            var elHeight = parseInt(element[0].offsetHeight);\n            var elWidth = parseInt(element[0].offsetWidth);\n            var position = lastPosition[element._positionY + element._positionX];\n            if (top + elHeight > window.innerHeight) {\n              position = args.startTop;\n              k++;\n              j = 0;\n            }\n            var top = lastTop = position ? j === 0 ? position : position + verticalSpacing : args.startTop;\n            var right = lastRight + k * (horizontalSpacing + elWidth);\n            element.css(element._positionY, top + 'px');\n            if (element._positionX == 'center') {\n              element.css('left', parseInt(window.innerWidth / 2 - elWidth / 2) + 'px');\n            } else {\n              element.css(element._positionX, right + 'px');\n            }\n            lastPosition[element._positionY + element._positionX] = top + elHeight;\n            if (options.maxCount > 0 && messageElements.length > options.maxCount && i === 0) {\n              element.scope().kill(true);\n            }\n            j++;\n          }\n        };\n        var templateElement = $compile(template)(scope);\n        templateElement._positionY = args.positionY;\n        templateElement._positionX = args.positionX;\n        templateElement._priority = args.priority;\n        templateElement.addClass(args.type);\n        var closeEvent = function closeEvent(e) {\n          e = e.originalEvent || e;\n          if (e.type === 'click' || e.propertyName === 'opacity' && e.elapsedTime >= 1) {\n            if (scope.onClose) {\n              scope.$apply(scope.onClose(templateElement));\n            }\n            templateElement.remove();\n            messageElements.splice(messageElements.indexOf(templateElement), 1);\n            scope.$destroy();\n            reposite();\n          }\n        };\n        if (args.closeOnClick) {\n          templateElement.addClass('clickable');\n          templateElement.bind('click', closeEvent);\n        }\n        templateElement.bind('webkitTransitionEnd oTransitionEnd otransitionend transitionend msTransitionEnd', closeEvent);\n        if (angular.isNumber(args.delay)) {\n          scope.timer = $timeout(function () {\n            templateElement.addClass('killed');\n          }, args.delay);\n        }\n        setCssTransitions('none');\n        angular.element(document.querySelector(args.container)).append(templateElement);\n        var offset = -(parseInt(templateElement[0].offsetHeight) + 50);\n        templateElement.css(templateElement._positionY, offset + \"px\");\n        messageElements.push(templateElement);\n        if (args.positionX == 'center') {\n          var elWidth = parseInt(templateElement[0].offsetWidth);\n          templateElement.css('left', parseInt(window.innerWidth / 2 - elWidth / 2) + 'px');\n        }\n        $timeout(function () {\n          setCssTransitions('');\n        });\n        function setCssTransitions(value) {\n          ['-webkit-transition', '-o-transition', 'transition'].forEach(function (prefix) {\n            templateElement.css(prefix, value);\n          });\n        }\n        scope._templateElement = templateElement;\n        scope.kill = function (isHard) {\n          if (isHard) {\n            if (scope.onClose) {\n              scope.$apply(scope.onClose(scope._templateElement));\n            }\n            messageElements.splice(messageElements.indexOf(scope._templateElement), 1);\n            scope._templateElement.remove();\n            scope.$destroy();\n            $timeout(reposite);\n          } else {\n            scope._templateElement.addClass('killed');\n          }\n        };\n        scope.dieHard = function () {\n          if (scope.onClose) {\n            scope.$apply(scope.onClose(scope._templateElement));\n          }\n          messageElements.splice(messageElements.indexOf(scope._templateElement), 1);\n          scope._templateElement.remove();\n          scope.$destroy();\n          reposite();\n        };\n        scope.clearTimer = function () {\n          $timeout.cancel(scope.timer);\n        };\n        scope.startTimer = function () {\n          $timeout(function () {\n            templateElement.addClass('killed');\n          }, args.delay);\n        };\n        $timeout(reposite);\n        if (!isResizeBound) {\n          angular.element($window).bind('resize', function (e) {\n            $timeout(reposite);\n          });\n          isResizeBound = true;\n        }\n        deferred.resolve(scope);\n      }\n      return deferred.promise;\n    };\n    notify.primary = function (args) {\n      return this(args, 'primary');\n    };\n    notify.error = function (args) {\n      return this(args, 'error');\n    };\n    notify.success = function (args) {\n      return this(args, 'success');\n    };\n    notify.info = function (args) {\n      return this(args, 'info');\n    };\n    notify.warning = function (args) {\n      return this(args, 'warning');\n    };\n    notify.clearAll = function () {\n      angular.forEach(messageElements, function (element) {\n        element.addClass('killed');\n      });\n    };\n    return notify;\n  }];\n});\nangular.module(\"ui-notification\").run([\"$templateCache\", function ($templateCache) {\n  $templateCache.put(\"angular-ui-notification.html\", \"<div class=\\\"ui-notification\\\"><h3 ng-show=\\\"title\\\" ng-bind-html=\\\"title\\\"></h3><div class=\\\"message\\\" ng-bind-html=\\\"message\\\"></div></div>\");\n}]);"

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var CoreMediator = function CoreMediator($rootScope, $state, $cookies, $q, $injector, $uibModalStack, $window, revisionRepository, loginRepository, loadUserDetailsRepository, alertHandler, loadProfileImageRepository, userProfileRepository, currentUserModel, notificationPreferenceRepository, coreConstant, uiPerformanceLogRepository, sendEmailNotificationRepository, loginTokenRepository, peoplePickerRepository, preferenceModel, forgotPasswordRepository, repeatingFormDynamicDataSetFormSetIdRepository, clientIdRepository, userImageRepository, deleteUserImageRepository, currentUserProfileRepository, updateUserProfileRepository, updateUserPreferencesRepository, defaultPreferencesRepository, userPreferencesRepository, configuredFileRepository, configuredFileDataRepository, notificationRepository, registrationRepository, chatRoomRepository, umRevisionRepository, appTypeConfigurationModel, refreshLoginTokenUtil, cachedDataSetsRepository, dataSetRepository, serverAckRepository, temporaryLoginTokenRepository, organizationRepository) {
  var _persistentConnection;
  var self = this;
  var userDetailDefer;
  var dataSetNameToTypeMap;
  function getPersistentConnection() {
    if (!_persistentConnection) {
      _persistentConnection = $injector.get('persistentConnection');
    }
    return _persistentConnection;
  }
  function loadUserDetails() {
    if (userDetailDefer) {
      return userDetailDefer.promise;
    } else {
      userDetailDefer = $q.defer();
    }
    function handleSuccess(userProfile) {
      currentUserModel.setCurrentUser(userProfile);
      self.loadUserPreferences().then(function () {
        userDetailDefer.resolve();
        userDetailDefer = null;
      });
    }
    function handleError() {
      userDetailDefer.reject();
      userDetailDefer = null;
    }
    loadUserDetailsRepository.loadUserDetails().then(handleSuccess, handleError);
    return userDetailDefer.promise;
  }
  this.refreshUserDetails = function () {
    loadUserDetailsRepository.clearCache();
    return loadUserDetailsRepository.loadUserDetails().then(function (userProfile) {
      currentUserModel.setCurrentUser(userProfile);
    });
  };
  this.bootstrapApplication = function () {
    var defer = $q.defer();
    getPersistentConnection().connect().then(function () {
      this.loadDefaultPreferences().then(function () {
        this.fetchApplicationData().then(function () {
          $rootScope.$broadcast(coreConstant.event.KEEPALIVE_PING);
          $rootScope.$broadcast(coreConstant.event.APPLICATION_READY);
          $rootScope.$broadcast(coreConstant.event.START_IDLE);
          defer.resolve();
        });
      }.bind(this));
    }.bind(this));
    return defer.promise;
  };
  this.getRevision = function () {
    return revisionRepository.getRevision();
  };
  this.getUmVersionNumber = function () {
    return umRevisionRepository.getUmVersionNumber();
  };
  this.login = function (username, password, timeoutSeconds, passwordIsToken, isExternalToken) {
    var deferred = $q.defer();
    function handleSuccess(loginToken) {
      function handleRefreshLoginTokenSuccess() {
        function handleUserDetailsSuccess() {
          deferred.resolve();
        }
        function handleUserDetailsError() {
          deferred.reject();
        }
        loadUserDetails().then(handleUserDetailsSuccess, handleUserDetailsError);
      }
      function handleRefreshLoginTokenError() {
        deferred.reject();
      }
      refreshLoginTokenUtil.start(loginToken).then(handleRefreshLoginTokenSuccess, handleRefreshLoginTokenError);
    }
    function handleLoginError(error) {
      deferred.reject(error);
    }
    loginRepository.login(username, password, timeoutSeconds, passwordIsToken, isExternalToken).then(handleSuccess, handleLoginError);
    return deferred.promise;
  };
  this.disconnect = function (isAutoLogout) {
    var deferred = $q.defer();
    getPersistentConnection().disconnect().finally(function () {
      deferred.resolve();
    });
    return deferred.promise;
  };
  this.logout = function (isAutoLogout) {
    var logoutUrl = this.getLogoutUrl(isAutoLogout);
    var deferred = $q.defer();
    $uibModalStack.dismissAll();
    alertHandler.clearRegisteredChannels();
    loginRepository.logout().then(function () {
      self.disconnect().finally(function () {
        currentUserModel.reset();
        self.removeLoginToken();
        self.removeClientId();
        loadUserDetailsRepository.clearCache();
        defaultPreferencesRepository.clearCache();
        preferenceModel.reset();
        $rootScope.$broadcast(coreConstant.event.STOP_KEEPALIVE_PING);
        refreshLoginTokenUtil.stop();
        $rootScope.$broadcast(coreConstant.event.STOP_IDLE);
        if (!_.isEmpty(logoutUrl) && !_.isEmpty(logoutUrl.trim())) {
          $window.open(logoutUrl, '_self');
        } else {
          $state.go('login');
        }
        $rootScope.$broadcast(coreConstant.event.LOGOUT_COMPLETE);
        deferred.resolve();
      });
    }, function (error) {
      deferred.reject(error);
    });
    return deferred.promise;
  };
  this.fetchApplicationData = function () {
    return loadUserDetails().then(function () {
      return this.buildDataSetNameToTypeMap();
    }.bind(this));
  };

  // this will go away when we remove data fetcher -rc
  this.loadUserProfile = function () {
    return loadUserDetailsRepository.loadUserDetails();
  };
  this.loadProfileImage = function (userId) {
    return loadProfileImageRepository.loadProfileImage(userId);
  };
  this.loadUser = function () {
    return currentUserProfileRepository.loadUser();
  };
  this.loadUserById = function (id, submissionId, notificationId, chatMessageId, emailMessageId) {
    return userProfileRepository.loadUserById(id, submissionId, notificationId, chatMessageId, emailMessageId);
  };
  this.loadOrganizationById = function (organizationId) {
    return organizationRepository.loadOrganizationById(organizationId);
  };
  this.updateUser = function (data) {
    return updateUserProfileRepository.updateUser(data);
  };
  this.updateUserImage = function (file, imageWidth, imageHeight) {
    return userImageRepository.updateUserImage(file, imageWidth, imageHeight);
  };
  this.deleteUserImage = function () {
    return deleteUserImageRepository.deleteUserImage();
  };
  this.loadUsersList = function (submissionId) {
    return peoplePickerRepository.loadUsersList(submissionId);
  };
  this.getChatNotificationRecipients = function (submissionId) {
    return chatRoomRepository.getChatNotificationRecipients(submissionId);
  };
  this.loadDefaultPreferences = function () {
    return defaultPreferencesRepository.loadDefaultPreferences();
  };
  this.loadUserPreferences = function () {
    return userPreferencesRepository.loadUserPreferences();
  };
  this.getCachedDataSetByName = function (dataSetName) {
    return cachedDataSetsRepository.getDataSet(dataSetName);
  };
  this.getRemoteDataSetByName = function (dataSetName) {
    return dataSetRepository.getDataSet(dataSetName);
  };
  this.buildDataSetNameToTypeMap = function () {
    dataSetNameToTypeMap = {};
    return dataSetRepository.getDataSetNameToTypeMap().then(function (map) {
      dataSetNameToTypeMap = map;
    });
  };
  this.getDataSetNameToTypeMap = function () {
    return dataSetNameToTypeMap;
  };
  this.getDynamicDataSet = function (params, registrationId, isNotFormRelated) {
    return dataSetRepository.getDynamicDataSet(params, registrationId, isNotFormRelated);
  };
  this.getDynamicDataSetItems = function (params, registrationId, isNotFormRelated) {
    return dataSetRepository.getDynamicDataSetItems(params, registrationId, isNotFormRelated);
  };
  this.unregisterDynamicDataset = function (params, registrationId) {
    return dataSetRepository.unregisterDynamicDataset(params, registrationId);
  };
  this.getRepeatingFormDynamicDataSetFormSetId = function (formId, dynamicDataSetName) {
    return repeatingFormDynamicDataSetFormSetIdRepository.getOwningFormSetId(formId, dynamicDataSetName);
  };
  this.getNotificationPopupTemplate = function (name, context) {
    return notificationPreferenceRepository.getNotificationPopupTemplate(name, context);
  };
  this.getNotificationEmailTemplate = function (name, context) {
    return notificationPreferenceRepository.getNotificationEmailTemplate(name, context);
  };
  this.updateUserPreferences = function (key, value) {
    var data = {};
    data[key] = value;
    return updateUserPreferencesRepository.updateUserPreferences(data).then(function () {
      preferenceModel.set(key, value);
    });
  };
  this.getPreferenceByName = function (name) {
    return preferenceModel.get(name);
  };
  this.createUiPerformanceLog = function (log) {
    return uiPerformanceLogRepository.createUiPerformanceLog(log);
  };
  this.sendEmailNotification = function (notificationName, isCustom, submissionId, options) {
    return sendEmailNotificationRepository.sendEmailNotification(notificationName, isCustom, submissionId, options);
  };
  this.getLoginToken = function () {
    return loginTokenRepository.getLoginToken();
  };
  this.getLoginTokenAuthorizationHeader = function () {
    return loginTokenRepository.getLoginTokenAuthorizationHeader();
  };
  this.getSingleUseToken = function () {
    return temporaryLoginTokenRepository.getSingleUseToken();
  };
  this.setLoginToken = function (loginToken) {
    loginTokenRepository.setLoginToken(loginToken);
  };
  this.removeLoginToken = function () {
    loginTokenRepository.removeLoginToken();
  };
  this.getClientId = function () {
    return clientIdRepository.getClientId();
  };
  this.setClientId = function (clientId) {
    clientIdRepository.setClientId(clientId);
  };
  this.removeClientId = function () {
    clientIdRepository.removeClientId();
  };
  this.forgotPassword = function (username, emailAddress) {
    return forgotPasswordRepository.forgotPassword(username, emailAddress);
  };
  this.isUserLoggedIn = function () {
    return !_.isNil(currentUserModel.getCurrentUser());
  };
  this.getConfiguredFile = function (name) {
    return configuredFileRepository.find(name);
  };
  this.getConfiguredFileData = function (id) {
    return configuredFileDataRepository.getData(id);
  };
  this.findByNotifiedUserId = function (userId, type, startingIndex, numberOfRows, latest, unreadOnly) {
    return notificationRepository.findByNotifiedUserId(userId, type, startingIndex, numberOfRows, latest, unreadOnly);
  };
  this.acknowledgeByNotificationId = function (notificationId) {
    return notificationRepository.acknowledgeByNotificationId(notificationId);
  };
  this.acknowledgeByUserId = function (userId, type) {
    return notificationRepository.acknowledgeByUserId(userId, type);
  };
  this.countUnacknowledgedByUserId = function (userId, type, latest) {
    return notificationRepository.countUnacknowledgedByUserId(userId, type, latest);
  };
  this.markAsReadByNotificationId = function (notificationId, isRead) {
    return notificationRepository.markAsReadByNotificationId(notificationId, isRead);
  };
  this.markAllAsReadByUserId = function (userId, type) {
    return notificationRepository.markAllAsReadByUserId(userId, type);
  };
  this.countUnreadByUserId = function (userId, type, latest) {
    return notificationRepository.countUnreadByUserId(userId, type, latest);
  };
  this.resetUserRegistrations = function () {
    var promises = [];
    _.each(currentUserModel.getRegistrations(), function (url) {
      promises.push(registrationRepository.deleteRegistration(url));
    });
    currentUserModel.clearRegistrations();
    return $q.all(promises);
  };
  this.resetUserNotificationRegistrations = function (type) {
    var promises = [];
    _.each(currentUserModel.getNotificationRegistrations(type), function (url) {
      promises.push(registrationRepository.deleteRegistration(url));
    });
    currentUserModel.clearNotificationRegistrations(type);
    return $q.all(promises);
  };
  this.setChatVisibility = function (isVisible) {
    return chatRoomRepository.setChatVisibility(isVisible);
  };
  this.enterChat = function (submissionId) {
    return chatRoomRepository.enter(submissionId);
  };
  this.leaveChat = function (submissionId) {
    return chatRoomRepository.leave(submissionId);
  };
  this.ack = function () {
    return serverAckRepository.ack();
  };
  this.getLogoutUrl = function (isAutoLogout) {
    var logoutUrl;
    if (!isAutoLogout) {
      if (appTypeConfigurationModel.isUnderwriterWorkstation() && !_.isEmpty(preferenceModel.get('system.urlUW'))) {
        logoutUrl = preferenceModel.get('system.urlUW');
      } else if (appTypeConfigurationModel.isAgentConsole() && !_.isEmpty(preferenceModel.get('system.urlAgent'))) {
        logoutUrl = preferenceModel.get('system.urlAgent');
      } else if (appTypeConfigurationModel.isAdminWorkstation() && !_.isEmpty(preferenceModel.get('system.urlAdmin'))) {
        logoutUrl = preferenceModel.get('system.urlAdmin');
      }
    } else {
      if (appTypeConfigurationModel.isUnderwriterWorkstation() && !_.isEmpty(preferenceModel.get('system.urlDisconnectedUW'))) {
        logoutUrl = preferenceModel.get('system.urlDisconnectedUW');
      } else if (appTypeConfigurationModel.isAgentConsole() && !_.isEmpty(preferenceModel.get('system.urlDisconnectedAgent'))) {
        logoutUrl = preferenceModel.get('system.urlDisconnectedAgent');
      } else if (appTypeConfigurationModel.isAdminWorkstation() && !_.isEmpty(preferenceModel.get('system.urlDisconnectedAdmin'))) {
        logoutUrl = preferenceModel.get('system.urlDisconnectedAdmin');
      }
    }
    return logoutUrl;
  };
};
CoreMediator.$inject = ["$rootScope", "$state", "$cookies", "$q", "$injector", "$uibModalStack", "$window", "revisionRepository", "loginRepository", "loadUserDetailsRepository", "alertHandler", "loadProfileImageRepository", "userProfileRepository", "currentUserModel", "notificationPreferenceRepository", "coreConstant", "uiPerformanceLogRepository", "sendEmailNotificationRepository", "loginTokenRepository", "peoplePickerRepository", "preferenceModel", "forgotPasswordRepository", "repeatingFormDynamicDataSetFormSetIdRepository", "clientIdRepository", "userImageRepository", "deleteUserImageRepository", "currentUserProfileRepository", "updateUserProfileRepository", "updateUserPreferencesRepository", "defaultPreferencesRepository", "userPreferencesRepository", "configuredFileRepository", "configuredFileDataRepository", "notificationRepository", "registrationRepository", "chatRoomRepository", "umRevisionRepository", "appTypeConfigurationModel", "refreshLoginTokenUtil", "cachedDataSetsRepository", "dataSetRepository", "serverAckRepository", "temporaryLoginTokenRepository", "organizationRepository"];
angular.module('umCore').service('coreMediator', CoreMediator);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

var CoreConstant = angular.module('umCore').constant('coreConstant', {
  event: {
    BOOT_APPLICATION: 'coreModule.bootApplication',
    ADVANCE_FOCUS: 'coreModule.advanceFocus',
    INVALID_SESSION: 'coreModule.invalidSession',
    RECENT_ACTIVITIES_CHANGED: 'coreModule.recentActivitiesChanged',
    DATAGRID_ON_STARTUP_COMPLETE: 'ums:datagrid:onStartupComplete',
    DATAGRID_ON_RESET_HEADERS: 'ums:datagrid:onResetHeaders',
    KEEPALIVE_PING: 'ums:keepalive:ping',
    STOP_KEEPALIVE_PING: 'ums:stop:keepalive:ping',
    HANDLE_ERROR: 'Notification.handleError',
    SHOW_MODAL_NOTIFICATION: 'Notification.showModalNotification',
    SHOW_FADING_NOTIFICATION: 'Notification.showFadingNotification',
    SHOW_FADING_NOTIFICATION_LOADING_BAR: 'Notification.showFadingNotificationLoadingBar',
    CONCLUDE_FADING_NOTIFICATION_LOADING_BAR: 'Notification.concludeFadingNotificationLoadingBar',
    SHOW_EMAIL_MODAL_NOTIFICATION: 'Notification.showEmailModalNotification',
    HANDLE_EMAIL_FROM_BUSINESS_CARD: 'Notification.showEmailFromBusinessCard',
    SHOW_EMAIL_EDITOR: 'Notification.showEmailEditor',
    SHOW_ERROR: 'Notification.showError',
    CONFIRM_ACTION_YES: 'Confirm.actionConfirmYes',
    CONFIRM_ACTION_NO: 'Confirm.actionConfirmNo',
    UPDATE_SUBMISSION: 'PersistentConnection.UpdateSubmission',
    UPDATE_NAVIGATION_ITEM_MESSAGE: 'PersistentConnection.UpdateNavigationItem',
    SHOW_LONG_REQUEST_WARNING: 'PersistentConnection.ShowLongRequestWarning',
    HIDE_LONG_REQUEST_WARNING: 'PersistentConnection.HideLongRequestWarning',
    REFRESH_QUOTE: 'PersistentConnection.RefreshQuote',
    REFRESH_POLICY_CHANGE: 'PersistentConnection.RefreshPolicyChange',
    QUOTE_DELETED: 'Submission.QuoteDeleted',
    REFRESH_PROPOSAL: 'PersistentConnection.RefreshProposal',
    PROPOSAL_DELETED: 'PersistentConnection.ProposalDeleted',
    REFRESH_RECENT_SUBMISSION_DROPDOWN: 'Submission.RefreshRecentSubmissionDropdown',
    CLOSE_SUBMISSION_VIEW: 'Submission.CloseSubmissionView',
    ACORD_UPLOAD_NOTIFICATION: 'AcordUploadNotification',
    PREFERENCES_READY: 'coreModule.PreferenceReady',
    USERTYPE_UPDATED: 'coreModule.UsertypeUpdated',
    START_UI_PERFORMANCE_LOG: 'coreModule.StartUiPerformanceLog',
    END_UI_PERFORMANCE_LOG: 'coreModule.EndUiPerformanceLog',
    END_UI_PERFORMANCE_LOG_WITHOUT_LOGGING: 'coreModule.EndUiPerformanceLogWithoutLogging',
    LOAD_SUBMISSION_LIST: 'coreModule.LoadSubmissionList',
    START_IDLE: 'coreModule.startIdle',
    STOP_IDLE: 'coreModule.stopIdle',
    LOGOUT_COMPLETE: 'coreModule.logoutComplete',
    FILE_DROPPED: 'coreModule.fileDropped',
    MODAL_OPENED: 'coreModule.modalOpen',
    MODAL_CLOSED: 'coreModule.modalClosed',
    MODAL_CLOSING: 'modal.closing',
    REFERESH_USER_NAME: 'refereshUserName',
    START_MAKING_APPLICATION: 'coreModule.StartMakingApplication',
    SHOW_USER_BUSINESS_CARD: 'showBusinessCard',
    HIDE_BUSINESS_CARD: 'hideBusinessCard',
    SHOW_ORGANIZATION_CARD: 'showOrganizationCard',
    HIDE_BUSINESS_CARD_ON_DROPDOWN: 'hideBusinessCardOnDropdown',
    PEOPLE_PICKER_USER_SELECTED: 'peoplePickerUserSelected',
    SHOW_LOADING_BAR: 'coreModule.showLoadingBar',
    HIDE_LOADING_BAR: 'coreModule.hideLoadingBar',
    HIDE_FADING_NOTIFICATION_LOADING_BAR: 'coreModule.hideFadingNotificationLoadingBar',
    EXPIRED_PASSWORD: 'coreModule.expiredPassword',
    NAVIGATION_DRAWER_TOGGLED: 'UiDrawerSlideDirective.DoneAnimating',
    APPLICATION_READY: 'coreModule.applicationReady',
    FILTER_SAVED: 'coreModule.filterSaved',
    FILTER_UPDATED: 'coreModule.filterUpdated',
    FILTER_CLEARED: 'coreModule.filterCleared',
    USER_AVATAR_RELOAD: 'userAvatarReload',
    UPDATE_SESSION_COUNTDOWN_MESSAGE: 'SessionTimeout.UPDATE_SESSION_COUNTDOWN_MESSAGE',
    SUBMISSION_FILTER_CHANGED: 'coreModule.submissionFilterChanged',
    FILTER_CHANGED: 'coreModule.filterChanged',
    GRID_SORT_TYPE_CHANGED: 'coreModule.gridSortTypeChanged',
    CREATE_NOTIFICATION: 'coreModule.notification.create',
    UPDATE_NOTIFICATION: 'coreModule.notification.update',
    CREATE_APP_NOTIFICATION: 'coreModule.notification.app.create',
    UPDATE_DATA_SET: 'coreModule.UpdateDataSet',
    SCROLL_TO_ITEM: 'Submission.ScrollToItem',
    SCROLL_TO_BOTTOM: 'Submission.ScrollToBottom',
    UPDATE_ACTIONS_MESSAGE: 'coreModule.UpdateActionsMessage',
    CHAT_VISIBILITY_CHANGED: 'coreModule.ChatVisibilityChanged',
    RESET_GRID_PAGING: 'coreModule.resetGridPaging',
    RECALCULATE_GRID_PAGING: 'coreModule.recalculateGridPaging',
    MULTI_SELECT_CLOSED: 'coreModule.MultiSelectClosed',
    MULTI_SELECT_UPDATED: 'coreModule.MultiSelectUpdated',
    MULTI_SELECT_FILTER_CHANGED: 'coreModule.MultiSelectFilterChanged',
    MULTI_SELECT_LIST_UPDATED: 'coreModule.MultiSelectListUpdated',
    SHOW_MULTI_SELECT_LIST_UPDATED: 'coreModule.ShowMultiSelectListUpdated',
    REFRESH_MULTI_SELECT: 'coreModule.RefreshMultiSelect',
    MULTI_SELECT_BUTTON_LABEL_UPDATED: 'coreModule.MultiSelectButtonLabelUpdated',
    RELOAD_CLASS_CODE_MULTI_SELECT: 'coreModule.ReloadClassCodeMultiSelect',
    MULTI_SELECT_CLEAR: 'coreModule.MultiSelectClear',
    SHOW_MULTI_SELECT: 'coreModule.ShowMultiSelect',
    HIDE_MULTI_SELECT: 'coreModule.HideMultiSelect',
    CREATE_USER: 'coreModule.createUser',
    UPDATE_USER: 'coreModule.updateUser',
    DELETE_USER: 'coreModule.deleteUser',
    RELOAD_USER: 'coreModule.reloadUser',
    CREATE_ORGANIZATION: 'coreModule.CreateOrganization',
    UPDATE_ORGANIZATION: 'coreModule.UpdateOrganization',
    DELETE_ORGANIZATION: 'coreModule.DeleteOrganization',
    ACCORDION_BUTTON_OPENED: 'coreModule.accordionButtonOpened',
    CLOSE_ACCORDION_BUTTON: 'coreModule.closeAccordionButton',
    OPEN_ACCORDION_BUTTON: 'coreModule.openAccordionButton',
    COLLAPSIBLE_LEFT_NAV_OPENED: 'coreModule.collapsibleLeftNavOpened',
    COLLAPSIBLE_LEFT_NAV_CLOSED: 'coreModule.collapsibleLeftNavClosed',
    SHOW_FORM_TOOLTIP: 'submission.showFormTooltip',
    HIDE_FORM_TOOLTIP: 'submission.hideFormTooltip',
    ACTION_BUTTONS_PROCESSING_COMPLETED: 'coreModule.ActionButtonsProcessingCompleted',
    FILE_UPLOADED: 'coreModule.fileUploaded',
    ACTION_STARTED: 'coreModule.ActionStarted',
    RELOAD_ACTIONS: 'coreModule.ReloadActions',
    CLOSE_EMAIL_POPUP: 'coreModule.closeEmailPopUp',
    ATTACHMENT_UPDATED: 'coreModule.attachmentUpdated',
    USER_GROUP_UPDATED: 'coreModule.userGroupUpdated',
    USER_GROUP_EDITOR_MODEL_UPDATED: 'coreModule.userGroupEditorModelUpdated',
    REFRESH_DATE_RANGE: 'coreModule.refreshDateRange',
    SHOW_TRANSACTION_TOOLTIP_EVENT: 'showTransactionTooltipEvent',
    HIDE_TRANSACTION_TOOLTIP_EVENT: 'hideTransactionTooltipEvent',
    SHOW_CUSTOM_ALERT_MODAL_NOTIFICATION: 'Notification.showCustomAlertModalNotification',
    widget: {
      DRAG_START: 'coreModule.widgetDragStart',
      DRAG_STOP: 'coreModule.widgetDragStop',
      RESIZE_START: 'coreModule.widgetResizeStart',
      RESIZE_STOP: 'coreModule.widgetResizeStop',
      RESIZED: 'coreModule.widgetResized'
    },
    dropdown: {
      DROPDOWN_ITEM_CHANGED: 'coreModule.dropdownItemChanged',
      DROPDOWN_HIGHLIGHT_UP: 'coreModule.dropdownHighlightUp',
      DROPDOWN_HIGHLIGHT_DOWN: 'coreModule.dropdownHighlightDown',
      DROPDOWN_SELECT_HIGHLIGHTED_ITEM: 'coreModule.dropdownSelectHighlightedItem',
      DROPDOWN_CLEAR_SEARCH_INPUT: 'coreModules.dropdownClearSearchInput',
      DROPDOWN_CLEAR_SELECTED: 'coreModules.dropdownClearSelected',
      DROPDOWN_CLOSE: 'coreModules.dropdownClose',
      searchInterface: {
        FOCUS_CLEAR_SEARCH_INPUT_BUTTON: 'coreModule.dropdownSearchInterfaceFocusClearSearchInputButton',
        BLUR_CLEAR_SEARCH_INPUT_BUTTON: 'coreModule.dropdownSearchInterfaceBlurClearSearchInputButton',
        FOCUS_CLEAR_SELECTED_BUTTON: 'coreModule.dropdownSearchInterfaceFocusClearSelectedButton',
        BLUR_CLEAR_SELECTED_BUTTON: 'coreModule.dropdownSearchInterfaceBlurClearSelectedButton'
      }
    },
    classCode: {
      HIDE_TOOLTIP: 'coreModule.hideTooltip'
    },
    functionExecute: 'coreModule.functionExecute',
    gridSelectionChanged: 'coreModule.gridSelectionChanged'
  },
  uiPeformanceLogger: {
    SUCCESS: 'success',
    FAIL: 'fail'
  },
  authorization: {
    LOCAL_STORAGE_LOGIN_TOKEN_KEY: 'loginToken',
    SESSION_STORAGE_CLIENT_ID_KEY: 'clientId',
    SCHEME: 'UMS-TOKEN',
    INITIAL_TOKEN_TIMEOUT_SECONDS: 60 * 60,
    // 1 hour
    CONSOLE_TYPE_UM: 'um',
    CONSOLE_TYPE_UM_AGENT: 'umagent',
    CONSOLE_TYPE_UM_STUDIO: 'umstudio',
    CONSOLE_TYPE_APPREADER: 'appreader'
  },
  CONTEXT_NONE: 'ContextNone',
  EDGE_KEEP_ALIVE_PING_INTERVAL: 5000,
  DEFAULT_KEEP_ALIVE_PING_INTERVAL: 60000,
  DEFAULT_REFRESH_LOGIN_TOKEN_INTERVAL: 900000,
  DEFAULT_SERVER_DISCONNECTED_RECONNECT_INTERVAL: 10000,
  SERVER_DISCONNECTED_TRIES_BEFORE_ADDITIONAL_INFO: 3,
  dropdown: {
    searchInterface: {
      SEARCH_INPUT: 'coreModule.dropdownSearchInputActiveSearchInterface',
      CLEAR_SEARCH_INPUT_BUTTON: 'coreModule.dropdownClearSearchInputButtonActiveSearchInterface',
      CLEAR_SELECTED_BUTTON: 'coreModule.dropdownClearSelectedButtonActiveSearchInterface'
    }
  },
  notifications: {
    loadLimit: 25,
    filters: {
      ALL: 'all',
      UNREAD: 'unread'
    }
  },
  chatNotifications: {
    loadLimit: 25,
    filters: {
      ALL: 'all',
      UNREAD: 'unread'
    }
  }
});

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

/*@ngInject*/
var AttachmentMediator = function AttachmentMediator(attachmentRepository, saveAttachmentRepository, updateAttachmentRepository, deleteAttachmentRepository, attachmentEmailsRepository) {
  this.retrieveAttachment = function (attachmentId) {
    return attachmentRepository.retrieveAttachment(attachmentId);
  };
  this.saveAttachment = function (data, file) {
    return saveAttachmentRepository.saveAttachment(data, file);
  };
  this.updateAttachment = function (attachmentId, attachment) {
    return updateAttachmentRepository.updateAttachment(attachmentId, attachment);
  };
  this.deleteAttachment = function (attachmentId, fieldId) {
    return deleteAttachmentRepository.deleteAttachment(attachmentId, fieldId);
  };
  this.retrieveAttachmentEmails = function (attachmentId) {
    return attachmentEmailsRepository.retrieveAttachmentEmails(attachmentId);
  };
};
AttachmentMediator.$inject = ["attachmentRepository", "saveAttachmentRepository", "updateAttachmentRepository", "deleteAttachmentRepository", "attachmentEmailsRepository"];
angular.module('umCore').service('attachmentMediator', AttachmentMediator);

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

/*@ngInject*/
var AttachmentEmailsRepository = function AttachmentEmailsRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.retrieveAttachmentEmails = function (attachmentId) {
    var url = '/rest/UnderwritingAttachment/' + attachmentId + '/Email';
    return this.get(url);
  };
};
AttachmentEmailsRepository.$inject = ["baseRepository"];
angular.module('umCore').service('attachmentEmailsRepository', AttachmentEmailsRepository);

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

/*@ngInject*/
var AttachmentRepository = function AttachmentRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.retrieveAttachment = function (attachmentId) {
    var url = '/rest/UnderwritingAttachment/' + attachmentId;
    return this.get(url);
  };
};
AttachmentRepository.$inject = ["baseRepository"];
angular.module('umCore').service('attachmentRepository', AttachmentRepository);

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

/*@ngInject*/
var DeleteAttachmentRepository = function DeleteAttachmentRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.deleteAttachment = function (attachmentId, fieldId) {
    var url = '/rest/UnderwritingAttachment/' + attachmentId;
    if (fieldId) {
      url += '?fieldId=' + fieldId;
    }
    return this.delete(url);
  };
};
DeleteAttachmentRepository.$inject = ["baseRepository"];
angular.module('umCore').service('deleteAttachmentRepository', DeleteAttachmentRepository);

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var SaveAttachmentRepository = function SaveAttachmentRepository(baseRepository) {
  angular.extend(this, baseRepository);
  function generateQueryString(payload) {
    var result = Object.keys(payload).map(function (key) {
      return key + '=' + encodeURIComponent(payload[key]) + '&';
    }).join();
    result = _.replace(result, /,/g, '');
    var lastIndex = _.lastIndexOf(result, '&');
    result = result.substr(0, lastIndex);
    return result;
  }
  this.saveAttachment = function (data, file) {
    var url = '/rest/UnderwritingAttachment/upload?' + generateQueryString(data),
      formData = new FormData(),
      config = {
        transformRequest: angular.identity,
        // When you assign undefined, the content type defaults to multipart/form-data
        headers: {
          'Content-Type': undefined
        }
      };
    formData.append('file', file);
    return this.post(url, formData, config);
  };
};
SaveAttachmentRepository.$inject = ["baseRepository"];
angular.module('umCore').service('saveAttachmentRepository', SaveAttachmentRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

/*@ngInject*/
var UpdateAttachmentRepository = function UpdateAttachmentRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.updateAttachment = function (attachmentId, attachment) {
    var url = '/rest/UnderwritingAttachment/' + attachmentId;
    delete attachment.objectUri;
    delete attachment.size;
    return this.post(url, attachment);
  };
};
UpdateAttachmentRepository.$inject = ["baseRepository"];
angular.module('umCore').service('updateAttachmentRepository', UpdateAttachmentRepository);

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

angular.module('umCore').constant('submissionConstant', {
  event: {
    REDIRECT_TO_OVERVIEW: 'Submission.RedirectToOverview',
    CLOSE_CHECKLIST: 'Wizard.CloseChecklist',
    TOGGLE_CHECKLIST: 'Wizard.ToggleChecklist',
    CHECKLIST_DID_OPEN: 'Wizard.ChecklistDidOpen',
    CHECKLIST_DID_CLOSE: 'Wizard.ChecklistDidClose',
    CLOSE_COLLABORATION: 'Wizard.CloseCollaboration',
    TOGGLE_COLLABORATION: 'Wizard.ToggleCollaboration',
    COLLABORATION_DID_OPEN: 'Wizard.CollaborationDidOpen',
    COLLABORATION_DID_CLOSE: 'Wizard.CollaborationDidClose',
    COLLABORATION_FILTER_CHANGE: 'Wizard.CollaborationFilterChange',
    RELOAD_SUBMISSION: 'Submission.ReloadSubmission',
    REFRESH_SUBMISSION: 'PersistentConnection.RefreshSubmission',
    REFRESH_BREADCRUMBS: 'Submission.RefreshBreadcrumbs',
    REFRESH_ACTIONS_BUTTONS: 'Submission.RefreshActionsButtons',
    CONTEXT_CHANGED: 'Submission.ContextChanged',
    REFRESH_CHECKLIST: 'Submission.RefreshChecklist',
    REFRESH_CHECKLIST_ITEM_COUNT: 'Submission.RefreshChecklistItemCount',
    OPEN_OWNER_URI: 'Submission.OpenOwnerUri',
    SELECT_DEFAULT_NAVIGATION_ITEM: 'Submission.SelectDefaultNavigationItem',
    CLOSE_NAVIGATION: 'Submission.CloseNavigation',
    CURRENT_SUBMISSION_CHANGE: 'Submission.CurrentSubmissionChange',
    OPEN_SUBMISSION_LIST_CHANGE: 'Submission.OpenSubmissionListChange',
    CLOSE_SUBMISSION_MODULE: 'Submission.CloseSubmissionModule',
    CLOSE_ACTIVITY_STREAM: 'Wizard.CloseActivityStream',
    TOGGLE_ACTIVITY_STREAM: 'Wizard.ToggleActivityStream',
    TOGGLE_SNIPPETS: 'Wizard.ToggleSnippets',
    TOGGLE_NAVIGATION_MENU: 'Navigation.ToggleNavigationMenu',
    CLOSE_SNIPPETS: 'Wizard.CloseSnippets',
    ACTIVITY_STREAM_DID_OPEN: 'Wizard.ActivityStreamDidOpen',
    ACTIVITY_STREAM_DID_CLOSE: 'Wizard.ActivityStreamDidClose',
    SNIPPETS_DID_OPEN: 'Wizard.SnippetsDidOpen',
    SNIPPETS_DID_CLOSE: 'Wizard.SnippetsDidClose',
    CLEAR_VISIBLE_TOOLTIP: 'Submission.ClearVisibleTooltip',
    CREATE_COLLABORATION_ITEM_MESSAGE: 'Submission.CreateCollaborationItemMessage',
    UPDATE_COLLABORATION_ITEM_MESSAGE: 'Submission.UpdateCollaborationItemMessage',
    DELETE_COLLABORATION_ITEM_MESSAGE: 'Submission.DeleteCollaborationItemMessage',
    CREATE_CHAT_MESSAGE: 'Submission.CreateChatMessage',
    UPDATE_CHAT_MESSAGE: 'Submission.UpdateChatMessage',
    DELETE_CHAT_MESSAGE: 'Submission.DeleteChatMessage',
    SET_CURRENT_SNIPPET_FIELD: 'Submission.SetCurrentSnippetField',
    REFRESH_SNIPPETS_TOGGLER: 'Submission.RefreshSnippetsToggler',
    UPDATE_ACCOUNT_GRID: 'Submission.UpdateAccountGrid',
    PREQUALIFICATION_START_LOADING: 'Submission.Prequalification.StartLoading',
    PREQUALIFICATION_STOP_LOADING: 'Submission.Prequalification.StopLoading',
    PREQUALIFICATION_CHANGE_FORM_ID: 'Submission.Prequalification.ChangeFormId',
    HISTORY_FILTER_CHANGE: 'Submission.HistoryFilterChange',
    OPEN_PROPOSAL_QUOTES_DRAWER: 'Submission.OpenProposalQuotesDrawer',
    CLOSE_PROPOSAL_QUOTES_DRAWER: 'Submission.CloseProposalQuotesDrawer',
    OPEN_CHAT_COLLABORATION: 'Submission.OpenChatCollaboration',
    ATTACHMENT_EDITOR_DID_OPEN: 'Wizard.AttachmentEditorDidOpen'
  },
  originator: {
    UMS_MANUAL: 0,
    UMS_AUTO: 1,
    UPLOAD: 2,
    REWRITE: 3,
    UPLOAD_ACORD_PDF: 4,
    EXCHANGE: 5,
    EMAIL_RECEIVER: 6,
    COPY: 7,
    SPLIT: 8
  },
  breadcrumbsStatus: {
    COMPLETE: 'COMPLETE',
    IN_PROGRESS: 'IN_PROGRESS',
    NOT_COMPLETE: 'NOT_COMPLETE'
  },
  CONTEXT_QUOTE: 'Submission.ContextQuote',
  CONTEXT_SUBMISSION: 'Submission.ContextSubmission',
  CONTEXT_REPORT: 'Submission.ContextReport',
  CONTEXT_POLICY_ISSUANCE: 'Submission.ContextPolicyIssuance',
  CONTEXT_POLICY: 'Submission.ContextPolicy',
  CONTEXT_PROPOSAL: 'Submission.ContextProposal',
  CONTEXT_POLICY_CANCELLATION: 'Submission.ContextPolicyCancellation',
  CONTEXT_ENDORSEMENT: 'Submission.ContextEndorsement',
  CONTEXT_POLICY_REWRITE: 'Submission.ContextPolicyRewrite',
  CONTEXT_POLICY_REISSUE: 'Submission.ContextPolicyReissue',
  searchDelay: 750,
  CHAT_MEMBER_LIST_FALLBACK_POLLING_INTERVAL: 30000,
  DEFAULT_SUBMISSION_GRID_PAGE_SIZE: 25,
  LOCAL_STORAGE_SUBMISSION_GRID_PAGE_SIZE_KEY: 'submissionGridPageSize',
  DEFAULT_TASK_GRID_PAGE_SIZE: 25,
  LOCAL_STORAGE_TASK_GRID_PAGE_SIZE_KEY: 'taskGridPageSize'
});

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

/*@ngInject*/
var AppModeConfigurationDirective = function AppModeConfigurationDirective($document, appTypeConfigurationModel, coreConstant, coreMediator, localization) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    function setDocumentTitle(userType) {
      localization.getTranslationByKey(appTypeConfigurationModel.getConsoleTitleKey()).then(function (translation) {
        $document[0].title = translation;
      });
    }
    function setAppUserType() {
      coreMediator.loadUserProfile().then(function (userProfile) {
        var userType = userProfile.userType;
        appTypeConfigurationModel.setUserType(userType);
        setDocumentTitle(userType);
        $scope.$broadcast(coreConstant.event.USERTYPE_UPDATED);
      });
    }
    coreMediator.loadDefaultPreferences().then(function (preferences) {
      setAppUserType();
    });
    $scope.$on(coreConstant.event.LOGOUT_COMPLETE, function (event) {
      appTypeConfigurationModel.clearUserType();
      setDocumentTitle(null);
    });
  };
  return {
    link: linkFunction,
    restrict: 'A'
  };
};
AppModeConfigurationDirective.$inject = ["$document", "appTypeConfigurationModel", "coreConstant", "coreMediator", "localization"];
angular.module('umCore').directive('appModeConfiguration', AppModeConfigurationDirective);

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

/*@ngInject*/
var PeoplePickerSaveOnBlurDirective = function PeoplePickerSaveOnBlurDirective() {
  return {
    require: 'uiSelect',
    link: function link($scope, $element, attrs, $select) {
      var searchInput = $element.querySelectorAll('input.ui-select-search');
      var handleBlur = function handleBlur() {
        var item,
          taggingActivated = $select.tagging.isActivated,
          isValidIndex = $select.activeIndex >= 0;
        if ($select.open && (taggingActivated || isValidIndex)) {
          item = $select.items[$select.activeIndex];
          if (item.isTag && item.valid) {
            $select.select(item, $select.skipFocusser);
          }
        }
      };
      searchInput.on('blur.peoplePicker', handleBlur);
      $scope.$on('$destroy', function () {
        searchInput.off('blur.peoplePicker', handleBlur);
      });
    }
  };
};
angular.module('umCore').directive('peoplePickerSaveOnBlur', PeoplePickerSaveOnBlurDirective);

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UIAutoCloseDirective = function UIAutoCloseDirective($timeout, $document) {
  var linkFunction = function linkFunction($scope, $elm) {
    var timeoutList = [],
      isOpenClick = true;
    function onClick(event) {
      if (!isOpenClick) {
        var isClickedElementChildOfPopup = $elm.find(event.target).length > 0;
        if (!isClickedElementChildOfPopup && $scope.isOpen) {
          timeoutList.push($timeout(function () {
            $scope.onClose();
            isOpenClick = true;
          }));
        }
      }
      isOpenClick = !$scope.isOpen;
    }
    $document.bind('click', onClick);
    $scope.$on('$destroy', function () {
      $document.unbind('click', onClick);
      _.each(timeoutList, function (item) {
        $timeout.cancel(item);
      });
    });
  };
  return {
    link: linkFunction,
    restrict: 'A',
    scope: {
      onClose: '&',
      isOpen: '<'
    }
  };
};
UIAutoCloseDirective.$inject = ["$timeout", "$document"];
angular.module('umCore').directive('uiAutoClose', UIAutoCloseDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

/*@ngInject*/
var UIAutoExpandDirective = function UIAutoExpandDirective() {
  var linkFunction = function linkFunction($scope, $elm) {
    function autoExpand(event) {
      var element = event.target;
      if (element) {
        var scrollHeight = element.scrollHeight;
        element.style.height = scrollHeight + 'px';
      }
    }
    $scope.$on('$destroy', function () {
      $elm.unbind('keyup', autoExpand);
      $elm.unbind('focus', autoExpand);
    });
    $elm.bind('keyup', autoExpand);
    $elm.bind('focus', autoExpand);
  };
  return {
    link: linkFunction,
    restrict: 'A'
  };
};
angular.module('umCore').directive('uiAutoExpand', UIAutoExpandDirective);

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

/*@ngInject*/
var UIAutoFocusDirective = function UIAutoFocusDirective() {
  return {
    link: {
      pre: function preLink(scope, element, attr) {
        // this fails since the element hasn't rendered
      },
      post: function postLink(scope, element, attr) {
        // this succeeds since the element has been rendered
        if (attr.uiAutoFocus === 'true') {
          element[0].focus();
        }
      }
    }
  };
};
angular.module('umCore').directive('uiAutoFocus', UIAutoFocusDirective);

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var UIBrowserDetectionDirective = function UIBrowserDetectionDirective($window, browserUtil) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    var userAgent = $window.navigator.userAgent,
      isInternetExplorer10 = $window.navigator.appVersion.indexOf('MSIE 10') !== -1,
      isInternetExplorer11 = browserUtil.isIE11(),
      isChrome = browserUtil.isChrome(),
      isFirefox = browserUtil.isFirefox(),
      isEdge = browserUtil.isEdge(),
      iOS = !!userAgent.match(/iPad/i) || !!userAgent.match(/iPhone/i),
      webkit = !!userAgent.match(/WebKit/i),
      isIosSafari = iOS && webkit && !userAgent.match(/CriOS/i);
    function handleIosSafari() {
      var bodyElm = $('body');
      function handleIosSafariResize() {
        bodyElm.height($window.innerHeight);
      }
      bodyElm.addClass('iosSafari');
      bodyElm.height($window.innerHeight);
      bodyElm.on('resize.handleIosSafariResize', handleIosSafariResize);
      $scope.$on('$destroy', function () {
        bodyElm.off('resize.handleIosSafariResize', handleIosSafariResize);
      });
    }
    if (isInternetExplorer10 || isInternetExplorer11) {
      $($elm).addClass('ie');
    }
    if (isInternetExplorer10) {
      $($elm).addClass('ie10');
    }
    if (isInternetExplorer11) {
      $($elm).addClass('ie11');
    }
    if (isChrome) {
      $($elm).addClass('chrome');
    }
    if (isFirefox) {
      $($elm).addClass('ff');
    }
    if (isEdge) {
      $($elm).addClass('edge');
    }
    if (isIosSafari) {
      handleIosSafari();
    }
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UIBrowserDetectionDirective.$inject = ["$window", "browserUtil"];
angular.module('umCore').directive('uiBrowserDetection', UIBrowserDetectionDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {/*@ngInject*/
var UICustomOnChangeDirective = function UICustomOnChangeDirective($timeout) {
  var linkFunction = function linkFunction($scope, $elm) {
    function onChangeHandler(event) {
      // Use this timeout to force a digest cycle since we are handling events outside of angular
      $timeout(function () {
        if (!_.isNil(event.target.files[0])) {
          $scope.uiCustomOnChange({
            file: event.target.files[0],
            event: event
          });
          $(event.target).val(null);
        }
      }, 0);
    }
    $elm.bind('change', onChangeHandler);
    $scope.$on('$destroy', function () {
      $elm.unbind('change', onChangeHandler);
    });
  };
  return {
    restrict: 'A',
    link: linkFunction,
    scope: {
      uiCustomOnChange: '&'
    }
  };
};
UICustomOnChangeDirective.$inject = ["$timeout"];
angular.module('umCore').directive('uiCustomOnChange', UICustomOnChangeDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4)))

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*
  * If the dropdown is displayed, check whether it fits in the window,
  * and if not, set its style height to the available height so that
  * it will then get a scrollbar.
  * This directive should be added to the element with the "uib-dropdown" directive.
  */
/*@ngInject*/
var UIDropdownFitToWindowDirective = function UIDropdownFitToWindowDirective() {
  /*
   * Check whether dropdownMenu fits in the window, and if not,
   * set its style height to the available height.
   */
  var fitToWindowFunction = function fitToWindowFunction(dropdownMenu, absoluteOffsetTop) {
    var availableHeight = $(window).height() - absoluteOffsetTop;
    // clear any previous style height so that offsetHeight is recalculated
    dropdownMenu.css('height', '');
    if (dropdownMenu.outerHeight(true) > availableHeight) {
      // setting overflow=auto seems to be necessary if
      // the dropdown has the dropdown-append-to-body attribute.
      dropdownMenu.css('overflow', 'auto');
      dropdownMenu.css('height', availableHeight.toString() + 'px');
    }
  };
  var linkFunction = function linkFunction($scope, $element, $attr, $controller) {
    var element = $($element);
    $scope.$watch(function () {
      return $controller.isOpen();
    }, function (newValue, oldValue) {
      var dropdownMenu;
      // if the dropdown is displayed, newValue will be true
      if (newValue !== oldValue && newValue) {
        dropdownMenu = $controller.dropdownMenu;
        if (dropdownMenu && dropdownMenu.length) {
          fitToWindowFunction(dropdownMenu, element.offset().top + element.outerHeight(true));
        }
      }
    });
  };
  return {
    restrict: 'A',
    require: '?^uibDropdown',
    link: linkFunction
  };
};
angular.module('umCore').directive('uiDropdownFitToWindow', UIDropdownFitToWindowDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

/*@ngInject*/
var UIDropZoneDirective = function UIDropZoneDirective(coreConstant) {
  var linkFunction = function linkFunction($scope, element, attrs) {
    function processDragOverOrEnter(event) {
      if (event) {
        event.preventDefault();
        if (event.type === 'dragover') {
          element.addClass('dragHover');
        } else if (event.type === 'dragleave') {
          element.removeClass('dragHover');
        }
      }
      event.originalEvent.dataTransfer.effectAllowed = 'copyMove';
      return false;
    }
    function handleDrop(event) {
      var file, reader;
      if (event) {
        event.preventDefault();
      }
      element.removeClass('dragHover');
      reader = new FileReader();
      reader.onload = function (evt) {
        $scope.$emit(coreConstant.event.FILE_DROPPED, file);
      };
      file = event.originalEvent.dataTransfer.files[0];
      reader.readAsDataURL(file);
      return false;
    }
    element.on('dragover', processDragOverOrEnter);
    element.on('dragenter', processDragOverOrEnter);
    element.on('dragleave', processDragOverOrEnter);
    element.on('drop', handleDrop);
    $scope.$on('$destroy', function () {
      element.off('dragover', processDragOverOrEnter);
      element.off('dragenter', processDragOverOrEnter);
      element.off('dragleave', processDragOverOrEnter);
      element.off('drop', handleDrop);
    });
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UIDropZoneDirective.$inject = ["coreConstant"];
angular.module('umCore').directive('uiDropZone', UIDropZoneDirective);

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

/*@ngInject*/
var UIEnterDirective = function UIEnterDirective() {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    function handleKeypress(event) {
      if (event.which === 13) {
        $scope.$apply(function () {
          $scope.$eval($attrs.uiEnter, {
            'event': event
          });
        });
        event.preventDefault();
      }
    }
    $elm.bind('keydown keypress', handleKeypress);
    $scope.$on('$destroy', function () {
      $elm.unbind('keydown keypress', handleKeypress);
    });
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
angular.module('umCore').directive('uiEnter', UIEnterDirective);

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UIErrorHandlerDirective = function UIErrorHandlerDirective($uibModal, coreConstant, localization, registerableResourceConstants, modalUtil) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    localization.getTranslations().then(function (translations) {
      $scope.$on(coreConstant.event.HANDLE_ERROR, function (event, payload, logInfo) {
        /*
         * Don't display an error if event.preventDefault() was called by an error handler.
         */
        if (!event.defaultPrevented && !modalUtil.isServerDisconnectedModalDisplayed()) {
          var title, message, messageKey, identifier, reference, trace, exception;
          if (payload) {
            title = _.get(translations, 'alert.genericErrorTitle');
            message = payload.errorMessage;
            messageKey = payload.errorMessageKey;
            identifier = payload.identifier;
            reference = payload.reference;
            trace = payload.trace;
            exception = _.get(translations.alert.exceptions, messageKey);
            if (!identifier && logInfo) {
              identifier = logInfo.timestamp;
            }
            if (!trace && logInfo) {
              if (logInfo.stacktrace) {
                trace = logInfo.stacktrace;
              } else if (logInfo.message) {
                trace = logInfo.message;
              }
            }

            // Suppress invalid registrationIdentifier errors to the user.
            if (message !== registerableResourceConstants.INVALID_REGISTRATION_IDENTIFIER_ERROR) {
              if (_.isNil(exception) || _.isUndefined(exception)) {
                if (_.isNil(message) || _.isUndefined(message)) {
                  message = _.get(translations, 'alert.genericErrorMessage');
                }
              } else {
                message = exception;
              }
              $uibModal.open({
                templateUrl: '/ui/modal/errorModal/errorModal.tpl.html',
                controller: 'errorModalController',
                backdrop: 'static',
                windowClass: 'genericErrorModal',
                resolve: {
                  options: {
                    title: title,
                    message: message,
                    identifier: identifier,
                    reference: reference,
                    trace: trace,
                    okButtonLabel: _.get(translations, 'alert.okButtonLabel')
                  }
                }
              });
            }
          } else {
            $uibModal.open({
              templateUrl: '/ui/modal/errorModal/errorModal.tpl.html',
              controller: 'errorModalController',
              backdrop: 'static',
              windowClass: 'genericErrorModal',
              resolve: {
                options: {
                  title: _.get(translations, 'alert.genericErrorMessage'),
                  message: _.get(translations, 'alert.genericErrorMessage'),
                  okButtonLabel: _.get(translations, 'alert.okButtonLabel')
                }
              }
            });
          }
        }
      });
    });
  };
  return {
    restrict: 'E',
    replace: false,
    link: linkFunction
  };
};
UIErrorHandlerDirective.$inject = ["$uibModal", "coreConstant", "localization", "registerableResourceConstants", "modalUtil"];
angular.module('umCore').directive('uiErrorHandler', UIErrorHandlerDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

/*@ngInject*/
var UIExternalHrefTargetBlankDirective = function UIExternalHrefTargetBlankDirective($window) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    function handleClick(e) {
      this.href = e.target.href;
      if (this.href && this.href.indexOf('http') === 0) {
        if ($attrs.stopPropagation) {
          e.stopPropagation();
        }
        e.preventDefault();
        $window.open(this.href, '_blank');
      }
    }
    $elm.on('click', handleClick);
    $scope.$on('$destroy', function () {
      $elm.off('click', handleClick);
    });
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UIExternalHrefTargetBlankDirective.$inject = ["$window"];
angular.module('umCore').directive('uiExternalHrefTargetBlank', UIExternalHrefTargetBlankDirective);

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {/*@ngInject*/
var UIFocusManagerDirective = function UIFocusManagerDirective($document, $timeout, coreConstant) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    $scope.$on(coreConstant.event.ADVANCE_FOCUS, function (event, selector, delayOverride) {
      var parentSelector = '.' + $attrs['uiFocusManager'] + ' ',
        focusElement,
        delay = delayOverride || 300;
      $timeout(function () {
        function isBody(element) {
          return $document[0].body === element;
        }
        function isDescendant(parent, child) {
          var node;
          if (child) {
            node = child.parentNode;
            while (!_.isNull(node)) {
              if (node === parent) {
                return true;
              }
              node = node.parentNode;
            }
          }
          return false;
        }
        focusElement = $(parentSelector + selector);

        // Limit focus change so that it occurs if the current focus is in the document body,
        // or if the current focus is a child of the parentSelector (element where
        // ui-focus-manager lives.)
        if (focusElement && (isBody($document[0].activeElement) || isDescendant($(parentSelector)[0], $document[0].activeElement))) {
          focusElement.focus();
          if (focusElement.hasClass('ui-select-match')) {
            focusElement.click();
          }
        }
      }, delay);
    });
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UIFocusManagerDirective.$inject = ["$document", "$timeout", "coreConstant"];
angular.module('umCore').directive('uiFocusManager', UIFocusManagerDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4)))

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var UIHideSelectOnScrollDirective = function UIHideSelectOnScrollDirective() {
  var linkFunction = function linkFunction($scope, $elm, $attrs, $select) {
    var element = $($elm),
      container = element.closest($attrs.uiHideSelectOnScrollSelector),
      handleScroll = function handleScroll() {
        if ($select.open) {
          $select.close();
        }
      };
    container.on('scroll.uiHideSelectOnScroll', handleScroll);
    $('.content').bind("DOMMouseScroll mousewheel onmousewheel", function (event) {
      if ($select.open) {
        $select.close();
      }
    });
    $scope.$on('$destroy', function () {
      container.off('scroll.uiHideSelectOnScroll', handleScroll);
    });
  };
  return {
    require: 'uiSelect',
    restrict: 'A',
    replace: false,
    link: linkFunction
  };
};
angular.module('umCore').directive('uiHideSelectOnScroll', UIHideSelectOnScrollDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UIIsTooltipEnabledDirective = function UIIsTooltipEnabledDirective($window, $timeout) {
  var linkFunction = function linkFunction($scope, $elm) {
    var window = $($window),
      timerDelay = 1000,
      timeoutList = [];
    function getColumnOverflow() {
      var $element = $($elm),
        $clone = $element.clone().css({
          display: 'inline',
          width: 'auto',
          visibility: 'hidden'
        }).appendTo('body');
      if ($scope.uiIsTooltipEnabledCheckParentWidth) {
        $scope.uiIsTooltipEnabled = $clone.width() > $element.parent().width();
      } else {
        $scope.uiIsTooltipEnabled = $clone.width() > $element.width();
      }
      if ($scope.uiIsTooltipEnabledCheckParentHeight) {
        $scope.uiIsTooltipEnabled = $element.parent().height() < $element.height() - 10;
      }
      $clone.remove();
    }
    window.on('resize.uiIsTooltipEnabled', getColumnOverflow);
    $scope.$on('$destroy', function () {
      window.off('resize.uiIsTooltipEnabled', getColumnOverflow);
      _.each(timeoutList, function (item) {
        $timeout.cancel(item);
      });
    });
    timeoutList.push($timeout(function () {
      getColumnOverflow();
    }, timerDelay));
  };
  return {
    restrict: 'A',
    link: linkFunction,
    scope: {
      'uiIsTooltipEnabled': '=',
      'uiIsTooltipEnabledCheckParentWidth': '<',
      'uiIsTooltipEnabledCheckParentHeight': '<'
    }
  };
};
UIIsTooltipEnabledDirective.$inject = ["$window", "$timeout"];
angular.module('umCore').directive('uiIsTooltipEnabled', UIIsTooltipEnabledDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UILogoDirective = function UILogoDirective($compile, $window, $rootScope, coreMediator) {
  var linkFunction = function linkFunction($scope, $elm) {
    function setupLogo() {
      var element = $($elm);
      if (!_.isEmpty($scope.logoConfiguredFileName)) {
        coreMediator.getConfiguredFile($scope.logoConfiguredFileName).then(function (configuredFile) {
          if (!_.isEmpty(configuredFile)) {
            coreMediator.getConfiguredFileData(configuredFile.id).then(function (data) {
              var source = "data:".concat(configuredFile.mimeType, ";base64,").concat(data);
              var img = angular.element("<img src=\"".concat(source, "\"/>"));
              $compile(img)($scope);
              element.html(img);
            });
          }
        });
      } else if (!_.isEmpty($scope.logoUrl)) {
        var img = angular.element("<img src=\"".concat($scope.logoUrl, "\"/>"));
        $compile(img)($scope);
        element.html(img);
      }
    }
    $scope.$watch('logoConfiguredFileName', function () {
      setupLogo();
    });
  };
  return {
    restrict: 'A',
    link: linkFunction,
    scope: {
      logoConfiguredFileName: '@',
      logoUrl: '@'
    }
  };
};
UILogoDirective.$inject = ["$compile", "$window", "$rootScope", "coreMediator"];
angular.module('umCore').directive('uiLogo', UILogoDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UIMaxCharsDirective = function UIMaxCharsDirective() {
  var linkFunction = function linkFunction($scope, $elem) {
    function handleKeypress(event) {
      var limit;

      // Ignore backspace
      if (event.keyCode !== 8) {
        limit = parseInt($scope.uiMaxChars);
        if ($elem[0].value.length >= limit) {
          event.preventDefault();
        }
      }
    }
    function handlePaste(event) {
      var limit = parseInt($scope.uiMaxChars),
        newValue,
        isLimited = true;
      if (window.clipboardData) {
        newValue = window.clipboardData.getData('Text');
      } else if (event.originalEvent.clipboardData) {
        newValue = event.originalEvent.clipboardData.getData('text/plain');
      }
      if (!_.isNaN(limit)) {
        isLimited = $elem[0].value.length + newValue.length <= limit;
      } else {
        isLimited = true;
      }
      if (!isLimited) {
        event.preventDefault();
      }
    }
    $elem.on('keypress', handleKeypress);
    $elem.on('keydown', handleKeypress);
    $elem.on('paste', handlePaste);
    $scope.$on('$destroy', function () {
      $elem.off('keypress.uiMaxChars');
      $elem.off('keydown.uiMaxChars');
      $elem.off('paste.uiMaxChars');
    });
  };
  return {
    restrict: 'A',
    scope: {
      uiMaxChars: '@'
    },
    link: linkFunction
  };
};
angular.module('umCore').directive('uiMaxChars', UIMaxCharsDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

/*@ngInject*/
var UIModalNotificationHandlerDirective = function UIModalNotificationHandlerDirective($rootScope, $state, $uibModal, coreConstant, coreMediator, emailNotificationOption, modalUtil) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    $scope.$on(coreConstant.event.SHOW_MODAL_NOTIFICATION, function (event, options, actionId) {
      modalUtil.showGenericConfirm(options).then(function () {
        // actionId is the submissionId, no actionId means submission is deleted
        if (options.isAcordUploadCompleteReviewEffectiveDate || options.isAcordUploadComplete && actionId) {
          $state.go('submission', {
            submissionId: actionId
          });
        } else if (options.isAcordUploadComplete && !actionId) {
          $state.reload();
        }
      });
    });
    $scope.$on(coreConstant.event.SHOW_EMAIL_MODAL_NOTIFICATION, function (event, message) {
      coreMediator.getNotificationEmailTemplate(message.variables.notificationName).then(function (notificationEmailTemplate) {
        var modalInstance;
        message.notificationTitle = notificationEmailTemplate.title;
        modalInstance = $uibModal.open({
          templateUrl: '/ui/modal/emailModal/emailModal.tpl.html',
          controller: 'emailModalController',
          windowClass: 'genericEmailModal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            options: function options() {
              return message;
            }
          }
        });
        modalInstance.result.then(function (result) {
          var isCustom = false;
          if (result.selection !== emailNotificationOption.NONE) {
            isCustom = result.selection === emailNotificationOption.CUSTOM;
            coreMediator.sendEmailNotification(result.notificationName, isCustom, result.submissionId, result.options);
          }
        });
      });
    });
  };
  return {
    restrict: 'E',
    replace: false,
    link: linkFunction
  };
};
UIModalNotificationHandlerDirective.$inject = ["$rootScope", "$state", "$uibModal", "coreConstant", "coreMediator", "emailNotificationOption", "modalUtil"];
angular.module('umCore').directive('uiModalNotificationHandler', UIModalNotificationHandlerDirective);

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(moment, i18n, _) {/*@ngInject*/
var UIReloadRelativeTimeDirective = function UIReloadRelativeTimeDirective($interval, $filter, localization) {
  localization.setupLocale('uiReloadRelativeTime', __webpack_require__(1039));
  moment.updateLocale('en', {
    relativeTime: {
      future: i18n.t('uiReloadRelativeTime|relativeTime.future'),
      past: i18n.t('uiReloadRelativeTime|relativeTime.past'),
      s: i18n.t('uiReloadRelativeTime|relativeTime.s'),
      ss: i18n.t('uiReloadRelativeTime|relativeTime.ss'),
      m: i18n.t('uiReloadRelativeTime|relativeTime.m'),
      mm: i18n.t('uiReloadRelativeTime|relativeTime.mm'),
      h: i18n.t('uiReloadRelativeTime|relativeTime.h'),
      hh: i18n.t('uiReloadRelativeTime|relativeTime.hh'),
      d: i18n.t('uiReloadRelativeTime|relativeTime.d'),
      dd: i18n.t('uiReloadRelativeTime|relativeTime.dd'),
      M: i18n.t('uiReloadRelativeTime|relativeTime.M'),
      MM: i18n.t('uiReloadRelativeTime|relativeTime.MM'),
      y: i18n.t('uiReloadRelativeTime|relativeTime.y'),
      yy: i18n.t('uiReloadRelativeTime|relativeTime.yy')
    }
  });
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    var useMoment = $scope.useMoment === 'true';
    var currentInterval = null;
    function updateText() {
      var timeInt = _.parseInt($attrs.time);
      var txt;
      if (useMoment) {
        var time = moment(timeInt);
        txt = time.fromNow();
      } else {
        var _time = new Date(timeInt);
        txt = $filter('relativeDate')(_time);
      }
      $elm.text(txt);
    }
    $scope.$watch($attrs.time, function (newValue) {
      if (newValue) {
        updateText();
      }
    });
    $scope.$watch($attrs.interval, function (newValue) {
      if (newValue) {
        if (currentInterval) {
          $interval.cancel(currentInterval);
        }
        var intervalInMilliseconds = _.parseInt($attrs.interval) * 1000 * 60;
        currentInterval = $interval(updateText, intervalInMilliseconds);
      }
    });
    $elm.on('$destroy', function () {
      $interval.cancel(currentInterval);
    });
  };
  return {
    restrict: 'E',
    scope: {
      useMoment: '@?'
    },
    link: linkFunction
  };
};
UIReloadRelativeTimeDirective.$inject = ["$interval", "$filter", "localization"];
angular.module('umCore').directive('uiReloadRelativeTime', UIReloadRelativeTimeDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2), __webpack_require__(18)["default"], __webpack_require__(0)))

/***/ }),
/* 1039 */
/***/ (function(module) {

module.exports = JSON.parse("{\"relativeTime\":{\"future\":\"in %s\",\"past\":\"%s\",\"s\":\"just now\",\"ss\":\"just now\",\"m\":\"1 min\",\"mm\":\"%d mins\",\"h\":\"1 hr\",\"hh\":\"%d hrs\",\"d\":\"1 day\",\"dd\":\"%d days\",\"M\":\"1 mth\",\"MM\":\"%d mths\",\"y\":\"1 yr\",\"yy\":\"%d yrs\"}}");

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var UIResponsiveViewportDirective = function UIResponsiveViewportDirective($window, $rootScope) {
  var linkFunction = function linkFunction($scope) {
    var window = $($window);
    function onResize() {
      // let screenWidth = window.width();

      // if (screenWidth > 1200) {
      //     $rootScope.isExtraSmallScreen = false;
      //     $rootScope.isSmallScreen = false;
      //     $rootScope.isMediumScreen = false;
      //     $rootScope.isLargeScreen = true;
      // }
      // else if (screenWidth > 992) {
      //     $rootScope.isExtraSmallScreen = false;
      //     $rootScope.isSmallScreen = false;
      //     $rootScope.isMediumScreen = true;
      //     $rootScope.isLargeScreen = false;
      // }
      // else if (screenWidth > 768) {
      //     $rootScope.isExtraSmallScreen = false;
      //     $rootScope.isSmallScreen = true;
      //     $rootScope.isMediumScreen = false;
      //     $rootScope.isLargeScreen = false;
      // }
      // else {
      //     $rootScope.isExtraSmallScreen = true;
      //     $rootScope.isSmallScreen = false;
      //     $rootScope.isMediumScreen = false;
      //     $rootScope.isLargeScreen = false;
      // }

      $rootScope.isLargeScreen = true;
    }
    $scope.$on('$destroy', function () {
      window.off('resize.uiResponsiveViewport', onResize);
    });
    window.on('resize.uiResponsiveViewport', onResize);
    onResize();
  };
  return {
    link: linkFunction,
    restrict: 'A'
  };
};
UIResponsiveViewportDirective.$inject = ["$window", "$rootScope"];
angular.module('umCore').directive('uiResponsiveViewport', UIResponsiveViewportDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var KeypressRestrictDirective = function KeypressRestrictDirective() {
  return {
    restrict: 'A',
    link: function link($scope, $elem, $attr) {
      var pattern = $attr.keypressRestrict,
        regexp = new RegExp(pattern);
      $attr.$observe('keypressRestrict', function (value) {
        pattern = value;
        regexp = new RegExp(value);
      });
      function restrict(event) {
        var textFromKeypress, newValue, newValueValid;
        if (event.keyCode === 8) {
          // prevent backspaces that creates a bad value

          newValue = calculateBackspacedTextValue($elem);
          newValueValid = regexp.test(newValue);
          if (!newValueValid) {
            event.preventDefault();
          }
        } else {
          // prevent normal keypress that creates a bad value
          textFromKeypress = event.key;
          newValue = calculateNewTextValue($elem, textFromKeypress);
          newValueValid = regexp.test(newValue);
          if (!newValueValid) {
            event.preventDefault();
          }
        }
      }
      function restrictPaste(event) {
        var newValue, hasTrailingReturnCharacter, isValid;
        if (window.clipboardData) {
          newValue = window.clipboardData.getData('Text');
        } else if (event.originalEvent.clipboardData) {
          newValue = event.originalEvent.clipboardData.getData('text/plain');
        }
        hasTrailingReturnCharacter = newValue[newValue.length - 1] === '↵';
        if (hasTrailingReturnCharacter) {
          newValue = newValue.substring(0, newValue.length - 1);
        }
        isValid = regexp.test(newValue);
        if (!isValid) {
          event.preventDefault();
        }
      }
      $elem.on('keypress', restrict);
      $elem.on('keydown', restrict);
      $elem.on('paste', restrictPaste);
      $scope.$on('$destroy', function () {
        $elem.off('keypress.keypressRestrict');
        $elem.off('keydown.keypressRestrict');
        $elem.off('paste.keypressRestrict');
      });

      /**
       * Compute new value for text element based on incoming string at current position/selection.
       *
       * @param textElement input[type=text] or textarea, jQuery wrapped or raw
       * @param incomingText new text value to be added
       * @returns {string}
       */
      function calculateNewTextValue(textElement, incomingText) {
        var wrappedElement = $(textElement),
          rawElement = wrappedElement[0],
          currentText = wrappedElement.val(),
          selectStart = rawElement.selectionStart,
          selectEnd = rawElement.selectionEnd,
          updatedText;
        if (selectStart > selectEnd) {
          selectEnd = rawElement.selectionStart;
          selectStart = rawElement.selectionEnd;
        }
        updatedText = currentText.substring(0, selectStart) + incomingText + currentText.substring(selectEnd);
        return updatedText;
      }

      /**
       * Compute new value for text element based on backspace at current position/selection.
       *
       * @param textElement input[type=text] or textarea, jQuery wrapped or raw
       * @returns {string}
       */
      function calculateBackspacedTextValue(textElement) {
        var wrappedElement = $(textElement),
          rawElement = wrappedElement[0],
          currentText = wrappedElement.val(),
          selectStart = rawElement.selectionStart,
          selectEnd = rawElement.selectionEnd,
          updatedText = '';
        if (selectStart > selectEnd) {
          selectEnd = rawElement.selectionStart;
          selectStart = rawElement.selectionEnd;
        }
        if (selectStart !== selectEnd) {
          // remove the selected text
          updatedText = currentText.substring(0, selectStart) + currentText.substring(selectEnd);
        } else if (selectStart > 0) {
          // remove the previous character
          updatedText = currentText.substring(0, selectStart - 1) + currentText.substring(selectStart);
        } else if (selectStart === 0) {
          updatedText = currentText;
        }
        return updatedText;
      }
    }
  };
};
angular.module('umCore').directive('keypressRestrict', KeypressRestrictDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UIScrollDetectionDirective = function UIScrollDetectionDirective($window, $timeout) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    var element = $($elm),
      target = element,
      window = $($window),
      handleDomChange,
      currentResizeTimeout;
    if ($attrs.uiScrollDetectionTarget) {
      target = $($attrs.uiScrollDetectionTarget);
    }
    function checkForScrollBars() {
      element.off('DOMSubtreeModified', handleDomChange);
      window.off('resize.uiScrollDetection', handleResize);
      var isScrolling = element[0].scrollHeight > element[0].clientHeight,
        isScrollbarPresent = element[0].clientWidth < element[0].offsetWidth;
      if (isScrolling && isScrollbarPresent) {
        target.addClass('scrolling');
      } else {
        target.removeClass('scrolling');
      }
      element.on('DOMSubtreeModified', handleDomChange);
      window.on('resize.uiScrollDetection', handleResize);
    }
    function handleResize() {
      $timeout.cancel(currentResizeTimeout);
      currentResizeTimeout = $timeout(function () {
        requestAnimationFrame(checkForScrollBars);
      }, 500);
    }
    handleDomChange = _.debounce(function () {
      requestAnimationFrame(checkForScrollBars);
    }, 500);
    element.on('DOMSubtreeModified', handleDomChange);
    window.on('resize.uiScrollDetection', handleResize);
    $scope.$on('$destroy', function () {
      element.off('DOMSubtreeModified', handleDomChange);
      window.off('resize.uiScrollDetection', handleResize);
      $timeout.cancel(currentResizeTimeout);
    });
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UIScrollDetectionDirective.$inject = ["$window", "$timeout"];
angular.module('umCore').directive('uiScrollDetection', UIScrollDetectionDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var UIScrollToBottomDirective = function UIScrollToBottomDirective($timeout, coreConstant) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    var element = $($elm);
    function scrollToBottom() {
      $timeout(function () {
        element.animate({
          scrollTop: element[0].scrollHeight
        }, 300);
      }, 100);
    }
    $scope.$on(coreConstant.event.SCROLL_TO_BOTTOM, function (event) {
      scrollToBottom();
    });
  };
  return {
    restrict: 'A',
    link: linkFunction,
    scope: {
      scrollableListLength: '<'
    }
  };
};
UIScrollToBottomDirective.$inject = ["$timeout", "coreConstant"];
angular.module('umCore').directive('uiScrollToBottom', UIScrollToBottomDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var UIScrollToItemDirective = function UIScrollToItemDirective($timeout, coreConstant) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    var element = $($elm);
    $scope.$on(coreConstant.event.SCROLL_TO_ITEM, function (event, itemId) {
      scrollToItem(itemId);
    });
    function scrollToItem(itemId) {
      $timeout(function () {
        var itemElement = $('.item-id-' + itemId);
        element.animate({
          scrollTop: itemElement.offset().top - element.offset().top + element.scrollTop()
        }, 300);
      }, 100);
    }
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UIScrollToItemDirective.$inject = ["$timeout", "coreConstant"];
angular.module('umCore').directive('uiScrollToItem', UIScrollToItemDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

/*@ngInject*/
var UICustomPrintTitleDirective = function UICustomPrintTitleDirective($window, $document, localization) {
  var linkFunction = function linkFunction($scope, $elm) {
    localization.getTranslationByKey('customPrintPageTitle').then(function (result) {
      var hasCustomPrintPageTitle = result;
      if (hasCustomPrintPageTitle) {
        var previousTitle = $document[0].title;
        function beforePrint() {
          $document[0].title = hasCustomPrintPageTitle;
        }
        function afterPrint() {
          $document[0].title = previousTitle;
        }
        $window.addEventListener('beforeprint', beforePrint);
        $window.addEventListener('afterprint', afterPrint);
        $scope.$on('$destroy', function () {
          $window.removeEventListener('beforeprint', beforePrint);
          $window.removeEventListener('afterprint', afterPrint);
        });
      }
    });
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UICustomPrintTitleDirective.$inject = ["$window", "$document", "localization"];
angular.module('umCore').directive('uiCustomPrintTitle', UICustomPrintTitleDirective);

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

/*@ngInject*/
var UISetFocusDirective = function UISetFocusDirective() {
  return function (scope, elem, attr) {
    scope.$on(attr.uiSetFocus, function (e) {
      elem[0].focus();
    });
  };
};
angular.module('umCore').directive('uiSetFocus', UISetFocusDirective);

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var UIStickyElementDirective = function UIStickyElementDirective() {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    var element = $($elm),
      targetSelector = element.data().target || window,
      target = element.closest(targetSelector);
    function handleScroll(e) {
      element.css('transform', 'translateY(' + target.scrollTop() + 'px)');
    }
    ;
    target.on('scroll', handleScroll);
    $scope.$on('$destroy', function () {
      element.removeClass('affix');
      target.off('scroll', handleScroll);
    });
    handleScroll();
    element.addClass('affix');
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
angular.module('umCore').directive('uiStickyElement', UIStickyElementDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

/*@ngInject*/
var UISystemFontDirective = function UISystemFontDirective(coreMediator, preferenceModel, coreConstant) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    $scope.$on(coreConstant.event.APPLICATION_READY, function () {
      coreMediator.loadUserPreferences().then(function () {
        if (preferenceModel.get('system.useApplicationFontInHTMLFormsViewer')) {
          $elm.addClass('enableOldFont');
        } else {
          $elm.removeClass('enableOldFont');
        }
      });
    });
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UISystemFontDirective.$inject = ["coreMediator", "preferenceModel", "coreConstant"];
angular.module('umCore').directive('uiSystemFont', UISystemFontDirective);

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {/*@ngInject*/
var UIUploadDirective = function UIUploadDirective(coreConstant) {
  var linkFunction = function linkFunction($scope, element, $attrs) {
    var delegateToParent = !_.isNil($attrs.uiUploadDelegateToParent);
    function handleClick(e) {
      var target = $(e.target);
      if (delegateToParent) {
        target = target.parent();
      }
      target.siblings('.hiddenUpload').trigger('click');
    }
    element.bind('click', handleClick);
    $scope.$on('$destroy', function () {
      element.unbind('click', handleClick);
    });
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UIUploadDirective.$inject = ["coreConstant"];
angular.module('umCore').directive('uiUpload', UIUploadDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4)))

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UICurrencyFormatterDirective = function UICurrencyFormatterDirective($timeout, $filter, currencyUtil, submissionConstant) {
  var linkFunction = function linkFunction($scope, $elm, $attrs, ngModelController) {
    var isEnabled,
      currencyFilter = $filter('currency'),
      currencyFormat,
      displayDollar,
      currencyRounding,
      element = $($elm),
      timeoutList = [],
      currencyCode;
    function run() {
      function floatStringFromCurrency(value) {
        var floatValue = value;
        floatValue = _.replace(floatValue, /\$/gi, '');
        floatValue = _.replace(floatValue, /,/gi, '');
        floatValue = _.replace(floatValue, _.get(currencyFormat, 'symbol', ''), '');
        return floatValue;
      }
      function handleFocus() {
        var strLength;
        if (ngModelController.$modelValue) {
          var viewValue = floatStringFromCurrency(ngModelController.$viewValue);
          ngModelController.$viewValue = viewValue;
          ngModelController.$render();
        } else {
          ngModelController.$viewValue = '';
          ngModelController.$render();
        }
        strLength = ngModelController.$viewValue.length;
        $elm[0].setSelectionRange(strLength, strLength);
      }
      function handleBlur() {
        var value, valueArray, currencyValue, fraction;
        if (!isNaN(ngModelController.$modelValue) && !_.isEmpty(ngModelController.$modelValue)) {
          value = parseFloat(floatStringFromCurrency(ngModelController.$modelValue));
          valueArray = _.split(value, '.');
          if (currencyRounding === 'none') {
            fraction = 2; //always display 2 digits when there is no rounding for currency

            if (_.isNil(valueArray[1]) || valueArray[1] === 0) {
              fraction = 0;
              value = Math.round(valueArray[0]);
            }
          } else {
            fraction = 0;
            switch (currencyRounding) {
              case 'nearest':
                value = Math.round(value);
                break;
              case 'up':
                value = Math.ceil(value);
                break;
              case 'down':
                value = Math.floor(value);
                break;
            }
          }
          currencyValue = currencyFilter(value, currencyFormat.symbol, fraction, currencyFormat.suffixSymbol, currencyFormat.customFormat);
          ngModelController.$viewValue = currencyValue;
          ngModelController.$render();
        }
      }
      function handleKeydown(event) {
        if (!isKeyAllowed(event)) {
          //remove comma
          return event.preventDefault();
        }
      }
      function isKeyAllowed(event) {
        var currentChar = event.keyCode || event.which;

        // allow TAB, ENTER, COMMA
        if (_.includes([9, 44, 13], currentChar)) {
          return true;
        }
        return _.isNumber(_.parseInt(String.fromCharCode(currentChar)));
      }
      $scope.$watch($attrs.ngModel, function (newValue) {
        if (!element.is(':focus') && newValue) {
          handleBlur();
        }
      });
      $scope.$on(submissionConstant.event.CURRENT_SUBMISSION_CHANGE, function (event, currentSubmission) {
        currencyCode = currentSubmission ? currentSubmission.currencyCode : null;
        currencyFormat = currencyUtil.getCurrencyFormat(currencyCode, displayDollar);
        if (!element.is(':focus')) {
          handleBlur();
        } else {
          handleFocus();
        }
      });
      element.on('focus', handleFocus);
      element.on('blur', handleBlur);
      element.on('keypress', handleKeydown);
      $scope.$on('$destroy', function () {
        element.off('focus', handleFocus);
        element.off('blur', handleBlur);
        element.off('keypress', handleKeydown);
      });
    }
    timeoutList.push($timeout(function () {
      isEnabled = $elm.hasClass('ui-currency-formatter');
      displayDollar = $elm.hasClass('ui-display-dollar');
      currencyRounding = $attrs.uiCurrencyFormatterRounding || 'none';
      currencyCode = $attrs.uiCurrencyCode;
      if (isEnabled) {
        currencyFormat = currencyUtil.getCurrencyFormat(currencyCode, displayDollar);
        run();
      }
    }, 300));
    $scope.$on('$destroy', function () {
      _.each(timeoutList, function (item) {
        $timeout.cancel(item);
      });
    });
  };
  return {
    restrict: 'A',
    require: 'ngModel',
    link: linkFunction
  };
};
UICurrencyFormatterDirective.$inject = ["$timeout", "$filter", "currencyUtil", "submissionConstant"];
angular.module('umCore').directive('uiCurrencyFormatter', UICurrencyFormatterDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UIDatetimeFormatterDirective = function UIDatetimeFormatterDirective($timeout, dateUtil, formComponentUtil) {
  var linkFunction = function linkFunction($scope, $elm, $attrs, ngModelController) {
    var isEnabled,
      element = $($elm),
      timeoutList = [],
      viewValue;
    function run() {
      function handleBlur() {
        viewValue = formComponentUtil.dateFromInput(ngModelController.$viewValue, false);
        // only attempt to apply a date format if specified input is in a valid date format to begin with
        if (!_.isNil(viewValue)) {
          ngModelController.$viewValue = formComponentUtil.formatDateWithDefaultPreferences(viewValue, false);
        }
        ngModelController.$render();
      }
      $scope.$watch($attrs.ngModel, function (newValue) {
        if (!element.is(':focus') && newValue) {
          handleBlur();
        }
      });
      element.on('blur', handleBlur);
      $scope.$on('$destroy', function () {
        element.off('blur', handleBlur);
        _.each(timeoutList, function (item) {
          $timeout.cancel(item);
        });
      });
      $scope.$watch($attrs.ngModel, function (newValue) {
        if (!element.is(':focus') && newValue) {
          handleBlur();
        }
      });
    }
    timeoutList.push($timeout(function () {
      isEnabled = $elm.hasClass('ui-datetime-formatter');
      if (isEnabled) {
        run();
      }
    }, 300));
  };
  return {
    restrict: 'A',
    require: 'ngModel',
    link: linkFunction
  };
};
UIDatetimeFormatterDirective.$inject = ["$timeout", "dateUtil", "formComponentUtil"];
angular.module('umCore').directive('uiDatetimeFormatter', UIDatetimeFormatterDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UINumberWithCommasFormatterDirective = function UINumberWithCommasFormatterDirective($timeout, $filter, submissionConstant) {
  var linkFunction = function linkFunction($scope, $elm, $attrs, ngModelController) {
    var isEnabled,
      numberFilter = $filter('number', 0),
      numberDomain,
      element = $($elm),
      timeoutList = [];
    function run() {
      function handleFocus() {
        var strLength, viewValue;
        if (ngModelController.$modelValue) {
          viewValue = ngModelController.$viewValue;
          viewValue = _.replace(viewValue, /\,/gi, '');
          ngModelController.$viewValue = viewValue;
          ngModelController.$render();
        } else {
          ngModelController.$viewValue = '';
          ngModelController.$render();
        }
        strLength = ngModelController.$viewValue.length;
        $elm[0].setSelectionRange(strLength, strLength);
      }
      function handleBlur() {
        var value,
          numberArray = [];
        if (!isNaN(ngModelController.$modelValue)) {
          numberArray = _.split(ngModelController.$modelValue, '.');
          if (numberArray.length === 1) {
            value = parseFloat(ngModelController.$modelValue);
            ngModelController.$viewValue = numberFilter(value);
          } else {
            value = parseFloat(numberArray[0]);
            ngModelController.$viewValue = numberFilter(value, 0) + '.' + numberArray[1];
          }
          ngModelController.$render();
        }
      }
      function handleKeydown(event) {
        if (!isKeyAllowed(event)) {
          return event.preventDefault();
        }
      }
      function isKeyAllowed(event) {
        var currentChar = event.keyCode || event.which;

        // allow TAB, ENTER, COMMA
        if (_.includes([9, 44, 13], currentChar)) {
          return true;
        }
        return _.isNumber(_.parseInt(String.fromCharCode(currentChar)));
      }
      $scope.$watch($attrs.ngModel, function (newValue) {
        if (!element.is(':focus') && newValue) {
          handleBlur();
        }
      });
      $scope.$on(submissionConstant.event.CURRENT_SUBMISSION_CHANGE, function () {
        if (!element.is(':focus')) {
          handleBlur();
        } else {
          handleFocus();
        }
      });
      element.on('focus', handleFocus);
      element.on('blur', handleBlur);
      element.on('keypress', handleKeydown);
      $scope.$on('$destroy', function () {
        element.off('focus', handleFocus);
        element.off('blur', handleBlur);
        element.off('keypress', handleKeydown);
      });
    }
    timeoutList.push($timeout(function () {
      isEnabled = $elm.hasClass('ui-number-with-commas-formatter');
      if (isEnabled) {
        numberDomain = $elm.attr('ui-number-domain');
        run();
      }
    }, 300));
    $scope.$on('$destroy', function () {
      _.each(timeoutList, function (item) {
        $timeout.cancel(item);
      });
    });
  };
  return {
    restrict: 'A',
    require: 'ngModel',
    link: linkFunction
  };
};
UINumberWithCommasFormatterDirective.$inject = ["$timeout", "$filter", "submissionConstant"];
angular.module('umCore').directive('uiNumberWithCommasFormatter', UINumberWithCommasFormatterDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UINumberWithoutCommasFormatterDirective = function UINumberWithoutCommasFormatterDirective($timeout, submissionConstant) {
  var linkFunction = function linkFunction($scope, $elm, $attrs, ngModelController) {
    var isEnabled,
      element = $($elm),
      timeoutList = [];
    function run() {
      function handleFocus() {
        var strLength;
        if (ngModelController.$modelValue) {
          var viewValue = ngModelController.$viewValue;
          viewValue = _.replace(viewValue, /\,/gi, '');
          ngModelController.$viewValue = viewValue;
          ngModelController.$render();
        } else {
          ngModelController.$viewValue = '';
          ngModelController.$render();
        }
        strLength = ngModelController.$viewValue.length;
        $elm[0].setSelectionRange(strLength, strLength);
      }
      function handleKeydown(event) {
        if (!isKeyAllowed(event)) {
          return event.preventDefault();
        }
      }
      function isKeyAllowed(event) {
        var currentChar = event.keyCode || event.which;

        // allow TAB, ENTER
        if (_.includes([9, 13], currentChar)) {
          return true;
        }
        // disallow COMMA
        else if (currentChar === 44) {
          return false;
        }
        return _.isNumber(_.parseInt(String.fromCharCode(currentChar)));
      }
      $scope.$on(submissionConstant.event.CURRENT_SUBMISSION_CHANGE, function () {
        if (element.is(':focus')) {
          handleFocus();
        }
      });
      element.on('focus', handleFocus);
      element.on('keypress', handleKeydown);
      $scope.$on('$destroy', function () {
        element.off('focus', handleFocus);
        element.off('keypress', handleKeydown);
      });
    }
    timeoutList.push($timeout(function () {
      isEnabled = $elm.hasClass('ui-number-without-commas-formatter');
      if (isEnabled) {
        run();
      }
    }, 300));
    $scope.$on('$destroy', function () {
      _.each(timeoutList, function (item) {
        $timeout.cancel(item);
      });
    });
  };
  return {
    restrict: 'A',
    require: 'ngModel',
    link: linkFunction
  };
};
UINumberWithoutCommasFormatterDirective.$inject = ["$timeout", "submissionConstant"];
angular.module('umCore').directive('uiNumberWithoutCommasFormatter', UINumberWithoutCommasFormatterDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var UIPercentFormatterDirective = function UIPercentFormatterDirective($timeout) {
  var linkFunction = function linkFunction($scope, $elm, $attrs, ngModelController) {
    var isEnabled, addPercent, numberDomain;
    function run() {
      function handleFocus() {
        if (ngModelController.$modelValue) {
          ngModelController.$viewValue = ngModelController.$modelValue.toString().replace('%', '');
        } else {
          ngModelController.$viewValue = '';
        }
        ngModelController.$render();
      }
      function handleBlur() {
        var value;
        if (ngModelController.$modelValue && !isNaN(ngModelController.$modelValue)) {
          if (numberDomain === 'int') {
            value = parseInt(ngModelController.$modelValue, 10);
          } else {
            value = ngModelController.$modelValue;
          }
          if (addPercent) {
            value = value + '%';
          }
          ngModelController.$viewValue = value;
          ngModelController.$render();
        }
      }
      function handleKeydown(event) {
        /*
         * Unlike Chrome and IE, Firefox passes control chars (e.g., delete, tab)
         * to the keydown handler, and the handler must allow those chars
         * in order for their functionality to work.
         */
        if (event.which >= 48 && event.which <= 57 /*[0-9]*/ || event.which >= 43 && event.which <= 46 /*[+,-.]*/ || event.which === 37 /*'%'*/ || event.which < 32 /*control chars*/) {
          // allow
        } else {
          return event.preventDefault();
        }
      }
      $scope.$watch($attrs['ngModel'], function (newValue) {
        if (!$($elm).is(':focus') && newValue) {
          handleBlur();
        }
      });
      $($elm).on('focus', handleFocus);
      $($elm).on('blur', handleBlur);
      $($elm).on('keypress', handleKeydown);
      $scope.$on('$destroy', function () {
        $($elm).off('focus', handleFocus);
        $($elm).off('blur', handleBlur);
        $($elm).off('keypress', handleKeydown);
      });
    }
    $timeout(function () {
      isEnabled = $elm.hasClass('ui-percent-formatter');
      if (isEnabled) {
        addPercent = $elm.attr('ui-percent-add-percent') === 'true';
        numberDomain = $elm.attr('ui-number-domain');
        run();
      }
    }, 300);
  };
  return {
    restrict: 'A',
    require: 'ngModel',
    link: linkFunction
  };
};
UIPercentFormatterDirective.$inject = ["$timeout"];
angular.module('umCore').directive('uiPercentFormatter', UIPercentFormatterDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {/*@ngInject*/
var UIPhoneNumberFormatterDirective = function UIPhoneNumberFormatterDirective($timeout) {
  var linkFunction = function linkFunction($scope, $elm, $attrs, ngModelController) {
    function runFormat() {
      var viewValue, viewValueNoDash;
      if (ngModelController.$viewValue.toString().length === 10) {
        viewValueNoDash = _.replace(ngModelController.$viewValue.toString(), '-', '');
        viewValue = viewValueNoDash.toString().slice(0, 3) + '-' + viewValueNoDash.toString().slice(3, 6) + '-' + viewValueNoDash.toString().slice(6);
        ngModelController.$setViewValue(viewValue);
        ngModelController.$render();
      }
    }
    function handleBlur() {
      runFormat();
    }
    $($elm).on('blur', handleBlur);
    $scope.$on('$destroy', function () {
      $($elm).off('blur', handleBlur);
    });
    $timeout(function () {
      if (ngModelController.$viewValue) {
        runFormat();
      }
    }, 300);
  };
  return {
    restrict: 'A',
    link: linkFunction,
    require: 'ngModel'
  };
};
UIPhoneNumberFormatterDirective.$inject = ["$timeout"];
angular.module('umCore').directive('uiPhoneNumberFormatter', UIPhoneNumberFormatterDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4)))

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {/*@ngInject*/
var UIZipCodeFormatterDirective = function UIZipCodeFormatterDirective($timeout) {
  var linkFunction = function linkFunction($scope, $elm, $attrs, ngModelController) {
    function runFormat() {
      if (ngModelController.$viewValue.toString().length === 9) {
        ngModelController.$viewValue = _.replace(ngModelController.$viewValue.toString(), '-', '');
        ngModelController.$viewValue = ngModelController.$viewValue.toString().slice(0, 5) + '-' + ngModelController.$viewValue.toString().slice(5);
        ngModelController.$render();
      } else if (ngModelController.$viewValue.toString().length === 5) {
        ngModelController.$viewValue = ngModelController.$viewValue.toString();
        ngModelController.$render();
      }
    }
    function handleBlur() {
      runFormat();
    }
    $($elm).on('blur', handleBlur);
    $scope.$on('$destroy', function () {
      $($elm).off('blur', handleBlur);
    });
    $timeout(function () {
      if (!_.isEmpty(ngModelController.$modelValue)) {
        runFormat();
      }
    }, 300);
  };
  return {
    restrict: 'A',
    link: linkFunction,
    require: 'ngModel'
  };
};
UIZipCodeFormatterDirective.$inject = ["$timeout"];
angular.module('umCore').directive('uiZipCodeFormatter', UIZipCodeFormatterDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4)))

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var emailRecipientsFilter = function emailRecipientsFilter() {
  return function (recipients) {
    // This filter will add whitespace between the given email recipients in order to avoid word wrap
    // issues
    return _.join(_.split(recipients, ','), ', ');
  };
};
angular.module('umCore').filter('emailRecipientsFilter', emailRecipientsFilter);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

/*@ngInject*/
var nl2brFilter = function nl2brFilter($sanitize) {
  return function (msg) {
    // nl2br has issue with linky filter so wrote custom filter
    // Source: https://stackoverflow.com/questions/28089736/how-to-use-nl2br-and-linky-filter-together-in-angularjs
    // ngSanitize's linky filter changes \r and \n to &#10; and &#13; respectively
    msg = (msg + '').replace(/(\r\n|\n\r|\r|\n|&#10;&#13;|&#13;&#10;|&#10;|&#13;)/g, '<br />' + '$1');
    return $sanitize(msg);
  };
};
nl2brFilter.$inject = ["$sanitize"];
angular.module('umCore').filter('nl2br', nl2brFilter);

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, moment) {/*@ngInject*/
var UtcDateFilter = function UtcDateFilter() {
  return function (date, format, useLocalTime) {
    if (!_.isNil(date)) {
      return !!useLocalTime ? moment(new Date(date)).format(format) : moment.utc(date).format(format);
    } else {
      return '';
    }
  };
};
angular.module('umCore').filter('utcDateFilter', UtcDateFilter);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(2)))

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('umFormViewer', []).config(["$stateProvider", function ($stateProvider) {}]).run(function () {});
__webpack_require__(1061);
__webpack_require__(1072);

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1062);
__webpack_require__(1063);
__webpack_require__(1065);
__webpack_require__(1066);
var DebuggerComponent = {
  templateUrl: '/formViewer/debug/debugger.tpl.html',
  controller: 'debuggerController',
  bindings: {
    formName: '<'
  }
};
angular.module('umFormViewer').component('umFormViewerDebugger', DebuggerComponent);

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

var path = '/formViewer/debug/debugger.tpl.html';
var html = "\n<div class=\"debugTitle\">{{ $ctrl.locale.title }}</div>\n\n<div class=\"checkboxGroupContainer\">\n    <label>\n        <input type=\"checkbox\"\n               tabIndex=\"-1\"\n               ng-model=\"$ctrl.isDebuggingLayout\"\n               ng-change=\"$ctrl.onToggleLayoutDebugger()\">\n        <span class=\"checkboxLabel\">{{ ::$ctrl.locale.layoutDebuggerLabel }}</span>\n    </label>\n\n    <label>\n        <input type=\"checkbox\"\n               tabIndex=\"-1\"\n               ng-model=\"$ctrl.isDebuggingWatcherManagement\"\n               ng-change=\"$ctrl.onToggleWatcherManagementDebugger()\">\n        <span class=\"checkboxLabel\">{{ ::$ctrl.locale.watcherDebuggerLabel }}</span>\n    </label>\n\n    <label>\n        <input type=\"checkbox\"\n               tabIndex=\"-1\"\n               ng-model=\"$ctrl.isDebuggingDragAndDrop\"\n               ng-change=\"$ctrl.onToggleDragAndDropDebugger()\">\n        <span class=\"checkboxLabel\">{{ ::$ctrl.locale.dragAndDropDebuggerLabel }}</span>\n    </label>\n\n    <label>\n        <input type=\"checkbox\"\n               tabIndex=\"-1\"\n               ng-model=\"$ctrl.isDebuggingSupplementalForm\"\n               ng-change=\"$ctrl.onToggleSupplementalFormDebugger()\">\n        <span class=\"checkboxLabel\">{{ ::$ctrl.locale.supplementalFormDebuggerLabel }}</span>\n    </label>\n</div>\n\n<um-drag-and-drop-debugger\n    ng-class=\"{ dragAndDropDebuggerEnabled: $ctrl.isDragAndDropDebuggerVisible }\"\n    ng-if=\"$ctrl.isDebuggingDragAndDropEnabled\"\"></um-drag-and-drop-debugger>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {var locale = __webpack_require__(1064);

/*@ngInject*/
var DebuggerController = function DebuggerController($scope, $element, formViewerConstant, $timeout) {
  var _this = this;
  this.$onInit = function () {
    _this.locale = locale;
    _this.isDebuggingLayout = false;
    _this.isDebuggingWatcherManagement = false;
    _this.isDebuggingDragAndDrop = false;
    _this.isDebuggingDragAndDropEnabled = false;
    _this.isDragAndDropDebuggerVisible = false;
    _this.isDebuggingSupplementalForm = false;
    _this.isDebuggingSupplementalFormEnabled = false;
    _this.isDebuggingSupplementalFormVisible = false;
    $element.addClass('debuggerComponent');
    $scope.$on(formViewerConstant.event.FORM_RENDERING_OPTIMIZE_WATCHERS, function () {
      _this.onToggleWatcherManagementDebugger();
    });
  };
  this.onToggleLayoutDebugger = function () {
    var form = $('.formViewer:has(.' + _this.formName + ')');
    if (_this.isDebuggingLayout) {
      form.addClass('debugLayout');
    } else {
      form.removeClass('debugLayout');
    }
  };
  this.onToggleWatcherManagementDebugger = function () {
    var target = $('.formViewer:has(.' + _this.formName + ')');
    var topOfViewport, bottomOfViewport, fieldListComponents;
    target.find('.debuggingFormContainer').remove();
    target.find('.debuggingContainer').remove();
    if (_this.isDebuggingWatcherManagement) {
      topOfViewport = target.offset().top;
      bottomOfViewport = target.height();
      target.append('<div class="debuggingFormContainer">' + '<span class="debuggerFormRow">' + 'TopOfViewport: ' + parseInt(topOfViewport) + '</span>' + '<span class="debuggerFormRow">' + ', BottomOfViewport: ' + parseInt(topOfViewport + bottomOfViewport) + '</span>' + '</div>');
      if (!fieldListComponents) {
        fieldListComponents = target.find('.fieldListComponent');
      }
      _.each(fieldListComponents, function (componentDom) {
        var component = $(componentDom),
          topOfComponent = component.offset().top,
          bottomOfComponent = topOfComponent + component.height();
        component.append('<div class="debuggingContainer">' + '<span class="debuggerRow">' + 'top:' + parseInt(topOfComponent) + '</span>' + '<span class="debuggerRow">' + ', bottom:' + parseInt(bottomOfComponent) + '</span>' + '<span class="debuggerRow">' + ', enabled: ' + (!component.hasClass('watchersDisabled')).toString().slice(0, 1).toUpperCase() + '</span>' + '</div>');
      });
    }
  };
  this.onToggleDragAndDropDebugger = function () {
    var form = $('.formViewer:has(.' + _this.formName + ')');
    if (_this.isDebuggingDragAndDrop) {
      _this.isDebuggingDragAndDropEnabled = true;
      form.addClass('debugDragAndDrop');
      $timeout(function () {
        _this.isDragAndDropDebuggerVisible = true;
      }, 100);
    } else {
      _this.isDragAndDropDebuggerVisible = false;
      form.removeClass('debugDragAndDrop');
      $timeout(function () {
        _this.isDebuggingDragAndDropEnabled = false;
      }, 100);
    }
  };
  this.onToggleSupplementalFormDebugger = function () {
    var form = $('.formViewer:has(.' + _this.formName + ')');
    if (_this.isDebuggingSupplementalForm) {
      _this.isDebuggingSupplementalFormEnabled = true;
      form.addClass('debugSupplementalForm');
      $timeout(function () {
        _this.isDebuggingSupplementalFormVisible = true;
      }, 100);
    } else {
      _this.isDebuggingSupplementalFormEnabled = false;
      form.removeClass('debugSupplementalForm');
      $timeout(function () {
        _this.isDebuggingSupplementalFormVisible = false;
      }, 100);
    }
  };
};
DebuggerController.$inject = ["$scope", "$element", "formViewerConstant", "$timeout"];
angular.module('umFormViewer').controller('debuggerController', DebuggerController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1064 */
/***/ (function(module) {

module.exports = JSON.parse("{\"title\":\"Form Viewer Debugging Tools\",\"layoutDebuggerLabel\":\"Layout\",\"watcherDebuggerLabel\":\"Watcher Management\",\"dragAndDropDebuggerLabel\":\"Drag & Drop\",\"supplementalFormDebuggerLabel\":\"Supplemental Form\"}");

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

/*@ngInject*/
var DebuggerDirective = function DebuggerDirective($timeout, $document) {
  var linkFunction = function linkFunction($scope, $element, $attr) {
    function toggleDebugger() {
      $scope.debuggingMode = !$scope.debuggingMode;
      toggleFormViewerDebuggerClass($scope.debuggingMode);
    }
    function toggleFormViewerDebuggerClass(isDebugging) {
      var debuggerClass = 'debuggerEnabled';
      if (isDebugging) {
        $element.addClass(debuggerClass);
      } else {
        $element.removeClass(debuggerClass);
      }
    }
    var handleKeyUp = function handleKeyUp(event) {
      var isPressingD = event.keyCode === 68,
        isPressingShift = event.shiftKey,
        isPressingAlt = event.altKey,
        isCorrectKeyboardCombo = isPressingD && isPressingShift && isPressingAlt;
      if (isCorrectKeyboardCombo) {
        toggleDebugger();
      }
      $timeout();
    };
    $document.on('keyup.UIFormViewerDirective', handleKeyUp);
    $scope.$on('$destroy', function () {
      $document.off('keyup.UIFormViewerDirective', handleKeyUp);
    });
  };
  return {
    link: linkFunction,
    restrict: 'A'
  };
};
DebuggerDirective.$inject = ["$timeout", "$document"];
angular.module('umFormViewer').directive('uiDebuggerDirective', DebuggerDirective);

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1067);
__webpack_require__(1068);
__webpack_require__(1069);
__webpack_require__(1070);
var DragAndDropComponent = {
  templateUrl: '/formViewer/debug/dragAndDrop/dragAndDrop.tpl.html',
  controller: 'dragAndDropDebuggerController',
  bindings: {}
};
angular.module('umFormViewer').component('umDragAndDropDebugger', DragAndDropComponent);

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var DragAndDropDomManagerDirective = function DragAndDropDomManagerDirective($document, formViewerConstant) {
  var linkFunction = function linkFunction($scope, $elm, $attr) {
    var mouseTargetClass = 'dragAndDropMouseTarget';
    var mouseTarget;
    var fieldStructureId;
    var targetElement;
    function addTargetDebuggingElements() {
      var mouseTargetTpl = "<div class=\"".concat(mouseTargetClass, "\"></div>");
      var topDropAreaTpl = '<div class="topZone"></div>';
      var bottomDropAreaTpl = '<div class="bottomZone"></div>';
      targetElement.append(mouseTargetTpl);
      targetElement.append(topDropAreaTpl);
      targetElement.append(bottomDropAreaTpl);
      mouseTarget = $('.' + mouseTargetClass);
    }
    function updateMouseTargetPosition(xValue, yValue) {
      mouseTarget.css('left', xValue + 'px');
      mouseTarget.css('top', yValue + 'px');
    }
    function resetScreen() {
      targetElement.find('.' + mouseTargetClass).remove();
      targetElement.find('.topZone').remove();
      targetElement.find('.bottomZone').remove();
      fieldStructureId = null;
    }
    var resetDebuggerInfo = function resetDebuggerInfo() {
      var mouseTarget = element.find('.mouseTarget'),
        debuggerXVal = $('.formViewerContainer .debuggingDragAndDropContainer .xVal'),
        debuggerYVal = $('.formViewerContainer .debuggingDragAndDropContainer .yVal'),
        debuggerDropTypeVal = $('.formViewerContainer .debuggingDragAndDropContainer .dropTypeVal');
      mouseTarget.css('top', '0px');
      mouseTarget.css('left', '0px');
      mouseTarget.css('display', 'none');
      debuggerXVal.html('');
      debuggerYVal.html('');
      debuggerDropTypeVal.html('');
    };
    $scope.$on(formViewerConstant.configuration.event.DRAG_FORM_ELEMENT, function (event, debuggerInfo) {
      if (debuggerInfo.fieldStructureId !== fieldStructureId) {
        fieldStructureId = debuggerInfo.fieldStructureId;
        targetElement = $('.' + fieldStructureId);
        resetScreen();
        addTargetDebuggingElements();
      }
      updateMouseTargetPosition(debuggerInfo.xValue, debuggerInfo.yValue);
    });
    $scope.$on(formViewerConstant.configuration.event.DRAG_FORM_ELEMENT_END, function () {
      resetScreen();
    });
    $scope.$on('$destroy', function () {
      resetScreen();
    });
  };
  return {
    link: linkFunction,
    scope: {},
    restrict: 'E'
  };
};
DragAndDropDomManagerDirective.$inject = ["$document", "formViewerConstant"];
angular.module('umFormViewer').directive('umDragAndDropDomManager', DragAndDropDomManagerDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

var path = '/formViewer/debug/dragAndDrop/dragAndDrop.tpl.html';
var html = "<um-drag-and-drop-dom-manager></um-drag-and-drop-dom-manager>\n\n<div class=\"debuggerRow\">\n    <div class=\"rowLabel\">{{ ::$ctrl.locale.fieldName }}</div>\n    <div class=\"rowValue\">{{ $ctrl.debuggerInfo.indexedName }}</div>\n</div>\n\n<div class=\"debuggerRow\">\n    <div class=\"rowLabel\">{{ ::$ctrl.locale.fieldStructureId }}</div>\n    <div class=\"rowValue\">{{ $ctrl.debuggerInfo.fieldStructureId }}</div>\n</div>\n\n<div class=\"debuggerRow\">\n    <div class=\"rowLabel\">{{ ::$ctrl.locale.parentForm }}</div>\n    <div class=\"rowValue\">{{ $ctrl.debuggerInfo.parentFormName }}</div>\n</div>\n\n<div class=\"debuggerRow\">\n    <div class=\"rowLabel\">{{ ::$ctrl.locale.parentRowSelector }}</div>\n    <div class=\"rowValue\">{{ $ctrl.debuggerInfo.parentRowSelector }}</div>\n</div>\n\n<div class=\"debuggerRow\">\n\n    <div class=\"rowLabel\">{{ ::$ctrl.locale.dropType }}</div>\n\n    <div class=\"rowValue\">\n        {{ $ctrl.dropTypeValue }}\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

var locale = __webpack_require__(1071);

/*@ngInject*/
var DragAndDropDebuggerController = function DragAndDropDebuggerController($scope, $element, formViewerConstant, $timeout) {
  var _this = this;
  this.$onInit = function () {
    $element.addClass('dragAndDropDebugger');
    _this.locale = locale;
  };
  this.renderDebuggerInfo = function (debuggerInfo) {
    _this.debuggerInfo = debuggerInfo;
    if (debuggerInfo.isTopDropAttempt) {
      _this.dropTypeValue = 'Top';
    } else if (debuggerInfo.isBottomDropAttempt) {
      _this.dropTypeValue = 'Bottom';
    } else if (debuggerInfo.isLeftDropAttempt) {
      _this.dropTypeValue = 'Left';
    } else if (debuggerInfo.isRightDropAttempt) {
      _this.dropTypeValue = 'Right';
    }
  };
  $scope.$on(formViewerConstant.configuration.event.DRAG_FORM_ELEMENT, function (event, debuggerInfo) {
    this.renderDebuggerInfo(debuggerInfo);
  }.bind(this));
};
DragAndDropDebuggerController.$inject = ["$scope", "$element", "formViewerConstant", "$timeout"];
angular.module('umFormViewer').controller('dragAndDropDebuggerController', DragAndDropDebuggerController);

/***/ }),
/* 1071 */
/***/ (function(module) {

module.exports = JSON.parse("{\"fieldName\":\"Field Name: \",\"fieldStructureId\":\"Field Structure ID: \",\"parentForm\":\"Parent Form: \",\"parentRowSelector\":\"Parent Row Selector: \",\"dropType\":\"Drop Type: \"}");

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

/*@ngInject*/
var UIHideEmptySectionDirective = function UIHideEmptySectionDirective($timeout) {
  var linkFunction = function linkFunction($scope, $elm) {
    var sectionDom = $elm[0];
    var mutationConfig = {
      attributes: false,
      childList: true,
      subtree: true,
      characterData: false,
      characterDataOldValue: false
    };
    var validateContainerSize = function validateContainerSize() {
      var sectionHeight = sectionDom.offsetHeight;
      var minHeight = 10;
      if (sectionHeight > minHeight) {
        $elm.removeClass('hideBottomBorder');
      } else {
        $elm.addClass('hideBottomBorder');
      }
    };
    var observer = new MutationObserver(validateContainerSize);
    observer.observe(sectionDom, mutationConfig);
    $timeout(function () {
      validateContainerSize();
    }, 300);
    $scope.$on('$destroy', function () {
      observer.disconnect();
    });
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UIHideEmptySectionDirective.$inject = ["$timeout"];
angular.module('umFormViewer').directive('uiHideEmptySection', UIHideEmptySectionDirective);

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UIFormViewerDirective = function UIFormViewerDirective($document, $timeout) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    var element = $($elm),
      timeoutList = [];
    element.addClass('formViewer');
    if ($scope.supplemental) {
      element.addClass('supplemental');
    }
    $scope.$on('$destroy', function () {
      _.each(timeoutList, function (item) {
        $timeout.cancel(item);
      });
    });
  };
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      submissionId: '@',
      formId: '@',
      isConfigurableForm: '<',
      formData: '<',
      supplemental: '@',
      lazyRender: '@',
      printPreview: '<',
      printable: '<',
      displayFormName: '<',
      effectiveDate: '@'
    },
    templateUrl: '/formViewer/formViewer.tpl.html',
    controller: 'formViewerController',
    link: linkFunction
  };
};
UIFormViewerDirective.$inject = ["$document", "$timeout"];
angular.module('umFormViewer').directive('uiFormViewer', UIFormViewerDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, moment) {/*@ngInject*/
var FormViewerController = function FormViewerController($window, $rootScope, $scope, $stateParams, $state, $timeout, localization, fieldType, formMediator, formTemplateType, formViewerConstant, formViewerUtil, submissionConstant, formatUtil, coreMediator) {
  $scope.timeoutList = [];
  $scope.fieldType = fieldType;
  localization.getTranslations().then(function (translations) {
    $scope.printFormTooltip = _.get(translations, 'formsViewer.printFormTooltip');
  });
  var loadForm = function loadForm() {
    $scope.isLoading = true;
    $scope.sectionList = [];
    $scope.effectiveDate = $scope.effectiveDate || moment.now();
    if ($scope.isConfigurableForm) {
      formMediator.loadStaticForm($scope.formId);
    } else {
      formMediator.loadRootForm($scope.formId, $scope.printPreview, $scope.effectiveDate, $scope.currencyCode);
    }
    $scope.timeoutList.push($timeout(function () {
      $rootScope.$broadcast(formViewerConstant.event.FORM_LAZY_RENDERING_START, $scope.formId);
    }, 1));
  };
  if ($scope.supplemental) {
    $scope.sectionList = $scope.formData.sectionList;
  }
  $scope.showNextRequiredField = function () {
    $rootScope.$broadcast(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD, $scope.formId);
  };
  $scope.$on(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD_AFTER_FORM_LOAD, function () {
    formMediator.setDelayShowNextRequiredField(true);
  });
  $scope.printForm = function () {
    $rootScope.$broadcast(submissionConstant.event.CLOSE_CHECKLIST);
    $rootScope.$broadcast(submissionConstant.event.CLOSE_COLLABORATION);
    $rootScope.$broadcast(submissionConstant.event.CLOSE_ACTIVITY_STREAM);
    $rootScope.$broadcast(submissionConstant.event.CLOSE_SNIPPETS);
    $window.print();
  };
  $scope.showPrintIcon = function () {
    var isPrintable = _.isUndefined($scope.printable) ? true : $scope.printable;
    var isPrintPreview = _.isUndefined($scope.formData) || _.isUndefined($scope.formData.formModel) ? false : $scope.formData.formModel.printPreview;
    return isPrintable && !isPrintPreview;
  };
  if (!$scope.supplemental) {
    $scope.shouldProcessFormEvent = function (fieldModel) {
      var rootFormId = parseInt($scope.formId);
      return !$scope.isLoading && formMediator.shouldProcessForm(rootFormId, fieldModel.formId);
    };
    $scope.$on(formViewerConstant.event.CREATE_FIELD_MESSAGE, function (event, fieldModel) {
      if ($scope.shouldProcessFormEvent(fieldModel)) {
        formMediator.processFieldUpdate(fieldModel, $scope.formId);
      }
    });
    $scope.$on(formViewerConstant.event.UPDATE_FIELD_MESSAGE, function (event, fieldModel) {
      if ($scope.shouldProcessFormEvent(fieldModel)) {
        formMediator.processFieldUpdate(fieldModel, $scope.formId);
      }
    });
    $scope.$on(formViewerConstant.event.DELETE_FIELD_MESSAGE, function (event, fieldModel) {
      if ($scope.shouldProcessFormEvent(fieldModel)) {
        formMediator.processFieldDelete(fieldModel, $scope.formId);
      }
    });
    $scope.$on(formViewerConstant.event.RENAME_FIELD_MESSAGE, function (event, fieldModel) {
      if ($scope.shouldProcessFormEvent(fieldModel)) {
        formMediator.processFieldRename(fieldModel, $scope.formId);
      }
    });
    $scope.$on(formViewerConstant.event.FORM_STRUCTURE_CHANGED, function (event, rootFormId) {
      if ($scope.formId === rootFormId) {
        $scope.formData = formMediator.getFormStructure($scope.formId);
        if (!_.isEmpty($scope.formData)) {
          $rootScope.$broadcast(formViewerConstant.event.FORM_DATA_READY, $scope.formData, rootFormId);
          if (formMediator.isDelayShowNextRequiredField()) {
            formMediator.resetDelayShowNextRequiredField();
            $scope.$on(formViewerConstant.event.FORM_LAZY_RENDERING_END, function (event) {
              $scope.timeoutList.push($timeout(function () {
                $rootScope.$broadcast(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD, $scope.formId);
              }, 500));
            });
          }
        }
      }
    });
    $scope.$on(formViewerConstant.event.CREATE_NEW_SUPPLEMENTAL_FORM, function (event, form) {
      var currentRootFormId = parseInt($scope.formId),
        eventRootFormId = form.rootFormId ? form.rootFormId : form.id;
      if (currentRootFormId === eventRootFormId) {
        if ($scope.isLoading) {
          return;
        }
        formMediator.createSupplementalForm(form, $scope.formId, $scope.printPreview);
        $scope.timeoutList.push($timeout(function () {}, 0));
      }
    });
    $scope.$on(formViewerConstant.event.DELETE_SUPPLEMENTAL_FORM, function (event, form) {
      var currentRootFormId = parseInt($scope.formId),
        eventRootFormId = form.rootFormId ? form.rootFormId : form.id;
      function attemptSupplementalFormDelete(supplementalForm, rootFormId, attemptCount) {
        var maxTries = 10;
        var shouldRetry = attemptCount < maxTries;
        var isDeleteSuccessful = formMediator.deleteSupplementalForm(supplementalForm, rootFormId);
        if (!isDeleteSuccessful && shouldRetry) {
          $timeout(function () {
            attemptSupplementalFormDelete(supplementalForm, rootFormId, attemptCount + 1);
          }, 500);
        }
      }
      if (currentRootFormId === eventRootFormId) {
        if ($scope.isLoading) {
          return;
        }
        attemptSupplementalFormDelete(form, $scope.formId, 0);
      }
    });
    $scope.$on(formViewerConstant.event.UPDATE_ROOT_FORM, function (event, form) {
      var currentRootFormId = parseInt($scope.formId),
        eventRootFormId = form.rootFormId ? form.rootFormId : form.id;
      if (currentRootFormId === eventRootFormId) {
        if ($scope.isLoading) {
          return;
        }
        formMediator.processRootFormUpdate(form, $scope.formId);
      }
    });
    $scope.$on(formViewerConstant.event.DELETE_ROW, function (event, message) {
      var rootFormId = parseInt($scope.formId),
        shouldProcessRowEvent = formMediator.shouldProcessForm(rootFormId, message.messagePayload.formId);
      if (shouldProcessRowEvent) {
        formMediator.processRemoteRowDeletion(message, $scope.formId);
      }
    });
    $scope.$on(formViewerConstant.event.CREATE_ROW, function (event, message) {
      var rootFormId = parseInt($scope.formId),
        shouldProcessRowEvent = formMediator.shouldProcessForm(rootFormId, message.messagePayload.formId);
      if (shouldProcessRowEvent) {
        formMediator.processRemoteRowAddition(message, $scope.formId);
      }
    });
    $scope.$on(formViewerConstant.event.UPDATE_ROW, function (event, message) {
      var rootFormId = parseInt($scope.formId),
        shouldProcessRowEvent = formMediator.shouldProcessForm(rootFormId, message.formId);
      if (shouldProcessRowEvent) {
        formMediator.processRemoteRowUpdate(message, $scope.formId);
      }
    });
    $scope.$on(formViewerConstant.event.RELOAD_FORM, function () {
      loadForm();
    });
    $scope.$on('$destroy', function () {
      var hasLoginToken = !_.isNil(coreMediator.getLoginToken());
      if (hasLoginToken) {
        formMediator.unregisterForm($scope.formId);
      }
      _.each($scope.timeoutList, function (item) {
        if (item) {
          $timeout.cancel(item);
        }
      });
    });
    $scope.$watch('formId', function (newFormId, oldFormId) {
      if (newFormId) {
        loadForm();
        if (oldFormId && oldFormId !== newFormId) {
          formMediator.unregisterForm(oldFormId);
        }
      }
    });
  }
};
FormViewerController.$inject = ["$window", "$rootScope", "$scope", "$stateParams", "$state", "$timeout", "localization", "fieldType", "formMediator", "formTemplateType", "formViewerConstant", "formViewerUtil", "submissionConstant", "formatUtil", "coreMediator"];
angular.module('umFormViewer').controller('formViewerController', FormViewerController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(2)))

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

var FormViewerConstant = {
  event: {
    FORM_STRUCTURE_CHANGED: 'FormViewerConstant.formStructureChanged',
    FORM_LAZY_RENDERING_START: 'FormViewerConstant.formLazyRenderingStart',
    FORM_LAZY_RENDERING_END: 'FormViewerConstant.formLazyRenderingEnd',
    FORM_RENDERING_OPTIMIZE_WATCHERS: 'FormViewerConstant.FormRenderingOptimizeWatchers',
    SUPPLEMENTAL_FORM_ADDED: 'FormViewerConstant.SupplementalFormAdded',
    SUPPLEMENTAL_FORM_REMOVED: 'FormViewerConstant.SupplementalFormRemoved',
    OPTIMIZE_FORM_WATCHERS: 'formViewerConstant.OptimizeFormWatchers',
    CREATE_FIELD_MESSAGE: 'FormViewerConstant.CreateFieldMessage',
    UPDATE_FIELD_MESSAGE: 'FormViewerConstant.UpdateFieldMessage',
    DELETE_FIELD_MESSAGE: 'FormViewerConstant.DeleteFieldMessage',
    RENAME_FIELD_MESSAGE: 'FormViewerConstant.RenameFieldMessage',
    SHOW_REMOTE_FIELD_NOTIFICATION: 'FormViewerConstant.remoteFieldUpdate',
    SHOW_NEXT_REQUIRED_FIELD: 'FormViewerConstant.showNextRequiredField',
    SHOW_NEXT_REQUIRED_FIELD_AFTER_FORM_LOAD: 'FormViewerConstant.showNextRequiredFieldAfterFormLoad',
    SHOW_NEXT_REQUIRED_FIELD_FORM_SUMMARY_GRID: 'FormViewerConstant.showNextRequiredFieldFormSummaryGrid',
    CREATE_NEW_SUPPLEMENTAL_FORM: 'FormViewerConstant.CreateNewSupplementalForm',
    DELETE_SUPPLEMENTAL_FORM: 'FormViewerConstant.DeleteSupplementalForm',
    UPDATE_ROOT_FORM: 'FormViewerConstant.UpdateRootForm',
    CREATE_ROW: 'FormViewerConstant.CreateRow',
    DELETE_ROW: 'FormViewerConstant.DeleteRow',
    UPDATE_ROW: 'FormViewerConstant.UpdateRow',
    ROW_RENDERING_COMPLETE: 'FormViewerConstant.RowRenderingComplete',
    FORM_DATA_READY: 'FormViewerConstant.RenderData',
    CLOSE_CALENDAR_POPUP: 'FormViewerConstant.CloseCalendarPopup',
    DROPDOWN_UPDATE_ACTIVE_INDEX: 'formViewerConstant.DropdownUpdateActiveIndex',
    RELOAD_FORM: 'formViewerConstant.ReloadForm',
    FOCUSED_FIELD_CHANGED: 'formViewerConstant.FocusedFieldChanged',
    INITIAL_RENDERING_COMPLETE: 'formViewerConstant.InitialRenderingComplete',
    FORM_TEMPLATE_INVALIDATED: 'formViewerConstant.FormTemplateInvalidated',
    REPEATING_ROW_SELECTED: 'formViewerConstant.RepeatingRowSelected',
    REPEATING_ROW_PAGE_CHANGE: 'formViewerConstant.RepeatingRowPageChange',
    formBuilder: {
      FIELD_COMPONENT_SELECTED: 'formViewerConstant.formBuilder.FieldComponentSelected',
      FORM_TEMPLATE_UPDATED: 'formViewerConstant.formBuilder.FormTemplateUpdated',
      FORM_TEMPLATE_SAVED: 'formViewerConstant.formBuilder.FormTemplateSaved',
      COLUMN_RESIZED: 'formViewerConstant.formBuilder.ColumnResized',
      COLUMN_RESIZING: 'formViewerConstant.formBuilder.ColumnResizing',
      DISABLE_DRAGGABLE_ELEMENTS: 'formViewerConstant.formBuilder.DisableDraggableElements',
      ENABLE_DRAGGABLE_ELEMENTS: 'formViewerConstant.formBuilder.EnableDraggableElements',
      REARRANGE_COLUMN: 'formViewerConstant.formBuilder.RearrangeColumn'
    },
    ruleBuilder: {
      REVIEW_RULE: 'formViewerConstant.ruleBuilder.reviewRule'
    }
  },
  configuration: {
    event: {
      CREATE_NEW_ROW: 'FormViewerConstant.configuration.CreateNewRow',
      CREATE_NEW_COMPONENT: 'FormViewerConstant.configuration.CreateNewComponent',
      CREATE_NEW_SECTION: 'FormViewerConstant.configuration.CreateNewSection',
      CREATE_NEW_ROW_REPEATER: 'FormViewerConstant.configuration.CreateNewRowRepeater',
      FIELD_SELECTION_CHANGE: 'FormViewerConstant.configuration.FieldSelectionChange',
      ROW_SELECTION_CHANGE: 'FormViewerConstant.configuration.RowSelectionChange',
      SECTION_SELECTION_CHANGE: 'FormViewerConstant.configuration.SectionSelectionChange',
      FIELD_DRAG_START: 'FormViewerConstant.configuration.FieldDragStart',
      DRAG_FORM_ELEMENT: 'FormViewerConstant.configuration.DragFormElement',
      DRAG_FORM_ELEMENT_END: 'FormViewerConstant.configuration.DragFormElementEnd',
      DELETE_FIELD: 'FormViewerConstant.configuration.DeleteField',
      DELETE_ROW: 'FormViewerConstant.configuration.DeleteRow',
      DELETE_SECTION: 'FormViewerConstant.configuration.DeleteSection',
      UPDATE_ROW_REPEATER_SETTING: 'FormViewerConstant.configuration.UpdateRowRepeaterSetting',
      UPDATE_COMPONENT_SETTING: 'FormViewerConstant.configuration.UpdateComponentSetting',
      SAVE_FORM_TEMPLATE_CHANGES: 'FormViewerConstant.configuration.SaveFormTemplateChanges',
      FIELD_MOVED_IN_ROW: 'FormViewerConstant.configuration.FieldMovedInRow'
    },
    dragOperationType: {
      MOVE: 'FormViewerConstant.DragOperationType.Move',
      INSERT: 'FormViewerConstant.DragOperationType.Insert'
    },
    formStructureType: {
      SECTION: 'FormViewerConstant.FormStructureType.Section',
      ROW: 'FormViewerConstant.FormStructureType.Row',
      ROW_REPEATER: 'FormViewerConstant.FormStructureType.RowRepeater',
      COMPONENT: 'FormViewerConstant.FormStructureType.Component'
    },
    INSERT_BEFORE: 'FormViewerConstant.InsertBefore',
    INSERT_AFTER: 'FormViewerConstant.InsertAfter',
    INSERT_ABOVE: 'FormViewerConstant.InsertAbove',
    INSERT_BELOW: 'FormViewerConstant.InsertBelow'
  },
  timing: {
    FORM_VIEWER: 'FormViewerConstant.FormViewer',
    LOAD_DATA: 'FormViewerConstant.LoadData',
    BEGIN_RENDERING: 'FormViewerConstant.BeginRendering',
    INITIAL_SCREEN_RENDERED: 'FormViewerConstant.InitialScreenRendered',
    FORM_FULLY_RENDERED: 'FormViewerConstant.FormFullyRendered'
  }
};
angular.module('umFormViewer').constant('formViewerConstant', FormViewerConstant);

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FormMediator = function FormMediator($q, $timeout, delayShowNextRequiredFieldModel, formRepository, formTemplateRepository, persistentConnection, fieldType, loadFieldInstanceListRepository, formViewerModel, createFieldInstanceRepository, updateFieldInstanceRepository, loadRowInstanceListRepository, addFormRowRepository, authorizationConstants, deleteFormRowRepository, deleteFormSummaryInstanceRepository, remoteFunctionRepository, formSnippetsRepository, formTemplateStatus, formInstanceRepository, closeFormRepository, loadUserDetailsRepository, formSnippetBlobRepository, classCodeFormatRepository, classCodeItemsRepository, classCodeGroupingsRepository, registrationRepository, formRegistrationModel, addDeleteRepeatingFormConfigRepository, formSummaryRepository, timingModel, formViewerConstant, uiFormTemplateRepository, dragModel, getUiFieldListRepository, currentUserModel, uuidUtil) {
  var pendingFieldRequestQueue = [],
    activeFieldRequest = false;
  this.getFormsByRootFormId = function (rootFormId) {
    var defer = $q.defer();
    persistentConnection.connect().then(function () {
      function handleSuccess(result) {
        defer.resolve(result);
      }
      function handleError(error) {
        defer.reject(error);
      }
      formRepository.getFormsByRootFormId(rootFormId).then(handleSuccess, handleError);
    });
    return defer.promise;
  };
  this.getFormInstanceById = function (formId) {
    return formInstanceRepository.getFormInstanceById(formId);
  };
  this.loadStaticForm = function (uiFormTemplateId) {
    timingModel.addMilestone(formViewerConstant.timing.FORM_VIEWER, formViewerConstant.timing.LOAD_DATA);
    uiFormTemplateRepository.getUiFormTemplateById(uiFormTemplateId).then(function (uiFormTemplate) {
      var hasManageFormsRole = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS);
      formViewerModel.buildStaticForm(uiFormTemplateId, uiFormTemplate, hasManageFormsRole);
    });
  };
  this.loadRootForm = function (formId, printPreview, effectiveDate, submissionId, currencyCode) {
    var _this = this;
    var formTemplateIdList, formInstanceIdList, formSummaryList, hasWriteAccess;
    timingModel.addMilestone(formViewerConstant.timing.FORM_VIEWER, formViewerConstant.timing.LOAD_DATA);
    this.getFormsByRootFormId(formId).then(function (rootFormResult) {
      formSummaryList = rootFormResult.formSummaries;
      hasWriteAccess = rootFormResult.hasWriteAccess;
      formTemplateIdList = _.map(formSummaryList, 'formTemplateId');
      formInstanceIdList = _.map(formSummaryList, function (formSummary) {
        return {
          formSummaryId: formSummary.id,
          objectUri: formSummary.objectUri
        };
      });
      _this.loadFormData(formId, formSummaryList, formTemplateIdList, formInstanceIdList, hasWriteAccess, false, printPreview, effectiveDate, submissionId, currencyCode);
    });
  };
  this.loadFormData = function (rootFormId, formSummaryList, formTemplateIdList, formInstanceIdList, hasWriteAccess, isSupplementalForm, printPreview, effectiveDate, submissionId, currencyCode) {
    var formRowInstanceList, uiFormTemplateList, fieldInstanceList;
    function loadRowInstanceList(formInstanceIdList) {
      var rowInstanceList = [],
        promiseList = [];
      _.each(formInstanceIdList, function (instance) {
        var promise = loadRowInstanceListRepository.loadRowInstanceList(instance.formSummaryId, instance.objectUri).then(function (result) {
          rowInstanceList = _.concat(rowInstanceList, result);
        });
        promiseList.push(promise);
      });

      // wait until all async calls are complete
      $q.all(promiseList).then(function () {
        formRowInstanceList = rowInstanceList;
        formTemplateRepository.loadUIFormTemplates(formTemplateIdList).then(function (result) {
          uiFormTemplateList = result;
          loadFieldInstanceList(formInstanceIdList);
        });
      });
    }
    function loadFieldInstanceList(formInstanceIdList) {
      var instanceList = [],
        promiseList = [];
      _.each(formInstanceIdList, function (instance) {
        var promise = loadFieldInstanceListRepository.loadFieldInstanceList(instance.formSummaryId, instance.objectUri).then(function (result) {
          if (!result) {
            result = [];
          }
          instanceList = _.concat(instanceList, result);
        });
        promiseList.push(promise);
      });

      // wait until all async calls are complete
      $q.all(promiseList).then(function () {
        fieldInstanceList = instanceList;
        function onAllFormDataReady() {
          timingModel.addMilestone(formViewerConstant.timing.FORM_VIEWER, formViewerConstant.timing.BEGIN_RENDERING);
          if (isSupplementalForm) {
            formViewerModel.addSupplementalForm(rootFormId, uiFormTemplateList, fieldInstanceList, formSummaryList, formRowInstanceList, hasWriteAccess, printPreview, currencyCode);
          } else {
            formSnippetsRepository.getFormSnippets(rootFormId).then(function (snippets) {
              formViewerModel.buildForm(rootFormId, uiFormTemplateList, fieldInstanceList, formSummaryList, formRowInstanceList, hasWriteAccess, printPreview, snippets, effectiveDate, submissionId, currencyCode);
            });
          }
        }
        $timeout(function () {
          onAllFormDataReady();
        }, 1, false);
      });
    }
    loadRowInstanceList(formInstanceIdList);
  };
  this.createSupplementalForm = function (form, formId, printPreview) {
    var formSummaryList = [form],
      hasWriteAccess = true,
      isSupplementalForm = true,
      formTemplateIdList = _.map(formSummaryList, 'formTemplateId'),
      formInstanceIdList = _.map(formSummaryList, function (formSummary) {
        return {
          formSummaryId: formSummary.id,
          objectUri: formSummary.objectUri
        };
      });
    this.loadFormData(formId, formSummaryList, formTemplateIdList, formInstanceIdList, hasWriteAccess, isSupplementalForm, printPreview);
  };
  this.deleteSupplementalForm = function (supplementalForm, rootFormId) {
    return formViewerModel.deleteSupplementalForm(supplementalForm, rootFormId);
  };
  this.processRootFormUpdate = function (rootForm, rootFormId) {
    formViewerModel.processRootFormUpdate(rootForm, rootFormId);
  };
  this.getFormStructure = function (rootFormId) {
    return formViewerModel.getFormStructure(rootFormId);
  };
  this.closeForm = function (rootFormId) {
    return closeFormRepository.closeForm(rootFormId);
  };
  this.importForms = function (submissionId, formId, uploadType, formTemplateName, file) {
    return formSummaryRepository.importForms(submissionId, formId, uploadType, formTemplateName, file);
  };
  this.loadFormTemplates = function (formTemplateIdList) {
    return formTemplateRepository.loadUIFormTemplates(formTemplateIdList);
  };
  this.createFieldInstance = function (formId, instance) {
    return createFieldInstanceRepository.createFieldInstance(formId, instance);
  };
  this.updateFieldInstance = function (formId, instance) {
    return updateFieldInstanceRepository.updateFieldInstance(formId, instance);
  };
  this.processFieldUpdate = function (fieldModel, rootFormId) {
    return formViewerModel.processFieldUpdate(fieldModel, rootFormId);
  };
  this.processFieldDelete = function (fieldModel, rootFormId) {
    return formViewerModel.processFieldDelete(fieldModel, rootFormId);
  };
  this.processFieldRename = function (fieldModel, rootFormId) {
    return formViewerModel.processFieldRename(fieldModel, rootFormId);
  };
  this.addRepeatingRow = function (formId, uiRowId, rowNumberOfLastRow) {
    return addFormRowRepository.addFormRow(formId, uiRowId, rowNumberOfLastRow);
  };
  this.deleteRepeatingRow = function (deleteRepeatingRows) {
    return deleteFormRowRepository.deleteFormRow(deleteRepeatingRows);
  };
  this.processRemoteRowDeletion = function (message, rootFormId) {
    var _this2 = this;
    formViewerModel.processRemoteRowDeletion(message.messagePayload, rootFormId);
    _.each(message.deleteFieldMessages, function (deleteFieldMessage) {
      _this2.processFieldDelete(deleteFieldMessage, rootFormId);
    });
    _.each(message.renameFieldMessages, function (renameFieldMessage) {
      _this2.processFieldRename(renameFieldMessage, rootFormId);
    });
    _.each(message.createFieldMessages, function (createFieldMessage) {
      _this2.processFieldUpdate(createFieldMessage, rootFormId);
    });
    _.each(message.updateFieldMessages, function (updateFieldMessage) {
      _this2.processFieldUpdate(updateFieldMessage, rootFormId);
    });
  };
  this.processRemoteRowAddition = function (message, rootFormId) {
    var _this3 = this;
    formViewerModel.processRemoteRowAddition(message.messagePayload.uiRowId, message.messagePayload, rootFormId);
    _.each(message.deleteFieldMessages, function (deleteFieldMessage) {
      _this3.processFieldDelete(deleteFieldMessage, rootFormId);
    });
    _.each(message.renameFieldMessages, function (renameFieldMessage) {
      _this3.processFieldRename(renameFieldMessage, rootFormId);
    });
    _.each(message.createFieldMessages, function (createFieldMessage) {
      _this3.processFieldUpdate(createFieldMessage, rootFormId);
    });
    _.each(message.updateFieldMessages, function (updateFieldMessage) {
      _this3.processFieldUpdate(updateFieldMessage, rootFormId);
    });
  };
  this.processRemoteRowUpdate = function (message, rootFormId) {
    var _this4 = this;
    if (message.messagePayload) {
      formViewerModel.processRemoteRowUpdate(message.messagePayload.uiRowId, message.messagePayload, rootFormId);
    }
    _.each(message.deleteFieldMessages, function (deleteFieldMessage) {
      _this4.processFieldDelete(deleteFieldMessage, rootFormId);
    });
    _.each(message.renameFieldMessages, function (renameFieldMessage) {
      _this4.processFieldRename(renameFieldMessage, rootFormId);
    });
    _.each(message.createFieldMessages, function (createFieldMessage) {
      _this4.processFieldUpdate(createFieldMessage, rootFormId);
    });
    _.each(message.updateFieldMessages, function (updateFieldMessage) {
      _this4.processFieldUpdate(updateFieldMessage, rootFormId);
    });
  };
  this.sortRowRepeater = function (rootFormId, rowRepeaterId, sortKey, sortType) {
    formViewerModel.sortRowRepeater(rootFormId, rowRepeaterId, sortKey, sortType);
  };
  this.processCollapsibleColumnsAndVisibility = function (rowRepeaterId, rootFormId) {
    formViewerModel.processCollapsibleColumnsAndVisibility(rowRepeaterId, rootFormId);
  };
  this.checkFieldRequestQueue = function () {
    if (pendingFieldRequestQueue.length > 0) {
      var nextRequest = _.head(pendingFieldRequestQueue);
      pendingFieldRequestQueue = _.drop(pendingFieldRequestQueue);
      this.makeFieldRequest(nextRequest.formId, nextRequest.fieldStructure, nextRequest.errorCallback, nextRequest.successCallback);
    }
  };
  this.makeFieldRequest = function (formId, fieldStructure, errorCallback, successCallback) {
    var _this5 = this;
    var hasFieldModel = !_.isUndefined(fieldStructure.fieldModel.id),
      newInstanceConfig;
    activeFieldRequest = true;
    function getFieldName() {
      var result = fieldStructure.uiField.fieldTemplate.variableName;
      if (fieldStructure.rowRepeaterId && fieldStructure.rowNumber > 0) {
        result += ':' + fieldStructure.rowNumber;
      }
      return result;
    }
    if (hasFieldModel) {
      this.updateFieldInstance(fieldStructure.fieldModel.id, fieldStructure.fieldModel).then(successCallback, errorCallback).finally(function () {
        activeFieldRequest = false;
        _this5.checkFieldRequestQueue();
      });
    } else {
      newInstanceConfig = {
        name: getFieldName(),
        value: fieldStructure.fieldModel.value,
        formId: formId
      };
      if (fieldStructure.fieldModel.valueLabel) {
        newInstanceConfig.valueLabel = fieldStructure.fieldModel.valueLabel;
      }
      this.createFieldInstance(formId, newInstanceConfig).then(successCallback, errorCallback).finally(function () {
        activeFieldRequest = false;
        _this5.checkFieldRequestQueue();
      });
    }
  };
  this.handleFieldChange = function (formId, fieldStructure, errorCallback, successCallback) {
    if (activeFieldRequest) {
      pendingFieldRequestQueue.push({
        formId: formId,
        fieldStructure: fieldStructure,
        errorCallback: errorCallback,
        successCallback: successCallback
      });
    } else {
      this.makeFieldRequest(formId, fieldStructure, errorCallback, successCallback);
    }
  };
  this.setDelayShowNextRequiredField = function (value) {
    delayShowNextRequiredFieldModel.setDelayShowNextRequiredField(value);
  };
  this.isDelayShowNextRequiredField = function () {
    return delayShowNextRequiredFieldModel.isDelayShowNextRequiredField();
  };
  this.resetDelayShowNextRequiredField = function () {
    delayShowNextRequiredFieldModel.reset();
  };
  this.addFormSummaryRow = function (formId, submissionId, formTemplateName, addFormInstanceFunctionButtonExecutorName) {
    var params = {
      formTemplateName: formTemplateName
    };
    if (!addFormInstanceFunctionButtonExecutorName) {
      addFormInstanceFunctionButtonExecutorName = 'addFormInstanceFunctionButtonExecutor';
    }
    return remoteFunctionRepository.executeFunction(formId, submissionId, addFormInstanceFunctionButtonExecutorName, null /*fieldId*/, params);
  };
  this.deleteFormSummaryRow = function (formId) {
    return deleteFormSummaryInstanceRepository.deleteFormSummaryRow(formId);
  };
  this.shouldProcessForm = function (rootFormId, eventFormId) {
    return formViewerModel.shouldProcessForm(rootFormId, eventFormId);
  };
  this.getFormSnippets = function (rootFormId) {
    return formSnippetsRepository.getFormSnippets(rootFormId);
  };
  this.getSnippetBlob = function (snippetId) {
    return formSnippetBlobRepository.getSnippetBlob(snippetId);
  };
  this.executeFunction = function (formId, submissionId, beanName, fieldId, paramMap) {
    return remoteFunctionRepository.executeFunction(formId, submissionId, beanName, fieldId, paramMap);
  };
  this.getClassCodeItems = function (type, query, effectiveDate) {
    return classCodeItemsRepository.getClassCodeItems(type, query, effectiveDate);
  };
  this.getClassCodeItemsNoDate = function (type, query) {
    return classCodeItemsRepository.getClassCodeItemsNoDate(type, query);
  };
  this.getClassCodeGroupings = function (type, effectiveDate) {
    return classCodeGroupingsRepository.getClassCodeGroupings(type, effectiveDate);
  };
  this.getClassCodeFormat = function (classCodeType) {
    return classCodeFormatRepository.getClassCodeFormat(classCodeType);
  };
  this.getFormSummaryAddDeleteConfigByFormSummaryInstanceId = function (formId, formSummaryInstanceId) {
    return addDeleteRepeatingFormConfigRepository.getAddDeleteConfigByFormSummaryInstanceId(formId, formSummaryInstanceId);
  };
  this.getFormSummaryAddDeleteConfigByFormSummaryGridFieldName = function (formId, formSummaryGridFieldName) {
    return addDeleteRepeatingFormConfigRepository.getAddDeleteConfigByFormSummaryGridFieldName(formId, formSummaryGridFieldName);
  };
  this.updateFieldStructureConfiguration = function (fieldStructure, suppressFormEvents) {
    return formViewerModel.updateFieldStructureConfiguration(fieldStructure, suppressFormEvents);
  };
  this.unregisterForm = function (formId) {
    formViewerModel.resetForm(formId);
    _.each(formRegistrationModel.getRegistrations(formId), function (url) {
      registrationRepository.deleteRegistration(url);
    });
    formRegistrationModel.removeRegistrations(formId);
  };
  this.createField = function (rootFormId, dropConfiguration, dropZoneFieldId) {
    return formViewerModel.createField(rootFormId, dropConfiguration, dropZoneFieldId);
  };
  this.moveField = function (rootFormId, elementToMoveId, dropZoneFieldId, moveType) {
    return formViewerModel.moveField(rootFormId, elementToMoveId, dropZoneFieldId, moveType);
  };
  this.moveSection = function (rootFormId, elementToMoveSectionId, dropZoneSectionId, moveType) {
    return formViewerModel.moveSection(rootFormId, elementToMoveSectionId, dropZoneSectionId, moveType);
  };
  this.moveRow = function (rootFormId, elementToMoveRowId, dropZoneRowId, moveType) {
    return formViewerModel.moveRow(rootFormId, elementToMoveRowId, dropZoneRowId, moveType);
  };
  this.createSection = function (rootFormId, dropConfiguration, dropZoneFieldId, insertLocation) {
    return formViewerModel.createSection(rootFormId, dropConfiguration, dropZoneFieldId, insertLocation);
  };
  this.createRowRepeater = function (rootFormId, dropConfiguration, dropZoneRowId, insertLocation) {
    return formViewerModel.createRowRepeater(rootFormId, dropConfiguration, dropZoneRowId, insertLocation);
  };
  this.updateUiFormTemplate = function (uiFormTemplate, id) {
    return uiFormTemplateRepository.updateFormTemplate(uiFormTemplate, id);
  };
  this.deleteField = function (rootFormId, formStructureId) {
    return formViewerModel.deleteField(rootFormId, formStructureId);
  };
  this.deleteSection = function (rootFormId, sectionStructureId) {
    formViewerModel.deleteSection(rootFormId, sectionStructureId);
  };
  this.deleteRow = function (rootFormId, rowStructureId) {
    formViewerModel.deleteRow(rootFormId, rowStructureId);
  };
  this.findReferenceCountByFieldTemplateId = function (fieldTemplateId) {
    return uiFormTemplateRepository.findReferenceCountByFieldTemplateId(fieldTemplateId);
  };
  this.getCurrentDragItem = function () {
    return dragModel.getCurrentDragItem();
  };
  this.setCurrentDragItem = function (newDragConfig) {
    dragModel.setCurrentDragItem(newDragConfig);
  };
  this.getUiFieldList = function (formTemplateType) {
    return getUiFieldListRepository.getUiFieldList(formTemplateType);
  };
  this.getUiFieldByType = function (uiFieldType, formTemplateType) {
    var defer = $q.defer(),
      uiField;
    this.getUiFieldList(formTemplateType).then(function (uiFieldMap) {
      uiField = _.cloneDeep(uiFieldMap[uiFieldType]);
      uiField.id = -1;
      uiField.fieldTemplate.id = -1;
      uiField.fieldTemplate.variableName = 'let_' + uuidUtil.generateUUID();
      defer.resolve(uiField);
    });
    return defer.promise;
  };
  this.getUiFormStructureList = function () {
    return getUiFieldListRepository.getUiFormStructureList();
  };
  this.buildRowRepeaterTemplate = function (formTemplateType) {
    var defer = $q.defer(),
      promiseList = [],
      uiFormStructureList,
      uiFieldList,
      uiRowTemplate,
      uiRowRepeaterTemplate,
      uiTextInputTemplate;
    promiseList.push(this.getUiFormStructureList().then(function (result) {
      uiFormStructureList = result;
    }));
    promiseList.push(this.getUiFieldList(formTemplateType).then(function (result) {
      uiFieldList = result;
    }));
    promiseList.push(this.getUiFieldByType(fieldType.ROWREPEATER, formTemplateType).then(function (result) {
      uiRowRepeaterTemplate = result;
    }));
    promiseList.push(this.getUiFieldByType(fieldType.TEXT_INPUT, formTemplateType).then(function (result) {
      uiTextInputTemplate = result;
      uiTextInputTemplate.hideLabel = true;
    }));
    $q.all(promiseList).then(function () {
      uiRowTemplate = uiFormStructureList[formViewerConstant.configuration.formStructureType.ROW_REPEATER];
      uiRowTemplate.id = -1;
      uiRowTemplate.ordering = 0;
      uiRowTemplate.repeaterField = uiRowRepeaterTemplate;
      uiRowTemplate.fields = [uiTextInputTemplate, uiRowTemplate.repeaterField];
      defer.resolve(_.cloneDeep(uiRowTemplate));
    });
    return defer.promise;
  };
  this.buildEmptySectionTemplate = function (formTemplateType) {
    var defer = $q.defer();
    this.buildNewUiSectionList(formTemplateType).then(function (sectionList) {
      defer.resolve(_.cloneDeep(sectionList[0]));
    });
    return defer.promise;
  };
  this.buildEmptyUiRowTemplate = function () {
    var defer = $q.defer();
    this.getUiFormStructureList().then(function (uiFormStructureList) {
      var uiRowTemplate = _.clone(uiFormStructureList[formViewerConstant.configuration.formStructureType.ROW]);
      uiRowTemplate.id = -1;
      defer.resolve(uiRowTemplate);
    });
    return defer.promise;
  };
  this.buildNewUiSectionList = function (formTemplateType) {
    var _this6 = this;
    var defer = $q.defer(),
      sections = [],
      promiseList = [],
      uiFormStructureList,
      uiFieldList,
      uiSectionTemplate,
      uiRowTemplate;
    promiseList.push(this.getUiFormStructureList().then(function (result) {
      uiFormStructureList = result;
    }));
    promiseList.push(this.getUiFieldList(formTemplateType).then(function (result) {
      uiFieldList = result;
    }));
    $q.all(promiseList).then(function () {
      uiSectionTemplate = _.clone(uiFormStructureList[formViewerConstant.configuration.formStructureType.SECTION]);
      uiRowTemplate = _.clone(uiFormStructureList[formViewerConstant.configuration.formStructureType.ROW]);
      _this6.getUiFieldByType(fieldType.LABEL, formTemplateType).then(function (uiField) {
        uiRowTemplate.id = -1;
        uiRowTemplate.ordering = 0;
        uiRowTemplate.fields.push(uiField);
        uiSectionTemplate.id = -1;
        uiSectionTemplate.ordering = 0;
        uiSectionTemplate.rows.push(uiRowTemplate);
        sections.push(uiSectionTemplate);
        defer.resolve(sections);
      });
    });
    return defer.promise;
  };
  this.clearIdsFromSectionList = function (sections) {
    _.each(sections, function (section) {
      delete section.id;
      _.each(section.rows, function (row) {
        delete row.id;
        _.each(row.fields, function (field) {
          delete field.id;
          delete field.fieldTemplate.id;
        });
      });
    });
  };
};
FormMediator.$inject = ["$q", "$timeout", "delayShowNextRequiredFieldModel", "formRepository", "formTemplateRepository", "persistentConnection", "fieldType", "loadFieldInstanceListRepository", "formViewerModel", "createFieldInstanceRepository", "updateFieldInstanceRepository", "loadRowInstanceListRepository", "addFormRowRepository", "authorizationConstants", "deleteFormRowRepository", "deleteFormSummaryInstanceRepository", "remoteFunctionRepository", "formSnippetsRepository", "formTemplateStatus", "formInstanceRepository", "closeFormRepository", "loadUserDetailsRepository", "formSnippetBlobRepository", "classCodeFormatRepository", "classCodeItemsRepository", "classCodeGroupingsRepository", "registrationRepository", "formRegistrationModel", "addDeleteRepeatingFormConfigRepository", "formSummaryRepository", "timingModel", "formViewerConstant", "uiFormTemplateRepository", "dragModel", "getUiFieldListRepository", "currentUserModel", "uuidUtil"];
angular.module('umFormViewer').service('formMediator', FormMediator);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FormViewerUtil = function FormViewerUtil(localization, dateUtil, formTemplateType) {
  this.findPrecedingFieldRowForSupplementalForm = function (precedingFieldVariableName, precedingFormTemplateUniqueName, sectionList) {
    var precedingFieldInfo;
    function searchSections(sectionList) {
      _.each(sectionList, function (section) {
        return searchRows(section.rowList, section, precedingFormTemplateUniqueName);
      });
    }
    function searchRows(rowList, section, precedingFormTemplateUniqueName) {
      _.each(rowList, function (row, index) {
        var isRepeatingRow = !_.isNil(row.rowList);
        if (section.parentUiFormTemplate.formTemplate.uniqueName === precedingFormTemplateUniqueName) {
          searchFields(row.fieldStructureList, index, section);
          if (isRepeatingRow) {
            _.each(row.rowList, function (row) {
              searchFields(row.fieldStructureList, index, section);
            });
          }
        }
        if (row.sectionList) {
          searchSections(row.sectionList);
        }
      });
    }
    function searchFields(fieldStructureList, precedingFieldRowIndex, section) {
      _.each(fieldStructureList, function (fieldStructure) {
        if (fieldStructure.uiField.fieldTemplate.variableName === precedingFieldVariableName) {
          precedingFieldInfo = {};
          precedingFieldInfo.precedingFieldRow = section.rowList[precedingFieldRowIndex];
          precedingFieldInfo.precedingFieldRowIndex = precedingFieldRowIndex;
          precedingFieldInfo.precedingFieldSection = section;
        }
      });
    }
    searchSections(sectionList);
    return precedingFieldInfo;
  };
  this.findLastFieldInPreviousRowKey = function (previousRow) {
    var lastFieldInRow = previousRow.rowTemplate.fields[previousRow.rowTemplate.fields.length - 1],
      key = lastFieldInRow.fieldTemplate.id + '-' + previousRow.rowModel.id;
    return key;
  };
  this.isFormVisible = function (currentWizardStep, currentSubmission, formIndex) {
    if (currentWizardStep === 'createSubmission' && currentSubmission.forms[formIndex].form.formTemplate.type !== formTemplateType.SUBMISSION) {
      return false;
    }
    return true;
  };
};
FormViewerUtil.$inject = ["localization", "dateUtil", "formTemplateType"];
angular.module('umFormViewer').service('formViewerUtil', FormViewerUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/formViewer/formViewer.tpl.html';
var html = "<div class=\"formViewerContainer {{ formData.formName }}\"\n     ng-class=\"{\n        wrap: formData.hasResponsiveLayout,\n        autoHeight: formData.autoHeight\n     }\"\n     ui-focus-manager=\"{{ formData.formName }}\"\n     ui-viewport-manager=\"{{ supplemental }}\"\n     ui-next-required-field-finder=\"{{ supplemental }}\"\n     ui-show-hidden-field-details-modal>\n\n    <um-form-viewer-debugger ng-if=\"!supplemental\"\n                             form-name=\"formData.formName\"\n                             ui-debugger-directive>\n    </um-form-viewer-debugger>\n\n    <!--Form Viewer Required Fields-->\n    <div class=\"formHeader\" ng-if=\"!supplemental\" ng-show=\"!isLoading\">\n\n        <div ng-if=\"displayFormName\"\n             class=\"formName\">\n            {{ formData.formModel.dynamicName ? formData.formModel.dynamicName :\n            formData.formModel.formTemplateDisplayName }}\n        </div>\n\n        <ng-transclude class=\"transcludeContainer\"></ng-transclude>\n\n        <div class=\"printForm\"\n             ng-if=\"showPrintIcon()\">\n            <a class=\"btn btn-link\"\n               ng-click=\"printForm()\"\n               uib-tooltip=\"{{ ::printFormTooltip }}\"\n               tooltip-popup-delay=\"500\"\n               tooltip-append-to-body=\"true\"\n               tooltip-placement=\"left\">\n                <span class=\"glyphicon glyphicon-print\"></span>\n            </a>\n        </div>\n\n        <div class=\"formViewerRequiredFields\"\n             data-target=\".mainContent\"\n             ng-if=\"formData.formModel.totalRequiredFieldCount > 0 && !formData.formModel.printPreview\"\n             ng-click=\"showNextRequiredField()\">\n\n            Please complete <span class=\"requiredFieldsTotal\"><b>{{ formData.formModel.totalRequiredFieldCount }}</b> field</span><span\n            class=\"requiredFieldsTotal\"\n            ng-show=\"formData.formModel.totalRequiredFieldCount > 1\">s</span>\n            <span class=\"glyphicon glyphicon-asterisk\"></span>\n        </div>\n    </div>\n\n    <div class=\"lazyLoadPreloader\" ng-if=\"showLazyLoadingSpinner\">\n        <img src=\"" + __webpack_require__(1079) + "\"\n             class=\"icon-formViewerPreloaderShort\">\n    </div>\n\n    <img ng-if=\"isLoading\"\n         src=\"" + __webpack_require__(1080) + "\"\n         class=\"icon-formViewerPreloader formViewerPreloader\">\n\n    <ui-form-tooltip></ui-form-tooltip>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a56d109ba7caae7b03b0db3ebeb8b393.svg";

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7e996fdb62018a28f83d661d3d2901b1.svg";

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var BaseDataSetFormComponentController = function BaseDataSetFormComponentController($scope, $q, $stateParams, coreMediator, formComponentUtil, formViewerConstant, dataSetType, dataSetUtil) {
  this.supportSearch = false;
  this.searchText = null;
  this.dataSetCount = null;
  this.showLoadingSpinner = false;
  this.setSearchText = function (searchText) {
    this.searchText = searchText;
  };
  this.isRowRepeater = function () {
    return _.isPlainObject(this.fieldStructure.rowRepeaterTemplate) && _.isPlainObject(this.fieldStructure.rowRepeaterModel);
  };
  this.onInitDataSetComponent = function (dataSetImmediateLoad, preventDataSetLoadIfConfigurableComponent) {
    var uiField = this.fieldStructure.uiField;
    var isConfigurableForm = this.fieldStructure.parentFormStructure && this.fieldStructure.parentFormStructure.isConfigurableForm;
    this.hideLabel = _.isNil(this.fieldStructure.hideLabel) ? this.hideLabel : this.fieldStructure.hideLabel;
    this.itemsList = [{}];
    this.dataSetName = uiField.fieldTemplate.dataSetName;
    if (!_.isEmpty(this.dataSetName)) {
      this.type = dataSetUtil.getDataSetType(this.dataSetName);
      if (preventDataSetLoadIfConfigurableComponent && isConfigurableForm) {
        return $q.when();
      } else if (!preventDataSetLoadIfConfigurableComponent && isConfigurableForm) {
        return this.loadConfigurableFormDataSet(dataSetImmediateLoad);
      } else {
        return this.loadDataSet(dataSetImmediateLoad);
      }
    } else {
      return $q.when();
    }
  };
  this.loadConfigurableFormDataSet = function () {
    var _this = this;
    return coreMediator.getRemoteDataSetByName(this.dataSetName).then(function (dataSet) {
      _this.setItemsList(dataSet.items);
    });
  };
  this.loadDataSet = function (dataSetImmediateLoad) {
    var _this2 = this;
    var isConfigurableForm = this.fieldStructure.parentFormStructure && this.fieldStructure.parentFormStructure.isConfigurableForm;
    if (dataSetImmediateLoad && !isConfigurableForm) {
      this.showLoadingSpinner = true;
      return coreMediator.getCachedDataSetByName(this.dataSetName).then(function (dataSet) {
        if (_this2.type === dataSetType.STATIC) {
          _this2.showLoadingSpinner = false;
          _this2.setItemsList(dataSet.items);
        } else {
          _this2.supportSearch = dataSet.supportSearch;
          _this2.minimumSearchLength = dataSet.minSearchStringLength;
          if (!_this2.supportSearch || _this2.searchText && _this2.searchText.length >= dataSet.minSearchStringLength) {
            var formId = _this2.fieldStructure.parentForm.id;
            _this2.dynamicDataSetParams = dataSetUtil.getDataSetParamsByFieldStructure(dataSet, _this2.fieldStructure, _this2.searchText);
            if (_this2.supportSearch) {
              return coreMediator.getDynamicDataSet(_this2.dynamicDataSetParams, formId).then(function (dataSet) {
                _this2.dataSetCount = dataSet.count;
                _this2.setItemsList(dataSet.items);
              }).finally(function () {
                _this2.showLoadingSpinner = false;
              });
            } else {
              return dataSetUtil.getDataItems(_this2.dynamicDataSetParams, formId).then(function (items) {
                _this2.setItemsList(items);
              }).finally(function () {
                _this2.showLoadingSpinner = false;
              });
            }
          } else {
            _this2.showLoadingSpinner = false;
          }
        }
      });
    } else {
      return $q.when();
    }
  };
  this.shouldUpdateItems = function (updateEvent, data) {
    if (!this.dynamicDataSetParams) {
      return false; // not yet initialized
    }
    var isCurrentComponent = !this.isRowRepeater() && _.isEmpty(data.dynamicDataSetKey.formRowUri) || this.dynamicDataSetParams.formRowUri === data.dynamicDataSetKey.formRowUri;
    var isDataSetName = data.name === this.dataSetName;
    var isDataSetVariableName = this.dynamicDataSetParams.variableName === data.dynamicDataSetKey.variableName;
    return isCurrentComponent && isDataSetName && isDataSetVariableName;
  };
  this.setItemsList = function (itemsList) {
    this.itemsList = _.cloneDeep(itemsList);
  };
  this.isItemsListEmpty = function () {
    return this.itemsList.length === 0 || this.itemsList.length === 1 && _.isEmpty(this.itemsList[0]);
  };
};
BaseDataSetFormComponentController.$inject = ["$scope", "$q", "$stateParams", "coreMediator", "formComponentUtil", "formViewerConstant", "dataSetType", "dataSetUtil"];
angular.module('umFormViewer').controller('baseDataSetFormComponentController', BaseDataSetFormComponentController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var BaseFormComponentController = function BaseFormComponentController($scope, $rootScope, formComponentUtil, formViewerConstant, formMediator, coreConstant, formatUtil) {
  this.onInit = function () {
    var fieldInstance = this.fieldStructure.fieldModel;
    this.hideLabel = _.isNil(this.fieldStructure.hideLabel) ? this.hideLabel : this.fieldStructure.hideLabel;
    this.origFieldValue = fieldInstance ? fieldInstance.value : '';
    this.configurationClass = this.fieldStructure.isConfigurableComponent ? 'configurableComponent' : '';
  };
  this.onChanges = function () {
    var fieldInstance = this.fieldStructure.fieldModel;
    var hasValueChange = fieldInstance ? this.origFieldValue !== fieldInstance.value : false;
    this.hideLabel = _.isNil(this.fieldStructure.hideLabel) ? this.hideLabel : this.fieldStructure.hideLabel;
    if (!this.fieldStructure.hasLocalChanges && hasValueChange) {
      $scope.$broadcast(formViewerConstant.event.SHOW_REMOTE_FIELD_NOTIFICATION);
    }
    this.origFieldValue = fieldInstance ? fieldInstance.value : '';
    this.fieldStructure.hasLocalChanges = false;
  };
  this.updateOriginalFieldValue = function () {
    this.origFieldValue = this.fieldStructure.fieldModel.value;
  };
  this.resetFieldValue = function () {
    this.fieldStructure.fieldModel.value = this.origFieldValue;
  };
  this.getComponentClassName = function (uiField) {
    return "formFieldComponent-".concat(formatUtil.formatAsSelector(uiField.fieldTemplate.variableName));
  };
  this.getComponentId = function (uiField) {
    return uiField.fieldTemplate.variableName;
  };
  this.updateFieldValue = function () {
    if (this.fieldStructure.hasLocalChanges) {
      formMediator.handleFieldChange(this.fieldStructure.parentForm.id, this.fieldStructure, this.resetFieldValue.bind(this), this.updateOriginalFieldValue.bind(this));
    }
  };
  this.handleFocus = function () {
    $rootScope.$broadcast(formViewerConstant.event.FOCUSED_FIELD_CHANGED, this.fieldStructure);
  };
  this.mouseEnter = function (event, fieldStructure) {
    var componentParams = {
      pageX: event.pageX,
      pageY: event.pageY,
      offsetX: event.offsetX,
      offsetY: event.offsetY,
      clientWidth: event.currentTarget.clientWidth,
      fieldStructure: fieldStructure,
      tooltipMessage: fieldStructure.uiField.tooltipText
    };
    if (!_.isNil(fieldStructure.dynamicProperties.tooltip) && !_.isNil(fieldStructure.dynamicProperties.tooltip.message)) {
      componentParams.tooltipMessage = fieldStructure.dynamicProperties.tooltip.message;
    }
    if (!_.isNil(componentParams.tooltipMessage)) {
      $rootScope.$broadcast(coreConstant.event.SHOW_FORM_TOOLTIP, componentParams);
    }
  };
  this.mouseLeave = function () {
    $rootScope.$broadcast(coreConstant.event.HIDE_FORM_TOOLTIP);
  };
};
BaseFormComponentController.$inject = ["$scope", "$rootScope", "formComponentUtil", "formViewerConstant", "formMediator", "coreConstant", "formatUtil"];
angular.module('umFormViewer').controller('baseFormComponentController', BaseFormComponentController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, moment) {/*@ngInject*/
var FormComponentUtil = function FormComponentUtil(xmlUtil, localization, numberFilter, currencyFilter, coreMediator, appTypeConfigurationModel, editableFieldLevel, currencyUtil, fieldType, preferenceModel) {
  var TOOLTIP_POPOVER = 'tooltipPopover',
    ERROR_POPOVER = 'errorPopover',
    errorDelay = 50,
    tooltipDelay = 500,
    shortDateFormat = coreMediator.getPreferenceByName('view.shortDateFormat'),
    translations = {};
  localization.getTranslations().then(function (result) {
    translations = result;
  });
  this.buildLayoutProperties = function (uiField, groupItems) {
    var isLeftAligned = uiField.labelAlignment === 'left',
      isCheckbox = uiField.fieldTemplate.type === fieldType.CHECK_BOX,
      result = {};
    result.labelWidth = uiField.labelWidth;
    result.isLabelLeftAligned = isLeftAligned;
    result.inputWidth = isCheckbox ? 65 : uiField.minWidth;
    result.inputHeight = uiField.height;
    result.hasBusinessCard = uiField.hasBusinessCard;
    result.hasOrganizationCard = uiField.hasOrganizationCard;
    return result;
  };
  this.getGroupItemWidth = function (layout, groupItems) {
    var groupItemWidth = 0;
    if (layout.inputWidth > 0 && groupItems && groupItems.length > 0) {
      var maxLengthString = '',
        itemWidth;
      _.each(groupItems, function (groupItem) {
        if (!_.isEmpty(groupItem) && groupItem.name.length > maxLengthString.length) {
          //make sure the length is really the longer, based on characters width
          itemWidth = getTextWidth(groupItem.name, null);
          if (itemWidth > groupItemWidth) {
            maxLengthString = groupItem.name;
            groupItemWidth = itemWidth;
          }
        }
      });
      groupItemWidth = _.toString(groupItemWidth + 32) + 'px';
    } else {
      groupItemWidth = '';
    }
    return groupItemWidth;
  };

  /**
   * Uses canvas.measureText to compute and return the width of the given text of given font in pixels.
   *
   * @param {String} text The text to be rendered.
   * @param {String} font The css font descriptor that text is to be rendered with (e.g. 'bold 14px verdana').
   *
   * @see http://stackoverflow.com/questions/118241/calculate-text-width-with-javascript/21015393#21015393
   */
  function getTextWidth(text, font) {
    // re-use canvas object for better performance
    var canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement('canvas'));
    var context = canvas.getContext('2d');
    context.font = font ? font : '11px Arial';
    var metrics = context.measureText(text);
    return metrics.width;
  }
  this.isFieldRequired = function (form, fieldModel, fieldTemplate) {
    var requiredFieldLevel = fieldModel && fieldModel.requiredFieldLevel >= 0 ? fieldModel.requiredFieldLevel : fieldTemplate.requiredFieldLevel;
    return requiredFieldLevel > 0 && requiredFieldLevel <= form.requiredFieldLevel;
  };
  this.isValidField = function (fieldModel) {
    var result = true;
    if (fieldModel) {
      result = fieldModel.valid !== false;
    }
    return result;
  };
  this.isFieldDisabled = function (form, fieldInstance, fieldTemplate, hasWriteAccess) {
    var isFieldDisabled = fieldInstance ? fieldInstance.disabled : false,
      fieldTemplateEditableFieldLevel = appTypeConfigurationModel.isUnderwriterWorkstation() ? fieldTemplate.carrierEditableFieldLevel : fieldTemplate.agencyEditableFieldLevel,
      isFieldLevelDisabled = form.editableFieldLevel > fieldTemplateEditableFieldLevel && fieldTemplateEditableFieldLevel !== editableFieldLevel.ALWAYS_EDITABLE,
      isFormDisabled = isFieldLevelDisabled || form.readOnly || form.printPreview;
    return isFieldDisabled || isFormDisabled || !hasWriteAccess;
  };
  this.isFieldHidden = function (fieldInstance, fieldTemplate) {
    var result = false,
      templateHiddenForUserType = appTypeConfigurationModel.isUnderwriterWorkstation() ? !fieldTemplate.carrierVisible : !fieldTemplate.agencyVisible;
    if (templateHiddenForUserType) {
      result = true;
    } else {
      if (fieldTemplate.hidden) {
        result = true;
      }
      if (fieldInstance && fieldInstance.hidden) {
        result = true;
      } else if (fieldInstance && !fieldInstance.hidden) {
        result = false;
      }
    }
    return result;
  };
  this.getTooltip = function (fieldInstance, uiField, hasChanges, currencyCode) {
    var result,
      errorMessage = this.getErrorMessage(fieldInstance, uiField, hasChanges, currencyCode);
    if (errorMessage) {
      result = {
        type: ERROR_POPOVER,
        delay: errorDelay,
        message: errorMessage
      };
    } else {
      result = {
        type: TOOLTIP_POPOVER,
        delay: tooltipDelay,
        message: uiField.tooltipText
      };
    }
    return result;
  };
  this.setupFieldProperties = function (fieldStructure, currencyCode) {
    if (fieldStructure) {
      var form = fieldStructure.parentForm,
        uiField = fieldStructure.uiField,
        fieldInstance = fieldStructure.fieldModel,
        fieldTemplate = fieldStructure.uiField.fieldTemplate;
      fieldStructure.dynamicProperties = {};
      fieldStructure.dynamicProperties.hasValue = fieldInstance ? !_.isEmpty(fieldInstance.value) : false;
      fieldStructure.dynamicProperties.isRequired = this.isFieldRequired(form, fieldInstance, fieldTemplate);
      fieldStructure.dynamicProperties.isValid = this.isValidField(fieldInstance);
      fieldStructure.dynamicProperties.disabled = this.isFieldDisabled(form, fieldInstance, fieldTemplate, form.hasWriteAccess);
      fieldStructure.dynamicProperties.hidden = this.isFieldHidden(fieldInstance, fieldTemplate);
      fieldStructure.dynamicProperties.tooltip = this.getTooltip(fieldInstance, uiField, fieldStructure.hasLocalChanges, currencyCode);
      fieldStructure.layout = this.buildLayoutProperties(uiField);
      fieldStructure.requiredIndicatorLabelConfig = {
        required: fieldStructure.dynamicProperties.isRequired,
        valid: fieldStructure.dynamicProperties.isValid,
        hasValue: fieldStructure.dynamicProperties.hasValue,
        label: fieldStructure.uiField.displayLabel,
        width: fieldStructure.layout.labelWidth,
        bold: _.toLower(uiField.labelFontStyle) === 'bold',
        variableName: fieldStructure.uiField.fieldTemplate.variableName
      };
    }
  };
  this.getErrorMessage = function (fieldInstance, uiField, hasLocalChanges, currencyCode) {
    var errorCode = fieldInstance ? fieldInstance.validationErrorCode : -1,
      errorMessage,
      dynamicMessageValues = xmlUtil.parseString(uiField.fieldTemplate.validatorProperty),
      tooltip = uiField.tooltipText,
      fieldValidator = uiField.fieldTemplate.validator;
    function processRangeMessage() {
      // Handle cases where fromNum isn't defined, defaulting to 0
      var fromNum = dynamicMessageValues.fromNum || '0',
        toNum = dynamicMessageValues.toNum,
        currencyFormat = currencyUtil.getCurrencyFormat(currencyCode);
      if (fieldValidator === 'currency') {
        fromNum = currencyFilter(parseInt(fromNum), currencyFormat.symbol, 0, currencyFormat.suffixSymbol, currencyFormat.customFormat);
        toNum = currencyFilter(parseInt(toNum), currencyFormat.symbol, 0, currencyFormat.suffixSymbol, currencyFormat.customFormat);
      } else {
        if (!_.isNil(fromNum)) {
          fromNum = numberFormatter(fromNum);
        }
        if (!_.isNil(toNum)) {
          toNum = numberFormatter(toNum);
        }
      }
      errorMessage = _.replace(errorMessage, '{0}', fromNum);
      errorMessage = _.replace(errorMessage, '{1}', toNum);
    }
    function buildMessage() {
      errorMessage = _.get(translations, 'formsViewer.errors.' + errorCode) || '';
      if (errorCode === 'noMatch' && tooltip) {
        errorMessage = errorMessage + ' - ' + tooltip;
      } else if (errorMessage) {
        errorMessage = errorMessage + '.';
      }
    }
    function processDynamicValues() {
      switch (errorCode) {
        case 'amountOutOfRange':
        case 'numberOutOfRange':
        case 'percentageOutOfRange':
          processRangeMessage();
          break;
        case 'wrongDateFormat':
          errorMessage = _.replace(errorMessage, '{0}', shortDateFormat);
          break;
      }
    }
    function numberFormatter(number) {
      number = parseFloat(number).toString();
      if (number.indexOf('.') !== -1) {
        var numberWithDecimal = _.split(number, '.');
        /* Specific scenario to handle tooltip when number range validator is given like -0.01.
        Numberfilter is changing -0 to 0 and it results in wrong tooltip. To avoid this, -0 is being skipped from formatting*/
        if (numberWithDecimal[0] !== '-0') {
          numberWithDecimal[0] = numberFilter(numberWithDecimal[0], 0);
        }
        number = numberWithDecimal[0] + '.' + numberWithDecimal[1];
      } else {
        number = numberFilter(number, 0);
      }
      return number;
    }
    buildMessage();
    processDynamicValues();
    return errorMessage;
  };
  this.formatDateWithDefaultPreferences = function (date, isAmPm, utc) {
    var isValid = date ? moment(new Date(date)).isValid() : false,
      result = date,
      formatWith = isAmPm ? shortDateFormat + ' hh:mm A' : shortDateFormat,
      momentObject;
    if (isValid) {
      momentObject = moment(new Date(date));
      if (utc) {
        momentObject = momentObject.utc();
      }
      result = momentObject.format(formatWith);
    } else {
      result = undefined;
    }
    return result;
  };
  this.parseDateWithDefaultPreferences = function (date, isAmPm, utc) {
    var dateArray, momentObject;
    if (shortDateFormat === 'DD/MM/YYYY') {
      dateArray = _.split(date, '/');
      date = dateArray[1] + '/' + dateArray[0] + '/' + dateArray[2];
    }
    var formatWith = isAmPm ? shortDateFormat + ' hh:mm A' : shortDateFormat,
      isValid = moment(date, formatWith).isValid() && moment(new Date(date)).isAfter('1900-01-01T12:00:00Z') && moment(new Date(date)).isBefore('2100-01-01T12:00:00Z') && date.length >= 8,
      result = date;
    if (isValid) {
      momentObject = moment(new Date(date));
      if (utc) {
        momentObject = momentObject.utc();
      }
      result = momentObject.format(formatWith);
    } else {
      result = undefined;
    }
    return result;
  };
  this.formatDateForServer = function (date, isAmPm, utc) {
    var isValid = date ? moment(new Date(date)).isValid() : false,
      result = date,
      formatWith = isAmPm ? 'MM/DD/YYYY hh:mm A ZZ' : 'MM/DD/YYYY',
      momentObject;
    if (isValid) {
      momentObject = moment(new Date(date));
      if (utc) {
        momentObject = momentObject.utc();
      }
      result = momentObject.format(formatWith);
    } else {
      result = undefined;
    }
    return result;
  };
  this.formatCurrencyForRounding = function (value) {
    var currencySeparatorIsPeriod = preferenceModel.get('view.currencySeparator'),
      //Only remove $ if found, otherwise invalid, other symbols for the preference 'system.currencyCode' are not supported
      valueWithoutCurrencySymbol = value.substring(0, 1) === '$' ? value.substring(1) : value,
      //2nd find currency separator and if currency separator is in value format (matches regEX looking for separators for valid currency format)
      isValidCurrencyFormat = currencySeparatorIsPeriod === 'true' ? !!valueWithoutCurrencySymbol.match(/(?=.*?\d)^\$?(([1-9]\d{0,2}(\.\d{3})*)|\d+)?(,\d{1,2})?$/) : !!valueWithoutCurrencySymbol.match(/(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/),
      modifiedValue;
    if (currencySeparatorIsPeriod === 'true') {
      //only allow numbers and commas(decimal points)
      modifiedValue = isValidCurrencyFormat ? value.replace(/[^0-9,]/g, "") : value;
    } else {
      //only allow numbers and periods(decimal points)
      modifiedValue = isValidCurrencyFormat ? value.replace(/[^0-9.]/g, "") : value;
    }
    return modifiedValue;
  };
  this.roundCurrencyForServer = function (value, rounding) {
    var modifiedValue = this.formatCurrencyForRounding(value);
    if (!_.isEmpty(modifiedValue) && !isNaN(modifiedValue)) {
      switch (rounding) {
        case 'nearest':
          modifiedValue = Math.round(modifiedValue);
          break;
        case 'up':
          modifiedValue = Math.ceil(modifiedValue);
          break;
        case 'down':
          modifiedValue = Math.floor(modifiedValue);
          break;
      }
    }
    return modifiedValue;
  };
  this.parseDateFromServer = function (date, isAmPm, utc) {
    var formatWith = isAmPm ? 'MM/DD/YYYY hh:mm A ZZ' : 'MM/DD/YYYY',
      isValid = moment(date, formatWith).isValid() && moment(date, formatWith).isAfter('1900-01-01T12:00:00Z') && moment(date, formatWith).isBefore('2100-01-01T12:00:00Z') && date.length >= 8,
      result = date,
      momentObject;
    if (isValid) {
      momentObject = moment(date, formatWith);
      if (utc) {
        momentObject = momentObject.utc();
      }
      result = momentObject.toDate();
    } else {
      result = undefined;
    }
    return result;
  };
  this.dateFromInput = function (date, isAmPm, utc) {
    var yyyyDateFormat = shortDateFormat === 'MM/DD/YY' ? 'MM/DD/YYYY' : shortDateFormat,
      formatWith = isAmPm ? yyyyDateFormat + ' hh:mm A' : yyyyDateFormat,
      isValid = moment(date, formatWith).isValid() && moment(date, formatWith).isAfter('1900-01-01T12:00:00Z') && moment(date, formatWith).isBefore('2100-01-01T12:00:00Z') && date.length >= 6,
      result = date,
      momentObject;
    if (isValid) {
      momentObject = moment(date, formatWith);
      if (utc) {
        momentObject = momentObject.utc();
      }
      result = momentObject.toDate();
    } else {
      result = undefined;
    }
    return result;
  };
  this.getIndexedFieldName = function (uiField, isRowRepeater, rowModel) {
    return uiField.fieldTemplate.variableName + (isRowRepeater && rowModel.rowNumber > 0 ? ':' + rowModel.rowNumber : '');
  };
};
FormComponentUtil.$inject = ["xmlUtil", "localization", "numberFilter", "currencyFilter", "coreMediator", "appTypeConfigurationModel", "editableFieldLevel", "currencyUtil", "fieldType", "preferenceModel"];
angular.module('umFormViewer').service('formComponentUtil', FormComponentUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(2)))

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

var path = '/formViewer/component/formPlaceholder.tpl.html';
var html = "<div class=\"formSectionContainer\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

var path = '/formViewer/component/sectionPlaceholder.tpl.html';
var html = "<div class=\"formSection\"\n     ui-hide-empty-section></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

var path = '/formViewer/component/supplementalFormPlaceholder.tpl.html';
var html = "<ui-form-viewer ng-if=\"row.sectionList\"\n                form-id=\"{{ ::formId }}\"\n                form-data=\"row\"\n                supplemental=\"true\"></ui-form-viewer>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

var path = '/formViewer/component/calendar/calendar.tpl.html';
var html = "<div class=\"formComponentContainer {{ ::$ctrl.configurationClass }}\"\n     ng-class=\"{\n        labelLeft: $ctrl.fieldStructure.layout.isLabelLeftAligned,\n        showAsHidden: $ctrl.fieldStructure.dynamicProperties.hidden\n     }\"\n     ng-if=\"!$ctrl.fieldStructure.dynamicProperties.hidden || $ctrl.fieldStructure.isConfigurableComponent\">\n\n    <!--Label-->\n\n    <ui-required-indicator-label\n            ng-if=\"!$ctrl.hideLabel\"\n            required-label-config=\"$ctrl.fieldStructure.requiredIndicatorLabelConfig\">\n    </ui-required-indicator-label>\n\n    <!--Input-->\n    <div class=\"componentCalendarContainer {{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n         ui-snippets-indicator\n         ui-snippets-indicator-container=\"self\"\n         ui-snippets-indicator-name=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\">\n\n        <div class=\"inputContainer\"\n             ui-manual-size\n             width=\"::$ctrl.fieldStructure.layout.inputWidth - 25\"\n             ng-mouseenter=\"$ctrl.mouseEnter($event,$ctrl.fieldStructure)\"\n             ng-mouseleave=\"$ctrl.mouseLeave()\">\n\n            <input type=\"text\"\n                   ui-manual-size\n                   width=\"::$ctrl.fieldStructure.layout.inputWidth - 25\"\n                   ng-class=\"{ error: !$ctrl.fieldStructure.dynamicProperties.isValid }\"\n                   ng-model=\"$ctrl.textInputDate\"\n                   ng-disabled=\"$ctrl.fieldStructure.dynamicProperties.disabled\"\n                   ng-blur=\"$ctrl.handleBlur()\"\n                   ng-focus=\"$ctrl.handleFocus()\"\n                   ui-remote-change-notification\n                   is-time-enabled=\"{{ $ctrl.isTimeEnabled }}\"\n                   class=\"calendarInput\"/>\n        </div>\n\n        <button class=\"toggleCalendarPopup glyphicon glyphicon-calendar\"\n                uib-popover-template=\"'/formViewer/component/calendar/calendarPopover.tpl.html'\"\n                popover-trigger=\"none\"\n                popover-append-to-body=\"true\"\n                popover-placement=\"auto top\"\n                popover-is-open=\"$ctrl.popupOpen\"\n                popover-class=\"calendarPopover\"\n                ng-click=\"$ctrl.onToggleCalendarPopup()\"\n                ng-disabled=\"$ctrl.fieldStructure.dynamicProperties.disabled\"></button>\n\n    </div>\n</div>\n\n<span class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n      ng-if=\"$ctrl.fieldStructure.dynamicProperties.hidden && !$ctrl.fieldStructure.isConfigurableComponent\"></span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

var CalendarComponent = {
  templateUrl: '/formViewer/component/calendar/calendar.tpl.html',
  controller: 'calendarController',
  bindings: {
    fieldStructure: '<',
    timeLastModified: '<',
    hideLabel: '<'
  }
};
angular.module('umFormViewer').component('uiCalendar', CalendarComponent);

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var CalendarController = function CalendarController($rootScope, $scope, $controller, $timeout, coreMediator, formViewerConstant, formComponentUtil, formMediator, xmlUtil) {
  angular.extend(this, $controller('baseFormComponentController', {
    $scope: $scope
  }));
  var timeoutList = [];
  this.popupOpen = false;
  this.hourStep = 1;
  this.minuteStep = 1;
  this.isTimeEnabled = false;
  this.$onInit = function () {
    this.onInit();
    var uiField = this.fieldStructure.uiField;
    if (!this.fieldStructure.fieldModel) {
      this.fieldStructure.fieldModel = {
        value: ''
      };
    }
    this.isTimeEnabled = uiField.options ? xmlUtil.parseString(uiField.options).enableTimeEntry : false;
    this.selectedDate = this.fieldStructure.fieldModel ? formComponentUtil.parseDateFromServer(this.fieldStructure.fieldModel.value, this.isTimeEnabled) : undefined;
    this.textInputDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedDate, this.isTimeEnabled);
    this.fieldStructure.hasLocalChanges = false;
    this.formStructure = formMediator.getFormStructure(this.fieldStructure.rootFormId);
  };
  this.$onChanges = function () {
    this.selectedDate = this.fieldStructure.fieldModel ? formComponentUtil.parseDateFromServer(this.fieldStructure.fieldModel.value, this.isTimeEnabled) : undefined;
    this.textInputDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedDate, this.isTimeEnabled);
    this.onChanges();
  };
  this.handleChange = function (event) {
    if (event && event.target) {
      var targetElement = $(event.target),
        isDaySelected = targetElement.parents('.uib-day').length > 0;
      if (isDaySelected) {
        this.fieldStructure.hasLocalChanges = true;
        formComponentUtil.setupFieldProperties(this.fieldStructure, this.formStructure.currencyCode);
        this.textInputDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedDate, this.isTimeEnabled);
        this.fieldStructure.fieldModel.value = formComponentUtil.formatDateForServer(this.selectedDate, this.isTimeEnabled);
        this.updateFieldValue();
        if (!this.isTimeEnabled) {
          this.popupOpen = false;
        }
      }
    }
  };
  this.handleClose = function () {
    var selected = this.selectedDate;
    if (selected) {
      var modified = formComponentUtil.formatDateForServer(this.selectedDate, this.isTimeEnabled);
      if (modified !== this.fieldStructure.fieldModel.value) {
        this.fieldStructure.hasLocalChanges = true;
        this.fieldStructure.fieldModel.value = modified;
        this.updateFieldValue();
      }
    }
  };
  this.handleKeyup = function (event) {
    var isDayModeSelected = event ? $(event.target).hasClass('uib-daypicker') : false;
    if (event.which === 13 && isDayModeSelected) {
      this.fieldStructure.hasLocalChanges = true;
      formComponentUtil.setupFieldProperties(this.fieldStructure, this.formStructure.currencyCode);
      this.textInputDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedDate, this.isTimeEnabled);
      this.fieldStructure.fieldModel.value = formComponentUtil.formatDateForServer(this.selectedDate, this.isTimeEnabled);
      this.updateFieldValue();
    }
  };
  this.handleBlur = function () {
    var date,
      isSameAsOriginal = this.textInputDate === formComponentUtil.formatDateWithDefaultPreferences(this.origFieldValue, this.isTimeEnabled);
    if (this.textInputDate === '' && !isSameAsOriginal) {
      this.fieldStructure.hasLocalChanges = true;
      this.selectedDate = undefined;
      this.fieldStructure.fieldModel.value = '';
      this.updateFieldValue();
    } else {
      date = formComponentUtil.dateFromInput(this.textInputDate, this.isTimeEnabled);
      if (!_.isUndefined(date) && !isSameAsOriginal) {
        this.fieldStructure.hasLocalChanges = true;
        this.selectedDate = date;
        this.textInputDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedDate, this.isTimeEnabled);
        this.fieldStructure.fieldModel.value = formComponentUtil.formatDateForServer(this.selectedDate, this.isTimeEnabled);
        this.updateFieldValue();
      } else {
        // Revert back to previous date if there was a problem parsing
        this.textInputDate = formComponentUtil.formatDateWithDefaultPreferences(this.origFieldValue, this.isTimeEnabled);
      }
    }
  };
  this.resetFieldValue = function () {
    this.fieldStructure.fieldModel.value = this.origFieldValue;
    this.textInputDate = formComponentUtil.formatDateWithDefaultPreferences(this.origFieldValue, this.isTimeEnabled);
    this.selectedDate = formComponentUtil.dateFromInput(this.textInputDate, this.isTimeEnabled);
  };
  this.resetMonthView = function () {
    if (_.isUndefined(this.textInputDate) || this.textInputDate === '') {
      this.selectedDate = undefined;
    } else {
      this.selectedDate = formComponentUtil.dateFromInput(this.textInputDate, this.isTimeEnabled);
    }
  };
  this.isToday = function (date, mode) {
    var today = new Date(),
      year = today.getFullYear();
    today.setHours(12, 0, 0, 0);
    if (today.toDateString() === date.toDateString() || mode === 'year' && year === date.getFullYear()) {
      return 'today';
    }
  };
  this.onToggleCalendarPopup = function () {
    this.popupOpen = !this.popupOpen;
  };
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
};
CalendarController.$inject = ["$rootScope", "$scope", "$controller", "$timeout", "coreMediator", "formViewerConstant", "formComponentUtil", "formMediator", "xmlUtil"];
angular.module('umFormViewer').controller('calendarController', CalendarController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

var path = '/formViewer/component/calendar/calendarPlaceholder.tpl.html';
var html = "<ui-calendar class=\"fieldListComponent\"\n             field-structure=\"fieldStructure\"\n             time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n             hide-label=\"::hideLabel\"\n             collapsible=\"::$ctrl.collapsible\"\n             ui-show-field-details-modal></ui-calendar>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

var path = '/formViewer/component/calendar/calendarPopover.tpl.html';
var html = "<div class=\"componentDateTimePickerPopup\"\n     ui-calendar-auto-close=\".formViewer\"\n     ui-calendar-focus\n     ui-click-outside=\"$ctrl.handleClose()\"\n     ng-keydown=\"$ctrl.handleKeydown($event)\">\n\n    <div class=\"dateTimePickerContainer\">\n\n        <div uib-datepicker\n             ng-model=\"$ctrl.selectedDate\"\n             ng-click=\"$ctrl.handleChange($event)\"\n             ng-keyup=\"$ctrl.handleKeyup($event)\"\n             show-weeks=\"false\"\n             datepicker-mode=\"'day'\"\n             custom-class=\"$ctrl.isToday(date, mode)\"></div>\n\n        <div uib-timepicker\n            ng-if=\"$ctrl.isTimeEnabled\"\n            ng-model=\"$ctrl.selectedDate\"\n            hour-step=\"$ctrl.hourStep\"\n            minute-step=\"$ctrl.minuteStep\"></div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var UICalendarAutoCloseDirective = function UICalendarAutoCloseDirective($timeout, $document) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    var element = $($elm),
      targetElement = $($attrs['uiCalendarAutoClose']),
      bodySourceDom = $document[0].body;
    function handleClick(event) {
      var target = $(event.target),
        isChildElement = element.find(target).length;
      if (!isChildElement) {
        closeElement();
      }
    }
    function closeElement() {
      $scope.$ctrl.popupOpen = false;
      $timeout(function () {}, 0);
    }
    targetElement.on('scroll', closeElement);
    /*
     * For any click in the window, call handleClick to check
     * if the click is outside the popup. Use event capturing
     * (i.e., the "true" argument to bodySourceDom.addEventListener)
     * so that handleClick is called before Angular processes
     * the click. For example, if the user clicks on the "month"
     * button in the "day" layout, Angular will switch to the "month"
     * layout, and so the "month" button in the "day" layout
     * will no longer be a child of element. Similarly for clicking
     * on the "year" button in the "month" layout.
     */
    bodySourceDom.addEventListener('click', handleClick, true);
    $elm.on('$destroy', function () {
      targetElement.off('scroll', closeElement);
      bodySourceDom.removeEventListener('click', handleClick, true);
    });
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UICalendarAutoCloseDirective.$inject = ["$timeout", "$document"];
angular.module('umFormViewer').directive('uiCalendarAutoClose', UICalendarAutoCloseDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

var path = '/formViewer/component/checkbox/checkbox.tpl.html';
var html = "<div class=\"formComponentContainer {{ ::$ctrl.configurationClass }}\"\n     ng-class=\"{\n        labelLeft: $ctrl.fieldStructure.layout.isLabelLeftAligned,\n        showAsHidden: $ctrl.fieldStructure.dynamicProperties.hidden\n     }\"\n     ng-if=\"!$ctrl.fieldStructure.dynamicProperties.hidden || $ctrl.fieldStructure.isConfigurableComponent\"\n     ui-manual-size\n     width=\"::$ctrl.getRowRepeaterFieldWidth($ctrl.fieldStructure.uiField)\"\n     ui-snippets-indicator\n     ui-snippets-indicator-container=\"self\"\n     ui-snippets-indicator-name=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\">\n\n    <!--Input-->\n    <div class=\"componentInputContainer {{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n         ng-mouseenter=\"$ctrl.mouseEnter($event,$ctrl.fieldStructure)\"\n         ng-mouseleave=\"$ctrl.mouseLeave()\">\n\n        <input type=\"checkbox\"\n               class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n               ng-class=\"{ error: !$ctrl.fieldStructure.dynamicProperties.isValid }\"\n               ng-model=\"$ctrl.checkboxValue\"\n               ng-disabled=\"$ctrl.fieldStructure.dynamicProperties.disabled\"\n               ng-change=\"$ctrl.handleChange()\"\n               ui-remote-change-notification\n               ng-focus=\"$ctrl.handleFocus()\"\n        />\n\n    </div>\n\n    <!--Label-->\n    <ui-required-indicator-label\n            class=\"checkboxLabel\"\n            ng-if=\"!$ctrl.hideLabel\"\n            ng-click=\"$ctrl.handleClick()\"\n            required-label-config=\"$ctrl.fieldStructure.requiredIndicatorLabelConfig\">\n    </ui-required-indicator-label>\n\n</div>\n\n<!-- Row Repeater Hidden Width Placeholder -->\n<div class=\"formComponentContainer collapsedPlaceholder\"\n     ng-if=\"$ctrl.fieldStructure.isRowRepeaterField && $ctrl.fieldStructure.dynamicProperties.hidden && !$ctrl.fieldStructure.isColumnCollapsed\">\n\n    <div ui-manual-size\n         width=\"::$ctrl.fieldStructure.layout.inputWidth\"></div>\n</div>\n\n<span class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n      ng-if=\"$ctrl.fieldStructure.dynamicProperties.hidden && !$ctrl.fieldStructure.isConfigurableComponent\"></span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

var CheckboxComponent = {
  templateUrl: '/formViewer/component/checkbox/checkbox.tpl.html',
  controller: 'checkboxController',
  bindings: {
    fieldStructure: '<',
    timeLastModified: '<',
    hideLabel: '<'
  }
};
angular.module('umFormViewer').component('uiCheckbox', CheckboxComponent);

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var CheckboxController = function CheckboxController($scope, $controller, formViewerConstant, formComponentUtil, formMediator) {
  this.checkboxValue = false;
  angular.extend(this, $controller('baseFormComponentController', {
    $scope: $scope
  }));
  this.$onInit = function () {
    this.onInit();
    this.updateCheckbox();
  };
  this.$onChanges = function () {
    this.onChanges();
    this.updateCheckbox();
  };
  this.updateCheckbox = function () {
    var fieldInstance = this.fieldStructure.fieldModel,
      uiField = this.fieldStructure.uiField,
      defaultValue = uiField.fieldTemplate && uiField.fieldTemplate.defaultValue === 'TRUE' ? true : false;
    this.hasValue = fieldInstance ? !_.isEmpty(fieldInstance.value) : false;
    this.checkboxValue = this.hasValue ? fieldInstance.value.toLowerCase() === 'true' : defaultValue;
  };
  this.handleClick = function () {
    if (this.fieldStructure.dynamicProperties.disabled) {
      return;
    }
    this.checkboxValue = !this.checkboxValue;
    this.handleChange();
  };
  this.handleChange = function () {
    this.fieldStructure.hasLocalChanges = true;
    if (this.fieldStructure.fieldModel) {
      this.fieldStructure.fieldModel.value = this.checkboxValue ? 'true' : 'false';
    } else {
      this.fieldStructure.fieldModel = {
        value: this.checkboxValue ? 'true' : 'false'
      };
    }
    formMediator.handleFieldChange(this.fieldStructure.parentForm.id, this.fieldStructure, this.resetFieldValue.bind(this), this.updateOriginalFieldValue.bind(this));
  };
  this.getRowRepeaterFieldWidth = function () {
    var isRowRepeater = this.hideLabel,
      padding = isRowRepeater ? 12 : 0,
      inputWidth = this.fieldStructure.layout.inputWidth + padding;
    return isRowRepeater ? inputWidth : 'auto';
  };
};
CheckboxController.$inject = ["$scope", "$controller", "formViewerConstant", "formComponentUtil", "formMediator"];
angular.module('umFormViewer').controller('checkboxController', CheckboxController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

var path = '/formViewer/component/checkbox/checkboxPlaceholder.tpl.html';
var html = "<ui-checkbox class=\"fieldListComponent checkboxComponent\" field-structure=\"fieldStructure\"\n             time-last-modified=\"fieldStructure.fieldModel.timeLastModified\" hide-label=\"::hideLabel\"\n             collapsible=\"::$ctrl.collapsible\" ui-show-field-details-modal></ui-checkbox>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

var path = '/formViewer/component/checkboxGroup/checkboxGroup.tpl.html';
var html = "<div class=\"formComponentContainer {{ ::$ctrl.configurationClass }}\"\n     ng-class=\"{\n        labelLeft: $ctrl.fieldStructure.layout.isLabelLeftAligned\n     }\"\n     ng-if=\"!$ctrl.fieldStructure.dynamicProperties.hidden || $ctrl.fieldStructure.isConfigurableComponent\"\n     ui-snippets-indicator\n     ui-snippets-indicator-container=\"self\"\n     ui-snippets-indicator-name=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\">\n\n    <!--Label-->\n    <ui-required-indicator-label\n            class=\"groupLabel\"\n            ng-class=\"{\n                labelLeft: $ctrl.fieldStructure.layout.isLabelLeftAligned,\n                labelTop: !$ctrl.fieldStructure.layout.isLabelLeftAligned,\n                required: $ctrl.fieldStructure.requiredIndicatorLabelConfig.required,\n                checked: $ctrl.fieldStructure.requiredIndicatorLabelConfig.required && $ctrl.fieldStructure.requiredIndicatorLabelConfig.valid && $ctrl.fieldStructure.requiredIndicatorLabelConfig.hasValue\n                }\"\n            ng-if=\"!$ctrl.hideLabel\"\n            required-label-config=\"$ctrl.fieldStructure.requiredIndicatorLabelConfig\">\n    </ui-required-indicator-label>\n\n    <!--Input-->\n    <div class=\"componentInputContainer {{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n         ui-manual-size\n         width=\"$ctrl.fieldStructure.layout.inputWidth\">\n\n        <label ng-repeat=\"item in $ctrl.itemsList\"\n               ng-class=\"{ disabled: $ctrl.fieldStructure.dynamicProperties.disabled }\"\n               ui-manual-size\n               width=\"$ctrl.fieldStructure.layout.groupItemWidth\"\n               ng-mouseenter=\"$ctrl.mouseEnter($event,$ctrl.fieldStructure)\"\n               ng-mouseleave=\"$ctrl.mouseLeave()\">\n            <input type=\"checkbox\"\n                   ng-class=\"{ error: !$ctrl.fieldStructure.dynamicProperties.isValid }\"\n                   ng-disabled=\"$ctrl.fieldStructure.dynamicProperties.disabled\"\n                   ng-model=\"item.checked\"\n                   ng-focus=\"$ctrl.handleFocus()\"\n                   name=\"{{ $ctrl.getGroupName($ctrl.fieldStructure.uiField) }}\"\n                   ng-change=\"$ctrl.handleChange()\"\n                   ui-remote-change-notification />\n            {{ item.name }}\n        </label>\n    </div>\n\n</div>\n\n<!-- Row Repeater Hidden Width Placeholder -->\n<div class=\"dynamicComponentContainer collapsedPlaceholder\"\n     ng-if=\"$ctrl.fieldStructure.isRowRepeaterField && $ctrl.fieldStructure.dynamicProperties.hidden && !$ctrl.fieldStructure.isColumnCollapsed\">\n\n    <div ui-manual-size\n         width=\"$ctrl.fieldStructure.layout.inputWidth\"></div>\n</div>\n\n<span class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n      ng-if=\"$ctrl.fieldStructure.dynamicProperties.hidden && !$ctrl.fieldStructure.isConfigurableComponent\"></span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

var CheckboxGroupComponent = {
  templateUrl: '/formViewer/component/checkboxGroup/checkboxGroup.tpl.html',
  controller: 'checkboxGroupController',
  bindings: {
    fieldStructure: '<',
    timeLastModified: '<',
    hideLabel: '<'
  }
};
angular.module('umFormViewer').component('checkboxGroup', CheckboxGroupComponent);

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var CheckboxGroupController = function CheckboxGroupController($scope, $controller, $timeout, coreConstant, formViewerConstant, formComponentUtil, coreMediator, formMediator) {
  var splitKey = '::';
  var timeoutList = [];
  angular.extend(this, $controller('baseFormComponentController', {
    $scope: $scope
  }), $controller('baseDataSetFormComponentController', {
    $scope: $scope
  }));
  this.$onInit = function () {
    var _this = this;
    var dataSetImmediateLoad = true;
    var preventDataSetLoadIfConfigurableComponent = false;
    this.onInitDataSetComponent(dataSetImmediateLoad, preventDataSetLoadIfConfigurableComponent).then(function () {
      _this.fieldStructure.layout.groupItemWidth = formComponentUtil.getGroupItemWidth(_this.fieldStructure.layout, _this.itemsList);
      _this.updateItemsWithCheckedValues();
    });
    this.formStructure = formMediator.getFormStructure(this.fieldStructure.rootFormId);
  };
  this.$onChanges = function () {
    this.onChanges();
    this.updateItemsWithCheckedValues();
  };
  this.getGroupName = function (uiField) {
    return uiField.fieldTemplate.variableName + (this.isRowRepeater() ? ':' + this.fieldStructure.rowNumber : '');
  };
  this.handleChange = function () {
    this.fieldStructure.hasLocalChanges = true;
    this.updateFieldValueFromCheckedItems();
    formComponentUtil.setupFieldProperties(this.fieldStructure, this.formStructure.currencyCode);
    formMediator.handleFieldChange(this.fieldStructure.parentForm.id, this.fieldStructure, this.resetFieldValue.bind(this), this.updateOriginalFieldValue.bind(this));
  };
  this.updateItems = function (updateEvent, data) {
    var _this2 = this;
    if (this.shouldUpdateItems(updateEvent, data)) {
      timeoutList.push($timeout(function () {
        _this2.itemsList.length = 0;
        _.each(_.cloneDeep(data.items), function (item) {
          _this2.itemsList.push(item);
        });
        _this2.fieldStructure.layout.groupItemWidth = formComponentUtil.getGroupItemWidth(_this2.fieldStructure.layout, _this2.itemsList);
        _this2.updateItemsWithCheckedValues();
      }, 100));
    }
  };
  this.updateItemsWithCheckedValues = function () {
    var fieldInstance = this.fieldStructure.fieldModel;
    if (fieldInstance) {
      var checkedValues = _.split(fieldInstance.value, splitKey);
      _.forEach(this.itemsList, function (item) {
        item.checked = !!_.includes(checkedValues, item.value);
      });
    }
  };
  this.updateFieldValueFromCheckedItems = function () {
    var fieldValue = '';
    _.forEach(this.itemsList, function (item) {
      if (item.checked) {
        if (fieldValue !== '') {
          fieldValue += splitKey;
        }
        fieldValue += item.value;
      }
    });
    if (this.fieldStructure.fieldModel) {
      this.fieldStructure.fieldModel.value = fieldValue;
    } else {
      this.fieldStructure.fieldModel = {
        value: fieldValue
      };
    }
  };
  $scope.$on(coreConstant.event.UPDATE_DATA_SET, this.updateItems.bind(this));
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
};
CheckboxGroupController.$inject = ["$scope", "$controller", "$timeout", "coreConstant", "formViewerConstant", "formComponentUtil", "coreMediator", "formMediator"];
angular.module('umFormViewer').controller('checkboxGroupController', CheckboxGroupController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

var path = '/formViewer/component/checkboxGroup/checkboxGroupPlaceholder.tpl.html';
var html = "<checkbox-group class=\"fieldListComponent checkboxGroupComponent\"\n                field-structure=\"fieldStructure\"\n                time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n                hide-label=\"::hideLabel\"\n                collapsible=\"::$ctrl.collapsible\"\n                ui-show-field-details-modal></checkbox-group>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

var path = '/formViewer/component/multiSelect/multiSelect.tpl.html';
var html = "<div class=\"formComponentContainer multiSelectField {{ ::$ctrl.configurationClass }}\"\n     ui-tooltip\n     ng-class=\"{\n        labelLeft: $ctrl.fieldStructure.layout.isLabelLeftAligned,\n        showAsHidden: $ctrl.fieldStructure.dynamicProperties.hidden\n     }\"\n     ng-if=\"!$ctrl.fieldStructure.dynamicProperties.hidden || $ctrl.fieldStructure.isConfigurableComponent\">\n\n    <!--Label-->\n    <ui-required-indicator-label\n        ng-if=\"!$ctrl.hideLabel\"\n        required-label-config=\"$ctrl.fieldStructure.requiredIndicatorLabelConfig\">\n    </ui-required-indicator-label>\n\n    <ui-multi-select\n        width=\"::$ctrl.fieldStructure.layout.inputWidth\"\n        tooltip-message=\"$ctrl.fieldStructure.dynamicProperties.tooltip.message\"\n        class=\"multiSelectFieldSelect\"\n        prompt-value=\"$ctrl.promptValue\"\n        item-name=\"$ctrl.itemName\"\n        append-to-body=\"true\"\n        items-list=\"$ctrl.itemsList\"\n        selected-value=\"$ctrl.fieldStructure.fieldModel.value\"\n        is-list-load-dynamically=\"$ctrl.supportSearch\"\n        truncate-char-length=\"100\"\n        filter-text-prompt=\"$ctrl.filterTextPrompt\"\n        on-change=\"$ctrl.handleMultiSelectChange(selectedValueList)\">\n    </ui-multi-select>\n\n\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

var MultiSelectFieldComponent = {
  templateUrl: '/formViewer/component/multiSelect/multiSelect.tpl.html',
  controller: 'multiSelectFieldController',
  bindings: {
    fieldStructure: '<',
    timeLastModified: '<',
    hideLabel: '<'
  }
};
angular.module('umCore').component('uiMultiSelectField', MultiSelectFieldComponent);

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var MultiSelectFieldController = function MultiSelectFieldController($rootScope, $scope, $controller, $timeout, coreConstant, formViewerConstant, formComponentUtil, coreMediator, formMediator, localization, uuidUtil) {
  var _this = this;
  var splitKey = '::';
  var timeoutList = [];
  var dataSetImmediateLoad = true;
  var preventDataSetLoadIfConfigurableComponent = false;
  angular.extend(this, $controller('baseFormComponentController', {
    $scope: $scope
  }), $controller('baseDataSetFormComponentController', {
    $scope: $scope
  }));
  this.promptValue = '';
  this.filterTextPrompt = '';
  this.itemName = "Multi Select ".concat(uuidUtil.generateUUID());
  this.$onInit = function () {
    this.onInitDataSetComponent(dataSetImmediateLoad, preventDataSetLoadIfConfigurableComponent).then(function () {});
    this.dropdownSelectedValue = null;
    this.formStructure = formMediator.getFormStructure(this.fieldStructure.rootFormId);
  };
  this.filterToolTip = function (items) {
    var tooltipArr = _.map(items, function (item) {
      return item.description;
    });
    var toolTipValue = _.replace(tooltipArr.toString(), new RegExp(',', 'g'), ', ');
    this.fieldStructure.dynamicProperties.tooltip = {
      type: '',
      message: toolTipValue
    };
  };
  this.handleChange = function () {};
  this.handleMultiSelectChange = function (selectedValueList) {
    var fieldValue = '';
    _.forEach(selectedValueList, function (item) {
      fieldValue += (fieldValue == '' ? '' : splitKey) + item.value;
    });
    if (this.fieldStructure.fieldModel) {
      this.fieldStructure.fieldModel.value = fieldValue;
    } else {
      this.fieldStructure.fieldModel = {
        value: fieldValue
      };
    }
    if (!_.isNil(fieldValue)) {
      this.filterToolTip(selectedValueList);
    } else {
      this.fieldStructure.dynamicProperties.tooltip = {
        type: '',
        messages: ''
      };
    }
    this.fieldStructure.hasLocalChanges = true;
    formMediator.handleFieldChange(this.fieldStructure.parentForm.id, this.fieldStructure, this.resetFieldValue.bind(this), this.updateOriginalFieldValue.bind(this));
  };
  $scope.$on(coreConstant.event.MULTI_SELECT_CLEAR, function (event, itemName) {
    if (_this.itemName === itemName) {
      _this.fieldStructure.dynamicProperties.tooltip.message = '';
    }
  });
  $scope.$on(coreConstant.event.MULTI_SELECT_FILTER_CHANGED, function (event, itemName, searchText) {
    if (_this.itemName === itemName) {
      if (_this.supportSearch && _.size(searchText) >= _this.minimumSearchCharacters) {
        _this.setSearchText(searchText);
        _this.loadDataSet(dataSetImmediateLoad);
      }
    }
  });
};
MultiSelectFieldController.$inject = ["$rootScope", "$scope", "$controller", "$timeout", "coreConstant", "formViewerConstant", "formComponentUtil", "coreMediator", "formMediator", "localization", "uuidUtil"];
angular.module('umFormViewer').controller('multiSelectFieldController', MultiSelectFieldController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

var path = '/formViewer/component/multiSelect/multiSelectPlaceholder.tpl.html';
var html = "<ui-multi-select-field class=\"fieldListComponent multiSelectFieldComponent\"\n                field-structure=\"fieldStructure\"\n                time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n                hide-label=\"::hideLabel\"\n                collapsible=\"::$ctrl.collapsible\"\n                ui-show-field-details-modal></ui-multi-select-field>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

var path = '/formViewer/component/classCode/classCode.tpl.html';
var html = "<div class=\"formComponentContainer classCodeComponent {{ ::$ctrl.configurationClass }}\"\n     ng-class=\"{\n        labelLeft: $ctrl.fieldStructure.layout.isLabelLeftAligned,\n        showAsHidden: $ctrl.fieldStructure.dynamicProperties.hidden\n     }\"\n     ng-if=\"!$ctrl.fieldStructure.dynamicProperties.hidden || $ctrl.fieldStructure.isConfigurableComponent\">\n\n    <!--Label-->\n    <ui-required-indicator-label\n        ng-if=\"!$ctrl.hideLabel\"\n        required-label-config=\"$ctrl.fieldStructure.requiredIndicatorLabelConfig\">\n    </ui-required-indicator-label>\n    <!--Input-->\n    <div class=\"componentInputContainer\"\n         ng-class=\"{ error: !$ctrl.fieldStructure.dynamicProperties.isValid }\"\n         ui-manual-size\n         width=\"$ctrl.fieldStructure.layout.inputWidth\"\n         ui-class-code-stop-event=\"click\"\n         ui-snippets-indicator\n         ui-snippets-indicator-container=\"self\"\n         ui-snippets-indicator-name=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\">\n\n        <!--State Dropdown-->\n        <ui-select ng-if=\"$ctrl.isStateClassCode\"\n                   class=\"dropdownComponentSelect classCodeStateSelect {{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }} {{ ::$ctrl.configurationClass }} {{ $ctrl.getRowNumberClass() }}\"\n                   ng-model=\"$ctrl.stateDropdownSelectedValue\"\n                   ng-disabled=\"$ctrl.fieldStructure.dynamicProperties.disabled\"\n                   theme=\"select2\"\n                   append-to-body=\"true\"\n                   dropdown-unselect-item=\"{{ ::$ctrl.stateClassCodeDropdownUnselectItemIdentifier }}\"\n                   dropdown-handle-focus=\"handleStateFocus\"\n                   dropdown-handle-active-index\n                   on-select=\"$ctrl.handleStateSelect()\"\n                   ui-hide-select-on-scroll\n                   keypress-restrict=\"^[a-zA-Z]*$\"\n                   ui-hide-select-on-scroll-selector=\".formViewer\">\n\n            <ui-select-match allow-clear=\"true\">{{ $ctrl.stateDropdownSelectedValue.code }}</ui-select-match>\n\n            <ui-select-choices repeat=\"item in ($ctrl.stateList | classCodePropsFilter: {code: $select.search}) track by $index\">\n                <span ng-if=\"!$ctrl.showStateLoadingSpinner\"\n                      ng-bind-html=\"item.code\"></span>\n\n                <div class=\"spinnerBox\" ng-if=\"$ctrl.showStateLoadingSpinner\">\n                    <div class=\"icon-spinner\"></div>\n                </div>\n            </ui-select-choices>\n        </ui-select>\n\n        <ui-select class=\"dropdownComponentSelect classCodeComponentSelect {{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }} {{ ::$ctrl.configurationClass }} {{ $ctrl.getRowNumberClass() }}\"\n                   ng-class=\"{ isStateClassCode: $ctrl.isStateClassCode }\"\n                   ng-model=\"$ctrl.dropdownSelectedValue\"\n                   theme=\"select2\"\n                   append-to-body=\"true\"\n                   ng-disabled=\"$ctrl.isStateClassCode ? !$ctrl.stateDropdownSelectedValue || $ctrl.fieldStructure.dynamicProperties.disabled : $ctrl.fieldStructure.dynamicProperties.disabled \"\n                   on-select=\"$ctrl.handleSelect()\"\n                   ui-remote-change-notification\n                   dropdown-unselect-item\n                   dropdown-handle-focus\n                   ui-hide-select-on-scroll\n                   ui-hide-select-on-scroll-selector=\".formViewer\"\n                   class-code-populate-search-text=\"{{ $ctrl.getCurrentValue() }}\"\n                   placeholder=\"{{$ctrl.placeholder}}\"\n                   ui-tooltip\n                   ui-tooltip-text=\"{{$ctrl.dropdownSelectedValue.tooltip}}\"\n                   ui-tooltip-text-element=\"select2-chosen\"\n                   ui-tooltip-message=\"{{$ctrl.fieldStructure.dynamicProperties.tooltip.message}}\">\n\n            <ui-select-match placeholder=\"{{ $ctrl.placeholder }}\"\n                             allow-clear=\"true\">\n                <span ng-bind=\"$ctrl.getItemDescription($select.selected)\"></span>\n            </ui-select-match>\n\n            <ui-select-choices refresh=\"$ctrl.loadItemsList($select.search)\"\n                               refresh-delay=\"500\"\n                               minimum-input-length=\"0\"\n                               repeat=\"item in $ctrl.itemsList\"\n                               ui-disable-choice=\"item.helper===true\"\n                               position=\"auto\">\n                <span ng-bind-html=\"$ctrl.getItemDescription(item) | highlight: $select.search\"></span>\n            </ui-select-choices>\n        </ui-select>\n    </div>\n</div>\n\n<span class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n      ng-if=\"$ctrl.fieldStructure.dynamicProperties.hidden && !$ctrl.fieldStructure.isConfigurableComponent\"></span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1107);
var ClassCodeComponent = {
  templateUrl: '/formViewer/component/classCode/classCode.tpl.html',
  controller: 'classCodeController',
  bindings: {
    fieldStructure: '<',
    timeLastModified: '<',
    hideLabel: '<',
    effectiveDate: '<?',
    onSelect: '&?'
  }
};
angular.module('umCore').component('uiClassCode', ClassCodeComponent);

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

/*@ngInject*/
var ClassCodePropsFilter = function ClassCodePropsFilter() {
  return function (items, props) {
    var out = [];
    if (angular.isArray(items)) {
      var keys = Object.keys(props);
      items.forEach(function (item) {
        var itemMatches = false;
        for (var i = 0; i < keys.length; i++) {
          var prop = keys[i];
          var text = props[prop].toLowerCase();
          if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
            itemMatches = true;
            break;
          }
        }
        if (itemMatches) {
          out.push(item);
        }
      });
    } else {
      // Let the output be the input untouched
      out = items;
    }
    return out;
  };
};
angular.module('umCore').filter('classCodePropsFilter', ClassCodePropsFilter);

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ClassCodeController = function ClassCodeController($rootScope, $scope, $controller, formViewerConstant, formComponentUtil, xmlUtil, formMediator, localization, coreMediator, coreConstant, appTypeConfigurationModel, browserUtil) {
  var splitKey = '::',
    itemHelper = {
      helper: true,
      'description': null
    },
    itemNoResult = {
      helper: true,
      'description': null
    },
    minTextSearchLength = 3,
    minWidth = 150,
    currencyCode,
    inStudio = false;
  angular.extend(this, $controller('baseFormComponentController', {
    $scope: $scope
  }), $controller('baseDataSetFormComponentController', {
    $scope: $scope
  }));
  this.$onInit = function () {
    var _this = this;
    var consoleType = appTypeConfigurationModel.getConsoleType();
    this.dropdownSelectedValue = null;
    this.itemsList = [];
    this.stateList = [{
      code: ''
    }];
    this.stateDropdownSelectedValue = null;
    this.isStateClassCode = false;
    this.showStateLoadingSpinner = false;
    this.stateClassCodeDropdownUnselectItemIdentifier = 'stateClassCodeDropdown';
    this.formStructure = formMediator.getFormStructure(this.fieldStructure.rootFormId);
    if (!_.isNil(this.formStructure)) {
      this.effectiveDate = this.formStructure.effectiveDate;
      currencyCode = this.formStructure.currencyCode;
    }
    localization.getTranslationByKey('formsViewer.controls.umsClassCodeFinder').then(function (translations) {
      itemHelper.description = _.replace(_.get(translations, 'itemHelper'), '{0}', minTextSearchLength);
      itemNoResult.description = _.get(translations, 'noResults');
    });
    this.fieldOptions = this.fieldStructure.uiField.options ? xmlUtil.parseString(this.fieldStructure.uiField.options) : {};
    this.placeholder = this.fieldOptions.classCodeLabel;
    this.classCodeType = this.fieldOptions.classCodeType || 'NCCI';
    this.clearItemsList();
    if (consoleType === coreConstant.authorization.CONSOLE_TYPE_UM_STUDIO) {
      formComponentUtil.setupFieldProperties(this.fieldStructure, currencyCode);
      inStudio = true;
    }
    this.areStatesLoaded = false;
    formMediator.getClassCodeFormat(this.classCodeType).then(function (format) {
      _this.isStateClassCode = format.indexOf('{state}') !== -1;
      if (_this.isStateClassCode) {
        if (_this.fieldStructure.layout.inputWidth < minWidth) {
          _this.fieldStructure.layout.inputWidth = minWidth;
          _this.fieldStructure.uiField.minWidth = minWidth;
        }
        _this.updateStateDropdownSelectedValue();
      }
      _this.updateDropdownSelectedValue();
    });
    this.configurationClass = this.fieldStructure.isConfigurableComponent ? 'configurableComponent' : '';
    this.initialized = true;
  };
  this.$onChanges = function () {
    this.onChanges();
    if (this.initialized) {
      this.updateStateDropdownSelectedValue();
      this.updateDropdownSelectedValue();
    }
  };
  this.setStateItemsList = function (stateList) {
    this.stateList = _.cloneDeep(stateList);
  };
  this.handleStateFocus = function () {
    var _this2 = this;
    if (!this.areStatesLoaded && (_.isNil(this.fieldStructure.parentFormStructure) || !this.fieldStructure.parentFormStructure.isConfigurableForm)) {
      this.showStateLoadingSpinner = true;
      formMediator.getClassCodeGroupings(this.classCodeType, this.effectiveDate).then(function (result) {
        _this2.setStateItemsList(result);
        _this2.areStatesLoaded = true;
        _this2.updateStateDropdownSelectedValue();
        $rootScope.$broadcast(coreConstant.event.HIDE_FORM_TOOLTIP);
      }).finally(function () {
        _this2.showStateLoadingSpinner = false;
      });
    }
  };
  this.loadItemsList = function (query) {
    var _this3 = this;
    var searchTerm,
      adjustedSearchLength = minTextSearchLength;
    if (this.isStateClassCode) {
      searchTerm = (this.stateDropdownSelectedValue ? this.stateDropdownSelectedValue.code : '') + query;
      adjustedSearchLength += 2;
    } else {
      searchTerm = query;
    }
    var processClassCodeItems = function processClassCodeItems(result) {
      if (result.length === 0) {
        _this3.itemsList = [itemNoResult];
      } else {
        _this3.itemsList = result;
      }
    };
    if (searchTerm.length >= adjustedSearchLength) {
      if (inStudio) {
        formMediator.getClassCodeItemsNoDate(this.classCodeType, searchTerm).then(processClassCodeItems);
      } else {
        formMediator.getClassCodeItems(this.classCodeType, searchTerm, this.effectiveDate).then(processClassCodeItems);
      }
    } else {
      this.clearItemsList(query.length);
    }
  };
  this.handleSelect = function () {
    this.fieldStructure.hasLocalChanges = true;
    if (!this.fieldStructure.fieldModel) {
      this.fieldStructure.fieldModel = {};
    }
    if (this.dropdownSelectedValue) {
      this.fieldStructure.fieldModel.value = _.get(this.dropdownSelectedValue, 'code') + splitKey;
      this.fieldStructure.fieldModel.valueLabel = _.get(this.dropdownSelectedValue, 'value');
      $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, this.dropdownSelectedValue);
    } else {
      this.fieldStructure.fieldModel.value = this.stateDropdownSelectedValue ? this.stateDropdownSelectedValue.code : '';
      this.fieldStructure.fieldModel.valueLabel = '';
      this.fieldStructure.dynamicProperties.tooltip.message = this.fieldStructure.uiField.tooltipText;
      this.clearItemsList(0);
    }
    formComponentUtil.setupFieldProperties(this.fieldStructure, currencyCode);
    if (!_.isNil(this.onSelect)) {
      this.onSelect({
        classCodeValue: this.fieldStructure.fieldModel.value
      });
    } else {
      formMediator.handleFieldChange(this.fieldStructure.parentForm.id, this.fieldStructure, this.resetFieldValue.bind(this));
    }
    if (browserUtil.isIE11() || browserUtil.isEdge()) {
      $scope.$broadcast(coreConstant.event.classCode.HIDE_TOOLTIP);
    }
  };
  this.getCurrentValue = function () {
    var result = '',
      value;
    if (!_.isNil(this.dropdownSelectedValue) && !_.isNil(this.dropdownSelectedValue.codeDisplayText)) {
      result = this.dropdownSelectedValue.codeDisplayText;
    } else {
      if (this.fieldStructure.dynamicProperties.hasValue) {
        value = _.replace(_.get(this.fieldStructure, 'fieldModel.value'), splitKey, '');
        if (this.isStateClassCode) {
          result = value.slice(3, value.length);
        } else {
          result = value;
        }
      }
    }
    return result;
  };
  this.clearItemsList = function (queryLength) {
    var helper = _.clone(itemHelper);
    queryLength = queryLength || 0;
    if (this.fieldStructure.dynamicProperties.tooltip) {
      helper.description = this.fieldStructure.dynamicProperties.tooltip.message;
    }
    this.itemsList = [helper];
    $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, null);
  };
  this.updateStateDropdownSelectedValue = function () {
    var value, stateCode, selectedStateCode, selectedStateCodeValueIndex;
    if (this.fieldStructure.dynamicProperties.hasValue && this.isStateClassCode) {
      stateCode = this.fieldStructure.fieldModel.value.slice(0, 2);
      selectedStateCodeValueIndex = _.findIndex(this.stateList, {
        code: stateCode
      });
      $scope.$broadcast(formViewerConstant.event.DROPDOWN_UPDATE_ACTIVE_INDEX, selectedStateCodeValueIndex);
      if (selectedStateCodeValueIndex !== -1) {
        selectedStateCode = this.stateList[selectedStateCodeValueIndex];
      }
      if (_.isNil(selectedStateCode)) {
        this.stateDropdownSelectedValue = {
          code: stateCode
        };
      } else {
        this.stateDropdownSelectedValue = selectedStateCode;
      }
      this.skipStateMaskOnClassCodeSelector = !this.stateDropdownSelectedValue && !this.fieldStructure.dynamicProperties.isValid;
    } else {
      this.stateDropdownSelectedValue = null;
    }
    $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, this.stateDropdownSelectedValue, this.stateClassCodeDropdownUnselectItemIdentifier);
  };
  this.updateDropdownSelectedValue = function () {
    var _this4 = this;
    var fieldInstance = this.fieldStructure.fieldModel,
      value,
      stateCode,
      description,
      hasClassCode,
      selectedStateCode,
      selectedStateCodeValueIndex;
    if (this.fieldStructure.dynamicProperties.hasValue) {
      value = _.replace(fieldInstance.value, splitKey, '');
      description = value;
      hasClassCode = !this.isStateClassCode || value.length > 2;
      stateCode = description.slice(0, 2);
      if (hasClassCode) {
        formMediator.getClassCodeItems(this.classCodeType, value, this.effectiveDate).then(function (result) {
          var classCode;
          if (_.size(result) === 1) {
            classCode = result[0];
            if (_.isEmpty(fieldInstance.valueLabel)) {
              fieldInstance.valueLabel = classCode.value;
            }
          }
          if (!_.isEmpty(fieldInstance.valueLabel)) {
            description += ' - ' + fieldInstance.valueLabel;
          }
          _this4.dropdownSelectedValue = {
            value: fieldInstance.valueLabel || fieldInstance.value,
            code: value,
            description: description,
            tooltip: description
          };
          if (!_.isNil(classCode) && !_.isNil(classCode.codeDisplayText)) {
            _this4.dropdownSelectedValue.description = classCode.description;
            _this4.dropdownSelectedValue.codeDisplayText = classCode.codeDisplayText;
            _this4.dropdownSelectedValue.tooltip = (_this4.isStateClassCode ? stateCode + ' ' : '') + _this4.dropdownSelectedValue.description;
          }
        });
      }
    } else {
      this.dropdownSelectedValue = null;
    }
    $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, this.dropdownSelectedValue);
  };
  this.handleStateSelect = function () {
    this.dropdownSelectedValue = null;
    this.clearItemsList();
    this.handleSelect();
    $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, this.stateDropdownSelectedValue, this.stateClassCodeDropdownUnselectItemIdentifier);
    $scope.$emit(coreConstant.event.ADVANCE_FOCUS, '.classCodeComponent .classCodeComponentSelect .ui-select-match');
  };
  this.getItemDescription = function (item) {
    var result = '';
    if (item && this.isStateClassCode && !this.skipStateMaskOnClassCodeSelector) {
      result = item.helper || !_.isNil(item.codeDisplayText) ? item.description : item.description.slice(2, item.description.length);
    } else if (item) {
      result = item.description;
    }
    return result;
  };
  this.getRowNumberClass = function () {
    var rowNumberClass = '';
    if (!_.isNil(this.fieldStructure.rowNumber)) {
      rowNumberClass = "row".concat(this.fieldStructure.rowNumber);
    }
    return rowNumberClass;
  };
};
ClassCodeController.$inject = ["$rootScope", "$scope", "$controller", "formViewerConstant", "formComponentUtil", "xmlUtil", "formMediator", "localization", "coreMediator", "coreConstant", "appTypeConfigurationModel", "browserUtil"];
angular.module('umFormViewer').controller('classCodeController', ClassCodeController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

var path = '/formViewer/component/classCode/classCodePlaceholder.tpl.html';
var html = "<ui-class-code class=\"fieldListComponent\"\n               field-structure=\"fieldStructure\"\n               time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n               hide-label=\"::hideLabel\"\n               collapsible=\"::$ctrl.collapsible\"\n               ui-show-field-details-modal></ui-class-code>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

/*@ngInject*/
var ClassCodePopulateSearchTextDirective = function ClassCodePopulateSearchTextDirective($rootScope, submissionConstant, formViewerConstant) {
  return {
    require: 'uiSelect',
    link: function link($scope, $element, attrs, $select) {
      var searchInput = $element.querySelectorAll('input.ui-select-search');
      function handleFocus() {
        $scope.$apply(function () {
          $select.search = attrs.classCodePopulateSearchText;
          $rootScope.$broadcast(submissionConstant.event.CLEAR_VISIBLE_TOOLTIP);
          $scope.$ctrl.handleFocus();
        });
      }
      searchInput.on('focus', handleFocus);
      $scope.$on('$destroy', function () {
        searchInput.off('focus', handleFocus);
      });
    }
  };
};
ClassCodePopulateSearchTextDirective.$inject = ["$rootScope", "submissionConstant", "formViewerConstant"];
angular.module('umCore').directive('classCodePopulateSearchText', ClassCodePopulateSearchTextDirective);

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var UIClassCodeStopEventDirective = function UIClassCodeStopEventDirective() {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    var element = $($elm);
    if ($attrs && $attrs.uiClassCodeStopEvent) {
      var catchStopableEvent = function catchStopableEvent(e) {
        if (e.type === $attrs.uiClassCodeStopEvent && $(e.currentTarget).parent().hasClass('disabled')) {
          e.stopPropagation();
          e.preventDefault();
        }
      };
      element.on($attrs.uiClassCodeStopEvent, 'a', catchStopableEvent);
      $scope.$on('$destroy', function () {
        element.off($attrs.uiClassCodeStopEvent, catchStopableEvent);
      });
    }
  };
  return {
    restrict: 'A',
    replace: false,
    link: linkFunction
  };
};
angular.module('umCore').directive('uiClassCodeStopEvent', UIClassCodeStopEventDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

var path = '/formViewer/component/multiSelectClassCode/multiSelectClassCode.tpl.html';
var html = "<div class=\"multiSelectClassCode\">\n    <ui-multi-select\n        ui-tooltip\n        class=\"multiSelect\"\n        prompt-value=\"$ctrl.promptValue\"\n        item-name=\"$ctrl.itemName\"\n        append-to-body=\"true\"\n        selected-value=\"$ctrl.selectedValue\"\n        is-list-load-dynamically=\"true\"\n        truncate-char-length=\"60\"\n        filter-text-prompt=\"$ctrl.filterTextPrompt\"\n        on-change=\"$ctrl.handleMultiSelectClassCodeChange(selectedValueList)\">\n    </ui-multi-select>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

var MultiSelectClassCodeComponent = {
  templateUrl: '/formViewer/component/multiSelectClassCode/multiSelectClassCode.tpl.html',
  controller: 'multiSelectClassCodeController',
  bindings: {
    timeLastModified: '<',
    onSelect: '&?',
    fieldStructure: '<',
    effectiveDate: '<'
  }
};
angular.module('umCore').component('uiMultiSelectClassCode', MultiSelectClassCodeComponent);

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var MultiSelectClassCodeController = function MultiSelectClassCodeController($rootScope, $scope, $q, $timeout, localization, xmlUtil, formMediator, coreConstant, uuidUtil) {
  var _this2 = this;
  this.promptValue = '';
  this.filterTextPrompt = '';
  this.itemName = "Multi Select Class Code ".concat(uuidUtil.generateUUID());
  this.$onInit = function () {
    var _this = this;
    this.dropdownSelectedValue = null;
    localization.getTranslationByKey('formsViewer.controls.multiSelectClassCode').then(function (translations) {
      _this.promptValue = _.get(translations, 'selectClassCodePrompt');
      _this.fieldOptions = _this.fieldStructure.uiField.options ? xmlUtil.parseString(_this.fieldStructure.uiField.options) : {};
      _this.classCodeType = _this.fieldOptions.classCodeType || 'NCCI';
      var classCodeValue = '',
        classCodeArr = [],
        items = [];
      if (!_.isEmpty(_this.fieldStructure.fieldModel.value)) {
        classCodeValue = _this.fieldStructure.fieldModel.value;
        classCodeArr = classCodeValue.split(',');
      }
      var promiseList = [];
      _.each(classCodeArr, function (classCode) {
        classCode = _.trim(_.trim(classCode), '::');
        promiseList.push(formMediator.getClassCodeItemsNoDate(_this.classCodeType, classCode));
      });
      $q.all(promiseList).then(function (classCodeItems) {
        _.each(_.cloneDeep(classCodeItems), function (item) {
          if (item.length > 0) {
            item[0].selected = true;
            items.push(item[0]);
          }
        });
        //Added this timeout, just to make avoid $broadcast firing before the $on is ready
        $timeout(function () {
          return $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_LIST_UPDATED, _this.itemName, items);
        });
        _this.filterToolTip(items);
      });
      formMediator.getClassCodeFormat(_this.classCodeType).then(function (format) {
        _this.isStateClassCode = format.indexOf('{state}') !== -1;
        if (_this.isStateClassCode) {
          _this.minimumSearchCharacters = parseInt(_.get(translations, 'stateClassCodeMinimumSearchCharacters'));
        } else {
          _this.minimumSearchCharacters = parseInt(_.get(translations, 'classCodeMinimumSearchCharacters'));
        }
        if (_this.minimumSearchCharacters === 1) {
          _this.filterTextPrompt = _.get(translations, 'filterTextPromptSingular');
        } else {
          _this.filterTextPrompt = _.replace(_.get(translations, 'filterTextPromptPlural'), '{minimumSearchCharacters}', _this.minimumSearchCharacters);
        }
      });
    });
  };
  this.filterToolTip = function (items) {
    var tooltipArr = _.map(items, function (item) {
      return item.description;
    });
    var toolTipValue = _.replace(tooltipArr.toString(), new RegExp(',', 'g'), ', ');
    this.fieldStructure.dynamicProperties.tooltip = {
      type: '',
      message: toolTipValue
    };
  };
  this.handleMultiSelectClassCodeChange = function (selectedValueList) {
    var selectedClassCodeValue = _.map(selectedValueList, function (selectedValue) {
      return selectedValue.code + '::';
    });
    selectedClassCodeValue = _.join(selectedClassCodeValue, ',');
    if (!_.isNil(selectedClassCodeValue)) {
      this.filterToolTip(selectedValueList);
      this.fieldStructure.fieldModel.value = selectedClassCodeValue;
    } else {
      this.fieldStructure.fieldModel.value = '';
      this.fieldStructure.dynamicProperties.tooltip = {
        type: '',
        messages: ''
      };
    }
    this.onSelect({
      classCodeValue: this.fieldStructure.fieldModel.value
    });
  };
  $scope.$on(coreConstant.event.MULTI_SELECT_CLEAR, function (event, itemName) {
    if (_this2.itemName === itemName) {
      _this2.fieldStructure.dynamicProperties.tooltip.message = '';
    }
  });
  $scope.$on(coreConstant.event.MULTI_SELECT_FILTER_CHANGED, function (event, itemName, searchText) {
    if (_this2.itemName === itemName) {
      if (_.size(searchText) >= _this2.minimumSearchCharacters) {
        formMediator.getClassCodeItemsNoDate(_this2.classCodeType, searchText).then(function (result) {
          _this2.itemList = _.cloneDeep(result);
          $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_LIST_UPDATED, _this2.itemName, _this2.itemList, searchText);
        });
      } else {
        _this2.itemList = [];
        $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_LIST_UPDATED, _this2.itemName, _this2.itemList, searchText);
      }
    }
  });
  $scope.$on(coreConstant.event.RELOAD_CLASS_CODE_MULTI_SELECT, function () {
    _this2.fieldStructure.fieldModel.value = null;
    _this2.$onInit();
  });
};
MultiSelectClassCodeController.$inject = ["$rootScope", "$scope", "$q", "$timeout", "localization", "xmlUtil", "formMediator", "coreConstant", "uuidUtil"];
angular.module('umFormViewer').controller('multiSelectClassCodeController', MultiSelectClassCodeController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UICalendarFocusDirective = function UICalendarFocusDirective($timeout) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    var timeoutList = [];
    timeoutList.push($timeout(function () {
      $scope.$broadcast('uib:datepicker.focus');
    }));
    $scope.$on('$destroy', function () {
      _.each(timeoutList, function (item) {
        $timeout.cancel(item);
      });
    });
  };
  return {
    restrict: 'AC',
    link: linkFunction
  };
};
UICalendarFocusDirective.$inject = ["$timeout"];
angular.module('umFormViewer').directive('uiCalendarFocus', UICalendarFocusDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var UIClickOutsideDirective = function UIClickOutsideDirective($document) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    var handleClick = function handleClick(event) {
      var isToggleButton = $attrs.toggleButtonClass ? $(event.target).hasClass($attrs.toggleButtonClass) : false,
        isChild = $elm.has(event.target).length > 0,
        isSelf = $elm[0] === event.target,
        isDayPickerChild = $(event.target).closest('.uib-daypicker').length > 0,
        isMonthPickerChild = $(event.target).closest('.uib-monthpicker').length > 0,
        isYearPickerChild = $(event.target).closest('.uib-yearpicker').length > 0,
        isDayChild = $(event.target).closest('.uib-day').length > 0,
        isElement = isSelf || isChild || isDayPickerChild || isMonthPickerChild || isYearPickerChild || isToggleButton || isDayChild;
      if (!isElement) {
        $scope.$apply($attrs.uiClickOutside);
      }
    };
    $scope.$on('$destroy', function () {
      $document.off('click.uiClickOutside');
    });
    $document.on('click.uiClickOutside', handleClick);
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UIClickOutsideDirective.$inject = ["$document"];
angular.module('umFormViewer').directive('uiClickOutside', UIClickOutsideDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UIFormTooltipDirective = function UIFormTooltipDirective($document, $timeout, submissionConstant, coreConstant, $sanitize) {
  var linkFunction = function linkFunction($scope, $elm, $attr) {
    var timeoutList = [],
      body = angular.element('body'),
      formViewer = angular.element('.formViewer .formViewerContainer:first-child'),
      tooltip,
      arrow,
      arrowBackground;
    function showTooltip(componentParams) {
      var tooltipConfig = componentParams.fieldStructure.dynamicProperties.tooltip;
      if (componentParams.tooltipMessage && tooltipConfig.type !== 'errorPopover') {
        tooltipConfig.message = componentParams.tooltipMessage;
      }
      var hasTooltipMessage = tooltipConfig && tooltipConfig.message,
        showTooltipDelay = tooltipConfig ? tooltipConfig.delay : 0,
        activeElement = $document[0].activeElement,
        hasFocus = activeElement ? activeElement.className === $elm[0].className : false,
        shouldAddTooltip = !tooltip && hasTooltipMessage && !hasFocus; // && isEnabled;

      if (shouldAddTooltip) {
        body.append('<div class="uiTooltip ' + tooltipConfig.type + '">' + '<div class="message">' + $sanitize(tooltipConfig.message) + '</div>' + '<div class="arrowBackground"></div>' + '<div class="arrow"></div>' + '</div>');
        tooltip = angular.element('.uiTooltip');
        arrow = angular.element('.arrow');
        arrowBackground = angular.element('.arrowBackground');
        tooltip.css('opacity', 0);
        tooltip.css('top', componentParams.pageY - (tooltip[0].offsetHeight + componentParams.offsetY + 1));
        if (tooltip[0].offsetWidth > componentParams.clientWidth) {
          tooltip.css('left', componentParams.pageX - (componentParams.offsetX + (tooltip[0].offsetWidth - componentParams.clientWidth) / 2));
        } else {
          tooltip.css('left', componentParams.pageX + (componentParams.clientWidth - tooltip[0].offsetWidth) / 2 - componentParams.offsetX);
        }
        formViewer.on('scroll', removeTooltip);
        $scope.$on('$stateChangeStart', removeTooltip);
        $scope.$on(submissionConstant.event.CLEAR_VISIBLE_TOOLTIP, removeTooltip);
        timeoutList.push($timeout(function () {
          if (tooltip) {
            tooltip.css('opacity', 1);
          }
        }, showTooltipDelay));
      }
    }
    function removeTooltip() {
      if (!_.isNil(tooltip)) {
        tooltip.css('opacity', 0);
        formViewer.off('scroll', removeTooltip);
        angular.element('.uiTooltip').remove();
        tooltip = null;
      }
    }
    $scope.$on(coreConstant.event.SHOW_FORM_TOOLTIP, function (arg1, params) {
      showTooltip(params);
    });
    $scope.$on(coreConstant.event.HIDE_FORM_TOOLTIP, function () {
      removeTooltip();
    });
    $scope.$on('$destroy', function () {
      if (!_.isNil(tooltip)) {
        formViewer.off('scroll', removeTooltip);
        angular.element('.uiTooltip').remove();
        tooltip = null;
      }
      _.each(timeoutList, function (item) {
        $timeout.cancel(item);
      });
    });
  };
  return {
    restrict: 'E',
    link: linkFunction
  };
};
UIFormTooltipDirective.$inject = ["$document", "$timeout", "submissionConstant", "coreConstant", "$sanitize"];
angular.module('umFormViewer').directive('uiFormTooltip', UIFormTooltipDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UIManualSizeDirective = function UIManualSizeDirective() {
  var linkFunction = function linkFunction($scope, $elm) {
    var element = $($elm);
    function setSize(name, value) {
      if (_.isNumber(value)) {
        element.css(name, value + 'px');
      } else {
        element.css(name, value);
      }
    }
    function setupWatcher(name) {
      $scope.$watch(name, function (newValue) {
        if (newValue) {
          setSize(name, newValue);
        }
      });
    }
    if ($scope.width) {
      setSize('width', $scope.width);
      setupWatcher('width', $scope.width);
    }
    if ($scope.height) {
      setSize('height', $scope.height);
      setupWatcher('height', $scope.height);
    }
    if ($scope.maxHeight) {
      setSize('maxHeight', $scope.maxHeight);
      setupWatcher('maxHeight', $scope.maxHeight);
    }
    if ($scope.maxHeight) {
      setSize('maxHeight', $scope.maxHeight);
      setupWatcher('maxHeight', $scope.maxHeight);
    }
    if ($scope.minHeight) {
      setSize('min-height', $scope.minHeight);
      setupWatcher('min-height', $scope.minHeight);
    }
    if ($scope.minWidth) {
      setSize('minWidth', $scope.minWidth);
      setupWatcher('minWidth', $scope.minWidth);
    }
    if ($scope.flexWidth) {
      setSize('flex', '0 0 ' + $scope.flexWidth);
      setupWatcher('flexWidth', $scope.flexWidth);
    }
  };
  return {
    restrict: 'A',
    scope: {
      width: '<',
      height: '<',
      minHeight: '<',
      maxHeight: '<',
      minWidth: '<',
      flexWidth: '<'
    },
    link: linkFunction
  };
};
angular.module('umFormViewer').directive('uiManualSize', UIManualSizeDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, i18n, $) {/*@ngInject*/
var UINextRequiredFieldFinderDirective = function UINextRequiredFieldFinderDirective($rootScope, $timeout, $q, coreConstant, fieldType, formComponentUtil, formRepository, formViewerConstant, formViewerModel, formViewerUtil, formatUtil, localization, umsLog, dataSetUtil, formSummaryGridUtil, coreMediator, dataSetType) {
  var linkFunction = function linkFunction($scope, $elm) {
    localization.setupLocale('fieldFinder', __webpack_require__(1120));
    var timeoutList = [];
    var nextRequiredFieldIndex = 0,
      eligibleRequiredFieldList = [];
    function resetEligibleRequiredFieldList() {
      var fieldStructureList = _.clone(formViewerModel.getFieldMap($scope.formId).values());
      eligibleRequiredFieldList = [];
      var promises = [];
      var tempEligibleRequiredFieldList = [];

      // To properly generate the eligibleRequiredFieldList, the following steps are taken:
      // 1.) Iterate through all field structures in the current form, including supplemental forms
      // 2.) If the field structure is not hidden and has no value or is invalid proceed, otherwise skip
      // 3.) If the field structure is not a form summary grid or a row repeater, and is required, add it to the temporary list
      // 4.) If the field structure if a form summary grid, we have to make some server calls to determine the current items in the form summary grid.
      //     If there are any required items in the form summary grid, add it to the temporary list
      // 5.) Once everything has finished ($q.all) re-iterate through the field structures in the current form, including supplemental forms,
      //     and if the field structure appears in the temporary list, add it to the actual list. This is done to maintain the required field ordering because of the async
      //     calls needed to the server because of form summary grids.

      _.each(fieldStructureList, function (fieldStructure) {
        var hasValue = fieldStructure.dynamicProperties.hasValue;
        var isValid = fieldStructure.dynamicProperties.isValid;
        var isHidden = fieldStructure.dynamicProperties.hidden;
        var isFormSummaryGrid = fieldStructure.uiField.fieldTemplate.type === fieldType.FORM_SUMMARY_GRID;
        var isNotRowRepeater = fieldStructure.uiField.fieldTemplate.type !== fieldType.ROWREPEATER;
        var isFieldInsideRowRepeater = fieldStructure.rowRepeaterId;
        var isOptionallyRequired = fieldStructure.dynamicProperties.isOptionallyRequired;
        var isRequired = isFieldInsideRowRepeater && isOptionallyRequired ? fieldStructure.dynamicProperties.isColumnRequired : fieldStructure.dynamicProperties.isRequired;
        if (!isHidden && !(hasValue && isValid)) {
          if (isFormSummaryGrid) {
            var dataSetName = fieldStructure.uiField.fieldTemplate.dataSetName;
            if (!_.isNil(dataSetName)) {
              var promise = coreMediator.getCachedDataSetByName(dataSetName).then(function (dataSet) {
                if (dataSet.type !== dataSetType.STATIC) {
                  var dataSetParams = dataSetUtil.getDataSetParamsByFieldStructure(dataSet, fieldStructure);
                  var formId = fieldStructure.parentForm.id;
                  return dataSetUtil.getDataItems(dataSetParams, formId).then(function (dataSetItems) {
                    var formSummaryGridItems = formSummaryGridUtil.processFormSummaryGridItems(dataSetItems);
                    _.each(formSummaryGridItems, function (formSummaryGridItem) {
                      if (formSummaryGridItem.name.requiredCount.value > 0) {
                        tempEligibleRequiredFieldList.push(fieldStructure.fieldStructureId);
                        return false;
                      }
                    });
                  });
                }
              });
              promises.push(promise);
            }
          } else if (isNotRowRepeater && isRequired) {
            // If this is a required and blank or invalid field then we've found an eligible required field, so add it.
            tempEligibleRequiredFieldList.push(fieldStructure.fieldStructureId);
          }
        }
      });
      return $q.all(promises).then(function () {
        _.each(fieldStructureList, function (fieldStructure) {
          if (_.includes(tempEligibleRequiredFieldList, fieldStructure.fieldStructureId)) {
            eligibleRequiredFieldList.push(fieldStructure);
          }
        });
      });
    }
    function findNextRequiredField() {
      var formStructure = formViewerModel.getFormStructure($scope.formId);
      if (formStructure && formStructure.formModel && formStructure.formName) {
        resetEligibleRequiredFieldList().then(function () {
          if (nextRequiredFieldIndex >= eligibleRequiredFieldList.length) {
            nextRequiredFieldIndex = 0;
          }
          var fieldStructure = eligibleRequiredFieldList[nextRequiredFieldIndex++];
          if (!fieldStructure) {
            formRepository.resetRequiredFieldCountByFormId($scope.formId).then(function (didTotalRequiredFieldCountChange) {
              if (didTotalRequiredFieldCountChange) {
                $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, i18n.t('fieldFinder|uiNextRequiredFieldFinder.requiredCountRecalculatedNotification'));
              } else {
                umsLog.warn('The next required field could not be found, but a reset of the required field count did not produce a change!');
              }
            });
          } else {
            triggerNotification(fieldStructure);
          }
        });
      } else {
        timeoutList.push($timeout(function () {
          findNextRequiredField();
        }));
      }
    }
    function triggerNotification(fieldStructure) {
      function handleScroll(containerElement, targetElement) {
        if (containerElement.length && targetElement.length) {
          var formViewerContainer = containerElement.parent();
          var containerOffsetTop = containerElement.offset().top;
          var elementOffsetTop = targetElement.offset().top;
          var currentScroll = containerElement.scrollTop();
          var topMargin = 75;
          formViewerContainer.animate({
            scrollTop: currentScroll + elementOffsetTop - containerOffsetTop - topMargin
          }, 300);
        }
      }
      function handleDropdown(dropdownElement, className) {
        timeoutList.push($timeout(function () {
          var dropdownButton = dropdownElement.find(className);
          dropdownButton.focus();
          dropdownButton.trigger('click');
        }, 500));
      }
      if (!fieldStructure) {
        return;
      }
      var type = fieldStructure.uiField.fieldTemplate.type;
      if (type === fieldType.FORM_SUMMARY_GRID) {
        $rootScope.$broadcast(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD_FORM_SUMMARY_GRID, fieldStructure.fieldStructureId);
      } else {
        var selector = '[form-id="' + fieldStructure.rootFormId + '"] .' + formatUtil.formatAsSelector(fieldStructure.parentForm.formTemplateUniqueName);
        if (fieldStructure.rowInstanceId) {
          selector += ' .row' + fieldStructure.rowNumber;
        }
        selector += ' .formFieldComponent-' + formatUtil.formatAsSelector(fieldStructure.uiField.fieldTemplate.variableName);
        var fieldElement = $(selector);
        if (fieldElement) {
          handleScroll($($elm), fieldElement);
        }
        var isDropdown = fieldElement.hasClass('umDropdownContainer');
        var isClassCode = fieldElement.hasClass('classCodeStateSelect');
        var isCalender = fieldElement.hasClass('componentCalendarContainer');
        var isRadio = fieldElement.is(':radio') || type === fieldType.RADIO_BUTTON_GROUP || type === fieldType.YES_NO;
        var isCheckbox = fieldElement.is(':checkbox') || type === fieldType.CHECK_BOX || type === fieldType.CHECK_BOX_GROUP;
        if (isDropdown) {
          handleDropdown(fieldElement, '.match');
          fieldElement = fieldElement.find('.match');
        } else if (isClassCode) {
          handleDropdown(fieldElement, '.ui-select-match');
          fieldElement = fieldElement.find('.ui-select-match');
        } else if (isRadio || isCheckbox) {
          fieldElement = $(fieldElement[0]).closest('.fieldListComponent');
          var focusFieldElement = fieldElement.find('input');
          timeoutList.push($timeout(function () {
            focusFieldElement.focus();
          }, 500));
        } else if (isCalender) {
          fieldElement = fieldElement.find('input');
          timeoutList.push($timeout(function () {
            fieldElement.focus();
          }, 500));
        } else {
          timeoutList.push($timeout(function () {
            fieldElement.click();
            fieldElement.focus();
          }, 500));
        }
        fieldElement.addClass('animateFieldNotification');
        fieldElement.addClass('nextRequiredFieldNotification');
        timeoutList.push($timeout(function () {
          removeNotification(fieldElement);
        }, 3000));
      }
    }
    function removeNotification(fieldElement) {
      fieldElement.removeClass('nextRequiredFieldNotification');
      timeoutList.push($timeout(function () {
        removeTransition(fieldElement);
      }, 500));
    }
    function removeTransition(fieldElement) {
      fieldElement.removeClass('animateFieldNotification');
    }
    function configure() {
      $scope.$on(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD, function (event, formId) {
        if (parseInt($scope.formId) === parseInt(formId)) {
          findNextRequiredField();
        }
      });
    }
    if (!$scope.supplemental) {
      configure();
    }
    $scope.$on('$destroy', function () {
      _.each(timeoutList, function (item) {
        $timeout.cancel(item);
      });
    });
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UINextRequiredFieldFinderDirective.$inject = ["$rootScope", "$timeout", "$q", "coreConstant", "fieldType", "formComponentUtil", "formRepository", "formViewerConstant", "formViewerModel", "formViewerUtil", "formatUtil", "localization", "umsLog", "dataSetUtil", "formSummaryGridUtil", "coreMediator", "dataSetType"];
angular.module('umFormViewer').directive('uiNextRequiredFieldFinder', UINextRequiredFieldFinderDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(18)["default"], __webpack_require__(4)))

/***/ }),
/* 1120 */
/***/ (function(module) {

module.exports = JSON.parse("{\"uiNextRequiredFieldFinder\":{\"requiredCountRecalculatedNotification\":\"The required field count for this form has been updated\"}}");

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UIOverflowTooltipDirective = function UIOverflowTooltipDirective($document, $timeout, $sanitize) {
  var linkFunction = function linkFunction($scope, $elm, $attr) {
    var timeoutList = [],
      body = angular.element('body'),
      tooltip,
      position;
    function showTooltip(text) {
      position = $elm.offset();
      body.append('<div class="uiTooltip">' + '<div class="message">' + $sanitize(text) + '</div>' + '<div class="arrowBackground"></div>' + '<div class="arrow"></div>' + '</div>');
      tooltip = angular.element('.uiTooltip');
      tooltip.css('opacity', 0);

      // verify if the top will be offscreen
      var positionTop = position.top - tooltip[0].offsetHeight - 1;
      if (positionTop < 0) {
        positionTop = position.top + $elm[0].offsetHeight + 10;
        tooltip.addClass('bottom');
      }
      tooltip.css('top', positionTop);
      tooltip.css('left', position.left - tooltip[0].offsetWidth / 2 + $elm[0].offsetWidth / 2);
      timeoutList.push($timeout(function () {
        if (tooltip) {
          tooltip.css('opacity', 1);
        }
      }, 1));
    }
    function removeTooltip() {
      if (tooltip) {
        tooltip.css('opacity', 0);
        timeoutList.push($timeout(function () {
          angular.element('.uiTooltip').remove();
          tooltip = null;
        }, 200));
      }
    }
    $elm.on('mouseenter', function () {
      var displayTooltip = true;
      if ($elm[0].scrollWidth <= $elm.innerWidth()) {
        displayTooltip = false;
      }
      if (displayTooltip) {
        showTooltip($elm.text());
      }
    });
    $elm.on('mouseleave', removeTooltip);
    $scope.$on('$destroy', function () {
      $elm.off('mouseenter', showTooltip);
      $elm.off('mouseleave', removeTooltip);
      _.each(timeoutList, function (item) {
        $timeout.cancel(item);
      });
    });
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UIOverflowTooltipDirective.$inject = ["$document", "$timeout", "$sanitize"];
angular.module('umCore').directive('uiOverflowTooltip', UIOverflowTooltipDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UIPopupPositionDirective = function UIPopupPositionDirective($window, $timeout) {
  var linkFunction = function linkFunction($scope, $elm) {
    var timeoutList = [],
      appWindow = angular.element($window),
      toggleButton = $elm.find('.toggleCalendarPopup'),
      popupWidth = 247,
      offsetLeft = $elm.offset().left + popupWidth,
      windowWidth = appWindow.width();
    $scope.setPopupPosition = function () {
      var popup = $elm.find('.componentDateTimePickerPopup'),
        right = windowWidth - offsetLeft;
      if (right < 0) {
        popup.addClass('popupAlignRight');
      } else {
        popup.removeClass('popupAlignRight');
      }
    };
    toggleButton.on('click.uiPopupPosition', function () {
      timeoutList.push($timeout(function () {
        $scope.setPopupPosition();
      }));
    });
    appWindow.on('resize.uiPopupPosition', function () {
      windowWidth = appWindow.width();
    });
    $scope.$on('$destroy', function () {
      appWindow.off('resize.uiPopupPosition');
      toggleButton.off('click.uiPopupPosition');
      _.each(timeoutList, function (item) {
        $timeout.cancel(item);
      });
    });
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UIPopupPositionDirective.$inject = ["$window", "$timeout"];
angular.module('umFormViewer').directive('uiPopupPosition', UIPopupPositionDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UIRemoteChangeNotificationDirective = function UIRemoteChangeNotificationDirective($timeout, formViewerConstant) {
  var linkFunction = function linkFunction($scope, $elm, $attr) {
    var timeoutList = [],
      element = $($elm);
    function triggerNotification() {
      element.addClass('animateFieldNotification');
      element.addClass('remoteChangeNotification');
      timeoutList.push($timeout(function () {
        removeNotification();
      }, 1200));
    }
    function removeNotification() {
      element.removeClass('remoteChangeNotification');
      timeoutList.push($timeout(function () {
        removeTransition();
      }, 500));
    }
    function removeTransition() {
      element.removeClass('animateFieldNotification');
    }
    $scope.$on(formViewerConstant.event.SHOW_REMOTE_FIELD_NOTIFICATION, function () {
      triggerNotification();
    });
    $scope.$on('$destroy', function () {
      _.each(timeoutList, function (item) {
        $timeout.cancel(item);
      });
    });
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UIRemoteChangeNotificationDirective.$inject = ["$timeout", "formViewerConstant"];
angular.module('umFormViewer').directive('uiRemoteChangeNotification', UIRemoteChangeNotificationDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var UIScrollIntoViewDirective = function UIScrollIntoViewDirective($timeout) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    var element = $($elm),
      viewport = $('.formViewer').first();
    function handleClick(event) {
      var targetElement = $(event.target),
        containerOffsetTop,
        elementOffsetTop,
        currentScroll,
        topMargin,
        isUiSelect,
        uiSelectParents,
        bottomOfElementYpos = element.offset().top + element.height(),
        bottomOfViewportYpos = viewport.offset().top + viewport.height(),
        numberOfPixelsOffscreen = bottomOfElementYpos - bottomOfViewportYpos,
        newScrollPosition;
      if (numberOfPixelsOffscreen > 20 && element.height() < viewport.height()) {
        containerOffsetTop = viewport.offset().top;
        elementOffsetTop = element.offset().top;
        currentScroll = viewport.scrollTop();
        topMargin = 75;
        newScrollPosition = currentScroll + elementOffsetTop - containerOffsetTop - topMargin;
        if (currentScroll !== newScrollPosition) {
          viewport.animate({
            scrollTop: newScrollPosition
          }, 300);
          isUiSelect = targetElement.hasClass('ui-select-match');
          uiSelectParents = targetElement.parents('.ui-select-match');
          if (isUiSelect || uiSelectParents && uiSelectParents.length > 0) {
            event.stopPropagation();
            event.preventDefault();
            $timeout(function () {
              targetElement.click();
            }, 500);
            return false;
          }
        }
      }
    }
    if ($attrs['uiScrollIntoView'] !== 'false') {
      // use add event listener so we can use the capture phase of the event
      element[0].addEventListener('click', handleClick, true);
      $scope.$on('$destroy', function () {
        element[0].removeEventListener('click', handleClick, true);
      });
    }
  };
  return {
    scope: true,
    restrict: 'A',
    link: linkFunction
  };
};
UIScrollIntoViewDirective.$inject = ["$timeout"];
angular.module('umFormViewer').directive('uiScrollIntoView', UIScrollIntoViewDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UISnippetsIndicatorDirective = function UISnippetsIndicatorDirective($document, $timeout, submissionConstant) {
  var linkFunction = function linkFunction($scope, $elm, $attr) {
    var currentFieldName = $attr.uiSnippetsIndicatorName,
      indicator,
      parentFormStructure = $scope.$ctrl.fieldStructure.parentFormStructure || {},
      isAcordUpload = parentFormStructure.isAcordUpload;
    var createIndicator = function createIndicator(fieldName) {
      var containerElement;
      indicator = $('<span class="glyphicon glyphicon-scissors"></span>').appendTo($elm);
      if ($attr.uiSnippetsIndicatorContainer === 'self') {
        containerElement = $elm;
      } else {
        containerElement = $elm.find('.' + currentFieldName);
      }
      indicator.css('left', containerElement.outerWidth());
    };
    if (isAcordUpload) {
      $scope.$on(submissionConstant.event.SET_CURRENT_SNIPPET_FIELD, function (e, fieldName, hasSnippet, isViewerOpen) {
        $elm.removeClass('currentSnippetField hasSnippet isViewerOpen');
        if (fieldName === currentFieldName) {
          var classList = [];
          if (!indicator) {
            createIndicator();
          }
          classList.push('currentSnippetField');
          if (hasSnippet) {
            classList.push('hasSnippet');
          }
          if (isViewerOpen) {
            classList.push('isViewerOpen');
          }
          $elm.addClass(classList.join(' '));
        }
        if (_.isNil(fieldName)) {
          $('.currentSnippetField').removeClass('currentSnippetField'); // for out of viewport element
        }
      });
    }
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UISnippetsIndicatorDirective.$inject = ["$document", "$timeout", "submissionConstant"];
angular.module('umFormViewer').directive('uiSnippetsIndicator', UISnippetsIndicatorDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UITooltipDirective = function UITooltipDirective($document, $timeout, submissionConstant, coreConstant, $sanitize) {
  var linkFunction = function linkFunction($scope, $elm, $attr) {
    var timeoutList = [],
      body = angular.element('body'),
      formViewer = angular.element('.formViewer .formViewerContainer:first-child'),
      tooltip,
      position,
      arrow,
      arrowBackground;
    function showTooltip(overwriteText) {
      var tooltipConfig = {};
      if ($scope.$ctrl) {
        tooltipConfig = $scope.$ctrl.fieldStructure ? $scope.$ctrl.fieldStructure.dynamicProperties.tooltip : $scope.$ctrl.tooltip;
      }
      if (_.isNil(tooltipConfig)) {
        tooltipConfig = {
          'type': 'tooltipPopover',
          'delay': 500,
          'message': overwriteText
        };
      }
      if (overwriteText && tooltipConfig.type !== 'errorPopover') {
        tooltipConfig.message = overwriteText;
      }
      var hasTooltipMessage = tooltipConfig && tooltipConfig.message,
        showTooltipDelay = tooltipConfig ? tooltipConfig.delay : 0,
        activeElement = $document[0].activeElement,
        hasFocus = activeElement ? activeElement.className === $elm[0].className : false,
        isEnabled = _.isUndefined($attr.uiTooltipEnabled) || !_.isUndefined($attr.uiTooltipEnabled) && $attr.uiTooltipEnabled !== 'false',
        shouldAddTooltip = !tooltip && hasTooltipMessage && isEnabled;
      if (shouldAddTooltip) {
        position = $elm.offset();
        body.append('<div class="uiTooltip ' + tooltipConfig.type + '">' + '<div class="message">' + $sanitize(tooltipConfig.message) + '</div>' + '<div class="arrowBackground"></div>' + '<div class="arrow"></div>' + '</div>');
        tooltip = angular.element('.uiTooltip');
        arrow = angular.element('.arrow');
        arrowBackground = angular.element('.arrowBackground');
        tooltip.css('opacity', 0);
        tooltip.css('top', position.top - tooltip[0].offsetHeight - 1);
        if (tooltip[0].offsetWidth / 2 > position.left) {
          tooltip.css('left', position.left - $elm[0].offsetWidth / 2);
          arrow.css('left', $elm[0].offsetWidth);
          arrowBackground.css('left', $elm[0].offsetWidth);
        } else {
          tooltip.css('left', position.left - tooltip[0].offsetWidth / 2 + $elm[0].offsetWidth / 2);
        }
        formViewer.on('scroll', removeTooltip);
        $scope.$on('$stateChangeStart', removeTooltip);
        $scope.$on(submissionConstant.event.CLEAR_VISIBLE_TOOLTIP, removeTooltip);
        timeoutList.push($timeout(function () {
          if (tooltip) {
            tooltip.css('opacity', 1);
          }
        }, showTooltipDelay));
      }
    }
    function removeTooltip() {
      if (tooltip) {
        tooltip.css('opacity', 0);
        timeoutList.push($timeout(function () {
          formViewer.off('scroll', removeTooltip);
          angular.element('.uiTooltip').remove();
          tooltip = null;
        }, 200));
      }
    }
    function onClick() {
      if (!$attr.uiTooltipUseClick) {
        removeTooltip();
      } else {
        if (!tooltip) {
          showTooltip($attr.uiTooltipText);
        } else {
          removeTooltip();
        }
      }
    }
    function onMouseEnter() {
      if (!$attr.uiTooltipUseClick) {
        var $element = $elm;
        if ($attr.uiTooltipTextElement) {
          $element = $elm.find('.' + $attr.uiTooltipTextElement + ':visible');
        }
        if ($element[0].scrollWidth > $element.innerWidth()) {
          showTooltip($attr.uiTooltipText);
        } else if ($attr.uiTooltipMessage) {
          showTooltip($attr.uiTooltipMessage);
        }
      }
    }
    $scope.$on(coreConstant.event.classCode.HIDE_TOOLTIP, function () {
      if (tooltip) {
        tooltip.css('opacity', 0);
        formViewer.off('scroll', removeTooltip);
        angular.element('.uiTooltip').remove();
        tooltip = null;
      }
    });
    $elm.on('click', onClick);
    $elm.on('mouseenter', onMouseEnter);
    $elm.on('mouseleave', removeTooltip);
    $elm.on('focus', removeTooltip);
    $scope.$on('$destroy', function () {
      $elm.off('click', onClick);
      $elm.off('mouseenter', onMouseEnter);
      $elm.off('mouseleave', removeTooltip);
      $elm.off('focus', removeTooltip);
      if (tooltip !== null) {
        formViewer.off('scroll', removeTooltip);
        angular.element('.uiTooltip').remove();
        tooltip = null;
      }
      _.each(timeoutList, function (item) {
        $timeout.cancel(item);
      });
    });
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UITooltipDirective.$inject = ["$document", "$timeout", "submissionConstant", "coreConstant", "$sanitize"];
angular.module('umFormViewer').directive('uiTooltip', UITooltipDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

/*@ngInject*/
var HiddenFieldDetailsModalController = function HiddenFieldDetailsModalController($rootScope, $scope, options, coreConstant, localization, formatUtil) {
  $scope.viewModel = {
    formHiddenFieldList: options.formHiddenFieldList
  };
  $scope.getFieldClassName = function (formField) {
    return "formField-".concat(formatUtil.formatAsSelector(formField.name));
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
HiddenFieldDetailsModalController.$inject = ["$rootScope", "$scope", "options", "coreConstant", "localization", "formatUtil"];
angular.module('umFormViewer').controller('hiddenFieldDetailsModalController', HiddenFieldDetailsModalController);

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

var path = '/formViewer/component/directive/uiHiddenFieldDetailsModal/hiddenFieldDetailsModal.tpl.html';
var html = "<div>\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\" ui-translate>formsViewer.hiddenFieldDetailsModal.title</h3>\n        <button class=\"close\" ng-click=\"$dismiss()\"><span class=\"glyphicon glyphicon-remove\"></span></button>\n    </div>\n\n    <div class=\"modal-body\">\n        <div class=\"rowHeader\">\n            <div class=\"fieldDetailsLabel\">\n                <label class=\"nameHeader\" ui-translate>formsViewer.hiddenFieldDetailsModal.name</label>\n            </div>\n            <div class=\"fieldDetailsLabel fieldDetailsValueHeader\">\n                <label ui-translate>formsViewer.hiddenFieldDetailsModal.id</label>\n            </div>\n            <div class=\"fieldDetailsLabel fieldDetailsValueHeader\">\n                <label ui-translate>formsViewer.hiddenFieldDetailsModal.value</label>\n            </div>\n        </div>\n        <div class=\"fieldDetailsRow {{::getFieldClassName(formField)}}\" ng-if=\"viewModel.formHiddenFieldList\"  ng-repeat=\"formField in viewModel.formHiddenFieldList\" >\n                <span class=\"fieldDetailsLabel\"\n                     uib-tooltip=\"{{::formField.name}}\"\n                     tooltip-append-to-body=\"true\"\n                     tooltip-enable=\"{{::formField.name.length > 29 }}\"\n                     tooltip-placement=\"bottom\">{{::formField.name}}</span>\n                <div class=\"fieldDetailsValue formFieldId\">{{::formField.id}}</div>\n                <div class=\"fieldDetailsValue formFieldValue\">{{::formField.value}}</div>\n        </div>\n\n\t    <div class=\"modal-footer\">\n\t        <button class=\"btn btn-primary\"\n\t                ng-click=\"$close()\">\n\t            <span ui-translate>formsViewer.fieldDetailsModal.okButtonLabel</span></button>\n\t    </div>\n\t</div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UIShowHiddenFieldDetailsModalDirective = function UIShowHiddenFieldDetailsModalDirective(formMediator, modalUtil) {
  var linkFunction = function linkFunction($scope, $elm, $attr) {
    var element = $($elm),
      formId = $scope.formId,
      formData = {},
      hiddenFieldList = [],
      pressKey = 0,
      sectionList = [],
      rowDetailObj = {};
    function collectHiddenFields(formData, hiddenFieldList) {
      if (!_.isNil(formData.sectionList)) {
        _.each(formData.sectionList, function (section) {
          collectHiddenFields(section, hiddenFieldList);
        });
      }
      if (!_.isNil(formData.rowList)) {
        _.each(formData.rowList, function (row) {
          collectHiddenFields(row, hiddenFieldList);
        });
      }
      if (!_.isNil(formData.fieldStructureList)) {
        _.each(formData.fieldStructureList, function (rowDetail) {
          if (!_.isNil(rowDetail)) {
            if (rowDetail.dynamicProperties.hidden === true) {
              rowDetailObj = {};
              rowDetailObj.name = rowDetail.uiField.fieldTemplate.variableName;
              if (!_.isNil(rowDetail.fieldModel)) {
                rowDetailObj.id = rowDetail.fieldModel.id;
                rowDetailObj.value = rowDetail.fieldModel.value;
              } else {
                rowDetailObj.value = '';
              }
              hiddenFieldList.push(rowDetailObj);
            }
          }
        });
      }
    }
    function showHiddenFieldDetailsModal(event) {
      // statement will execute if the key combination is "SHIFT+1+Click"
      if (event.shiftKey && pressKey === 49) {
        formData = formMediator.getFormStructure($scope.formId);
        hiddenFieldList = [];
        collectHiddenFields(formData, hiddenFieldList);
        modalUtil.showHiddenFieldDetails(hiddenFieldList);
      }
    }
    $(document).bind('keydown', onKeyDown);
    function onKeyDown(event) {
      pressKey = event.keyCode;
    }
    element.bind('click', showHiddenFieldDetailsModal);
    $scope.$on('$destroy', function () {
      element.unbind('click', showHiddenFieldDetailsModal);
      $(document).unbind('keydown', onKeyDown);
    });
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UIShowHiddenFieldDetailsModalDirective.$inject = ["formMediator", "modalUtil"];
angular.module('umFormViewer').directive('uiShowHiddenFieldDetailsModal', UIShowHiddenFieldDetailsModalDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

var path = '/formViewer/component/directive/uiShowFieldDetailsModal/fieldDetailsModal.tpl.html';
var html = "<div class=\"fieldDetailsModalContent\">\n\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\" ui-translate>formsViewer.fieldDetailsModal.title</h3>\n        <button class=\"close\" ng-click=\"$dismiss()\"><span class=\"glyphicon glyphicon-remove\"></span></button>\n    </div>\n\n    <div class=\"modal-body\">\n\n        <!-- Field -->\n        <div class=\"fieldDetailsRow\">\n            <div><h4 ui-translate>formsViewer.fieldDetailsModal.fieldAttributes</h4></div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ng-if=\"!viewModel.fieldStructure.fieldModel\" ui-translate>\n                formsViewer.fieldDetailsModal.fieldInstanceDoesNotExist\n            </div>\n        </div>\n        <div ng-if=\"viewModel.fieldStructure.fieldModel\">\n            <div class=\"fieldDetailsRow\">\n                <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.fieldId</div>\n                <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.fieldModel.id}}</div>\n            </div>\n            <div class=\"fieldDetailsRow\">\n                <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.rowId</div>\n                <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.fieldModel.rowId}}</div>\n            </div>\n            <div class=\"fieldDetailsRow\">\n                <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.requiredFieldLevel</div>\n                <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.fieldModel.requiredFieldLevel !== -1 ? viewModel.fieldStructure.fieldModel.requiredFieldLevel : ''}}</div>\n            </div>\n            <div class=\"fieldDetailsRow\">\n                <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.name</div>\n                <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.fieldModel.name}}</div>\n            </div>\n            <div class=\"fieldDetailsRow\">\n                <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.value</div>\n                <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.fieldModel.value}}</div>\n            </div>\n            <div class=\"fieldDetailsRow\">\n                <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.valueLabel</div>\n                <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.fieldModel.valueLabel}}</div>\n            </div>\n        </div>\n\n        <!-- Field Template -->\n        <div class=\"fieldDetailsRow\">\n            <div><h4 ui-translate>formsViewer.fieldDetailsModal.fieldTemplateAttributes</h4>\n            </div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.fieldTemplateId</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.uiField.fieldTemplate.id}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.variableName</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.uiField.fieldTemplate.variableName}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.dataSetName</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.uiField.fieldTemplate.dataSetName}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.agencyVisible</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.uiField.fieldTemplate.agencyVisible}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.carrierVisible</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.uiField.fieldTemplate.carrierVisible}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.hidden</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.uiField.fieldTemplate.hidden}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.agencyEditableFieldLevel</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.agencyEditableFieldLevelString}}\n            </div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.carrierEditableFieldLevel</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.carrierEditableFieldLevelString}}\n            </div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.requiredFieldLevel</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.requiredFieldLevelString}}\n            </div>\n        </div>\n\n        <!-- Form -->\n        <div class=\"fieldDetailsRow\">\n            <div><h4 ui-translate>formsViewer.fieldDetailsModal.formAttributes</h4></div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.formId</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentForm.id}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.referenceId</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentForm.referenceId}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.formName</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentForm.name}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.rootFormId</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentForm.rootFormId ? viewModel.fieldStructure.parentForm.rootFormId : viewModel.fieldStructure.parentForm.id}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.rootFormName</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentForm.rootFormBaseName ? viewModel.fieldStructure.parentForm.rootFormBaseName : viewModel.fieldStructure.parentForm.name}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.editableFieldLevel</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.formEditableFieldLevelString}}\n            </div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.requiredFieldLevel</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.formRequiredFieldLevelString}}\n            </div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.requiredFieldCount</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentForm.requiredFieldCount}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.totalRequiredFieldCount</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentForm.totalRequiredFieldCount}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>\n                formsViewer.fieldDetailsModal.requiredFieldToCreateApplicationCount\n            </div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentForm.requiredFieldToCreateApplicationCount}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.requiredFieldToSubmitCount</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentForm.requiredFieldToSubmitCount}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.requiredFieldToRateCount</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentForm.requiredFieldToRateCount}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.requiredFieldToPriceCount</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentForm.requiredFieldToPriceCount}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.requiredFieldToQuoteCount</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentForm.requiredFieldToQuoteCount}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.requiredFieldToIssueCount</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentForm.requiredFieldToIssueCount}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>\n                formsViewer.fieldDetailsModal.requiredFieldToRequestCancellationCount\n            </div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentForm.requiredFieldToRequestCancellationCount}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>\n                formsViewer.fieldDetailsModal.requiredFieldToSubmitCancellationCount\n            </div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentForm.requiredFieldToSubmitCancellationCount}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.requiredFieldToCancelCount</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentForm.requiredFieldToCancelCount}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.linkedFieldsResolved</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentForm.linkedFieldsResolved}}</div>\n        </div>\n\n        <!-- Form Template -->\n        <div class=\"fieldDetailsRow\">\n            <div><h4 ui-translate>formsViewer.fieldDetailsModal.formTemplateAttributes</h4>\n            </div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.formTemplateId</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentUiFormTemplate.formTemplate.id}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.formTemplateDisplayName</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentUiFormTemplate.formTemplate.displayName}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.formTemplateUniqueName</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentUiFormTemplate.formTemplate.uniqueName}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.version</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentUiFormTemplate.formTemplate.version}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.effectiveDateRangeBegin</div>\n            <div class=\"fieldDetailsValue\">\n                {{viewModel.fieldStructure.parentUiFormTemplate.formTemplate.effectiveDateRangeBegin}}\n            </div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.effectiveDateRangeEnd</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentUiFormTemplate.formTemplate.effectiveDateRangeEnd}}\n            </div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.root</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentUiFormTemplate.formTemplate.root}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.includedInEndorsement</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentUiFormTemplate.formTemplate.includedInEndorsement}}\n            </div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.proposalLevel</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentUiFormTemplate.formTemplate.proposalLevel}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.ordering</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentUiFormTemplate.ordering}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.deferLinkedFields</div>\n            <div class=\"fieldDetailsValue\">{{viewModel.fieldStructure.parentUiFormTemplate.formTemplate.deferLinkedFields}}</div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>\n                formsViewer.fieldDetailsModal.requiredFieldToCreateApplicationCount\n            </div>\n            <div class=\"fieldDetailsValue\">\n                {{viewModel.fieldStructure.parentUiFormTemplate.formTemplate.requiredFieldToCreateApplicationCount}}\n            </div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.requiredFieldToSubmitCount</div>\n            <div class=\"fieldDetailsValue\">\n                {{viewModel.fieldStructure.parentUiFormTemplate.formTemplate.requiredFieldToSubmitCount}}\n            </div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.requiredFieldToRateCount</div>\n            <div class=\"fieldDetailsValue\">\n                {{viewModel.fieldStructure.parentUiFormTemplate.formTemplate.requiredFieldToRateCount}}\n            </div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.requiredFieldToPriceCount</div>\n            <div class=\"fieldDetailsValue\">\n                {{viewModel.fieldStructure.parentUiFormTemplate.formTemplate.requiredFieldToPriceCount}}\n            </div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.requiredFieldToQuoteCount</div>\n            <div class=\"fieldDetailsValue\">\n                {{viewModel.fieldStructure.parentUiFormTemplate.formTemplate.requiredFieldToQuoteCount}}\n            </div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.requiredFieldToBindCount</div>\n            <div class=\"fieldDetailsValue\">\n                {{viewModel.fieldStructure.parentUiFormTemplate.formTemplate.requiredFieldToBindCount}}\n            </div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.requiredFieldToIssueCount</div>\n            <div class=\"fieldDetailsValue\">\n                {{viewModel.fieldStructure.parentUiFormTemplate.formTemplate.requiredFieldToIssueCount}}\n            </div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>\n                formsViewer.fieldDetailsModal.requiredFieldToRequestCancellationCount\n            </div>\n            <div class=\"fieldDetailsValue\">\n                {{viewModel.fieldStructure.parentUiFormTemplate.formTemplate.requiredFieldToRequestCancellationCount}}\n            </div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>\n                formsViewer.fieldDetailsModal.requiredFieldToSubmitCancellationCount\n            </div>\n            <div class=\"fieldDetailsValue\">\n                {{viewModel.fieldStructure.parentUiFormTemplate.formTemplate.requiredFieldToSubmitCancellationCount}}\n            </div>\n        </div>\n        <div class=\"fieldDetailsRow\">\n            <div class=\"fieldDetailsLabel\" ui-translate>formsViewer.fieldDetailsModal.requiredFieldToCancelCount</div>\n            <div class=\"fieldDetailsValue\">\n                {{viewModel.fieldStructure.parentUiFormTemplate.formTemplate.requiredFieldToCancelCount}}\n            </div>\n        </div>\n    </div>\n\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-primary\"\n                ng-click=\"$close()\">\n            <span ui-translate>formsViewer.fieldDetailsModal.okButtonLabel</span></button>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

/*@ngInject*/
var FieldDetailsModalController = function FieldDetailsModalController($rootScope, $scope, options, coreConstant, localization) {
  $scope.viewModel = {
    fieldStructure: options.fieldStructure,
    formStructure: options.formStructure,
    agencyEditableFieldLevelString: '',
    carrierEditableFieldLevelString: '',
    requiredFieldLevelString: '',
    formEditableFieldLevelString: '',
    formRequiredFieldLevelString: ''
  };
  localization.getTranslationByKey('formsViewer.editableFieldLevel.' + $scope.viewModel.fieldStructure.uiField.fieldTemplate.agencyEditableFieldLevel).then(function (translation) {
    $scope.viewModel.agencyEditableFieldLevelString = translation;
  });
  localization.getTranslationByKey('formsViewer.editableFieldLevel.' + $scope.viewModel.fieldStructure.uiField.fieldTemplate.carrierEditableFieldLevel).then(function (translation) {
    $scope.viewModel.carrierEditableFieldLevelString = translation;
  });
  localization.getTranslationByKey('formsViewer.requiredFieldLevel.' + $scope.viewModel.fieldStructure.uiField.fieldTemplate.requiredFieldLevel).then(function (translation) {
    $scope.viewModel.requiredFieldLevelString = translation;
  });
  localization.getTranslationByKey('formsViewer.editableFieldLevel.' + $scope.viewModel.fieldStructure.parentForm.editableFieldLevel).then(function (translation) {
    $scope.viewModel.formEditableFieldLevelString = translation;
  });
  localization.getTranslationByKey('formsViewer.requiredFieldLevel.' + $scope.viewModel.fieldStructure.parentForm.requiredFieldLevel).then(function (translation) {
    $scope.viewModel.formRequiredFieldLevelString = translation;
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
FieldDetailsModalController.$inject = ["$rootScope", "$scope", "options", "coreConstant", "localization"];
angular.module('umFormViewer').controller('fieldDetailsModalController', FieldDetailsModalController);

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var UIShowFieldDetailsModalDirective = function UIShowFieldDetailsModalDirective(formMediator, modalUtil) {
  var linkFunction = function linkFunction($scope, $elm, $attr) {
    var element = $($elm),
      rootFormId = $scope.fieldStructure.rootFormId;
    function showFieldDetailsModal(event) {
      if (event.shiftKey && (event.ctrlKey || event.altKey)) {
        modalUtil.showFieldDetails($scope.fieldStructure, formMediator.getFormStructure(rootFormId));
      }
    }
    element.bind('click', showFieldDetailsModal);
    $scope.$on('$destroy', function () {
      element.unbind('click', showFieldDetailsModal);
    });
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UIShowFieldDetailsModalDirective.$inject = ["formMediator", "modalUtil"];
angular.module('umFormViewer').directive('uiShowFieldDetailsModal', UIShowFieldDetailsModalDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1135);
var FormDropdownComponent = {
  templateUrl: '/formViewer/component/dropdown/formDropdown.tpl.html',
  controller: 'formDropdownController',
  bindings: {
    fieldStructure: '<',
    timeLastModified: '<',
    hideLabel: '<'
  }
};
angular.module('umFormViewer').component('uiFormDropdown', FormDropdownComponent);

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(757);
__webpack_require__(1136);
__webpack_require__(1137);
var LazyLoadDropdownComponent = {
  templateUrl: '/formViewer/component/dropdown/lazyLoadDropdown/lazyLoadDropdown.tpl.html',
  controller: 'umLazyLoadDropdownController',
  transclude: {
    'footerOption': '?footer',
    'feedbackMessage': '?feedback'
  },
  bindings: {
    className: '@',
    required: '<',
    optionList: '<',
    optionListCount: '<',
    placeholder: '<',
    selectedValue: '<',
    selectedName: '<',
    onChange: '&',
    onOpen: '&',
    onSearch: '&',
    isLoading: '<',
    isDisabled: '<',
    hasBusinessCard: '<',
    hasOrganizationCard: '<',
    isValid: '<',
    feedbackOverride: '<',
    maximumOptionsLimit: '<',
    componentClassName: '@',
    tooltipMessage: '<'
  }
};
angular.module('umFormViewer').component('umLazyLoadDropdown', LazyLoadDropdownComponent);

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(i18n, _) {/*@ngInject*/
var LazyLoadDropdownController = function LazyLoadDropdownController($scope, $element, localization, dropdownMediator, coreConstant) {
  var _this = this;
  this.$onInit = function () {
    this.isLoading = this.isLoading === 'true' || this.isLoading === true;

    /**
     * begin dropdown controller
     */
    this.isDisabled = this.isDisabled === true || this.isDisabled === 'true';
    this.selectedOption = this.selectedOption || {};
    this.searchTerm = this.searchTerm || '';
    this.placeholder = this.placeholder || '';
    this.required = this.required === true || this.required === 'true' || false;
    localization.setupLocale('component', __webpack_require__(758));
    this.feedbackMessage = '';
    this.maximumOptionsError = i18n.t('component|dropdown.maximumOptionsLimitMessage', {
      maxOptions: this.maximumOptionsLimit
    });
    this.noMatchesError = i18n.t('component|dropdown.noMatchesFoundMessage');
    this.uniqueComponentClass = this.className + 'DropdownComponent';
    $element.addClass('umDropdownContainer');
    $element.addClass('lazyLoadDropdown');
    $element.addClass(this.uniqueComponentClass);
    $element.addClass(this.componentClassName);
    this.validateOptionList();

    /**
     * end dropdown controller
     */
  };
  this.$onChanges = function (changes) {
    var dropdownSelectedValueState = dropdownMediator.getDropdownSelectedValueState(changes, this.selectedOption, this.optionList, this.placeholder);
    if (!_.isNil(dropdownSelectedValueState)) {
      this.selectedOption = dropdownSelectedValueState.selectedOption;
      this.dropdownButtonDisplayText = dropdownSelectedValueState.dropdownButtonDisplayText;
    }
    var valueArray = _.split(this.selectedOption.value, '::');
    if (valueArray[0] === 'externalID') {
      this.hasBusinessCard = false;
      this.hasOrganizationCard = false;
    }
    if (this.hasBusinessCard) {
      this.businessCardUserId = !_.isNil(this.selectedOption.value) ? parseInt(this.selectedOption.value) : null;
    }
    if (this.hasOrganizationCard) {
      this.businessCardOrganizationId = !_.isNil(this.selectedOption.value) ? parseInt(this.selectedOption.value) : null;
    }
    this.validateOptionList();
  };
  this.toggleOptionList = function (event) {
    if (!event.originalEvent.repeat) {
      this.isOptionListOpen = !this.isOptionListOpen;
      if (this.isOptionListOpen) {
        this.onOpen();
      } else {
        $scope.setFocus('.' + this.uniqueComponentClass + ' .umDropdownButton button', event);
      }
    }
  };
  this.isDropdownListVisible = function () {
    return !this.isLoading && this.feedbackMessage === null;
  };
  this.onSearchTermChanged = function (searchTerm) {
    this.searchTerm = searchTerm;
    this.onSearch({
      searchTerm: searchTerm
    });
  };
  this.isClearButtonEnabled = function () {
    var isLoading = this.isLoading; // new in this impl
    var hasValueSelected = !_.isEmpty(this.selectedOption.name);
    return !isLoading && hasValueSelected;
  };
  this.onSelectedOptionChange = function (option) {
    this.selectedOption = option;
    this.toggleOptionList({
      originalEvent: {
        repeat: false
      }
    });
    this.onChange({
      selectedOption: this.selectedOption
    });
  };

  /**
   * begin dropdownController
   */

  this.validateOptionList = function () {
    if (!_.isNil(this.optionList)) {
      var numberOfOptions = _.get(this.optionList, 'length');
      var maximumOptionsLimitReached = numberOfOptions >= this.maximumOptionsLimit;
      var hasZeroOptions = numberOfOptions === 0;
      var hasPositiveCount = this.optionListCount > 0;
      if (hasZeroOptions) {
        if (hasPositiveCount) {
          this.feedbackMessage = i18n.t('component|dropdown.maximumOptionsLimitMessage', {
            maxOptions: this.optionListCount
          });
        } else {
          this.feedbackMessage = this.noMatchesError;
        }
      } else if (maximumOptionsLimitReached) {
        this.filteredOptionList = [];
        this.feedbackMessage = this.maximumOptionsError;
      } else {
        this.feedbackMessage = null;
      }
    }
    var hasFeedbackMessageOverride = !_.isEmpty(this.feedbackOverride);
    if (hasFeedbackMessageOverride) {
      this.feedbackMessage = this.feedbackOverride;
    }
  };
  this.onClearSelectedOption = function () {
    this.selectedOption = {};
    this.toggleOptionList({
      originalEvent: {
        repeat: false
      }
    });
    this.onChange({
      selectedOption: null
    });
  };
  $scope.$on(coreConstant.event.dropdown.DROPDOWN_CLEAR_SELECTED, function () {
    if (_this.isOptionListOpen) {
      _this.onClearSelectedOption();
    }
  });
  $scope.$on(coreConstant.event.dropdown.DROPDOWN_CLOSE, function (event) {
    if (_this.isOptionListOpen) {
      _this.toggleOptionList({
        originalEvent: {
          repeat: false
        }
      });
    }
  });

  /**
   * end dropdownController
   */
};
LazyLoadDropdownController.$inject = ["$scope", "$element", "localization", "dropdownMediator", "coreConstant"];
angular.module('umFormViewer').controller('umLazyLoadDropdownController', LazyLoadDropdownController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(18)["default"], __webpack_require__(0)))

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/formViewer/component/dropdown/lazyLoadDropdown/lazyLoadDropdown.tpl.html';
var html = "<um-focus-manager></um-focus-manager>\n\n<um-dropdown-button\n    display-text=\"$ctrl.dropdownButtonDisplayText\"\n    tooltip-text=\"$ctrl.isOptionListOpen || $ctrl.isDisabled ? '' : $ctrl.selectedOption.name || $ctrl.placeholder\"\n    tooltip-enabled=\"!$ctrl.isOptionListOpen && !$ctrl.isDisabled && $ctrl.isValid && !$ctrl.hasBusinessCard && !$ctrl.businessCardOrganizationId\"\n    tooltip-message=\"$ctrl.tooltipMessage\"\n    enabled=\"!$ctrl.isDisabled\"\n    valid=\"$ctrl.isValid\"\n    has-business-card=\"$ctrl.hasBusinessCard || $ctrl.hasOrganizationCard\"\n    business-card-user-id=\"$ctrl.businessCardUserId\"\n    business-card-organization-id=\"$ctrl.businessCardOrganizationId\"\n    ng-class=\"{userBusinessCard : $ctrl.businessCardUserId || $ctrl.businessCardUserId}\"\n    on-click=\"$ctrl.toggleOptionList(event)\"></um-dropdown-button>\n\n<um-dropdown-popover\n    ng-if=\"$ctrl.isOptionListOpen\"\n    popover-identifier=\"lazyLoadDropdown\"\n    popover-class-name=\"{{ ::$ctrl.className }}\">\n\n    <um-dropdown-keyboard-controls></um-dropdown-keyboard-controls>\n\n    <um-auto-close-popover\n        parent-class-name=\"{{ ::$ctrl.uniqueComponentClass }}\"\n        dropdown-popover-class-name=\"{{ ::$ctrl.className }}\"\n        on-close=\"$ctrl.toggleOptionList(event)\">\n    </um-auto-close-popover>\n\n    <um-label-button class=\"clearSelectedButton\"\n                     ng-if=\"!$ctrl.required && !$ctrl.isLoading\"\n                     enabled=\"$ctrl.isClearButtonEnabled()\"\n                     display-text=\"'Clear Selected'\"\n                     on-click=\"$ctrl.onClearSelectedOption()\"></um-label-button>\n\n    <um-dropdown-search ng-if=\"!$ctrl.isLoading\"\n                        search-term=\"$ctrl.searchTerm\"\n                        on-change=\"$ctrl.onSearchTermChanged(searchTerm)\"\n                        on-clear-search=\"$ctrl.onSearchTermChanged('')\"></um-dropdown-search>\n\n    <um-dropdown-list\n        ng-if=\"$ctrl.isDropdownListVisible()\"\n        option-list=\"$ctrl.optionList\"\n        selected-value=\"$ctrl.selectedValue\"\n        search-term=\"$ctrl.searchTerm\"\n        on-select=\"$ctrl.onSelectedOptionChange(option)\">\n\n        <div class=\"footerOption\"\n             ng-transclude=\"footerOption\"\n             ng-click=\"$ctrl.toggleOptionList($event)\"></div>\n\n    </um-dropdown-list>\n\n    <div ng-if=\"$ctrl.isLoading\"\n         class=\"spinnerContainer\">\n\n        <img class=\"icon-spinner\"\n             src=\"" + __webpack_require__(67) + "\" />\n    </div>\n\n    <div ng-if=\"$ctrl.feedbackMessage\"\n         class=\"feedbackMessage\">\n\n        <div class=\"messageLabel\">{{ $ctrl.feedbackMessage }}</div>\n    </div>\n</um-dropdown-popover>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

var path = '/formViewer/component/dropdown/formDropdown.tpl.html';
var html = "<div class=\"formComponentContainer dropdownComponent {{ ::$ctrl.configurationClass }}\"\n     ng-class=\"{\n        labelLeft: $ctrl.fieldStructure.layout.isLabelLeftAligned,\n        showAsHidden: $ctrl.fieldStructure.dynamicProperties.hidden\n     }\"\n     ng-if=\"!$ctrl.fieldStructure.dynamicProperties.hidden || $ctrl.fieldStructure.isConfigurableComponent\">\n\n    <!--Label-->\n    <ui-required-indicator-label\n        ng-if=\"!$ctrl.hideLabel\"\n        required-label-config=\"$ctrl.fieldStructure.requiredIndicatorLabelConfig\">\n    </ui-required-indicator-label>\n\n    <!--Input-->\n    <div\n        class=\"componentInputContainer {{ ::$ctrl.isRowRepeaterComponent ? $ctrl.fieldStructure.rowRepeaterName : '' }} {{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n        ui-manual-size\n        width=\"::$ctrl.fieldStructure.layout.inputWidth\"\n        ui-snippets-indicator\n        ui-snippets-indicator-container=\"self\"\n        ui-snippets-indicator-name=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\">\n\n        <um-lazy-load-dropdown\n                     class-name=\"{{ ::$ctrl.dropdownComponentName }}\"\n                     required=\"$ctrl.isRequired()\"\n                     placeholder=\"$ctrl.placeholder\"\n                     option-list=\"$ctrl.filteredItemsList\"\n                     option-list-count=\"$ctrl.dataSetCount\"\n                     has-business-card=\"$ctrl.hasBusinessCard\"\n                     has-organization-card=\"$ctrl.hasOrganizationCard\"\n                     selected-value=\"$ctrl.dropdownSelectedValue.value\"\n                     selected-name=\"$ctrl.dropdownSelectedValue.name\"\n                     on-change=\"$ctrl.handleSelect(selectedOption)\"\n                     on-open=\"$ctrl.handleFocus()\"\n                     on-search=\"$ctrl.onSearch(searchTerm)\"\n                     is-disabled=\"$ctrl.fieldStructure.dynamicProperties.disabled\"\n                     is-valid=\"$ctrl.fieldStructure.dynamicProperties.isValid\"\n                     is-loading=\"$ctrl.showLoadingSpinner\"\n                     feedback-override=\"$ctrl.feedbackMessageOverride\"\n                     maximum-options-limit=\"$ctrl.maximumDropdownSize\"\n                     component-class-name=\"{{ ::$ctrl.dropdownClassName }}\"\n                     tooltip-message=\"$ctrl.fieldStructure.dynamicProperties.tooltip.message\"\n                     ui-remote-change-notification>\n\n            <footer ng-if=\"$ctrl.dropdownExecutorEnabled\">\n                <button class=\"btn-link optionRowContainer\"\n                        ng-class=\"{ 'selected': false }\"\n                        ng-click=\"$ctrl.execute()\"\n                        tabindex=\"0\">\n                    <span class=\"buttonLabel\">{{ $ctrl.dropdownExecutorPrompt }}</span>\n                </button>\n            </footer>\n\n        </um-lazy-load-dropdown>\n\n    </div>\n    <div class=\"componentOtherContainer\"\n         ng-if=\"$ctrl.isOtherTriggered\">\n        <ui-required-indicator-label\n            required-label-config=\"$ctrl.otherPromptLabelConfig\">\n        </ui-required-indicator-label>\n\n        <input type=\"text\"\n               class=\"otherTextBoxValue\"\n               ng-model=\"$ctrl.otherPromptValue\"\n               ng-blur=\"$ctrl.handleSelect($ctrl.dropdownSelectedValue)\"\n               ng-disabled=\"$ctrl.fieldStructure.dynamicProperties.disabled\"\n               ng-mouseenter=\"$ctrl.mouseEnter($event, $ctrl.fieldStructure)\"\n               ng-mouseleave=\"$ctrl.mouseLeave()\"\n               ui-manual-size\n               ui-datetime-formatter\n               width=\"::$ctrl.fieldStructure.layout.inputWidth\"\n               ng-class=\"{\n                error: !$ctrl.fieldStructure.dynamicProperties.isValid,\n                'ui-datetime-formatter': $ctrl.isDate\n             }\">\n    </div>\n</div>\n\n<span class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n      ng-if=\"$ctrl.fieldStructure.dynamicProperties.hidden && !$ctrl.fieldStructure.isConfigurableComponent\"></span>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, i18n) {/*@ngInject*/
var FormDropdownController = function FormDropdownController($scope, $controller, $q, $filter, $rootScope, coreConstant, formViewerConstant, formComponentUtil, preferenceModel, coreMediator, xmlUtil, formMediator, localization, modalUtil, loadingBarHandler, remoteFunction, dataSetType, functionActionUtil) {
  var splitKey = '::',
    itemLoading = {
      loading: true,
      disabled: true,
      'name': null
    },
    itemLongList = {
      warning: true,
      disabled: true,
      'name': null
    },
    searchPrompt,
    noMatchFound,
    dropdownExecutorDefaultConfirmYesButton,
    dropdownExecutorDefaultConfirmNoButton,
    dropdownExecutorDefaultConfirmTitle;
  angular.extend(this, $controller('baseFormComponentController', {
    $scope: $scope
  }), $controller('baseDataSetFormComponentController', {
    $scope: $scope
  }));
  this.$onInit = function () {
    var _this = this;
    localization.setupLocale('formComponent', __webpack_require__(1140));
    this.feedbackMessage = '';
    this.maximumDropdownSize = preferenceModel.get('system.maximumDropdownSize');
    var uiField = this.fieldStructure.uiField,
      fieldInstance = this.fieldStructure.fieldModel,
      dataSetImmediateLoad = this.fieldStructure.dynamicProperties.hasValue && _.isNil(fieldInstance.valueLabel),
      preventDataSetLoadIfConfigurableComponent = true;
    localization.getTranslationByKey('formsViewer.controls.dropdown').then(function (translation) {
      itemLoading.name = _.get(translation, 'loading');
      itemLongList.name = _.get(translation, 'longListWarning');
      searchPrompt = _.get(translation, 'searchPrompt');
      noMatchFound = _.get(translation, 'noMatchFound');
      dropdownExecutorDefaultConfirmYesButton = _.get(translation, 'dropdownExecutorDefaultConfirmYesButton');
      dropdownExecutorDefaultConfirmNoButton = _.get(translation, 'dropdownExecutorDefaultConfirmNoButton');
      dropdownExecutorDefaultConfirmTitle = _.get(translation, 'dropdownExecutorDefaultConfirmTitle');
      _this.setSearchCharLimit = _.get(translation, 'searchCharLimit');
    });
    this.onInitDataSetComponent(dataSetImmediateLoad, preventDataSetLoadIfConfigurableComponent).then(function () {
      var shouldSetDefaultItemListValue = _this.fieldStructure.dynamicProperties.hasValue && _this.isItemsListEmpty();
      if (shouldSetDefaultItemListValue) {
        // Because we don't load the dataset items on initialization for dynamic data set dropdowns,
        // we need to have a default item in the list if the field currently has a value
        _this.setDefaultItemListValue();
      }
      _this.updateDropdownSelectedValue(true);
    });
    this.fieldOptions = uiField.options ? xmlUtil.parseString(uiField.options) : {};
    this.isRegistered = false;
    this.dropdownSelectedValue = null;
    this.placeholder = this.fieldOptions.prompt || '';
    this.isDate = this.fieldStructure.uiField.fieldTemplate.validator === 'date';
    this.hasBusinessCard = this.fieldStructure.uiField.hasBusinessCard;
    this.hasOrganizationCard = this.fieldStructure.uiField.hasOrganizationCard;
    this.otherPromptLabelConfig = {
      label: this.fieldOptions.otherPrompt
    };
    this.isOtherTriggered = this.checkIfOtherTriggered(fieldInstance);
    this.isRowRepeaterComponent = this.fieldStructure.rowRepeaterId !== undefined;
    if (this.isRowRepeaterComponent) {
      this.dropdownComponentName = this.fieldStructure.rowRepeaterName + 'row' + this.fieldStructure.rowNumber + this.getComponentId(this.fieldStructure.uiField);
    } else {
      this.dropdownComponentName = this.getComponentId(this.fieldStructure.uiField);
    }
    this.dropdownExecutorEnabled = !!this.fieldOptions.dropdownExecutor;
    if (this.dropdownExecutorEnabled) {
      this.dropdownExecutorPrompt = this.fieldOptions.dropdownExecutorPrompt;
    }
    this.dropdownClassName = this.getComponentClassName(this.fieldStructure.uiField);
    this.formStructure = formMediator.getFormStructure(this.fieldStructure.rootFormId);
  };
  this.$onChanges = function (changes) {
    var timeLastModified = _.get(changes, 'timeLastModified');
    if (timeLastModified && !timeLastModified.isFirstChange()) {
      var fieldInstance = this.fieldStructure.fieldModel;
      this.onChanges();
      this.isOtherTriggered = this.checkIfOtherTriggered(fieldInstance);
      if (this.isItemsListEmpty() && this.fieldStructure.dynamicProperties.hasValue) {
        this.setDefaultItemListValue();
      }
      this.updateDropdownSelectedValue();
    }
  };
  this.isRequired = function () {
    var isRequired = this.fieldStructure.requiredIndicatorLabelConfig.required === true;
    var isOptionallyRequired = this.fieldStructure.dynamicProperties.isOptionallyRequired === false;
    return isRequired || isOptionallyRequired;
  };

  /*
   * this.handleFocus is set to baseFormComponentController.handleFocus
   * because of the above angular.extend call. save it in superHandleFocus
   * so that the handleFocus method below can call it.
   */
  this.superHandleFocus = this.handleFocus;
  this.handleFocus = function () {
    var _this2 = this;
    this.superHandleFocus();
    $rootScope.$broadcast(coreConstant.event.HIDE_FORM_TOOLTIP);
    if (!this.isRegistered && (_.isNil(this.fieldStructure.parentFormStructure) || !this.fieldStructure.parentFormStructure.isConfigurableForm)) {
      this.loadDataSet(true).then(function () {
        _this2.updateDropdownSelectedValue(true);
        if (_this2.minimumSearchLength === 1) {
          _this2.minimumSearchLengthError = i18n.t('formComponent|dropdown.minimumSearchLengthMessage', {
            minChars: _this2.minimumSearchLength
          });
        } else {
          _this2.minimumSearchLengthError = i18n.t('formComponent|dropdown.minimumSearchLengthMessage_plural', {
            minChars: _this2.minimumSearchLength
          });
        }
        if (_this2.supportSearch) {
          _this2.validateRemoteSearch();
        }
        _this2.isRegistered = true;
      });
    } else {
      if (this.supportSearch) {
        this.validateRemoteSearch();
      }
    }
  };
  this.handleSelect = function (selectionOption) {
    this.dropdownSelectedValue = selectionOption;
    if (this.dropdownExecutorEnabled && !_.isNil(this.dropdownSelectedValue) && this.dropdownSelectedValue.isDropdownExecutor) {
      this.dropdownSelectedValue = null;
      this.execute();
    } else {
      this.fieldStructure.hasLocalChanges = true;
      this.updateOriginalFieldValue();
      if (this.dropdownSelectedValue) {
        if (!this.fieldStructure.fieldModel) {
          this.fieldStructure.fieldModel = {};
        }
        this.fieldStructure.fieldModel.value = _.get(this.dropdownSelectedValue, 'value');
        this.fieldStructure.fieldModel.valueLabel = _.get(this.dropdownSelectedValue, 'name');
        this.isOtherTriggered = this.checkIfOtherTriggered(this.fieldStructure.fieldModel);
        if (this.isOtherTriggered) {
          this.fieldStructure.fieldModel.value += splitKey + _.toString(this.otherPromptValue);
        }
      } else {
        this.fieldStructure.fieldModel.value = null;
        this.fieldStructure.fieldModel.valueLabel = null;
      }
      formComponentUtil.setupFieldProperties(this.fieldStructure, this.formStructure.currencyCode);
      formMediator.handleFieldChange(this.fieldStructure.parentForm.id, this.fieldStructure, this.resetFieldValue.bind(this));
      $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, this.dropdownSelectedValue);
    }
  };
  this.execute = function () {
    var _this3 = this;
    var formId = this.fieldStructure.parentForm.id,
      fieldId = this.fieldStructure.fieldModel ? this.fieldStructure.fieldModel.id : null,
      rowIndex = this.fieldStructure.rowNumber,
      submissionId = this.fieldStructure.parentForm.submissionId,
      config = {
        cancelButtonLabel: !_.isEmpty(this.fieldOptions.dropdownExecutorNoButtonLabel) ? this.fieldOptions.dropdownExecutorNoButtonLabel : dropdownExecutorDefaultConfirmNoButton,
        confirmActionButtonLabel: !_.isEmpty(this.fieldOptions.dropdownExecutorYesButtonLabel) ? this.fieldOptions.dropdownExecutorYesButtonLabel : dropdownExecutorDefaultConfirmYesButton,
        summary: this.fieldOptions.dropdownExecutorConfirmationMessage,
        title: !_.isEmpty(this.fieldOptions.dropdownExecutorConfirmationTitle) ? this.fieldOptions.dropdownExecutorConfirmationTitle : dropdownExecutorDefaultConfirmTitle
      },
      parameters = functionActionUtil.getParameterAsObject(this.fieldOptions.dropdownExecutorParameters);
    if (!_.isEmpty(this.fieldOptions.dropdownExecutorConfirmationMessage)) {
      modalUtil.showGenericConfirm(config).then(function () {
        if (!_.isEmpty(_this3.fieldOptions.dropdownExecutorProcessingIndicatorText)) {
          loadingBarHandler.showLoadingBar(_this3.fieldOptions.dropdownExecutorProcessingIndicatorText);
        }
        executeContinue(submissionId, formId, fieldId, rowIndex, parameters);
      });
    } else {
      executeContinue(submissionId, formId, fieldId, rowIndex, parameters);
    }
  };
  function executeContinue(submissionId, formId, fieldId, rowIndex, parameters) {
    remoteFunction.executeFunction(formId, fieldId, rowIndex, parameters, submissionId).finally(function () {
      loadingBarHandler.hideLoadingBar();
    });
  }
  this.updateDropdownSelectedValue = function (showInvalid) {
    var fieldInstance = this.fieldStructure.fieldModel,
      value,
      otherValue,
      splittedValue,
      selectedValueIndex,
      selectedValue;
    if (this.fieldStructure.dynamicProperties.hasValue) {
      value = fieldInstance.value;
      this.isOtherTriggered = this.checkIfOtherTriggered(fieldInstance);
      if (this.isOtherTriggered) {
        splittedValue = fieldInstance.value.split('::');
        value = splittedValue[0];
        otherValue = splittedValue[1];
      }
      selectedValueIndex = _.findIndex(this.itemsList, {
        value: value
      });
      $scope.$broadcast(formViewerConstant.event.DROPDOWN_UPDATE_ACTIVE_INDEX, selectedValueIndex);
      if (selectedValueIndex !== -1) {
        selectedValue = this.itemsList[selectedValueIndex];
      }
      this.otherPromptValue = _.toString(otherValue);

      // Don't reset the selected value if it's a warning
      if (!_.isNil(selectedValue) && this.isSpecialMessageDisplayed) {
        return;
      }
      if (_.isNil(selectedValue)) {
        this.dropdownSelectedValue = {
          name: fieldInstance.valueLabel,
          value: fieldInstance.value,
          ordering: -1
        };
        if (showInvalid) {
          if (this.type !== dataSetType.STATIC && this.clearInvalidFieldValue) {
            this.fieldStructure.fieldModel.value = '';
            this.dropdownSelectedValue = null;
            this.otherPromptValue = null;
            this.handleSelect();
          }
          this.fieldStructure.dynamicProperties.isValid = false;
        }
      } else {
        this.dropdownSelectedValue = selectedValue;
      }
    } else {
      this.dropdownSelectedValue = null;
      this.otherPromptValue = null;
    }
    $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, this.dropdownSelectedValue);
  };
  this.updateItems = function (updateEvent, data) {
    if (this.shouldUpdateItems(updateEvent, data)) {
      this.setItemsList(data.items);
      this.updateDropdownSelectedValue(false);
    }
  };
  this.updateOriginalFieldValue = function () {
    if (this.fieldStructure.fieldModel) {
      this.origFieldValue = this.fieldStructure.fieldModel.value;
      this.origFieldValueLabel = this.fieldStructure.fieldModel.valueLabel;
    }
  };
  this.resetFieldValue = function () {
    this.fieldStructure.fieldModel.value = this.origFieldValue;
    this.fieldStructure.fieldModel.valueLabel = this.origFieldValueLabel;
    formComponentUtil.setupFieldProperties(this.fieldStructure, this.formStructure.currencyCode);
    this.updateDropdownSelectedValue(false);
  };
  this.setDefaultItemListValue = function () {
    var fieldInstance = this.fieldStructure.fieldModel,
      value = this.fieldStructure.fieldModel.value,
      splittedValue,
      item;
    this.isOtherPromptVisible = this.fieldStructure.dynamicProperties.hasValue && this.fieldOptions.otherTrigger && _.toString(fieldInstance.value).indexOf(this.fieldOptions.otherTrigger) === 0;
    if (this.isOtherPromptVisible) {
      splittedValue = fieldInstance.value.split('::');
      value = splittedValue[0];
    }
    item = {
      value: value,
      name: this.fieldStructure.fieldModel.valueLabel,
      ordering: 1
    };
    this.setItemsList([item]);
  };
  this.setItemsList = function (itemsList) {
    this.itemsList = _.cloneDeep(itemsList);
    this.filterItems();
  };
  this.validateRemoteSearch = function () {
    var searchLength = _.size(this.searchText);
    var hasMinimumSearchLengthError = searchLength < this.minimumSearchLength;
    if (hasMinimumSearchLengthError) {
      this.feedbackMessageOverride = this.minimumSearchLengthError;
    } else {
      this.feedbackMessageOverride = null;
    }
    this.makeRemoteSearch();
  };
  this.makeRemoteSearch = function () {
    this.loadDataSet(true);
  };
  this.checkIfOtherTriggered = function (fieldInstance) {
    return fieldInstance && this.fieldOptions.otherTrigger && _.toString(fieldInstance.value).split('::')[0] === this.fieldOptions.otherTrigger;
  };
  this.onSearch = function (searchText) {
    this.setSearchText(searchText);
    if (this.supportSearch) {
      this.validateRemoteSearch();
      var isValidSearch = _.isNil(this.feedbackMessageOverride);
      if (isValidSearch) {
        this.makeRemoteSearch();
      }
      this.makeRemoteSearch();
    } else {
      this.filterItems();
    }
  };
  this.filterItems = function () {
    var searchText = this.searchText;
    var hasSearch = !_.isEmpty(searchText);
    var filteredItemsList = [];
    if (!this.supportSearch) {
      if (hasSearch) {
        filteredItemsList = _.filter(this.itemsList, function (item) {
          return _.includes(item.name.toLowerCase(), searchText.toLowerCase());
        });
      } else {
        filteredItemsList = _.cloneDeep(this.itemsList);
      }
      this.filteredItemsList = filteredItemsList;
    } else {
      this.filteredItemsList = _.cloneDeep(this.itemsList);
    }
  };
  $scope.$on(coreConstant.event.UPDATE_DATA_SET, this.updateItems.bind(this));
};
FormDropdownController.$inject = ["$scope", "$controller", "$q", "$filter", "$rootScope", "coreConstant", "formViewerConstant", "formComponentUtil", "preferenceModel", "coreMediator", "xmlUtil", "formMediator", "localization", "modalUtil", "loadingBarHandler", "remoteFunction", "dataSetType", "functionActionUtil"];
angular.module('umFormViewer').controller('formDropdownController', FormDropdownController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(18)["default"]))

/***/ }),
/* 1140 */
/***/ (function(module) {

module.exports = JSON.parse("{\"dropdown\":{\"minimumSearchLengthMessage\":\"Please type at least {{ minChars }} character to start search\",\"minimumSearchLengthMessage_plural\":\"Please type at least {{ minChars }} characters to start search\",\"remoteSearchCountWarning\":\"Too many results ({{ maxResults }} items). Please revise your search\"}}");

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

/*@ngInject*/
var FormDropdownHandleActiveIndexDirective = function FormDropdownHandleActiveIndexDirective(formViewerConstant) {
  return {
    require: 'uiSelect',
    link: function link($scope, $element, attrs, $select) {
      $scope.$on(formViewerConstant.event.DROPDOWN_UPDATE_ACTIVE_INDEX, function (e, activeIndex) {
        $select.activeIndex = activeIndex;
      });
    }
  };
};
FormDropdownHandleActiveIndexDirective.$inject = ["formViewerConstant"];
angular.module('umCore').directive('dropdownHandleActiveIndex', FormDropdownHandleActiveIndexDirective);

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FormDropdownHandleFocusDirective = function FormDropdownHandleFocusDirective(formViewerConstant) {
  return {
    require: 'uiSelect',
    link: function link($scope, $element, $attr, $select) {
      var searchInput = $element.querySelectorAll('input.ui-select-search'),
        currentItem;
      var handleFocusser = function handleFocusser() {
        var handleFocusMethodName = $attr.dropdownHandleFocus;
        if (_.isEmpty(handleFocusMethodName)) {
          handleFocusMethodName = 'handleFocus';
        }
        if ($scope.$ctrl && _.isFunction($scope.$ctrl[handleFocusMethodName])) {
          $scope.$ctrl[handleFocusMethodName]($select);
        }
      };
      $select.focusser.on('focus.formViewer', handleFocusser);
      searchInput.on('focus.handleFocusDirective.dropdown', handleFocusser);
      $scope.$on('$destroy', function () {
        searchInput.off('focus.handleFocusDirective.dropdown', handleFocusser);
        $select.focusser.off('focus.formViewer', handleFocusser);
      });
    }
  };
};
FormDropdownHandleFocusDirective.$inject = ["formViewerConstant"];
angular.module('umCore').directive('dropdownHandleFocus', FormDropdownHandleFocusDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

var path = '/formViewer/component/dropdown/formDropdownPlaceholder.tpl.html';
var html = "<ui-form-dropdown class=\"fieldListComponent\"\n             field-structure=\"fieldStructure\"\n             time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n             hide-label=\"::hideLabel\"\n             collapsible=\"::$ctrl.collapsible\"\n             ui-show-field-details-modal></ui-form-dropdown>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FormDropdownUnselectItemDirective = function FormDropdownUnselectItemDirective(coreConstant) {
  return {
    require: 'uiSelect',
    link: function link($scope, $element, $attr, $select) {
      var currentItem,
        searchInput = $element.querySelectorAll('input.ui-select-search'),
        directiveIdentifier = $attr.dropdownUnselectItem,
        handleSearchInputFocus = function handleSearchInputFocus() {
          $scope.$apply(function () {
            $select.activate();
            if (_.isNil(currentItem)) {
              $select.activeIndex = -1;
            }
          });
        };
      searchInput.on('focus.unselectItem.dropdown', handleSearchInputFocus);
      $scope.$on('$destroy', function () {
        searchInput.off('focus.unselectItem.dropdown', handleSearchInputFocus);
      });
      $scope.$on(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, function (event, item, identifier) {
        if (_.isEmpty(directiveIdentifier) || identifier === directiveIdentifier) {
          currentItem = item;
        }
      });
    }
  };
};
FormDropdownUnselectItemDirective.$inject = ["coreConstant"];
angular.module('umCore').directive('dropdownUnselectItem', FormDropdownUnselectItemDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

var path = '/formViewer/component/fieldList/fieldList.tpl.html';
var html = "<div class=\"{{ fieldStructure.hasResponsiveLayout ? fieldStructure.uiField.fieldTemplate.flags: '' }} fieldList\"\n     ng-repeat=\"fieldStructure in $ctrl.row.fieldStructureList track by fieldStructure.fieldStructureId\"\n     ng-switch on=\"fieldStructure.uiField.fieldTemplate.type\">\n\n    <!--Label-->\n    <div class=\"formComponent\"\n         ng-switch-when=\"9\"\n         ng-class=\"{'isHidden':$ctrl.isFieldHidden(fieldStructure)}\">\n        <ui-label\n            class=\"fieldListComponent\"\n            field-structure=\"fieldStructure\"\n            time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n            hide-label=\"::$ctrl.hideLabel\"\n            collapsible=\"::$ctrl.collapsible\"\n            ui-show-field-details-modal>\n        </ui-label>\n    </div>\n\n    <!--Spacer-->\n    <div class=\"formComponent\"\n         ng-switch-when=\"14\"\n         ng-class=\"{'isHidden':$ctrl.isFieldHidden(fieldStructure)}\">\n\n        <ui-spacer\n            class=\"fieldListComponent\"\n            field-structure=\"fieldStructure\"\n            collapsible=\"::$ctrl.collapsible\"\n            ui-show-field-details-modal>\n        </ui-spacer>\n    </div>\n\n    <!--Input-->\n    <div class=\"formComponent\"\n         ng-switch-when=\"0\"\n         ng-class=\"{'isHidden':$ctrl.isFieldHidden(fieldStructure)}\">\n\n        <ui-text-input\n            class=\"fieldListComponent\"\n            field-structure=\"fieldStructure\"\n            time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n            hide-label=\"::$ctrl.hideLabel\"\n            collapsible=\"::$ctrl.collapsible\"\n            ui-show-field-details-modal>\n        </ui-text-input>\n    </div>\n\n    <!--Radio-->\n    <div class=\"formComponent yesNoRadioComponent\"\n         ng-switch-when=\"2\"\n         ng-class=\"{'isHidden':$ctrl.isFieldHidden(fieldStructure)}\">\n\n        <ui-yes-no-radio\n            class=\"fieldListComponent\"\n            field-structure=\"fieldStructure\"\n            time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n            hide-label=\"::$ctrl.hideLabel\"\n            collapsible=\"::$ctrl.collapsible\"\n            ui-show-field-details-modal>\n        </ui-yes-no-radio>\n    </div>\n\n    <!--Checkbox-->\n    <div class=\"formComponent checkboxComponent\"\n         ng-switch-when=\"5\"\n         ng-class=\"{'isHidden':$ctrl.isFieldHidden(fieldStructure)}\">\n\n        <ui-checkbox\n            class=\"fieldListComponent\"\n            field-structure=\"fieldStructure\"\n            time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n            hide-label=\"::$ctrl.hideLabel\"\n            collapsible=\"::$ctrl.collapsible\"\n            ui-show-field-details-modal>\n        </ui-checkbox>\n    </div>\n\n    <!--Text Area-->\n    <div class=\"formComponent textAreaComponent\"\n         ng-switch-when=\"1\"\n         ng-class=\"{'isHidden':$ctrl.isFieldHidden(fieldStructure)}\">\n\n        <ui-text-area\n            class=\"fieldListComponent\"\n            field-structure=\"fieldStructure\"\n            time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n            collapsible=\"::$ctrl.collapsible\"\n            hide-label=\"::$ctrl.hideLabel\"\n            ui-show-field-details-modal>\n        </ui-text-area>\n    </div>\n\n    <!--Button-->\n    <div class=\"formComponent\"\n         ng-switch-when=\"8\"\n         ng-class=\"{'isHidden':$ctrl.isFieldHidden(fieldStructure)}\">\n        <button type=\"button\"\n                class=\"btn btn-sm btn-default fieldListComponent\"\n                ui-show-field-details-modal>\n            {{ ::fieldStructure.uiField.displayLabel }}\n        </button>\n    </div>\n\n    <!--Link Button-->\n    <div class=\"formComponent\"\n         ng-switch-when=\"20\"\n         ng-class=\"{'isHidden':$ctrl.isFieldHidden(fieldStructure)}\">\n        <ui-url-link\n            class=\"fieldListComponent\"\n            field-structure=\"fieldStructure\"\n            collapsible=\"::$ctrl.collapsible\"\n            ui-show-field-details-modal>\n        </ui-url-link>\n    </div>\n\n    <!--Dropdown-->\n    <div class=\"formComponent dropdownComponent\"\n         ng-switch-when=\"3\"\n         ng-class=\"{'isHidden':$ctrl.isFieldHidden(fieldStructure)}\">\n\n        <ui-dropdown\n            class=\"fieldListComponent\"\n            field-structure=\"fieldStructure\"\n            time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n            hide-label=\"::$ctrl.hideLabel\"\n            collapsible=\"::$ctrl.collapsible\"\n            ui-show-field-details-modal>\n        </ui-dropdown>\n    </div>\n\n    <!--Checkbox Group-->\n    <div class=\"formComponent checkboxGroupComponent\"\n         ng-switch-when=\"6\"\n         ng-class=\"{'isHidden':$ctrl.isFieldHidden(fieldStructure)}\">\n        <checkbox-group class=\"fieldListComponent\"\n                        field-structure=\"fieldStructure\"\n                        time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n                        hide-label=\"::$ctrl.hideLabel\"\n                        collapsible=\"::$ctrl.collapsible\"\n                        ui-show-field-details-modal>\n        </checkbox-group>\n    </div>\n\n    <!--Calendar-->\n    <div class=\"formComponent\"\n         ng-switch-when=\"7\"\n         ng-class=\"{'isHidden':$ctrl.isFieldHidden(fieldStructure)}\">\n        <ui-calendar\n            class=\"fieldListComponent\"\n            field-structure=\"fieldStructure\"\n            time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n            hide-label=\"::$ctrl.hideLabel\"\n            collapsible=\"::$ctrl.collapsible\"\n            ui-show-field-details-modal>\n        </ui-calendar>\n    </div>\n\n    <!--ClassCode finder-->\n    <div class=\"formComponent dropdownComponent classCodeComponent\"\n         ng-switch-when=\"12\"\n         ng-class=\"{'isHidden':$ctrl.isFieldHidden(fieldStructure)}\">\n\n        <ui-class-code\n            class=\"fieldListComponent\"\n            field-structure=\"fieldStructure\"\n            time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n            hide-label=\"::$ctrl.hideLabel\"\n            collapsible=\"::$ctrl.collapsible\"\n            ui-show-field-details-modal>\n        </ui-class-code>\n    </div>\n\n    <!--Radio Button Group-->\n    <div class=\"formComponent radioButtonGroupComponent\"\n         ng-switch-when=\"13\"\n         ng-class=\"{'isHidden':$ctrl.isFieldHidden(fieldStructure)}\">\n        <radio-button-group\n            class=\"fieldListComponent\"\n            field-structure=\"fieldStructure\"\n                            time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n                            hide-label=\"::$ctrl.hideLabel\"\n                            collapsible=\"::$ctrl.collapsible\"\n                            ui-show-field-details-modal>\n        </radio-button-group>\n    </div>\n\n\n    <!--Function Button-->\n    <div class=\"formComponent\"\n         ng-switch-when=\"17\">\n        <ui-function-button\n            class=\"fieldListComponent\"\n            field-structure=\"fieldStructure\"\n            ui-show-field-details-modal>\n        </ui-function-button>\n    </div>\n\n    <!--Upload Attachment finder-->\n    <div class=\"formComponent\"\n         ng-switch-when=\"21\"\n         ng-class=\"{'isHidden':$ctrl.isFieldHidden(fieldStructure)}\">\n\n        <ui-upload-attachment\n            class=\"fieldListComponent\"\n            field-structure=\"fieldStructure\"\n            time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n            hide-label=\"::$ctrl.hideLabel\"\n            collapsible=\"::$ctrl.collapsible\"\n            ui-show-field-details-modal>\n        </ui-upload-attachment>\n    </div>\n\n    <!--Form Summary Grid-->\n    <div class=\"formComponent\"\n         ng-switch-when=\"24\"\n         ng-class=\"{'isHidden':$ctrl.isFieldHidden(fieldStructure)}\">\n\n        <ui-form-summary-grid\n            class=\"fieldListComponent\"\n            field-structure=\"fieldStructure\"\n            time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n            ui-show-field-details-modal>\n        </ui-form-summary-grid>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

var FieldListComponent = {
  templateUrl: '/formViewer/component/fieldList/fieldList.tpl.html',
  controller: 'fieldListController',
  bindings: {
    row: '<',
    hideLabel: '<?',
    collapsible: '@'
  }
};
angular.module('umFormViewer').component('uiFieldList', FieldListComponent);

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

/*@ngInject*/
var FieldListController = function FieldListController(fieldType, formComponentUtil) {
  this.fieldType = fieldType;
  this.isFieldHidden = function (fieldStructure) {
    var fieldInstance = fieldStructure.fieldModel,
      fieldTemplate = fieldStructure.uiField.fieldTemplate;
    return formComponentUtil.isFieldHidden(fieldInstance, fieldTemplate);
  };
};
FieldListController.$inject = ["fieldType", "formComponentUtil"];
angular.module('umFormViewer').controller('fieldListController', FieldListController);

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

/*@ngInject*/
var DeleteFormSummaryInstanceRepository = function DeleteFormSummaryInstanceRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.deleteFormSummaryRow = function (formIds) {
    var url = '/rest/Form',
      config = {
        params: {
          formId: formIds
        }
      };
    return this.delete(url, config);
  };
};
DeleteFormSummaryInstanceRepository.$inject = ["baseRepository"];
angular.module('umFormViewer').service('deleteFormSummaryInstanceRepository', DeleteFormSummaryInstanceRepository);

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var FormSummaryButtonPositionDirective = function FormSummaryButtonPositionDirective($document, $window, $timeout, coreConstant) {
  var linkFunction = function linkFunction($scope, $elm) {
    var timeoutList = [],
      element = $($elm),
      window = $($window),
      screen = $($document),
      navigationToggleButton = $('.navigationContainer'),
      formViewer = $('.formViewer').first();
    function positionContainer(container) {
      var parentElementWidth = element.width(),
        parentElementXOffset = element.offset().left,
        screenWidth = screen.width(),
        isOffScreen = parentElementWidth + parentElementXOffset > screenWidth,
        totalWidthOffscreen,
        offset = 20,
        newXPosition;
      if (isOffScreen) {
        totalWidthOffscreen = parentElementXOffset + parentElementWidth - screenWidth;
        newXPosition = parseInt(totalWidthOffscreen + offset);
        container.css('right', newXPosition);
      } else {
        container.css('right', 10);
      }
    }
    function updateScreen() {
      var actionButtonContainer = element.find('.actionButtonContainer'),
        deleteButtonContainer = element.find('.deleteButtonContainer');
      if (actionButtonContainer.length) {
        positionContainer(actionButtonContainer);
      }
      if (deleteButtonContainer.length) {
        positionContainer(deleteButtonContainer);
      }
    }
    $scope.$watch('$ctrl.isDeleting', function () {
      timeoutList.push($timeout(function () {
        updateScreen();
      }, 400));
    });
    window.on('resize.formSummaryButtonPosition', updateScreen);
    formViewer.on('scroll', updateScreen);
    $scope.$on(coreConstant.NAVIGATION_DRAWER_TOGGLED, updateScreen);
    $scope.$on('$destroy', function () {
      window.off('resize.formSummaryButtonPosition', updateScreen);
      formViewer.off('scroll', updateScreen);
      _.each(timeoutList, function (item) {
        $timeout.cancel(item);
      });
    });
    timeoutList.push($timeout(function () {
      updateScreen();
    }, 400));
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
FormSummaryButtonPositionDirective.$inject = ["$document", "$window", "$timeout", "coreConstant"];
angular.module('umFormViewer').directive('formSummaryButtonPosition', FormSummaryButtonPositionDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1150 */
/***/ (function(module, exports) {

var path = '/formViewer/component/formSummary/formSummaryGrid.tpl.html';
var html = "<div class=\"formSummaryGrid {{ ::$ctrl.configurationClass }} {{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n     ng-class=\"{ showAsHidden: $ctrl.fieldStructure.dynamicProperties.hidden }\"\n     ng-if=\"!$ctrl.fieldStructure.dynamicProperties.hidden || $ctrl.fieldStructure.isConfigurableComponent\"\n     ui-manual-size\n     height=\"$ctrl.gridHeight + $ctrl.bulkUpdateHeight\"\n     ng-if=\"!$ctrl.isFormSummaryHidden || $ctrl.fieldStructure.isConfigurableComponent\"\n     uib-popover=\"{{ ::$ctrl.fieldStructure.uiField.tooltipText }}\"\n     popover-append-to-body=\"true\"\n     popover-trigger=\"mouseenter\">\n\n    <!--Title Bar-->\n    <div class=\"titleBar\">\n\n        <div class=\"title\">\n            {{ ::$ctrl.fieldStructure.uiField.displayLabel }}\n        </div>\n\n        <!--Action Button Container-->\n        <div class=\"buttonContainer actionButtonContainer\"\n             ng-show=\"!$ctrl.isDeleting\">\n\n            <!-- Add Row Button -->\n            <button ng-if=\"$ctrl.enableAdd\"\n                    class=\"btn btn-xs addButton\"\n                    ng-disabled=\"$ctrl.isWaitingForServerResponse\"\n                    ng-click=\"$ctrl.onAddClick()\"\n                    uib-tooltip=\"{{ ::$ctrl.addFormTooltip }}\"\n                    tooltip-popup-delay=\"500\"\n                    tooltip-append-to-body=\"true\"\n                    tooltip-placement=\"bottom\">\n                <span class=\"glyphicon glyphicon-plus\"></span>\n            </button>\n\n            <!-- Delete Mode Button-->\n            <button\n                ng-if=\"$ctrl.enableDelete\"\n                class=\"btn btn-xs deleteButton\"\n                ng-click=\"$ctrl.onInitializeDelete()\"\n                uib-tooltip=\"{{ ::$ctrl.trashIconTooltip }}\"\n                tooltip-popup-delay=\"500\"\n                tooltip-append-to-body=\"true\"\n                tooltip-placement=\"bottom\">\n                <span class=\"glyphicon glyphicon-trash\"></span>\n            </button>\n\n            <div class=\"btn-group\"\n                 uib-dropdown\n                 dropdown-append-to-body=\"true\"\n                 ng-if=\"$ctrl.showExportOrImportButtons()\">\n\n                <button type=\"button\"\n                        class=\"btn btn-xs\"\n                        uib-dropdown-toggle>\n                    <span class=\"glyphicon glyphicon-cog\"></span>\n                </button>\n\n                <ul class=\"dropdown-menu dropdown-menu-right\"\n                    uib-dropdown-menu>\n\n                    <li ng-if=\"!$ctrl.fieldStructure.dynamicProperties.disabled && $ctrl.showImportButton()\">\n                        <input class=\"hiddenUpload\"\n                               type=\"file\"\n                               ui-custom-on-change=\"$ctrl.onImportClick(file, event)\"/>\n                        <button type=\"button\"\n                                class=\"btn btn-link\"\n                                ui-upload\n                                ui-translate>formsViewer.formSummary.import</button>\n                    </li>\n                    <li ng-if=\"$ctrl.showExportButton()\">\n                        <button type=\"button\"\n                                class=\"btn btn-link\"\n                                ng-click=\"$ctrl.onExportClick()\"\n                                ui-upload\n                                ui-translate>formsViewer.formSummary.export</button>\n                    </li>\n                </ul>\n            </div>\n\n        </div>\n    </div>\n\n    <!--Bulk Update Header-->\n    <div class=\"bulkUpdateHeader\"\n         ng-if=\"$ctrl.isDeleting\">\n\n        <div class=\"instructions\"\n             ui-translate>formsViewer.formSummary.deleteTooltip</div>\n\n        <button class=\"btn btn-sm btn-default\"\n                ng-click=\"$ctrl.onCancelDelete()\">\n            <span ui-translate>formsViewer.formSummary.cancel</span>\n        </button>\n\n        <button class=\"btn btn-sm btn-primary confirm\"\n                ng-disabled=\"!$ctrl.isSubmitDeleteEnabled\"\n                ng-click=\"$ctrl.onConfirmDelete()\">\n            <span ui-translate>formsViewer.formSummary.confirm</span>\n        </button>\n    </div>\n\n    <!--Column Header-->\n    <div class=\"columnHeader\">\n        <div class=\"columnRow\"\n             ng-class=\"{ bulkSelection: $ctrl.isDeleting }\">\n\n            <!--Delete Column-->\n            <div class=\"col deleteColumn\"\n                 ng-if=\"$ctrl.isDeleting\">\n\n                <input type=\"checkbox\"\n                       ng-if=\"!$ctrl.fieldStructure.dynamicProperties.isRequired\"\n                       ng-change=\"$ctrl.onDeleteAllClick()\"\n                       ng-model=\"$ctrl.isDeleteAllSelected\">\n            </div>\n\n            <!--Required Field-->\n            <div class=\"col requiredFieldCount\"\n                 ng-if=\"$ctrl.options.formRepeaterSummary.showRequiredCountColumn === 'true' && !$ctrl.isDeleting\"\n                 ng-click=\"$ctrl.onSort('requiredFieldCount')\">\n\n                <div class=\"sortIcons\"\n                     ng-if=\"!$ctrl.fieldStructure.isConfigurableComponent\">\n                    <div class=\"glyphicon glyphicon-triangle-top\"\n                         ng-if=\"$ctrl.isSorting('requiredFieldCount', 'asc')\"></div>\n\n                    <div class=\"glyphicon glyphicon-triangle-bottom\"\n                         ng-if=\"$ctrl.isSorting('requiredFieldCount', 'desc')\"></div>\n                </div>\n            </div>\n\n            <!--Row Index-->\n            <div class=\"col rowIndexColumn\"\n                 ng-if=\"$ctrl.options.formRepeaterSummary.showFormNumberColumn === 'true'\"\n                 ng-click=\"$ctrl.onSort('rowIndexColumn')\">\n                <span>#</span>\n\n                <div class=\"sortIcons\"\n                     ng-if=\"!$ctrl.fieldStructure.isConfigurableComponent\">\n                    <div class=\"glyphicon glyphicon-triangle-top\"\n                         ng-if=\"$ctrl.isSorting('rowIndexColumn', 'asc')\"></div>\n\n                    <div class=\"glyphicon glyphicon-triangle-bottom\"\n                         ng-if=\"$ctrl.isSorting('rowIndexColumn', 'desc')\"></div>\n                </div>\n            </div>\n\n            <div class=\"col\"\n                 ng-repeat=\"column in $ctrl.columnList\"\n                 ng-if=\"!$ctrl.fieldStructure.isConfigurableComponent\"\n                 ui-manual-size\n                 width=\"::column._width\"\n                 ng-click=\"$ctrl.onSort(column._variableName)\">\n\n                <div class=\"columnLabel\">\n                    {{ ::column._columnHeading }}\n                </div>\n\n                <div class=\"sortIcons\">\n                    <div class=\"glyphicon glyphicon-triangle-top\"\n                         ng-if=\"$ctrl.isSorting(column._variableName, 'asc')\"></div>\n\n                    <div class=\"glyphicon glyphicon-triangle-bottom\"\n                         ng-if=\"$ctrl.isSorting(column._variableName, 'desc')\"></div>\n                </div>\n            </div>\n\n            <div class=\"col draggableColumn {{ ::column._variableName }}\"\n                 ng-if=\"$ctrl.fieldStructure.isConfigurableComponent\"\n                 ng-repeat=\"column in $ctrl.columnList\"\n                 ui-manual-size\n                 width=\"column._width\"\n                 ng-click=\"$ctrl.onSort(column._variableName)\"\n                 ui-draggable-column\n                 ui-draggable-column-identifier=\"{{ ::column._variableName }}\"\n                 ui-draggable-column-is-draggable=\"{{ ::$ctrl.fieldStructure.parentForm.hasWriteAccess }}\">\n\n                <div class=\"columnLabel\"\n                     ng-if=\"!$ctrl.fieldStructure.parentForm.hasWriteAccess\">\n                    {{ ::column._columnHeading }}\n                </div>\n\n                <div class=\"editableColumnLabel\"\n                     ng-if=\"$ctrl.fieldStructure.parentForm.hasWriteAccess\">\n                    <input type=\"text\"\n                           ng-model=\"column._columnHeading\"\n                           ng-mouseover=\"$ctrl.onEditableColumnLabelMouseOver()\"\n                           ng-mouseleave=\"$ctrl.onEditableColumnLabelMouseLeave()\"\n                           ng-blur=\"$ctrl.onEditableColumnLabelBlur($event, column)\"\n                           ui-enter=\"$ctrl.onEditableColumnLabelBlur($event, column)\"\n                           placeholder=\"{{ ::column._variableName }}\"\n                           tabindex=\"{{ ::$index }}\"/>\n                </div>\n\n                <div class=\"columnResizeHandle\"\n                     ng-if=\"$ctrl.fieldStructure.parentForm.hasWriteAccess\"\n                     ui-column-resize\n                     ui-column-resize-identifier=\"{{ ::column._variableName }}\">\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <!--Datagrid-->\n    <div class=\"datagrid table\"\n         ux-datagrid=\"$ctrl.formSummaryList\"\n         ng-if=\"!$ctrl.isLoading\">\n\n        <script type=\"template/html\"\n                data-template-item=\"item\"\n                data-template-name=\"default\">\n\n            <div class=\"columnRow\"\n                 ng-class=\"{\n                        disabled: $ctrl.isDeleting && !$ctrl.isFormSummaryItemDeleteEnabled(item),\n                        bulkSelection: $ctrl.isDeleting,\n                        notEditable: !item.name.editable\n                    }\"\n                 ng-click=\"$ctrl.onRowClick(item)\"\n                 uib-tooltip=\"{{ $ctrl.getRowTooltip(item) }}\"\n                 tooltip-popup-delay=\"500\"\n                 tooltip-append-to-body=\"true\"\n                 tooltip-placement=\"bottom\">\n\n                <!--Delete Column-->\n                <div class=\"col deleteColumn\"\n                     ng-if=\"$ctrl.isDeleting\">\n\n                    <input ng-disabled=\"!$ctrl.isFormSummaryItemDeleteEnabled(item)\"\n                           type=\"checkbox\"\n                           ng-change=\"$ctrl.onRowClick(item)\"\n                           ng-model=\"item.selected\"/>\n                </div>\n\n                <!--Required Field-->\n                <div class=\"col requiredFieldCount\"\n                     ng-if=\"$ctrl.options.formRepeaterSummary.showRequiredCountColumn === 'true' && !$ctrl.isDeleting\">\n                    <div class=\"requiredIndicator\"\n                         ng-if=\"item.name.requiredCount.value > 0\"></div>\n\n                    <span class=\"glyphicon glyphicon-ok\"\n                          ng-if=\"item.name.requiredCount.value === 0\"></span>\n                </div>\n\n                <!--Row Index-->\n                <div class=\"col rowIndexColumn\"\n                     ng-if=\"$ctrl.options.formRepeaterSummary.showFormNumberColumn === 'true'\">\n                    {{ item.name.index + 1 }}\n                </div>\n\n                <div class=\"col {{ ::column._variableName}}\" ng-repeat=\"column in $ctrl.columnList\"\n                     ui-manual-size\n                     width=\"::column._width\">\n\n                    <div class=\"columnLabel\">\n                        {{ $ctrl.getColumnValue(item.name.index, column._variableName) }}\n                    </div>\n                </div>\n\n            </div>\n        </script>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

var FormSummaryGridComponent = {
  templateUrl: '/formViewer/component/formSummary/formSummaryGrid.tpl.html',
  controller: 'formSummaryGridController',
  bindings: {
    fieldStructure: '<',
    timeLastModified: '<'
  }
};
angular.module('umFormViewer').component('uiFormSummaryGrid', FormSummaryGridComponent);

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FormSummaryGridController = function FormSummaryGridController($rootScope, $scope, $state, $stateParams, $controller, $timeout, $window, xmlUtil, localization, modalUtil, formMediator, formViewerConstant, currencyFilter, formSummaryRepository, loadingBarHandler, coreConstant, currencyUtil, attachmentUtil, formSummaryGridUtil) {
  var _this = this;
  var translations,
    timeoutList = [];
  angular.extend(this, $controller('baseFormComponentController', {
    $scope: $scope
  }), $controller('baseDataSetFormComponentController', {
    $scope: $scope
  }));
  localization.getTranslations().then(function (result) {
    translations = result;
    _this.notEditableRowTooltip = _.get(translations, 'formsViewer.formSummary.notEditableRowTooltip');
  });
  this.isLoading = null;
  this.options = null;
  this.columnList = null;
  this.formSummaryList = [];
  this.gridHeight = null;
  this.gridWidth = null;
  this.isGridScrollingActive = false;
  this.sort = {
    columnName: 'rowIndexColumn',
    sortDirection: 'asc'
  };
  this.isDeleting = null;
  this.isWaitingForServerResponse = false;
  this.rowsToDelete = [];
  this.isFormSummaryHidden = false;
  this.isDeleteAllSelected = false;
  this.detailScreenOwnerUri = -1;
  this.acceptedTypes = ['.xls', '.xlsx'];
  this.enableAdd = false;
  this.enableDelete = false;
  this.$onInit = function () {
    var _this2 = this;
    var dataSetImmediateLoad = true,
      preventDataSetLoadIfConfigurableComponent = true;
    this.isLoading = true;
    this.options = xmlUtil.parseStringWithoutFlattening(this.fieldStructure.uiField.options).options;
    this.configureColumnList();
    this.onInitDataSetComponent(dataSetImmediateLoad, preventDataSetLoadIfConfigurableComponent).then(function () {
      _this2.configureDynamicDatasetItems(_this2.itemsList);
      if (!_this2.fieldStructure.isConfigurableComponent) {
        _this2.loadAddDeletePermissionConfig();
      }
      _this2.isLoading = false;
      _this2.addFormTooltip = _.get(translations, 'formsViewer.formSummary.addFormTooltip');
      _this2.trashIconTooltip = _.get(translations, 'formsViewer.formSummary.trashIconTooltip');
    });
    this.calculateGridHeight();
    this.formStructure = formMediator.getFormStructure(this.fieldStructure.rootFormId);
  };
  this.configureColumnList = function () {
    this.columnList = _.cloneDeep(this.options.formRepeaterSummary.summaryColumns.summaryColumn);

    // Because of the way the xmlUtil parses lists of tags, if the list of tags has only one, the
    // parser will set the attribute to an object, rather than an array of length one.
    if (!_.isArray(this.columnList)) {
      this.columnList = [this.columnList];
    }
    _.each(this.columnList, function (item, index, source) {
      source[index]._width = parseInt(item._width) + 20;
    });
    this.calculateGridWidth();
  };
  this.$onChanges = function () {
    this.isFormSummaryHidden = this.fieldStructure.dynamicProperties.hidden;
  };
  this.configureDynamicDatasetItems = function (itemsList) {
    this.formSummaryList = formSummaryGridUtil.processFormSummaryGridItems(itemsList);
    if (!_.isEmpty(this.formSummaryList)) {
      if (!_.isNil(this.formSummaryList[0])) {
        this.detailScreenOwnerUri = this.formSummaryList[0].value;
      }
    }
    this.sortFormSummary();
    this.calculateGridHeight();
    if ($scope.datagrid) {
      $scope.datagrid.update();
    }
  };
  this.calculateGridHeight = function () {
    var numberOfRows = this.formSummaryList.length || 1,
      maxRows = parseInt(this.options.maxRowsToDisplay),
      headerHeight = 70,
      rowHeight = 41,
      variableHeight = numberOfRows * rowHeight + headerHeight - 2,
      maxHeight = maxRows * rowHeight + headerHeight;
    this.gridHeight = numberOfRows > maxRows ? maxHeight : variableHeight;
    this.isGridScrollingActive = numberOfRows > maxRows;
  };
  this.calculateGridWidth = function () {
    var width = 0;
    _.each(this.columnList, function (item) {
      width += item._width;
    });
    this.gridWidth = width;
  };
  this.getColumnValue = function (formSummaryItemIndex, columnVariableName) {
    var formSummaryItem = this.formSummaryList[formSummaryItemIndex],
      currencyFormat,
      columnItem,
      result;
    _.each(this.formSummaryList, function (item) {
      if (item.name.index === formSummaryItemIndex) {
        formSummaryItem = item;
      }
    });
    formSummaryItem = formSummaryItem || {};
    columnItem = formSummaryItem.name[columnVariableName] || {};
    if (columnItem.validator === 'currency') {
      currencyFormat = currencyUtil.getCurrencyFormat(this.formStructure.currencyCode);
      result = currencyFilter(parseFloat(columnItem.value), currencyFormat.symbol, 0, currencyFormat.suffixSymbol, currencyFormat.customFormat);
    } else if (columnItem.validator === 'percent') {
      result = parseFloat(columnItem.value) + '%';
    } else {
      result = columnItem.value;
    }
    return result;
  };
  this.sortFormSummary = function () {
    var currentSortColumn = this.sort.columnName,
      currentSortDirection = this.sort.sortDirection,
      initialList = _.cloneDeep(this.formSummaryList),
      sortedList;
    if (_.isUndefined(initialList[0])) {
      return;
    }
    sortedList = _.sortBy(initialList, function (item) {
      var result;
      if (currentSortColumn === 'rowIndexColumn') {
        result = item.name.index;
      } else if (currentSortColumn === 'requiredFieldCount') {
        result = item.name.requiredCount.value;
      } else {
        result = item.name[currentSortColumn].value;
      }
      if (!isNaN(parseFloat(result)) && isFinite(result)) {
        result = parseFloat(result);
      }
      return result;
    });
    if (currentSortDirection === 'desc') {
      sortedList.reverse();
    }
    this.formSummaryList = sortedList;
  };
  this.isSorting = function (columnName, sortType) {
    return this.sort.columnName === columnName && this.sort.sortDirection === sortType;
  };
  this.onSort = function (columnName) {
    var currentSortDirection = this.sort.sortDirection;
    if (this.sort.columnName === columnName) {
      this.sort.sortDirection = currentSortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sort = {
        columnName: columnName,
        sortDirection: 'asc'
      };
    }
    this.sortFormSummary();
  };
  this.onInitializeDelete = function () {
    this.isDeleting = true;
    this.isDeleteAllSelected = false;
    this.updateSubmitDeleteButton();
    this.bulkUpdateHeight = 32;
  };
  this.onCancelDelete = function () {
    _.each(this.formSummaryList, function (item) {
      item.selected = false;
    });
    this.bulkUpdateHeight = 0;
    this.isDeleting = false;
    this.rowsToDelete = [];
  };
  this.onAddClick = function () {
    var _this3 = this;
    this.isWaitingForServerResponse = true;
    formMediator.addFormSummaryRow(this.fieldStructure.parentForm.id, this.fieldStructure.parentForm.submissionId, this.options.formRepeaterSummary.formTemplateName, this.options.addFormInstanceFunctionButtonExecutorName).then(function (result) {
      $state.go('^.formSummaryGridDetail', {
        formId: $stateParams.formId,
        ownerUriId: _this3.detailScreenOwnerUri,
        formSummaryInstanceId: result.id
      });
      _this3.isWaitingForServerResponse = false;
    });
  };
  this.onImportClick = function (file, event) {
    var _this4 = this;
    var typeArray = [],
      inputType,
      submissionId,
      formTemplateName,
      allowFile = attachmentUtil.validateAttachmentType(file, _.get(translations, 'formsViewer.formSummary.unacceptableType'), this.acceptedTypes);
    if (allowFile) {
      typeArray = _.split(xmlUtil.parseString(this.fieldStructure.uiField.options).parameters, 'importType=');
      formTemplateName = xmlUtil.parseString(this.fieldStructure.uiField.options).formRepeaterSummary.formTemplateName;
      inputType = _.split(typeArray[1], '::')[0];
      submissionId = this.fieldStructure.parentForm.submissionId;
      loadingBarHandler.showLoadingBar(translations.formsViewer.formSummary.importLoadingBar);
      formMediator.importForms(submissionId, $stateParams.formId, inputType, formTemplateName, file).then(function () {
        var dataSetImmediateLoad = true,
          preventDataSetLoadIfConfigurableComponent = false;
        loadingBarHandler.hideLoadingBar();
        _this4.onInitDataSetComponent(dataSetImmediateLoad, preventDataSetLoadIfConfigurableComponent).then(function () {
          _this4.configureDynamicDatasetItems(_this4.itemsList);
        });
      });
    } else {
      event.target.value = null;
    }
  };
  this.onExportClick = function () {
    var exportFileName = xmlUtil.parseString(this.fieldStructure.uiField.options).formRepeaterSummary.formTemplateName;
    formSummaryRepository.getExportUrl(this.fieldStructure.parentForm.submissionId, $stateParams.formId, exportFileName).then(function (url) {
      $window.open(url, '_blank');
    });
  };
  this.showImportButton = function () {
    return xmlUtil.parseString(this.fieldStructure.uiField.options).showImportButton;
  };
  this.showExportButton = function () {
    return xmlUtil.parseString(this.fieldStructure.uiField.options).showExportButton;
  };
  this.showExportOrImportButtons = function () {
    return xmlUtil.parseString(this.fieldStructure.uiField.options).showExportButton || !this.fieldStructure.dynamicProperties.disabled && xmlUtil.parseString(this.fieldStructure.uiField.options).showImportButton;
  };
  this.onConfirmDelete = function () {
    var _this5 = this;
    var config = {
      cancelButtonLabel: translations.formsViewer.formSummary.cancel,
      confirmActionButtonLabel: translations.formsViewer.formSummary.confirm,
      summary: translations.formsViewer.formSummary.deleteConfirmationMessage,
      title: translations.formsViewer.formSummary.deleteConfirmationTitle
    };
    config.summary = config.summary.replace('{1}', this.rowsToDelete.length);
    config.summary = config.summary.replace('{2}', this.rowsToDelete.length > 1 ? 's' : '');
    modalUtil.showGenericConfirm(config).then(function () {
      var formIds = [];
      _.each(_this5.rowsToDelete, function (item) {
        formIds.push(item.value);
      });
      loadingBarHandler.showLoadingBar(translations.formsViewer.formSummary.deleteLoadingBar);
      formMediator.deleteFormSummaryRow(formIds).then(function () {
        _this5.onCancelDelete();
        loadingBarHandler.hideLoadingBar();
      });
    });
  };
  this.isFormSummaryItemDeleteEnabled = function (formSummaryItem) {
    var result = true;
    if (formSummaryItem.name.delete) {
      result = formSummaryItem.name.delete.enabled;
    }
    return result;
  };
  this.getRowTooltip = function (formSummaryItem) {
    if (!formSummaryItem.name.editable && !this.isDeleting) {
      return this.notEditableRowTooltip;
    }
    return null;
  };
  this.onRowClick = function (formSummaryItem) {
    if (!this.fieldStructure.parentForm.printPreview) {
      if (this.isDeleting) {
        if (this.isFormSummaryItemDeleteEnabled(formSummaryItem)) {
          formSummaryItem.selected = !formSummaryItem.selected;
          this.rowsToDelete = _.filter(this.formSummaryList, function (item) {
            return item.selected === true;
          });
          this.updateSubmitDeleteButton();
        }
      } else {
        if (formSummaryItem.name.editable) {
          $state.go('^.formSummaryGridDetail', {
            formId: $stateParams.formId,
            ownerUriId: this.detailScreenOwnerUri,
            formSummaryInstanceId: formSummaryItem.value
          });
        }
      }
      this.isDeleteAllSelected = false;
    }
  };
  this.openFirstFormSummaryGridDetailWithRequiredFields = function () {
    var _this6 = this;
    _.each(this.formSummaryList, function (formSummaryRow) {
      if (formSummaryRow.name.requiredCount.value > 0) {
        _this6.onRowClick(formSummaryRow);
        return false;
      }
    });
  };
  this.updateSubmitDeleteButton = function () {
    var formSummaryListOptions = this.formSummaryList[0] ? this.formSummaryList[0].name : {},
      isRequired = !formSummaryListOptions.canDeleteAllRows;
    this.isSubmitDeleteEnabled = this.rowsToDelete.length !== 0;
    if (isRequired) {
      this.isSubmitDeleteEnabled = this.isSubmitDeleteEnabled && this.rowsToDelete.length !== this.formSummaryList.length;
    }
  };
  this.updateItems = function (updateEvent, data) {
    if (this.shouldUpdateItems(updateEvent, data)) {
      this.configureDynamicDatasetItems(data.items);
      this.loadAddDeletePermissionConfig();
    }
  };
  this.onDeleteAllClick = function () {
    var _this7 = this;
    _.each(this.formSummaryList, function (item, index, source) {
      if (_this7.isFormSummaryItemDeleteEnabled(item)) {
        source[index].selected = _this7.isDeleteAllSelected;
      }
    });
    this.rowsToDelete = _.filter(this.formSummaryList, function (item) {
      return item.selected === true;
    });
    this.updateSubmitDeleteButton();
  };
  this.$onDestroy = function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  };
  this.loadAddDeletePermissionConfig = function () {
    var _this8 = this;
    var formId = this.fieldStructure.rootFormId,
      formSummaryGridFieldName = this.fieldStructure.uiField.fieldTemplate.variableName;
    formMediator.getFormSummaryAddDeleteConfigByFormSummaryGridFieldName(formId, formSummaryGridFieldName).then(function (result) {
      _this8.enableAdd = result.enableAdd;
      _this8.enableDelete = result.enableDelete;
    });
  };
  this.updateFieldStructureOptions = function () {
    // Update the underlying XML
    this.fieldStructure.uiField.options = xmlUtil.toXmlString({
      options: this.options
    });
    $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
  };
  this.onEditableColumnLabelMouseOver = function () {
    $rootScope.$broadcast(formViewerConstant.event.formBuilder.DISABLE_DRAGGABLE_ELEMENTS);
  };
  this.onEditableColumnLabelMouseLeave = function () {
    $rootScope.$broadcast(formViewerConstant.event.formBuilder.ENABLE_DRAGGABLE_ELEMENTS);
  };
  this.onEditableColumnLabelBlur = function (event, column) {
    var dataChanged = false;

    // Because of the way the xmlUtil parses lists of tags, if the list of tags has only one, the
    // parser will set the attribute to an object, rather than an array of length one.
    if (!_.isArray(this.options.formRepeaterSummary.summaryColumns.summaryColumn)) {
      if (this.options.formRepeaterSummary.summaryColumns.summaryColumn._variableName === column._variableName) {
        if (this.options.formRepeaterSummary.summaryColumns.summaryColumn._columnHeading !== column._columnHeading) {
          this.options.formRepeaterSummary.summaryColumns.summaryColumn._columnHeading = column._columnHeading;
          dataChanged = true;
        }
      }
    } else {
      _.each(this.options.formRepeaterSummary.summaryColumns.summaryColumn, function (summaryColumn) {
        if (summaryColumn._variableName === column._variableName) {
          if (summaryColumn._columnHeading !== column._columnHeading) {
            summaryColumn._columnHeading = column._columnHeading;
            dataChanged = true;
          }
          return false;
        }
      });
    }
    if (dataChanged) {
      this.updateFieldStructureOptions();
    }
  };
  $scope.$on(formViewerConstant.event.formBuilder.COLUMN_RESIZED, function (event, columnIdentifier, newWidth) {
    // Because of the way the xmlUtil parses lists of tags, if the list of tags has only one, the
    // parser will set the attribute to an object, rather than an array of length one.
    if (!_.isArray(_this.options.formRepeaterSummary.summaryColumns.summaryColumn)) {
      if (_this.options.formRepeaterSummary.summaryColumns.summaryColumn._variableName === columnIdentifier) {
        _this.options.formRepeaterSummary.summaryColumns.summaryColumn._width = newWidth;
      }
    } else {
      _.each(_this.options.formRepeaterSummary.summaryColumns.summaryColumn, function (summaryColumn) {
        if (summaryColumn._variableName === columnIdentifier) {
          summaryColumn._width = newWidth;
          return false;
        }
      });
    }
    _this.updateFieldStructureOptions();
    _this.configureColumnList();
  });
  $scope.$on(formViewerConstant.event.formBuilder.REARRANGE_COLUMN, function (event, columnToRearrange, targetColumn, isLeftDrop) {
    // Remove the column to rearrange from the list of columns:
    var summaryColumnToRearrange = _.remove(_this.options.formRepeaterSummary.summaryColumns.summaryColumn, function (summaryColumn) {
        return summaryColumn._variableName === columnToRearrange;
      })[0],
      indexToInsertColumn = _.findIndex(_this.options.formRepeaterSummary.summaryColumns.summaryColumn, function (summaryColumn) {
        return summaryColumn._variableName === targetColumn;
      });

    // Insert the column in the correct position:
    _this.options.formRepeaterSummary.summaryColumns.summaryColumn.splice(isLeftDrop ? indexToInsertColumn : indexToInsertColumn + 1, 0, summaryColumnToRearrange);
    _this.updateFieldStructureOptions();
    _this.configureColumnList();
  });
  $scope.$on(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD_FORM_SUMMARY_GRID, function (event, fieldStructureId) {
    if (_this.fieldStructure.fieldStructureId === fieldStructureId) {
      _this.openFirstFormSummaryGridDetailWithRequiredFields();
    }
  });
  $scope.$on(coreConstant.event.UPDATE_DATA_SET, this.updateItems.bind(this));
  $scope.$on(ux.datagrid.events.ON_STARTUP_COMPLETE, function (event, inst) {
    $scope.datagrid = inst;
    $scope.$apply();
  });
};
FormSummaryGridController.$inject = ["$rootScope", "$scope", "$state", "$stateParams", "$controller", "$timeout", "$window", "xmlUtil", "localization", "modalUtil", "formMediator", "formViewerConstant", "currencyFilter", "formSummaryRepository", "loadingBarHandler", "coreConstant", "currencyUtil", "attachmentUtil", "formSummaryGridUtil"];
angular.module('umFormViewer').controller('formSummaryGridController', FormSummaryGridController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

var path = '/formViewer/component/formSummary/formSummaryGridPlaceholder.tpl.html';
var html = "<ui-form-summary-grid class=\"fieldListComponent\"\n                      field-structure=\"fieldStructure\"\n                      time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n                      ui-show-field-details-modal></ui-form-summary-grid>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FormSummaryRepository = function FormSummaryRepository(baseRepository, sortUtil, coreMediator) {
  angular.extend(this, baseRepository);
  this.getExportUrl = function (submissionId, formId, formSummaryGridName) {
    return coreMediator.getSingleUseToken().then(function (token) {
      return "/formDownload/".concat(_.lowerCase(formSummaryGridName), ".csv?submissionId=").concat(submissionId, "&formId=").concat(formId) + "&formSummaryGridName=".concat(encodeURIComponent(formSummaryGridName), "&t=").concat(encodeURIComponent(token));
    });
  };
  this.importForms = function (submissionId, formId, importType, formTemplateName, file) {
    var _this = this;
    var config, formData, url;
    return coreMediator.getSingleUseToken().then(function (token) {
      url = "/formUpload/FormUploadServlet?uploadType=".concat(importType, "&submissionId=").concat(submissionId, "&formId=").concat(formId) + "&fileName=".concat(file.name, "&size=").concat(file.size, "&formTemplateName=").concat(encodeURIComponent(formTemplateName), "&t=").concat(encodeURIComponent(token));
      formData = new FormData();
      config = {
        transformRequest: angular.identity,
        headers: {
          'Content-Type': undefined
        }
      };
      formData.append('Filedata', file);
      return _this.post(url, formData, config);
    });
  };
};
FormSummaryRepository.$inject = ["baseRepository", "sortUtil", "coreMediator"];
angular.module('umFormViewer').service('formSummaryRepository', FormSummaryRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

var path = '/formViewer/component/formSummary/detail/formSummaryGridDetail.tpl.html';
var html = "<div class=\"formSummaryGridDetails\">\n\n    <ui-form-viewer submission-id=\"{{ ::viewModel.submissionId }}\"\n                    form-id=\"{{ viewModel.formSummaryInstanceId }}\"\n                    effective-date=\"{{ ::viewModel.effectiveDate }}\"\n                    currency-code=\"{{ ::viewModel.currencyCode }}\"\n                    printable=\"::viewModel.printable\">\n\n        <div class=\"formInstanceBreadcrumbs\">\n\n            <span class=\"formSummaryGridTitle\">\n                <button type=\"button\"\n                        class=\"btn-link parentFormButton\"\n                        ng-click=\"onGoToParentForm()\">{{ viewModel.parentFormName }}</button>\n\n                <span class=\"glyphicon glyphicon-triangle-right\"\n                      ng-if=\"viewModel.parentFormName\"></span>\n            </span>\n\n            <div ng-if=\"viewModel.formInstanceList.length === 1\">{{ viewModel.selectedFormInstance.name }}</div>\n\n            <um-dropdown ng-if=\"viewModel.formInstanceList.length !== 1 && viewModel.selectedFormInstance\"\n                         class-name=\"formSelectionDropdown\"\n                         required=\"'true'\"\n                         option-list=\"viewModel.formInstanceList\"\n                         selected-value=\"viewModel.selectedFormInstance.value\"\n                         on-change=\"onChangeFormInstance(selectedOption)\">\n            </um-dropdown>\n\n\n            <div class=\"actionsContainer\">\n\n                <!--Add Button-->\n                <a class=\"btn btn-link actionButton addButton\"\n                   ng-if=\"viewModel.enableAdd\"\n                   ng-disabled=\"viewModel.isWaitingForServerResponse\"\n                   uib-tooltip=\"{{ ::i18n.addFormTooltip }}\"\n                   tooltip-popup-delay=\"500\"\n                   tooltip-append-to-body=\"true\"\n                   tooltip-placement=\"bottom\"\n                   ng-click=\"createNewFormInstance()\">\n                    <span class=\"glyphicon glyphicon-plus\"></span>\n                </a>\n\n                <!--Delete Button-->\n                <a class=\"btn btn-link actionButton deleteButton\"\n                   ng-if=\"viewModel.enableDelete\"\n                   ng-click=\"deleteFormInstance()\"\n                   uib-tooltip=\"{{ ::i18n.deleteFormTooltip }}\"\n                   tooltip-popup-delay=\"500\"\n                   tooltip-append-to-body=\"true\"\n                   tooltip-placement=\"bottom\">\n                    <span class=\"glyphicon glyphicon-trash\"></span>\n                </a>\n\n            </div>\n\n        </div>\n\n    </ui-form-viewer>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(1157);

/*@ngInject*/
var FormSummaryGridDetailController = function FormSummaryGridDetailController($scope, $state, $stateParams, $timeout, preferenceModel, coreConstant, formViewerConstant, formMediator, modalUtil, coreMediator, effectiveDate, currencyCode, printable) {
  var timeoutList = [];
  $scope.i18n = locale.formSummaryGridDetail;
  $scope.submissionId = parseInt($stateParams.submissionId);
  $scope.viewModel = {
    formIsLoaded: false,
    parentFormId: $stateParams.formId,
    parentFormName: '',
    formSummaryInstanceId: $stateParams.formSummaryInstanceId,
    formSummaryInstanceOwnerUri: 'com.firstbest.underwriting.form.Form:' + $stateParams.ownerUriId,
    addFormInstanceFunctionButtonExecutorName: '',
    isWaitingForServerResponse: false,
    formTemplateName: '',
    formInstanceList: [],
    selectedFormInstance: null,
    enableDelete: false,
    enableAdd: false,
    options: {},
    submissionId: $stateParams.submissionId,
    effectiveDate: effectiveDate.get(),
    currencyCode: currencyCode.get(),
    printable: printable.get(),
    dynamicFormNameDataSetName: 'Dynamic Form Names With Ids'
  };
  function loadAddDeletePermissionConfig() {
    var formId = $stateParams.formId,
      formSummaryInstanceId = $stateParams.formSummaryInstanceId;
    formMediator.getFormSummaryAddDeleteConfigByFormSummaryInstanceId(formId, formSummaryInstanceId).then(function (result) {
      $scope.viewModel.enableAdd = result.enableAdd;
      $scope.viewModel.enableDelete = result.enableDelete;
      $scope.viewModel.addFormInstanceFunctionButtonExecutorName = result.addFormInstanceFunctionButtonExecutorName;
      $scope.viewModel.formTemplateName = result.formTemplateName;
    });
  }
  function loadFormInstances() {
    var params = {
      name: $scope.viewModel.dynamicFormNameDataSetName,
      ownerUri: $scope.viewModel.formSummaryInstanceOwnerUri
    };
    if (!_.isNil($stateParams.submissionId)) {
      params.submissionUri = 'com.firstbest.underwriting.submission.Submission:' + $stateParams.submissionId;
    }
    coreMediator.getDynamicDataSetItems(params, $stateParams.formId).then(function (result) {
      $scope.viewModel.formInstanceList = result;
      $scope.viewModel.selectedFormInstance = _.find(result, {
        value: $scope.viewModel.formSummaryInstanceId
      });
    });
  }
  function loadParentFormInstance() {
    formMediator.getFormInstanceById($scope.viewModel.parentFormId).then(function (result) {
      $scope.viewModel.parentForm = result;
      $scope.viewModel.parentFormName = $scope.viewModel.parentForm.formTemplateDisplayName;
    });
  }
  $scope.onChangeFormInstance = function (selectedForm) {
    var newFormInstanceId = selectedForm.value;
    $state.go($state.current.name, {
      formSummaryInstanceId: newFormInstanceId
    }, {
      notify: true
    });
    $scope.viewModel.formSummaryInstanceId = newFormInstanceId;
  };
  $scope.onGoToParentForm = function () {
    $state.go('^.form', {
      formId: $scope.viewModel.parentFormId
    });
  };
  $scope.updateItems = function (updateEvent, data) {};
  $scope.createNewFormInstance = function () {
    var detailScreenOwnerUri = $stateParams.ownerUriId,
      parentFormId = $scope.viewModel.parentFormId,
      submissionId = parseInt($stateParams.submissionId),
      formTemplateName = $scope.viewModel.formTemplateName,
      addFormInstanceFunctionButtonExecutorName = $scope.viewModel.addFormInstanceFunctionButtonExecutorName;
    $scope.viewModel.isWaitingForServerResponse = true;
    formMediator.addFormSummaryRow(parentFormId, submissionId, formTemplateName, addFormInstanceFunctionButtonExecutorName).then(function (result) {
      $state.go('^.formSummaryGridDetail', {
        formId: $stateParams.formId,
        ownerUriId: detailScreenOwnerUri,
        formSummaryInstanceId: result.id
      });
      $scope.viewModel.isWaitingForServerResponse = false;
    });
  };
  $scope.deleteFormInstance = function () {
    var config = {
      cancelButtonLabel: $scope.i18n.cancel,
      confirmActionButtonLabel: $scope.i18n.confirm,
      summary: $scope.i18n.deleteSingleForm,
      title: $scope.i18n.deleteSingleFormTitle
    };
    modalUtil.showGenericConfirm(config).then(function () {
      formMediator.deleteFormSummaryRow([$stateParams.formSummaryInstanceId]).then(function () {
        $scope.onGoToParentForm();
      });
    });
  };
  $scope.$on(coreConstant.event.UPDATE_DATA_SET, function (event, data) {
    timeoutList.push($timeout(function () {
      if ($scope.viewModel.formSummaryInstanceOwnerUri === data.dynamicDataSetKey.ownerUri && data.name === $scope.viewModel.dynamicFormNameDataSetName) {
        $scope.viewModel.formInstanceList = data.items;
        $scope.viewModel.selectedFormInstance = _.find(data.items, {
          value: $scope.viewModel.formSummaryInstanceId
        });
      }
    }, 0));
  });
  $scope.$on(ux.datagrid.events.ON_STARTUP_COMPLETE, function (event, inst) {
    timeoutList.push($timeout(function () {
      $scope.datagrid = inst;
    }, 0));
  });
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
  $scope.$on(formViewerConstant.event.FORM_DATA_READY, function (event, formData, rootFormId) {
    var formSummaryInstanceId = $stateParams.formSummaryInstanceId,
      dynamicFormNameDataSetName = formData.uiFormTemplate.formTemplate.dynamicFormNameDataSetName;
    if (formSummaryInstanceId === rootFormId) {
      if (!_.isNil(dynamicFormNameDataSetName) && !_.isEmpty(dynamicFormNameDataSetName)) {
        $scope.viewModel.dynamicFormNameDataSetName = dynamicFormNameDataSetName;
      }
      loadAddDeletePermissionConfig();
      loadFormInstances();
      loadParentFormInstance();
    }
  });
};
FormSummaryGridDetailController.$inject = ["$scope", "$state", "$stateParams", "$timeout", "preferenceModel", "coreConstant", "formViewerConstant", "formMediator", "modalUtil", "coreMediator", "effectiveDate", "currencyCode", "printable"];
angular.module('umFormViewer').controller('formSummaryGridDetailController', FormSummaryGridDetailController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1157 */
/***/ (function(module) {

module.exports = JSON.parse("{\"formSummaryGridDetail\":{\"cancel\":\"Cancel\",\"confirm\":\"Delete\",\"deleteSingleFormTitle\":\"Delete Form\",\"deleteSingleForm\":\"Are you sure you want to delete this form?\",\"addFormTooltip\":\"Add a form.\",\"deleteFormTooltip\":\"Delete form.\"}}");

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

var path = '/formViewer/component/functionButton/buttonPlaceholder.tpl.html';
var html = "<button type=\"button\"\n        class=\"btn btn-sm btn-default fieldListComponent\"\n        ui-show-field-details-modal> {{::fieldStructure.uiField.displayLabel}}</button>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

var path = '/formViewer/component/functionButton/functionButton.tpl.html';
var html = "<div class=\"formComponentContainer {{ ::$ctrl.configurationClass }}\"\n     ng-class=\"{ showAsHidden: $ctrl.fieldStructure.dynamicProperties.hidden }\"\n     ng-if=\"!$ctrl.fieldStructure.dynamicProperties.hidden || $ctrl.fieldStructure.isConfigurableComponent\"\n     ng-mouseenter=\"$ctrl.mouseEnter($event,$ctrl.fieldStructure)\"\n     ng-mouseleave=\"$ctrl.mouseLeave()\">\n\n    <div class=\"componentInputContainer\"\n         ui-manual-size\n         width=\"$ctrl.getButtonWidth()\"\n         height=\"::$ctrl.fieldStructure.layout.inputHeight\">\n\n            <button type=\"button\"\n                    ng-click=\"$ctrl.execute()\"\n                    class=\"btn btn-default functionBtn {{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n                    ng-disabled=\"$ctrl.fieldStructure.dynamicProperties.disabled\"\n                    ng-class=\"{'noLabelWidth' : $ctrl.fieldStructure.layout.labelWidth === 0}\">\n                <span> {{::$ctrl.getLabelText()}}  </span>\n            </button>\n    </div>\n</div>\n\n<span class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n      ng-if=\"$ctrl.fieldStructure.dynamicProperties.hidden && !$ctrl.fieldStructure.isConfigurableComponent\"></span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

var FunctionButtonComponent = {
  templateUrl: '/formViewer/component/functionButton/functionButton.tpl.html',
  controller: 'functionButtonController',
  bindings: {
    fieldStructure: '<'
  }
};
angular.module('umCore').component('uiFunctionButton', FunctionButtonComponent);

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FunctionButtonController = function FunctionButtonController($scope, $controller, $window, xmlUtil, formComponentUtil, formMediator, remoteFunction, remoteFunctionRepository, localization, $uibModal, loadingBarHandler, functionActionUtil, coreMediator, coreConstant) {
  angular.extend(this, $controller('baseFormComponentController', {
    $scope: $scope
  }));
  this.execute = function () {
    var formId = this.fieldStructure.parentForm.id,
      fieldId = this.fieldStructure.fieldModel ? this.fieldStructure.fieldModel.id : null,
      fieldName = this.fieldStructure.indexedName,
      rowId = this.fieldStructure.rowInstanceId,
      rowIndex = this.fieldStructure.rowNumber,
      submissionId = this.fieldStructure.parentForm.submissionId,
      fieldStructure = this.fieldStructure,
      xmlOptions = xmlUtil.parseString(this.fieldStructure.uiField.options);
    localization.getTranslationByKey('formsViewer.controls.functionButton').then(function (translation) {
      var customOptions = {
        'confirmationMessage': xmlOptions.confirmationMessage,
        'confirmationTitle': xmlOptions.confirmationTitle ? xmlOptions.confirmationTitle : translation.title,
        'yesButtonLabel': xmlOptions.yesButtonLabel ? xmlOptions.yesButtonLabel : translation.yesButton,
        'noButtonLabel': xmlOptions.noButtonLabel ? xmlOptions.noButtonLabel : translation.noButton,
        'processingIndicatorText': xmlOptions.processingIndicatorText ? xmlOptions.processingIndicatorText : null,
        'functionClass': xmlOptions.functionClass,
        'parameters': xmlOptions.parameters
      };
      if (customOptions.functionClass === 'com.firstbest.components.formcomponent.functions.RemoteFunctionWrapper') {
        function handleLoadingBar(submissionId, formId, fieldId, rowIndex, customOptions, fieldStructure) {
          if (customOptions.processingIndicatorText) {
            loadingBarHandler.showLoadingBar(customOptions.processingIndicatorText);
          }
          executeContinue(submissionId, formId, fieldId, rowIndex, customOptions, fieldStructure);
        }
        if (customOptions.confirmationMessage !== '') {
          showGenericConfirm(formId, fieldId, customOptions).then(function () {
            handleLoadingBar(submissionId, formId, fieldId, rowIndex, customOptions, fieldStructure);
          });
        } else {
          handleLoadingBar(submissionId, formId, fieldId, rowIndex, customOptions, fieldStructure);
        }
      } else if (customOptions.functionClass === 'submissionAgencyChange') {
        showChangeAgencyModal(customOptions);
      } else {
        $scope.$emit(coreConstant.event.functionExecute, customOptions, {
          submissionId: submissionId,
          formId: formId,
          fieldId: fieldId,
          fieldName: fieldName,
          rowId: rowId,
          rowIndex: rowIndex
        });
      }
    });
  };
  function executeContinue(submissionId, formId, fieldId, rowIndex, customOptions, fieldStructure) {
    var parameters = functionActionUtil.getParameterAsObject(customOptions.parameters),
      form = fieldStructure.parentForm,
      fieldInstance = fieldStructure.fieldModel,
      fieldTemplate = fieldStructure.uiField.fieldTemplate;
    fieldStructure.dynamicProperties.disabled = true;
    remoteFunction.executeFunction(formId, fieldId, rowIndex, parameters, submissionId).then(function (executorResult) {
      if (executorResult.url) {
        parameters.url = executorResult.url;
      }
      if (parameters.url) {
        coreMediator.loadUserProfile().then(function (userProfile) {
          functionActionUtil.constructUrl(parameters, submissionId, userProfile).then(function (url) {
            $window.open(url);
          });
        });
      }
      loadingBarHandler.hideLoadingBar();
    }).finally(function () {
      fieldStructure.dynamicProperties.disabled = formComponentUtil.isFieldDisabled(form, fieldInstance, fieldTemplate, form.hasWriteAccess);
    });
  }
  ;
  this.getButtonWidth = function () {
    var inputContainerWidth = 160;
    var isRowRepeater = this.fieldStructure.isRowRepeaterField;
    if (isRowRepeater && this.fieldStructure.layout.labelWidth === 0) {
      return inputContainerWidth;
    } else {
      return this.fieldStructure.layout.labelWidth;
    }
  };
  function showGenericConfirm(formId, fieldId, customOptions) {
    var modalInstance = $uibModal.open({
      templateUrl: '/ui/modal/modal.tpl.html',
      controller: 'modalController',
      backdrop: 'static',
      windowClass: 'genericModal',
      resolve: {
        options: function options() {
          return {
            cancelButtonLabel: customOptions.noButtonLabel,
            confirmActionButtonLabel: customOptions.yesButtonLabel,
            summary: customOptions.confirmationMessage,
            title: customOptions.confirmationTitle
          };
        }
      }
    });
    return modalInstance.result;
  }
  function showChangeAgencyModal(customOptions) {
    var modalInstance = $uibModal.open({
      templateUrl: '/wizard/changeAgency/changeAgencyModal.tpl.html',
      controller: 'changeAgencyModalController',
      backdrop: 'static',
      windowClass: 'changeAgencyModalContainer',
      resolve: {
        options: function options() {
          return {
            cancelButtonLabel: customOptions.noButtonLabel,
            confirmActionButtonLabel: customOptions.yesButtonLabel,
            processingIndicatorText: customOptions.processingIndicatorText,
            title: customOptions.confirmationTitle
          };
        }
      }
    });
    return modalInstance.result;
  }
  this.getLabelText = function () {
    var valueLabel = this.fieldStructure.fieldModel ? this.fieldStructure.fieldModel.valueLabel : null;
    if (!_.isNil(valueLabel)) {
      return valueLabel;
    }
    return this.fieldStructure.uiField.displayLabel;
  };
};
FunctionButtonController.$inject = ["$scope", "$controller", "$window", "xmlUtil", "formComponentUtil", "formMediator", "remoteFunction", "remoteFunctionRepository", "localization", "$uibModal", "loadingBarHandler", "functionActionUtil", "coreMediator", "coreConstant"];
angular.module('umFormViewer').controller('functionButtonController', FunctionButtonController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

var path = '/formViewer/component/functionButton/functionButtonPlaceholder.tpl.html';
var html = "<ui-function-button class=\"fieldListComponent\"\n                    field-structure=\"fieldStructure\"\n                    ui-show-field-details-modal></ui-function-button>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

var path = '/formViewer/component/label/label.tpl.html';
var html = "<div class=\"formComponentContainer {{ ::$ctrl.configurationClass }}\"\n     ng-class=\"{ showAsHidden: $ctrl.fieldStructure.dynamicProperties.hidden }\"\n     ng-if=\"!$ctrl.fieldStructure.dynamicProperties.hidden || $ctrl.fieldStructure.isConfigurableComponent\">\n\n    <ui-required-indicator-label ng-if=\"!$ctrl.hideRequiredIndicator\"\n                                 required-label-config=\"$ctrl.fieldStructure.requiredIndicatorLabelConfig\"\n                                 class=\"labelRequiredIndicator\"\n                                 ng-class=\"{ required: $ctrl.fieldStructure.requiredIndicatorLabelConfig.required && !($ctrl.fieldStructure.requiredIndicatorLabelConfig.valid && $ctrl.fieldStructure.requiredIndicatorLabelConfig.hasValue)}\"></ui-required-indicator-label>\n\n    <!--Label-->\n    <div class=\"componentInputContainer\"\n         ui-manual-size\n         width=\"::$ctrl.fieldStructure.layout.labelWidth\"\n         ng-mouseenter=\"$ctrl.mouseEnter($event,$ctrl.fieldStructure)\"\n         ng-mouseleave=\"$ctrl.mouseLeave()\">\n\n        <label class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }} {{ $ctrl.className }} labelText\">{{ $ctrl.labelValue }}</label>\n    </div>\n</div>\n\n<span class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n    ng-if=\"$ctrl.fieldStructure.dynamicProperties.hidden && !$ctrl.fieldStructure.isConfigurableComponent\"></span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

var LabelComponent = {
  templateUrl: '/formViewer/component/label/label.tpl.html',
  controller: 'labelController',
  bindings: {
    fieldStructure: '<',
    timeLastModified: '<'
  }
};
angular.module('umCore').component('uiLabel', LabelComponent);

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var LabelController = function LabelController($scope, $controller) {
  angular.extend(this, $controller('baseFormComponentController', {
    $scope: $scope
  }));
  this.$onInit = function () {
    this.onInit();
    this.setLabelValue();
    var isLabelBold = _.toLower(this.fieldStructure.uiField.labelFontStyle) !== 'normal';
    this.className = isLabelBold ? 'isBold' : '';
    this.updateRequiredIndicator();
  };
  this.$onChanges = function () {
    this.onChanges();
    this.setLabelValue();
    this.updateRequiredIndicator();
  };
  this.setLabelValue = function () {
    var fieldInstance = this.fieldStructure.fieldModel;
    this.labelValue = this.fieldStructure.uiField.displayLabel;
    if (fieldInstance && !_.isNull(fieldInstance.value)) {
      this.labelValue = fieldInstance.value;
    }
  };
  this.updateRequiredIndicator = function () {
    this.fieldStructure.requiredIndicatorLabelConfig.label = null;
    this.hideRequiredIndicator = !this.fieldStructure.requiredIndicatorLabelConfig.required;
  };
};
LabelController.$inject = ["$scope", "$controller"];
angular.module('umFormViewer').controller('labelController', LabelController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1167 */
/***/ (function(module, exports) {

var path = '/formViewer/component/label/labelPlaceholder.tpl.html';
var html = "<ui-label class=\"fieldListComponent\"\n          field-structure=\"fieldStructure\"\n          time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n          hide-label=\"::hideLabel\"\n          collapsible=\"::$ctrl.collapsible\"\n          ui-show-field-details-modal></ui-label>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1168 */
/***/ (function(module, exports) {

var path = '/formViewer/component/radioButtonGroup/radioButtonGroup.tpl.html';
var html = "<div class=\"formComponentContainer {{ ::$ctrl.configurationClass }}\"\n     ng-class=\"{\n        labelLeft: $ctrl.fieldStructure.layout.isLabelLeftAligned,\n        showAsHidden: $ctrl.fieldStructure.dynamicProperties.hidden\n     }\"\n     ng-if=\"!$ctrl.fieldStructure.dynamicProperties.hidden || $ctrl.fieldStructure.isConfigurableComponent\"\n     ui-snippets-indicator\n     ui-snippets-indicator-container=\"self\"\n     ui-snippets-indicator-name=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n     >\n\n    <!--Label-->\n    <ui-required-indicator-label\n            class=\"groupLabel\"\n            ng-class=\"{\n                labelLeft: $ctrl.fieldStructure.layout.isLabelLeftAligned,\n                labelTop: !$ctrl.fieldStructure.layout.isLabelLeftAligned,\n                required: $ctrl.fieldStructure.requiredIndicatorLabelConfig.required,\n                checked: $ctrl.fieldStructure.requiredIndicatorLabelConfig.required && $ctrl.fieldStructure.requiredIndicatorLabelConfig.valid && $ctrl.fieldStructure.requiredIndicatorLabelConfig.hasValue\n                }\"\n            ng-if=\"!$ctrl.hideLabel\"\n            required-label-config=\"$ctrl.fieldStructure.requiredIndicatorLabelConfig\">\n    </ui-required-indicator-label>\n\n    <!--Input-->\n    <div class=\"componentInputContainer {{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n         ui-manual-size\n         width=\"::$ctrl.fieldStructure.layout.inputWidth\"\n         >\n\n        <label ng-repeat=\"item in $ctrl.itemsList\"\n               ng-class=\"{ disabled: $ctrl.fieldStructure.dynamicProperties.disabled }\"\n               ui-manual-size\n               width=\"$ctrl.fieldStructure.layout.groupItemWidth\"\n               ng-mouseenter=\"$ctrl.mouseEnter($event,$ctrl.fieldStructure)\"\n               ng-mouseleave=\"$ctrl.mouseLeave()\">\n            <input type=\"radio\"\n                   name=\"{{ $ctrl.getGroupName($ctrl.fieldStructure.uiField) }}\"\n                   ng-class=\"{ error: !$ctrl.fieldStructure.dynamicProperties.isValid }\"\n                   ng-model=\"$ctrl.fieldStructure.fieldModel.value\"\n                   ng-value=\"item.value\"\n                   ng-disabled=\"$ctrl.fieldStructure.dynamicProperties.disabled\"\n                   ng-change=\"$ctrl.handleChange(item)\"\n                   ng-focus=\"$ctrl.handleFocus()\"\n                   ng-click=\"$ctrl.handleClick($event, item)\"\n                   ui-remote-change-notification/>\n            {{ item.name }}\n        </label>\n    </div>\n\n</div>\n\n<!-- Row Repeater Hidden Width Placeholder -->\n<div class=\"dynamicComponentContainer collapsedPlaceholder\"\n     ng-if=\"$ctrl.fieldStructure.isRowRepeaterField && $ctrl.fieldStructure.dynamicProperties.hidden && !$ctrl.fieldStructure.isColumnCollapsed\">\n\n    <div ui-manual-size\n         width=\"$ctrl.fieldStructure.layout.inputWidth\"></div>\n</div>\n\n<span class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n      ng-if=\"$ctrl.fieldStructure.dynamicProperties.hidden && !$ctrl.fieldStructure.isConfigurableComponent\"></span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

var RadioButtonGroupComponent = {
  templateUrl: '/formViewer/component/radioButtonGroup/radioButtonGroup.tpl.html',
  controller: 'radioButtonGroupController',
  bindings: {
    fieldStructure: '<',
    timeLastModified: '<',
    hideLabel: '<'
  }
};
angular.module('umFormViewer').component('radioButtonGroup', RadioButtonGroupComponent);

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var RadioButtonGroupController = function RadioButtonGroupController($scope, $controller, formComponentUtil, formMediator, coreConstant) {
  angular.extend(this, $controller('baseFormComponentController', {
    $scope: $scope
  }), $controller('baseDataSetFormComponentController', {
    $scope: $scope
  }));
  this.$onInit = function () {
    var _this = this;
    var dataSetImmediateLoad = true;
    var preventDataSetLoadIfConfigurableComponent = false;
    this.onInitDataSetComponent(dataSetImmediateLoad, preventDataSetLoadIfConfigurableComponent).then(function () {
      _this.fieldStructure.layout.groupItemWidth = formComponentUtil.getGroupItemWidth(_this.fieldStructure.layout, _this.itemsList);
    });
  };
  this.$onChanges = function () {
    this.onChanges();
  };
  this.getGroupName = function (uiField) {
    return uiField.fieldTemplate.variableName + this.fieldStructure.parentForm.formTemplateUniqueName + (this.isRowRepeater() ? ':' + this.fieldStructure.rowNumber : '');
  };
  this.handleChange = function (selectedItem) {
    this.fieldStructure.hasLocalChanges = true;
    if (!_.isNil(selectedItem.name)) {
      this.fieldStructure.fieldModel.valueLabel = selectedItem.name;
    }
    formComponentUtil.setupFieldProperties(this.fieldStructure);
    formMediator.handleFieldChange(this.fieldStructure.parentForm.id, this.fieldStructure, this.resetFieldValue.bind(this), this.updateOriginalFieldValue.bind(this));
  };
  this.handleClick = function (event, selectedItem) {
    if (this.fieldStructure.dynamicProperties.disabled) {
      return;
    }
    if (event.ctrlKey) {
      this.fieldStructure.fieldModel.value = null;
      this.handleChange(selectedItem);
    }
  };
  this.updateItems = function (updateEvent, data) {
    if (this.shouldUpdateItems(updateEvent, data)) {
      this.itemsList = _.cloneDeep(data.items);
      this.fieldStructure.layout.groupItemWidth = formComponentUtil.getGroupItemWidth(this.fieldStructure.layout, this.itemsList);
    }
  };
  $scope.$on(coreConstant.event.UPDATE_DATA_SET, this.updateItems.bind(this));
};
RadioButtonGroupController.$inject = ["$scope", "$controller", "formComponentUtil", "formMediator", "coreConstant"];
angular.module('umFormViewer').controller('radioButtonGroupController', RadioButtonGroupController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

var path = '/formViewer/component/radioButtonGroup/radioButtonGroupPlaceholder.tpl.html';
var html = "<radio-button-group class=\"fieldListComponent radioButtonGroupComponent\"\n                    field-structure=\"fieldStructure\"\n                    time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n                    hide-label=\"::hideLabel\"\n                    collapsible=\"::$ctrl.collapsible\"\n                    ui-show-field-details-modal></radio-button-group>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

var path = '/formViewer/component/requiredIndicatorLabel/requiredIndicatorLabel.tpl.html';
var html = "<div class=\"componentLabel\">\n    <div class=\"requiredField\">\n        <div class=\"invalidIcon\"\n             ng-class=\"::$ctrl.config.variableName + 'InvalidIcon'\"\n             ng-if=\"$ctrl.config.required && !($ctrl.config.valid && $ctrl.config.hasValue)\"></div>\n\n        <div ng-if=\"$ctrl.config.required && $ctrl.config.valid && $ctrl.config.hasValue\"\n             class=\"glyphicon glyphicon-ok\"\n             ng-class=\"::$ctrl.config.variableName + 'GlyphiconOk'\"></div>\n    </div>\n\n    <div class=\"labelContainer {{$ctrl.className}}\"\n         ui-manual-size\n         width=\"::$ctrl.config.width\"\n         ng-if=\"::$ctrl.config.configurable\">\n        {{ $ctrl.config.label }}\n    </div>\n\n    <div class=\"labelContainer {{::$ctrl.className}}\"\n         ui-manual-size\n         width=\"::$ctrl.config.width\"\n         ng-if=\"::!$ctrl.config.configurable\">\n        {{ ::$ctrl.config.label }}\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

var RequiredIndicatorLabelComponent = {
  templateUrl: '/formViewer/component/requiredIndicatorLabel/requiredIndicatorLabel.tpl.html',
  controller: 'requiredIndicatorLabelController',
  bindings: {
    config: '<requiredLabelConfig'
  }
};
angular.module('umFormViewer').component('uiRequiredIndicatorLabel', RequiredIndicatorLabelComponent);

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

/*@ngInject*/
var RequiredIndicatorLabelController = function RequiredIndicatorLabelController($element) {
  this.$onInit = function () {
    $element.addClass('requiredIndicatorComponent');
    this.className = this.config.bold ? 'isBold' : '';
  };
  this.$onChanges = function () {
    this.className = this.config.bold ? 'isBold' : '';
  };
};
RequiredIndicatorLabelController.$inject = ["$element"];
angular.module('umFormViewer').controller('requiredIndicatorLabelController', RequiredIndicatorLabelController);

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/formViewer/component/rowRepeater/rowRepeater.tpl.html';
var html = "<div ng-if=\"$ctrl.row.rowList && $ctrl.showRepeater\"\n     class=\"row\">\n\n    <!--Title Bar-->\n    <div class=\"titleBar\"\n         ng-if=\"$ctrl.rowRepeaterTitle !== '' || ($ctrl.rowRepeaterTitle === '' && !$ctrl.isRowRepeaterAddDisabled())\"\n         form-summary-button-position\n         ng-click=\"$ctrl.rowRepeaterClicked()\">\n\n        <div class=\"title {{ ::$ctrl.rowRepeaterTitleClass }}\">{{ $ctrl.rowRepeaterTitle }}</div>\n\n        <!--Action Button Container-->\n        <div class=\"buttonContainer actionButtonContainer\"\n             ng-if=\"!$ctrl.row.parentFormStructure.isConfigurableForm\"\n             ng-show=\"!$ctrl.isDeleting && !$ctrl.row.parentForm.printPreview\">\n\n            <!--Add-->\n            <button class=\"btn btn-xs addNewButton\"\n                    ng-if=\"!$ctrl.isRowRepeaterAddDisabled()\"\n                    ng-disabled=\"$ctrl.hasRowAdditionInProgress\"\n                    ng-click=\"$ctrl.onAddRow()\"\n                    uib-tooltip=\"{{ $ctrl.addButtonTooltip }}\"\n                    tooltip-popup-delay=\"500\"\n                    tooltip-append-to-body=\"true\"\n                    tooltip-placement=\"bottom\">\n                <span class=\"glyphicon glyphicon-plus\"></span>\n            </button>\n\n            <!--Remove-->\n            <button ng-if=\"!$ctrl.isRepeaterDeleteDisabled()\"\n                    class=\"btn btn-xs deleteButton\"\n                    ng-click=\"$ctrl.onInitializeDelete()\"\n                    uib-tooltip=\"{{ $ctrl.trashIconTooltip }}\"\n                    tooltip-popup-delay=\"500\"\n                    tooltip-append-to-body=\"true\"\n                    tooltip-placement=\"bottom\">\n                <span class=\"glyphicon glyphicon-trash\"></span>\n            </button>\n        </div>\n    </div>\n\n    <!--Bulk Update Header-->\n    <div class=\"bulkUpdateHeader\"\n         ng-if=\"$ctrl.isDeleting\"\n         ng-click=\"$ctrl.rowRepeaterClicked()\">\n\n        <div class=\"instructions\" ui-translate>formsViewer.rowRepeater.deleteTooltip</div>\n\n        <button class=\"btn btn-sm btn-default\"\n                ng-click=\"$ctrl.onCancelDelete()\">\n            <span ui-translate>formsViewer.formSummary.cancel</span>\n        </button>\n\n        <button class=\"btn btn-sm btn-primary confirm submitDelete\"\n                ng-disabled=\"!$ctrl.isSubmitDeleteEnabled\"\n                ng-click=\"$ctrl.onConfirmDelete()\">\n            <span ui-translate>formsViewer.formSummary.confirm</span>\n        </button>\n\n    </div>\n\n    <div class=\"formComponentContainer rowRepeaterHeader\"\n         ng-if=\"!$ctrl.allColumnsWithNoLabel\"\n         ng-click=\"$ctrl.rowRepeaterClicked()\">\n\n        <!--Delete Column-->\n        <div class=\"col rowSelector deleteColumn\"\n             ng-if=\"$ctrl.isDeleting\">\n\n            <input type=\"checkbox\"\n                   ng-change=\"$ctrl.onDeleteAllClick()\"\n                   ng-model=\"$ctrl.isDeleteAllSelected\">\n        </div>\n\n        <ui-column-header class=\"formComponent rowRepeaterColumn\"\n                          ng-if=\"!$ctrl.rowNumberField.hidden\"\n                          ui-field=\"$ctrl.rowNumberField\"\n                          row=\"$ctrl.row\"\n                          root-form-id=\"::$ctrl.rootFormId\"\n                          time-last-modified=\"$ctrl.row.timeLastModified\">\n        </ui-column-header>\n\n        <div class=\"rowRepeaterHeaders\"\n             ng-if=\"$ctrl.configurable\">\n            <ui-column-header ng-repeat=\"field in $ctrl.fieldList\"\n                              class=\"formComponent rowRepeaterColumn\"\n                              ui-field=\"field\"\n                              row=\"$ctrl.row\"\n                              root-form-id=\"::$ctrl.rootFormId\"\n                              time-last-modified=\"$ctrl.row.timeLastModified\">\n            </ui-column-header>\n        </div>\n\n        <div class=\"rowRepeaterHeaders\"\n             ng-if=\"!$ctrl.configurable\">\n            <ui-column-header ng-repeat=\"field in ::$ctrl.fieldList\"\n                              class=\"formComponent rowRepeaterColumn\"\n                              ui-field=\"field\"\n                              configurable=\"$ctrl.configurable\"\n                              row=\"$ctrl.row\"\n                              root-form-id=\"::$ctrl.rootFormId\"\n                              time-last-modified=\"$ctrl.row.timeLastModified\">\n            </ui-column-header>\n        </div>\n    </div>\n\n    <ui-repeating-rows class=\"repeatingRowContainer\"\n                       ng-class=\"{ fadeRows: $ctrl.showLoadingSpinner }\"\n                       row-repeater-iden=\"::'rowRepeater-'+$ctrl.row.rowTemplate.repeaterField.fieldTemplate.id\"\n                       visible-rows=\"$ctrl.visibleRowList\"\n                       hide-row-numbers=\"::$ctrl.rowNumberField.hidden\"\n                       configurable=\"::$ctrl.configurable\"></ui-repeating-rows>\n\n    <div class=\"buttonContainer\">\n\n        <ui-paging class=\"paging\"\n                   source=\"$ctrl.row.rowList\"\n                   page-size=\"::$ctrl.row.pageSize\"\n                   time-last-modified=\"$ctrl.row.timeLastModified\"\n                   print-preview=\"$ctrl.row.parentForm.printPreview\"\n                   on-change=\"$ctrl.onChange(startIndex, endIndex)\"></ui-paging>\n    </div>\n\n    <div class=\"icon-spinner\" ng-if=\"$ctrl.showLoadingSpinner\">\n        <img src=\"" + __webpack_require__(67) + "\"/>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

var RowRepeaterComponent = {
  templateUrl: '/formViewer/component/rowRepeater/rowRepeater.tpl.html',
  controller: 'rowRepeaterController',
  bindings: {
    row: '<',
    rootFormId: '<',
    configurable: '<'
  }
};
angular.module('umFormViewer').component('uiRowRepeater', RowRepeaterComponent);

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var RowRepeaterController = function RowRepeaterController($rootScope, $scope, $timeout, localization, formComponentUtil, fieldType, formMediator, modalUtil, xmlUtil, formViewerConstant, rowRepeaterUtil, rowRepeaterRowListComparisonResultConstant) {
  var translations;
  var timeoutList = [];
  this.$onInit = function () {
    var _this = this;
    localization.getTranslations().then(function (result) {
      translations = result;
      _this.addButtonTooltip = translations.formsViewer.rowRepeater.addButtonTooltip;
      _this.trashIconTooltip = translations.formsViewer.rowRepeater.trashIconTooltip;
    });
    this.fieldType = fieldType;
    this.rowsToDelete = [];
    this.visibleRowList = [];
    this.fieldList = [];
    this.previousRowList = [];
    this.repeaterFieldStructure = this.row.repeaterFieldStructure;
    this.rowRepeaterTitle = '';
    this.rowRepeaterTitleClass = null;
    this.hasRowAdditionInProgress = false;
    this.isDeleting = false;
    this.isDeleteAllSelected = false;
    this.isDeletable = false;
    this.isSubmitDeleteEnabled = false;
    this.showLoadingSpinner = false;
    this.showRepeater = true;
    this.rowNumberField = _.clone(this.row.rowTemplate.fields[0]);
    this.rowNumberField.displayLabel = '#';
    this.rowNumberField.inputWidth = 20;
    this.rowNumberField.labelWidth = 20;
    this.rowNumberField.minWidth = 20;
    this.rowNumberField.fieldTemplate = {
      variableName: 'rowNumber',
      type: fieldType.TEXT_INPUT
    };
    this.rowNumberField.hidden = !xmlUtil.parseString(this.row.rowTemplate.repeaterField.options).showRowNumber;
    this.init();
    $scope.$on(formViewerConstant.event.CREATE_ROW, function () {
      timeoutList.push($timeout(function () {
        _this.hasRowAdditionInProgress = false;
      }, 100));
    });
    $scope.$on(formViewerConstant.event.REPEATING_ROW_SELECTED, function (event, triggerEvent, row) {
      if (_this.isDeleting && !row.isRowDeleteDisabled && row.rowTemplate.id === _this.row.rowTemplate.id) {
        _this.onSelectRow(triggerEvent, row);
      }
    });
    $scope.$on(formViewerConstant.configuration.event.DELETE_FIELD, function () {
      _this.refresh();
    });
    $scope.$on(formViewerConstant.configuration.event.FIELD_MOVED_IN_ROW, function () {
      _this.refresh();
    });
    $scope.$on(formViewerConstant.configuration.event.UPDATE_COMPONENT_SETTING, function () {
      _this.refresh();
    });
    $scope.$on(formViewerConstant.configuration.event.CREATE_NEW_COMPONENT, function () {
      _this.refresh();
    });
    $scope.$watch('$ctrl.row.timeLastModified', function () {
      var sortChanged = !_.isNil(_this.sort) && (_this.sort.sortKey !== _this.row.sort.sortKey || _this.sort.sortType !== _this.row.sort.sortType);
      var rowRepeaterRowListComparisonResult = rowRepeaterUtil.compareRowLists(_this.row.rowList, _this.previousRowList);
      var rowRepeaterRowListComparisonWarrantsChange = rowRepeaterRowListComparisonResult !== rowRepeaterRowListComparisonResultConstant.EQUAL && rowRepeaterRowListComparisonResult !== rowRepeaterRowListComparisonResultConstant.ONE_ROW_ADDED;
      if (sortChanged || rowRepeaterRowListComparisonWarrantsChange) {
        _this.onChange(_this.startIndexOrig, _this.endIndexOrig);
      }
      _this.previousRowList = _.cloneDeep(_this.row.rowList);
    });
    this.processCollapsibleColumnsAndVisibility();
  };
  this.init = function () {
    var _this2 = this;
    this.showRepeater = this.isRepeaterVisible();
    this.previousRowList = _.cloneDeep(this.row.rowList);
    this.fieldList = _.filter(this.row.rowTemplate.fields, function (uiField) {
      var isRowRepeater = uiField.fieldTemplate.type === fieldType.ROWREPEATER;
      if (isRowRepeater) {
        _this2.rowRepeaterTitle = uiField.displayLabel;
      }
      return !isRowRepeater;
    });
    this.allColumnsWithNoLabel = this.isAllColumnsWithNoLabel();
    var isLabelBold = _.toLower(this.repeaterFieldStructure.uiField.labelFontStyle) !== 'normal';
    if (isLabelBold) {
      this.rowRepeaterTitleClass = 'isBold';
    }
    if (this.row.pageSize <= 0) {
      this.row.pageSize = Number.MAX_SAFE_INTEGER;
    }
  };
  this.isAllColumnsWithNoLabel = function () {
    var allColumnsWithNoLabel = true;
    _.each(this.row.rowList, function (item) {
      _.each(item.fieldStructureList, function (fieldStructure) {
        var fieldInstance = fieldStructure.fieldModel,
          fieldTemplate = fieldStructure.uiField.fieldTemplate;
        if (fieldTemplate.type !== fieldType.ROWREPEATER && (!formComponentUtil.isFieldHidden(fieldInstance, fieldTemplate) && fieldStructure.dynamicProperties.isRequired || !_.isEmpty(fieldStructure.uiField.displayLabel))) {
          allColumnsWithNoLabel = false;
          return false;
        }
      });
    });
    return allColumnsWithNoLabel;
  };
  this.isRepeaterVisible = function () {
    var isVisible = this.configurable;
    if (!isVisible) {
      _.each(this.row.rowList, function (item) {
        _.each(item.fieldStructureList, function (fieldStructure) {
          var fieldInstance = fieldStructure.fieldModel,
            fieldTemplate = fieldStructure.uiField.fieldTemplate;
          if (!formComponentUtil.isFieldHidden(fieldInstance, fieldTemplate)) {
            isVisible = true;
            return false;
          }
        });
        if (isVisible) {
          return false;
        }
      });
    }
    return isVisible;
  };
  this.updateSelectedRows = function () {
    this.rowsToDelete = _.filter(this.row.rowList, function (row) {
      return row.selected === true;
    });
    this.updateSubmitDeleteButton();
    this.isDeleteAllSelected = false;
  };
  this.onAddRow = function () {
    var formId = this.row.parentForm.id,
      rowId = this.row.rowTemplate.id,
      rowNumberOfLastRow = this.row.rowList.length;
    if (!this.hasRowAdditionInProgress) {
      this.hasRowAdditionInProgress = true;
      formMediator.addRepeatingRow(formId, rowId, rowNumberOfLastRow);
    }
  };
  this.onInitializeDelete = function () {
    var _this3 = this;
    _.each(this.row.rowList, function (item) {
      item.isRowDeleteDisabled = _this3.isRowDeleteDisabled(item);
      item.isDeleting = true;
    });
    this.isDeleting = true;
    this.isDeleteAllSelected = false;
    this.updateSubmitDeleteButton();
    this.bulkUpdateHeight = 32;
  };
  this.onChange = function (startIndex, endIndex) {
    var _this4 = this;
    this.startIndexOrig = startIndex;
    this.endIndexOrig = endIndex;
    this.sort = this.row.sort;
    this.showLoadingSpinner = true;
    timeoutList.push($timeout(function () {
      var sortedList = _this4.row.rowList;
      _this4.visibleRowList = [];
      _this4.isDeleteAllSelected = false;
      if (_this4.row.pageSize > 0 && !_this4.row.parentForm.printPreview) {
        _.each(sortedList, function (item, index) {
          if (index >= startIndex && index <= endIndex) {
            _this4.visibleRowList.push(item);
          }
        });
      } else {
        _.each(sortedList, function (item) {
          _this4.visibleRowList.push(item);
        });
      }
      timeoutList.push($timeout(function () {
        _this4.showLoadingSpinner = false;
        $rootScope.$broadcast(formViewerConstant.event.REPEATING_ROW_PAGE_CHANGE);
      }, _this4.visibleRowList.length * 50));
    }, 0));
  };
  this.processCollapsibleColumnsAndVisibility = function () {
    formMediator.processCollapsibleColumnsAndVisibility(this.row.rowRepeaterId, this.rootFormId);
  };
  this.isRowDeleteDisabled = function (row) {
    var form = row.parentForm,
      fieldStructure = _.find(row.fieldStructureList, function (item) {
        return item.uiField.fieldTemplate.type === fieldType.ROWREPEATER;
      }),
      fieldInstance = fieldStructure.fieldModel || {},
      fieldTemplate = fieldStructure.uiField.fieldTemplate,
      hasWriteAccess = form.hasWriteAccess,
      hasAllActionsDisabled = fieldInstance.value === 'o',
      isAddOnly = fieldInstance.value === '+';
    if (!this.row.rowList.length) {
      return true;
    }
    return hasAllActionsDisabled || isAddOnly || formComponentUtil.isFieldDisabled(form, fieldInstance, fieldTemplate, hasWriteAccess);
  };
  this.isRowRepeaterAddDisabled = function () {
    var result = false;
    var form = this.row.parentForm;
    if (!form.hasWriteAccess) {
      result = true;
    } else if (form.hasWriteAccess) {
      var lastRowInstanceIndex = this.row.rowList.length - 1,
        lastRowInstance = this.row.rowList[lastRowInstanceIndex];
      if (!_.isNil(lastRowInstance)) {
        var rowRepeaterFieldTemplate = this.row.rowTemplate.repeaterField.fieldTemplate,
          isRowRepeaterFieldDisabled = formComponentUtil.isFieldDisabled(form, null, rowRepeaterFieldTemplate, form.hasWriteAccess),
          lastRowRepeaterField = _.find(lastRowInstance.fieldStructureList, function (item) {
            return item.uiField.fieldTemplate.type === fieldType.ROWREPEATER;
          }),
          lastRowRepeaterFieldInstance = lastRowRepeaterField.fieldModel || {},
          hasAllActionsDisabled = lastRowRepeaterFieldInstance.value === 'o',
          isDeleteOnly = lastRowRepeaterFieldInstance.value === '-',
          isLastRowRepeaterFieldInstanceDisabled = formComponentUtil.isFieldDisabled(form, lastRowRepeaterFieldInstance, rowRepeaterFieldTemplate, form.hasWriteAccess);
        result = hasAllActionsDisabled || isDeleteOnly || isRowRepeaterFieldDisabled || isLastRowRepeaterFieldInstanceDisabled;
      }
    }
    return result;
  };
  this.isRepeaterDeleteDisabled = function () {
    var _this5 = this;
    var result = false;
    var form = this.row.parentForm;
    if (!form.hasWriteAccess) {
      result = true;
    } else if (form.hasWriteAccess) {
      var disabledRowList = _.filter(this.row.rowList, function (row) {
          return _this5.isRowDeleteDisabled(row);
        }),
        totalRows = this.row.rowList.length,
        rowsAvailableForDelete = totalRows - disabledRowList.length;
      result = totalRows < 2 || rowsAvailableForDelete === 0;
    }
    return result;
  };
  this.updateSubmitDeleteButton = function () {
    this.isSubmitDeleteEnabled = this.rowsToDelete.length !== 0;
    this.isSubmitDeleteEnabled = this.isSubmitDeleteEnabled && this.rowsToDelete.length !== this.row.rowList.length;
  };
  this.onDeleteAllClick = function () {
    var _this6 = this;
    _.map(this.visibleRowList, function (row) {
      if (!_this6.isRowDeleteDisabled(row)) {
        row.selected = _this6.isDeleteAllSelected;
      }
      return row;
    });
    this.rowsToDelete = _.filter(this.row.rowList, function (item) {
      return item.selected === true;
    });
    this.updateSubmitDeleteButton();
  };
  this.onCancelDelete = function () {
    _.each(this.row.rowList, function (item) {
      item.selected = false;
      item.isDeleting = false;
    });
    this.isDeleting = false;
    this.rowsToDelete = [];
    this.bulkUpdateHeight = 0;
  };
  this.onConfirmDelete = function () {
    var _this7 = this;
    var config = {
      cancelButtonLabel: translations.formsViewer.rowRepeater.cancel,
      confirmActionButtonLabel: translations.formsViewer.rowRepeater.confirm,
      summary: translations.formsViewer.rowRepeater.deleteConfirmationMessage,
      title: translations.formsViewer.rowRepeater.deleteConfirmationTitle
    };
    config.summary = config.summary.replace('{1}', this.rowsToDelete.length);
    config.summary = config.summary.replace('{2}', this.rowsToDelete.length > 1 ? 's' : '');
    modalUtil.showGenericConfirm(config).then(function () {
      var rowIds = [];
      _this7.showLoadingSpinner = true;
      _.filter(_this7.row.rowList, function (row) {
        return row.selected === true;
      }).map(function (row) {
        return rowIds.push(row.rowModel.id);
      });
      formMediator.deleteRepeatingRow(rowIds).then(function () {
        _this7.onCancelDelete();
        timeoutList.push($timeout(function () {
          _this7.showLoadingSpinner = false;
        }, 1500));
      });
    });
  };
  this.onSelectRow = function (event, row) {
    _.each(this.row.rowList, function (rowElement) {
      if (row.rowModel.id === rowElement.rowModel.id) {
        rowElement.selected = !rowElement.selected;
        return false;
      }
    });
    this.updateSelectedRows();
  };
  this.refresh = function () {
    var _this8 = this;
    timeoutList.push($timeout(function () {
      _this8.init();
      _this8.row.timeLastModified = new Date().getTime();
    }), 0);
  };
  this.rowRepeaterClicked = function () {
    $rootScope.$broadcast(formViewerConstant.configuration.event.ROW_SELECTION_CHANGE, this.row);
  };
  this.$onDestroy = function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  };
};
RowRepeaterController.$inject = ["$rootScope", "$scope", "$timeout", "localization", "formComponentUtil", "fieldType", "formMediator", "modalUtil", "xmlUtil", "formViewerConstant", "rowRepeaterUtil", "rowRepeaterRowListComparisonResultConstant"];
angular.module('umFormViewer').controller('rowRepeaterController', RowRepeaterController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

var path = '/formViewer/component/rowRepeater/rowRepeaterPlaceholder.tpl.html';
var html = "<ui-row-repeater ng-if=\"(row.rowList && !row.isHidden) || configurable \"\n                 class=\"rowRepeater {{ ::row.rowRepeaterName }} rowRepeater-{{ ::row.rowTemplate.repeaterField.fieldTemplate.id }}\"\n                 row=\"row\"\n                 root-form-id=\"::formId\"\n                 configurable=\"configurable\"></ui-row-repeater>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

var path = '/formViewer/component/rowRepeater/header/columnHeader.tpl.html';
var html = "<div class=\"repeaterColumnHeader {{ ::$ctrl.getComponentClassName($ctrl.uiField) }}\"\n     ng-click=\"$ctrl.toggleSort()\"\n     ui-manual-size\n     width=\"$ctrl.getHeaderFieldWidth($ctrl.uiField)\"\n     ng-if=\"!$ctrl.hidden && !$ctrl.isColumnCollapsed\">\n\n    <ui-required-indicator-label\n            class=\"columnRequiredIndicatorLabel\"\n            required-label-config=\"$ctrl.requiredIndicatorLabelConfig\">\n    </ui-required-indicator-label>\n\n    <div class=\"sortIcons\">\n        <div class=\"glyphicon glyphicon-triangle-top\"\n            ng-if=\"$ctrl.isSortingAsc\"></div>\n\n        <div class=\"glyphicon glyphicon-triangle-bottom\"\n             ng-if=\"$ctrl.isSortingDesc\"></div>\n    </div>\n\n</div>\n\n<div class=\"hiddenColumnHeaderSpacer\" ng-if=\"$ctrl.hidden && $ctrl.isColumnCollapsed\"></div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

var ColumnHeaderComponent = {
  templateUrl: '/formViewer/component/rowRepeater/header/columnHeader.tpl.html',
  controller: 'columnHeaderController',
  bindings: {
    uiField: '<',
    row: '<',
    timeLastModified: '<',
    rootFormId: '<',
    configurable: '<'
  }
};
angular.module('umFormViewer').component('uiColumnHeader', ColumnHeaderComponent);

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ColumnHeaderController = function ColumnHeaderController($element, formComponentUtil, fieldType, xmlUtil, formMediator, appTypeConfigurationModel, formatUtil) {
  var fieldStructureList;
  function buildFieldInstanceList() {
    var fieldTemplateId = this.uiField.fieldTemplate.id,
      fieldModel,
      isMatchingFieldTemplateId;
    fieldStructureList = [];
    _.each(this.row.rowList, function (row) {
      _.each(row.fieldStructureList, function (fieldStructure) {
        isMatchingFieldTemplateId = fieldStructure.uiField.fieldTemplate.id === fieldTemplateId;
        if (isMatchingFieldTemplateId) {
          fieldStructureList.push(fieldStructure);
        }
      });
    });
  }
  this.$onInit = function () {
    var rowRepeaterId = this.row.rowRepeaterId,
      sortKey = this.uiField.fieldTemplate.variableName,
      sortType;
    this.isRowNumberColumn = this.uiField.fieldTemplate.variableName === 'rowNumber';
    this.currentSortType = 'none';
    this.currentSortKey = 'none';
    this.updateSortValues();
    buildFieldInstanceList.call(this);
    this.setupDynamicProperties();
    if (this.isActiveSort) {
      rowRepeaterId = this.row.rowRepeaterId;
      sortKey = this.uiField.fieldTemplate.variableName;
      formMediator.sortRowRepeater(this.rootFormId, rowRepeaterId, sortKey, this.currentSortType);
    }
  };
  this.$onChanges = function () {
    buildFieldInstanceList.call(this);
    this.setupDynamicProperties();
    this.updateSortValues();
  };
  this.getHeaderFieldWidth = function () {
    var uiField = this.uiField,
      isSpacer = uiField.fieldTemplate.type === fieldType.SPACER,
      isUploadAttachmentButton = uiField.fieldTemplate.type === fieldType.UPLOAD_ATTACHMENT_BUTTON,
      isFunctionButton = uiField.fieldTemplate.type === fieldType.FUNCTION_BUTTON,
      isYesNo = uiField.fieldTemplate.type === fieldType.YES_NO,
      inputContainerWidth = 160;
    var layout, options, result;
    if (!_.isNil(uiField.fieldTemplate.type)) {
      var _layout = formComponentUtil.buildLayoutProperties(uiField);
      result = _layout.inputWidth || _layout.labelWidth;
      if (isSpacer) {
        var _options = xmlUtil.parseString(uiField.options);
        result = parseInt(_options.width);
        if (this.configurable) {
          result = parseInt(_options.width) < 18 ? 18 : _options.width;
        }
      } else if (isUploadAttachmentButton || isFunctionButton) {
        result = _layout.labelWidth || inputContainerWidth;
      } else if (isYesNo) {
        result = _layout.labelWidth > inputContainerWidth ? _layout.labelWidth : inputContainerWidth;
      }
    }
    return result;
  };
  this.getHeaderLabel = function () {
    var uiField = this.uiField,
      isSpacer = uiField.fieldTemplate.type === fieldType.SPACER,
      isUploadAttachmentButton = uiField.fieldTemplate.type === fieldType.UPLOAD_ATTACHMENT_BUTTON,
      isFunctionButton = uiField.fieldTemplate.type === fieldType.FUNCTION_BUTTON;
    return isSpacer || isUploadAttachmentButton || isFunctionButton ? '' : uiField.displayLabel;
  };
  this.setupDynamicProperties = function () {
    var form = this.row.parentForm,
      uiField = this.uiField,
      fieldTemplate = uiField.fieldTemplate,
      rowTemplate = this.row.rowTemplate,
      rowList = this.row.rowList,
      fieldModel;
    function setupValidity() {
      var result = true;
      _.each(fieldStructureList, function (fieldStructure) {
        fieldModel = fieldStructure.fieldModel || {};
        if (fieldModel.valid === false) {
          result = false;
        }
      });
      return result;
    }
    function setupConfigurable() {
      var result = true;
      _.each(fieldStructureList, function (fieldStructure) {
        result = fieldStructure.isConfigurableComponent;
        return;
      });
      return result;
    }
    function setupRequired() {
      var result = formComponentUtil.isFieldRequired(form, null, fieldTemplate),
        isOptionallyRequired = formComponentUtil.isFieldRequired(form, null, rowTemplate.repeaterField.fieldTemplate) === false,
        isRequired;
      _.each(fieldStructureList, function (fieldStructure) {
        isRequired = formComponentUtil.isFieldRequired(form, fieldStructure.fieldModel, fieldTemplate);
        if (isRequired) {
          result = true;
        }
      });
      if (isOptionallyRequired) {
        if (anyRowHasValue() || rowList.length > 1) {
          result = result;
        } else {
          result = false;
        }
      }
      _.each(fieldStructureList, function (fieldStructure) {
        if (isOptionallyRequired) {
          fieldStructure.dynamicProperties.isOptionallyRequired = true;
          fieldStructure.dynamicProperties.isColumnRequired = result;
        } else {
          fieldStructure.dynamicProperties.isOptionallyRequired = false;
        }
      });
      return result;
    }
    function anyRowHasValue() {
      var result = false,
        fieldModel;
      _.each(rowList, function (row) {
        _.each(row.fieldStructureList, function (fieldStructure) {
          fieldModel = fieldStructure.fieldModel || {};
          if (!_.isEmpty(fieldModel.value) && fieldStructure.uiField.fieldTemplate.type !== fieldType.ROWREPEATER && (!fieldStructure.uiField.fieldTemplate.hidden || fieldStructure.uiField.fieldTemplate.hidden && !fieldModel.hidden)) {
            result = true;
          }
        });
      });
      return result;
    }
    function allRowsHaveValue() {
      var allRowsHaveValue = true,
        allRowsHaveInstance = rowList.length === fieldStructureList.length,
        fieldModel;
      _.each(fieldStructureList, function (fieldStructure) {
        fieldModel = fieldStructure.fieldModel || {};
        if (_.isEmpty(fieldModel.value) && formComponentUtil.isFieldRequired(form, fieldModel, fieldTemplate) && (!fieldStructure.uiField.fieldTemplate.hidden || fieldStructure.uiField.fieldTemplate.hidden && !_.isEmpty(fieldModel) && !fieldModel.hidden)) {
          allRowsHaveValue = false;
        }
      });
      return allRowsHaveValue && allRowsHaveInstance;
    }
    function setupHidden() {
      var result = false,
        numberOfFields = 0,
        numberOfVisibleFields = 0;
      _.each(fieldStructureList, function (fieldStructure) {
        if (fieldStructure.fieldModel) {
          numberOfFields++;
          if (!fieldStructure.fieldModel.hidden) {
            numberOfVisibleFields++;
          }
        }
      });

      /*
       * If there are any fields in the column, hide the column if none of the fields
       * are visible. If there aren't any fields in the column, then hide the column
       * if the field template says that the field should be hidden.
       * Even if those checks say that the column should not be hidden, hide the column
       * if the field template says that the column should not be visible for
       * the current user type.
       */
      result = (numberOfFields > 0 ? numberOfVisibleFields === 0 : fieldTemplate.hidden) || (appTypeConfigurationModel.isUnderwriterWorkstation() ? !fieldTemplate.carrierVisible : !fieldTemplate.agencyVisible);
      return result;
    }
    function setupCollapsedColumn() {
      var variableName = fieldTemplate.variableName,
        result = false,
        isCorrectColumn;
      _.each(rowList, function (row) {
        _.each(row.fieldStructureList, function (fieldStructure) {
          isCorrectColumn = fieldStructure.uiField.fieldTemplate.variableName === variableName;
          if (isCorrectColumn && fieldStructure.isColumnCollapsed) {
            result = true;
          }
        });
      });
      return result;
    }
    if (!this.isRowNumberColumn) {
      this.hasValue = allRowsHaveValue();
      this.isRequired = setupRequired();
      this.isValid = setupValidity();
      this.configurable = setupConfigurable();
      this.hidden = this.configurable ? false : setupHidden();
      this.isColumnCollapsed = this.configurable ? false : setupCollapsedColumn();
    } else if (uiField.hidden) {
      this.hidden = true;
    }
    this.requiredIndicatorLabelConfig = {
      required: this.isRequired,
      valid: this.isValid,
      hasValue: this.hasValue,
      label: this.getHeaderLabel(),
      width: this.getHeaderFieldWidth(),
      configurable: this.configurable,
      bold: this.uiField.labelFontStyle === 'Bold'
    };
    if (this.hidden && this.isColumnCollapsed) {
      $element.addClass('collapsed');
    } else {
      $element.removeClass('collapsed');
    }
  };
  this.updateSortValues = function () {
    var rowRepeaterSort = this.row.sort || {},
      sortKey = this.uiField.fieldTemplate.variableName;
    this.isActiveSort = rowRepeaterSort.sortKey === sortKey;
    this.currentSortType = rowRepeaterSort.sortType;
    this.isSortingAsc = this.isActiveSort && rowRepeaterSort.sortType === 'asc';
    this.isSortingDesc = this.isActiveSort && rowRepeaterSort.sortType === 'desc';
  };
  this.toggleSort = function () {
    var form = this.row.parentForm,
      rowRepeaterId = this.row.rowRepeaterId,
      sortKey = this.uiField.fieldTemplate.variableName,
      allowSort = !form.isConfigurableForm;
    var sortType;
    if (allowSort) {
      if (this.currentSortType === 'asc') {
        sortType = 'desc';
      } else if (this.currentSortType === 'desc') {
        sortType = 'asc';
      }
      formMediator.sortRowRepeater(this.rootFormId, rowRepeaterId, sortKey, sortType);
    }
  };
  this.getComponentClassName = function (uiField) {
    return "rowRepeaterColumnHeader-".concat(formatUtil.formatAsSelector(uiField.fieldTemplate.variableName));
  };
};
ColumnHeaderController.$inject = ["$element", "formComponentUtil", "fieldType", "xmlUtil", "formMediator", "appTypeConfigurationModel", "formatUtil"];
angular.module('umFormViewer').controller('columnHeaderController', ColumnHeaderController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

var path = '/formViewer/component/rowRepeater/paging/paging.tpl.html';
var html = "<div class=\"pagingContainer\"\n     ng-if=\"$ctrl.source.length > $ctrl.pageSize && $ctrl.pagingIsEnabled\">\n\n    <button class=\"btn btn-xs btn-default previousPageButton first\"\n            ng-click=\"$ctrl.onPreviousPage()\"\n            ng-disabled=\"$ctrl.selectedIndex === 0\">\n        Prev\n    </button>\n\n    <button class=\"btn btn-xs btn-default pageButton\"\n            ng-class=\"{ selected : page.index === $ctrl.selectedIndex }\"\n            ng-repeat=\"page in $ctrl.visiblePageList\"\n            ng-click=\"$ctrl.onSelectPage(page)\">\n        {{ page.label }}\n    </button>\n\n    <button class=\"btn btn-xs btn-default nextPageButton\"\n            ng-click=\"$ctrl.onNextPage()\"\n            ng-disabled=\"$ctrl.selectedIndex === $ctrl.pageList.length - 1\">\n        Next\n    </button>\n\n    <div class=\"pagingContext\">Showing <span class=\"startIndex\">{{ $ctrl.startIndex + 1}}</span>-<span class=\"endIndex\">{{ $ctrl.endIndex + 1}}</span> of <span class=\"total\">{{ $ctrl.source.length }}</span> items</div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

var PagingComponent = {
  templateUrl: '/formViewer/component/rowRepeater/paging/paging.tpl.html',
  controller: 'pagingController',
  bindings: {
    source: '<',
    pageSize: '<',
    timeLastModified: '<',
    printPreview: '<',
    onChange: '&'
  }
};
angular.module('umFormViewer').component('uiPaging', PagingComponent);

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var PagingController = function PagingController() {
  var maximumVisiblePages = 10;
  this.$onInit = function () {
    this.selectedIndex = 0;
    this.pagingIsEnabled = this.pageSize > 0 && !this.printPreview;
    this.setupPages();
    this.calculatePageRange();
  };
  this.$onChanges = function () {
    this.setupPages();
    this.calculatePageRange();
  };
  this.setupPages = function () {
    var maxIndex, currentIndex;
    this.numberOfPages = Math.ceil(this.source.length / this.pageSize);
    if (this.numberOfPages === 0) {
      this.numberOfPages = 1;
    }
    this.pageList = _.map(_.times(this.numberOfPages), function (index) {
      return {
        index: index,
        label: index + 1
      };
    });
    maxIndex = this.pageList.length - 1;
    currentIndex = this.selectedIndex;
    if (currentIndex > maxIndex) {
      this.selectedIndex = maxIndex;
    }
  };
  this.onSelectPage = function (page) {
    this.selectedIndex = this.pageList.indexOf(page);
    this.calculatePageRange();
  };
  this.onNextPage = function () {
    var maxIndex = this.pageList.length - 1,
      currentIndex = this.selectedIndex,
      isAllowed = currentIndex < maxIndex;
    this.selectedIndex = isAllowed ? currentIndex + 1 : maxIndex;
    this.calculatePageRange();
  };
  this.onPreviousPage = function () {
    this.selectedIndex = this.selectedIndex > 0 ? this.selectedIndex - 1 : 0;
    this.calculatePageRange();
  };
  this.calculatePageRange = function () {
    var startIndexOrig = this.startIndex,
      endIndexOrig = this.endIndex;
    this.startIndex = this.selectedIndex * this.pageSize;
    this.endIndex = this.startIndex + this.pageSize - 1;
    if (this.endIndex > this.source.length - 1 && this.source.length - 1 >= 0) {
      this.endIndex = this.source.length - 1;
    }
    var startPage = 0,
      endPage = this.pageList.length,
      isMaximumVisiblePages = maximumVisiblePages < endPage;
    if (isMaximumVisiblePages) {
      // Current page is displayed in the middle of the visible ones
      startPage = Math.max(this.selectedIndex - Math.floor(maximumVisiblePages / 2), 0);
      endPage = startPage + maximumVisiblePages;

      // Adjust if limit is exceeded
      if (endPage > this.pageList.length) {
        endPage = this.pageList.length;
        startPage = endPage - maximumVisiblePages;
      }
    }
    this.visiblePageList = _.slice(_.clone(this.pageList), startPage, endPage);
    if (startIndexOrig !== this.startIndex || endIndexOrig !== this.endIndex) {
      this.onChange({
        startIndex: this.startIndex,
        endIndex: this.endIndex
      });
    }
  };
};
angular.module('umFormViewer').controller('pagingController', PagingController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var RepeatingRowsDirective = function RepeatingRowsDirective($rootScope, formComponentRenderingUtil, formViewerConstant, rowRepeaterUtil, rowRepeaterRowListComparisonResultConstant) {
  var linkFunction = function linkFunction($scope, $elm) {
    var rowRepeaterContainer = $($elm);
    var renderedRows;
    function createRepeatingRow(row) {
      formComponentRenderingUtil.createRepeatingRow(row, rowRepeaterContainer, $scope.hideRowNumbers, $scope.configurable);
      _.map(row.fieldStructureList, function (fieldStructure) {
        if ($scope.configurable) {
          formComponentRenderingUtil.createConfigurableComponent(fieldStructure, row.viewContainer, true);
        } else {
          formComponentRenderingUtil.createComponentByType(fieldStructure, row.viewContainer, true);
        }
      });
    }
    $scope.$watch('visibleRows', function () {
      var reRender = false;
      var rowRenderingHappened = false;
      if (_.isEmpty(renderedRows)) {
        renderedRows = $scope.visibleRows;
        reRender = true;
      }
      if (!reRender) {
        var rowRepeaterRowListComparisonResult = rowRepeaterUtil.compareRowLists($scope.visibleRows, renderedRows);
        switch (rowRepeaterRowListComparisonResult) {
          // If we have added a single new row, add that new row without having to re-render the entire row repeater
          case rowRepeaterRowListComparisonResultConstant.ONE_ROW_ADDED:
            createRepeatingRow($scope.visibleRows[$scope.visibleRows.length - 1]);
            rowRenderingHappened = true;
            break;

          // More than one row was added, rows were removed or the number of rows is unchanged but the contents changed, re-render the entire row repeater.
          case rowRepeaterRowListComparisonResultConstant.MORE_THAN_ONE_ROW_ADDED:
          case rowRepeaterRowListComparisonResultConstant.ROWS_REMOVED:
          case rowRepeaterRowListComparisonResultConstant.CONTENTS_CHANGED:
            reRender = true;
            break;
          case rowRepeaterRowListComparisonResultConstant.EQUAL:
          default:
            break;
        }
      }
      renderedRows = $scope.visibleRows;
      if (reRender) {
        var scopeList = $(".".concat($scope.rowRepeaterIden, " .repeatingRowContainer .ng-scope"));
        var isolateScopeList = $(".".concat($scope.rowRepeaterIden, " .repeatingRowContainer .ng-isolate-scope"));
        formComponentRenderingUtil.manuallyDestroyDomScope(scopeList, isolateScopeList);
        rowRepeaterContainer.empty();
        _.each($scope.visibleRows, function (row) {
          createRepeatingRow(row);
        });
        if (!_.isNil($scope.visibleRows) && !_.isEmpty($scope.visibleRows)) {
          rowRenderingHappened = true;
        }
      }
      if (rowRenderingHappened) {
        $rootScope.$broadcast(formViewerConstant.event.ROW_RENDERING_COMPLETE);
      }
    });
  };
  return {
    restrict: 'E',
    replace: false,
    link: linkFunction,
    scope: {
      rowRepeaterIden: '<',
      visibleRows: '<',
      hideRowNumbers: '<',
      configurable: '<'
    }
  };
};
RepeatingRowsDirective.$inject = ["$rootScope", "formComponentRenderingUtil", "formViewerConstant", "rowRepeaterUtil", "rowRepeaterRowListComparisonResultConstant"];
angular.module('umFormViewer').directive('uiRepeatingRows', RepeatingRowsDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

/*@ngInject*/
var AddFormRowRepository = function AddFormRowRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.addFormRow = function (formId, uiRowId, rowNumberOfLastRow) {
    var url = '/rest/FormRow',
      config = {
        params: {
          formId: formId,
          uiRowId: uiRowId,
          rowNumber: rowNumberOfLastRow
        }
      };
    return this.post(url, {}, config);
  };
};
AddFormRowRepository.$inject = ["baseRepository"];
angular.module('umFormViewer').service('addFormRowRepository', AddFormRowRepository);

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

/*@ngInject*/
var DeleteFormRowRepository = function DeleteFormRowRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.deleteFormRow = function (uiRowIds) {
    var url = '/rest/FormRow/rows',
      config = {
        params: {
          rowId: uiRowIds
        }
      };
    return this.delete(url, config);
  };
};
DeleteFormRowRepository.$inject = ["baseRepository"];
angular.module('umFormViewer').service('deleteFormRowRepository', DeleteFormRowRepository);

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

var path = '/formViewer/component/spacer/spacer.tpl.html';
var html = "<div class=\"formSpacer {{ ::$ctrl.configurationClass }}\"\n     ng-if=\"!$ctrl.fieldStructure.dynamicProperties.hidden || $ctrl.fieldStructure.isConfigurableComponent\"\n     ng-click=\"$ctrl.handleClick()\">\n\n    <div class=\"formComponentContainer\">\n        <div class=\"componentInputContainer {{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n             ui-manual-size\n             width=\"::$ctrl.spacerWidth\"\n             height=\"::$ctrl.spacerHeight\">\n\n            <div class=\"configurableSpacerContainer\"\n                 ng-if=\"::$ctrl.fieldStructure.isConfigurableComponent\">\n            </div>\n        </div>\n    </div>\n</div>\n\n<span class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n      ng-if=\"$ctrl.fieldStructure.dynamicProperties.hidden && !$ctrl.fieldStructure.isConfigurableComponent\"></span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

var SpacerComponent = {
  templateUrl: '/formViewer/component/spacer/spacer.tpl.html',
  controller: 'spacerController',
  bindings: {
    fieldStructure: '<'
  }
};
angular.module('umFormViewer').component('uiSpacer', SpacerComponent);

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

/*@ngInject*/
var SpacerController = function SpacerController($scope, $rootScope, $controller, xmlUtil, formViewerConstant) {
  angular.extend(this, $controller('baseFormComponentController', {
    $scope: $scope
  }));
  this.$onInit = function () {
    this.onInit();
    var options = xmlUtil.parseString(this.fieldStructure.uiField.options);
    this.spacerWidth = options.width;
    this.spacerHeight = options.height;
    this.isConfigurableComponent = this.fieldStructure.isConfigurableComponent === true;
    this.configurationClass = this.isConfigurableComponent ? 'configurable' : '';
    if (this.fieldStructure.isConfigurableComponent) {
      this.spacerWidth = parseInt(options.width) < 18 ? 18 : options.width;
    }
  };
  this.handleClick = function () {
    $rootScope.$broadcast(formViewerConstant.event.FOCUSED_FIELD_CHANGED, this.fieldStructure);
  };
};
SpacerController.$inject = ["$scope", "$rootScope", "$controller", "xmlUtil", "formViewerConstant"];
angular.module('umFormViewer').controller('spacerController', SpacerController);

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

var path = '/formViewer/component/spacer/spacerPlaceholder.tpl.html';
var html = "<ui-spacer class=\"fieldListComponent spacer\"\n           field-structure=\"fieldStructure\"\n           collapsible=\"::$ctrl.collapsible\"\n           ui-show-field-details-modal></ui-spacer>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

var path = '/formViewer/component/textarea/textArea.tpl.html';
var html = "<div class=\"formComponentContainer {{ ::$ctrl.configurationClass }}\"\n     ng-class=\"{\n        labelLeft: $ctrl.fieldStructure.layout.isLabelLeftAligned,\n        showAsHidden: $ctrl.fieldStructure.dynamicProperties.hidden\n     }\"\n     ng-if=\"!$ctrl.fieldStructure.dynamicProperties.hidden || $ctrl.fieldStructure.isConfigurableComponent\">\n\n    <!--Label-->\n    <ui-required-indicator-label\n            ng-if=\"!$ctrl.hideLabel\"\n            required=\"$ctrl.fieldStructure.dynamicProperties.isRequired\"\n            required-label-config=\"$ctrl.fieldStructure.requiredIndicatorLabelConfig\">\n    </ui-required-indicator-label>\n\n    <!--Input-->\n    <div class=\"componentInputContainer\"\n         ui-manual-size\n         ui-snippets-indicator\n         ui-snippets-indicator-name=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n         width=\"::$ctrl.fieldStructure.layout.inputWidth\"\n         height=\"$ctrl.getManualHeight()\"\n         ng-mouseenter=\"$ctrl.mouseEnter($event,$ctrl.fieldStructure)\"\n         ng-mouseleave=\"$ctrl.mouseLeave()\">\n\n        <textarea class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n                  maxlength=\"{{ ::$ctrl.getMaxChar($ctrl.fieldStructure.uiField.options)}}\"\n                  ng-model=\"$ctrl.fieldStructure.fieldModel.value\"\n                  ng-disabled=\"$ctrl.fieldStructure.dynamicProperties.disabled\"\n                  ng-change=\"$ctrl.handleChange()\"\n                  ng-blur=\"$ctrl.updateFieldValue()\"\n                  ng-focus=\"$ctrl.handleFocus()\"\n                  ui-remote-change-notification\n                  ng-if=\"!$ctrl.getRichText($ctrl.fieldStructure.uiField.options)\"></textarea>\n\n        <summernote class=\"editor\"\n                    config=\"$ctrl.getRichTextOptions()\"\n                    editor=\"editor\"\n                    class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n                    ng-model=\"$ctrl.fieldStructure.fieldModel.value\"\n                    editable=\"!$ctrl.fieldStructure.dynamicProperties.disabled\"\n                    on-change=\"$ctrl.handleChange()\"\n                    on-blur=\"$ctrl.updateFieldValue()\"\n                    on-focus=\"$ctrl.handleFocus()\"\n                    ui-remote-change-notification\n                    ng-if=\"$ctrl.getRichText($ctrl.fieldStructure.uiField.options)\"></summernote>\n\n        <div class=\"textarea {{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n                  ng-class=\"{'disabled': $ctrl.fieldStructure.dynamicProperties.disabled}\"\n                  ui-remote-change-notification\n                  ui-manual-size\n                  min-height=\"::$ctrl.fieldStructure.layout.inputHeight\"\n                  ng-bind-html=\"$ctrl.printValue\"></div>\n    </div>\n</div>\n\n<span class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n      ng-if=\"$ctrl.fieldStructure.dynamicProperties.hidden && !$ctrl.fieldStructure.isConfigurableComponent\"></span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

var TextAreaComponent = {
  templateUrl: '/formViewer/component/textarea/textArea.tpl.html',
  controller: 'textAreaController',
  bindings: {
    fieldStructure: '<',
    timeLastModified: '<',
    hideLabel: '<'
  }
};
angular.module('umFormViewer').component('uiTextArea', TextAreaComponent);

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var TextAreaController = function TextAreaController($scope, $controller, formViewerConstant, formComponentUtil, xmlUtil) {
  angular.extend(this, $controller('baseFormComponentController', {
    $scope: $scope
  }));
  this.$onInit = function () {
    this.onInit();
    this.refreshPrintValue();
  };
  this.$onChanges = function () {
    this.onChanges();
  };
  this.handleChange = function () {
    this.fieldStructure.hasLocalChanges = true;
    formComponentUtil.setupFieldProperties(this.fieldStructure);
    this.refreshPrintValue();
  };
  this.refreshPrintValue = function () {
    if (this.fieldStructure.fieldModel && !_.isNil(this.fieldStructure.fieldModel.value)) {
      this.printValue = this.fieldStructure.fieldModel.value.replace(/\n/g, '<br>');
    }
  };
  this.getManualHeight = function () {
    var isPrintPreview = this.fieldStructure.parentForm.printPreview;
    var inputHeight = this.fieldStructure.layout.inputHeight;
    return isPrintPreview ? false : inputHeight;
  };
  this.getMaxChar = function (options) {
    var optionsObject = xmlUtil.parseString(options);
    return parseInt(optionsObject.maxChars) > 0 ? optionsObject.maxChars : null;
  };
  this.getRichText = function (options) {
    var optionsObject = xmlUtil.parseString(options);
    return optionsObject.richText;
  };
  this.optionsList = {
    height: 200,
    toolbar: [['style', ['style']], ['font', ['bold', 'underline', 'italic', 'clear']], ['fontname', ['fontname']], ['color', ['color']], ['para', ['ul', 'ol', 'paragraph']], ['insert', ['link']]],
    dialogsInBody: true,
    disableResizeEditor: true,
    disableLinkTarget: true,
    defaultLinkTargetNewWindow: true,
    disableDragAndDrop: true,
    fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Helvetica', 'Impact', 'Lato', 'Tahoma', 'Times New Roman', 'Verdana']
  };
  this.getRichTextOptions = function () {
    this.optionsList.height = this.fieldStructure.layout.inputHeight - 35;
    return this.optionsList;
  };
};
TextAreaController.$inject = ["$scope", "$controller", "formViewerConstant", "formComponentUtil", "xmlUtil"];
angular.module('umFormViewer').controller('textAreaController', TextAreaController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

var path = '/formViewer/component/textarea/textAreaPlaceholder.tpl.html';
var html = "<ui-text-area class=\"fieldListComponent\"\n              field-structure=\"fieldStructure\"\n              time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n              collapsible=\"::$ctrl.collapsible\"\n              hide-label=\"::hideLabel\"\n              ui-show-field-details-modal></ui-text-area>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

var path = '/formViewer/component/textInput/textInput.tpl.html';
var html = "<div class=\"formComponentContainer {{ ::$ctrl.configurationClass }}\"\n     ng-class=\"{\n        labelLeft: $ctrl.fieldStructure.layout.isLabelLeftAligned,\n        showAsHidden: $ctrl.fieldStructure.dynamicProperties.hidden\n     }\"\n     ng-if=\"!$ctrl.fieldStructure.dynamicProperties.hidden || $ctrl.fieldStructure.isConfigurableComponent\">\n\n    <!--Label-->\n    <ui-required-indicator-label\n        ng-if=\"::!$ctrl.hideLabel\"\n        required-label-config=\"$ctrl.fieldStructure.requiredIndicatorLabelConfig\">\n    </ui-required-indicator-label>\n\n    <!--Input-->\n    <div class=\"componentInputContainer\"\n         ui-manual-size\n         ui-snippets-indicator\n         ui-snippets-indicator-name=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n         width=\"::$ctrl.fieldStructure.layout.inputWidth\"\n         ng-mouseenter=\"$ctrl.mouseEnter($event,$ctrl.fieldStructure)\"\n         ng-mouseleave=\"$ctrl.mouseLeave()\">\n\n        <input type=\"text\"\n               class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n               maxlength=\"{{ ::$ctrl.getMaxChar($ctrl.fieldStructure.uiField.options)}}\"\n               ng-class=\"{\n                    error: !$ctrl.fieldStructure.dynamicProperties.isValid,\n                    'ui-currency-formatter': $ctrl.isCurrency,\n                    'ui-display-dollar': $ctrl.isDisplayDollar,\n                    'ui-percent-formatter': $ctrl.isPercentage,\n                    'ui-number-with-commas-formatter': $ctrl.isNumberWithCommas,\n                    'ui-datetime-formatter': $ctrl.isDate,\n                    'ui-number-without-commas-formatter': $ctrl.isNumber && !$ctrl.isNumberWithCommas\n               }\"\n               ng-model=\"$ctrl.fieldStructure.fieldModel.value\"\n               ng-disabled=\"$ctrl.fieldStructure.dynamicProperties.disabled\"\n               ng-change=\"$ctrl.handleChange()\"\n               ng-blur=\"$ctrl.handleBlur()\"\n               ng-focus=\"$ctrl.handleFocus()\"\n               ui-remote-change-notification\n               ui-currency-formatter\n               ui-datetime-formatter\n               ui-currency-formatter-rounding=\"{{::$ctrl.currencyRounding}}\"\n               ui-currency-code=\"{{::$ctrl.formStructure.currencyCode}}\"\n               ui-percent-formatter\n               ui-percent-add-percent=\"{{::$ctrl.percentageAddPercent}}\"\n               ui-number-with-commas-formatter\n               ui-number-without-commas-formatter\n               ui-number-domain=\"{{::$ctrl.numberDomain}}\"\n        />\n\n    </div>\n\n</div>\n\n<!-- Row Repeater Hidden Width Placeholder -->\n<div class=\"formComponentContainer collapsedPlaceholder\"\n     ng-if=\"$ctrl.fieldStructure.isRowRepeaterField && $ctrl.fieldStructure.dynamicProperties.hidden && !$ctrl.fieldStructure.isColumnCollapsed\">\n\n    <div ui-manual-size\n         width=\"$ctrl.fieldStructure.layout.inputWidth\"></div>\n</div>\n\n<span class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n      ng-if=\"$ctrl.fieldStructure.dynamicProperties.hidden && !$ctrl.fieldStructure.isConfigurableComponent\"></span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

var TextInputComponent = {
  templateUrl: '/formViewer/component/textInput/textInput.tpl.html',
  controller: 'textInputController',
  bindings: {
    fieldStructure: '<',
    timeLastModified: '<',
    hideLabel: '<'
  }
};
angular.module('umFormViewer').component('uiTextInput', TextInputComponent);

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var TextInputController = function TextInputController($scope, $controller, formViewerConstant, formComponentUtil, formMediator, xmlUtil) {
  angular.extend(this, $controller('baseFormComponentController', {
    $scope: $scope
  }));
  this.$onInit = function () {
    this.onInit();
    var fieldTemplate = this.fieldStructure.uiField.fieldTemplate,
      validatorProperty;
    this.isCurrency = fieldTemplate.validator === 'currency';
    this.isPercentage = fieldTemplate.validator === 'percent';
    this.isNumber = fieldTemplate.validator === 'number';
    this.isNumberWithCommas = fieldTemplate.validator === 'number with commas';
    this.isNumberRange = fieldTemplate.validator === 'number range';
    this.isDate = fieldTemplate.validator === 'date';
    if (_.isNil(fieldTemplate.validatorProperty) && this.isCurrency) {
      this.isDisplayDollar = true;
    }
    if (fieldTemplate.validatorProperty) {
      validatorProperty = xmlUtil.parseString(fieldTemplate.validatorProperty);
      if (this.isCurrency) {
        var displayDollarSymbol = validatorProperty.displayDollarSymbol;
        this.isDisplayDollar = _.isUndefined(displayDollarSymbol) ? true : displayDollarSymbol;
        this.currencyRounding = validatorProperty.currencyRounding;
      }
      if (this.isPercentage || this.isNumber || this.isNumberWithCommas || this.isNumberRange) {
        this.numberDomain = validatorProperty.numberDomain;
      }
      if (this.isPercentage) {
        this.percentageAddPercent = validatorProperty.addPercent;
      }
    }
    this.formStructure = formMediator.getFormStructure(this.fieldStructure.rootFormId);
  };
  this.$onChanges = function () {
    this.onChanges();
  };
  this.handleChange = function () {
    this.fieldStructure.hasLocalChanges = true;
  };
  this.handleBlur = function () {
    var dateValue;
    if (this.fieldStructure.hasLocalChanges) {
      if (this.fieldStructure.rowRepeaterId) {
        this.fieldStructure.dynamicProperties.isValid = true;
      }
      if (this.isDate) {
        dateValue = formComponentUtil.dateFromInput(this.fieldStructure.fieldModel.value, false);
        this.fieldStructure.fieldModel.value = formComponentUtil.formatDateForServer(dateValue, false);
      } else if (this.isCurrency) {
        this.fieldStructure.fieldModel.value = formComponentUtil.roundCurrencyForServer(this.fieldStructure.fieldModel.value, this.currencyRounding);
      }
      formMediator.handleFieldChange(this.fieldStructure.parentForm.id, this.fieldStructure, this.resetFieldValue.bind(this), this.updateOriginalFieldValue.bind(this));
    }
  };
  this.getMaxChar = function (options) {
    var optionsObject = xmlUtil.parseString(options);
    return parseInt(optionsObject.maxChars) > 0 ? optionsObject.maxChars : null;
  };
};
TextInputController.$inject = ["$scope", "$controller", "formViewerConstant", "formComponentUtil", "formMediator", "xmlUtil"];
angular.module('umFormViewer').controller('textInputController', TextInputController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

var path = '/formViewer/component/textInput/textInputPlaceholder.tpl.html';
var html = "<ui-text-input class=\"fieldListComponent\"\n               field-structure=\"fieldStructure\"\n               time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n               hide-label=\"::hideLabel\"\n               collapsible=\"::$ctrl.collapsible\"\n               ui-show-field-details-modal></ui-text-input>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1200 */
/***/ (function(module) {

module.exports = JSON.parse("{\"uploadAttachment\":{\"unacceptableType\":{\"unacceptableTypeMessage\":\"File {name} is not a supported document type for import.\",\"unacceptableTypeTitle\":\"Alert\",\"unacceptableTypeConfirmActionButtonLabel\":\"OK\"},\"deleteConfirmation\":{\"message\":\"Are you sure you want to delete this Attachment?\",\"title\":\"Delete Attachment\",\"cancel\":\"No\",\"confirm\":\"Yes\"}}}");

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

var path = '/formViewer/component/uploadAttachment/uploadAttachment.tpl.html';
var html = "<div class=\"formComponentContainer {{ ::$ctrl.configurationClass }}\"\n     ng-class=\"{\n        labelLeft: $ctrl.fieldStructure.layout.isLabelLeftAligned,\n        showAsHidden: $ctrl.fieldStructure.dynamicProperties.hidden\n     }\"\n     ng-if=\"!$ctrl.fieldStructure.dynamicProperties.hidden || $ctrl.fieldStructure.isConfigurableComponent\">\n\n    <div class=\"uploadAttachmentContainer\"\n         ng-mouseenter=\"$ctrl.mouseEnter($event,$ctrl.fieldStructure)\"\n         ng-mouseleave=\"$ctrl.mouseLeave()\">\n\n        <!--Label-->\n        <ui-required-indicator-label\n                ng-if=\"!$ctrl.hideLabel\"\n                required-label-config=\"$ctrl.fieldStructure.requiredIndicatorLabelConfig\"\n                class=\"uploadAttachmentRequiredLabel\">\n        </ui-required-indicator-label>\n\n        <!--Input-->\n        <div class=\"componentUploadAttachmentContainer\"\n             ui-manual-size\n             width=\"$ctrl.getButtonWidth()\">\n\n            <div ng-if=\"!$ctrl.fieldStructure.dynamicProperties.hasValue\">\n                <input type=\"file\"\n                       class=\"hiddenFileInput\"\n                       name=\"' + scope.valueName + '_file\"\n                       ui-custom-on-change=\"$ctrl.fileSelected(file, event)\"\n                       accept=\"{{ $ctrl.fileInputAcceptTypes }}\"\n                       />\n\n                <input type=\"button\"\n                       value=\"{{$ctrl.label}}\"\n                       class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }} btn btn-sm\"\n                       ng-class=\"{'noLabelWidth' : $ctrl.fieldStructure.layout.labelWidth === 0}\"\n                       ng-model=\"$ctrl.fieldStructure.fieldModel.value\"\n                       ng-disabled=\"$ctrl.fieldStructure.dynamicProperties.disabled\"\n                       ui-remote-change-notification>\n            </div>\n            <div class=\"attachmentLinkContainer\" ng-if=\"$ctrl.fieldStructure.dynamicProperties.hasValue\">\n                <a class=\"attachmentLink\"\n                   ng-if=\"!$ctrl.isImage\"\n                   ng-click=\"attachmentDownloadClick($event)\" ng-attr-title = \"{{$ctrl.getLinkText()}}\">{{::$ctrl.getLinkText()}}</a>\n                <img ng-if=\"$ctrl.isImage && $ctrl.isImageUrlLoaded\"\n                     ng-src=\"{{$ctrl.imageUrl}}\"\n                     width=\"{{$ctrl.imageWidth}}\"\n                     height=\"{{$ctrl.imageHeight}}\">\n                <div class=\"deleteButton glyphicon glyphicon-remove\"\n                     ng-if=\"!$ctrl.fieldStructure.dynamicProperties.disabled\"\n                     ng-class=\"{nonImage: !$ctrl.isImage}\"\n                     ng-click=\"$ctrl.deleteAttachment()\"></div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<!-- Row Repeater Hidden Width Placeholder -->\n<div class=\"dynamicComponentContainer collapsedPlaceholder\"\n     ng-if=\"$ctrl.fieldStructure.isRowRepeaterField && $ctrl.hidden && !$ctrl.fieldStructure.isColumnCollapsed\">\n\n    <div ui-manual-size\n         width=\"$ctrl.layout.inputWidth\"></div>\n</div>\n\n<span class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n      ng-if=\"$ctrl.fieldStructure.dynamicProperties.hidden && !$ctrl.fieldStructure.isConfigurableComponent\"></span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

var UploadAttachmentComponent = {
  templateUrl: '/formViewer/component/uploadAttachment/uploadAttachment.tpl.html',
  controller: 'uploadAttachmentController',
  bindings: {
    fieldStructure: '<',
    timeLastModified: '<',
    hideLabel: '<'
  }
};
angular.module('umCore').component('uiUploadAttachment', UploadAttachmentComponent);

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UploadAttachmentController = function UploadAttachmentController($rootScope, $scope, $controller, $window, xmlUtil, attachmentMediator, uuidUtil, localization, modalUtil, attachmentUtil, coreConstant, loadingBarHandler, preferenceModel) {
  var _this4 = this;
  var translations;
  angular.extend(this, $controller('baseFormComponentController', {
    $scope: $scope
  }));
  localization.getTranslationByKey('uploadAttachment').then(function (result) {
    translations = result;
  });
  this.$onInit = function () {
    this.onInit();
    var uiField = this.fieldStructure.uiField,
      uiFieldOptions,
      imageProperty,
      splitParameters;
    this.attachmentType = xmlUtil.parseString(uiField.options).attachmentType;
    this.label = this.fieldStructure.uiField.displayLabel;
    this.fieldStructure.requiredIndicatorLabelConfig.label = null;
    this.parameters = xmlUtil.parseString(uiField.options).parameters;
    this.acceptedTypes = null;
    this.globalAcceptedTypes = preferenceModel.get('system.allowedFileTypes').split('::');
    this.fileInputAcceptTypes = '';
    this.buildImageProperty();
    if (this.parameters) {
      splitParameters = _.split(this.parameters, 'fileType=', 2);
      this.fileInputAcceptTypes = splitParameters[1];
      if (splitParameters.length > 1) {
        this.acceptedTypes = _.split(splitParameters[1], ',');
      }
    }
  };
  this.getButtonWidth = function () {
    var inputContainerWidth = 160;
    var isRowRepeater = this.fieldStructure.isRowRepeaterField;
    if (isRowRepeater && this.fieldStructure.layout.labelWidth === 0) {
      return inputContainerWidth;
    } else {
      return this.fieldStructure.layout.labelWidth;
    }
  };
  this.buildImageProperty = function () {
    var uiField = this.fieldStructure.uiField,
      uiFieldOptions = xmlUtil.parseString(uiField.options),
      imageProperty = uiFieldOptions.imageProperty;
    this.isImageUrlLoaded = false;
    this.isImage = imageProperty ? imageProperty.isImageDisplayChecked : false;
    if (this.isImage) {
      this.imageWidth = imageProperty ? parseInt(imageProperty.imageWidth) : 0;
      this.imageHeight = imageProperty ? parseInt(imageProperty.imageHeight) : 0;
      this.imageUrl = null;
      this.buildImageUrl();
    }
  };
  this.buildImageUrl = function () {
    var _this = this;
    attachmentUtil.getAttachmentLinkURL(this.getAttachmentId(), this.getAttachmentName()).then(function (url) {
      _this.imageUrl = url;
      _this.isImageUrlLoaded = true;
    });
  };
  this.$onChanges = function () {
    this.onChanges();
    this.fieldStructure.requiredIndicatorLabelConfig.label = null;
  };
  this.fileSelected = function (file, event) {
    var _this2 = this;
    var submissionId = this.fieldStructure.parentForm.submissionId,
      allowFile = attachmentUtil.validateAttachmentType(file, _.get(translations, 'unacceptableType'), this.acceptedTypes, this.globalAcceptedTypes),
      queryParameters;
    if (allowFile) {
      queryParameters = {
        'type': this.attachmentType,
        'description': '',
        'fileExpectedSize': file.size,
        'guid': uuidUtil.generateUUID(),
        'name': file.name,
        'formId': this.fieldStructure.parentForm.id,
        'fieldName': this.fieldStructure.indexedName
      };
      if (submissionId) {
        queryParameters.submissionId = submissionId;
      }
      loadingBarHandler.showLoadingBar('formsViewer.controls.uploadAttachment.loadingBar');
      attachmentMediator.saveAttachment(queryParameters, file).then(function (payload) {
        loadingBarHandler.hideLoadingBar();
        var attachmentId = payload.attachment.id;
        if (!_this2.fieldStructure.fieldModel) {
          _this2.fieldStructure.fieldModel = {};
        }
        _this2.fieldStructure.fieldModel.value = file.name + '|' + attachmentId;
        _this2.fieldStructure.hasLocalChanges = true;
        _this2.updateFieldValue();
        _this2.buildImageProperty();
      });
    } else {
      event.target.value = null;
    }
  };
  this.deleteAttachment = function () {
    var message = _.get(translations, 'deleteConfirmation.message'),
      title = _.get(translations, 'deleteConfirmation.title'),
      cancelButtonLabel = _.get(translations, 'deleteConfirmation.cancel'),
      confirmButtonLabel = _.get(translations, 'deleteConfirmation.confirm'),
      fieldInstance = this.fieldStructure.fieldModel,
      attachmentId = this.getAttachmentId();
    function handleClose() {
      var _this3 = this;
      attachmentMediator.deleteAttachment(attachmentId, fieldInstance.id).then(function () {
        _this3.isImageUrlLoaded = false;
      });
    }
    modalUtil.showGenericConfirm({
      cancelButtonLabel: cancelButtonLabel,
      confirmActionButtonLabel: confirmButtonLabel,
      summary: message,
      title: title
    }).then(handleClose);
  };
  this.getAttachmentId = function () {
    if (this.fieldStructure.fieldModel.value) {
      var fieldValue = this.fieldStructure.fieldModel.value;
      return fieldValue.substring(_.lastIndexOf(fieldValue, '|') + 1);
    }
  };
  this.getAttachmentName = function () {
    if (this.fieldStructure.fieldModel.value) {
      var fieldValue = this.fieldStructure.fieldModel.value;
      return fieldValue.substring(0, _.lastIndexOf(fieldValue, '|'));
    }
  };
  this.getLinkText = function () {
    if (this.fieldStructure.fieldModel.value) {
      return this.getAttachmentName();
    }
    return '';
  };
  $scope.attachmentDownloadClick = function ($event) {
    $event.stopPropagation();
    attachmentUtil.getAttachmentLinkURL(_this4.getAttachmentId(), _this4.getAttachmentName()).then(function (url) {
      $window.open(url, '_blank');
    });
  };
};
UploadAttachmentController.$inject = ["$rootScope", "$scope", "$controller", "$window", "xmlUtil", "attachmentMediator", "uuidUtil", "localization", "modalUtil", "attachmentUtil", "coreConstant", "loadingBarHandler", "preferenceModel"];
angular.module('umFormViewer').controller('uploadAttachmentController', UploadAttachmentController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

var path = '/formViewer/component/uploadAttachment/uploadAttachmentPlaceholder.tpl.html';
var html = "<ui-upload-attachment class=\"fieldListComponent\"\n                      field-structure=\"fieldStructure\"\n                      time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n                      hide-label=\"::hideLabel\"\n                      collapsible=\"::$ctrl.collapsible\"\n                      ui-show-field-details-modal></ui-upload-attachment>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

var path = '/formViewer/component/urlLink/urlLink.tpl.html';
var html = "<div class=\"formComponentContainer {{ ::$ctrl.configurationClass }}\"\n     ng-class=\"{ showAsHidden: $ctrl.fieldStructure.dynamicProperties.hidden }\"\n     ng-if=\"!$ctrl.fieldStructure.dynamicProperties.hidden || $ctrl.fieldStructure.isConfigurableComponent\">\n\n    <div class=\"componentInputContainer\"\n         ui-manual-size\n         width=\"::$ctrl.fieldStructure.layout.labelWidth\">\n\n        <button type=\"button\"\n                ng-click=\"openLink()\"\n                ng-mouseenter=\"$ctrl.mouseEnter($event,$ctrl.fieldStructure)\"\n                ng-mouseleave=\"$ctrl.mouseLeave()\"\n                class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }} btn btn-link btn-default\">\n            {{$ctrl.getLabelText()}}\n        </button>\n    </div>\n</div>\n\n\n<span class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n      ng-if=\"$ctrl.fieldStructure.dynamicProperties.hidden && !$ctrl.fieldStructure.isConfigurableComponent\"></span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

var UrlLinkComponent = {
  templateUrl: '/formViewer/component/urlLink/urlLink.tpl.html',
  controller: 'urlLinkController',
  bindings: {
    fieldStructure: '<'
  }
};
angular.module('umFormViewer').component('uiUrlLink', UrlLinkComponent);

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var urlLinkController = function urlLinkController($scope, $window, $controller, coreMediator, xmlUtil) {
  angular.extend(this, $controller('baseFormComponentController', {
    $scope: $scope
  }));
  this.$onInit = function () {
    $scope.openLink = function () {
      var fieldStructure = this.$parent.$ctrl.fieldStructure,
        fieldModel = fieldStructure.fieldModel,
        submissionId,
        formId,
        formName,
        variableName,
        link,
        uiFieldOptions;
      if (fieldModel) {
        uiFieldOptions = xmlUtil.parseString(fieldStructure.uiField.options);
        if (uiFieldOptions.logAccess) {
          coreMediator.getSingleUseToken().then(function (token) {
            submissionId = fieldStructure.parentForm.submissionId;
            formId = fieldStructure.parentForm.id;
            formName = fieldStructure.parentForm.name;
            variableName = fieldModel.name;
            link = "/mvc/link?l=".concat(fieldModel.value, "&s=").concat(submissionId, "&f=").concat(formId, "&n=").concat(encodeURIComponent(formName), "&v=").concat(variableName, "&t=").concat(encodeURIComponent(token));
            $window.open(link, '_blank');
          });
        } else {
          $window.open(fieldModel.value, '_blank');
        }
      }
    };
  };
  this.getLabelText = function () {
    var valueLabel = this.fieldStructure.fieldModel ? this.fieldStructure.fieldModel.valueLabel : null;
    if (!_.isNil(valueLabel)) {
      return valueLabel;
    }
    return this.fieldStructure.uiField.displayLabel;
  };
};
urlLinkController.$inject = ["$scope", "$window", "$controller", "coreMediator", "xmlUtil"];
angular.module('umFormViewer').controller('urlLinkController', urlLinkController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

var path = '/formViewer/component/urlLink/urlLinkPlaceholder.tpl.html';
var html = "<ui-url-link class=\"fieldListComponent\"\n             field-structure=\"fieldStructure\"\n             collapsible=\"::$ctrl.collapsible\"\n             ui-show-field-details-modal></ui-url-link>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

var path = '/formViewer/component/yesNoRadio/yesNoRadio.tpl.html';
var html = "<div class=\"formComponentContainer  {{ ::$ctrl.configurationClass }}\"\n    ng-class=\"{\n        labelLeft: $ctrl.fieldStructure.layout.isLabelLeftAligned, 'textareaIsVisible':$ctrl.showTextArea(),\n        labelTop: !$ctrl.fieldStructure.layout.isLabelLeftAligned,\n        showAsHidden: $ctrl.fieldStructure.dynamicProperties.hidden\n     }\"\n     ng-if=\"!$ctrl.fieldStructure.dynamicProperties.hidden || $ctrl.fieldStructure.isConfigurableComponent\"\n     ui-snippets-indicator\n     ui-snippets-indicator-container=\"self\"\n     ui-snippets-indicator-name=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n     ui-manual-size\n     width=\"$ctrl.getComponentContainerWidth()\">\n\n    <div class=\"mouseInputContainer\"\n         ng-mouseenter=\"$ctrl.mouseEnter($event,$ctrl.fieldStructure)\"\n         ng-mouseleave=\"$ctrl.mouseLeave()\">\n\n        <!--Label-->\n        <ui-required-indicator-label\n            ng-if=\"!$ctrl.hideLabel\"\n            required-label-config=\"$ctrl.fieldStructure.requiredIndicatorLabelConfig\">\n        </ui-required-indicator-label>\n    </div>\n\n    <div class=\"inputListContainer\">\n\n        <!--Yes Radio-->\n        <div class=\"componentInputContainer yes\"\n             ng-class=\"{ disabled: $ctrl.fieldStructure.dynamicProperties.disabled }\"\n             ng-mouseenter=\"$ctrl.mouseEnter($event,$ctrl.fieldStructure)\"\n             ng-mouseleave=\"$ctrl.mouseLeave()\"\n             ng-click=\"$ctrl.handleLabelClick($event, 'yes')\">\n\n            <input type=\"radio\"\n                   name=\"{{ ::$ctrl.fieldStructure.uiField.fieldTemplate.formTemplateId}} {{ ::$ctrl.getComponentId($ctrl.fieldStructure.uiField)}} {{ ::$ctrl.fieldStructure.rowNumber }} yes\"\n                   value=\"yes\"\n                   class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }} yes\"\n                   ng-class=\"{ error: !$ctrl.fieldStructure.dynamicProperties.isValid }\"\n                   ng-model=\"$ctrl.radioValue\"\n                   ng-disabled=\"$ctrl.fieldStructure.dynamicProperties.disabled\"\n                   ng-change=\"$ctrl.handleClick()\"\n                   ui-remote-change-notification\n                   ng-focus=\"$ctrl.handleFocus()\"/>\n\n            <span ui-translate>formsViewer.yesNoRadio.yes</span>\n        </div>\n\n        <!--No Radio-->\n        <div class=\"componentInputContainer no\"\n             ng-class=\"{ disabled: $ctrl.fieldStructure.dynamicProperties.disabled }\"\n             ng-mouseenter=\"$ctrl.mouseEnter($event,$ctrl.fieldStructure)\"\n             ng-mouseleave=\"$ctrl.mouseLeave()\"\n             ng-click=\"$ctrl.handleLabelClick($event, 'no')\">\n\n            <input type=\"radio\"\n                   name=\"{{ ::$ctrl.fieldStructure.uiField.fieldTemplate.formTemplateId}} {{ ::$ctrl.getComponentId($ctrl.fieldStructure.uiField)}} {{ ::$ctrl.fieldStructure.rowNumber }} no\"\n                   value=\"no\"\n                   class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }} no\"\n                   ng-class=\"{ error: !$ctrl.fieldStructure.dynamicProperties.isValid }\"\n                   ng-model=\"$ctrl.radioValue\"\n                   ng-disabled=\"$ctrl.fieldStructure.dynamicProperties.disabled\"\n                   ng-change=\"$ctrl.handleClick()\"\n                   ui-remote-change-notification\n                   ng-focus=\"$ctrl.handleFocus()\"/>\n\n            <span ui-translate>formsViewer.yesNoRadio.no</span>\n\n        </div>\n\n    </div>\n</div>\n\n<div class=\"formComponentContainer\"\n     ng-if=\"$ctrl.showTextArea()\">\n    <!--TextArea-->\n    <div class=\"componentTextAreaContainer\">\n\n        <label ng-if=\"($ctrl.radioValue === 'yes' && $ctrl.showYesText)\">\n            {{ $ctrl.yesPrompt }}\n        </label>\n\n        <label ng-if=\"($ctrl.radioValue === 'no' && $ctrl.showNoText)\">\n            {{ $ctrl.noPrompt }}\n        </label>\n\n        <textarea class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n                  ng-model=\"$ctrl.explainValue\"\n                  ng-disabled=\"$ctrl.fieldStructure.dynamicProperties.disabled\"\n                  ng-change=\"$ctrl.handleChange()\"\n                  ng-blur=\"$ctrl.updateFieldValue()\"\n                  ui-remote-change-notification\n                  ng-focus=\"$ctrl.handleFocus()\"\n                  ng-mouseenter=\"$ctrl.mouseEnter($event,$ctrl.fieldStructure)\"\n                  ng-mouseleave=\"$ctrl.mouseLeave()\">\n        </textarea>\n    </div>\n</div>\n\n<span class=\"{{ ::$ctrl.getComponentClassName($ctrl.fieldStructure.uiField) }}\"\n      ng-if=\"$ctrl.fieldStructure.dynamicProperties.hidden && !$ctrl.fieldStructure.isConfigurableComponent\"></span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

var YesNoRadioComponent = {
  templateUrl: '/formViewer/component/yesNoRadio/yesNoRadio.tpl.html',
  controller: 'yesNoRadioController',
  bindings: {
    fieldStructure: '<',
    timeLastModified: '<',
    hideLabel: '<'
  }
};
angular.module('umFormViewer').component('uiYesNoRadio', YesNoRadioComponent);

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var YesNoRadioController = function YesNoRadioController($scope, $controller, formViewerConstant, formComponentUtil, formMediator, localization, xmlUtil) {
  var _this = this;
  this.radioValue = '';
  this.explainValue = '';
  this.showYesText = false;
  this.showNoText = false;
  this.yesPrompt = '';
  this.noPrompt = '';
  angular.extend(this, $controller('baseFormComponentController', {
    $scope: $scope
  }));
  localization.getTranslations().then(function (translations) {
    _this.translations = translations.formsViewer.yesNoRadio;
  });
  this.$onInit = function () {
    this.onInit();
    var uiField = this.fieldStructure.uiField,
      options = uiField.options ? xmlUtil.parseString(uiField.options) : null;
    this.showYesText = options ? options.showYesText : false;
    this.showNoText = options ? options.showNoText : false;
    this.yesPrompt = options ? options.yesText : this.translations.pleaseExplain;
    this.noPrompt = options ? options.noText : this.translations.pleaseExplain;
    this.yesLabel = options ? options.yesText : this.translations.yes;
    this.noLabel = options ? options.noText : this.translations.no;
    this.radioValue = this.splitFieldValue(0);
    if (this.radioValue === 'true') {
      this.radioValue = 'yes';
    } else if (this.radioValue === 'false') {
      this.radioValue = 'no';
    }
    this.buildToolTipMessage();
    this.explainValue = this.splitFieldValue(1);
    this.yesName = _.join([this.fieldStructure.uiField.fieldTemplate.formTemplateId, this.getComponentId(this.fieldStructure.uiField), this.fieldStructure.rowNumber, 'yes'], ' ');
    this.noName = _.join([this.fieldStructure.uiField.fieldTemplate.formTemplateId, this.getComponentId(this.fieldStructure.uiField), this.fieldStructure.rowNumber, 'no'], ' ');
  };
  this.$onChanges = function () {
    this.onChanges();
    this.radioValue = this.splitFieldValue(0);
    if (this.radioValue === 'true') {
      this.radioValue = 'yes';
    } else if (this.radioValue === 'false') {
      this.radioValue = 'no';
    }
    this.explainValue = this.splitFieldValue(1);
    this.buildToolTipMessage();
  };
  this.getComponentContainerWidth = function () {
    var isRowRepeater = this.fieldStructure.isRowRepeaterField,
      rowRepeaterColumnHeaderExtraWidth = 15,
      isLabelTopAligned = !this.fieldStructure.layout.isLabelLeftAligned,
      inputContainerWidth = 150,
      topAlignmentExtraWidth = 0,
      extraWidth = isLabelTopAligned ? topAlignmentExtraWidth : inputContainerWidth,
      labelWidth = this.getLabelWidth(),
      result;
    if (!isRowRepeater && this.fieldStructure.requiredIndicatorLabelConfig.width === 0) {
      return labelWidth;
    }
    if (isRowRepeater) {
      result = labelWidth > inputContainerWidth ? labelWidth : inputContainerWidth;
      result += rowRepeaterColumnHeaderExtraWidth;
    } else if (isLabelTopAligned) {
      result = labelWidth > inputContainerWidth ? labelWidth : inputContainerWidth;
    } else {
      result = labelWidth + extraWidth;
    }
    return result;
  };
  this.getLabelWidth = function () {
    var isRowRepeater = this.fieldStructure.isRowRepeaterField,
      defaultLabelWidth = 150;
    if (!isRowRepeater && this.fieldStructure.requiredIndicatorLabelConfig.width === 0) {
      return '100%';
    } else {
      return this.fieldStructure.requiredIndicatorLabelConfig.width;
    }
  };
  this.showTextArea = function () {
    return this.radioValue === 'yes' && this.showYesText || this.radioValue === 'no' && this.showNoText;
  };
  this.splitFieldValue = function (index) {
    if (!this.fieldStructure.fieldModel) {
      return '';
    }
    var radioValueArray = _.split(this.fieldStructure.fieldModel.value, '::');
    return radioValueArray[index] || '';
  };
  this.concatFieldValue = function () {
    if (this.explainValue !== '') {
      return this.radioValue + '::' + this.explainValue;
    } else {
      this.explainValue = '';
      return this.radioValue;
    }
  };
  this.handleLabelClick = function (event, radioValue) {
    if (this.fieldStructure.dynamicProperties.disabled) {
      return;
    }
    if (event.ctrlKey) {
      this.radioValue = null;
    } else {
      this.radioValue = radioValue;
    }
    this.handleClick();
  };
  this.handleClick = function () {
    this.explainValue = '';
    this.handleChange();
    this.handleBlur();
  };
  this.onClick = function (event) {
    if (this.fieldStructure.dynamicProperties.disabled) {
      return;
    }
    if (event && event.ctrlKey) {
      this.radioValue = null;
      this.handleClick();
    }
  };
  this.handleChange = function () {
    this.fieldStructure.hasLocalChanges = true;
    if (this.fieldStructure.fieldModel) {
      this.fieldStructure.fieldModel.value = this.concatFieldValue();
    } else {
      this.fieldStructure.fieldModel = {
        value: this.concatFieldValue()
      };
    }
  };
  this.handleBlur = function () {
    if (this.fieldStructure.hasLocalChanges) {
      formMediator.handleFieldChange(this.fieldStructure.parentForm.id, this.fieldStructure, this.resetFieldValue.bind(this), this.updateOriginalFieldValue.bind(this));
    }
  };
  this.buildToolTipMessage = function () {
    var prompt;
    if (this.radioValue === 'yes' && this.yesPrompt) {
      prompt = this.yesPrompt;
    } else if (this.radioValue === 'no' && this.noPrompt) {
      prompt = this.noPrompt;
    }
    if (prompt) {
      this.fieldStructure.dynamicProperties.tooltip.message = _.replace(this.fieldStructure.dynamicProperties.tooltip.message, '{0}', _.replace(prompt, /:$/, ''));
    }
  };
};
YesNoRadioController.$inject = ["$scope", "$controller", "formViewerConstant", "formComponentUtil", "formMediator", "localization", "xmlUtil"];
angular.module('umFormViewer').controller('yesNoRadioController', YesNoRadioController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

var path = '/formViewer/component/yesNoRadio/yesNoRadioPlaceholder.tpl.html';
var html = "<ui-yes-no-radio class=\"fieldListComponent yesNoRadioComponent\"\n                 field-structure=\"fieldStructure\"\n                 time-last-modified=\"fieldStructure.fieldModel.timeLastModified\"\n                 hide-label=\"::hideLabel\"\n                 collapsible=\"::$ctrl.collapsible\"\n                 ui-show-field-details-modal></ui-yes-no-radio>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1213 */
/***/ (function(module) {

module.exports = JSON.parse("{\"componentEditor\":{\"deleteComponentConfirmation\":{\"title\":\"Delete Component\",\"summary\":\"Are you sure that you want to permanently delete this component?\"}}}");

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

var path = '/formViewer/editor/componentEditor.tpl.html';
var html = "\n<div class=\"selectionContainer\"\n     ng-class=\"{\n        selected: $ctrl.componentStructure.selected,\n        showAsHidden: $ctrl.componentStructure.dynamicProperties.hidden\n     }\">\n\n    <button class=\"btn btn-xs btn-default deleteComponentButton\"\n            ng-if=\"$ctrl.componentStructure.selected && $ctrl.canDeleteComponent\"\n            ng-click=\"$ctrl.onDeleteComponentStructure()\">\n\n        <span class=\"glyphicon glyphicon-trash\"></span>\n    </button>\n\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

var ComponentEditorComponent = {
  templateUrl: '/formViewer/editor/componentEditor.tpl.html',
  controller: 'componentEditorController',
  bindings: {
    componentStructure: '<',
    rootFormId: '<'
  }
};
angular.module('umFormViewer').component('uiComponentEditor', ComponentEditorComponent);

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ComponentEditorController = function ComponentEditorController($rootScope, $scope, $element, formViewerConstant, configurationConstant, formMediator, formTemplateStatus, modalUtil, localization, authorizationConstants, currentUserModel, componentModel) {
  $element.addClass('componentEditor');
  this.translations = {};
  this.canDeleteComponent = false;
  this.$onInit = function () {
    var userCanManageForms = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS);
    localization.getTranslations().then(function (translations) {
      this.translations = translations;
    }.bind(this));

    // this "if" check should be removed once we refactor row repeaters to be configurable
    if (this.componentStructure.parentUiFormTemplate) {
      this.canDeleteComponent = this.componentStructure.parentUiFormTemplate.formTemplate.id !== this.componentStructure.uiField.fieldTemplate.formTemplateId || userCanManageForms && this.componentStructure.parentUiFormTemplate.formTemplate.status !== formTemplateStatus.IN_PRODUCTION;
    }
    if (!_.isNil(this.componentStructure)) {
      this.componentStructure.selected = componentModel.getSelectedComponentId() === this.componentStructure.originalVariableName;
    }
    if (this.componentStructure.selected) {
      $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, this.componentStructure);
    }
  };
  this.onDeleteComponentStructure = function () {
    var message = _.get(this.translations, 'componentEditor.deleteComponentConfirmation.summary'),
      title = _.get(this.translations, 'componentEditor.deleteComponentConfirmation.title'),
      cancelButtonLabel = _.get(this.translations, 'genericButtons.cancel'),
      confirmButtonLabel = _.get(this.translations, 'genericButtons.continue');
    function handleClose() {
      formMediator.deleteField(this.rootFormId, this.componentStructure.fieldStructureId);
      $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, null);
    }
    modalUtil.showGenericConfirm({
      cancelButtonLabel: cancelButtonLabel,
      confirmActionButtonLabel: confirmButtonLabel,
      summary: message,
      title: title
    }).then(handleClose.bind(this));
  };
  $scope.$on(configurationConstant.event.OPTION_GROUP_INPUT_VALUE_CHANGED, function (event, object) {
    if (object.name === 'variableName') {
      componentModel.setSelectedComponentId(object.value);
    }
  }.bind(this));
  $scope.$on(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, function (event, componentStructure) {
    if (!_.isNil(componentStructure)) {
      this.componentStructure.selected = componentStructure.originalVariableName === this.componentStructure.originalVariableName;
      componentModel.setSelectedComponentId(componentStructure.uiField.fieldTemplate.variableName);
    } else {
      this.componentStructure.selected = false;
    }
  }.bind(this));
  $scope.$on(formViewerConstant.configuration.event.ROW_SELECTION_CHANGE, function () {
    this.componentStructure.selected = false;
  }.bind(this));
  $scope.$on(formViewerConstant.configuration.event.SECTION_SELECTION_CHANGE, function () {
    this.componentStructure.selected = false;
  }.bind(this));
  $scope.$on(formViewerConstant.configuration.event.ROW_SELECTION_CHANGE, function () {
    this.componentStructure.selected = false;
  }.bind(this));
};
ComponentEditorController.$inject = ["$rootScope", "$scope", "$element", "formViewerConstant", "configurationConstant", "formMediator", "formTemplateStatus", "modalUtil", "localization", "authorizationConstants", "currentUserModel", "componentModel"];
angular.module('umFormViewer').controller('componentEditorController', ComponentEditorController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

var path = '/formViewer/editor/componentEditorPlaceholder.tpl.html';
var html = "<ui-component-editor class=\"componentEditor {{ ::componentStructure.fieldStructureId }}\"\n                     component-structure=\"componentStructure\"\n                     root-form-id=\"formId\"\n                     ui-drag-manager\n</ui-component-editor>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

/*@ngInject*/
var ComponentModel = function ComponentModel() {
  var selectedComponentId;
  this.getSelectedComponentId = function () {
    return selectedComponentId;
  };
  this.setSelectedComponentId = function (id) {
    selectedComponentId = id;
  };
};
angular.module('umFormViewer').service('componentModel', ComponentModel);

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

/*@ngInject*/
var DragModel = function DragModel() {
  var currentDragConfig;
  this.getCurrentDragItem = function () {
    return currentDragConfig;
  };
  this.setCurrentDragItem = function (newDragCongig) {
    currentDragConfig = newDragCongig;
  };
};
angular.module('umFormViewer').service('dragModel', DragModel);

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var GetUiFieldListRepository = function GetUiFieldListRepository($q, $timeout, baseRepository, formViewerConstant, baseCachedRepository) {
  angular.extend(this, baseRepository, baseCachedRepository);
  this.getCacheName = function () {
    return 'CachedUiFieldRepository';
  };
  this.getCacheCapacity = function () {
    return 50;
  };
  this.getUiFieldList = function (formTemplateType) {
    var url = '/rest/UIFormTemplate/fieldTypes',
      cacheKey = 'cachedUiFields-' + formTemplateType,
      config = {
        params: {
          formTemplateType: formTemplateType
        }
      };
    return this.get(cacheKey, url, config);
  };
  this.getUiFormStructureList = function () {
    var defer = $q.defer(),
      sectionTpl = {
        label: 'Section Label',
        rows: [],
        repeatable: false
      },
      rowTpl = {
        fields: [],
        repeatable: false,
        rowRepeatable: false,
        staticLayout: false,
        repeaterField: null
      },
      rowRepeaterTpl = _.merge(_.clone(rowTpl), {
        repeatable: true,
        rowRepeatable: true
      }),
      result = {};
    result[formViewerConstant.configuration.formStructureType.ROW] = rowTpl;
    result[formViewerConstant.configuration.formStructureType.ROW_REPEATER] = rowRepeaterTpl;
    result[formViewerConstant.configuration.formStructureType.SECTION] = sectionTpl;
    $timeout(function () {
      defer.resolve(result);
    }, 200);
    return defer.promise;
  };
};
GetUiFieldListRepository.$inject = ["$q", "$timeout", "baseRepository", "formViewerConstant", "baseCachedRepository"];
angular.module('umFormViewer').service('getUiFieldListRepository', GetUiFieldListRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var UIColumnResizeDirective = function UIColumnResizeDirective($rootScope, $document, formViewerConstant) {
  var linkFunction = function linkFunction($scope, $elm, $attr) {
    var element = $($elm),
      uiColumnResizeIdentifier = $attr.uiColumnResizeIdentifier,
      columnElement = element.parent(),
      resizeActive = false,
      startWidth,
      startClientX;
    function initColumnResize(event) {
      startWidth = columnElement.width();
      startClientX = event.clientX;
      resizeActive = true;
      event.preventDefault();
    }
    function resizeColumn(event) {
      if (resizeActive) {
        var offsetX = event.clientX - startClientX,
          newWidth = startWidth + offsetX;
        columnElement.width(startWidth + offsetX);
        $rootScope.$broadcast(formViewerConstant.event.formBuilder.COLUMN_RESIZING);
      }
    }
    function stopColumnResize(event) {
      var offsetX = event.clientX - startClientX,
        newWidth = startWidth + offsetX;
      if (resizeActive) {
        $rootScope.$broadcast(formViewerConstant.event.formBuilder.COLUMN_RESIZED, uiColumnResizeIdentifier, newWidth);
        resizeActive = false;
      }
    }
    $document.on('mousemove.uiColumnResize', resizeColumn);
    $document.on('mouseup.uiColumnResize', stopColumnResize);
    element.on('mousedown', initColumnResize);
    $scope.$on('$destroy', function () {
      element.off('mousedown', initColumnResize);
      $document.off('mousemove.uiColumnResize', resizeColumn);
      $document.off('mouseup.uiColumnResize', stopColumnResize);
    });
  };
  return {
    link: linkFunction,
    restrict: 'A'
  };
};
UIColumnResizeDirective.$inject = ["$rootScope", "$document", "formViewerConstant"];
angular.module('umFormViewer').directive('uiColumnResize', UIColumnResizeDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UIDraggableColumnDirective = function UIDraggableColumnDirective($rootScope, formMediator, formViewerConstant) {
  var linkFunction = function linkFunction($scope, $elm, $attr) {
    var element = $($elm),
      uiDraggableColumnIdentifier = $attr.uiDraggableColumnIdentifier,
      isDraggable = $attr.uiDraggableColumnIsDraggable === 'true',
      areColumnsBeingResized = false,
      isLeftDropAttempt,
      isRightDropAttempt;
    if (isDraggable) {
      element.attr('draggable', 'true');
    }
    function onMouseEnter(event) {
      if (!areColumnsBeingResized) {
        element.addClass('selectable');
      }
    }
    function onMouseLeave(event) {
      if (!areColumnsBeingResized) {
        element.removeClass('selectable');
      }
    }
    function onDragStart(event) {
      var dataTransfer = event.originalEvent.dataTransfer,
        isDraggingColumn = event.target.className.indexOf('draggableColumn') !== -1,
        dragConfiguration = {
          columnIdentifier: uiDraggableColumnIdentifier,
          isDraggingColumn: true
        };
      if (isDraggingColumn) {
        element.addClass('dragging');
        dataTransfer.effectAllowed = 'move';
        event.originalEvent.dataTransfer.setData('text', JSON.stringify(dragConfiguration));
        formMediator.setCurrentDragItem(dragConfiguration);
      }
    }
    function onDragOver(event) {
      var dataTransfer = event.originalEvent.dataTransfer,
        currentDropTarget = $(event.currentTarget),
        isElementBeingDragged = currentDropTarget.hasClass('dragging'),
        previousChild = element.prev(),
        currentDragConfig = formMediator.getCurrentDragItem(),
        isDraggingColumn = !_.isNil(currentDragConfig) && !!currentDragConfig.isDraggingColumn,
        offsetX,
        width,
        horizontalMiddle;
      if (!isElementBeingDragged && isDraggingColumn) {
        offsetX = event.clientX - currentDropTarget.offset().left;
        width = currentDropTarget.width();
        horizontalMiddle = width / 2;
        isLeftDropAttempt = offsetX <= horizontalMiddle;
        isRightDropAttempt = offsetX > horizontalMiddle;
        previousChild.removeClass('dragOverRight');
        element.removeClass('dragOverRight');
        if (isLeftDropAttempt) {
          previousChild.addClass('dragOverRight');
        } else if (isRightDropAttempt) {
          element.addClass('dragOverRight');
        }
        dataTransfer.dropEffect = 'move';
        event.preventDefault();
      }
    }
    function onDragLeave() {
      var previousChild = element.prev();
      previousChild.removeClass('dragOverRight');
      element.removeClass('dragOverRight');
    }
    function onDrop(event) {
      var dataTransfer = event.originalEvent.dataTransfer,
        dropConfiguration = JSON.parse(dataTransfer.getData('text')),
        isDraggingColumn = !!dropConfiguration.isDraggingColumn,
        dropZone = $(event.currentTarget),
        dropZonePreviousChild = dropZone.prev(),
        offsetX,
        width,
        horizontalMiddle;
      if (isDraggingColumn) {
        offsetX = event.offsetX;
        width = dropZone.width();
        horizontalMiddle = width / 2;
        isLeftDropAttempt = offsetX < horizontalMiddle;
        if (dropConfiguration.columnIdentifier !== uiDraggableColumnIdentifier) {
          $rootScope.$broadcast(formViewerConstant.event.formBuilder.REARRANGE_COLUMN, dropConfiguration.columnIdentifier, uiDraggableColumnIdentifier, isLeftDropAttempt);
        }
        dropZonePreviousChild.removeClass('dragOverRight');
        dropZone.removeClass('dragOverRight');
        event.preventDefault();
        return false;
      }
    }
    function onDragEnd() {
      var previousChild = element.prev();
      element.removeClass('dragging');
      previousChild.removeClass('dragOverRight');
      element.removeClass('dragOverRight');
    }
    element.on('mouseenter', onMouseEnter);
    element.on('mouseleave', onMouseLeave);
    if (isDraggable) {
      element.on('dragstart', onDragStart);
      element.on('dragover', onDragOver);
      element.on('dragleave', onDragLeave);
      element.on('drop', onDrop);
      element.on('dragend', onDragEnd);
    }
    $scope.$on(formViewerConstant.event.formBuilder.DISABLE_DRAGGABLE_ELEMENTS, function () {
      if (isDraggable) {
        element.attr('draggable', 'false');
      }
    });
    $scope.$on(formViewerConstant.event.formBuilder.ENABLE_DRAGGABLE_ELEMENTS, function () {
      if (isDraggable) {
        element.attr('draggable', 'true');
      }
    });
    $scope.$on(formViewerConstant.event.formBuilder.COLUMN_RESIZING, function () {
      areColumnsBeingResized = true;
      element.removeClass('selectable');
    });
    $scope.$on(formViewerConstant.event.formBuilder.COLUMN_RESIZED, function () {
      areColumnsBeingResized = false;
    });
    $scope.$on('$destroy', function () {
      element.off('mouseenter', onMouseEnter);
      element.off('mouseleave', onMouseLeave);
      element.off('dragstart', onDragStart);
      element.off('dragover', onDragOver);
      element.off('dragleave', onDragLeave);
      element.off('drop', onDrop);
      element.off('dragend', onDragEnd);
    });
  };
  return {
    link: linkFunction,
    restrict: 'A'
  };
};
UIDraggableColumnDirective.$inject = ["$rootScope", "formMediator", "formViewerConstant"];
angular.module('umFormViewer').directive('uiDraggableColumn', UIDraggableColumnDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UIDragManagerDirective = function UIDragManagerDirective($document, $rootScope, $timeout, formMediator, formViewerConstant) {
  var linkFunction = function linkFunction($scope, $elm, $attr) {
    var element = $($elm),
      selectionContainer = element.find('.selectionContainer'),
      rootFormId = $scope.componentStructure.rootFormId,
      isDraggable = $scope.componentStructure.parentForm.hasWriteAccess,
      parentFormName = $scope.componentStructure.parentFormStructure.formName,
      fieldStructureId = $scope.componentStructure.fieldStructureId,
      parentRowSelector = getParentRowSelectorFromFieldStructureId(fieldStructureId),
      isTopDropAttempt,
      isBottomDropAttempt,
      isLeftDropAttempt,
      isRightDropAttempt,
      isDraggingOverDropZone = false;
    if (isDraggable) {
      element.attr('draggable', 'true');
    }
    function getParentRowSelectorFromFieldStructureId(fieldStructureId) {
      return '.' + parentFormName + ' .rowEditor:has(.' + fieldStructureId + ')';
    }
    function selectThisField() {
      $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, $scope.componentStructure);
      $timeout(function () {}, 0);
    }
    function onMouseEnter() {
      selectionContainer.addClass('selectable');
      enableDebuggerTools();
    }
    function onMouseLeave() {
      selectionContainer.removeClass('selectable');
      isTopDropAttempt = false;
      isBottomDropAttempt = false;
      isLeftDropAttempt = false;
      isRightDropAttempt = false;
      onDragLeave();
      var debuggerInfo = {
        parentFormName: parentFormName,
        indexedName: $scope.componentStructure.indexedName,
        fieldStructureId: fieldStructureId,
        parentRowSelector: parentRowSelector
      };
      $rootScope.$broadcast(formViewerConstant.configuration.event.DRAG_FORM_ELEMENT_END, debuggerInfo);
      disableDebuggerTools();
      $timeout(function () {}, 0);
    }
    function onMouseMove(event) {
      var position, xVal, yVal, parentRow, height, width, horizontalMiddle;
      isTopDropAttempt = false;
      isBottomDropAttempt = false;
      isLeftDropAttempt = false;
      isRightDropAttempt = false;
      if (isDraggingOverDropZone) {
        parentRow = $(parentRowSelector);
        position = element.offset();
        xVal = event.clientX - position.left;
        yVal = event.clientY - position.top;
        height = element.height();
        width = element.width();
        horizontalMiddle = width / 2;
        isTopDropAttempt = yVal < 8;
        isBottomDropAttempt = yVal > height - 8;
        isLeftDropAttempt = xVal < horizontalMiddle;
        isRightDropAttempt = xVal > horizontalMiddle;
        parentRow.removeClass('dragOverTop');
        parentRow.removeClass('dragOverBottom');
        element.removeClass('dragOverLeft');
        element.removeClass('dragOverRight');
        if (isTopDropAttempt) {
          parentRow.addClass('dragOverTop');
        } else if (isBottomDropAttempt) {
          parentRow.addClass('dragOverBottom');
        } else if (isLeftDropAttempt) {
          element.addClass('dragOverLeft');
        } else if (isRightDropAttempt) {
          element.addClass('dragOverRight');
        }
        var debuggerInfo = {
          parentFormName: parentFormName,
          indexedName: $scope.componentStructure.indexedName,
          fieldStructureId: fieldStructureId,
          parentRowSelector: parentRowSelector,
          xValue: xVal,
          yValue: yVal,
          isTopDropAttempt: isTopDropAttempt,
          isBottomDropAttempt: isBottomDropAttempt,
          isLeftDropAttempt: isLeftDropAttempt,
          isRightDropAttempt: isRightDropAttempt
        };
        $rootScope.$broadcast(formViewerConstant.configuration.event.DRAG_FORM_ELEMENT, debuggerInfo);
        $timeout(function () {}, 0);
      }
    }
    function onMouseUp() {
      selectThisField();
    }
    function onDragStart(event) {
      var dataTransfer = event.originalEvent.dataTransfer,
        isDraggingComponent = event.target.className.indexOf('componentEditor') !== -1,
        dragConfiguration = {
          formStructureType: formViewerConstant.configuration.formStructureType.COMPONENT,
          dragType: formViewerConstant.configuration.dragOperationType.MOVE,
          fieldStructureId: $scope.componentStructure.fieldStructureId
        };
      selectThisField();
      if (isDraggingComponent) {
        element.addClass('dragging');
        dataTransfer.effectAllowed = 'move';
        event.originalEvent.dataTransfer.setData('text', JSON.stringify(dragConfiguration));
        formMediator.setCurrentDragItem(dragConfiguration);
      }
    }
    function onDragOver(event) {
      var dataTransfer = event.originalEvent.dataTransfer,
        currentDropTarget = $(event.currentTarget),
        isElementBeingDragged = currentDropTarget.hasClass('dragging'),
        currentDragConfig = formMediator.getCurrentDragItem(),
        isDraggingComponent = !_.isNil(currentDragConfig) && currentDragConfig.formStructureType === formViewerConstant.configuration.formStructureType.COMPONENT;
      if (!isElementBeingDragged && isDraggingComponent) {
        isDraggingOverDropZone = true;
        dataTransfer.dropEffect = 'move';
        onMouseMove(event);
        event.preventDefault();
      }
    }
    function onDragLeave() {
      var parentRow = $(parentRowSelector);
      isDraggingOverDropZone = false;
      element.removeClass('dragOverLeft');
      element.removeClass('dragOverRight');
      parentRow.removeClass('dragOverTop');
      parentRow.removeClass('dragOverBottom');
    }
    function onDrop(event) {
      var dataTransfer = event.originalEvent.dataTransfer,
        dropConfiguration = JSON.parse(dataTransfer.getData('text')),
        isInsertDropOperation = dropConfiguration.dragType === formViewerConstant.configuration.dragOperationType.INSERT,
        isMoveDropOperation = dropConfiguration.dragType === formViewerConstant.configuration.dragOperationType.MOVE,
        currentDragConfig = formMediator.getCurrentDragItem(),
        isDraggingComponent = currentDragConfig.formStructureType === formViewerConstant.configuration.formStructureType.COMPONENT;
      if (isDraggingComponent) {
        if (isInsertDropOperation) {
          handleInsertDropOperation($(event.currentTarget), dropConfiguration);
        } else if (isMoveDropOperation) {
          handleMoveDropOperation($(event.currentTarget), dropConfiguration);
        }
        event.preventDefault();
        return false;
      }
    }
    function handleInsertDropOperation(dropZone, dropConfiguration) {
      var dropZoneFieldId = $scope.componentStructure.fieldStructureId,
        dropZoneParentRow = $(parentRowSelector),
        takeAction = isTopDropAttempt || isBottomDropAttempt || isLeftDropAttempt || isRightDropAttempt,
        moveActionResult,
        newComponentConfiguration,
        newRowConfiguration;
      if (takeAction) {
        if (isTopDropAttempt) {
          dropConfiguration.dropType = formViewerConstant.configuration.INSERT_ABOVE;
          moveActionResult = formMediator.createField(rootFormId, dropConfiguration, dropZoneFieldId);
          formMediator.buildEmptyUiRowTemplate().then(function (result) {
            moveActionResult.movedElement.rowTemplate = result;
          });
          newRowConfiguration = {
            row: moveActionResult.movedElement,
            dropZoneRow: dropZoneParentRow,
            createAfterDropZone: false
          };
          $rootScope.$broadcast(formViewerConstant.configuration.event.CREATE_NEW_ROW, newRowConfiguration);
        } else if (isBottomDropAttempt) {
          dropConfiguration.dropType = formViewerConstant.configuration.INSERT_BELOW;
          moveActionResult = formMediator.createField(rootFormId, dropConfiguration, dropZoneFieldId);
          formMediator.buildEmptyUiRowTemplate().then(function (result) {
            moveActionResult.movedElement.rowTemplate = result;
          });
          newRowConfiguration = {
            row: moveActionResult.movedElement,
            dropZoneRow: dropZoneParentRow,
            createAfterDropZone: true
          };
          $rootScope.$broadcast(formViewerConstant.configuration.event.CREATE_NEW_ROW, newRowConfiguration);
        } else if (isLeftDropAttempt) {
          dropConfiguration.dropType = formViewerConstant.configuration.INSERT_BEFORE;
          moveActionResult = formMediator.createField(rootFormId, dropConfiguration, dropZoneFieldId);
          newComponentConfiguration = {
            fieldStructure: moveActionResult.movedElement,
            targetSibling: dropZone,
            createAfterDropZone: false
          };
          $rootScope.$broadcast(formViewerConstant.configuration.event.CREATE_NEW_COMPONENT, newComponentConfiguration);
        } else if (isRightDropAttempt) {
          dropConfiguration.dropType = formViewerConstant.configuration.INSERT_AFTER;
          moveActionResult = formMediator.createField(rootFormId, dropConfiguration, dropZoneFieldId);
          newComponentConfiguration = {
            fieldStructure: moveActionResult.movedElement,
            targetSibling: dropZone,
            createAfterDropZone: true,
            isRowRepeater: moveActionResult.isRowRepeater
          };
          $rootScope.$broadcast(formViewerConstant.configuration.event.CREATE_NEW_COMPONENT, newComponentConfiguration);
        }
      }
      dropZoneParentRow.removeClass('dragOverTop');
      dropZoneParentRow.removeClass('dragOverBottom');
      dropZone.removeClass('dragOverLeft');
      dropZone.removeClass('dragOverRight');
    }
    function handleMoveDropOperation(dropZone, dropConfiguration) {
      var elementToMoveId,
        elementToMoveSelector,
        elementToMove,
        elementToMoveParentRow,
        dropZoneFieldId,
        dropZoneParentRow,
        takeAction,
        moveActionResult,
        newRowConfiguration,
        currentDragConfig = formMediator.getCurrentDragItem(),
        isDraggingComponent = currentDragConfig.formStructureType === formViewerConstant.configuration.formStructureType.COMPONENT;
      if (isDraggingComponent) {
        elementToMoveId = dropConfiguration.fieldStructureId;
        elementToMoveSelector = '.' + elementToMoveId;
        dropZoneFieldId = $scope.componentStructure.fieldStructureId;
        dropZoneParentRow = $(parentRowSelector);
        takeAction = isTopDropAttempt || isBottomDropAttempt || isLeftDropAttempt || isRightDropAttempt;
        if (takeAction) {
          elementToMoveParentRow = $(getParentRowSelectorFromFieldStructureId(dropConfiguration.fieldStructureId));
          elementToMove = $(elementToMoveSelector).detach();
          elementToMove.removeClass('dragging');
        }
        dropZoneParentRow.removeClass('dragOverTop');
        dropZoneParentRow.removeClass('dragOverBottom');
        dropZone.removeClass('dragOverLeft');
        dropZone.removeClass('dragOverRight');
        if (takeAction) {
          if (isTopDropAttempt) {
            moveActionResult = formMediator.moveField(rootFormId, elementToMoveId, dropZoneFieldId, formViewerConstant.configuration.INSERT_ABOVE);
            formMediator.buildEmptyUiRowTemplate().then(function (result) {
              moveActionResult.movedElement.rowTemplate = result;
            });
            newRowConfiguration = {
              row: moveActionResult.movedElement,
              dropZoneRow: dropZoneParentRow,
              createAfterDropZone: false
            };
            $rootScope.$broadcast(formViewerConstant.configuration.event.CREATE_NEW_ROW, newRowConfiguration);
          } else if (isBottomDropAttempt) {
            moveActionResult = formMediator.moveField(rootFormId, elementToMoveId, dropZoneFieldId, formViewerConstant.configuration.INSERT_BELOW);
            formMediator.buildEmptyUiRowTemplate().then(function (result) {
              moveActionResult.movedElement.rowTemplate = result;
            });
            newRowConfiguration = {
              row: moveActionResult.movedElement,
              dropZoneRow: dropZoneParentRow,
              createAfterDropZone: true
            };
            $rootScope.$broadcast(formViewerConstant.configuration.event.CREATE_NEW_ROW, newRowConfiguration);
          } else if (isLeftDropAttempt) {
            moveActionResult = formMediator.moveField(rootFormId, elementToMoveId, dropZoneFieldId, formViewerConstant.configuration.INSERT_BEFORE);
            elementToMove.insertBefore(dropZone);
          } else if (isRightDropAttempt) {
            moveActionResult = formMediator.moveField(rootFormId, elementToMoveId, dropZoneFieldId, formViewerConstant.configuration.INSERT_AFTER);
            elementToMove.insertAfter(dropZone);
          }
          if (moveActionResult.removePreviousRow) {
            elementToMoveParentRow.remove();
          }
        }
      }
    }
    function onDragEnd() {
      element.removeClass('dragging');
      element.removeClass('dragOverLeft');
      element.removeClass('dragOverRight');
      isDraggingOverDropZone = false;
      selectThisField();
    }
    function enableDebuggerTools() {
      if (isDebuggingDragAndDrop()) {
        isDraggingOverDropZone = true;
      }
    }
    function disableDebuggerTools() {
      if (isDebuggingDragAndDrop()) {
        isDraggingOverDropZone = false;
      }
    }
    function isDebuggingDragAndDrop() {
      var form = $('.formViewer:has(.' + parentFormName + ')');
      return form.hasClass('debugDragAndDrop');
    }
    element.on('mouseup', onMouseUp);
    element.on('mouseenter', onMouseEnter);
    element.on('mouseleave', onMouseLeave);
    element.on('mousemove', onMouseMove);
    if (isDraggable) {
      element.on('dragstart', onDragStart);
      element.on('dragover', onDragOver);
      element.on('dragleave', onDragLeave);
      element.on('drop', onDrop);
      element.on('dragend', onDragEnd);
    }
    $scope.$on(formViewerConstant.configuration.event.DELETE_FIELD, function (event, fieldStructureId) {
      if ($scope.componentStructure.fieldStructureId === fieldStructureId) {
        $scope.resetComponent(element.parent(), fieldStructureId);
      }
    });
    $scope.$on(formViewerConstant.event.formBuilder.DISABLE_DRAGGABLE_ELEMENTS, function () {
      element.attr('draggable', 'false');
    });
    $scope.$on(formViewerConstant.event.formBuilder.ENABLE_DRAGGABLE_ELEMENTS, function () {
      element.attr('draggable', 'true');
    });
    $scope.$on('$destroy', function () {
      element.off('mouseenter', onMouseEnter);
      element.off('mouseleave', onMouseLeave);
      element.off('mousemove', onMouseMove);
      element.off('mouseup', onMouseUp);
      element.off('dragstart', onDragStart);
      element.off('dragover', onDragOver);
      element.off('dragleave', onDragLeave);
      element.off('drop', onDrop);
      element.off('dragend', onDragEnd);
    });
  };
  return {
    link: linkFunction,
    restrict: 'A'
  };
};
UIDragManagerDirective.$inject = ["$document", "$rootScope", "$timeout", "formMediator", "formViewerConstant"];
angular.module('umFormViewer').directive('uiDragManager', UIDragManagerDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1224 */
/***/ (function(module) {

module.exports = JSON.parse("{\"rowEditor\":{\"deleteRowConfirmation\":{\"title\":\"Delete Row\",\"summary\":\"Are you sure that you want to permanently delete this row and all of its components?\"}}}");

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

var path = '/formViewer/editor/row/rowEditor.tpl.html';
var html = "\n<div class=\"rowSelectionContainer\"\n     ng-class=\"{\n        selected: $ctrl.rowStructure.selected\n     }\">\n\n    <button class=\"btn btn-xs btn-default deleteComponentButton\"\n            ng-if=\"$ctrl.isDeleteVisible\"\n            ng-click=\"$ctrl.onDeleteRowStructure()\">\n\n        <span class=\"glyphicon glyphicon-trash\"></span>\n    </button>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

var RowEditorComponent = {
  templateUrl: '/formViewer/editor/row/rowEditor.tpl.html',
  controller: 'rowEditorController',
  bindings: {
    rowStructure: '<',
    rootFormId: '<'
  }
};
angular.module('umFormViewer').component('uiRowEditor', RowEditorComponent);

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var RowEditorController = function RowEditorController($rootScope, $scope, $element, formViewerConstant, formMediator, formTemplateStatus, modalUtil, localization, authorizationConstants, currentUserModel) {
  this.translations = {};
  this.canDeleteRow = false;
  this.isDeleteVisible = false;
  this.$onInit = function () {
    var userCanManageForms = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS),
      isUnsavedField;
    localization.getTranslations().then(function (translations) {
      this.translations = translations;
    }.bind(this));
    isUnsavedField = !_.isNil(this.rowStructure.rowTemplate) && !_.isNil(this.rowStructure.rowTemplate.repeaterField) && this.rowStructure.parentUiFormTemplate.formTemplate.id !== this.rowStructure.rowTemplate.repeaterField.fieldTemplate.formTemplateId;
    this.canDeleteRow = isUnsavedField || userCanManageForms && this.rowStructure.parentUiFormTemplate.formTemplate.status !== formTemplateStatus.IN_PRODUCTION;
  };
  this.onDeleteRowStructure = function () {
    var message = _.get(this.translations, 'rowEditor.deleteRowConfirmation.summary'),
      title = _.get(this.translations, 'rowEditor.deleteRowConfirmation.title'),
      cancelButtonLabel = _.get(this.translations, 'genericButtons.cancel'),
      confirmButtonLabel = _.get(this.translations, 'genericButtons.continue');
    function handleClose() {
      formMediator.deleteRow(this.rootFormId, this.rowStructure.rowStructureId);
    }
    modalUtil.showGenericConfirm({
      cancelButtonLabel: cancelButtonLabel,
      confirmActionButtonLabel: confirmButtonLabel,
      summary: message,
      title: title
    }).then(handleClose.bind(this));
  };
  this.updateDeleteVisibility = function () {
    this.isDeleteVisible = this.canDeleteRow && this.rowStructure.selected;
  };
  $scope.$on(formViewerConstant.configuration.event.SECTION_SELECTION_CHANGE, function () {
    this.rowStructure.selected = false;
    this.updateDeleteVisibility();
  }.bind(this));
  $scope.$on(formViewerConstant.configuration.event.ROW_SELECTION_CHANGE, function (event, rowStructure) {
    this.rowStructure.selected = rowStructure.rowStructureId === this.rowStructure.rowStructureId;
    this.updateDeleteVisibility();
  }.bind(this));
  $scope.$on(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, function () {
    this.rowStructure.selected = false;
    this.updateDeleteVisibility();
  }.bind(this));
  $scope.$on(formViewerConstant.configuration.event.DELETE_FIELD, function () {
    if (!_.isNil(this.rowStructure.rowList) && !_.isNil(this.rowStructure.viewContainer) && this.rowStructure.rowList[0].fieldStructureList.length === 1) {
      formMediator.deleteRow(this.rootFormId, this.rowStructure.rowStructureId);
    }
  }.bind(this));
};
RowEditorController.$inject = ["$rootScope", "$scope", "$element", "formViewerConstant", "formMediator", "formTemplateStatus", "modalUtil", "localization", "authorizationConstants", "currentUserModel"];
angular.module('umFormViewer').controller('rowEditorController', RowEditorController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

var path = '/formViewer/editor/row/rowEditorPlaceholder.tpl.html';
var html = "<ui-row-editor class=\"rowEditor {{ ::rowStructure.rowStructureId }}\"\n                   ng-class=\"{ repeatingRow: rowStructure.repeating }\"\n                   row-structure=\"rowStructure\"\n                   root-form-id=\"rowStructure.rootFormId\"\n                   ui-draggable-row >\n</ui-row-editor>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UIDraggableRowDirective = function UIDraggableRowDirective($rootScope, $timeout, formMediator, formViewerConstant, authorizationConstants, currentUserModel) {
  var linkFunction = function linkFunction($scope, $elm) {
    var element = $($elm),
      selectionContainer = element.find('.rowSelectionContainer'),
      rootFormId = $scope.rowStructure.rootFormId,
      isTopDropAttempt,
      isBottomDropAttempt,
      userCanManageForms = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS);
    if (userCanManageForms) {
      element.attr('draggable', 'true');
    }
    function selectThisRow() {
      $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, null);
      $rootScope.$broadcast(formViewerConstant.configuration.event.ROW_SELECTION_CHANGE, $scope.rowStructure);
      $timeout(function () {}, 0);
    }
    function onMouseUp(event) {
      var className = event.target.className;
      if (isRowTarget(className)) {
        selectThisRow();
      }
    }
    function onMouseMove(event) {
      var className = event.target.className;
      if (isRowTarget(className)) {
        selectionContainer.addClass('selectable');
      } else {
        selectionContainer.removeClass('selectable');
      }
    }
    function onMouseLeave(event) {
      selectionContainer.removeClass('selectable');
    }
    function isRowTarget(targetClassName) {
      var isClickingRow = targetClassName.indexOf('rowEditor') !== -1,
        isClickingSelectionContainer = targetClassName.indexOf('rowSelectionContainer') !== -1;
      return isClickingRow || isClickingSelectionContainer;
    }
    function onDragStart(event) {
      var className = event.target.className;
      if (isRowTarget(className)) {
        selectThisRow();
      }
      var dataTransfer = event.originalEvent.dataTransfer,
        isDraggingRow = isRowTarget(event.target.className),
        dragConfiguration = {
          formStructureType: formViewerConstant.configuration.formStructureType.ROW,
          dragType: formViewerConstant.configuration.dragOperationType.MOVE,
          rowStructureId: $scope.rowStructure.rowStructureId
        };
      if (isDraggingRow) {
        element.addClass('dragging');
        dataTransfer.effectAllowed = 'move';
        event.originalEvent.dataTransfer.setData('text', JSON.stringify(dragConfiguration));
        formMediator.setCurrentDragItem(dragConfiguration);
      }
    }
    function onDragOver(event) {
      var dataTransfer = event.originalEvent.dataTransfer,
        currentTarget = $(event.currentTarget),
        isElementBeingDragged = currentTarget.hasClass('dragging'),
        currentDragConfig = formMediator.getCurrentDragItem(),
        isDraggingRow = !_.isNil(currentDragConfig) && currentDragConfig.formStructureType === formViewerConstant.configuration.formStructureType.ROW,
        isDraggingRowRepeater = !_.isNil(currentDragConfig) && currentDragConfig.formStructureType === formViewerConstant.configuration.formStructureType.ROW_REPEATER,
        takeActionOnDragEvent = !isElementBeingDragged && (isDraggingRow || isDraggingRowRepeater),
        offsetY,
        height;
      if (takeActionOnDragEvent) {
        offsetY = event.clientY - element.offset().top;
        height = currentTarget.height();
        isTopDropAttempt = offsetY < height / 2;
        isBottomDropAttempt = offsetY > height / 2;
        element.removeClass('dragOverTop');
        element.removeClass('dragOverBottom');
        if (isTopDropAttempt) {
          element.addClass('dragOverTop');
        } else if (isBottomDropAttempt) {
          element.addClass('dragOverBottom');
        }
        dataTransfer.dropEffect = 'move';
        event.preventDefault();
      }
    }
    function onDragLeave() {
      element.removeClass('dragOverTop');
      element.removeClass('dragOverBottom');
    }
    function handleMoveDropOperation(dropConfiguration) {
      var elementToMoveRowId = dropConfiguration.rowStructureId,
        elementToMoveSelector = '.' + elementToMoveRowId,
        elementToMove,
        dropZoneRowId = $scope.rowStructure.rowStructureId,
        dropZoneTarget,
        takeAction = isTopDropAttempt || isBottomDropAttempt;
      if (takeAction) {
        dropZoneTarget = $('.' + dropZoneRowId);
        elementToMove = $(elementToMoveSelector).detach();
        elementToMove.removeClass('dragging');
        if (isTopDropAttempt) {
          formMediator.moveRow(rootFormId, elementToMoveRowId, dropZoneRowId, formViewerConstant.configuration.INSERT_ABOVE);
          elementToMove.insertBefore(dropZoneTarget);
        } else if (isBottomDropAttempt) {
          formMediator.moveRow(rootFormId, elementToMoveRowId, dropZoneRowId, formViewerConstant.configuration.INSERT_BELOW);
          elementToMove.insertAfter(dropZoneTarget);
        }
      }
    }
    function handleInsertDropOperation(dropConfiguration) {
      var takeAction = isTopDropAttempt || isBottomDropAttempt,
        moveActionResult,
        newRowConfiguration,
        dropZoneRowId = $scope.rowStructure.rowStructureId;
      if (takeAction) {
        if (isTopDropAttempt) {
          moveActionResult = formMediator.createRowRepeater(rootFormId, dropConfiguration, dropZoneRowId, formViewerConstant.configuration.INSERT_ABOVE);
        } else {
          moveActionResult = formMediator.createRowRepeater(rootFormId, dropConfiguration, dropZoneRowId, formViewerConstant.configuration.INSERT_BELOW);
        }
        newRowConfiguration = {
          rowStructure: moveActionResult.movedElement,
          dropZoneRow: element,
          createAfterDropZone: isBottomDropAttempt
        };
        $rootScope.$broadcast(formViewerConstant.configuration.event.CREATE_NEW_ROW_REPEATER, newRowConfiguration);
      }
    }
    function onDrop(event) {
      var dataTransfer = event.originalEvent.dataTransfer,
        dropConfiguration = JSON.parse(dataTransfer.getData('text')),
        isInsertDropOperation = dropConfiguration.dragType === formViewerConstant.configuration.dragOperationType.INSERT,
        isMoveDropOperation = dropConfiguration.dragType === formViewerConstant.configuration.dragOperationType.MOVE,
        currentDragConfig = formMediator.getCurrentDragItem(),
        isDraggingRow = currentDragConfig.formStructureType === formViewerConstant.configuration.formStructureType.ROW || currentDragConfig.formStructureType === formViewerConstant.configuration.formStructureType.ROW_REPEATER;
      if (isDraggingRow) {
        if (isInsertDropOperation) {
          handleInsertDropOperation(dropConfiguration);
        } else if (isMoveDropOperation) {
          handleMoveDropOperation(dropConfiguration);
        }
        element.removeClass('dragOverTop');
        element.removeClass('dragOverBottom');
        event.preventDefault();
        return false;
      }
    }
    function onDragEnd(event) {
      var className = event.target.className;
      element.removeClass('dragOverTop');
      element.removeClass('dragOverBottom');
      element.removeClass('dragging');
      if (isRowTarget(className)) {
        selectThisRow();
      }
    }
    element.on('mouseup', onMouseUp);
    element.on('mouseleave', onMouseLeave);
    element.on('mousemove', onMouseMove);
    element.on('dragstart', onDragStart);
    element.on('dragover', onDragOver);
    element.on('dragleave', onDragLeave);
    element.on('drop', onDrop);
    element.on('dragend', onDragEnd);
    $scope.$on(formViewerConstant.configuration.event.DELETE_ROW, function (event, rowStructureId) {
      if ($scope.rowStructure.rowStructureId === rowStructureId) {
        $scope.resetRow(element.parent(), $scope.rowStructure);
      }
    });
    $scope.$on(formViewerConstant.event.formBuilder.DISABLE_DRAGGABLE_ELEMENTS, function () {
      element.attr('draggable', 'false');
    });
    $scope.$on(formViewerConstant.event.formBuilder.ENABLE_DRAGGABLE_ELEMENTS, function () {
      element.attr('draggable', 'true');
    });
    $scope.$on('$destroy', function () {
      element.off('mouseup', onMouseUp);
      element.off('mouseleave', onMouseLeave);
      element.off('mousemove', onMouseMove);
      element.off('dragstart', onDragStart);
      element.off('dragover', onDragOver);
      element.off('dragleave', onDragLeave);
      element.off('drop', onDrop);
      element.off('dragend', onDragEnd);
    });
  };
  return {
    link: linkFunction,
    restrict: 'A'
  };
};
UIDraggableRowDirective.$inject = ["$rootScope", "$timeout", "formMediator", "formViewerConstant", "authorizationConstants", "currentUserModel"];
angular.module('umFormViewer').directive('uiDraggableRow', UIDraggableRowDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1230 */
/***/ (function(module) {

module.exports = JSON.parse("{\"sectionEditor\":{\"deleteSectionConfirmation\":{\"title\":\"Delete Section\",\"summary\":\"Are you sure that you want to permanently delete this section and all of it's components?\"}}}");

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

var path = '/formViewer/editor/section/sectionEditor.tpl.html';
var html = "<div class=\"sectionSelectionContainer\"\n     ng-class=\"{\n        selected: $ctrl.sectionStructure.selected\n     }\">\n\n    <button class=\"btn btn-xs btn-default deleteComponentButton\"\n            ng-if=\"$ctrl.isDeleteVisible\"\n            ng-click=\"$ctrl.onDeleteComponentStructure()\">\n\n        <span class=\"glyphicon glyphicon-trash\"></span>\n    </button>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

var SectionEditorComponent = {
  templateUrl: '/formViewer/editor/section/sectionEditor.tpl.html',
  controller: 'sectionEditorController',
  bindings: {
    sectionStructure: '<',
    rootFormId: '<'
  }
};
angular.module('umFormViewer').component('uiSectionEditor', SectionEditorComponent);

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var SectionEditorController = function SectionEditorController($rootScope, $scope, $element, formViewerConstant, formMediator, formTemplateStatus, modalUtil, localization, authorizationConstants, currentUserModel, formViewerModel) {
  $element.addClass('componentEditor');
  this.translations = {};
  this.isDeleteVisible = false;
  this.userCanManageForms = false;
  this.$onInit = function () {
    this.userCanManageForms = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS);
    this.updateDeleteVisibility();
    localization.getTranslations().then(function (translations) {
      this.translations = translations;
    }.bind(this));
  };
  this.canDeleteSection = function () {
    return this.userCanManageForms && this.sectionStructure.parentUiFormTemplate.formTemplate.status !== formTemplateStatus.IN_PRODUCTION && this.formHasMultipleSections();
  };
  this.formHasMultipleSections = function () {
    var formStructure = formViewerModel.getFormStructure(this.rootFormId);
    return !_.isNil(formStructure) && _.size(formStructure.sectionList) > 1;
  };
  this.onDeleteComponentStructure = function () {
    var message = _.get(this.translations, 'sectionEditor.deleteSectionConfirmation.summary'),
      title = _.get(this.translations, 'sectionEditor.deleteSectionConfirmation.title'),
      cancelButtonLabel = _.get(this.translations, 'genericButtons.cancel'),
      confirmButtonLabel = _.get(this.translations, 'genericButtons.continue');
    function handleClose() {
      formMediator.deleteSection(this.rootFormId, this.sectionStructure.sectionStructureId);
    }
    if (this.canDeleteSection()) {
      modalUtil.showGenericConfirm({
        cancelButtonLabel: cancelButtonLabel,
        confirmActionButtonLabel: confirmButtonLabel,
        summary: message,
        title: title
      }).then(handleClose.bind(this));
    }
  };
  this.updateDeleteVisibility = function () {
    this.isDeleteVisible = this.canDeleteSection() && this.sectionStructure.selected;
  };
  $scope.$on(formViewerConstant.configuration.event.SECTION_SELECTION_CHANGE, function (event, sectionStructure) {
    this.sectionStructure.selected = sectionStructure.sectionStructureId === this.sectionStructure.sectionStructureId;
    this.updateDeleteVisibility();
  }.bind(this));
  $scope.$on(formViewerConstant.configuration.event.ROW_SELECTION_CHANGE, function () {
    this.sectionStructure.selected = false;
    this.updateDeleteVisibility();
  }.bind(this));
  $scope.$on(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, function () {
    this.sectionStructure.selected = false;
    this.updateDeleteVisibility();
  }.bind(this));
  $scope.$on(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED, function () {
    this.updateDeleteVisibility();
  }.bind(this));
};
SectionEditorController.$inject = ["$rootScope", "$scope", "$element", "formViewerConstant", "formMediator", "formTemplateStatus", "modalUtil", "localization", "authorizationConstants", "currentUserModel", "formViewerModel"];
angular.module('umFormViewer').controller('sectionEditorController', SectionEditorController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

var path = '/formViewer/editor/section/sectionEditorPlaceholder.tpl.html';
var html = "<ui-section-editor class=\"sectionEditor {{ ::sectionStructure.sectionStructureId }}\"\n                     section-structure=\"sectionStructure\"\n                     root-form-id=\"formId\"\n                     ui-draggable-section\n</ui-section-editor>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var UIDraggableSectionDirective = function UIDraggableSectionDirective($rootScope, $timeout, formMediator, formViewerConstant, authorizationConstants, currentUserModel) {
  var linkFunction = function linkFunction($scope, $elm) {
    var element = $($elm),
      selectionContainer = element.find('.sectionSelectionContainer'),
      rootFormId = $scope.sectionStructure.rootFormId,
      isTopDropAttempt,
      isBottomDropAttempt,
      userCanManageForms = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS);
    if (userCanManageForms) {
      element.attr('draggable', 'true');
    }
    function selectThisSection() {
      $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, null);
      $rootScope.$broadcast(formViewerConstant.configuration.event.SECTION_SELECTION_CHANGE, $scope.sectionStructure);
      $timeout(function () {}, 0);
    }
    function onMouseUp(event) {
      var className = event.target.className,
        isClickingSection = className.indexOf('sectionContainer') !== -1,
        isClickingSelectionContainer = className.indexOf('sectionSelectionContainer') !== -1,
        isClickingRow = className.indexOf('formRow') !== -1;
      if (isClickingRow || isClickingSection || isClickingSelectionContainer) {
        selectThisSection();
      }
    }
    function onMouseMove(event) {
      var className = event.target.className,
        isOverSection = className.indexOf('sectionContainer') !== -1;
      if (isOverSection) {
        selectionContainer.addClass('selectable');
      } else {
        selectionContainer.removeClass('selectable');
      }
    }
    function onMouseLeave(event) {
      selectionContainer.removeClass('selectable');
    }
    function onDragStart(event) {
      var dataTransfer = event.originalEvent.dataTransfer,
        isDraggingSection = event.target.className.indexOf('sectionEditor') !== -1,
        dragConfiguration = {
          formStructureType: formViewerConstant.configuration.formStructureType.SECTION,
          dragType: formViewerConstant.configuration.dragOperationType.MOVE,
          sectionStructureId: $scope.sectionStructure.sectionStructureId
        };
      if (isDraggingSection) {
        selectThisSection();
        element.addClass('dragging');
        dataTransfer.effectAllowed = 'move';
        event.originalEvent.dataTransfer.setData('text', JSON.stringify(dragConfiguration));
        formMediator.setCurrentDragItem(dragConfiguration);
      }
    }
    function onDragOver(event) {
      var dataTransfer = event.originalEvent.dataTransfer,
        currentTarget = $(event.currentTarget),
        isElementBeingDragged = currentTarget.hasClass('dragging'),
        currentDragConfig = formMediator.getCurrentDragItem(),
        isDraggingSection = currentDragConfig.formStructureType === formViewerConstant.configuration.formStructureType.SECTION,
        offsetY,
        height;
      if (!isElementBeingDragged && isDraggingSection) {
        offsetY = event.clientY - element.offset().top;
        height = currentTarget.height();
        isTopDropAttempt = offsetY < height / 2;
        isBottomDropAttempt = offsetY > height / 2;
        element.removeClass('dragOverTop');
        element.removeClass('dragOverBottom');
        if (isTopDropAttempt) {
          element.addClass('dragOverTop');
        } else if (isBottomDropAttempt) {
          element.addClass('dragOverBottom');
        }
        dataTransfer.dropEffect = 'move';
        event.preventDefault();
      }
    }
    function onDragLeave() {
      element.removeClass('dragOverTop');
      element.removeClass('dragOverBottom');
    }
    function handleMoveDropOperation(dropConfiguration) {
      var elementToMoveSectionId = dropConfiguration.sectionStructureId,
        elementToMoveSelector = '.' + elementToMoveSectionId,
        elementToMove,
        dropZoneSectionId = $scope.sectionStructure.sectionStructureId,
        dropZoneTarget,
        takeAction = isTopDropAttempt || isBottomDropAttempt;
      if (takeAction) {
        dropZoneTarget = $('.' + dropZoneSectionId);
        elementToMove = $(elementToMoveSelector).detach();
        elementToMove.removeClass('dragging');
        if (isTopDropAttempt) {
          formMediator.moveSection(rootFormId, elementToMoveSectionId, dropZoneSectionId, formViewerConstant.configuration.INSERT_ABOVE);
          elementToMove.insertBefore(dropZoneTarget);
        } else if (isBottomDropAttempt) {
          formMediator.moveSection(rootFormId, elementToMoveSectionId, dropZoneSectionId, formViewerConstant.configuration.INSERT_BELOW);
          elementToMove.insertAfter(dropZoneTarget);
        }
      }
    }
    function handleInsertDropOperation(dropConfiguration) {
      var takeAction = isTopDropAttempt || isBottomDropAttempt,
        moveActionResult,
        newSectionConfiguration,
        dropZoneSectionId = $scope.sectionStructure.sectionStructureId;
      if (takeAction) {
        if (isTopDropAttempt) {
          moveActionResult = formMediator.createSection(rootFormId, dropConfiguration, dropZoneSectionId, formViewerConstant.configuration.INSERT_ABOVE);
        } else {
          moveActionResult = formMediator.createSection(rootFormId, dropConfiguration, dropZoneSectionId, formViewerConstant.configuration.INSERT_BELOW);
        }
        newSectionConfiguration = {
          sectionStructure: moveActionResult.movedElement,
          dropZoneSection: element,
          createAfterDropZone: isBottomDropAttempt
        };
        $rootScope.$broadcast(formViewerConstant.configuration.event.CREATE_NEW_SECTION, newSectionConfiguration);
      }
    }
    function onDrop(event) {
      var dataTransfer = event.originalEvent.dataTransfer,
        dropConfiguration = JSON.parse(dataTransfer.getData('text')),
        isInsertDropOperation = dropConfiguration.dragType === formViewerConstant.configuration.dragOperationType.INSERT,
        isMoveDropOperation = dropConfiguration.dragType === formViewerConstant.configuration.dragOperationType.MOVE,
        currentDragConfig = formMediator.getCurrentDragItem(),
        isDraggingSection = currentDragConfig.formStructureType === formViewerConstant.configuration.formStructureType.SECTION;
      if (isDraggingSection) {
        if (isInsertDropOperation) {
          handleInsertDropOperation(dropConfiguration);
        } else if (isMoveDropOperation) {
          handleMoveDropOperation(dropConfiguration);
        }
        element.removeClass('dragOverTop');
        element.removeClass('dragOverBottom');
        event.preventDefault();
        return false;
      }
    }
    function onDragEnd(event) {
      var className = event.target.className,
        isClickingSection = className.indexOf('sectionContainer') !== -1,
        isClickingRow = className.indexOf('formRow') !== -1;
      element.removeClass('dragOverTop');
      element.removeClass('dragOverBottom');
      element.removeClass('dragging');
      if (isClickingRow || isClickingSection) {
        selectThisSection();
      }
    }
    element.on('mouseup', onMouseUp);
    element.on('mouseleave', onMouseLeave);
    element.on('mousemove', onMouseMove);
    element.on('dragstart', onDragStart);
    element.on('dragover', onDragOver);
    element.on('dragleave', onDragLeave);
    element.on('drop', onDrop);
    element.on('dragend', onDragEnd);
    $scope.$on(formViewerConstant.configuration.event.DELETE_SECTION, function (event, sectionStructureId) {
      if ($scope.sectionStructure.sectionStructureId === sectionStructureId) {
        $scope.resetComponent(element.parent(), $scope.sectionStructure);
      }
    });
    $scope.$on(formViewerConstant.event.formBuilder.DISABLE_DRAGGABLE_ELEMENTS, function () {
      element.attr('draggable', 'false');
    });
    $scope.$on(formViewerConstant.event.formBuilder.ENABLE_DRAGGABLE_ELEMENTS, function () {
      element.attr('draggable', 'true');
    });
    $scope.$on('$destroy', function () {
      element.off('mouseup', onMouseUp);
      element.off('mouseleave', onMouseLeave);
      element.off('mousemove', onMouseMove);
      element.off('dragstart', onDragStart);
      element.off('dragover', onDragOver);
      element.off('dragleave', onDragLeave);
      element.off('drop', onDrop);
      element.off('dragend', onDragEnd);
    });
  };
  return {
    link: linkFunction,
    restrict: 'A'
  };
};
UIDraggableSectionDirective.$inject = ["$rootScope", "$timeout", "formMediator", "formViewerConstant", "authorizationConstants", "currentUserModel"];
angular.module('umFormViewer').directive('uiDraggableSection', UIDraggableSectionDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

/*@ngInject*/
var RemoteFunction = function RemoteFunction(formMediator) {
  this.executeFunction = function (formId, fieldId, rowIndex, parameters, submissionId) {
    parameters.rowIndex = rowIndex;
    return formMediator.executeFunction(formId, submissionId, parameters.beanName, fieldId, parameters);
  };
};
RemoteFunction.$inject = ["formMediator"];
angular.module('umCore').service('remoteFunction', RemoteFunction);

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

/*@ngInject*/
var DelayShowNextRequiredFieldModel = function DelayShowNextRequiredFieldModel() {
  var delayShowNextRequiredField = false;
  this.reset = function () {
    delayShowNextRequiredField = false;
  };
  this.setDelayShowNextRequiredField = function (value) {
    delayShowNextRequiredField = value;
  };
  this.isDelayShowNextRequiredField = function () {
    return delayShowNextRequiredField;
  };
};
angular.module('umFormViewer').service('delayShowNextRequiredFieldModel', DelayShowNextRequiredFieldModel);

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FormConfigurationUtil = function FormConfigurationUtil($rootScope, formViewerConstant, uuidUtil) {
  function findFieldStructureLocationById(targetFieldId, sourceFormStructure) {
    var result = null;
    function searchSections(sectionList, parentForm) {
      _.each(sectionList, function (section) {
        return searchRows(section.rowList, parentForm, section);
      });
    }
    function searchRows(rowList, parentForm, section) {
      _.each(rowList, function (row) {
        searchFields(row.fieldStructureList, parentForm, section, row);
        if (_.isNil(result) && !_.isEmpty(row.rowList) && !_.isNil(row.rowList[0])) {
          searchFields(row.rowList[0].fieldStructureList, parentForm, section, row);
        }
        if (row.sectionList) {
          searchSections(row.sectionList);
        }
      });
    }
    function searchFields(fieldStructureList, parentForm, section, row) {
      _.each(fieldStructureList, function (fieldStructure) {
        if (fieldStructure.fieldStructureId === targetFieldId) {
          result = {
            parentForm: parentForm,
            parentSection: section,
            parentRow: row,
            fieldStructure: fieldStructure,
            isRowRepeater: row.rowTemplate.rowRepeatable
          };
          return false;
        }
      });
    }
    searchSections(sourceFormStructure.sectionList, sourceFormStructure);
    return result;
  }
  function findSectionStructureLocationById(targetSectionId, sourceFormStructure) {
    var result = null;
    function searchSections(sectionList, parentForm) {
      _.each(sectionList, function (section) {
        if (section.sectionStructureId === targetSectionId) {
          result = {
            parentForm: parentForm,
            sectionStructure: section
          };
        } else {
          searchRows(section.rowList, parentForm, section);
        }
      });
    }
    function searchRows(rowList) {
      _.each(rowList, function (row) {
        if (row.sectionList) {
          searchSections(row.sectionList);
        }
      });
    }
    searchSections(sourceFormStructure.sectionList, sourceFormStructure);
    return result;
  }
  function findRowStructureLocationById(targetRowId, sourceFormStructure) {
    var result = null;
    function searchSections(sectionList, parentForm) {
      _.each(sectionList, function (section) {
        searchRows(section.rowList, parentForm, section);
      });
    }
    function searchRows(rowList, parentForm, parentSection) {
      _.each(rowList, function (row) {
        if (row.sectionList) {
          searchSections(row.sectionList, row);
        } else if (row.rowStructureId === targetRowId) {
          result = {
            parentForm: parentForm,
            parentSection: parentSection,
            rowStructure: row
          };
        }
      });
    }
    searchSections(sourceFormStructure.sectionList, sourceFormStructure);
    return result;
  }
  this.removeField = function (parentFieldStructureList, fieldStructure) {
    _.pull(parentFieldStructureList, fieldStructure);
  };
  this.removeRow = function (parentRowList, rowToRemove) {
    var rowIndexToRemove = _.findIndex(parentRowList, rowToRemove);
    parentRowList.splice(rowIndexToRemove, 1);
  };
  this.removeSection = function (parentSectionList, sectionToRemove) {
    _.pull(parentSectionList, sectionToRemove);
  };
  this.deleteField = function (formViewerInstance, elementToDeleteId) {
    var deleteTargetFieldStuctureLocation = findFieldStructureLocationById(elementToDeleteId, formViewerInstance.formStructure),
      parentRow = getFieldStructureLocationParentRow(deleteTargetFieldStuctureLocation);
    this.removeField(parentRow.fieldStructureList, deleteTargetFieldStuctureLocation.fieldStructure);
    this.removeField(parentRow.rowTemplate.fields, deleteTargetFieldStuctureLocation.fieldStructure.uiField);
    $rootScope.$broadcast(formViewerConstant.configuration.event.DELETE_FIELD, elementToDeleteId);
  };
  this.deleteSection = function (formViewerInstance, elementToDeleteId) {
    var deleteTargetFieldStuctureLocation = findSectionStructureLocationById(elementToDeleteId, formViewerInstance.formStructure);
    this.removeSection(deleteTargetFieldStuctureLocation.parentForm.sectionList, deleteTargetFieldStuctureLocation.sectionStructure);
    $rootScope.$broadcast(formViewerConstant.configuration.event.DELETE_SECTION, elementToDeleteId);
  };
  this.deleteRow = function (formViewerInstance, elementToDeleteId) {
    var deleteTargetRowLocation = findRowStructureLocationById(elementToDeleteId, formViewerInstance.formStructure);
    this.removeRow(deleteTargetRowLocation.parentSection.rowList, deleteTargetRowLocation.rowStructure);
    $rootScope.$broadcast(formViewerConstant.configuration.event.DELETE_ROW, elementToDeleteId);
  };
  this.moveField = function (formViewerInstance, elementToMoveId, dropZoneFieldId, moveType) {
    var isMoveLeft = moveType === formViewerConstant.configuration.INSERT_BEFORE,
      isMoveRight = moveType === formViewerConstant.configuration.INSERT_AFTER,
      isMoveIntoExistingRow = isMoveLeft || isMoveRight,
      isRowAdditionAbove = moveType === formViewerConstant.configuration.INSERT_ABOVE,
      isRowAdditionBelow = moveType === formViewerConstant.configuration.INSERT_BELOW,
      isRowAddition = isRowAdditionAbove || isRowAdditionBelow,
      moveTargetFieldStructureLocation = findFieldStructureLocationById(elementToMoveId, formViewerInstance.formStructure),
      moveTargetParentRow = getFieldStructureLocationParentRow(moveTargetFieldStructureLocation),
      dropZoneFieldStructureLocation = findFieldStructureLocationById(dropZoneFieldId, formViewerInstance.formStructure),
      dropZoneParentRow = getFieldStructureLocationParentRow(dropZoneFieldStructureLocation),
      result = {
        removePreviousRow: false,
        movedElement: null,
        isRowRepeater: dropZoneFieldStructureLocation.isRowRepeater
      };
    function moveElementIntoExistingRow() {
      var dropZoneFieldStructureList = dropZoneParentRow.fieldStructureList,
        dropZoneTargetIndex = _.findIndex(dropZoneFieldStructureList, dropZoneFieldStructureLocation.fieldStructure),
        dropZoneRowTemplateFieldStructureList = dropZoneParentRow.rowTemplate.fields;
      if (isMoveRight) {
        dropZoneTargetIndex += 1;
      }
      moveTargetFieldStructureLocation.fieldStructure.hideLabel = dropZoneFieldStructureLocation.isRowRepeater;
      this.removeField(moveTargetParentRow.fieldStructureList, moveTargetFieldStructureLocation.fieldStructure);
      this.removeField(moveTargetParentRow.rowTemplate.fields, moveTargetFieldStructureLocation.fieldStructure.uiField);
      dropZoneFieldStructureList.splice(dropZoneTargetIndex, 0, moveTargetFieldStructureLocation.fieldStructure);
      dropZoneRowTemplateFieldStructureList.splice(dropZoneTargetIndex, 0, moveTargetFieldStructureLocation.fieldStructure.uiField);
      return moveTargetFieldStructureLocation.fieldStructure;
    }
    function createNewRowWithMovedField() {
      var rootFormId = moveTargetFieldStructureLocation.fieldStructure.rootFormId,
        newRowId = uuidUtil.generateUUID(),
        newRow = {
          rootFormId: rootFormId,
          rowStructureId: rootFormId + '-' + newRowId,
          parentForm: moveTargetFieldStructureLocation.fieldStructure.parentForm,
          parentFormStructure: moveTargetParentRow.parentFormStructure,
          parentUiFormTemplate: moveTargetFieldStructureLocation.parentForm.uiFormTemplate,
          rowTemplate: null,
          fieldStructureList: [moveTargetFieldStructureLocation.fieldStructure],
          rowHeight: moveTargetParentRow.rowHeight,
          rowIdentifier: rootFormId + '-' + newRowId
        },
        dropZoneTargetRowList = dropZoneFieldStructureLocation.parentSection.rowList,
        dropZoneTargetRowIndex = _.findIndex(dropZoneTargetRowList, dropZoneFieldStructureLocation.parentRow);
      if (isRowAdditionBelow) {
        dropZoneTargetRowIndex += 1;
      }
      dropZoneTargetRowList.splice(dropZoneTargetRowIndex, 0, newRow);
      return newRow;
    }
    this.removeField(moveTargetParentRow.fieldStructureList, moveTargetFieldStructureLocation.fieldStructure);
    if (moveTargetParentRow.fieldStructureList.length === 0) {
      result.removePreviousRow = true;
      this.removeRow(moveTargetFieldStructureLocation.parentSection.rowList, moveTargetParentRow);
    }
    if (isMoveIntoExistingRow) {
      result.movedElement = moveElementIntoExistingRow.bind(this)();
      $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_MOVED_IN_ROW, result.movedElement);
    } else if (isRowAddition) {
      result.movedElement = createNewRowWithMovedField();
    }
    return result;
  };
  this.moveSection = function (formViewerInstance, elementToMoveSectionId, dropZoneSectionId, moveType) {
    var isMoveAbove = moveType === formViewerConstant.configuration.INSERT_ABOVE,
      moveTargetSectionStructureLocation = findSectionStructureLocationById(elementToMoveSectionId, formViewerInstance.formStructure),
      dropZoneSectionStructureLocation = findSectionStructureLocationById(dropZoneSectionId, formViewerInstance.formStructure),
      dropZoneSectionStructureList,
      dropZoneTargetIndex;
    this.removeSection(moveTargetSectionStructureLocation.parentForm.sectionList, moveTargetSectionStructureLocation.sectionStructure);
    dropZoneSectionStructureList = dropZoneSectionStructureLocation.parentForm.sectionList;
    dropZoneTargetIndex = _.findIndex(dropZoneSectionStructureList, dropZoneSectionStructureLocation.sectionStructure);
    if (!isMoveAbove) {
      dropZoneTargetIndex += 1;
    }
    dropZoneSectionStructureList.splice(dropZoneTargetIndex, 0, moveTargetSectionStructureLocation.sectionStructure);
    return {
      movedElement: moveTargetSectionStructureLocation.sectionStructure
    };
  };
  this.moveRow = function (formViewerInstance, elementToMoveRowId, dropZoneRowId, moveType) {
    var isMoveAbove = moveType === formViewerConstant.configuration.INSERT_ABOVE,
      moveTargetRowStructureLocation = findRowStructureLocationById(elementToMoveRowId, formViewerInstance.formStructure),
      dropZoneRowStructureLocation = findRowStructureLocationById(dropZoneRowId, formViewerInstance.formStructure),
      dropZoneRowStructureList,
      dropZoneTargetIndex;
    this.removeRow(moveTargetRowStructureLocation.parentSection.rowList, moveTargetRowStructureLocation.rowStructure);
    dropZoneRowStructureList = dropZoneRowStructureLocation.parentSection.rowList;
    dropZoneTargetIndex = _.findIndex(dropZoneRowStructureList, dropZoneRowStructureLocation.rowStructure);
    if (!isMoveAbove) {
      dropZoneTargetIndex += 1;
    }
    dropZoneRowStructureList.splice(dropZoneTargetIndex, 0, moveTargetRowStructureLocation.rowStructure);
    return {
      movedElement: moveTargetRowStructureLocation.rowStructure
    };
  };
  function getFieldStructureLocationParentRow(fieldStructureLocation) {
    return _.isNil(fieldStructureLocation.parentRow.rowList) ? fieldStructureLocation.parentRow : fieldStructureLocation.parentRow.rowList[0];
  }
};
FormConfigurationUtil.$inject = ["$rootScope", "formViewerConstant", "uuidUtil"];
angular.module('umFormViewer').service('formConfigurationUtil', FormConfigurationUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FormRegistrationModel = function FormRegistrationModel() {
  var registrations = [];
  this.addRegistration = function (formId, url) {
    var doAdd = false;
    if (!registrations[formId]) {
      registrations[formId] = [];
      doAdd = true;
    }
    if (!doAdd) {
      doAdd = true;
      _.each(registrations[formId], function (registration) {
        if (JSON.stringify(url) === JSON.stringify(registration)) {
          doAdd = false;
        }
      });
    }
    if (doAdd) {
      registrations[formId].push(url);
    }
  };
  this.removeRegistrations = function (formId) {
    delete registrations[formId];
  };
  this.clearRegistrations = function () {
    registrations = [];
  };
  this.getRegistrations = function (formId) {
    return registrations[formId];
  };
};
angular.module('umFormViewer').service('formRegistrationModel', FormRegistrationModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FormStructureUtil = function FormStructureUtil($q, $timeout, fieldType, formViewerUtil, xmlUtil, formComponentUtil, formatUtil, uuidUtil, rowRepeaterUtil) {
  this.buildFormStructure = function (rootFormId, sourceForm, fieldInstanceList, formSummaryList, formRowInstanceList, hasWriteAccess, rowRepeaterMap, fieldMap, topLevelSectionList, printPreview, currencyCode, isConfigurableForm) {
    var defer = $q.defer(),
      formRoot = {
        uiFormTemplate: sourceForm,
        formModel: _.find(formSummaryList, {
          formTemplateId: sourceForm.formTemplate.id
        }),
        hasWriteAccess: hasWriteAccess,
        sectionList: null,
        hasResponsiveLayout: sourceForm.formTemplate.flags === 'wrap',
        isConfigurableForm: isConfigurableForm
      },
      formConfig,
      isSupplemental,
      previousFieldKey,
      precedingFieldInfo;
    isSupplemental = sourceForm.precedingFieldFormId && sourceForm.precedingFieldFormId > 0;
    formRoot.formModel = _.extend(formRoot.formModel, {
      printPreview: printPreview
    });
    if (isSupplemental) {
      precedingFieldInfo = formViewerUtil.findPrecedingFieldRowForSupplementalForm(formRoot.uiFormTemplate.precedingFieldVariableName, formRoot.uiFormTemplate.precedingFieldFormTemplateUniqueName, topLevelSectionList);
      if (precedingFieldInfo) {
        previousFieldKey = formViewerUtil.findLastFieldInPreviousRowKey(precedingFieldInfo.precedingFieldRow);
      }
    }
    formRoot.formModel.hasWriteAccess = hasWriteAccess;
    function buildSections(sections) {
      var sectionList = [],
        formHeight = 0,
        sectionConfig;
      _.each(sections, function (section) {
        sectionConfig = buildRows(section.rows);
        sectionList.push({
          rootFormId: rootFormId,
          sectionStructureId: rootFormId + '-' + section.id,
          sectionTemplate: section,
          rowList: sectionConfig.rowList,
          sectionHeight: sectionConfig.sectionHeight,
          parentUiFormTemplate: formRoot.uiFormTemplate
        });
        formHeight += sectionConfig.sectionHeight;
      });
      return {
        formHeight: formHeight,
        sectionList: sectionList
      };
    }
    function getRowRepeaterFieldStructure(row) {
      var fieldStructure = _.find(row.fields, function (fieldStructure) {
        return fieldStructure.fieldTemplate.type === fieldType.ROWREPEATER;
      });
      return fieldStructure;
    }
    function buildRows(sectionRows) {
      var rowList = [],
        totalSectionHeight = 0,
        rowRepeater;
      function getRowRepeaterField(rowList) {
        var result = null,
          fieldStructureList = _.last(rowList).fieldStructureList;
        _.find(fieldStructureList, function (fieldStructure) {
          var fieldStructureType = _.get(fieldStructure, 'uiField.fieldTemplate.type'),
            isRowRepeater = fieldStructureType === fieldType.ROWREPEATER;
          if (isRowRepeater) {
            result = fieldStructure;
            return false;
          }
        });
        return result;
      }
      function getPageSize(row) {
        var options = xmlUtil.parseString(row.repeaterField.options);
        if (options.rowsPerPage) {
          return parseInt(options.rowsPerPage);
        } else {
          return 0;
        }
      }
      _.each(sectionRows, function (row) {
        var fieldConfig,
          rowRepeaterConfig,
          titlebarHeight = 70,
          pagingHeight = 25,
          rowHeight,
          rowListHeight;
        if (row.rowRepeatable) {
          if (formRoot.isConfigurableForm) {
            rowRepeaterConfig = buildStaticRepeatingRowList(row);
          } else {
            rowRepeaterConfig = buildRepeatingRowList(row);
          }
          var rowFieldStructure = getRowRepeaterFieldStructure(row);
          rowRepeater = {
            rootFormId: rootFormId,
            rowStructureId: rootFormId + '-' + row.id,
            parentFormStructure: formRoot,
            parentUiFormTemplate: formRoot.uiFormTemplate,
            parentForm: formRoot.formModel,
            rowRepeaterId: row.id,
            repeating: true,
            repeaterFieldStructure: getRowRepeaterField(rowRepeaterConfig.repeatingRowList),
            rowRepeaterName: rowRepeaterUtil.getRowRepeaterName(rowFieldStructure),
            rowTemplate: row,
            rowList: rowRepeaterConfig.repeatingRowList,
            pageSize: getPageSize(row),
            sort: {
              sortKey: 'rowNumber',
              sortType: 'asc'
            },
            rowIdentifier: 'rowRepeater:' + row.id
          };
          rowHeight = rowRepeaterConfig.rowHeight;
          rowListHeight = rowHeight * rowRepeater.rowList.length;
          pagingHeight = rowRepeater.rowList.length > rowRepeater.pageSize ? pagingHeight : 0;
          rowRepeater.rowHeight = titlebarHeight + rowListHeight + pagingHeight;
          totalSectionHeight += rowRepeater.rowHeight;
          rowList.push(rowRepeater);
          rowRepeaterMap[rowRepeater.rowRepeaterId] = rowRepeater;
        } else {
          fieldConfig = buildFieldStructureList(row.fields);
          rowList.push({
            rootFormId: rootFormId,
            rowStructureId: rootFormId + '-' + row.id,
            parentFormStructure: formRoot,
            parentUiFormTemplate: formRoot.uiFormTemplate,
            parentForm: formRoot.formModel,
            rowTemplate: row,
            fieldStructureList: fieldConfig.fieldStructureList,
            rowHeight: fieldConfig.rowHeight,
            rowIdentifier: 'fields:' + row.id
          });
          totalSectionHeight += fieldConfig.rowHeight;
        }
      });
      return {
        rowList: rowList,
        sectionHeight: totalSectionHeight
      };
    }
    function buildStaticRepeatingRowList(row) {
      var repeatingRowList = [],
        fieldConfig = buildFieldStructureList(row.fields, row, {
          rowNumber: 0
        }),
        maximumFieldHeight = fieldConfig.rowHeight;
      _.each(fieldConfig.fieldStructureList, function (fieldStructure) {
        fieldStructure.hideLabel = true;
      });
      repeatingRowList.push({
        parentForm: formRoot.formModel,
        parentFormStructure: formRoot,
        rootFormId: rootFormId,
        rowTemplate: row,
        rowModel: {
          rowNumber: 0
        },
        fieldStructureList: fieldConfig.fieldStructureList
      });
      return {
        rowHeight: maximumFieldHeight,
        repeatingRowList: repeatingRowList
      };
    }
    function buildRepeatingRowList(row) {
      var filteredRowInstanceList = _.filter(formRowInstanceList, {
          uiRowId: row.id
        }),
        repeatingRowList = [],
        fieldConfig,
        maximumFieldHeight = 100;
      _.each(filteredRowInstanceList, function (rowInstance) {
        fieldConfig = buildFieldStructureList(row.fields, row, rowInstance);
        maximumFieldHeight = fieldConfig.rowHeight;
        repeatingRowList.push({
          parentForm: formRoot.formModel,
          parentFormStructure: formRoot,
          rootFormId: rootFormId,
          rowTemplate: row,
          rowModel: rowInstance,
          fieldStructureList: fieldConfig.fieldStructureList
        });
      });
      if (repeatingRowList.length === 0) {
        fieldConfig = buildFieldStructureList(row.fields, row, {
          rowNumber: 0
        });
        maximumFieldHeight = fieldConfig.rowHeight;
        repeatingRowList.push({
          parentForm: formRoot.formModel,
          parentFormStructure: formRoot,
          rootFormId: rootFormId,
          rowTemplate: row,
          rowModel: {
            rowNumber: 0
          },
          fieldStructureList: fieldConfig.fieldStructureList
        });
      }
      return {
        rowHeight: maximumFieldHeight,
        repeatingRowList: repeatingRowList
      };
    }
    function buildFieldStructureList(rowFields, rowTemplate, rowModel) {
      var fieldStructureList = [],
        fieldStructure,
        isRowRepeater = rowModel && rowTemplate,
        maxFieldHeight = 32;
      _.each(rowFields, function (uiField) {
        var fieldModel;
        if (isRowRepeater) {
          fieldModel = _.find(fieldInstanceList, function (instance) {
            var isFieldMatch = instance.fieldTemplateId === uiField.fieldTemplate.id,
              isInstanceMatch = instance.rowId === rowModel.id;
            return isFieldMatch && isInstanceMatch;
          });
        } else {
          fieldModel = _.find(fieldInstanceList, {
            fieldTemplateId: uiField.fieldTemplate.id
          });
        }
        fieldStructure = {
          fieldStructureId: rootFormId + '-' + uiField.fieldTemplate.id,
          rootFormId: rootFormId,
          parentForm: formRoot.formModel,
          parentFormStructure: formRoot,
          parentUiFormTemplate: formRoot.uiFormTemplate,
          uiField: uiField,
          fieldModel: fieldModel,
          hasResponsiveLayout: formRoot.hasResponsiveLayout,
          indexedName: formComponentUtil.getIndexedFieldName(uiField, isRowRepeater, rowModel),
          originalVariableName: uiField.fieldTemplate.variableName,
          isConfigurableComponent: formRoot.isConfigurableForm
        };
        if (isRowRepeater) {
          fieldStructure.isRowRepeaterField = true;
          fieldStructure.fieldStructureId += '-' + rowModel.id;
          fieldStructure.rowNumber = rowModel.rowNumber;
          fieldStructure.rowInstanceId = rowModel.id;
          fieldStructure.rowRepeaterId = rowTemplate.id;
          fieldStructure.rowRepeaterName = rowRepeaterUtil.getRowRepeaterName(rowTemplate.repeaterField);
          fieldStructure.rowRepeaterModel = rowModel;
          fieldStructure.rowRepeaterTemplate = rowTemplate;
        }
        formComponentUtil.setupFieldProperties(fieldStructure, currencyCode);
        fieldStructureList.push(fieldStructure);
        if (previousFieldKey) {
          fieldMap.putAfter(previousFieldKey, fieldStructure.fieldStructureId, fieldStructure);
          previousFieldKey = fieldStructure.fieldStructureId;
        } else {
          fieldMap.put(fieldStructure.fieldStructureId, fieldStructure);
        }
        if (fieldStructure.layout.height > maxFieldHeight) {
          maxFieldHeight = fieldStructure.layout.height;
        }
      });
      return {
        rowHeight: maxFieldHeight,
        fieldStructureList: fieldStructureList
      };
    }
    formConfig = buildSections(sourceForm.sections);
    formRoot.formName = formatUtil.formatAsSelector(formRoot.formModel.formTemplateUniqueName);
    formRoot.sectionList = formConfig.sectionList;
    formRoot.formHeight = formConfig.formHeight;
    formRoot.rowIdentifier = 'form:' + formRoot.formModel.id;
    $timeout(function () {
      defer.resolve(formRoot);
    }, 1, false);
    return defer.promise;
  };
  this.createField = function (formViewerInstance, rootFormId, dropConfiguration, skipFieldInsertion) {
    var isRowRepeater = false,
      currencyCode = null,
      uiField = dropConfiguration.uiField,
      newFieldId = uuidUtil.generateUUID(),
      newFieldStructure,
      firstAvailableRowInForm;
    function getFirstRowInForm(sectionList) {
      var result = null;
      _.each(sectionList, function (section) {
        if (result) {
          return false;
        } else {
          _.each(section.rowList, function (row) {
            if (row.repeating) {
              result = row.rowList[0];
            } else {
              result = row;
            }
            return false;
          });
        }
      });
      return result;
    }
    firstAvailableRowInForm = getFirstRowInForm(formViewerInstance.formStructure.sectionList);
    newFieldStructure = {
      fieldStructureId: rootFormId + '-' + newFieldId,
      rootFormId: rootFormId,
      parentForm: formViewerInstance.formStructure.formModel,
      parentFormStructure: formViewerInstance.formStructure,
      parentUiFormTemplate: formViewerInstance.formStructure.uiFormTemplate,
      uiField: uiField,
      fieldModel: null,
      hasResponsiveLayout: formViewerInstance.formStructure.hasResponsiveLayout,
      indexedName: formComponentUtil.getIndexedFieldName(uiField, isRowRepeater, null),
      originalVariableName: uiField.fieldTemplate.variableName,
      isConfigurableComponent: true,
      hideLabel: uiField.hideLabel
    };
    formComponentUtil.setupFieldProperties(newFieldStructure, currencyCode);
    if (!skipFieldInsertion) {
      firstAvailableRowInForm.fieldStructureList.push(newFieldStructure);
    }
    formViewerInstance.fieldMap.put(newFieldStructure.fieldStructureId, newFieldStructure);
    return newFieldStructure;
  };
  this.createSection = function (formViewerInstance, rootFormId, dropConfiguration) {
    var uiSection = dropConfiguration.uiSection,
      newSectionStructure,
      uiRow = uiSection.rows[0],
      newSectionId = uuidUtil.generateUUID(),
      newRowId = uuidUtil.generateUUID(),
      labelUiField = uiRow.fields[0],
      skipFieldInsertion = true,
      labelFieldStructure = this.createField(formViewerInstance, rootFormId, {
        uiField: labelUiField
      }, skipFieldInsertion);
    uiSection.uiFormTemplateId = parseInt(rootFormId);
    newSectionStructure = {
      rootFormId: rootFormId,
      sectionStructureId: rootFormId + '-' + newSectionId,
      sectionTemplate: uiSection,
      rowList: [{
        rootFormId: rootFormId,
        parentFormStructure: formViewerInstance.formStructure,
        parentUiFormTemplate: formViewerInstance.formStructure.uiFormTemplate,
        parentForm: formViewerInstance.formStructure.formModel,
        rowTemplate: uiRow,
        fieldStructureList: [labelFieldStructure],
        rowHeight: 100,
        rowIdentifier: 'uiRow:' + newRowId
      }],
      sectionHeight: 100,
      parentUiFormTemplate: formViewerInstance.formStructure.uiFormTemplate
    };
    formViewerInstance.formStructure.sectionList.unshift(newSectionStructure);
    return newSectionStructure;
  };
  this.getRowRepeaterField = function (rowList) {
    var result = null,
      fieldStructureList = _.last(rowList).fieldStructureList;
    _.each(fieldStructureList, function (fieldStructure) {
      var fieldStructureType = _.get(fieldStructure, 'uiField.fieldTemplate.type'),
        isRowRepeater = fieldStructureType === fieldType.ROWREPEATER;
      if (isRowRepeater) {
        result = fieldStructure;
        return false;
      }
    });
    return result;
  };
  this.createRowRepeater = function (formViewerInstance, rootFormId, dropConfiguration) {
    var uiRow = dropConfiguration.uiRow,
      skipFieldInsertion = true,
      rowStructure,
      rowList,
      newRowId = uuidUtil.generateUUID();
    function createFieldStructureList() {
      var _this = this;
      var fieldStructureList = [];
      _.each(uiRow.fields, function (uiField) {
        var fieldStructure = _this.createField(formViewerInstance, rootFormId, {
          uiField: uiField
        }, skipFieldInsertion);
        fieldStructureList.push(fieldStructure);
      });
      return fieldStructureList;
    }
    rowList = [{
      parentForm: formViewerInstance.formStructure.formModel,
      parentFormStructure: formViewerInstance.formStructure,
      rootFormId: rootFormId,
      rowTemplate: uiRow,
      rowModel: {
        rowNumber: 0
      },
      fieldStructureList: createFieldStructureList.call(this)
    }];
    rowStructure = {
      rootFormId: rootFormId,
      rowStructureId: rootFormId + '-' + newRowId,
      parentFormStructure: formViewerInstance.formStructure,
      parentUiFormTemplate: formViewerInstance.formStructure.uiFormTemplate,
      parentForm: formViewerInstance.formStructure.formModel,
      rowRepeaterId: uiRow.id,
      rowRepeaterName: 'newRowRepeater-' + newRowId,
      repeaterFieldStructure: this.getRowRepeaterField(rowList),
      rowTemplate: uiRow,
      pageSize: 1,
      repeating: true,
      configurable: true,
      sort: {
        sortKey: 'rowNumber',
        sortType: 'asc'
      },
      rowHeight: 100,
      rowIdentifier: 'uiRow:' + newRowId,
      rowList: rowList
    };
    formViewerInstance.rowRepeaterMap[rowStructure.rowRepeaterId] = rowStructure;
    formViewerInstance.formStructure.sectionList[0].rowList.unshift(rowStructure);
    return rowStructure;
  };
};
FormStructureUtil.$inject = ["$q", "$timeout", "fieldType", "formViewerUtil", "xmlUtil", "formComponentUtil", "formatUtil", "uuidUtil", "rowRepeaterUtil"];
angular.module('umFormViewer').service('formStructureUtil', FormStructureUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var LinkedHashMap = __webpack_require__(1242);

/*@ngInject*/
var FormViewerModel = function FormViewerModel($rootScope, $q, $timeout, fieldType, formComponentUtil, formStructureUtil, formViewerConstant, rowRepeaterUtil, supplementalFormUtil, formViewerUtil, formatUtil, formConfigurationUtil) {
  var formViewerModel = {};
  function reset(rootFormId) {
    var formViewerInstance;
    formViewerModel[rootFormId] = {
      formStructure: {},
      rowRepeaterMap: {},
      formIdList: [],
      fieldMap: null
    };
    formViewerInstance = formViewerModel[rootFormId];
    if (!formViewerInstance.fieldMap) {
      formViewerInstance.fieldMap = new LinkedHashMap();
    }
    formViewerInstance.fieldMap.clear();
  }
  function deleteSupplementalForm(supplementalForm, rootFormId) {
    var formViewerInstance = formViewerModel[rootFormId],
      sectionList = formViewerInstance.formStructure.sectionList,
      fieldMap = formViewerInstance.fieldMap,
      supplementalFormIdIndex = formViewerInstance.formIdList.indexOf(parseInt(supplementalForm.id));
    formViewerInstance.formIdList.splice(supplementalFormIdIndex, 1);
    supplementalFormUtil.deleteSupplementalForm(supplementalForm, sectionList, fieldMap);
  }
  function insertSupplementalForm(supplementalForm, rootFormId) {
    var formViewerInstance = formViewerModel[rootFormId],
      sectionList = formViewerInstance.formStructure.sectionList;
    formViewerInstance.formIdList.push(parseInt(supplementalForm.formModel.id));
    supplementalFormUtil.insertSupplementalForm(supplementalForm, sectionList);
  }
  function buildFormStructure(rootFormId, sourceForm, fieldInstanceList, formSummaryList, formRowInstanceList, hasWriteAccess, sectionList, printPreview, currencyCode, isConfigurableForm) {
    var formViewerInstance = formViewerModel[rootFormId],
      rowRepeaterMap = formViewerInstance.rowRepeaterMap,
      fieldMap = formViewerInstance.fieldMap;
    return formStructureUtil.buildFormStructure(rootFormId, sourceForm, fieldInstanceList, formSummaryList, formRowInstanceList, hasWriteAccess, rowRepeaterMap, fieldMap, null, printPreview, currencyCode, isConfigurableForm);
  }
  this.buildForm = function (rootFormId, uiFormTemplateList, fieldInstanceList, formSummaryList, formRowInstanceList, hasWriteAccess, printPreview, snippets, effectiveDate, currencyCode) {
    var _this = this;
    var promiseList = [],
      formRoot = uiFormTemplateList[0],
      formViewerInstance,
      sectionList,
      rowRepeaterMap,
      supplementalFormList = _.filter(uiFormTemplateList, function (uiFormTemplate) {
        return uiFormTemplate.precedingFieldFormTemplateUniqueName && uiFormTemplate.precedingFieldVariableName;
      }),
      isConfigurableForm = false;
    reset(rootFormId);
    formViewerInstance = formViewerModel[rootFormId];
    formViewerInstance.formIdList.push(parseInt(rootFormId));
    sectionList = formViewerInstance.formStructure.sectionList;
    rowRepeaterMap = formViewerInstance.rowRepeaterMap;
    promiseList.push(buildFormStructure(rootFormId, formRoot, fieldInstanceList, formSummaryList, formRowInstanceList, hasWriteAccess, null, printPreview, currencyCode, isConfigurableForm).then(function (rootFormStructure) {
      formViewerInstance.formStructure = rootFormStructure;
      formViewerInstance.formStructure.isAcordUpload = snippets.length > 0;
      formViewerInstance.formStructure.snippetList = snippets;
      formViewerInstance.formStructure.effectiveDate = parseInt(effectiveDate);
      formViewerInstance.formStructure.currencyCode = currencyCode;
    }));
    _.each(supplementalFormList, function (supplementalFormRoot) {
      promiseList.push(buildFormStructure(rootFormId, supplementalFormRoot, fieldInstanceList, formSummaryList, formRowInstanceList, hasWriteAccess, sectionList, printPreview, currencyCode).then(function (supplementalFormRootStructure) {
        supplementalFormRootStructure.parentForm = formViewerInstance.formStructure;
        supplementalFormRootStructure.autoHeight = true;
        insertSupplementalForm(supplementalFormRootStructure, rootFormId);
      }));
    });
    _.each(rowRepeaterMap, function (repeater) {
      _this.processCollapsibleColumnsAndVisibility(repeater.rowRepeaterId, rootFormId);
    });
    $q.all(promiseList).then(function () {
      $rootScope.$broadcast(formViewerConstant.event.FORM_STRUCTURE_CHANGED, rootFormId);
    });
  };
  this.buildStaticForm = function (uiFormTemplateId, uiFormTemplate, hasManageFormsRole) {
    var formViewerInstanceKey = uiFormTemplateId,
      formViewerInstance,
      fieldInstanceList = [],
      formSummaryList = [{
        root: true,
        id: uiFormTemplate.id,
        formTemplateId: uiFormTemplate.formTemplate.id,
        formTemplateUniqueName: uiFormTemplate.formTemplate.uniqueName
      }],
      formRowInstanceList = [],
      hasWriteAccess = hasManageFormsRole,
      printPreview = false,
      currencyCode = null,
      isConfigurableForm = true;
    reset(formViewerInstanceKey);
    formViewerInstance = formViewerModel[formViewerInstanceKey];
    buildFormStructure(formViewerInstanceKey, uiFormTemplate, fieldInstanceList, formSummaryList, formRowInstanceList, hasWriteAccess, null, printPreview, currencyCode, isConfigurableForm).then(function (rootFormStructure) {
      formViewerInstance.formStructure = rootFormStructure;
      $rootScope.$broadcast(formViewerConstant.event.FORM_STRUCTURE_CHANGED, formViewerInstanceKey);
    });
  };
  this.moveField = function (rootFormId, elementToMoveId, dropZoneFieldId, moveType) {
    var formViewerInstance = formViewerModel[rootFormId],
      result = formConfigurationUtil.moveField(formViewerInstance, elementToMoveId, dropZoneFieldId, moveType);
    $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
    return result;
  };
  this.createField = function (rootFormId, dropConfiguration, dropZoneFieldId) {
    var formViewerInstance = formViewerModel[rootFormId],
      newFieldStructure = formStructureUtil.createField(formViewerInstance, rootFormId, dropConfiguration);
    $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
    return this.moveField(rootFormId, newFieldStructure.fieldStructureId, dropZoneFieldId, dropConfiguration.dropType);
  };
  this.createSection = function (rootFormId, dropConfiguration, dropZoneFieldId, insertLocation) {
    var formViewerInstance = formViewerModel[rootFormId],
      newSectionStructure = formStructureUtil.createSection(formViewerInstance, rootFormId, dropConfiguration);
    $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
    return this.moveSection(rootFormId, newSectionStructure.sectionStructureId, dropZoneFieldId, insertLocation);
  };
  this.createRowRepeater = function (rootFormId, dropConfiguration, dropZoneRowId, insertLocation) {
    var formViewerInstance = formViewerModel[rootFormId],
      newRowStructure = formStructureUtil.createRowRepeater(formViewerInstance, rootFormId, dropConfiguration);
    $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
    return this.moveRow(rootFormId, newRowStructure.rowStructureId, dropZoneRowId, insertLocation);
  };
  this.moveSection = function (rootFormId, elementToMoveSectionId, dropZoneSectionId, moveType) {
    var formViewerInstance = formViewerModel[rootFormId],
      result = formConfigurationUtil.moveSection(formViewerInstance, elementToMoveSectionId, dropZoneSectionId, moveType);
    $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
    return result;
  };
  this.moveRow = function (rootFormId, elementToMoveRowId, dropZoneRowId, moveType) {
    var formViewerInstance = formViewerModel[rootFormId],
      result = formConfigurationUtil.moveRow(formViewerInstance, elementToMoveRowId, dropZoneRowId, moveType);
    $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
    return result;
  };
  this.deleteField = function (rootFormId, formStructureId) {
    var formViewerInstance = formViewerModel[rootFormId];
    formConfigurationUtil.deleteField(formViewerInstance, formStructureId);
    $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
  };
  this.deleteSection = function (rootFormId, sectionStructureId) {
    var formViewerInstance = formViewerModel[rootFormId];
    formConfigurationUtil.deleteSection(formViewerInstance, sectionStructureId);
    $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
  };
  this.deleteRow = function (rootFormId, rowStructureId) {
    var formViewerInstance = formViewerModel[rootFormId];
    formConfigurationUtil.deleteRow(formViewerInstance, rowStructureId);
    $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
  };
  this.addSupplementalForm = function (rootFormId, uiFormTemplateList, fieldInstanceList, formSummaryList, formRowInstanceList, hasWriteAccess, printPreview) {
    var formViewerInstance = formViewerModel[rootFormId];
    if (!_.isNil(formViewerInstance)) {
      var formRoot = uiFormTemplateList[0];
      var formIdList = formViewerInstance.formIdList;
      var supplementalExists = formIdList.indexOf(formSummaryList[0].id) !== -1;
      var currencyCode = formViewerInstance.formStructure.currencyCode;
      if (!supplementalExists) {
        var maxTryCount = 5,
          currentTryCount = 0;
        function buildSupplementalFormStructure() {
          var formViewerInstance = formViewerModel[rootFormId];
          var supplementalUiFormTemplate = uiFormTemplateList[0];
          var rootFormSectionList = formViewerInstance.formStructure.sectionList;
          var precedingFieldVariableName = supplementalUiFormTemplate.precedingFieldVariableName;
          var precedingFieldFormTemplateUniqueName = supplementalUiFormTemplate.precedingFieldFormTemplateUniqueName;
          var hasPrecedingFieldForm = supplementalFormUtil.doesPrecedingFormExist(precedingFieldVariableName, precedingFieldFormTemplateUniqueName, rootFormSectionList);
          if (hasPrecedingFieldForm) {
            buildFormStructure(rootFormId, formRoot, fieldInstanceList, formSummaryList, formRowInstanceList, hasWriteAccess, null, printPreview, currencyCode).then(function (supplementalFormRootStructure) {
              var formTemplateUniqueName = formatUtil.formatAsSelector(supplementalFormRootStructure.formModel.formTemplateUniqueName);
              supplementalFormRootStructure.parentForm = formViewerInstance.formStructure;
              supplementalFormRootStructure.autoHeight = false;
              insertSupplementalForm(supplementalFormRootStructure, rootFormId);
              $rootScope.$broadcast(formViewerConstant.event.FORM_STRUCTURE_CHANGED);
              $rootScope.$broadcast(formViewerConstant.event.SUPPLEMENTAL_FORM_ADDED, formTemplateUniqueName, supplementalFormRootStructure);
            });
          } else {
            if (currentTryCount < maxTryCount) {
              $timeout(function () {
                currentTryCount += 1;
                buildSupplementalFormStructure();
              }, 500);
            } else {
              console.log('Unable to find preceding row when adding supplemental');
            }
          }
        }
        buildSupplementalFormStructure();
      }
    }
  };
  this.deleteSupplementalForm = function (supplementalForm, rootFormId) {
    var formViewerInstance = formViewerModel[rootFormId],
      formIdList = formViewerInstance.formIdList,
      supplementalExists = formIdList.indexOf(supplementalForm.id) !== -1;
    if (supplementalExists) {
      deleteSupplementalForm(supplementalForm, rootFormId);
      $rootScope.$broadcast(formViewerConstant.event.FORM_STRUCTURE_CHANGED);
    }
    return supplementalExists;
  };
  this.processRemoteRowDeletion = function (message, rootFormId) {
    var formViewerInstance = formViewerModel[rootFormId],
      rowRepeaterMap = formViewerInstance.rowRepeaterMap,
      fieldMap = formViewerInstance.fieldMap;
    rowRepeaterUtil.processRemoteRowDeletion(message, rowRepeaterMap, fieldMap);
  };
  this.processRemoteRowAddition = function (rowTemplateId, rowInstance, rootFormId) {
    var formViewerInstance = formViewerModel[rootFormId],
      rowRepeaterMap = formViewerInstance.rowRepeaterMap,
      fieldMap = formViewerInstance.fieldMap;
    rowRepeaterUtil.processRemoteRowAddition(rowTemplateId, rowInstance, rowRepeaterMap, fieldMap, rootFormId, formStructureUtil);
  };
  this.processRemoteRowUpdate = function (rowTemplateId, rowInstance, rootFormId) {
    var formViewerInstance = formViewerModel[rootFormId],
      rowRepeaterMap = formViewerInstance.rowRepeaterMap;
    rowRepeaterUtil.processRemoteRowUpdate(rowTemplateId, rowInstance, rowRepeaterMap);
  };
  this.sortRowRepeater = function (rootFormId, rowRepeaterId, sortKey, sortType) {
    var formViewerInstance = formViewerModel[rootFormId],
      rowRepeaterMap = formViewerInstance.rowRepeaterMap;
    rowRepeaterUtil.sortRowRepeater(rowRepeaterId, sortKey, sortType, rowRepeaterMap);
  };
  this.processCollapsibleColumnsAndVisibility = function (rowRepeaterId, rootFormId) {
    var formViewerInstance = formViewerModel[rootFormId],
      rowRepeaterMap = formViewerInstance.rowRepeaterMap;
    rowRepeaterUtil.processCollapsibleColumnsAndVisibility(rowRepeaterId, rowRepeaterMap);
  };
  this.processRootFormUpdate = function (form, rootFormId) {
    var formViewerInstance = formViewerModel[rootFormId];
    var isValidUpdate = formViewerInstance.formStructure.formModel.lastModificationDate <= form.lastModificationDate;
    var hasRequiredFieldLevelChange = formViewerInstance.formStructure.formModel.requiredFieldLevel !== form.requiredFieldLevel;
    var hasEditableFieldLevelChange = formViewerInstance.formStructure.formModel.editableFieldLevel !== form.editableFieldLevel;
    var hasReadOnlyChange = formViewerInstance.formStructure.formModel.readOnly !== form.readOnly;
    if (isValidUpdate) {
      if (hasRequiredFieldLevelChange || hasEditableFieldLevelChange || hasReadOnlyChange) {
        $rootScope.$broadcast(formViewerConstant.event.RELOAD_FORM);
      } else {
        formViewerInstance.formStructure.formModel = form;
        $timeout(function () {}, 0);
      }
    }
  };
  this.processFieldUpdate = function (fieldModel, rootFormId) {
    this.processFieldEvent(fieldModel, rootFormId);
  };
  this.processFieldDelete = function (fieldModel, rootFormId) {
    this.processFieldEvent(fieldModel, rootFormId, true /*isDeleteEvent*/);
  };
  this.processFieldRename = function (fieldModel, rootFormId) {
    this.processFieldEvent(fieldModel, rootFormId, false);
  };
  this.processFieldEvent = function (fieldModel, rootFormId, isDeleteEvent) {
    var localField,
      parentRowRepeater,
      formViewerInstance = formViewerModel[rootFormId],
      rowRepeaterMap = formViewerInstance.rowRepeaterMap,
      fieldMap = formViewerInstance.fieldMap;
    if (fieldModel.rowId) {
      localField = fieldMap.get(rootFormId + '-' + fieldModel.fieldTemplateId + '-' + fieldModel.rowId);
      if (localField) {
        localField.fieldModel = isDeleteEvent ? null : fieldModel;
        formComponentUtil.setupFieldProperties(localField);
        parentRowRepeater = rowRepeaterMap[localField.rowRepeaterId];
        parentRowRepeater.timeLastModified = fieldModel.timeLastModified;
        this.processCollapsibleColumnsAndVisibility(localField.rowRepeaterId, rootFormId);
      }
    } else {
      localField = fieldMap.get(rootFormId + '-' + fieldModel.fieldTemplateId);
      if (localField) {
        localField.fieldModel = isDeleteEvent ? null : fieldModel;
        formComponentUtil.setupFieldProperties(localField);
      }
    }
    $timeout(function () {}, 0);
  };
  this.updateFieldStructureConfiguration = function (componentStructure, suppressFormEvents) {
    var rootFormId = componentStructure.rootFormId,
      formViewerInstance = formViewerModel[rootFormId],
      currencyCode = formViewerInstance.formStructure.currencyCode,
      isRowRepeater = componentStructure.repeating,
      isRowRepeaterField = componentStructure.isRowRepeaterField;
    function updateRowRepeaterStructure(repeaterRowStructure) {
      var rowRepeaterFieldIndex = _.findIndex(repeaterRowStructure.rowTemplate.fields, function (uiField) {
        return uiField.fieldTemplate.type === fieldType.ROWREPEATER;
      });
      repeaterRowStructure.rowRepeaterName = rowRepeaterUtil.getRowRepeaterName(repeaterRowStructure.rowTemplate.repeaterField);
      repeaterRowStructure.repeaterFieldStructure.uiField = repeaterRowStructure.rowTemplate.repeaterField;
      formComponentUtil.setupFieldProperties(repeaterRowStructure.repeaterFieldStructure, currencyCode);
      repeaterRowStructure.rowTemplate.fields[rowRepeaterFieldIndex] = repeaterRowStructure.rowTemplate.repeaterField;
      $rootScope.$broadcast(formViewerConstant.configuration.event.UPDATE_ROW_REPEATER_SETTING, repeaterRowStructure);
    }
    if (isRowRepeaterField) {
      componentStructure.hideLabel = formViewerInstance.formStructure.isConfigurableForm;
    }
    if (isRowRepeater) {
      updateRowRepeaterStructure(componentStructure);
    } else {
      formComponentUtil.setupFieldProperties(componentStructure, currencyCode);
      $rootScope.$broadcast(formViewerConstant.configuration.event.UPDATE_COMPONENT_SETTING, componentStructure);
    }
    if (suppressFormEvents !== true) {
      $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
    }
  };
  this.getFormStructure = function (rootFormId) {
    var form = formViewerModel[rootFormId] || {};
    return form.formStructure;
  };
  this.getFieldMap = function (rootFormId) {
    return formViewerModel[rootFormId].fieldMap;
  };
  this.shouldProcessForm = function (rootFormId, eventFormId) {
    var formViewerInstance = formViewerModel[rootFormId],
      formIdList = formViewerInstance.formIdList;
    return formIdList.indexOf(eventFormId) !== -1;
  };
  this.resetForm = function (rootFormId) {
    formViewerModel[rootFormId] = null;
  };
};
FormViewerModel.$inject = ["$rootScope", "$q", "$timeout", "fieldType", "formComponentUtil", "formStructureUtil", "formViewerConstant", "rowRepeaterUtil", "supplementalFormUtil", "formViewerUtil", "formatUtil", "formConfigurationUtil"];
angular.module('umFormViewer').service('formViewerModel', FormViewerModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _superPropGet(t, e, o, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), e, o); return 2 & r && "function" == typeof p ? function (t) { return p.apply(o, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var HashMap = __webpack_require__(1243);
var LinkedHashMap = /*#__PURE__*/function (_HashMap) {
  _inherits(LinkedHashMap, _HashMap);
  var _super = _createSuper(LinkedHashMap);
  function LinkedHashMap() {
    var _this;
    _classCallCheck(this, LinkedHashMap);
    _this = _super.call(this);

    // 'inner' Entry class
    _this._Entry = function (value) {
      this.prev = null;
      this.next = null;
      this.value = value;
    };

    // doubly linkedlist instance variables
    _this._head = _this._tail = null;
    return _this;
  }

  /**
   * Puts the key/value pair in the HashMap and records
   * the insertion record if it does not exist.
   *
   * @override HashMap.put()
   */
  _createClass(LinkedHashMap, [{
    key: "put",
    value: function put(key, value) {
      var entry = new this._Entry(key);
      if (!this.containsKey(key)) {
        if (this.size() === 0) {
          this._head = entry;
          this._tail = entry;
        } else {
          this._tail.next = entry;
          entry.prev = this._tail;
          this._tail = entry;
        }
      }

      /*
       * EDIT: Added optimization suggested
       * by Chad Walker (see article comments).
       */
      // overwrite the value with an optimized Object wrapper
      value = {
        value: value,
        entry: entry
      };
      _superPropGet(LinkedHashMap, "put", this, 3)([key, value]);
    }
  }, {
    key: "putAfter",
    value: function putAfter(startKey, key, value) {
      var entry = new this._Entry(key);
      if (!this.containsKey(key)) {
        var startValue = this.getEntry(startKey);
        if (!startValue || this.size === 0) {
          this.put(key, value);
          return false;
        } else {
          var startEntry = startValue.entry;
          entry.prev = startEntry;
          entry.next = startEntry.next;
          startEntry.next = entry;
          if (this._tail === startEntry) {
            this._tail = entry;
          }
        }
      }
      value = {
        value: value,
        entry: entry
      };
      _superPropGet(LinkedHashMap, "put", this, 3)([key, value]);
    }
  }, {
    key: "getEntry",
    value: function getEntry(key) {
      return _superPropGet(LinkedHashMap, "get", this, 3)([key]);
    }
  }, {
    key: "get",
    /**
     * Returns the value associated with the key.
     *
     * @override HashMap.get()
     */
    value: function get(key) {
      var value = _superPropGet(LinkedHashMap, "get", this, 3)([key]);

      /*
       * EDIT: Added optimization suggested
       * by Chad Walker (see article comments).
       */
      // we must unwrap the value
      return value !== null ? value.value : null;
    }
  }, {
    key: "remove",
    /**
     * Removes the key/value pair from the map and
     * the key from the insertion order.
     *
     * @override Hashmap.remove()
     */
    value: function remove(key) {
      /*
       * EDIT: Added optimization suggested
       * by Chad Walker (see article comments).
       */
      var value = _superPropGet(LinkedHashMap, "remove", this, 3)([key]);
      if (value !== null) {
        var entry = value.entry;
        if (entry === this._head) {
          this._head = entry.next;
          this._head.prev = null;
        } else if (entry === this._tail) {
          this._tail = entry.prev;
          this._tail.next = null;
        } else if (entry.next && entry.prev) {
          entry.prev.next = entry.next;
          entry.next.prev = entry.prev;
        }
      }
      return value;
    }
  }, {
    key: "clear",
    /**
     * Clears the HashMap and insertion order.
     *
     * @override HashMap.clear()
     */
    value: function clear() {
      _superPropGet(LinkedHashMap, "clear", this, 3)([]);
      this._head = this._tail = null;
    }
  }, {
    key: "keys",
    /**
     * Returns the HashMap keys in insertion order.
     *
     * @override HashMap.keys()
     */
    value: function keys() {
      var keys = [];
      for (var cur = this._head; cur !== null; cur = cur.next) {
        keys.push(cur.value);
      }
      return keys;
    }
  }, {
    key: "values",
    /**
     * Returns the HashMap values in insertion order.
     *
     * @override HashMap.values()
     */
    value: function values() {
      var values = [];
      for (var cur = this._head; cur !== null; cur = cur.next) {
        values.push(this.get(cur.value));
      }
      return values;
    }
  }]);
  return LinkedHashMap;
}(HashMap);
module.exports = LinkedHashMap;

/***/ }),
/* 1243 */
/***/ (function(module, exports) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var HashMap = /*#__PURE__*/function () {
  function HashMap() {
    _classCallCheck(this, HashMap);
    this._size = 0;
    this._map = {};
  }

  /**
   * Puts the key/value pair into the map, overwriting
   * any existing entry.
   */
  _createClass(HashMap, [{
    key: "put",
    value: function put(key, value) {
      if (!this.containsKey(key)) {
        this._size++;
      }
      this._map[key] = value;
    }
    /**
     * Removes the entry associated with the key
     * and returns the removed value.
     */
  }, {
    key: "remove",
    value: function remove(key) {
      if (this.containsKey(key)) {
        this._size--;
        var value = this._map[key];
        delete this._map[key];
        return value;
      } else {
        return null;
      }
    }
    /**
     * Checks if this map contains the given key.
     */
  }, {
    key: "containsKey",
    value: function containsKey(key) {
      return this._map.hasOwnProperty(key);
    }
    /**
     * Checks if this map contains the given value.
     * Note that values are not required to be unique.
     */
  }, {
    key: "containsValue",
    value: function containsValue(value) {
      for (var key in this._map) {
        if (this._map.hasOwnProperty(key)) {
          if (this._map[key] === value) {
            return true;
          }
        }
      }
      return false;
    }
    /**
     * Returns the value associated with the given key.
     */
  }, {
    key: "get",
    value: function get(key) {
      return this.containsKey(key) ? this._map[key] : null;
    }
    /**
     * Clears all entries from the map.
     */
  }, {
    key: "clear",
    value: function clear() {
      this._size = 0;
      this._map = {};
    }
    /**
     * Returns an array of all keys in the map.
     */
  }, {
    key: "keys",
    value: function keys() {
      var keys = [];
      for (var key in this._map) {
        if (this._map.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
      return keys;
    }
    /**
     * Returns an array of all values in the map.
     */
  }, {
    key: "values",
    value: function values() {
      var values = [];
      for (var key in this._map) {
        if (this._map.hasOwnProperty(key)) {
          values.push(this._map[key]);
        }
      }
      return values;
    }
    /**
     * Returns the size of the map, which is
     * the number of keys.
     */
  }, {
    key: "size",
    value: function size() {
      return this._size;
    }
  }]);
  return HashMap;
}();
module.exports = HashMap;

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

angular.module('umFormViewer').constant('rowRepeaterRowListComparisonResultConstant', {
  EQUAL: 'equal',
  ONE_ROW_ADDED: 'oneRowAdded',
  MORE_THAN_ONE_ROW_ADDED: 'moreThanOneRowAdded',
  ROWS_REMOVED: 'rowsRemoved',
  CONTENTS_CHANGED: 'contentsChanged'
});

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var RowRepeaterUtil = function RowRepeaterUtil(formComponentUtil, formViewerUtil, formatUtil, appTypeConfigurationModel, fieldType, rowRepeaterRowListComparisonResultConstant) {
  this.processCollapsibleColumnsAndVisibility = function (rowRepeaterId, rowRepeaterMap) {
    var rowRepeater = rowRepeaterMap[rowRepeaterId],
      columnList = {},
      variableName,
      totalVisibleRows,
      rowHiddenForUserType = appTypeConfigurationModel.isUnderwriterWorkstation() ? !rowRepeater.rowTemplate.repeaterField.fieldTemplate.carrierVisible : !rowRepeater.rowTemplate.repeaterField.fieldTemplate.agencyVisible;
    if (_.size(rowRepeater.rowList) !== 0) {
      _.each(rowRepeater.rowList[0].fieldStructureList, function (fieldStructure) {
        variableName = fieldStructure.uiField.fieldTemplate.variableName;
        columnList[variableName] = true;
      });
      _.each(rowRepeater.rowList, function (row) {
        _.each(row.fieldStructureList, function (fieldStructure) {
          if (!formComponentUtil.isFieldHidden(fieldStructure.fieldModel, fieldStructure.uiField.fieldTemplate)) {
            variableName = fieldStructure.uiField.fieldTemplate.variableName;
            columnList[variableName] = false;
          }
        });
      });
      _.each(rowRepeater.rowList, function (row) {
        _.each(row.fieldStructureList, function (fieldStructure) {
          variableName = fieldStructure.uiField.fieldTemplate.variableName;
          fieldStructure.columnName = variableName;
          fieldStructure.isColumnCollapsed = columnList[variableName];
        });
      });
    }
    totalVisibleRows = _.filter(columnList, function (item) {
      return item === false;
    }).length;
    rowRepeater.isHidden = rowRepeater.configurable ? false : rowHiddenForUserType || totalVisibleRows === 1;
  };
  this.processRemoteRowAddition = function (rowTemplateId, rowInstance, rowRepeaterMap, fieldMap, rootFormId) {
    var _this = this;
    var rowRepeater = rowRepeaterMap[rowTemplateId],
      rowRepeaterId = rowInstance.uiRowId,
      parentForm = rowRepeaterMap[rowRepeaterId].parentForm;
    var buildFieldStructureList = function buildFieldStructureList(rowFields, rowInstanceId) {
      var fieldStructureList = [],
        fieldStructure;
      var previousFieldKey = null;
      var previousRow = rowRepeater.rowList[rowRepeater.rowList.length - 1];
      if (previousRow) {
        previousFieldKey = formViewerUtil.findLastFieldInPreviousRowKey(previousRow);
      }
      _.each(rowFields, function (uiField) {
        fieldStructure = {
          isRowRepeaterField: true,
          fieldStructureId: rootFormId + '-' + uiField.fieldTemplate.id + '-' + rowInstance.id,
          rootFormId: rootFormId,
          parentForm: parentForm,
          uiField: uiField,
          fieldModel: undefined,
          rowNumber: rowInstance.rowNumber,
          rowInstanceId: rowInstanceId,
          rowRepeaterId: rowRepeaterId,
          rowRepeaterName: _this.getRowRepeaterName(rowRepeater.rowTemplate.repeaterField),
          rowRepeaterModel: rowInstance,
          rowRepeaterTemplate: rowRepeater.rowTemplate,
          indexedName: formComponentUtil.getIndexedFieldName(uiField, true, rowInstance)
        };
        formComponentUtil.setupFieldProperties(fieldStructure);
        fieldStructureList.push(fieldStructure);
        var fieldKey = rootFormId + '-' + uiField.fieldTemplate.id + '-' + rowInstanceId;
        if (previousFieldKey) {
          fieldMap.putAfter(previousFieldKey, fieldKey, fieldStructure);
        } else {
          fieldMap.put(fieldKey, fieldStructure);
        }
        previousFieldKey = fieldKey;
      });
      return fieldStructureList;
    };

    // If the server creates a row and we already have a placeholder row, replace with the server representation
    if (rowInstance.rowNumber === 0 && rowRepeater.rowList.length > 0) {
      rowRepeater.rowList[0].parentForm = parentForm;
      rowRepeater.rowList[0].rowTemplate = rowRepeater.rowTemplate;
      rowRepeater.rowList[0].rowModel = rowInstance;
      rowRepeater.rowList[0].fieldStructureList = buildFieldStructureList(rowRepeater.rowTemplate.fields, rowInstance.id);
    } else {
      rowRepeater.rowList.push({
        parentForm: parentForm,
        rowTemplate: rowRepeater.rowTemplate,
        rowModel: rowInstance,
        fieldStructureList: buildFieldStructureList(rowRepeater.rowTemplate.fields, rowInstance.id)
      });
    }
    this.processCollapsibleColumnsAndVisibility(rowRepeaterId, rowRepeaterMap);
    rowRepeater.timeLastModified = new Date().getTime();
  };
  this.processRemoteRowUpdate = function (rowTemplateId, rowInstance, rowRepeaterMap) {
    var rowRepeaterId = rowTemplateId,
      rowRepeater = rowRepeaterMap[rowRepeaterId],
      rowList = rowRepeater.rowList;
    _.each(rowList, function (row) {
      if (row.rowModel.id === rowInstance.id) {
        row.rowModel = _.clone(rowInstance);
        _.each(row.fieldStructureList, function (fieldStructure) {
          var fieldName;
          fieldStructure.rowNumber = row.rowModel.rowNumber;
          fieldStructure.indexedName = formComponentUtil.getIndexedFieldName(fieldStructure.uiField, true, row.rowModel);
          if (!_.isNil(fieldStructure.fieldModel)) {
            fieldName = fieldStructure.fieldModel.baseName;
            if (fieldStructure.rowNumber > 0) {
              fieldName += ':' + fieldStructure.rowNumber;
            }
            fieldStructure.fieldModel.name = fieldName;
            fieldStructure.fieldModel.index = fieldStructure.rowNumber;
          }
        });
      }
    });
  };
  this.processRemoteRowDeletion = function (message, rowRepeaterMap, fieldMap) {
    var rowRepeaterId = message.uiRowId,
      rowRepeater = rowRepeaterMap[rowRepeaterId];
    _.each(rowRepeater.rowList, function (row, index) {
      if (row.rowModel.id === message.id) {
        _.eachRight(row.fieldStructureList, function (fieldStructure) {
          fieldMap.remove(fieldStructure.fieldStructureId);
        });
        rowRepeater.rowList.splice(index, 1);
        return false;
      }
    });
    this.processCollapsibleColumnsAndVisibility(rowRepeaterId, rowRepeaterMap);
    rowRepeater.timeLastModified = new Date().getTime();
  };
  this.sortRowRepeater = function (rowRepeaterId, sortKey, sortType, rowRepeaterMap) {
    var rowRepeater = rowRepeaterMap[rowRepeaterId];
    rowRepeater.sort = {
      sortKey: sortKey,
      sortType: sortType
    };
    rowRepeater.rowList = _.sortBy(rowRepeater.rowList, function (row) {
      var fieldStructure = _.find(row.fieldStructureList, function (fieldStructure) {
          return fieldStructure.uiField.fieldTemplate.variableName === rowRepeater.sort.sortKey;
        }) || {},
        validator,
        numericValidatorList = ['number', 'currency', 'number range', 'percent', 'number with commas', 'year', 'vehicle year'],
        result = '';
      if (sortKey === 'rowNumber') {
        result = row.rowModel.rowNumber;
      } else if (fieldStructure.uiField.fieldTemplate.type === fieldType.CLASSCODEFINDER) {
        result = fieldStructure.fieldModel.value;
      } else if (fieldStructure.fieldModel) {
        validator = fieldStructure.uiField.fieldTemplate.validator;
        if (numericValidatorList.indexOf(validator) !== -1) {
          result = parseFloat(fieldStructure.fieldModel.value);
        } else if (fieldStructure.fieldModel.valueLabel) {
          result = fieldStructure.fieldModel.valueLabel;
        } else {
          result = fieldStructure.fieldModel.value;
        }
      }
      return result;
    });
    if (rowRepeater.sort.sortType === 'desc') {
      rowRepeater.rowList = rowRepeater.rowList.reverse();
    }
    rowRepeater.timeLastModified = new Date().getTime();
  };
  this.getRowRepeaterName = function (fieldStructure) {
    return "rowRepeater-".concat(formatUtil.formatAsSelector(fieldStructure.fieldTemplate.variableName));
  };
  this.compareRowLists = function (rowList1, rowList2) {
    var rowRepeaterRowListComparisonResult = rowRepeaterRowListComparisonResultConstant.EQUAL;
    var rowList1Length = _.size(rowList1);
    var rowList2Length = _.size(rowList2);
    var numberOfRowsAdded = 0;
    _.each(rowList1, function (row, index) {
      // If the row we are comparing doesn't have an equivalent row in the second list, we have added a new row to the list
      if (index >= rowList2Length) {
        numberOfRowsAdded++;
      } else {
        // If the the row we are comparing and the equivalent row in the second list DO NOT have matching IDs, the contents of the list have changed
        if (rowList2[index].rowModel.id !== row.rowModel.id) {
          rowRepeaterRowListComparisonResult = rowRepeaterRowListComparisonResultConstant.CONTENTS_CHANGED;
          return false;
        }
      }
    });
    if (rowRepeaterRowListComparisonResult !== rowRepeaterRowListComparisonResultConstant.CONTENTS_CHANGED) {
      if (numberOfRowsAdded === 1) {
        rowRepeaterRowListComparisonResult = rowRepeaterRowListComparisonResultConstant.ONE_ROW_ADDED;
      } else if (numberOfRowsAdded > 1) {
        rowRepeaterRowListComparisonResult = rowRepeaterRowListComparisonResultConstant.MORE_THAN_ONE_ROW_ADDED;
      } else if (rowList1Length < rowList2Length) {
        rowRepeaterRowListComparisonResult = rowRepeaterRowListComparisonResultConstant.ROWS_REMOVED;
      }
    }
    return rowRepeaterRowListComparisonResult;
  };
};
RowRepeaterUtil.$inject = ["formComponentUtil", "formViewerUtil", "formatUtil", "appTypeConfigurationModel", "fieldType", "rowRepeaterRowListComparisonResultConstant"];
angular.module('umFormViewer').service('rowRepeaterUtil', RowRepeaterUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var SupplementalFormUtil = function SupplementalFormUtil($rootScope, formViewerConstant, formViewerUtil) {
  this.deleteSupplementalForm = function (supplementalForm, sectionList, fieldMap) {
    var supplementalFormId = supplementalForm.id;
    function removeFieldsFromFieldMap(supplementalSectionList) {
      function removeFieldEntries(fieldStructureList) {
        _.eachRight(fieldStructureList, function (fieldStructure) {
          var fieldKey = fieldStructure.uiField.fieldTemplate.id;
          if (fieldStructure.rowInstanceId) {
            fieldKey += '-' + fieldStructure.rowInstanceId;
          }
          fieldMap.remove(fieldKey);
        });
      }
      _.eachRight(supplementalSectionList, function (section) {
        _.eachRight(section.rowList, function (row) {
          if (row.sectionList) {
            removeFieldsFromFieldMap(row.sectionList);
          }
          if (row.rowList) {
            _.eachRight(row.rowList, function (rowRepeater) {
              removeFieldEntries(rowRepeater.fieldStructureList);
            });
          }
          removeFieldEntries(row.fieldStructureList);
        });
      });
    }
    function searchSections(sectionList) {
      _.each(sectionList, function (section) {
        searchRows(section.rowList, section);
      });
    }
    function searchRows(rowList) {
      _.each(rowList, function (row, index) {
        if (row && row.sectionList && row.formModel.id === supplementalFormId) {
          $rootScope.$broadcast(formViewerConstant.event.SUPPLEMENTAL_FORM_REMOVED, row.formName, row.formModel.rootFormId, supplementalFormId, row.sectionList);
          removeFieldsFromFieldMap(row.sectionList);
          rowList.splice(index, 1);
        } else if (row && !_.isEmpty(row.sectionList)) {
          searchSections(row.sectionList);
        }
      });
    }
    searchSections(sectionList);
  };
  this.doesPrecedingFormExist = function (precedingFieldVariableName, precedingFieldFormTemplateUniqueName, rootFormSectionList) {
    return _.isUndefined(formViewerUtil.findPrecedingFieldRowForSupplementalForm(precedingFieldVariableName, precedingFieldFormTemplateUniqueName, rootFormSectionList)) !== true;
  };
  this.insertSupplementalForm = function (supplementalForm, sectionList) {
    var precedingFieldVariableName = supplementalForm.uiFormTemplate.precedingFieldVariableName;
    var precedingFieldFormTemplateUniqueName = supplementalForm.uiFormTemplate.precedingFieldFormTemplateUniqueName;
    var precedingFieldInfo = formViewerUtil.findPrecedingFieldRowForSupplementalForm(precedingFieldVariableName, precedingFieldFormTemplateUniqueName, sectionList);
    precedingFieldInfo.precedingFieldSection.sectionHeight += supplementalForm.formHeight;
    precedingFieldInfo.precedingFieldSection.rowList.splice(precedingFieldInfo.precedingFieldRowIndex + 1, 0, supplementalForm);
    supplementalForm.parentForm = precedingFieldInfo.precedingFieldRow.parentFormStructure;
  };
};
SupplementalFormUtil.$inject = ["$rootScope", "formViewerConstant", "formViewerUtil"];
angular.module('umFormViewer').service('supplementalFormUtil', SupplementalFormUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var FormComponentRenderingUtil = function FormComponentRenderingUtil($rootScope, $compile, $templateCache, $timeout, $q, fieldType, umsLog, watchManagerUtil) {
  var componentDirectory = '/formViewer/component/',
    structureDirectory = '/formViewer/structure/',
    editorDirectory = '/formViewer/editor/',
    componentLookup = {},
    formTpl = $($templateCache.get(componentDirectory + 'formPlaceholder.tpl.html')),
    sectionTpl = $compile($($templateCache.get(componentDirectory + 'sectionPlaceholder.tpl.html'))),
    supplementalFormTpl = $compile($($templateCache.get(componentDirectory + 'supplementalFormPlaceholder.tpl.html'))),
    rowTpl = $compile($($templateCache.get(structureDirectory + 'row/rowPlaceholder.tpl.html'))),
    repeatingRowTpl = $compile($($templateCache.get(structureDirectory + 'repeatingRow/repeatingRowPlaceholder.tpl.html'))),
    configurableRowTpl = $compile($($templateCache.get(editorDirectory + 'row/rowEditorPlaceholder.tpl.html'))),
    configurableComponentTpl = $compile($($templateCache.get(editorDirectory + 'componentEditorPlaceholder.tpl.html'))),
    configurableSectionTpl = $compile($($templateCache.get(editorDirectory + 'section/sectionEditorPlaceholder.tpl.html')));
  componentLookup[fieldType.TEXT_INPUT] = $compile($($templateCache.get(componentDirectory + 'textInput/textInputPlaceholder.tpl.html'))[0]);
  componentLookup[fieldType.DROP_DOWN] = $compile($($templateCache.get(componentDirectory + 'dropdown/formDropdownPlaceholder.tpl.html'))[0]);
  componentLookup[fieldType.LABEL] = $compile($($templateCache.get(componentDirectory + 'label/labelPlaceholder.tpl.html'))[0]);
  componentLookup[fieldType.YES_NO] = $compile($($templateCache.get(componentDirectory + 'yesNoRadio/yesNoRadioPlaceholder.tpl.html'))[0]);
  componentLookup[fieldType.SPACER] = $compile($($templateCache.get(componentDirectory + 'spacer/spacerPlaceholder.tpl.html')));
  componentLookup[fieldType.CHECK_BOX] = $compile($($templateCache.get(componentDirectory + 'checkbox/checkboxPlaceholder.tpl.html'))[0]);
  componentLookup[fieldType.TEXT_AREA] = $compile($($templateCache.get(componentDirectory + 'textarea/textAreaPlaceholder.tpl.html')));
  componentLookup[fieldType.BUTTON] = $compile($($templateCache.get(componentDirectory + 'functionButton/buttonPlaceholder.tpl.html')));
  componentLookup[fieldType.LINK_BUTTON] = $compile($($templateCache.get(componentDirectory + 'urlLink/urlLinkPlaceholder.tpl.html')));
  componentLookup[fieldType.CHECK_BOX_GROUP] = $compile($($templateCache.get(componentDirectory + 'checkboxGroup/checkboxGroupPlaceholder.tpl.html')));
  componentLookup[fieldType.MULTI_SELECT] = $compile($($templateCache.get(componentDirectory + 'multiSelect/multiSelectPlaceholder.tpl.html')));
  componentLookup[fieldType.CALENDAR] = $compile($($templateCache.get(componentDirectory + 'calendar/calendarPlaceholder.tpl.html'))[0]);
  componentLookup[fieldType.CLASSCODEFINDER] = $compile($($templateCache.get(componentDirectory + 'classCode/classCodePlaceholder.tpl.html')));
  componentLookup[fieldType.RADIO_BUTTON_GROUP] = $compile($($templateCache.get(componentDirectory + 'radioButtonGroup/radioButtonGroupPlaceholder.tpl.html')));
  componentLookup[fieldType.FUNCTION_BUTTON] = $compile($($templateCache.get(componentDirectory + 'functionButton/functionButtonPlaceholder.tpl.html')));
  componentLookup[fieldType.UPLOAD_ATTACHMENT_BUTTON] = $compile($($templateCache.get(componentDirectory + 'uploadAttachment/uploadAttachmentPlaceholder.tpl.html')));
  componentLookup[fieldType.FORM_SUMMARY_GRID] = $compile($($templateCache.get(componentDirectory + 'formSummary/formSummaryGridPlaceholder.tpl.html')));
  componentLookup[fieldType.ROWREPEATER] = $compile($($templateCache.get(componentDirectory + 'rowRepeater/rowRepeaterPlaceholder.tpl.html')));
  this.createComponentByType = function (field, parentRowContainer, hideLabel) {
    var newScope, newFieldLink;
    this.validateContainer(parentRowContainer);
    newScope = $rootScope.$new(true);
    newScope.fieldStructure = field;
    newScope.hideLabel = hideLabel;
    newFieldLink = componentLookup[field.uiField.fieldTemplate.type];
    if (newFieldLink) {
      newFieldLink(newScope, function (clone) {
        parentRowContainer.append(clone);
      });
    }
  };
  this.createRow = function (row, parentRowContainer, advancedInsertion, insertAfter) {
    var newScope = $rootScope.$new(true);
    this.validateContainer(parentRowContainer);
    newScope.row = row;
    return rowTpl(newScope, function (clone) {
      var cloneElement = $(clone);
      row.viewContainer = cloneElement.find('.formRowContainer');
      if (advancedInsertion) {
        if (insertAfter) {
          cloneElement.insertAfter(parentRowContainer);
        } else {
          cloneElement.insertBefore(parentRowContainer);
        }
      } else {
        parentRowContainer.append(cloneElement);
      }
      return clone;
    });
  };
  this.createRepeatingRow = function (row, parentRowContainer, hideRowNumbers, configurable) {
    var newScope = $rootScope.$new(true);
    this.validateContainer(parentRowContainer);
    newScope.row = row;
    newScope.hideRowNumbers = hideRowNumbers;
    newScope.configurable = configurable;
    return repeatingRowTpl(newScope, function (clone) {
      var cloneElement = $(clone);
      row.viewContainer = cloneElement.find('.formRowContainer');
      parentRowContainer.append(cloneElement);
      return clone;
    });
  };
  this.createConfigurableRowComponent = function (row, targetContainer, advancedInsertion, insertAfter) {
    var newScope = $rootScope.$new(true);
    this.validateContainer(targetContainer);
    newScope.rowStructure = row;
    newScope.resetRow = this.resetRowEditor.bind(this);
    configurableRowTpl(newScope, function (clone) {
      var selectionContainer = $(clone).find('.rowSelectionContainer');
      if (advancedInsertion) {
        if (insertAfter) {
          clone.insertAfter(targetContainer);
        } else {
          clone.insertBefore(targetContainer);
        }
      } else {
        targetContainer.append(clone);
      }
      this.createRow(row, selectionContainer);
    }.bind(this));
  };
  this.createRowRepeaterComponent = function (row, parentRowContainer, configurable) {
    var newScope = $rootScope.$new(true);
    this.validateContainer(parentRowContainer);
    newScope.row = row;
    newScope.formId = row.parentForm.root ? row.parentForm.id : row.parentForm.rootFormId;
    newScope.configurable = configurable;
    componentLookup[fieldType.ROWREPEATER](newScope, function (clone) {
      parentRowContainer.append(clone);
    });
  };
  this.createConfigurableRowRepeaterComponent = function (rowStructure, parentRowContainer, advancedInsertion, insertAfter) {
    var configurableRowScope = $rootScope.$new(true);
    this.validateContainer(parentRowContainer);

    // create configurable row
    configurableRowScope.rowStructure = rowStructure;
    configurableRowScope.resetRow = this.resetRowEditor.bind(this);
    configurableRowTpl(configurableRowScope, function (configurableRowClone) {
      var configurableRowSelectionContainer = $(configurableRowClone).find('.rowSelectionContainer');
      if (advancedInsertion) {
        if (insertAfter) {
          configurableRowClone.insertAfter(parentRowContainer);
        } else {
          configurableRowClone.insertBefore(parentRowContainer);
        }
      } else {
        parentRowContainer.append(configurableRowClone);
      }

      // create row component
      var newRowScope = $rootScope.$new(true);
      newRowScope.row = rowStructure;
      this.validateContainer(configurableRowSelectionContainer);
      return rowTpl(newRowScope, function (rowClone) {
        var newRowElement = $(rowClone),
          formRowContainer = newRowElement.find('.formRowContainer');
        rowStructure.viewContainer = formRowContainer;
        configurableRowSelectionContainer.append(newRowElement);
        this.validateContainer(formRowContainer);
        this.createRowRepeaterComponent(rowStructure, formRowContainer, true);
        return rowClone;
      }.bind(this));
    }.bind(this));
  };
  this.createSupplementalFormComponent = function (row, parentRowContainer) {
    var defer = $q.defer(),
      newScope = $rootScope.$new(true);
    this.validateContainer(parentRowContainer);
    newScope.row = row;
    newScope.formId = row.formModel.id;
    supplementalFormTpl(newScope, function (clone) {
      parentRowContainer.append(clone);
      defer.resolve();
    });
    return defer.promise;
  };
  this.createSectionComponent = function (section, parentFormContainer, shouldRenderEntireForm) {
    var newSectionScope = $rootScope.$new(true);
    newSectionScope.formId = section.rootFormId;
    newSectionScope.sectionStructure = section;
    this.validateContainer(parentFormContainer);
    sectionTpl(newSectionScope, function (clone) {
      var compiledSection = $(clone);
      section.viewContainer = compiledSection;
      section.addedToView = true;
      parentFormContainer.append(clone);
      if (!shouldRenderEntireForm) {
        compiledSection.addClass('rendering');
      }
    });
  };
  this.createConfigurableSectionComponent = function (section, parentFormContainer, shouldRenderEntireForm) {
    var newScope = $rootScope.$new(true);
    this.validateContainer(parentFormContainer);
    newScope.formId = section.rootFormId;
    newScope.sectionStructure = section;
    newScope.resetComponent = this.resetSectionEditor.bind(this);
    configurableSectionTpl(newScope, function (clone) {
      var selectionContainer = $(clone).find('.sectionSelectionContainer');
      parentFormContainer.append(clone);
      this.createSectionComponent(section, selectionContainer, shouldRenderEntireForm);
    }.bind(this));
  };
  this.createConfigurableSection = function (sectionStructure, dropZoneSection, insertAfter) {
    var newScope = $rootScope.$new(true),
      shouldRenderEntireForm = true,
      advancedInsertion = false;
    this.validateContainer(dropZoneSection);
    newScope.formId = sectionStructure.rootFormId;
    newScope.sectionStructure = sectionStructure;
    newScope.resetComponent = this.resetSectionEditor.bind(this);
    configurableSectionTpl(newScope, function (clone) {
      var selectionContainer = $(clone).find('.sectionSelectionContainer'),
        defaultRow = sectionStructure.rowList[0],
        defaultField = defaultRow.fieldStructureList[0],
        formSectionContainer,
        formRowContainer;
      this.createSectionComponent(sectionStructure, selectionContainer, shouldRenderEntireForm);
      formSectionContainer = $(clone).find('.formSection');
      this.createConfigurableRowComponent(defaultRow, formSectionContainer, advancedInsertion, insertAfter);
      formRowContainer = $(clone).find('.formRowContainer');
      this.createConfigurableComponent(defaultField, formRowContainer);
      if (insertAfter) {
        clone.insertAfter(dropZoneSection);
      } else {
        clone.insertBefore(dropZoneSection);
      }
    }.bind(this));
  };
  this.createConfigurableSectionBefore = function (sectionStructure, dropZoneSection) {
    var insertAfter = false;
    this.createConfigurableSection(sectionStructure, dropZoneSection, insertAfter);
  };
  this.createConfigurableSectionAfter = function (sectionStructure, dropZoneSection) {
    var insertAfter = true;
    this.createConfigurableSection(sectionStructure, dropZoneSection, insertAfter);
  };
  this.createFormComponent = function () {
    return formTpl.clone();
  };
  this.createConfigurableComponentBefore = function (fieldStructure, targetSibling, hideLabel) {
    var newScope = this.createConfigurableComponentScope(fieldStructure);
    this.validateContainer(targetSibling);
    configurableComponentTpl(newScope, function (clone) {
      var configurableComponent = $(clone),
        selectionContainer = configurableComponent.find('.selectionContainer');
      configurableComponent.insertBefore(targetSibling);
      this.createComponentByType(fieldStructure, selectionContainer, hideLabel);
    }.bind(this));
  };
  this.createConfigurableComponentAfter = function (fieldStructure, targetSibling, hideLabel) {
    var newScope = this.createConfigurableComponentScope(fieldStructure);
    this.validateContainer(targetSibling);
    configurableComponentTpl(newScope, function (clone) {
      var configurableComponent = $(clone),
        selectionContainer = configurableComponent.find('.selectionContainer');
      configurableComponent.insertAfter(targetSibling);
      this.createComponentByType(fieldStructure, selectionContainer, hideLabel);
    }.bind(this));
  };
  this.createConfigurableComponentScope = function (fieldStructure) {
    var newScope = $rootScope.$new(true);
    newScope.componentStructure = fieldStructure;
    newScope.componentStructure.isConfigurableComponent = true;
    newScope.formId = fieldStructure.rootFormId;
    newScope.isDraggable = fieldStructure.parentForm.hasWriteAccess;
    newScope.resetComponent = this.resetComponentEditor.bind(this);
    return newScope;
  };
  this.createConfigurableComponent = function (fieldStructure, parentRowContainer, hideLabel) {
    var newScope = this.createConfigurableComponentScope(fieldStructure);
    this.validateContainer(parentRowContainer);
    configurableComponentTpl(newScope, function (clone) {
      var selectionContainer = $(clone).find('.selectionContainer');
      parentRowContainer.append(clone);
      this.createComponentByType(fieldStructure, selectionContainer, hideLabel);
    }.bind(this));
  };
  this.validateContainer = function (container) {
    var result = true;
    if (container.length < 1) {
      umsLog.error('Container does not exist or is empty');
      result = false;
    } else if (container.length > 1) {
      umsLog.error('Multiple containers exist when only 1 is expected.');
      result = false;
    }
    return result;
  };
  this.resetComponentEditor = function (container, fieldStructureId) {
    var className = '.componentEditor.' + fieldStructureId;
    watchManagerUtil.resetScopeForComponentId(fieldStructureId);
    this.resetComponentsByClassName(container, className);
  };
  this.resetSectionEditor = function (container, sectionStructure) {
    var className = '.sectionEditor.' + sectionStructure.sectionStructureId;
    this.clearDomReferences([sectionStructure]);
    this.resetComponentsByClassName(container, className);
  };
  this.resetRowEditor = function (container, rowStructure) {
    var className = '.rowEditor.' + rowStructure.rowStructureId;
    this.clearDomReferences([rowStructure]);
    this.resetComponentsByClassName(container, className);
  };
  this.resetAllSections = function (container, formName, formId, sectionList, isSupplemental) {
    var className = '.' + formName + ' .formSectionContainer';
    this.clearDomReferences(sectionList);
    this.resetComponentsByClassName(container, className, isSupplemental);
    if (isSupplemental) {
      watchManagerUtil.resetByFormId(formId);
    } else {
      watchManagerUtil.reset();
    }
  };
  this.resetComponentsByClassName = function (container, className, isSupplemental) {
    var scopeList = !!isSupplemental ? container.find(className + ' .ng-scope').parent() : container.find(className + ' .ng-scope'),
      isolateScopeList = !!isSupplemental ? container.find(className + ' .ng-isolate-scope').parent() : container.find(className + ' .ng-isolate-scope');
    this.manuallyDestroyDomScope(scopeList, isolateScopeList);
    this.clearContent(container, className);
  };
  this.clearContent = function (container, className) {
    container.find(className, '.').remove();
  };
  this.clearDomReferences = function (rootSectionList) {
    function clearSectionDomReferences(sectionList) {
      _.each(sectionList, function (section) {
        section.viewContainer = null;
        delete section.viewContainer;
        clearRowDomReferences(section.rowList);
      });
    }
    function clearRowDomReferences(rowList) {
      _.each(rowList, function (row) {
        row.viewContainer = null;
        delete row.viewContainer;
        if (row.sectionList) {
          clearSectionDomReferences(row.sectionList);
        }
      });
    }
    clearSectionDomReferences(rootSectionList);
  };
  this.manuallyDestroyDomScope = function (scopeList, isolateScopeList) {
    var scope;
    _.each(scopeList, function (listItem) {
      scope = angular.element(listItem).scope();
      if (scope) {
        scope.$destroy();
      }
    });
    _.each(isolateScopeList, function (listItem) {
      scope = angular.element(listItem).isolateScope();
      if (scope) {
        scope.$destroy();
      }
    });
  };
};
FormComponentRenderingUtil.$inject = ["$rootScope", "$compile", "$templateCache", "$timeout", "$q", "fieldType", "umsLog", "watchManagerUtil"];
angular.module('umFormViewer').service('formComponentRenderingUtil', FormComponentRenderingUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FormRenderingUtil = function FormRenderingUtil($q, $rootScope, $window, $timeout, $compile, formViewerConstant, browserUtil, formComponentRenderingUtil) {
  var filterStrength = 2,
    frameTime = 0,
    lastLoop = getTime(),
    thisLoop;
  function getTime() {
    var perf = window.performance;
    if (browserUtil.isIE11() || browserUtil.isFirefox()) {
      return function () {
        return perf.now();
      };
    } else {
      return function () {
        return Date.now();
      };
    }
  }
  this.lastRenderSpeed = null;
  this.renderInterval = 1;
  this.renderChunkSize = 1;
  this.renderGroupSize = 1;
  this.viewportHeight = null;
  this.renderInternalId = null;
  this.optimizeFormWatchers = null;
  this.onInitialRenderingComplete = null;
  this.onFadeInRenderedSections = null;
  this.registerWatcherCallback = function (callback) {
    this.optimizeFormWatchers = callback;
  };
  this.registerInitialRenderingCompleteCallback = function (callback) {
    this.onInitialRenderingComplete = callback;
  };
  this.registerFadeInRenderedSectionsCallback = function (callback) {
    this.onFadeInRenderedSections = callback;
  };
  this.beginRendering = function (element, form) {
    this.defer = $q.defer();
    this.viewportHeight = element.height() || form.formHeight;
    form.renderedHeight = 0;
    form.initialRenderComplete = false;
    this.startLazyRendering.call(this, form, element);
    return this.defer.promise;
  };
  this.makeRenderPass = function (form, parentFormContainer, shouldRenderEntireForm) {
    var actionTaken = false;
    function makeSectionListPass(sectionList) {
      function isSupplementalPartiallyRendered(supplementalSectionList) {
        var result = false,
          partiallyRenderedSupplementalRows;
        _.map(supplementalSectionList, function (supplementalSection) {
          partiallyRenderedSupplementalRows = _.filter(supplementalSection.rowList, findPartiallyRenderedRows);
          if (partiallyRenderedSupplementalRows.length) {
            result = true;
          }
        });
        return result;
      }
      function findPartiallyRenderedRows(row) {
        var result;
        if (row.sectionList) {
          result = isSupplementalPartiallyRendered(row.sectionList);
        } else {
          result = !row.fullyRendered;
        }
        return result;
      }
      _.map(sectionList, function (section) {
        var partiallyRenderedRows, newSectionTpl;
        if ((!actionTaken || shouldRenderEntireForm) && !section.fullyRendered) {
          if (!section.viewContainer) {
            if (form.isConfigurableForm) {
              formComponentRenderingUtil.createConfigurableSectionComponent(section, parentFormContainer, shouldRenderEntireForm);
            } else {
              formComponentRenderingUtil.createSectionComponent(section, parentFormContainer, shouldRenderEntireForm);
            }
          }
          if (!section.fullyRendered) {
            makeRowListPass.call(this, section.rowList, section.viewContainer);
            partiallyRenderedRows = _.filter(section.rowList, findPartiallyRenderedRows);
            section.partiallyRendered = partiallyRenderedRows.length > 0;
            section.fullyRendered = partiallyRenderedRows.length === 0;
          }
        }
      }.bind(this));
    }
    function makeRowListPass(rowList, parentSectionContainer) {
      var renderChunkCount = 0;
      _.map(rowList, function (row) {
        if (!actionTaken || shouldRenderEntireForm) {
          if (!row.fullyRendered) {
            if (!row.addedToView) {
              if (form.isConfigurableForm) {
                formComponentRenderingUtil.createConfigurableRowComponent(row, parentSectionContainer);
              } else {
                formComponentRenderingUtil.createRow(row, parentSectionContainer);
              }
              row.addedToView = true;
              if (row.sectionList) {
                form.renderedHeight += row.formHeight;
              } else if (row.rowList) {
                form.renderedHeight += row.rowHeight;
              } else {
                form.renderedHeight += row.rowHeight;
              }
            }
            if (row.sectionList) {
              row.fullyRendered = true;
              actionTaken = true;
              formComponentRenderingUtil.createSupplementalFormComponent(row, row.viewContainer);
            } else if (row.rowList) {
              row.fullyRendered = true;
              renderChunkCount += 1;
              if (renderChunkCount >= this.renderChunkSize) {
                actionTaken = true;
              }
              formComponentRenderingUtil.createRowRepeaterComponent(row, row.viewContainer, form.isConfigurableForm);
            } else {
              _.map(row.fieldStructureList, function (fieldStructure) {
                if (!actionTaken && !fieldStructure.rendered || shouldRenderEntireForm) {
                  if (form.isConfigurableForm) {
                    formComponentRenderingUtil.createConfigurableComponent(fieldStructure, row.viewContainer);
                  } else {
                    formComponentRenderingUtil.createComponentByType(fieldStructure, row.viewContainer);
                  }
                  fieldStructure.rendered = true;
                  renderChunkCount += 1;
                  if (renderChunkCount >= this.renderChunkSize) {
                    actionTaken = true;
                  }
                }
              }.bind(this));
              row.fullyRendered = _.filter(row.fieldStructureList, {
                rendered: true
              }).length === row.fieldStructureList.length;
            }
          }
        }
      }.bind(this));
    }
    makeSectionListPass.call(this, form.sectionList);
  };
  this.startLazyRendering = function (form, parentFormViewerContainer) {
    var newFormTpl = formComponentRenderingUtil.createFormComponent(),
      render = function () {
        var sourceSections = form.sectionList,
          sourceSectionsFullyRendered,
          isRendering;
        this.makeRenderPass.call(this, form, newFormTpl);
        sourceSectionsFullyRendered = _.filter(sourceSections, function (section) {
          return section.fullyRendered;
        });
        isRendering = sourceSectionsFullyRendered.length !== sourceSections.length;
        if ((form.renderedHeight > this.viewportHeight || !isRendering) && !form.initialRenderComplete) {
          form.initialRenderComplete = true;
          $rootScope.$broadcast(formViewerConstant.INITIAL_RENDERING_COMPLETE);
          if (this.onInitialRenderingComplete) {
            this.onInitialRenderingComplete();
          }
        }
        if (form.initialRenderComplete && this.onFadeInRenderedSections) {
          this.onFadeInRenderedSections();
        }
        if (!isRendering && !form.renderingComplete) {
          form.renderingComplete = true;
          this.defer.resolve();
          $rootScope.$broadcast(formViewerConstant.event.FORM_LAZY_RENDERING_END);
        }
      }.bind(this),
      renderGroup = function () {
        if (!form.initialRenderComplete) {
          this.renderInterval = 1;
          this.renderChunkSize = 10;
          this.renderGroupSize = 10;
        } else {
          if (this.lastRenderSpeed < 5) {
            this.renderInterval = 1;
            this.renderChunkSize = 3;
            this.renderGroupSize = 2;
          } else {
            this.renderInterval = 1;
            this.renderChunkSize = 5;
            this.renderGroupSize = 2;
          }
        }
        _.times(this.renderGroupSize, function () {
          if (!form.initialRenderComplete && form.renderedHeight <= this.viewportHeight) {
            render();
          } else if (form.initialRenderComplete) {
            render();
          }
        }.bind(this));
        if (this.optimizeFormWatchers) {
          this.optimizeFormWatchers();
        }
        var thisFrameTime = (thisLoop = getTime()) - lastLoop;
        frameTime += (thisFrameTime - frameTime) / filterStrength;
        lastLoop = thisLoop;
        if (!form.renderingComplete) {
          this.renderInternalId = $timeout(renderGroup, this.renderInterval);
        }
      }.bind(this);
    newFormTpl.insertAfter(parentFormViewerContainer.find('.formHeader'));
    this.renderInternalId = $timeout(renderGroup, this.renderInterval);
  };
  this.insertSupplemental = function (precedingRow, form) {
    var parentRowContainer = formComponentRenderingUtil.createRow(form, precedingRow, /*isAdvancedInsertion=*/true, /*insertAfter=*/true),
      formRowContainer = parentRowContainer.find('.formRowContainer');
    form.renderedHeight = 0;
    return formComponentRenderingUtil.createSupplementalFormComponent(form, formRowContainer);
  };
  this.renderSupplemental = function (parentFormContainer, form) {
    var newFormTpl = formComponentRenderingUtil.createFormComponent(),
      shouldRenderEntireForm = true;
    form.renderedHeight = 0;
    this.makeRenderPass.call(this, form, parentFormContainer, shouldRenderEntireForm);
    newFormTpl.insertAfter(parentFormContainer.find('.formHeader'));
    if (this.optimizeFormWatchers) {
      this.optimizeFormWatchers();
    }
  };
  this.insertNewRow = function (newRowConfig) {
    var isAdvancedInsertion = true;
    formComponentRenderingUtil.createConfigurableRowComponent(newRowConfig.row, newRowConfig.dropZoneRow, isAdvancedInsertion, newRowConfig.createAfterDropZone);
    $timeout(function () {
      formComponentRenderingUtil.createConfigurableComponent(newRowConfig.row.fieldStructureList[0], newRowConfig.row.viewContainer);
    }, 10);
  };
  this.insertNewComponent = function (newComponentConfig) {
    if (newComponentConfig.createAfterDropZone) {
      this.createConfigurableComponentAfter(newComponentConfig.fieldStructure, newComponentConfig.targetSibling, newComponentConfig.isRowRepeater);
    } else {
      this.createConfigurableComponentBefore(newComponentConfig.fieldStructure, newComponentConfig.targetSibling, newComponentConfig.isRowRepeater);
    }
  };
  this.insertNewSection = function (newSectionConfig) {
    if (newSectionConfig.createAfterDropZone) {
      formComponentRenderingUtil.createConfigurableSectionAfter(newSectionConfig.sectionStructure, newSectionConfig.dropZoneSection);
    } else {
      formComponentRenderingUtil.createConfigurableSectionBefore(newSectionConfig.sectionStructure, newSectionConfig.dropZoneSection);
    }
  };
  this.insertNewRowRepeater = function (newRowRepeaterConfig) {
    var rowStructure = newRowRepeaterConfig.rowStructure,
      dropZoneRow = newRowRepeaterConfig.dropZoneRow,
      advancedInsert = true,
      createAfterDropZone = newRowRepeaterConfig.createAfterDropZone;
    formComponentRenderingUtil.createConfigurableRowRepeaterComponent(rowStructure, dropZoneRow, advancedInsert, createAfterDropZone);
  };
  this.createConfigurableComponentBefore = function (fieldStructure, targetSibling, hideLabel) {
    return formComponentRenderingUtil.createConfigurableComponentBefore(fieldStructure, targetSibling, hideLabel);
  };
  this.createConfigurableComponentAfter = function (fieldStructure, targetSibling, hideLabel) {
    return formComponentRenderingUtil.createConfigurableComponentAfter(fieldStructure, targetSibling, hideLabel);
  };
  this.createConfigurableRowRepeaterComponent = function (rowStructure, parentSectionContainer, advancedInsertion, insertAfter) {
    formComponentRenderingUtil.createConfigurableRowComponent(rowStructure, parentSectionContainer, advancedInsertion, insertAfter);
    $timeout(function () {
      formComponentRenderingUtil.createRowRepeaterComponent(rowStructure, rowStructure.viewContainer, true);
    }, 10);
  };
  this.createConfigurableRowRepeaterComponentBefore = function (rowStructure, parentSectionContainer) {
    var advancedInsertion = true,
      insertAfter = false;
    this.createConfigurableRowRepeaterComponent(rowStructure, parentSectionContainer, advancedInsertion, insertAfter);
  };
  this.createConfigurableRowRepeaterComponentAfter = function (rowStructure, parentSectionContainer) {
    var advancedInsertion = true,
      insertAfter = true;
    this.createConfigurableRowRepeaterComponent(rowStructure, parentSectionContainer, advancedInsertion, insertAfter);
  };
  this.createConfigurableComponent = function (fieldStructure, parentRowContainer) {
    return formComponentRenderingUtil.createConfigurableComponent(fieldStructure, parentRowContainer);
  };
};
FormRenderingUtil.$inject = ["$q", "$rootScope", "$window", "$timeout", "$compile", "formViewerConstant", "browserUtil", "formComponentRenderingUtil"];
angular.module('umFormViewer').service('formRenderingUtil', FormRenderingUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {var transition = __webpack_require__(1250);

/*@ngInject*/
var UIViewportManagerDirective = function UIViewportManagerDirective($window, $rootScope, $timeout, formViewerConstant, uiPerformanceLoggerConstant, coreConstant, formRenderingUtil, watchManagerUtil, timingModel, formComponentRenderingUtil, formatUtil, umsLog) {
  var linkFunction = function linkFunction($scope, $elm) {
    var timeoutList = [],
      element = $($elm),
      parentElement = element.parent();
    function handleScroll(event) {
      var target = event.target,
        isScrollable = target.scrollHeight > target.clientHeight;
      $scope.showLazyLoadingSpinner = isScrollable && $scope.isRendering && !$scope.isLoading;
      watchManagerUtil.updateView();
      timeoutList.push($timeout(function () {}, 0));
    }
    function optimizeFormWatchers() {
      // timeout to ensure row repeaters are on the screen prior to selecting components
      // check to see if this can be removed after components are all manually created
      // by formRenderingComponentUtil
      timeoutList.push($timeout(function () {
        var fieldListComponents = parentElement.find('.fieldListComponent');
        watchManagerUtil.setupScope(parentElement, fieldListComponents);
        watchManagerUtil.updateView();
      }, 200));
    }
    function triggerFormReadyPerformanceLogger() {
      var logAction = uiPerformanceLoggerConstant.SHOW_FORM,
        status = coreConstant.uiPeformanceLogger.SUCCESS;
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, status);
    }
    function beginBuildingForm(formData) {
      $scope.isLoading = true;
      $scope.isRendering = true;
      clearExistingForm();
      formRenderingUtil.registerWatcherCallback(optimizeFormWatchers);
      formRenderingUtil.registerInitialRenderingCompleteCallback(initialScreenRendered);
      formRenderingUtil.registerFadeInRenderedSectionsCallback(fadeInRenderedSections);
      formRenderingUtil.beginRendering(element, formData).then(function () {
        var totalRenderTime;
        $scope.isRendering = false;
        $timeout(function () {
          timingModel.addMilestone(formViewerConstant.timing.FORM_VIEWER, formViewerConstant.timing.FORM_FULLY_RENDERED);
          totalRenderTime = timingModel.getDuration(formViewerConstant.timing.FORM_VIEWER, formViewerConstant.timing.BEGIN_RENDERING, formViewerConstant.timing.FORM_FULLY_RENDERED);
          $($elm).addClass('renderedInFull');
          console.log($scope.formData.formName + ':totalRenderTime: ' + totalRenderTime);
        }, 1);
      });
    }
    function clearExistingForm() {
      var formName = _.get($scope, 'formData.formName'),
        sections = _.get($scope, 'formData.sectionList');
      formComponentRenderingUtil.resetAllSections(parentElement, formName, $scope.formId, sections);
    }
    function initialScreenRendered() {
      var networkRequests, initialViewRendering;
      $timeout(function () {
        $scope.isLoading = false;
        timingModel.addMilestone(formViewerConstant.timing.FORM_VIEWER, formViewerConstant.timing.INITIAL_SCREEN_RENDERED);
        networkRequests = timingModel.getDuration(formViewerConstant.timing.FORM_VIEWER, formViewerConstant.timing.LOAD_DATA, formViewerConstant.timing.BEGIN_RENDERING);
        initialViewRendering = timingModel.getDuration(formViewerConstant.timing.FORM_VIEWER, formViewerConstant.timing.BEGIN_RENDERING, formViewerConstant.timing.INITIAL_SCREEN_RENDERED);
        console.log($scope.formData.formName + ':networkRequests: ' + networkRequests);
        console.log($scope.formData.formName + ':initialViewRendering: ' + initialViewRendering);
        triggerFormReadyPerformanceLogger();
        $($elm).addClass('rendered');
      }, 1);
    }
    function fadeInRenderedSections() {
      timeoutList.push($timeout(function () {
        var elementsToFadeIn = element.find('.formSection.rendering');
        elementsToFadeIn.removeClass('rendering');
      }, 5));
    }
    function configure() {
      parentElement.on('scroll', handleScroll);
      $scope.$on(formViewerConstant.event.FORM_DATA_READY, function (event, formData, rootFormId) {
        if ($scope.formId === rootFormId && !$scope.isRendering) {
          beginBuildingForm(formData);
        }
      });

      /*
       * A field can have its value updated by the server, which can change
       * how its component is displayed, and so change the height of its row.
       * For example, a yes-no component can show or hide a text box depending
       * on the field's value. If the text box is hidden, and the row's height
       * is reduced, that could cause additional rows to come into view that
       * were not visible before. The components of those additional rows have
       * their watchers disabled (because they had been offscreen), so they
       * might not be displayed correctly. So call updateView to reevaluate
       * the watcher situation.
       */
      $scope.$on(formViewerConstant.event.UPDATE_FIELD_MESSAGE, function (event) {
        $timeout(function () {
          watchManagerUtil.updateView();
        }, 0);
      });
      $scope.$on(formViewerConstant.event.SUPPLEMENTAL_FORM_ADDED, function (event, supplementalFormName, supplementalFormRootStructure) {
        var parentFormName = formatUtil.formatAsSelector(supplementalFormRootStructure.uiFormTemplate.precedingFieldFormTemplateUniqueName),
          rootFormId = supplementalFormRootStructure.formModel.rootFormId,
          maxTryCount = 5,
          currentTryCount = 0;
        function insertSupplementalForm() {
          var precedingFieldName = formatUtil.formatAsSelector(supplementalFormRootStructure.uiFormTemplate.precedingFieldVariableName);
          var precedingRow = $('.' + parentFormName + ' .formRow:has(.formFieldComponent-' + precedingFieldName + ')');
          var isPrecedingRowRepeating = !_.isNil(precedingRow) && precedingRow.length > 1;
          if (precedingRow.length) {
            if (isPrecedingRowRepeating) {
              precedingRow = precedingRow[0];
            }
            if (parseInt($scope.formId) === rootFormId) {
              formRenderingUtil.insertSupplemental(precedingRow, supplementalFormRootStructure).then(function () {
                optimizeFormWatchers();
                timeoutList.push($timeout(function () {
                  transition({
                    element: '.' + supplementalFormName,
                    prop: 'height',
                    val: 'auto',
                    style: 'height .35s ease-out'
                  });
                }, 1));
              });
            }
          } else {
            if (currentTryCount < maxTryCount) {
              $timeout(function () {
                currentTryCount += 1;
                insertSupplementalForm();
              }, 500);
            } else {
              umsLog.error('Unable to find preceding row when adding supplemental');
            }
          }
        }
        insertSupplementalForm();
      });
      $scope.$on(formViewerConstant.event.REPEATING_ROW_PAGE_CHANGE, function () {
        optimizeFormWatchers();
      });
      $scope.$on(formViewerConstant.event.OPTIMIZE_FORM_WATCHERS, function () {
        optimizeFormWatchers();
      });
      $scope.$on(formViewerConstant.event.SUPPLEMENTAL_FORM_REMOVED, function (event, supplementalFormName, rootFormId, supplementalFormId, sectionList) {
        var supplementalFormContainer = $('.' + supplementalFormName);
        var supplementalParentContainer = $(supplementalFormContainer.parents('.formViewer')[1]);
        var supplementalFormRowContainer = $(supplementalFormContainer.parents('.formRow')[0]);
        if (parseInt($scope.formId) === rootFormId) {
          transition({
            element: '.' + supplementalFormName,
            prop: 'height',
            val: '0',
            style: 'height .35s ease-out'
          });
          supplementalFormContainer.addClass('isHidden');
          $('.' + supplementalFormName + ':parent').css('margin', '0px');
          $timeout(function () {
            formComponentRenderingUtil.resetAllSections(supplementalParentContainer, supplementalFormName, supplementalFormId, sectionList, true);
            supplementalFormRowContainer.remove();
          }, 350);
        }
      });
      $scope.$on(formViewerConstant.configuration.event.CREATE_NEW_ROW, function (event, newRowConfiguration) {
        formRenderingUtil.insertNewRow(newRowConfiguration);
      });
      $scope.$on(formViewerConstant.configuration.event.CREATE_NEW_COMPONENT, function (event, newComponentConfiguration) {
        formRenderingUtil.insertNewComponent(newComponentConfiguration);
      });
      $scope.$on(formViewerConstant.configuration.event.CREATE_NEW_SECTION, function (event, newSectionConfiguration) {
        formRenderingUtil.insertNewSection(newSectionConfiguration);
      });
      $scope.$on(formViewerConstant.configuration.event.CREATE_NEW_ROW_REPEATER, function (event, newRowRepeaterConfiguration) {
        formRenderingUtil.insertNewRowRepeater(newRowRepeaterConfiguration);
      });
      $scope.$on(formViewerConstant.configuration.event.UPDATE_COMPONENT_SETTING, function (event, fieldStructure) {
        var component = $('.' + fieldStructure.fieldStructureId),
          parentRow = component.parent(),
          totalChildrenInRow = parentRow.children().length,
          previousSibling = component.prev(),
          nextSibling = component.next(),
          hasPreviousSibling = previousSibling.length > 0,
          hasNextSibling = nextSibling.length > 0;
        component.remove();
        if (totalChildrenInRow === 1) {
          formRenderingUtil.createConfigurableComponent(fieldStructure, parentRow);
        } else if (hasPreviousSibling) {
          formRenderingUtil.createConfigurableComponentAfter(fieldStructure, previousSibling);
        } else if (hasNextSibling) {
          formRenderingUtil.createConfigurableComponentBefore(fieldStructure, nextSibling);
        }
      }.bind(this));
      $scope.$on(formViewerConstant.configuration.event.UPDATE_ROW_REPEATER_SETTING, function (event, rowStructure) {
        var component = $('.' + rowStructure.rowStructureId),
          parentSection = component.parent(),
          previousSibling = component.prev(),
          nextSibling = component.next(),
          hasPreviousSibling = previousSibling.length > 0,
          hasNextSibling = nextSibling.length > 0;
        component.remove();
        if (hasPreviousSibling) {
          formRenderingUtil.createConfigurableRowRepeaterComponentAfter(rowStructure, previousSibling);
        } else if (hasNextSibling) {
          formRenderingUtil.createConfigurableRowRepeaterComponentBefore(rowStructure, nextSibling);
        } else {
          formRenderingUtil.createConfigurableRowRepeaterComponent(rowStructure, parentSection);
        }
      }.bind(this));
      function beforePrint() {
        var fakeParentViewport = parentElement.find('.formName');
        var fieldListComponents = $('.fieldListComponent');
        watchManagerUtil.setupScope(fakeParentViewport, fieldListComponents);
        watchManagerUtil.updateView();
      }
      function afterPrint() {
        optimizeFormWatchers();
      }
      $window.addEventListener('beforeprint', beforePrint);
      $window.addEventListener('afterprint', afterPrint);
      $scope.$watch('formId', function (newValue, oldValue) {
        if (oldValue && newValue !== oldValue) {
          clearExistingForm();
        }
      });
      $scope.$on('$destroy', function () {
        parentElement.off('scroll', handleScroll);
        clearExistingForm();
        _.each(timeoutList, function (timeout) {
          $timeout.cancel(timeout);
        });
        $window.removeEventListener('beforeprint', beforePrint);
        $window.removeEventListener('afterprint', afterPrint);
      });
    }
    if (!$scope.supplemental) {
      configure();
    } else {
      formRenderingUtil.renderSupplemental(element, $scope.formData);
    }
  };
  return {
    restrict: 'A',
    link: linkFunction
  };
};
UIViewportManagerDirective.$inject = ["$window", "$rootScope", "$timeout", "formViewerConstant", "uiPerformanceLoggerConstant", "coreConstant", "formRenderingUtil", "watchManagerUtil", "timingModel", "formComponentRenderingUtil", "formatUtil", "umsLog"];
angular.module('umFormViewer').directive('uiViewportManager', UIViewportManagerDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1250 */,
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var WatchManagerUtil = function WatchManagerUtil($rootScope, formViewerConstant) {
  this.viewport = [];
  this.elementList = null;
  function checkInView(viewportDom, elementDom) {
    var viewport = $(viewportDom),
      viewportOffsetTop = viewport.offset().top,
      viewportHeight = viewport.height(),
      element = $(elementDom),
      topOfElement = element.offset().top,
      bottomOfElement = topOfElement + element.height(),
      topOfViewport = viewportOffsetTop,
      bottomOfViewport = viewportOffsetTop + viewportHeight;
    return topOfElement < bottomOfViewport + 1 && bottomOfElement > topOfViewport;
  }
  this.clearWatcherList = function (scope) {
    var child = scope.$$childHead,
      childScopeWatcherList = [],
      watchers,
      clearWatchers = true;
    if (scope && scope.$$watchers && scope.$$watchers.length !== 0) {
      watchers = scope.$$watchers;
      _.each(watchers, function (watcher) {
        if (watcher.exp === 'uiWatchIsVisible') {
          clearWatchers = false;
        }
      });
      if (clearWatchers) {
        scope.$$watchers = [];
      }
    }
    while (child) {
      childScopeWatcherList.push(this.clearWatcherList(child));
      child = child.$$nextSibling;
    }
    return function () {
      // Add back the watchers
      if (scope && watchers) {
        scope.$$watchers = _.union(scope.$$watchers, watchers);
      }

      // Add back the watchers for the children
      if (childScopeWatcherList.length !== 0) {
        angular.forEach(childScopeWatcherList, function (playChildWatcher) {
          playChildWatcher();
        });
      }
    };
  };
  this.setupScope = function (viewport, elementList) {
    // Make sure we reset properly, since the elementList being passed into this method may have all or some of the entries run through the
    // setupScope method before, and we want to make sure their watchers are re-enabled before we lose the references to them.
    this.reset();
    this.viewport = viewport;
    this.elementList = elementList;
    this.elementList = _.map(elementList, function (fieldComponent) {
      return {
        dom: fieldComponent,
        scope: angular.element(fieldComponent).scope(),
        isActive: true,
        reActivateWatcherList: null
      };
    });
  };
  this.updateView = function () {
    _.each(this.elementList, function (fieldComponent) {
      var isInView = checkInView(this.viewport[0], fieldComponent.dom);
      if (!isInView && fieldComponent.isActive) {
        fieldComponent.reActivateWatcherList = this.clearWatcherList(fieldComponent.scope);
        fieldComponent.isActive = false;
        fieldComponent.scope.watchersDisabled = true;
        $(fieldComponent.dom).addClass('watchersDisabled');
      }
      if (isInView && !fieldComponent.isActive) {
        fieldComponent.isActive = true;
        fieldComponent.scope.watchersDisabled = false;
        $(fieldComponent.dom).removeClass('watchersDisabled');
        fieldComponent.reActivateWatcherList();
      }
    }.bind(this));
    $rootScope.$broadcast(formViewerConstant.event.FORM_RENDERING_OPTIMIZE_WATCHERS);
  };
  this.resetScope = function () {
    _.each(this.elementList, function (fieldComponent) {
      if (!fieldComponent.isActive) {
        if (fieldComponent.reActivateWatcherList) {
          fieldComponent.reActivateWatcherList();
        }
      }
    });
  };
  this.resetScopeForFormId = function (formId) {
    _.each(this.elementList, function (fieldComponent) {
      if (!fieldComponent.isActive && fieldComponent.scope.fieldStructure.parentForm.id === formId) {
        if (fieldComponent.reActivateWatcherList) {
          fieldComponent.reActivateWatcherList();
        }
      }
    });
  };
  this.resetScopeForComponentId = function (componentId) {
    _.each(this.elementList, function (fieldComponent) {
      if (!fieldComponent.isActive && fieldComponent.scope.fieldStructure.id === componentId) {
        if (fieldComponent.reActivateWatcherList) {
          fieldComponent.reActivateWatcherList();
        }
      }
    });
  };
  this.reset = function () {
    this.resetScope();
    this.elementList = null;
    this.viewport = null;
  };
  this.resetByFormId = function (formId) {
    this.resetScopeForFormId(formId);
    this.elementList = _.filter(this.elementList, function (fieldComponent) {
      return fieldComponent.scope.fieldStructure.parentForm.id !== formId;
    });
  };
};
WatchManagerUtil.$inject = ["$rootScope", "formViewerConstant"];
angular.module('umFormViewer').service('watchManagerUtil', WatchManagerUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1252 */
/***/ (function(module, exports) {

/*@ngInject*/
var AddDeleteRepeatingFormConfigRepository = function AddDeleteRepeatingFormConfigRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getAddDeleteConfigByFormSummaryInstanceId = function (formId, formSummaryInstanceId) {
    var url = '/rest/Form/addDeleteRepeatingFormConfig',
      config = {
        params: {
          parentFormId: formId,
          repeatingFormId: formSummaryInstanceId
        }
      };
    return this.get(url, config);
  };
  this.getAddDeleteConfigByFormSummaryGridFieldName = function (formId, formSummaryGridFieldName) {
    var url = '/rest/Form/addDeleteRepeatingFormConfig',
      config = {
        params: {
          parentFormId: formId,
          formSummaryGridFieldName: formSummaryGridFieldName
        }
      };
    return this.get(url, config);
  };
};
AddDeleteRepeatingFormConfigRepository.$inject = ["baseRepository"];
angular.module('umFormViewer').service('addDeleteRepeatingFormConfigRepository', AddDeleteRepeatingFormConfigRepository);

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

/*@ngInject*/
var ClassCodeFormatRepository = function ClassCodeFormatRepository(baseCachedSharedPromiseRepository) {
  var sharedPromiseCache = {};
  angular.extend(this, baseCachedSharedPromiseRepository);
  this.getCacheName = function () {
    return 'classCodeFormatRepository';
  };
  this.getCacheCapacity = function () {
    return 10;
  };
  this.getSharedPromiseCache = function () {
    return sharedPromiseCache;
  };
  this.getClassCodeFormat = function (classCodeType) {
    var url = '/rest/ClassCode/Format',
      config = {
        params: {
          classCodeType: classCodeType
        }
      },
      cacheKey = classCodeType;
    return this.get(cacheKey, url, config);
  };
};
ClassCodeFormatRepository.$inject = ["baseCachedSharedPromiseRepository"];
angular.module('umFormViewer').service('classCodeFormatRepository', ClassCodeFormatRepository);

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(moment, _) {/*@ngInject*/
var ClassCodeRepository = function ClassCodeRepository(baseCachedRepository) {
  angular.extend(this, baseCachedRepository);
  this.getCacheName = function () {
    return 'classCodeRepository';
  };
  this.getCacheCapacity = function () {
    return 10;
  };
  this.getClassCodeItems = function (type, query, effectiveDate) {
    var url = '/rest/ClassCode',
      config = {
        params: {
          classCodeType: type,
          searchString: query,
          effectiveDate: moment(effectiveDate).utc().format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS)
        }
      },
      cacheKey = type + query;
    return this.get(cacheKey, url, config);
  };
  this.getClassCodeGroupings = function (type, effectiveDate) {
    var url = '/rest/ClassCode/Groupings',
      config = {
        params: {
          classCodeType: type,
          effectiveDate: moment(effectiveDate).utc().format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS)
        }
      },
      cacheKey = type + effectiveDate;
    return this.get(cacheKey, url, config);
  };
  this.processResponseData = function (responseData) {
    _.map(responseData, function (item) {
      item.value = item.description;
      item.description = (!_.isNil(item.codeDisplayText) ? item.codeDisplayText : item.code) + ' - ' + item.value;
      return item;
    });
    return responseData;
  };
};
ClassCodeRepository.$inject = ["baseCachedRepository"];
angular.module('umFormViewer').service('classCodeRepository', ClassCodeRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2), __webpack_require__(0)))

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(moment, _) {/*@ngInject*/
var ClassCodeItemsRepository = function ClassCodeItemsRepository(baseCachedSharedPromiseRepository) {
  var sharedPromiseCache = {};
  angular.extend(this, baseCachedSharedPromiseRepository);
  this.getCacheName = function () {
    return 'classCodeItemsRepository';
  };
  this.getCacheCapacity = function () {
    return 100;
  };
  this.getSharedPromiseCache = function () {
    return sharedPromiseCache;
  };
  this.getClassCodeItems = function (classCodeType, searchString, effectiveDate) {
    var url = '/rest/ClassCode',
      config = {
        params: {
          classCodeType: classCodeType,
          searchString: searchString,
          effectiveDate: moment(effectiveDate).utc().format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS)
        }
      },
      cacheKey = classCodeType + searchString + effectiveDate;
    return this.get(cacheKey, url, config);
  };
  this.getClassCodeItemsNoDate = function (classCodeType, searchString) {
    var url = '/rest/ClassCode',
      config = {
        params: {
          classCodeType: classCodeType,
          searchString: searchString
        }
      },
      cacheKey = classCodeType + searchString;
    return this.get(cacheKey, url, config);
  };
  this.processResponseData = function (responseData) {
    _.map(responseData, function (item) {
      item.value = item.description;
      item.description = (!_.isNil(item.codeDisplayText) ? item.codeDisplayText : item.code) + ' - ' + item.value;
      return item;
    });
    return responseData;
  };
};
ClassCodeItemsRepository.$inject = ["baseCachedSharedPromiseRepository"];
angular.module('umFormViewer').service('classCodeItemsRepository', ClassCodeItemsRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2), __webpack_require__(0)))

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(moment) {/*@ngInject*/
var ClassCodeGroupingsRepository = function ClassCodeGroupingsRepository(baseCachedSharedPromiseRepository) {
  var sharedPromiseCache = {};
  angular.extend(this, baseCachedSharedPromiseRepository);
  this.getCacheName = function () {
    return 'classCodeGroupingsRepository';
  };
  this.getCacheCapacity = function () {
    return 25;
  };
  this.getSharedPromiseCache = function () {
    return sharedPromiseCache;
  };
  this.getClassCodeGroupings = function (classCodeType, effectiveDate) {
    var url = '/rest/ClassCode/Groupings',
      config = {
        params: {
          classCodeType: classCodeType,
          effectiveDate: moment(effectiveDate).format('YYYY-MM-DD')
        }
      },
      cacheKey = classCodeType + effectiveDate;
    return this.get(cacheKey, url, config);
  };
};
ClassCodeGroupingsRepository.$inject = ["baseCachedSharedPromiseRepository"];
angular.module('umFormViewer').service('classCodeGroupingsRepository', ClassCodeGroupingsRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2)))

/***/ }),
/* 1257 */
/***/ (function(module, exports) {

/*@ngInject*/
var CloseFormRepository = function CloseFormRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.closeForm = function (rootFormId) {
    var url = '/rest/Form/List?registrationIdentifier=RootFormList_' + rootFormId;
    return this.delete(url);
  };
};
CloseFormRepository.$inject = ["baseRepository"];
angular.module('umFormViewer').service('closeFormRepository', CloseFormRepository);

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

/*@ngInject*/
var CreateFieldInstanceRepository = function CreateFieldInstanceRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.createFieldInstance = function (formId, instance) {
    var url = '/rest/Field?formId=' + formId;
    return this.post(url, instance);
  };
};
CreateFieldInstanceRepository.$inject = ["baseRepository"];
angular.module('umFormViewer').service('createFieldInstanceRepository', CreateFieldInstanceRepository);

/***/ }),
/* 1259 */
/***/ (function(module, exports) {

/*@ngInject*/
var FormInstanceRepository = function FormInstanceRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getFormInstanceById = function (formId) {
    var url = '/rest/Form/' + formId + '/List';
    return this.get(url);
  };
  this.processGetResponseData = function (responseData) {
    return responseData.formSummaries[0];
  };
};
FormInstanceRepository.$inject = ["baseRepository"];
angular.module('umFormViewer').service('formInstanceRepository', FormInstanceRepository);

/***/ }),
/* 1260 */
/***/ (function(module, exports) {

/*@ngInject*/
var FormRepository = function FormRepository(baseRepository, formRegistrationModel) {
  angular.extend(this, baseRepository);
  this.getFormsByRootFormId = function (rootFormId) {
    var url = '/rest/Form/' + rootFormId + '/List?registrationIdentifier=RootFormList_' + rootFormId;
    formRegistrationModel.addRegistration(rootFormId, '/rest/Form/List?registrationIdentifier=RootFormList_' + rootFormId);
    return this.get(url);
  };
  this.resetRequiredFieldCountByFormId = function (rootFormId) {
    var url = '/rest/Form/' + rootFormId + '/resetRequiredFieldCount';
    return this.post(url);
  };
};
FormRepository.$inject = ["baseRepository", "formRegistrationModel"];
angular.module('umFormViewer').service('formRepository', FormRepository);

/***/ }),
/* 1261 */
/***/ (function(module, exports) {

/*@ngInject*/
var FormSnippetBlobRepository = function FormSnippetBlobRepository(baseCachedRepository) {
  angular.extend(this, baseCachedRepository);
  this.getCacheName = function () {
    return 'snippetsBlobRepository';
  };
  this.getCacheCapacity = function () {
    return 10;
  };
  this.getSnippetBlob = function (snippetId) {
    var url = '/rest/Snippet/' + snippetId + '/blob',
      cacheKey = 'snippetBlob:' + snippetId;
    return this.get(cacheKey, url);
  };
};
FormSnippetBlobRepository.$inject = ["baseCachedRepository"];
angular.module('umFormViewer').service('formSnippetBlobRepository', FormSnippetBlobRepository);

/***/ }),
/* 1262 */
/***/ (function(module, exports) {

/*@ngInject*/
var FormSnippetsRepository = function FormSnippetsRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getFormSnippets = function (rootFormId) {
    var url = '/rest/Form/' + rootFormId + '/snippets';
    return this.get(url);
  };
};
FormSnippetsRepository.$inject = ["baseRepository"];
angular.module('umFormViewer').service('formSnippetsRepository', FormSnippetsRepository);

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FormTemplateRepository = function FormTemplateRepository($cacheFactory, $http, $q, baseCachedRepository) {
  angular.extend(this, baseCachedRepository);
  this.getCacheName = function () {
    return 'formTemplateRepository';
  };
  this.getCacheCapacity = function () {
    return 25;
  };
  this.loadUIFormTemplates = function (formTemplateIdList) {
    var templateIds = '',
      url,
      cachedUIFormTemplates = [],
      cache = $cacheFactory.get(this.getCacheName());
    if (!cache) {
      cache = $cacheFactory(this.getCacheName(), {
        capacity: this.getCacheCapacity()
      });
    }

    // Find out which uiFormTemplates are already cached.
    _.each(formTemplateIdList, function (formTemplateId) {
      if (cache.get(formTemplateId)) {
        cachedUIFormTemplates.push(cache.get(formTemplateId));
      } else {
        templateIds += 'formTemplateId=' + formTemplateId + '&';
      }
    });
    function onSuccess(response) {
      var uiFormTemplateList = [],
        unorderedUiFormTemplateList = [];
      if (response) {
        unorderedUiFormTemplateList = this.processResponseData(response.data);
        _.each(unorderedUiFormTemplateList, function (uiFormTemplate) {
          cache.put(uiFormTemplate.formTemplate.id, uiFormTemplate);
        });
        unorderedUiFormTemplateList = _.concat(unorderedUiFormTemplateList, cachedUIFormTemplates);

        // Order the returned list of UIFormTemplate objects such that they match the order of the
        // inputted formTemplateIdList
        _.each(formTemplateIdList, function (formTemplateId) {
          uiFormTemplateList.push(_.find(unorderedUiFormTemplateList, function (uiFormTemplate) {
            return uiFormTemplate.formTemplate.id === formTemplateId;
          }));
        });
        return $q.resolve(uiFormTemplateList);
      } else {
        return $q.reject();
      }
    }
    function onError(errorResponse) {
      return $q.reject(errorResponse.data);
    }
    if (_.isEmpty(templateIds)) {
      // If all are cached, then return them immediately.
      return $q.resolve(cachedUIFormTemplates);
    }

    // If any are not cached, then retrieve them from the server.
    url = '/rest/UIFormTemplate/Array?' + templateIds;
    return $http.get(url).then(onSuccess.bind(this), onError);
  };
};
FormTemplateRepository.$inject = ["$cacheFactory", "$http", "$q", "baseCachedRepository"];
angular.module('umFormViewer').service('formTemplateRepository', FormTemplateRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

/*@ngInject*/
var LoadFieldInstanceListRepository = function LoadFieldInstanceListRepository(baseRepository, formRegistrationModel) {
  angular.extend(this, baseRepository);
  this.loadFieldInstanceList = function (formId, registrationIdentifier) {
    var url = '/rest/Field/List?formId=' + formId + '&registrationIdentifier=' + registrationIdentifier;
    formRegistrationModel.addRegistration(formId, url);
    return this.get(url);
  };
};
LoadFieldInstanceListRepository.$inject = ["baseRepository", "formRegistrationModel"];
angular.module('umFormViewer').service('loadFieldInstanceListRepository', LoadFieldInstanceListRepository);

/***/ }),
/* 1265 */
/***/ (function(module, exports) {

/*@ngInject*/
var LoadRowInstanceListRepository = function LoadRowInstanceListRepository(baseRepository, formRegistrationModel) {
  angular.extend(this, baseRepository);
  this.loadRowInstanceList = function (formId, registrationIdentifier) {
    var url = '/rest/FormRow/List?formId=' + formId + '&registrationIdentifier=' + registrationIdentifier;
    formRegistrationModel.addRegistration(formId, url);
    return this.get(url);
  };
};
LoadRowInstanceListRepository.$inject = ["baseRepository", "formRegistrationModel"];
angular.module('umFormViewer').service('loadRowInstanceListRepository', LoadRowInstanceListRepository);

/***/ }),
/* 1266 */
/***/ (function(module, exports) {

/*@ngInject*/
var LoadRowInstanceRepository = function LoadRowInstanceRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadRowInstanceList = function (rowId) {
    var url = '/rest/FormRow/' + rowId;
    return this.get(url);
  };
};
LoadRowInstanceRepository.$inject = ["baseRepository"];
angular.module('umFormViewer').service('loadRowInstanceRepository', LoadRowInstanceRepository);

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

/*@ngInject*/
var RemoteFunctionRepository = function RemoteFunctionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.executeFunction = function (formId, submissionId, beanName, fieldId, paramMap) {
    var url = '/rest/Form/' + formId + '/executor?beanName=' + beanName + (submissionId ? '&submissionId=' + submissionId : '') + (fieldId ? '&fieldId=' + fieldId : '');
    return this.post(url, paramMap);
  };
};
RemoteFunctionRepository.$inject = ["baseRepository"];
angular.module('umFormViewer').service('remoteFunctionRepository', RemoteFunctionRepository);

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UiFormTemplateRepository = function UiFormTemplateRepository(baseRepository, databaseDownloadSectionName, temporaryLoginTokenRepository) {
  angular.extend(this, baseRepository);
  this.getUiFormTemplatesByFilterUri = function (filterUri, requestParams) {
    var url = '/rest/UIFormTemplate/filter',
      config = {
        params: {
          filterUri: filterUri,
          sortBy: requestParams.key,
          sortDirection: requestParams.sortType,
          startIndex: requestParams.startIndex,
          numberOfRows: requestParams.pageSize
        }
      };
    return this.get(url, config);
  };
  this.getUIFormTemplatesByMatchingName = function (matchingName) {
    var url = '/rest/UIFormTemplate/uniqueNames/',
      config = {
        params: {
          matchingName: matchingName
        }
      };
    return this.get(url, config);
  };
  this.getFieldOptions = function (formTemplateUniqueName, fieldName) {
    var url = '/rest/UIFormTemplate/fieldOptions',
      config = {
        params: {
          formTemplateUniqueName: formTemplateUniqueName,
          fieldName: fieldName
        }
      };
    return this.get(url, config);
  };
  this.getUiFormTemplateById = function (uiFormTemplateId) {
    var url = '/rest/UIFormTemplate/' + uiFormTemplateId,
      config = {};
    return this.get(url, config);
  };
  this.getFieldRulesByUIFormTemplateId = function (uiFormTemplateId) {
    var url = '/rest/UIFormTemplate/' + uiFormTemplateId + '/fieldRules',
      config = {};
    return this.get(url, config);
  };
  this.createFormTemplate = function (uiFormTemplate) {
    var url = '/rest/UIFormTemplate';
    return this.post(url, uiFormTemplate);
  };
  this.updateFormTemplate = function (uiFormTemplate, id) {
    var url = '/rest/UIFormTemplate/' + id;
    return this.post(url, uiFormTemplate);
  };
  this.findReferenceCountByFieldTemplateId = function (fieldTemplateId) {
    var url = '/rest/UIFormTemplate/findReferenceCountByFieldTemplateId',
      config = {
        params: {
          fieldTemplateId: fieldTemplateId
        }
      };
    return this.get(url, config);
  };
  this.deleteUIFormTemplates = function (uiFormTemplateIds) {
    var url = '/rest/UIFormTemplate',
      config = {
        params: {
          uiFormTemplateIds: uiFormTemplateIds
        }
      };
    return this.delete(url, config);
  };
  this.markFormTemplatesInProduction = function (uiFormTemplateIds) {
    var url = '/rest/UIFormTemplate/markInProduction',
      config = {
        params: {
          uiFormTemplateIds: uiFormTemplateIds
        }
      };
    return this.post(url, {}, config);
  };
  this.markFormTemplatesInProductionByFilterUri = function (filterUri, excludedUiFormTemplateIds) {
    var url = '/rest/UIFormTemplate/markInProduction',
      config = {
        params: {
          filterUri: filterUri,
          excludedFormTemplateIds: excludedUiFormTemplateIds
        }
      };
    return this.post(url, {}, config);
  };
  this.importFormTemplates = function (file) {
    var _this = this;
    var url = '/databaseUpload/DatabaseUploadServlet',
      formData = new FormData(),
      config = {
        transformRequest: angular.identity,
        params: {
          mode: 'unmarshal',
          operation: 'INSERT',
          sectionName: databaseDownloadSectionName.FORM_TEMPLATES
        },
        // When you assign undefined, the content type defaults to multipart/form-data
        headers: {
          'Content-Type': undefined
        }
      };
    formData.append('file', file);
    return temporaryLoginTokenRepository.getSingleUseToken().then(function (token) {
      config.params.t = token;
      return _this.post(url, formData, config);
    });
  };
  this.exportFormTemplates = function (formTemplateIds) {
    var _this2 = this;
    var url = '/database',
      config = {
        params: {
          mode: 'marshal',
          sectionName: databaseDownloadSectionName.FORM_TEMPLATES,
          entityIdentifiers: _.join(formTemplateIds)
        }
      };
    return temporaryLoginTokenRepository.getSingleUseToken().then(function (token) {
      config.params.t = token;
      return _this2.get(url, config);
    });
  };
  this.exportFormTemplatesByFilterUri = function (filterUri, excludedFormTemplateIds) {
    var _this3 = this;
    var url = '/databaseWithFilter',
      config = {
        params: {
          mode: 'marshal',
          sectionName: databaseDownloadSectionName.FORM_TEMPLATES,
          filterUri: filterUri,
          excludedEntityIdentifiers: _.join(excludedFormTemplateIds)
        }
      };
    return temporaryLoginTokenRepository.getSingleUseToken().then(function (token) {
      config.params.t = token;
      return _this3.get(url, config);
    });
  };
  this.reloadFormRules = function (validate) {
    var url = '/rest/UIFormTemplate/reloadFormRules',
      config = {
        params: {
          validate: validate
        }
      };
    return this.post(url, {}, config);
  };
  this.reloadFieldRules = function (validate) {
    var url = '/rest/UIFormTemplate/reloadFieldRules',
      config = {
        params: {
          validate: validate
        }
      };
    return this.post(url, {}, config);
  };
  this.getByFormTemplateIds = function (formTemplateIds) {
    var url = '/rest/UIFormTemplate/Array?formTemplateId=' + formTemplateIds;
    return this.get(url);
  };
  this.getRepeatingFormTemplateUniqueNames = function () {
    var url = '/rest/UIFormTemplate/repeatingFormTemplateUniqueNames';
    return this.get(url);
  };
  this.getJsBuilderOptions = function (uiFormTemplateId) {
    var url = '/rest/UIFormTemplate/' + uiFormTemplateId + '/jsOptions';
    return this.get(url);
  };
  this.validateRegExp = function (regExp, value) {
    var url = '/rest/UIFormTemplate/validateRegEx',
      body = 'regExp=' + encodeURIComponent(regExp) + '&value=' + encodeURIComponent(value),
      config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
    return this.post(url, body, config);
  };
  this.formTemplateBackup = function () {
    var _this4 = this;
    var url = '/database/DatabaseDownloadServlet',
      config = {
        params: {
          sectionName: databaseDownloadSectionName.FORM_TEMPLATES
        }
      };
    return temporaryLoginTokenRepository.getSingleUseToken().then(function (token) {
      config.params.t = token;
      return _this4.get(url, config);
    });
  };
  this.findUIFieldByUIFormTemplateUniqueNameAndFieldName = function (uiFormTemplateUniqueName, fieldName) {
    var url = '/rest/UIFormTemplate/UIField',
      config = {
        params: {
          uiFormTemplateUniqueName: uiFormTemplateUniqueName,
          fieldName: fieldName
        }
      };
    return this.get(url, config);
  };
};
UiFormTemplateRepository.$inject = ["baseRepository", "databaseDownloadSectionName", "temporaryLoginTokenRepository"];
angular.module('umCore').service('uiFormTemplateRepository', UiFormTemplateRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1269 */
/***/ (function(module, exports) {

/*@ngInject*/
var UpdateFieldInstanceRepository = function UpdateFieldInstanceRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.updateFieldInstance = function (fieldId, instance) {
    var url = '/rest/Field/' + fieldId;
    return this.post(url, instance);
  };
};
UpdateFieldInstanceRepository.$inject = ["baseRepository"];
angular.module('umFormViewer').service('updateFieldInstanceRepository', UpdateFieldInstanceRepository);

/***/ }),
/* 1270 */
/***/ (function(module, exports) {

var path = '/formViewer/structure/repeatingRow/repeatingRow.tpl.html';
var html = "<div class=\"formRowContainer {{ 'row' + $ctrl.row.rowModel.rowNumber }}\"\n     ng-class=\"{\n        deleteMode: $ctrl.row.isDeleting,\n        fadeRows: $ctrl.row.isDeleting\n     }\"\n     ng-click=\"$ctrl.onSelectRow($event)\"\n     ui-scroll-into-view>\n\n    <div class=\"formComponent rowSelector\"\n         ng-if=\"$ctrl.row.isDeleting\">\n\n        <input type=\"checkbox\"\n               ng-disabled=\"$ctrl.row.isRowDeleteDisabled\"\n               class=\"deleteCheckbox\"\n               ng-checked=\"$ctrl.row.selected\"/>\n    </div>\n\n    <div class=\"formComponent rowNumber\" ng-show=\"!$ctrl.hideRowNumbers\">\n        <span>{{ $ctrl.row.rowModel.rowNumber + 1 }}</span>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1271 */
/***/ (function(module, exports) {

var RepeatingRowComponent = {
  templateUrl: '/formViewer/structure/repeatingRow/repeatingRow.tpl.html',
  controller: 'repeatingRowController',
  bindings: {
    row: '<',
    hideRowNumbers: '<',
    configurable: '<'
  }
};
angular.module('umFormViewer').component('uiRepeatingRow', RepeatingRowComponent);

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

/*@ngInject*/
var RepeatingRowController = function RepeatingRowController($rootScope, $scope, $element, fieldType, formViewerConstant) {
  this.$onInit = function () {
    $element.addClass('formRow');
    $element.addClass('repeatingFormRow');
  };
  this.onSelectRow = function (event) {
    $rootScope.$broadcast(formViewerConstant.event.REPEATING_ROW_SELECTED, event, this.row);
  };
};
RepeatingRowController.$inject = ["$rootScope", "$scope", "$element", "fieldType", "formViewerConstant"];
angular.module('umFormViewer').controller('repeatingRowController', RepeatingRowController);

/***/ }),
/* 1273 */
/***/ (function(module, exports) {

var path = '/formViewer/structure/repeatingRow/repeatingRowPlaceholder.tpl.html';
var html = "<ui-repeating-row row=\"row\"\n                  hide-row-numbers=\"hideRowNumbers\"\n                  configurable=\"configurable\"></ui-repeating-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1274 */
/***/ (function(module, exports) {

var path = '/formViewer/structure/row/row.tpl.html';
var html = "<div class=\"formRowContainer\"\n     ng-class=\"{\n        removeIndent: $ctrl.shouldRemoveIndent($ctrl.row)\n     }\"\n     ui-scroll-into-view=\"{{ ::!$ctrl.containsSupplementalForm }}\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1275 */
/***/ (function(module, exports) {

var RowComponent = {
  templateUrl: '/formViewer/structure/row/row.tpl.html',
  controller: 'rowController',
  bindings: {
    row: '<'
  }
};
angular.module('umFormViewer').component('uiRow', RowComponent);

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var RowController = function RowController($scope, $element, fieldType) {
  var _this = this;
  $element.addClass('formRow');
  this.$onInit = function () {
    _this.containsSupplementalForm = !_.isEmpty(_this.row.formName);
  };
  this.shouldRemoveIndent = function (rowStructure) {
    var fieldStructureList = rowStructure.fieldStructureList,
      hasOneField = fieldStructureList ? fieldStructureList.length === 1 : true,
      field = fieldStructureList ? fieldStructureList[0] : null,
      fieldTemplateType = field ? field.uiField.fieldTemplate.type : -1,
      isLabelField = fieldTemplateType === fieldType.LABEL,
      isRowRepeater = fieldTemplateType === fieldType.ROWREPEATER,
      isSupplementalForm = rowStructure.formName;
    return isLabelField && hasOneField && !isRowRepeater || isSupplementalForm;
  };
};
RowController.$inject = ["$scope", "$element", "fieldType"];
angular.module('umFormViewer').controller('rowController', RowController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1277 */
/***/ (function(module, exports) {

var path = '/formViewer/structure/row/rowPlaceholder.tpl.html';
var html = "<ui-row row=\"row\"></ui-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ErrorInResponseInterceptor = function ErrorInResponseInterceptor($rootScope, $q, $injector, coreConstant, loadingBarHandler, registerableResourceConstants) {
  var _umsLog;
  function getUmsLog() {
    if (!_umsLog) {
      _umsLog = $injector.get('umsLog');
    }
    return _umsLog;
  }
  return {
    responseError: function responseError(response) {
      var invalidSessionError = response.status === 454,
        umsLog,
        error;
      if (invalidSessionError) {
        $rootScope.$broadcast(coreConstant.event.INVALID_SESSION);
      } else if (response.data && response.headers().returnstatusdesc === 'expired password') {
        $rootScope.$broadcast(coreConstant.event.EXPIRED_PASSWORD);
      } else if (response.data && response.data.errorMessage === registerableResourceConstants.INVALID_REGISTRATION_IDENTIFIER_ERROR) {
        return $q.resolve(response);
      } else if (_.includes(response.config.url, '/localization.json')) {
        // Log, but don't display  error for missing language pack.  Silent fallback to English
        umsLog = getUmsLog();
        error = response.config.method + ' ' + response.config.url + ' ' + response.status + ' (' + response.statusText + ')';
        umsLog.error.apply(umsLog, [error, response.config.url]);
      } else if (!_.includes(response.config.url, '/rest/Log')) {
        // Make sure we don't log errors from errors while logging errors :)
        umsLog = getUmsLog();
        error = response.config.method + ' ' + response.config.url + ' ' + response.status + ' (' + response.statusText + ')';
        umsLog.error.apply(umsLog, [error, response.config.url]).then(function (logInfo) {
          $rootScope.$broadcast(coreConstant.event.HANDLE_ERROR, response.data, logInfo);
        });
      }
      loadingBarHandler.hideLoadingBar();
      loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
      return $q.reject(response);
    }
  };
};
ErrorInResponseInterceptor.$inject = ["$rootScope", "$q", "$injector", "coreConstant", "loadingBarHandler", "registerableResourceConstants"];
angular.module('umCore').factory('errorInResponseInterceptor', ErrorInResponseInterceptor);
angular.module('umCore').config(["$httpProvider", function ($httpProvider) {
  $httpProvider.interceptors.push('errorInResponseInterceptor');
}]);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, i18n) {/*@ngInject*/
var Localization = function Localization($http, $q, $window, umsLog) {
  var loadDefault = true,
    isLoading = false,
    defer = null,
    translations = null;
  this.getTranslationByKey = function (key) {
    var keyDefer = $q.defer();
    function handleSuccess(translations) {
      var localizedString = '';
      if (key) {
        localizedString = _.get(translations, key.trim());
        if (_.isEmpty(localizedString)) {
          umsLog.info('Can\'t find localized string for key: ' + key);
        }
      }
      keyDefer.resolve(localizedString);
    }
    function handleError(error) {
      keyDefer.reject(error);
    }
    this.getTranslations().then(handleSuccess, handleError);
    return keyDefer.promise;
  };
  this.getTranslationsByKeys = function (keys) {
    var defer = $q.defer(),
      promiseList = [];
    _.each(keys, function (key) {
      if (!_.isNil(key)) {
        promiseList.push(this.getTranslationByKey(key));
      }
    }.bind(this));
    $q.all(promiseList).then(function (results) {
      var mergedTranslations = {};
      _.each(results, function (result) {
        // Order of merge matters here, we want keys in the list that have lower index to overwrite higher index entries.
        mergedTranslations = _.merge(_.cloneDeep(result), mergedTranslations);
      });
      defer.resolve(mergedTranslations);
    });
    return defer.promise;
  };
  this.getTranslations = function () {
    function loadLocalizationFile(language) {
      var url = 'localization/' + language + '/localization.json';
      function loadLanguageFileSuccess(result) {
        return result;
      }
      function loadLanguageFileError(error) {
        if (loadDefault) {
          loadDefault = false;
          return loadLocalizationFile('en-US');
        } else {
          return $q.reject(error);
        }
      }
      return $http.get(url).then(loadLanguageFileSuccess, loadLanguageFileError);
    }
    function handleSuccess(response) {
      isLoading = false;
      translations = response.data;
      if (defer) {
        defer.resolve(translations);
      }
      defer = null;
    }
    function handleError(error) {
      isLoading = false;
      return defer.reject(error);
    }
    if (_.isNull(defer)) {
      defer = $q.defer();
    }
    if (isLoading) {
      return defer.promise;
    } else if (translations) {
      defer.resolve(translations);
    } else {
      isLoading = true;
      var language = $window.navigator.language;
      loadLocalizationFile(language).then(handleSuccess.bind(this), handleError);
    }
    return defer.promise;
  };
  this.setupLocale = function (namespace, resourceBundle) {
    var namespaceExists = i18n.hasResourceBundle('en-US', namespace);
    if (!namespaceExists) {
      i18n.loadNamespaces(namespace);
    }
    i18n.addResourceBundle('en-US', namespace, resourceBundle, true, true);
  };
};
Localization.$inject = ["$http", "$q", "$window", "umsLog"];
angular.module('umCore').service('localization', Localization);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(18)["default"]))

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

/*@ngInject*/
var UITranslateDirective = function UITranslateDirective(localization, $interpolate) {
  var linkFunction = function linkFunction($scope, $elm, $attr, controller, transclusionFn) {
    var key = null;
    transclusionFn($scope, function (clone) {
      var innerHtml = clone[0].nodeValue;
      if (innerHtml) {
        key = $interpolate(innerHtml)($scope);
        localization.getTranslationByKey(key).then(function (translation) {
          $elm.html(translation ? translation : key.trim());
        });
      }
    });
  };
  return {
    restrict: 'A',
    transclude: true,
    link: linkFunction
  };
};
UITranslateDirective.$inject = ["localization", "$interpolate"];
angular.module('umCore').directive('uiTranslate', UITranslateDirective);

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(i18n) {/*@ngInject*/
var UILocaleDirective = function UILocaleDirective(localization, $interpolate) {
  var linkFunction = function linkFunction($scope, $elm, $attr, controller, transclusionFn) {
    var key = null;
    transclusionFn($scope, function (clone) {
      var innerHtml = clone[0].nodeValue;
      if (innerHtml) {
        key = $interpolate(innerHtml)($scope);
        var translatedText = i18n.t(key);
        $elm.html(translatedText);
      }
    });
  };
  return {
    restrict: 'A',
    transclude: true,
    link: linkFunction
  };
};
UILocaleDirective.$inject = ["localization", "$interpolate"];
angular.module('umCore').directive('uiLocale', UILocaleDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(18)["default"]))

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

/*@ngInject*/
var UiPerformanceLogger = function UiPerformanceLogger(coreMediator, clientType) {
  var activeLogs = {};
  this.startLog = function (logAction, message) {
    // Create an activeLog entry and store it in the map.
    var activeLog = {
      logAction: logAction,
      message: message,
      startTime: new Date()
    };
    activeLogs[logAction] = activeLog;
  };
  this.endLog = function (logAction, status, newMessage, isLogOut) {
    if (activeLogs[logAction]) {
      var activeLog = activeLogs[logAction];
      if (isLogOut) {
        endLogContinue(logAction, status, newMessage);
      } else {
        coreMediator.loadUserProfile().then(function (userProfile) {
          activeLog.username = userProfile.userName;
          endLogContinue(logAction, status, newMessage);
        });
      }
    }
  };
  this.endLogWithoutLogging = function (logAction) {
    if (activeLogs[logAction]) {
      delete activeLogs[logAction];
    }
  };
  function endLogContinue(logAction, status, newMessage) {
    // Retrieve the activeLog entry and persist the record to the server.
    var activeLog = activeLogs[logAction];
    var now = new Date();
    var uiPerformanceLog = {
      logAction: logAction,
      message: newMessage ? newMessage : activeLog.message,
      username: activeLog.username,
      elapsedTime: (now - activeLog.startTime) / 1000,
      status: status,
      clientType: clientType.HTML,
      logDate: now.getTime()
    };

    // Make sure to clear the log from the activeLogs map, and make sure to do it before making
    // the async request to ensure that another broadcast of the END_UI_PERFORMANCE_LOG can trigger
    // sending the same log.
    delete activeLogs[logAction];
    coreMediator.createUiPerformanceLog(uiPerformanceLog);
  }
};
UiPerformanceLogger.$inject = ["coreMediator", "clientType"];
angular.module('umCore').service('uiPerformanceLogger', UiPerformanceLogger);

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

angular.module('umCore').constant('uiPerformanceLoggerConstant', {
  // CONSTANTS FOR THE UI PERFORMANCE LOGGER
  SUBMIT_SUBMISSION: 'submitSubmission',
  CLEAR_SUBMISSION: 'clearSubmission',
  CLEAR_READY_SUBMISSION: 'clearReadySubmission',
  DECLINE_SUBMISSION: 'declineSubmission',
  NEW_SUBMISSION: 'newSubmission',
  MAKE_SUBMISSION: 'makeSubmission',
  SHOW_FORM: 'showForm',
  GET_RATE: 'getRate',
  BEGIN_BINDING: 'beginBinding',
  BIND: 'bind',
  GENERATE_BINDER: 'generateBinder',
  LOGIN: 'login',
  LOGOUT: 'logout',
  SUBMISSION_HOME: 'submissionHome',
  TASK_HOME: 'taskHome',
  REQUEST_BINDING: 'requestBinding',
  DELETE_QUOTE: 'deleteQuote',
  COPY_QUOTE: 'copyQuote',
  COPY_QUOTE_FOR_MULTI_QUOTE_PROPOSAL: 'copyQuoteForMultiQuoteProposal',
  CHANGE_PRODUCTS: 'changeProducts',
  UPDATE_STATUS_REASON: 'updateStatusReason',
  SEND_PROPOSAL: 'sendProposalToProducer',
  REFER_SUBMISSION: 'referSubmission',
  RETRACT_REFERRAL: 'retractReferral',
  BEGIN_ISSUANCE: 'beginIssuance',
  REVERT_TO_BOUND: 'revertToBound',
  SUBMIT_FOR_ISSUANCE: 'submitForIssuance',
  MODIFY_ISSUANCE: 'modifyIssuance',
  MARK_AS_ISSUED: 'markAsIssued',
  MARK_AS_LOST: 'markAsLost',
  MARK_EXPIRED: 'markExpired',
  MARK_RENEWED: 'markRenewed',
  MARK_NON_RENEWED: 'markNonRenewed',
  REVERT_TO_PENDING_ISSUANCE: 'revertToPendingIssuance',
  CLEAR_REFERRAL: 'clearReferral',
  DECLINE_REFERRAL: 'declineReferral',
  SPLIT_SUBMISSION: 'splitSubmission',
  START_POLICY_CANCELLATION: 'startPolicyCancellation',
  DELETE_DRAFT_CANCELLATION: 'deleteDraftCancellation',
  SUBMIT_FOR_CANCELLATION: 'submitForCancellation',
  MARK_AS_CANCELLED: 'markAsCancelled',
  REVERT_TO_CANCELLATION_PENDING: 'revertToCancellationPending',
  RESCIND_CANCELLATION: 'rescindCancellation',
  REQUEST_CANCELLATION: 'requestCancellation',
  RETRACT_CANCELLATION_REQUEST: 'retractCancellationRequest',
  RESUBMIT_SUBMISSION: 'resubmitSubmission',
  SUBMIT_RENEWAL: 'submitRenewal',
  SUBMIT_NON_RENEWAL: 'submitNonRenewal',
  RETRACT_NON_RENEWAL: 'retractNonRenewal',
  FLAG_FOR_NON_RENEWAL: 'flagForNonRenewal',
  CLEAR_NON_RENEWAL_FLAG: 'clearNonRenewalFlag',
  DISABLE_AUTOMATION: 'disableAutomation',
  CREATE_QUOTE: 'createQuote',
  POLICY_SUMMARY_GRID: 'policySummaryGrid',
  PROPOSAL_SUMMARY_GRID: 'proposalSummaryGrid',
  UNBIND: 'unbind',
  REINSTATE_POLICY: 'reinstatePolicy',
  MODIFY_BINDER: 'modifyBinder',
  ADD_SECTION: 'addSection',
  DELETE_SECTION: 'deleteSection',
  REVERT_TO_SENT: 'revertToSent',
  WITHDRAW_QUOTE: 'withdrawQuote',
  GENERATE_RATING_ATTACHMENTS: 'generateRatingAttachments',
  DELETE_ENDORSEMENT: 'deleteEndorsement',
  SUBMIT_ENDORSEMENT: 'submitEndorsement',
  MARK_ENDORSEMENT_AS_ISSUED: 'markEndorsementAsIssued',
  DECLINE_ENDORSEMENT: 'declineEndorsement',
  APPROVE_ENDORSEMENT: 'approveEndorsement',
  REVERT_TO_CLEAR: 'revertToClear',
  DELETE_USER: 'deleteUser',
  DEACTIVATE_USER: 'deactivateUser',
  ACTIVATE_USER: 'activateUser',
  RESET_PASSWORD: 'resetPassword',
  CREATE_PASSWORD: 'createPassword',
  UNLOCK_USER: 'unlockUser',
  RELOAD_FORM_RULES: 'reloadFormRules',
  RELOAD_FIELD_RULES: 'reloadFieldRules',
  RELOAD_SECTION_TEMPLATE_RULES: 'reloadSectionTemplateRules',
  DECLINE_TO_BIND: 'declineToBind',
  WITHDRAW_REQUEST: 'withdrawRequest',
  REDEPLOY_RULE_SETS: 'redeployRuleSets',
  UPDATE_PRODUCT_TEMPLATE: 'updateProductTemplate',
  CREATE_PRODUCT_TEMPLATE: 'createProductTemplate',
  DELETE_ORGANIZATION: 'deleteOrganization',
  DEACTIVATE_ORGANIZATION: 'deactivateOrganization',
  ACTIVATE_ORGANIZATION: 'activateOrganization',
  COPY_PROPOSAL: 'copyProposal',
  UPDATE_EMAIL_SIGNATURE: 'updateEmailSignature',
  UPDATE_PERMISSION: 'updatePermission',
  COPY_SUBMISSION: 'copySubmission',
  REWRITE_SUBMISSION: 'rewriteSubmission',
  ASSIGN_ACCOUNT_EXISTING: 'assignAccountExisting',
  ASSIGN_ACCOUNT_CREATE_NEW: 'assignAccountCreateNew',
  ASSIGN_ACCOUNT_SEARCH: 'assignAccountSearch',
  UPLOAD_ATTACHMENT: 'uploadAttachment',
  CREATE_ENDORSEMENT: 'createEndorsement',
  CREATE_PROPOSAL: 'createProposal',
  GENERATE_QUOTE: 'generateQuote',
  START_QUOTE: 'startQuote',
  SHOW_DOCUMENT: 'showDocument',
  CREATE_POLICY_REWRITE: 'createPolicyRewrite',
  DELETE_POLICY_REWRITE: 'deletePolicyRewrite',
  MARK_POLICY_REWRITE_AS_ISSUED: 'markPolicyRewriteAsIssued'
});

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

/*@ngInject*/
var UiPerformanceLogRepository = function UiPerformanceLogRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.createUiPerformanceLog = function (log) {
    var url = '/rest/UIPerformanceLogger',
      data = [log];
    return this.post(url, data);
  };
};
UiPerformanceLogRepository.$inject = ["baseRepository"];
angular.module('umCore').service('uiPerformanceLogRepository', UiPerformanceLogRepository);

/***/ }),
/* 1285 */
/***/ (function(module, exports) {

/*@ngInject*/
var LogRepository = function LogRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.log = function (log, level) {
    var url = '/rest/Log' + (level ? '?level=' + level : ''),
      data = [log];
    return this.post(url, data);
  };
};
LogRepository.$inject = ["baseRepository"];
angular.module('umCore').service('logRepository', LogRepository);

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(moment, _) {var StackTrace = __webpack_require__(1287);

/*@ngInject*/
var LogUtil = function LogUtil($q, $log, $window, $state, $stateParams, appTypeConfigurationModel, logRepository, coreConstant, loginTokenRepository) {
  function log(logLevel, message, context, stacktrace) {
    var log = {
        clientType: 'HTML',
        timestamp: moment().format('YYYY-MM-DD HH:mm:ss,SSS'),
        message: message,
        context: context
      },
      defer = $q.defer();
    if (stacktrace) {
      log.stacktrace = stacktrace;
    }
    logRepository.log(log, logLevel).finally(function () {
      defer.resolve(log);
    });
    return defer.promise;
  }
  function buildContext(url) {
    var context = {
      browser: $window.navigator.userAgent,
      location: $window.location.href,
      state: $state.current.name
    };
    _.assignIn(context, $stateParams);
    if (url) {
      context.url = url;
    }
    return context;
  }
  this.logError = function (error, url) {
    if (!_.isNil(loginTokenRepository.getLoginToken())) {
      return StackTrace.fromError(error, {
        offline: true
      }).then(function (stackframes) {
        var errorMessage = error.name + ': ' + error.message,
          // Parse the stackframes into a nice format:
          stacktrace = _.join(_.map(stackframes, function (sf) {
            if (sf.fileName === '(native)') {
              return '\tat ' + sf.functionName + ' ' + sf.fileName;
            } else {
              return '\tat ' + sf.functionName + ' (' + sf.fileName + ':' + sf.lineNumber + ':' + sf.columnNumber + ')';
            }
          }), '\n');
        stacktrace = errorMessage + '\n' + stacktrace;
        return log('ERROR', errorMessage, buildContext(url), stacktrace);
      }).catch(function (error) {
        $log.error(error);
      });
    } else {
      return $q.when();
    }
  };
  this.logWarning = function (message) {
    return log('WARN', message, buildContext());
  };
  this.logInfo = function (message) {
    return log('INFO', message, buildContext());
  };
  this.logDebug = function (message) {
    return log('DEBUG', message, buildContext());
  };
  this.logTrace = function (message) {
    return log('TRACE', message, buildContext());
  };
};
LogUtil.$inject = ["$q", "$log", "$window", "$state", "$stateParams", "appTypeConfigurationModel", "logRepository", "coreConstant", "loginTokenRepository"];
angular.module('umCore').service('logUtil', LogUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2), __webpack_require__(0)))

/***/ }),
/* 1287 */,
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UMSLog = function UMSLog($log, logUtil) {
  this.debug = function (message) {
    $log.debug(message);
  };
  this.error = function (error, url) {
    if (_.isString(error)) {
      error = new Error(error);

      // In IE11, creating a new Error does not automatically populate the stack property,
      // which is needed for StackTraceJS parsing. So, in order to generate the stack, throw
      // the new error, catch it, and set the stack.
      if (!error.stack) {
        try {
          throw error;
        } catch (e) {
          error.stack = e.stack;
        }
      }
    }
    $log.error(error);
    return logUtil.logError(error, url);
  };
  this.info = function (message) {
    $log.info(message);
  };
  this.warn = function (message) {
    $log.warn(message);
  };
};
UMSLog.$inject = ["$log", "logUtil"];
angular.module('umCore').service('umsLog', UMSLog);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1289 */
/***/ (function(module, exports) {

/*@ngInject*/
var AppTypeConfigurationModel = function AppTypeConfigurationModel($q, coreConstant, authorizationConstants, clientType, userTypeConstant) {
  var consoleType = null,
    userType = null,
    channelMappings = {
      'Agent': 'allAgents',
      'Underwriter': 'allUws',
      'ServiceUser': 'allSUs'
    },
    consoleTitleMappings = {
      'umagent': 'homePage.agentTitle',
      'um': 'homePage.underwriterTitle',
      'umstudio': 'homePage.umStudioTitle',
      'appreader': 'homePage.appreaderTitle'
    };
  this.setConsoleType = function (type) {
    consoleType = type;
  };
  this.getConsoleType = function () {
    return consoleType;
  };
  this.getConsoleTypeAuthorizationName = function () {
    var result,
      consoleType = this.getConsoleType();
    if (consoleType === coreConstant.authorization.CONSOLE_TYPE_UM_AGENT) {
      result = authorizationConstants.LOGIN_AGENT_WORKSPACE;
    } else if (consoleType === coreConstant.authorization.CONSOLE_TYPE_UM) {
      result = authorizationConstants.LOGIN_UNDERWRITER_WORKSTATION;
    } else if (consoleType === coreConstant.authorization.CONSOLE_TYPE_UM_STUDIO) {
      result = authorizationConstants.LOGIN_CONFIGURATOR;
    } else if (consoleType === coreConstant.authorization.CONSOLE_TYPE_APPREADER) {
      result = authorizationConstants.LOGIN_APPREADER;
    }
    return result;
  };
  this.appendConsoleType = function (key) {
    return key + '::' + this.getConsoleType();
  };
  this.setUserType = function (type) {
    userType = type;
  };
  this.getUserType = function () {
    return userType;
  };
  this.isAgentConsole = function () {
    return userType === userTypeConstant.AGENT;
  };
  this.isUnderwriterWorkstation = function () {
    return userType === userTypeConstant.UNDERWRITER || userType === userTypeConstant.SERVICEUSER;
  };
  this.isAdminWorkstation = function () {
    return userType === userTypeConstant.SYSTEMUSER;
  };
  this.clearUserType = function () {
    userType = null;
  };
  this.getAllChannel = function () {
    return channelMappings[userType];
  };
  this.getConsoleTitleKey = function () {
    return consoleTitleMappings[consoleType];
  };
  this.getApplicationId = function () {
    var applicationId;
    if (consoleType === coreConstant.authorization.CONSOLE_TYPE_UM_AGENT) {
      applicationId = clientType.UM_HTML_AGENT;
    } else if (consoleType === coreConstant.authorization.CONSOLE_TYPE_UM) {
      applicationId = clientType.UM_HTML_UW;
    } else if (consoleType === coreConstant.authorization.CONSOLE_TYPE_UM_STUDIO) {
      applicationId = clientType.UM_STUDIO;
    } else if (consoleType === coreConstant.authorization.CONSOLE_TYPE_APPREADER) {
      applicationId = clientType.APP_READER;
    }
    return applicationId;
  };
};
AppTypeConfigurationModel.$inject = ["$q", "coreConstant", "authorizationConstants", "clientType", "userTypeConstant"];
angular.module('umCore').service('appTypeConfigurationModel', AppTypeConfigurationModel);

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var CurrentUserModel = function CurrentUserModel(notificationType) {
  var currentUser,
    authorizations = [],
    registrations = [],
    notificationRegistrations = {};
  this.filterInfoMap = {};
  notificationRegistrations[notificationType.REGULAR] = [];
  notificationRegistrations[notificationType.CHAT] = [];
  this.setCurrentUser = function (newUser) {
    currentUser = newUser;
    authorizations = [];
    _.each(newUser.assignedAuthorizations, function (authorization) {
      authorizations.push(authorization.name);
    });
  };
  this.getCurrentUser = function () {
    return currentUser;
  };
  this.getCurrentUserSimplePrincipalId = function () {
    var currentUserPrincipalId = this.getCurrentUser().principalId,
      separatorIndex;
    if (currentUserPrincipalId) {
      separatorIndex = _.lastIndexOf(currentUserPrincipalId, ':');
      if (separatorIndex > -1) {
        currentUserPrincipalId = currentUserPrincipalId.substring(separatorIndex + 1);
      }
    }
    return currentUserPrincipalId;
  };
  this.reset = function () {
    currentUser = null;
    authorizations = [];
    registrations = [];
    notificationRegistrations = {};
    this.filterInfoMap = {};
  };
  this.addRegistration = function (url) {
    var doAdd = true;
    _.each(registrations, function (registration) {
      if (JSON.stringify(url) === JSON.stringify(registration)) {
        doAdd = false;
      }
    });
    if (doAdd) {
      registrations.push(url);
    }
  };
  this.addNotificationRegistration = function (type, url) {
    var doAdd = true;
    _.each(notificationRegistrations[type], function (registration) {
      if (JSON.stringify(url) === JSON.stringify(registration)) {
        doAdd = false;
      }
    });
    if (doAdd) {
      notificationRegistrations[type].push(url);
    }
  };
  this.getRegistrations = function () {
    return registrations;
  };
  this.getNotificationRegistrations = function (type) {
    return notificationRegistrations[type];
  };
  this.clearRegistrations = function () {
    registrations = [];
  };
  this.clearNotificationRegistrations = function (type) {
    notificationRegistrations[type] = [];
  };
  this.hasAuthorization = function (authorization) {
    return _.includes(authorizations, authorization);
  };
};
CurrentUserModel.$inject = ["notificationType"];
angular.module('umCore').service('currentUserModel', CurrentUserModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var GridColumnModel = function GridColumnModel($http, $q, $rootScope, $window, localization, xmlUtil, preferenceModel, gridColumnConstant, appTypeConfigurationModel, submissionConstant) {
  var viewActiveOnlyCheckBoxChecked,
    columnPreference,
    selectedSubmissionFilterName,
    selectedActivityFilterName,
    selectedTaskFilterName,
    openFilterUri = {},
    savedFilterUri = {},
    savedSortType = {},
    savedSortKey = {},
    submissionParams = {},
    activityParams = {},
    taskParams = {};
  this.getSubmissionParams = function () {
    return submissionParams;
  };
  function updateSubmissionGridPageSizeLocalStorage(pageSize) {
    var submissionGridPageSizeLocalStorageKey = appTypeConfigurationModel.appendConsoleType(submissionConstant.LOCAL_STORAGE_SUBMISSION_GRID_PAGE_SIZE_KEY);
    $window.localStorage.setItem(submissionGridPageSizeLocalStorageKey, pageSize);
  }
  this.setSubmissionParams = function (_submissionParams) {
    submissionParams = _submissionParams;
    updateSubmissionGridPageSizeLocalStorage(submissionParams.pageSize);
  };
  this.updateSubmissionParamByName = function (name, value) {
    submissionParams[name] = value;
    if (name === 'pageSize') {
      updateSubmissionGridPageSizeLocalStorage(value);
    }
  };
  this.getActivityParams = function () {
    return activityParams;
  };
  this.setActivityParams = function (_activityParams) {
    activityParams = _activityParams;
  };
  this.getTaskParams = function () {
    return taskParams;
  };
  function updateTaskGridPageSizeLocalStorage(pageSize) {
    var taskGridPageSizeLocalStorageKey = appTypeConfigurationModel.appendConsoleType(submissionConstant.LOCAL_STORAGE_TASK_GRID_PAGE_SIZE_KEY);
    $window.localStorage.setItem(taskGridPageSizeLocalStorageKey, pageSize);
  }
  this.setTaskParams = function (_taskParams) {
    taskParams = _taskParams;
    updateTaskGridPageSizeLocalStorage(taskParams.pageSize);
  };
  this.updateTaskParamByName = function (name, value) {
    taskParams[name] = value;
    if (name === 'pageSize') {
      updateTaskGridPageSizeLocalStorage(value);
    }
  };
  this.updateActivityParamByName = function (name, value) {
    activityParams[name] = value;
  };
  this.setSelectedSubmissionFilterName = function (name) {
    selectedSubmissionFilterName = name;
  };
  this.setSelectedActivityFilterName = function (name) {
    selectedActivityFilterName = name;
  };
  this.setOpenFilterUri = function (namespace, filterUri) {
    openFilterUri[namespace] = filterUri;
  };
  this.getOpenFilterUri = function (namespace) {
    return openFilterUri[namespace];
  };
  this.setSavedFilterUri = function (namespace, filterUri) {
    savedFilterUri[namespace] = filterUri;
  };
  this.getSavedFilterUri = function (namespace) {
    return savedFilterUri[namespace];
  };
  this.setSavedSortType = function (namespace, type) {
    savedSortType[namespace] = type;
  };
  this.getSavedSortType = function (namespace) {
    return savedSortType[namespace];
  };
  this.setSavedSortKey = function (namespace, Key) {
    savedSortKey[namespace] = Key;
  };
  this.getSavedSortKey = function (namespace) {
    return savedSortKey[namespace];
  };
  this.setSelectedTaskFilterName = function (name) {
    selectedTaskFilterName = name;
  };
  this.setColumnPreference = function (preference) {
    columnPreference = preference;
  };
  this.getSelectedSubmissionFilterName = function () {
    return selectedSubmissionFilterName;
  };
  this.getSelectedActivityFilterName = function () {
    return selectedActivityFilterName;
  };
  this.getSelectedTaskFilterName = function () {
    return selectedTaskFilterName;
  };
  this.setViewActiveOnlyCheckBox = function (val) {
    viewActiveOnlyCheckBoxChecked = val;
  };
  this.isViewActiveOnlyCheckBoxChecked = function () {
    return viewActiveOnlyCheckBoxChecked;
  };
  this.getGridColumnXML = function (colChanged, userPrefName) {
    var xml = '<columns>',
      columns = this.getDropdownColumns(userPrefName);
    _.each(columns, function (item) {
      if (colChanged && item.name === colChanged.name) {
        item.visible = colChanged.visible;
      }
      xml += '<column visible="' + item.visible;
      xml += '" width="' + item.width + '"' + (item.accessor ? ' accessor="' + item.accessor + '"' : '') + (item.sort ? ' sort="' + item.sort + '"' : '') + (item.type ? ' type="' + item.type + '"' : '') + '>' + item.name + '</column>';
    });
    xml += '</columns>';
    return xml;
  };
  this.getColumnsXML = function (columns) {
    var xml = '<columns>';
    _.each(columns, function (item) {
      xml += '<column visible="' + item._visible;
      xml += '" width="' + item._width + '"' + (item._accessor ? ' accessor="' + item._accessor + '"' : '') + (item._sort ? ' sort="' + item._sort + '"' : '') + (item._type ? ' type="' + item._type + '"' : '') + '>' + item.__text + '</column>';
    });
    xml += '</columns>';
    return xml;
  };
  this.resetParams = function () {
    var submissionGridPageSizeLocalStorageKey = appTypeConfigurationModel.appendConsoleType(submissionConstant.LOCAL_STORAGE_SUBMISSION_GRID_PAGE_SIZE_KEY);
    var submissionGridPageSize = $window.localStorage.getItem(submissionGridPageSizeLocalStorageKey) || submissionConstant.DEFAULT_SUBMISSION_GRID_PAGE_SIZE;
    submissionParams = {
      key: 'status',
      startIndex: 0,
      pageSize: _.toInteger(submissionGridPageSize),
      sortType: 'asc',
      searchString: '',
      filterUri: ''
    };
    activityParams = {
      filterUri: '',
      startIndex: 0,
      pageSize: 25
    };
    var taskGridPageSizeLocalStorageKey = appTypeConfigurationModel.appendConsoleType(submissionConstant.LOCAL_STORAGE_TASK_GRID_PAGE_SIZE_KEY);
    var taskGridPageSize = $window.localStorage.getItem(taskGridPageSizeLocalStorageKey) || submissionConstant.DEFAULT_TASK_GRID_PAGE_SIZE;
    taskParams = {
      key: 'dueDate',
      startIndex: 0,
      pageSize: _.toInteger(taskGridPageSize),
      sortType: 'asc',
      searchString: '',
      filterUri: ''
    };
  };
  localization.getTranslations().then(function (translations) {
    this.reset = function () {
      viewActiveOnlyCheckBoxChecked = true;
      selectedSubmissionFilterName = _.get(translations, 'homePage.myAgencySubmissions');
      selectedTaskFilterName = _.get(translations, 'homePage.myTasks');
      columnPreference = null;
      selectedActivityFilterName = null;
      openFilterUri = {};
      savedFilterUri = {};
      savedSortType = {};
      savedSortKey = {};
      this.resetParams();
    };
    this.getWidgetConfig = function () {
      var userPrefName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var name = arguments.length > 1 ? arguments[1] : undefined;
      var config = null;
      if (userPrefName) {
        var userPreferences = preferenceModel.getUserPreferences();
        var widgetPref = userPreferences[userPrefName];
        if (widgetPref) {
          var item = xmlUtil.parseStringWithoutFlattening(widgetPref);
          config = item;
          if (item.widget) config = item.widget;
          config = config[name];
        }
      }
      return config;
    };
    this.getDropdownColumns = function () {
      var userPrefName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var columns = null;
      if (userPrefName) {
        columns = this.getWidgetConfig(userPrefName, 'columns');
      }
      if (!columns) {
        columns = preferenceModel.get(columnPreference, userPrefName == null);
      }
      if (!columns) {
        return;
      }
      var dropDownArray = [];
      _.each(columns.column, function (item) {
        var visibleProp = item._visible === 'true',
          columnName = item.__text;
        dropDownArray.push({
          displayName: item.__text === gridColumnConstant.SUBMISSION_HOME_PAGE_COVERAGE ? _.get(translations, 'homePage.grid.header.coverage') : columnName,
          name: columnName,
          accessor: item._accessor,
          type: item._type,
          sort: item._sort,
          width: item._width,
          visible: visibleProp,
          disabled: columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_INSURED
        });
      });
      return dropDownArray;
    };
    this.getTaskDropdownColumns = function () {
      var columns = preferenceModel.get(columnPreference),
        removeColumns = ['Next Action', 'Overdue', 'Assigned to me'];
      if (!columns) {
        return;
      }
      _.remove(columns.column, function (item) {
        return _.indexOf(removeColumns, item.__text) !== -1;
      });
      var dropDownArray = [];
      _.each(columns.column, function (item) {
        var visibleProp = item._visible === 'true',
          columnName = item.__text;
        dropDownArray.push({
          displayName: item.__text === gridColumnConstant.SUBMISSION_HOME_PAGE_COVERAGE ? _.get(translations, 'homePage.grid.header.coverage') : columnName,
          name: columnName,
          width: item._width,
          visible: visibleProp,
          disabled: columnName === gridColumnConstant.TASK_GRID_TASK_SUMMARY
        });
      });
      return dropDownArray;
    };
    this.reset();
  }.bind(this));
  this.getSubmissionGridColumns = function () {
    var userPrefName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var colViewModel = {},
      columns = null;
    if (userPrefName) {
      columns = this.getWidgetConfig(userPrefName, 'columns');
    }
    if (!columns) {
      columns = preferenceModel.get(columnPreference, false);
    }
    if (!columns) {
      return;
    }
    colViewModel.columns = [];
    _.each(columns.column, function (item) {
      var visibleProp = item._visible === 'true',
        columnName = item.__text;
      if (columnPreference === 'system.accountSubmissionsGridColumns' || columnPreference === 'system.accountOverviewSubmissionColumnsForAgent' || columnPreference === 'system.accountOverviewSubmissionColumnsForUnderwriter') {
        if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_INSURED) {
          colViewModel.colInsuredName = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_STATUS) {
          colViewModel.colStatus = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_STATUS_REASON) {
          colViewModel.colStatusReason = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_EFFECTIVE) {
          colViewModel.colEffectiveDate = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_EXPIRATION) {
          colViewModel.colExpirationDate = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_PREMIUM) {
          colViewModel.colPremium = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_NEXT_ACTION) {
          colViewModel.colNextAction = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_ASSIGNED_TO) {
          colViewModel.colAssignedTo = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_AGENCY) {
          colViewModel.colAgency = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_RISK_STATE) {
          colViewModel.colRiskState = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_TOTAL_LIMIT) {
          colViewModel.colTotalLimit = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_OBLIGATION_NAME) {
          colViewModel.colNameOfObligation = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_COVERAGE) {
          colViewModel.colCoverage = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_SUBMISSION) {
          colViewModel.colSubmissionNumber = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_RECEIVED_DATE) {
          colViewModel.colReceivedDate = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_ACCOUNT_PAGE_ACTION_DATE) {
          colViewModel.colActionDate = visibleProp;
        }
      } else if (columnPreference === 'view.uw.homePageColumns') {
        if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_INSURED) {
          colViewModel.colSubmissionNumber = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_ACCOUNT_NAME) {
          colViewModel.colAccountName = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_STATUS) {
          colViewModel.colStatus = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_STATUS_REASON) {
          colViewModel.colStatusReason = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_EFFECTIVE) {
          colViewModel.colEffectiveDate = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_EXPIRATION) {
          colViewModel.colExpirationDate = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_PREMIUM) {
          colViewModel.colPremium = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_NEXT_ACTION) {
          colViewModel.colNextAction = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_ACTION_DATE) {
          colViewModel.colActionDate = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_AGENCY) {
          colViewModel.colAgency = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_UNDERWRITER) {
          colViewModel.colUnderwriter = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_ASSIGNED_TO) {
          colViewModel.colAssignedTo = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_PRODUCT) {
          colViewModel.colCoverage = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_PRIORITY) {
          colViewModel.colPriority = visibleProp;
        } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_RECEIVED_DATE) {
          colViewModel.colReceivedDate = visibleProp;
        }
        colViewModel.columns.push(item);
      } else {
        colViewModel.columns.push(item);
      }
    });
    return colViewModel;
  };
  this.getTaskGridColumns = function () {
    var colViewModel = {},
      columns = preferenceModel.get(columnPreference);
    if (!columns) {
      return;
    }
    _.each(columns.column, function (item) {
      var visibleProp = item._visible === 'true',
        columnName = item.__text;
      if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_INSURED) {
        colViewModel.colInsuredName = visibleProp;
      } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_ASSIGNED_TO) {
        colViewModel.colAssignedTo = visibleProp;
      } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_PRIORITY) {
        colViewModel.colPriority = visibleProp;
      } else if (columnName === gridColumnConstant.SUBMISSION_HOME_PAGE_COVERAGE) {
        colViewModel.colCoverage = visibleProp;
      } else if (columnName === gridColumnConstant.TASK_GRID_RESOLVED) {
        colViewModel.colResolved = visibleProp;
      } else if (columnName === gridColumnConstant.TASK_GRID_DUE_DATE) {
        colViewModel.colDueDate = visibleProp;
      } else if (columnName === gridColumnConstant.TASK_GRID_TASK_SUMMARY) {
        colViewModel.colTaskSummary = visibleProp;
      } else if (columnName === gridColumnConstant.TASK_GRID_ASSIGNED_BY) {
        colViewModel.colAssignedBy = visibleProp;
      } else if (columnName === gridColumnConstant.TASK_GRID_TASK_DETAILS) {
        colViewModel.colTaskDetails = visibleProp;
      } else if (columnName === gridColumnConstant.TASK_GRID_EFFECTIVE_DATE) {
        colViewModel.colEffectiveDate = visibleProp;
      } else if (columnName === gridColumnConstant.TASK_GRID_CREATED_DATE) {
        colViewModel.colCreatedDate = visibleProp;
      } else if (columnName === gridColumnConstant.TASK_GRID_RESOLVED_DATE) {
        colViewModel.colResolvedDate = visibleProp;
      }
    });
    return colViewModel;
  };
  this.getPoliciesGridColumns = function () {
    var colViewModel = {},
      columns = xmlUtil.parseString(preferenceModel.get(columnPreference));
    colViewModel.columns = columns.column;
    if (!columns) {
      return;
    }
    _.each(columns.column, function (item) {
      var visibleProp = item._visible === 'true';
      colViewModel[item.__text] = item._visible;
    });
    return colViewModel;
  };
  this.getSubmissionTransactionGridColumns = function () {
    var colViewModel = {},
      columns = xmlUtil.parseString(preferenceModel.get(columnPreference));
    colViewModel.columns = columns.column;
    if (!columns) {
      return;
    }
    _.each(columns.column, function (item) {
      var visibleProp = item._visible === 'true';
      colViewModel[item.__text] = item._visible;
    });
    return colViewModel;
  };
  this.resetParams();
};
GridColumnModel.$inject = ["$http", "$q", "$rootScope", "$window", "localization", "xmlUtil", "preferenceModel", "gridColumnConstant", "appTypeConfigurationModel", "submissionConstant"];
angular.module('umCore').service('gridColumnModel', GridColumnModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var NavigationStateModel = function NavigationStateModel() {
  var stateModelStorage;
  this.init = function () {
    stateModelStorage = {};
  };
  this.saveViewState = function (stateName, param) {
    stateModelStorage[stateName] = _.cloneDeep(param);
  };
  this.updateViewStateData = function (stateName, param) {
    if (stateModelStorage[stateName]) {
      if (stateName === 'configuration.formTemplateBrowser') {
        stateModelStorage[stateName]['data'] = {
          uiFormTemplateId: _.cloneDeep(param)
        };
      }
    }
  };
  this.restoreViewState = function (stateName) {
    var previousState = stateModelStorage[stateName];
    if (previousState) {
      return stateModelStorage[stateName];
    }
  };
  this.init();
};
angular.module('umCore').service('navigationStateModel', NavigationStateModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var PreferenceModel = function PreferenceModel($rootScope, $q, umsLog, xmlUtil) {
  var preferences = {},
    defaultPreferences = {},
    userPreferences = {},
    defaultPreferencePromise,
    userPreferencePromise;
  this.get = function (name) {
    var useViewWidgets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var pref, columnPref, type;
    pref = _.get(preferences, name);
    if (name === 'view.agent.homePageColumns' || name === 'view.uw.homePageColumns' || name === 'view.tasksHomePageTaskColumnsForUnderwriter' || name === 'view.tasksHomePageTaskColumnsForAgent') {
      if (name === 'view.agent.homePageColumns' || name === 'view.uw.homePageColumns') {
        type = '1';
      } else if (name === 'view.tasksHomePageTaskColumnsForUnderwriter' || name === 'view.tasksHomePageTaskColumnsForAgent') {
        type = '2';
      }
      // submissionGrid columns from "view.widgets" is legacy, but have to keep it for UI column editting purpose
      if (useViewWidgets) {
        columnPref = this.getColumns(type);
      }
      if (!_.isNil(columnPref)) {
        var userPref = xmlUtil.parseString(_.get(_.clone(_.get(preferences, name)), 'value'));
        columnPref = this.reconcileWithUserPref(columnPref, userPref);
        return columnPref;
      } else {
        if (_.isPlainObject(pref)) {
          pref = xmlUtil.parseString(_.get(pref, 'value'));
        } else {
          return pref = xmlUtil.parseString(_.get(preferences, name));
        }
      }
    } else if (name === 'system.accountSubmissionsGridColumns' || name === 'system.accountOverviewSubmissionColumnsForUnderwriter' || name === 'system.accountOverviewSubmissionColumnsForAgent') {
      if (_.isPlainObject(pref)) {
        return pref = xmlUtil.parseString(_.get(pref, 'value'));
      } else {
        return pref = xmlUtil.parseString(pref);
      }
    } else {
      if (_.isPlainObject(pref)) {
        pref = _.get(pref, 'value');
      }
    }
    return pref;
  };
  this.reconcileWithUserPref = function (widgetPref, userPref) {
    _.each(userPref.column, function (userPrefColumn, index) {
      var widgetPrefColumn = _.find(widgetPref.column, function (column) {
        return column.__text === userPrefColumn.__text;
      });
      if (!_.isNil(widgetPrefColumn)) {
        userPref.column[index] = widgetPrefColumn;
      }
    });
    return userPref;
  };
  this.getColumns = function (type) {
    var columns,
      widgetsObject = xmlUtil.parseStringWithoutFlattening(this.get('view.widgets')),
      widgetArray;
    if (widgetsObject.widgets) {
      widgetArray = Array.isArray(widgetsObject.widgets.widget) ? widgetsObject.widgets.widget : [widgetsObject.widgets.widget];
      _.each(widgetArray, function (item) {
        if (item.type === type) {
          if (!_.isNil(item.columns)) {
            columns = item.columns;
            return columns;
          }
        }
      });
    }
    return columns;
  };
  this.set = function (key, value) {
    preferences[key] = value;
  };
  this.getAll = function () {
    return preferences;
  };
  this.isDefaultLoaded = function () {
    return !_.isEmpty(defaultPreferences);
  };
  this.isUserLoaded = function () {
    return !_.isEmpty(userPreferences);
  };
  this.setDefaultPreferences = function (defaultPrefs) {
    defaultPreferences = defaultPrefs;
    preferences = _.clone(defaultPreferences);
  };
  this.setUserPreferences = function (userPrefs) {
    userPreferences = userPrefs;
    preferences = _.assign(_.clone(defaultPreferences), _.clone(userPreferences));
  };
  this.getUserPreferences = function () {
    return userPreferences;
  };
  this.reset = function () {
    preferences = {};
    userPreferences = {};
    userPreferencePromise = null;
    defaultPreferencePromise = null;
  };
};
PreferenceModel.$inject = ["$rootScope", "$q", "umsLog", "xmlUtil"];
angular.module('umCore').service('preferenceModel', PreferenceModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

/*@ngInject*/
var TimingModel = function TimingModel(browserUtil) {
  var timings = {};
  function getTime() {
    var perf = window.performance;
    if (browserUtil.isIE11() || browserUtil.isFirefox()) {
      return perf.now();
    } else {
      return Date.now();
    }
  }
  this.addMilestone = function (timingName, milestoneName) {
    var timingGroup = timings[timingName];
    if (!timingGroup) {
      timings[timingName] = {};
      timingGroup = timings[timingName];
    }
    timingGroup[milestoneName] = getTime();
  };
  this.getDuration = function (timingName, milestoneStart, milestoneEnd) {
    var timingGroup = timings[timingName],
      milestoneStartTime = timingGroup[milestoneStart],
      milestoneEndTime = timingGroup[milestoneEnd],
      duration = parseFloat(milestoneEndTime - milestoneStartTime),
      readableDuration = duration > 1000 ? (duration / 1000).toFixed(1) + 's' : duration + 'ms';
    return readableDuration;
  };
};
TimingModel.$inject = ["browserUtil"];
angular.module('umCore').service('timingModel', TimingModel);

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

/*@ngInject*/
var CachedDataSetsRepository = function CachedDataSetsRepository(baseCachedRepository) {
  angular.extend(this, baseCachedRepository);
  this.getCacheName = function () {
    return 'cachedDataSetsRepository';
  };
  this.getCacheCapacity = function () {
    return 50;
  };
  this.getDataSet = function (name) {
    var url = '/rest/DataSet',
      config = {
        params: {
          dataSetName: name
        }
      },
      cacheKey = name;
    return this.get(cacheKey, url, config);
  };
};
CachedDataSetsRepository.$inject = ["baseCachedRepository"];
angular.module('umCore').service('cachedDataSetsRepository', CachedDataSetsRepository);

/***/ }),
/* 1296 */
/***/ (function(module, exports) {

/*@ngInject*/
var ChatRoomRepository = function ChatRoomRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.setChatVisibility = function (isVisible) {
    var url = '/rest/ChatRoom/setVisibility',
      config = {
        params: {
          isVisible: isVisible
        }
      };
    return this.get(url, config);
  };
  this.enter = function (submissionId) {
    var url = '/rest/ChatRoom/' + submissionId + '/enter';
    return this.post(url);
  };
  this.leave = function (submissionId) {
    var url = '/rest/ChatRoom/' + submissionId + '/leave';
    return this.post(url);
  };
  this.getChatNotificationRecipients = function (submissionId) {
    var url = '/rest/ChatRoom/chatNotificationRecipients',
      config = {
        params: {
          submissionUri: 'com.firstbest.underwriting.submission.Submission:' + submissionId
        }
      };
    return this.get(url, config);
  };
};
ChatRoomRepository.$inject = ["baseRepository"];
angular.module('umCore').service('chatRoomRepository', ChatRoomRepository);

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

/*@ngInject*/
var CurrentUserProfileRepository = function CurrentUserProfileRepository(baseRepository, currentUserModel) {
  angular.extend(this, baseRepository);
  this.loadUser = function () {
    var url = '/rest/User/' + currentUserModel.getCurrentUser().userId;
    return this.get(url);
  };
};
CurrentUserProfileRepository.$inject = ["baseRepository", "currentUserModel"];
angular.module('umCore').service('currentUserProfileRepository', CurrentUserProfileRepository);

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var DataSetRepository = function DataSetRepository(baseRepository, formRegistrationModel, databaseDownloadSectionName, cachedDataSetsRepository, temporaryLoginTokenRepository) {
  angular.extend(this, baseRepository);
  this.createDataSet = function (dataSet) {
    var url = '/rest/DataSet';
    return this.post(url, dataSet);
  };
  this.updateDataSet = function (dataSet, name) {
    var url = '/rest/DataSet/update?dataSetName=' + encodeURIComponent(name);
    return this.post(url, dataSet).then(function (response) {
      cachedDataSetsRepository.removeFromCache(name);
      return response;
    });
  };
  this.deleteDataSet = function (name) {
    var url = '/rest/DataSet/' + name;
    return this.delete(url, name);
  };
  this.getDataSet = function (name) {
    var url = '/rest/DataSet',
      config = {
        params: {
          dataSetName: name
        }
      };
    return this.get(url, config);
  };
  this.getGeneratorDefinitions = function (type) {
    var url = '/rest/DataSet/generatorDefinitions',
      config = {
        params: {
          type: type
        }
      };
    return this.get(url, config);
  };
  this.getDataSetsByFilterUri = function (filterUri, requestParams) {
    var url = '/rest/DataSet/filter',
      config = {
        params: {
          filterUri: filterUri,
          sortBy: requestParams.key,
          sortDirection: requestParams.sortType,
          startIndex: requestParams.startIndex,
          numberOfRows: requestParams.pageSize
        }
      };
    return this.get(url, config);
  };
  this.getDynamicDataSet = function (params, registrationId, isNotFormRelated) {
    var url = '/rest/DataSet/dynamicDataSet',
      config = {
        params: params
      };
    if (registrationId) {
      if (_.isNil(isNotFormRelated) || !isNotFormRelated) {
        url += '?registrationIdentifier=/DataSet/formRegistrationId/' + registrationId;
        formRegistrationModel.addRegistration(registrationId, '/rest/DataSet' + '?registrationIdentifier=/DataSet/formRegistrationId/' + registrationId);
      } else {
        url += '?registrationIdentifier=/DataSet/registrationId/' + registrationId;
      }
    }
    return this.get(url, config).then(function (response) {
      var dataItems = response.items;
      if (!_.isNil(response) && !_.isNil(response.items)) {
        if (!_.isNil(response.defaultValue)) {
          dataItems = response.items;
          _.each(dataItems, function (dataItem) {
            if (dataItem.value === response.defaultValue.value) {
              dataItem.isDefault = true;
            }
          });
        }
        response.items = dataItems;
      }
      return response;
    });
  };
  this.getDynamicDataSetItems = function (params, registrationId, isNotFormRelated) {
    return this.getDynamicDataSet(params, registrationId, isNotFormRelated).then(function (dataSet) {
      return dataSet.items;
    });
  };
  this.unregisterDynamicDataset = function (params, registrationId) {
    var url = '/rest/DataSet',
      config = {
        params: params
      };
    url += '?registrationIdentifier=/DataSet/registrationId/' + registrationId;
    return this.delete(url, config);
  };
  this.getDataSetNameToTypeMap = function () {
    var url = '/rest/DataSet/dataSetNamesToTypes';
    return this.get(url);
  };
  this.exportDataSetsByName = function (dataSetNames) {
    var _this = this;
    var url = '/database/DatabaseDownloadServlet',
      config = {
        params: {
          sectionName: databaseDownloadSectionName.DATA_SETS,
          entityIdentifiers: _.join(dataSetNames, ',')
        }
      };
    return temporaryLoginTokenRepository.getSingleUseToken().then(function (token) {
      config.params.t = token;
      return _this.get(url, config);
    });
  };
  this.exportDataSetsByNameWithFilter = function (filterUri, excludedDataSetNames) {
    var _this2 = this;
    var url = '/databaseWithFilter/DatabaseDownloadWithServlet',
      config = {
        params: {
          sectionName: databaseDownloadSectionName.DATA_SETS,
          filterUri: filterUri,
          excludedEntityIdentifiers: excludedDataSetNames
        }
      };
    return temporaryLoginTokenRepository.getSingleUseToken().then(function (token) {
      config.params.t = token;
      return _this2.get(url, config);
    });
  };
};
DataSetRepository.$inject = ["baseRepository", "formRegistrationModel", "databaseDownloadSectionName", "cachedDataSetsRepository", "temporaryLoginTokenRepository"];
angular.module('umCore').service('dataSetRepository', DataSetRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var DefaultPreferencesRepository = function DefaultPreferencesRepository(baseCachedSharedPromiseRepository, preferenceModel) {
  var sharedPromiseCache = {};
  angular.extend(this, baseCachedSharedPromiseRepository);
  this.getCacheName = function () {
    return 'preferenceRepository';
  };
  this.getCacheCapacity = function () {
    return 10;
  };
  this.getSharedPromiseCache = function () {
    return sharedPromiseCache;
  };
  this.processResponseData = function (responseData) {
    var defaultPreferences = _.mapKeys(responseData, function (entry) {
      return entry.name;
    });
    preferenceModel.setDefaultPreferences(defaultPreferences);
    return defaultPreferences;
  };
  this.loadDefaultPreferences = function () {
    var url = '/rest/DefaultPreference',
      cacheKey = 'defaultPref';
    return this.get(cacheKey, url);
  };
};
DefaultPreferencesRepository.$inject = ["baseCachedSharedPromiseRepository", "preferenceModel"];
angular.module('umCore').service('defaultPreferencesRepository', DefaultPreferencesRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

/*@ngInject*/
var DeleteUserImageRepository = function DeleteUserImageRepository($cacheFactory, baseRepository, currentUserModel) {
  angular.extend(this, baseRepository);
  this.deleteUserImage = function (ile) {
    var url = '/rest/User/' + currentUserModel.getCurrentUser().userId + '/deleteUserImage',
      cacheKey = 'userProfile:' + currentUserModel.getCurrentUser().userId;
    return this.delete(url).then(function (responseData) {
      $cacheFactory.get('loadProfileImageCache').remove(cacheKey);
      return responseData;
    });
  };
};
DeleteUserImageRepository.$inject = ["$cacheFactory", "baseRepository", "currentUserModel"];
angular.module('umCore').service('deleteUserImageRepository', DeleteUserImageRepository);

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

/*@ngInject*/
var GetServerPublicKeySpecRepository = function GetServerPublicKeySpecRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getServerPublicKeySpec = function () {
    var url = '/rest/Session/serverPublicKeySpec';
    return this.get(url);
  };
};
GetServerPublicKeySpecRepository.$inject = ["baseRepository"];
angular.module('umCore').service('getServerPublicKeySpecRepository', GetServerPublicKeySpecRepository);

/***/ }),
/* 1302 */
/***/ (function(module, exports) {

/*@ngInject*/
var LoadProfileImageRepository = function LoadProfileImageRepository(baseCachedSharedPromiseRepository) {
  var sharedPromiseCache = {};
  angular.extend(this, baseCachedSharedPromiseRepository);
  this.getCacheName = function () {
    return 'loadProfileImageCache';
  };
  this.getCacheCapacity = function () {
    return 10;
  };
  this.getSharedPromiseCache = function () {
    return sharedPromiseCache;
  };
  this.loadProfileImage = function (profileId) {
    var url = '/rest/User/' + profileId + '/ProfileImage',
      cacheKey = 'userProfile:' + profileId;
    return this.get(cacheKey, url);
  };
};
LoadProfileImageRepository.$inject = ["baseCachedSharedPromiseRepository"];
angular.module('umCore').service('loadProfileImageRepository', LoadProfileImageRepository);

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

/*@ngInject*/
var LoadUserDetailsRepository = function LoadUserDetailsRepository(baseCachedRepository) {
  angular.extend(this, baseCachedRepository);
  this.getCacheName = function () {
    return 'loadUserDetailsCache';
  };
  this.getCacheCapacity = function () {
    return 10;
  };
  this.loadUserDetails = function () {
    var url = '/rest/User/profile',
      cacheKey = 'userProfile';
    return this.get(cacheKey, url);
  };
};
LoadUserDetailsRepository.$inject = ["baseCachedRepository"];
angular.module('umCore').service('loadUserDetailsRepository', LoadUserDetailsRepository);

/***/ }),
/* 1304 */
/***/ (function(module, exports) {

/*@ngInject*/
var ConfiguredFileRepository = function ConfiguredFileRepository(baseCachedSharedPromiseRepository) {
  var sharedPromiseCache = {};
  angular.extend(this, baseCachedSharedPromiseRepository);
  this.getCacheName = function () {
    return 'configuredFileCache';
  };
  this.getCacheCapacity = function () {
    return 50;
  };
  this.getSharedPromiseCache = function () {
    return sharedPromiseCache;
  };
  this.find = function (name) {
    var url = '/rest/ConfiguredFile',
      config = {
        params: {
          name: name
        }
      },
      cacheKey = "name:".concat(name);
    return this.get(cacheKey, url, config);
  };
};
ConfiguredFileRepository.$inject = ["baseCachedSharedPromiseRepository"];
angular.module('umCore').service('configuredFileRepository', ConfiguredFileRepository);

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

/*@ngInject*/
var ConfiguredFileDataRepository = function ConfiguredFileDataRepository(baseCachedRepository) {
  angular.extend(this, baseCachedRepository);
  this.getCacheName = function () {
    return 'configuredFileDataCache';
  };
  this.getCacheCapacity = function () {
    return 50;
  };
  this.getData = function (id) {
    var url = "/rest/ConfiguredFile/".concat(id, "/data"),
      cacheKey = 'configuredFileData-' + id;
    return this.get(cacheKey, url);
  };
};
ConfiguredFileDataRepository.$inject = ["baseCachedRepository"];
angular.module('umCore').service('configuredFileDataRepository', ConfiguredFileDataRepository);

/***/ }),
/* 1306 */
/***/ (function(module, exports) {

var NotificationEmailTemplateRepository = function NotificationEmailTemplateRepository(baseRepository, baseCachedRepository) {
  angular.extend(this, baseRepository);
  angular.extend(this, baseCachedRepository);
  this.getCacheName = function () {
    return 'notificationEmailTemplateRepository';
  };
  this.getCacheCapacity = function () {
    return 100;
  };
  this.loadActions = function (id) {
    var url = '/rest/Actions',
      cacheKey = 'notificationEmailTemplate-actions-' + id,
      config = {
        params: {
          uri: 'com.firstbest.underwriting.notification.NotificationEmailTemplate:' + id
        }
      };
    return this.get(cacheKey, url, config);
  };
  this.getNotificationEmailTemplate = function (id) {
    var url = '/rest/NotificationEmailTemplate/' + id,
      cacheKey = 'notificationEmailTemplate-' + id;
    return this.get(cacheKey, url);
  };
  this.saveNotificationEmailTemplate = function (notificationEmailTemplate) {
    var url = '/rest/NotificationEmailTemplate',
      body = notificationEmailTemplate,
      config = {
        params: {}
      },
      cacheKey = 'notificationEmailTemplate-' + notificationEmailTemplate.id;
    if (notificationEmailTemplate.id) {
      url = '/rest/NotificationEmailTemplate/' + notificationEmailTemplate.id;
      this.removeFromCache(cacheKey);
    }
    return this.post(url, body, config);
  };
  this.deleteNotificationEmailTemplate = function (id) {
    var url = '/rest/NotificationEmailTemplate/' + id;
    return this.delete(url);
  };
  this.processResponseData = function (responseData) {
    return responseData;
  };
};
NotificationEmailTemplateRepository.$inject = ["baseRepository", "baseCachedRepository"];
angular.module('umCore').service('notificationEmailTemplateRepository', NotificationEmailTemplateRepository);

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

/*@ngInject*/
var NotificationPopupTemplateRepository = function NotificationPopupTemplateRepository(baseRepository, baseCachedRepository) {
  angular.extend(this, baseRepository);
  angular.extend(this, baseCachedRepository);
  this.getCacheName = function () {
    return 'notificationPopupTemplateRepository';
  };
  this.getCacheCapacity = function () {
    return 100;
  };
  this.loadActions = function (id) {
    var url = '/rest/Actions',
      cacheKey = 'notificationPopupTemplate-actions-' + id,
      config = {
        params: {
          uri: 'com.firstbest.underwriting.notification.NotificationPopupTemplate:' + id
        }
      };
    return this.get(cacheKey, url, config);
  };
  this.getNotificationPopupTemplate = function (id) {
    var url = '/rest/NotificationPopupTemplate/' + id,
      cacheKey = 'notificationPopupTemplate-' + id;
    return this.get(cacheKey, url);
  };
  this.saveNotificationPopupTemplate = function (notificationPopupTemplate) {
    var url = '/rest/NotificationPopupTemplate',
      body = notificationPopupTemplate,
      config = {
        params: {}
      },
      cacheKey = 'notificationPopupTemplate-' + notificationPopupTemplate.id;
    if (notificationPopupTemplate.id) {
      url = '/rest/NotificationPopupTemplate/' + notificationPopupTemplate.id;
      this.removeFromCache(cacheKey);
    }
    return this.post(url, body, config);
  };
  this.deleteNotificationPopupTemplate = function (id) {
    var url = '/rest/NotificationPopupTemplate/' + id;
    return this.delete(url);
  };
  this.processResponseData = function (responseData) {
    return responseData;
  };
};
NotificationPopupTemplateRepository.$inject = ["baseRepository", "baseCachedRepository"];
angular.module('umCore').service('notificationPopupTemplateRepository', NotificationPopupTemplateRepository);

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var PeoplePickerRepository = function PeoplePickerRepository($rootScope, $cacheFactory, coreConstant, submissionConstant, baseCachedRepository) {
  angular.extend(this, baseCachedRepository);
  this.getCacheName = function () {
    return 'loadUsersListCache';
  };
  this.getCacheCapacity = function () {
    return 10;
  };
  this.loadUsersList = function (submissionId) {
    var url = '/rest/User/people',
      config = {
        params: {
          submissionId: submissionId
        }
      },
      cacheKey = submissionId;
    return this.get(cacheKey, url, config);
  };
  this.processResponseData = function (responseData) {
    function flattenPayload(payload) {
      var uniqueItems = new Set();
      return _.flatten(_.toArray(_.mapValues(payload, function (value, key) {
        return _.each(value, function (item) {
          if (!uniqueItems.has(item.id + ':' + item.type)) {
            uniqueItems.add(item.id + ':' + item.type);
            item.group = key;
            item.grouping = key;
            item.name = !item.name ? item.firstName + ' ' + item.lastName : item.name;
          }
        });
      })));
    }
    return flattenPayload(responseData);
  };
  $rootScope.$on(coreConstant.event.LOGOUT_COMPLETE, function () {
    this.clearCache();
  }.bind(this));
  $rootScope.$on(submissionConstant.event.REFRESH_SUBMISSION, function (event, submission) {
    var cache = $cacheFactory.get(this.getCacheName());
    if (cache) {
      cache.remove(submission.id);
    }
  }.bind(this));
};
PeoplePickerRepository.$inject = ["$rootScope", "$cacheFactory", "coreConstant", "submissionConstant", "baseCachedRepository"];
angular.module('umCore').service('peoplePickerRepository', PeoplePickerRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var RegistrationRepository = function RegistrationRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.deleteRegistration = function (url) {
    if (!_.isNil(url)) {
      if (_.isNil(url.params)) {
        return this.delete(url);
      } else {
        return this.delete(url.url, {
          params: url.params
        });
      }
    } else {
      return Promise.resolve();
    }
  };
};
RegistrationRepository.$inject = ["baseRepository"];
angular.module('umCore').service('registrationRepository', RegistrationRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

/*@ngInject*/
var RepeatingFormDynamicDataSetFormSetIdRepository = function RepeatingFormDynamicDataSetFormSetIdRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getOwningFormSetId = function (formId, dynamicDataSetName) {
    var url = '/rest/DataSet/repeatingDynamicDataSetFormSetId',
      config = {
        params: {
          formId: formId,
          dynamicDataSetName: dynamicDataSetName
        }
      };
    return this.get(url, config);
  };
};
RepeatingFormDynamicDataSetFormSetIdRepository.$inject = ["baseRepository"];
angular.module('umCore').service('repeatingFormDynamicDataSetFormSetIdRepository', RepeatingFormDynamicDataSetFormSetIdRepository);

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var RevisionRepository = function RevisionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.processGetResponseData = function (responseData) {
    var revision = $(responseData);
    return {
      revNumber: revision.find('revNumber').text(),
      buildBranch: revision.find('buildBranch').text(),
      buildTime: revision.find('buildTime').text()
    };
  };
  this.getRevision = function () {
    var url = '/xml/revision_info.xml';
    return this.get(url);
  };
};
RevisionRepository.$inject = ["baseRepository"];
angular.module('umCore').service('revisionRepository', RevisionRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

/*@ngInject*/
var SendEmailNotificationRepository = function SendEmailNotificationRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.sendEmailNotification = function (notificationName, isCustom, submissionId, options) {
    var url = '/rest/Email/SendNotification',
      config = {
        params: options ? options.variables : {},
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      },
      payload = 'notificationName=' + notificationName + '&isCustom=' + isCustom + '&submissionId=' + submissionId;
    if (config.params.additionalText) {
      config.params.additionalText = encodeURIComponent(config.params.additionalText);
    }
    return this.post(url, payload, config);
  };
};
SendEmailNotificationRepository.$inject = ["baseRepository"];
angular.module('umCore').service('sendEmailNotificationRepository', SendEmailNotificationRepository);

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

/*@ngInject*/
var ServerAckRepository = function ServerAckRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.ack = function () {
    var url = '/rest/Session/ack';
    return this.get(url);
  };
};
ServerAckRepository.$inject = ["baseRepository"];
angular.module('umCore').service('serverAckRepository', ServerAckRepository);

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

/*@ngInject*/
var UmRevisionRepository = function UmRevisionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getUmVersionNumber = function () {
    var url = '/rest/Server';
    return this.get(url);
  };
};
UmRevisionRepository.$inject = ["baseRepository"];
angular.module('umCore').service('umRevisionRepository', UmRevisionRepository);

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UpdateUserPreferencesRepository = function UpdateUserPreferencesRepository(baseRepository, $cacheFactory) {
  var cache = $cacheFactory.get('preferenceRepository'),
    cacheKey = 'userPrefs';
  angular.extend(this, baseRepository);
  if (!cache) {
    cache = $cacheFactory('preferenceRepository', {
      capacity: 10
    });
  }
  this.updateUserPreferences = function (data) {
    var url = '/rest/UserPreference';
    return this.post(url, data).then(function (responseData) {
      var cachedData = cache.get(cacheKey);
      if (cachedData) {
        cachedData = _.assign(cachedData, data);
        cache.put(cacheKey, cachedData);
      }
      return responseData;
    });
  };
};
UpdateUserPreferencesRepository.$inject = ["baseRepository", "$cacheFactory"];
angular.module('umCore').service('updateUserPreferencesRepository', UpdateUserPreferencesRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

/*@ngInject*/
var UpdateUserProfileRepository = function UpdateUserProfileRepository(baseRepository, currentUserModel) {
  angular.extend(this, baseRepository);
  this.updateUser = function (data) {
    var url = '/rest/User/' + currentUserModel.getCurrentUser().userId;
    return this.post(url, data);
  };
};
UpdateUserProfileRepository.$inject = ["baseRepository", "currentUserModel"];
angular.module('umCore').service('updateUserProfileRepository', UpdateUserProfileRepository);

/***/ }),
/* 1317 */
/***/ (function(module, exports) {

/*@ngInject*/
var UserImageRepository = function UserImageRepository($cacheFactory, baseRepository, currentUserModel) {
  angular.extend(this, baseRepository);
  this.updateUserImage = function (file, imageWidth, imageHeight) {
    var cacheKey = 'userProfile:' + currentUserModel.getCurrentUser().userId,
      url = '/rest/User/' + currentUserModel.getCurrentUser().userId + '/UserImage?maxWidth=' + imageWidth + '&maxHeight=' + imageHeight,
      formData = new FormData(),
      config = {
        transformRequest: angular.identity,
        headers: {
          'Content-Type': undefined
        }
      };
    formData.append('file', file);
    return this.post(url, formData, config).then(function (responseData) {
      $cacheFactory.get('loadProfileImageCache').remove(cacheKey);
      return responseData;
    });
  };
};
UserImageRepository.$inject = ["$cacheFactory", "baseRepository", "currentUserModel"];
angular.module('umCore').service('userImageRepository', UserImageRepository);

/***/ }),
/* 1318 */
/***/ (function(module, exports) {

/*@ngInject*/
var UserPreferencesRepository = function UserPreferencesRepository(baseCachedRepository, preferenceModel) {
  angular.extend(this, baseCachedRepository);
  this.getCacheName = function () {
    return 'preferenceRepository';
  };
  this.getCacheCapacity = function () {
    return 10;
  };
  this.processResponseData = function (responseData) {
    preferenceModel.setUserPreferences(responseData);
    return responseData;
  };
  this.loadUserPreferences = function () {
    var url = '/rest/UserPreference',
      cacheKey = 'userPrefs';
    return this.get(cacheKey, url);
  };
};
UserPreferencesRepository.$inject = ["baseCachedRepository", "preferenceModel"];
angular.module('umCore').service('userPreferencesRepository', UserPreferencesRepository);

/***/ }),
/* 1319 */
/***/ (function(module, exports) {

/*@ngInject*/
var UserProfileRepository = function UserProfileRepository($q, baseRepository) {
  angular.extend(this, baseRepository);
  this.loadUserById = function (id, submissionId, notificationId, chatMessageId, emailMessageId) {
    var url = "/rest/User/".concat(id),
      config = {
        params: {
          registrationIdentifier: "/User/".concat(id),
          submissionId: submissionId,
          notificationId: notificationId,
          chatMessageId: chatMessageId,
          emailMessageId: emailMessageId
        }
      };
    return this.get(url, config);
  };
};
UserProfileRepository.$inject = ["$q", "baseRepository"];
angular.module('umCore').service('userProfileRepository', UserProfileRepository);

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var BaseCachedRepository = function BaseCachedRepository($http, $q, $cacheFactory) {
  this.getCacheName = function () {
    return '';
  };
  this.getCacheCapacity = function () {
    return 0;
  };
  this.clearCache = function () {
    var cache = $cacheFactory.get(this.getCacheName());
    if (cache) {
      cache.removeAll();
    }
  };
  this.removeFromCache = function (cacheKey) {
    var cache = $cacheFactory.get(this.getCacheName());
    if (cache) {
      cache.remove(cacheKey);
    }
  };
  this.get = function (cacheKey, url, config) {
    var cache = $cacheFactory.get(this.getCacheName());
    function onSuccess(response) {
      var processedResponseData;
      if (response) {
        processedResponseData = this.processResponseData(_.cloneDeep(response.data));
        cache.put(cacheKey, processedResponseData);
        return processedResponseData;
      } else {
        return $q.reject();
      }
    }
    function onError(errorResponse) {
      return $q.reject(errorResponse.data);
    }
    if (!cache) {
      cache = $cacheFactory(this.getCacheName(), {
        capacity: this.getCacheCapacity()
      });
    }
    if (!_.isNil(cache.get(cacheKey))) {
      return $q.when(cache.get(cacheKey));
    }
    return $http.get(url, config).then(onSuccess.bind(this), onError);
  };
  this.processResponseData = function (responseData) {
    return responseData;
  };
};
BaseCachedRepository.$inject = ["$http", "$q", "$cacheFactory"];
angular.module('umCore').service('baseCachedRepository', BaseCachedRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var BaseCachedSharedPromiseRepository = function BaseCachedSharedPromiseRepository($http, $q, $cacheFactory) {
  this.getCacheName = function () {
    return '';
  };
  this.getCacheCapacity = function () {
    return 0;
  };
  this.clearCache = function () {
    var cache = $cacheFactory.get(this.getCacheName());
    if (cache) {
      cache.removeAll();
    }
  };
  this.getSharedPromiseCache = function () {
    return null;
  };
  this.get = function (cacheKey, url, config) {
    var cache = $cacheFactory.get(this.getCacheName()),
      defer;
    function onSuccess(response) {
      var processedResponseData;
      if (response) {
        processedResponseData = this.processResponseData(_.cloneDeep(response.data));
        cache.put(cacheKey, processedResponseData);
        defer.resolve(processedResponseData);
      } else {
        defer.reject();
      }
    }
    function onError(errorResponse) {
      return defer.reject(errorResponse.data);
    }
    function onFinally() {
      this.getSharedPromiseCache()[cacheKey] = null;
      delete this.getSharedPromiseCache()[cacheKey];
    }
    if (!cache) {
      cache = $cacheFactory(this.getCacheName(), {
        capacity: this.getCacheCapacity()
      });
    }
    if (_.has(this.getSharedPromiseCache(), cacheKey)) {
      return _.get(this.getSharedPromiseCache(), cacheKey);
    }
    if (!_.isNil(cache.get(cacheKey))) {
      return $q.when(cache.get(cacheKey));
    }
    defer = $q.defer();
    $http.get(url, config).then(onSuccess.bind(this), onError).finally(onFinally.bind(this));
    this.getSharedPromiseCache()[cacheKey] = defer.promise;
    return defer.promise;
  };
  this.processResponseData = function (responseData) {
    return responseData;
  };
};
BaseCachedSharedPromiseRepository.$inject = ["$http", "$q", "$cacheFactory"];
angular.module('umCore').service('baseCachedSharedPromiseRepository', BaseCachedSharedPromiseRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1322 */
/***/ (function(module, exports) {

/*@ngInject*/
var BaseRepository = function BaseRepository($http, $q) {
  function onSuccess(response) {
    if (response) {
      switch (response.config.method) {
        case 'GET':
          return this.processGetResponseData(response.data);
        case 'POST':
          return this.processPostResponseData(response.data);
        case 'DELETE':
          return this.processDeleteResponseData(response.data);
      }
    } else {
      return $q.reject();
    }
  }
  function onError(errorResponse) {
    return $q.reject(errorResponse.data);
  }
  this.get = function (url, config) {
    return $http.get(url, config).then(onSuccess.bind(this), onError);
  };
  this.processGetResponseData = function (responseData) {
    return responseData;
  };
  this.delete = function (url, config) {
    return $http.delete(url, config).then(onSuccess.bind(this), onError);
  };
  this.processDeleteResponseData = function (responseData) {
    return responseData;
  };
  this.post = function (url, formData, config) {
    return $http.post(url, formData, config).then(onSuccess.bind(this), onError);
  };
  this.processPostResponseData = function (responseData) {
    return responseData;
  };
};
BaseRepository.$inject = ["$http", "$q"];
angular.module('umCore').service('baseRepository', BaseRepository);

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var BaseSharedPromiseRepository = function BaseSharedPromiseRepository($http, $q) {
  this.getGETSharedPromiseCache = function () {
    return null;
  };
  this.getPOSTSharedPromiseCache = function () {
    return null;
  };
  this.getDELETESharedPromiseCache = function () {
    return null;
  };
  this.get = function (cacheKey, url, config) {
    var defer;
    function onSuccess(response) {
      if (response) {
        defer.resolve(this.processGetResponseData(_.cloneDeep(response.data)));
      } else {
        defer.reject();
      }
    }
    function onError(errorResponse) {
      return defer.reject(errorResponse.data);
    }
    function onFinally() {
      this.getGETSharedPromiseCache()[cacheKey] = null;
      delete this.getGETSharedPromiseCache()[cacheKey];
    }
    if (_.has(this.getGETSharedPromiseCache(), cacheKey)) {
      return _.get(this.getGETSharedPromiseCache(), cacheKey);
    }
    defer = $q.defer();
    $http.get(url, config).then(onSuccess.bind(this), onError).finally(onFinally.bind(this));
    this.getGETSharedPromiseCache()[cacheKey] = defer.promise;
    return defer.promise;
  };
  this.processGetResponseData = function (responseData) {
    return responseData;
  };
  this.delete = function (cacheKey, url) {
    var defer;
    function onSuccess(response) {
      if (response) {
        defer.resolve(this.processDeleteResponseData(_.cloneDeep(response.data)));
      } else {
        defer.reject();
      }
    }
    function onError(errorResponse) {
      return defer.reject(errorResponse.data);
    }
    function onFinally() {
      this.getDELETESharedPromiseCache()[cacheKey] = null;
      delete this.getDELETESharedPromiseCache()[cacheKey];
    }
    if (_.has(this.getDELETESharedPromiseCache(), cacheKey)) {
      return _.get(this.getDELETESharedPromiseCache(), cacheKey);
    }
    defer = $q.defer();
    $http.delete(url).then(onSuccess.bind(this), onError).finally(onFinally.bind(this));
    this.getDELETESharedPromiseCache()[cacheKey] = defer.promise;
    return defer.promise;
  };
  this.processDeleteResponseData = function (responseData) {
    return responseData;
  };
  this.post = function (cacheKey, url, formData, config) {
    var defer;
    function onSuccess(response) {
      if (response) {
        defer.resolve(this.processPostResponseData(_.cloneDeep(response.data)));
      } else {
        defer.reject();
      }
    }
    function onError(errorResponse) {
      return defer.reject(errorResponse.data);
    }
    function onFinally() {
      this.getPOSTSharedPromiseCache()[cacheKey] = null;
      delete this.getPOSTSharedPromiseCache()[cacheKey];
    }
    if (_.has(this.getPOSTSharedPromiseCache(), cacheKey)) {
      return _.get(this.getPOSTSharedPromiseCache(), cacheKey);
    }
    defer = $q.defer();
    $http.post(url, formData, config).then(onSuccess.bind(this), onError).finally(onFinally.bind(this));
    this.getPOSTSharedPromiseCache()[cacheKey] = defer.promise;
    return defer.promise;
  };
  this.processPostResponseData = function (responseData) {
    return responseData;
  };
};
BaseSharedPromiseRepository.$inject = ["$http", "$q"];
angular.module('umCore').service('baseSharedPromiseRepository', BaseSharedPromiseRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

/*@ngInject*/
var LoadingBarHandler = function LoadingBarHandler($rootScope, $timeout, coreConstant) {
  this.isLoading = false;
  this.isNotificationLoading = false;
  this.showLoadingBar = function (messageKey) {
    $rootScope.$broadcast(coreConstant.event.SHOW_LOADING_BAR, messageKey);
    this.isLoading = true;
  };
  this.showNotificationLoadingBar = function (message) {
    $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION_LOADING_BAR, message);
    this.isNotificationLoading = true;
  };
  this.showFadingNotificationLoadingBar = function (message) {
    this.showNotificationLoadingBar(message);
    $timeout(function () {
      this.hideNotificationLoadingBar(true);
    }.bind(this), 1000);
  };
  this.concludeNotificationLoadingBar = function (message) {
    $rootScope.$broadcast(coreConstant.event.CONCLUDE_FADING_NOTIFICATION_LOADING_BAR, message);
    this.isNotificationLoading = false;
  };
  this.hideLoadingBar = function () {
    $rootScope.$broadcast(coreConstant.event.HIDE_LOADING_BAR);
    this.isLoading = false;
  };
  this.hideNotificationLoadingBar = function (isHard) {
    $rootScope.$broadcast(coreConstant.event.HIDE_FADING_NOTIFICATION_LOADING_BAR, isHard);
    this.isNotificationLoading = false;
  };
  this.isLoadingBarVisible = function () {
    return this.isLoading;
  };
  this.isNotificationLoadingBarVisible = function () {
    return this.isNotificationLoading;
  };
};
LoadingBarHandler.$inject = ["$rootScope", "$timeout", "coreConstant"];
angular.module('umCore').service('loadingBarHandler', LoadingBarHandler);

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _, moment) {var atmosphere = __webpack_require__(1326);

/*@ngInject*/
var PersistentConnection = function PersistentConnection($rootScope, $state, $q, $timeout, $window, localization, alertHandler, umsLog, coreConstant, submissionConstant, formViewerConstant, coreMediator, logUtil, modalUtil, preferenceModel) {
  var isConnected = false,
    isConnecting = false,
    isReconnect = false,
    defer = null,
    logLevel = 'info',
    activeTransactions = {},
    connection,
    connectionTimeout;
  function alert(message) {
    message = convertPersistentConnectionMessageToAlert(message);
    if (message.email) {
      $rootScope.$broadcast(coreConstant.event.SHOW_EMAIL_MODAL_NOTIFICATION, message);
    } else if (message.emailNotificationDraftId) {
      /*
       * UMS-26310
       * Add the chat-message, email-message and notification ids to the SHOW_EMAIL_EDITOR broadcast.
       * This is step 5 of 6.
       * The next step is in the function handling SHOW_EMAIL_EDITOR in collaborationController.js.
       * The previous step is in the BaseEmailNotifier.sendEmailMessage method.
       */
      $rootScope.$broadcast(coreConstant.event.SHOW_EMAIL_EDITOR, message.emailNotificationDraftId, message.variables.submissionId, message.variables.chatMessageId, message.variables.emailMessageId, message.variables.notificationId, message.deleteNewEmailOnCancel);
    } else if (message.progressBar) {
      if (message.progressBar !== 'hide') {
        $rootScope.$broadcast(coreConstant.event.SHOW_LOADING_BAR, message.progressBar, message.variables.submissionId);
      } else {
        $rootScope.$broadcast(coreConstant.event.HIDE_LOADING_BAR, message.variables.submissionId);
      }
    } else if (message.refreshSubmission) {
      $rootScope.$broadcast(submissionConstant.event.RELOAD_SUBMISSION, message.variables.submissionId);
    } else {
      alertHandler.showAlert(message);
    }
  }
  function convertPersistentConnectionMessageToAlert(persistentConnectionMessage) {
    if (persistentConnectionMessage) {
      var returnObject = {},
        xmlDoc = $.parseXML(persistentConnectionMessage.payload.body),
        fields = $(xmlDoc).find('fields'),
        variables = {},
        namedParameters = ['message', 'title', 'email', 'progressBar', 'refreshSubmission', 'notification', 'notificationValue', 'customButtonType', 'emailNotificationDraftId', 'deleteNewEmailOnCancel', 'customButtonNames', 'customButtons'],
        customButtonNamesString;
      _.each(fields.children(), function (value) {
        if (namedParameters.indexOf(value.tagName) === -1) {
          variables[value.tagName] = $(value).text();
        } else if (value.tagName === 'customButtonNames') {
          customButtonNamesString = $(value).text();
          if (customButtonNamesString) {
            variables[value.tagName] = customButtonNamesString.split('::');
          }
        } else if (value.tagName === 'customButtons') {
          var customButtons = [];
          _.each(value.childNodes, function (child) {
            var customButton = {};
            _.each(child.childNodes, function (item) {
              customButton[item.tagName] = $(item).text();
            });
            customButtons.push(customButton);
          });
          returnObject[value.tagName] = customButtons;
        } else {
          returnObject[value.tagName] = $(value).text();
        }
      });
      returnObject.channel = persistentConnectionMessage.objectUri;
      returnObject.variables = variables;
      return returnObject;
    }
  }
  function checkForActiveTransaction(correlationId, totalMessageCount) {
    if (_.isUndefined(activeTransactions[correlationId])) {
      // This is a new transaction.
      if (logLevel === 'debug') {
        umsLog.debug('Start transaction -- ' + correlationId);
      }
      activeTransactions[correlationId] = {
        messagesRemaining: totalMessageCount,
        updatedSubmissionId: 0
      };
    }
  }
  function checkAndHandleEndOfTransaction(messagesRemaining, correlationId) {
    var isEndOfTransaction = messagesRemaining === 0,
      activeTransaction,
      updatedSubmission,
      updatedSubmissionId,
      updatedQuoteSummary,
      updatedPolicyChanges,
      updatedProposalSummary,
      navigationItem,
      navigationItemSubmissionUri,
      navigationItemActorPrincipalName,
      isDelete,
      isQuoteDeleted,
      isProposalDeleted,
      createRowMessages,
      updateRowMessages,
      deleteRowMessages,
      createdNotification,
      updatedNotifications;
    if (isEndOfTransaction) {
      activeTransaction = activeTransactions[correlationId];
      updatedSubmission = activeTransaction.updatedSubmission;
      updatedSubmissionId = activeTransaction.updatedSubmissionId;
      updatedQuoteSummary = activeTransaction.updatedQuoteSummary;
      updatedPolicyChanges = activeTransaction.updatedPolicyChanges;
      updatedProposalSummary = activeTransaction.updatedProposalSummary;
      navigationItem = activeTransaction.navigationItem;
      navigationItemSubmissionUri = activeTransaction.navigationItemSubmissionUri;
      navigationItemActorPrincipalName = activeTransaction.navigationItemActorPrincipalName;
      isDelete = activeTransaction.isDelete;
      isQuoteDeleted = activeTransaction.isQuoteDeleted;
      isProposalDeleted = activeTransaction.isProposalDeleted;
      createRowMessages = activeTransaction.createRowMessages;
      updateRowMessages = activeTransaction.updateRowMessages;
      deleteRowMessages = activeTransaction.deleteRowMessages;
      createdNotification = activeTransaction.createdNotification;
      updatedNotifications = activeTransaction.updatedNotifications;
      if (updatedSubmissionId > 0) {
        if (!isDelete) {
          if (updatedSubmission) {
            updateSubmission(updatedSubmission);
          }
        } else {
          // Either you or someone else deleted this submission, so close the submission (if open) and deregister.
          $rootScope.$broadcast(coreConstant.event.CLOSE_SUBMISSION_VIEW, updatedSubmissionId);
        }
      }
      if (updatedQuoteSummary) {
        if (!isQuoteDeleted) {
          $rootScope.$broadcast(coreConstant.event.REFRESH_QUOTE, updatedQuoteSummary);
        } else {
          $rootScope.$broadcast(coreConstant.event.QUOTE_DELETED, updatedQuoteSummary);
        }
      }
      if (updatedPolicyChanges) {
        _.each(updatedPolicyChanges, function (policyChange) {
          $rootScope.$broadcast(coreConstant.event.REFRESH_POLICY_CHANGE, policyChange);
        });
      }
      if (updatedProposalSummary) {
        if (!isProposalDeleted) {
          $rootScope.$broadcast(coreConstant.event.REFRESH_PROPOSAL, updatedProposalSummary, updatedSubmissionId);
        } else {
          $rootScope.$broadcast(coreConstant.event.PROPOSAL_DELETED, updatedProposalSummary, updatedSubmissionId);
        }
      }
      if (navigationItem) {
        $rootScope.$broadcast(coreConstant.event.UPDATE_NAVIGATION_ITEM_MESSAGE, navigationItemSubmissionUri, navigationItem, navigationItemActorPrincipalName);
      }
      if (deleteRowMessages && _.size(deleteRowMessages) !== 0) {
        _.each(deleteRowMessages, function (deleteRowMessage) {
          $rootScope.$broadcast(formViewerConstant.event.DELETE_ROW, deleteRowMessage);
        });
      }
      if (createRowMessages && _.size(createRowMessages) !== 0) {
        _.each(createRowMessages, function (createRowMessage) {
          $rootScope.$broadcast(formViewerConstant.event.CREATE_ROW, createRowMessage);
        });
      }
      if (updateRowMessages && _.size(updateRowMessages) !== 0) {
        _.each(updateRowMessages, function (updateRowMessage) {
          $rootScope.$broadcast(formViewerConstant.event.UPDATE_ROW, updateRowMessage);
        });
      }
      if (createdNotification) {
        $rootScope.$broadcast(coreConstant.event.CREATE_NOTIFICATION, createdNotification);
      }
      if (updatedNotifications) {
        $rootScope.$broadcast(coreConstant.event.UPDATE_NOTIFICATION, updatedNotifications);
      }
      if (logLevel === 'debug') {
        umsLog.debug('End transaction -- ' + correlationId);
      }
      delete activeTransactions[correlationId];
    }
  }
  function updateSubmission(submission) {
    // Send an event to anyone who is interested that we've received an update for this submission.
    $rootScope.$broadcast(coreConstant.event.UPDATE_SUBMISSION, submission);
  }
  this.connect = function () {
    // If we are already connected, immediately return a resolved promise.
    if (isConnected) {
      return $q.when();
    }
    if (_.isNull(defer)) {
      defer = $q.defer();
    }
    if (isConnecting) {
      // In the case where we have multiple calls to this method at the same time AND
      // it hasn't connected yet, we want to return the same promise to all the callers so that
      // we can resolve that single promise when the connection opens.
      return defer.promise;
    } else {
      if (logLevel === 'debug') {
        umsLog.debug('persistentConnection.connect()');
      }
      var maxReconnectOnClose = preferenceModel.get('system.persistentConnectionMaxReconnectOnClose') || 2,
        reconnectInterval = preferenceModel.get('system.persistentConnectionReconnectInterval') || 500,
        request = {
          method: 'POST',
          maxReconnectOnClose: maxReconnectOnClose,
          reconnectInterval: reconnectInterval,
          url: '/rest/v2/PersistentConnection',
          transport: 'streaming',
          timeout: -1,
          logLevel: logLevel,
          trackMessageLength: true,
          readResponsesHeaders: true,
          closeAsync: true,
          data: 'Authorization=' + coreMediator.getLoginTokenAuthorizationHeader()
        };
      if (coreMediator.getClientId()) {
        request.uuid = coreMediator.getClientId();
      }
      request.onOpen = this.onOpen;
      request.onMessage = this.onMessage;
      request.onClose = this.onClose;
      request.onReconnect = this.onReconnect;
      request.onReopen = this.onReopen;
      request.onError = this.onError;

      // Initiate the suspended POST using the options configured above.
      isConnecting = true;
      connection = atmosphere.subscribe(request);
      connectionTimeout = $timeout(function () {
        modalUtil.showPersistentConnectionFailed();
        logUtil.logWarning('Persistent connection failed to connect.');
      }, 5000);
    }
    return defer.promise;
  };
  this.onOpen = function () {
    var clientId = this.uuid;
    if (logLevel === 'debug') {
      umsLog.debug('persistentConnection.onOpen()');
    }
    if (!_.isNil(connectionTimeout)) {
      $timeout.cancel(connectionTimeout);
    }
    coreMediator.setClientId(clientId);
    activeTransactions = {};
    alertHandler.start(clientId);
    isConnecting = false;
    isConnected = true;
    if (defer) {
      defer.resolve();
    }
    defer = null;
    logUtil.logInfo('Client Connected');
  };
  this.onClose = function () {
    if (logLevel === 'debug') {
      umsLog.debug('persistentConnection.onClose()');
    }
    if (!_.isNil(connectionTimeout)) {
      $timeout.cancel(connectionTimeout);
    }
    isConnected = false;
    $timeout(function () {
      if (!_.isNil(connection) && !isReconnect) {
        modalUtil.showServerDisconnectedModal();
      } else {
        isReconnect = false;
      }
    }, 500);
  };
  this.disconnectAndAlert = disconnectAndAlert;
  function disconnectAndAlert() {
    disconnect().finally(function () {
      modalUtil.showServerDisconnectedModal();
    });
  }
  this.disconnect = disconnect;
  function disconnect() {
    if (!_.isNil(connectionTimeout)) {
      $timeout.cancel(connectionTimeout);
    }
    if (isConnected) {
      disconnectAtmosphere();
      coreMediator.removeClientId();
      return $q.when();
    } else if (isConnecting) {
      return defer.promise.then(disconnect);
    } else {
      return $q.reject();
    }
  }
  function disconnectAtmosphere() {
    activeTransactions = {};
    isConnecting = false;
    isConnected = false;
    atmosphere.unsubscribe();
    connection = null;
  }
  this.onReconnect = function (request) {
    // During a reconnect, we need to update the request URL because our Authorization token
    // may have changed since we last connected, and we don't want to send an expired token.
    request.data = 'Authorization=' + coreMediator.getLoginTokenAuthorizationHeader();
    if (logLevel === 'debug') {
      umsLog.debug('persistentConnection.onReconnect()');
    }
    if (!_.isNil(connectionTimeout)) {
      $timeout.cancel(connectionTimeout);
    }
    isConnected = true;
    isReconnect = true;
    coreMediator.setClientId(this.uuid);
  };

  // Debounce the onReopen method because sometimes atmosphere decides to invoke onReopen
  // *a lot* when the connection is re-established.
  this.onReopen = _.debounce(function () {
    if (logLevel === 'debug') {
      umsLog.debug('persistentConnection.onReopen()');
    }
    if (!_.isNil(connectionTimeout)) {
      $timeout.cancel(connectionTimeout);
    }
    coreMediator.setClientId(this.uuid);
    logUtil.logInfo('Client Reconnect: client-side disconnect');
  }, 1000, {
    leading: true,
    trailing: false
  });
  this.onError = function () {
    if (logLevel === 'debug') {
      umsLog.debug('persistentConnection.onError()');
    }
    disconnectAndAlert();
  };
  this.onMessage = function (response) {
    /**
     * @param persistentConnectionMessage.totalMessageCount
     * @param persistentConnectionMessage.correlationId
     */
    var persistentConnectionMessage = JSON.parse(response.responseBody),
      totalMessageCount = persistentConnectionMessage.totalMessageCount,
      correlationId = persistentConnectionMessage.correlationId,
      actorPrincipalName = persistentConnectionMessage.actorPrincipalName,
      objectUri = persistentConnectionMessage.objectUri ? persistentConnectionMessage.objectUri.toLocaleLowerCase() : '',
      messagePayload = persistentConnectionMessage.payload,
      messagesRemaining,
      isDynamicDatasetMessage = objectUri.indexOf('dynamicdataset') !== -1,
      isFieldMessage = objectUri.indexOf('field') !== -1,
      isFormMessage = objectUri.indexOf('form') !== -1,
      isRowMessage = objectUri.indexOf('formrow') !== -1,
      isNavigationItemMessage = objectUri.indexOf('navigationitem') !== -1,
      isSubmissionUpdate = objectUri.indexOf('\/submission\/') > -1,
      isQuoteUpdate = objectUri.indexOf('\/quote\/') > -1,
      isPolicyChangeUpdate = objectUri.indexOf('\/policy') === 0 || objectUri.indexOf('\/endorsement') === 0 || objectUri.indexOf('\/policyrewrite') === 0,
      isCollaborationItemMessage = objectUri.indexOf('note') !== -1 || objectUri.indexOf('attachment') !== -1 || objectUri.indexOf('email') !== -1 || objectUri.indexOf('task') !== -1 || objectUri.indexOf('collabmessage') !== -1,
      isActionsMessage = objectUri.indexOf('\/actions') !== -1,
      isProposalUpdate = objectUri.indexOf('\/proposal\/') > -1,
      isNotificationUpdate = objectUri.indexOf('\/notification\/') > -1,
      isChatMessage = objectUri.indexOf('\/message\/') > -1,
      isUserMessage = objectUri.indexOf('\/user\/') > -1,
      isOrganizationMessage = objectUri.indexOf('\/organization\/') > -1,
      isInvalidSession = response.status === 454,
      isPingMessage = persistentConnectionMessage.type === 'ping',
      isCreateType,
      isDeleteType,
      isUpdateType,
      isDelete,
      isRenameType;
    if (logLevel === 'debug') {
      umsLog.debug('persistentConnection.onMessage()');
      umsLog.debug(JSON.stringify(persistentConnectionMessage, null, 2));
    }
    if (isInvalidSession) {
      disconnect();
      return;
    }
    function handleSubmissionUpdate() {
      // Postpone submission update processing until the end of the transaction.
      var submission = messagePayload;
      isDelete = persistentConnectionMessage.type === 'Delete';
      activeTransactions[correlationId].updatedSubmission = submission;
      activeTransactions[correlationId].updatedSubmissionId = submission.id;
      activeTransactions[correlationId].isDelete = isDelete;
    }
    function handleQuoteUpdate() {
      var quoteSummary = messagePayload;
      isDelete = persistentConnectionMessage.type === 'Delete';
      activeTransactions[correlationId].updatedQuoteSummary = quoteSummary;
      activeTransactions[correlationId].updatedSubmissionId = quoteSummary.submissionId;
      activeTransactions[correlationId].isQuoteDeleted = isDelete;
    }
    function handlePolicyChangeUpdate() {
      var policyChange = messagePayload;
      if (_.isNil(activeTransactions[correlationId].updatedPolicyChanges)) {
        activeTransactions[correlationId].updatedPolicyChanges = [];
      }
      activeTransactions[correlationId].updatedPolicyChanges.push(policyChange);
      activeTransactions[correlationId].updatedSubmissionId = policyChange.submissionId;
    }
    function handleProposalUpdate() {
      var proposalSummary = messagePayload;
      isDelete = persistentConnectionMessage.type === 'Delete';
      activeTransactions[correlationId].updatedProposalSummary = proposalSummary;
      activeTransactions[correlationId].isProposalDeleted = isDelete;
    }
    function cleanStickyAndReload() {
      var now = new Date();
      document.cookie = 'AWSALB=;path=/;expires=' + now.toGMTString();
      document.cookie = 'AWSALBCORS=;path=/;expires=' + now.toGMTString();
      $window.location.reload();
    }
    var handleNonSubmissionUpdate = function () {
      var setupMessageType = function () {
        switch (persistentConnectionMessage.type) {
          case 'alert':
            var messageObj = convertPersistentConnectionMessageToAlert(persistentConnectionMessage);
            if (messageObj.message == 'action:resetConnections') {
              cleanStickyAndReload();
            } else if (messageObj.message == 'action:resetConnectionsWithConfirmation') {
              localization.getTranslations().then(function (translations) {
                var confirmed = false;
                var now = moment();
                modalUtil.showGenericConfirm({
                  title: _.get(translations, 'serverReconnectModal.title'),
                  summary: _.get(translations, 'serverReconnectModal.summary'),
                  confirmActionButtonLabel: 'OK',
                  cancelButtonLabel: 'CANCEL'
                }).then(function () {
                  cleanStickyAndReload();
                }).finally(function () {
                  confirmed = true;
                });
                setTimeout(function () {
                  if (!confirmed) cleanStickyAndReload();
                }, 60000);
              });
            } else {
              alert(persistentConnectionMessage);
            }
            break;
          case 'Update':
            isUpdateType = true;
            break;
          case 'Create':
            isCreateType = true;
            break;
          case 'Delete':
            isDeleteType = true;
            break;
          case 'Rename':
            isRenameType = true;
            break;
        }
      }.bind(this);
      function handleRowMessage() {
        if (activeTransactions[correlationId]) {
          if (!activeTransactions[correlationId].createRowMessages) {
            activeTransactions[correlationId].createRowMessages = {};
          }
          if (!activeTransactions[correlationId].updateRowMessages) {
            activeTransactions[correlationId].updateRowMessages = {};
          }
          if (!activeTransactions[correlationId].deleteRowMessages) {
            activeTransactions[correlationId].deleteRowMessages = {};
          }
        }
        if (isCreateType) {
          activeTransactions[correlationId].createRowMessages[messagePayload.id] = {
            messagePayload: messagePayload,
            createFieldMessages: [],
            updateFieldMessages: [],
            deleteFieldMessages: [],
            renameFieldMessages: []
          };
        } else if (isDeleteType) {
          activeTransactions[correlationId].deleteRowMessages[messagePayload.id] = {
            messagePayload: messagePayload,
            createFieldMessages: [],
            updateFieldMessages: [],
            deleteFieldMessages: [],
            renameFieldMessages: []
          };
        } else if (isUpdateType) {
          activeTransactions[correlationId].updateRowMessages[messagePayload.id] = {
            messagePayload: messagePayload,
            formId: messagePayload.formId,
            createFieldMessages: [],
            updateFieldMessages: [],
            deleteFieldMessages: [],
            renameFieldMessages: []
          };
        }
      }
      function handleFormMessage() {
        if (isCreateType) {
          $rootScope.$broadcast(formViewerConstant.event.CREATE_NEW_SUPPLEMENTAL_FORM, messagePayload);
        } else if (isDeleteType) {
          $rootScope.$broadcast(formViewerConstant.event.DELETE_SUPPLEMENTAL_FORM, messagePayload);
        } else if (isUpdateType) {
          var form = messagePayload;
          if (form.root) {
            $rootScope.$broadcast(formViewerConstant.event.UPDATE_ROOT_FORM, form);
          }
        }
      }
      function handleFieldMessage() {
        var createRowMessages = activeTransactions[correlationId].createRowMessages,
          updateRowMessages,
          deleteRowMessages = activeTransactions[correlationId].deleteRowMessages;
        if (messagePayload.rowId) {
          if (!activeTransactions[correlationId].updateRowMessages) {
            activeTransactions[correlationId].updateRowMessages = {};
          }
          updateRowMessages = activeTransactions[correlationId].updateRowMessages;
          if (!updateRowMessages[messagePayload.rowId]) {
            updateRowMessages[messagePayload.rowId] = {
              formId: messagePayload.formId,
              createFieldMessages: [],
              updateFieldMessages: [],
              deleteFieldMessages: [],
              renameFieldMessages: []
            };
          }
          if (isCreateType) {
            if (createRowMessages && createRowMessages[messagePayload.rowId]) {
              createRowMessages[messagePayload.rowId].createFieldMessages.push(messagePayload);
            } else if (updateRowMessages && updateRowMessages[messagePayload.rowId]) {
              updateRowMessages[messagePayload.rowId].createFieldMessages.push(messagePayload);
            } else if (deleteRowMessages && deleteRowMessages[messagePayload.rowId]) {
              deleteRowMessages[messagePayload.rowId].createFieldMessages.push(messagePayload);
            }
          } else if (isUpdateType) {
            if (createRowMessages && createRowMessages[messagePayload.rowId]) {
              createRowMessages[messagePayload.rowId].updateFieldMessages.push(messagePayload);
            } else if (updateRowMessages && updateRowMessages[messagePayload.rowId]) {
              updateRowMessages[messagePayload.rowId].updateFieldMessages.push(messagePayload);
            } else if (deleteRowMessages && deleteRowMessages[messagePayload.rowId]) {
              deleteRowMessages[messagePayload.rowId].updateFieldMessages.push(messagePayload);
            }
          } else if (isDeleteType) {
            if (createRowMessages && createRowMessages[messagePayload.rowId]) {
              createRowMessages[messagePayload.rowId].deleteFieldMessages.push(messagePayload);
            } else if (updateRowMessages && updateRowMessages[messagePayload.rowId]) {
              updateRowMessages[messagePayload.rowId].deleteFieldMessages.push(messagePayload);
            } else if (deleteRowMessages && deleteRowMessages[messagePayload.rowId]) {
              deleteRowMessages[messagePayload.rowId].deleteFieldMessages.push(messagePayload);
            }
          } else if (isRenameType) {
            if (createRowMessages && createRowMessages[messagePayload.rowId]) {
              createRowMessages[messagePayload.rowId].renameFieldMessages.push(messagePayload);
            } else if (updateRowMessages && updateRowMessages[messagePayload.rowId]) {
              updateRowMessages[messagePayload.rowId].renameFieldMessages.push(messagePayload);
            } else if (deleteRowMessages && deleteRowMessages[messagePayload.rowId]) {
              deleteRowMessages[messagePayload.rowId].renameFieldMessages.push(messagePayload);
            }
          }
        } else {
          if (isCreateType) {
            $rootScope.$broadcast(formViewerConstant.event.CREATE_FIELD_MESSAGE, messagePayload);
          } else if (isUpdateType) {
            $rootScope.$broadcast(formViewerConstant.event.UPDATE_FIELD_MESSAGE, messagePayload);
          } else if (isDeleteType) {
            $rootScope.$broadcast(formViewerConstant.event.DELETE_FIELD_MESSAGE, messagePayload);
          }
        }
      }
      function handleNavigationItemMessage() {
        if (isUpdateType) {
          activeTransactions[correlationId].navigationItem = messagePayload.entity;
          activeTransactions[correlationId].navigationItemSubmissionUri = messagePayload.contextUri;
          activeTransactions[correlationId].navigationItemActorPrincipalName = actorPrincipalName;
        }
      }
      function handleCollaborationItemMessage() {
        if (isCreateType) {
          $rootScope.$broadcast(submissionConstant.event.CREATE_COLLABORATION_ITEM_MESSAGE, messagePayload);
        } else if (isUpdateType) {
          $rootScope.$broadcast(submissionConstant.event.UPDATE_COLLABORATION_ITEM_MESSAGE, messagePayload);
        } else if (isDeleteType) {
          $rootScope.$broadcast(submissionConstant.event.DELETE_COLLABORATION_ITEM_MESSAGE, messagePayload);
        }
      }
      function handleActionsMessage() {
        var uriSplits = _.split(objectUri, '/'),
          entityType = _.toLower(uriSplits[0]),
          entityId = parseInt(uriSplits[1]);
        if (isUpdateType) {
          _.each(messagePayload.actions.actions, function (action) {
            action.name = _.replace(action.name, 'Create Report: ', '');
          });
          $rootScope.$broadcast(coreConstant.event.UPDATE_ACTIONS_MESSAGE, messagePayload, entityType, entityId);
        }
      }
      function handleNotificationUpdate() {
        var notification = messagePayload;
        if (isCreateType) {
          activeTransactions[correlationId].createdNotification = notification;
        } else {
          if (_.isNil(activeTransactions[correlationId].updatedNotifications)) {
            activeTransactions[correlationId].updatedNotifications = [];
          }
          activeTransactions[correlationId].updatedNotifications.push(notification);
        }
      }
      function handleChatMessageUpdate() {
        if (isCreateType) {
          $rootScope.$broadcast(submissionConstant.event.CREATE_CHAT_MESSAGE, messagePayload);
        } else if (isUpdateType) {
          $rootScope.$broadcast(submissionConstant.event.UPDATE_CHAT_MESSAGE, messagePayload);
        } else if (isDeleteType) {
          $rootScope.$broadcast(submissionConstant.event.DELETE_CHAT_MESSAGE, messagePayload);
        }
      }
      function handleUserUpdate() {
        if (isCreateType) {
          $rootScope.$broadcast(coreConstant.event.CREATE_USER, messagePayload);
        } else if (isUpdateType) {
          $rootScope.$broadcast(coreConstant.event.UPDATE_USER, messagePayload);
        } else if (isDeleteType) {
          $rootScope.$broadcast(coreConstant.event.DELETE_USER, messagePayload);
        }
      }
      function handleOrganizationUpdate() {
        if (isCreateType) {
          $rootScope.$broadcast(coreConstant.event.CREATE_ORGANIZATION, messagePayload);
        } else if (isUpdateType) {
          $rootScope.$broadcast(coreConstant.event.UPDATE_ORGANIZATION, messagePayload);
        } else if (isDeleteType) {
          $rootScope.$broadcast(coreConstant.event.DELETE_ORGANIZATION, messagePayload);
        }
      }
      setupMessageType();
      if (isDynamicDatasetMessage && isUpdateType) {
        var dataItems = messagePayload.items;
        if (!_.isNil(messagePayload.defaultValue)) {
          _.each(dataItems, function (dataItem) {
            if (dataItem.value === messagePayload.defaultValue.value) {
              dataItem.isDefault = true;
            }
          });
        }
        messagePayload.items = dataItems;
        $rootScope.$broadcast(coreConstant.event.UPDATE_DATA_SET, messagePayload);
      }
      if (isRowMessage) {
        handleRowMessage();
      } else if (isFormMessage) {
        handleFormMessage();
      } else if (isFieldMessage) {
        handleFieldMessage();
      } else if (isNavigationItemMessage) {
        handleNavigationItemMessage();
      } else if (isCollaborationItemMessage) {
        handleCollaborationItemMessage();
      } else if (isActionsMessage) {
        handleActionsMessage();
      } else if (isNotificationUpdate) {
        handleNotificationUpdate();
      } else if (isChatMessage) {
        handleChatMessageUpdate();
      } else if (isUserMessage) {
        handleUserUpdate();
      } else if (isOrganizationMessage) {
        handleOrganizationUpdate();
      }
    }.bind(this);

    // First, see if we have already processed at least one message from this transaction.
    checkForActiveTransaction(correlationId, totalMessageCount);
    messagesRemaining = activeTransactions[correlationId].messagesRemaining;
    if (isSubmissionUpdate) {
      handleSubmissionUpdate();
    } else if (isQuoteUpdate) {
      handleQuoteUpdate();
    } else if (isProposalUpdate) {
      handleProposalUpdate();
    } else if (isPolicyChangeUpdate) {
      handlePolicyChangeUpdate();
    } else if (isPingMessage) {
      umsLog.debug('Received ping.');
    } else {
      handleNonSubmissionUpdate();
    }

    // Count down the remaining message count.
    activeTransactions[correlationId].messagesRemaining = --messagesRemaining;

    // If we have received all of the messages we're expecting, we've reached the end of this transaction.
    checkAndHandleEndOfTransaction(messagesRemaining, correlationId);
  }.bind(this);
};
PersistentConnection.$inject = ["$rootScope", "$state", "$q", "$timeout", "$window", "localization", "alertHandler", "umsLog", "coreConstant", "submissionConstant", "formViewerConstant", "coreMediator", "logUtil", "modalUtil", "preferenceModel"];
angular.module('umCore').service('persistentConnection', PersistentConnection);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0), __webpack_require__(2)))

/***/ }),
/* 1326 */,
/* 1327 */,
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var AlertHandler = function AlertHandler($rootScope, alertRegistrationRepository, localization, loadUserDetailsRepository, coreConstant, notificationPreferenceRepository, appTypeConfigurationModel, $injector) {
  var registeredChannels = [];
  var notificationName;
  var systemAnnouncementChannelList = ['allAgents', 'allUws', 'allSUs'];
  var FORCE_LOGOUT_CHANNEL_STRING = 'forceLogout:';
  var MESSAGE_CHANNEL_STRING = 'message:';
  var GLOBAL_MESSAGE_CHANNEL_STRING = 'globalMessage';
  var CLIENT_CHANNEL_STRING = '';
  this.start = function (clientId) {
    function startAlertHandler(principalId) {
      if (clientId) {
        var forceLogoutChannel = FORCE_LOGOUT_CHANNEL_STRING + clientId,
          simplePrincipalId = principalId,
          channels = [],
          globalMessageChannel = GLOBAL_MESSAGE_CHANNEL_STRING,
          allChannel = appTypeConfigurationModel.getAllChannel(),
          clientIdChannel = CLIENT_CHANNEL_STRING,
          sessionMessageChannel = MESSAGE_CHANNEL_STRING + clientId,
          channelsNotRegistered,
          channelsToBeRemoved;
        if (simplePrincipalId) {
          var seperatorIndex = simplePrincipalId.lastIndexOf(':');
          if (seperatorIndex > -1) {
            simplePrincipalId = simplePrincipalId.substring(seperatorIndex + 1);
          }
        }
        var messageChannel = MESSAGE_CHANNEL_STRING + simplePrincipalId;
        channels.push(forceLogoutChannel);
        channels.push(messageChannel);
        channels.push(globalMessageChannel);
        channels.push(allChannel);
        channels.push(clientIdChannel);
        channels.push(sessionMessageChannel);
        channelsNotRegistered = _.difference(channels, registeredChannels);
        channelsToBeRemoved = _.difference(registeredChannels, channels);
        if (!_.isNil(channelsToBeRemoved) && channelsToBeRemoved.length > 0) {
          alertRegistrationRepository.performRegistration('', true).then(function () {
            alertRegistrationRepository.performRegistration(channels, false).then(function () {
              registeredChannels = channels;
            });
          });
        } else if (!_.isNil(channelsNotRegistered) && channelsNotRegistered.length > 0) {
          alertRegistrationRepository.performRegistration(channelsNotRegistered, false).then(function () {
            registeredChannels = channels;
          });
        }
      }
    }
    loadUserDetailsRepository.loadUserDetails().then(function (userProfile) {
      var userType = userProfile.userType;
      appTypeConfigurationModel.setUserType(userType);
      startAlertHandler(userProfile.principalId);
    });
  };
  this.stop = function () {
    if (registeredChannels && registeredChannels.length > 0) {
      registeredChannels = [];
      alertRegistrationRepository.performRegistration('', true).then(onSuccess, onError);
    }
  };
  this.clearRegisteredChannels = function () {
    registeredChannels = [];
  };
  this.showAlert = function (alert) {
    if (_.includes(systemAnnouncementChannelList, alert.channel)) {
      localization.getTranslationByKey('systemAnnouncement.title').then(function (translation) {
        showModalNotificationMessage(translation, alert.message);
      });
    } else if (_.startsWith(alert.channel, FORCE_LOGOUT_CHANNEL_STRING)) {
      localization.getTranslationByKey('forceLogout.title').then(function (translation) {
        showModalNotificationMessage(translation, alert.message);
        $injector.get('coreMediator').logout();
      });
    } else {
      notificationName = alert.notification;
      if (isAcordUpload(alert)) {
        processNotificationPreference(JSON.parse(alert.notificationValue), alert.variables.submissionId);
      } else {
        if (alert.notificationValue) {
          processNotificationPreference(JSON.parse(alert.notificationValue), -1);
        } else if (!_.isNil(alert.customButtonType) && alert.customButtonType === 'customAlert') {
          showCustomButtonNotification(alert);
        } else if (alert.notification) {
          notificationPreferenceRepository.getNotificationPopupTemplate(alert.notification, alert.variables).then(processNotificationPreference);
        } else {
          processNotificationPreference(alert, -1);
        }
      }
    }
  };
  function showCustomButtonNotification(alert) {
    var options = {
      title: alert.title,
      summary: alert.message,
      customButtonType: alert.customButtonType,
      customButtons: alert.customButtons,
      notificationName: notificationName,
      contextParameters: alert.variables.contextParameters
    };
    $rootScope.$broadcast(coreConstant.event.SHOW_CUSTOM_ALERT_MODAL_NOTIFICATION, options);
  }
  function isAcordUpload(alert) {
    return alert.notification && (alert.notification === 'acordUploadCompleteReviewEffectiveDate' || alert.notification === 'acordUploadComplete');
  }
  function processNotificationPreference(notification, actionId) {
    localization.getTranslationByKey('alert.genericAlertTitle').then(function (genericAlertTitle) {
      if (!isNotificationHidden(notification) && (_.isNil(notification.id) || notification.enabled)) {
        var title = notification.title ? notification.title : genericAlertTitle;
        var body = notification.body || notification.message;
        if (body) {
          body = body.replace(/\\n/g, '\n');
          showNotificationMessage(title, body, actionId, notificationName);
        }
      }
      notificationName = '';
    });
  }
  function isNotificationHidden(notification) {
    return notification.excludeConsole && (notification.excludeConsole === 'Producer' && appTypeConfigurationModel.isAgentConsole() || notification.excludeConsole === 'Underwriter' && appTypeConfigurationModel.isUnderwriterWorkstation());
  }
  function showModalNotificationMessage(notificationTitle, notificationMessage) {
    localization.getTranslations().then(function (translations) {
      $rootScope.$broadcast(coreConstant.event.SHOW_MODAL_NOTIFICATION, {
        title: notificationTitle,
        summary: notificationMessage,
        cancelButtonLabel: _.get(translations, 'alert.okButtonLabel')
      });
    });
  }
  function showNotificationMessage(notificationTitle, notificationMessage, actionId, notificationName) {
    localization.getTranslations().then(function (translations) {
      var options = {};
      options.title = notificationTitle;
      options.summary = notificationMessage;
      options.confirmActionButtonLabel = actionId > 0 ? _.get(translations, 'alert.confirmActionButtonLabel') : _.get(translations, 'alert.okButtonLabel');
      options.notificationName = notificationName;
      if (actionId > 0) {
        options.cancelButtonLabel = _.get(translations, 'alert.cancelActionButtonLabel');
      }
      if (!_.isNil(notificationName) && notificationName !== 'acordUploadCompleteReviewEffectiveDate' && notificationName !== 'acordUploadComplete') {
        $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, notificationMessage);
      } else {
        $rootScope.$broadcast(coreConstant.event.ACORD_UPLOAD_NOTIFICATION, options, actionId);
      }
    });
  }
  function replaceMessageVariables(message, variables) {
    _.forEach(variables, function (property) {
      var messageArray = message.split('{' + property + '}');
      message = messageArray.join(variables[property]);
    });
    return message;
  }
};
AlertHandler.$inject = ["$rootScope", "alertRegistrationRepository", "localization", "loadUserDetailsRepository", "coreConstant", "notificationPreferenceRepository", "appTypeConfigurationModel", "$injector"];
angular.module('umCore').service('alertHandler', AlertHandler);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

/*@ngInject*/
var AlertRegistrationRepository = function AlertRegistrationRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.performRegistration = function (channels, isUnsubscribe) {
    var url = '/rest/Alert/register',
      config = {
        params: {
          registrationIdentifier: 'alert',
          channels: channels
        }
      };
    if (isUnsubscribe) {
      return this.delete(url, config);
    } else {
      return this.post(url, {}, config);
    }
  };
};
AlertRegistrationRepository.$inject = ["baseRepository"];
angular.module('umCore').service('alertRegistrationRepository', AlertRegistrationRepository);

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

var path = '/sessionTimeout/sessionTimeout.tpl.html';
var html = "<div></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1331 */
/***/ (function(module, exports) {

var SessionTimeoutComponent = {
  templateUrl: '/sessionTimeout/sessionTimeout.tpl.html',
  controller: 'sessionTimeoutController',
  bindings: {}
};
angular.module('umCore').component('sessionTimeout', SessionTimeoutComponent);

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var SessionTimeoutController = function SessionTimeoutController($rootScope, $scope, $filter, $uibModal, $element, preferenceModel, localization, Idle, coreMediator, coreConstant, appTypeConfigurationModel) {
  $element.addClass('sessionTimeout');
  var translations, idleWarningTitle, sessionExpireTitle, modalInstance;
  localization.getTranslations().then(function (result) {
    translations = result;
    idleWarningTitle = _.get(translations, 'sessionTimeout.idleWarningTitle');
    sessionExpireTitle = _.get(translations, 'sessionTimeout.inactivityLogOutTitle');
  });
  function generateMessage(countDown) {
    var autoLogoutWarning = _.get(translations, 'sessionTimeout.autoLogoutWarning');
    autoLogoutWarning = _.replace(autoLogoutWarning, '{umsType}', _.get(translations, 'sessionTimeout.' + _.lowerFirst(appTypeConfigurationModel.getUserType())));
    autoLogoutWarning = _.replace(autoLogoutWarning, '{autoLogoutWarningMinutes}', preferenceModel.get('system.autoLogoutMinutes'));
    autoLogoutWarning = _.replace(autoLogoutWarning, '{countDown}', $filter('readableTime')(countDown));
    return autoLogoutWarning;
  }
  $scope.$on('IdleWarn', function (e, countdown) {
    var message = generateMessage(countdown);
    if (modalInstance) {
      $rootScope.$broadcast(coreConstant.event.UPDATE_SESSION_COUNTDOWN_MESSAGE, message);
    } else {
      displayModal(idleWarningTitle, message);
    }
  });
  $scope.$on('IdleTimeout', function () {
    var autoLogoutRedirectMessage = _.get(translations, 'sessionTimeout.autoLogoutRedirectMessage');
    autoLogoutRedirectMessage = _.replace(autoLogoutRedirectMessage, '{umsType}', _.get(translations, 'sessionTimeout.' + _.lowerFirst(appTypeConfigurationModel.getUserType())));
    coreMediator.logout(true);
    displayModal(sessionExpireTitle, autoLogoutRedirectMessage);
  });
  function closeOpenModal() {
    if (!_.isNil(modalInstance)) {
      modalInstance.close();
      modalInstance = null;
    }
  }
  function displayModal(_title, _message) {
    closeOpenModal();
    modalInstance = $uibModal.open({
      templateUrl: '/ui/modal/sessionTimeoutModal/sessionTimeoutModal.tpl.html',
      windowClass: 'sessionTimeoutModal',
      backdrop: 'static',
      controller: 'sessionTimeoutModalController',
      resolve: {
        title: function title() {
          return _title;
        },
        message: function message() {
          return _message;
        }
      }
    });
  }
  $scope.$on('IdleStart', function () {
    // Nothing
  });
  $scope.$on('IdleEnd', function () {
    closeOpenModal();
  });
  $scope.$on('Keepalive', function () {
    // Nothing
  });
  $scope.$on(coreConstant.event.START_IDLE, function () {
    closeOpenModal();
    Idle.watch();
    Idle.setIdle(parseInt(preferenceModel.get('system.autoLogoutMinutes')) * 60);
    Idle.setTimeout(parseInt(preferenceModel.get('system.autoLogoutWarningMinutes')) * 60);
  });
  $scope.$on(coreConstant.event.STOP_IDLE, function () {
    Idle.unwatch();
  });
};
SessionTimeoutController.$inject = ["$rootScope", "$scope", "$filter", "$uibModal", "$element", "preferenceModel", "localization", "Idle", "coreMediator", "coreConstant", "appTypeConfigurationModel"];
angular.module('umCore').controller('sessionTimeoutController', SessionTimeoutController).config(["TitleProvider", function (TitleProvider) {
  TitleProvider.enabled(false); // Disable the idle message in the HTML page title
}]);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UIWatcherManagerDirective = function UIWatcherManagerDirective($timeout, watchManagerUtil) {
  var linkFunction = function linkFunction($scope, $elm) {
    var reEnableWatchers = [];
    function configure() {
      $scope.$watch('uiWatchIsVisible', function (isVisible) {
        if (isVisible === 'true') {
          _.each(reEnableWatchers, function (reEnableWatcher) {
            reEnableWatcher();
          });
          reEnableWatchers = [];
        } else {
          $timeout(function () {
            clearChildScopes(angular.element($elm).scope(), false);
          }, 0);
        }
      });
      function clearChildScopes(scope, clearScope) {
        var child = scope.$$childHead;
        if (clearScope) {
          reEnableWatchers.push(watchManagerUtil.clearWatcherList(scope));
        }
        while (child) {
          clearChildScopes(child, true);
          child = child.$$nextSibling;
        }
      }
      $scope.$on('$destroy', function () {
        watchManagerUtil.reset();
      });
    }
    configure();
  };
  return {
    restrict: 'A',
    link: linkFunction,
    scope: {
      uiWatchIsVisible: '@'
    }
  };
};
UIWatcherManagerDirective.$inject = ["$timeout", "watchManagerUtil"];
angular.module('umCore').directive('uiWatcherManager', UIWatcherManagerDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

window.getWatchersCount = function () {
  var rootElm = angular.element(document.getElementsByTagName('body')),
    watchers = [];
  var _f = function f(element) {
    angular.forEach(['$scope', '$isolateScope'], function (scopeProperty) {
      if (element.data() && element.data().hasOwnProperty(scopeProperty)) {
        angular.forEach(element.data()[scopeProperty].$$watchers, function (watcher) {
          watchers.push(watcher);
        });
      }
    });
    angular.forEach(element.children(), function (childElement) {
      _f(angular.element(childElement));
    });
  };
  _f(rootElm);

  // Remove duplicate watchers
  var watchersWithoutDuplicates = [];
  angular.forEach(watchers, function (item) {
    if (watchersWithoutDuplicates.indexOf(item) < 0) {
      watchersWithoutDuplicates.push(item);
    }
  });
  return watchersWithoutDuplicates.length;
};

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var AttachmentUtil = function AttachmentUtil($rootScope, coreMediator, coreConstant, preferenceModel, uuidUtil, dataSetUtil) {
  this.getAttachmentLinkURL = function (attachmentId, attachmentName) {
    return coreMediator.getSingleUseToken().then(function (token) {
      attachmentName = null; // to avoid issues like UMS-26493, not to include attachment name for now but leave the param for future use
      var attachmentNamePath = attachmentName ? '/' + encodeURIComponent(attachmentName) : '';
      var attachmentNameParameter = attachmentName ? encodeURIComponent(' filename="' + attachmentName + '"') : '';
      var t = encodeURIComponent(token);
      return "/attachments".concat(attachmentNamePath, "?id=").concat(attachmentId, "&t=").concat(t, "&contentDisposition=inline;").concat(attachmentNameParameter);
    });
  };
  this.getAttachmentTypes = function () {
    return dataSetUtil.getDataItems({
      name: 'Attachment Types'
    });
  };
  this.validateAttachment = function (uploadedFile, i18n) {
    var acceptedTypes = preferenceModel.get('system.allowedFileTypes').split('::'),
      allowFile = this.validateAttachmentType(uploadedFile, i18n, acceptedTypes, null);
    if (allowFile) {
      var maxUploadFileSize = parseInt(preferenceModel.get('system.maxUpload'));
      if (uploadedFile.size / 1024 / 1024 > maxUploadFileSize) {
        var notificationMessage = _.get(i18n, 'maxFileSizeMessage');
        notificationMessage = _.replace(notificationMessage, '{maxSize}', maxUploadFileSize);
        $rootScope.$broadcast(coreConstant.event.SHOW_MODAL_NOTIFICATION, {
          title: _.get(i18n, 'maxFileSizeTitle'),
          summary: notificationMessage
        });
        allowFile = false;
      }
    }
    return allowFile;
  };
  this.validateAttachmentForUMStudio = function (uploadedFile, i18n) {
    var acceptedTypes = preferenceModel.get('system.allowedFileTypes').split('::');
    return this.validateAttachmentType(uploadedFile, i18n, acceptedTypes);
  };
  this.validateAttachmentType = function (uploadedFile, i18n, acceptedTypes, globalAcceptedTypes) {
    var allowFile = false;
    if (_.isEmpty(acceptedTypes)) {
      allowFile = true;
      if (!_.isEmpty(globalAcceptedTypes)) {
        allowFile = false;
        _.each(globalAcceptedTypes, function (type) {
          type = _.trim(type);
          type = _.replace(type, '*.', '');
          type = _.replace(type, '.', '');
          if (_.endsWith(_.toLower(uploadedFile.name), ".".concat(type))) {
            allowFile = true;
            return false;
          }
        });
      }
    } else {
      _.each(acceptedTypes, function (type) {
        type = _.trim(type);
        type = _.replace(type, '*.', '');
        type = _.replace(type, '.', '');
        if (!_.isEmpty(globalAcceptedTypes)) {
          _.each(globalAcceptedTypes, function (globalType) {
            globalType = _.trim(globalType);
            globalType = _.replace(globalType, '*.', '');
            globalType = _.replace(globalType, '.', '');
            if (type === globalType) {
              if (_.endsWith(_.toLower(uploadedFile.name), ".".concat(type))) {
                allowFile = true;
                return false;
              }
            }
          });
        } else {
          if (_.endsWith(_.toLower(uploadedFile.name), ".".concat(type))) {
            allowFile = true;
            return false;
          }
        }
      });
    }
    if (!allowFile) {
      var notificationMessage = _.get(i18n, 'unacceptableTypeMessage');
      notificationMessage = _.replace(notificationMessage, '{name}', uploadedFile.name);
      $rootScope.$broadcast(coreConstant.event.SHOW_MODAL_NOTIFICATION, {
        title: _.get(i18n, 'unacceptableTypeTitle'),
        summary: notificationMessage,
        confirmActionButtonLabel: _.get(i18n, 'unacceptableTypeConfirmActionButtonLabel')
      });
    }
    return allowFile;
  };
  this.getAttachmentPayload = function (attachment) {
    return {
      'type': attachment.type ? attachment.type : '',
      'description': attachment.description ? attachment.description : '',
      'shared': attachment.shared,
      'fileExpectedSize': attachment.size,
      'guid': attachment.guid ? attachment.guid : uuidUtil.generateUUID(),
      'kind': 0,
      'name': attachment.name,
      'nonDeletable': false
    };
  };
  this.isNewAttachmentObject = function (attachment) {
    return _.has(attachment, 'file') && _.has(attachment, 'attachment');
  };
  this.convertAttachmentSize = function (size) {
    var displaySize;
    if (size / (1024 * 1024) > 1) {
      displaySize = (size / (1024 * 1024)).toFixed(0) + 'MB';
    } else {
      displaySize = (size / 1024).toFixed(0) + 'KB';
    }
    return displaySize;
  };
};
AttachmentUtil.$inject = ["$rootScope", "coreMediator", "coreConstant", "preferenceModel", "uuidUtil", "dataSetUtil"];
angular.module('umCore').service('attachmentUtil', AttachmentUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var BrowserUtil = function BrowserUtil(xmlUtil) {
  this.getBrowserInfo = function () {
    var ua = navigator.userAgent,
      tem,
      M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return 'IE, Ver: ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem !== null) {
        return tem.slice(1).join(' ').replace('OPR', 'Opera');
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
      M.splice(1, 1, tem[1]);
    }
    return M[0] + ', Ver: ' + M[1];
  };
  this.isChrome = function () {
    return _.includes(_.toLower(this.getBrowserInfo()), 'chrome');
  };
  this.isEdge = function () {
    return _.includes(_.toLower(this.getBrowserInfo()), 'edge');
  };
  this.isFirefox = function () {
    return _.includes(_.toLower(this.getBrowserInfo()), 'firefox');
  };
  this.isIE11 = function () {
    return !window.ActiveXObject && 'ActiveXObject' in window;
  };
  this.getOSName = function () {
    var OSName = 'Unknown',
      userAgent = navigator.userAgent;
    if (userAgent.indexOf('Windows NT 10.0') !== -1) {
      OSName = 'Windows 10';
    }
    if (userAgent.indexOf('Windows NT 6.2') !== -1) {
      OSName = 'Windows 8';
    }
    if (userAgent.indexOf('Windows NT 6.1') !== -1) {
      OSName = 'Windows 7';
    }
    if (userAgent.indexOf('Windows NT 6.0') !== -1) {
      OSName = 'Windows Vista';
    }
    if (userAgent.indexOf('Windows NT 5.1') !== -1) {
      OSName = 'Windows XP';
    }
    if (userAgent.indexOf('Windows NT 5.0') !== -1) {
      OSName = 'Windows 2000';
    }
    if (userAgent.indexOf('Mac') !== -1) {
      OSName = 'Mac/iOS';
    }
    if (userAgent.indexOf('X11') !== -1) {
      OSName = 'UNIX';
    }
    if (userAgent.indexOf('Linux') !== -1) {
      OSName = 'Linux';
    }
    return OSName;
  };
};
BrowserUtil.$inject = ["xmlUtil"];
angular.module('umCore').service('browserUtil', BrowserUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var BigInteger = __webpack_require__(1338).BigInteger;

/*@ngInject*/
var CryptoUtil = function CryptoUtil($q, getServerPublicKeySpecRepository) {
  var publicKey,
    isLoading = false,
    defer = null;
  this.initServerPublicKey = function () {
    function handleSuccess(publicKeySpec) {
      isLoading = false;
      var initSecureRandom = new SecureRandom();
      publicKey = new RSAKey();
      publicKey.setPublic(publicKeySpec.modulusHexString, publicKeySpec.publicExponentHexString);
      if (defer) {
        defer.resolve();
      }
      defer = null;
    }
    function handleError(error) {
      isLoading = false;
      return defer.reject(error);
    }
    if (_.isNull(defer)) {
      defer = $q.defer();
    }
    if (isLoading) {
      return defer.promise;
    } else if (publicKey) {
      defer.resolve();
    } else {
      isLoading = true;
      getServerPublicKeySpecRepository.getServerPublicKeySpec().then(handleSuccess, handleError);
    }
    return defer.promise;
  };
  this.encryptWithServerPublicKey = function (value) {
    //Fixes issue with the added prototype method not being added in the RSA code in FireFox
    var initSecureRandom = new SecureRandom();
    var result = publicKey.encrypt(value);
    return hex2b64(result);
  };
};
CryptoUtil.$inject = ["$q", "getServerPublicKeySpecRepository"];
angular.module('umCore').service('cryptoUtil', CryptoUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1338 */,
/* 1339 */
/***/ (function(module, exports) {

/*@ngInject*/
var CurrencyUtil = function CurrencyUtil(coreMediator, iso4217, preferenceModel) {
  this.getCurrencyFormat = function (currencyCode, displayDollar) {
    var symbol, suffixSymbol, decimalSeparator, groupSeparator, currency;
    currencyCode = currencyCode || 'USD';
    if (preferenceModel.get('view.currencySeparator') === 'false') {
      decimalSeparator = '.';
      groupSeparator = ',';
    } else {
      decimalSeparator = ',';
      groupSeparator = '.';
    }
    currency = iso4217.getCurrencyByCode(currencyCode);
    if (displayDollar) {
      currency = iso4217.getCurrencyByCode('USD');
      symbol = currency.symbol; // get symbol from iso lib
      suffixSymbol = false;
    } else if (preferenceModel.get('view.currencyDisplayFormat') === 'false' && displayDollar !== false) {
      symbol = currency.symbol; // get symbol from iso lib
      suffixSymbol = false;
    } else if (displayDollar !== false) {
      symbol = ' ' + currencyCode;
      suffixSymbol = true;
    } else {
      symbol = '';
      suffixSymbol = false;
    }
    return {
      symbol: symbol,
      suffixSymbol: suffixSymbol,
      customFormat: {
        'DECIMAL_SEP': decimalSeparator,
        'GROUP_SEP': groupSeparator
      }
    };
  };
};
CurrencyUtil.$inject = ["coreMediator", "iso4217", "preferenceModel"];
angular.module('umCore').service('currencyUtil', CurrencyUtil);

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var DataSetUtil = function DataSetUtil(coreMediator, dataSetType) {
  this.getDataSetParamsByName = function (dataSetName, variableName, submissionUri, ownerUri, formRowUri) {
    return {
      name: dataSetName,
      submissionUri: submissionUri,
      ownerUri: ownerUri,
      formRowUri: formRowUri,
      variableName: variableName
    };
  };
  this.getDataSetParams = function (dataSet, variableName, submissionUri, ownerUri, formRowUri, searchString) {
    return {
      name: dataSet.name,
      submissionUri: submissionUri,
      ownerUri: ownerUri,
      formRowUri: formRowUri,
      variableName: dataSet.includeVariableNameInDynamicDataSetBinding ? variableName : null,
      search: searchString
    };
  };
  this.getDataSetParamsByFieldStructure = function (dataSet, fieldStructure, searchString) {
    var submissionId = fieldStructure.parentForm.submissionId;
    var submissionUri = !_.isNil(submissionId) ? "com.firstbest.underwriting.submission.Submission:".concat(submissionId) : null;
    var ownerUri = _.replace(fieldStructure.parentForm.uri, 'FormSummary', 'Form');
    var formRowUri = this.getFormRowUri(dataSet, fieldStructure);
    var variableName = fieldStructure.uiField.fieldTemplate.variableName;
    return {
      name: dataSet.name,
      submissionUri: submissionUri,
      ownerUri: ownerUri,
      formRowUri: formRowUri,
      variableName: dataSet.includeVariableNameInDynamicDataSetBinding ? variableName : null,
      search: searchString
    };
  };
  this.getFormRowUri = function (dataSet, fieldStructure) {
    var result = null,
      sourceFieldDependencies,
      sourceFieldExists,
      isFieldDependant = dataSet.type === dataSetType.PRODUCT_FIELD_DEPENDENT || dataSet.type === dataSetType.CUSTOM,
      isRowRepeater = _.isPlainObject(fieldStructure.rowRepeaterTemplate) && _.isPlainObject(fieldStructure.rowRepeaterModel);
    if (isRowRepeater) {
      if (isFieldDependant) {
        if (!_.isNil(dataSet.dynamicDataSetDependency)) {
          sourceFieldDependencies = dataSet.dynamicDataSetDependency.sourceFieldDependencies;
          sourceFieldExists = sourceFieldDependencies.length > 0;
          if (sourceFieldExists) {
            var anyMatch = false;
            _.each(fieldStructure.rowRepeaterTemplate.fields, function (templateObject) {
              _.each(sourceFieldDependencies, function (sourceObject) {
                if (templateObject.fieldTemplate.variableName === sourceObject.fieldName) {
                  anyMatch = true;
                }
              });
            });
            if (anyMatch) {
              result = _.replace(fieldStructure.rowRepeaterModel.uri, 'FormRowSummary', 'FormRow');
            }
          }
        }
      }
    }
    return result;
  };
  this.getDataSet = function (dataSetParams, formId) {
    var type = this.getDataSetType(dataSetParams.name);
    if (type === dataSetType.CUSTOM || type === dataSetType.PRODUCT_FIELD_DEPENDENT) {
      return coreMediator.getDynamicDataSet(dataSetParams, formId);
    } else if (type === dataSetType.REPEATING_FORM) {
      return coreMediator.getRepeatingFormDynamicDataSetFormSetId(formId, dataSetParams.name).then(function (formSetId) {
        dataSetParams.ownerUri = 'com.firstbest.underwriting.form.FormSet:' + formSetId;
        return coreMediator.getDynamicDataSet(dataSetParams, formId);
      });
    } else {
      return coreMediator.getCachedDataSetByName(dataSetParams.name).then(function (dataSet) {
        return dataSet;
      });
    }
  };
  this.getDataItems = function (dataSetParams, formId) {
    return this.getDataSet(dataSetParams, formId).then(function (dataSet) {
      return dataSet.items;
    });
  };
  this.getDataSetType = function (dataSetName) {
    var type = dataSetType.STATIC,
      dataSetNameToTypeMap = coreMediator.getDataSetNameToTypeMap();
    if (!_.isNil(dataSetNameToTypeMap[dataSetName])) {
      type = dataSetNameToTypeMap[dataSetName];
    }
    return type;
  };
  this.getDataItemValue = function (dataItem) {
    var doesDataItemExist = !_.isNil(dataItem),
      doesDataItemValueExist = doesDataItemExist && !_.isNil(dataItem.value);
    return doesDataItemValueExist ? dataItem.value : null;
  };
};
DataSetUtil.$inject = ["coreMediator", "dataSetType"];
angular.module('umCore').service('dataSetUtil', DataSetUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(moment, _) {/*@ngInject*/
var DateUtil = function DateUtil() {
  this.formatDate = function (millis, format) {
    if (!format) {
      format = 'MM/DD/YYYY';
    }
    var value = moment(millis);
    return value.format(format);
  };
  this.formatTime = function (millis, format) {
    if (!format) {
      format = 'h:mm a';
    }
    return this.formatDate(millis, format);
  };
  this.formatShortDate = function (date, utc) {
    var isValid = moment(date).isValid(),
      result = date;
    if (isValid) {
      var momentObject = moment(date);
      if (utc) {
        momentObject = momentObject.utc();
      }
      result = momentObject.format('MM/DD/YY');
    }
    return result;
  };
  this.formatShortDateAndTime = function (date, utc) {
    var isValid = moment(date).isValid(),
      result = date;
    if (isValid) {
      var momentObject = moment(date);
      if (utc) {
        momentObject = momentObject.utc();
      }
      result = momentObject.format('MM/DD/YY HH:mm A');
    }
    return result;
  };
  this.formatShortDateAndTimeLongYearAmPm = function (date, utc) {
    var isValid = moment(new Date(date)).isValid(),
      result = date;
    if (isValid) {
      var momentObject = moment(new Date(date));
      if (utc) {
        momentObject = momentObject.utc();
      }
      result = momentObject.format('MM/DD/YYYY hh:mm A');
    }
    return result;
  };
  this.formatShortDateWithLongYear = function (date, utc) {
    var isValid = moment(date).isValid(),
      result = date;
    if (isValid) {
      var momentObject = moment(date);
      if (utc) {
        momentObject = momentObject.utc();
      }
      result = momentObject.format('MM/DD/YYYY');
    }
    return result;
  };
  this.formatMediumDate = function (date, utc) {
    var isValid = moment(date).isValid(),
      result = date;
    if (isValid) {
      var momentObject = moment(date);
      if (utc) {
        momentObject = momentObject.utc();
      }
      result = momentObject.format('MMM. DD, YYYY');
    }
    return result;
  };
  this.formatServerDate = function (date) {
    var isValid = moment(date).isValid(),
      result = date;
    if (isValid) {
      result = moment(date).unix();
    }
    return result;
  };
  this.formatUtcDateRangeString = function (startDate, endDate) {
    return this.formatDateRangeString(startDate, endDate, true);
  };
  this.formatLocalDateRangeString = function (startDate, endDate) {
    return this.formatDateRangeString(startDate, endDate, false);
  };
  this.formatDateRangeString = function (startDate, endDate, utc) {
    var momentStartDate = utc ? moment.utc(startDate) : moment(startDate),
      momentEndDate = utc ? moment.utc(endDate) : moment(endDate),
      isValidStartDate = momentStartDate.isValid(),
      isValidEndDate = momentEndDate.isValid(),
      startDateString = isValidStartDate ? momentStartDate.format('MM/DD/YYYYZZ') : ' ',
      endDateSting = isValidEndDate ? momentEndDate.format('MM/DD/YYYYZZ') : ' ';
    return "SPECIFIED::".concat(startDateString, "::").concat(endDateSting);
  };
  this.parseDateRangeStartDateToMilliseconds = function (dateRangeString) {
    var dateParts = _.split(dateRangeString, '::'),
      startDate = moment(dateParts[1], 'MM/DD/YYYYZZ'),
      isValidStartDate = startDate.isValid();
    return isValidStartDate ? startDate.valueOf() : null;
  };
  this.parseDateRangeEndDateToMilliseconds = function (dateRangeString) {
    var dateParts = _.split(dateRangeString, '::'),
      endDate = moment(dateParts[2], 'MM/DD/YYYYZZ'),
      isValidEndDate = endDate.isValid();
    return isValidEndDate ? endDate.valueOf() : null;
  };
  this.isBefore = function (date, comparisonDate) {
    return moment(date).isBefore(comparisonDate);
  };
  this.isAfter = function (date, comparisonDate) {
    return moment(date).isAfter(comparisonDate);
  };
  this.isSame = function (date, comparisonDate) {
    return moment(date).isSame(comparisonDate, 'day');
  };
  this.getSeconds = function (date) {
    var now = moment(new Date()).unix(),
      pastDate = moment(date).unix();
    return now - pastDate;
  };
  this.generateRandomDate = function (start, end) {
    return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
  };
  this.add = function (date, additionTotal) {
    moment(date).add(additionTotal, 'days').toDate();
  };
  this.subtract = function (date, subtractionTotal) {
    return moment(date).subtract(subtractionTotal, 'days').toDate();
  };
  this.isValidDate = function (date) {
    return moment(new Date(date)).isValid();
  };
  this.getFirstDayOfLastMonth = function (date) {
    return moment(new Date()).subtract(1, 'months').startOf('month').toDate();
  };
  this.getLastDayOfLastMonth = function (date) {
    return moment(new Date()).subtract(1, 'months').endOf('month').toDate();
  };
};
angular.module('umCore').service('dateUtil', DateUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2), __webpack_require__(0)))

/***/ }),
/* 1342 */
/***/ (function(module, exports) {

/*@ngInject*/
var FileExportUtil = function FileExportUtil(FileSaver, Blob) {
  this.saveAs = function (content, type, filename) {
    var file = new Blob([content], {
      type: type
    });
    FileSaver.saveAs(file, filename);
  };
};
FileExportUtil.$inject = ["FileSaver", "Blob"];
angular.module('umCore').service('fileExportUtil', FileExportUtil);

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FormatUtil = function FormatUtil() {
  this.formatAsSelector = function (name) {
    function makeCamelCase(str) {
      return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
        return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
      }).replace(/\s+/g, '');
    }
    if (_.isNil(name)) {
      return '';
    }
    name = name.replace(/`/g, ' ');
    name = name.replace(/~/g, ' ');
    name = name.replace(/!/g, ' ');
    name = name.replace(/@/g, ' ');
    name = name.replace(/#/g, ' ');
    name = name.replace(/\$/g, ' ');
    name = name.replace(/%/g, ' ');
    name = name.replace(/\^/g, ' ');
    name = name.replace(/&/g, ' ');
    name = name.replace(/\*/g, ' ');
    name = name.replace(/\(/g, ' ');
    name = name.replace(/\)/g, ' ');
    name = name.replace(/-/g, ' ');
    name = name.replace(/_/g, ' ');
    name = name.replace(/=/g, ' ');
    name = name.replace(/\+/g, ' ');
    name = name.replace(/\[/g, ' ');
    name = name.replace(/{/g, ' ');
    name = name.replace(/]/g, ' ');
    name = name.replace(/}/g, ' ');
    name = name.replace(/\\/g, ' ');
    name = name.replace(/\|/g, ' ');
    name = name.replace(/;/g, ' ');
    name = name.replace(/:/g, ' ');
    name = name.replace(/'/g, '');
    name = name.replace(/"/g, ' ');
    name = name.replace(/,/g, ' ');
    name = name.replace(/</g, ' ');
    name = name.replace(/\./g, ' ');
    name = name.replace(/>/g, ' ');
    name = name.replace(/\//g, '--');
    name = name.replace(/\?/g, ' ');
    return makeCamelCase(name);
  };
};
angular.module('umCore').service('formatUtil', FormatUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FunctionActionUtil = function FunctionActionUtil($window, $stateParams, customButtonFunctionType, modalUtil, coreMediator, loadingBarHandler, remoteFunction) {
  this.handleAction = function (action, submission, identifierName, identifier, contextParameters) {
    if (action.functionType === customButtonFunctionType.URL) {
      handleUrlAction(action, submission, identifierName, identifier, contextParameters);
    } else if (action.functionType === customButtonFunctionType.REMOTE_FUNCTION) {
      handleRemoteFunctionAction(action, submission, identifierName, identifier, contextParameters);
    }
  };
  this.getParameterAsObject = function (parameters) {
    var parameterArray,
      index,
      name,
      value,
      parameterObject = {};
    parameterArray = _.split(parameters, '::');
    _.forEach(parameterArray, function (parameter) {
      index = _.indexOf(parameter, '=');
      name = parameter.substring(0, index);
      value = parameter.substring(index + 1);
      parameterObject[name] = value;
    });
    return parameterObject;
  };
  this.constructUrl = function (parameters, submissionId, userProfile) {
    var url = parameters.url;
    if (url.includes('?')) {
      url += '&';
    } else {
      url += '?';
    }
    url += 'submissionId=' + submissionId;
    if ($stateParams.formId) {
      url += "&formId=".concat(!_.isNil($stateParams.formSummaryInstanceId) ? $stateParams.formSummaryInstanceId : $stateParams.formId);
    }
    _.forOwn(parameters, function (parameterValue, parameterName) {
      if (parameterName !== 'url') {
        url += '&' + parameterName + '=' + encodeURIComponent(parameterValue);
      }
    });
    return coreMediator.getSingleUseToken().then(function (token) {
      return url += '&t=' + encodeURIComponent(token);
    });
  };
  var handleUrlAction = function (action, submission, identifierName, identifier, contextParameters) {
    var translations, parameters;
    var openUrl = function () {
      parameters = this.getParameterAsObject(action.parameters);
      if (_.has(parameters, 'url') && !_.isNull(submission)) {
        function getFormattedPolicyNumbers(policyNumber) {
          var policyNumbers = '',
            policyNumberArray = _.split(policyNumber, ',');
          _.each(policyNumberArray, function (value, index) {
            if (index > 0) {
              policyNumbers += ',';
            }
            policyNumbers += _.trim(value);
          });
          return policyNumbers;
        }
        var policyNumbers = '';
        if (!_.isNil(submission.policyNumber)) {
          policyNumbers = getFormattedPolicyNumbers(submission.policyNumber);
          policyNumbers += !_.isNil(submission.expiringPolicyNumber) ? ',' + getFormattedPolicyNumbers(submission.expiringPolicyNumber) : '';
        } else if (!_.isNil(submission.expiringPolicyNumber)) {
          policyNumbers = getFormattedPolicyNumbers(submission.expiringPolicyNumber);
        }
        parameters['url'] = _.replace(parameters['url'], '{0}', policyNumbers);
      }
      if (!_.isNil(identifierName)) {
        parameters[identifierName] = identifier;
      }
      coreMediator.loadUserProfile().then(function (userProfile) {
        this.constructUrl(parameters, submission.id, userProfile).then(function (url) {
          if (!_.isNil(contextParameters)) {
            url += '&' + _.replace(contextParameters, /::/g, '&');
          }
          $window.open(url);
        });
      }.bind(this));
    }.bind(this);
    if (action.confirmationMessage) {
      translations = {
        cancelButtonLabel: action.noButtonLabel,
        confirmActionButtonLabel: action.yesButtonLabel,
        summary: action.confirmationMessage,
        title: action.confirmationTitle
      };
      modalUtil.showGenericConfirm(translations).then(openUrl);
    } else {
      openUrl();
    }
  }.bind(this);
  var handleRemoteFunctionAction = function (action, submission, identifierName, identifier, contextParameters) {
    var translations;
    var executeRemoteFunction = function (contextParameters) {
      var parameters = this.getParameterAsObject(action.parameters);
      if (!_.isNil(identifierName)) {
        parameters[identifierName] = identifier;
      }
      if (!_.isNil(contextParameters)) {
        var contextParametersArray, contextParametersNameValuePair;
        if (contextParameters.includes('::')) {
          contextParametersArray = contextParameters.split('::');
          for (var i = 0; i < contextParametersArray.length; i++) {
            contextParametersNameValuePair = contextParametersArray[i].split('=');
            parameters[contextParametersNameValuePair[0]] = contextParametersNameValuePair[1];
          }
        } else {
          contextParametersNameValuePair = contextParameters.split('=');
          parameters[contextParametersNameValuePair[0]] = contextParametersNameValuePair[1];
        }
      }
      if (action.processingIndicatorText) {
        loadingBarHandler.showLoadingBar(action.processingIndicatorText);
      }

      // Passing -1 for the formId will cause the REST url to be /rest/Form/-1/execute, which just
      // indicates that the remote function is not associated with a specific form. This will not fail.
      remoteFunction.executeFunction(-1, null, null, parameters, submission.id).then(function (executorResult) {
        if (executorResult.url) {
          parameters.url = executorResult.url;
        }
        if (parameters.url) {
          coreMediator.loadUserProfile().then(function (userProfile) {
            this.constructUrl(parameters, submission.id, userProfile).then(function (url) {
              $window.open(url);
            });
          }.bind(this));
        }
        loadingBarHandler.hideLoadingBar();
      }.bind(this));
    }.bind(this);
    if (action.confirmationMessage) {
      translations = {
        cancelButtonLabel: action.noButtonLabel,
        confirmActionButtonLabel: action.yesButtonLabel,
        summary: action.confirmationMessage,
        title: action.confirmationTitle
      };
      modalUtil.showGenericConfirm(translations).then(executeRemoteFunction);
    } else {
      executeRemoteFunction(contextParameters);
    }
  }.bind(this);
};
FunctionActionUtil.$inject = ["$window", "$stateParams", "customButtonFunctionType", "modalUtil", "coreMediator", "loadingBarHandler", "remoteFunction"];
angular.module('umCore').service('functionActionUtil', FunctionActionUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var SortUtil = function SortUtil() {
  function getItemValue(item, sortColumn) {
    var itemValue = _.isArray(sortColumn) && !_.isNull(item[sortColumn[0]]) ? item[sortColumn[0]][sortColumn[1]] : item[sortColumn];
    return _.isString(itemValue) ? _.lowerCase(itemValue) : itemValue;
  }
  this.naturalSortObject = function (sortColumn) {
    return function (itemA, itemB) {
      var arrayA = [],
        arrayB = [],
        itemAValue = getItemValue(itemA, sortColumn),
        itemBValue = getItemValue(itemB, sortColumn),
        shiftedArrayA,
        shiftedArrayB,
        comparedArrays;
      _.replace(itemAValue, /(\d+)|(\D+)/g, function (_, $1, $2) {
        arrayA.push([$1 || Infinity, $2 || '']);
      });
      _.replace(itemBValue, /(\d+)|(\D+)/g, function (_, $1, $2) {
        arrayB.push([$1 || Infinity, $2 || '']);
      });
      while (arrayA.length && arrayB.length) {
        shiftedArrayA = arrayA.shift();
        shiftedArrayB = arrayB.shift();
        comparedArrays = shiftedArrayA[0] - shiftedArrayB[0] || shiftedArrayA[1].localeCompare(shiftedArrayB[1]);
        if (comparedArrays) {
          return comparedArrays;
        }
      }
      return arrayA.length - arrayB.length;
    };
  };
};
angular.module('umCore').service('sortUtil', SortUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

/*@ngInject*/
var UuidUtil = function UuidUtil() {
  this.generateUUID = function () {
    var d = new Date().getTime();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
  };
};
angular.module('umCore').service('uuidUtil', UuidUtil);

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var XMLUtil = function XMLUtil() {
  function convertBooleanValue(value) {
    if (value === 'false') {
      value = false;
    } else if (value === 'true') {
      value = true;
    }
    return value;
  }
  function flatten(object) {
    var check = _.isPlainObject(object) && _.size(object) === 1,
      obj = check ? _.values(object)[0] : object;
    if (_.isPlainObject(obj)) {
      return _.mapValues(obj, function (v) {
        return flatten(v);
      });
    }
    obj = convertBooleanValue(obj);
    return obj;
  }
  this.parseString = function (xmlString) {
    var obj = {};
    if (_.isEmpty(xmlString)) {
      return obj;
    }
    obj = new X2JS({
      attributePrefix: ''
    }).xml_str2json(xmlString);
    return flatten(obj);
  };
  this.parseStringWithoutFlattening = function (xmlString) {
    var obj = {};
    if (_.isEmpty(xmlString)) {
      return obj;
    }
    obj = new X2JS({
      attributePrefix: ''
    }).xml_str2json(xmlString);
    return obj;
  };
  this.toXmlString = function (obj) {
    var str = '';
    if (!_.isNil(obj)) {
      str = new X2JS().json2xml_str(JSON.parse(angular.toJson(obj)));
    }
    return str;
  };
};
angular.module('umCore').service('xmlUtil', XMLUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ConfiguredFileUtil = function ConfiguredFileUtil(coreMediator) {
  this.getConfiguredFileLinkURL = function (configuredFileId, configuredFileName) {
    configuredFileName = _.replace(configuredFileName, /[#/@'"]/gi, '');
    return coreMediator.getSingleUseToken().then(function (token) {
      var encodedConfiguredFileName = configuredFileName ? encodeURIComponent(configuredFileName) : null;
      var configuredFileNamePath = encodedConfiguredFileName ? '/' + encodedConfiguredFileName : '';
      var configuredFileNameParameter = encodedConfiguredFileName ? ' filename="' + encodedConfiguredFileName + '"' : '';
      var t = encodeURIComponent(token);
      return "/configuredFiles".concat(configuredFileNamePath, "?id=").concat(configuredFileId, "&t=").concat(t, "&contentDisposition=inline;").concat(configuredFileNameParameter);
    });
  };
};
ConfiguredFileUtil.$inject = ["coreMediator"];
angular.module('umCore').service('configuredFileUtil', ConfiguredFileUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FormSummaryGridUtil = function FormSummaryGridUtil(xmlUtil) {
  this.processFormSummaryGridItems = function (formSummaryGridItems) {
    return _.map(formSummaryGridItems, function (formSummaryGridItem) {
      if (formSummaryGridItem.hasOwnProperty('name')) {
        formSummaryGridItem.name = JSON.parse(formSummaryGridItem.name);
        _.map(formSummaryGridItem.name, function (formProperty) {
          if (formProperty.validatorProperty) {
            formProperty.validatorProperty = xmlUtil.parseString(formProperty.validatorProperty);
          }
          return formProperty;
        });
        return formSummaryGridItem;
      }
    });
  };
};
FormSummaryGridUtil.$inject = ["xmlUtil"];
angular.module('umCore').service('formSummaryGridUtil', FormSummaryGridUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1351);
__webpack_require__(1352);
__webpack_require__(1353);
__webpack_require__(1354);
var KeepAliveComponent = {
  templateUrl: '/keepAlive/keepAlive.tpl.html',
  controller: 'keepAliveController',
  bindings: {}
};
angular.module('umCore').component('keepAlive', KeepAliveComponent);

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

var path = '/keepAlive/keepAlive.tpl.html';
var html = "<div></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var KeepAliveController = function KeepAliveController($scope, $element, $interval, browserUtil, coreConstant, coreMediator, preferenceModel, keepAliveMediator, umsLog) {
  $element.addClass('keepAlive');
  var pingInterval,
    intervalObject = null,
    isEdge = browserUtil.isEdge();
  function init() {
    coreMediator.loadDefaultPreferences().then(function () {
      var keepAliveIntervalInMillisecondsPreference;
      if (isEdge) {
        pingInterval = coreConstant.EDGE_KEEP_ALIVE_PING_INTERVAL;
        keepAliveIntervalInMillisecondsPreference = preferenceModel.get('system.edgeKeepAliveIntervalInMilliseconds');
      } else {
        pingInterval = coreConstant.DEFAULT_KEEP_ALIVE_PING_INTERVAL;
        keepAliveIntervalInMillisecondsPreference = preferenceModel.get('system.keepAliveIntervalInMilliseconds');
      }
      if (!isNaN(keepAliveIntervalInMillisecondsPreference)) {
        pingInterval = _.parseInt(keepAliveIntervalInMillisecondsPreference);
      }
    });
  }
  ;
  function start() {
    if (_.isNil(intervalObject)) {
      intervalObject = $interval(function () {
        keepAliveMediator.keepAliveDisconnectOnError();
      }, pingInterval);
    }
  }
  function stop() {
    if (!_.isNil(intervalObject)) {
      $interval.cancel(intervalObject);
      intervalObject = null;
    }
  }
  $scope.$on(coreConstant.event.KEEPALIVE_PING, function () {
    start();
  });
  $scope.$on(coreConstant.event.STOP_KEEPALIVE_PING, function () {
    stop();
  });
  $scope.$on('$destroy', function () {
    stop();
  });
  init();
};
KeepAliveController.$inject = ["$scope", "$element", "$interval", "browserUtil", "coreConstant", "coreMediator", "preferenceModel", "keepAliveMediator", "umsLog"];
angular.module('umCore').controller('keepAliveController', KeepAliveController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var KeepAliveMediator = function KeepAliveMediator(keepAliveRepository, persistentConnection, preferenceModel) {
  this.keepAlive = function () {
    return keepAliveRepository.keepAlive();
  };
  this.keepAliveDisconnectOnError = function () {
    var requestTimeout = preferenceModel.get('system.keepAliveRequestTimeout') || 15000;
    return keepAliveRepository.keepAlive(requestTimeout).then(null, function (result) {
      // On keepAlive ping error:
      // Check that 'result' is nil, indicating that the server did not respond to the request.
      if (_.isNil(result)) {
        persistentConnection.disconnectAndAlert();
      }
    });
  };
};
KeepAliveMediator.$inject = ["keepAliveRepository", "persistentConnection", "preferenceModel"];
angular.module('umCore').service('keepAliveMediator', KeepAliveMediator);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

/*@ngInject*/
var KeepAliveRepository = function KeepAliveRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.keepAlive = function (requestTimeout) {
    var url = '/rest/Session';
    var config = {
      timeout: requestTimeout
    };
    return this.get(url, config);
  };
};
KeepAliveRepository.$inject = ["baseRepository"];
angular.module('umCore').service('keepAliveRepository', KeepAliveRepository);

/***/ }),
/* 1355 */
/***/ (function(module) {

module.exports = JSON.parse("{\"actionButtonsBar\":{\"actions\":{\"name\":\"Actions\"}}}");

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

var path = '/ui/actionButtonsBar/actionButtonsBar.tpl.html';
var html = "<ul class=\"actionButtonsBarList\" ng-class=\"{ 'disabled': $ctrl.disabled }\">\n\n    <!--Actions List Button Bar-->\n    <li class=\"actionBarButton\"\n        ng-repeat=\"action in $ctrl.buttonBarActions\">\n\n        <div class=\"buttonContainer {{ ::action.identifier }}Button\"\n             uib-tooltip=\"{{ ::action.notes }}\"\n             tooltip-placement=\"auto top\">\n\n            <div class=\"buttonOverlay\"\n                 ng-if=\"!action.enabled || action.temporarilyDisabled\"></div>\n\n            <button ng-click=\"$ctrl.handleButtonClick(action)\"\n                    class=\"btn actionButtonsBorderWidth {{ ::action.identifier }}\"\n                    ng-class=\"{ 'enabled': action.enabled && !action.temporarilyDisabled, 'disabled': !action.enabled || action.temporarilyDisabled, 'btn-success': action.nextAction, 'btn-default': action.previousAction, 'btn-primary': !action.nextAction && !action.previousAction }\"\n                    ng-disabled=\"!action.enabled || action.temporarilyDisabled\">\n\n            <span ng-show=\"action.previousAction\"\n                  class=\"glyphicon glyphicon-chevron-left previousNext\"></span>\n\n                <span>{{ ::action.buttonLabel }}</span>\n\n                <span ng-show=\"action.nextAction\"\n                      class=\"glyphicon glyphicon-chevron-right previousNext\"></span>\n            </button>\n            <span ng-if=\"action.hasSubText\"\n                  class=\"{{ ::action.subTextClass }}\">{{ ::action.subText }}</span>\n        </div>\n    </li>\n\n    <!--Grouped Action List Dropdown-->\n    <li class=\"dropdown\"\n        ng-if=\"$ctrl.groupedIWantToActionsKeys && $ctrl.groupedIWantToActionsKeys.length !== 0\"\n        uib-dropdown ui-dropdown-fit-to-window>\n\n        <a class=\"btn btn-primary btn-outline\"\n           uib-dropdown-toggle>\n\n            <span ui-translate>{{::$ctrl.context.identifier + '.actions.name'}}</span>\n            <span class=\"glyphicon glyphicon-chevron-down\"></span>\n        </a>\n\n        <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu>\n\n            <li class=\"actionGroupsPanel\">\n                <ul class=\"actionGroups\"\n                    ng-repeat=\"contextKey in $ctrl.groupedIWantToActionsKeys\">\n                    <li role=\"separator\" class=\"divider\"\n                        ng-if=\"!$first && $ctrl.groupedIWantToActionsMap[contextKey.key]\"></li>\n                    <li class=\"groupHeader\"\n                        ng-if=\"$ctrl.groupedIWantToActionsMap[contextKey.key] && !$ctrl.groupedIWantToActionsMap[contextKey.key].hideGroupHeader\">\n                        <label>{{ ::contextKey.contextLabel }}</label>\n                    </li>\n\n                    <ul ng-repeat=\"group in $ctrl.groupedIWantToActionsMap[contextKey.key]\"\n                        ng-if=\"$ctrl.groupedIWantToActionsMap[contextKey.key]\">\n                        <li role=\"separator\" class=\"divider\"\n                            ng-if=\"!$first && group\"></li>\n                        <li ng-repeat=\"action in group\"\n                            ng-if=\"action\">\n                            <input ng-if=\"action.isHiddenInputAction\"\n                                   type=\"file\"\n                                   accept=\"{{ ::action.accept }}\"\n                                   class=\"hiddenUpload\"\n                                   ui-custom-on-change=\"$ctrl.handleHiddenInputAction(action, file)\"/>\n                            <a ng-if=\"action.isHiddenInputAction\"\n                               class=\"{{ ::action.identifier }}\"\n                               uib-tooltip=\"{{ action.notes }}\"\n                               tooltip-append-to-body=\"true\"\n                               tooltip-placement=\"bottom\"\n                               ng-class=\"$ctrl.getActionClass(action)\"\n                               data-toggle=\"tab\"\n                               ui-upload>\n\n                                <span ng-if=\"action.previousAction\"\n                                      class=\"glyphicon glyphicon-chevron-left previousNext\"\n                                      ui-upload\n                                      ui-upload-delegate-to-parent></span>\n\n                                <span ng-disabled=\"(action.valid && !action.enabled && action.notes) || action.temporarilyDisabled\"\n                                      ui-upload\n                                      ui-upload-delegate-to-parent>\n                                    {{ ::action.buttonLabel }}\n                                </span>\n\n                                <span ng-if=\"action.nextAction\"\n                                      class=\"glyphicon glyphicon-chevron-right previousNext\"\n                                      ui-upload\n                                      ui-upload-delegate-to-parent></span>\n                            </a>\n                            <a ng-if=\"!action.isHiddenInputAction\"\n                               class=\"{{ ::action.identifier }}\"\n                               uib-tooltip=\"{{ action.notes }}\"\n                               tooltip-append-to-body=\"true\"\n                               tooltip-placement=\"bottom\"\n                               ng-click=\"$ctrl.handleButtonClick(action, $event)\"\n                               ng-class=\"$ctrl.getActionClass(action)\"\n                               data-toggle=\"tab\">\n\n                                <span ng-show=\"action.previousAction\"\n                                      class=\"glyphicon glyphicon-chevron-left previousNext\"></span>\n\n                                <span ng-disabled=\"(action.valid && !action.enabled && action.notes) || action.temporarilyDisabled\">{{ ::action.buttonLabel }}</span>\n\n                                <span ng-show=\"action.nextAction\"\n                                      class=\"glyphicon glyphicon-chevron-right previousNext\"></span>\n                            </a>\n                        </li>\n                    </ul>\n                </ul>\n            </li>\n\n            <iframe src=\"about:blank\" class=\"ieMaskFrame\" ui-browser-detection></iframe>\n        </ul>\n    </li>\n</ul>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

var ActionButtonsBarComponent = {
  templateUrl: '/ui/actionButtonsBar/actionButtonsBar.tpl.html',
  controller: 'actionButtonsBarController',
  bindings: {
    context: '<',
    actions: '<',
    hiddenInputActions: '<?',
    actionSubTexts: '<?',
    hideDropdown: '<?',
    notifyActionClicked: '&',
    timeLastModified: '<'
  }
};
angular.module('umCore').component('actionButtonsBar', ActionButtonsBarComponent);

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ActionButtonsBarController = function ActionButtonsBarController($rootScope, $scope, $element, $timeout, localization, actionHandler, coreConstant) {
  var contextOrder = {},
    contextActionsArray = [],
    actionReloadTimeout,
    translations;
  this.$onInit = function () {
    var _this = this;
    $element.addClass('actionButtonsBar');
    $element.addClass(this.context.identifier + 'ActionButtonsBar');
    localization.getTranslations().then(function (translationsResult) {
      _this.buttonBarActions = [];
      _this.groupedIWantToActionsKeys = [];
      _this.groupedIWantToActionsMap = {};
      translations = translationsResult;
      _this.processActions();
    });
    $scope.$on(coreConstant.event.ACTION_STARTED, function (event, promise) {
      _.each(_this.actions, function (contextAction) {
        _.each(contextAction.actions, function (action) {
          action.temporarilyDisabled = true;
        });
      });
      _this.processActions();
      if (!_.isNil(promise)) {
        promise.finally(function () {
          if (!_.isNil(actionReloadTimeout)) {
            $timeout.cancel(actionReloadTimeout);
          }
          actionReloadTimeout = $timeout(function () {
            $rootScope.$broadcast(coreConstant.event.RELOAD_ACTIONS);
          }, 1000);
        });
      }
    });
    $scope.$on(coreConstant.event.UPDATE_ACTIONS_MESSAGE, function () {
      _this.resetTemporarilyDisabledActions();
    });
    $scope.$on('$destroy', function () {
      if (!_.isNil(actionReloadTimeout)) {
        $timeout.cancel(actionReloadTimeout);
      }
    });
  };
  this.resetTemporarilyDisabledActions = function () {
    if (!_.isNil(actionReloadTimeout)) {
      $timeout.cancel(actionReloadTimeout);
    }
    _.each(this.actions, function (contextAction) {
      _.each(contextAction.actions, function (action) {
        action.temporarilyDisabled = false;
      });
    });
  };
  this.getButtonLabel = function (action) {
    var label;
    if (action.labelKey) {
      label = _.get(translations, action.labelKey);
      if (_.isNil(label)) {
        label = action.labelKey;
      }
    } else {
      label = _.get(translations, this.context.identifier + '.actions.' + action.name);
      if (!label) {
        label = action.label || action.name;
      }
    }
    return label;
  };
  this.getContextLabel = function (context) {
    var splitContext = _.split(context, '.');
    return _.get(translations, this.context.identifier + '.actions.context.' + splitContext[1]) ? _.get(translations, this.context.identifier + '.actions.context.' + splitContext[1]) : context;
  };
  this.processActions = function () {
    var _this2 = this;
    var iWantToActionsMap, combinedActions, tempGroupedIWantToActionsKeys;
    _.each(this.actions, function (contextAction) {
      _.each(contextAction.actions, function (action) {
        var hiddenInputAction, subText;
        if (!_.isNil(_this2.hiddenInputActions)) {
          hiddenInputAction = _this2.hiddenInputActions[action.name];
          if (!_.isNil(hiddenInputAction)) {
            action.isHiddenInputAction = true;
            action.accept = hiddenInputAction;
          } else {
            action.isHiddenInputAction = false;
          }
        } else {
          action.isHiddenInputAction = false;
        }
        if (!_.isNil(_this2.actionSubTexts)) {
          subText = _this2.actionSubTexts[action.name];
          if (!_.isNil(subText)) {
            action.hasSubText = true;
            action.subTextClass = subText.class;
            action.subText = subText.text;
          } else {
            action.hasSubText = false;
          }
        } else {
          action.hasSubText = false;
        }
        action.identifier = _.camelCase(action.name);
        action.buttonLabel = _this2.getButtonLabel(action);
      });
    });
    contextActionsArray = actionHandler.processContextActions(this.actions, this.context.model.hierarchicalContextList);
    combinedActions = this.createAllActionsArray(this.actions);
    this.buttonBarActions = actionHandler.getButtonBarActions(combinedActions);
    this.groupedIWantToActionsKeys = null;
    if (!this.hideDropdown) {
      iWantToActionsMap = actionHandler.getIWantToActions(combinedActions, this.context.actions, this.context.fallthrough);
      this.groupedIWantToActionsMap = {};
      _.forOwn(iWantToActionsMap, function (actions, context) {
        _this2.groupedIWantToActionsMap[context] = _.orderBy(_.groupBy(actions, 'groupName'), [function (group) {
          return group[0].groupOrdering;
        }]);
        _this2.groupedIWantToActionsMap[context].hideGroupHeader = context === coreConstant.CONTEXT_NONE;
      });
      tempGroupedIWantToActionsKeys = _.orderBy(_.keys(this.groupedIWantToActionsMap), [function (context) {
        return contextOrder[context];
      }], ['desc']);
      this.groupedIWantToActionsKeys = [];
      _.each(tempGroupedIWantToActionsKeys, function (key) {
        _this2.groupedIWantToActionsKeys.push({
          key: key,
          contextLabel: _this2.getContextLabel(key)
        });
      });
    }
    $rootScope.$broadcast(coreConstant.event.ACTION_BUTTONS_PROCESSING_COMPLETED);
  };
  this.createAllActionsArray = function (contextActionsArray) {
    var allActions = [];
    if (contextActionsArray) {
      _.each(contextActionsArray, function (contextActions) {
        if (!_.isNil(contextActions) && !_.isEmpty(contextActions.actions)) {
          allActions.push(_.filter(_.cloneDeep(contextActions.actions), function (a) {
            return a.valid;
          }));
          contextOrder[contextActions.contextType] = _.get(contextActions.actions, _.keys(contextActions.actions)[0]).contextOrdering;
        }
      });
    }
    return allActions;
  };
  this.handleButtonClick = function (action, event) {
    if (action.valid && !action.enabled && action.notes) {
      event.stopPropagation();
    } else {
      this.notifyActionClicked({
        action: action
      });
    }
  };
  this.handleHiddenInputAction = function (action, file) {
    this.notifyActionClicked({
      action: action,
      file: file
    });
  };
  this.$onChanges = function () {
    this.processActions();
    this.resetTemporarilyDisabledActions();
  };
  this.getActionClass = function (action) {
    if (action.nextAction && !(action.valid && !action.enabled && action.notes)) {
      return 'btn-success';
    } else if (action.previousAction && !(action.valid && !action.enabled && action.notes)) {
      return 'btn-default';
    } else if (action.valid && !action.enabled && action.notes) {
      return 'disabled';
    }
  };
};
ActionButtonsBarController.$inject = ["$rootScope", "$scope", "$element", "$timeout", "localization", "actionHandler", "coreConstant"];
angular.module('umCore').controller('actionButtonsBarController', ActionButtonsBarController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ActionHandler = function ActionHandler(coreConstant) {
  this.getButtonBarActions = function (actions) {
    var allActions = _.flatten(_.map(actions, function (a) {
      return _.flatten(a);
    }));
    return _.filter(allActions, function (a) {
      return a.valid && a.buttonBarAction && !a.iwantToAction;
    }).sort(this.actionSortFunction);
  };
  this.getIWantToActions = function (actions, actionContexts, actionContextFallthrough) {
    var allActions = _.flatten(_.map(actions, function (a) {
        return _.flatten(a);
      })),
      filteredActions = _.filter(allActions, function (a) {
        if (a.iwantToAction && a.valid && !a.enabled && !_.isEmpty(a.notes) && !a.buttonBarAction) {
          return true;
        } else {
          return a.enabled && a.valid && a.iwantToAction && !a.buttonBarAction;
        }
      }).sort(this.actionSortFunction),
      actionsMap = {};
    _.forOwn(actionContexts, function (value, key) {
      actionsMap[key] = [];
    });
    actionsMap[actionContextFallthrough] = [];
    _.each(filteredActions, function (filteredAction) {
      var foundMapping = false;
      _.forOwn(actionContexts, function (value, key) {
        if (_.includes(filteredAction.context, value)) {
          actionsMap[key].push(filteredAction);
          foundMapping = true;
          return false;
        } else if (key === coreConstant.CONTEXT_NONE) {
          actionsMap[coreConstant.CONTEXT_NONE].push(filteredAction);
          foundMapping = true;
          return false;
        }
      });
      if (!foundMapping) {
        actionsMap[actionContextFallthrough].push(filteredAction);
      }
    });
    _.forOwn(actionContexts, function (value, key) {
      if (_.isEmpty(actionsMap[key])) {
        delete actionsMap[key];
      }
    });
    if (_.isEmpty(actionsMap[actionContextFallthrough])) {
      delete actionsMap[actionContextFallthrough];
    }
    return actionsMap;
  };

  /**
   * If child has next action -> Show child's next and previous actions
   * Else if parent has next action -> Show parent's next and previous actions
   * Else if child has previous action -> Show child's previous actions
   * Else if parent has previous action -> Show parent's previous actions
   */
  this.processContextActions = function (actions, hierarchicalContextList) {
    var nextActionCount = -1,
      previousActionCount = -1,
      contextActionObject;
    _.each(hierarchicalContextList, function (hierarchicalContext) {
      contextActionObject = _.find(actions, function (actionObject) {
        return actionObject.contextType === hierarchicalContext.contextType;
      });
      if (contextActionObject) {
        _.map(contextActionObject.actions, function (action) {
          if (action.iwantToAction || action.buttonBarAction) {
            if (action.nextAction) {
              if (nextActionCount <= 0) {
                action.iwantToAction = false;
                action.buttonBarAction = true;
              } else if (nextActionCount !== -1) {
                action.iwantToAction = true;
                action.buttonBarAction = false;
              }
            } else if (action.previousAction) {
              if (previousActionCount <= 0) {
                action.iwantToAction = false;
                action.buttonBarAction = true;
              } else if (previousActionCount !== -1) {
                action.iwantToAction = true;
                action.buttonBarAction = false;
              }
            } else if (action.iwantToAction && action.buttonBarAction) {
              action.buttonBarAction = false;
            }
          }
        });
        nextActionCount = _.filter(contextActionObject.actions, function (action) {
          return action.nextAction && action.buttonBarAction && action.valid;
        }).length;
        previousActionCount = _.filter(contextActionObject.actions, function (action) {
          return action.previousAction && action.buttonBarAction && action.valid;
        }).length;
      }
    });
    return actions;
  };
  this.actionSortFunction = function (action1, action2) {
    var sortValue = 0;

    // If both actions are on the button bar, or, if both actions' ordering are the same, we need to determine
    // their sort order via previousAction and nextAction before defaulting to calculating the sort solely
    // via the ordering values.
    if (action1.buttonBarAction && action2.buttonBarAction || action1.ordering === action2.ordering) {
      if (action2.previousAction) {
        sortValue = 1;
      } else if (action1.previousAction) {
        sortValue = -1;
      } else if (action2.nextAction) {
        sortValue = -1;
      } else if (action1.nextAction) {
        sortValue = 1;
      }
    }
    if (sortValue === 0) {
      sortValue = action1.ordering - action2.ordering > 0 ? 1 : -1;
    }
    return sortValue;
  };
};
ActionHandler.$inject = ["coreConstant"];
angular.module('umCore').service('actionHandler', ActionHandler);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1360 */
/***/ (function(module) {

module.exports = JSON.parse("{\"advancedFilterSubmissionStatus\":{\"0\":\"Invalid\",\"1\":\"Draft\",\"2\":\"Submitted\",\"3\":\"Clear\",\"4\":\"Quoted\",\"5\":\"Bind Requested\",\"6\":\"Bound\",\"7\":\"Issued\",\"8\":\"Not Clear\",\"9\":\"Lost\",\"10\":\"Declined\",\"11\":\"Quote Withdrawn\",\"12\":\"Expired\",\"13\":\"Started Pre-Qualification\",\"14\":\"Failed Pre-Qualification\",\"15\":\"Pending Issuance\",\"16\":\"Declined Quote\",\"18\":\"Cancelled\",\"20\":\"Clear Awaiting Rate\",\"21\":\"Renewed\",\"22\":\"Non-Renewed\",\"23\":\"Succeeded Pre-Qualification\",\"24\":\"Submit Pending\",\"25\":\"Clear-Ready to Underwrite\",\"26\":\"Rejected\",\"27\":\"Created\",\"uploadStatus\":{\"1\":\"Upload in Progress\",\"2\":\"Upload in Progress\",\"4\":\"Application Uploaded\"}},\"advancedFilterAgentSubmissionStatus\":{\"0\":\"Invalid\",\"1\":\"Draft\",\"2\":\"Submitted\",\"3\":\"Clear\",\"4\":\"Quoted\",\"5\":\"Bind Requested\",\"6\":\"Bound\",\"7\":\"Issued\",\"8\":\"Clearance Review\",\"9\":\"Lost\",\"10\":\"Declined\",\"11\":\"Quote Withdrawn\",\"12\":\"Expired\",\"13\":\"Started Pre-Qualification\",\"14\":\"Failed Pre-Qualification\",\"15\":\"Pending Issuance\",\"16\":\"Declined Quote\",\"18\":\"Cancelled\",\"20\":\"Clear Awaiting Rate\",\"21\":\"Renewed\",\"22\":\"Non-Renewed\",\"23\":\"Succeeded Pre-Qualification\",\"24\":\"Submit Pending\",\"25\":\"Clear-Ready to Underwrite\",\"26\":\"Incomplete\",\"27\":\"Created\",\"uploadStatus\":{\"1\":\"Upload in Progress\",\"2\":\"Upload in Progress\",\"4\":\"Application Uploaded\"}}}");

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

/*@ngInject*/
var AdvancedFilterMediator = function AdvancedFilterMediator(filterRepository) {
  this.getFilters = function (type) {
    return filterRepository.getFilters(type);
  };
  this.getFilterTemplates = function (templateId) {
    return filterRepository.getFilterTemplates(templateId);
  };
  this.saveFilter = function (filter) {
    return filterRepository.saveFilter(filter);
  };
  this.deleteFilter = function (filter) {
    return filterRepository.deleteFilter(filter.uri);
  };
  this.getFilter = function (filterUri) {
    return filterRepository.getFilter(filterUri);
  };
};
AdvancedFilterMediator.$inject = ["filterRepository"];
angular.module('umCore').service('advancedFilterMediator', AdvancedFilterMediator);

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var AdvancedFilterModel = function AdvancedFilterModel(advancedFilterType, filterCriterionDataType, filterType) {
  var advancedFilterModels = {};
  this.reset = function (namespace) {
    if (namespace) {
      advancedFilterModels[namespace] = {
        filterTemplate: null,
        filter: null,
        selectedFilterCriterionTemplates: null,
        unselectedFilterCriterionTemplates: null
      };
    } else {
      advancedFilterModels = {};
    }
  };
  this.getAdvancedFilterModel = function (namespace) {
    return advancedFilterModels[namespace];
  };
  this.buildFilter = function (namespace, filterTemplate, filter, selectAll) {
    var advancedFilterModel = advancedFilterModels.hasOwnProperty(namespace) ? advancedFilterModels[namespace] : {},
      filterCriteria = null;
    advancedFilterModel.selectedFilterCriterionTemplates = _.filter(filterTemplate.criterionTemplates, function (criterionTemplate) {
      filterCriteria = _.find(filter.criteria, ['filterCriterionTemplateId', criterionTemplate.id]);
      if (!_.isNil(filterCriteria)) {
        criterionTemplate.value = filterTemplate.type === filterType.TYPE_FORMTEMPLATE_FILTER && criterionTemplate.type === filterCriterionDataType.TYPE_BOOLEAN ? !!filterCriteria.value : filterCriteria.value;
        return true;
      } else if (namespace === advancedFilterType.SUBMISSION_GRID && criterionTemplate.variableName === 'insuredNameOrSubmissionOrPolicyNumberSubstring') {
        // Always show the insured name quick search on the submission grid
        return true;
      }
      return selectAll;
    });
    if (!selectAll) {
      advancedFilterModel.unselectedFilterCriterionTemplates = _.sortBy(_.filter(filterTemplate.criterionTemplates, function (criterionTemplate) {
        return _.isNil(_.find(filter.criteria, ['filterCriterionTemplateId', criterionTemplate.id])) && !(namespace === advancedFilterType.SUBMISSION_GRID && criterionTemplate.variableName === 'insuredNameOrSubmissionOrPolicyNumberSubstring');
      }), 'name');
    }
    advancedFilterModel.filterTemplate = filterTemplate;
    advancedFilterModel.filter = filter;
    advancedFilterModels[namespace] = advancedFilterModel;
  };
  this.buildCurrentFilter = function (namespace) {
    var advancedFilterModel = advancedFilterModels[namespace],
      currentFilter = _.clone(advancedFilterModel.filter),
      selectedCriterionTemplates = advancedFilterModel.selectedFilterCriterionTemplates,
      tempCriteria = null;
    currentFilter.criteria = [];
    _.forEach(selectedCriterionTemplates, function (criterionTemplate) {
      tempCriteria = {
        filterUri: currentFilter.uri,
        filterCriterionTemplateId: criterionTemplate.id,
        value: criterionTemplate.value
      };
      currentFilter.criteria.push(tempCriteria);
    });
    return currentFilter;
  };
  this.unselectFilterCriterion = function (namespace, filterTemplateCriterionId) {
    var advancedFilterModel = advancedFilterModels[namespace],
      filterTemplateCriterion = _.remove(advancedFilterModel.selectedFilterCriterionTemplates, ['id', filterTemplateCriterionId]);
    filterTemplateCriterion[0].value = null;
    advancedFilterModel.unselectedFilterCriterionTemplates.push(filterTemplateCriterion[0]);
    advancedFilterModel.unselectedFilterCriterionTemplates = _.sortBy(advancedFilterModel.unselectedFilterCriterionTemplates, 'name');
  };
  this.selectFilterCriterion = function (namespace, filterTemplateCriterionId) {
    var advancedFilterModel = advancedFilterModels[namespace],
      filterTemplateCriterion = _.remove(advancedFilterModel.unselectedFilterCriterionTemplates, ['id', filterTemplateCriterionId]);
    advancedFilterModel.selectedFilterCriterionTemplates.push(filterTemplateCriterion[0]);
  };
};
AdvancedFilterModel.$inject = ["advancedFilterType", "filterCriterionDataType", "filterType"];
angular.module('umCore').service('advancedFilterModel', AdvancedFilterModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var advancedFilterSplitterFilter = function advancedFilterSplitterFilter() {
  return function (items, before, after) {
    var splitterIndex;
    if (items) {
      splitterIndex = _.findIndex(items, function (item) {
        return item.uiType === 10;
      });
      if (before && !after && splitterIndex > -1) {
        return items.slice(0, splitterIndex);
      } else if (before && !after && splitterIndex === -1) {
        return items;
      } else if (!before && after && splitterIndex > -1) {
        return items.slice(splitterIndex, items.length);
      } else if (splitterIndex > -1) {
        return [items[splitterIndex]];
      }
    }
  };
};
angular.module('umCore').filter('advancedFilterSplitterFilter', advancedFilterSplitterFilter);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

angular.module('umCore').constant('advancedFilterType', {
  ACCOUNT_GRID: 'accountGrid',
  ACCOUNT_SUBMISSIONS_GRID: 'accountSubmissionsGrid',
  POLICY_GRID: 'policyGrid',
  SUBMISSION_GRID: 'submissionGrid',
  ACTIVITY_GRID: 'activityGrid',
  TASK_GRID: 'taskGrid',
  FORM_TEMPLATE_BROWSER: 'formTemplateBrowser',
  DATA_SET_BROWSER: 'dataSetBrowser',
  RULES_BROWSER: 'rulesBrowser',
  PRODUCT_TEMPLATE_BROWSER: 'productTemplateBrowser',
  ORGANIZATION_BROWSER: 'organizationBrowser'
});

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

/*@ngInject*/
var FilterRepository = function FilterRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.deleteFilter = function (filterUri) {
    var url = '/rest/Filter',
      config = {
        params: {
          filterUri: filterUri
        }
      };
    return this.delete(url, config);
  };
  this.saveFilter = function (filter) {
    var url = '/rest/Filter/';
    return this.post(url, filter);
  };
  this.getFilters = function (type) {
    var url = '/rest/Filter',
      config = {
        params: {
          type: type
        }
      };
    return this.get(url, config);
  };
  this.getFilter = function (filterUri) {
    var url = '/rest/Filter/single',
      config = {
        params: {
          filterUri: filterUri
        }
      };
    return this.get(url, config);
  };
  this.getFilterTemplates = function (templateId) {
    var url = '/rest/FilterTemplate/' + templateId;
    return this.get(url);
  };
};
FilterRepository.$inject = ["baseRepository"];
angular.module('umCore').service('filterRepository', FilterRepository);

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var yesNoFilter = function yesNoFilter(localization) {
  var translations;
  localization.getTranslationByKey('filter.yesNo').then(function (result) {
    translations = result;
  });
  return function (text, length, end) {
    if (text) {
      return _.get(translations, 'yes');
    }
    return _.get(translations, 'no');
  };
};
yesNoFilter.$inject = ["localization"];
angular.module('umCore').filter('yesNoFilter', yesNoFilter);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

var path = '/ui/advancedFilter/component/advancedFilterList/advancedFilterList.tpl.html';
var html = "<div class=\"advancedFilterList\">\n    <div class=\"filterComponentsContainer\"\n         ng-repeat=\"criterionTemplate in $ctrl.filterModel.selectedFilterCriterionTemplates | advancedFilterSplitterFilter:true:false\"\n         ng-switch on=\"criterionTemplate.uiType\">\n\n        <!-- Text input -->\n        <div class=\"filterComponent\"\n             ng-switch-when=\"1\">\n            <ui-text-input-filter\n                criterion-template=\"criterionTemplate\"\n                advanced-filter-type=\"$ctrl.advancedFilterType\"\n                translations-key=\"$ctrl.translationsKey\"\n                disable-auto-focus=\"$ctrl.disableAutoFocus\">\n            </ui-text-input-filter>\n        </div>\n\n        <!-- Single select dropdown -->\n        <div class=\"filterComponent\"\n             ng-switch-when=\"2\">\n            <ui-select-filter\n                criterion-template=\"criterionTemplate\"\n                multi-select=\"false\"\n                submission=\"$ctrl.submission\"\n                advanced-filter-type=\"$ctrl.advancedFilterType\"\n                translations-key=\"$ctrl.translationsKey\">\n            </ui-select-filter>\n        </div>\n\n        <!-- Multi select dropdown -->\n        <div class=\"filterComponent\"\n             ng-switch-when=\"3\">\n            <ui-select-filter\n                criterion-template=\"criterionTemplate\"\n                multi-select=\"true\"\n                submission=\"$ctrl.submission\"\n                advanced-filter-type=\"$ctrl.advancedFilterType\"\n                translations-key=\"$ctrl.translationsKey\">\n            </ui-select-filter>\n        </div>\n\n        <!-- Checkbox component -->\n        <div class=\"filterComponent\"\n             ng-switch-when=\"5\">\n            <ui-checkbox-filter\n                criterion-template=\"criterionTemplate\"\n                advanced-filter-type=\"$ctrl.advancedFilterType\"\n                translations-key=\"$ctrl.translationsKey\">\n            </ui-checkbox-filter>\n        </div>\n\n        <!-- Selected label value -->\n        <div class=\"filterComponent\"\n             ng-switch-when=\"7\">\n            <ui-yes-no-filter\n                criterion-template=\"criterionTemplate\"\n                advanced-filter-type=\"$ctrl.advancedFilterType\"\n                translations-key=\"$ctrl.translationsKey\">\n            </ui-yes-no-filter>\n        </div>\n\n        <!-- Date Selector with UTC timezone -->\n        <div class=\"filterComponent\"\n             ng-switch-when=\"8\">\n            <ui-date-filter\n                criterion-template=\"criterionTemplate\"\n                submission=\"$ctrl.submission\"\n                advanced-filter-type=\"$ctrl.advancedFilterType\"\n                translations-key=\"$ctrl.translationsKey\"\n                timezone-mode=\"'utc'\">\n            </ui-date-filter>\n        </div>\n\n        <!-- Type Ahead Widget -->\n        <div class=\"filterComponent\"\n             ng-switch-when=\"9\">\n            <ui-type-ahead-filter\n                criterion-template=\"criterionTemplate\"\n                submission-id=\"$ctrl.submission.id\"\n                advanced-filter-type=\"$ctrl.advancedFilterType\"\n                translations-key=\"$ctrl.translationsKey\">\n            </ui-type-ahead-filter>\n        </div>\n\n        <!-- Date Selector with local timezone -->\n        <div class=\"filterComponent\"\n             ng-switch-when=\"11\">\n            <ui-date-filter\n                criterion-template=\"criterionTemplate\"\n                submission=\"$ctrl.submission\"\n                advanced-filter-type=\"$ctrl.advancedFilterType\"\n                translations-key=\"$ctrl.translationsKey\"\n                timezone-mode=\"'local'\">\n            </ui-date-filter>\n        </div>\n    </div>\n    <!-- Unselected filter widget -->\n    <div class=\"filterComponent\"\n         ng-if=\"!$ctrl.showAllTemplates\">\n        <ui-unselected-filter\n            filter-model=\"$ctrl.filterModel\"\n            advanced-filter-type=\"$ctrl.advancedFilterType\"\n            translations-key=\"$ctrl.translationsKey\">\n        </ui-unselected-filter>\n    </div>\n    <div class=\"filterComponent firstClearButtonFilterComponent\"\n         ng-if=\"$ctrl.allowClearFilter\">\n        <a class=\"firstClearButton\"\n           ng-class=\"{ 'btn btn-default': !$ctrl.clearFilterIsLink }\"\n           ng-click=\"$ctrl.clearFilter(false)\">{{ ::$ctrl.clearFilterLabel }}\n        </a>\n    </div>\n</div>\n\n<span class=\"splitter\"\n      ng-repeat=\"criterionTemplate in $ctrl.filterModel.selectedFilterCriterionTemplates | advancedFilterSplitterFilter:true:true\">{{criterionTemplate.name}}</span>\n\n<div class=\"advancedFilterList\">\n    <div class=\"filterComponentsContainer\"\n         ng-repeat=\"criterionTemplate in $ctrl.filterModel.selectedFilterCriterionTemplates | advancedFilterSplitterFilter:false:true\"\n         ng-switch on=\"criterionTemplate.uiType\">\n\n        <!-- Text input -->\n        <div class=\"filterComponent\"\n             ng-switch-when=\"1\">\n            <ui-text-input-filter\n                criterion-template=\"criterionTemplate\"\n                advanced-filter-type=\"$ctrl.advancedFilterType\"\n                translations-key=\"$ctrl.translationsKey\">\n            </ui-text-input-filter>\n        </div>\n\n        <!-- Single select dropdown -->\n        <div class=\"filterComponent\"\n             ng-switch-when=\"2\">\n            <ui-select-filter\n                criterion-template=\"criterionTemplate\"\n                multi-select=\"false\"\n                submission=\"$ctrl.submission\"\n                advanced-filter-type=\"$ctrl.advancedFilterType\"\n                translations-key=\"$ctrl.translationsKey\">\n            </ui-select-filter>\n        </div>\n\n        <!-- Multi select dropdown -->\n        <div class=\"filterComponent\"\n             ng-switch-when=\"3\">\n            <ui-select-filter\n                criterion-template=\"criterionTemplate\"\n                multi-select=\"true\"\n                submission=\"$ctrl.submission\"\n                advanced-filter-type=\"$ctrl.advancedFilterType\"\n                translations-key=\"$ctrl.translationsKey\">\n            </ui-select-filter>\n        </div>\n\n        <!-- Checkbox component -->\n        <div class=\"filterComponent\"\n             ng-switch-when=\"5\">\n            <ui-checkbox-filter\n                criterion-template=\"criterionTemplate\"\n                advanced-filter-type=\"$ctrl.advancedFilterType\"\n                translations-key=\"$ctrl.translationsKey\">\n            </ui-checkbox-filter>\n        </div>\n\n        <!-- Selected label value -->\n        <div class=\"filterComponent\"\n             ng-switch-when=\"7\">\n            <ui-yes-no-filter\n                criterion-template=\"criterionTemplate\"\n                advanced-filter-type=\"$ctrl.advancedFilterType\"\n                translations-key=\"$ctrl.translationsKey\">\n            </ui-yes-no-filter>\n        </div>\n\n        <!-- Date Selector with UTC timezone -->\n        <div class=\"filterComponent\"\n             ng-switch-when=\"8\">\n            <ui-date-filter\n                criterion-template=\"criterionTemplate\"\n                submission=\"$ctrl.submission\"\n                advanced-filter-type=\"$ctrl.advancedFilterType\"\n                translations-key=\"$ctrl.translationsKey\"\n                timezone-mode=\"'utc'\">\n            </ui-date-filter>\n        </div>\n\n        <!-- Type Ahead Widget -->\n        <div class=\"filterComponent\"\n             ng-switch-when=\"9\">\n            <ui-type-ahead-filter\n                criterion-template=\"criterionTemplate\"\n                submission-id=\"$ctrl.submission.id\"\n                advanced-filter-type=\"$ctrl.advancedFilterType\"\n                translations-key=\"$ctrl.translationsKey\">\n            </ui-type-ahead-filter>\n        </div>\n\n        <!-- Date Selector with local timezone -->\n        <div class=\"filterComponent\"\n             ng-switch-when=\"11\">\n            <ui-date-filter\n                criterion-template=\"criterionTemplate\"\n                submission=\"$ctrl.submission\"\n                advanced-filter-type=\"$ctrl.advancedFilterType\"\n                translations-key=\"$ctrl.translationsKey\"\n                timezone-mode=\"'local'\">\n            </ui-date-filter>\n        </div>\n    </div>\n    <div class=\"filterComponent lastClearButtonFilterComponent\"\n         ng-if=\"$ctrl.allowClearFilter && !$ctrl.oneClearFilter\">\n        <a class=\"lastClearButton\"\n           ng-class=\"{ 'btn btn-default': !$ctrl.clearFilterIsLink }\"\n           ng-click=\"$ctrl.clearFilter(true)\">{{ ::$ctrl.clearFilterLabel }}\n        </a>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

var AdvancedFilterListComponent = {
  templateUrl: '/ui/advancedFilter/component/advancedFilterList/advancedFilterList.tpl.html',
  controller: 'advancedFilterListController',
  bindings: {
    filterModel: '<',
    showAllTemplates: '<',
    submission: '<',
    advancedFilterType: '<',
    allowClearFilter: '<',
    translationsKey: '<?',
    disableAutoFocus: '<?',
    oneClearFilter: '<',
    clearFilterIsLink: '<'
  }
};
angular.module('umCore').component('uiAdvancedFilterList', AdvancedFilterListComponent);

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var AdvancedFilterListController = function AdvancedFilterListController($scope, advancedFilterModel, advancedFilterMediator, coreConstant, currentUserModel, filterCriterionUiType, localization) {
  this.$onInit = function () {
    var _this = this;
    localization.getTranslationsByKeys([this.translationsKey, 'advancedFilter']).then(function (translations) {
      _this.clearFilterLabel = translations.clearButton;
    });
  };
  $scope.$on(coreConstant.event.FILTER_UPDATED, function (event, advancedFilterType, isProgramatic) {
    if (isProgramatic) {
      this.programaticUpdateFilter();
    } else {
      this.userUpdateFilter();
    }
  }.bind(this));
  this.clearFilter = function (isAfterSplitter) {
    var items = this.filterModel.selectedFilterCriterionTemplates,
      splitterIndex;
    if (!this.oneClearFilter) {
      splitterIndex = _.findIndex(items, function (item) {
        return item.uiType === filterCriterionUiType.UI_BREAKER;
      });
      if (isAfterSplitter) {
        items = items.slice(splitterIndex, items.length);
      } else {
        items = items.slice(0, splitterIndex);
      }
    }
    _.each(items, function (item) {
      $scope.$broadcast(coreConstant.event.FILTER_CLEARED, item.id);
    });
    this.updateFilter();
  };
  this.userUpdateFilter = _.debounce(function () {
    this.updateFilter();
  }.bind(this), 500);
  this.programaticUpdateFilter = _.debounce(function () {
    this.updateFilter();
  }.bind(this), 200);
  this.updateFilter = function () {
    var filter = advancedFilterModel.buildCurrentFilter(this.advancedFilterType);
    if (!advancedFilterModel.getAdvancedFilterModel(this.advancedFilterType).temporary) {
      filter.temporary = true;
      filter.uri = null;
      filter.id = null;
    }
    filter.userId = currentUserModel.getCurrentUser().userId;
    advancedFilterMediator.saveFilter(filter).then(function (filter) {
      $scope.$emit(coreConstant.event.FILTER_SAVED, filter);
    });
  };
};
AdvancedFilterListController.$inject = ["$scope", "advancedFilterModel", "advancedFilterMediator", "coreConstant", "currentUserModel", "filterCriterionUiType", "localization"];
angular.module('umCore').controller('advancedFilterListController', AdvancedFilterListController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

var path = '/ui/advancedFilter/component/checkboxFilter/checkboxFilter.tpl.html';
var html = "<div class=\"filterCriterionContainer checkboxFilter {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\">\n\n    <div class=\"componentInputContainer {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\"\n         ng-class=\"{'open': $ctrl.isOpen}\">\n\n        <div class=\"labelContainer {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\">\n            {{ ::$ctrl.criterionTemplate.name }}:\n        </div>\n\n        <input type=\"checkbox\"\n               class=\"{{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\"\n               ng-model=\"$ctrl.criterionTemplate.value\"\n               ng-change=\"$ctrl.handleChange()\"/>\n\n        <div class=\"removeButton {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }} glyphicon glyphicon-remove\"\n             ng-click=\"$ctrl.handleRemove()\"\n             ui-tooltip></div>\n    </div>\n\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

var CheckboxFilterComponent = {
  templateUrl: '/ui/advancedFilter/component/checkboxFilter/checkboxFilter.tpl.html',
  controller: 'checkboxFilterController',
  bindings: {
    criterionTemplate: '<',
    advancedFilterType: '<',
    translationsKey: '<?'
  }
};
angular.module('umCore').component('uiCheckboxFilter', CheckboxFilterComponent);

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

/*@ngInject*/
var CheckboxFilterController = function CheckboxFilterController($scope, coreConstant, advancedFilterModel, localization) {
  this.$onInit = function () {
    var _this = this;
    this.tooltip = {
      delay: 750
    };
    localization.getTranslationsByKeys([this.translationsKey, 'advancedFilter']).then(function (translations) {
      _this.tooltip.message = translations.removeButtonTooltip;
    });
    this.isOpen = true;
  };
  this.handleChange = function () {
    $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
  };
  this.getComponentId = function (filterCriterionTemplate) {
    return this.advancedFilterType + 'AdvancedFilterType ' + filterCriterionTemplate.variableName;
  };
  this.handleRemove = function () {
    advancedFilterModel.unselectFilterCriterion(this.advancedFilterType, this.criterionTemplate.id);
    $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
  };
  $scope.$on(coreConstant.event.FILTER_CLEARED, function (event, criterionTemplateId) {
    if (criterionTemplateId === this.criterionTemplate.id) {
      this.criterionTemplate.value = '';
    }
  }.bind(this));
};
CheckboxFilterController.$inject = ["$scope", "coreConstant", "advancedFilterModel", "localization"];
angular.module('umCore').controller('checkboxFilterController', CheckboxFilterController);

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

var path = '/ui/advancedFilter/component/dateFilter/dateFilter.tpl.html';
var html = "<div class=\"filterCriterionContainer {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\">\n\n    <div class=\"componentInputContainer {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\"\n         ng-class=\"{'open': $ctrl.isOpen}\">\n\n        <div class=\"labelContainer {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\">\n            {{ ::$ctrl.criterionTemplate.name }}:\n        </div>\n\n        <div class=\"dropdownComponentContainer\">\n            <ui-select class=\"dropdownComponentSelect {{::$ctrl.criterionTemplate.variableName}}\"\n                       ng-model=\"$ctrl.dropdownSelectedValue\"\n                       value=\"{{$ctrl.dropdownSelectedValue}}\"\n                       theme=\"select2\"\n                       on-select=\"$ctrl.handleSelect($select)\"\n                       on-remove=\"$ctrl.handleSelect($select)\"\n                       append-to-body=\"true\"\n                       placeholder=\"{{::$ctrl.placeholder}}\"\n                       dropdown-unselect-item\n                       dropdown-handle-focus\n                       ui-hide-select-on-scroll\n                       ui-hide-select-on-scroll-selector=\".content\">\n\n                <ui-select-match placeholder=\"{{::$ctrl.placeholder}}\" allow-clear=\"true\">\n                <span class=\"{{::$ctrl.formatAsSelector($select.selected.name)}}\"\n                      ng-bind=\"$select.selected.name\"></span>\n                </ui-select-match>\n\n                <ui-select-choices refresh=\"$ctrl.filterItems($select.search)\"\n                                   refresh-delay=\"250\"\n                                   repeat=\"item in $ctrl.filteredItemsList\"\n                                   group-by=\"'grouping'\">\n                <span class=\"option {{::$ctrl.formatAsSelector(item.name)}}\"\n                      ng-bind=\"item.name\"\n                      ng-class=\"{'warning': item.warning}\"></span>\n                </ui-select-choices>\n                <i class=\"glyphicon glyphicon-plus\"></i>\n            </ui-select>\n\n            <ui-date-range ng-if=\"$ctrl.customRange\"\n                           date-value=\"$ctrl.criterionTemplate.value\"\n                           value-updated=\"$ctrl.customDateRangeUpdated(value)\"\n                           allow-independent-dates=\"true\"\n                           allow-date-clearing=\"true\"\n                           timezone-mode=\"$ctrl.timezoneMode\">\n            </ui-date-range>\n        </div>\n\n\n        <div class=\"removeButton {{::$ctrl.criterionTemplate.variableName}} glyphicon glyphicon-remove\"\n             ng-click=\"$ctrl.handleRemove()\"\n             ui-tooltip></div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

var DateFilterComponent = {
  templateUrl: '/ui/advancedFilter/component/dateFilter/dateFilter.tpl.html',
  controller: 'dateFilterController',
  bindings: {
    criterionTemplate: '<',
    submission: '<',
    advancedFilterType: '<',
    translationsKey: '<?',
    timezoneMode: '<'
  }
};
angular.module('umCore').component('uiDateFilter', DateFilterComponent);

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var DateFilterController = function DateFilterController($scope, $q, advancedFilterModel, coreMediator, coreConstant, formatUtil, localization, dataSetUtil) {
  this.$onInit = function () {
    var _this = this;
    var criterionTemplate = this.criterionTemplate,
      dataSetName = criterionTemplate.dataSetName,
      submissionUri = !_.isNil(this.submission) ? 'com.firstbest.underwriting.submission.Submission:' + this.submission.id : null,
      variableName = this.criterionTemplate.variableName,
      dataSetParams = dataSetUtil.getDataSetParamsByName(dataSetName, variableName, submissionUri);
    this.customRange = false;
    this.isOpen = true;
    this.tooltip = {
      delay: 750
    };
    this.itemsList = [];
    localization.getTranslationsByKeys([this.translationsKey, 'advancedFilter']).then(function (translations) {
      _this.placeholder = _.get(translations.dateFilter, _this.criterionTemplate.variableName + '.placeholder') || translations.placeholder;
      _this.tooltip.message = translations.removeButtonTooltip;
    });
    return dataSetUtil.getDataItems(dataSetParams).then(function (items) {
      this.setItemsList(items);
      return items;
    }.bind(this));
  };
  this.formatAsSelector = function (nameString) {
    return nameString ? formatUtil.formatAsSelector(nameString) : '';
  };
  this.setItemsList = function (itemsList) {
    this.itemsList = itemsList;
    this.filterItems();
    this.updateDropdownSelectedValue();
  };
  this.filterItems = function (searchText) {
    var filteredItemsList = [];
    if (!_.isEmpty(searchText)) {
      filteredItemsList = _.filter(this.itemsList, function (item) {
        return _.includes(item.name.toLowerCase(), searchText.toLowerCase());
      });
    } else if (_.isArray(this.itemsList)) {
      filteredItemsList = this.itemsList;
    }
    if (this.searchableList && filteredItemsList.length > 150) {
      this.showLongListWarning(filteredItemsList.length);
    } else {
      this.filteredItemsList = filteredItemsList;
    }
  };
  this.updateDropdownSelectedValue = function () {
    var criterionValue = this.criterionTemplate.value,
      selectedValue = null;
    if (!_.isNil(criterionValue)) {
      if (_.startsWith(criterionValue, 'SPECIFIED::')) {
        selectedValue = _.find(this.itemsList, {
          value: 'Custom Range'
        });
        this.customRange = true;
      } else {
        selectedValue = _.find(this.itemsList, {
          value: criterionValue
        });
      }
      if (!_.isNil(selectedValue)) {
        this.dropdownSelectedValue = selectedValue;
      } else {
        this.dropdownSelectedValue = _.intersectionWith(this.itemsList, _.split(criterionValue, '::'), function (dataItem, criterionItem) {
          return dataItem.value === criterionItem;
        });
      }
    } else {
      this.dropdownSelectedValue = null;
    }
  };
  this.handleSelect = function (select) {
    var selectedItems = null;
    if (_.isArray(select.selected)) {
      selectedItems = '';
      _.forEach(select.selected, function (selectedItem) {
        selectedItems += selectedItem.value + '::';
      });
      selectedItems = selectedItems.substring(0, selectedItems.lastIndexOf('::'));
    } else if (!_.isNil(select.selected)) {
      selectedItems = select.selected.value;
    }
    if (selectedItems === 'Custom Range') {
      this.customRange = true;
      this.criterionTemplate.value = 'ALL';
    } else {
      this.customRange = false;
      this.criterionTemplate.value = selectedItems;
    }
    $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
  };
  this.getComponentId = function (filterCriterionTemplate) {
    return this.advancedFilterType + 'AdvancedFilterType ' + filterCriterionTemplate.variableName;
  };
  this.handleRemove = function () {
    advancedFilterModel.unselectFilterCriterion(this.advancedFilterType, this.criterionTemplate.id);
    $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
  };
  this.customDateRangeUpdated = function (value) {
    this.criterionTemplate.value = value;
    $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
  };
  $scope.$on(coreConstant.event.FILTER_CLEARED, function (event, criterionTemplateId) {
    if (criterionTemplateId === this.criterionTemplate.id) {
      this.criterionTemplate.value = null;
      this.customRange = false;
      this.updateDropdownSelectedValue();
    }
  }.bind(this));
};
DateFilterController.$inject = ["$scope", "$q", "advancedFilterModel", "coreMediator", "coreConstant", "formatUtil", "localization", "dataSetUtil"];
angular.module('umCore').controller('dateFilterController', DateFilterController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

var path = '/ui/advancedFilter/component/dateFilter/dateRange/dateRange.tpl.html';
var html = "<div class=\"dateRangeComponent\">\n\n    <div class=\"componentCalendarContainer\"\n         ui-popup-position>\n\n        <div class=\"dateInputContainer\">\n            <div class=\"dateLabelContainer\"\n                 ng-if=\"$ctrl.startDateLabel\">\n                <div class=\"requiredIcon startDateRequired\"\n                     ng-if=\"!$ctrl.startDate\"></div>\n                <div class=\"glyphicon glyphicon-ok validIcon startDateValid\"\n                     ng-if=\"$ctrl.startDate\"></div>\n                <span class=\"dateLabel\">{{::$ctrl.startDateLabel}}</span>\n            </div>\n\n            <input type=\"text\"\n                   class=\"dateRange effective\"\n                   ng-model=\"$ctrl.startDate\"\n                   ng-blur=\"$ctrl.handleBlur()\"\n                   ng-disabled=\"$ctrl.isDateDisabled\"\n                   placeholder=\"{{::$ctrl.startDatePlaceHolder}}\"/>\n        </div>\n\n        <button class=\"toggleCalendarPopup glyphicon glyphicon-calendar\"\n                uib-popover-template=\"'/formViewer/component/calendar/calendarPopover.tpl.html'\"\n                popover-trigger=\"none\"\n                popover-append-to-body=\"true\"\n                popover-placement=\"auto top\"\n                popover-is-open=\"$ctrl.startPopupOpen\"\n                popover-class=\"calendarPopover\"\n                ng-click=\"$ctrl.handleStartClick($event)\"\n                aria-hidden=\"true\"\n                ng-disabled=\"$ctrl.isDateDisabled\"></button>\n    </div>\n    <span ng-if=\"!$ctrl.endDateLabel\" ui-translate>advancedFilter.dateRange.to</span>\n    <div class=\"componentCalendarContainer\"\n         ui-popup-position>\n\n        <div class=\"dateInputContainer\">\n            <div class=\"dateLabelContainer\"\n                 ng-if=\"$ctrl.endDateLabel\">\n                <div class=\"requiredIcon endDateRequired\"\n                     ng-if=\"!$ctrl.endDate\"></div>\n                <div class=\"glyphicon glyphicon-ok validIcon endDateValie\"\n                     ng-if=\"$ctrl.endDate\"></div>\n                <span class=\"dateLabel\">{{::$ctrl.endDateLabel}}</span>\n            </div>\n            <input type=\"text\"\n                   class=\"dateRange expiration\"\n                   ng-model=\"$ctrl.endDate\"\n                   ng-blur=\"$ctrl.handleBlur()\"\n                   ng-disabled=\"$ctrl.isDateDisabled\"\n                   placeholder=\"{{::$ctrl.endDatePlaceHolder}}\"/>\n        </div>\n\n        <button class=\"toggleCalendarPopup glyphicon glyphicon-calendar\"\n                uib-popover-template=\"'/formViewer/component/calendar/calendarPopover.tpl.html'\"\n                popover-trigger=\"none\"\n                popover-append-to-body=\"true\"\n                popover-placement=\"auto top\"\n                popover-is-open=\"$ctrl.endPopupOpen\"\n                popover-class=\"calendarPopover\"\n                ng-click=\"$ctrl.handleEndClick($event)\"\n                aria-hidden=\"true\"\n                ng-disabled=\"$ctrl.isDateDisabled\"></button>\n    </div>\n</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

var DateRangeComponent = {
  templateUrl: '/ui/advancedFilter/component/dateFilter/dateRange/dateRange.tpl.html',
  controller: 'dateRangeController',
  bindings: {
    dateValue: '<',
    valueUpdated: '&',
    startDateLabel: '<',
    endDateLabel: '<',
    allowIndependentDates: '<?',
    allowDateClearing: '<?',
    endDateValidationErrorMessage: '<',
    timezoneMode: '<',
    isDisabled: '<'
  }
};
angular.module('umCore').component('uiDateRange', DateRangeComponent);

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $, moment) {/*@ngInject*/
var DateRangeController = function DateRangeController($scope, $rootScope, $timeout, formComponentUtil, localization, dateUtil, coreConstant) {
  var timeoutList = [];
  this.isDateDisabled = false;
  this.$onInit = function () {
    this.init();
  };
  this.init = function () {
    var dateRange, startDateParts, endDateParts;
    if (this.isDisabled) {
      this.isDateDisabled = true;
    }
    if (!_.isNil(this.dateValue)) {
      dateRange = _.split(this.dateValue, '::');
      if (dateRange.length === 3) {
        startDateParts = _.split(dateRange[1], /[-+]/);
        endDateParts = _.split(dateRange[2], /[-+]/);
        this.startDate = startDateParts[0] !== ' ' ? formComponentUtil.formatDateWithDefaultPreferences(startDateParts[0], false) : startDateParts[0];
        this.endDate = endDateParts[0] !== ' ' ? formComponentUtil.formatDateWithDefaultPreferences(endDateParts[0], false) : endDateParts[0];
        this.origStartDate = this.startDate;
        this.origEndDate = this.endDate;
        if (this.startDate !== ' ' && startDateParts.length === 1 || this.endDate !== ' ' && endDateParts.length === 1) {
          // timezone offset is missing
          this.updateValue();
        }
      }
    }
    localization.getTranslationByKey('advancedFilter.dateRange').then(function (translation) {
      this.startDatePlaceHolder = translation.startDatePlaceHolder;
      this.endDatePlaceHolder = translation.endDatePlaceHolder;
    }.bind(this));
  };
  this.handleStartClick = function (event) {
    var isToggleSelected = event ? $(event.target).hasClass('toggleCalendarPopup') : false;
    if (this.startPopupOpen && isToggleSelected) {
      this.startPopupOpen = false;
      return;
    }
    if (this.startPopupOpen) {
      this.startDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedDate, false);
      this.updateValue();
      this.startPopupOpen = !this.startPopupOpen;
    } else {
      timeoutList.push($timeout(function () {
        this.startPopupOpen = !this.startPopupOpen;
        this.resetMonthView();
        this.selectedDate = this.selectedStartDate;
      }.bind(this)));
    }
  };
  this.handleEndClick = function (event) {
    var isToggleSelected = event ? $(event.target).hasClass('toggleCalendarPopup') : false;
    if (this.endPopupOpen && isToggleSelected) {
      this.endPopupOpen = false;
      return;
    }
    if (this.endPopupOpen) {
      this.endDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedDate, false);
      this.updateValue();
      this.endPopupOpen = !this.endPopupOpen;
    } else {
      timeoutList.push($timeout(function () {
        this.endPopupOpen = !this.endPopupOpen;
        this.resetMonthView();
        this.selectedDate = this.selectedEndDate;
      }.bind(this)));
    }
  };
  this.handleChange = function (event) {
    var isDaySelected = event ? $(event.target).parents('.uib-day').length > 0 : false;
    if (isDaySelected) {
      if (this.startPopupOpen) {
        this.startDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedDate, false);
      }
      if (this.endPopupOpen) {
        this.endDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedDate, false);
      }
      if (!_.isNil(this.endDate) && this.endDateValidationErrorMessage) {
        if (dateUtil.isBefore(this.endDate, this.startDate)) {
          this.endDate = '';
          $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, this.endDateValidationErrorMessage);
        }
      }
      this.updateValue();
      this.startPopupOpen = false;
      this.endPopupOpen = false;
    }
  };
  this.handleBlur = function () {
    var selectedStartDateCleared,
      selectedEndDateCleared,
      updateStartDate = true,
      updateEndDate = true;
    this.selectedStartDate = formComponentUtil.dateFromInput(this.startDate, false);
    this.selectedEndDate = formComponentUtil.dateFromInput(this.endDate, false);
    selectedStartDateCleared = _.isUndefined(this.selectedStartDate) && !_.isUndefined(this.startDate);
    selectedEndDateCleared = _.isUndefined(this.selectedEndDate) && !_.isUndefined(this.endDate);
    if (!this.allowDateClearing) {
      if (!this.allowIndependentDates) {
        if (selectedStartDateCleared || selectedEndDateCleared) {
          this.startDate = this.origStartDate;
          this.endDate = this.origEndDate;
          updateStartDate = false;
          updateEndDate = false;
        }
      } else {
        if (selectedStartDateCleared) {
          this.startDate = this.origStartDate;
          updateStartDate = false;
        }
        if (selectedEndDateCleared) {
          this.endDate = this.origEndDate;
          updateEndDate = false;
        }
      }
    }
    if (updateStartDate) {
      this.startDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedStartDate, false);
    }
    if (updateEndDate) {
      this.endDate = formComponentUtil.formatDateWithDefaultPreferences(this.selectedEndDate, false);
    }
    if (updateStartDate || updateEndDate) {
      this.updateValue();
    }
  };
  this.resetMonthView = function () {
    if (_.isUndefined(this.startDate) || this.startDate === '') {
      this.selectedStartDate = undefined;
    } else {
      this.selectedStartDate = formComponentUtil.dateFromInput(this.startDate, false);
    }
    if (_.isUndefined(this.endDate) || this.endDate === '') {
      this.selectedEndDate = undefined;
    } else {
      this.selectedEndDate = formComponentUtil.dateFromInput(this.endDate, false);
    }
  };
  this.updateValue = function () {
    var startDateTimezoneOffset = '+0000',
      endDateTimezoneOffset = '+0000',
      startDateMoment,
      endDateMoment,
      startDate_MM_DD_YYYY_ZZ,
      endDate_MM_DD_YYYY_ZZ;
    if (_.isNil(this.startDate) && _.isNil(this.endDate)) {
      this.dateValue = 'ALL';
    } else {
      if (!this.allowIndependentDates && this.startDate !== this.origStartDate) {
        this.endDate = formComponentUtil.formatDateWithDefaultPreferences(moment(this.startDate).add(1, 'year'), false);
      }

      // convert the formatted date values (can be in MM/DD/YY, MM/DD/YYYY, DD/MM/YYYY) to a moment so that dateValue can be normalized
      startDateMoment = moment(formComponentUtil.dateFromInput(this.startDate, false));
      endDateMoment = moment(formComponentUtil.dateFromInput(this.endDate, false));

      // calculate the timezone offset based on the date; e.g. offset is different during Day Light Savings
      if (this.timezoneMode === 'local') {
        if (this.startDate) {
          startDateTimezoneOffset = startDateMoment.format('ZZ');
        }
        if (this.endDate) {
          endDateTimezoneOffset = endDateMoment.format('ZZ');
        }
      }
      startDate_MM_DD_YYYY_ZZ = this.startDate ? startDateMoment.format('MM/DD/YYYY') + startDateTimezoneOffset : ' ';
      endDate_MM_DD_YYYY_ZZ = this.endDate ? endDateMoment.format('MM/DD/YYYY') + endDateTimezoneOffset : ' ';

      // store in the format SPECIFIED::MM/DD/YYYYZZ::MM/DD/YYYYZZ where ZZ is the offset, e.g. +0000, -0400, etc...
      this.dateValue = 'SPECIFIED::' + startDate_MM_DD_YYYY_ZZ + '::' + endDate_MM_DD_YYYY_ZZ;
    }
    this.origStartDate = this.startDate;
    this.origEndDate = this.endDate;
    this.valueUpdated({
      value: this.dateValue
    });
  };
  this.isToday = function (date, mode) {
    var today = new Date(),
      year = today.getFullYear();
    today.setHours(12, 0, 0, 0);
    if (today.toDateString() === date.toDateString() || mode === 'year' && year === date.getFullYear()) {
      return 'today';
    }
  };
  this.handleClose = function () {
    this.startPopupOpen = false;
    this.endPopupOpen = false;
  };
  this.handleKeydown = function (event) {
    if (event.which === 9) {
      this.startPopupOpen = false;
      this.endPopupOpen = false;
    }
    return false;
  };
  $scope.$on(coreConstant.event.REFRESH_DATE_RANGE, function (event) {
    this.init();
  }.bind(this));
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
};
DateRangeController.$inject = ["$scope", "$rootScope", "$timeout", "formComponentUtil", "localization", "dateUtil", "coreConstant"];
angular.module('umCore').controller('dateRangeController', DateRangeController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

var path = '/ui/advancedFilter/component/selectFilter/selectFilter.tpl.html';
var html = "<div class=\"filterCriterionContainer {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\">\n\n    <!--Input-->\n    <div class=\"componentInputContainer {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\"\n         ng-class=\"{'open': $ctrl.isOpen}\">\n\n        <div class=\"labelContainer {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\">\n            {{ ::$ctrl.criterionTemplate.name }}:\n        </div>\n\n        <ui-select ng-if=\"!$ctrl.multiSelect\"\n                   class=\"dropdownComponentSelect {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\"\n                   ng-model=\"$ctrl.dropdownSelectedValue\"\n                   value=\"{{$ctrl.dropdownSelectedValue}}\"\n                   theme=\"select2\"\n                   on-select=\"$ctrl.handleSelect($select)\"\n                   on-remove=\"$ctrl.handleSelect($select)\"\n                   append-to-body=\"true\"\n                   placeholder=\"{{::$ctrl.placeholder}}\"\n                   dropdown-unselect-item=\"{{ ::$ctrl.filterDropdownIdentifier }}\"\n                   dropdown-handle-focus\n                   ui-hide-select-on-scroll\n                   ui-hide-select-on-scroll-selector=\".content\">\n\n            <ui-select-match placeholder=\"{{::$ctrl.placeholder}}\" allow-clear=\"true\">\n                <span class=\"{{::$ctrl.formatAsSelector($select.selected.name)}}\"\n                      ng-bind=\"$select.selected.name\"></span>\n            </ui-select-match>\n\n            <ui-select-choices refresh=\"$ctrl.filterItems($select.search)\"\n                               refresh-delay=\"250\"\n                               repeat=\"item in $ctrl.filteredItemsList\"\n                               group-by=\"'grouping'\"\n                               ui-disable-choice=\"item.value == undefined\">\n                <span class=\"option {{::$ctrl.formatAsSelector(item.name)}}\"\n                      ng-bind=\"item.name\"\n                      ng-class=\"{'warning': item.warning}\"></span>\n            </ui-select-choices>\n\n        </ui-select>\n\n        <ui-multi-select ng-if=\"$ctrl.multiSelect\"\n                         items-list=\"$ctrl.itemsList\"\n                         append-to-body=\"$ctrl.appendToBody\"\n                         selected-value=\"$ctrl.criterionTemplate.value\"\n                         item-name=\"::($ctrl.advancedFilterType+'_'+$ctrl.criterionTemplate.name)\"\n                         prompt-value=\"::$ctrl.placeholder\"></ui-multi-select>\n\n        <div class=\"removeButton {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }} glyphicon glyphicon-remove\"\n             ng-click=\"$ctrl.handleRemove()\"\n             ui-tooltip></div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

var SelectFilterComponent = {
  templateUrl: '/ui/advancedFilter/component/selectFilter/selectFilter.tpl.html',
  controller: 'selectFilterController',
  bindings: {
    criterionTemplate: '<',
    multiSelect: '<',
    submission: '<',
    advancedFilterType: '<',
    translationsKey: '<?'
  }
};
angular.module('umCore').component('uiSelectFilter', SelectFilterComponent);

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var SelectFilterController = function SelectFilterController($scope, $q, $element, $filter, $timeout, advancedFilterModel, coreConstant, coreMediator, formatUtil, localization, dataSetUtil) {
  this.appendToBody = true;
  this.filterDropdownIdentifier = 'filterDropdown';
  var itemLongList = {
      warning: true,
      disabled: true,
      'name': null
    },
    timeoutList = [];
  this.$onInit = function () {
    var _this = this;
    var criterionTemplate = this.criterionTemplate,
      dataSetName = criterionTemplate.dataSetName,
      submissionUri = !_.isNil(this.submissionId) ? 'com.firstbest.underwriting.submission.Submission:' + this.submissionId : null,
      variableName = criterionTemplate.variableName,
      dataSetParams = dataSetUtil.getDataSetParamsByName(dataSetName, variableName, submissionUri);
    this.tooltip = {
      delay: 750
    };
    localization.getTranslationsByKeys([this.translationsKey, 'advancedFilter']).then(function (translations) {
      _this.placeholder = _.get(translations.selectFilter, _this.criterionTemplate.variableName + '.placeholder') || translations.placeholder;
      _this.tooltip.message = translations.removeButtonTooltip;
    });
    localization.getTranslationByKey('formsViewer.controls.dropdown.longListWarning').then(function (text) {
      itemLongList.name = text;
    });
    this.itemsList = [];
    this.isOpen = true;
    return dataSetUtil.getDataItems(dataSetParams).then(function (items) {
      this.setItemsList(items);
      //     return items;
    }.bind(this));
  };
  this.formatAsSelector = function (nameString) {
    return nameString ? formatUtil.formatAsSelector(nameString) : '';
  };
  this.setItemsList = function (itemsList) {
    this.itemsList = itemsList;
    this.filterItems();
    this.updateDropdownSelectedValue();
  };
  this.filterItems = function (searchText) {
    var filteredItemsList = [];
    if (!_.isEmpty(searchText)) {
      filteredItemsList = _.filter(this.itemsList, function (item) {
        return _.includes(item.name.toLowerCase(), searchText.toLowerCase());
      });
    } else if (_.isArray(this.itemsList)) {
      filteredItemsList = this.itemsList;
    }
    if (filteredItemsList.length > 150) {
      this.showLongListWarning(filteredItemsList.length);
    } else {
      this.filteredItemsList = filteredItemsList;
    }
  };
  this.showLongListWarning = function (listLength) {
    var item = _.clone(itemLongList);
    item.name = _.replace(item.name, '{0}', $filter('number')(listLength));
    this.filteredItemsList = [item];
    this.isSpecialMessageDisplayed = true;
  };
  this.updateDropdownSelectedValue = function () {
    var criterionValue = this.criterionTemplate.value,
      selectedValue = null;
    if (!_.isNil(criterionValue)) {
      selectedValue = _.find(this.itemsList, {
        value: criterionValue
      });
      if (!_.isNil(selectedValue)) {
        this.dropdownSelectedValue = selectedValue;
      } else {
        this.dropdownSelectedValue = _.intersectionWith(this.itemsList, _.split(criterionValue, '::'), function (dataItem, criterionItem) {
          if (dataItem.value === criterionItem) {
            dataItem.selected = true;
            return true;
          } else {
            return false;
          }
        });
      }
    } else {
      this.dropdownSelectedValue = null;
    }
    $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, this.dropdownSelectedValue, this.filterDropdownIdentifier);
  };
  $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, _.debounce(function (event, itemName) {
    if (this.advancedFilterType + '_' + this.criterionTemplate.name === itemName) {
      var tempItemList = _.filter(this.itemsList, function (item) {
          return item.selected;
        }),
        values = _.map(tempItemList, 'value');
      values = _.join(values, '::');
      if (this.criterionTemplate.value !== values) {
        this.criterionTemplate.value = values;
        $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
      }
    }
  }.bind(this)), 500);
  this.handleSelect = function (select) {
    this.select = select;
    var selectedItems = null;
    if (!_.isNil(select.selected)) {
      // don't reset the selected value if it's a warning
      if (_.isNil(select.selected.value) && this.isSpecialMessageDisplayed) {
        select.selected = null;
        return;
      }
      selectedItems = select.selected.value;
    }
    this.criterionTemplate.value = selectedItems;
    $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, this.dropdownSelectedValue, this.filterDropdownIdentifier);
    $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
  };
  this.getComponentId = function (filterCriterionTemplate) {
    return this.advancedFilterType + 'AdvancedFilterType ' + filterCriterionTemplate.variableName;
  };
  this.handleRemove = function () {
    advancedFilterModel.unselectFilterCriterion(this.advancedFilterType, this.criterionTemplate.id);
    $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
  };
  $scope.$on(coreConstant.event.FILTER_CLEARED, function (event, criterionTemplateId) {
    if (criterionTemplateId === this.criterionTemplate.id) {
      this.criterionTemplate.value = null;
      this.updateDropdownSelectedValue();
    }
  }.bind(this));
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
};
SelectFilterController.$inject = ["$scope", "$q", "$element", "$filter", "$timeout", "advancedFilterModel", "coreConstant", "coreMediator", "formatUtil", "localization", "dataSetUtil"];
angular.module('umCore').controller('selectFilterController', SelectFilterController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

var path = '/ui/advancedFilter/component/textInputFilter/textInputFilter.tpl.html';
var html = "<div class=\"filterCriterionContainer {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\">\n    <!--Input-->\n    <div class=\"componentInputContainer {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\"\n         ng-class=\"{'open': $ctrl.isOpen}\">\n        <div class=\"labelContainer {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\">\n            {{ ::$ctrl.criterionTemplate.name }}:\n        </div>\n        <div>\n            <span class=\"glyphicon glyphicon-search filterSearch\"></span>\n            <input type=\"text\"\n                   class=\"ui-display-dollar {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\"\n                   ng-class=\"{ 'ui-currency-formatter': $ctrl.isCurrency }\"\n                   ng-model=\"$ctrl.criterionTemplate.value\"\n                   ng-model-options=\"{ debounce: $ctrl.searchDelayInMilliSeconds }\"\n                   ng-change=\"$ctrl.handleChange()\"\n                   placeholder=\"{{::$ctrl.placeholder}}\"\n                   ui-auto-focus=\"{{ $ctrl.isInsured && !$ctrl.disableAutoFocus }}\"\n                   ui-currency-formatter\n            />\n        </div>\n        <div class=\"removeButton {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }} glyphicon glyphicon-remove\"\n             ng-click=\"$ctrl.handleRemove()\"\n             ui-tooltip></div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

var TextInputFilterComponent = {
  templateUrl: '/ui/advancedFilter/component/textInputFilter/textInputFilter.tpl.html',
  controller: 'textInputFilterController',
  bindings: {
    criterionTemplate: '<',
    advancedFilterType: '<',
    translationsKey: '<?',
    disableAutoFocus: '<?'
  }
};
angular.module('umCore').component('uiTextInputFilter', TextInputFilterComponent);

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var TextInputFilterController = function TextInputFilterController($scope, advancedFilterModel, coreConstant, submissionConstant, localization) {
  this.$onInit = function () {
    var _this = this;
    this.searchDelayInMilliSeconds = submissionConstant.searchDelay;
    this.tooltip = {
      delay: 750
    };
    localization.getTranslationsByKeys([this.translationsKey, 'advancedFilter']).then(function (translations) {
      _this.placeholder = _.get(translations.textInputFilter, _this.criterionTemplate.variableName + '.placeholder') || translations.placeholder;
      _this.tooltip.message = translations.removeButtonTooltip;
    });
    if (_.includes(_.toLower(this.criterionTemplate.name), 'premium')) {
      this.isCurrency = true;
    }
    if (_.includes(_.toLower(this.criterionTemplate.name), 'insured')) {
      this.isInsured = true;
    }
    this.isOpen = true;
  };
  this.handleChange = function () {
    $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
  };
  this.getComponentId = function (filterCriterionTemplate) {
    return this.advancedFilterType + 'AdvancedFilterType ' + filterCriterionTemplate.variableName;
  };
  this.handleRemove = function () {
    advancedFilterModel.unselectFilterCriterion(this.advancedFilterType, this.criterionTemplate.id);
    $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
  };
  $scope.$on(coreConstant.event.FILTER_CLEARED, function (event, criterionTemplateId) {
    if (criterionTemplateId === this.criterionTemplate.id) {
      this.criterionTemplate.value = '';
    }
  }.bind(this));
};
TextInputFilterController.$inject = ["$scope", "advancedFilterModel", "coreConstant", "submissionConstant", "localization"];
angular.module('umCore').controller('textInputFilterController', TextInputFilterController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

var path = '/ui/advancedFilter/component/typeAheadFilter/typeAheadFilter.tpl.html';
var html = "<div class=\"filterCriterionContainer {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\">\n    <!--Input-->\n    <div class=\"componentInputContainer {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\"\n         ng-class=\"{'open': $ctrl.isOpen}\">\n        <div class=\"labelContainer {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\">\n            {{ ::$ctrl.criterionTemplate.name }}:\n        </div>\n        <input type=\"text\"\n               class=\"{{ ::$ctrl.criterionTemplate.variableName}}\"\n               ng-model=\"$ctrl.criterionTemplate.value\"\n               uib-typeahead=\"dataItem as dataItem.name for dataItem in $ctrl.itemsList | filter:{name:$viewValue}\"\n               typeahead-show-hint=\"true\"\n               typeahead-min-length=\"0\"\n               typeahead-on-select=\"$ctrl.handleChange()\"\n               ng-change=\"$ctrl.handleChange()\">\n        <div class=\"removeButton {{ ::$ctrl.criterionTemplate.variableName}} glyphicon glyphicon-remove\" ng-click=\"$ctrl.handleRemove()\"></div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

var TypeAheadFilterComponent = {
  templateUrl: '/ui/advancedFilter/component/typeAheadFilter/typeAheadFilter.tpl.html',
  controller: 'typeAheadFilterController',
  bindings: {
    criterionTemplate: '<',
    submissionId: '<',
    advancedFilterType: '<',
    translationsKey: '<?'
  }
};
angular.module('umCore').component('uiTypeAheadFilter', TypeAheadFilterComponent);

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var TypeAheadFilterController = function TypeAheadFilterController($scope, $q, $element, advancedFilterModel, coreConstant, coreMediator, submissionConstant, localization, dataSetUtil) {
  this.$onInit = function () {
    var _this = this;
    var criterionTemplate = this.criterionTemplate,
      dataSetName = criterionTemplate.dataSetName,
      submissionUri = !_.isNil(this.submissionId) ? 'com.firstbest.underwriting.submission.Submission:' + this.submissionId : null,
      variableName = criterionTemplate.variableName,
      dataSetParams = dataSetUtil.getDataSetParamsByName(dataSetName, variableName, submissionUri);
    this.searchDelayInMilliSeconds = submissionConstant.searchDelay;
    this.itemsList = [];
    this.isOpen = true;
    localization.getTranslationsByKeys([this.translationsKey, 'advancedFilter']).then(function (translations) {
      _this.placeholder = _.get(translations.typeAheadFilter, _this.criterionTemplate.variableName + '.placeholder') || translations.placeholder;
    });
    return dataSetUtil.getDataItems(dataSetParams).then(function (items) {
      if (!_.isNil(items)) {
        _.each(items, function (item) {
          if (item && item.isDefault) {
            this.criterionTemplate.value = item.name;
          }
        }.bind(this));
        $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType, true);
        this.setItemsList(items);
        return items;
      }
    }.bind(this));
  };
  this.setItemsList = function (itemsList) {
    this.itemsList = itemsList;
    this.filterItems();
  };
  this.filterItems = function (searchText) {
    var filteredItemsList = [];
    if (!_.isEmpty(searchText)) {
      filteredItemsList = _.filter(this.itemsList, function (item) {
        return _.includes(_.toLower(item.name), _.toLower(searchText));
      });
    } else if (_.isArray(this.itemsList)) {
      filteredItemsList = this.itemsList;
    }
    if (this.searchableList && filteredItemsList.length > 150) {
      this.showLongListWarning(filteredItemsList.length);
    } else {
      this.filteredItemsList = filteredItemsList;
    }
  };
  this.handleChange = function () {
    if (!_.isNil(this.criterionTemplate.value) && !_.isNil(this.criterionTemplate.value.name)) {
      this.criterionTemplate.value = this.criterionTemplate.value.name;
    }
    $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
  };
  this.getComponentId = function (filterCriterionTemplate) {
    return this.advancedFilterType + 'AdvancedFilterType ' + filterCriterionTemplate.variableName;
  };
  this.handleRemove = function () {
    advancedFilterModel.unselectFilterCriterion(this.advancedFilterType, this.criterionTemplate.id);
    $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
  };
  $scope.$on(coreConstant.event.FILTER_CLEARED, function (event, criterionTemplateId) {
    if (criterionTemplateId === this.criterionTemplate.id) {
      this.criterionTemplate.value = '';
    }
  }.bind(this));
};
TypeAheadFilterController.$inject = ["$scope", "$q", "$element", "advancedFilterModel", "coreConstant", "coreMediator", "submissionConstant", "localization", "dataSetUtil"];
angular.module('umCore').controller('typeAheadFilterController', TypeAheadFilterController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

var path = '/ui/advancedFilter/component/unselectedFilter/unselectedFilter.tpl.html';
var html = "<div class=\"filterCriterionContainer {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\">\n\n    <!--Input-->\n    <div class=\"componentInputContainer {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\"\n         ng-class=\"{'open': $ctrl.isOpen}\">\n\n        <ui-select class=\"dropdownComponentSelect unselectedFilterDropDown {{::$ctrl.criterionTemplate.variableName}}\"\n                   ng-model=\"$ctrl.value\"\n                   theme=\"select2\"\n                   on-select=\"$ctrl.handleSelect($select)\"\n                   append-to-body=\"true\"\n                   placeholder=\"{{::$ctrl.placeholder}}\"\n                   sortable=\"true\"\n                   dropdown-unselect-item\n                   dropdown-handle-focus\n                   ui-hide-select-on-scroll\n                   ui-hide-select-on-scroll-selector=\".content\">\n\n            <ui-select-match placeholder=\"{{::$ctrl.placeholder}}\" allow-clear=\"true\"\n                             ng-mousedown=\"$ctrl.handleClick()\">\n                <span class=\"{{::$ctrl.formatAsSelector($select.selected.name)}}\"\n                      ng-bind=\"$select.selected.name\"></span>\n            </ui-select-match>\n\n            <ui-select-choices refresh=\"$ctrl.filterItems($select.search)\"\n                               refresh-delay=\"250\"\n                               repeat=\"item in $ctrl.filteredItemsList\">\n                <span class=\"criteria option {{::$ctrl.formatAsSelector(item.name)}}\"\n                      ng-bind=\"item.name\"\n                      ng-class=\"{'warning': item.warning}\"></span>\n            </ui-select-choices>\n\n        </ui-select>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

var UnselectedFilterComponent = {
  templateUrl: '/ui/advancedFilter/component/unselectedFilter/unselectedFilter.tpl.html',
  controller: 'unselectedFilterController',
  bindings: {
    filterModel: '<',
    advancedFilterType: '<',
    translationsKey: '<?'
  }
};
angular.module('umCore').component('uiUnselectedFilter', UnselectedFilterComponent);

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UnselectedFilterController = function UnselectedFilterController($scope, coreConstant, advancedFilterModel, localization, formatUtil) {
  this.$onInit = function () {
    var _this = this;
    this.isOpen = true;
    localization.getTranslationsByKeys([this.translationsKey, 'advancedFilter']).then(function (translations) {
      _this.placeholder = _.get(translations.unselectedFilter, 'placeholder') || translations.placeholder;
    });
  };
  this.formatAsSelector = function (nameString) {
    return nameString ? formatUtil.formatAsSelector(nameString) : '';
  };
  this.handleClick = function () {
    this.filteredItemsList = this.filterModel.unselectedFilterCriterionTemplates;
  };
  this.handleSelect = function ($select) {
    var selectedFilterCriterionTemplate = $select.selected;
    advancedFilterModel.selectFilterCriterion(this.advancedFilterType, selectedFilterCriterionTemplate.id);
    $select.selected = null;
  };
  this.filterItems = function (searchText) {
    var filteredItemsList = [],
      itemList = !_.isNil(this.filterModel) ? this.filterModel.unselectedFilterCriterionTemplates : [];
    if (!_.isEmpty(searchText)) {
      filteredItemsList = _.filter(itemList, function (item) {
        return _.includes(item.name.toLowerCase(), searchText.toLowerCase());
      });
    } else if (_.isArray(itemList)) {
      filteredItemsList = itemList;
    }
    this.filteredItemsList = filteredItemsList;
  };
  $scope.$on(coreConstant.event.FILTER_CLEARED, function (event, criterionTemplateId) {
    if (criterionTemplateId === this.criterionTemplate.id) {
      this.criterionTemplate.value = '';
    }
  }.bind(this));
};
UnselectedFilterController.$inject = ["$scope", "coreConstant", "advancedFilterModel", "localization", "formatUtil"];
angular.module('umCore').controller('unselectedFilterController', UnselectedFilterController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

var path = '/ui/advancedFilter/component/yesNoFilter/yesNoFilter.tpl.html';
var html = "\n<div class=\"filterCriterionContainer {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\">\n    <div class=\"componentLabelContainer\"\n         ng-class=\"{'open': $ctrl.isOpen}\">\n        <div class=\"labelContainer {{ ::$ctrl.getComponentId($ctrl.criterionTemplate) }}\">\n            {{ ::$ctrl.criterionTemplate.name }}\n        </div>\n        <div class=\"removeButton glyphicon glyphicon-remove\"\n             ng-click=\"$ctrl.handleRemove()\"\n             ui-tooltip></div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

var YesNoFilterComponent = {
  templateUrl: '/ui/advancedFilter/component/yesNoFilter/yesNoFilter.tpl.html',
  controller: 'yesNoFilterController',
  bindings: {
    criterionTemplate: '<',
    advancedFilterType: '<',
    translationsKey: '<?'
  }
};
angular.module('umCore').component('uiYesNoFilter', YesNoFilterComponent);

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

/*@ngInject*/
var YesNoFilterController = function YesNoFilterController($scope, coreConstant, advancedFilterModel, localization) {
  this.$onInit = function () {
    var _this = this;
    this.tooltip = {
      delay: 750
    };
    localization.getTranslationsByKeys([this.translationsKey, 'advancedFilter']).then(function (translations) {
      _this.tooltip.message = translations.removeButtonTooltip;
    });
    if (this.criterionTemplate.value !== '0') {
      this.criterionTemplate.value = '0';
      $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
    }
    this.isOpen = true;
  };
  this.handleRemove = function () {
    advancedFilterModel.unselectFilterCriterion(this.advancedFilterType, this.criterionTemplate.id);
    $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
  };
};
YesNoFilterController.$inject = ["$scope", "coreConstant", "advancedFilterModel", "localization"];
angular.module('umCore').controller('yesNoFilterController', YesNoFilterController);

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

var path = '/ui/advancedFilter/saveAs/saveFilterAsModal.tpl.html';
var html = "<base-modal\n    modal-title=\"title\"\n    ok=\"saveButton\"\n    cancel=\"cancelButton\"\n    is-confirm-disabled=\"!canEnableConfirmButton()\"\n    on-cancel=\"onCancel()\"\n    on-confirm=\"onConfirm()\">\n\n    <div class=\"saveFilterAsModalContent\">\n        <!--Content-->\n        <div class=\"drawer\">\n            <div class=\"drawerRow\">\n                <div class=\"drawerCol\">\n                    <ui-required-indicator class=\"requiredIndicator\"\n                                           value=\"{{viewModel.filterName}}\"\n                                           validator=\"canEnableConfirmButton()\">\n                    </ui-required-indicator>\n                    <label ui-translate>advancedFilter.saveFilterAs.filterLabel</label>\n                </div>\n                <div class=\"drawerCol\">\n                    <label>\n                        <input type=\"text\" class=\"filterNameTextfield\"\n                               name=\"filterName\"\n                               ng-model=\"viewModel.filterName\"\n                               maxlength=\"75\">\n                    </label>\n                </div>\n            </div>\n            <div class=\"drawerRow\">\n                <label class=\"warning\"\n                       ng-if=\"!isFilterNameAvailable()\"\n                       ui-translate=\"\">advancedFilter.saveFilterAs.duplicateWarning</label>\n            </div>\n        </div>\n    </div>\n\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var SaveFilterAsModalController = function SaveFilterAsModalController($rootScope, $scope, filters, localization, coreConstant) {
  localization.getTranslations().then(function (translations) {
    $scope.title = _.get(translations, 'advancedFilter.saveFilterAs.title');
    $scope.saveButton = _.get(translations, 'advancedFilter.saveFilterAs.saveAsButton');
    $scope.cancelButton = _.get(translations, 'advancedFilter.saveFilterAs.cancelButton');
    $scope.viewModel = {
      filterName: ''
    };
    $scope.canEnableConfirmButton = function () {
      return $scope.viewModel.filterName.length > 0 && $scope.isFilterNameAvailable();
    };
    $scope.onConfirm = function () {
      $scope.$close({
        filterName: $scope.viewModel.filterName
      });
    };
    $scope.onCancel = function () {
      $scope.$dismiss();
    };
    $scope.isFilterNameAvailable = function () {
      var isAvailable = true;
      _.each(filters, function (filter) {
        if ($scope.viewModel.filterName === filter.name) {
          isAvailable = false;
        }
      });
      return isAvailable;
    };
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
SaveFilterAsModalController.$inject = ["$rootScope", "$scope", "filters", "localization", "coreConstant"];
angular.module('umCore').controller('saveFilterAsModalController', SaveFilterAsModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1396 */,
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UIUserAvatarDirective = function UIUserAvatarDirective($rootScope, $stateParams, $timeout, coreMediator, coreConstant, currentSubmissionModel) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    $scope.isLoading = false;
    $scope.isMouseEnterInProgress = false;
    $scope.$watch('src', function (newValue) {
      if (newValue) {
        $scope.hasAvatar = !!newValue;
        var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
        if (base64regex.test($scope.src)) {
          $scope.underwriterImage = 'data:image/png;base64,' + $scope.src;
        }
      }
    });
    $scope.$watch('userid', function (userid, userIdOrig) {
      var avatarNotLoaded = !$scope.hasAvatar,
        newUserSelected = userid !== userIdOrig;
      if (avatarNotLoaded || newUserSelected) {
        loadProfileImage(userid);
      }
    });
    $scope.mouseEnter = function (event) {
      if (!$rootScope.isBusinessCardFreezed) {
        $scope.isMouseEnterInProgress = true;
        $scope.mouseEnterTimer = $timeout(function () {
          if ($scope.isMouseEnterInProgress) {
            $scope.showBusinessCard(event);
          }
          $scope.isMouseEnterInProgress = false;
        }, 1000);
      }
    };
    $scope.mouseLeave = function () {
      if (!$rootScope.isBusinessCardFreezed) {
        $timeout.cancel($scope.mouseEnterTimer);
        $scope.isMouseEnterInProgress = false;
        $timeout.cancel($scope.mouseLeaveTimer);
        $scope.mouseLeaveTimer = $timeout(function () {
          $rootScope.$broadcast(coreConstant.event.HIDE_BUSINESS_CARD);
        }, 1000);
      }
    };
    $scope.$on(coreConstant.event.HIDE_BUSINESS_CARD_ON_DROPDOWN, function () {
      $scope.isMouseEnterInProgress = false;
      $rootScope.$broadcast(coreConstant.event.HIDE_BUSINESS_CARD);
    });
    $scope.avatarClick = function () {
      $rootScope.$broadcast(coreConstant.event.HIDE_BUSINESS_CARD);
    };
    $scope.showBusinessCard = function (event) {
      var avatarUserId = $scope.usersummary ? JSON.parse($scope.usersummary).id : parseInt($scope.userid);
      if (avatarUserId && !$scope.disablebusinesscard) {
        var submissionId = $scope.submissionid ? $scope.submissionid : $stateParams.submissionId;
        if (!submissionId && currentSubmissionModel && currentSubmissionModel.getCurrentSubmission()) {
          submissionId = currentSubmissionModel.getCurrentSubmission().id;
        }
        $rootScope.$broadcast(coreConstant.event.SHOW_USER_BUSINESS_CARD, event, $scope.usersummary, parseInt($scope.userid), $scope.isGroup, submissionId, $scope.hasBusinessCard, $scope.notificationId, $scope.chatMessageId, $scope.emailMessageId);
      } else if ($scope.organizationId && !$scope.disablebusinesscard) {
        $rootScope.$broadcast(coreConstant.event.SHOW_ORGANIZATION_CARD, event, $scope.organizationId);
      }
    };
    $scope.$on(coreConstant.event.USER_AVATAR_RELOAD, function (arg1, userid) {
      var avatarUserId = $scope.usersummary ? JSON.parse($scope.usersummary).id : parseInt($scope.userid);
      if (avatarUserId === userid) {
        loadProfileImage(userid);
      }
    });
    function loadProfileImage(userid) {
      if (userid && parseInt(userid) > 0 && !_.isEqual($scope.isGroup, 'true')) {
        coreMediator.loadProfileImage(userid).then(function (underwriterImage) {
          $scope.hasAvatar = !!underwriterImage;
          $scope.underwriterImage = 'data:image/png;base64,' + underwriterImage;
        });
      } else {
        $scope.hasAvatar = false;
      }
    }
  };
  return {
    restrict: 'AE',
    scope: {
      src: '@',
      usersummary: '@',
      userid: '@',
      organizationId: '@',
      icon: '@',
      isGroup: '@?',
      hasBusinessCard: '<?',
      submissionid: '@',
      isLoading: '<?',
      disablebusinesscard: '<?',
      disabled: '<?',
      notificationId: '@',
      chatMessageId: '@',
      emailMessageId: '@'
    },
    link: linkFunction,
    templateUrl: '/ui/avatar/uiUserAvatar.tpl.html'
  };
};
UIUserAvatarDirective.$inject = ["$rootScope", "$stateParams", "$timeout", "coreMediator", "coreConstant", "currentSubmissionModel"];
angular.module('umCore').directive('uiUserAvatar', UIUserAvatarDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/ui/avatar/uiUserAvatar.tpl.html';
var html = "<div ng-if=\"!isLoading\"\n     class=\"userAvatar\"\n     ng-class=\"{userBusinessCard : hasBusinessCard,\n                organizationCard: organizationId}\"\n     ng-mouseenter=\"mouseEnter($event)\"\n     ng-mouseleave=\"mouseLeave()\"\n     ng-click=\"avatarClick($event)\"\n     ng-disabled=\"disabled\">\n\n    <img ng-src=\"{{ underwriterImage }}\"\n         ng-if=\"hasAvatar && !isGroup\"/>\n\n    <img ng-src=\"" + __webpack_require__(761) + "\"\n         ng-if=\"!hasAvatar && !isGroup && !organizationId\"/>\n\n    <div class=\"fa fa-building-o orgImage\"\n         ng-if=\"!hasAvatar && !isGroup && organizationId\"></div>\n\n    <img ng-src=\"" + __webpack_require__(1399) + "\"\n         ng-if=\"isGroup\"/>\n\n    <span class=\"userAvatarIcon\" ng-if=\"icon\" ng-switch on=\"icon\" ng-class=\"{'attachmentIcon':icon === 'attachment',\n                                                                             'messageIcon':icon === 'message',\n                                                                             'emailIcon':icon === 'email',\n                                                                             'noteIcon':icon === 'note',\n                                                                             'taskIcon':icon === 'task'}\">\n\n        <img ng-switch-when=\"attachment\"\n             class=\"icon-image icon-collaborationTypeFile\"\n             src=\"" + __webpack_require__(142) + "\"/>\n\n        <img ng-switch-when=\"message\"\n             class=\"icon-image icon-collaborationTypeChat\"\n             src=\"" + __webpack_require__(1400) + "\"/>\n\n        <img ng-switch-when=\"email\"\n             class=\"icon-image icon-collaborationTypeEmail\"\n             src=\"" + __webpack_require__(1401) + "\"/>\n\n        <img ng-switch-when=\"note\"\n             class=\"icon-image icon-collaborationTypeNote\"\n             src=\"" + __webpack_require__(1402) + "\"/>\n\n        <img ng-switch-when=\"task\"\n             class=\"icon-image icon-collaborationTypeTasks\"\n             src=\"" + __webpack_require__(36) + "\"/>\n    </span>\n</div>\n\n<div ng-if=\"isLoading\"\n     class=\"avatarIconSpinner\">\n    <div class=\"icon-spinner\"></div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "83f91e08bf9d90c036639207a5196ba2.png";

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f8ac46ee6f7208cfc5c539b1c25726c0.svg";

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7b7a3c00f68a8874039faf632b3b71d4.svg";

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a6c35e05e25005b1e9b0e7d013e5cb47.svg";

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

var path = '/ui/collapsibleLeftNav/collapsibleLeftNav.tpl.html';
var html = "<div class=\"closedDrawerBackgroundToggle\"\n     ng-if=\"!$ctrl.isDrawerOpen\"\n     ng-click=\"$ctrl.onToggleDrawer()\"></div>\n\n<div class=\"collapsibleLeftNavContent\"\n     ng-if=\"$ctrl.isDrawerOpen\">\n\n    <div ng-transclude class=\"transcludeContainer\"></div>\n\n</div>\n\n<div class=\"drawerControl\"\n     ng-click=\"$ctrl.onToggleDrawer()\"\n     ng-if=\"$ctrl.collapsible\">\n\n        <span class=\"glyphicon\"\n              ng-class=\"{\n                'glyphicon-arrow-left': $ctrl.isDrawerOpen,\n                'glyphicon-arrow-right': !$ctrl.isDrawerOpen\n              }\"></span>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

var CollapsibleLeftNavComponent = {
  templateUrl: '/ui/collapsibleLeftNav/collapsibleLeftNav.tpl.html',
  controller: 'collapsibleLeftNavController',
  transclude: true,
  bindings: {
    collapsible: '<'
  }
};
angular.module('umCore').component('uiCollapsibleLeftNav', CollapsibleLeftNavComponent);

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

/*@ngInject*/
var CollapsibleLeftNavController = function CollapsibleLeftNavController($rootScope, $element, coreConstant) {
  this.$onInit = function () {
    $element.addClass('collapsibleLeftNav');
    this.isDrawerOpen = true;
    $element.addClass('open');
  };
  this.onToggleDrawer = function () {
    if (this.collapsible) {
      this.isDrawerOpen = !this.isDrawerOpen;
      if (this.isDrawerOpen) {
        $element.addClass('open');
        $rootScope.$broadcast(coreConstant.event.COLLAPSIBLE_LEFT_NAV_OPENED);
      } else {
        $element.removeClass('open');
        $rootScope.$broadcast(coreConstant.event.COLLAPSIBLE_LEFT_NAV_CLOSED);
      }
    }
  };
};
CollapsibleLeftNavController.$inject = ["$rootScope", "$element", "coreConstant"];
angular.module('umCore').controller('collapsibleLeftNavController', CollapsibleLeftNavController);

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

var path = '/ui/collapsibleLeftNav/accordionButton/accordionButton.tpl.html';
var html = "<div class=\"navRowContainer\"\n     ng-class=\"{navRowContainerOpen: $ctrl.isOpen}\">\n    <!--Main Nav Button-->\n    <div class=\"btn btn-link navRow\"\n         ng-click=\"$ctrl.onAccordionButtonClick()\"\n         ng-class=\"{ active: $ctrl.isActive, disableUserInteraction: $ctrl.disableUserInteraction }\"\n         ng-disabled=\"$ctrl.isDisabled\">\n\n        <div class=\"activeBar\"></div>\n\n        <div class=\"accordionButtonLabel\">{{ ::$ctrl.label }}</div>\n\n        <div class=\"subTextLabel\">{{ $ctrl.subTextLabel }}</div>\n\n        <button class=\"btn btn-primary customButton\"\n                ng-if=\"$ctrl.showCustomButton\"\n                ng-click=\"$ctrl.onCustomButtonClick($event)\">{{ $ctrl.customButtonLabel }}\n        </button>\n\n        <div class=\"requiredFieldContainer\"\n             ng-if=\"!$ctrl.isOpen\"\n             ng-click=\"$ctrl.onRequiredIndicatorClicked($event)\">\n            <div class=\"label label-warning\"\n                 ng-if=\"$ctrl.requiredFieldCount > 0\" ng-bind=\"$ctrl.requiredFieldCount\"></div>\n        </div>\n\n        <div class=\"treeControlArrow\">\n            <div ng-if=\"$ctrl.hasChildren\">\n                <div class=\"glyphicon glyphicon-chevron-right\"\n                     ng-if=\"!$ctrl.isOpen && !$ctrl.displayCustomIcon() && !$ctrl.disableChevron\"></div>\n\n                <div class=\"glyphicon glyphicon-chevron-down\"\n                     ng-if=\"$ctrl.isOpen && !$ctrl.displayCustomIcon() && !$ctrl.disableChevron\"></div>\n\n                <a class=\"{{ :: $ctrl.customIcon }}\"\n                   ng-if=\"$ctrl.displayCustomIcon()\"\n                   ng-click=\"$ctrl.onCustomIconClick($event)\"></a>\n            </div>\n        </div>\n\n\n    </div>\n\n    <!--Children Nav Buttons-->\n    <div class=\"childButtonContainer\"\n         ng-if=\"$ctrl.isOpen\">\n        <div ng-transclude class=\"transcludeContainer\"></div>\n\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

var AccordionButtonComponent = {
  templateUrl: '/ui/collapsibleLeftNav/accordionButton/accordionButton.tpl.html',
  controller: 'accordionButtonController',
  transclude: true,
  bindings: {
    label: '<',
    subTextLabel: '@',
    value: '<',
    requiredFieldCount: '<',
    onRequiredFieldCountClick: '&?',
    isOpen: '<',
    hasChildren: '<',
    notifyAccordionButtonClick: '&',
    closeOtherAccordionsOnOpen: '<',
    isActive: '<',
    isDisabled: '<',
    disableChevron: '<',
    customIcon: '<?',
    notifyCustomIconClick: '&',
    showCustomButton: '<',
    customButtonLabel: '<',
    notifyCustomButtonClick: '&',
    disableUserInteraction: '<'
  }
};
angular.module('umCore').component('uiAccordionButton', AccordionButtonComponent);

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var AccordionButtonController = function AccordionButtonController($rootScope, $scope, $element, coreConstant) {
  var _this = this;
  this.$onInit = function () {
    $element.addClass('accordionButton');
    if (this.hasChildren && this.isOpen) {
      $element.addClass('open');
    }
  };
  this.onAccordionButtonClick = function () {
    if (!this.disableUserInteraction) {
      if (this.hasChildren) {
        if (this.isOpen) {
          $element.removeClass('open');
        } else {
          $element.addClass('open');
        }
        this.isOpen = !this.isOpen;
      }
      this.notifyAccordionButtonClick({
        value: this.value
      });
      if (this.isOpen) {
        $rootScope.$broadcast(coreConstant.event.ACCORDION_BUTTON_OPENED, {
          value: this.value
        });
      }
    }
  };
  this.displayCustomIcon = function () {
    return !_.isNil(this.customIcon);
  };
  this.onCustomIconClick = function (event) {
    event.stopImmediatePropagation();
    this.notifyCustomIconClick();
  };
  this.onCustomButtonClick = function (event) {
    event.stopImmediatePropagation();
    this.notifyCustomButtonClick();
  };
  this.onRequiredIndicatorClicked = function (event) {
    event.stopImmediatePropagation();
    this.onRequiredFieldCountClick();
  };
  $scope.$on(coreConstant.event.ACCORDION_BUTTON_OPENED, function (event, params) {
    if (_this.closeOtherAccordionsOnOpen && _this.value !== params.value) {
      $element.removeClass('open');
      _this.isOpen = false;
    }
  });
  $scope.$on(coreConstant.event.CLOSE_ACCORDION_BUTTON, function (event, params) {
    if (_this.value === params.value) {
      $element.removeClass('open');
      _this.isOpen = false;
    }
  });
  $scope.$on(coreConstant.event.OPEN_ACCORDION_BUTTON, function (event, params) {
    if (_this.value === params.value) {
      $element.addClass('open');
      _this.isOpen = true;
      $rootScope.$broadcast(coreConstant.event.ACCORDION_BUTTON_OPENED, {
        value: _this.value
      });
    }
  });
};
AccordionButtonController.$inject = ["$rootScope", "$scope", "$element", "coreConstant"];
angular.module('umCore').controller('accordionButtonController', AccordionButtonController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

var path = '/ui/columnSort/gridSortableHeader.tpl.html';
var html = "<div class=\"col sortable sideBar\" ng-click=\"toggleSort()\">\n    <div class=\"columnLabel\"\n         ng-class=\"{ sortHeader: key === requestParams.key }\">\n\n        <span ui-translate>{{ itemLabel }}</span>\n\n        <ui-sort-icons column-id=\"{{ key }}\"></ui-sort-icons>\n\n    </div>\n\n    <div class=\"columnResizeHandle\"\n    \tng-if=\"resizable\"\n        ui-column-resize\n        ui-column-resize-identifier=\"{{ itemLabel }}\">\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

var path = '/ui/columnSort/sortIcons.tpl.html';
var html = "<span class=\"sortIcons\">\n\n    <span class=\"glyphicon glyphicon-chevron-up\"\n         ng-if=\"!getIconDisabledState('asc')\"> </span>\n\n    <span class=\"glyphicon glyphicon-chevron-down\"\n          ng-if=\"!getIconDisabledState('desc')\"> </span>\n\n</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

/*@ngInject*/
var UIGridSortableHeaderDirective = function UIGridSortableHeaderDirective(coreConstant) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    $scope.key = $attrs.itemName;
    $scope.toggleSort = function () {
      $scope.requestParams.key = $scope.key;
      if ($scope.requestParams.sortType === 'desc') {
        $scope.requestParams.sortType = 'asc';
      } else {
        $scope.requestParams.sortType = 'desc';
      }
      $scope.resetGridHeaders({
        $value: $scope.requestParams
      });
      $scope.onToggle({
        params: {
          key: $scope.key,
          sortType: $scope.requestParams.sortType
        }
      });
    };
    $scope.$on(coreConstant.event.DATAGRID_ON_RESET_HEADERS, function (evt, requestParams) {
      $scope.requestParams = requestParams;
    });
  };
  return {
    restrict: 'AE',
    replace: true,
    scope: {
      itemLabel: '@',
      resizable: '<',
      requestParams: '<',
      resetGridHeaders: '&',
      onToggle: '&'
    },
    link: linkFunction,
    templateUrl: '/ui/columnSort/gridSortableHeader.tpl.html'
  };
};
UIGridSortableHeaderDirective.$inject = ["coreConstant"];
angular.module('umCore').directive('uiGridSortableHeader', UIGridSortableHeaderDirective);

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

/*@ngInject*/
var UISortIconsDirective = function UISortIconsDirective(coreConstant) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    $scope.getIconDisabledState = function (iconSortType) {
      var columnId = $attrs.columnId,
        result;
      if ($scope.requestParams) {
        $scope.requestParams.sortType = $scope.requestParams.sortType || 'none';
        if ($scope.requestParams.key !== columnId) {
          result = true;
        } else {
          result = $scope.requestParams.sortType !== iconSortType;
        }
      }
      return result;
    };
    $scope.$on(coreConstant.event.DATAGRID_ON_RESET_HEADERS, function (evt, requestParams) {
      //only in the case that the event is applicable for that header, continue
      //otherwise just return
      if ($scope.key !== requestParams.key) {
        return;
      }
      $scope.requestParams.key = requestParams.key;
    });
    $scope.$on('$destroy', function () {});
  };
  return {
    restrict: 'E',
    replace: true,
    link: linkFunction,
    templateUrl: '/ui/columnSort/sortIcons.tpl.html'
  };
};
UISortIconsDirective.$inject = ["coreConstant"];
angular.module('umCore').directive('uiSortIcons', UISortIconsDirective);

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $, moment) {/*@ngInject*/
var BaseGridWidgetController = function BaseGridWidgetController($controller, $scope, $state, $stateParams, $rootScope, $uibModal, $window, advancedFilterMediator, advancedFilterModel, appTypeConfigurationModel, browserUtil, coreConstant, coreMediator, filterRepository, submissionGridConstant, gridColumnModel, localization, loadingBarHandler, persistentConnection, preferenceModel, submissionStateMediator, uiPerformanceLoggerConstant, currencyUtil, filterType, currentUserModel) {
  angular.extend(this, $controller('baseWidgetController', {
    $scope: $scope
  }));
  this.colResizable = false;
  this.isUserTypeUpdated = false;
  this.openFilter;
  this.columnPreference;
  this.shortDateFormat = null;
  this.isLoading = true;
  this.selectedFilterName = '';
  this.isGridEmpty = true;
  this.toolTipDelay = 500;
  this.totalRecords = 0;
  this.savedTotalRecords = 0;
  this.records = [];
  this.dropdownColumns = [];
  this.filters = {};
  this.colViewModel = {};
  this.isAgent = appTypeConfigurationModel.isAgentConsole();
  this.isDrawerOpen = false;
  this.isColSelectDropdownOpen = false;
  this.requestParams;
  this.uiPerformanceLogAction = '';
  this.gridLoadedEvent = '';
  this.isBulkUpdateMode = false;
  this.bulkUpdateSelectAll = false;
  this.isLoaded = false;
  this.selectedBulkItems = [];
  this.onInitGridWidget = function () {
    this.requestParams = this.getFilterParams();
    this.onInit();
  };
  this.getSelectedFilterName = function () {};
  this.loadGrid = function () {
    if (!this.isUserTypeUpdated || this.requestParams.criteriaName === '') {
      return;
    }
    this.isLoading = true;
    this.selectedFilterName = this.getSelectedFilterName();
    function onSuccess(result) {
      var resultRecords = result.records ? result.records : result,
        currencyCode;
      this.isLoading = false;
      this.isLoaded = true;
      this.records = _.map(resultRecords, function (record) {
        currencyCode = record.currencyCode || null;
        record.currencyFormat = currencyUtil.getCurrencyFormat(currencyCode);
        return record;
      });
      /*
       * If the server returns totalRecords as -1, that means that
       * the client should use the previous totalRecords value.
       */
      if (result.totalRecords === -1) {
        // this.savedTotalRecords is not reliable if we come back to a nont startIndex==0 page
        if (this.savedTotalRecords > 0 || this.savedTotalRecords === 0 && this.requestParams.startIndex === 0) {
          result.totalRecords = this.savedTotalRecords;
        } else if (currentUserModel.filterInfoMap && currentUserModel.filterInfoMap[this.selectedFilterName]) {
          result.totalRecords = currentUserModel.filterInfoMap[this.selectedFilterName].totalRecords;
        }
      }
      // filter-level config and paging info is only supported for submissionGrid now
      else if (this.advancedFilterType === 'submissionGrid' && currentUserModel.filterInfoMap && currentUserModel.filterInfoMap[this.selectedFilterName]) {
        currentUserModel.filterInfoMap[this.selectedFilterName].totalRecords = result.totalRecords;
      }
      this.totalRecords = result.totalRecords || resultRecords.length;
      if (this.totalRecords >= 0) {
        this.savedTotalRecords = this.totalRecords;
      }
      this.showPaging = this.totalRecords > this.requestParams.pageSize;
      this.isGridEmpty = this.records.length === 0;
      this.recalculateGridPaging();
      $rootScope.$broadcast(this.gridLoadedEvent);
      // just pass the column config to the landingController without saving it
      this.notifyColumnsChange(null, false);
      coreMediator.loadUserProfile().then(function (userProfile) {
        this.userId = userProfile.userId;
        localization.getTranslationByKey(appTypeConfigurationModel.getConsoleTitleKey()).then(function (translation) {
          var action = uiPerformanceLoggerConstant.LOGIN,
            status = coreConstant.uiPeformanceLogger.SUCCESS,
            message = $window.location.href;
          message += '|' + $window.navigator.userAgent;
          message += '|' + browserUtil.getOSName();
          message += '|' + translation;
          message += '|' + appTypeConfigurationModel.getUserType();
          message += '|' + userProfile.userName;
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, action, status, message);
        });
      }.bind(this));
      var filterAction = this.uiPerformanceLogAction + ':' + this.getSelectedFilterName(),
        status = coreConstant.uiPeformanceLogger.SUCCESS;
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, filterAction, status);
    }
    function onError() {
      var filterAction = this.uiPerformanceLogAction + ':' + this.getSelectedFilterName(),
        status = coreConstant.uiPeformanceLogger.FAIL;
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, filterAction, status);
    }
    return this.loadRecords(onSuccess.bind(this), onError.bind(this));
  };
  this.loadListOnFilterChange = function () {
    this.openFilter = null;
    this.calculateFilterParams();
    this.resetGridPaging();
    this.loadGrid();
  };
  this.resetGridPaging = function () {
    $scope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
  };
  this.recalculateGridPaging = function () {
    $scope.$broadcast(coreConstant.event.RECALCULATE_GRID_PAGING);
  };
  this.resetGridColumns = function () {
    this.updateColumnsFromPreferences(); // update the columnPreference in shared gridColumnModel
    this.generateColumns();
    this.loadGrid();
  };
  this.initLandingPage = function () {
    this.shortDateFormat = coreMediator.getPreferenceByName('view.shortDateFormat');
    this.updateDefaultSortColumn();
    this.updateColumnsFromPreferences();
    this.resetGridColumns();
    this.updateFilterFromPreferences();
  };
  this.loadRecords = function (onSuccess, onError) {
    if (this.advancedFilterType === 'submissionGrid') {
      this.requestParams = this.getFilterParams();
    }
    if (this.requestParams.filterUri !== '') {
      this.loadRecordsInt(this.requestParams).then(onSuccess, onError).finally(function () {
        this.updateBulkUpdateSelectAllState();
        this.updateSelectedBulkItems();
      }.bind(this));
    }
  };
  this.loadRecordsInt = function () {};
  this.updateDefaultSortColumn = function () {};
  this.resetFilter = function () {
    var filterName = this.getSelectedFilterName(),
      selectedFilter = _.find(this.filters, ['name', filterName]),
      isOpen = this.isSearchOpen;
    this.onFilterChange(selectedFilter);
    this.isSearchOpen = isOpen;
  };
  this.getFilterStatus = function () {
    if (this.isFilterEdited()) {
      return this.i18n.advancedFilter.editedFilter;
    } else {
      return '';
    }
  };
  this.isFilterEdited = function () {
    var filterUri = !_.isNil(this.getOpenFilterUri()) ? this.getOpenFilterUri() : gridColumnModel.getSavedFilterUri(this.advancedFilterType),
      hasFilterBeenUpdated = !_.isNil(filterUri) && !_.isNaN(filterUri),
      isCurrentFilterTemporary = _.isNil(_.find(this.filters, ['uri', filterUri]));
    return hasFilterBeenUpdated && isCurrentFilterTemporary;
  };
  this.isFilterTemporary = function () {
    var filterUri = !_.isNil(this.getOpenFilterUri()) ? this.getOpenFilterUri() : gridColumnModel.getSavedFilterUri(this.advancedFilterType),
      isCurrentFilterTemporary = _.isNil(_.find(this.filters, ['uri', filterUri]));
    return isCurrentFilterTemporary;
  };
  this.isDefaultFilter = function () {
    var filter = _.find(this.filters, ['name', this.selectedFilterName]);
    return !_.isNil(filter) && !_.isNil(filter.uri) && filter.uri.startsWith('com.firstbest.underwriting.filter.DefaultFilter');
  };
  this.updateFilterFromPreferences = function () {
    // savedFilterUri is the last filter that was used for the grid.
    // It's remembered in gridColumnModel so that when we come back to the grid from the submission screen, we know the right filter to use
    var savedFilterUri = gridColumnModel.getSavedFilterUri(this.advancedFilterType);
    filterRepository.getFilters().then(function (filters) {
      this.filters = _.filter(filters, {
        'type': this.filterType,
        'temporary': false
      });
      if (!savedFilterUri) {
        this.selectedFilterName = _.get(_.first(this.filters), 'name');
        this.setSelectedFilterName(this.selectedFilterName);
        $scope.$broadcast(submissionGridConstant.event.RESET_GRID_LIST);
      } else {
        filterRepository.getFilter(savedFilterUri).then(function (filter) {
          if (filter) {
            this.selectedFilterName = filter.name;
            this.setSelectedFilterName(this.selectedFilterName);
            $scope.$broadcast(submissionGridConstant.event.RESET_GRID_LIST);
          }
        }.bind(this));
      }
    }.bind(this));
  };
  this.updateFilterFromUserPreferences = function (type, filterUri) {
    if (type === filterType.TYPE_SUBMISSION_FILTER) {
      var prefName = "views.submissionGrid:" + filterUri;
      var sortType = gridColumnModel.getWidgetConfig(prefName, 'sortType');
      var sortKey = gridColumnModel.getWidgetConfig(prefName, 'sortKey');
      if (sortType) {
        gridColumnModel.updateSubmissionParamByName('sortType', sortType);
        gridColumnModel.updateSubmissionParamByName('key', sortKey);
      }
    }
  };
  this.calculateFilterParams = function () {
    var filterParams,
      filter,
      savedFilterUri = gridColumnModel.getSavedFilterUri(this.advancedFilterType);
    if (!_.isNaN(savedFilterUri) && !_.isNil(savedFilterUri)) {
      filterParams = this.getFilterParams();
      filterParams.filterUri = savedFilterUri;
      this.setFilterParams(filterParams);
      filterRepository.getFilter(gridColumnModel.getSavedFilterUri(this.advancedFilterType)).then(function (filter) {
        this.selectedFilterName = filter.name;
        this.setSelectedFilterName(filter.name);
        if (!_.isNil(filter)) {
          advancedFilterMediator.getFilterTemplates(filter.filterTemplateId).then(function (filterTemplate) {
            advancedFilterModel.buildFilter(this.advancedFilterType, filterTemplate, filter);
            this.filterModel = advancedFilterModel.getAdvancedFilterModel(this.advancedFilterType);
          }.bind(this));
          this.updateFilterFromUserPreferences(filter.type, filterParams.filterUri);
          this.isSearchOpen = this.isFilterEdited();
          if (!_.isNil(this.getOpenFilterUri())) {
            this.isSearchOpen = true;
            this.isDrawerOpen = true;
          }
        }
      }.bind(this));
    } else {
      this.selectedFilterName = this.getSelectedFilterName();
      filterParams = this.getFilterParams();
      filter = _.find(this.filters, ['name', this.selectedFilterName]);
      if (!_.isNil(this.openFilter)) {
        filter = this.openFilter;
      }
      if (!_.isNil(filter)) {
        advancedFilterMediator.getFilterTemplates(filter.filterTemplateId).then(function (filterTemplate) {
          advancedFilterModel.buildFilter(this.advancedFilterType, filterTemplate, filter);
          this.filterModel = advancedFilterModel.getAdvancedFilterModel(this.advancedFilterType);
        }.bind(this));
        if (_.isNil(this.openFilter)) {
          this.setOpenFilterUri(null);
        } else {
          this.setOpenFilterUri(this.openFilter.uri);
        }
        if (this.openFilter) {
          this.isSearchOpen = true;
          filterParams.filterUri = this.openFilter.uri;
        } else {
          this.isSearchOpen = false;
          filterParams.filterUri = filter.uri;
          this.setFilterParams(filterParams);
        }
        this.updateFilterFromUserPreferences(filter.type, filterParams.filterUri);
        if (this.alwaysShowSearch) {
          this.isSearchOpen = true;
        }
      }
    }
  };
  this.setFilterParams = function (filterParams) {};
  this.getFilterParams = function () {};
  this.resetParams = function (params) {};
  this.setOpenFilterUri = function (filterUri) {};
  this.getOpenFilterUri = function () {};
  this.resetGridHeaders = function (params) {
    this.resetParams(params);
    this.loadGrid();
    $rootScope.$broadcast(coreConstant.event.GRID_SORT_TYPE_CHANGED, params, this.advancedFilterType);
  };
  this.generateColumns = function () {};
  this.updateColumnsFromPreferences = function () {
    // this is legacy -- not good to share gridColumnModel.columnPreference across widgets
    gridColumnModel.setColumnPreference(this.columnPreference);
  };
  this.onStartResize = function () {
    this.colResizable = true;
  };
  this.onFinishResize = function () {
    this.colResizable = false;
  };
  this.onFilterChange = function (filter) {
    this.updateColumnsFromPreferences(); // update the columnPreference in shared gridColumnModel
    // reset filter first
    gridColumnModel.setSavedFilterUri(this.advancedFilterType, null);
    currentUserModel.filterInfoMap[filter.name] = {};
    if (filter) {
      // remember the open filter
      if (this.isSearchOpen) {
        this.setOpenFilterUri(filter.uri);
      }
      gridColumnModel.setSavedFilterUri(this.advancedFilterType, filter.uri);
    }
    gridColumnModel.setSavedSortType(this.advancedFilterType, null);
    var action = this.uiPerformanceLogAction + ':' + filter.name;
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, null);
    this.setSelectedFilterName(filter.name, true);
    $scope.$broadcast(submissionGridConstant.event.RESET_GRID_LIST);
    $rootScope.$broadcast(coreConstant.event.FILTER_CHANGED, filter.uri, this.advancedFilterType);
  };

  // Intended to be overwritten by a controller extending this
  this.isMultiSelectMode = function () {
    return false;
  };
  this.openSubmission = _.debounce(function (submissionId) {
    var params = {
        submissionId: submissionId
      },
      stateName = 'submission.default';
    if (!this.isMultiSelectMode()) {
      if (submissionId === parseInt($stateParams.submissionId)) {
        return;
      }
      if (this.isColSelectDropdownOpen) {
        this.updateDropdownClosed();
        return;
      }
      if (!this.isSearchOpen) {
        this.setOpenFilterUri(null);
      }
      this.isLoading = true;
      $state.go(stateName, params);
    }
  }.bind(this), 200, {
    leading: true
  });
  this.setSelectedItem = function (event, selectedItem) {
    if (!this.isMultiSelectMode()) {
      if (this.isBulkUpdateMode) {
        this.handleBulkUpdateRowClick(selectedItem);
      } else {
        if (selectedItem.selected) {
          selectedItem.selected = false;
          this.isDrawerOpen = false;
          return;
        }
        if ($(event.currentTarget).hasClass('toggleDrawer')) {
          this.isDrawerOpen = true;
        }
        _.forEach(this.records, function (item) {
          item.selected = item === selectedItem;
        });
        $scope.$broadcast(this.openDetailDrawerEvent);
      }
    }
  };
  this.updateDropdownClosed = function () {
    this.isColSelectDropdownOpen = false;
  };
  this.getFilterPrefName = function (filterUri) {
    return null;
  };
  this.onColumnCheckboxClick = function (event, column) {
    if (!column.disabled) {
      column.visible = !column.visible;
      this.updateColumnsFromPreferences();
      var columnsXML = gridColumnModel.getGridColumnXML(column, this.getFilterPrefName());
      this.notifyColumnsChange(columnsXML);
    }
    event.preventDefault();
    event.stopPropagation();
  };
  this.notifyColumnsChange = function (columnsXML) {
    var doSave = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    this.updateColumnsFromPreferences();
    if (!columnsXML) {
      columnsXML = gridColumnModel.getGridColumnXML(null, this.getFilterPrefName());
    }
    if (doSave && (this.columnPreference === 'system.accountSubmissionsGridColumns' || this.columnPreference === 'system.accountOverviewSubmissionColumnsForAgent' || this.columnPreference === 'system.accountOverviewSubmissionColumnsForUnderwriter')) {
      coreMediator.updateUserPreferences(this.columnPreference, columnsXML).then(function () {
        $scope.$broadcast(submissionGridConstant.event.RESET_GRID_COLUMNS);
      });
    } else {
      $rootScope.$broadcast(submissionGridConstant.event.MODIFIED_COLUMN_SELECTION, this.columnPreference, columnsXML, doSave);
    }
  };
  this.cancelClickEvent = function (event) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  };
  this.handleFilterSave = function (event, filter) {
    this.updateColumnsFromPreferences(); // update the columnPreference in shared gridColumnModel
    // get the columns XML for the current filter
    var columnsXML = gridColumnModel.getGridColumnXML(null, this.getFilterPrefName());
    var filterParams = this.getFilterParams(),
      selectedFilter = _.find(this.filters, ['name', this.selectedFilterName]);
    if (selectedFilter.name === filter.name) {
      filterParams.filterUri = filter.uri;
      filterParams.startIndex = 0;
      this.setFilterParams(filterParams);
      this.resetGridPaging(filterParams.pageSize, filterParams.startIndex);
      $rootScope.$broadcast(coreConstant.event.FILTER_CHANGED, filter.uri, this.advancedFilterType);
    }
    gridColumnModel.setSavedFilterUri(this.advancedFilterType, filter.uri);
    if (this.isSearchOpen) {
      this.setOpenFilterUri(filter.uri);
    }

    // update the column config in landingController
    this.notifyColumnsChange(columnsXML);
  };
  this.onToggleSearch = function () {
    this.isSearchOpen = !this.isSearchOpen;
  };
  this.onSaveFilterAs = function () {
    var modalInstance = $uibModal.open({
      templateUrl: '/ui/advancedFilter/saveAs/saveFilterAsModal.tpl.html',
      controller: 'saveFilterAsModalController',
      backdrop: 'static',
      windowClass: 'saveFilterAsModal',
      resolve: {
        filters: function () {
          return _.filter(this.filters, {
            'type': this.filterType,
            'temporary': false
          });
        }.bind(this)
      }
    });
    modalInstance.result.then(function (response) {
      function onSuccess(result) {
        filterRepository.getFilters().then(function (filters) {
          gridColumnModel.setSavedFilterUri(this.advancedFilterType, null);
          this.filters = _.filter(filters, {
            'type': this.filterType,
            'temporary': false
          });
          this.setSelectedFilterName(result.name);
          this.selectedFilterName = result.name;
          this.handleFilterSave(coreConstant.event.FILTER_SAVED, result);
          this.calculateFilterParams();
          loadingBarHandler.hideLoadingBar();
        }.bind(this));
      }
      var currentFilter = advancedFilterModel.buildCurrentFilter(this.advancedFilterType);
      currentFilter.id = null;
      currentFilter.uri = null;
      currentFilter.name = response.filterName;
      currentFilter.temporary = false;
      currentFilter.userId = this.userId;
      loadingBarHandler.showLoadingBar('advancedFilter.saveFilterAs.loadingBar');
      advancedFilterMediator.saveFilter(currentFilter).then(onSuccess.bind(this));
    }.bind(this));
  };
  this.onDeleteFilter = function () {
    var currentFilter = advancedFilterModel.getAdvancedFilterModel(this.advancedFilterType).filter;
    function onSuccess() {
      filterRepository.getFilters().then(function (filters) {
        gridColumnModel.setSavedFilterUri(this.advancedFilterType, null);
        this.filters = _.filter(filters, {
          'type': this.filterType,
          'temporary': false
        });
        this.onFilterChange(_.first(this.filters));
        loadingBarHandler.hideLoadingBar();
      }.bind(this));
    }
    function deleteFilter() {
      loadingBarHandler.showLoadingBar('advancedFilter.deleteFilter.loadingBar');
      advancedFilterMediator.deleteFilter(currentFilter).then(onSuccess.bind(this));
    }
    localization.getTranslationByKey('advancedFilter.deleteFilter').then(function (translation) {
      var _options = {
        title: _.get(translation, 'title'),
        summary: _.get(translation, 'summary'),
        cancelButtonLabel: _.get(translation, 'cancelButton'),
        confirmActionButtonLabel: _.get(translation, 'deleteButton')
      };
      var modalInstance = $uibModal.open({
        templateUrl: '/ui/modal/modal.tpl.html',
        controller: 'modalController',
        backdrop: 'static',
        windowClass: 'genericModal',
        resolve: {
          options: function options() {
            return _options;
          }
        }
      });
      modalInstance.result.then(deleteFilter.bind(this));
    }.bind(this));
  };
  this.setSelectedFilterName = function (filterName) {};
  this.onSaveFilter = function () {
    var currentFilter = advancedFilterModel.buildCurrentFilter(this.advancedFilterType);
    function onSuccess(result) {
      filterRepository.getFilters().then(function (filters) {
        gridColumnModel.setSavedFilterUri(this.advancedFilterType, null);
        this.filters = _.filter(filters, {
          'type': this.filterType,
          'temporary': false
        });
        this.setSelectedFilterName(result.name);
        this.handleFilterSave(coreConstant.event.FILTER_SAVED, result);
        loadingBarHandler.hideLoadingBar();
      }.bind(this));
    }
    currentFilter.uri = advancedFilterModel.getAdvancedFilterModel(this.advancedFilterType).filter.uri;
    currentFilter.name = advancedFilterModel.getAdvancedFilterModel(this.advancedFilterType).filter.name;
    currentFilter.temporary = false;
    currentFilter.userId = this.userId;
    loadingBarHandler.showLoadingBar('advancedFilter.saveFilterAs.loadingBar');
    advancedFilterMediator.saveFilter(currentFilter).then(onSuccess.bind(this));
  };
  this.handleBulkUpdateRowClick = function (selectedItem) {
    selectedItem.selected = !selectedItem.selected;
    this.updateSelectedBulkItems();
    this.updateBulkUpdateSelectAllState();
  };
  this.updateSelectedBulkItems = function () {
    this.selectedBulkItems = _.filter(this.records, function (record) {
      return record.selected;
    });
  };
  this.updateBulkUpdateSelectAllState = function () {
    this.bulkUpdateSelectAll = this.selectedBulkItems.length === this.records.length;
  };
  this.onBulkUpdate = function () {
    this.isBulkUpdateMode = true;
    this.selectedBulkItems = [];
  };
  this.onCancelBulkUpdate = function () {
    this.isBulkUpdateMode = false;
    this.bulkUpdateSelectAll = false;
    _.map(this.records, function (record) {
      record.selected = false;
    }.bind(this));
  };
  this.onBulkUpdateSelectAllRecords = function () {
    _.map(this.records, function (record) {
      record.selected = this.bulkUpdateSelectAll;
    }.bind(this));
    this.updateSelectedBulkItems();
  };
  this.isPastDue = function (dueDate) {
    return moment(dueDate).isBefore(moment.utc(new Date()));
  };
  this.rearrangeColumn = function (columns, columnToRearrange, targetColumn, isLeftDrop) {
    var toRearrange = _.find(columns, function (c) {
      return c.__text === columnToRearrange;
    });
    var target = _.find(columns, function (c) {
      return c.__text === targetColumn;
    });
    if (toRearrange && target) {
      var index = columns.indexOf(toRearrange);
      columns.splice(index, 1);
      var targetIndex = columns.indexOf(target);
      if (!isLeftDrop) {
        targetIndex += 1;
      }
      columns.splice(targetIndex, 0, toRearrange);
    }
    var value = gridColumnModel.getColumnsXML(columns);
    $rootScope.$broadcast(submissionGridConstant.event.MODIFIED_COLUMN_SELECTION, this.columnPreference, value);
  };
  this.resizeColumn = function (columns, columnIdentifier, newWidth) {
    var column = _.find(columns, function (c) {
      return c.__text === columnIdentifier;
    });
    column._width = newWidth;
    var value = gridColumnModel.getColumnsXML(columns);
    $rootScope.$broadcast(submissionGridConstant.event.MODIFIED_COLUMN_SELECTION, this.columnPreference, value);
  };
};
BaseGridWidgetController.$inject = ["$controller", "$scope", "$state", "$stateParams", "$rootScope", "$uibModal", "$window", "advancedFilterMediator", "advancedFilterModel", "appTypeConfigurationModel", "browserUtil", "coreConstant", "coreMediator", "filterRepository", "submissionGridConstant", "gridColumnModel", "localization", "loadingBarHandler", "persistentConnection", "preferenceModel", "submissionStateMediator", "uiPerformanceLoggerConstant", "currencyUtil", "filterType", "currentUserModel"];
angular.module('umCore').controller('baseGridWidgetController', BaseGridWidgetController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

angular.module('umCore').constant('gridColumnConstant', {
  SUBMISSION_HOME_PAGE_INSURED: 'Insured',
  SUBMISSION_HOME_PAGE_ACCOUNT_NAME: 'Account Name',
  SUBMISSION_HOME_PAGE_SUBMISSION: 'Submission',
  SUBMISSION_HOME_PAGE_EFFECTIVE: 'Effective',
  SUBMISSION_HOME_PAGE_EXPIRATION: 'Expiration',
  SUBMISSION_HOME_PAGE_STATUS: 'Status',
  SUBMISSION_HOME_PAGE_STATUS_REASON: 'Status Reason',
  SUBMISSION_HOME_PAGE_PREMIUM: 'Premium',
  SUBMISSION_HOME_PAGE_NEXT_ACTION: 'Next Action',
  SUBMISSION_HOME_PAGE_ACTION_DATE: 'Action Date',
  SUBMISSION_HOME_PAGE_ASSIGNED_TO: 'Assigned To',
  SUBMISSION_HOME_PAGE_UNDERWRITER: 'Underwriter',
  SUBMISSION_HOME_PAGE_COVERAGE: 'Coverage',
  SUBMISSION_HOME_PAGE_AGENCY: 'Agency',
  SUBMISSION_HOME_PAGE_PRODUCT: 'Product',
  SUBMISSION_HOME_PAGE_RECEIVED_DATE: 'Received Date',
  SUBMISSION_HOME_PAGE_NEEDED_BY_DATE: 'Needed By Date',
  SUBMISSION_HOME_PAGE_PRIORITY: 'Priority',
  SUBMISSION_HOME_PAGE_RISK_STATE: 'Risk State',
  SUBMISSION_HOME_PAGE_TOTAL_LIMIT: 'Total Limit',
  SUBMISSION_HOME_PAGE_OBLIGATION_NAME: 'Name of Obligation',
  SUBMISSION_ACCOUNT_PAGE_INSURED: 'Insured',
  SUBMISSION_ACCOUNT_PAGE_EFFECTIVE: 'Effective',
  SUBMISSION_ACCOUNT_PAGE_EXPIRATION: 'Expiration',
  SUBMISSION_ACCOUNT_PAGE_STATUS: 'Status',
  SUBMISSION_ACCOUNT_PAGE_STATUS_REASON: 'Status Reason',
  SUBMISSION_ACCOUNT_PAGE_PREMIUM: 'Premium',
  SUBMISSION_ACCOUNT_PAGE_NEXT_ACTION: 'Next Action',
  SUBMISSION_ACCOUNT_PAGE_ASSIGNED_TO: 'Assigned To',
  SUBMISSION_ACCOUNT_PAGE_RISK_STATE: 'Risk State',
  SUBMISSION_ACCOUNT_PAGE_TOTAL_LIMIT: 'Total Limit',
  SUBMISSION_ACCOUNT_PAGE_OBLIGATION_NAME: 'Name of Obligation',
  SUBMISSION_ACCOUNT_PAGE_COVERAGE: 'Product',
  SUBMISSION_ACCOUNT_PAGE_SUBMISSION: 'Submission #',
  SUBMISSION_ACCOUNT_PAGE_RECEIVED_DATE: 'Date Received',
  SUBMISSION_ACCOUNT_PAGE_ACTION_DATE: 'Next Action Due Date',
  SUBMISSION_ACCOUNT_PAGE_AGENCY: 'Agency/Brokerage',
  TASK_GRID_RESOLVED: 'Resolved',
  TASK_GRID_DUE_DATE: 'Due Date',
  TASK_GRID_TASK_SUMMARY: 'Task Summary',
  TASK_GRID_ASSIGNED_BY: 'Assigned By',
  TASK_GRID_TASK_DETAILS: 'Task Details',
  TASK_GRID_EFFECTIVE_DATE: 'Effective Date',
  TASK_GRID_CREATED_DATE: 'Assigned Date',
  TASK_GRID_RESOLVED_DATE: 'Resolved Date'
});

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

var path = '/ui/grid/gridPaging/gridPaging.tpl.html';
var html = "<ul class=\"pagination\">\n    <li ng-if=\"($ctrl.showPaging || viewModel.showPaging)\"\n        ng-class=\"{ 'disabled': selectedPage === 1 }\">\n        <a ng-click=\"changePage(-1)\"\n           ui-translate>gridPaging.back</a>\n    </li>\n    <li ng-if=\"$ctrl.showPaging || viewModel.showPaging\"\n        ng-repeat=\"page in pages\"\n        ng-class=\"{ 'active' : selectedPage === page.number }\">\n        <a ng-click=\"numberClick($index)\">{{ page.number }}</a>\n    </li>\n    <li ng-if=\"($ctrl.showPaging || viewModel.showPaging)\"\n        ng-class=\"{ 'disabled': selectedPage === getMaxNumPages() }\">\n        <a ng-click=\"changePage(1)\"\n           ui-translate>gridPaging.next</a>\n    </li>\n    <li ng-if=\"endRecord > 0\"\n        class=\"summary\">{{ getRecordCountText() }}\n    </li>\n</ul>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UIGridPagingDirective = function UIGridPagingDirective(coreConstant, localization) {
  var linkFunction = function linkFunction($scope) {
    var buttonWidth = 65,
      pageWidth = 35,
      summaryLength = 250,
      i;
    $scope.pages = [];
    $scope.$ctrl.maxVisiblePages = 10;
    $scope.startRecord = 1;
    $scope.endRecord = $scope.$ctrl.requestParams.pageSize;
    $scope.selectedPage = Math.ceil($scope.$ctrl.requestParams.startIndex / $scope.$ctrl.requestParams.pageSize) + 1;
    $scope.recordCountText = $scope.$ctrl.recordCountText;
    $scope.recordsCountText = $scope.$ctrl.recordsCountText;
    $scope.isTask = $scope.$ctrl.isTask;
    for (i = 1; i < $scope.$ctrl.maxVisiblePages + 1; i++) {
      $scope.pages.push({
        number: i
      });
    }
    if (_.isNil($scope.recordCountText) && _.isNil($scope.recordsCountText)) {
      localization.getTranslationByKey('homePage.grid').then(function (translation) {
        $scope.recordCountText = $scope.isTask ? translation.taskCount : translation.submissionCount;
        $scope.recordsCountText = $scope.isTask ? translation.tasksCount : translation.submissionsCount;
        if ($scope.$ctrl.isGenericItem) {
          $scope.recordCountText = translation.itemCount;
          $scope.recordsCountText = translation.itemsCount;
        }
      });
    }
    var totalWidth = 2 * buttonWidth + $scope.pages.length * pageWidth + summaryLength;
    $scope.totalWidth = {
      'width': totalWidth + 'px'
    };
    $scope.numberClick = function (index) {
      var page = $scope.pages[index];
      if ($scope.selectedPage === page.number) {
        return;
      }

      //making sure that an empty page cannot be selected
      while ((page.number - 1) * $scope.$ctrl.requestParams.pageSize > $scope.$ctrl.totalRecords) {
        page.number--;
      }
      $scope.selectedPage = page.number;
      $scope.notify();
    };
    $scope.getMaxNumPages = function () {
      return Math.ceil($scope.$ctrl.totalRecords / $scope.$ctrl.requestParams.pageSize);
    };
    $scope.changePage = function (direction) {
      var length = $scope.getMaxNumPages();
      if ($scope.selectedPage === length && direction === 1) {
        return;
      }
      if ($scope.selectedPage === 1 && direction === -1) {
        return;
      }
      $scope.selectedPage += direction;

      //define upper limit
      if ($scope.selectedPage > length) {
        $scope.selectedPage = length;
      }

      //define lower limit
      if ($scope.selectedPage < 1) {
        $scope.selectedPage = 1;
      }
      $scope.notify();
    };
    $scope.notify = function () {
      var requestParams = $scope.$ctrl.requestParams;
      requestParams.startIndex = ($scope.selectedPage - 1) * requestParams.pageSize;
      $scope.$emit(coreConstant.event.DATAGRID_ON_RESET_HEADERS, $scope.$ctrl.requestParams);
      $scope.startRecord = ($scope.selectedPage - 1) * requestParams.pageSize + 1;
      $scope.calculateVisiblePages();
    };
    $scope.calculateVisiblePages = function () {
      //updating visible pages in the pager
      var numOfGroups = Math.ceil($scope.$ctrl.totalRecords / $scope.$ctrl.requestParams.pageSize),
        lower = 0,
        upper = 0,
        j;
      for (i = 0; i < numOfGroups; i++) {
        lower = i * $scope.$ctrl.maxVisiblePages;
        upper = i * $scope.$ctrl.maxVisiblePages + $scope.$ctrl.maxVisiblePages;
        if ($scope.selectedPage > lower && $scope.selectedPage <= upper) {
          $scope.pages = [];
          for (j = lower + 1; j < upper + 1 && j <= numOfGroups; j++) {
            $scope.pages.push({
              number: j
            });
          }
          break;
        }
      }
      $scope.endRecord = $scope.selectedPage * $scope.$ctrl.requestParams.pageSize;
      //this is the case that the last page is not full
      if ($scope.endRecord > $scope.$ctrl.totalRecords) {
        $scope.endRecord = $scope.$ctrl.totalRecords;
      }
    };
    $scope.getRecordCountText = function () {
      var message = '';
      if ($scope.endRecord > 1) {
        message = $scope.recordsCountText;
      } else {
        message = $scope.recordCountText;
      }
      message = _.replace(message, 'startIndex', $scope.startRecord);
      message = _.replace(message, 'endIndex', $scope.endRecord);
      message = _.replace(message, 'total', $scope.$ctrl.totalRecords);
      return message;
    };
    $scope.$on(coreConstant.event.RESET_GRID_PAGING, function () {
      $scope.$ctrl.requestParams.startIndex = 0;
      $scope.startRecord = 1;
      $scope.selectedPage = 1;
      $scope.endRecord = $scope.$ctrl.requestParams.pageSize;
      $scope.notify();
    });
    $scope.$on(coreConstant.event.RECALCULATE_GRID_PAGING, function () {
      $scope.calculateVisiblePages();
    });
    $scope.calculateVisiblePages();
  };
  return {
    restrict: 'A',
    link: linkFunction,
    templateUrl: '/ui/grid/gridPaging/gridPaging.tpl.html'
  };
};
UIGridPagingDirective.$inject = ["coreConstant", "localization"];
angular.module('umCore').directive('uiGridPaging', UIGridPagingDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1418);
__webpack_require__(1419);
__webpack_require__(1420);
__webpack_require__(1421);
__webpack_require__(1422);
__webpack_require__(1423);

/*@ngInject*/
var UISubmissionGridMultiSelect = function UISubmissionGridMultiSelect($rootScope, $parse, submissionGridConstant, localization) {
  var linkFunction = function linkFunction($scope, $elm, $attr) {
    var maxBulkReassignPreference = $parse($attr.multiSelectMaximumBatchSize)($scope);
    $scope.onMultiSelectReassignCallback = $parse($attr.multiSelectReassignCallback)($scope);
    $scope.onMultiSelectResolveCallback = $parse($attr.multiSelectResolveCallback)($scope);
    $scope.multiSelectModel = {
      multiSelectHeaderTitle: $attr['multiSelectTitle'],
      multiSelectCogMenuLabel: $attr['multiSelectCogMenuLabel'],
      showResolveAction: $attr['showResolveAction'] || false,
      isMultiSelectMode: false,
      selectAllCheckbox: false,
      multiSelectItemList: [],
      isMultiSelectUsingExclusion: false,
      maxBulkReassignSubmissions: maxBulkReassignPreference < 1000 ? maxBulkReassignPreference : 1000
    };
    localization.getTranslationByKey('homePage.widgets.submissionGrid.bulkReassign.maximumSelectionWarning').then(function (result) {
      $scope.multiSelectModel.maximumSelectionWarning = result;
    });
    $scope.multiSelectUtil = {
      onBeginMultiSelect: function onBeginMultiSelect() {
        $scope.multiSelectModel.isMultiSelectMode = true;
        $scope.multiSelectModel.multiSelectItemList = [];
        $rootScope.$broadcast(submissionGridConstant.event.CLOSE_SUBMISSION_DETAIL_DRAWER);
      },
      onCancelMultiSelect: function onCancelMultiSelect() {
        $scope.multiSelectModel.isMultiSelectMode = false;
        $scope.multiSelectModel.selectAllCheckbox = false;
        $scope.multiSelectModel.isMultiSelectUsingExclusion = false;
        $scope.multiSelectModel.multiSelectItemList = [];
      },
      resetMultiSelect: function resetMultiSelect() {
        $scope.multiSelectModel.multiSelectItemList = [];
      },
      onToggleSelectAllCheckbox: function onToggleSelectAllCheckbox() {
        $scope.multiSelectModel.selectAllCheckbox = !$scope.multiSelectModel.selectAllCheckbox;
        $scope.multiSelectModel.multiSelectItemList = [];
        $scope.multiSelectModel.isMultiSelectUsingExclusion = $scope.multiSelectModel.selectAllCheckbox;
      },
      activateSelectAllCheckbox: function activateSelectAllCheckbox() {
        $scope.multiSelectModel.selectAllCheckbox = true;
        $scope.multiSelectModel.multiSelectItemList = [];
        $scope.multiSelectModel.isMultiSelectUsingExclusion = $scope.multiSelectModel.selectAllCheckbox;
      },
      getMultiSelectCount: function getMultiSelectCount() {
        var allItemsSelected = $scope.multiSelectModel.selectAllCheckbox;
        var multiSelectItemListCount = $scope.multiSelectModel.multiSelectItemList.length;
        var total = 0;
        if (allItemsSelected) {
          total = $scope.$ctrl.totalRecords - multiSelectItemListCount;
        } else {
          total = multiSelectItemListCount;
        }
        return total;
      },
      isRowSelected: function isRowSelected(id) {
        var isAllCheckboxSelected = $scope.multiSelectModel.selectAllCheckbox === true;
        var isRowIdInList = $scope.multiSelectModel.multiSelectItemList.indexOf(id) !== -1;
        var result = false;
        if (isAllCheckboxSelected) {
          result = isRowIdInList === false;
        } else {
          result = isRowIdInList === true;
        }
        return result;
      },
      handleMultiSelectRowClick: function handleMultiSelectRowClick(selectedItem) {
        var isRowInSelectionList = $scope.multiSelectModel.multiSelectItemList.indexOf(selectedItem.id) !== -1;
        if (!isRowInSelectionList) {
          $scope.multiSelectModel.multiSelectItemList.push(selectedItem.id);
        } else {
          var selectedItemId = selectedItem.id;
          var selectedItemIndex = $scope.multiSelectModel.multiSelectItemList.indexOf(selectedItemId);
          $scope.multiSelectModel.multiSelectItemList.splice(selectedItemIndex, 1);
        }
      },
      isSelectAllCheckboxSelected: function isSelectAllCheckboxSelected() {
        var isSelectAllCheckboxSelected = $scope.multiSelectModel.selectAllCheckbox;
        var isEntireListSelected = $scope.multiSelectModel.totalRecords === $scope.multiSelectModel.multiSelectItemList.length;
        return isEntireListSelected || isSelectAllCheckboxSelected;
      },
      getMaximumSelectionCountWarning: function getMaximumSelectionCountWarning() {
        return $scope.multiSelectModel.maximumSelectionWarning.replace('{1}', $scope.multiSelectModel.maxBulkReassignSubmissions.toString());
      },
      isMaximumSelectionCountWarningVisible: function isMaximumSelectionCountWarningVisible() {
        var selectionLimit = $scope.multiSelectModel.maxBulkReassignSubmissions;
        var totalSelected = $scope.multiSelectUtil.getMultiSelectCount();
        return totalSelected > selectionLimit;
      }
    };
  };
  return {
    link: linkFunction,
    restrict: 'A'
  };
};
UISubmissionGridMultiSelect.$inject = ["$rootScope", "$parse", "submissionGridConstant", "localization"];
angular.module('umCore').directive('uiSubmissionGridMultiSelect', UISubmissionGridMultiSelect);

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

var path = '/ui/grid/multiSelect/template/multiSelectButton.tpl.html';
var html = "<a ng-click=\"multiSelectUtil.onBeginMultiSelect()\"\n    class=\"bulkReassignButton\">\n    <span ui-translate>{{::multiSelectModel.multiSelectCogMenuLabel}}</span>\n</a>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

var path = '/ui/grid/multiSelect/template/multiSelectHeader.tpl.html';
var html = "<div class=\"multiSelectHeaderContainer\"\n     ng-if=\"multiSelectModel.isMultiSelectMode\">\n\n    <div class=\"selectedTotal\">\n        <div class=\"totalCount\">{{multiSelectUtil.getMultiSelectCount()}}</div>\n        <div class=\"totalLabel\">\n            <span class=\"titleText\" ui-translate>{{::multiSelectModel.multiSelectHeaderTitle}}</span>\n        </div>\n    </div>\n\n    <div class=\"selectionWarning\"\n         ng-if=\"multiSelectUtil.isMaximumSelectionCountWarningVisible()\">\n       {{multiSelectUtil.getMaximumSelectionCountWarning()}}\n    </div>\n\n    <div class=\"actions\">\n        <button type=\"button\"\n                class=\"btn btn-sm btn-default cancelButton\"\n                ng-click=\"multiSelectUtil.onCancelMultiSelect()\">\n            <span ui-translate>homePage.widgets.submissionGrid.bulkReassign.cancel</span>\n        </button>\n\n        <button type=\"button\"\n                class=\"btn btn-sm btn-primary reassignButton\"\n                ng-disabled=\"multiSelectUtil.getMultiSelectCount() < 1\"\n                ng-click=\"onMultiSelectReassignCallback()\">\n            <span ui-translate>homePage.widgets.submissionGrid.bulkReassign.reassign</span>\n        </button>\n\n        <button type=\"button\"\n                class=\"btn btn-sm btn-primary resolveButton\"\n                ng-if=\"multiSelectModel.showResolveAction\"\n                ng-disabled=\"multiSelectUtil.getMultiSelectCount() < 1\"\n                ng-click=\"onMultiSelectResolveCallback()\">\n            <span ui-translate>homePage.widgets.submissionGrid.bulkReassign.resolve</span>\n        </button>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UserSelectionModalController = function UserSelectionModalController($rootScope, $scope, coreConstant, dataSetUtil, userRepository) {
  $scope.viewModel = {
    selectedGroup: 1,
    selectedUser: null,
    groups: {
      responsibleUnderwriters: 1,
      assignedUnderwriters: 2,
      serviceTeam: 3
    },
    selectedResponsibleUnderwriter: null,
    responsibleUnderwritersList: [],
    selectedAssignedUnderwriter: null,
    assignedUnderwritersList: [],
    selectedServiceTeam: null,
    serviceTeamList: [],
    selectedServiceTeamOptionList: [],
    selectedServiceTeamAddition: null,
    selectedServiceTeamRemoval: null
  };
  dataSetUtil.getDataSet({
    name: 'Active Underwriters Optional'
  }).then(function (dataSet) {
    var datasetList = _.sortBy(dataSet.items, function (item) {
      return item.name;
    });
    $scope.viewModel.responsibleUnderwritersList = _.filter(datasetList, function (item) {
      // filter out the unassigned value
      return item.value !== '0';
    });
    $scope.viewModel.assignedUnderwritersList = _.clone(datasetList);
  });
  dataSetUtil.getDataSet({
    name: 'Service Team User Types'
  }).then(function (dataSet) {
    $scope.viewModel.serviceTeamList = _.sortBy(dataSet.items, function (item) {
      return item.name;
    });
  });
  $scope.onResponsibleUnderwriterChange = function (selectedOption) {
    if (!selectedOption.roles) {
      $scope.getUserRoles(selectedOption).then(function (roles) {
        if (roles) {
          selectedOption.roles = roles;
          selectedOption.name += ' (' + roles + ')';
        }
        $scope.viewModel.selectedResponsibleUnderwriter = selectedOption;
      });
    } else {
      $scope.viewModel.selectedResponsibleUnderwriter = selectedOption;
    }
    $scope.viewModel.selectedUser = selectedOption;
  };
  $scope.onAssignedUnderwriterChange = function (selectedOption) {
    if (!selectedOption.roles) {
      $scope.getUserRoles(selectedOption).then(function (roles) {
        if (roles) {
          selectedOption.roles = roles;
          selectedOption.name += ' (' + roles + ')';
        }
        $scope.viewModel.selectedAssignedUnderwriter = selectedOption;
      });
    } else {
      $scope.viewModel.selectedAssignedUnderwriter = selectedOption;
    }
    $scope.viewModel.selectedUser = selectedOption;
  };
  $scope.onServiceTeamChange = function (selectedOption) {
    $scope.viewModel.selectedServiceTeam = selectedOption;
    $scope.viewModel.selectedServiceTeamAddition = null;
    $scope.viewModel.selectedServiceTeamRemoval = null;
    dataSetUtil.getDataSet({
      name: "Service Team Users - ".concat(selectedOption.name)
    }).then(function (dataSet) {
      $scope.viewModel.selectedServiceTeamOptionList = _.sortBy(dataSet.items, function (item) {
        return item.name;
      });
    });
  };
  $scope.onServiceTeamAdditionChange = function (selectedOption) {
    $scope.viewModel.selectedServiceTeamAddition = selectedOption;
    $scope.viewModel.selectedUser = selectedOption;
  };
  $scope.onServiceTeamRemovalChange = function (selectedOption) {
    $scope.viewModel.selectedServiceTeamRemoval = selectedOption;
    $scope.viewModel.selectedUser = selectedOption;
  };
  $scope.onSelectedGroupChange = function () {
    $scope.viewModel.selectedResponsibleUnderwriter = null;
    $scope.viewModel.selectedAssignedUnderwriter = null;
    $scope.viewModel.selectedServiceTeam = null;
    $scope.viewModel.selectedServiceTeamAddition = null;
    $scope.viewModel.selectedServiceTeamRemoval = null;
    $scope.viewModel.selectedUser = null;
  };
  $scope.isContinueButtonDisabled = function () {
    var hasSelection = $scope.viewModel.selectedUser;
    var isServiceGroupSelected = $scope.viewModel.selectedGroup === $scope.viewModel.groups.serviceTeam;
    var hasAdditionSelection = $scope.viewModel.selectedServiceTeamAddition;
    var hasRemovalSelection = $scope.viewModel.selectedServiceTeamRemoval;
    var result = false;
    if (isServiceGroupSelected) {
      result = !hasAdditionSelection && !hasRemovalSelection;
    } else {
      result = !hasSelection;
    }
    return result;
  };
  $scope.onConfirm = function () {
    var result = {};
    var _$scope$viewModel = $scope.viewModel,
      selectedGroup = _$scope$viewModel.selectedGroup,
      selectedResponsibleUnderwriter = _$scope$viewModel.selectedResponsibleUnderwriter,
      selectedAssignedUnderwriter = _$scope$viewModel.selectedAssignedUnderwriter,
      selectedServiceTeamAddition = _$scope$viewModel.selectedServiceTeamAddition,
      selectedServiceTeamRemoval = _$scope$viewModel.selectedServiceTeamRemoval,
      groups = _$scope$viewModel.groups;
    if (selectedGroup === groups.responsibleUnderwriters) {
      result.assignementType = 'Responsible Underwriter';
      result.userToAssignId = parseInt(selectedResponsibleUnderwriter.value);
    } else if (selectedGroup === groups.assignedUnderwriters) {
      result.assignementType = 'Assigned To Underwriter';
      result.userToAssignId = parseInt(selectedAssignedUnderwriter.value);
    } else if (selectedGroup === groups.serviceTeam) {
      result.assignementType = 'Service User';
      if (selectedServiceTeamRemoval) {
        result.userToRemoveId = parseInt(selectedServiceTeamRemoval.value);
      }
      if (selectedServiceTeamAddition) {
        result.userToAssignId = parseInt(selectedServiceTeamAddition.value);
      }
    }
    $scope.$close(result);
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
  $scope.getUserRoles = function (item) {
    if (item && item.value) {
      // item.value should be the user id
      return userRepository.getUserRolesById(item.value);
    } else {
      return null;
    }
  };
};
UserSelectionModalController.$inject = ["$rootScope", "$scope", "coreConstant", "dataSetUtil", "userRepository"];
angular.module('umCore').controller('userSelectionModalController', UserSelectionModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

var path = '/ui/grid/multiSelect/userSelectionModal/userSelectionModal.tpl.html';
var html = "<div class=\"genericModalContent\">\n\n    <div class=\"modal-header\">\n\n        <h3 class=\"modal-title\" ui-translate>homePage.widgets.submissionGrid.bulkReassign.userSelectionModal.title</h3>\n\n        <button class=\"close\"\n                ng-click=\"$dismiss()\">\n\n            <span class=\"glyphicon glyphicon-remove\"></span>\n        </button>\n    </div>\n\n    <div class=\"modal-body modalSummary\">\n\n<!-- Responsible Underwriter -->\n        <div class=\"inputRow\">\n            <div class=\"activationRow\">\n                <label>\n                    <input type=\"radio\"\n                           class=\"responsibleUnderwriterRadio\"\n                           ng-model=\"viewModel.selectedGroup\"\n                           ng-value=\"viewModel.groups.responsibleUnderwriters\"\n                           ng-change=\"onSelectedGroupChange()\">\n\n                    <span class=\"radioLabel\" ui-translate>homePage.widgets.submissionGrid.bulkReassign.userSelectionModal.responsibleUnderwriterGroupLabel</span>\n                </label>\n            </div>\n\n            <um-dropdown class-name=\"responsibleUnderwriterDropdown\"\n                         required=\"'true'\"\n                         option-list=\"viewModel.responsibleUnderwritersList\"\n                         selected-value=\"viewModel.selectedResponsibleUnderwriter.value\"\n                         on-change=\"onResponsibleUnderwriterChange(selectedOption)\"\n                         is-disabled=\"viewModel.selectedGroup !== viewModel.groups.responsibleUnderwriters\">\n            </um-dropdown>\n        </div>\n\n<!-- Assigned Underwriter -->\n        <div class=\"inputRow\">\n            <div class=\"activationRow\">\n                <label>\n                    <input type=\"radio\"\n                           class=\"assignedUnderwriterRadio\"\n                           ng-model=\"viewModel.selectedGroup\"\n                           ng-value=\"viewModel.groups.assignedUnderwriters\"\n                           ng-change=\"onSelectedGroupChange()\">\n\n                    <span class=\"radioLabel\" ui-translate>homePage.widgets.submissionGrid.bulkReassign.userSelectionModal.assignedToGroupLabel</span>\n                </label>\n            </div>\n\n            <um-dropdown class-name=\"assignedUnderwriterDropdown\"\n                         required=\"'true'\"\n                         option-list=\"viewModel.assignedUnderwritersList\"\n                         selected-value=\"viewModel.selectedAssignedUnderwriter.value\"\n                         on-change=\"onAssignedUnderwriterChange(selectedOption)\"\n                         is-disabled=\"viewModel.selectedGroup !== viewModel.groups.assignedUnderwriters\">\n            </um-dropdown>\n        </div>\n\n<!-- Service Team -->\n        <div class=\"inputRow\"\n             ng-if=\"viewModel.serviceTeamList.length\">\n            <div class=\"activationRow\">\n                <label>\n                    <input type=\"radio\"\n                           class=\"serviceUserRadio\"\n                           ng-model=\"viewModel.selectedGroup\"\n                           ng-value=\"viewModel.groups.serviceTeam\"\n                           ng-change=\"onSelectedGroupChange()\">\n\n                    <span class=\"radioLabel\" ui-translate>homePage.widgets.submissionGrid.bulkReassign.userSelectionModal.serviceTeamGroupLabel</span>\n                </label>\n            </div>\n\n            <um-dropdown class-name=\"serviceUserDropdown\"\n                         required=\"'true'\"\n                         option-list=\"viewModel.serviceTeamList\"\n                         selected-value=\"viewModel.selectedServiceTeam.value\"\n                         on-change=\"onServiceTeamChange(selectedOption)\"\n                         is-disabled=\"viewModel.selectedGroup !== viewModel.groups.serviceTeam\">\n            </um-dropdown>\n        </div>\n\n        <div class=\"secondaryGroup\">\n            <!-- Add Member-->\n            <div class=\"subInputRow\"\n                 ng-if=\"viewModel.selectedGroup === viewModel.groups.serviceTeam\">\n\n                <div class=\"activationRow\">\n                    <span ui-translate>homePage.widgets.submissionGrid.bulkReassign.userSelectionModal.addMemberServiceDropdownLabel</span>\n                </div>\n\n                <um-dropdown class-name=\"serviceTeamAdditionDropdown\"\n                             option-list=\"viewModel.selectedServiceTeamOptionList\"\n                             selected-value=\"viewModel.selectedServiceTeamAddition.value\"\n                             on-change=\"onServiceTeamAdditionChange(selectedOption)\"\n                             is-disabled=\"!viewModel.selectedServiceTeam\">\n                </um-dropdown>\n            </div>\n\n\n            <!-- Remove Member-->\n            <div class=\"subInputRow\"\n                 ng-if=\"viewModel.selectedGroup === viewModel.groups.serviceTeam\">\n\n                <div class=\"activationRow\">\n                    <span ui-translate>homePage.widgets.submissionGrid.bulkReassign.userSelectionModal.removeMemberServiceDropdownLabel</span>\n                </div>\n\n                <um-dropdown class-name=\"serviceTeamRemovalDropdown\"\n                             option-list=\"viewModel.selectedServiceTeamOptionList\"\n                             selected-value=\"viewModel.selectedServiceTeamRemoval.value\"\n                             on-change=\"onServiceTeamRemovalChange(selectedOption)\"\n                             is-disabled=\"!viewModel.selectedServiceTeam\">\n                </um-dropdown>\n            </div>\n        </div>\n\n\n    </div>\n\n    <!--Footer-->\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-primary confirmActionButton\"\n                ng-disabled=\"isContinueButtonDisabled()\"\n                ng-click=\"onConfirm()\">\n            <span ui-translate>homePage.widgets.submissionGrid.bulkReassign.reassign</span>\n        </button>\n\n        <button class=\"btn btn-default cancelButton\"\n                ng-click=\"$dismiss()\">\n            <span ui-translate>homePage.widgets.submissionGrid.bulkReassign.cancel</span>\n        </button>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

/*@ngInject*/
var MultiSelectConfirmationModalController = function MultiSelectConfirmationModalController($window, $rootScope, $state, $scope, options, coreConstant) {
  $scope.viewModel = {
    successCount: options.successCount,
    totalRequested: options.totalRequested,
    errorList: options.errorList
  };
  $scope.onOpenErrorSubmission = function (submissionId) {
    var url = $state.href('submission', {
      submissionId: submissionId
    });
    $window.open(url, '_blank');
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
MultiSelectConfirmationModalController.$inject = ["$window", "$rootScope", "$state", "$scope", "options", "coreConstant"];
angular.module('umCore').controller('multiSelectConfirmationModalController', MultiSelectConfirmationModalController);

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

var path = '/ui/grid/multiSelect/confirmationModal/confirmationModal.tpl.html';
var html = "<div class=\"genericModalContent\">\n\n    <div class=\"modal-header\">\n\n        <h3 class=\"modal-title\" ui-translate>homePage.widgets.submissionGrid.bulkReassign.confirmationModal.title</h3>\n\n        <button class=\"close\"\n                ng-click=\"$dismiss()\">\n\n            <span class=\"glyphicon glyphicon-remove\"></span>\n        </button>\n    </div>\n\n    <div class=\"modal-body modalSummary\">\n        <div>\n            <span class=\"successCount\">{{viewModel.successCount}}</span>\n            <span ui-translate>homePage.widgets.submissionGrid.bulkReassign.confirmationModal.message.of</span>\n            <span class=\"totalRequested\">{{viewModel.totalRequested}}</span>\n            <span ui-translate>homePage.widgets.submissionGrid.bulkReassign.confirmationModal.message.successfullyProcessed</span>\n        </div>\n        <div class=\"errorLinks\">\n\n            <div class=\"errorTitle\"\n                 ng-if=\"viewModel.errorList.length\" ui-translate>homePage.widgets.submissionGrid.bulkReassign.confirmationModal.error.title</div>\n\n            <a ng-repeat=\"errorItem in viewModel.errorList\"\n                ng-click=\"onOpenErrorSubmission(errorItem)\">\n                <span ui-translate>homePage.widgets.submissionGrid.bulkReassign.confirmationModal.error.urlStructure</span>\n                <span>{{errorItem}}</span>\n            </a>\n        </div>\n\n    </div>\n\n    <!--Footer-->\n    <div class=\"modal-footer\">\n\n        <button class=\"btn btn-primary closeButton\"\n                ng-click=\"$close()\"><span ui-translate>homePage.widgets.submissionGrid.bulkReassign.confirmationModal.closeButton</span>\n        </button>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

var path = '/ui/iconViewer/iconViewer.tpl.html';
var html = "<ul class=\"iconList\">\n\n    <li ng-if=\"$ctrl.displayCustomIcons\"\n        ng-repeat=\"icon in $ctrl.customIcons\">\n        <img ng-src=\"{{icon.source}}\"\n             class=\"accordIcon\"\n             uib-tooltip=\"{{icon.description}}\"\n             tooltip-append-to-body=\"true\"\n             tooltip-placement=\"bottom auto\"\n             tooltip-trigger=\"mouseenter\"/>\n    </li>\n\n    <li ng-if=\"$ctrl.showRenewalIcon()\">\n        <img ng-src=\"{{::$ctrl.nonCustomIcons.renewalIcon.source}}\"\n             class=\"renewalIcon\"\n             uib-tooltip=\"{{::$ctrl.nonCustomIcons.renewalIcon.description}}\"\n             tooltip-append-to-body=\"true\"\n             tooltip-placement=\"bottom auto\"\n             tooltip-trigger=\"mouseenter\"/>\n    </li>\n\n    <li ng-if=\"$ctrl.showReferredCurrentIcon()\">\n        <img ng-src=\"{{::$ctrl.nonCustomIcons.referredCurrentIcon.source}}\"\n             uib-tooltip=\"{{::$ctrl.nonCustomIcons.referredCurrentIcon.description}}\"\n             class=\"referredCurrentIcon\"\n             tooltip-append-to-body=\"true\"\n             tooltip-placement=\"bottom auto\"\n             tooltip-trigger=\"mouseenter\"/>\n    </li>\n\n    <li ng-if=\"$ctrl.showReferredOtherIcon()\">\n        <img class=\"referredOtherIcon\"\n             ng-src=\"{{::$ctrl.nonCustomIcons.referredOtherIcon.source}}\"\n             class=\"referredOtherIcon\"\n             uib-tooltip=\"{{::$ctrl.nonCustomIcons.referredOtherIcon.description}} {{::$ctrl.item.referredUnderwriterSummary.name}}\"\n             tooltip-append-to-body=\"true\"\n             tooltip-placement=\"bottom auto\"\n             tooltip-trigger=\"mouseenter\"/>\n\n    </li>\n\n    <li ng-if=\"$ctrl.showEligibleQuotingIcon()\">\n        <img ng-src=\"{{$ctrl.agentQuotingIcon.source}}\"\n             class=\"eligibleQuotingIcon\"\n             uib-tooltip=\"{{::$ctrl.agentQuotingIcon.description}}\"\n             tooltip-append-to-body=\"true\"\n             tooltip-placement=\"bottom auto\"\n             tooltip-trigger=\"mouseenter\"/>\n    </li>\n\n    <li ng-if=\"$ctrl.showReferralClearedIcon()\">\n        <img class=\"referralClearedIcon\"\n             ng-src=\"{{::$ctrl.nonCustomIcons.referralClearedIcon.source}}\"\n             class=\"referralClearedIcon\"\n             uib-tooltip=\"{{::$ctrl.nonCustomIcons.referralClearedIcon.description}}\"\n             tooltip-append-to-body=\"true\"\n             tooltip-placement=\"bottom auto\"\n             tooltip-trigger=\"mouseenter\"/>\n    </li>\n\n</ul>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

var IconViewerComponent = {
  templateUrl: '/ui/iconViewer/iconViewer.tpl.html',
  controller: 'iconViewerController',
  bindings: {
    item: '<',
    userId: '<'
  }
};
angular.module('umCore').component('uiIconViewer', IconViewerComponent);

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, i18n) {var stpIndicator = __webpack_require__(1427),
  renewalIndicator = __webpack_require__(1428),
  referredToIcon = __webpack_require__(1429),
  referredFromIcon = __webpack_require__(1430),
  referralClearedIcon = __webpack_require__(1431);

/*@ngInject*/
var IconViewerController = function IconViewerController($scope, localization, coreMediator, submissionTransactionType, agentQuoteStatus, submissionReferralStatus, xmlUtil, appTypeConfigurationModel) {
  localization.setupLocale('iconViewer', __webpack_require__(1432));
  this.$onInit = function () {
    this.displayCustomIcons = false;
    this.getNonCustomIcons();
    this.getAgentQuotingIcon();
    if (_.isNil(this.customIcons)) {
      this.getCustomIcons();
    }
  };
  this.$onChanges = function () {
    if (this.item.customIconNames) {
      this.getCustomIcons();
    } else {
      this.customIcons = null;
    }
  };
  this.getAgentQuotingIcon = function () {
    var _this = this;
    this.agentQuotingIcon = {
      description: i18n.t('iconViewer|icons.eligibleQuoting')
    };
    coreMediator.getConfiguredFile('agentQuotingIcon').then(function (configuredFile) {
      if (!_.isEmpty(configuredFile)) {
        coreMediator.getConfiguredFileData(configuredFile.id).then(function (data) {
          _this.agentQuotingIcon.source = "data:".concat(configuredFile.mimeType, ";base64,").concat(data);
          if (_.isEmpty(_this.agentQuotingIcon.description)) {
            _this.agentQuotingIcon.description = configuredFile.description;
          }
        });
      } else {
        _this.agentQuotingIcon.source = stpIndicator;
      }
    });
  };
  this.getCustomIcons = function () {
    var _this2 = this;
    this.customIcons = [];
    if (!_.isNil(this.item)) {
      _.each(this.item.customIconNames, function (icon) {
        coreMediator.getConfiguredFile(icon.customIconName).then(function (configuredFile) {
          if (!_.isEmpty(configuredFile)) {
            coreMediator.getConfiguredFileData(configuredFile.id).then(function (data) {
              icon.source = "data:".concat(configuredFile.mimeType, ";base64,").concat(data);
              var i18nKey = "iconViewer|icons.".concat(configuredFile.name);
              if (icon.text) {
                icon.description = icon.text;
              } else if (i18n.exists(i18nKey)) {
                icon.description = i18n.t(i18nKey);
              } else {
                icon.description = configuredFile.description;
              }
              _this2.customIcons.push(icon);
              _this2.displayCustomIcons = true;
            });
          }
        });
      });
    }
  };
  this.getNonCustomIcons = function () {
    this.nonCustomIcons = {
      renewalIcon: {
        description: i18n.t('iconViewer|icons.renewalSubmission'),
        source: renewalIndicator
      },
      referredCurrentIcon: {
        description: i18n.t('iconViewer|icons.referredCurrent'),
        source: referredToIcon
      },
      referredOtherIcon: {
        description: i18n.t('iconViewer|icons.referredOther'),
        source: referredFromIcon
      },
      referralClearedIcon: {
        description: i18n.t('iconViewer|icons.referralCleared'),
        source: referralClearedIcon
      }
    };
  };
  this.showRenewalIcon = function () {
    if (!_.isNil(this.item)) {
      return this.item.transactionType === submissionTransactionType.RENEWAL;
    }
    return false;
  };
  this.showReferredCurrentIcon = function () {
    if (!_.isNil(this.item)) {
      return this.item.referredUnderwriterSummary && this.item.referredUnderwriterSummary.id === this.userId;
    }
    return false;
  };
  this.showReferredOtherIcon = function () {
    var isNotAgentConsole, agentQuotingEnabled, notAgentConsoleOrSTP;
    if (!_.isNil(this.item)) {
      isNotAgentConsole = !appTypeConfigurationModel.isAgentConsole();
      agentQuotingEnabled = this.item.agentQuoteStatus === agentQuoteStatus.ENABLED;
      notAgentConsoleOrSTP = isNotAgentConsole || agentQuotingEnabled;
      return this.item.referredUnderwriterSummary && this.item.referredUnderwriterSummary.id !== this.userId && notAgentConsoleOrSTP;
    }
    return false;
  };
  this.showEligibleQuotingIcon = function () {
    if (!_.isNil(this.item)) {
      return this.item.agentQuoteStatus === agentQuoteStatus.ENABLED;
    }
    return false;
  };
  this.showReferralClearedIcon = function () {
    var isNotAgentConsole, agentQuotingEnabled, notAgentConsoleOrSTP;
    if (!_.isNil(this.item)) {
      isNotAgentConsole = !appTypeConfigurationModel.isAgentConsole();
      agentQuotingEnabled = this.item.agentQuoteStatus === agentQuoteStatus.ENABLED;
      notAgentConsoleOrSTP = isNotAgentConsole || agentQuotingEnabled;
      return this.item.referralStatus === submissionReferralStatus.CLEAR_REFERRAL && notAgentConsoleOrSTP;
    }
    return false;
  };
};
IconViewerController.$inject = ["$scope", "localization", "coreMediator", "submissionTransactionType", "agentQuoteStatus", "submissionReferralStatus", "xmlUtil", "appTypeConfigurationModel"];
angular.module('umCore').controller('iconViewerController', IconViewerController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(18)["default"]))

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2183e65569a3a6395ff824cb01f554a4.png";

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6af6c77d570a6d7761794994ad272ea7.png";

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cae06591d0546c723430268e69483e0b.png";

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a74ff00c7fb7de3e16a8b0ecc7562203.png";

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "03b18396b4aa82008cf614ffe4bff51d.png";

/***/ }),
/* 1432 */
/***/ (function(module) {

module.exports = JSON.parse("{\"icons\":{\"renewalSubmission\":\"Renewal Submission\",\"referredCurrent\":\"Referred to you\",\"referredOther\":\"Referred to \",\"eligibleQuoting\":\"Eligible for Agent Quoting\",\"referralCleared\":\"Referral Cleared\"}}");

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

/*@ngInject*/
var UILoaderDirective = function UILoaderDirective() {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    $scope.type = 'light';
    if ($attrs.type === 'dark') {
      $scope.type = 'dark';
    }
  };
  return {
    restrict: 'E',
    replace: true,
    link: linkFunction,
    templateUrl: '/ui/uiLoader.tpl.html'
  };
};
angular.module('umCore').directive('uiLoader', UILoaderDirective);

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

var path = '/ui/loader/uiLoader.tpl.html';
var html = "<div ng-if=\"viewModel.isLoading\" class=\"loaderContainer\" ng-class=\"type\">\n    <div class=\"loader\" ng-class=\"{'icon-dotsSpinnerDark':type==='dark', 'icon-dotsSpinnerLight':type==='light'}\"></div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

var path = '/ui/loadingBar/loadingBar.tpl.html';
var html = "<div class=\"loadingBarMask\"\n    ng-if=\"$ctrl.isLoading\">\n\n    <div class=\"loadingBar\">\n\n        <span>{{ $ctrl.message }}</span>\n\n        <uib-progressbar class=\"loadingBarProgress progress-striped active\"\n                         animate=\"true\">\n\n    </div>\n    <iframe src=\"about:blank\" class=\"ieMaskFrame loadingBarMask\" ui-browser-detection></iframe>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1436 */
/***/ (function(module, exports) {

var LoadingBarComponent = {
  templateUrl: '/ui/loadingBar/loadingBar.tpl.html',
  controller: 'loadingBarController',
  bindings: {
    message: '@'
  }
};
angular.module('umCore').component('loadingBar', LoadingBarComponent);

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var LoadingBarController = function LoadingBarController($scope, coreConstant, localization) {
  this.$onInit = function () {
    this.isLoading = false;
  };
  $scope.$on(coreConstant.event.SHOW_LOADING_BAR, function (event, messageKey) {
    this.setMessage(messageKey);
    this.isLoading = true;
  }.bind(this));
  $scope.$on(coreConstant.event.HIDE_LOADING_BAR, function () {
    this.isLoading = false;
  }.bind(this));
  this.setMessage = function (messageKey) {
    if (_.isNil(messageKey)) {
      messageKey = 'loadingBar.defaultMessage';
    }
    localization.getTranslationByKey(messageKey).then(function (translation) {
      this.message = translation || messageKey;
    }.bind(this));
  };
  this.setMessage('loadingBar.defaultMessage');
};
LoadingBarController.$inject = ["$scope", "coreConstant", "localization"];
angular.module('umCore').controller('loadingBarController', LoadingBarController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

var path = '/ui/modal/modal.tpl.html';
var html = "<div class=\"genericModalContent\">\n\n    <div class=\"modal-header\">\n\n        <h3 class=\"modal-title\">{{ viewModel.title }}</h3>\n\n        <button class=\"close\"\n                ng-click=\"$dismiss()\">\n\n            <span class=\"glyphicon glyphicon-remove\"></span>\n        </button>\n    </div>\n\n    <div class=\"modal-body modalSummary\">{{ viewModel.summary }}</div>\n\n    <!--Footer-->\n    <div class=\"modal-footer\"\n        ng-if=\"!viewModel.showCustomButton\">\n\n        <button class=\"btn btn-default\"\n                ng-if=\"viewModel.showAlternateButton\"\n                ng-click=\"$close('alternate')\">{{ viewModel.alternateButtonLabel }}\n        </button>\n\n        <button class=\"btn btn-primary confirmActionButton\"\n                ng-if=\"viewModel.showConfirmActionButton\"\n                ng-click=\"$close('confirm')\">{{ viewModel.confirmActionButtonLabel }}\n        </button>\n\n        <button class=\"btn btn-default cancelButton\"\n                ng-if=\"viewModel.showCancelButton\"\n                ng-click=\"$dismiss()\">{{ viewModel.cancelButtonLabel }}\n        </button>\n    </div>\n\n    <!--Custom Button Footer-->\n    <div class=\"modal-footer\"\n         ng-if=\"viewModel.showCustomButton\">\n        <div ng-repeat=\"alert in viewModel.customButtons track by $index\">\n            <button class=\"btn btn-default {{::alert.label }}\"\n                    uib-tooltip=\"{{alert.tooltipText}}\"\n                    ng-class=\"{'btn btn-primary' : isPrimaryButton(alert)}\"\n                    ng-click=\"onCustomButtonClick(alert)\">{{ alert.label }}\n            </button>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ModalController = function ModalController($rootScope, $scope, options, coreConstant, functionActionUtil) {
  $scope.viewModel = {
    showCancelButton: !_.isUndefined(options.cancelButtonLabel),
    showConfirmActionButton: !_.isUndefined(options.confirmActionButtonLabel),
    confirmActionButtonLabel: options.confirmActionButtonLabel,
    summary: options.summary,
    cancelButtonLabel: options.cancelButtonLabel,
    title: options.title,
    showCustomButton: !_.isUndefined(options.customButtonType),
    customButtons: options.customButtons,
    showAlternateButton: !_.isUndefined(options.alternateButtonLabel),
    alternateButtonLabel: options.alternateButtonLabel,
    submission: options.submission,
    contextParameters: options.contextParameters
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $scope.isPrimaryButton = function (alert) {
    var parameterObject = functionActionUtil.getParameterAsObject(alert.parameters);
    if (parameterObject.action === 'noOpen') {
      return false;
    }
    return true;
  };
  $scope.onCustomButtonClick = function (alert) {
    var parameterObject = functionActionUtil.getParameterAsObject(alert.parameters);
    if (parameterObject.action === 'noOpen') {
      $scope.$close();
    } else {
      functionActionUtil.handleAction(alert, $scope.viewModel.submission, options.customButtonType, alert.name, options.contextParameters);
      $scope.$close('confirm');
    }
  };
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
ModalController.$inject = ["$rootScope", "$scope", "options", "coreConstant", "functionActionUtil"];
angular.module('umCore').controller('modalController', ModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, moment) {/*@ngInject*/
var ModalUtil = function ModalUtil($rootScope, $uibModal, $state, $q, coreMediator, coreConstant, localization, loadingBarHandler, submissionConstant) {
  var serverDisconnectedModalDisplayed = false;
  this.showConfirmationModal = function (submissionId, quoteId, notificationEmailTemplateName, translationRoot, logAction, hideLoadingBar, callbackOnClose) {
    localization.getTranslations().then(function (root) {
      var translations = _.get(root, translationRoot),
        context = {};
      if (notificationEmailTemplateName) {
        if (submissionId) {
          context.submissionId = submissionId;
        }
        if (quoteId) {
          context.quoteId = quoteId;
        }
        coreMediator.getNotificationEmailTemplate(notificationEmailTemplateName, context).then(show);
      } else {
        show();
      }
      function show(notificationPreference) {
        var modalInstance = $uibModal.open({
          templateUrl: '/ui/modal/modal.tpl.html',
          controller: 'modalController',
          backdrop: 'static',
          windowClass: 'genericModal',
          resolve: {
            options: {
              cancelButtonLabel: _.get(translations, 'cancel'),
              confirmActionButtonLabel: _.get(translations, 'confirm'),
              summary: _.get(translations, 'summary'),
              title: notificationPreference && !_.isNil(notificationPreference.title) ? notificationPreference.title : _.get(translations, 'title')
            }
          }
        });
        modalInstance.result.then(handleClose);
      }
      function handleClose(result) {
        var callbackPromise;
        if (!hideLoadingBar) {
          loadingBarHandler.showLoadingBar(translationRoot + '.loadingBar');
        }
        startPerformanceLog(logAction, submissionId);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        callbackPromise = callbackOnClose(result);
        if (!_.isNil(callbackPromise)) {
          callbackPromise.then(onSuccess, onError);
        }
        function onSuccess() {
          loadingBarHandler.hideLoadingBar();
          $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
          stopPerformanceLog(logAction, coreConstant.uiPeformanceLogger.SUCCESS);
        }
        function onError() {
          loadingBarHandler.hideLoadingBar();
          stopPerformanceLog(logAction, coreConstant.uiPeformanceLogger.FAIL);
        }
      }
    });
  };
  this.showProposalBindActionModal = function (submissionId, proposalId, translationRoot, notificationName, logAction, callBack) {
    localization.getTranslations().then(function (root) {
      var translations = _.get(root, translationRoot);
      if (notificationName) {
        coreMediator.getNotificationPreference(notificationName, {
          submissionId: submissionId.toString(),
          proposalId: proposalId,
          link: null
        }).then(show);
      } else {
        show();
      }
      function show(notificationPreference) {
        var dynamicDataSetParams = {
          name: _.get(translations, 'dataSet'),
          submissionUri: 'com.firstbest.underwriting.submission.Submission:' + submissionId,
          ownerUri: 'com.firstbest.underwriting.proposal.Proposal:' + proposalId
        };
        coreMediator.getDynamicDataSetItems(dynamicDataSetParams).then(function (response) {
          var modalInstance = $uibModal.open({
            templateUrl: '/wizard/actions/bindActions/bindActionModal.tpl.html',
            controller: 'bindActionModalController',
            backdrop: 'static',
            windowClass: 'bindActionModal',
            resolve: {
              options: function options() {
                return {
                  quoteList: response,
                  translationRoot: translationRoot,
                  notificationPreference: notificationPreference
                };
              }
            }
          });
          modalInstance.result.then(function (options) {
            bindActionContinue(callBack, submissionId, logAction, translationRoot, proposalId, options.selectedQuoteIds);
          });
        });
      }
    });
  };
  function bindActionContinue(callBack, submissionId, logAction, translationRoot, proposalId, quoteIds) {
    startPerformanceLog(logAction, submissionId);
    loadingBarHandler.showLoadingBar(translationRoot + '.loadingBar');
    callBack(proposalId, quoteIds).then(onSuccess, onError).finally(onFinally);
    function onSuccess(response) {
      stopPerformanceLog(logAction, coreConstant.uiPeformanceLogger.SUCCESS);
    }
    function onError() {
      stopPerformanceLog(logAction, coreConstant.uiPeformanceLogger.FAIL);
    }
    function onFinally() {
      loadingBarHandler.hideLoadingBar();
    }
  }
  this.showSelectionModal = function (submissionId, quoteId, proposalId, translationRoot, logAction, callbackOnClose) {
    localization.getTranslations().then(function (root) {
      var translations = _.get(root, translationRoot);
      var modalInstance = $uibModal.open({
        templateUrl: '/wizard/selection/selectionModal.tpl.html',
        controller: 'selectionModalController',
        backdrop: 'static',
        windowClass: 'selectionModalContainer',
        resolve: {
          selectionDropdown: function selectionDropdown() {
            var uri;
            if (!_.isNil(quoteId)) {
              uri = quoteId ? 'com.firstbest.underwriting.quote.Quote:' + quoteId : null;
            }
            if (!_.isNil(proposalId)) {
              uri = proposalId ? 'com.firstbest.underwriting.proposal.Proposal:' + proposalId : null;
            }
            return {
              name: _.get(translations, 'dataSet'),
              submissionUri: 'com.firstbest.underwriting.submission.Submission:' + submissionId,
              ownerUri: uri
            };
          },
          options: function options() {
            return {
              title: _.get(translations, 'title'),
              summary: _.get(translations, 'summary'),
              confirm: _.get(translations, 'confirmButton'),
              warningSummary: _.get(translations, 'warningSummary'),
              selectedPrimaryPrompt: _.get(translations, 'primaryPrompt')
            };
          }
        }
      });
      modalInstance.result.then(handleClose);
      function handleClose(result) {
        var callbackPromise;
        loadingBarHandler.showLoadingBar(translationRoot + '.loadingBar');
        startPerformanceLog(logAction, submissionId);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        callbackPromise = callbackOnClose(result);
        if (!_.isNil(callbackPromise)) {
          callbackPromise.then(onSuccess, onError);
        }
        function onSuccess(result) {
          loadingBarHandler.hideLoadingBar();
          stopPerformanceLog(logAction, coreConstant.uiPeformanceLogger.SUCCESS);
        }
        function onError() {
          loadingBarHandler.hideLoadingBar();
          stopPerformanceLog(logAction, coreConstant.uiPeformanceLogger.FAIL);
        }
      }
    });
  };
  this.showUserProfile = function () {
    $uibModal.open({
      templateUrl: '/ui/modal/userProfileModal/userProfileModal.tpl.html',
      controller: 'userProfileModalController',
      backdrop: 'static',
      windowClass: 'userProfileModal'
    });
  };
  this.showFieldDetails = function (fieldStructure, formStructure) {
    $uibModal.open({
      templateUrl: '/formViewer/component/directive/uiShowFieldDetailsModal/fieldDetailsModal.tpl.html',
      controller: 'fieldDetailsModalController',
      backdrop: 'static',
      windowClass: 'fieldDetailsModalContainer',
      resolve: {
        options: function options() {
          return {
            fieldStructure: fieldStructure,
            formStructure: formStructure
          };
        }
      }
    });
  };
  this.showHiddenFieldDetails = function (hiddenFieldList) {
    $uibModal.open({
      templateUrl: '/formViewer/component/directive/uiHiddenFieldDetailsModal/hiddenFieldDetailsModal.tpl.html',
      controller: 'hiddenFieldDetailsModalController',
      backdrop: 'static',
      windowClass: 'hiddenFieldDetailsModalContainer',
      resolve: {
        options: function options() {
          return {
            formHiddenFieldList: hiddenFieldList
          };
        }
      }
    });
  };
  this.showGenericConfirm = function (translations) {
    var modalInstance = $uibModal.open({
      templateUrl: '/ui/modal/modal.tpl.html',
      controller: 'modalController',
      backdrop: 'static',
      windowClass: 'genericModal',
      resolve: {
        options: function options() {
          return {
            cancelButtonLabel: translations.cancelButtonLabel,
            showCancelButton: translations.showCancelButton,
            confirmActionButtonLabel: translations.confirmActionButtonLabel,
            alternateButtonLabel: translations.alternateButtonLabel,
            summary: translations.summary,
            customButtonType: translations.customButtonType,
            customButtons: translations.customButtons,
            title: translations.title
          };
        }
      }
    });
    return modalInstance.result;
  };
  this.showCustomAlertModal = function (translations, submission) {
    var modalInstance = $uibModal.open({
      templateUrl: '/ui/modal/modal.tpl.html',
      controller: 'modalController',
      backdrop: 'static',
      windowClass: 'genericModal',
      resolve: {
        options: function options() {
          return {
            summary: translations.summary,
            customButtonType: translations.customButtonType,
            customButtons: translations.customButtons,
            title: translations.title,
            submission: submission,
            contextParameters: translations.contextParameters
          };
        }
      }
    });
    return modalInstance.result;
  };
  this.showEmailViewer = function (email, forwardCallback, replyCallback, replyAllCallback, saveEmailCallback, deleteEmailCallback, isUnderwriterUser, canCreateEmail, canDeleteEmail) {
    return $uibModal.open({
      templateUrl: '/collaboration/email/emailViewer/emailViewerModal.tpl.html',
      controller: 'emailViewerModalController',
      backdrop: 'static',
      windowClass: 'emailViewerModal',
      resolve: {
        options: function options() {
          return {
            email: email,
            isUnderwriterUser: isUnderwriterUser,
            canCreateEmail: canCreateEmail,
            canDeleteEmail: canDeleteEmail,
            forwardEmail: forwardCallback,
            replyEmail: replyCallback,
            replyAllEmail: replyAllCallback,
            saveEmail: saveEmailCallback,
            deleteEmail: deleteEmailCallback
          };
        }
      }
    });
  };
  this.showCommentsModal = function (submissionId, comments, _options, translationRoot, logAction, callbackOnClose) {
    localization.getTranslations().then(function (root) {
      var translations = _.get(root, translationRoot);
      $uibModal.open({
        templateUrl: '/ui/modal/commentsModal/commentsModal.tpl.html',
        controller: 'commentsModalController',
        backdrop: 'static',
        windowClass: 'commentsModalContainer',
        resolve: {
          options: function options() {
            return {
              title: _options.title ? _options.title : _.get(translations, 'title'),
              summary: _options.summary || _options.summary === null ? _options.summary : _.get(translations, 'summary'),
              label: _options.label ? _options.label : _.get(translations, 'label'),
              comments: comments,
              cancel: _options.cancel ? _options.cancel : _.get(translations, 'cancel'),
              primaryAction: _options.primaryAction ? _options.primaryAction : _.get(translations, 'primaryAction'),
              secondaryAction: _options.secondaryAction ? _options.secondaryAction : _.get(translations, 'secondaryAction'),
              showSecondaryAction: _options.showSecondaryAction
            };
          }
        }
      }).result.then(handleClose);
      function handleClose(result) {
        var loadingBar, callbackPromise;
        if (result.primaryAction) {
          loadingBar = _options.primaryActionLoadingBar ? _options.primaryActionLoadingBar : _.get(translations, 'primaryActionLoadingBar');
        } else if (result.secondaryAction) {
          loadingBar = _options.secondaryActionLoadingBar ? _options.secondaryActionLoadingBar : _.get(translations, 'secondaryActionLoadingBar');
        }
        loadingBarHandler.showLoadingBar(loadingBar);
        startPerformanceLog(logAction, submissionId);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        callbackPromise = callbackOnClose(result);
        if (!_.isNil(callbackPromise)) {
          callbackPromise.then(onSuccess, onError);
        }
        function onSuccess() {
          loadingBarHandler.hideLoadingBar();
          $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
          stopPerformanceLog(logAction, coreConstant.uiPeformanceLogger.SUCCESS);
        }
        function onError() {
          loadingBarHandler.hideLoadingBar();
          stopPerformanceLog(logAction, coreConstant.uiPeformanceLogger.FAIL);
        }
      }
    });
  };
  this.showNewAttachmentModal = function (_existingFile, _fullOptionsForm) {
    var instance = $uibModal.open({
      templateUrl: '/newAttachmentModal/newAttachmentModal.tpl.html',
      controller: 'newAttachmentModalController',
      backdrop: 'static',
      windowClass: 'newAttachmentModal',
      resolve: {
        options: function options() {
          return {};
        },
        isUnderwriterUser: function isUnderwriterUser() {
          return coreMediator.loadUserProfile().then(function (userProfile) {
            return userProfile.userType === 'Underwriter';
          });
        },
        fullOptionsForm: function fullOptionsForm() {
          return _fullOptionsForm;
        },
        existingFile: function existingFile() {
          return _existingFile;
        }
      }
    });
    return instance.result;
  };
  this.showAttachmentsListModal = function (attachmentList) {
    var instance = $uibModal.open({
      templateUrl: '/wizard/addDocumentAction/addDocumentActionModal.tpl.html',
      controller: 'addDocumentActionModalController',
      backdrop: 'static',
      windowClass: 'addDocumentActionModal',
      resolve: {
        attachments: function attachments() {
          return attachmentList;
        }
      }
    });
    return instance.result;
  };
  this.showActionNotImplementedModal = function (actionName) {
    localization.getTranslations().then(function (translations) {
      $uibModal.open({
        templateUrl: '/ui/modal/errorModal/errorModal.tpl.html',
        controller: 'errorModalController',
        backdrop: 'static',
        windowClass: 'genericErrorModal',
        resolve: {
          options: {
            title: _.get(translations, 'alert.genericErrorTitle'),
            message: _.get(translations, 'alert.unableToRouteAction') + actionName,
            okButtonLabel: _.get(translations, 'alert.okButtonLabel')
          }
        }
      });
    });
  };
  this.openFieldReferencesModal = function (translationRoot, fieldReferences, variableName, showConfirmationButtons) {
    return localization.getTranslations().then(function (root) {
      var instance,
        translations = _.get(root, translationRoot),
        summary = _.get(translations, 'summary');
      summary = _.replace(summary, '{referencesCount}', fieldReferences.length);
      summary = _.replace(summary, '{variableName}', variableName);
      instance = $uibModal.open({
        templateUrl: '/configuration/fieldReferences/fieldReferencesModal.tpl.html',
        controller: 'fieldReferencesController',
        backdrop: 'static',
        windowClass: 'fieldReferencesModal',
        resolve: {
          options: function options() {
            return {
              title: _.get(translations, 'title'),
              summary: summary,
              confirmButtonLabel: _.get(translations, 'confirmButtonLabel'),
              cancelButtonLabel: _.get(translations, 'cancelButtonLabel'),
              showConfirmationButtons: showConfirmationButtons,
              variableName: variableName,
              fieldReferenceList: fieldReferences
            };
          }
        }
      });
      return instance.result;
    });
  };
  this.openFormReferencesModal = function (translationRoot, formTemplateReferences, formTemplateUniqueName, showConfirmationButtons) {
    return localization.getTranslations().then(function (root) {
      var instance,
        translations = _.get(root, translationRoot),
        summary = _.get(translations, 'summary');
      summary = _.replace(summary, '{referencesCount}', formTemplateReferences.length);
      summary = _.replace(summary, '{formTemplateUniqueName}', formTemplateUniqueName);
      instance = $uibModal.open({
        templateUrl: '/configuration/formReferences/formReferencesModal.tpl.html',
        controller: 'formReferencesController',
        backdrop: 'static',
        windowClass: 'formReferencesModal',
        resolve: {
          options: function options() {
            return {
              title: _.get(translations, 'title'),
              summary: summary,
              confirmButtonLabel: _.get(translations, 'confirmButtonLabel'),
              cancelButtonLabel: _.get(translations, 'cancelButtonLabel'),
              showConfirmationButtons: showConfirmationButtons,
              formReferenceList: formTemplateReferences
            };
          }
        }
      });
      return instance.result;
    });
  };
  this.showServerDisconnectedModal = function () {
    if (!serverDisconnectedModalDisplayed) {
      serverDisconnectedModalDisplayed = true;
      return localization.getTranslations().then(function (translations) {
        var now = moment(),
          summary = _.replace(_.replace(_.get(translations, 'serverDisconnectedModal.summary'), '${dayOfWeek}', now.format('dddd')), '${time}', now.format('h:mmA')),
          instance;
        instance = $uibModal.open({
          templateUrl: '/ui/modal/serverDisconnectedModal/serverDisconnectedModal.tpl.html',
          controller: 'serverDisconnectedModalController',
          windowClass: 'serverDisconnectedModal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            options: function options() {
              return {
                title: _.get(translations, 'serverDisconnectedModal.title'),
                summary: summary,
                additionalSummary: _.get(translations, 'serverDisconnectedModal.additionalSummary')
              };
            }
          }
        });
        return instance.result.finally(function () {
          serverDisconnectedModalDisplayed = false;
        });
      });
    } else {
      return $q.when();
    }
  };
  this.showPersistentConnectionFailed = function () {
    localization.getTranslations().then(function (translations) {
      $uibModal.open({
        templateUrl: '/ui/modal/errorModal/errorModal.tpl.html',
        controller: 'errorModalController',
        windowClass: 'genericErrorModal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          options: function options() {
            return {
              title: _.get(translations, 'persistentConnectionFailedModal.title'),
              message: _.get(translations, 'persistentConnectionFailedModal.summary'),
              okButtonLabel: null
            };
          }
        }
      });
    });
  };
  this.isServerDisconnectedModalDisplayed = function () {
    return serverDisconnectedModalDisplayed;
  };
  function startPerformanceLog(logAction, submissionId) {
    if (logAction) {
      var message = !_.isNil(submissionId) ? submissionId.toString() : null;
      $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
    }
  }
  function stopPerformanceLog(logAction, status) {
    if (logAction) {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, status);
    }
  }
};
ModalUtil.$inject = ["$rootScope", "$uibModal", "$state", "$q", "coreMediator", "coreConstant", "localization", "loadingBarHandler", "submissionConstant"];
angular.module('umCore').service('modalUtil', ModalUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(2)))

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*@ngInject*/
var UmModalUtil = function UmModalUtil($rootScope, $uibModal, localization, coreConstant, coreMediator, loadingBarHandler, submissionConstant, submissionStateMediator, $state) {
  function startPerformanceLog(logAction, submissionId) {
    if (logAction) {
      var message = submissionId.toString();
      $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
    }
  }
  function stopPerformanceLog(logAction, status) {
    if (logAction) {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, status);
    }
  }
  this.showReasonModal = function (submissionId, quoteId, notificationEmailTemplateName, reasonObject, translationRoot, isReasonOptional, logAction, callbackOnClose, dropdownFilterFunctions, isSecondaryDropdownOptional, showDates, redirectToReturnedSubmission, utcDate) {
    isSecondaryDropdownOptional = _.isUndefined(isSecondaryDropdownOptional) ? true : isSecondaryDropdownOptional;
    localization.getTranslations().then(function (root) {
      var translations = _.get(root, translationRoot);
      if (notificationEmailTemplateName) {
        coreMediator.getNotificationEmailTemplate(notificationEmailTemplateName, {
          submissionId: submissionId.toString(),
          quoteId: quoteId ? quoteId.toString() : null,
          link: null
        }).then(show);
      } else {
        show();
      }
      function show(notificationPreference) {
        var modalInstance = $uibModal.open({
          templateUrl: '/wizard/reason/reasonModal.tpl.html',
          controller: 'reasonModalController',
          backdrop: 'static',
          windowClass: 'reasonModalContainer',
          resolve: {
            primaryDropdown: function primaryDropdown() {
              return {
                name: _.get(translations, 'reasons'),
                submissionUri: 'com.firstbest.underwriting.submission.Submission:' + submissionId,
                quoteUri: quoteId ? 'com.firstbest.underwriting.quote.Quote:' + quoteId : null
              };
            },
            secondaryDropdown: function secondaryDropdown() {
              if (!_.get(translations, 'secondaryReasons')) {
                return null;
              }
              return {
                name: _.get(translations, 'secondaryReasons'),
                submissionUri: 'com.firstbest.underwriting.submission.Submission:' + submissionId,
                quoteUri: quoteId ? 'com.firstbest.underwriting.quote.Quote:' + quoteId : null
              };
            },
            options: function options() {
              return {
                title: notificationPreference && !_.isNil(notificationPreference.title) ? notificationPreference.title : _.get(translations, 'title'),
                summary: _.get(translations, 'summary'),
                secondaryLabel: _.get(translations, 'secondaryLabel'),
                primaryReasonIsOptional: isReasonOptional,
                secondaryDropdownIsOptional: isSecondaryDropdownOptional,
                selectedPrimaryReason: isReasonOptional ? {
                  name: _.get(translations, 'primaryPrompt')
                } : {
                  name: reasonObject && reasonObject.reason ? reasonObject.reason : _.get(translations, 'primaryPrompt'),
                  value: reasonObject && reasonObject.reason ? reasonObject.reason : null,
                  ordering: reasonObject && reasonObject.reason ? -999 /* for 'Other' field */ : -1
                },
                selectedSecondaryReason: _.get(translations, 'secondaryPrompt') ? {
                  name: _.get(translations, 'secondaryPrompt'),
                  value: null,
                  ordering: -1
                } : null,
                comments: reasonObject && reasonObject.details ? reasonObject.details : '',
                primaryDropdownFilterFunction: dropdownFilterFunctions ? dropdownFilterFunctions.primaryDropdown : null,
                secondaryDropdownFilterFunction: dropdownFilterFunctions ? dropdownFilterFunctions.secondaryDropdown : null,
                showDates: showDates,
                startDateLabel: _.get(translations, 'startDateLabel'),
                endDateLabel: _.get(translations, 'endDateLabel'),
                timezoneMode: utcDate ? 'utc' : 'local'
              };
            }
          }
        });
        modalInstance.result.then(handleClose);
      }
      function handleClose(result) {
        loadingBarHandler.showLoadingBar(translationRoot + '.loadingBar');
        startPerformanceLog(logAction, submissionId);
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        callbackOnClose(result).then(onSuccess, onError);
        function onSuccess(result) {
          loadingBarHandler.hideLoadingBar();
          stopPerformanceLog(logAction, coreConstant.uiPeformanceLogger.SUCCESS);
          if (redirectToReturnedSubmission) {
            var params = {
                submissionId: result.id
              },
              stateName = 'submission.default';
            $state.go(stateName, params);
          }
        }
        function onError() {
          loadingBarHandler.hideLoadingBar();
          stopPerformanceLog(logAction, coreConstant.uiPeformanceLogger.FAIL);
        }
      }
    });
  };
  this.showReasonFormModel = function (_submission, _reasonFormId, _confirmActionCallback, _cancelActionCallback, _localizationRoot, _logAction) {
    $uibModal.open({
      templateUrl: '/wizard/reason/form/reasonFormModal.tpl.html',
      controller: 'reasonFormModalController',
      windowClass: 'reasonFormModal',
      resolve: {
        submission: function submission() {
          return _submission;
        },
        reasonFormId: function reasonFormId() {
          return _reasonFormId;
        },
        confirmActionCallback: function confirmActionCallback() {
          return _confirmActionCallback;
        },
        cancelActionCallback: function cancelActionCallback() {
          return _cancelActionCallback;
        },
        localizationRoot: function localizationRoot() {
          return _localizationRoot;
        },
        logAction: function logAction() {
          return _logAction;
        }
      },
      keyboard: false,
      backdrop: 'static'
    });
  };
  this.showReasonFormModal = function (_submission2, _reasonFormId2, _confirmActionCallback2, _cancelActionCallback2, _localizationRoot2, _logAction2) {
    $uibModal.open(_defineProperty({
      templateUrl: '/wizard/reason/form/reasonFormModal.tpl.html',
      controller: 'reasonFormModalController',
      backdrop: 'static',
      windowClass: 'reasonFormModal',
      resolve: {
        submission: function submission() {
          return _submission2;
        },
        reasonFormId: function reasonFormId() {
          return _reasonFormId2;
        },
        confirmActionCallback: function confirmActionCallback() {
          return _confirmActionCallback2;
        },
        cancelActionCallback: function cancelActionCallback() {
          return _cancelActionCallback2;
        },
        localizationRoot: function localizationRoot() {
          return _localizationRoot2;
        },
        logAction: function logAction() {
          return _logAction2;
        }
      },
      keyboard: false
    }, "backdrop", 'static'));
  };
};
UmModalUtil.$inject = ["$rootScope", "$uibModal", "localization", "coreConstant", "coreMediator", "loadingBarHandler", "submissionConstant", "submissionStateMediator", "$state"];
angular.module('umCore').service('umModalUtil', UmModalUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

var path = '/ui/modal/baseModal/baseModal.tpl.html';
var html = "<div class=\"baseModalContent\">\n\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\">{{::$ctrl.modalTitle}}</h3>\n        <button class=\"close\"\n                ng-click=\"onCancelClick()\">\n            <span class=\"glyphicon glyphicon-remove\"></span>\n        </button>\n    </div>\n\n    <!--Content-->\n    <div ng-transclude class=\"modal-body\"></div>\n\n    <!--Footer-->\n    <div class=\"modal-footer\">\n        <button class=\"btn {{::$ctrl.thirdButtonClass}} \"\n                ng-if=\"displayThirdButton()\"\n                ng-click=\"onThirdButtonClick()\"\n                ng-disabled=\"$ctrl.isThirdButtonDisabled\">{{$ctrl.thirdButton}}</button>\n        <a href=\"{{$ctrl.confirmButtonUrl}}\"\n           target=\"_blank\"\n           name=\"downloadLink\"\n           ng-click=\"onConfirmButtonUrlClick($event)\">\n            <button class=\"btn btn-primary okButton {{$ctrl.okButtonClass}} \"\n                    ng-click=\"onConfirm()\"\n                    ng-disabled=\"$ctrl.isConfirmDisabled\">{{$ctrl.ok}}</button>\n        </a>\n        <button class=\"btn btn-default cancelButton\"\n                ng-if=\"displayCancelButton()\"\n                ng-click=\"onCancelClick()\">{{::$ctrl.cancel}}</button>\n\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

var BaseModalComponent = {
  transclude: true,
  templateUrl: '/ui/modal/baseModal/baseModal.tpl.html',
  controller: 'baseModalController',
  bindings: {
    modalTitle: '<?',
    ok: '<?',
    cancel: '<?',
    thirdButton: '<?',
    isConfirmDisabled: '<?',
    isThirdButtonDisabled: '<?',
    confirmButtonUrl: '<?',
    onConfirm: '&?',
    onCancel: '&?',
    onThirdButton: '&?',
    okButtonClass: '<?',
    thirdButtonClass: '<?'
  }
};
angular.module('umCore').component('baseModal', BaseModalComponent);

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var BaseModalController = function BaseModalController($scope) {
  // these should all be on this and not scope since
  // they are in a component controller. then the below code would be this.onConfirm etc
  $scope.onConfirm = function () {
    $scope.$ctrl.onConfirm();
  };
  $scope.onConfirmButtonUrlClick = function (event) {
    if (_.isUndefined(this.$ctrl.confirmButtonUrl) || this.$ctrl.confirmButtonUrl === '') {
      event.preventDefault();
    }
  };
  $scope.onCancelClick = function () {
    $scope.$ctrl.onCancel();
  };
  $scope.onThirdButtonClick = function () {
    $scope.$ctrl.onThirdButton();
  };
  $scope.canEnableConfirmButton = function () {
    if (_.isUndefined($scope.$ctrl.canEnableConfirmButton)) {
      return true;
    } else {
      return $scope.$ctrl.canEnableConfirmButton();
    }
  };
  $scope.displayCancelButton = function () {
    if (_.isUndefined(this.$ctrl.cancel) || this.$ctrl.cancel === '') {
      return false;
    }
    return true;
  };
  $scope.displayThirdButton = function () {
    if (_.isUndefined(this.$ctrl.thirdButton) || this.$ctrl.thirdButton === '') {
      return false;
    }
    return true;
  };
};
BaseModalController.$inject = ["$scope"];
angular.module('umCore').controller('baseModalController', BaseModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

var path = '/ui/modal/commentsModal/commentsModal.tpl.html';
var html = "<div class=\"commentsModalContent\">\n    <!--Header-->\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\">{{ viewModel.title }}</h3>\n        <button ng-click=\"$dismiss()\" class=\"close\"><span class=\"glyphicon glyphicon-remove\"></span></button>\n    </div>\n\n    <!--Content-->\n    <div class=\"modal-body\">\n        <div class=\"summary\" ng-if=\"viewModel.summary\"\n             ng-bind-html=\"viewModel.summary\"></div>\n\n        <div class=\"comments\">\n            <div class=\"commentsLabel\">{{ viewModel.label }}</div>\n\n            <textarea class=\"comments\"\n                      ng-model=\"viewModel.comments\"></textarea>\n        </div>\n    </div>\n\n    <!--Footer-->\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-default\"\n                ng-if=\"viewModel.showSecondaryAction\"\n                ng-click=\"onSecondaryAction()\">{{ viewModel.secondaryAction }}\n        </button>\n\n        <button class=\"btn btn-primary\"\n                ng-click=\"onPrimaryAction()\">{{ viewModel.primaryAction }}\n        </button>\n\n        <button class=\"btn btn-default\"\n                ng-click=\"$dismiss()\">{{ viewModel.cancel }}\n        </button>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var CommentsModalController = function CommentsModalController($rootScope, $scope, options, localization, coreConstant) {
  localization.getTranslations().then(function (root) {
    var translations = _.get(root, 'commentsModal');
    $scope.viewModel = {
      title: options.title ? options.title : _.get(translations, 'title'),
      summary: options.summary || options.summary === null ? options.summary : _.get(translations, 'summary'),
      label: options.label ? options.label : _.get(translations, 'label'),
      comments: options.comments,
      cancel: options.cancel ? options.cancel : _.get(translations, 'cancel'),
      primaryAction: options.primaryAction ? options.primaryAction : _.get(translations, 'primaryAction'),
      secondaryAction: options.secondaryAction ? options.secondaryAction : _.get(translations, 'secondaryAction'),
      showSecondaryAction: options.showSecondaryAction
    };
    $scope.onPrimaryAction = function () {
      $scope.$close({
        comments: $scope.viewModel.comments,
        primaryAction: true,
        secondaryAction: false
      });
    };
    $scope.onSecondaryAction = function () {
      $scope.$close({
        comments: $scope.viewModel.comments,
        primaryAction: false,
        secondaryAction: true
      });
    };
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
CommentsModalController.$inject = ["$rootScope", "$scope", "options", "localization", "coreConstant"];
angular.module('umFormViewer').controller('commentsModalController', CommentsModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

var path = '/ui/modal/emailModal/emailModal.tpl.html';
var html = "<base-modal\n    modal-title=\"viewModel.notificationTitle\"\n    ok=\"viewModel.okButton\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\">\n\n    <div class=\"summary\"\n         ui-translate>emailModal.summary\n    </div>\n    <div class=\"summary\">\n        <div>\n            <input type=\"radio\"\n                   ng-model=\"viewModel.emailSelection\"\n                   value=\"{{::viewModel.emailNotificationOptions.STANDARD}}\"\n                   ng-if=\"viewModel.allowStandardEmail\">\n            <span ng-click=\"handleLabelClick($event, viewModel.emailNotificationOptions.STANDARD)\"\n                  class=\"radioLabel\"\n                  ui-translate\n                  ng-if=\"viewModel.allowStandardEmail\">emailModal.send</span>\n        </div>\n        <div>\n            <input type=\"radio\"\n                   ng-model=\"viewModel.emailSelection\"\n                   value=\"{{::viewModel.emailNotificationOptions.CUSTOM}}\">\n            <span ng-click=\"handleLabelClick($event, viewModel.emailNotificationOptions.CUSTOM)\"\n                  class=\"radioLabel\"\n                  ui-translate>emailModal.customize</span>\n        </div>\n        <div>\n            <input type=\"radio\"\n                   ng-model=\"viewModel.emailSelection\"\n                   value=\"{{::viewModel.emailNotificationOptions.NONE}}\">\n            <span ng-click=\"handleLabelClick($event, viewModel.emailNotificationOptions.NONE)\"\n                  class=\"radioLabel\"\n                  ui-translate>emailModal.doNotSend</span>\n        </div>\n    </div>\n\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var EmailModalController = function EmailModalController($scope, $rootScope, options, coreConstant, coreMediator, localization, emailNotificationOption) {
  localization.getTranslations().then(function (root) {
    var translations = _.get(root, 'emailModal');
    $scope.viewModel = {
      emailSelection: emailNotificationOption.STANDARD,
      submissionId: options.variables ? options.variables.submissionId : options.submissionId,
      notificationTitle: options.notificationTitle,
      allowStandardEmail: true,
      emailNotificationOptions: emailNotificationOption,
      okButton: _.get(translations, 'confirmButton')
    };
    $scope.onConfirm = function () {
      $scope.$close({
        notificationName: options.variables.notificationName,
        selection: $scope.viewModel.emailSelection,
        submissionId: $scope.viewModel.submissionId,
        options: options
      });
    };
    $scope.onCancel = function () {
      $scope.$dismiss();
    };
    $scope.handleLabelClick = function (event, radioValue) {
      $scope.viewModel.emailSelection = radioValue;
    };
    if (options.variables) {
      if (!_.isNil(options.variables.defaultSelectedOption)) {
        $scope.viewModel.emailSelection = options.variables.defaultSelectedOption;
      }
      $scope.viewModel.allowStandardEmail = parseInt(options.variables.numberOfRecipients) > 0;
      if (!$scope.viewModel.allowStandardEmail && $scope.viewModel.emailSelection === emailNotificationOption.STANDARD) {
        $scope.viewModel.emailSelection = emailNotificationOption.NONE;
      }
    } else {
      localization.getTranslationByKey('emailModal.title').then(function (translation) {
        $scope.viewModel.notificationTitle = translation;
      });
    }
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
EmailModalController.$inject = ["$scope", "$rootScope", "options", "coreConstant", "coreMediator", "localization", "emailNotificationOption"];
angular.module('umCore').controller('emailModalController', EmailModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1449 */
/***/ (function(module, exports) {

var path = '/ui/modal/errorModal/errorModal.tpl.html';
var html = "<base-modal\n    modal-title=\"viewModel.title\"\n    ok=\"viewModel.okButtonLabel\"\n    on-confirm=\"closePopUp()\"\n    on-cancel=\"closePopUp()\"\n    ok-button-class=\"viewModel.okButtonClass\">\n\n    <div class=\"genericErrorModalContent\">\n\n        <div class=\"summary\">\n            <p>{{ viewModel.message }}</p>\n        </div>\n\n        <div class=\"identifier text-right\" ng-if=\"viewModel.identifier\">\n            <div>{{ viewModel.identifier }}</div>\n        </div>\n\n        <div class=\"reference text-right\" ng-if=\"viewModel.reference\">\n            <div>Reference: {{ viewModel.reference }}</div>\n        </div>\n    </div>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ErrorModalController = function ErrorModalController($rootScope, $scope, options, coreConstant, $uibModalInstance) {
  $scope.viewModel = {
    showTraceMessage: false,
    trace: options.trace,
    okButtonLabel: options.okButtonLabel,
    identifier: options.identifier,
    reference: options.reference,
    message: options.message,
    title: options.title,
    okButtonClass: _.isNil(options.okButtonLabel) ? 'hideOkButton' : null
  };
  $scope.closePopUp = function () {
    $uibModalInstance.close();
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
ErrorModalController.$inject = ["$rootScope", "$scope", "options", "coreConstant", "$uibModalInstance"];
angular.module('umCore').controller('errorModalController', ErrorModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

var path = '/ui/modal/serverDisconnectedModal/serverDisconnectedModal.tpl.html';
var html = "<div class=\"serverDisconnectedModalContent\">\n\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\" ui-translate>{{ ::viewModel.title }}</h3>\n    </div>\n\n    <div class=\"modal-body\">\n        <div class=\"summary\"\n             ng-bind-html=\"::viewModel.summary\"></div>\n\n        <div class=\"additionalSummary\"\n             ng-if=\"viewModel.showAdditionalSummary\"\n             ng-bind-html=\"viewModel.additionalSummary\"></div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(moment, _) {/*@ngInject*/
var ServerDisconnectedModalController = function ServerDisconnectedModalController($rootScope, $scope, $interval, $window, $state, options, coreConstant, logUtil, refreshLoginTokenUtil, coreMediator) {
  var intervalObject = null;
  $scope.viewModel = {
    title: options.title,
    summary: options.summary,
    showAdditionalSummary: false,
    additionalSummary: options.additionalSummary
  };
  function init() {
    var reconnectTryCount = 0,
      unixMilliSecondsWhenDisconnected = moment().valueOf();
    $rootScope.$broadcast(coreConstant.event.STOP_KEEPALIVE_PING);
    refreshLoginTokenUtil.stop();
    $rootScope.$broadcast(coreConstant.event.STOP_IDLE);
    intervalObject = $interval(function () {
      function onSuccess() {
        var disconnectedForMillis = moment().valueOf() - unixMilliSecondsWhenDisconnected;
        logUtil.logWarning('Client Reconnect: disconnectedForMillis: ' + disconnectedForMillis).then(function () {
          $window.location.reload();
        });
      }
      function onError() {
        if (reconnectTryCount >= coreConstant.SERVER_DISCONNECTED_TRIES_BEFORE_ADDITIONAL_INFO) {
          $scope.viewModel.showAdditionalSummary = true;
        }
      }
      if (_.indexOf($state.current.name, 'login') === -1) {
        reconnectTryCount++;
        coreMediator.ack().then(onSuccess, onError);
      }
    }, coreConstant.DEFAULT_SERVER_DISCONNECTED_RECONNECT_INTERVAL);
  }
  $scope.$on('$destroy', function () {
    $interval.cancel(intervalObject);
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
  init();
};
ServerDisconnectedModalController.$inject = ["$rootScope", "$scope", "$interval", "$window", "$state", "options", "coreConstant", "logUtil", "refreshLoginTokenUtil", "coreMediator"];
angular.module('umCore').controller('serverDisconnectedModalController', ServerDisconnectedModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(2), __webpack_require__(0)))

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

var path = '/ui/modal/sessionTimeoutModal/sessionTimeoutModal.tpl.html';
var html = "<div class=\"sessionTimeoutContent\">\n\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\" ui-translate>{{ ::title }}</h3>\n    </div>\n\n    <div class=\"modal-body\">{{ message }}</div>\n\n    <!--Footer-->\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-primary\"\n                ng-click=\"$dismiss()\">\n            <span ui-translate>sessionTimeout.okButton</span>\n        </button>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var SessionTimeoutModalController = function SessionTimeoutModalController($rootScope, $scope, message, title, $timeout, coreConstant) {
  var timeoutList = [];
  $scope.message = message;
  $scope.title = title;
  $scope.$on(coreConstant.event.UPDATE_SESSION_COUNTDOWN_MESSAGE, function (event, message) {
    // Force digest since this event is being triggered by a non angular lib
    timeoutList.push($timeout(function () {
      $scope.message = message;
    }, 0));
  });
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
SessionTimeoutModalController.$inject = ["$rootScope", "$scope", "message", "title", "$timeout", "coreConstant"];
angular.module('umCore').controller('sessionTimeoutModalController', SessionTimeoutModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

var path = '/ui/modal/userProfileModal/userProfileModal.tpl.html';
var html = "<div class=\"userProfileModalContent\">\n\n    <div class=\"modal-header\">\n       <h3 class=\"modal-title\">{{::i18n.userProfile.title}}</h3>\n        <button class=\"close\" \n                ng-click=\"$dismiss()\">\n           <span class=\"glyphicon glyphicon-remove\"></span>\n       </button>\n    </div>\n\n    <div class=\"modal-body\">\n\n        <form role=\"form\" name=\"profileForm\" novalidate=\"\" ng-show=\"displayProfileForm\">\n            <div class=\"drawer\">\n                <div class=\"drawerRow\">\n                    <div class=\"drawerCol\">\n\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.firstName}}\">\n                        </ui-required-indicator>\n                        <label>{{::i18n.userProfile.firstNameLabel}}</label>\n                        <span>\n                            <input type=\"text\"\n                                   required\n                                   ui-max-chars=\"225\"\n                                   keypress-restrict=\"^[a-zA-Z]*$\"\n                                   class=\"firstName\"\n                                   ng-model=\"viewModel.firstName\"\n                                   ng-disabled=\"!viewModel.isProfileManagementEnabled\"\n                                   tabindex=\"1\"/>\n                        </span>\n                    </div>\n                    <div class=\"drawerCol\">\n                        <label>{{::i18n.userProfile.addressLine1}}</label>\n                        <span><input type=\"text\"\n                                     ui-max-chars=\"225\"\n                                     ng-model=\"viewModel.addressLine1\"\n                                     ng-disabled=\"!viewModel.isProfileManagementEnabled\"\n                                     tabindex=\"8\"/>\n                        </span>\n                    </div>\n                </div>\n\n                <div class=\"drawerRow\">\n                    <div class=\"drawerCol\">\n                        <label>{{::i18n.userProfile.middleNameLabel}}</label>\n                        <span><input type=\"text\"\n                                     ui-max-chars=\"225\"\n                                     keypress-restrict=\"^[a-zA-Z]*$\"\n                                     ng-model=\"viewModel.middleName\"\n                                     ng-disabled=\"!viewModel.isProfileManagementEnabled\"\n                                     tabindex=\"2\"/>\n                        </span>\n                    </div>\n                    <div class=\"drawerCol\">\n                        <label>{{::i18n.userProfile.addressLine2}}</label>\n                        <span><input type=\"text\"\n                                     ui-max-chars=\"225\"\n                                     ng-model=\"viewModel.addressLine2\"\n                                     ng-disabled=\"!viewModel.isProfileManagementEnabled\"\n                                     tabindex=\"9\"/>\n                        </span>\n                    </div>\n                </div>\n\n                <div class=\"drawerRow\">\n                    <div class=\"drawerCol\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.lastName}}\">\n                        </ui-required-indicator>\n                        <label>{{::i18n.userProfile.lastNameLabel}}</label>\n                        <span><input type=\"text\"\n                                     required\n                                     ui-max-chars=\"225\"\n                                     keypress-restrict=\"^[a-zA-Z]*$\"\n                                     class=\"lastName\"\n                                     ng-model=\"viewModel.lastName\"\n                                     ng-disabled=\"!viewModel.isProfileManagementEnabled\"\n                                     tabindex=\"3\"/></span>\n                    </div>\n                    <div class=\"drawerCol\">\n                        <label>{{::i18n.userProfile.cityLabel}}</label>\n                        <input type=\"text\"\n                               ui-max-chars=\"225\"\n                               ng-model=\"viewModel.city\"\n                               ng-disabled=\"!viewModel.isProfileManagementEnabled\"\n                               tabindex=\"10\"/>\n                    </div>\n                </div>\n\n                <div class=\"drawerRow\">\n                    <div class=\"drawerCol\">\n                        <label>{{::i18n.userProfile.jobTitleLabel}}</label>\n                        <span><input type=\"text\"\n                                     ui-max-chars=\"225\"\n                                     ng-model=\"viewModel.title\"\n                                     ng-disabled=\"!viewModel.isProfileManagementEnabled\"\n                                     tabindex=\"4\"/></span>\n                    </div>\n                    <div class=\"drawerCol\">\n                        <label>{{::i18n.userProfile.stateLabel}}</label>\n                        <select ng-model=\"viewModel.state\"\n                                ng-options=\"option.value as option.name for option in stateDataProvider\"\n                                ng-disabled=\"!viewModel.isProfileManagementEnabled\"\n                                tabindex=\"10\">\n                        </select>\n                    </div>\n                </div>\n\n                <div class=\"drawerRow\">\n                    <div class=\"drawerCol\">\n                        <label>{{::i18n.userProfile.emailLabel}}</label>\n                        <span><input type=\"text\"\n                                     ui-max-chars=\"225\"\n                                     ng-model=\"viewModel.emailAddress\"\n                                     disabled/>\n                        </span>\n                    </div>\n                    <div class=\"drawerCol\">\n                        <label>{{::i18n.userProfile.zipLabel}}</label>\n                        <span><input name=\"zipCode\"\n                                     type=\"text\"\n                                     ui-zip-code-formatter\n\n                                     ng-class=\"{\n                                        error: profileForm.zipCode.$error.pattern\n                                     }\"\n                                     popover-enable=\"profileForm.zipCode.$error.pattern\"\n                                     uib-popover=\"{{::viewModel.zipCodeError}}\"\n                                     popover-trigger=\"mouseenter\"\n                                     popover-class=\"errorPopover\"\n                                     popover-append-to-body=\"true\"\n                                     ng-pattern=\"/^(\\d{9}|\\d{5}-\\d{4}|\\d{5})$/\"\n                                     ng-model=\"viewModel.postalCode\"\n                                     keypress-restrict=\"^[0-9/-]*$\"\n                                     ng-disabled=\"!viewModel.isProfileManagementEnabled\"\n                                     tabindex=\"11\"/>\n                        </span>\n                    </div>\n\n                </div>\n                <div class=\"drawerRow\">\n                    <div class=\"drawerCol\">\n                        <label>{{::i18n.userProfile.workPhoneLabel}}</label>\n                        <span><input name=\"workPhoneNumber\"\n                                     type=\"text\"\n                                     ui-phone-number-formatter\n                                     ng-class=\"{\n                                        error: profileForm.workPhoneNumber.$error.pattern\n                                     }\"\n                                     popover-enable=\"profileForm.workPhoneNumber.$error.pattern\"\n                                     uib-popover=\"{{::viewModel.phoneNumberError}}\"\n                                     popover-trigger=\"mouseenter\"\n                                     popover-class=\"errorPopover\"\n                                     popover-append-to-body=\"true\"\n                                     ng-pattern=\"/^[(]{0,1}[0-9]{3}[)\\.\\- ]{0,1}[0-9]{3}[\\.\\- ]{0,1}[0-9]{4}$/\"\n                                     ui-max-chars=\"25\"\n                                     ng-model=\"viewModel.phoneNumber\"\n                                     keypress-restrict=\"^[0-9/-]*$\"\n                                     ng-disabled=\"!viewModel.isProfileManagementEnabled\"\n                                     tabindex=\"5\"/>\n                        </span>\n                    </div>\n                    <div class=\"drawerCol\">\n                        <label>{{::i18n.userProfile.countryLabel}}</label>\n                        <select ng-model=\"viewModel.country\"\n                                ng-options=\"option.value as option.name for option in countryList\"\n                                ng-disabled=\"!viewModel.isProfileManagementEnabled\"\n                                tabindex=\"12\">\n                        </select>\n                    </div>\n                </div>\n\n                <div class=\"drawerRow\">\n                    <div class=\"drawerCol\">\n                        <label>{{::i18n.userProfile.cellPhoneLabel}}</label>\n                        <span><input name=\"cellPhoneNumber\"\n                                     type=\"text\"\n                                     ui-phone-number-formatter\n                                     ng-class=\"{\n                                        error: profileForm.cellPhoneNumber.$error.pattern\n                                     }\"\n                                     popover-enable=\"profileForm.cellPhoneNumber.$error.pattern\"\n                                     uib-popover=\"{{::viewModel.phoneNumberError}}\"\n                                     popover-trigger=\"mouseenter\"\n                                     popover-class=\"errorPopover\"\n                                     popover-append-to-body=\"true\"\n                                     ng-pattern=\"/^[(]{0,1}[0-9]{3}[)\\.\\- ]{0,1}[0-9]{3}[\\.\\- ]{0,1}[0-9]{4}$/\"\n                                     ui-max-chars=\"25\"\n                                     ng-model=\"viewModel.cellPhoneNumber\"\n                                     keypress-restrict=\"^[0-9/-]*$\"\n                                     ng-disabled=\"!viewModel.isProfileManagementEnabled\"\n                                     tabindex=\"5\"/>\n                        </span>\n                    </div>\n                    <div class=\"drawerCol\">\n                        <label>{{::i18n.userProfile.extLabel}}</label>\n                        <span><input type=\"text\" ui-max-chars=\"6\"\n                                     ui-max-chars=\"6\"\n                                     keypress-restrict=\"^[0-9]*$\"\n                                     ng-model=\"viewModel.phoneNumberExtension\"\n                                     ng-disabled=\"!viewModel.isProfileManagementEnabled\"\n                                     tabindex=\"6\"/>\n                        </span>\n                    </div>\n                </div>\n\n                <div class=\"drawerRow\">\n                    <div class=\"drawerCol\">\n                        <label>{{::i18n.userProfile.faxLabel}}</label>\n                        <span><input name=\"fax\"\n                                     type=\"text\"\n                                     ui-max-chars=\"25\"\n                                     ui-phone-number-formatter\n                                     ng-class=\"{\n                                        error: profileForm.fax.$error.pattern\n                                     }\"\n                                     popover-enable=\"profileForm.fax.$error.pattern\"\n                                     uib-popover=\"{{::viewModel.faxNumberError}}\"\n                                     popover-trigger=\"mouseenter\"\n                                     popover-class=\"errorPopover\"\n                                     popover-append-to-body=\"true\"\n                                     keypress-restrict=\"^[0-9/-]*$\"\n                                     ng-model=\"viewModel.faxNumber\"\n                                     ng-disabled=\"!viewModel.isProfileManagementEnabled\"\n                                     tabindex=\"7\"/>\n                        </span>\n                    </div>\n                </div>\n            </div>\n        </form>\n\n\n        <div ng-if=\"!displayProfileForm\" class=\"dragDropBoxOuter\">\n\n            <div class=\"dragDropBox\"\n                 ui-drop-zone\n                 file=\"{{viewModel.uploadedFile}}\">\n                <span>{{::i18n.userProfile.userImage.dragAndDrop}}</span>\n                <span>{{::i18n.userProfile.userImage.or}}</span>\n                <div>\n                    <input type=\"file\"\n                           class=\"btn btn-primary btn-sm hiddenFileInput\"\n                           name=\"' + scope.valueName + '_file\"\n                           ui-custom-on-change=\"fileSelected(file)\"/>\n                    <input type=\"button\"\n                           class=\"btn btn-primary btn-sm\"\n                           value=\"{{viewModel.chooseFileString}}\"/>\n                </div>\n            </div>\n\n            <div class=\"dockPanelInnerContent narrow\"\n                ng-if=\"viewModel.userImage\">\n                <div class=\"dockPanelCellSide\">\n                    <span class=\"glyphicon glyphicon-file\"></span>\n                    <a ng-href=\"{{viewModel.attachmentLink}}\" target=\"_blank\">\n                        {{viewModel.userImage.name}}\n                    </a>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"drawer\">\n            <div class=\"drawerRow\">\n                <div class=\"drawerCol\">\n                    <label>{{::i18n.userProfile.pictureLabel}}</label>\n                </div>\n            </div>\n            <div class=\"drawerRow\">\n                <div class=\"drawerCol\">\n                    <div class=\"profileImageBox\">\n                        <img class=\"profileImage\"\n                            ng-click=\"changePhoto()\"\n                            ng-src=\"{{ userImage }}\"/>\n\n                        <div class=\"changeBox\"\n                            ng-show=\"displayProfileForm\"\n                            ng-click=\"changePhoto()\"\n                            ng-if=\"viewModel.isProfileManagementEnabled\">\n                            <label class=\"changeBoxLabel\">{{::i18n.userProfile.userImage.change}}</label>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n    </div>\n    \n    <!--Footer-->\n    <div class=\"modal-footer\" ng-show=\"displayProfileForm\">\n        <button class=\"btn btn-primary saveProfileButton\" ng-disabled=\"!profileForm.$valid || !profileForm.$dirty\"\n                ng-click=\"update()\"><span>{{::i18n.userProfile.okButton}}</span></button>\n        <button class=\"btn btn-primary\"\n                ng-click=\"$close()\"><span>{{::i18n.userProfile.cancelButton}}</span></button>\n    </div>\n\n    <div class=\"modal-footer\" ng-show=\"!displayProfileForm\">\n        <button class=\"btn btn-primary\" ng-disabled=\"!viewModel.isValidFileSelected\"\n                ng-click=\"uploadProfilePhoto()\"><span>{{::i18n.userProfile.uploadProfilePhoto}}</span></button>\n\n        <button class=\"btn btn-primary\" ng-disabled=\"isSilhouetteImage || !doesUserHasStoredImage\"\n                ng-click=\"deleteUserPhoto()\"><span>{{::i18n.userProfile.deletePhoto}}</span></button>\n\n        <button class=\"btn btn-primary\"\n                ng-click=\"cancelPhotoUpload()\"><span>{{::i18n.userProfile.cancelUpload}}</span></button>\n    </div>\n    \n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var userImage = __webpack_require__(761);
var locale = __webpack_require__(74);

/*@ngInject*/
var UserProfileModalController = function UserProfileModalController($rootScope, $scope, $uibModalInstance, $timeout, coreConstant, coreMediator, loadingBarHandler, currentUserModel, preferenceModel, dataSetUtil, appTypeConfigurationModel, attachmentUtil) {
  function init() {
    $scope.i18n = locale;
    $scope.viewModel = {
      addressLine1: '',
      addressLine2: '',
      cellPhoneNumber: '',
      city: '',
      country: '',
      emailAddress: '',
      faxNumber: '',
      firstName: '',
      lastName: '',
      middleName: '',
      name: '',
      organizationId: '',
      phoneNumber: '',
      phoneNumberExtension: '',
      principalId: '',
      postalCode: '',
      state: '',
      title: '',
      faxNumberError: '',
      phoneNumberError: '',
      cellPhoneNumberError: '',
      zipCode: '',
      userImage: null,
      uploadedFile: null,
      isValidFileSelected: false,
      isProfileManagementEnabled: false,
      chooseFileString: ''
    };
    $scope.viewModel.chooseFileString = _.get($scope.i18n, 'userProfile.userImage.chooseFile');
    $scope.viewModel.faxNumberError = _.get($scope.i18n, 'userProfile.error.faxNumber');
    $scope.viewModel.phoneNumberError = _.get($scope.i18n, 'userProfile.error.phoneNumber');
    $scope.viewModel.cellPhoneNumberError = _.get($scope.i18n, 'userProfile.error.cellPhoneNumberError');
    $scope.viewModel.zipCodeError = _.get($scope.i18n, 'userProfile.error.zipCode');
    $scope.enableActionButton = true;
    $scope.displayProfileForm = true;
    $scope.countryList = [{
      name: 'USA',
      value: 'USA'
    }, {
      name: 'Canada',
      value: 'Canada'
    }];
  }
  $scope.update = function () {
    loadingBarHandler.showLoadingBar('userProfile.updateUserProfileLoadingBar');
    coreMediator.updateUser($scope.viewModel).then(function () {
      loadingBarHandler.hideLoadingBar();
      $uibModalInstance.close();
    });
  };
  $scope.changePhoto = function () {
    if ($scope.viewModel.isProfileManagementEnabled) {
      $scope.displayProfileForm = false;
      $scope.viewModel.chooseFileString = _.get($scope.i18n, 'userProfile.userImage.chooseFile');
    }
  };
  $scope.deleteUserPhoto = function () {
    coreMediator.deleteUserImage().then(function () {
      $scope.displayProfileForm = false;
      setSilhouetteImage();
      $scope.viewModel.isValidFileSelected = false;
      $scope.viewModel.userImage = null;
      $rootScope.$broadcast(coreConstant.event.USER_AVATAR_RELOAD, currentUserModel.getCurrentUser().userId);
    });
  };
  $scope.$on(coreConstant.event.FILE_DROPPED, function (event, file) {
    if (file) {
      $scope.file = file;
      storeUploadedFile(file);
    }
  });
  $scope.fileSelected = function (file) {
    if (file) {
      $scope.file = file;
      storeUploadedFile(file);
    }
  };
  $scope.isDeletePhotoButtonEnabled = function () {
    return $scope.underwriterImage ? true : false;
  };
  $scope.cancelPhotoUpload = function () {
    $scope.displayProfileForm = true;
    $scope.userImage = $scope.underwriterImage;
    if ($scope.viewModel.isValidFileSelected) {
      $scope.viewModel.userImage.name = null;
      $scope.viewModel.isValidFileSelected = false;
    }
  };
  $scope.uploadProfilePhoto = function () {
    var onSuccess = function onSuccess() {
      loadingBarHandler.hideLoadingBar();
      $scope.displayProfileForm = true;
      $scope.underwriterImage = $scope.userImage;
      $scope.doesUserHasStoredImage = true;
      $rootScope.$broadcast(coreConstant.event.USER_AVATAR_RELOAD, currentUserModel.getCurrentUser().userId);
    };
    var onError = function onError() {
      loadingBarHandler.hideLoadingBar();
    };
    loadingBarHandler.showLoadingBar('userProfile.userImage.imageUploadingLoadingBar');
    coreMediator.updateUserImage($scope.file, $scope.imageWidth, $scope.imageHeight).then(onSuccess, onError);
  };
  function storeUploadedFile(uploadedFile) {
    var allowFile = true,
      allowedUserImageFileTypes = preferenceModel.get('system.allowedUserImageFileTypes'),
      acceptedTypes = _.split(allowedUserImageFileTypes, ';'),
      allowFileType = attachmentUtil.validateAttachmentType(uploadedFile, _.get($scope.i18n, 'userProfile.userImage.unacceptableType'), acceptedTypes),
      maxUploadFileSize = preferenceModel.get('system.maxUserImageUploadSizeInKilobytes'),
      img = new Image();
    if (allowFileType) {
      if (uploadedFile.size / 1024 >= maxUploadFileSize) {
        var notificationMessage = _.get($scope.i18n, 'userProfile.userImage.maxFileSizeMessage');
        notificationMessage = _.replace(notificationMessage, '{maxSize}', maxUploadFileSize);
        $rootScope.$broadcast(coreConstant.event.SHOW_MODAL_NOTIFICATION, {
          title: _.get($scope.i18n, 'userProfile.userImage.maxFileSizeTitle'),
          summary: notificationMessage
        });
        allowFile = false;
      }
      if (allowFile) {
        var imageReader = new FileReader();
        imageReader.onload = function (event) {
          img.src = event.target.result;
        };
        imageReader.readAsDataURL(uploadedFile);
        img.onload = function () {
          if (this.width !== this.height) {
            // if image is not square
            var _notificationMessage = _.get($scope.i18n, 'userProfile.userImage.imageSizeMessage');
            $rootScope.$broadcast(coreConstant.event.SHOW_MODAL_NOTIFICATION, {
              title: _.get($scope.i18n, 'userProfile.userImage.imageSizeTitle'),
              summary: _notificationMessage
            });
          } else {
            $scope.imageWidth = this.width;
            $scope.imageHeight = this.height;
            $timeout(function () {
              $scope.viewModel.uploadedFile = uploadedFile;
              if (!$scope.viewModel.userImage) {
                $scope.viewModel.userImage = {};
              }
              $scope.viewModel.userImage.name = uploadedFile.name;
              $scope.viewModel.userImage.size = uploadedFile.size;
            }, 0);
            $scope.viewModel.isValidFileSelected = true;
            var reader = new FileReader();
            reader.onload = function (event) {
              $scope.isSilhouetteImage = false;
              $scope.userImage = event.target.result;
              $scope.$apply();
            };
            reader.readAsDataURL(uploadedFile);
          }
        };
      }
    }
  }
  function loadDataSets() {
    dataSetUtil.getDataItems({
      name: 'States'
    }).then(function (result) {
      $scope.stateDataProvider = result;
    });
  }
  function showUserProfileImage() {
    coreMediator.loadProfileImage(currentUserModel.getCurrentUser().userId).then(function (underwriterImage) {
      if (underwriterImage) {
        $scope.doesUserHasStoredImage = true;
        $scope.isSilhouetteImage = false;
        $scope.underwriterImage = 'data:image/png;base64,' + underwriterImage;
        $scope.userImage = $scope.underwriterImage;
      } else {
        setSilhouetteImage();
      }
    });
  }
  function setSilhouetteImage() {
    $scope.underwriterImage = userImage;
    $scope.userImage = $scope.underwriterImage;
    $scope.isSilhouetteImage = true;
  }
  function loadUserProfile() {
    var currentUser, isAgentUser;
    coreMediator.loadUser().then(function (userProfile) {
      $scope.viewModel = userProfile;
      currentUser = currentUserModel.getCurrentUser(), isAgentUser = currentUser.userType === 'Agent';
      coreMediator.loadDefaultPreferences().then(function (preferences) {
        if (appTypeConfigurationModel.getConsoleType() === coreConstant.authorization.CONSOLE_TYPE_UM_AGENT && preferences['system.disablePasswordAndProfileManagementAgent'].value === 'false' || appTypeConfigurationModel.getConsoleType() === coreConstant.authorization.CONSOLE_TYPE_UM && preferences['system.disablePasswordAndProfileManagementUnderwriter'].value === 'false' || appTypeConfigurationModel.getConsoleType() === coreConstant.authorization.CONSOLE_TYPE_UM_STUDIO && preferences['system.disablePasswordAndProfileManagementConfigurator'].value === 'false') {
          $scope.viewModel.isProfileManagementEnabled = true;
        }
      });
    });
  }
  init();
  loadUserProfile();
  loadDataSets();
  showUserProfileImage();
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
UserProfileModalController.$inject = ["$rootScope", "$scope", "$uibModalInstance", "$timeout", "coreConstant", "coreMediator", "loadingBarHandler", "currentUserModel", "preferenceModel", "dataSetUtil", "appTypeConfigurationModel", "attachmentUtil"];
angular.module('umCore').controller('userProfileModalController', UserProfileModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

var path = '/ui/multiSelect/multiSelect.tpl.html';
var html = "<div class=\"multiSelect inlineBlock\" ui-manual-size=\"$ctrl.width?true:null\" width=\"$ctrl.width\">\n    <button type=\"button\"\n            ui-tooltip\n            ui-tooltip-text-element=\"buttonLabel\"\n            ui-tooltip-message=\"{{$ctrl.tooltipMessage}}\"\n            ui-tooltip-text=\"{{$ctrl.isDisabled ? '' : $ctrl.names || $ctrl.placeholder}}\"\n            ng-disabled=\"$ctrl.isDisabled\"\n            ng-click=\"$ctrl.openMultiSelectPopup($event)\"\n            class=\"multiSelectButton\">\n        <div class=\"optionalPrefix\"\n             ng-if=\"$ctrl.optionalPrefix\">{{ $ctrl.optionalPrefix }}\n        </div>\n        <div class=\"buttonLabel\" ng-class=\"{placeHolder: ($ctrl.buttonLabel === $ctrl.promptValue)}\"\n          ui-manual-size=\"$ctrl.width?true:null\" width=\"$ctrl.width\">\n            {{$ctrl.buttonLabel}}\n        </div>\n        <span class=\"glyphicon glyphicon-chevron-down\"></span>\n    </button>\n</div>\n<ui-multi-select-popup item-name=\"$ctrl.itemName\"\n                       class=\"multiSelectPopup {{ ::$ctrl.itemName }}\"\n                       append-to-body=\"'true'\"\n                       is-list-load-dynamically=\"$ctrl.isListLoadDynamically\"\n                       filter-text-prompt=\"$ctrl.filterTextPrompt\"></ui-multi-select-popup>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

var MultiSelectComponent = {
  templateUrl: '/ui/multiSelect/multiSelect.tpl.html',
  controller: 'multiSelectController',
  bindings: {
    itemsList: '<',
    selectedValue: '<',
    itemName: '<',
    promptValue: '<',
    appendToBody: '<',
    optionalPrefix: '<',
    autoExpand: '<',
    isDisabled: '<',
    delimiter: '<',
    fixedMultipleSelectionButtonLabel: '<',
    fixedAllSelectedButtonLabel: '<',
    isListLoadDynamically: '<',
    truncateCharLength: '<',
    filterTextPrompt: '<',
    width: '<',
    onChange: '&',
    tooltipMessage: '<'
  }
};
angular.module('umCore').component('uiMultiSelect', MultiSelectComponent);

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var MultiSelectController = function MultiSelectController($scope, $rootScope, $timeout, coreConstant, localization) {
  var _this = this;
  var timeoutList = [];
  localization.getTranslationByKey('advancedFilter').then(function (translations) {
    _this.translations = translations;
    if (!_this.isListLoadDynamically) {
      _this.buttonLabel = _this.refreshButtonLabel();
    }
  });
  this.$onInit = function () {
    this.initialize();
    this.$onChanges = function () {
      this.initialize();
    };
  };
  this.initialize = function () {
    if (_.isNil(this.delimiter)) {
      this.delimiter = '::';
    }
    this.setItemsList();
    this.refreshButtonLabel();
    if (this.autoExpand) {
      this.openMultiSelectPopup();
    }
  };
  this.setItemsList = function () {
    var _this2 = this;
    if (this.isListLoadDynamically) {
      if (!_.isNil(this.selectedValue)) {
        _.each(this.selectedValue, function (selectedVal) {
          _.each(_this2.itemsList, function (item) {
            if (item.code === selectedVal.code) {
              item.selected = true;
            }
          });
        });
        var totalList = _.concat(this.itemsList, this.selectedValue);
        this.itemsList = _.uniqBy(totalList, 'code');
      }
    } else {
      _.each(this.itemsList, function (item) {
        item.selected = false;
      });
      _.intersectionWith(this.itemsList, _.split(this.selectedValue, this.delimiter), function (dataItem, criterionItem) {
        if (dataItem.value === criterionItem) {
          dataItem.selected = true;
          return true;
        } else {
          return false;
        }
      });
    }
  };
  $scope.$on(coreConstant.event.MULTI_SELECT_CLEAR, function (event, itemName) {
    if (_this.itemName === itemName) {
      _this.selectedValue = '';
      _.each(_this.itemsList, function (item) {
        item.selected = false;
      });
    }
  });
  $scope.$on(coreConstant.event.MULTI_SELECT_CLOSED, function (event, itemName) {
    if (_this.itemName === itemName) {
      if (_this.isListLoadDynamically) {
        _this.itemsList = _.filter(_this.itemsList, function (item) {
          return item.selected;
        });
      }
      $scope.$emit(coreConstant.event.MULTI_SELECT_CLOSED);
    }
  });
  $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, function (event, itemName) {
    if (_this.itemName === itemName) {
      if (_this.isListLoadDynamically) {
        _this.refreshButtonLabel();
        var selectedValueList = _.filter(_this.itemsList, function (item) {
          return item.selected;
        });
        _this.onChange({
          selectedValueList: selectedValueList
        });
        _this.selectedValue = selectedValueList;
      } else {
        _this.refreshButtonLabel();
        _this.onChange({
          selectedValueList: _.filter(_this.itemsList, function (item) {
            return item.selected;
          })
        });
      }
    }
  });
  this.openMultiSelectPopup = function (event) {
    $rootScope.$broadcast(coreConstant.event.SHOW_MULTI_SELECT, event, this.itemsList, this.itemName, this.appendToBody);
  };
  this.refreshButtonLabel = function () {
    var _this3 = this;
    var tempItemList = _.filter(this.itemsList, function (item) {
      return item.selected;
    });
    var names = '';
    if (this.isListLoadDynamically) {
      names = _.map(tempItemList, 'code');
    } else {
      names = _.map(tempItemList, 'name');
    }
    var multipleSelection = _.size(tempItemList) > 1,
      allSelected = _.size(tempItemList) === _.size(this.itemsList);
    names = _.join(names, ', ');
    this.names = names;
    if (this.truncateCharLength) {
      names = _.truncate(names, {
        length: this.truncateCharLength,
        seperator: /,? +/
      });
    } else {
      names = _.truncate(names, {
        length: 75,
        seperator: /,? +/
      });
    }
    timeoutList.push($timeout(function () {
      if (!_.isEmpty(names)) {
        if (!_.isNil(_this3.fixedAllSelectedButtonLabel) && allSelected) {
          names = _this3.fixedAllSelectedButtonLabel;
        } else if (!_.isNil(_this3.fixedMultipleSelectionButtonLabel) && multipleSelection) {
          names = _this3.fixedMultipleSelectionButtonLabel;
        }
      }
      _this3.buttonLabel = names ? names : _.isNil(_this3.promptValue) ? _this3.translations.placeholder : _this3.promptValue;
      $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_BUTTON_LABEL_UPDATED, _this3.itemName, _this3.buttonLabel);
    }, 0));
  };
  this.onItemClick = function (item) {
    item.selected = !item.selected;
    this.refreshButtonLabel();
  };
  $scope.$on(coreConstant.event.MULTI_SELECT_LIST_UPDATED, function (event, itemName, itemList, searchText) {
    if (_this.itemName === itemName) {
      _this.itemsList = itemList;
      if (!_.isNil(searchText)) {
        _this.setItemsList();
        _this.refreshButtonLabel();
        $rootScope.$broadcast(coreConstant.event.SHOW_MULTI_SELECT_LIST_UPDATED, _this.itemsList);
      } else {
        _this.selectedValue = itemList;
        _this.setItemsList();
        _this.refreshButtonLabel();
      }
    }
  });
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
};
MultiSelectController.$inject = ["$scope", "$rootScope", "$timeout", "coreConstant", "localization"];
angular.module('umCore').controller('multiSelectController', MultiSelectController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1460 */
/***/ (function(module, exports) {

var path = '/ui/multiSelect/multiSelectPopup.tpl.html';
var html = "<div class=\"checkboxLayer\"\n     ng-if=\"showPopup\"\n     ng-style=\"locationStyle\"\n     ng-click=\"onPopupClickOrScroll()\">\n\n    <div class=\"helperContainer\">\n        <div class=\"line\">\n            <input type=\"text\"\n                   ng-click=\"select( 'filter', $event )\"\n                   ng-model=\"filterText\"\n                   ng-change=\"onFilterChange(filterText)\"\n                   class=\"inputFilter\"/>\n            <span class=\"glyphicon glyphicon-search filterDataSetIcon\"></span>\n        </div>\n        <div class=\"searchFieldPrompt\" ng-show=\"isSearchListAvailable()\">{{ ::filterTextPrompt }}</div>\n    </div>\n    <div class=\"checkBoxContainer\">\n        <div class=\"grouping\"\n             ng-repeat=\"grouping in groupedItemsList\">\n            <div class=\"acol\">\n                <div class=\"groupingContainer\">\n                    <label ng-if=\"grouping.name!==null\">\n                        <span class=\"groupingText\">{{::grouping.name}}</span>\n                    </label>\n                    <a class=\"clearSelectedButton\"\n                       ng-if=\"grouping.name===selectedLabel\"\n                       ng-click=\"onClearSelected()\">{{::clearSelectedLabel}}</a>\n                </div>\n                <div\n                    ng-repeat=\"item in grouping.items\"\n                    class=\"multiSelectItem\"\n                    row-id=\"{{$index}}\"\n                    ng-click=\"onItemClick(item)\"\n                    ng-mouseleave=\"removeFocusStyle( tabIndex );\">\n                    <div class=\"acol\">\n                        <label>\n                            <input class=\"checkbox focusable {{::item.name}}\" type=\"checkbox\" ng-checked=\"item.selected\"/>\n                        </label>\n                    </div>\n                    <div class=\"acol\">\n                        <label class=\"nameLabel\" ng-if=\"!isListLoadDynamically\">\n                          <span>{{::item.name}}</span>\n                        </label>\n                         <div ng-if=\"isListLoadDynamically\" class=\"descriptionLabel\"\n                               title=\"{{getDescriptionTooltip(item)}}\">{{item.description}}</div>\n                       \n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"longListWarning\" ng-if=\"showLongListWarning\">\n        <span>{{longListWarning.text}}</span>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UIMultiSelectPopupDirective = function UIMultiSelectPopupDirective($rootScope, $document, $window, $timeout, $filter, coreConstant, localization, browserUtil) {
  var linkFunction = function linkFunction($scope, $elm) {
    var window = $($window);
    $scope.xPos = 0;
    $scope.yPos = 0;
    $scope.showPopup = false;
    $scope.itemsList = [];
    $scope.showLongListWarning = false;
    $scope.openEvent = null;
    $scope.newHeight = 'auto';
    $scope.longListWarning = {
      originalText: null,
      text: null
    };
    $scope.locationStyle = {
      'left': $scope.xPos,
      'top': $scope.yPos
    };
    $scope.filterText = '';
    localization.getTranslationByKey('advancedFilter').then(function (translations) {
      $scope.selectedLabel = translations.selected;
      $scope.clearSelectedLabel = translations.clearSelected;
    });
    localization.getTranslationByKey('formsViewer.controls.dropdown.longListWarning').then(function (translation) {
      $scope.longListWarning.originalText = translation;
    });
    $scope.$on(coreConstant.event.HIDE_MULTI_SELECT, function () {
      if ($scope.showPopup) {
        $scope.xPos = 0;
        $scope.yPos = 0;
        $scope.showPopup = false;
        $scope.newHeight = 'auto';
        setLocationStyle('visible');
        removeListeners();
        $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_CLOSED, $scope.itemName);
      }
    });
    $scope.$on(coreConstant.event.SHOW_MULTI_SELECT, function (arg1, event, itemsList, itemName) {
      var checkBoxLayer,
        appendToBody = true;
      if (!_.isNil($scope.itemName)) {
        if ($scope.itemName === itemName && $scope.showPopup) {
          handleDocumentInteraction();
          return;
        }
        if ($scope.itemName === itemName) {
          if ($scope.showPopup === false) {
            addListeners();
          }
          $scope.itemName = itemName;
          $scope.itemsList = itemsList;
          createdGroupedList();
          $scope.canClose = false;
          setLocationStyle('hidden');
          $scope.showPopup = true;
          $scope.openEvent = event;
          positionPopup();
          $timeout(function () {
            var inputFilter = $elm.find('.inputFilter');
            setLocationStyle('visible');
            inputFilter.focus();
          }, 0);
          if (appendToBody) {
            $document.find('body').append($elm);
          }
        }
        if ($scope.itemName !== itemName && $scope.showPopup) {
          checkBoxLayer = $elm.find('.checkboxLayer');
          $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_CLOSED, $scope.itemName);
          checkBoxLayer.scrollTop();
        }
      }
    });
    function positionPopup() {
      var event = $scope.openEvent;
      $scope.newHeight = 'auto';
      $timeout(function () {
        var checkBoxLayer = $elm.find('.checkboxLayer'),
          checkBoxLayerWidth = checkBoxLayer.width(),
          checkBoxLayerHeight = checkBoxLayer.height(),
          windowInnerHeight = $window.innerHeight,
          windowInnerWidth = $window.innerWidth,
          pageX = event.pageX,
          pageY = event.pageY,
          offsetX = event.offsetX || pageX - $(event.target).offset().left,
          offsetY = event.offsetY || pageY - $(event.target).offset().top,
          targetOffsetHeight = event.target.offsetHeight,
          targetOffsetTop = event.target.offsetTop;
        if (pageX - offsetX + checkBoxLayerWidth > windowInnerWidth) {
          $scope.xPos = windowInnerWidth - checkBoxLayerWidth - 30;
        } else {
          $scope.xPos = pageX - offsetX;
        }
        if (pageY + checkBoxLayerHeight > windowInnerHeight) {
          $scope.yPos = pageY - offsetY - checkBoxLayerHeight - 15;
          if ($scope.yPos < 0) {
            if (windowInnerHeight - (pageY - offsetY + 30) > (15 + offsetY - pageY) * -1) {
              $scope.yPos = pageY - offsetY + 30;
              $scope.newHeight = windowInnerHeight - $scope.yPos;
            } else {
              $scope.yPos = 0;
              $scope.newHeight = (15 + offsetY - pageY) * -1;
            }
          }
        } else {
          $scope.yPos = pageY - offsetY + targetOffsetHeight;
          if ($scope.yPos > windowInnerHeight) {
            $scope.yPos -= targetOffsetTop;
          }
        }
        $scope.locationStyle = {
          'left': $scope.xPos,
          'top': $scope.yPos,
          'height': $scope.newHeight
        };
      }, 0);
    }
    function setLocationStyle(visibility) {
      $scope.locationStyle = {
        'left': $scope.xPos,
        'top': $scope.yPos,
        'visibility': visibility,
        'height': $scope.newHeight
      };
    }
    $scope.onItemClick = function (item) {
      item.selected = !item.selected;
      $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_UPDATED, $scope.itemName);
    };
    $scope.onFilterChange = function (filterText) {
      if (_.isEmpty(filterText)) {
        $scope.showLongListWarning = false;
      }
      if ($scope.isListLoadDynamically) {
        $scope.isLoading = true;
        $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_FILTER_CHANGED, $scope.itemName, filterText);
      } else {
        createdGroupedList(filterText);
        $timeout(function () {
          positionPopup();
        }, 0);
      }
    };
    $scope.isSearchListAvailable = function () {
      return !_.isEmpty($scope.filterTextPrompt) && _.isEmpty($scope.groupedItemsList);
    };
    $scope.$on(coreConstant.event.MULTI_SELECT_CLEAR, function () {
      _.each($scope.itemsList, function (item) {
        item.selected = false;
      });
      $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_UPDATED, $scope.itemName);
    });
    $scope.onClearSelected = function () {
      _.each($scope.itemsList, function (item) {
        item.selected = false;
      });
      $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_UPDATED, $scope.itemName);
    };
    $scope.getDescriptionTooltip = function (item) {
      return item.description.length > 42 ? item.description : '';
    };
    function createdGroupedList(filterText) {
      var numberOfFilteredItems = 0;
      $scope.groupedItemsList = {
        selected: {
          name: $scope.selectedLabel,
          items: []
        },
        ungroupedItems: {
          name: null,
          items: []
        }
      };
      _.each($scope.itemsList, function (item) {
        if (_.isNil(filterText) || _.includes(_.lowerCase(item.name), _.lowerCase(filterText))) {
          //If an item is selected add it to the 'Selected group
          if (item.selected) {
            $scope.groupedItemsList.selected.items.push(item);
            numberOfFilteredItems++;
            //If an item is in a group, add it to that group
          } else if (!_.isNil(item.grouping)) {
            if (_.isNil($scope.groupedItemsList[item.grouping])) {
              $scope.groupedItemsList[item.grouping] = {
                name: item.grouping,
                items: [item]
              };
              numberOfFilteredItems++;
            } else {
              $scope.groupedItemsList[item.grouping].items.push(item);
              numberOfFilteredItems++;
            }
            //If an item is not selected and has no group, put it in the ungrouped section
          } else {
            if (_.isNil($scope.groupedItemsList.ungroupedItems)) {
              $scope.groupedItemsList.ungroupedItems = {
                name: null,
                items: []
              };
            }
            $scope.groupedItemsList.ungroupedItems.items.push(item);
            numberOfFilteredItems++;
          }
        }
      });
      $scope.showLongListWarning = numberOfFilteredItems > 500;
      $scope.longListWarning.text = _.replace($scope.longListWarning.originalText, '{0}', $filter('number')(numberOfFilteredItems));
      if ($scope.groupedItemsList.ungroupedItems.items.length === 0) {
        delete $scope.groupedItemsList.ungroupedItems;
      }
      if ($scope.groupedItemsList.selected.items.length === 0) {
        delete $scope.groupedItemsList.selected;
      }
      if ($scope.showLongListWarning) {
        var selected = $scope.groupedItemsList.selected;
        $scope.groupedItemsList = {
          'selected': selected
        };
      }
    }

    //When we click or scroll in the popup negate our document listeners
    $scope.onPopupClickOrScroll = function () {
      $scope.canClose = false;
      document.removeEventListener('scroll', handleDocumentInteraction, true);
      addDocumentScrollListener();
    };

    // Turn off the document listener while we scroll in the popup
    var addDocumentScrollListener = _.debounce(function () {
      $timeout(function () {
        document.addEventListener('scroll', handleDocumentInteraction, true);
        $scope.canClose = true;
      }, 50);
    }, 50, {
      trailing: true
    });

    //Try to close the popup when the user clicks or scrolls outside the popup
    function handleDocumentInteraction() {
      $timeout(function () {
        if ($scope.canClose && $scope.showPopup) {
          $scope.xPos = 0;
          $scope.yPos = 0;
          $scope.showPopup = false;
          $scope.newHeight = 'auto';
          setLocationStyle('visible');
          removeListeners();
          $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_CLOSED, $scope.itemName);
        }
        $scope.canClose = true;
      }, 0);
    }
    $scope.$on('$destroy', function () {
      var checkBoxLayer = $elm.find('.checkboxLayer');
      checkBoxLayer.remove();
    });
    function addListeners() {
      $document.on('click', handleDocumentInteraction);
      window.on('resize', handleDocumentInteraction);
      $elm.get(0).addEventListener('scroll', $scope.onPopupClickOrScroll, true);
      document.addEventListener('scroll', handleDocumentInteraction, true);
    }
    function removeListeners() {
      $document.off('click', handleDocumentInteraction);
      window.off('resize', handleDocumentInteraction);
      $elm.get(0).removeEventListener('scroll', $scope.onPopupClickOrScroll, true);
      document.removeEventListener('scroll', handleDocumentInteraction, true);
    }
    $scope.$on(coreConstant.event.SHOW_MULTI_SELECT_LIST_UPDATED, function (event, itemsList) {
      $scope.itemsList = [];
      $scope.itemsList = itemsList;
      createdGroupedList();
    });
  };
  return {
    link: linkFunction,
    restrict: 'AE',
    scope: {
      itemName: '<',
      isListLoadDynamically: '<',
      filterTextPrompt: '<'
    },
    templateUrl: '/ui/multiSelect/multiSelectPopup.tpl.html'
  };
};
UIMultiSelectPopupDirective.$inject = ["$rootScope", "$document", "$window", "$timeout", "$filter", "coreConstant", "localization", "browserUtil"];
angular.module('umCore').directive('uiMultiSelectPopup', UIMultiSelectPopupDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/ui/notification/notification.tpl.html';
var html = "<div class=\"notifications regular\"\n     ng-click=\"$ctrl.onIconClick($event)\"\n     uib-tooltip=\"{{ ::$ctrl.tooltip }}\"\n     tooltip-popup-delay=\"500\"\n     tooltip-append-to-body=\"true\"\n     tooltip-placement=\"bottom\">\n\n    <i class=\"fa fa-bell-o notificationButton\" aria-hidden=\"true\"></i>\n\n    <span ng-if=\"$ctrl.numberOfUnacknowledged > 0\"\n          class=\"notificationToggleBadge\">{{ $ctrl.numberOfUnacknowledged }}</span>\n</div>\n\n<div class=\"arrowUp\" ng-if=\"$ctrl.isOpen\"></div>\n\n<div class=\"notificationPopout regular\"\n     ng-if=\"$ctrl.isOpen\"\n     ui-auto-close\n     on-close=\"$ctrl.onIconClick()\"\n     is-open=\"$ctrl.isOpen\">\n\n    <div class=\"header\">\n\n        <div class=\"notificationHeaderLabel\"\n             ui-locale>notification|notification.popout.title</div>\n\n        <div class=\"unreadFilterToggle\">\n\n            <div class=\"filter allFilter\"\n                 ng-class=\"{'selected': $ctrl.isFilterSelected('all')}\"\n                 ng-click=\"$ctrl.selectFilter('all')\"\n                 ui-locale>notification|notification.popout.all</div>\n\n            <div class=\"filter unreadFilter\"\n                 ng-class=\"{'selected': $ctrl.isFilterSelected('unread')}\"\n                 ng-click=\"$ctrl.selectFilter('unread')\"\n                 ui-locale>notification|notification.popout.unread</div>\n        </div>\n\n        <div class=\"markAllAsRead\"\n             ng-class=\"{'disabled': $ctrl.areAllNotificationsRead()}\"\n             ng-click=\"$ctrl.markAllAsRead()\"\n             ui-locale>notification|notification.popout.markAllAsRead</div>\n    </div>\n\n    <ul class=\"content\">\n\n        <li class=\"dockPanelCell\"\n            ng-class=\"{'read': notification.read, 'unread': !notification.read, 'acknowledged': notification.acknowledged, 'unacknowledged': !notification.acknowledged}\"\n            ng-repeat=\"notification in $ctrl.notificationModel.getNotifications() | limitTo: $ctrl.limit\"\n            ng-if=\"$ctrl.notificationModel.getNotifications().length > 0 && !$ctrl.isLoading\"\n            ng-mouseover=\"$ctrl.showControls(notification)\"\n            ng-mouseleave=\"$ctrl.hideControls(notification)\"\n            row-id=\"{{ $index }}\">\n\n            <div class=\"cellLeftSide\">\n\n                <ui-user-avatar userid=\"{{ ::notification.actorId }}\"\n                                submissionid=\"{{ ::notification.submissionId }}\"\n                                notification-id=\"{{ ::notification.id }}\"></ui-user-avatar>\n            </div>\n\n            <div class=\"cellContent\">\n\n                <div class=\"insuredNameContainer\"\n                     uib-tooltip=\"{{ ::notification.insuredName }}\"\n                     tooltip-append-to-body=\"true\"\n                     tooltip-popup-delay=\"500\"\n                     tooltip-enable=\"{{ $ctrl.notificationTooltips[notification.id] }}\">\n\n                    <span class=\"insuredName\"\n                          ng-click=\"$ctrl.onInsuredNameClick(notification)\"\n                          ui-is-tooltip-enabled=\"$ctrl.notificationTooltips[notification.id]\"\n                          ui-is-tooltip-enabled-check-parent-width=\"true\">{{ ::notification.insuredName }}</span>\n                </div>\n\n                <div class=\"message\">\n\n                    <p ui-browser-detection\n                       ng-bind-html=\"$ctrl.getNotificationMessage(notification)\"></p>\n                </div>\n            </div>\n\n            <div class=\"cellRightSide\">\n\n                <div class=\"cellRightSideTopContainer\">\n\n                    <span class=\"newNotificationIndicator\"\n                          ng-if=\"!notification.acknowledged && !$ctrl.areControlsVisible(notification)\"\n                          ui-locale>notification|notification.popout.new</span>\n\n                    <input type=\"checkbox\"\n                           class=\"markAsReadCheckbox\"\n                           ng-if=\"$ctrl.areControlsVisible(notification)\"\n                           uib-tooltip=\"{{ $ctrl.getMarkAsReadTooltip(notification) }}\"\n                           tooltip-popup-delay=\"500\"\n                           tooltip-append-to-body=\"true\"\n                           tooltip-placement=\"left\"\n                           ng-model=\"notification.read\"\n                           ng-change=\"$ctrl.toggleRead(notification)\"/>\n                </div>\n\n                <div class=\"cellRightSideBottomContainer\">\n\n                    <ui-reload-relative-time time=\"{{ ::notification.timeCreated }}\"\n                                             interval=\"1\"\n                                             use-moment=\"true\"></ui-reload-relative-time>\n                </div>\n            </div>\n        </li>\n\n        <li ng-if=\"$ctrl.notificationModel.getNotifications().length === 0 && !$ctrl.isLoading\"\n            class=\"noNotifications\">\n\n            <span ng-if=\"$ctrl.isFilterSelected('all')\"\n                  ui-locale>notification|notification.popout.noNotifications</span>\n\n            <span ng-if=\"$ctrl.isFilterSelected('unread')\"\n                  ui-locale>notification|notification.popout.noUnreadNotifications</span>\n        </li>\n\n        <li ng-if=\"$ctrl.isLoading\"\n            class=\"loadingNotifications\">\n\n            <div class=\"icon-spinner\">\n\n                <img src=\"" + __webpack_require__(67) + "\" />\n            </div>\n        </li>\n    </ul>\n\n    <div class=\"footer\">\n\n        <div class=\"loadMoreContainer\">\n\n            <span class=\"loadMore\"\n                  ng-class=\"{'disabled': $ctrl.shouldDisableLoadMore(), 'hidden': $ctrl.isLoadingMore}\"\n                  ng-click=\"$ctrl.onLoadMoreClick($event)\"\n                  ui-locale>notification|notification.popout.loadMore</span>\n\n            <div class=\"loadingMoreNotifications\"\n                 ng-if=\"$ctrl.isLoadingMore\">\n\n                <div class=\"icon-spinner\">\n\n                    <img src=\"" + __webpack_require__(67) + "\" />\n                </div>\n            </div>\n        </div>\n\n        <div class=\"unreadNotificationsCount\"\n             ng-if=\"$ctrl.shouldShowUnreadNotificationsCount()\">{{ $ctrl.getUnreadNotificationsCount() }}</div>\n    </div>\n\n    <iframe src=\"about:blank\" class=\"ieMaskFrame\" ui-browser-detection></iframe>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1463 */
/***/ (function(module, exports) {

var NotificationComponent = {
  templateUrl: '/ui/notification/notification.tpl.html',
  controller: 'notificationController'
};
angular.module('umCore').component('uiNotification', NotificationComponent);

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, i18n) {/*@ngInject*/
var NotificationController = function NotificationController($scope, $state, $q, localization, coreConstant, coreMediator, currentUserModel, currentSubmissionModel, notificationModel, notificationType, preferenceModel) {
  var _this6 = this;
  var openingSubmissionFromNotificationMarksNotificationAsReadPreference = preferenceModel.get('system.openingSubmissionFromNotificationMarksNotificationAsRead');
  var openingSubmissionFromNotificationMarksNotificationAsRead = openingSubmissionFromNotificationMarksNotificationAsReadPreference === 'true' || _.isNil(openingSubmissionFromNotificationMarksNotificationAsReadPreference);
  localization.setupLocale('notification', __webpack_require__(1465));
  this.isOpen = false;
  this.notificationModel = notificationModel;
  this.limit = coreConstant.notifications.loadLimit;
  this.limitIncrement = coreConstant.notifications.loadLimit;
  this.userId = currentUserModel.getCurrentUser().userId;
  this.disableLoadMore = false;
  this.numberOfUnacknowledged = 0;
  this.numberOfUnread = 0;
  this.tooltip = i18n.t('notification|notification.tooltip');
  this.markAsReadTooltip = i18n.t('notification|notification.popout.markAsRead');
  this.markAsUnreadTooltip = i18n.t('notification|notification.popout.markAsUnread');
  this.controlsVisible = {};
  this.notificationTooltips = {};
  this.unreadLabel = i18n.t('notification|notification.popout.unread');
  this.isLoading = false;
  this.isLoadingMore = false;
  this.init = function () {
    var isLoadingMore = false;
    if (!notificationModel.areNotificationsPopulated()) {
      this.getNotifications(isLoadingMore);
    }
    this.getCounts();
  };
  this.onIconClick = function () {
    this.isOpen = !this.isOpen;
    if (!this.isOpen) {
      this.numberOfUnacknowledged = 0;
      this.disableLoadMore = false;
      coreMediator.acknowledgeByUserId(this.userId, notificationType.REGULAR);
    } else {
      this.controlsVisible = {};
      this.notificationTooltips = {};
      if (this.limit >= notificationModel.getNotifications().length) {
        this.disableLoadMore = true;
      }
    }
  };
  this.onLoadMoreClick = function () {
    var isLoadingMore = true;
    if (!this.disableLoadMore) {
      this.limit += this.limitIncrement;
      this.getNotifications(isLoadingMore);
    }
  };
  this.onInsuredNameClick = function (notification) {
    var _this = this;
    var promise;
    if (notification.read) {
      promise = $q.when();
    } else {
      if (openingSubmissionFromNotificationMarksNotificationAsRead) {
        promise = coreMediator.markAsReadByNotificationId(notification.id, true);
      } else {
        promise = $q.when();
      }
    }
    promise.then(function () {
      var params = {
          submissionId: notification.submissionId
        },
        stateName = 'submission.form';
      _this.onIconClick();
      if (_.isNil(currentSubmissionModel.getCurrentSubmission()) || currentSubmissionModel.getSelectedSubmission().id !== notification.submissionId) {
        $state.go(stateName, params);
      }
    });
  };
  this.getNotificationMessage = function (notification) {
    var actorName = notification.actorName === 'AUTHENTICATION_SERVER' ? 'System' : notification.actorName;
    return "<strong>".concat(actorName, "</strong> ").concat(notification.message);
  };
  this.getNotifications = function (isLoadingMore) {
    var _this2 = this;
    if (isLoadingMore) {
      this.isLoadingMore = true;
    } else {
      this.isLoading = true;
    }
    coreMediator.resetUserNotificationRegistrations(notificationType.REGULAR).finally(function () {
      var latest = false;
      var unreadOnly = _this2.isFilterSelected(coreConstant.notifications.filters.UNREAD);
      coreMediator.findByNotifiedUserId(_this2.userId, notificationType.REGULAR, 0, _this2.limit + _this2.limitIncrement, latest, unreadOnly).then(function (notifications) {
        if (_this2.limit >= notifications.length) {
          _this2.disableLoadMore = true;
        }
        notificationModel.setNotifications(notifications);
      }).finally(function () {
        _this2.isLoading = false;
        _this2.isLoadingMore = false;
      });
    });
  };
  this.getCounts = function () {
    var _this3 = this;
    var latest = false;
    coreMediator.countUnacknowledgedByUserId(this.userId, notificationType.REGULAR, latest).then(function (numberOfUnacknowledged) {
      _this3.numberOfUnacknowledged = numberOfUnacknowledged;
    });
    coreMediator.countUnreadByUserId(this.userId, notificationType.REGULAR, latest).then(function (numberOfUnread) {
      _this3.numberOfUnread = numberOfUnread;
    });
  };
  this.isFilterSelected = function (filter) {
    return notificationModel.getSelectedFilter() === filter;
  };
  this.selectFilter = function (filter) {
    var isLoadingMore = false;
    if (notificationModel.getSelectedFilter() !== filter) {
      notificationModel.setSelectedFilter(filter);
      this.limit = coreConstant.notifications.loadLimit;
      this.disableLoadMore = false;
      this.getNotifications(isLoadingMore);
    }
  };
  this.areAllNotificationsRead = function () {
    return this.numberOfUnread === 0;
  };
  this.markAllAsRead = function () {
    var _this4 = this;
    if (!this.areAllNotificationsRead()) {
      // set local notifications as read
      this.numberOfUnread = 0;
      _.each(notificationModel.getNotifications(), function (notification) {
        notification.read = true;
      });
      // call backend
      coreMediator.markAllAsReadByUserId(this.userId, notificationType.REGULAR).then(function () {
        coreMediator.acknowledgeByUserId(_this4.userId, notificationType.REGULAR);
      });
    }
  };
  this.showControls = function (notification) {
    this.controlsVisible[notification.id] = true;
  };
  this.hideControls = function (notification) {
    this.controlsVisible[notification.id] = false;
  };
  this.areControlsVisible = function (notification) {
    return this.controlsVisible[notification.id];
  };
  this.getMarkAsReadTooltip = function (notification) {
    var tooltip;
    if (notification.read) {
      tooltip = this.markAsUnreadTooltip;
    } else {
      tooltip = this.markAsReadTooltip;
    }
    return tooltip;
  };
  this.toggleRead = function (notification) {
    var _this5 = this;
    var hideControls = this.isFilterSelected(coreConstant.notifications.filters.UNREAD);
    coreMediator.markAsReadByNotificationId(notification.id, notification.read).then(function () {
      if (!notification.acknowledged) {
        coreMediator.acknowledgeByNotificationId(notification.id);
      }
      if (hideControls) {
        _this5.hideControls(notification);
      }
    });
  };
  this.getUnreadNotificationsCount = function () {
    return "".concat(this.numberOfUnread, " ").concat(this.unreadLabel);
  };
  this.shouldShowUnreadNotificationsCount = function () {
    return this.numberOfUnread > 0;
  };
  this.shouldDisableLoadMore = function () {
    return this.disableLoadMore || this.isLoading || this.isLoadingMore;
  };
  $scope.$on(coreConstant.event.CREATE_NOTIFICATION, function (event, notification) {
    if (notificationType.REGULAR === notification.type) {
      if (_this6.isFilterSelected(coreConstant.notifications.filters.UNREAD) && !notification.read || _this6.isFilterSelected(coreConstant.notifications.filters.ALL)) {
        notificationModel.prependNotification(notification);
        if (notificationModel.getNotifications().length > _this6.limit) {
          _this6.disableLoadMore = false;
        }
        _this6.getCounts();
      }
    }
  });
  $scope.$on(coreConstant.event.UPDATE_NOTIFICATION, function (event, notifications) {
    var getCounts = false;
    _.each(notifications, function (notification) {
      var isLoadingMore = false;
      if (notificationType.REGULAR === notification.type) {
        if (_this6.isFilterSelected(coreConstant.notifications.filters.UNREAD) && notification.read) {
          notificationModel.removeNotification(notification);
          if (notificationModel.getNotifications().length === 0) {
            _this6.getNotifications(isLoadingMore);
          } else if (_this6.limit >= notificationModel.getNotifications().length) {
            _this6.disableLoadMore = true;
          }
        } else {
          notificationModel.updateNotification(notification);
        }
        getCounts = true;
      }
    });
    if (getCounts) {
      _this6.getCounts();
    }
  });
  $scope.$on(coreConstant.event.LOGOUT_COMPLETE, function () {
    notificationModel.clearNotifications();
    currentUserModel.clearRegistrations();
    currentUserModel.clearNotificationRegistrations();
  });
  this.init();
};
NotificationController.$inject = ["$scope", "$state", "$q", "localization", "coreConstant", "coreMediator", "currentUserModel", "currentSubmissionModel", "notificationModel", "notificationType", "preferenceModel"];
angular.module('umCore').controller('notificationController', NotificationController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(18)["default"]))

/***/ }),
/* 1465 */
/***/ (function(module) {

module.exports = JSON.parse("{\"notification\":{\"popout\":{\"title\":\"Notifications\",\"loadMore\":\"Load more\",\"noNotifications\":\"You have no Notifications\",\"noUnreadNotifications\":\"All Notifications have been read\",\"all\":\"All\",\"unread\":\"Unread\",\"markAsRead\":\"Mark as Read\",\"markAsUnread\":\"Mark as Unread\",\"markAllAsRead\":\"Mark All as Read\",\"new\":\"New\"},\"tooltip\":\"View submission notifications.\"}}");

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

angular.module('umCore').constant('notificationConstant', {
  email: {
    NONE: '<notification><email/><emailOption>NONE</emailOption></notification>'
  }
});

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var NotificationModel = function NotificationModel(coreConstant) {
  var notifications = [],
    notificationsPopulated = false,
    selectedFilter = coreConstant.notifications.filters.ALL;
  this.areNotificationsPopulated = function () {
    return notificationsPopulated;
  };
  this.prependNotification = function (notification) {
    notifications.unshift(notification);
  };
  this.removeNotification = function (notificationToRemove) {
    _.remove(notifications, function (notification) {
      return notification.id === notificationToRemove.id;
    });
  };
  this.updateNotification = function (notification) {
    var arrayLength = notifications.length;
    for (var i = 0; i < arrayLength; i++) {
      if (notifications[i].id === notification.id) {
        notifications[i] = notification;
      }
    }
  };
  this.getNotifications = function () {
    return notifications;
  };
  this.clearNotifications = function () {
    notifications = [];
    notificationsPopulated = false;
  };
  this.setNotifications = function (newNotifications) {
    notifications = newNotifications;
    notificationsPopulated = true;
  };
  this.setSelectedFilter = function (filter) {
    selectedFilter = filter;
  };
  this.getSelectedFilter = function () {
    return selectedFilter;
  };
};
NotificationModel.$inject = ["coreConstant"];
angular.module('umCore').service('notificationModel', NotificationModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

/*@ngInject*/
var NotificationPopupUtil = function NotificationPopupUtil(Notification) {
  this.displayNotificationPopup = function ($scope) {
    return Notification.info({
      templateUrl: '/ui/notification/notificationGrowl/notificationGrowlComponent.tpl.html',
      scope: $scope,
      positionX: 'center'
    });
  };
  this.displayChatNotification = function ($scope) {
    return Notification.info({
      templateUrl: '/ui/notification/growl/growlComponent.tpl.html',
      scope: $scope
    });
  };
};
NotificationPopupUtil.$inject = ["Notification"];
angular.module('umCore').service('notificationPopupUtil', NotificationPopupUtil);

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

var path = '/ui/notification/growl/growl.tpl.html';
var html = "<div class=\"growlContent\" ng-click=\"$ctrl.onGrowlClick($event)\">\n    <button class=\"close\" ng-click=\"$ctrl.onDismissGrowl($event)\">\n        <span class=\"glyphicon glyphicon-remove\"></span>\n    </button>\n    <div class=\"cellSide\">\n        <ui-user-avatar userid=\"{{::$ctrl.notification.actorId}}\"\n                        submissionid=\"{{::$ctrl.notification.submissionId}}\"\n                        notification-id=\"{{::$ctrl.notification.id}}\"></ui-user-avatar>\n    </div>\n    <div class=\"cellContent\">\n        <span class=\"insuredName\">{{::$ctrl.notification.insuredName}}</span>\n        <div class=\"message\">\n            <p ui-browser-detection ng-bind-html=\"::$ctrl.getNotificationMessage()\"></p>\n        </div>\n        <iframe src=\"about:blank\" class=\"ieMaskFrame\" ui-browser-detection></iframe>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

var NotificationGrowlComponent = {
  templateUrl: '/ui/notification/growl/growl.tpl.html',
  controller: 'growlController',
  bindings: {
    notification: '<',
    closeNotification: '&'
  }
};
angular.module('umCore').component('uiNotificationGrowl', NotificationGrowlComponent);

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

var path = '/ui/notification/growl/growlComponent.tpl.html';
var html = "<!-- bind the angular-ui-notification dieHard() function which will handle the closing and cleanup of viewable notifications -->\n<ui-notification-growl\n    notification=\"notification\"\n    close-notification=\"kill(true)\"\n    class=\"ui-notification\"></ui-notification-growl>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var GrowlController = function GrowlController($element, $rootScope, $state, $stateParams, coreMediator, notificationType, submissionStateMediator, submissionConstant, preferenceModel) {
  var openingSubmissionFromNotificationMarksNotificationAsReadPreference = preferenceModel.get('system.openingSubmissionFromNotificationMarksNotificationAsRead');
  var openingSubmissionFromNotificationMarksNotificationAsRead = openingSubmissionFromNotificationMarksNotificationAsReadPreference === 'true' || _.isNil(openingSubmissionFromNotificationMarksNotificationAsReadPreference);
  $element.addClass('uiGrowlNotification');
  this.onGrowlClick = function () {
    var _this = this;
    // acknowledge the notification and route to the associated submission
    var params = {
      submissionId: this.notification.submissionId
    };
    var stateName = 'submission.form';
    coreMediator.acknowledgeByNotificationId(this.notification.id).then(function () {
      if (openingSubmissionFromNotificationMarksNotificationAsRead) {
        coreMediator.markAsReadByNotificationId(_this.notification.id, true);
      }
    });
    if (_.isNil($stateParams.submissionId) || parseInt($stateParams.submissionId) !== this.notification.submissionId) {
      if (this.notification.type === notificationType.CHAT) {
        submissionStateMediator.openChatCollaboration(this.notification.submissionId);
      }
      $state.go(stateName, params);
    } else {
      if (this.notification.type === notificationType.CHAT) {
        $rootScope.$broadcast(submissionConstant.event.OPEN_CHAT_COLLABORATION);
      }
    }
  };
  this.onDismissGrowl = function (event) {
    // prevent propagation to the onGrowlClick() function
    event.stopPropagation();
    event.preventDefault();
    // call the bound function to close the notification
    this.closeNotification();
    return false;
  };
  this.getNotificationMessage = function () {
    var actorName = this.notification.actorName === 'AUTHENTICATION_SERVER' ? 'System' : this.notification.actorName;
    return "<strong>".concat(actorName, "</strong> ").concat(this.notification.message);
  };
};
GrowlController.$inject = ["$element", "$rootScope", "$state", "$stateParams", "coreMediator", "notificationType", "submissionStateMediator", "submissionConstant", "preferenceModel"];
angular.module('umCore').controller('growlController', GrowlController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/ui/notification/notificationGrowl/notificationGrowl.tpl.html';
var html = "<div class=\"notificationGrowlContent\"\n     ng-class=\"{ 'loadingBar': $ctrl.isLoadingBar }\"\n     ng-click=\"$ctrl.onGrowlClick($event)\"\n     ng-mouseleave=\"$ctrl.startDelay()\"\n     ng-mouseenter=\"$ctrl.resetDelay()\">\n\n    <div ng-if=\"!$ctrl.isLoadingBar\"\n         class=\"successContainer\">\n        <span class=\"tickIcon glyphicon glyphicon-ok\"></span>\n    </div>\n\n    <div ng-if=\"$ctrl.isLoadingBar\"\n         class=\"loadingContainer\">\n        <div class=\"icon-whiteSpinner\"><img src=\"" + __webpack_require__(1474) + "\" /></div>\n    </div>\n\n    <div class=\"message\">\n        <span ui-browser-detection ng-bind-html=\"$ctrl.getNotificationMessage()\"></span>\n    </div>\n\n    <iframe src=\"about:blank\" class=\"ieMaskFrame\" ui-browser-detection></iframe>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4fe30872493128fd73a4120086a53d9f.svg";

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

var ActionNotificationGrowlComponent = {
  templateUrl: '/ui/notification/notificationGrowl/notificationGrowl.tpl.html',
  controller: 'notificationGrowlController',
  bindings: {
    notification: '<',
    isLoadingBar: '<',
    closeNotification: '&',
    startTimer: '&',
    clearTimer: '&'
  }
};
angular.module('umCore').component('actionNotificationGrowl', ActionNotificationGrowlComponent);

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

var path = '/ui/notification/notificationGrowl/notificationGrowlComponent.tpl.html';
var html = "<!-- bind the angular-ui-notification dieHard() function which will handle the closing and cleanup of viewable notifications -->\n<action-notification-growl\n    notification=\"notification\"\n    is-loading-bar=\"isLoadingBar\"\n    close-notification=\"kill(true)\"\n    start-timer=\"startTimer()\"\n    clear-timer= \"clearTimer()\"\n    class=\"ui-notification\"></action-notification-growl>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var NotificationGrowlController = function NotificationGrowlController() {
  this.$onInit = function () {
    if (this.isLoadingBar) {
      this.clearTimer();
    }
  };
  this.onGrowlClick = function (event) {
    // prevent propagation to the onGrowlClick() function
    event.stopPropagation();
    event.preventDefault();
    if (!this.isLoadingBar) {
      // call the bound function to close the notification
      this.closeNotification();
      return false;
    }
  };
  this.getNotificationMessage = function () {
    return this.notification;
  };
  this.startDelay = function () {
    if (!this.isLoadingBar) {
      this.startTimer();
    }
  };
  this.resetDelay = function () {
    if (!this.isLoadingBar) {
      this.clearTimer();
    }
  };
  this.$onChanges = function (changes) {
    if (!_.isNil(changes.isLoadingBar)) {
      // If the notification growl changed to a non-loading bar, trigger the start of the delay
      if (changes.isLoadingBar.currentValue !== changes.isLoadingBar.previousValue && !this.isLoadingBar) {
        this.startDelay();
      }
    }
  };
};
angular.module('umCore').controller('notificationGrowlController', NotificationGrowlController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var NotificationPreferenceRepository = function NotificationPreferenceRepository(baseCachedRepository) {
  angular.extend(this, baseCachedRepository);
  this.getCacheName = function () {
    return 'notificationPreferenceRepository';
  };
  this.getCacheCapacity = function () {
    return 10;
  };
  this.getNotificationEmailTemplate = function (name, context) {
    var url = "/rest/NotificationEmailTemplate/name?notificationEmailTemplateName=".concat(name),
      cacheKey = "".concat(name, "email");
    if (!_.isNull(context)) {
      _.each(context, function (value, key) {
        url += "&".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
        cacheKey += "&".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
      });
    }
    return this.get(cacheKey, url);
  };
  this.getNotificationPopupTemplate = function (name, context) {
    var url = "/rest/NotificationPopupTemplate/name?notificationPopupTemplateName=".concat(name),
      cacheKey = "".concat(name, "popup");
    if (!_.isNull(context)) {
      _.each(context, function (value, key) {
        url += "&".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
        cacheKey += "&".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
      });
    }
    return this.get(cacheKey, url);
  };
  this.processResponseData = function (responseData) {
    if (!_.isNil(responseData.confirmationMessage)) {
      responseData.confirmationMessage = responseData.confirmationMessage.replace(/\\n/g, '\n');
    }
    if (!_.isNil(responseData.body)) {
      responseData.body = responseData.body.replace(/\\n/g, '\n');
    }
    return responseData;
  };
};
NotificationPreferenceRepository.$inject = ["baseCachedRepository"];
angular.module('umCore').service('notificationPreferenceRepository', NotificationPreferenceRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

/*@ngInject*/
var NotificationRepository = function NotificationRepository(baseRepository, currentUserModel) {
  angular.extend(this, baseRepository);
  this.findByNotifiedUserId = function (userId, type, startingIndex, numberOfRows, latest, unreadOnly) {
    var url = '/rest/Notification/toUser';
    var config = {
      params: {
        userId: userId,
        type: type,
        startingIndex: startingIndex,
        numberOfRows: numberOfRows,
        registrationIdentifier: '/User/' + userId,
        latest: latest,
        unreadOnly: unreadOnly
      }
    };
    currentUserModel.addNotificationRegistration(type, {
      'url': url,
      'params': config.params
    });
    return this.get(url, config);
  };
  this.countUnacknowledgedByUserId = function (userId, type, latest) {
    var url = '/rest/Notification/toUser/countUnacknowledged';
    var config = {
      params: {
        userId: userId,
        type: type,
        latest: latest
      }
    };
    return this.get(url, config);
  };
  this.acknowledgeByUserId = function (userId, type) {
    var url = '/rest/Notification/acknowledgeByUserId',
      config = {
        params: {
          userId: userId,
          type: type
        }
      };
    return this.post(url, {}, config);
  };
  this.acknowledgeByNotificationId = function (notificationId) {
    var url = "/rest/Notification/acknowledge/".concat(notificationId);
    return this.post(url);
  };
  this.markAsReadByNotificationId = function (notificationId, isRead) {
    var url = "/rest/Notification/".concat(notificationId, "/markAsRead");
    var config = {
      params: {
        isRead: isRead
      }
    };
    return this.post(url, {}, config);
  };
  this.markAllAsReadByUserId = function (userId, type) {
    var url = '/rest/Notification/markAllAsReadByUserId';
    var config = {
      params: {
        userId: userId,
        type: type
      }
    };
    return this.post(url, {}, config);
  };
  this.countUnreadByUserId = function (userId, type, latest) {
    var url = '/rest/Notification/toUser/countUnread';
    var config = {
      params: {
        userId: userId,
        type: type,
        latest: latest
      }
    };
    return this.get(url, config);
  };
};
NotificationRepository.$inject = ["baseRepository", "currentUserModel"];
angular.module('umCore').service('notificationRepository', NotificationRepository);

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

/*@ngInject*/
var OrganizationRepository = function OrganizationRepository($q, baseRepository) {
  angular.extend(this, baseRepository);
  this.loadOrganizationById = function (organizationId) {
    var url = "/rest/Organization/".concat(organizationId);
    return this.get(url);
  };
};
OrganizationRepository.$inject = ["$q", "baseRepository"];
angular.module('umCore').service('organizationRepository', OrganizationRepository);

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UIRequiredIndicatorDirective = function UIRequiredIndicatorDirective() {
  var linkFunction = function linkFunction($scope) {
    $scope.showGreen = false;
    $scope.$watch('value', function (newValue) {
      if (!_.isNil($scope.validator)) {
        $scope.showGreen = $scope.validator();
      } else {
        $scope.showGreen = !_.isNil(newValue) && newValue !== '';
      }
    });
  };
  return {
    restrict: 'E',
    replace: true,
    scope: {
      value: '@',
      validator: '&?'
    },
    link: linkFunction,
    templateUrl: '/ui/requiredIndicator/uiRequiredIndicator.tpl.html'
  };
};
angular.module('umCore').directive('uiRequiredIndicator', UIRequiredIndicatorDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

var path = '/ui/requiredIndicator/uiRequiredIndicator.tpl.html';
var html = "<div class=\"requiredIndicator\" >\r\n    <i ng-if=\"showGreen\" class=\"glyphicon glyphicon-ok\"></i>\r\n    <span ng-if=\"!showGreen\" class=\"glyphicon glyphicon-asterisk\"></span>\r\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1483 */
/***/ (function(module, exports) {

/*@ngInject*/
var UserMediator = function UserMediator(userRepository, userStateModel, userGroupsBrowserRepository, userGroupEditorRepository) {
  this.loadUserList = function (params) {
    return userRepository.loadUserList(params);
  };
  this.createNewUser = function (userType) {
    return userRepository.createNewUser(userType);
  };
  this.savePreviousUser = function (id, userType, formId) {
    userStateModel.savePreviousUser(id, userType, formId);
  };
  this.getPreviousUser = function () {
    return userStateModel.getPreviousUser();
  };
  this.saveViewState = function (stateName, stateModel) {
    userStateModel.saveViewState(stateName, stateModel);
  };
  this.restoreViewState = function (stateName, viewModel) {
    return userStateModel.restoreViewState(stateName, viewModel);
  };
  this.getPreviousViewState = function (stateName) {
    return userStateModel.getPreviousViewState(stateName);
  };
  this.hasPreviousUser = function () {
    return userStateModel.hasPreviousUser();
  };
  this.resetPreviousUser = function () {
    return userStateModel.resetPreviousUser();
  };
  this.loadUserActions = function (userType, userId) {
    return userRepository.loadUserActions(userType, userId);
  };
  this.loadUserById = function (userId) {
    return userRepository.loadUserById(userId);
  };
  this.closeUserPersistentConnection = function (userId) {
    return userRepository.closeUserPersistentConnection(userId);
  };
  this.upgradeForms = function (userId) {
    return userRepository.upgradeForms(userId);
  };
  this.getForms = function (userId) {
    return userRepository.getForms(userId);
  };
  this.loadUserGroupsActions = function () {
    return userGroupsBrowserRepository.loadUserGroupsActions();
  };
  this.getUserGroups = function (nameSearchString, requestParams) {
    return userGroupsBrowserRepository.getUserGroups(nameSearchString, requestParams);
  };
  this.loadUserGroupActions = function (userGroupId) {
    return userGroupEditorRepository.loadUserGroupActions(userGroupId);
  };
  this.loadUserGroupById = function (userGroupId) {
    return userGroupEditorRepository.loadUserGroupById(userGroupId);
  };
  this.loadCarrierUserRoles = function () {
    return userGroupEditorRepository.loadCarrierUserRoles();
  };
  this.createUserGroup = function (userGroup) {
    return userGroupEditorRepository.createUserGroup(userGroup);
  };
  this.saveUserGroup = function (userGroup) {
    return userGroupEditorRepository.saveUserGroup(userGroup);
  };
};
UserMediator.$inject = ["userRepository", "userStateModel", "userGroupsBrowserRepository", "userGroupEditorRepository"];
angular.module('umCore').service('userMediator', UserMediator);

/***/ }),
/* 1484 */
/***/ (function(module, exports) {

angular.module('umUser', []).config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state('userList', {
    url: '/user/list/:userType',
    views: {
      'header': {
        templateUrl: '/common/header/appHeader.tpl.html',
        controller: 'appHeaderController'
      },
      'content': {
        templateUrl: '/ui/user/list/userList.tpl.html',
        controller: 'userListController'
      }
    }
  }).state('userGroups', {
    url: '/userGroups/browser',
    views: {
      'header': {
        templateUrl: '/common/header/appHeader.tpl.html',
        controller: 'appHeaderController'
      },
      'content': {
        templateUrl: '/ui/userGroupsBrowser/userGroupsBrowser.tpl.html',
        controller: 'userGroupsBrowserController'
      }
    }
  }).state('userGroupEditor', {
    url: '/userGroupEditor/:userGroupId',
    views: {
      'header': {
        templateUrl: '/common/header/appHeader.tpl.html',
        controller: 'appHeaderController'
      },
      'content': {
        templateUrl: '/ui/userGroupEditor/userGroupEditor.tpl.html',
        controller: 'userGroupEditorController'
      }
    }
  }).state('manageUser', {
    url: '/user/manage/:userType/:userId',
    views: {
      'header': {
        templateUrl: '/common/header/appHeader.tpl.html',
        controller: 'appHeaderController'
      },
      'content': {
        templateUrl: '/ui/user/manage/manageUser.tpl.html',
        controller: 'manageUserController'
      }
    }
  }).state('manageUser.form', {
    url: '/form/:formId',
    views: {
      'mainContent': {
        templateUrl: '/ui/user/manage/formViewer/manageUserFormViewer.tpl.html',
        controller: 'manageUserFormViewerController'
      }
    },
    params: {
      formId: {
        squash: true,
        value: null
      }
    }
  }).state('manageUser.formSummaryGridDetail', {
    url: '/form/:formId/detail/:ownerUriId/:formSummaryInstanceId',
    views: {
      'mainContent': {
        templateUrl: '/formViewer/component/formSummary/detail/formSummaryGridDetail.tpl.html',
        controller: 'formSummaryGridDetailController'
      }
    },
    resolve: {
      effectiveDate: function effectiveDate() {
        return {
          get: function get() {
            return null;
          }
        };
      },
      currencyCode: function currencyCode() {
        return {
          get: function get() {
            return null;
          }
        };
      },
      printable: function printable() {
        return {
          get: function get() {
            return false;
          }
        };
      }
    }
  });
}]);

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var GetUserListRepository = function GetUserListRepository($q, baseRepository, userUtil) {
  angular.extend(this, baseRepository);
  var closeUserPersistentConnectionPromises = {};
  this.loadUserList = function (params) {
    var url = '/rest/User/List',
      config = {
        params: {
          userName: params.searchString,
          userType: params.userType,
          activeOnly: params.hideInactiveUsers,
          adminUsersOnly: params.adminUsersOnly,
          startIndex: params.startIndex,
          numberOfRows: params.pageSize,
          sortBy: params.key,
          sortDirection: params.sortType
        }
      };
    return this.get(url, config);
  };
  this.createNewUser = function (userType) {
    var url = '/rest/User/createUser',
      body = {},
      config = {
        params: {
          userType: userType,
          organizationId: 15
        }
      };
    return this.post(url, body, config);
  };
  this.loadUserActions = function (userType, userId) {
    var url = '/rest/Actions',
      config = {
        params: {
          uri: userUtil.getOwnerUri(userType, userId),
          registrationIdentifier: !_.isNil(userId) ? '/User/' + userId : null
        }
      };
    return this.get(url, config);
  };
  this.loadUserById = function (userId) {
    var _this = this;
    var url = "/rest/User/".concat(userId),
      config = {
        params: {
          registrationIdentifier: "/User/".concat(userId)
        }
      },
      closeUserPersistentConnectionPromise = closeUserPersistentConnectionPromises[userId] || $q.when();
    return closeUserPersistentConnectionPromise.then(function () {
      return _this.get(url, config);
    });
  };
  this.getUserRolesById = function (userId) {
    var url = "/rest/User/".concat(userId, "/roles");
    return this.get(url);
  };
  this.closeUserPersistentConnection = function (userId) {
    var url = "/rest/User/".concat(userId, "/List"),
      config = {
        params: {
          registrationIdentifier: "/User/".concat(userId)
        }
      },
      promise = this.delete(url, config);
    closeUserPersistentConnectionPromises[userId] = promise;
    return promise;
  };
  this.upgradeForms = function (userId) {
    var url = "/rest/User/".concat(userId, "/upgradeForms");
    return this.post(url);
  };
  this.getForms = function (userId) {
    var url = "/rest/User/".concat(userId, "/formSummaries");
    return this.get(url);
  };
};
GetUserListRepository.$inject = ["$q", "baseRepository", "userUtil"];
angular.module('umCore').service('userRepository', GetUserListRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UserStateModel = function UserStateModel($rootScope, $state, coreConstant) {
  var stateModelStorage, userId, userType, userForm, isVisibleForChat;
  this.init = function () {
    stateModelStorage = {};
    userId = null;
    userType = null;
    userForm = null;
    isVisibleForChat = true;
  };
  this.setVisibleForChat = function (isVisible) {
    isVisibleForChat = isVisible;
    $rootScope.$broadcast(coreConstant.event.CHAT_VISIBILITY_CHANGED, isVisibleForChat);
  };
  this.isVisibleForChat = function () {
    return isVisibleForChat;
  };
  this.saveViewState = function (stateName, stateModel) {
    stateModelStorage[stateName] = _.cloneDeep(stateModel);
  };
  this.restoreViewState = function (stateName, viewModel) {
    var previousState = stateModelStorage[stateName];
    if (previousState) {
      return _.merge(viewModel, previousState);
    }
  };
  this.getPreviousViewState = function (stateName) {
    return stateModelStorage[stateName];
  };
  this.savePreviousUser = function (id, type, formId) {
    userId = id;
    userType = type;
    userForm = formId;
  };
  this.getPreviousUser = function () {
    return {
      userId: userId,
      userType: userType,
      formId: userForm
    };
  };
  this.hasPreviousUser = function () {
    return userId !== null;
  };
  this.resetPreviousUser = function () {
    userId = null;
    userType = null;
    userForm = null;
    delete stateModelStorage[$state.name];
  };
  this.init();
};
UserStateModel.$inject = ["$rootScope", "$state", "coreConstant"];
angular.module('umCore').service('userStateModel', UserStateModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1487 */
/***/ (function(module, exports) {

/*@ngInject*/
var UserUtil = function UserUtil(userType) {
  this.getTitleFromStateParam = function (paramUserType) {
    var agency = 'userList.manageAgencyUsersLabel',
      underwriter = 'userList.manageUnderwriters',
      service = 'userList.manageServiceUsers',
      system = 'userList.manageSystemUsers',
      result;
    switch (paramUserType) {
      case userType.UNDERWRITER:
        result = underwriter;
        break;
      case userType.AGENCY_BROKERAGE:
        result = agency;
        break;
      case userType.SYSTEM:
        result = system;
        break;
      case userType.SERVICE:
        result = service;
        break;
    }
    return result;
  };
  this.getOwnerUri = function (type, userId) {
    var agent = 'com.firstbest.underwriting.agent.Agent:',
      underwriter = 'com.firstbest.underwriting.underwriter.Underwriter:',
      system = 'com.firstbest.user.system.SystemUser:',
      service = 'com.firstbest.underwriting.serviceuser.ServiceUser:',
      result;
    type = parseInt(type);
    switch (type) {
      case userType.AGENCY_BROKERAGE:
        result = agent;
        break;
      case userType.SERVICE:
        result = service;
        break;
      case userType.SYSTEM:
        result = system;
        break;
      case userType.UNDERWRITER:
        result = underwriter;
        break;
    }
    return result + userId;
  };
  this.isValidNavigationItem = function (item) {
    return item.formTemplateAllowDirectNavigation && item.root;
  };
};
UserUtil.$inject = ["userType"];
angular.module('umCore').service('userUtil', UserUtil);

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

var userTypeConstant = {
  UNDERWRITER: 'Underwriter',
  AGENT: 'Agent',
  SYSTEMUSER: 'SystemUser',
  SERVICEUSER: 'ServiceUser'
};
angular.module('umCore').constant('userTypeConstant', userTypeConstant);

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

var path = '/ui/user/dropdown/userAccess/userAccessButton.tpl.html';
var html = "<div class=\"userAccessDropdown\"\n     ng-if=\"$ctrl.hasUserManagementRole\"\n     uib-dropdown>\n\n    <div uib-dropdown-toggle\n         ui-translate>user.dropdown.label</div>\n\n    <ul uib-dropdown-menu>\n       <li ng-if=\"$ctrl.hasAgencyRole\"\n           ng-click=\"$ctrl.onManageAgencyUsers()\">\n           <span ui-translate>userList.manageAgencyUsersLabel</span>\n       </li>\n\n       <li ng-if=\"$ctrl.hasUnderwriterRole\"\n           ng-click=\"$ctrl.onManageUnderwriters()\">\n           <span ui-translate>userList.manageUnderwriters</span>\n       </li>\n    </ul>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

var UserAccessButtonComponent = {
  templateUrl: '/ui/user/dropdown/userAccess/userAccessButton.tpl.html',
  controller: 'userAccessButtonController',
  bindings: {}
};
angular.module('umCore').component('userAccessButton', UserAccessButtonComponent);

/***/ }),
/* 1491 */
/***/ (function(module, exports) {

/*@ngInject*/
var UserAccessButtonController = function UserAccessButtonController($scope, $element, $state, userType, userMediator, authorizationConstants, currentUserModel) {
  $element.addClass('userAccessButton');
  this.hasAgencyRole = currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_PRODUCERS);
  this.hasUnderwriterRole = currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_UNDERWRITERS);
  this.hasUserManagementRole = this.hasAgencyRole || this.hasUnderwriterRole;
  this.navigateUserType = function (userType) {
    var previousUser;
    if (userMediator.hasPreviousUser()) {
      previousUser = userMediator.getPreviousUser();
      $state.go('manageUser.form', {
        userId: previousUser.userId,
        userType: previousUser.userType,
        formId: previousUser.formId
      });
    } else {
      $state.go('userList', {
        userType: userType
      });
    }
  };
  this.onManageAgencyUsers = function () {
    this.navigateUserType(userType.AGENCY_BROKERAGE);
  };
  this.onManageUnderwriters = function () {
    this.navigateUserType(userType.UNDERWRITER);
  };
};
UserAccessButtonController.$inject = ["$scope", "$element", "$state", "userType", "userMediator", "authorizationConstants", "currentUserModel"];
angular.module('umCore').controller('userAccessButtonController', UserAccessButtonController);

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/ui/user/list/userList.tpl.html';
var html = "<div class=\"userList\">\n\n    <!-- Header -->\n    <div class=\"header\">\n\n        <div class=\"headerContent\">\n            <div class=\"headerLabel\"\n                 ng-if=\"viewModel.title\"\n                 ui-translate>{{ viewModel.title }}\n            </div>\n\n            <action-buttons-bar context=\"context\"\n                                actions=\"actions\"\n                                hidden-input-actions=\"hiddenInputActions\"\n                                notify-action-clicked=\"handleAction(action, file)\"\n                                time-last-modified=\"actionsTimeLastModified\"></action-buttons-bar>\n        </div>\n    </div>\n\n    <!-- Tools -->\n    <div class=\"tools\">\n\n        <div class=\"toolsContent\">\n\n            <div class=\"userSearchInput\">\n                <span class=\"glyphicon glyphicon-search\"></span>\n                <input type=\"text\"\n                       class=\"usersSubstring\"\n                       ng-model=\"viewModel.userSearchTerm\"\n                       ng-change=\"onUserSearchTermChanged()\"\n                       placeholder=\"{{ ::viewModel.userSearchTermPlaceholder }}\"/>\n\n                <span class=\"glyphicon glyphicon-remove\"\n                      ng-if=\"viewModel.userSearchTerm\"\n                      ng-click=\"onClearSearchTerm()\"></span>\n            </div>\n\n            <div class=\"inactiveUserToggle\">\n                <span ui-translate>userList.showOnlyActiveUsers</span>\n                <input class=\"activeUsers\" type=\"checkbox\" ng-model=\"viewModel.hideInactiveUsers\"\n                       ng-change=\"onHideInactiveUsersChanged()\">\n            </div>\n\n            <div class=\"adminUserToggle\"\n                ng-if=\"viewModel.isAgencyUsers\">\n                <span ui-translate>userList.showOnlyAdminUsers</span>\n                <input class=\"adminUsers\" type=\"checkbox\" ng-model=\"viewModel.adminUsersOnly\"\n                       ng-change=\"onAdminUsersOnlyChanged()\">\n            </div>\n        </div>\n    </div>\n\n    <!-- Grid -->\n    <div class=\"grid\">\n\n        <div class=\"gridContainer\">\n\n            <!-- Grid Header -->\n            <div class=\"columnHeader\">\n\n                <div class=\"columnRow\">\n\n                    <div class=\"colHover\"></div>\n\n                    <div class=\"colName\"\n                         ui-grid-sortable-header\n                         request-params=\"initialSortConfig\"\n                         item-name=\"name\"\n                         item-label=\"userList.columns.name\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colUsername\"\n                         ui-grid-sortable-header\n                         request-params=\"initialSortConfig\"\n                         item-name=\"username\"\n                         item-label=\"userList.columns.username\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colStatus\"\n                         ui-grid-sortable-header\n                         request-params=\"initialSortConfig\"\n                         item-name=\"status\"\n                         item-label=\"userList.columns.status\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colOrganization\"\n                         ui-grid-sortable-header\n                         request-params=\"initialSortConfig\"\n                         item-name=\"organization\"\n                         item-label=\"userList.columns.organization\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colAgencyNumber\"\n                         ng-if=\"viewModel.isAgencyUsers\"\n                         ui-grid-sortable-header\n                         request-params=\"initialSortConfig\"\n                         item-name=\"organization.agencyNumber\"\n                         item-label=\"userList.columns.agencyNumber\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colLatestLogin\"\n                         ui-grid-sortable-header\n                         request-params=\"initialSortConfig\"\n                         item-name=\"loginDate\"\n                         item-label=\"userList.columns.latestLogin\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n                </div>\n            </div>\n\n\n            <div class=\"datagrid table\"\n                 ux-datagrid=\"viewModel.userRecordList\"\n                 ng-if=\"!viewModel.isLoading\"\n                 ui-scroll-detection\n                 ui-scroll-detection-target=\".columnHeader\">\n\n                <script type=\"template/html\"\n                        data-template-item=\"item\"\n                        data-template-name=\"default\">\n\n                    <div class=\"columnRow\">\n\n                        <div class=\"columnRowWrapper\">\n\n                            <div class=\"col colName\"\n                                 ng-click=\"onClickRow(item)\">\n                                <ui-user-avatar userid=\"{{ ::item.id}}\"></ui-user-avatar>\n                                <span class=\"columnText\">{{ ::item.name }}</span>\n                            </div>\n\n                            <div class=\"col colUsername\"\n                                 ng-click=\"onClickRow(item)\">\n                                <span class=\"columnText\">{{ ::item.username }}</span>\n                            </div>\n\n                            <div class=\"col colStatus\"\n                                 ng-click=\"onClickRow(item)\">\n                                <span class=\"columnText\"\n                                      ng-class=\"{'draftStatus': item.isDraftStatus }\">{{ ::item.statusLabel }}</span>\n                            </div>\n\n                            <div class=\"col colOrganization\"\n                                 ng-click=\"onClickRow(item)\">\n                                <span class=\"columnText\">{{ ::item.organizationName }}</span>\n                            </div>\n\n                            <div class=\"col colAgencyNumber\"\n                                 ng-if=\"viewModel.isAgencyUsers\"\n                                 ng-click=\"onClickRow(item)\">\n                                <span class=\"columnText\">{{ ::item.agencyNumber }}</span>\n                            </div>\n\n                            <div class=\"col colLatestLogin\"\n                                 ng-click=\"onClickRow(item)\">\n                                <span class=\"columnText\">{{ ::item.loginDate | date : 'M/d/y' }}</span>\n                            </div>\n                        </div>\n                    </div>\n                </script>\n            </div>\n\n            <ui-grid-paging-component\n                ng-hide=\"viewModel.totalUserRecords === 0\"\n                start-index=\"viewModel.startIndex\"\n                page-size=\"viewModel.pageSize\"\n                total-records=\"viewModel.totalUserRecords\"\n                record-count-text=\"viewModel.recordCountText\"\n                records-count-text=\"viewModel.recordsCountText\"\n                on-change=\"onPagingChange($event, params)\"></ui-grid-paging-component>\n\n            <div class=\"gridEmpty\"\n                 ng-if=\"viewModel.isGridEmpty && !viewModel.isLoading\" ui-translate>userList.emptyGrid\n            </div>\n\n            <div class=\"icon-spinner\"\n                 ng-if=\"viewModel.isLoading\">\n                <img src=\"" + __webpack_require__(67) + "\"/>\n            </div>\n        </div>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

/*@ngInject*/
var UserListActionMediator = function UserListActionMediator(userListActionRepository) {
  this.importUWLOAs = function (file) {
    return userListActionRepository.importUWLOAs(file);
  };
  this.exportUWLOAs = function () {
    return userListActionRepository.exportUWLOAs();
  };
};
UserListActionMediator.$inject = ["userListActionRepository"];
angular.module('umCore').service('userListActionMediator', UserListActionMediator);

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

/*@ngInject*/
var UserListActionRepository = function UserListActionRepository(baseRepository, temporaryLoginTokenRepository) {
  angular.extend(this, baseRepository);
  this.importUWLOAs = function (file) {
    var _this = this;
    var url = '/underWriterLOAImport/UnderWriterLOAImportServlet',
      formData = new FormData(),
      config = {
        transformRequest: angular.identity,
        params: {
          fileName: file.name,
          size: file.size
        },
        // When you assign undefined, the content type defaults to multipart/form-data
        headers: {
          'Content-Type': undefined
        }
      };
    formData.append('file', file);
    return temporaryLoginTokenRepository.getSingleUseToken().then(function (token) {
      config.params.t = token;
      return _this.post(url, formData, config);
    });
  };
  this.exportUWLOAs = function () {
    var _this2 = this;
    var url = '/underWriterLOAExport/UnderWriterLOAExportServlet',
      config = {
        params: {}
      };
    return temporaryLoginTokenRepository.getSingleUseToken().then(function (token) {
      config.params.t = token;
      return _this2.get(url, config);
    });
  };
};
UserListActionRepository.$inject = ["baseRepository", "temporaryLoginTokenRepository"];
angular.module('umCore').service('userListActionRepository', UserListActionRepository);

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UserListActionsUtil = function UserListActionsUtil($rootScope, $state, userMediator, userListActionMediator, modalUtil, coreConstant, loadingBarHandler, fileExportUtil, localization) {
  localization.getTranslationByKey('userList').then(function (translations) {
    this.createUser = function (userType) {
      var promise = userMediator.createNewUser(userType).then(function (user) {
        $state.go('manageUser', {
          userId: user.id,
          userType: userType
        });
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    };
    this.importUWLOAs = function (file) {
      var promise;
      loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'importUWLOAs.loadingBar'));
      promise = userListActionMediator.importUWLOAs(file).then(function (result) {
        var resultSplits = _.split(result, '\n'),
          successfulImports = parseInt(_.trim(resultSplits[1].substring(_.indexOf(resultSplits[1], '-') + 1))),
          failedImports = parseInt(_.trim(resultSplits[2].substring(_.indexOf(resultSplits[2], '-') + 1))),
          failedReasons,
          config,
          summary;
        if (failedImports === 0) {
          loadingBarHandler.concludeNotificationLoadingBar(_.replace(_.get(translations, 'importUWLOAs.' + (successfulImports === 1 ? 'successMessageSingular' : 'successMessagePlural')), '{0}', successfulImports));
        } else {
          loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);

          // Remove the first 4 entries of the resultSplits array, which is everything except the failed reasons,
          // then join those reasons back together to display in the client:
          resultSplits.splice(0, 4);
          failedReasons = _.join(resultSplits, '\n');
          summary = _.get(translations, 'importUWLOAs.errorModal.summary');
          summary = _.replace(summary, '{0}', successfulImports);
          summary = _.replace(summary, '{1}', failedImports);
          summary = _.replace(summary, '{2}', failedReasons);
          config = {
            confirmActionButtonLabel: _.get(translations, 'importUWLOAs.errorModal.confirmActionButtonLabel'),
            summary: summary,
            title: _.get(translations, 'importUWLOAs.errorModal.title')
          };
          modalUtil.showGenericConfirm(config);
        }
      }, function () {
        // On Error
        loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    };
    this.exportUWLOAs = function () {
      var promise;
      loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'exportUWLOAs.loadingBar'));
      promise = userListActionMediator.exportUWLOAs().then(function (result) {
        var filename = 'userLOAExport.xml';
        loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'exportUWLOAs.successMessage'));
        fileExportUtil.saveAs(result, 'application/xml', filename);
      }, function () {
        // On Error
        loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    };
  }.bind(this));
};
UserListActionsUtil.$inject = ["$rootScope", "$state", "userMediator", "userListActionMediator", "modalUtil", "coreConstant", "loadingBarHandler", "fileExportUtil", "localization"];
angular.module('umCore').service('userListActionsUtil', UserListActionsUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UserListController = function UserListController($rootScope, $scope, $state, $stateParams, $timeout, userType, coreConstant, userMediator, localization, userUtil, navigationStateModel, userManagementAction, userListActionsUtil, modalUtil, userStatus) {
  localization.getTranslationByKey('userList').then(function (translations) {
    $scope.initialSortConfig = {
      key: 'name',
      sortType: 'asc'
    };
    $scope.viewModel = {
      isLoading: false,
      isAgencyUsers: false,
      hideInactiveUsers: false,
      adminUsersOnly: false,
      userSearchTerm: '',
      userRecordList: [],
      totalUserRecords: 0,
      startIndex: 0,
      pageSize: 10,
      key: 'name',
      sortType: 'asc',
      userType: parseInt($stateParams.userType),
      title: '',
      recordCountText: _.get(translations, 'userCount'),
      recordsCountText: _.get(translations, 'usersCount'),
      userSearchTermPlaceholder: _.get(translations, 'userSearchTermPlaceholder')
    };
    $scope.viewModel.isAgencyUsers = $scope.viewModel.userType === userType.AGENCY_BROKERAGE;
    $scope.actions = [];
    $scope.hiddenInputActions = {};
    $scope.context = {
      identifier: 'userList',
      actions: {},
      fallthrough: null,
      model: {
        contextType: coreConstant.CONTEXT_NONE
      }
    };
    $scope.context.actions[coreConstant.CONTEXT_NONE] = '';
    function loadActions() {
      userMediator.loadUserActions($stateParams.userType, /*userId*/null).then(function (actions) {
        var allActions = [];
        allActions.push({
          actions: actions.actions,
          contextType: $scope.context.model.contextType
        });
        $scope.actions = allActions;
        $scope.hiddenInputActions = {};
        $scope.hiddenInputActions[userManagementAction.IMPORT_UW_LOAS] = 'application/xml';
        $scope.actionsTimeLastModified = new Date().getTime();
      });
    }
    function loadUserList() {
      var viewModel = userMediator.restoreViewState('userList:' + $stateParams.userType);
      if (!_.isNil(viewModel)) {
        $scope.viewModel = viewModel;
      }
      var params = {
        userType: $scope.viewModel.userType,
        hideInactiveUsers: $scope.viewModel.hideInactiveUsers,
        adminUsersOnly: $scope.viewModel.adminUsersOnly,
        searchString: $scope.viewModel.userSearchTerm,
        key: $scope.viewModel.key,
        sortType: $scope.viewModel.sortType,
        startIndex: $scope.viewModel.startIndex,
        pageSize: $scope.viewModel.pageSize
      };
      $scope.viewModel.isLoading = true;
      userMediator.loadUserList(params).then(function (result) {
        _.each(result.records, function (user) {
          if (_.isNil(user.name)) {
            user.name = _.get(translations, 'draftUserName');
          } else {
            var name = _.isEmpty(user.name) ? user.firstName + ' ' + user.lastName : user.name;
            user.name = _.isEmpty(name.trim()) ? _.get(translations, 'draftUserName') : name;
          }
          user.statusLabel = _.get(translations, 'status.' + user.status);
          if (user.locked) {
            user.statusLabel += ' ' + _.get(translations, 'lockedLabel');
          }
          user.isDraftStatus = user.status === userStatus.STATUS_DRAFT;
        });
        $scope.viewModel.userRecordList = result.records;
        $scope.viewModel.totalUserRecords = result.totalRecords;
        $scope.viewModel.isGridEmpty = $scope.viewModel.userRecordList.length === 0;
        $timeout(function () {
          $rootScope.$broadcast(coreConstant.event.RECALCULATE_GRID_PAGING);
          $scope.viewModel.isLoading = false;
        }, 0);
      });
      userMediator.saveViewState('userList:' + $stateParams.userType, null);
      navigationStateModel.saveViewState('userList:', null);
    }
    $scope.onClickRow = function (user) {
      var navigationModel = {
        parentState: 'userList:' + $stateParams.userType,
        currentState: 'manageUser',
        data: {
          userId: user.id,
          userType: parseInt($stateParams.userType)
        }
      };
      userMediator.saveViewState(navigationModel.parentState, $scope.viewModel);
      $state.go('manageUser', {
        userId: user.id,
        userType: $scope.viewModel.userType
      });
      navigationStateModel.saveViewState(navigationModel.parentState, navigationModel);
    };
    $scope.onHideInactiveUsersChanged = function () {
      userMediator.saveViewState('userList:' + $stateParams.userType, $scope.viewModel);
      loadUserList();
    };
    $scope.onAdminUsersOnlyChanged = function () {
      userMediator.saveViewState('userList:' + $stateParams.userType, $scope.viewModel);
      loadUserList();
    };
    $scope.onClearSearchTerm = function () {
      $scope.viewModel.userSearchTerm = '';
      $scope.viewModel.startIndex = 0;
      userMediator.saveViewState('userList:' + $stateParams.userType, null);
      loadUserList();
      $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
    };
    $scope.onUserSearchTermChanged = _.debounce(function () {
      $scope.viewModel.startIndex = 0;
      userMediator.saveViewState('userList:' + $stateParams.userType, null);
      loadUserList();
      $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
    }, 750);
    $scope.onPagingChange = function ($event, params) {
      $scope.viewModel.startIndex = params.startIndex;
      loadUserList();
    };
    $scope.onSortChange = function (event, params) {
      $scope.viewModel.key = params.key;
      $scope.viewModel.sortType = params.sortType;
      loadUserList();
    };
    $scope.getUserStatus = function (user) {
      return _.get(translations, 'status.' + user.status);
    };
    $scope.$on('$destroy', function () {
      userMediator.saveViewState($state.name, $scope.viewModel);
    });
    function checkPreviousViewState() {
      var state = userMediator.getPreviousViewState($state.name);
      if (!_.isNil(state)) {
        if (state.userType !== parseInt($stateParams.userType)) {
          loadUserList();
        } else {
          userMediator.restoreViewState($state.name, $scope.viewModel);
          loadUserList();
        }
      } else {
        loadUserList();
      }
    }
    $scope.handleAction = function (action, file) {
      if (action.enabled) {
        switch (action.name) {
          case userManagementAction.CREATE_USER:
            userListActionsUtil.createUser($stateParams.userType);
            break;
          case userManagementAction.EXPORT_UW_LOAS:
            userListActionsUtil.exportUWLOAs().then(function () {
              loadActions();
            });
            break;
          case userManagementAction.IMPORT_UW_LOAS:
            userListActionsUtil.importUWLOAs(file).then(function () {
              loadActions();
            });
            break;
          default:
            modalUtil.showActionNotImplementedModal(action.name);
            break;
        }
      }
    };
    loadActions();
    checkPreviousViewState();
    $scope.viewModel.title = userUtil.getTitleFromStateParam(parseInt($stateParams.userType));
  });
  $scope.$on(ux.datagrid.events.ON_STARTUP_COMPLETE, function () {
    $scope.$apply();
  });
};
UserListController.$inject = ["$rootScope", "$scope", "$state", "$stateParams", "$timeout", "userType", "coreConstant", "userMediator", "localization", "userUtil", "navigationStateModel", "userManagementAction", "userListActionsUtil", "modalUtil", "userStatus"];
angular.module('umCore').controller('userListController', UserListController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

/*@ngInject*/
var FormSetMediator = function FormSetMediator(formSetRepository) {
  this.startChanges = function (formSetId) {
    return formSetRepository.startChanges(formSetId);
  };
  this.applyChanges = function (formSetId) {
    return formSetRepository.applyChanges(formSetId);
  };
  this.discardChanges = function (formSetId) {
    return formSetRepository.discardChanges(formSetId);
  };
};
FormSetMediator.$inject = ["formSetRepository"];
angular.module('umCore').service('formSetMediator', FormSetMediator);

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

/*@ngInject*/
var FormSetRepository = function FormSetRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.startChanges = function (formSetId) {
    var url = '/rest/FormSet/' + formSetId + '/startChanges';
    return this.post(url);
  };
  this.applyChanges = function (formSetId) {
    var url = '/rest/FormSet/' + formSetId + '/applyChanges';
    return this.post(url);
  };
  this.discardChanges = function (formSetId) {
    var url = '/rest/FormSet/' + formSetId + '/discardChanges';
    return this.post(url);
  };
};
FormSetRepository.$inject = ["baseRepository"];
angular.module('umCore').service('formSetRepository', FormSetRepository);

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

var path = '/ui/user/manage/manageUser.tpl.html';
var html = "<div class=\"manageUser\">\n\n    <!--Header-->\n    <div class=\"header\">\n\n        <div class=\"userInfo\">\n\n            <div class=\"leftColumn\">\n                <button class=\"btn btn-link backButton\"\n                        ng-click=\"navigateToUserList()\">\n                    <span class=\"glyphicon glyphicon-arrow-left\"></span>\n                    <span>{{ ::viewModel.backButtonLabel }}</span>\n                </button>\n\n                <span class=\"username\">{{ viewModel.user.firstName }} {{ viewModel.user.lastName }}</span>\n            </div>\n\n            <div class=\"userStatus\">\n                <span class=\"statusLabel\">\n                    <span ui-translate>user.manage.statusLabel</span>:</span>\n                <div class=\"currentStatus\">\n                    <span ng-class=\"{'draftStatus': viewModel.isDraftStatus}\"\n                          ng-bind=\"getUserStatus()\"></span>\n                    <span class=\"draftStatus\" ng-if=\"viewModel.user.locked\">{{::viewModel.lockedLabel}}</span>\n                    <span class=\"lockedDetail\" ng-if=\"viewModel.user.locked\">{{::viewModel.lockedDetail}}</span>\n                    <span class=\"lockedDetail\" ng-if=\"viewModel.user.locked\">{{viewModel.user.lastAccountLockDate | date : viewModel.shortDateTimeFormat }}</span>\n                </div>\n            </div>\n        </div>\n\n        <action-buttons-bar context=\"context\"\n                            actions=\"actions\"\n                            notify-action-clicked=\"handleAction(action, file)\"\n                            time-last-modified=\"actionsTimeLastModified\"></action-buttons-bar>\n    </div>\n\n    <div class=\"bottomContent\">\n\n        <!--Form Navigation-->\n        <div class=\"formNavigation\"\n             ng-show=\"viewModel.showFormNavigation\">\n\n            <ui-user-menu\n                ng-if=\"viewModel.user\"\n                user-id=\"viewModel.user.id\"\n                default-selected-value=\"viewModel.formId\"\n                on-selected-item-change=\"onSelectedFormChange(datasetItem)\"\n                on-menu-has-single-item=\"onMenuHasSingleItem()\"\n                on-menu-has-multiple-items=\"onMenuHasMultipleItems()\">\n            </ui-user-menu>\n\n        </div>\n\n        <!--Form-->\n        <div class=\"userFormContainer\" ui-view=\"mainContent\"></div>\n\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ManageUserController = function ManageUserController($rootScope, $scope, $state, $stateParams, $timeout, userType, userMediator, userUtil, localization, coreConstant, formViewerConstant, navigationStateModel, coreMediator, loadingBarHandler, modalUtil, userAction, userActionUtil, formSetMediator, userStatus) {
  localization.getTranslations().then(function (translations) {
    $scope.viewModel = {
      user: null,
      userType: parseInt($stateParams.userType),
      formId: parseInt($stateParams.formId),
      formName: null,
      userId: $stateParams.userId,
      showFormNavigation: true,
      backButtonLabel: _.get(translations, userUtil.getTitleFromStateParam(parseInt($stateParams.userType))),
      shortDateTimeFormat: 'MM/dd/yy hh:mma'
    };
    $scope.timeoutList = [];
    $scope.actions = [];
    $scope.context = {
      identifier: 'user',
      actions: {},
      fallthrough: null,
      model: {
        contextType: coreConstant.CONTEXT_NONE
      }
    };
    $scope.context.actions[coreConstant.CONTEXT_NONE] = '';
    function loadActions() {
      userMediator.loadUserActions($stateParams.userType, $stateParams.userId).then(function (actions) {
        processActions(actions);
      });
    }
    function processActions(actions) {
      var allActions = [];
      $scope.timeoutList.push($timeout(function () {
        allActions.push({
          actions: actions.actions,
          contextType: $scope.context.model.contextType
        });
        $scope.actions = allActions;
        $scope.actionsTimeLastModified = new Date().getTime();
      }, 0));
    }
    $scope.upgradeForms = function () {
      if (!_.isNaN($scope.viewModel.formId)) {
        loadingBarHandler.showLoadingBar('loadingBar.defaultMessage');
        userMediator.upgradeForms($stateParams.userId).then(function (numberOfFormsUpgraded) {
          if (numberOfFormsUpgraded > 0) {
            var formsText = numberOfFormsUpgraded === 1 ? _.get(translations, 'formsViewer.formUpgrade.singularMessage') : _.get(translations, 'formsViewer.formUpgrade.pluralMessage'),
              message = _.get(translations, 'formsViewer.formUpgrade.message');
            message = _.replace(message, '{1}', numberOfFormsUpgraded);
            message = _.replace(message, '{2}', formsText);
            modalUtil.showGenericConfirm({
              title: _.get(translations, 'formsViewer.formUpgrade.title'),
              summary: message,
              confirmActionButtonLabel: _.get(translations, 'formsViewer.formUpgrade.confirmActionButtonLabel')
            }).then(function () {
              $state.reload();
            });
          }
        }).finally(function () {
          loadingBarHandler.hideLoadingBar();
        });
      }
    };
    $scope.onSelectedFormChange = function (datasetItem) {
      var formId = datasetItem.id,
        upgradeForms = _.isNaN($scope.viewModel.formId);
      $state.go('manageUser.form', {
        formId: formId
      });
      $scope.viewModel.formId = formId;
      $scope.viewModel.formName = datasetItem.name;
      userMediator.savePreviousUser($scope.viewModel.user.id, $scope.viewModel.userType, $scope.viewModel.formId);
      if (upgradeForms) {
        $scope.upgradeForms();
      }
    };
    $scope.navigateToUserList = function () {
      $state.go('userList', {
        userType: $stateParams.userType
      });
      userMediator.resetPreviousUser();
      navigationStateModel.saveViewState('userList:' + $stateParams.userType, null);
    };
    $scope.onMenuHasSingleItem = function () {
      $scope.viewModel.showFormNavigation = false;
    };
    $scope.onMenuHasMultipleItems = function () {
      $scope.viewModel.showFormNavigation = true;
    };
    $scope.getUserStatus = function () {
      if (!_.isNil($scope.viewModel.user)) {
        return _.get(translations, 'user.manage.status.' + $scope.viewModel.user.status);
      } else {
        return '';
      }
    };
    $scope.userStatusIsInactive = function () {
      if (!_.isNil($scope.viewModel.user)) {
        return $scope.viewModel.user.status === 0;
      } else {
        return false;
      }
    };
    $scope.$on(coreConstant.event.UPDATE_USER, function (event, user) {
      if (user.id === parseInt($stateParams.userId)) {
        setUser(user);
      }
    });
    $scope.$on(coreConstant.event.DELETE_USER, function (event, user) {
      if (user.id === parseInt($stateParams.userId)) {
        $scope.navigateToUserList();
      }
    });
    $scope.$on('$destroy', function () {
      userMediator.closeUserPersistentConnection($stateParams.userId);
      _.each($scope.timeoutList, function (item) {
        if (item) {
          $timeout.cancel(item);
        }
      });
    });
    $scope.$on(coreConstant.event.UPDATE_ACTIONS_MESSAGE, function (event, updateActionsMessage, entityType, entityId) {
      if ((entityType === 'agent' || entityType === 'underwriter' || entityType === 'serviceuser' || entityType === 'systemuser') && parseInt($stateParams.userId) === entityId) {
        processActions(updateActionsMessage.actions);
      }
    });
    $scope.$on(coreConstant.event.RELOAD_ACTIONS, function () {
      loadActions();
      loadUser();
    });
    $scope.$on(coreConstant.event.RELOAD_USER, function () {
      reloadUser();
    });
    function loadUser() {
      userMediator.loadUserById($stateParams.userId).then(function (user) {
        setUser(user);
      });
    }
    function setUser(user) {
      $scope.viewModel.user = user;
      $scope.viewModel.isDraftStatus = user.status === userStatus.STATUS_DRAFT;
      $scope.viewModel.lockedLabel = _.get(translations, 'userList.lockedLabel');
      $scope.viewModel.lockedDetail = _.get(translations, 'userList.lockedDetail');
    }

    /*
     * reloadUser redisplays the user's forms.
     * if formId or formName is specified, then the form with
     * that id or name is displayed; otherwise, the first form
     * is displayed.
     * The reason for specifying a form name is that some actions
     * (e.g., "Edit", "Discard", "Save") return a different set
     * of forms because of the user's modification-form-set.
     */
    function reloadUser(formId, formName) {
      userMediator.getForms($scope.viewModel.userId).then(function (result) {
        var nextFormId;
        result = _.filter(result, userUtil.isValidNavigationItem);
        nextFormId = result[0].id;
        if (formId || formName) {
          _.each(result, function (item) {
            if (item.id === formId || item.name === formName) {
              nextFormId = item.id;
              return false;
            }
            return true;
          });
        }
        $state.go('manageUser.form', {
          formId: nextFormId
        }, {
          reload: true
        });
      });
    }
    function performUserFormSetChanges(userActionType) {
      var promise = userActionUtil.getFormSetId($stateParams.userId).then(function (formSetId) {
        function handleDiscardConfirm() {
          loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'user.discardUserChangesLoadingBar'));
          var promise = formSetMediator.discardChanges(formSetId).then(function () {
            reloadUser($scope.viewModel.formId, $scope.viewModel.formName);
            loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'user.discardUserChangesSuccessLoadingBar'));
          });
          $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
          return promise;
        }
        if (userActionType === userAction.EDIT) {
          var _promise = formSetMediator.startChanges(formSetId).then(function () {
            reloadUser($scope.viewModel.formId, $scope.viewModel.formName);
          });
          $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, _promise);
        } else if (userActionType === userAction.SAVE_CHANGES) {
          var _promise2 = formSetMediator.applyChanges(formSetId).then(function () {
            reloadUser($scope.viewModel.formId, $scope.viewModel.formName);
          });
          $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, _promise2);
        } else if (userActionType === userAction.CANCEL_EDIT) {
          modalUtil.showConfirmationModal(null, null, null, 'user.discard', null, /*hideLoadingBar*/true, handleDiscardConfirm);
        }
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    }
    ;
    $scope.handleAction = function (action, file) {
      if (action.enabled) {
        switch (action.name) {
          case userAction.ACTIVATE:
            userActionUtil.activateUser($stateParams.userId);
            break;
          case userAction.CANCEL:
            userActionUtil.cancel($stateParams.userId);
            break;
          case userAction.DEACTIVATE:
            userActionUtil.deactivateUser($stateParams.userId);
            break;
          case userAction.RESET_PASSWORD:
            userActionUtil.resetPassword($stateParams.userId);
            break;
          case userAction.CREATE_PASSWORD:
            userActionUtil.createPassword($stateParams.userId);
            break;
          case userAction.EDIT:
            performUserFormSetChanges(userAction.EDIT);
            break;
          case userAction.SAVE_CHANGES:
            performUserFormSetChanges(userAction.SAVE_CHANGES);
            break;
          case userAction.CANCEL_EDIT:
            performUserFormSetChanges(userAction.CANCEL_EDIT);
            break;
          case userAction.UNLOCK:
            userActionUtil.unlockUser($stateParams.userId);
            break;
          default:
            modalUtil.showActionNotImplementedModal(action.name);
            break;
        }
      }
    };
    loadActions();
    $scope.upgradeForms();
    loadUser();
  });
};
ManageUserController.$inject = ["$rootScope", "$scope", "$state", "$stateParams", "$timeout", "userType", "userMediator", "userUtil", "localization", "coreConstant", "formViewerConstant", "navigationStateModel", "coreMediator", "loadingBarHandler", "modalUtil", "userAction", "userActionUtil", "formSetMediator", "userStatus"];
angular.module('umCore').controller('manageUserController', ManageUserController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

/*@ngInject*/
var UserActionRepository = function UserActionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.deactivateUser = function (userId) {
    var url = '/rest/User/' + userId + '/deactivate';
    return this.post(url);
  };
  this.activateUser = function (userId) {
    var url = '/rest/User/' + userId + '/activate';
    return this.post(url);
  };
  this.deleteUser = function (userId) {
    var url = '/rest/User/' + userId;
    return this.delete(url);
  };
  this.resetPassword = function (userId) {
    var url = '/rest/User/' + userId + '/resetPassword';
    return this.post(url);
  };
  this.unlockUser = function (userId) {
    var url = '/rest/User/' + userId + '/unlock';
    return this.post(url);
  };
  this.getFormSetId = function (userId) {
    var url = '/rest/User/' + userId + '/formset';
    return this.get(url);
  };
};
UserActionRepository.$inject = ["baseRepository"];
angular.module('umCore').service('userActionRepository', UserActionRepository);

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

/*@ngInject*/
var UserActionMediator = function UserActionMediator(userActionRepository) {
  this.deactivateUser = function (userId) {
    return userActionRepository.deactivateUser(userId);
  };
  this.activateUser = function (userId) {
    return userActionRepository.activateUser(userId);
  };
  this.deleteUser = function (userId) {
    return userActionRepository.deleteUser(userId);
  };
  this.resetPassword = function (userId) {
    return userActionRepository.resetPassword(userId);
  };
  this.unlockUser = function (userId) {
    return userActionRepository.unlockUser(userId);
  };
  this.getFormSetId = function (userId) {
    return userActionRepository.getFormSetId(userId);
  };
};
UserActionMediator.$inject = ["userActionRepository"];
angular.module('umCore').service('userActionMediator', UserActionMediator);

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

/*@ngInject*/
var UserActionUtil = function UserActionUtil($rootScope, $state, loadingBarHandler, modalUtil, userActionMediator, userLoginType, uiPerformanceLoggerConstant, coreConstant) {
  this.cancel = function (userId) {
    modalUtil.showConfirmationModal(/*submissionId*/null, /*quoteId*/null, /*notificationName*/null, 'user.cancelModal', uiPerformanceLoggerConstant.DELETE_USER, /*hideLoadingBar*/false, function () {
      return userActionMediator.deleteUser(userId).then(function () {
        $state.go('userList', {
          userType: $state.params.userType
        });
      });
    });
  };
  this.deactivateUser = function (userId) {
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.DEACTIVATE_USER);
    modalUtil.showConfirmationModal(null, null, null, 'user.deactivateModal', uiPerformanceLoggerConstant.DEACTIVATE_USER, /*hideLoadingBar*/false, function () {
      var promise = userActionMediator.deactivateUser(userId).then(onSuccess, onError);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    });
    function onSuccess() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.DEACTIVATE_USER, coreConstant.uiPeformanceLogger.SUCCESS);
      $rootScope.$broadcast(coreConstant.event.RELOAD_USER);
    }
    function onError() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.DEACTIVATE_USER, coreConstant.uiPeformanceLogger.FAIL);
    }
  };
  this.activateUser = function (userId) {
    loadingBarHandler.showLoadingBar('user.activate.loadingBar');
    $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ACTIVATE_USER);
    userActionMediator.activateUser(userId).then(onSuccess, onError);
    function onSuccess(user) {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ACTIVATE_USER, coreConstant.uiPeformanceLogger.SUCCESS);
      loadingBarHandler.hideLoadingBar();
      $rootScope.$broadcast(coreConstant.event.RELOAD_USER);
      if (!user.sentPassword && user.loginType !== userLoginType.SINGLE_SIGN_ON) {
        modalUtil.showConfirmationModal(/*submissionId*/null, /*quoteId*/null, /*notificationName*/null, 'user.activate.sendPasswordModal', uiPerformanceLoggerConstant.RESET_PASSWORD, /*hideLoadingBar*/false, function () {
          var promise = userActionMediator.resetPassword(userId);
          $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
          return promise;
        });
      }
    }
    function onError() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ACTIVATE_USER, coreConstant.uiPeformanceLogger.FAIL);
    }
  };
  this.resetPassword = function (userId) {
    modalUtil.showConfirmationModal(/*submissionId*/null, /*quoteId*/null, /*notificationName*/null, 'user.resetPasswordModal', uiPerformanceLoggerConstant.RESET_PASSWORD, /*hideLoadingBar*/false, function () {
      var promise = userActionMediator.resetPassword(userId);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    });
  };
  this.createPassword = function (userId) {
    modalUtil.showConfirmationModal(/*submissionId*/null, /*quoteId*/null, /*notificationName*/null, 'user.createPasswordModal', uiPerformanceLoggerConstant.CREATE_PASSWORD, /*hideLoadingBar*/false, function () {
      var promise = userActionMediator.resetPassword(userId);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    });
  };
  this.unlockUser = function (userId) {
    modalUtil.showConfirmationModal(/*submissionId*/null, /*quoteId*/null, /*notificationName*/null, 'user.unlockUserModal', uiPerformanceLoggerConstant.UNLOCK_USER, /*hideLoadingBar*/false, function () {
      var promise = userActionMediator.unlockUser(userId);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    });
  };
  this.getFormSetId = function (userId) {
    return userActionMediator.getFormSetId(userId);
  };
};
UserActionUtil.$inject = ["$rootScope", "$state", "loadingBarHandler", "modalUtil", "userActionMediator", "userLoginType", "uiPerformanceLoggerConstant", "coreConstant"];
angular.module('umCore').service('userActionUtil', UserActionUtil);

/***/ }),
/* 1504 */
/***/ (function(module, exports) {

var path = '/ui/user/manage/formViewer/manageUserFormViewer.tpl.html';
var html = "<ui-form-viewer form-id=\"{{ ::viewModel.formId }}\"\n                printable=\"false\"\n                display-form-name=\"true\">\n</ui-form-viewer>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

/*@ngInject*/
var ManageUserFormViewerController = function ManageUserFormViewerController($scope, $stateParams) {
  $scope.viewModel = {
    formId: parseInt($stateParams.formId)
  };
};
ManageUserFormViewerController.$inject = ["$scope", "$stateParams"];
angular.module('umCore').controller('manageUserFormViewerController', ManageUserFormViewerController);

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

var path = '/ui/user/menu/userMenu.tpl.html';
var html = "<ui-collapsible-left-nav collapsible=\"false\"\n                         ng-class=\"{ open: $ctrl}\">\n    <ui-accordion-button ng-repeat=\"item in $ctrl.navigationItemList\"\n                         label=\"item.formTemplateDisplayName || item.name\"\n                         value=\"item.id\"\n                         has-children=\"$ctrl.hasChildren(item)\"\n                         is-open=\"$ctrl.isItemOpen(item)\"\n                         notify-accordion-button-click=\"$ctrl.onNavItemClick(value)\"\n                         is-active=\"$ctrl.selectedItem && $ctrl.selectedItem.id === item.id\"\n                         required-field-count=\"item.requiredFieldCount\"\n                         on-required-field-count-click=\"$ctrl.onRequiredIndicatorClicked($event, item)\"\n                         ng-class=\"{open: $ctrl.isItemOpen(item)}\">\n\n        <div class=\"navigationRow\"\n             ng-repeat=\"childItem in item.children\"\n             ng-class=\"{ 'selected': $ctrl.isActive(childItem)}\">\n\n            <button class=\"btn-link navigationLabel \"\n                    ng-click=\"$ctrl.onNavChildItemClick(childItem)\"\n                    ng-class=\"{ 'active': $ctrl.isActive(childItem)}\">\n                <div class=\"activeBar\"></div>\n                <span class=\"buttonLabel\">{{ ::childItem.formTemplateDisplayName }}</span>\n            </button>\n            <div class=\"requiredFieldContainer\"\n                 ng-click=\"$ctrl.onRequiredIndicatorClicked($event, childItem)\">\n                <div class=\"label label-warning\"\n                     ng-if=\"childItem.requiredFieldCount > 0\" ng-bind=\"childItem.requiredFieldCount\"></div>\n            </div>\n        </div>\n    </ui-accordion-button>\n</ui-collapsible-left-nav>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

var UserMenuComponent = {
  templateUrl: '/ui/user/menu/userMenu.tpl.html',
  controller: 'userMenuController',
  bindings: {
    userId: '<',
    defaultSelectedValue: '<',
    onSelectedItemChange: '&',
    onMenuHasSingleItem: '&',
    onMenuHasMultipleItems: '&'
  }
};
angular.module('umCore').component('uiUserMenu', UserMenuComponent);

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UserMenuController = function UserMenuController($rootScope, $scope, $element, $state, $stateParams, coreConstant, loadingBarHandler, localization, userMediator, formViewerConstant, userUtil) {
  $element.addClass('userMenu');
  this.navigationItemList = [];
  this.selectedItem = null;
  this.$onInit = function () {
    var _this = this;
    localization.getTranslations().then(function (translations) {
      _this.processList = function (formSummaries) {
        var _this2 = this;
        formSummaries = _.filter(formSummaries, userUtil.isValidNavigationItem);
        var groupedList = _.groupBy(formSummaries, function (formSummary) {
          return _.get(translations, 'user.manage.formTemplateType.' + formSummary.formTemplateType);
        });
        this.navigationItemList = [];
        if (formSummaries.length === 1) {
          this.onMenuHasSingleItem();
        } else {
          this.onMenuHasMultipleItems();
        }
        _.each(groupedList, function (item) {
          var itemToPush,
            selectedChild = null;
          if (item.length === 1) {
            itemToPush = item[0];
          } else {
            itemToPush = {
              name: _.get(translations, 'user.manage.formTemplateType.' + item[0].formTemplateType),
              children: item,
              isOpen: false
            };
          }
          if (!_.isNil(itemToPush)) {
            if (!_.isNil(itemToPush.totalRequiredFieldCount)) {
              itemToPush.requiredFieldCount = itemToPush.totalRequiredFieldCount;
            }
            var requiredFieldCount = 0;
            if ($stateParams.formId) {
              if (itemToPush.id && $stateParams.formId === itemToPush.id.toString()) {
                _this2.selectedItem = itemToPush;
              } else if (itemToPush.children) {
                _.each(itemToPush.children, function (item) {
                  if (!_.isNil(item.totalRequiredFieldCount)) {
                    item.requiredFieldCount = item.totalRequiredFieldCount;
                  }
                  requiredFieldCount += item.requiredFieldCount;
                  if (item.id && $stateParams.formId === item.id.toString()) {
                    selectedChild = item;
                  }
                });
                if (selectedChild) {
                  _this2.selectedItem = selectedChild;
                }
                itemToPush.requiredFieldCount = requiredFieldCount;
              }
            } else if (itemToPush.children) {
              _.each(itemToPush.children, function (item) {
                if (!_.isNil(item.totalRequiredFieldCount)) {
                  item.requiredFieldCount = item.totalRequiredFieldCount;
                }
                requiredFieldCount += item.requiredFieldCount;
              });
              itemToPush.requiredFieldCount = requiredFieldCount;
            }
            _this2.navigationItemList.push(itemToPush);
          }
        });
      };
    });
    $scope.$on(coreConstant.event.UPDATE_USER, function (event, result) {
      if (result.id === _this.userId) {
        _this.getUserForms();
      }
    });
    $scope.$on(formViewerConstant.event.FORM_DATA_READY, function (event, fieldModel) {
      _this.getUserForms();
    });
    $scope.$on(formViewerConstant.event.UPDATE_ROOT_FORM, function (event, fieldModel) {
      _this.getUserForms();
    });
    this.loadUserForms();
  };
  this.onRequiredIndicatorClicked = function (event, navItem) {
    var isChangingState = false;
    if (navItem.children) {
      isChangingState = navItem.id !== this.selectedItem.id;
      _.each(navItem.children, function (item) {
        if (item.requiredFieldCount > 0) {
          navItem = item;
          return false;
        }
      });
    } else {
      isChangingState = navItem.id !== this.selectedItem.id;
    }
    this.onNavChildItemClick(navItem);
    if (isChangingState) {
      $rootScope.$broadcast('showNextRequiredFieldAfterFormLoad');
      $rootScope.$broadcast(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD_AFTER_FORM_LOAD);
    } else {
      $rootScope.$broadcast('showNextRequiredField');
      $rootScope.$broadcast(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD, navItem.id.toString());
    }
  };
  this.validatedSelectedItem = function () {
    var selectedItemExists;
    function isItemInList(itemList, targetValue) {
      var _this3 = this;
      var result = false;
      _.each(itemList, function (item) {
        if (item.id === targetValue) {
          result = true;
        } else if (item.children) {
          result = isItemInList.call(_this3, item.children, targetValue);
        }
      });
      return result;
    }
    if (!this.selectedItem) {
      if (this.defaultSelectedValue) {
        this.selectedItem = _.find(this.navigationItemList, {
          id: this.defaultSelectedValue
        });
      } else {
        this.selectedItem = this.navigationItemList[0];
      }
    } else {
      selectedItemExists = isItemInList.call(this, this.navigationItemList, this.selectedItem.id);
      if (!selectedItemExists) {
        this.selectedItem = this.navigationItemList[0];
      }
    }
  };
  this.onNavItemClick = function (itemValue) {
    var item = _.find(this.navigationItemList, function (navigationItem) {
      return navigationItem.id === itemValue;
    });
    if (!item.children) {
      this.notifyChange(item);
    }
  };
  this.onNavChildItemClick = function (item) {
    this.notifyChange(item);
  };
  this.notifyChange = function (item) {
    this.selectedItem = item;
    this.onSelectedItemChange({
      datasetItem: this.selectedItem
    });
  };
  this.hasChildren = function (item) {
    return !_.isEmpty(item.children);
  };
  this.isActive = function (childItem) {
    return this.defaultSelectedValue === parseInt(childItem.id);
  };
  this.isItemOpen = function (item) {
    var _this4 = this;
    var result = false;
    if (item.id === this.defaultSelectedValue && this.hasChildren(item)) {
      result = true;
    } else {
      _.each(item.children, function (item) {
        if (item.id === _this4.defaultSelectedValue) {
          result = true;
        }
      });
    }
    return result;
  };
  this.getUserForms = function () {
    var _this5 = this;
    return userMediator.getForms(this.userId).then(function (result) {
      _this5.processList(result);
      _this5.validatedSelectedItem();
      if (_this5.selectedItem) {
        _this5.notifyChange(_this5.selectedItem);
      }
    });
  };
  this.loadUserForms = function () {
    loadingBarHandler.showLoadingBar();
    this.getUserForms().then(function () {
      loadingBarHandler.hideLoadingBar();
    });
  };
};
UserMenuController.$inject = ["$rootScope", "$scope", "$element", "$state", "$stateParams", "coreConstant", "loadingBarHandler", "localization", "userMediator", "formViewerConstant", "userUtil"];
angular.module('umCore').controller('userMenuController', UserMenuController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

var path = '/ui/user/paging/gridPaging.tpl.html';
var html = "<div class=\"gridPaging\">\n    <ul class=\"pagination\">\n        <li ng-if=\"$ctrl.showPaging\"\n            class=\"backPagingLink\"\n            ng-class=\"{ 'disabled': $ctrl.selectedPage === 1 }\">\n            <a class=\"backPagingButton\" ng-click=\"$ctrl.changePage(-1)\"\n               ui-translate>gridPaging.back</a>\n        </li>\n\n        <li ng-if=\"$ctrl.showPaging\"\n            ng-repeat=\"page in $ctrl.pages\"\n            ng-class=\"{ 'active' : $ctrl.selectedPage === page.number }\">\n            <a ng-click=\"$ctrl.numberClick($index)\">{{ page.number }}</a>\n        </li>\n\n        <li ng-if=\"$ctrl.showPaging\"\n            class=\"nextPageLink\"\n            ng-class=\"{ 'disabled': $ctrl.selectedPage === $ctrl.getMaxNumPages() }\">\n            <a class=\"nextPageButton\" ng-click=\"$ctrl.changePage(1)\"\n               ui-translate>gridPaging.next</a>\n        </li>\n\n        <li ng-if=\"$ctrl.endRecord > 0\"\n            class=\"summary\">{{ $ctrl.getRecordCountText() }}\n        </li>\n    </ul>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

var GridPagingComponent = {
  templateUrl: '/ui/user/paging/gridPaging.tpl.html',
  controller: 'gridPagingController',
  bindings: {
    startIndex: '<',
    pageSize: '<',
    totalRecords: '<',
    recordCountText: '<',
    recordsCountText: '<',
    onChange: '&'
  }
};
angular.module('umCore').component('uiGridPagingComponent', GridPagingComponent);

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var GridPagingController = function GridPagingController($scope, $element, coreConstant) {
  var buttonWidth = 65,
    pageWidth = 35,
    summaryLength = 250,
    i;
  this.$onInit = function () {
    $element.addClass('gridPaging');
    this.showPaging = true;
    this.requestParams = {
      startIndex: this.startIndex,
      pageSize: this.pageSize
    };
    this.pages = [];
    this.maxVisiblePages = 10;
    this.startRecord = 1;
    this.endRecord = this.requestParams.pageSize;
    this.selectedPage = Math.ceil(this.requestParams.startIndex / this.requestParams.pageSize) + 1;
    for (i = 1; i < this.maxVisiblePages + 1; i++) {
      this.pages.push({
        number: i
      });
    }
    var totalWidth = 2 * buttonWidth + this.pages.length * pageWidth + summaryLength;
    this.totalWidth = {
      'width': totalWidth + 'px'
    };
    $scope.$on(coreConstant.event.DATAGRID_ON_RESET_HEADERS, function (evt, params) {
      this.onChange({
        params: {
          pageSize: params.pageSize,
          startIndex: params.startIndex
        }
      });
    }.bind(this));
    $scope.$on(coreConstant.event.RESET_GRID_PAGING, function (evt, pageSize, startIndex) {
      this.requestParams.startIndex = 0;
      if (startIndex) {
        this.requestParams.startIndex = startIndex;
      }
      if (pageSize) {
        this.requestParams.pageSize = pageSize;
      }
      this.startRecord = this.requestParams.startIndex + 1;
      this.selectedPage = Math.ceil(this.requestParams.startIndex / this.requestParams.pageSize) + 1;
      this.endRecord = this.startRecord + this.requestParams.pageSize - 1;
      this.notify();
    }.bind(this));
    $scope.$on(coreConstant.event.RECALCULATE_GRID_PAGING, function () {
      this.calculateVisiblePages();
    }.bind(this));
    this.calculateVisiblePages();
    this.$onChanges = function (changes) {
      this.calculateVisiblePages();
    };
  };
  this.numberClick = function (index) {
    var page = this.pages[index];
    if (this.selectedPage === page.number) {
      return;
    }

    //making sure that an empty page cannot be selected
    while ((page.number - 1) * this.requestParams.pageSize > this.totalRecords) {
      page.number--;
    }
    this.selectedPage = page.number;
    this.notify();
  };
  this.getMaxNumPages = function () {
    return Math.ceil(this.totalRecords / this.requestParams.pageSize);
  };
  this.changePage = function (direction) {
    var length = this.getMaxNumPages();
    if (this.selectedPage === length && direction === 1) {
      return;
    }
    if (this.selectedPage === 1 && direction === -1) {
      return;
    }
    this.selectedPage += direction;

    //define upper limit
    if (this.selectedPage > length) {
      this.selectedPage = length;
    }

    //define lower limit
    if (this.selectedPage < 1) {
      this.selectedPage = 1;
    }
    this.notify();
  };
  this.notify = function () {
    var requestParams = this.requestParams;
    requestParams.startIndex = (this.selectedPage - 1) * requestParams.pageSize;
    $scope.$emit(coreConstant.event.DATAGRID_ON_RESET_HEADERS, this.requestParams);
    this.startRecord = (this.selectedPage - 1) * requestParams.pageSize + 1;
    this.calculateVisiblePages();
  };
  this.calculateVisiblePages = function () {
    //updating visible pages in the pager
    var numOfGroups = Math.ceil(this.totalRecords / this.requestParams.pageSize),
      lower = 0,
      upper = 0,
      j;
    for (i = 0; i < numOfGroups; i++) {
      lower = i * this.maxVisiblePages;
      upper = i * this.maxVisiblePages + this.maxVisiblePages;
      if (this.selectedPage > lower && this.selectedPage <= upper) {
        this.pages = [];
        for (j = lower + 1; j < upper + 1 && j <= numOfGroups; j++) {
          this.pages.push({
            number: j
          });
        }
        break;
      }
    }
    this.endRecord = this.selectedPage * this.requestParams.pageSize;
    //this is the case that the last page is not full
    if (this.endRecord > this.totalRecords) {
      this.endRecord = this.totalRecords;
    }
  };
  this.getRecordCountText = function () {
    var message = '';
    if (this.endRecord > 1) {
      message = this.recordsCountText;
    } else {
      message = this.recordCountText;
    }
    message = _.replace(message, 'startIndex', this.startRecord);
    message = _.replace(message, 'endIndex', this.endRecord);
    message = _.replace(message, 'total', this.totalRecords);
    return message;
  };
};
GridPagingController.$inject = ["$scope", "$element", "coreConstant"];
angular.module('umCore').controller('gridPagingController', GridPagingController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(1513);
__webpack_require__(762);
__webpack_require__(763);

/*@ngInject*/
var UserGroupsBrowserController = function UserGroupsBrowserController($rootScope, $scope, $timeout, $state, $stateParams, coreConstant, userMediator, userGroupAction, localization, navigationStateModel) {
  localization.getTranslationByKey('userGroupsBrowser').then(function (translations) {
    $scope.viewModel = {
      isLoading: true,
      userGroups: [],
      totalUserGroups: 0,
      nameSearchString: '',
      isGridEmpty: true,
      recordCountText: _.get(translations, 'recordCountText'),
      recordsCountText: _.get(translations, 'recordsCountText'),
      nameSearchStringPlaceholder: _.get(translations, 'nameSearchStringPlaceholder'),
      shortDateTimeFormat: 'MM/dd/yy hh:mma',
      title: _.get(translations, 'title'),
      emptyGridLabel: _.get(translations, 'emptyGrid'),
      searchDelayInMilliSeconds: 750,
      requestParams: {
        key: 'name',
        startIndex: 0,
        pageSize: 25,
        sortType: 'asc'
      }
    };
    $scope.actions = [];
    $scope.context = {
      identifier: 'userGroupsBrowser',
      actions: {},
      fallthrough: null,
      model: {
        contextType: coreConstant.CONTEXT_NONE
      }
    };
    $scope.context.actions[coreConstant.CONTEXT_NONE] = '';
    $scope.onNameSearchStringChanged = function () {
      $scope.viewModel.requestParams.startIndex = 0;
      loadUserGroups();
    };
    function loadActions() {
      userMediator.loadUserGroupsActions().then(function (actions) {
        var allActions = [];
        allActions.push({
          actions: actions.actions,
          contextType: $scope.context.model.contextType
        });
        $scope.actions = allActions;
        $scope.actionsTimeLastModified = new Date().getTime();
      });
    }
    function loadUserGroups() {
      $scope.viewModel.isLoading = true;
      userMediator.getUserGroups($scope.viewModel.nameSearchString, $scope.viewModel.requestParams).then(function (result) {
        $scope.viewModel.userGroups = result.records;
        $scope.viewModel.totalUserGroups = result.totalRecords;
        $scope.viewModel.isGridEmpty = result.totalRecords === 0;
        $scope.viewModel.isLoading = false;
      });
    }
    $scope.getStatus = function (item) {
      return _.get(translations, 'status.' + item.status);
    };
    $scope.onPagingChange = function ($event, params) {
      $scope.viewModel.requestParams.startIndex = params.startIndex;
      loadUserGroups();
    };
    $scope.onSortChange = function (event, params) {
      $scope.viewModel.requestParams.key = params.key;
      $scope.viewModel.requestParams.sortType = params.sortType;
      loadUserGroups();
    };
    function resetNavigationState() {
      navigationStateModel.saveViewState('userGroups', null);
    }
    $scope.handleAction = function (action, file) {
      if (action.enabled) {
        switch (action.name) {
          case userGroupAction.NEW_USER_GROUP:
            $state.go('userGroupEditor', {
              userGroupId: -1
            });
            break;
          default:
            modalUtil.showActionNotImplementedModal(action.name);
            break;
        }
      }
    };
    $scope.onClickRow = function (event, item) {
      $state.go('userGroupEditor', {
        userGroupId: item.id
      });
      var navigationModel = {
        parentState: 'userGroups',
        currentState: 'userGroupEditor',
        data: {
          userGroupId: item.id
        }
      };
      navigationStateModel.saveViewState('userGroups', navigationModel);
    };
    loadActions();
    resetNavigationState();
    loadUserGroups();
  });
  $scope.$on(ux.datagrid.events.ON_STARTUP_COMPLETE, function () {
    $scope.$apply();
  });
};
UserGroupsBrowserController.$inject = ["$rootScope", "$scope", "$timeout", "$state", "$stateParams", "coreConstant", "userMediator", "userGroupAction", "localization", "navigationStateModel"];
angular.module('umCore').controller('userGroupsBrowserController', UserGroupsBrowserController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1513 */
/***/ (function(module) {

module.exports = JSON.parse("{\"userGroupsBrowser\":{\"title\":\"Manage User Groups\",\"columns\":{\"name\":\"Name\",\"autoAssign\":\"Auto-Assign Tasks\",\"status\":\"Status\",\"lastModifiedBy\":\"Last Modified By\",\"timeLastModified\":\"Last Modified Date\"},\"emptyGrid\":\"No matching user groups\",\"recordCountText\":\"Showing startIndex to endIndex of total User Group\",\"recordsCountText\":\"Showing startIndex to endIndex of total User Groups\",\"nameSearchStringPlaceholder\":\"Search Name\",\"actions\":{\"name\":\"Actions\",\"new user group\":\"New Group\",\"discard\":\"Discard\",\"save\":\"Save\",\"delete\":\"Delete\"},\"status\":{\"0\":\"Inactive\",\"1\":\"Active\"}}}");

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(1515);
__webpack_require__(764);
__webpack_require__(765);
__webpack_require__(1516);
__webpack_require__(1517);

/*@ngInject*/
var UserGroupEditorController = function UserGroupEditorController($rootScope, $scope, $state, $stateParams, $timeout, $uibModal, localization, configurationMediator, productTypes, coreConstant, configurationConstant, userGroupEditorModel, dataSetUtil, currentUserModel, authorizationConstants, coreMediator, userMediator) {
  var translations;
  $scope.viewModel = {
    selectedUsers: '',
    itemName: 'userGroup',
    userGroup: {},
    userRoles: [],
    requestParams: {
      key: 'name',
      startIndex: 0,
      pageSize: 25,
      sortType: 'asc'
    },
    selectedUsersRole: [],
    displayList: false,
    isLoading: true,
    isGridEmpty: true,
    hasManagePermission: currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_USER_GROUPS),
    id: '',
    active: 1,
    inactive: 0,
    userList: []
  };
  localization.getTranslationByKey('userGroupInformation').then(function (result) {
    translations = result;
    $scope.viewModel.userGroup.namePrompt = _.get(translations, 'userGroupNamePrompt');
    $scope.viewModel.userGroup.autoAssign = _.get(translations, 'autoAssignName');
    $scope.viewModel.userGroup.manageUsersName = _.get(translations, 'manageUsersName');
    $scope.viewModel.searchForStep2 = _.get(translations, 'selectUsers');
  }.bind(this));
  function init() {
    userGroupEditorModel.buildUserGroup(parseInt($stateParams.userGroupId));
  }
  $scope.getStatus = function (item) {
    return _.get(translations, 'status.' + item.status);
  };
  $scope.onSortChange = function (event, params) {
    onSort(params.key, params.sortType);
  };
  function loadModel() {
    userGroupEditorModel.hasUnsavedChanges = false;
    $scope.viewModel.userGroup = userGroupEditorModel.getUserGroup($stateParams.userGroupId);
    $scope.viewModel.isLoading = false;
    _.each($scope.viewModel.userGroup.userIds, function (id) {
      if ($scope.viewModel.selectedUsers !== '') {
        $scope.viewModel.selectedUsers += '::';
      }
      $scope.viewModel.selectedUsers += id;
    });
    loadManageUserList();
  }
  function loadManageUserList() {
    userMediator.loadCarrierUserRoles().then(function (roles) {
      $scope.viewModel.userRoles = roles;
      var userGroupList = [];
      _.each(roles, function (user) {
        if (_.indexOf($scope.viewModel.userGroup.userIds, user.id) !== -1) {
          userGroupList.push(user);
        }
        $scope.viewModel.userList.push({
          name: user.firstName + ' ' + user.lastName + ' (' + user.roles + ')',
          value: String(user.id)
        });
      });
      $scope.viewModel.displayList = true;
      $scope.viewModel.selectedUsersRole = _.orderBy(userGroupList, ['firstName', 'lastName'], ['asc', 'asc']);
    });
  }
  function isFieldValid() {
    var result = false;
    if (!_.isEmpty($scope.viewModel.userGroup.name) && !_.isEmpty($scope.viewModel.selectedUsersRole)) {
      result = true;
    }
    return result;
  }
  function onSort(key, sortType) {
    $scope.viewModel.selectedUsersRole = _.orderBy($scope.viewModel.selectedUsersRole, [key, 'firstName', 'lastName'], [sortType, sortType, sortType]);
    $timeout(function () {
      $scope.$apply();
    }, 10);
  }
  function updateUserGroupModel() {
    var userGroup = {};
    if (!_.isNil(userGroupEditorModel.getUserGroup())) {
      userGroup.id = userGroupEditorModel.getUserGroup().id;
    }
    userGroup.name = $scope.viewModel.userGroup.name;
    userGroup.status.active = $scope.viewModel.userGroup.status === 'active';
    userGroupEditorModel.setUserGroup(userGroup);
  }
  $scope.$on(coreConstant.event.USER_GROUP_EDITOR_MODEL_UPDATED, function (event, userGroupId) {
    if (parseInt($stateParams.userGroupId) === userGroupId) {
      loadModel();
    }
  });
  $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, _.debounce(function (event, itemName) {
    if (itemName === $scope.viewModel.itemName) {
      var tempItemList = _.filter($scope.viewModel.userList, function (item) {
        return item.selected;
      });
      $scope.viewModel.selectedUsersRole = [];
      _.each($scope.viewModel.userRoles, function (user) {
        _.each(tempItemList, function (selectUser) {
          if (user.id === parseInt(selectUser.value)) {
            $scope.viewModel.selectedUsersRole.push(user);
          }
          $scope.viewModel.displayList = true;
        });
      });
      $scope.onChange();
    }
  }), 500);
  $scope.onChange = function () {
    userGroupEditorModel.hasUnsavedChanges = true;
    userGroupEditorModel.isValid = isFieldValid();
    $scope.viewModel.userGroup.userRoleInfos = $scope.viewModel.selectedUsersRole;
    userGroupEditorModel.setUserGroup($scope.viewModel.userGroup);
    $rootScope.$broadcast(coreConstant.event.USER_GROUP_UPDATED, $scope.viewModel.userGroup.id);
  };
  init();
};
UserGroupEditorController.$inject = ["$rootScope", "$scope", "$state", "$stateParams", "$timeout", "$uibModal", "localization", "configurationMediator", "productTypes", "coreConstant", "configurationConstant", "userGroupEditorModel", "dataSetUtil", "currentUserModel", "authorizationConstants", "coreMediator", "userMediator"];
angular.module('umCore').controller('userGroupEditorController', UserGroupEditorController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1515 */
/***/ (function(module) {

module.exports = JSON.parse("{\"userGroupInformation\":{\"userGroupName\":\"Group Name\",\"userGroupNamePrompt\":\"Group Name\",\"inactive\":\"Inactive\",\"active\":\"Active\",\"statusLabel\":\"Status\",\"status\":{\"0\":\"Inactive\",\"1\":\"Active\"},\"taskAssignment\":\"Task Assignment\",\"autoAssignTasks\":\"Auto-Assign Tasks\",\"manageUsersName\":\"Manage Users\",\"selectUsers\":\"Select Users\"},\"userRoleList\":{\"title\":\"Users\",\"columns\":{\"name\":\"Name\",\"status\":\"Status\",\"userRole\":\"User Role\",\"branch\":\"Branch\",\"available\":\"Available\"},\"emptyGrid\":\"No matching section templates\",\"recordCountText\":\"Showing startIndex to endIndex of total Section Template\",\"recordsCountText\":\"Showing startIndex to endIndex of total Section Templates\",\"nameSearchStringPlaceholder\":\"Search Name\",\"actions\":{\"name\":\"Actions\",\"new section template\":\"New Section Template\",\"backup\":\"Backup\",\"reload section rules\":\"Reload Section Rules\"},\"status\":{\"active\":\"Active\",\"inactive\":\"Inactive\"}}}");

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UserGroupEditorModel = function UserGroupEditorModel($rootScope, coreConstant, userMediator) {
  var userGroup = {};
  var userGroupEditorModel = {};
  this.hasUnsavedChanges = false;
  this.isValid = false;
  this.reset = function (userGroupId) {
    if (!_.isNil(userGroupId)) {
      userGroupEditorModel[userGroupId] = {
        updateUserGroup: null,
        isValid: null,
        isValidToSave: null
      };
    } else {
      userGroupEditorModel = {};
    }
  };
  this.buildUserGroup = function (userGroupId) {
    var _this = this;
    this.reset(userGroupId);
    if (userGroupId === -1) {
      this.updateUserGroup({
        id: -1,
        name: null,
        status: 1,
        autoAssign: false,
        userRolesInfos: []
      });
    } else {
      userMediator.loadUserGroupById(userGroupId).then(function (userGroup) {
        _this.updateUserGroup(userGroup);
      });
    }
  };
  this.updateUserGroup = function (userGroup) {
    var model = {
      userGroup: _.cloneDeep(userGroup),
      isValid: null,
      isValidToSave: null
    };
    userGroupEditorModel[userGroup.id] = model;
    $rootScope.$broadcast(coreConstant.event.USER_GROUP_EDITOR_MODEL_UPDATED, userGroup.id);
  };
  this.getUserGroup = function (userGroupId) {
    var model = userGroupEditorModel[userGroupId];
    return model.userGroup;
  };
  this.setUserGroup = function (userGroup) {
    var model = {
      userGroup: _.cloneDeep(userGroup)
    };
    userGroupEditorModel[userGroup.id] = model;
  };
};
UserGroupEditorModel.$inject = ["$rootScope", "coreConstant", "userMediator"];
angular.module('umCore').service('userGroupEditorModel', UserGroupEditorModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1518);
__webpack_require__(1519);
__webpack_require__(1520);
__webpack_require__(1521);
var UserGroupEditorHeaderController = {
  templateUrl: '/ui/userGroupEditor/header/userGroupEditorHeader.tpl.html',
  controller: 'userGroupEditorHeaderController',
  bindings: {
    userGroupName: '<'
  }
};
angular.module('umCore').component('uiUserGroupEditorHeader', UserGroupEditorHeaderController);

/***/ }),
/* 1518 */
/***/ (function(module) {

module.exports = JSON.parse("{\"userGroupEditorHeader\":{\"title\":\"Manage User Groups\",\"actions\":{\"name\":\"Actions\",\"new user group\":\"New Group\",\"discard\":\"Discard\",\"save\":\"Save\",\"delete\":\"Delete\"},\"unsavedChanges\":\"Unsaved changes\",\"invalidUserGroup\":\"The user group is invalid. Please correct or discard your changes before leaving this page.\",\"discardConfirmation\":{\"title\":\"Discard Changes\",\"summary\":\"Are you sure you want to discard your changes?\",\"success\":\"Your changes have been discarded.\",\"cancel\":\"No\",\"confirm\":\"Yes\"},\"createUserGroup\":{\"loadingBar\":\"Creating User Group...\",\"creatingUserGroupSuccessLoadingBar\":\"Successfully created user group\"},\"saveUserGroup\":{\"loadingBar\":\"Saving User Group...\",\"savingUserGroupSuccessLoadingBar\":\"Successfully saved user group\"}}}");

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

var path = '/ui/userGroupEditor/header/userGroupEditorHeader.tpl.html';
var html = "<div class=\"headerRow\">\n    <!--Status-->\n    <div class=\"nameColumn\">\n        <button type=\"button\"\n                class=\"btn-link backButton\"\n                ui-sref=\"userGroups\">\n            <span class=\"glyphicon glyphicon-arrow-left\"></span>\n            <span ui-translate>userGroupEditorHeader.title</span>\n        </button>\n        <div class=\"userGroupName\" uib-tooltip=\"{{ $ctrl.userGroupName }}\">{{ $ctrl.userGroupName }}</div>\n    </div>\n\n    <div class=\"actionButtonColumn\">\n        <action-buttons-bar context=\"$ctrl.context\"\n                            actions=\"$ctrl.actions\"\n                            action-sub-texts=\"$ctrl.actionSubTexts\"\n                            notify-action-clicked=\"$ctrl.handleAction(action, file)\"\n                            time-last-modified=\"$ctrl.actionsTimeLastModified\"></action-buttons-bar>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UserGroupEditorHeaderController = function UserGroupEditorHeaderController($rootScope, $scope, $element, $stateParams, $state, $uibModal, localization, configurationConstant, configurationMediator, coreConstant, modalUtil, userGroupAction, userGroupEditorModel, userGroupActionsUtil, loadingBarHandler, userMediator) {
  var _this3 = this;
  $element.addClass('userGroupEditorHeader');
  this.translations = null;
  this.actions = [];
  this.userGroup = {};
  this.context = {
    identifier: 'userGroupEditorHeader',
    actions: {},
    fallthrough: null,
    model: {
      contextType: coreConstant.CONTEXT_NONE
    }
  };
  this.context.actions[coreConstant.CONTEXT_NONE] = '';
  this.actionSubTexts = {};
  this.actionsTimeLastModified = '';
  this.$onInit = function () {
    var _this = this;
    localization.getTranslationByKey('userGroupEditorHeader').then(function (translations) {
      _this.translations = translations;
      _this.actions = [];
      _this.loadActions();
    });
  };
  this.loadActions = function () {
    var _this2 = this;
    var staticActions = [],
      allActions = [];
    userMediator.loadUserGroupActions($stateParams.userGroupId).then(function (actions) {
      allActions.push({
        actions: actions.actions,
        contextType: _this2.context.model.contextType
      });
      _this2.actions = allActions;
      _this2.actionsTimeLastModified = new Date().getTime();
      _this2.processActions(allActions, false);
    });
  };
  $scope.$on(coreConstant.event.USER_GROUP_UPDATED, function (event, userGroupId) {
    if (parseInt($stateParams.userGroupId) === userGroupId) {
      _this3.userGroup = userGroupEditorModel.getUserGroup(userGroupId);
      _this3.processActions(_this3.actions);
    }
  });
  this.processActions = function (actions) {
    this.actions = actions;
    this.actionSubTexts = {};
    _.each(this.actions, function (subAction) {
      _.each(subAction.actions, function (action) {
        if (action.name === userGroupAction.SAVE) {
          action.enabled = userGroupEditorModel.hasUnsavedChanges && userGroupEditorModel.isValid;
        } else if (action.name === userGroupAction.DISCARD) {
          action.enabled = parseInt($stateParams.userGroupId) === -1 || userGroupEditorModel.getUserGroup($stateParams.userGroupId) && userGroupEditorModel.hasUnsavedChanges;
        }
        if (action.name === userGroupAction.SAVE && userGroupEditorModel.hasUnsavedChanges) {
          this.actionSubTexts[action.name] = {
            class: 'unsavedChanges',
            text: _.get(this.translations, 'unsavedChanges')
          };
        }
      }.bind(this));
    }.bind(this));
    this.actionsTimeLastModified = new Date().getTime();
  };
  this.handleAction = function (action) {
    if (action.enabled) {
      switch (action.name) {
        case userGroupAction.SAVE:
          if (this.userGroup.id === -1) {
            userGroupActionsUtil.createUserGroup($stateParams.userGroupId, this.translations).then(function (userGroup) {
              $stateParams.userGroupId = userGroup.id;
              userGroupEditorModel.hasUnsavedChanges = false;
              userGroupEditorModel.isValid = false;
              userGroupEditorModel.setUserGroup(userGroup);
              $state.reload();
            });
          } else {
            userGroupActionsUtil.saveUserGroup($stateParams.userGroupId, this.translations).then(function (userGroups) {
              userGroupEditorModel.hasUnsavedChanges = false;
              userGroupEditorModel.isValid = false;
              $state.reload();
            });
          }
          break;
        case userGroupAction.DISCARD:
          userGroupActionsUtil.discard(this.userGroup.id, this.translations);
          break;
        default:
          modalUtil.showActionNotImplementedModal(action.name);
          break;
      }
    }
  };
  $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
    var isCurrentStateUserGroupsManager = _.startsWith(fromState.name, 'userGroupEditor'),
      isTargetSameAsCurrent = toState.name === fromState.name;
    if (toState.name === 'login') {
      return;
    }
    if (userGroupEditorModel.hasUnsavedChanges && isCurrentStateUserGroupsManager && !isTargetSameAsCurrent && userGroupEditorModel.getUserGroup(parseInt($stateParams.userGroupId))) {
      event.preventDefault();
      if (userGroupEditorModel.isValid) {
        if (this.userGroup.id === -1) {
          userGroupActionsUtil.createUserGroup($stateParams.userGroupId, this.translations).then(function (userGroup) {
            userGroupEditorModel.hasUnsavedChanges = false;
            userGroupEditorModel.isValid = false;
            $state.go(toState, toParams);
          });
        } else {
          userGroupActionsUtil.saveUserGroup($stateParams.userGroupId, this.translations).then(function (userGroups) {
            userGroupEditorModel.hasUnsavedChanges = false;
            userGroupEditorModel.isValid = false;
            $state.go(toState, toParams);
          });
        }
      } else {
        $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(this.translations, 'invalidUserGroup'));
      }
    } else {
      // there are no changes to be saved, do nothing
    }
  }.bind(this));
};
UserGroupEditorHeaderController.$inject = ["$rootScope", "$scope", "$element", "$stateParams", "$state", "$uibModal", "localization", "configurationConstant", "configurationMediator", "coreConstant", "modalUtil", "userGroupAction", "userGroupEditorModel", "userGroupActionsUtil", "loadingBarHandler", "userMediator"];
angular.module('umCore').controller('userGroupEditorHeaderController', UserGroupEditorHeaderController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var UserGroupActionsUtil = function UserGroupActionsUtil($rootScope, $stateParams, $state, $q, userGroupEditorModel, modalUtil, coreConstant, loadingBarHandler, userMediator) {
  this.createUserGroup = function (userGroupId, translations) {
    var userGroup = userGroupEditorModel.getUserGroup(userGroupId);
    loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'createUserGroup.loadingBar'));
    return userMediator.createUserGroup(userGroup).then(function (result) {
      loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'createUserGroup.creatingUserGroupSuccessLoadingBar'));
      return result;
    });
  };
  this.saveUserGroup = function (userGroupId, translations) {
    var userGroup = userGroupEditorModel.getUserGroup(userGroupId);
    loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'saveUserGroup.loadingBar'));
    return userMediator.saveUserGroup(userGroup).then(function (result) {
      loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'saveUserGroup.savingUserGroupSuccessLoadingBar'));
    });
  };
  this.discard = function (userGroupId, translations) {
    modalUtil.showConfirmationModal(null, null, null, 'userGroupEditorHeader.discardConfirmation', null, true, function () {
      $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(translations, 'discardConfirmation.success'));
      userGroupEditorModel.hasUnsavedChanges = false;
      if (!_.isNil(userGroupId) && userGroupId !== -1 && userGroupEditorModel.getUserGroup(userGroupId)) {
        $state.reload();
      } else {
        $state.go('userGroups', {});
      }
    });
  };
  this.delete = function (translations, sectionTemplateId) {
    //TBD
  };
};
UserGroupActionsUtil.$inject = ["$rootScope", "$stateParams", "$state", "$q", "userGroupEditorModel", "modalUtil", "coreConstant", "loadingBarHandler", "userMediator"];
angular.module('umCore').service('userGroupActionsUtil', UserGroupActionsUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var BaseWidgetController = function BaseWidgetController($scope, coreConstant) {
  this.onInit = function () {
    this.defaultWidgetConfig = _.cloneDeep(this.widgetConfig);
  };
  this.minimize = function ($event) {
    if (!this.isMinimized()) {
      this.widgetConfig.sizeX = this.widgetConfig.minSizeX || 1;
      this.widgetConfig.sizeY = this.widgetConfig.minSizeY || 1;
      $scope.$emit(coreConstant.event.widget.RESIZE_STOP);
    } else {
      $event.stopPropagation();
    }
  };
  this.maximize = function ($event) {
    if (!this.isMaximized()) {
      this.widgetConfig.sizeX = 6;
      this.widgetConfig.sizeY = 4;
      this.widgetConfig.row = 0;
      this.widgetConfig.col = 0;
      $scope.$emit(coreConstant.event.widget.RESIZE_STOP);
    } else {
      $event.stopPropagation();
    }
  };
  this.returnToDefaultSize = function ($event) {
    if (!this.isAtDefaultSize()) {
      this.widgetConfig.sizeX = this.defaultWidgetConfig.sizeX;
      this.widgetConfig.sizeY = this.defaultWidgetConfig.sizeY;
      $scope.$emit(coreConstant.event.widget.RESIZE_STOP);
    } else {
      $event.stopPropagation();
    }
  };
  this.isMinimized = function () {
    return (this.widgetConfig.sizeX === this.widgetConfig.minSizeX || this.widgetConfig.sizeX === 1) && (this.widgetConfig.sizeY === this.widgetConfig.minSizeY || this.widgetConfig.sizeY === 1);
  };
  this.isMaximized = function () {
    return this.widgetConfig.sizeX === 6 && this.widgetConfig.sizeY === 4 && this.widgetConfig.row === 0 && this.widgetConfig.col === 0;
  };
  this.isAtDefaultSize = function () {
    return this.widgetConfig.sizeX === this.defaultWidgetConfig.sizeX && this.widgetConfig.sizeY === this.defaultWidgetConfig.sizeY;
  };
};
BaseWidgetController.$inject = ["$scope", "coreConstant"];
angular.module('umCore').controller('baseWidgetController', BaseWidgetController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1524);
__webpack_require__(1525);
__webpack_require__(757);
__webpack_require__(1526);
__webpack_require__(1529);
__webpack_require__(1532);
__webpack_require__(1535);
__webpack_require__(1538);
__webpack_require__(1542);
__webpack_require__(1543);
var DropdownComponent = {
  templateUrl: '/ui/dropdown/dropdown.tpl.html',
  controller: 'umDropdownController',
  bindings: {
    className: '@',
    required: '<',
    optionList: '<',
    placeholder: '<',
    selectedValue: '<',
    statusText: '<',
    isDisabled: '<',
    onChange: '&',
    onClose: '&'
  }
};
angular.module('umCore').component('umDropdown', DropdownComponent);

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

var path = '/ui/dropdown/dropdown.tpl.html';
var html = "<um-focus-manager></um-focus-manager>\n\n<!--Dropdown Button-->\n<um-dropdown-button\n    display-text=\"$ctrl.dropdownButtonDisplayText\"\n    status-text=\"$ctrl.statusText\"\n    tooltip-text=\"$ctrl.isOptionListOpen || $ctrl.isDisabled ? '' : $ctrl.dropdownButtonDisplayText || $ctrl.placeholder\"\n    tooltip-enabled=\"!$ctrl.isOptionListOpen && !$ctrl.isDisabled\"\n    enabled=\"!$ctrl.isDisabled\"\n    valid=\"'true'\"\n    on-click=\"$ctrl.toggleOptionList(event)\"></um-dropdown-button>\n\n<!--Popover-->\n<um-dropdown-popover\n    ng-if=\"$ctrl.isOptionListOpen\"\n    popover-class-name=\"{{ ::$ctrl.className }}\">\n\n    <um-dropdown-keyboard-controls></um-dropdown-keyboard-controls>\n\n    <um-auto-close-popover\n        parent-class-name=\"{{ ::$ctrl.uniqueComponentClass }}\"\n        dropdown-popover-class-name=\"{{ ::$ctrl.className }}\"\n        on-close=\"$ctrl.toggleOptionList(event)\">\n    </um-auto-close-popover>\n\n    <!--Clear Selection Button-->\n    <um-label-button class=\"clearSelectedButton\"\n                     ng-if=\"!$ctrl.required\"\n                     enabled=\"$ctrl.isClearButtonEnabled()\"\n                     display-text=\"'Clear Selected'\"\n                     on-click=\"$ctrl.onClearSelectedOption()\"></um-label-button>\n\n    <!--Search-->\n    <um-dropdown-search search-term=\"$ctrl.searchTerm\"\n                        on-change=\"$ctrl.onSearch(searchTerm)\"\n                        on-clear-search=\"$ctrl.onClearSearch()\"></um-dropdown-search>\n\n    <!--Option List-->\n    <um-dropdown-list\n        ng-if=\"$ctrl.isDropdownListVisible()\"\n        option-list=\"$ctrl.filteredOptionList\"\n        selected-value=\"$ctrl.selectedValue\"\n        search-term=\"$ctrl.searchTerm\"\n        on-select=\"$ctrl.onSelectedOptionChange(option)\"></um-dropdown-list>\n\n    <!--Feedback Message-->\n    <div class=\"feedbackMessage\"\n         ng-if=\"$ctrl.feedbackMessage\">\n        <div class=\"messageLabel\">{{ $ctrl.feedbackMessage }}</div>\n    </div>\n\n</um-dropdown-popover>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(i18n, _) {/*@ngInject*/
var DropdownController = function DropdownController($scope, $element, localization, dropdownMediator, coreConstant) {
  var _this2 = this;
  this.$onInit = function () {
    this.selectedOption = this.selectedOption || {};
    this.searchTerm = this.searchTerm || '';
    this.placeholder = this.placeholder || '';
    this.required = this.required === true || this.required === 'true' || false;
    localization.setupLocale('component', __webpack_require__(758));
    this.uniqueComponentClass = this.className + 'DropdownComponent';
    $element.addClass('umDropdownContainer');
    $element.addClass(this.uniqueComponentClass);
    this.feedbackMessage = '';
    this.noMatchesError = i18n.t('component|dropdown.noMatchesFoundMessage');
  };
  this.$onChanges = function (changes) {
    var dropdownSelectedValueState = dropdownMediator.getDropdownSelectedValueState(changes, this.selectedOption, this.optionList, this.placeholder);
    if (!_.isNil(dropdownSelectedValueState)) {
      this.selectedOption = dropdownSelectedValueState.selectedOption;
      this.dropdownButtonDisplayText = dropdownSelectedValueState.dropdownButtonDisplayText;
    }
    this.filterOptionList();
    this.validateOptionList();
  };
  this.onSelectedOptionChange = function (option) {
    this.selectedOption = option;
    this.toggleOptionList({
      originalEvent: {
        repeat: false
      }
    });
    this.onChange({
      selectedOption: this.selectedOption
    });
  };
  this.toggleOptionList = function (event) {
    if (!event.originalEvent.repeat) {
      this.isOptionListOpen = !this.isOptionListOpen;
      if (!this.isOptionListOpen) {
        $scope.setFocus('.' + this.uniqueComponentClass + ' .umDropdownButton button', event);
        this.onClose();
      }
      this.filterOptionList();
      this.validateOptionList();
    }
  };
  this.isDropdownListVisible = function () {
    return this.feedbackMessage === null;
  };
  this.onSearch = function (searchTerm) {
    this.searchTerm = searchTerm;
    this.filterOptionList();
    this.validateOptionList();
  };
  this.filterOptionList = function () {
    var _this = this;
    this.filteredOptionList = _.filter(this.optionList, function (option) {
      var searchTerm = _this.searchTerm || '';
      var isSearching = !_.isEmpty(_this.searchTerm);
      var optionValue = _.get(option, 'value') || '';
      var optionName = _.get(option, 'name') || '';
      var isWithinSearchBounds = _.includes(optionValue.toLowerCase(), searchTerm.toLowerCase()) || _.includes(optionName.toLowerCase(), searchTerm.toLowerCase());
      return isSearching ? isWithinSearchBounds : true;
    });
  };
  this.validateOptionList = function () {
    if (!_.isNil(this.filteredOptionList)) {
      var numberOfOptions = _.get(this.filteredOptionList, 'length');
      var hasZeroOptions = numberOfOptions === 0;
      if (hasZeroOptions) {
        this.feedbackMessage = this.noMatchesError;
      } else {
        this.feedbackMessage = null;
      }
    }
  };
  this.isClearButtonEnabled = function () {
    return !_.isEmpty(this.selectedOption.name);
  };
  this.onClearSelectedOption = function () {
    this.selectedOption = {};
    this.toggleOptionList({
      originalEvent: {
        repeat: false
      }
    });
    this.onChange({
      selectedOption: null
    });
  };
  $scope.$on(coreConstant.event.dropdown.DROPDOWN_CLEAR_SELECTED, function () {
    if (_this2.isOptionListOpen) {
      _this2.onClearSelectedOption();
    }
  });
  $scope.$on(coreConstant.event.dropdown.DROPDOWN_CLOSE, function (event) {
    if (_this2.isOptionListOpen) {
      _this2.toggleOptionList({
        originalEvent: {
          repeat: false
        }
      });
    }
  });
};
DropdownController.$inject = ["$scope", "$element", "localization", "dropdownMediator", "coreConstant"];
angular.module('umCore').controller('umDropdownController', DropdownController);
module.exports = DropdownController;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(18)["default"], __webpack_require__(0)))

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1527);
__webpack_require__(1528);
var DropdownButtonComponent = {
  templateUrl: '/ui/dropdown/common/button/dropdownButton.tpl.html',
  controller: 'umDropdownButtonController',
  bindings: {
    displayText: '<',
    statusText: '<',
    tooltipText: '<',
    tooltipEnabled: '<',
    enabled: '<',
    valid: '<',
    hasBusinessCard: '<',
    businessCardUserId: '<',
    businessCardOrganizationId: '<',
    onClick: '&',
    tooltipMessage: '<'
  }
};
angular.module('umCore').component('umDropdownButton', DropdownButtonComponent);

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

var path = '/ui/dropdown/common/button/dropdownButton.tpl.html';
var html = "<div class=\"tooltipContainer\">\n    <ui-user-avatar\n        ng-click=\"$ctrl.onBusinessCardDropdownClick($event)\"\n        ng-if=\"$ctrl.showBusinessCard\"\n        userid=\"{{ $ctrl.businessCardUserId }}\"\n        organization-id=\"{{ $ctrl.businessCardOrganizationId }}\"\n        has-business-card=\"$ctrl.hasBusinessCard\">\n    </ui-user-avatar>\n\n    <button class=\"match\"\n            type=\"button\"\n            ng-class=\"{ invalid: !$ctrl.valid }\"\n            ng-mouseup=\"$ctrl.onDropdownClick($event)\"\n            ng-keydown=\"$ctrl.onDropdownKeydown($event)\"\n            ng-disabled=\"!$ctrl.enabled\"\n            tabindex=\"0\"\n            ui-tooltip\n            ui-tooltip-text=\"{{$ctrl.tooltipText}}\"\n            ui-tooltip-text-element=\"buttonLabel\"\n            ui-tooltip-message=\"{{$ctrl.tooltipMessage}}\">\n\n        <span class=\"buttonLabel\"\n              ng-class=\"{userBusinessCard : $ctrl.hasBusinessCard,\n                         organizationBusinessCard : $ctrl.businessCardOrganizationId }\"\n              ng-disabled=\"'true'\" ng-bind-html=\"$ctrl.displayText\"></span>\n        <span class=\"statusText\" ng-if=\"$ctrl.statusText !== ''\">{{ ::$ctrl.statusText }}</span>\n    </button>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var DropdownButtonController = function DropdownButtonController($rootScope, $scope, $element, coreConstant) {
  this.$onInit = function () {
    $element.addClass('umDropdownButton');
    this.enabled = this.enabled !== 'false' && this.enabled !== false;
    this.tooltipEnabled = this.tooltipEnabled !== 'false' && this.tooltipEnabled !== false;
    this.showBusinessCard = this.canShowBusinessCard();
  };
  this.$onChanges = function () {
    this.showBusinessCard = this.canShowBusinessCard();
  };
  this.canShowBusinessCard = function () {
    return (!_.isNil(this.businessCardUserId) || !_.isNil(this.businessCardOrganizationId)) && this.hasBusinessCard;
  };
  this.onBusinessCardDropdownClick = function (event) {
    if (this.enabled) {
      $rootScope.$broadcast(coreConstant.event.HIDE_BUSINESS_CARD_ON_DROPDOWN);
      this.onClick({
        event: event
      });
    }
  };
  this.onDropdownClick = function (event) {
    this.onClick({
      event: event
    });
  };
  this.onDropdownKeydown = function (event) {
    if (event.keyCode === 13 || event.keyCode === 32) {
      // Enter or space key only
      this.onClick({
        event: event
      });
      event.stopPropagation();
    }
  };
};
DropdownButtonController.$inject = ["$rootScope", "$scope", "$element", "coreConstant"];
angular.module('umCore').controller('umDropdownButtonController', DropdownButtonController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1530);
__webpack_require__(1531);
var LabelButtonComponent = {
  templateUrl: '/ui/dropdown/common/labelButton/labelButton.tpl.html',
  controller: 'umLabelButtonController',
  bindings: {
    displayText: '<',
    enabled: '<',
    onClick: '&'
  }
};
angular.module('umCore').component('umLabelButton', LabelButtonComponent);

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

var path = '/ui/dropdown/common/labelButton/labelButton.tpl.html';
var html = "<button class=\"labelButton\"\n        ng-class=\"{'searchInterfaceFocus': $ctrl.searchInterfaceFocus}\"\n        ng-click=\"$ctrl.onClick()\"\n        ng-disabled=\"!$ctrl.enabled\"\n        tabindex=\"0\">\n\n    <span class=\"displayText\">{{ $ctrl.displayText }}</span>\n</button>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var LabelButtonController = function LabelButtonController($scope, $element, $timeout, coreConstant) {
  var _this = this;
  var timeoutList = [];
  this.$onInit = function () {
    $element.addClass('umDropdownLabelButton');
    this.enabled = this.enabled === undefined ? true : this.enabled;
  };
  this.$onChanges = function (changes) {};
  $scope.$on(coreConstant.event.dropdown.searchInterface.FOCUS_CLEAR_SELECTED_BUTTON, function () {
    _this.searchInterfaceFocus = true;
    timeoutList.push($timeout(function () {}, 0));
  });
  $scope.$on(coreConstant.event.dropdown.searchInterface.BLUR_CLEAR_SELECTED_BUTTON, function () {
    _this.searchInterfaceFocus = false;
    timeoutList.push($timeout(function () {}, 0));
  });
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
};
LabelButtonController.$inject = ["$scope", "$element", "$timeout", "coreConstant"];
angular.module('umCore').controller('umLabelButtonController', LabelButtonController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {__webpack_require__(1533);
__webpack_require__(1534);

/*@ngInject*/
var DropdownPopoverDirective = function DropdownPopoverDirective($timeout, $window) {
  var linkFunction = function linkFunction($scope, $elm, $attr, $controller, $transclude) {
    var requestAnimationFrame = $window.requestAnimationFrame || $window.mozRequestAnimationFrame || $window.webkitRequestAnimationFrame || $window.msRequestAnimationFrame;
    var cancelAnimationFrame = $window.cancelAnimationFrame || $window.mozCancelAnimationFrame;
    var element = $elm[0];
    var popoverMenu;
    var transcludeScope;
    var animationFrameRequest = null;
    $elm.addClass('umDropdownPopoverComponent');
    $transclude(function (cloneList, scope) {
      var transcludeContainer = document.createElement('div');
      transcludeContainer.classList.add('umPopover');
      if (_.includes($scope.popoverClassName, ' ')) {
        _.each(_.split($scope.popoverClassName, ' '), function (className) {
          transcludeContainer.classList.add(className);
        });
      } else {
        transcludeContainer.classList.add($scope.popoverClassName);
      }
      if (!_.isEmpty($scope.popoverIdentifier)) {
        transcludeContainer.classList.add($scope.popoverIdentifier);
      }
      _.each(cloneList, function (clone) {
        transcludeContainer.appendChild(clone);
      });
      document.body.appendChild(transcludeContainer);
      popoverMenu = transcludeContainer;
      transcludeScope = scope;
      animationFrameRequest = requestAnimationFrame(calculatePopoverPosition);
    });
    function calculatePopoverPosition() {
      // TODO need to optimize this so it doesn't run so frequently.

      var windowHeight = Math.max(document.documentElement.clientHeight, $window.innerHeight || 0);
      var headerHeight = 60;
      var searchComponentHeight = 58;
      var clearSelectedHeight = 33;
      var maxWidth = 600;
      var displayAreaHeight = windowHeight - headerHeight;
      var popoverMenuRect = popoverMenu.getBoundingClientRect();
      var popoverMenuHeight = Math.round(parseFloat(popoverMenuRect.height));
      var elementRect = element.getBoundingClientRect();
      var elementTop = Math.round(parseFloat(elementRect.top));
      var elementHeight = Math.round(parseFloat(element.offsetTop));
      var elementLeft = Math.round(parseFloat(elementRect.left));
      var elementWidth = Math.round(parseFloat(elementRect.width));
      var targetTop = elementTop;
      var openUp = elementTop - elementHeight * 2 > displayAreaHeight / 2;
      if (openUp) {
        targetTop = elementTop - (elementHeight + popoverMenuHeight);
        if (targetTop < headerHeight) {
          var dropdownList = $(popoverMenu).find('um-dropdown-list');
          var dropdownListHeight = dropdownList.height();
          var newHeight = dropdownListHeight + targetTop - headerHeight - 5;
          dropdownList.css('max-height', newHeight);
          targetTop = headerHeight + 5;
        }
      } else {
        var _dropdownList = $(popoverMenu).find('um-dropdown-list');
        var _dropdownListHeight = _dropdownList.height();
        if (targetTop + _dropdownListHeight > windowHeight) {
          var _newHeight = windowHeight - targetTop - searchComponentHeight;
          var clearSelectedButton = $(popoverMenu).find('.clearSelectedButton');
          if (clearSelectedButton.length !== 0) {
            _newHeight -= clearSelectedHeight;
          }
          _dropdownList.css('max-height', _newHeight);
        }
      }
      popoverMenu.style.left = elementLeft + 'px';
      popoverMenu.style.top = targetTop + 'px';
      popoverMenu.style['min-width'] = _.clamp(elementWidth, 0, maxWidth) + 'px';
      animationFrameRequest = requestAnimationFrame(calculatePopoverPosition);
    }
    $scope.$on('$destroy', function () {
      $(popoverMenu).remove(); // TODO fix this properly: https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove
      transcludeScope.$destroy();
      if (animationFrameRequest) {
        cancelAnimationFrame(animationFrameRequest);
      }
    });
  };
  return {
    link: linkFunction,
    restrict: 'E',
    transclude: true,
    controller: 'umDropdownPopoverController',
    scope: {
      visible: '<',
      popoverIdentifier: '@',
      popoverClassName: '@'
    }
  };
};
DropdownPopoverDirective.$inject = ["$timeout", "$window"];
angular.module('umCore').directive('umDropdownPopover', DropdownPopoverDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4)))

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

/*@ngInject*/
var DropdownPopoverController = function DropdownPopoverController($scope, $element) {
  this.$onInit = function () {
    $element.addClass('umDropdownPopoverComponent');
  };
};
DropdownPopoverController.$inject = ["$scope", "$element"];
angular.module('umCore').controller('umDropdownPopoverController', DropdownPopoverController);

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var UIAutoClosePopoverDirective = function UIAutoClosePopoverDirective($timeout, $document, $window, coreConstant) {
  var linkFunction = function linkFunction($scope, $elm) {
    var element = $($elm);
    var window = $($window);
    function onClick(event) {
      var popoverParentElement = $(".".concat($scope.parentClassName));
      var popoverMenuElement = $(".umPopover.".concat($scope.dropdownPopoverClassName));
      var searchInputElement = $('um-dropdown-search');
      var isInteractingOutsideDropdown = element[0] === event.target;
      var isScrolling = event.type === 'mousewheel' || event.type === 'DOMMouseScroll';
      var isClickingParentContainer = popoverParentElement.find(event.target).length !== 0;
      var isClickingPopoverMenuChild = popoverMenuElement.find(event.target).length !== 0;
      var isClickingSearchInput = searchInputElement.find(event.target).length !== 0;
      var isClickingPopoverMenu = popoverMenuElement[0] === event.target;
      var isClickingOutsideOptionList = !(isClickingPopoverMenuChild || isClickingParentContainer || isClickingPopoverMenu || isInteractingOutsideDropdown);
      if (isClickingOutsideOptionList) {
        closeDropdown(event);
      } else if (!isScrolling && !isClickingSearchInput && (isClickingPopoverMenuChild || isClickingPopoverMenu)) {
        event.preventDefault();
      }
    }
    function closeDropdown(event) {
      $scope.onClose({
        event: event
      });
    }

    // use timeout to avoid handling the event on initialization
    // since its triggered on a click
    $timeout(function () {
      $scope.$on(coreConstant.event.HANDLE_ERROR, closeDropdown);
      window.on('resize.uiAutoCloseDropdown', onClick);
      $document.bind('mousedown.uiAutoCloseDropdown', onClick);
      $document.bind('mousewheel.uiAutoCloseDropdown', onClick);
      $document.bind('DOMMouseScroll.uiAutoCloseDropdown', onClick);
    }, 0);
    $scope.$on('$destroy', function () {
      window.off('resize.uiAutoCloseDropdown', onClick);
      $document.unbind('mousedown.uiAutoCloseDropdown', onClick);
      $document.unbind('mousewheel.uiAutoCloseDropdown', onClick);
      $document.unbind('DOMMouseScroll.uiAutoCloseDropdown', onClick);
    });
  };
  return {
    link: linkFunction,
    restrict: 'E',
    scope: {
      parentClassName: '@',
      dropdownPopoverClassName: '@',
      onClose: '&'
    }
  };
};
UIAutoClosePopoverDirective.$inject = ["$timeout", "$document", "$window", "coreConstant"];
angular.module('umCore').directive('umAutoClosePopover', UIAutoClosePopoverDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1536);
__webpack_require__(1537);
var DropdownSearchComponent = {
  templateUrl: '/ui/dropdown/common/search/dropdownSearch.tpl.html',
  controller: 'umDropdownSearchController',
  bindings: {
    searchTerm: '<',
    onChange: '&'
  }
};
angular.module('umCore').component('umDropdownSearch', DropdownSearchComponent);

/***/ }),
/* 1536 */
/***/ (function(module, exports) {

var path = '/ui/dropdown/common/search/dropdownSearch.tpl.html';
var html = "<um-focus-manager></um-focus-manager>\n\n<input type=\"text\"\n       class=\"optionListSearchInput\"\n       ng-change=\"$ctrl.onInputChange()\"\n       placeholder=\"Search\"\n       ng-model=\"$ctrl.searchTerm\" />\n\n<button class=\"clearSearchButton\"\n        ng-class=\"{'searchInterfaceFocus': $ctrl.searchInterfaceFocus}\"\n        ng-if=\"$ctrl.searchTerm\"\n        ng-click=\"$ctrl.onClearSearchClick()\">\n    <span class=\"fa fa-times-circle buttonIcon\"></span>\n</button>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var DropdownSearchController = function DropdownSearchController($scope, $element, $timeout, coreConstant) {
  var _this = this;
  var timeoutList = [];
  this.$onInit = function () {
    $element.addClass('umDropdownSearchComponent');
  };
  this.$postLink = function () {
    this.applyFocusToSearch();
  };
  this.applyFocusToSearch = function () {
    $scope.setFocus('.umPopover .optionListSearchInput');
  };
  this.onInputChange = _.debounce(function () {
    _this.onChange({
      searchTerm: _this.searchTerm
    });
    timeoutList.push($timeout(function () {}, 0));
  }, 750);
  this.onClearSearchClick = function () {
    this.searchTerm = '';
    this.onInputChange();
    this.applyFocusToSearch();
  };
  $scope.$on(coreConstant.event.dropdown.searchInterface.FOCUS_CLEAR_SEARCH_INPUT_BUTTON, function () {
    _this.searchInterfaceFocus = true;
    timeoutList.push($timeout(function () {}, 0));
  });
  $scope.$on(coreConstant.event.dropdown.searchInterface.BLUR_CLEAR_SEARCH_INPUT_BUTTON, function () {
    _this.searchInterfaceFocus = false;
    timeoutList.push($timeout(function () {}, 0));
  });
  $scope.$on(coreConstant.event.dropdown.DROPDOWN_CLEAR_SEARCH_INPUT, function () {
    _this.onClearSearchClick();
  });
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (timeout) {
      $timeout.cancel(timeout);
    });
  });
};
DropdownSearchController.$inject = ["$scope", "$element", "$timeout", "coreConstant"];
angular.module('umCore').controller('umDropdownSearchController', DropdownSearchController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1539);
__webpack_require__(1540);
var DropdownListComponent = {
  templateUrl: '/ui/dropdown/common/list/dropdownList.tpl.html',
  controller: 'umDropdownListController',
  transclude: true,
  bindings: {
    optionList: '<',
    selectedValue: '<',
    searchTerm: '<',
    onSelect: '&'
  }
};
angular.module('umCore').component('umDropdownList', DropdownListComponent);

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

var path = '/ui/dropdown/common/list/dropdownList.tpl.html';
var html = "<div class=\"optionRowContainerWrapper\"\n     ng-repeat=\"item in $ctrl.itemsList\"\n     um-dropdown-list-item-scroll-into-view>\n\n    <div ng-if=\"item.isGroupingLabel\"\n         class=\"groupingLabel\"\n         ng-class=\"{ 'first-group': $index === 0 }\">\n        {{ item.grouping }}\n    </div>\n\n    <button ng-if=\"!item.isGroupingLabel\"\n            class=\"btn-link optionRowContainer\"\n            ng-class=\"{ 'selected': item.value === $ctrl.selectedValue, 'highlighted': item.highlighted }\"\n            ng-click=\"$ctrl.onSelect({ option: item })\"\n            ng-mouseover=\"$ctrl.onMouseOver(item)\"\n            ng-mouseleave=\"$ctrl.onMouseLeave(item)\"\n            tabindex=\"-1\">\n\n        <div class=\"buttonLabel\">{{item.name}}</div>\n    </button>\n</div>\n\n<div ng-transclude class=\"footerOption\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(1541);

/*@ngInject*/
var DropdownListController = function DropdownListController($scope, $element, $timeout, coreConstant) {
  var _this2 = this;
  var timeoutList = [];
  var currentHighlightedItem = null;
  this.$onInit = function () {
    $element.addClass('umDropdownListComponent');
    this.itemsList = this.itemsList || [];
  };
  this.$onChanges = function (changes) {
    var isOptionListChange = !_.isEmpty(changes.optionList);
    if (isOptionListChange) {
      this.processOptionList();
      timeoutList.push($timeout(function () {
        var selectedElement = $element.find('.selected');
        if (selectedElement.length) {
          selectedElement[0].scrollIntoView({
            block: 'center'
          });
        }
      }, 100));
    }
  };
  this.processOptionList = function () {
    var _this = this;
    var groupings = [];
    var itemsByGrouping = {};
    _.each(this.optionList, function (item) {
      if (!_.includes(groupings, item.grouping)) {
        itemsByGrouping[item.grouping || ''] = [];
        groupings.push(item.grouping);
      }
      _this.unhighlightItem(item);
      itemsByGrouping[item.grouping || ''].push(item);
    });
    this.itemsList = [];
    _.forOwn(itemsByGrouping, function (items, grouping) {
      _this.itemsList.push({
        isGroupingLabel: true,
        grouping: grouping
      });
      _this.itemsList = _.concat(_this.itemsList, items);
    });
    this.itemsListWithoutGroupings = _.filter(this.itemsList, function (item) {
      return !item.isGroupingLabel;
    });
    if (!_.isEmpty(this.searchTerm) && !_.isEmpty(this.itemsListWithoutGroupings)) {
      this.highlightItem(_.first(this.itemsListWithoutGroupings));
    }
  };
  this.onMouseOver = function (item) {
    item.mouseOver = true;
    this.highlightItem(item);
  };
  this.onMouseLeave = function (item) {
    item.mouseOver = false;
    this.unhighlightItem(item);
  };
  this.findItemToHighlight = function (up) {
    var itemToHighlight = null;
    if (up) {
      if (_.isNil(currentHighlightedItem)) {
        itemToHighlight = _.last(this.itemsListWithoutGroupings);
      } else {
        var currentHighlightedItemIndex = _.findIndex(this.itemsListWithoutGroupings, function (item) {
          return item === currentHighlightedItem;
        });
        if (currentHighlightedItemIndex === 0) {
          itemToHighlight = _.last(this.itemsListWithoutGroupings);
        } else {
          itemToHighlight = this.itemsListWithoutGroupings[currentHighlightedItemIndex - 1];
        }
      }
    } else {
      if (_.isNil(currentHighlightedItem)) {
        itemToHighlight = _.first(this.itemsListWithoutGroupings);
      } else {
        var _currentHighlightedItemIndex = _.findIndex(this.itemsListWithoutGroupings, function (item) {
          return item === currentHighlightedItem;
        });
        if (_currentHighlightedItemIndex === _.size(this.itemsListWithoutGroupings) - 1) {
          itemToHighlight = _.first(this.itemsListWithoutGroupings);
        } else {
          itemToHighlight = this.itemsListWithoutGroupings[_currentHighlightedItemIndex + 1];
        }
      }
    }
    return itemToHighlight;
  };
  this.handleDropdownHighlightChange = function (up) {
    var itemToHighlight = this.findItemToHighlight(up);
    this.highlightItem(itemToHighlight);
  };
  this.highlightItem = function (item) {
    _.map(this.itemsListWithoutGroupings, function (item) {
      item.highlighted = false;
    });
    item.highlighted = true;
    currentHighlightedItem = item;
  };
  this.unhighlightItem = function (item) {
    item.highlighted = false;
    currentHighlightedItem = null;
  };
  $scope.$on(coreConstant.event.dropdown.DROPDOWN_HIGHLIGHT_UP, function () {
    _this2.handleDropdownHighlightChange(true);
    timeoutList.push($timeout(function () {}, 0));
  });
  $scope.$on(coreConstant.event.dropdown.DROPDOWN_HIGHLIGHT_DOWN, function () {
    _this2.handleDropdownHighlightChange(false);
    timeoutList.push($timeout(function () {}, 0));
  });
  $scope.$on(coreConstant.event.dropdown.DROPDOWN_SELECT_HIGHLIGHTED_ITEM, function () {
    if (!_.isNil(currentHighlightedItem)) {
      _this2.onSelect({
        option: currentHighlightedItem
      });
      timeoutList.push($timeout(function () {}, 0));
    }
  });
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
};
DropdownListController.$inject = ["$scope", "$element", "$timeout", "coreConstant"];
angular.module('umCore').controller('umDropdownListController', DropdownListController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UMDropdownListItemScrollIntoViewDirective = function UMDropdownListItemScrollIntoViewDirective() {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    var element = $($elm);
    var listElement = $('um-dropdown-list');
    $scope.$watch('item.highlighted', function (newValue, oldValue) {
      if (!$scope.item.mouseOver) {
        if (!_.isNil(newValue) && !_.isNil(oldValue) && newValue === true && oldValue === false) {
          var listBoundingClientRect = listElement[0].getBoundingClientRect();
          var elementBoundingClientRect = element[0].getBoundingClientRect();
          if (shouldScrollIntoViewTop(listBoundingClientRect, elementBoundingClientRect)) {
            listElement.animate({
              scrollTop: listElement.scrollTop() + elementBoundingClientRect.top - listBoundingClientRect.top
            }, 0);
          } else if (shouldScrollIntoViewBottom(listBoundingClientRect, elementBoundingClientRect)) {
            listElement.animate({
              scrollTop: listElement.scrollTop() + elementBoundingClientRect.bottom - listBoundingClientRect.bottom
            }, 0);
          }
        }
      }
    });
    function shouldScrollIntoViewTop(listBoundingClientRect, elementBoundingClientRect) {
      return elementBoundingClientRect.top < listBoundingClientRect.top;
    }
    function shouldScrollIntoViewBottom(listBoundingClientRect, elementBoundingClientRect) {
      return elementBoundingClientRect.bottom > listBoundingClientRect.bottom;
    }
  };
  return {
    link: linkFunction,
    restrict: 'A'
  };
};
angular.module('umCore').directive('umDropdownListItemScrollIntoView', UMDropdownListItemScrollIntoViewDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {/*@ngInject*/
var FocusManagerDirective = function FocusManagerDirective($timeout, browserUtil) {
  var linkFunction = function linkFunction($scope) {
    $scope.setFocus = function (targetClass, event) {
      $timeout(function () {
        var targetElement = document.querySelector(targetClass);
        var isEventTargetFormFieldComponent = false;
        if (!_.isNil(event)) {
          var eventTarget = $(event.target);
          isEventTargetFormFieldComponent = !_.isEmpty(eventTarget.parents('.formComponentContainer'));
        }
        if (targetElement && !isEventTargetFormFieldComponent) {
          targetElement.focus();
          if (browserUtil.isIE11()) {
            if (targetElement instanceof HTMLInputElement && !_.isNil(targetElement.value)) {
              // IE fix to move the cursor to the end of the value.
              targetElement.setSelectionRange(targetElement.value.length, targetElement.value.length);
            }
          }
        }
      }, 100);
    };
  };
  return {
    link: linkFunction,
    restrict: 'E'
  };
};
FocusManagerDirective.$inject = ["$timeout", "browserUtil"];
angular.module('umCore').directive('umFocusManager', FocusManagerDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4)))

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var UMDropdownKeyboardControlsDirective = function UMDropdownKeyboardControlsDirective($rootScope, $document, coreConstant) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    var currentDropdownSearchInterface = coreConstant.dropdown.searchInterface.SEARCH_INPUT;
    function onKeyDown(event) {
      switch (event.keyCode) {
        case 9:
          handleTabKey(event);
          break;
        case 13:
          handleEnterKey(event);
          break;
        case 27:
          handleEscapeKey(event);
          break;
        case 38:
          handleUpKey(event);
          break;
        case 40:
          handleDownKey(event);
          break;
        default:
          break;
      }
    }
    function handleTabKey(event) {
      // Ignore the default TAB behavior and handle it ourselves
      event.preventDefault();
      var backwards = event.shiftKey;
      var clearSearchInputButton = $('.umPopover um-dropdown-search .clearSearchButton');
      var clearSelectedButton = $('.umPopover um-label-button .labelButton:enabled');
      switch (currentDropdownSearchInterface) {
        case coreConstant.dropdown.searchInterface.SEARCH_INPUT:
          if (backwards) {
            focusClearSelectedButton(event, clearSelectedButton);
          } else {
            focusClearSearchInputButton(event, clearSearchInputButton);
          }
          break;
        case coreConstant.dropdown.searchInterface.CLEAR_SEARCH_INPUT_BUTTON:
          if (backwards) {
            focusSearchInput();
          } else {
            focusClearSelectedButton(event, clearSelectedButton);
          }
          break;
        case coreConstant.dropdown.searchInterface.CLEAR_SELECTED_BUTTON:
          if (backwards) {
            focusClearSearchInputButton(event, clearSearchInputButton);
          } else {
            focusSearchInput();
          }
          break;
        default:
          break;
      }
    }
    function focusSearchInput() {
      currentDropdownSearchInterface = coreConstant.dropdown.searchInterface.SEARCH_INPUT;
      $rootScope.$broadcast(coreConstant.event.dropdown.searchInterface.BLUR_CLEAR_SELECTED_BUTTON);
      $rootScope.$broadcast(coreConstant.event.dropdown.searchInterface.BLUR_CLEAR_SEARCH_INPUT_BUTTON);
    }
    function focusClearSelectedButton(event, clearSelectedButton) {
      currentDropdownSearchInterface = coreConstant.dropdown.searchInterface.CLEAR_SELECTED_BUTTON;
      if (clearSelectedButton.length !== 0) {
        $rootScope.$broadcast(coreConstant.event.dropdown.searchInterface.FOCUS_CLEAR_SELECTED_BUTTON);
        $rootScope.$broadcast(coreConstant.event.dropdown.searchInterface.BLUR_CLEAR_SEARCH_INPUT_BUTTON);
      } else {
        handleTabKey(event);
      }
    }
    function focusClearSearchInputButton(event, clearSearchInputButton) {
      currentDropdownSearchInterface = coreConstant.dropdown.searchInterface.CLEAR_SEARCH_INPUT_BUTTON;
      if (clearSearchInputButton.length !== 0) {
        $rootScope.$broadcast(coreConstant.event.dropdown.searchInterface.FOCUS_CLEAR_SEARCH_INPUT_BUTTON);
        $rootScope.$broadcast(coreConstant.event.dropdown.searchInterface.BLUR_CLEAR_SELECTED_BUTTON);
      } else {
        handleTabKey(event);
      }
    }
    function handleUpKey(event) {
      // Ignore the default behavior to prevent the cursor from moving around in the search input
      event.preventDefault();
      focusSearchInput();
      $rootScope.$broadcast(coreConstant.event.dropdown.DROPDOWN_HIGHLIGHT_UP);
    }
    function handleDownKey(event) {
      // Ignore the default behavior to prevent the cursor from moving around in the search input
      event.preventDefault();
      focusSearchInput();
      $rootScope.$broadcast(coreConstant.event.dropdown.DROPDOWN_HIGHLIGHT_DOWN);
    }
    function handleEnterKey(event) {
      event.preventDefault();
      switch (currentDropdownSearchInterface) {
        case coreConstant.dropdown.searchInterface.SEARCH_INPUT:
          $rootScope.$broadcast(coreConstant.event.dropdown.DROPDOWN_SELECT_HIGHLIGHTED_ITEM);
          break;
        case coreConstant.dropdown.searchInterface.CLEAR_SEARCH_INPUT_BUTTON:
          currentDropdownSearchInterface = coreConstant.dropdown.searchInterface.SEARCH_INPUT;
          $rootScope.$broadcast(coreConstant.event.dropdown.DROPDOWN_CLEAR_SEARCH_INPUT);
          break;
        case coreConstant.dropdown.searchInterface.CLEAR_SELECTED_BUTTON:
          currentDropdownSearchInterface = coreConstant.dropdown.searchInterface.SEARCH_INPUT;
          $rootScope.$broadcast(coreConstant.event.dropdown.DROPDOWN_CLEAR_SELECTED);
          break;
        default:
          break;
      }
    }
    function handleEscapeKey(event) {
      event.preventDefault();
      $rootScope.$broadcast(coreConstant.event.dropdown.DROPDOWN_CLOSE);
    }
    $document.bind('keydown.umDropdownKeyboardControls', onKeyDown);
    $scope.$on('$destroy', function () {
      $document.unbind('keydown.umDropdownKeyboardControls', onKeyDown);
    });
  };
  return {
    link: linkFunction,
    restrict: 'E'
  };
};
UMDropdownKeyboardControlsDirective.$inject = ["$rootScope", "$document", "coreConstant"];
angular.module('umCore').directive('umDropdownKeyboardControls', UMDropdownKeyboardControlsDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1545);
__webpack_require__(1546);
var ToggleButtonComponent = {
  templateUrl: '/ui/toggleButton/toggleButton.tpl.html',
  controller: 'umToggleButtonController',
  bindings: {
    className: '@',
    value: '<',
    isDisabled: '<',
    onChange: '&'
  }
};
angular.module('umCore').component('umToggleButton', ToggleButtonComponent);

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

var path = '/ui/toggleButton/toggleButton.tpl.html';
var html = "<button class=\"toggleButton\"\n        ng-click=\"$ctrl.handleToggleButtonClick()\"\n        ng-class=\"{'checked': $ctrl.value, 'unChecked': !$ctrl.value}\"\n        ng-disabled=\"$ctrl.isDisabled\">\n        <span class=\"animationLayer\">\n            <span class=\"toggle\"></span>\n        </span>\n\n</button>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

/*@ngInject*/
var ToggleButtonController = function ToggleButtonController($scope, $element) {
  this.$onInit = function () {
    this.uniqueComponentClass = this.className + 'ToggleButtonComponent';
    $element.addClass('umToggleButton');
    $element.addClass(this.uniqueComponentClass);
  };
  this.handleToggleButtonClick = function () {
    this.value = !this.value;
    this.onChange({
      value: this.value
    });
  };
};
ToggleButtonController.$inject = ["$scope", "$element"];
angular.module('umCore').controller('umToggleButtonController', ToggleButtonController);
module.exports = ToggleButtonController;

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

var adminFunctionConstants = {
  CONFIGURATION_TAB: 'Configuration',
  USERS_TAB: 'Users',
  ORGANIZATIONS_TAB: 'Organizations',
  NOTIFICATIONS_TAB: 'Notifications',
  PERMISSIONS_TAB: 'Permissions',
  CONFIGURATION_SCORING: 'Scoring',
  PREFERENCES_TAB: 'Preferences',
  CONFIGURATION_PRODUCTS: 'Products',
  CONFIGURATION_SECTIONS: 'Sections',
  CONFIGURATION_RULES: 'Rules',
  CONFIGURATION_DATA_SETS: 'Data Sets',
  CONFIGURATION_FORMS: 'Forms',
  CONFIGURATION_SCORING_RULES: 'Scoring Rules',
  CONFIGURATION_RATE_STATUS: 'Rate Status',
  USERS_USER_GROUPS: 'User Groups',
  SYSTEM_USERS: 'System Users',
  SERVICE_TEAM_USERS: 'Service Users',
  USERS_UNDERWRITERS: 'Underwriters',
  USERS_AGENCY_BROKERAGE_USERS: 'Agency/Brokerage Users',
  ORGANIZATIONS_MGA_ORGANIZATION: 'MGA',
  ORGANIZATIONS_CARRIER_ORGANIZATION: 'Carrier',
  ORGANIZATIONS_MGA_AGENCY_BROKERAGE: 'MGA Agency/Brokerage',
  ORGANIZATIONS_AGENCY_BROKERAGE: 'Agency/Brokerage',
  NOTIFICATIONS_POP_UP: 'Pop-up',
  NOTIFICATIONS_EMAIL: 'Email',
  PERMISSIONS_AGENCY_BROKERAGE: 'Agency/Brokerage',
  PERMISSIONS_SERVICE_TEAM: 'Service Team',
  PERMISSIONS_UNDERWRITING: 'Underwriting',
  PERMISSIONS_SYSTEM: 'System',
  PREFERENCES_GENERAL: 'General',
  PREFERENCES_TABLE_COLUMNS: 'Table Columns',
  PREFERENCES_FILES_AND_ICONS: 'Files & Icons'
};
angular.module('gw-um-j2js').constant('adminFunctionConstants', adminFunctionConstants);

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

var authorizationConstants = {
  AUTHORIZATION_NAME_ALL: 'AUTHORIZATION_ALL',
  AUTHORIZATION_NAME_VIEW: 'AUTHORIZATION_VIEW',
  AUTHORIZATION_NAME_UPDATE: 'AUTHORIZATION_UPDATE',
  AUTHORIZATION_NAME_DELETE: 'AUTHORIZATION_DELETE',
  AUTHORIZATION_NAME_PERMISSION: 'AUTHORIZATION_PERMISSION',
  AUTHORIZATION_CHANGE_PASSWORD: 'AUTHORIZATION_CHANGE_PASSWORD',
  SAVE_LOAD_SYSTEM_FILES: 'AUTHORIZATION_SAVE_LOAD_SYSTEM_FILES',
  LIVE_CHAT: 'AUTHORIZATION_LIVE_CHAT',
  CLEAR_ALL_CHAT_MESSAGES: 'AUTHORIZATION_CLEAR_ALL_CHAT_MESSAGES',
  AUTHORIZATION_CHECK_LOA_CHECKLIST_ITEM: 'AUTHORIZATION_CHECK_LOA_CHECKLIST_ITEM',
  VIEW_CONFIG_FORMS: 'AUTHORIZATION_CONFIGURATOR_FORMS_VIEW',
  SAVE_AS_NEW_CONFIG_FORMS: 'AUTHORIZATION_CONFIGURATOR_FORMS_SAVE_AS_NEW',
  VIEW_CONFIG_DATASETS: 'AUTHORIZATION_CONFIGURATOR_DATASETS_VIEW',
  MANAGE_DATASETS: 'AUTHORIZATION_MANAGE_DATASETS',
  VIEW_CONFIG_IMPORT_DATA: 'AUTHORIZATION_CONFIGURATOR_IMPORT_DATA_VIEW',
  MODIFY_CONFIG_IMPORT_DATA: 'AUTHORIZATION_CONFIGURATOR_IMPORT_DATA_MODIFY',
  VIEW_CONFIG_CLASSCODES: 'AUTHORIZATION_CONFIGURATOR_CLASSCODES_VIEW',
  MODIFY_CONFIG_CLASSCODES: 'AUTHORIZATION_CONFIGURATOR_CLASSCODES_MODIFY',
  VIEW_CONFIG_AMBEST_CARRIERS: 'AUTHORIZATION_CONFIGURATOR_AMBEST_CARRIERS_VIEW',
  MODIFY_CONFIG_AMBEST_CARRIERS: 'AUTHORIZATION_CONFIGURATOR_AMBEST_CARRIERS_MODIFY',
  VIEW_CONFIG_RULES: 'AUTHORIZATION_CONFIGURATOR_RULES_VIEW',
  MODIFY_CONFIG_RULES: 'AUTHORIZATION_CONFIGURATOR_RULES_MODIFY',
  VIEW_CONFIG_SCORING: 'AUTHORIZATION_CONFIGURATOR_SCORING_VIEW',
  MODIFY_CONFIG_SCORING: 'AUTHORIZATION_CONFIGURATOR_SCORING_MODIFY',
  VIEW_CONFIG_SYSTEM_ADMIN_USERS: 'AUTHORIZATION_CONFIGURATOR_SYSTEM_ADMIN_USERS_VIEW',
  MODIFY_CONFIG_SYSTEM_ADMIN_USERS: 'AUTHORIZATION_CONFIGURATOR_SYSTEM_ADMIN_USERS_MODIFY',
  VIEW_CONFIG_AGENCY_ADMIN_USERS: 'AUTHORIZATION_CONFIGURATOR_AGENCY_ADMIN_USERS_VIEW',
  MODIFY_CONFIG_AGENCY_ADMIN_USERS: 'AUTHORIZATION_CONFIGURATOR_AGENCY_ADMIN_USERS_MODIFY',
  VIEW_CONFIG_CARRIER_ADMIN_USERS: 'AUTHORIZATION_CONFIGURATOR_CARRIER_ADMIN_USERS_VIEW',
  MODIFY_CONFIG_CARRIER_ADMIN_USERS: 'AUTHORIZATION_CONFIGURATOR_CARRIER_ADMIN_USERS_MODIFY',
  VIEW_CONFIG_UNDERWRITERS: 'AUTHORIZATION_CONFIGURATOR_UNDERWRITERS_VIEW',
  VIEW_CONFIG_UNDERWRITER_LETTER_OF_AUTHORITY: 'AUTHORIZATION_CONFIGURATOR_UNDERWRITER_LETTER_OF_AUTHORITY_VIEW',
  MODIFY_CONFIG_UNDERWRITERS: 'AUTHORIZATION_CONFIGURATOR_UNDERWRITERS_MODIFY',
  MODIFY_CONFIG_UNDERWRITER_LETTER_OF_AUTHORITY: 'AUTHORIZATION_CONFIGURATOR_UNDERWRITER_LETTER_OF_AUTHORITY_MODIFY',
  VIEW_CONFIG_PRODUCERS: 'AUTHORIZATION_CONFIGURATOR_PRODUCERS_VIEW',
  MODIFY_CONFIG_PRODUCERS: 'AUTHORIZATION_CONFIGURATOR_PRODUCERS_MODIFY',
  VIEW_CONFIG_SERVICE_USERS: 'AUTHORIZATION_CONFIGURATOR_SERVICE_USERS_VIEW',
  MODIFY_CONFIG_SERVICE_USERS: 'AUTHORIZATION_CONFIGURATOR_SERVICE_USERS_MODIFY',
  VIEW_CONFIG_SYSTEM_ROLES: 'AUTHORIZATION_CONFIGURATOR_SYSTEM_ROLES_VIEW',
  MODIFY_CONFIG_SYSTEM_ROLES: 'AUTHORIZATION_CONFIGURATOR_SYSTEM_ROLES_MODIFY',
  VIEW_CONFIG_CARRIER_ROLES: 'AUTHORIZATION_CONFIGURATOR_CARRIER_ROLES_VIEW',
  MODIFY_CONFIG_CARRIER_ROLES: 'AUTHORIZATION_CONFIGURATOR_CARRIER_ROLES_MODIFY',
  VIEW_CONFIG_PRODUCER_ROLES: 'AUTHORIZATION_CONFIGURATOR_PRODUCER_ROLES_VIEW',
  MODIFY_CONFIG_PRODUCER_ROLES: 'AUTHORIZATION_CONFIGURATOR_PRODUCER_ROLES_MODIFY',
  VIEW_CONFIG_SERVICE_ROLES: 'AUTHORIZATION_CONFIGURATOR_SERVICE_ROLES_VIEW',
  MODIFY_CONFIG_SERVICE_ROLES: 'AUTHORIZATION_CONFIGURATOR_SERVICE_ROLES_MODIFY',
  VIEW_CONFIG_CARRIERS: 'AUTHORIZATION_CONFIGURATOR_CARRIER_ORG_VIEW',
  VIEW_CONFIG_CARRIERS_LETTER_OF_AUTHORITY: 'AUTHORIZATION_CONFIGURATOR_CARRIER_ORG_LETTER_OF_AUTHORITY_VIEW',
  MODIFY_CONFIG_CARRIERS: 'AUTHORIZATION_CONFIGURATOR_CARRIER_ORG_MODIFY',
  MODIFY_CONFIG_CARRIERS_LETTER_OF_AUTHORITY: 'AUTHORIZATION_CONFIGURATOR_CARRIER_ORG_LETTER_OF_AUTHORITY_MODIFY',
  VIEW_CONFIG_AGENCY_BROKERAGE: 'AUTHORIZATION_CONFIGURATOR_AGENCY_ORG_VIEW',
  VIEW_CONFIG_AGENCY_BROKERAGE_LETTER_OF_AUTHORITY: 'AUTHORIZATION_CONFIGURATOR_AGENCY_BROKERAGE_ORG_LETTER_OF_AUTHORITY_VIEW',
  MODIFY_CONFIG_AGENCY_BROKERAGE: 'AUTHORIZATION_CONFIGURATOR_AGENCY_ORG_MODIFY',
  MODIFY_CONFIG_AGENCY_BROKERAGE_LETTER_OF_AUTHORITY: 'AUTHORIZATION_CONFIGURATOR_AGENCY_BROKERAGE_ORG_LETTER_OF_AUTHORITY_MODIFY',
  VIEW_CONFIG_EMAIL: 'AUTHORIZATION_CONFIGURATOR_EMAIL_VIEW',
  MODIFY_CONFIG_EMAIL: 'AUTHORIZATION_CONFIGURATOR_EMAIL_MODIFY',
  MANAGE_POPUP_NOTIFICATIONS: 'AUTHORIZATION_CONFIGURATOR_MANAGE_POPUP_NOTIFICATIONS',
  VIEW_POPUP_NOTIFICATIONS: 'AUTHORIZATION_CONFIGURATOR_VIEW_POPUP_NOTIFICATIONS',
  MODIFY_CONFIG_BACKUP_RESTORE: 'AUTHORIZATION_CONFIGURATOR_BACKUP_RESTORE_MODIFY',
  VIEW_CONFIG_DETAILED_HISTORY: 'AUTHORIZATION_CONFIGURATOR_DETAILED_HISTORY_VIEW',
  VIEW_CONFIG_STATE_RATES: 'AUTHORIZATION_CONFIGURATOR_STATE_RATES_VIEW',
  MODIFY_CONFIG_STATE_RATES: 'AUTHORIZATION_CONFIGURATOR_STATE_RATES_MODIFY',
  VIEW_CONFIG_MGA_CARRIERS: 'AUTHORIZATION_CONFIGURATOR_MGA_CARRIER_ORG_VIEW',
  VIEW_CONFIG_MGA_CARRIERS_LETTER_OF_AUTHORITY: 'AUTHORIZATION_CONFIGURATOR_MGA_CARRIER_ORG_LETTER_OF_AUTHORITY_VIEW',
  MODIFY_CONFIG_MGA_CARRIERS: 'AUTHORIZATION_CONFIGURATOR_MGA_CARRIER_ORG_MODIFY',
  MODIFY_CONFIG_MGA_CARRIERS_LETTER_OF_AUTHORITY: 'AUTHORIZATION_CONFIGURATOR_MGA_CARRIER_ORG_LETTER_OF_AUTHORITY_MODIFY',
  VIEW_CONFIG_MGA_UNDERWRITERS: 'AUTHORIZATION_CONFIGURATOR_MGA_UNDERWRITERS_VIEW',
  VIEW_CONFIG_MGA_UNDERWRITER_LETTER_OF_AUTHORITY: 'AUTHORIZATION_CONFIGURATOR_MGA_UNDERWRITER_LETTER_OF_AUTHORITY_VIEW',
  MODIFY_CONFIG_MGA_UNDERWRITERS: 'AUTHORIZATION_CONFIGURATOR_MGA_UNDERWRITERS_MODIFY',
  MODIFY_CONFIG_MGA_UNDERWRITER_LETTER_OF_AUTHORITY: 'AUTHORIZATION_CONFIGURATOR_MGA_UNDERWRITER_LETTER_OF_AUTHORITY_MODIFY',
  VIEW_CONFIG_MGA_AGENCY_BROKERAGE: 'AUTHORIZATION_CONFIGURATOR_MGA_AGENCY_BROKERAGE_ORG_VIEW',
  VIEW_CONFIG_MGA_AGENCY_BROKERAGE_LETTER_OF_AUTHORITY: 'AUTHORIZATION_CONFIGURATOR_MGA_AGENCY_BROKERAGE_ORG_LETTER_OF_AUTHORITY_VIEW',
  MODIFY_CONFIG_MGA_AGENCY_BROKERAGE: 'AUTHORIZATION_CONFIGURATOR_MGA_AGENCY_BROKERAGE_ORG_MODIFY',
  MODIFY_CONFIG_MGA_AGENCY_BROKERAGE_LETTER_OF_AUTHORITY: 'AUTHORIZATION_CONFIGURATOR_MGA_AGENCY_BROKERAGE_ORG_LETTER_OF_AUTHORITY_MODIFY',
  VIEW_MODIFY_CONFIG_DEFAULT_PRODUCERS: 'AUTHORIZATION_CONFIGURATOR_VIEW_MANAGE_DEFAULT_PRODUCERS',
  VIEW_CONFIG_USER_LOGIN_TYPE: 'AUTHORIZATION_VIEW_USER_LOGIN_TYPE',
  MODIFY_CONFIG_USER_LOGIN_TYPE: 'AUTHORIZATION_MANAGE_USER_LOGIN_TYPE',
  MODIFY_CONFIG_USER_GROUPS: 'AUTHORIZATION_CONFIGURATOR_MANAGE_USER_GROUP',
  VIEW_CONFIG_COLUMNS: 'AUTHORIZATION_VIEW_BA_STUDIO_COLUMNS',
  MODIFY_CONFIG_COLUMNS: 'AUTHORIZATION_MANAGE_BA_STUDIO_COLUMNS',
  SUBMISSION_VIEW_AUDIT_TRAIL: 'AUTHORIZATION_SUBMISSION_VIEW_AUDIT_TRAIL',
  LOGIN_CONFIGURATOR: 'AUTHORIZATION_CONFIGURATOR',
  LOGIN_AGENT_WORKSPACE: 'AUTHORIZATION_AGENT_WORKSPACE',
  LOGIN_UNDERWRITER_WORKSTATION: 'AUTHORIZATION_UNDERWRITER_WORKSTATION',
  LOGIN_OPERATOR_CONSOLE: 'AUTHORIZATION_OPERATOR_CONSOLE',
  LOGIN_APPREADER: 'AUTHORIZATION_APPREADER',
  AUTHORIZATION_VIEW_SUBMISSION_APPLICATION: 'AUTHORIZATION_VIEW_SUBMISSION_APPLICATION',
  AUTHORIZATION_VIEW_SUBMISSION_REPORTS: 'AUTHORIZATION_VIEW_SUBMISSION_REPORTS',
  AUTHORIZATION_VIEW_SUBMISSION_PROPOSALS: 'AUTHORIZATION_VIEW_SUBMISSION_PROPOSALS',
  AUTHORIZATION_VIEW_SUBMISSION_WORKSHEETS: 'AUTHORIZATION_VIEW_SUBMISSION_WORKSHEETS',
  AUTHORIZATION_VIEW_SUBMISSION_PREDICTIVE_ANALYTICS: 'AUTHORIZATION_VIEW_SUBMISSION_PREDICTIVE_ANALYTICS',
  AUTHORIZATION_VIEW_SUBMISSION_POLICY: 'AUTHORIZATION_VIEW_SUBMISSION_POLICY',
  MANAGE_FORMS: 'AUTHORIZATION_MANAGE_FORMS',
  AUTHORIZATION_ADD_MODIFY_NOTES: 'AUTHORIZATION_ADD_MODIFY_NOTES',
  AUTHORIZATION_DELETE_NOTES: 'AUTHORIZATION_DELETE_NOTES',
  AUTHORIZATION_SHARE_UNSHARE_NOTES: 'AUTHORIZATION_SHARE_UNSHARE_NOTES',
  AUTHORIZATION_MODIFY_OTHER_USERS_NOTE_OPTIONS: 'AUTHORIZATION_MODIFY_OTHER_USERS_NOTE_OPTIONS',
  MANAGE_RULES: 'AUTHORIZATION_MANAGE_RULES',
  MANAGE_SYSTEM_CONFIGURATOR: 'AUTHORIZATION_MANAGE_SYSTEM_CONFIGURATOR',
  MANAGE_GENERAL_PREFERENCES: 'AUTHORIZATION_MANAGE_GENERAL_PREFERENCES',
  MANAGE_BA_STUDIO_PREFERENCES: 'AUTHORIZATION_MANAGE_BA_STUDIO_PREFERENCES',
  MANAGE_SECURTIY_MANAGEMENT: 'AUTHORIZATION_MANAGE_SECURTIY_MANAGEMENT',
  MANAGE_SYSTEM_URLS: 'AUTHORIZATION_MANAGE_SYSTEM_URLS',
  MANAGE_FILE_MANAGEMENT: 'AUTHORIZATION_MANAGE_FILE_MANAGEMENT',
  MANAGE_SETTING_MANAGER: 'AUTHORIZATION_MANAGE_SETTING_MANAGER',
  MANAGE_MESSAGE_CENTER: 'AUTHORIZATION_MANAGE_MESSAGE_CENTER',
  MANAGE_USER_CENTER: 'AUTHORIZATION_MANAGE_USER_CENTER',
  VIEW_GENERAL_PREFERENCES: 'AUTHORIZATION_VIEW_GENERAL_PREFERENCES',
  VIEW_BA_STUDIO_PREFERENCES: 'AUTHORIZATION_VIEW_BA_STUDIO_PREFERENCES',
  VIEW_SECURTIY_MANAGEMENT: 'AUTHORIZATION_VIEW_SECURTIY_MANAGEMENT',
  VIEW_SYSTEM_URLS: 'AUTHORIZATION_VIEW_SYSTEM_URLS',
  VIEW_FILE_MANAGEMENT: 'AUTHORIZATION_VIEW_FILE_MANAGEMENT',
  VIEW_SETTING_MANAGER: 'AUTHORIZATION_VIEW_SETTING_MANAGER',
  VIEW_MESSAGE_CENTER: 'AUTHORIZATION_VIEW_MESSAGE_CENTER',
  VIEW_USER_CENTER: 'AUTHORIZATION_VIEW_USER_CENTER',
  VIEW_DETAIL_HISTORY: 'AUTHORIZATION_VIEW_DETAIL_HISTORY',
  VIEW_WELCOME_LOGIN_MESSAGE: 'AUTHORIZATION_VIEW_WELCOME_LOGIN_MESSAGE',
  MANAGE_WELCOME_LOGIN_MESSAGE: 'AUTHORIZATION_MANAGE_WELCOME_LOGIN_MESSAGE',
  MANAGE_BACKUP_RESTORE_CENTER: 'AUTHORIZATION_MANAGE_BACKUP_RESTORE_CENTER',
  MANAGE_CUSTOM_FILES_AND_ICONS: 'AUTHORIZATION_MANAGE_CUSTOM_FILES_AND_ICONS',
  VIEW_CUSTOM_FILES_AND_ICONS: 'AUTHORIZATION_VIEW_CUSTOM_FILES_AND_ICONS',
  AUTHORIZATION_GENERATE_DATA_DICTIONARY: 'AUTHORIZATION_GENERATE_DATA_DICTIONARY',
  POLICY_SUBMIT_ISSUANCE: 'AUTHORIZATION_SUBMIT_ISSUANCE',
  POLICY_MARK_ISSUED: 'AUTHORIZATION_MARK_ISSUED',
  POLICY_REVERSE_ISSUANCE: 'AUTHORIZATION_REVERT_ISSUANCE',
  POLICY_CANCEL: 'AUTHORIZATION_POLICY_CANCEL',
  AUTHORIZATION_POLICY_REVERT_TO_CANCELLATION_PENDING: 'AUTHORIZATION_POLICY_REVERT_TO_CANCELLATION_PENDING',
  POLICY_SUBMIT_CANCELLATION: 'AUTHORIZATION_POLICY_SUBMIT_CANCELLATION',
  POLICY_REWRITE_AFTER_CANCELLATION: 'AUTHORIZATION_POLICY_REWRITE_AFTER_CANCELLATION',
  POLICY_REQUEST_CANCELLATION: 'AUTHORIZATION_POLICY_REQUEST_CANCELLATION',
  POLICY_RETRACT_CANCELLATION_REQUEST: 'AUTHORIZATION_POLICY_RETRACT_CANCELLATION_REQUEST',
  POLICY_REINSTATE: 'AUTHORIZATION_POLICY_REINSTATE',
  POLICY_RESCIND_CANCELLATION: 'AUTHORIZATION_RESCIND_CANCELLATION',
  POLICY_VIEW_REWRITE: 'AUTHORIZATION_POLICY_VIEW_REWRITE',
  PREQUALIFY_SUBMISSION: 'AUTHORIZATION_PREQUALIFY_SUBMISSION',
  QUOTE_INITIATE_NEW_PROPOSAL_AND_GET_RATE: 'AUTHORIZATION_QUOTE_INITIATE_NEW_PROPOSAL_AND_GET_RATE',
  QUOTE_GENERATE_MODIFY_PROPOSAL: 'AUTHORIZATION_QUOTE_GENERATE_MODIFY_PROPOSAL',
  QUOTE_SEND_TO_AGENT: 'AUTHORIZATION_QUOTE_SEND_TO_AGENT',
  QUOTE_WITHDRAW_QUOTE: 'AUTHORIZATION_QUOTE_WITHDRAW_QUOTE',
  QUOTE_REMOVE_MANDATORY_POLICY_FORMS: 'AUTHORIZATION_QUOTE_REMOVE_MANDATORY_POLICY_FORMS',
  QUOTE_GENERATE_RATING_ATTACHMENT: 'AUTHORIZATION_QUOTE_GENERATE_RATING_ATTACHMENT',
  CONFIRM_BINDING: 'AUTHORIZATION_CONFIRM_BINDING',
  UNBIND_COVERAGE: 'AUTHORIZATION_UNBIND_COVERAGE',
  REQUEST_BINDING: 'AUTHORIZATION_REQUEST_BINDING',
  DECLINE_BINDING: 'AUTHORIZATION_DECLINE_BINDING',
  WITHDRAW_BIND_REQUEST: 'AUTHORIZATION_WITHDRAW_BIND_REQUEST',
  REFERRAL_CLEAR_AND_DECLINE_REFERRAL: 'AUTHORIZATION_REFERRAL_CLEAR_AND_DECLINE',
  REFERRAL_RETRACT_AND_REFER_SUBMISSION: 'AUTHORIZATION_RETRACT_REFERRAL_AND_REFER_SUBMISSION',
  REPORTS_OBTAIN_INTERNAL_AND_EXTERNAL: 'AUTHORIZATION_REPORTS_OBTAIN_INTERNAL_AND_EXTERNAL',
  REPORTS_CREATE: 'AUTHORIZATION_REPORTS_CREATE',
  REPORTS_DELETE: 'AUTHORIZATION_REPORTS_DELETE',
  ASSIGN_ACCOUNT: 'AUTHORIZATION_SUBMISSION_ASSIGN_ACCOUNT',
  VIEW_ACCOUNT_OVERVIEW: 'AUTHORIZATION_ACCOUNT_VIEW_ACCOUNT_OVERVIEW',
  MODIFY_ACCOUNT_OVERVIEW: 'AUTHORIZATION_ACCOUNT_MODIFY_ACCOUNT_OVERVIEW',
  SUBMISSION_CREATE: 'AUTHORIZATION_SUBMISSION_CREATE',
  SUBMISSION_DELETE_DRAFT: 'AUTHORIZATION_SUBMISSION_DELETE_DRAFT',
  SUBMISSION_SUBMIT_FULL_OR_TO_RESERVE_MARKET: 'AUTHORIZATION_SUBMISSION_SUBMIT_FULL_OR_TO_RESERVE_MARKET',
  SUBMISSION_DECLINE: 'AUTHORIZATION_SUBMISSION_DECLINE',
  REACTIVATE_SUBMISSION: 'AUTHORIZATION_REACTIVATE_SUBMISSION',
  COPY_SUBMISSION: 'AUTHORIZATION_COPY_SUBMISSION',
  SPLIT_SUBMISSION: 'AUTHORIZATION_SUBMISSION_SPLIT_SUBMISSION',
  SUBMISSION_REJECT: 'AUTHORIZATION_SUBMISSION_REJECT',
  CHANGE_STATUS_TO_LOST: 'AUTHORIZATION_CHANGE_STATUS_TO_LOST',
  SUBMIT_RENEWAL: 'AUTHORIZATION_SUBMIT_RENEWAL',
  MARK_RENEWED: 'AUTHORIZATION_MARK_RENEWED',
  MARK_EXPIRED: 'AUTHORIZATION_MARK_EXPIRED',
  SUBMIT_NON_RENEWAL: 'AUTHORIZATION_SUBMIT_NON_RENEWAL',
  MARK_NON_RENEWED: 'AUTHORIZATION_MARK_NON_RENEWED',
  RETRACT_NON_RENEWAL: 'AUTHORIZATION_RETRACT_NON_RENEWAL',
  SUBMISSION_REVISE: 'AUTHORIZATION_SUBMISSION_REVISE',
  SUBMISSION_ACKNOWLEDGE_CHANGES_BY_AGENT: 'AUTHORIZATION_SUBMISSION_ACKNOWLEDGE_CHANGES_BY_AGENT',
  SUBMISSION_MODIFY_BOUND: 'AUTHORIZATION_SUBMISSION_MODIFY_BOUND',
  SUBMISSION_MODIFY_PRODUCER_DRAFT: 'AUTHORIZATION_SUBMISSION_MODIFY_PRODUCER_DRAFT',
  SUBMISSION_MODIFY_AND_DELETE_CARRIER_DRAFT: 'AUTHORIZATION_SUBMISSION_MODIFY_AND_DELETE_CARRIER_DRAFT',
  SUBMISSION_MODIFY_APPLICATION: 'AUTHORIZATION_SUBMISSION_MODIFY_APPLICATION',
  SUBMISSION_MODIFY_WORKSHEETS: 'AUTHORIZATION_SUBMISSION_MODIFY_WORKSHEETS',
  SUBMISSION_UPDATE_STATUS_REASON: 'AUTHORIZATION_SUBMISSION_UPDATE_STATUS_REASON',
  SUBMISSION_SET_PRODUCTS: 'AUTHORIZATION_SUBMISSION_SET_PRODUCTS',
  SUBMISSION_UPDATE: 'AUTHORIZATION_SUBMISSION_UPDATE',
  SUBMISSION_BULK_ASSIGN_SUBMISSION_PARTICIPANTS: 'AUTHORIZATION_SUBMISSION_BULK_ASSIGN_SUBMISSION_PARTICIPANTS',
  SUBMISSION_TASK_BULK_UPDATE: 'AUTHORIZATION_SUBMISSION_TASK_BULK_UPDATE',
  TASK_ADD_MODIFY: 'AUTHORIZATION_TASK_ADD_MODIFY',
  TASK_DELETE: 'AUTHORIZATION_TASK_DELETE',
  SUBMISSION_ASSIGN: 'AUTHORIZATION_SUBMISSION_ASSIGN',
  PERFORM_CLEARANCE: 'AUTHORIZATION_PERFORM_CLEARANCE',
  CHECK_CLEARANCE: 'AUTHORIZATION_CHECK_CLEARANCE',
  MARK_CLEAR_READY: 'AUTHORIZATION_MARK_READY_TO_UNDERWRITE_OR_REVERT_TO_CLEAR',
  MODIFY_AUTOMATION_STATUS: 'AUTHORIZATION_MODIFY_AUTOMATION_STATUS',
  REEVALUATE_SUBMISSION: 'AUTHORIZATION_REEVALUATE_SUBMISSION',
  ATTACHMENTS_DELETE_NONDELETABLE: 'AUTHORIZATION_ATTACHMENTS_DELETE_NONDELETABLE',
  ENDORSEMENT_CREATE: 'AUTHORIZATION_ENDORSEMENT_CREATE',
  ENDORSEMENT_SUBMIT: 'AUTHORIZATION_ENDORSEMENT_SUBMIT',
  ENDORSEMENT_REVERT_TO_SUBMITTED: 'AUTHORIZATION_ENDORSEMENT_REVERT_TO_SUBMITTED',
  ENDORSEMENT_SUBMIT_FOR_ISSUANCE: 'AUTHORIZATION_ENDORSEMENT_SUBMIT_FOR_ISSUANCE',
  ENDORSEMENT_MARK_AS_ISSUED: 'AUTHORIZATION_ENDORSEMENT_MARK_AS_ISSUED',
  ENDORSEMENT_REVERT_TO_PENDING_ISSUANCE: 'AUTHORIZATION_ENDORSEMENT_REVERT_TO_PENDING_ISSUANCE',
  ENDORSEMENT_APPROVE_OR_DECLINE: 'AUTHORIZATION_ENDORSEMENT_APPROVE_OR_DECLINE',
  ENDORSEMENT_REOPEN: 'AUTHORIZATION_ENDORSEMENT_REOPEN',
  ENDORSEMENT_DELETE: 'AUTHORIZATION_ENDORSEMENT_DELETE',
  ENDORSEMENT_MODIFY_APPLICATION: 'AUTHORIZATION_ENDORSEMENT_MODIFY_APPLICATION',
  CROSS_SELL_UP_SELL: 'AUTHORIZATION_CROSS_SELL_UP_SELL',
  LOB_ADD_TO_SUBMISSION: 'AUTHORIZATION_ADD_LOB_TO_SUBMISSION',
  LOB_CHANGE: 'AUTHORIZATION_CHANGE_LOB',
  POST_BINDING_NOTIFICATION: 'AUTHORIZATION_POST_BINDING_NOTIFICATION',
  PREQUOTE_RISK: 'AUTHORIZATION_PREQUOTE_RISK',
  QUOTE_VIEW_APPLICATION_STATE: 'AUTHORIZATION_QUOTE_VIEW_APPLICATION_STATE',
  REINSURANCE_BIND_COVERAGE: 'AUTHORIZATION_REINSURANCE_BIND_COVERAGE',
  REINSURANCE_REQUEST_QUOTE: 'AUTHORIZATION_REINSURANCE_REQUEST_QUOTE',
  RENEWAL_BIND: 'AUTHORIZATION_RENEWAL_BIND',
  RENEWAL_ISSUE_QUOTE: 'AUTHORIZATION_RENEWAL_ISSUE_QUOTE',
  SUBMISSION_UPGRADE: 'AUTHORIZATION_SUBMISSION_UPGRADE',
  SYSTEM_STATE_RESTART_AND_STOP: 'AUTHORIZATION_SYSTEM_STATE_RESTART_AND_STOP',
  SUBMISSION_RESUBMIT: 'AUTHORIZATION_SUBMISSION_RESUBMIT',
  AUTHORIZATION_ADVANCED_FILTER: 'AUTHORIZATION_ADVANCED_FILTER',
  VIEW_PRIVATE_ATTACHMENTS: 'AUTHORIZATION_VIEW_PRIVATE_ATTACHMENTS',
  VIEW_PRIVATE_NOTES: 'AUTHORIZATION_VIEW_PRIVATE_NOTES',
  ACCOUNT_MODIFY_WORKSHEETS: 'AUTHORIZATION_ACCOUNT_MODIFY_WORKSHEETS',
  AUTHORIZATION_ADD_ATTACHMENTS: 'AUTHORIZATION_ADD_ATTACHMENTS',
  AUTHORIZATION_DELETE_ATTACHMENTS: 'AUTHORIZATION_DELETE_ATTACHMENTS',
  AUTHORIZATION_MODIFY_ATTACHMENTS: 'AUTHORIZATION_MODIFY_ATTACHMENTS',
  AUTHORIZATION_SHARE_ATTACHMENTS: 'AUTHORIZATION_SHARE_ATTACHMENTS',
  MANAGE_CONFIG_SECTION_TEMPLATES: 'AUTHORIZATION_CONFIGURATOR_SECTION_TEMPLATES_MANAGE',
  VIEW_CONFIG_SECTION_TEMPLATES: 'AUTHORIZATION_CONFIGURATOR_SECTION_TEMPLATES_VIEW',
  SEND_EMAIL: 'AUTHORIZATION_EMAIL_SEND_EMAIL',
  AUTHORIZATION_EMAIL_DELETE_EMAIL: 'AUTHORIZATION_EMAIL_DELETE_EMAIL',
  AUTHORIZATION_EMAIL_VIEW_PRIVATE_EMAIL: 'AUTHORIZATION_EMAIL_VIEW_PRIVATE_EMAIL',
  AUTHORIZATION_CONFIGURATOR_MANAGE_PRODUCT_TEMPLATES: 'AUTHORIZATION_CONFIGURATOR_MANAGE_PRODUCT_TEMPLATES',
  AUTHORIZATION_CONFIGURATOR_VIEW_PRODUCT_TEMPLATES: 'AUTHORIZATION_CONFIGURATOR_VIEW_PRODUCT_TEMPLATES',
  AUTHORIZATION_CANCEL_POLICY_BEYOND_NOTIFICATION_PERIOD: 'AUTHORIZATION_CANCEL_POLICY_BEYOND_NOTIFICATION_PERIOD',
  AUTHORIZATION_HIDE_SHARED_EMAIL: 'AUTHORIZATION_HIDE_SHARED_EMAIL',
  AUTHORIZATION_OUTLOOK_CREATE_SUBMISSIONS: 'AUTHORIZATION_OUTLOOK_CREATE_SUBMISSIONS',
  AUTHORIZATION_QUOTE_VIEW_UNBOUND_QUOTES: 'AUTHORIZATION_QUOTE_VIEW_UNBOUND_QUOTES',
  AUTHORIZATION_QUOTE_VIEW_RATING_ATTACHMENTS: 'AUTHORIZATION_QUOTE_VIEW_RATING_ATTACHMENTS',
  AUTHORIZATION_QUOTE_VIEW_INPUT_FORMS: 'AUTHORIZATION_QUOTE_VIEW_INPUT_FORMS'
};
angular.module('gw-um-j2js').constant('authorizationConstants', authorizationConstants);

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

var authorizationStatus = {
  INACTIVE: 0,
  ACTIVE: 1
};
angular.module('gw-um-j2js').constant('authorizationStatus', authorizationStatus);

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

var permissionAction = {
  BACKUP: 'backup',
  DISCARD: 'discard',
  SAVE: 'save'
};
angular.module('gw-um-j2js').constant('permissionAction', permissionAction);

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

var checkListItemSourceType = {
  SYSTEM_RULE: 'SystemRule',
  USER_RULE: 'UserRule',
  USER: 'User'
};
angular.module('gw-um-j2js').constant('checkListItemSourceType', checkListItemSourceType);

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

var checkListItemSubType = {
  NONE: -1,
  UNDERWRITING_AUTHORITY: 1,
  UNDERWRITING_AUTHORITY_APPROVED: 2
};
angular.module('gw-um-j2js').constant('checkListItemSubType', checkListItemSubType);

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

var checkListItemType = {
  USER: 0,
  REQUIRED: 1,
  SUGGESTED_ACTIVE: 2,
  SUGGESTED_INACTIVE: 3
};
angular.module('gw-um-j2js').constant('checkListItemType', checkListItemType);

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

var configuredFileAction = {
  SAVE: 'save',
  DISCARD: 'discard',
  BACKUP: 'backup'
};
angular.module('gw-um-j2js').constant('configuredFileAction', configuredFileAction);

/***/ }),
/* 1555 */
/***/ (function(module, exports) {

var copyrightLicenseType = {
  AGENCY: 1,
  CARRIER: 2
};
angular.module('gw-um-j2js').constant('copyrightLicenseType', copyrightLicenseType);

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

var dataSetAction = {
  NEW_DATA_SET: 'new data set',
  EXPORT: 'export',
  BACKUP: 'backup',
  SAVE: 'save',
  DISCARD_CHANGES: 'discard changes',
  DATA_SET_SETTINGS: 'data set settings',
  VIEW_REFERENCES: 'view references',
  DELETE: 'delete'
};
angular.module('gw-um-j2js').constant('dataSetAction', dataSetAction);

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

var dataSetType = {
  STATIC: 0,
  CUSTOM: 1,
  PRODUCT_FIELD_DEPENDENT: 2,
  REPEATING_FORM: 3,
  STATIC_STRING: 'Static',
  CUSTOM_STRING: 'Custom',
  PRODUCT_FIELD_DEPENDENT_STRING: 'Product/Field Dependent',
  REPEATING_FORM_STRING: 'Repeating Form'
};
angular.module('gw-um-j2js').constant('dataSetType', dataSetType);

/***/ }),
/* 1558 */
/***/ (function(module, exports) {

var mimeType = {
  PDF: 'application/pdf',
  SWF: 'application/x-shockwave-flash'
};
angular.module('gw-um-j2js').constant('mimeType', mimeType);

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

var clientType = {
  FLASH_AIR: 'FLASH_AIR',
  FLASH_WEB: 'FLASH_WEB',
  IPAD_UW: 'IPAD_UW',
  OUTLOOK_PLUGIN: 'OUTLOOK_PLUGIN',
  UM_STUDIO: 'UM_STUDIO',
  UM_HTML_UW: 'UM_HTML_UW',
  UM_HTML_AGENT: 'UM_HTML_AGENT',
  APP_READER: 'APP_READER',
  OPERATOR: 'OPERATOR'
};
angular.module('gw-um-j2js').constant('clientType', clientType);

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

var logoType = {
  LOGO: 0,
  LETTERHEAD: 1,
  AUTOMATION_ICON: 2,
  CUSTOM_ICON: 3,
  POWERED_BY_LOGO: 4,
  CARRIER_LOGO: 5,
  LOGO_HTML_LOGIN: 6,
  LOGO_HTML_UNDERWRITER_HEADER: 7,
  LOGO_HTML_AGENT_HEADER: 8
};
angular.module('gw-um-j2js').constant('logoType', logoType);

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

var emailMessage = {
  EMAIL_ADDRESS_SEPERATOR: ';'
};
angular.module('gw-um-j2js').constant('emailMessage', emailMessage);

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

var emailMessageOriginator = {
  EMAIL_RECEIVER: 'EMR',
  UPLOAD: 'UPLOAD',
  SEND: 'SEND'
};
angular.module('gw-um-j2js').constant('emailMessageOriginator', emailMessageOriginator);

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

var emailMessageStatus = {
  STATUS_PENDING: 0,
  STATUS_SENT: 1,
  STATUS_FAILED: 2,
  STATUS_DRAFT: 3
};
angular.module('gw-um-j2js').constant('emailMessageStatus', emailMessageStatus);

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

var emailNotificationOption = {
  STANDARD: 'STANDARD',
  CUSTOM: 'CUSTOM',
  NONE: 'NONE'
};
angular.module('gw-um-j2js').constant('emailNotificationOption', emailNotificationOption);

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

var organizationStatus = {
  STATUS_ALL: -1,
  STATUS_INACTIVE: 0,
  STATUS_ACTIVE: 1,
  STATUS_HIDDEN: 0,
  STATUS_DRAFT: 2
};
angular.module('gw-um-j2js').constant('organizationStatus', organizationStatus);

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

var organizationSubType = {
  AGENCY_BRANCH: 1,
  CARRIER_BRANCH: 2,
  MGA_CARRIER_BRANCH: 3,
  MGA_AGENCY_BRANCH: 4
};
angular.module('gw-um-j2js').constant('organizationSubType', organizationSubType);

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

var organizationType = {
  AGENCY: 1,
  CARRIER: 2,
  MGA_CARRIER: 3,
  MGA_AGENCY: 4,
  AGENCY_STRING: 'agency',
  CARRIER_STRING: 'carrier',
  MGA_CARRIER_STRING: 'mgaCarrier',
  MGA_AGENCY_STRING: 'mgaAgency'
};
angular.module('gw-um-j2js').constant('organizationType', organizationType);

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

var organizationAction = {
  NEW_ORGANIZATION: 'new organization',
  NEW_CARRIER_ORGANIZATION: 'new carrier organization',
  NEW_AGENCY_ORGANIZATION: 'new agency organization',
  NEW_MGA_AGENCY_ORGANIZATION: 'new mga agency organization',
  NEW_MGA_CARRIER_ORGANIZATION: 'new mga carrier organization',
  IMPORT_CARRIER_LOAS: 'importCarrierLOAs',
  EXPORT_CARRIER_LOAS: 'exportCarrierLOAs',
  IMPORT_MGA_CARRIER_LOAS: 'importMgaCarrierLOAs',
  EXPORT_MGA_CARRIER_LOAS: 'exportMgaCarrierLOAs',
  BACKUP: 'backup',
  ACTIVATE: 'activate',
  DEACTIVATE: 'deactivate',
  EDIT: 'startChanges',
  SAVE_CHANGES: 'applyChanges',
  CANCEL_EDIT: 'discardChanges',
  CANCEL: 'cancel',
  EDIT_EMAIL_SIGNATURE: 'editEmailSignature'
};
angular.module('gw-um-j2js').constant('organizationAction', organizationAction);

/***/ }),
/* 1569 */
/***/ (function(module, exports) {

var databaseDownloadSectionName = {
  DATA_SETS: 'Data Sets',
  FORM_TEMPLATES: 'Form Templates',
  RULE_SETS: 'Rule Sets',
  ASSIGNED_AUTHORIZATIONS: 'Assigned Authorizations',
  PRODUCT_TEMPLATES: 'Product Templates',
  ORGANIZATIONS: 'Organizations',
  SECTION_TEMPLATES: 'Section Templates',
  NOTIFICATION_EMAIL_TEMPLATES: 'Notification Email Templates',
  NOTIFICATION_POPUP_TEMPLATES: 'Notification Popup Templates',
  DEFAULT_PREFERENCES: 'Default Preferences',
  SCORING: 'Scoring',
  STATE_RATES: 'State Rates',
  GRID_DEFINTIONS: 'Grid Definitions',
  FILES_AND_ICONS: 'Files & Icons'
};
angular.module('gw-um-j2js').constant('databaseDownloadSectionName', databaseDownloadSectionName);

/***/ }),
/* 1570 */
/***/ (function(module, exports) {

var reminderStatus = {
  INCOMPLETE: 0,
  COMPLETE: 1,
  PASTDUE: 2
};
angular.module('gw-um-j2js').constant('reminderStatus', reminderStatus);

/***/ }),
/* 1571 */
/***/ (function(module, exports) {

var displayType = {
  DISPLAY_TYPE_DIAL: 'DIAL',
  DISPLAY_TYPE_BAR_CHART: 'BAR_CHART',
  DISPLAY_TYPE_LINE_CHART: 'LINE_CHART',
  DISPLAY_TYPE_PIE_CHART: 'PIE_CHART'
};
angular.module('gw-um-j2js').constant('displayType', displayType);

/***/ }),
/* 1572 */
/***/ (function(module, exports) {

var roleType = {
  ROLE_TYPE_SUBMISSION: 0,
  ROLE_TYPE_SYSTEM_ADMIN: 1,
  ROLE_TYPE_CARRIER: 2,
  ROLE_TYPE_AGENT: 3,
  ROLE_TYPE_SERVICE: 4,
  ROLE_TYPE_AGENCY_ADMIN: 5,
  ROLE_TYPE_CARRIER_ADMIN: 6,
  ROLE_TYPE_CARRIER_MGA: 7,
  ROLE_TYPE_TASK_USER: 8
};
angular.module('gw-um-j2js').constant('roleType', roleType);

/***/ }),
/* 1573 */
/***/ (function(module, exports) {

var ruleAction = {
  NEW_RULE: 'new rule',
  REDEPLOY: 'redeploy',
  SAVE: 'save',
  DISCARD: 'discard',
  ACTIVATE: 'activate',
  DEACTIVATE: 'deactivate',
  RULE_SETTINGS: 'rule settings',
  DELETE: 'delete',
  REVIEW: 'review',
  BACKUP: 'backup'
};
angular.module('gw-um-j2js').constant('ruleAction', ruleAction);

/***/ }),
/* 1574 */
/***/ (function(module, exports) {

var ruleConditionType = {
  BINARY: 'binary',
  BINDING: 'binding',
  COMPOSITE: 'composite',
  RAW: 'raw',
  UNARY: 'unary'
};
angular.module('gw-um-j2js').constant('ruleConditionType', ruleConditionType);

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

var ruleEntryStatus = {
  STATUS_INACTIVE: 0,
  STATUS_ACTIVE: 1,
  STATUS_INVALID: 2,
  STATUS_DEBUG: 4
};
angular.module('gw-um-j2js').constant('ruleEntryStatus', ruleEntryStatus);

/***/ }),
/* 1576 */
/***/ (function(module, exports) {

var ruleFlag = {
  NON_DELETABLE: 1,
  NON_RENAMEABLE: 2
};
angular.module('gw-um-j2js').constant('ruleFlag', ruleFlag);

/***/ }),
/* 1577 */
/***/ (function(module, exports) {

var type = {
  TYPE_NAME_STRING: 'String',
  TYPE_NAME_BOOLEAN: 'Boolean',
  TYPE_NAME_INTEGER: 'Integer',
  TYPE_NAME_DOUBLE: 'Double',
  TYPE_NAME_FLOAT: 'Float',
  TYPE_NAME_DATE: 'Date',
  TYPE_NAME_CLASS_CODE: 'CLASS_CODE',
  TYPE_NAME_USER: 'USER',
  TYPE_NAME_IDENTIFIER: 'IDENTIFIER',
  TYPE_NAME_DATA_SET: 'DATA_SET'
};
angular.module('gw-um-j2js').constant('type', type);

/***/ }),
/* 1578 */
/***/ (function(module, exports) {

var accountAction = {
  APPLY_CHANGES: 'apply changes',
  CREATE_ACCOUNT_PROPOSAL: 'create account proposal',
  CREATE_SUBMISSION: 'create submission',
  DELETE_ACCOUNT: 'delete account',
  DISCARD_CHANGES: 'discard changes',
  MERGE_ACCOUNTS: 'merge accounts',
  MODIFY_ACCOUNT: 'modify account'
};
angular.module('gw-um-j2js').constant('accountAction', accountAction);

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

var attachmentType = {
  BINDER: 'Binder',
  BINDER_COVER_LETTER: 'Binder Cover Letter',
  CORRESPONDENCE: 'Correspondence',
  COVER_LETTER: 'Cover Letter',
  ENDORSEMENT: 'Endorsement',
  GENERATED_SECTION: 'Generated Section',
  ISSUANCE: 'Issuance',
  POLICY: 'Policy',
  PROPOSAL: 'Proposal',
  QUOTE: 'Quote',
  STATIC_SECTION: 'Static Section',
  NOTICE_OF_CANCELLATION: 'Notice of Cancellation'
};
angular.module('gw-um-j2js').constant('attachmentType', attachmentType);

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

var customButtonFunctionType = {
  ADD_FORM: 'addForm',
  CLOSE_FORM: 'closeForm',
  EXPORT_FORM: 'exportForm',
  IMPORT_FORM: 'importForm',
  INSIGHT_URL: 'insightUrl',
  REMOTE_FUNCTION: 'remoteFunction',
  URL: 'url'
};
angular.module('gw-um-j2js').constant('customButtonFunctionType', customButtonFunctionType);

/***/ }),
/* 1581 */
/***/ (function(module, exports) {

var customButtonType = {
  CUSTOM_ALERT: 'customAlert',
  ENDORSEMENT_BUTTON_TYPE: 'endorsement',
  POLICY_ISSUANCE_BUTTON_TYPE: 'issuance',
  POLICY_REWRITE_BUTTON_TYPE: 'rewrite',
  QUOTE_BUTTON_TYPE: 'quote',
  SUBMISSION_OVERVIEW_BUTTON_TYPE: 'overview'
};
angular.module('gw-um-j2js').constant('customButtonType', customButtonType);

/***/ }),
/* 1582 */
/***/ (function(module, exports) {

var externalReportAction = {
  DELETE_REPORT: 'delete report',
  EDIT_REPORT: 'edit report',
  GENERATE_REPORT: 'generate report'
};
angular.module('gw-um-j2js').constant('externalReportAction', externalReportAction);

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

var filterCriterionDataType = {
  TYPE_TEXT: 1,
  TYPE_NUMBER: 2,
  TYPE_BOOLEAN: 3,
  TYPE_NUMBER_RANGE: 5,
  TYPE_DATE_RANGE: 6,
  TYPE_DATA_SET: 11,
  TYPE_USER_SELECT: 12
};
angular.module('gw-um-j2js').constant('filterCriterionDataType', filterCriterionDataType);

/***/ }),
/* 1584 */
/***/ (function(module, exports) {

var filterCriterionUiType = {
  UI_TYPE_NOT_APPLICABLE: 0,
  UI_TYPE_TEXT_INPUT: 1,
  UI_TYPE_SINGLE_SELECT: 2,
  UI_TYPE_MULTI_SELECT: 3,
  UI_TYPE_RADIO_BUTTON: 4,
  UI_TYPE_CHECKBOX: 5,
  UI_TYPE_YES_NO: 6,
  UI_TYPE_ONE_SELECTION: 7,
  UI_DATE_RANGE: 8,
  UI_TYPE_AHEAD: 9,
  UI_BREAKER: 10,
  UI_DATE_RANGE_LOCAL_TIMEZONE: 11
};
angular.module('gw-um-j2js').constant('filterCriterionUiType', filterCriterionUiType);

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

var filterType = {
  TYPE_SUBMISSION_FILTER: 1,
  TYPE_ACCOUNT_FILTER: 2,
  TYPE_TASK_FILTER: 3,
  TYPE_FORMTEMPLATE_FILTER: 4,
  TYPE_ACTIVITY_FILTER: 5,
  TYPE_DATASET_FILTER: 6,
  TYPE_RULE_FILTER: 7,
  TYPE_PRODUCT_TEMPLATE_FILTER: 8,
  TYPE_ORGANIZATION_FILTER: 9
};
angular.module('gw-um-j2js').constant('filterType', filterType);

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

var editableFieldLevel = {
  NOT_EDITABLE: -1,
  ALWAYS_EDITABLE: 0,
  EDITABLE_THRU_CREATE_APPLICATION: 5,
  EDITABLE_THRU_CREATE_ENDORSEMENT: 5,
  EDITABLE_THRU_CREATE_REWRITE: 5,
  EDITABLE_THRU_SUBMIT: 10,
  EDITABLE_THRU_RATING: 15,
  EDITABLE_THRU_PRICING: 20,
  EDITABLE_THRU_QUOTING: 25,
  EDITABLE_THRU_BINDING: 30,
  EDITABLE_THRU_ISSUANCE: 35,
  EDITABLE_THRU_POST_ISSUANCE: 100,
  EDITABLE_THRU_REQUEST_CANCELLATION: 100,
  EDITABLE_THRU_SUBMIT_CANCELLATION: 101,
  EDITABLE_THRU_CANCELLATION: 102,
  EDITABLE_THRU_POST_CANCELLATION: 200,
  EDITABLE_THRU_REPORT_GENERATE: 305,
  EDITABLE_THRU_REPORT_POST_GENERATE: 310
};
angular.module('gw-um-j2js').constant('editableFieldLevel', editableFieldLevel);

/***/ }),
/* 1587 */
/***/ (function(module, exports) {

var fieldType = {
  TEXT_INPUT: 0,
  TEXT_AREA: 1,
  YES_NO: 2,
  DROP_DOWN: 3,
  RADIO_GROUP: 4,
  CHECK_BOX: 5,
  CHECK_BOX_GROUP: 6,
  CALENDAR: 7,
  BUTTON: 8,
  LABEL: 9,
  ROWREPEATER: 10,
  SECTIONREPEATER: 11,
  CLASSCODEFINDER: 12,
  RADIO_BUTTON_GROUP: 13,
  SPACER: 14,
  SAME_FIELDS_COPIER: 15,
  HEAT_MAP: 16,
  FUNCTION_BUTTON: 17,
  LIST: 18,
  AMBEST_CARRIERPICKER: 19,
  LINK_BUTTON: 20,
  UPLOAD_ATTACHMENT_BUTTON: 21,
  HTML_GRID: 22,
  POPUP_LIST: 23,
  FORM_SUMMARY_GRID: 24,
  MULTI_SELECT: 25
};
angular.module('gw-um-j2js').constant('fieldType', fieldType);

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

var formTemplateReference = {
  FIELD_EXPRESSION: 1,
  LINKED_FIELD: 2,
  RULE: 3,
  SCORING_RULE: 4,
  SUPPLEMENTAL_FORM: 5,
  DYNAMIC_DATA_SET: 6
};
angular.module('gw-um-j2js').constant('formTemplateReference', formTemplateReference);

/***/ }),
/* 1589 */
/***/ (function(module, exports) {

var formTemplateStatus = {
  DRAFT: 0,
  IN_PRODUCTION: 1,
  PUBLISHED: 2
};
angular.module('gw-um-j2js').constant('formTemplateStatus', formTemplateStatus);

/***/ }),
/* 1590 */
/***/ (function(module, exports) {

var formTemplateType = {
  INVALID: 0,
  APPLICATION: 1,
  RATING: 2,
  QUOTING: 3,
  PRE_QUALIFICATION_INPUT: 4,
  DECLINATION_LETTER: 5,
  EXTERNAL_DATA_REPORT_WCIRB: 6,
  UNDERWRITING_AUTHORITY: 7,
  UNDERWRITING_WORKSHEET: 9,
  LOST_LETTER: 10,
  PREDICTIVE_ANALYTICS: 11,
  NON_RENEWAL_LETTER: 12,
  AGENCY_BROKERAGE_AUTHORITY: 13,
  CORRESPONDENCE: 14,
  AGENT_RATING: 15,
  AGENT_BINDING: 16,
  UNDERWRITER_BINDING: 18,
  ISSUANCE: 19,
  PRE_QUALIFICATION_OUTPUT: 20,
  CARRIER_AUTHORITY: 21,
  ACCOUNT_OVERVIEW: 22,
  ACCOUNT_WORKSHEET: 24,
  EXTERNAL_DATA_REPORT_DNB: 25,
  EXTERNAL_DATA_REPORT_NCCI: 26,
  EXTERNAL_DATA_REPORT_RISK_METER: 27,
  POLICY_FORM: 28,
  ENDORSEMENT_ISSUANCE: 29,
  REJECTION_LETTER: 31,
  PROPOSAL_BINDER_SECTION: 32,
  REWRITE_REISSUE_ISSUANCE: 33,
  PRICING: 34,
  EXTERNAL_DATA_REPORT_EXPERIAN: 35,
  EXTERNAL_DATA_REPORT_EXPERIAN_PREMIER_PROFILE: 36,
  EXTERNAL_DATA_REPORT_VALEN: 37,
  CANCELLATION: 38,
  SUBMISSION: 39,
  EXTERNAL_DATA_REPORT_ISO_PASSPORT: 40,
  ENDORSEMENT: 41,
  USER: 42,
  ORGANIZATION: 43,
  DECLINATION: 44,
  MARK_AS_LOST: 45,
  REWRITE_REISSUE: 46
};
angular.module('gw-um-j2js').constant('formTemplateType', formTemplateType);

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

var displayConditionOperator = {
  EQUALS: 0,
  NOT_EQUALS: 1,
  NOT_EMPTY: 2,
  EMPTY_VALUE_SET: 3,
  NOT_EMPTY_VALUE_SET: 4
};
angular.module('gw-um-j2js').constant('displayConditionOperator', displayConditionOperator);

/***/ }),
/* 1592 */
/***/ (function(module, exports) {

var fieldTemplateComponentSettingOwningClass = {
  FIELD_TEMPLATE: 0,
  UI_FIELD: 1
};
angular.module('gw-um-j2js').constant('fieldTemplateComponentSettingOwningClass', fieldTemplateComponentSettingOwningClass);

/***/ }),
/* 1593 */
/***/ (function(module, exports) {

var inputType = {
  STRING: 0,
  NUMBER: 1,
  BOOLEAN: 2,
  BUTTON: 3,
  RADIO_BUTTON: 4,
  DROP_DOWN: 5,
  CHECK_BOX: 6,
  MULTI_SELECT_SET: 7
};
angular.module('gw-um-j2js').constant('inputType', inputType);

/***/ }),
/* 1594 */
/***/ (function(module, exports) {

var displayConditionLogicalOperator = {
  AND: 0,
  OR: 1
};
angular.module('gw-um-j2js').constant('displayConditionLogicalOperator', displayConditionLogicalOperator);

/***/ }),
/* 1595 */
/***/ (function(module, exports) {

var javascriptApplicableExpressions = {
  DISABLE_EXPRESSION: 'Disable Expression',
  REQUIRED_EXPRESSION: 'Required Expression'
};
angular.module('gw-um-j2js').constant('javascriptApplicableExpressions', javascriptApplicableExpressions);

/***/ }),
/* 1596 */
/***/ (function(module, exports) {

var javascriptExpressionOperandType = {
  NUMBER: 'Number',
  ANY: 'Any',
  NOT_APPLICABLE: 'N/A'
};
angular.module('gw-um-j2js').constant('javascriptExpressionOperandType', javascriptExpressionOperandType);

/***/ }),
/* 1597 */
/***/ (function(module, exports) {

var javascriptExpressionType = {
  FUNCTION: 'function',
  OPERATOR: 'operator',
  CONSTANT: 'constant'
};
angular.module('gw-um-j2js').constant('javascriptExpressionType', javascriptExpressionType);

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

var uIFormTemplateAction = {
  FORM_TEMPLATE_SETTINGS: 'form template settings',
  SAVE: 'save',
  DISCARD: 'discard',
  SAVE_AS_NEW_VERSION: 'save as new version',
  DELETE: 'delete',
  MARK_IN_PRODUCTION: 'mark in production',
  MARK_ALL_IN_PRODUCTION: 'mark all in production',
  EXPORT: 'export',
  BACKUP: 'backup',
  EXPORT_ALL: 'export all',
  SHOW_FORM_REFERENCES: 'show form references',
  RELOAD_FORM_RULES: 'reload form rules',
  RELOAD_FIELD_RULES: 'reload field rules',
  PUBLISH_FORM_TEMPLATES: 'publish form templates',
  IMPORT: 'import',
  NEW_FORM: 'new form',
  TEST_DRAFT_FORM_TEMPLATES: 'test draft form templates'
};
angular.module('gw-um-j2js').constant('uIFormTemplateAction', uIFormTemplateAction);

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

var uIFormTriggerOperatorType = {
  EQUALS: 0,
  CONTAINS: 1,
  MATCHES: 2,
  GREATER: 3,
  GREATEREQUAL: 4,
  LESS: 5,
  LESSEQUALS: 6
};
angular.module('gw-um-j2js').constant('uIFormTriggerOperatorType', uIFormTriggerOperatorType);

/***/ }),
/* 1600 */
/***/ (function(module, exports) {

var navigationItemType = {
  DOCUMENT: 1,
  FORM: 2,
  NONE: 3,
  QUOTES: 5,
  PROPOSALS: 6,
  PROPOSAL: 7,
  PROPOSAL_BUILDER: 8,
  BINDER_BUILDER: 9,
  POLICIES: 10,
  POLICY: 11,
  ACCOUNT: 12,
  REPORTS: 13,
  CUSTOM: 14,
  URL: 15,
  ACCOUNT_SUBMISSIONS: 16,
  QUOTE: 17,
  POLICY_ISSUANCE: 18,
  POLICY_CANCELLATION: 19,
  POLICY_REINSTATEMENT: 20,
  POLICY_REWRITE: 21,
  ENDORSEMENT: 22
};
angular.module('gw-um-j2js').constant('navigationItemType', navigationItemType);

/***/ }),
/* 1601 */
/***/ (function(module, exports) {

var notificationPreferencesAction = {
  BACKUP: 'backup',
  NEW_EMAIL: 'New Email',
  NEW_POPUP: 'New Popup',
  SAVE: 'save',
  DISCARD: 'discard',
  DELETE: 'delete'
};
angular.module('gw-um-j2js').constant('notificationPreferencesAction', notificationPreferencesAction);

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

var notificationPreferencesType = {
  EMAIL: 'EMAIL',
  POPUP: 'POPUP'
};
angular.module('gw-um-j2js').constant('notificationPreferencesType', notificationPreferencesType);

/***/ }),
/* 1603 */
/***/ (function(module, exports) {

var policyAction = {
  CANCEL: 'cancel',
  ENDORSE: 'endorse',
  REINSTATE: 'reinstate',
  REWRITE: 'rewrite',
  REISSUE: 'reissue'
};
angular.module('gw-um-j2js').constant('policyAction', policyAction);

/***/ }),
/* 1604 */
/***/ (function(module, exports) {

var policyReinstatementStatus = {
  INVALID: 0,
  REINSTATED: 1
};
angular.module('gw-um-j2js').constant('policyReinstatementStatus', policyReinstatementStatus);

/***/ }),
/* 1605 */
/***/ (function(module, exports) {

var policyStatus = {
  DRAFT: 0,
  BIND_PENDING: 12,
  BOUND: 1,
  BEGIN_ISSUANCE: 2,
  PENDING_ISSUANCE: 3,
  ISSUED: 4,
  CANCELLATION_REQUESTED: 5,
  CANCELLATION_PENDING: 6,
  CANCELLED: 7,
  REPLACED: 8,
  REWRITE_PENDING: 9,
  REISSUE_PENDING: 10,
  REWRITTEN: 11
};
angular.module('gw-um-j2js').constant('policyStatus', policyStatus);

/***/ }),
/* 1606 */
/***/ (function(module, exports) {

var policyTransition = {
  CREATE: 'create',
  GENERATE_BINDER: 'generate binder',
  MODIFY_BINDER: 'modify binder',
  BIND: 'bind',
  UNBIND: 'unbind',
  START_ISSUANCE: 'start issuance',
  MODIFY_ISSUANCE: 'modify issuance',
  SUBMIT_FOR_ISSUANCE: 'submit for issuance',
  REVERT_TO_BOUND: 'revert to bound',
  MARK_AS_ISSUED: 'mark as issued',
  REVERT_TO_DRAFT: 'revert to draft',
  REVERT_TO_PENDING_ISSUANCE: 'revert to pending issuance',
  REQUEST_CANCELLATION: 'request cancellation',
  SUBMIT_CANCELLATION: 'submit cancellation',
  RETRACT_CANCELLATION_REQUEST: 'retract cancellation request',
  RESCIND_CANCELLATION: 'rescind cancellation',
  MARK_AS_CANCELLED: 'mark as cancelled',
  REINSTATE: 'reinstate',
  REVERT_TO_CANCELLATION_PENDING: 'revert to cancellation pending',
  DELETE: 'delete',
  REPLACE: 'replace',
  ISSUE_REWRITE: 'issue rewrite',
  REISSUE: 'reissue',
  INITIATE_REWRITE: 'initiate rewrite',
  INITIATE_REISSUE: 'initiate reissue',
  REVERT_TO_CANCELLED: 'revert to cancelled',
  REWRITE: 'rewrite'
};
angular.module('gw-um-j2js').constant('policyTransition', policyTransition);

/***/ }),
/* 1607 */
/***/ (function(module, exports) {

var cancellationPendingStatus = {
  ALL: -1,
  PENDING: 0
};
angular.module('gw-um-j2js').constant('cancellationPendingStatus', cancellationPendingStatus);

/***/ }),
/* 1608 */
/***/ (function(module, exports) {

var policyCancellationStatus = {
  INVALID: 0,
  REQUESTED: 1,
  PENDING: 2,
  CANCELLED: 3,
  RETRACTED: 4,
  RESCINDED: 5
};
angular.module('gw-um-j2js').constant('policyCancellationStatus', policyCancellationStatus);

/***/ }),
/* 1609 */
/***/ (function(module, exports) {

var policyCancellationAction = {
  DELETE_DRAFT_CANCELLATION: 'delete draft cancellation',
  REQUEST_CANCELLATION: 'request cancellation',
  RETRACT_CANCELLATION_REQUEST: 'retract cancellation request',
  SUBMIT_FOR_CANCELLATION: 'submit for cancellation',
  RESCIND_CANCELLATION: 'rescind cancellation',
  MARK_AS_CANCELLED: 'mark as cancelled',
  REVERT_TO_CANCELLATION_PENDING: 'revert to cancellation pending'
};
angular.module('gw-um-j2js').constant('policyCancellationAction', policyCancellationAction);

/***/ }),
/* 1610 */
/***/ (function(module, exports) {

var endorsementStatus = {
  INVALID: 0,
  DRAFT: 1,
  SUBMITTED: 2,
  PENDING_ISSUANCE: 3,
  ISSUED: 4,
  DECLINED: 5,
  APPROVED: 6,
  INVALID_RATING: 7,
  VALID_RATING: 8,
  APPROVED_INVALID_RATING: 9,
  APPROVED_VALID_RATING: 10,
  PRICED: 11,
  APPROVED_PRICED: 12
};
angular.module('gw-um-j2js').constant('endorsementStatus', endorsementStatus);

/***/ }),
/* 1611 */
/***/ (function(module, exports) {

var endorsementTransition = {
  START: 'start',
  CREATE: 'create',
  SUBMIT: 'submit',
  SUBMIT_FOR_ISSUANCE: 'submit for issuance',
  REVERT_TO_SUBMITTED: 'revert to submitted',
  MARK_AS_ISSUED: 'mark as issued',
  REVERT_TO_PENDING_ISSUANCE: 'revert to pending issuance',
  APPROVE: 'approve',
  DECLINE: 'decline',
  REOPEN: 'reopen',
  DELETE: 'delete',
  CREATE_POLICY_FORMS: 'create policy forms',
  OPEN: 'open',
  CREATE_ENDORSEMENT_QUOTE: 'create endorsement quote',
  GENERATE_RATING: 'generate rating',
  GENERATE_RATING_ATTACHMENTS: 'generate rating attachments',
  START_PRICING: 'start pricing',
  MODIFY_RATING: 'modify rating',
  MODIFY_PRICING: 'modify pricing',
  REFRESH_QUOTE: 'refresh quote',
  REVIEW_CHANGES: 'review changes'
};
angular.module('gw-um-j2js').constant('endorsementTransition', endorsementTransition);

/***/ }),
/* 1612 */
/***/ (function(module, exports) {

var policyIssuanceConstants = {
  PENDING_ISSUANCE: 'Pending Issuance',
  ISSUED: 'Issued',
  REVERTED_TO_PENDING_ISSUANCE: 'Reverted to Pending Issuance',
  REVERTED_TO_BOUND: 'Reverted to Bound'
};
angular.module('gw-um-j2js').constant('policyIssuanceConstants', policyIssuanceConstants);

/***/ }),
/* 1613 */
/***/ (function(module, exports) {

var policyIssuanceAction = {
  BEGIN_ISSUANCE: 'begin issuance',
  REVERT_TO_BOUND: 'revert to bound',
  SUBMIT_FOR_ISSUANCE: 'submit for issuance',
  MODIFY_ISSUANCE: 'modify issuance',
  MARK_AS_ISSUED: 'mark as issued',
  REVERT_TO_PENDING_ISSUANCE: 'revert to pending issuance'
};
angular.module('gw-um-j2js').constant('policyIssuanceAction', policyIssuanceAction);

/***/ }),
/* 1614 */
/***/ (function(module, exports) {

var policyRewriteAction = {
  CREATE: 'create',
  SUBMIT: 'submit',
  DELETE: 'delete',
  START_RATING: 'start rating',
  REVERT_TO_SUBMITTED: 'revert to submitted',
  SUBMIT_FOR_ISSUANCE: 'submit for issuance',
  MARK_AS_ISSUED: 'mark as issued'
};
angular.module('gw-um-j2js').constant('policyRewriteAction', policyRewriteAction);

/***/ }),
/* 1615 */
/***/ (function(module, exports) {

var policyRewriteStatus = {
  INVALID: 0,
  DRAFT: 1,
  SUBMITTED: 2,
  PENDING_ISSUANCE: 3,
  ISSUED: 4,
  INVALID_RATING: 7,
  VALID_RATING: 8,
  VALID_PRICING: 9
};
angular.module('gw-um-j2js').constant('policyRewriteStatus', policyRewriteStatus);

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

var policyRewriteTransition = {
  START: 'start',
  CREATE: 'create',
  SUBMIT: 'submit',
  SUBMIT_FOR_ISSUANCE: 'submit for issuance',
  REVERT_TO_SUBMITTED: 'revert to submitted',
  MARK_AS_ISSUED: 'mark as issued',
  DELETE: 'delete',
  START_RATING: 'start rating',
  GENERATE_RATING: 'generate rating',
  MODIFY_RATING: 'modify rating',
  START_PRICING: 'start pricing',
  MODIFY_PRICING: 'modify pricing',
  REVIEW_CHANGES: 'review changes',
  REFRESH_QUOTE: 'refresh quote',
  GENERATE_RATING_ATTACHMENTS: 'generate rating attachments'
};
angular.module('gw-um-j2js').constant('policyRewriteTransition', policyRewriteTransition);

/***/ }),
/* 1617 */
/***/ (function(module, exports) {

var manuscriptEndorsementFormType = {
  ENDORSEMENT_FORM: 1,
  POLICY_FORM: 2
};
angular.module('gw-um-j2js').constant('manuscriptEndorsementFormType', manuscriptEndorsementFormType);

/***/ }),
/* 1618 */
/***/ (function(module, exports) {

var productTemplateAction = {
  BACKUP: 'backup',
  DISCARD: 'discard',
  NEW_PRODUCT_TEMPLATE: 'new product template',
  SAVE: 'save'
};
angular.module('gw-um-j2js').constant('productTemplateAction', productTemplateAction);

/***/ }),
/* 1619 */
/***/ (function(module, exports) {

var productTypes = {
  QUOTEABLE: 'Quoteable',
  SUBMITABLE: 'Submmitable',
  NA: 'Na'
};
angular.module('gw-um-j2js').constant('productTypes', productTypes);

/***/ }),
/* 1620 */
/***/ (function(module, exports) {

var proposalAction = {
  CREATE_QUOTE: 'create quote',
  COPY_PROPOSAL: 'copy proposal',
  DELETE_PROPOSAL: 'delete proposal',
  BIND_PROPOSAL: 'bind proposal',
  BIND_PROPOSAL_FROM_SENT: 'bind proposal from sent',
  SEND_PROPOSAL: 'send proposal',
  SEND_BINDER: 'send binder',
  ADD_SECTION: 'add section',
  ADD_DOCUMENT: 'add document',
  DELETE_SECTION: 'delete section',
  BEGIN_BINDING_PROPOSAL: 'begin binding proposal',
  DECLINE_TO_BIND_PROPOSAL: 'decline to bind proposal',
  DECLINE_TO_BIND_PROPOSAL_FROM_SENT: 'decline to bind proposal from sent',
  REQUEST_TO_BIND_PROPOSAL: 'request to bind proposal',
  REQUEST_TO_BIND_PROPOSAL_FROM_SENT: 'request to bind proposal from sent',
  GENERATE_BINDER_PROPOSAL: 'generate binder proposal',
  GENERATE_QUOTES: 'generate quotes',
  MODIFY_PROPOSAL: 'modify proposal'
};
angular.module('gw-um-j2js').constant('proposalAction', proposalAction);

/***/ }),
/* 1621 */
/***/ (function(module, exports) {

var proposalSendType = {
  SEND_QUOTE_LEGACY: 'Send Quote Legacy',
  SEND_PROPOSAL: 'Send Proposal'
};
angular.module('gw-um-j2js').constant('proposalSendType', proposalSendType);

/***/ }),
/* 1622 */
/***/ (function(module, exports) {

var sectionTemplateApplicabilityType = {
  OPTIONAL: 1,
  REQUIRED: 2,
  DEFAULT_SELECTED: 3,
  CONDITIONAL: 11
};
angular.module('gw-um-j2js').constant('sectionTemplateApplicabilityType', sectionTemplateApplicabilityType);

/***/ }),
/* 1623 */
/***/ (function(module, exports) {

var sectionTemplateStatus = {
  DRAFT: 0,
  IN_PRODUCTION: 1
};
angular.module('gw-um-j2js').constant('sectionTemplateStatus', sectionTemplateStatus);

/***/ }),
/* 1624 */
/***/ (function(module, exports) {

var sectionTemplateAction = {
  NEW_SECTION_TEMPLATE: 'new section template',
  BACKUP: 'backup',
  RELOAD_SECTION_RULES: 'reload section rules',
  SAVE: 'save',
  DISCARD: 'discard',
  DELETE: 'delete',
  MARK_IN_PRODUCTION: 'mark in production'
};
angular.module('gw-um-j2js').constant('sectionTemplateAction', sectionTemplateAction);

/***/ }),
/* 1625 */
/***/ (function(module, exports) {

var sectionType = {
  ANY: 0,
  PROPOSAL: 1,
  BINDER: 2
};
angular.module('gw-um-j2js').constant('sectionType', sectionType);

/***/ }),
/* 1626 */
/***/ (function(module, exports) {

var quoteAction = {
  SELECT_POLICY_FORMS: 'select policy forms',
  MODIFY_BINDING_FORMS: 'modify binding forms',
  REFRESH_QUOTE: 'refresh quote',
  REVERT_TO_SENT: 'revert to sent',
  COPY_QUOTE: 'copy quote',
  COPY_QUOTE_FOR_MULTI_QUOTE_PROPOSAL: 'copy quote for multi quote proposal',
  OPEN_POLICY_ISSUANCE: 'open policy issuance',
  GENERATE_RATING_ATTACHMENTS: 'generate rating attachments',
  VIEW_RATING_ATTACHMENTS: 'view rating attachments',
  ADD_SECTION: 'add section',
  ADD_DOCUMENT: 'add document',
  DELETE_SECTION: 'delete section',
  SEND_BINDER: 'send binder',
  GENERATE_QUOTE: 'generate quote',
  GENERATE_BINDER: 'generate binder'
};
angular.module('gw-um-j2js').constant('quoteAction', quoteAction);

/***/ }),
/* 1627 */
/***/ (function(module, exports) {

var quoteStatus = {
  INVALID: 0,
  INVALID_RATING: 1,
  VALID_RATING: 2,
  INVALID_QUOTE: 3,
  VALID_QUOTE: 4,
  SENT: 5,
  QUOTED: 5,
  BIND_REQUESTED: 6,
  BIND_CONFIRMED: 7,
  BOUND: 7,
  WITHDRAWN: 8,
  SENT_AGAIN: 10,
  DECLINED: 13,
  PENDING_RATING: 14,
  BEGIN_BINDING: 15,
  AWAITING_RATE: 16,
  PENDING_BINDING: 18,
  VALID_BIND: 20,
  NOT_TAKEN: 22,
  BIND_REQUEST_STARTED: 23,
  REPLACED: 24,
  PRICED: 25,
  ENDORSEMENT_ISSUANCE: 26,
  POLICY_REWRITE_ISSUANCE: 27
};
angular.module('gw-um-j2js').constant('quoteStatus', quoteStatus);

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

var quoteTransition = {
  START_RATING: 'start rating',
  CANCEL_RATING_REQUEST: 'cancel rating request',
  COMPLETE_RATING_REQUEST: 'complete rating request',
  GENERATE_RATING: 'generate rating',
  MODIFY_RATING: 'modify rating',
  START_QUOTE: 'start quote',
  GENERATE_QUOTE: 'generate quote',
  MODIFY_QUOTE: 'modify quote',
  SEND: 'send',
  BEGIN_REQUEST_BINDING: 'begin request binding',
  BEGIN_BINDING: 'begin binding',
  REQUEST_BINDING: 'request binding',
  DECLINE_QUOTE: 'decline quote',
  GENERATE_BINDER: 'generate binder',
  MODIFY_BINDER: 'modify binder',
  BIND: 'bind',
  CANCEL_BINDING: 'cancel binding',
  COMPLETE_BINDING: 'complete binding',
  UNBIND: 'unbind',
  DELETE: 'delete',
  WITHDRAW_QUOTE: 'withdraw quote',
  WITHDRAW_REQUEST: 'withdraw request',
  COPY_QUOTE: 'copy quote',
  REPLACE: 'replace',
  START_PRICING: 'start pricing',
  MODIFY_PRICING: 'modify pricing',
  SUBMIT_FOR_ISSUANCE: 'submit for issuance'
};
angular.module('gw-um-j2js').constant('quoteTransition', quoteTransition);

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

var renewalStatus = {
  INACTIVE: 0,
  RENEWAL_PENDING: 1,
  NON_RENEWAL_PENDING: 3,
  FLAGGED_FOR_NON_RENEWAL: 4
};
angular.module('gw-um-j2js').constant('renewalStatus', renewalStatus);

/***/ }),
/* 1630 */
/***/ (function(module, exports) {

var renewalTransition = {
  SUBMIT_RENEWAL: 'submit renewal',
  MARK_RENEWED: 'mark renewed',
  MARK_EXPIRED: 'mark expired',
  SUBMIT_NON_RENEWAL: 'submit non-renewal',
  MARK_NON_RENEWED: 'mark non-renewed',
  RETRACT_NON_RENEWAL: 'retract non-renewal',
  FLAG_FOR_NON_RENEWAL: 'flag for non-renewal',
  CLEAR_NON_RENEWAL_FLAG: 'clear non-renewal flag'
};
angular.module('gw-um-j2js').constant('renewalTransition', renewalTransition);

/***/ }),
/* 1631 */
/***/ (function(module, exports) {

var roleConstants = {
  ROLE_NAME_AGENT: 'ROLE_AGENT',
  ROLE_NAME_AGENCY_USER: 'ROLE_AGENCY_USER',
  ROLE_NAME_ADMIN: 'ROLE_ADMIN',
  ROLE_NAME_AGENCY_ADMIN: 'ROLE_AGENCY_ADMIN',
  ROLE_NAME_USER_ADMIN: 'ROLE_USER_ADMIN',
  ROLE_NAME_USER_ADMIN_2: 'ROLE_USER_ADMIN_2',
  ROLE_NAME_CARRIER_ADMIN_1: 'ROLE_CARRIER_ADMIN_1',
  ROLE_NAME_CARRIER_ADMIN_2: 'ROLE_CARRIER_ADMIN_2',
  ROLE_NAME_OPERATOR: 'ROLE_OPERATOR',
  ROLE_USER_GROUP_ADMIN: 'ROLE_USER_GROUP_ADMIN',
  ROLE_NAME_UNDERWRITER: 'ROLE_UNDERWRITER',
  ROLE_NAME_UNDERWRITER_MANAGER: 'ROLE_UNDERWRITER_MANAGER',
  ROLE_NAME_UNDERWRITER_TECH: 'ROLE_UNDERWRITER_TECH',
  ROLE_NAME_UNDERWRITER_ASSISTANT: 'ROLE_UNDERWRITER_ASSISTANT',
  ROLE_NAME_UNDERWRITER_EXAMINER: 'ROLE_UNDERWRITER_EXAMINER',
  ROLE_NAME_MGA_UNDERWRITER: 'ROLE_MGA_UNDERWRITER',
  ROLE_NAME_MGA_UNDERWRITER_ASSISTANT: 'ROLE_MGA_UNDERWRITER_ASSISTANT',
  ROLE_NAME_SERVICE: 'ROLE_SERVICE',
  ROLE_NAME_SERVICE_SAFETY: 'ROLE_SERVICE_SAFETY',
  ROLE_NAME_SERVICE_CLAIMS: 'ROLE_SERVICE_CLAIMS',
  ROLE_NAME_SERVICE_MARKETING: 'ROLE_SERVICE_MARKETING',
  ROLE_NAME_SERVICE_ACCOUNTING: 'ROLE_SERVICE_ACCOUNTING',
  ROLE_NAME_SERVICE_PREMIUM_AUDITOR: 'ROLE_SERVICE_PREMIUM_AUDITOR',
  ROLE_NAME_SERVICE_DOI_AUDITOR: 'ROLE_SERVICE_DOI_AUDITOR',
  ROLE_SUBMISSION_RESPONSIBLE_UNDERWRITER: 'ROLE_RESPONSIBLE_UNDERWRITER',
  ROLE_SUBMISSION_ASSIGNED_UNDERWRITER: 'ROLE_ASSIGNED_UNDERWRITER',
  ROLE_SUBMISSION_REFERRED_UNDERWRITER: 'ROLE_REFERRED_UNDERWRITER',
  ROLE_SUBMISSION_PRODUCER: 'ROLE_AGENT',
  ROLE_SUBMISSION_AGENCY_CONTACT: 'ROLE_AGENCY_CONTACT',
  ROLE_TASK_ASSIGNEE: 'ROLE_TASK_ASSIGNEE',
  ROLE_TASK_ASSIGNER: 'ROLE_TASK_ASSIGNER'
};
angular.module('gw-um-j2js').constant('roleConstants', roleConstants);

/***/ }),
/* 1632 */
/***/ (function(module, exports) {

var scoringRuleActions = {
  BACKUP: 'backup',
  CREATE: 'create',
  COPY: 'copy',
  DELETE: 'delete',
  DISCARD: 'discard',
  SAVE: 'save'
};
angular.module('gw-um-j2js').constant('scoringRuleActions', scoringRuleActions);

/***/ }),
/* 1633 */
/***/ (function(module, exports) {

var stateRateStatus = {
  INVALID: 0,
  TENTATIVELY_APPROVED: 1,
  APPROVED: 2,
  PENDING_ASSESSMENT_APPROVAL: 3
};
angular.module('gw-um-j2js').constant('stateRateStatus', stateRateStatus);

/***/ }),
/* 1634 */
/***/ (function(module, exports) {

var stateRateAction = {
  SAVE: 'save',
  DISCARD: 'discard',
  BACKUP: 'backup'
};
angular.module('gw-um-j2js').constant('stateRateAction', stateRateAction);

/***/ }),
/* 1635 */
/***/ (function(module, exports) {

var agentQuoteStatus = {
  DISABLED: 0,
  ENABLED: 1,
  FORCE_DISABLED: 11,
  QUOTE_ENABLED: 256,
  BIND_ENABLED: 512
};
angular.module('gw-um-j2js').constant('agentQuoteStatus', agentQuoteStatus);

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

var cancellationStatusConstants = {
  CANCELLATION_REQUESTED: 'Cancellation Requested',
  RETRACT_CANCELLATION_REQUEST: 'Retracted Cancellation Request',
  CANCELLATION_PENDING: 'Cancellation Pending',
  REVERT_TO_CANCELLATION_PENDING: 'Reverted to Cancellation Pending',
  CANCELLED: 'Cancelled',
  RESCINDED: 'Rescinded',
  REINSTATED: 'Reinstated'
};
angular.module('gw-um-j2js').constant('cancellationStatusConstants', cancellationStatusConstants);

/***/ }),
/* 1637 */
/***/ (function(module, exports) {

var policyCancellationType = {
  PRORATA_CANCELLATION: 'Pro Rata',
  FLAT_CANCELLATION: 'Flat - at inception',
  SHORT_RATE_CANCELLATION: 'Short Rate',
  EARNED_IN_FULL: 'Earned in Full',
  OTHER_CANCELLATION: 'Other'
};
angular.module('gw-um-j2js').constant('policyCancellationType', policyCancellationType);

/***/ }),
/* 1638 */
/***/ (function(module, exports) {

var submissionAction = {
  ACKNOWLEDGE_MODIFICATIONS: 'acknowledge modifications',
  ASSIGN_ACCOUNT: 'assign account',
  CHECK_CLEARANCE: 'check clearance',
  CLEAR_READY: 'clear ready',
  CLEAR_REFERRAL: 'clear referral',
  RETRACT_REFERRAL: 'retract referral',
  DECLINE_REFERRAL: 'decline referral',
  REFER: 'refer',
  COMPLETE_APPLICATION: 'complete application',
  COPY_PROPOSAL: 'copy proposal',
  COPY_QUOTE: 'copy quote',
  COPY_SUBMISSION: 'copy submission',
  SPLIT_SUBMISSION: 'split submission',
  CREATE_ACCOUNT: 'create account',
  CREATE_ENDORSEMENT: 'create endorsement',
  CREATE_PROPOSAL: 'create proposal',
  CREATE_QUOTE: 'create quote',
  DECLINE: 'decline',
  DELETE_PRE_DRAFT: 'delete pre draft',
  DETAILED_HISTORY: 'detailed history',
  DISABLE_AUTOMATION: 'disable automation',
  DISCARD_MODIFICATIONS: 'discard modifications',
  MODIFY_APPLICATION: 'modify application',
  MODIFY_CARRIER_DRAFT: 'modify carrier draft',
  MODIFY_RENEWAL_INDICATOR: 'modify renewal indicator',
  MODIFY_SUBMISSION: 'modify submission',
  MODIFY_BOUND_SUBMISSION: 'modify bound submission',
  MODIFY_SUBMISSION_EFFECTIVE_DATE: 'modify submission effective date',
  MODIFY_SUBMISSION_NEEDED_BY_DATE: 'modify submission neededBy date',
  MODIFY_SUBMISSION_EXPIRATION_DATE: 'modify submission expiration date',
  MODIFY_SUBMISSION_INSURED_NAME: 'modify submission insured name',
  MODIFY_SUBMISSION_POLICY_NUMBER: 'modify submission policy number',
  OPEN_CANCELLATION: 'open cancellation',
  OPEN_ENDORSEMENT: 'open endorsement',
  OPEN_POLICY_ISSUANCE: 'open policy issuance',
  PRINT_SUBMISSION: 'print submission',
  REQUEST_CANCELLATION: 'request cancellation',
  REVERT_TO_CLEAR: 'revert to clear',
  REWRITE_SUBMISSION: 'rewrite submission',
  SUBMIT_APPLICATION: 'submit application',
  SUBMIT_CANCELLATION: 'submit cancellation',
  SUBMIT_MODIFICATIONS: 'submit modifications',
  VALIDATE_ACCOUNT: 'validate account',
  VIEW_ACCOUNT_OVERVIEW: 'view account overview'
};
angular.module('gw-um-j2js').constant('submissionAction', submissionAction);

/***/ }),
/* 1639 */
/***/ (function(module, exports) {

var submissionCopyOptions = {
  SUBMISSION_APPLICATION_FORMS: 'Application Forms',
  LIVE_CHAT: 'Live Chat',
  NOTES: 'Notes',
  ATTACHMENTS: 'Attachments',
  REPORTS: 'Reports',
  WORKSHEETS: 'Worksheets',
  EMAILS: 'E-mails',
  ALL: 'All',
  SEPARATOR: ';'
};
angular.module('gw-um-j2js').constant('submissionCopyOptions', submissionCopyOptions);

/***/ }),
/* 1640 */
/***/ (function(module, exports) {

var submissionFormsUpgradeMode = {
  NO_UPGRADE_SUBMISSION_FORMS: 1,
  AUTO_UPGRADE_SUBMISSION_FORMS: 2,
  MANUAL_UPGRADE_SUBMISSION_FORMS: 3
};
angular.module('gw-um-j2js').constant('submissionFormsUpgradeMode', submissionFormsUpgradeMode);

/***/ }),
/* 1641 */
/***/ (function(module, exports) {

var submissionMappingReason = {
  RENEWAL: 0,
  REWRITE: 1,
  RESUBMIT: 2
};
angular.module('gw-um-j2js').constant('submissionMappingReason', submissionMappingReason);

/***/ }),
/* 1642 */
/***/ (function(module, exports) {

var submissionOriginator = {
  UMS_MANUAL: 0,
  UMS_AUTO: 1,
  UPLOAD: 2,
  REWRITE: 3,
  UPLOAD_ACORD_PDF: 4,
  EXCHANGE: 5,
  EMAIL_RECEIVER: 6,
  COPY: 7,
  SPLIT: 8,
  EMAIL_UPLOAD: 9
};
angular.module('gw-um-j2js').constant('submissionOriginator', submissionOriginator);

/***/ }),
/* 1643 */
/***/ (function(module, exports) {

var submissionReferralStatus = {
  REFER: 1,
  CLEAR_REFERRAL: 2,
  RETRACT_REFERRAL: 3,
  DECLINE_REFERRAL: 4,
  PARTIALLY_CLEAR_REFERRAL: 5
};
angular.module('gw-um-j2js').constant('submissionReferralStatus', submissionReferralStatus);

/***/ }),
/* 1644 */
/***/ (function(module, exports) {

var submissionStatus = {
  INVALID: 0,
  CREATED_APPLICATION: 1,
  CREATED: 1,
  SUBMITTED: 2,
  CLEARED: 3,
  CLEAR: 3,
  QUOTED: 4,
  BIND_REQUESTED: 5,
  BIND_CONFIRMED: 6,
  BOUND: 6,
  ISSUED: 7,
  CANNOT_BE_CLEARED: 8,
  NOT_CLEAR: 8,
  LOST: 9,
  DECLINED: 10,
  WITHDRAWN: 11,
  EXPIRED: 12,
  PENDING_ISSUANCE: 15,
  DECLINED_QUOTE: 16,
  CANCELLED: 18,
  CLEAR_AWAITING_RATE: 20,
  RENEWED: 21,
  NON_RENEWED: 22,
  SUBMIT_PENDING: 24,
  CLEAR_READY_TO_UNDERWRITE: 25,
  REJECTED: 26,
  CREATED_SUBMISSION: 27
};
angular.module('gw-um-j2js').constant('submissionStatus', submissionStatus);

/***/ }),
/* 1645 */
/***/ (function(module, exports) {

var submissionTransactionType = {
  NEW_BUSINESS: 0,
  RENEWAL: 1
};
angular.module('gw-um-j2js').constant('submissionTransactionType', submissionTransactionType);

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

var submissionTransition = {
  CREATE_APPLICATION: 'create application',
  CREATE: 'create application',
  CREATE_SUBMISSION: 'create submission',
  START_PREQUALIFICATION: 'start pre-qualification',
  CANCEL_PREQUALIFICATION: 'cancel pre-qualification',
  CHECK_PREQUALIFICATION: 'check pre-qualification',
  SUBMIT_PREQUALIFICATION: 'submit pre-qualification',
  SET_SUBMISSION_PRODUCTS: 'set submission products',
  MAKE_APPLICATION: 'make application',
  SUBMIT: 'submit',
  CLEARANCE_UNKNOWN: 'risk is unknown',
  CLEAR: 'risk is clear',
  CLEAR_READY: 'clear ready',
  REVERT_TO_CLEAR: 'revert to clear',
  NOT_CLEAR: 'risk is not clear',
  CREATE_QUOTE: 'create quote',
  SEND_QUOTE: 'send quote',
  BIND_QUOTE: 'bind quote',
  UNBIND_QUOTE: 'unbind quote',
  DECLINE_QUOTE: 'decline quote',
  SUBMIT_FOR_ISSUANCE: 'submit for issuance',
  REVERT_TO_BOUND: 'revert to bound',
  ISSUE_QUOTE: 'issue quote',
  ACTION_ISSUED: 'Issued',
  REVERT_TO_PENDING_ISSUANCE: 'revert to pending issuance',
  REFER: 'refer',
  CLEAR_REFERRAL: 'clear referral',
  RETRACT_REFERRAL: 'retract referral',
  DECLINE_REFERRAL: 'decline referral',
  ASSIGN: 'assign',
  ASSIGN_APPLICANT: 'assign applicant',
  PERFORM_CLEARANCE: 'perform clearance',
  DECLINE: 'decline',
  DELETE: 'delete',
  LOST: 'lost',
  REACTIVATE: 'reactivate',
  CHANGE_LINE_OF_BUSINESS: 'change line-of-business',
  CANCEL_POLICY: 'cancel',
  REINSTATE_POLICY: 'reinstate',
  REVERT_TO_ISSUED: 'revert to issued',
  REISSUE_POLICY: 'reissue policy',
  REWRITE_SUBMISSION: 'rewrite submission',
  REWRITE_POLICY: 'rewrite policy',
  REEVALUATE: 'reevaluate',
  UPDATE_STATUS_REASON: 'update status reason',
  RESUBMIT: 'resubmit',
  REJECT: 'reject'
};
angular.module('gw-um-j2js').constant('submissionTransition', submissionTransition);

/***/ }),
/* 1647 */
/***/ (function(module, exports) {

var submissionUploadStatus = {
  UPLOAD_INACTIVE: 0,
  UPLOAD_PENDING: 1,
  UPLOAD_IN_PROGRESS: 2,
  UPLOAD_FAILED: 3,
  UPLOAD_SUCCEEDED: 4
};
angular.module('gw-um-j2js').constant('submissionUploadStatus', submissionUploadStatus);

/***/ }),
/* 1648 */
/***/ (function(module, exports) {

var underwritingAutomationStatus = {
  FORCE_DISABLED: -1,
  DISABLED: 0,
  AUTO_CREATE_QUOTE: 4,
  AUTO_RATE: 6,
  AUTO_QUOTE: 8,
  AUTO_SEND_QUOTE: 10,
  AUTO_BIND: 20,
  AUTO_ISSUE: 30
};
angular.module('gw-um-j2js').constant('underwritingAutomationStatus', underwritingAutomationStatus);

/***/ }),
/* 1649 */
/***/ (function(module, exports) {

var activityEventNotificationStatus = {
  NEW: 0,
  VIEWED: 1
};
angular.module('gw-um-j2js').constant('activityEventNotificationStatus', activityEventNotificationStatus);

/***/ }),
/* 1650 */
/***/ (function(module, exports) {

var activityEventStatus = {
  NEW: 0,
  VIEWED: 1
};
angular.module('gw-um-j2js').constant('activityEventStatus', activityEventStatus);

/***/ }),
/* 1651 */
/***/ (function(module, exports) {

var activityEventType = {
  INVALID: 0,
  NEW_SUBMISSION: 1,
  CHANGED_SUBMISSION_STATUS: 2,
  NEW_NOTE: 3,
  CHANGED_NOTE: 4,
  DELETED_NOTE: 5,
  CHANGED_OWNER: 6,
  CHANGED_REFERRAL: 7,
  CHANGED_QUOTE_STATUS: 8,
  ADD_ATTACHMENT: 9,
  CHANGED_ATTACHMENT: 10,
  DELETED_ATTACHMENT: 11,
  SUBMISSION_CHANGESET: 12,
  NEW_UPLOADED_DRAFT: 13,
  SHARED_NOTE: 14,
  HIDDEN_NOTE: 15,
  CHANGED_POLICY_STATUS: 16,
  NEW_TASK: 19,
  CHANGED_TASK: 20,
  DELETED_TASK: 21,
  CORRESPONDENCE: 22,
  REWRITTEN_SUBMISSION: 23,
  REWRITE_SUBMISSION: 24,
  SUBMIT_RENEWAL: 25,
  MARK_RENEWED: 26,
  MARK_EXPIRED: 27,
  REVERT_TO_RENEWAL_PENDING: 28,
  SUBMIT_NON_RENEWAL: 29,
  MARK_NON_RENEWED: 30,
  REVERT_TO_NON_RENEWAL_PENDING: 31,
  RETRACT_NON_RENEWAL: 32,
  UPGRADED_FORMS: 33,
  SHARED_ATTACHMENT: 34,
  HIDDEN_ATTACHMENT: 35,
  CREATE_ENDORSEMENT: 36,
  SUBMIT_ENDORSEMENT: 37,
  EDIT_ENDORSEMENT: 38,
  SUBMIT_ENDORSEMENT_FOR_ISSUANCE: 39,
  REVERT_ENDORSEMENT_TO_SUBMITTED: 40,
  MARK_ENDORSEMENT_AS_ISSUED: 41,
  REVERT_ENDORSEMENT_TO_PENDING_ISSUANCE: 42,
  DECLINE_ENDORSEMENT: 43,
  REOPEN_ENDORSEMENT: 44,
  DELETE_ENDORSEMENT: 45,
  CREATE_ENDORSEMENT_PROPOSAL: 46,
  RESUBMIT_SUBMISSION: 47,
  SHARED_TASK: 48,
  HIDDEN_TASK: 49,
  FLAG_FOR_NON_RENEWAL: 50,
  CLEAR_NON_RENEWAL_FLAG: 51,
  COPY_SUBMISSION: 52,
  CHANGED_AGENCY_BROKERAGE: 53,
  APPROVE_ENDORSEMENT: 54,
  SPLIT_SUBMISSION: 55,
  CREATE_REWRITE: 56,
  SUBMIT_REWRITE: 57,
  EDIT_REWRITE: 58,
  SUBMIT_REWRITE_FOR_ISSUANCE: 59,
  REVERT_REWRITE_TO_SUBMITTED: 60,
  MARK_REWRITE_AS_ISSUED: 61,
  REVERT_REWRITE_TO_PENDING_ISSUANCE: 62,
  REOPEN_REWRITE: 63,
  DELETE_REWRITE: 64,
  CREATE_REWRITE_PROPOSAL: 65,
  SENT_EMAIL: 66,
  UPLOADED_EMAIL: 67
};
angular.module('gw-um-j2js').constant('activityEventType', activityEventType);

/***/ }),
/* 1652 */
/***/ (function(module, exports) {

var activityEventUserType = {
  AUTHENTICATION_RULES: 'AUTHENTICATION_RULES',
  AUTHENTICATION_SERVER: 'AUTHENTICATION_SERVER',
  AGENT: 'Agent',
  UNDERWRITER: 'Underwriter',
  SERVICE_USER: 'Service User',
  RULES: 'Rules',
  SYSTEM: 'System'
};
angular.module('gw-um-j2js').constant('activityEventUserType', activityEventUserType);

/***/ }),
/* 1653 */
/***/ (function(module, exports) {

var submissionTaskStatus = {
  ALL: -1,
  ASSIGNED: 0,
  RESOLVED: 1
};
angular.module('gw-um-j2js').constant('submissionTaskStatus', submissionTaskStatus);

/***/ }),
/* 1654 */
/***/ (function(module, exports) {

var widgetType = {
  SUBMISSIONS: 1,
  TASKS: 2,
  URL: 3,
  RECENT_ACTIVITY: 4
};
angular.module('gw-um-j2js').constant('widgetType', widgetType);

/***/ }),
/* 1655 */
/***/ (function(module, exports) {

var defaultPreferenceAction = {
  BACKUP: 'backup',
  SAVE: 'save',
  DISCARD: 'discard'
};
angular.module('gw-um-j2js').constant('defaultPreferenceAction', defaultPreferenceAction);

/***/ }),
/* 1656 */
/***/ (function(module, exports) {

var defaultPreferencesDataType = {
  STRING: 1,
  NUMERIC: 2,
  BOOLEAN: 3,
  ENUM_SINGLE_SELECT: 4,
  ENUM_MULTI_SELECT: 5
};
angular.module('gw-um-j2js').constant('defaultPreferencesDataType', defaultPreferencesDataType);

/***/ }),
/* 1657 */
/***/ (function(module, exports) {

var defaultPreferencesType = {
  STUDIO: 1,
  OPERATOR: 2
};
angular.module('gw-um-j2js').constant('defaultPreferencesType', defaultPreferencesType);

/***/ }),
/* 1658 */
/***/ (function(module, exports) {

var userAction = {
  CANCEL: 'cancel',
  ACTIVATE: 'activate',
  DEACTIVATE: 'deactivate',
  RESET_PASSWORD: 'reset password',
  CREATE_PASSWORD: 'create password',
  UNLOCK: 'unlock',
  EDIT: 'startChanges',
  SAVE_CHANGES: 'applyChanges',
  CANCEL_EDIT: 'discardChanges'
};
angular.module('gw-um-j2js').constant('userAction', userAction);

/***/ }),
/* 1659 */
/***/ (function(module, exports) {

var userLoginType = {
  DIRECT: 0,
  SINGLE_SIGN_ON: 1
};
angular.module('gw-um-j2js').constant('userLoginType', userLoginType);

/***/ }),
/* 1660 */
/***/ (function(module, exports) {

var userManagementAction = {
  CREATE_USER: 'createUser',
  IMPORT_UW_LOAS: 'importUWLOAs',
  EXPORT_UW_LOAS: 'exportUWLOAs'
};
angular.module('gw-um-j2js').constant('userManagementAction', userManagementAction);

/***/ }),
/* 1661 */
/***/ (function(module, exports) {

var userStatus = {
  STATUS_ALL: -1,
  STATUS_INACTIVE: 0,
  STATUS_ACTIVE: 1,
  STATUS_DRAFT: 2
};
angular.module('gw-um-j2js').constant('userStatus', userStatus);

/***/ }),
/* 1662 */
/***/ (function(module, exports) {

var userType = {
  AGENCY_BROKERAGE: 1,
  SERVICE: 2,
  SYSTEM: 3,
  UNDERWRITER: 4
};
angular.module('gw-um-j2js').constant('userType', userType);

/***/ }),
/* 1663 */
/***/ (function(module, exports) {

var userGroupAction = {
  NEW_USER_GROUP: 'new user group',
  SAVE: 'save',
  DISCARD: 'discard',
  DELETE: 'delete'
};
angular.module('gw-um-j2js').constant('userGroupAction', userGroupAction);

/***/ }),
/* 1664 */
/***/ (function(module, exports) {

var registerableResourceConstants = {
  INVALID_REGISTRATION_IDENTIFIER_ERROR: 'Invalid registrationIdentifier!'
};
angular.module('gw-um-j2js').constant('registerableResourceConstants', registerableResourceConstants);

/***/ }),
/* 1665 */
/***/ (function(module, exports) {

/*@ngInject*/
var AuthenticationMediator = function AuthenticationMediator($q, $uibModal, loginRepository, loginTokenRepository, refreshLoginTokenRepository, changePasswordRepository, changePasswordWithTokenRepository) {
  function refreshLoginTokenInternal(loginTokenToRefresh) {
    var defer = $q.defer();
    function onSuccess(newLoginToken) {
      loginTokenRepository.setLoginToken(newLoginToken);
      defer.resolve();
    }
    function onError() {
      defer.reject();
    }
    refreshLoginTokenRepository.refreshLoginToken(loginTokenToRefresh).then(onSuccess, onError);
    return defer.promise;
  }
  this.refreshLoginToken = function (loginToken) {
    return refreshLoginTokenInternal(loginToken);
  };
  this.refreshLoginTokenWithCurrent = function () {
    return refreshLoginTokenInternal(loginTokenRepository.getLoginToken());
  };
  this.showChangePasswordPopup = function (loginToken) {
    $uibModal.open({
      templateUrl: '/changePasswordModal/changePasswordModal.tpl.html',
      controller: 'changePasswordModalController',
      windowClass: 'changePasswordModal',
      backdrop: 'static',
      resolve: {
        options: function options() {
          return {
            loginToken: loginToken
          };
        }
      }
    });
  };
  this.showForgotPassword = function () {
    $uibModal.open({
      templateUrl: '/login/forgotPassword/forgotPassword.tpl.html',
      controller: 'forgotPasswordController',
      backdrop: 'static',
      windowClass: 'forgotPasswordModal'
    });
  };
  this.changePasswordAndLogin = function (username, oldPassword, newPassword, timeoutSeconds, passwordIsToken) {
    return loginRepository.changePasswordAndLogin(username, oldPassword, newPassword, timeoutSeconds, passwordIsToken);
  };
  this.changePassword = function (username, oldPassword, newPassword) {
    return changePasswordRepository.changePassword(username, oldPassword, newPassword);
  };
  this.changePasswordWithToken = function (username, loginToken, newPassword) {
    return changePasswordWithTokenRepository.changePasswordWithToken(username, loginToken, newPassword);
  };
};
AuthenticationMediator.$inject = ["$q", "$uibModal", "loginRepository", "loginTokenRepository", "refreshLoginTokenRepository", "changePasswordRepository", "changePasswordWithTokenRepository"];
angular.module('gw-um-auth').service('authenticationMediator', AuthenticationMediator);

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var AuthenticationUtil = function AuthenticationUtil($rootScope, $state, $stateParams, $q, $location, $interval, cryptoUtil, coreMediator, uiPerformanceLoggerConstant, coreConstant, checkAuthRepository, logUtil, refreshLoginTokenUtil) {
  this.attemptAutoAuthentication = function () {
    var defer = $q.defer(),
      ssoLogin = !_.isNil($stateParams.login) ? $stateParams.login : null,
      ssoExternalToken = $stateParams.externalToken,
      consoleTypeAuthorizationName,
      passwordIsToken = ssoExternalToken === 'false' || _.isNil(ssoExternalToken),
      isExternalToken = !passwordIsToken,
      ssoTokenSplits,
      username,
      password,
      excludedStates = ['password'],
      isOnlyIndexHtml = _.isEmpty($state.current.name) && _.isEmpty($location.path());
    function onCheckAuthSuccess(loginToken) {
      if (loginToken !== coreMediator.getLoginToken()) {
        // Remove the login details if there was no response in checking the session, as this indicates the
        // token has expired.
        coreMediator.removeLoginToken();
        coreMediator.removeClientId();
        defer.reject();
      } else {
        refreshLoginTokenUtil.start(loginToken).then(function () {
          logUtil.logInfo('Active Session exists, auto-logging into the client.');
          defer.resolve(!isOnlyIndexHtml);
        });
        if ($state.current.name === 'login' || $location.path().indexOf('login') > -1) {
          $state.go('landing');
        }
      }
    }
    function onCheckAuthError() {
      // Remove the login details if there was an error checking the session, as this may indicate the
      // token has expired.
      coreMediator.removeLoginToken();
      coreMediator.removeClientId();
      defer.reject();
    }
    function handleLoginSuccess() {
      defer.resolve(!isOnlyIndexHtml && _.isEmpty($stateParams.login));
    }
    function handleLoginError() {
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG_WITHOUT_LOGGING, uiPerformanceLoggerConstant.LOGIN, coreConstant.uiPeformanceLogger.FAIL);
      handleLoginAuthError();
    }
    function handleLoginAuthError() {
      cryptoUtil.initServerPublicKey();
      defer.reject();
    }
    function validatedExistingAuthentication() {
      if (!_.includes(excludedStates, $state.current.name)) {
        if (!_.isNil(ssoLogin)) {
          if (_.includes(ssoLogin, ':')) {
            ssoTokenSplits = _.split(ssoLogin, ':');
            if (ssoTokenSplits.length === 2) {
              username = ssoTokenSplits[0];
              password = ssoTokenSplits[1];
              cryptoUtil.initServerPublicKey().then(function () {
                $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.LOGIN, null);
                coreMediator.login(username, password, null, passwordIsToken, isExternalToken).then(handleLoginSuccess, handleLoginError);
              });
            } else {
              handleLoginAuthError();
            }
          } else {
            handleLoginAuthError();
          }
        } else {
          if (!_.isNil(coreMediator.getLoginToken())) {
            checkAuthRepository.checkAuth().then(onCheckAuthSuccess, onCheckAuthError).finally(cryptoUtil.initServerPublicKey);
          } else {
            handleLoginAuthError();
          }
        }
      } else {
        handleLoginAuthError();
      }
    }

    // Whenever we load the application, ensure the ClientID is cleared. We need this to happen because
    // if you click on a link inside the application, it will *not* start a new session, and therefore the
    // ClientID from the application that you clicked the link within will be used in the new tab, and will
    // cause unwanted behavior relating to the persistent connection.
    // This is also important for being able to support different sessions with the server per-browser-tab rather
    // than per-user.
    coreMediator.removeClientId();
    validatedExistingAuthentication();
    return defer.promise;
  };
};
AuthenticationUtil.$inject = ["$rootScope", "$state", "$stateParams", "$q", "$location", "$interval", "cryptoUtil", "coreMediator", "uiPerformanceLoggerConstant", "coreConstant", "checkAuthRepository", "logUtil", "refreshLoginTokenUtil"];
angular.module('gw-um-auth').service('authenticationUtil', AuthenticationUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var AuthorizationRequestInterceptorFactory = function AuthorizationRequestInterceptorFactory(loginTokenRepository, clientIdRepository) {
  return {
    request: function request(config) {
      var loginTokenAuthorizationHeader = loginTokenRepository.getLoginTokenAuthorizationHeader(),
        clientId = clientIdRepository.getClientId();
      if (loginTokenAuthorizationHeader) {
        if (_.isNil(config.headers.Authorization)) {
          config.headers.Authorization = loginTokenAuthorizationHeader;
        }
      }
      if (clientId) {
        config.headers.ClientID = clientId;
      }
      return config;
    }
  };
};
AuthorizationRequestInterceptorFactory.$inject = ["loginTokenRepository", "clientIdRepository"];
angular.module('gw-um-auth').factory('authorizationRequestInterceptor', AuthorizationRequestInterceptorFactory);
angular.module('gw-um-auth').config(["$httpProvider", function ($httpProvider) {
  $httpProvider.interceptors.push('authorizationRequestInterceptor');
}]);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var RefreshLoginTokenUtil = function RefreshLoginTokenUtil($q, $interval, coreConstant, preferenceModel, authenticationMediator) {
  var refreshInterval = coreConstant.DEFAULT_REFRESH_LOGIN_TOKEN_INTERVAL,
    intervalObject = null;
  this.start = function (loginToken) {
    var refreshIntervalInMillisecondsPreference = preferenceModel.get('system.loginTokenRefreshIntervalInMilliseconds'),
      refreshLoginTokenPromise;
    if (!isNaN(refreshIntervalInMillisecondsPreference)) {
      refreshInterval = _.parseInt(refreshIntervalInMillisecondsPreference);
    }
    if (!_.isNil(intervalObject)) {
      return $q.when();
    }

    // Make an immediate call to refresh the token, then start the interval.
    refreshLoginTokenPromise = authenticationMediator.refreshLoginToken(loginToken);
    intervalObject = $interval(function () {
      authenticationMediator.refreshLoginTokenWithCurrent();
    }, refreshInterval);
    return refreshLoginTokenPromise;
  };
  this.stop = function () {
    if (!_.isNil(intervalObject)) {
      $interval.cancel(intervalObject);
      intervalObject = null;
    }
  };
};
RefreshLoginTokenUtil.$inject = ["$q", "$interval", "coreConstant", "preferenceModel", "authenticationMediator"];
angular.module('gw-um-auth').service('refreshLoginTokenUtil', RefreshLoginTokenUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1669 */
/***/ (function(module, exports) {

/*@ngInject*/
var changePasswordRepository = function changePasswordRepository(baseRepository, cryptoUtil) {
  var _this = this;
  angular.extend(this, baseRepository);
  this.changePassword = function (username, oldPassword, newPassword) {
    var url = '/rest/User/changePassword',
      data = {
        username: username,
        oldPassword: cryptoUtil.encryptWithServerPublicKey(oldPassword),
        newPassword: cryptoUtil.encryptWithServerPublicKey(newPassword)
      };
    return _this.post(url, data);
  };
};
changePasswordRepository.$inject = ["baseRepository", "cryptoUtil"];
angular.module('gw-um-auth').service('changePasswordRepository', changePasswordRepository);

/***/ }),
/* 1670 */
/***/ (function(module, exports) {

/*@ngInject*/
var changePasswordWithTokenRepository = function changePasswordWithTokenRepository(baseRepository, cryptoUtil) {
  var _this = this;
  angular.extend(this, baseRepository);
  this.changePasswordWithToken = function (username, loginToken, newPassword) {
    var url = '/rest/User/changePassword',
      data = {
        username: username,
        loginToken: loginToken,
        newPassword: cryptoUtil.encryptWithServerPublicKey(newPassword)
      };
    return _this.post(url, data);
  };
};
changePasswordWithTokenRepository.$inject = ["baseRepository", "cryptoUtil"];
angular.module('gw-um-auth').service('changePasswordWithTokenRepository', changePasswordWithTokenRepository);

/***/ }),
/* 1671 */
/***/ (function(module, exports) {

/*@ngInject*/
var checkAuthRepository = function checkAuthRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.checkAuth = function () {
    var url = '/rest/v2/Session/checkAuth';
    return this.get(url);
  };
};
checkAuthRepository.$inject = ["baseRepository"];
angular.module('gw-um-auth').service('checkAuthRepository', checkAuthRepository);

/***/ }),
/* 1672 */
/***/ (function(module, exports) {

/*@ngInject*/
var ClientIdRepository = function ClientIdRepository($window, appTypeConfigurationModel, coreConstant) {
  this.getClientId = function () {
    return $window.sessionStorage.getItem(appTypeConfigurationModel.appendConsoleType(coreConstant.authorization.SESSION_STORAGE_CLIENT_ID_KEY));
  };
  this.setClientId = function (clientId) {
    $window.sessionStorage.setItem(appTypeConfigurationModel.appendConsoleType(coreConstant.authorization.SESSION_STORAGE_CLIENT_ID_KEY), clientId);
  };
  this.removeClientId = function () {
    return $window.sessionStorage.removeItem(appTypeConfigurationModel.appendConsoleType(coreConstant.authorization.SESSION_STORAGE_CLIENT_ID_KEY));
  };
};
ClientIdRepository.$inject = ["$window", "appTypeConfigurationModel", "coreConstant"];
angular.module('gw-um-auth').service('clientIdRepository', ClientIdRepository);

/***/ }),
/* 1673 */
/***/ (function(module, exports) {

/* @ngInject */
var LoginTokenRepository = function LoginTokenRepository($window, appTypeConfigurationModel, coreConstant) {
  var _this = this;
  this.getLoginToken = function () {
    var loginToken = $window.sessionStorage.getItem(appTypeConfigurationModel.appendConsoleType(coreConstant.authorization.LOCAL_STORAGE_LOGIN_TOKEN_KEY));
    return loginToken;
  };
  this.getLoginTokenAuthorizationHeader = function () {
    var loginToken = _this.getLoginToken();
    if (loginToken) {
      return coreConstant.authorization.SCHEME + ' ' + loginToken;
    }
    return null;
  };
  this.setLoginToken = function (loginToken) {
    $window.sessionStorage.setItem(appTypeConfigurationModel.appendConsoleType(coreConstant.authorization.LOCAL_STORAGE_LOGIN_TOKEN_KEY), loginToken);
  };
  this.removeLoginToken = function () {
    $window.sessionStorage.removeItem(appTypeConfigurationModel.appendConsoleType(coreConstant.authorization.LOCAL_STORAGE_LOGIN_TOKEN_KEY));
  };
};
LoginTokenRepository.$inject = ["$window", "appTypeConfigurationModel", "coreConstant"];
angular.module('gw-um-auth').service('loginTokenRepository', LoginTokenRepository);

/***/ }),
/* 1674 */
/***/ (function(module, exports) {

(function () {
  'use strict';

  /*@ngInject*/
  var RefreshLoginTokenRepository = function RefreshLoginTokenRepository(baseRepository) {
    var _this = this;
    angular.extend(this, baseRepository);
    this.refreshLoginToken = function (loginToken) {
      var url = '/rest/v2/Session/refreshLoginToken',
        config = {
          headers: {
            'Authorization': 'UMS-TOKEN ' + loginToken
          }
        };
      if (loginToken) {
        return _this.post(url, {}, config);
      } else {
        return _this.post(url);
      }
    };
  };
  RefreshLoginTokenRepository.$inject = ["baseRepository"];
  angular.module('gw-um-auth').service('refreshLoginTokenRepository', RefreshLoginTokenRepository);
})();

/***/ }),
/* 1675 */
/***/ (function(module, exports) {

/* @ngInject */
var TemporaryLoginTokenRepository = function TemporaryLoginTokenRepository(baseRepository) {
  var _this = this;
  angular.extend(this, baseRepository);
  this.getSingleUseToken = function () {
    var url = '/rest/Session/singleUseToken';
    return _this.get(url);
  };
};
TemporaryLoginTokenRepository.$inject = ["baseRepository"];
angular.module('gw-um-auth').service('temporaryLoginTokenRepository', TemporaryLoginTokenRepository);

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 1677 */
/***/ (function(module, exports) {

var path = '/login/login.tpl.html';
var html = "<div class=\"login\"\n     ui-focus-manager=\"loginContainer\"\n     ui-browser-detection>\n\n    <div class=\"loginGroup\">\n        <div class=\"loginContainer\">\n\n            <div class=\"formContainer\" ui-enter=\"login()\">\n\n                <div class=\"header\">\n                    <div class=\"firstBestCircleLogo\"\n                         ui-logo\n                         logo-configured-file-name=\"HTML Login Logo\">\n                    </div>\n                </div>\n                <div class=\"loginTitle\">{{::loginTitle}}</div>\n\n                <form name=\"viewModel.loginForm\" novalidate autocomplete=\"off\">\n\n                    <fieldset>\n                        <div>\n                            <label class=\"label\" ui-locale>auth|login.usernameInputLabel</label>\n                            <label class=\"input\">\n\n                                <input class=\"usernameInput\"\n                                       type=\"text\"\n                                       name=\"email\"\n                                       ng-model=\"userName\"\n                                       autocomplete=\"off\"\n                                       required>\n                            </label>\n                        </div>\n\n                        <div>\n                            <label class=\"label\" ui-locale>auth|login.passwordInputLabel</label>\n                            <label class=\"input\">\n                                <input type=\"password\"\n                                       class=\"passwordInput\"\n                                       name=\"password\"\n                                       ng-model=\"password\"\n                                       autocomplete=\"off\"\n                                       required>\n                            </label>\n\n                            <div class=\"note\"\n                                 ng-if=\"viewModel.displayForgotPassword\">\n                                <a ng-click=\"forgotPassword()\" ui-locale>auth|login.forgotPasswordButtonLabel</a>\n                            </div>\n                        </div>\n                    </fieldset>\n                </form>\n\n                <div class=\"footer\">\n                    <button class=\"btn btn-primary loginButton\"\n                            ng-click=\"login()\" ui-locale>auth|login.loginButtonLabel</button>\n                </div>\n\n            </div>\n\n        </div>\n\n        <div class=\"revision\">\n            <span ui-locale>auth|login.revisionLabel</span>\n            <span>{{ viewModel.revisionNumber }}</span>\n        </div>\n\n        <div class=\"unauthorizedAccess\">\n            <span ui-locale>auth|login.unauthorizedAccessLabel</span>\n        </div>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, i18n) {/*@ngInject*/
var LoginController = function LoginController($scope, $state, $rootScope, $uibModal, $location, $stateParams, $timeout, appTypeConfigurationModel, authorizationConstants, coreConstant, coreMediator, localization, uiPerformanceLoggerConstant, authenticationMediator) {
  var consoleTypeAuthorizationName = authorizationConstants.LOGIN_UNDERWRITER_WORKSTATION,
    timeoutList = [];
  localization.setupLocale('auth', __webpack_require__(1679));
  $scope.viewModel = {
    loginForm: null,
    revisionNumber: null,
    displayForgotPassword: false,
    loginTitle: null
  };
  timeoutList.push($timeout(function () {
    if (!_.isNil($stateParams.username)) {
      $scope.userName = $stateParams.username;
      $scope.$emit(coreConstant.event.ADVANCE_FOCUS, '.passwordInput');
    } else {
      $scope.$emit(coreConstant.event.ADVANCE_FOCUS, '.usernameInput');
    }
  }, 0));
  $scope.errorElement = '.usernameInput';
  function loadRevision() {
    coreMediator.getRevision().then(function (result) {
      $scope.viewModel.revisionNumber = result.revNumber;
    });
  }
  $scope.login = function () {
    var usernameIsValid = $scope.viewModel.loginForm.email.$valid,
      passwordIsValid = $scope.viewModel.loginForm.password.$valid,
      isFormValid = usernameIsValid && passwordIsValid,
      action = uiPerformanceLoggerConstant.LOGIN,
      message = '';
    function showErrorModal(message) {
      var modalInstance = $uibModal.open({
        templateUrl: '/ui/modal/errorModal/errorModal.tpl.html',
        controller: 'errorModalController',
        windowClass: 'genericErrorModal',
        backdrop: 'static',
        resolve: {
          options: {
            title: i18n.t('auth|login.messages.genericErrorTitle'),
            message: message,
            okButtonLabel: i18n.t('auth|login.okButtonLabel')
          }
        }
      });
    }
    function handleLoginSuccess() {
      $rootScope.$broadcast(coreConstant.event.BOOT_APPLICATION);
    }
    function handleError(error) {
      var action = uiPerformanceLoggerConstant.LOGIN,
        status = coreConstant.uiPeformanceLogger.FAIL;

      // If there was an error logging into the application, we need to end the ui performance log to clean
      // it up, but we don't want to send a request to the server to log the failure, because we aren't
      // authenticated...obviously :)
      $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG_WITHOUT_LOGGING, action, status);
      $scope.$emit(coreConstant.event.ADVANCE_FOCUS, '.usernameInput');
    }
    if (isFormValid) {
      if (appTypeConfigurationModel.getConsoleType() === coreConstant.authorization.CONSOLE_TYPE_UM_AGENT) {
        consoleTypeAuthorizationName = authorizationConstants.LOGIN_AGENT_WORKSPACE;
      } else if (appTypeConfigurationModel.getConsoleType() === coreConstant.authorization.CONSOLE_TYPE_UM_STUDIO) {
        consoleTypeAuthorizationName = authorizationConstants.LOGIN_CONFIGURATOR;
      }
      $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, action, message);
      coreMediator.login($scope.userName, $scope.password, coreConstant.authorization.INITIAL_TOKEN_TIMEOUT_SECONDS).then(handleLoginSuccess, handleError);
    } else {
      $scope.errorElement = !usernameIsValid ? '.usernameInput' : '.passwordInput';
      if (!usernameIsValid && !passwordIsValid) {
        message = i18n.t('auth|login.messages.userNamePasswordError');
      } else if (!usernameIsValid) {
        message = i18n.t('auth|login.messages.userNameError');
      } else if (!passwordIsValid) {
        message = i18n.t('auth|login.messages.passwordError');
      }
      showErrorModal(message);
    }
  };
  $scope.$on(coreConstant.event.EXPIRED_PASSWORD, function (event) {
    $state.go('password', {
      username: $scope.userName,
      messageKey: 'auth|changePassword.expiredPassword'
    });
  });
  var absoluteUrl = $location.absUrl().toLowerCase();
  if (_.includes(absoluteUrl, 'umagent')) {
    $rootScope.title = i18n.t('auth|login.umAgentPageTitle');
    $scope.loginTitle = i18n.t('auth|login.umAgentFormTitle');
  } else if (_.includes(absoluteUrl, 'umstudio')) {
    $rootScope.title = i18n.t('auth|login.umStudioPageTitle');
    $scope.loginTitle = i18n.t('auth|login.umStudioFormTitle');
  } else if (_.includes(absoluteUrl, 'appreader')) {
    $rootScope.title = i18n.t('auth|login.appReaderPageTitle');
    $scope.loginTitle = i18n.t('auth|login.appReaderFormTitle');
  } else {
    $rootScope.title = i18n.t('auth|login.uwPageTitle');
    $scope.loginTitle = i18n.t('auth|login.uwFormTitle');
  }
  $scope.forgotPassword = function () {
    authenticationMediator.showForgotPassword();
  };
  $scope.$on(coreConstant.event.MODAL_CLOSED, function (event) {
    $scope.$emit(coreConstant.event.ADVANCE_FOCUS, $scope.errorElement);
  });
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
  loadRevision();
  coreMediator.loadDefaultPreferences().then(function (preferences) {
    if (appTypeConfigurationModel.getConsoleType() === coreConstant.authorization.CONSOLE_TYPE_UM_AGENT && preferences['system.disablePasswordAndProfileManagementAgent'].value === 'false' || appTypeConfigurationModel.getConsoleType() === coreConstant.authorization.CONSOLE_TYPE_UM && preferences['system.disablePasswordAndProfileManagementUnderwriter'].value === 'false' || appTypeConfigurationModel.getConsoleType() === coreConstant.authorization.CONSOLE_TYPE_UM_STUDIO && preferences['system.disablePasswordAndProfileManagementConfigurator'].value === 'false') {
      $scope.viewModel.displayForgotPassword = true;
    }
  }.bind(this));
};
LoginController.$inject = ["$scope", "$state", "$rootScope", "$uibModal", "$location", "$stateParams", "$timeout", "appTypeConfigurationModel", "authorizationConstants", "coreConstant", "coreMediator", "localization", "uiPerformanceLoggerConstant", "authenticationMediator"];
angular.module('gw-um-auth').controller('loginController', LoginController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(18)["default"]))

/***/ }),
/* 1679 */
/***/ (function(module) {

module.exports = JSON.parse("{\"login\":{\"umStudioPageTitle\":\"UM Studio\",\"umStudioFormTitle\":\"Login to UM Studio\",\"umAgentPageTitle\":\"UM Agent\",\"umAgentFormTitle\":\"Login to UM Agent\",\"uwPageTitle\":\"Underwriting Management\",\"uwFormTitle\":\"Login to Underwriting Management™\",\"appReaderPageTitle\":\"AppReader\",\"appReaderFormTitle\":\"Login to AppReader\",\"loginButtonLabel\":\"Login\",\"usernameInputLabel\":\"User Name:\",\"passwordInputLabel\":\"Password:\",\"forgotPasswordButtonLabel\":\"Forgot Password\",\"revisionLabel\":\"Revision:\",\"unauthorizedAccessLabel\":\"Unauthorized Access is Prohibited\",\"okButtonLabel\":\"OK\",\"messages\":{\"genericErrorTitle\":\"Error\",\"Please enter username\":\"Veuillez entrer votre nom d'utilisateur\",\"userNameTooltip\":\"Please enter username\",\"passwordTooltip\":\"Enter your password\",\"passwordExpired\":\"Your password has expired. Please enter a new password.\",\"userNameError\":\"You must enter a username.\",\"passwordError\":\"You must enter a password.\",\"userNamePasswordError\":\"You must enter a username and password.\"}}}");

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 1681 */
/***/ (function(module, exports) {

var path = '/login/forgotPassword/forgotPassword.tpl.html';
var html = "<div class=\"forgotPasswordModalContent\">\n\n    <div class=\"mainContainer\">\n\n        <div class=\"header\">\n            <h3 ui-locale>auth|forgotPassword.title</h3>\n            <button class=\"close\"\n                    ng-click=\"$dismiss()\">\n                <span class=\"glyphicon glyphicon-remove\"></span>\n            </button>\n        </div>\n\n        <form role=\"form\">\n            <div class=\"drawer\">\n                <div class=\"drawerRow\">\n                    <div class=\"drawerCol\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.username}}\">\n                        </ui-required-indicator>\n                        <label ui-locale>auth|forgotPassword.usernameLabel</label>\n                        <span class=\"userName\">\n                            <input type=\"text\"\n                                   ui-max-chars=\"255\"\n                                   ng-model=\"viewModel.username\"\n                                   value=\"{{viewModel.username}}\"\n                                   tabindex=\"1\"/>\n                        </span>\n                    </div>\n                </div>\n\n                <div class=\"drawerRow\">\n                    <div class=\"drawerCol\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.emailAddress}}\">\n                        </ui-required-indicator>\n                        <label ui-locale>auth|forgotPassword.emailAddressLabel</label>\n                        <span class=\"emailAddress\">\n                            <input type=\"text\"\n                                   ui-max-chars=\"255\"\n                                   ng-model=\"viewModel.emailAddress\"\n                                   value=\"{{viewModel.emailAddress}}\"\n                                   tabindex=\"1\"\n                                   ui-enter=\"forgotPassword()\"/>\n                        </span>\n                    </div>\n                </div>\n            </div>\n        </form>\n    </div>\n\n    <!--Footer-->\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-primary forgotPasswordButton\"\n                ng-disabled=\"!validateFields()\"\n                ng-click=\"forgotPassword()\">\n            <span ui-locale>auth|forgotPassword.confirmButton</span></button>\n        <button class=\"btn btn-default cancelButton\"\n                ng-click=\"$close()\">\n            <span ui-locale>auth|forgotPassword.cancelButton</span></button>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(i18n) {/*@ngInject*/
var ForgotPasswordController = function ForgotPasswordController($scope, $uibModalInstance, modalUtil, coreMediator, localization) {
  localization.setupLocale('auth', __webpack_require__(1683));
  $scope.viewModel = {
    username: null,
    emailAddress: null
  };
  $scope.forgotPassword = function () {
    if ($scope.validateFields()) {
      coreMediator.forgotPassword($scope.viewModel.username, $scope.viewModel.emailAddress);
      $uibModalInstance.close();
      modalUtil.showGenericConfirm({
        title: i18n.t('auth|forgotPassword.title'),
        summary: i18n.t('auth|forgotPassword.summary'),
        confirmActionButtonLabel: i18n.t('auth|forgotPassword.okButton')
      });
    }
  };
  $scope.validateFields = function () {
    return $scope.viewModel.username && $scope.viewModel.emailAddress;
  };
};
ForgotPasswordController.$inject = ["$scope", "$uibModalInstance", "modalUtil", "coreMediator", "localization"];
angular.module('gw-um-auth').controller('forgotPasswordController', ForgotPasswordController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(18)["default"]))

/***/ }),
/* 1683 */
/***/ (function(module) {

module.exports = JSON.parse("{\"forgotPassword\":{\"title\":\"Forgot Password\",\"summary\":\"An email has been sent to you with instructions to reset your password\",\"usernameLabel\":\"Username:\",\"emailAddressLabel\":\"Email Address:\",\"confirmButton\":\"Forgot Password\",\"cancelButton\":\"Cancel\",\"okButton\":\"OK\"}}");

/***/ }),
/* 1684 */
/***/ (function(module, exports) {

(function () {
  'use strict';

  /*@ngInject*/
  var ForgotPasswordRepository = function ForgotPasswordRepository(baseRepository) {
    angular.extend(this, baseRepository);
    this.forgotPassword = function (username, emailAddress) {
      var url = '/rest/User/forgotPassword',
        payload = 'username=' + username + '&emailAddress=' + emailAddress,
        config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        };
      return this.post(url, payload, config);
    };
  };
  ForgotPasswordRepository.$inject = ["baseRepository"];
  angular.module('gw-um-auth').service('forgotPasswordRepository', ForgotPasswordRepository);
})();

/***/ }),
/* 1685 */
/***/ (function(module, exports) {

/*@ngInject*/
var LoginRepository = function LoginRepository(baseRepository, appTypeConfigurationModel, cryptoUtil) {
  var _this = this;
  angular.extend(this, baseRepository);
  this.login = function (username, password, timeoutSeconds, passwordIsToken, isExternalToken) {
    var url = '/rest/v2/Session',
      config = {
        params: {
          applicationId: appTypeConfigurationModel.getApplicationId(),
          timeoutSeconds: timeoutSeconds,
          passwordIsToken: passwordIsToken,
          isExternalToken: isExternalToken
        }
      },
      data = {
        userName: username,
        password: passwordIsToken ? password : cryptoUtil.encryptWithServerPublicKey(password)
      };
    return _this.post(url, data, config);
  };
  this.changePasswordAndLogin = function (username, oldPassword, newPassword, timeoutSeconds, passwordIsToken) {
    var url = '/rest/v2/Session',
      config = {
        params: {
          applicationId: appTypeConfigurationModel.getApplicationId(),
          timeoutSeconds: timeoutSeconds,
          passwordIsToken: passwordIsToken
        }
      },
      data = {
        userName: username,
        password: cryptoUtil.encryptWithServerPublicKey(newPassword),
        oldPassword: passwordIsToken ? oldPassword : cryptoUtil.encryptWithServerPublicKey(oldPassword)
      };
    return this.post(url, data, config);
  };
  this.logout = function () {
    var url = '/rest/Session';
    return _this.delete(url);
  };
  this.preDestroy = function () {
    var url = '/rest/Session/preDestroy';
    return _this.post(url);
  };
};
LoginRepository.$inject = ["baseRepository", "appTypeConfigurationModel", "cryptoUtil"];
angular.module('gw-um-auth').service('loginRepository', LoginRepository);

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 1687 */
/***/ (function(module, exports) {

var path = '/changePassword/changePassword.tpl.html';
var html = "<div class=\"changePassword\"\n     ui-focus-manager=\"changePasswordContainer\"\n     app-mode-configuration\n     ui-browser-detection\n     on-confirm=\"onConfirm()\"\n     on-cancel=\"onCancel()\">\n\n    <div class=\"changePasswordGroup\">\n        <div class=\"changePasswordContainer\">\n\n            <div class=\"formContainer\">\n\n                <div class=\"header\">\n                    <div class=\"firstBestCircleLogo\"\n                         ui-logo\n                         logo-configured-file-name=\"HTML Login Logo\">\n                    </div>\n                </div>\n\n                <form role=\"form\" autocomplete=\"off\">\n                    <fieldset>\n                        <div class=\"changePasswordMessage\">\n                            <label ui-locale\n                                   ng-if=\"viewModel.messageKey\">{{ viewModel.messageKey }}</label>\n                        </div>\n\n                        <div>\n                            <ui-required-indicator class=\"requiredIndicator\"\n                                                   value=\"{{ viewModel.username }}\">\n                            </ui-required-indicator>\n                            <label class=\"label\" ui-locale>auth|changePassword.usernameLabel</label>\n                            <label class=\"input\">\n\n                                <input class=\"usernameInput\"\n                                       type=\"text\"\n                                       ui-max-chars=\"255\"\n                                       ng-model=\"viewModel.username\"\n                                       value=\"{{ viewModel.username }}\"\n                                       tabindex=\"1\"\n                                       autocomplete=\"off\">\n                            </label>\n                        </div>\n\n                        <div ng-if=\"!viewModel.loginToken\">\n                            <ui-required-indicator class=\"requiredIndicator\"\n                                                   value=\"{{ viewModel.oldPassword }}\">\n                            </ui-required-indicator>\n                            <label class=\"label\" ui-locale>auth|changePassword.oldPasswordLabel</label>\n                            <label class=\"input\">\n                                <input class=\"oldPasswordInput\"\n                                       type=\"password\"\n                                       ui-max-chars=\"255\"\n                                       ng-model=\"viewModel.oldPassword\"\n                                       value=\"{{ viewModel.oldPassword }}\"\n                                       tabindex=\"1\"\n                                       autocomplete=\"off\">\n                            </label>\n                        </div>\n\n                        <div>\n                            <ui-required-indicator class=\"requiredIndicator\"\n                                                   value=\"{{ viewModel.newPassword }}\">\n                            </ui-required-indicator>\n                            <label class=\"label\" ui-locale>auth|changePassword.newPasswordLabel</label>\n                            <label class=\"input\">\n\n                                <input class=\"newPasswordInput\"\n                                       type=\"password\"\n                                       ui-max-chars=\"255\"\n                                       ng-model=\"viewModel.newPassword\"\n                                       value=\"{{ viewModel.newPassword }}\"\n                                       ng-focus=\"isNewPasswordFieldFocused=true\"\n                                       ng-blur=\"isNewPasswordFieldFocused=false\"\n                                       tabindex=\"1\"\n                                       autocomplete=\"off\">\n                            </label>\n                        </div>\n\n                        <div>\n                            <ui-required-indicator class=\"requiredIndicator\"\n                                                   value=\"{{ viewModel.verifyPassword }}\">\n                            </ui-required-indicator>\n                            <label class=\"label\" ui-locale>auth|changePassword.verifyPasswordLabel</label>\n                            <label class=\"input\">\n\n                                <input class=\"verifyNewPasswordInput\"\n                                       ng-class=\"{ error: true }\"\n                                       type=\"password\"\n                                       ui-max-chars=\"255\"\n                                       ng-model=\"viewModel.verifyPassword\"\n                                       value=\"{{ viewModel.verifyPassword }}\"\n                                       ng-focus=\"isVerifyPasswordFieldFocused=true\"\n                                       ng-blur=\"isVerifyPasswordFieldFocused=false\"\n                                       tabindex=\"1\"\n                                       autocomplete=\"off\">\n                            </label>\n                        </div>\n\n                        <div class=\"verifyPasswordMessage\">\n                            <label ui-locale\n                                   ng-if=\"isVerifyPasswordFieldInvalid()\">auth|changePassword.noMatch</label>\n                        </div>\n                    </fieldset>\n                </form>\n\n                <div class=\"footer\">\n                    <button class=\"btn btn-primary changePasswordButton\"\n                            ng-click=\"changePassword()\"\n                            ng-disabled=\"!validateFields()\">\n                        <span ui-locale>auth|changePassword.changePasswordButton</span>\n                    </button>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"revision\">\n            <span ui-locale>auth|changePassword.revision</span>:<span>{{ viewModel.revisionNumber }}</span>\n        </div>\n\n    </div>\n\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ChangePasswordController = function ChangePasswordController($rootScope, $scope, $location, $state, $stateParams, $window, coreConstant, coreMediator, loadingBarHandler, refreshLoginTokenUtil, authenticationMediator, localization) {
  localization.setupLocale('auth', __webpack_require__(1689));
  $scope.viewModel = {
    loginToken: $location.search().token,
    sourceClient: $location.search().source,
    userType: $location.search().userType,
    revisionNumber: '',
    username: $stateParams.username,
    oldPassword: $stateParams.oldPassword,
    messageKey: $stateParams.messageKey
  };
  coreMediator.getRevision().then(function (result) {
    $scope.viewModel.revisionNumber = result.revNumber;
  });
  $scope.validateFields = function () {
    return $scope.viewModel.username && $scope.viewModel.newPassword && $scope.viewModel.verifyPassword && $scope.viewModel.newPassword === $scope.viewModel.verifyPassword;
  };
  $scope.isVerifyPasswordFieldInvalid = function () {
    return !$scope.isVerifyPasswordFieldFocused && !$scope.isNewPasswordFieldFocused && $scope.viewModel.newPassword !== '' && $scope.viewModel.verifyPassword !== '' && $scope.viewModel.newPassword !== $scope.viewModel.verifyPassword;
  };
  $scope.changePassword = function () {
    var username = $scope.viewModel.username,
      loginToken = $scope.viewModel.loginToken,
      newPassword = $scope.viewModel.newPassword,
      oldPassword = $scope.viewModel.oldPassword;
    var onSuccess = function onSuccess(newLoginToken) {
      loadingBarHandler.hideLoadingBar();
      if (!_.isNil(newLoginToken) && ($scope.viewModel.sourceClient === 'html' || !$scope.viewModel.sourceClient)) {
        coreMediator.setLoginToken(newLoginToken);
        refreshLoginTokenUtil.start(newLoginToken).then(function () {
          $rootScope.$broadcast(coreConstant.event.BOOT_APPLICATION);
        });
      } else {
        $window.location.href = '../';
      }
    };
    var onError = function onError() {
      $scope.viewModel.newPassword = '';
      $scope.viewModel.verifyPassword = '';
      $scope.viewModel.oldPassword = '';
      $scope.viewModel.username = '';
    };
    loadingBarHandler.showLoadingBar('changePassword.loadingBar');
    authenticationMediator.changePasswordAndLogin(username, loginToken ? loginToken : oldPassword, newPassword, coreConstant.authorization.INITIAL_TOKEN_TIMEOUT_SECONDS, !_.isEmpty(loginToken)).then(onSuccess, onError);
  };
  $scope.onConfirm = function () {
    $scope.$close();
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
};
ChangePasswordController.$inject = ["$rootScope", "$scope", "$location", "$state", "$stateParams", "$window", "coreConstant", "coreMediator", "loadingBarHandler", "refreshLoginTokenUtil", "authenticationMediator", "localization"];
angular.module('gw-um-auth').controller('changePasswordController', ChangePasswordController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1689 */
/***/ (function(module) {

module.exports = JSON.parse("{\"changePassword\":{\"usernameLabel\":\"User Name:\",\"oldPasswordLabel\":\"Old Password:\",\"newPasswordLabel\":\"New Password:\",\"verifyPasswordLabel\":\"Verify Password:\",\"title\":\"Change Password\",\"changePasswordButton\":\"Change Password\",\"cancelButton\":\"Cancel\",\"loadingBar\":\"Updating...\",\"noMatch\":\"The passwords do not match. Please re-enter them.\",\"samePassword\":\"The new password must be different from the old password. Please re-enter.\",\"expiredPassword\":\"Your password has expired. Please enter a new password.\",\"revision\":\"Revision:\"}}");

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 1691 */
/***/ (function(module, exports) {

var path = '/changePasswordModal/changePasswordModal.tpl.html';
var html = "<base-modal\n    modal-title=\"title\"\n    ok=\"okButton\"\n    cancel=\"cancelButton\"\n    on-confirm=\"onConfirm()\"\n    is-confirm-disabled=\"!canEnableConfirmButton()\"\n    on-cancel=\"onCancel()\"\n    class=\"changePasswordModal\">\n\n    <form role=\"form\"\n          novalidate\n          >\n        <div class=\"drawer\">\n            <div class=\"drawerRow\">\n                <div class=\"drawerCol\">\n                    <ui-required-indicator class=\"requiredIndicator\"\n                                           value=\"{{viewModel.oldPassword}}\">\n                    </ui-required-indicator>\n                    <label ui-locale>auth|changePasswordModal.oldPasswordLabel</label>\n                    <span>\n                    <input class= \"oldPasswordText\"\n                           type=\"password\"\n                           required\n                           ui-max-chars=\"255\"\n                           ng-model=\"viewModel.oldPassword\"\n                           value=\"{{viewModel.oldPassword}}\"\n                           tabindex=\"1\"\n                           autocomplete=\"off\"/>\n                </span>\n                </div>\n            </div>\n\n            <div class=\"drawerRow\">\n                <div class=\"drawerCol\">\n                    <ui-required-indicator class=\"requiredIndicator\"\n                                           value=\"{{viewModel.newPassword}}\">\n                    </ui-required-indicator>\n                    <label ui-locale>auth|changePasswordModal.newPasswordLabel</label>\n                    <span class=\"newPassword\">\n                    <input class= \"newPasswordText\"\n                           type=\"password\"\n                           required\n                           ui-max-chars=\"255\"\n                           ng-model=\"viewModel.newPassword\"\n                           value=\"{{viewModel.newPassword}}\"\n                           ng-focus=\"isNewPasswordFieldFocused=true\"\n                           ng-blur=\"isNewPasswordFieldFocused=false\"\n                           tabindex=\"1\"\n                           autocomplete=\"off\"/>\n\n                    <label ui-locale\n                           ng-if=\"isNewPasswordFieldInvalid()\">auth|changePasswordModal.samePassword</label>\n                </span>\n                </div>\n            </div>\n\n            <div class=\"drawerRow\">\n                <div class=\"drawerCol\">\n                    <ui-required-indicator class=\"requiredIndicator\"\n                                           value=\"{{viewModel.verifyPassword}}\">\n                    </ui-required-indicator>\n                    <label ui-locale>auth|changePasswordModal.verifyPasswordLabel</label>\n                    <span class=\"newPassword\">\n                    <input class= \"verifyNewPasswordText\"\n                           type=\"password\"\n                           required\n                           ui-max-chars=\"255\"\n                           ng-model=\"viewModel.verifyPassword\"\n                           value=\"{{viewModel.verifyPassword}}\"\n                           ng-focus=\"isVerifyPasswordFieldFocused=true\"\n                           ng-blur=\"isVerifyPasswordFieldFocused=false\"\n                           tabindex=\"1\"\n                           autocomplete=\"off\"/>\n                    <label ui-locale\n                           ng-if=\"isVerifyPasswordFieldInvalid()\">auth|changePasswordModal.noMatch</label>\n                </span>\n\n                </div>\n            </div>\n        </div>\n    </form>\n\n</base-modal>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(i18n) {/*@ngInject*/
var ChangePasswordModalController = function ChangePasswordModalController($rootScope, $scope, $uibModalInstance, localization, coreConstant, coreMediator, loadingBarHandler, currentUserModel, authenticationMediator) {
  localization.setupLocale('auth', __webpack_require__(1693));
  $scope.title = i18n.t('auth|changePasswordModal.title');
  $scope.cancelButton = i18n.t('auth|changePasswordModal.cancelButton');
  $scope.okButton = i18n.t('auth|changePasswordModal.changePasswordButton');
  $scope.isNewPasswordFieldFocused = false;
  $scope.isVerifyPasswordFieldFocused = false;
  $scope.viewModel = {
    oldPassword: '',
    newPassword: '',
    verifyPassword: ''
  };
  $scope.onConfirm = function () {
    loadingBarHandler.showLoadingBar('changePassword.loadingBar');
    authenticationMediator.changePassword(currentUserModel.getCurrentUser().userName, $scope.viewModel.oldPassword, $scope.viewModel.newPassword).then(function (newLoginToken) {
      coreMediator.setLoginToken(newLoginToken);
      loadingBarHandler.hideLoadingBar();
      $uibModalInstance.close();
    }, function () {
      $scope.viewModel.newPassword = '';
      $scope.viewModel.oldPassword = '';
      $scope.viewModel.verifyPassword = '';
    });
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  $scope.canEnableConfirmButton = function () {
    var isValid = $scope.viewModel.newPassword && $scope.viewModel.oldPassword && $scope.viewModel.verifyPassword && $scope.viewModel.newPassword !== $scope.viewModel.oldPassword && $scope.viewModel.newPassword === $scope.viewModel.verifyPassword;
    return isValid;
  };
  $scope.isNewPasswordFieldInvalid = function () {
    return !$scope.isNewPasswordFieldFocused && $scope.viewModel.newPassword !== '' && $scope.viewModel.oldPassword !== '' && $scope.viewModel.newPassword === $scope.viewModel.oldPassword;
  };
  $scope.isVerifyPasswordFieldInvalid = function () {
    return !$scope.isVerifyPasswordFieldFocused && $scope.viewModel.newPassword !== '' && $scope.viewModel.verifyPassword !== '' && $scope.viewModel.newPassword !== $scope.viewModel.verifyPassword;
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
ChangePasswordModalController.$inject = ["$rootScope", "$scope", "$uibModalInstance", "localization", "coreConstant", "coreMediator", "loadingBarHandler", "currentUserModel", "authenticationMediator"];
angular.module('gw-um-auth').controller('changePasswordModalController', ChangePasswordModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(18)["default"]))

/***/ }),
/* 1693 */
/***/ (function(module) {

module.exports = JSON.parse("{\"changePasswordModal\":{\"usernameLabel\":\"User Name:\",\"oldPasswordLabel\":\"Old Password:\",\"newPasswordLabel\":\"New Password:\",\"verifyPasswordLabel\":\"Verify Password:\",\"title\":\"Change Password\",\"changePasswordButton\":\"Change Password\",\"cancelButton\":\"Cancel\",\"loadingBar\":\"Updating...\",\"noMatch\":\"The passwords do not match. Please re-enter them.\",\"samePassword\":\"The new password must be different from the old password. Please re-enter.\",\"expiredPassword\":\"Your password has expired. Please enter a new password.\"}}");

/***/ }),
/* 1694 */
/***/ (function(module, exports) {

module.exports = "function _typeof(o) { \"@babel/helpers - typeof\"; return _typeof = \"function\" == typeof Symbol && \"symbol\" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && \"function\" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? \"symbol\" : typeof o; }, _typeof(o); }\n/*!\n* ux-angularjs-datagrid v.1.6.13\n* (c) 2018, Obogo\n* https://github.com/obogo/ux-angularjs-datagrid\n* License: MIT.\n*/\n(function (exports, global) {\n  if (typeof define === \"function\" && define.amd) {\n    define(exports);\n  } else if (typeof module !== \"undefined\" && module.exports) {\n    module.exports = exports;\n  } else {\n    global.ux = exports;\n  }\n\n  /*!\n  * ux-angularjs-datagrid v.1.6.13\n  * (c) 2018, Obogo\n  * https://github.com/obogo/ux-angularjs-datagrid\n  * License: MIT.\n  */\n  (function (exports, global) {\n    global[\"util\"] = exports;\n    var define,\n      internal,\n      finalize = function finalize() {};\n    (function () {\n      var get,\n        defined,\n        pending,\n        definitions,\n        initDefinition,\n        $cachelyToken = \"~\",\n        $depsRequiredByDefinitionToken = \".\";\n      get = Function[$cachelyToken] = Function[$cachelyToken] || function (name) {\n        if (!get[name]) {\n          get[name] = {};\n        }\n        return get[name];\n      };\n      definitions = get(\"c\");\n      defined = get(\"d\");\n      pending = get(\"p\");\n      initDefinition = function initDefinition(name) {\n        if (defined[name]) {\n          return;\n        }\n        var args = arguments;\n        var val = args[1];\n        if (typeof val === \"function\") {\n          defined[name] = val();\n        } else {\n          definitions[name] = args[2];\n          definitions[name][$depsRequiredByDefinitionToken] = val;\n        }\n      };\n      define = internal = function internal() {\n        initDefinition.apply(null, arguments);\n      };\n      resolve = function (_resolve) {\n        function resolve(_x, _x2) {\n          return _resolve.apply(this, arguments);\n        }\n        resolve.toString = function () {\n          return _resolve.toString();\n        };\n        return resolve;\n      }(function (name, fn) {\n        pending[name] = true;\n        var deps = fn[$depsRequiredByDefinitionToken];\n        var args = [];\n        var i, len;\n        var dependencyName;\n        if (deps) {\n          len = deps.length;\n          for (i = 0; i < len; i++) {\n            dependencyName = deps[i];\n            if (definitions[dependencyName]) {\n              if (!pending.hasOwnProperty(dependencyName)) {\n                resolve(dependencyName, definitions[dependencyName]);\n              }\n              resolve(dependencyName, definitions[dependencyName]);\n              delete definitions[dependencyName];\n            }\n          }\n        }\n        if (!defined.hasOwnProperty(name)) {\n          for (i = 0; i < len; i++) {\n            dependencyName = deps[i];\n            args.push(defined.hasOwnProperty(dependencyName) && defined[dependencyName]);\n          }\n          defined[name] = fn.apply(null, args);\n        }\n        delete pending[name];\n      });\n      finalize = function finalize() {\n        for (var name in definitions) {\n          resolve(name, definitions[name]);\n        }\n      };\n      return define;\n    })();\n    //! ################# YOUR CODE STARTS HERE #################### //\n    //! node_modules/hbjs/src/utils/validators/isArguments.js\n    define(\"isArguments\", function () {\n      var toString = function toString() {\n        var value = [];\n        for (var e in this) {\n          if (this.hasOwnProperty(e)) {\n            value.push(\"\" + e);\n          }\n        }\n        return \"[\" + value.join(\", \") + \"]\";\n      };\n      var isArguments = function isArguments(value) {\n        var str = String(value);\n        var isArguments = str === \"[object Arguments]\";\n        if (!isArguments) {\n          isArguments = str !== \"[object Array]\" && value !== null && _typeof(value) === \"object\" && typeof value.length === \"number\" && value.length >= 0 && (!value.callee || toString.call(value.callee) === \"[object Function]\");\n        }\n        return isArguments;\n      };\n      return isArguments;\n    });\n    //! util/hb/src/api.js\n    define(\"dg.api\", [\"isMatch\", \"apply\", \"toArray\", \"sort\", \"dispatcher\", \"matchAll\"], function (isMatch, apply, toArray, sort, dispatcher, matchAll) {\n      exports.isMatch = isMatch;\n      exports.apply = apply;\n      exports.dispatcher = dispatcher;\n      exports.matchAll = matchAll;\n      exports.array = {\n        toArray: toArray,\n        sort: sort\n      };\n    });\n    //! node_modules/hbjs/src/utils/validators/isRegExp.js\n    define(\"isRegExp\", function () {\n      var isRegExp = function isRegExp(value) {\n        return Object.prototype.toString.call(value) === \"[object RegExp]\";\n      };\n      return isRegExp;\n    });\n    //! node_modules/hbjs/src/utils/validators/isDate.js\n    define(\"isDate\", function () {\n      var isDate = function isDate(val) {\n        return val instanceof Date;\n      };\n      return isDate;\n    });\n    //! node_modules/hbjs/src/utils/data/apply.js\n    define(\"apply\", [\"isFunction\"], function (isFunction) {\n      return function (func, scope, args) {\n        if (!isFunction(func)) {\n          return;\n        }\n        args = args || [];\n        switch (args.length) {\n          case 0:\n            return func.call(scope);\n          case 1:\n            return func.call(scope, args[0]);\n          case 2:\n            return func.call(scope, args[0], args[1]);\n          case 3:\n            return func.call(scope, args[0], args[1], args[2]);\n          case 4:\n            return func.call(scope, args[0], args[1], args[2], args[3]);\n          case 5:\n            return func.call(scope, args[0], args[1], args[2], args[3], args[4]);\n          case 6:\n            return func.call(scope, args[0], args[1], args[2], args[3], args[4], args[5]);\n        }\n        return func.apply(scope, args);\n      };\n    });\n    //! node_modules/hbjs/src/utils/validators/isFunction.js\n    define(\"isFunction\", function () {\n      var isFunction = function isFunction(val) {\n        return typeof val === \"function\";\n      };\n      return isFunction;\n    });\n    //! node_modules/hbjs/src/utils/formatters/toArray.js\n    define(\"toArray\", [\"isArguments\", \"isArray\", \"isUndefined\"], function (isArguments, isArray, isUndefined) {\n      var toArray = function toArray(value) {\n        if (isArguments(value)) {\n          return Array.prototype.slice.call(value, 0) || [];\n        }\n        try {\n          if (isArray(value)) {\n            return value;\n          }\n          if (!isUndefined(value)) {\n            return [].concat(value);\n          }\n        } catch (e) {}\n        return [];\n      };\n      return toArray;\n    });\n    //! node_modules/hbjs/src/utils/validators/isMatch.js\n    define(\"isMatch\", [\"isRegExp\", \"isDate\"], function (isRegExp, isDate) {\n      var primitive = [\"string\", \"number\", \"boolean\"];\n      function isMatch(item, filterObj) {\n        var itemType;\n        if (item === filterObj) {\n          return true;\n        } else if (_typeof(filterObj) === \"object\") {\n          itemType = _typeof(item);\n          if (primitive.indexOf(itemType) !== -1) {\n            if (isRegExp(filterObj) && !filterObj.test(item + \"\")) {\n              return false;\n            } else if (isDate(filterObj)) {\n              if (isDate(item) && filterObj.getTime() === item.getTime()) {\n                return true;\n              }\n              return false;\n            }\n          }\n          if (item instanceof Array && filterObj[0] !== undefined) {\n            for (var i = 0; i < item.length; i += 1) {\n              if (isMatch(item[i], filterObj[0])) {\n                return true;\n              }\n            }\n            return false;\n          } else {\n            for (var j in filterObj) {\n              if (filterObj.hasOwnProperty(j)) {\n                if (item[j] === undefined && !item.hasOwnProperty(j)) {\n                  return false;\n                }\n                if (!isMatch(item[j], filterObj[j])) {\n                  return false;\n                }\n              }\n            }\n          }\n          return true;\n        } else if (typeof filterObj === \"function\") {\n          return !!filterObj(item);\n        }\n        return false;\n      }\n      return isMatch;\n    });\n    //! node_modules/hbjs/src/utils/validators/isArray.js\n    define(\"isArray\", function () {\n      Array.prototype.__isArray = true;\n      Object.defineProperty(Array.prototype, \"__isArray\", {\n        enumerable: false,\n        writable: true\n      });\n      var isArray = function isArray(val) {\n        return val ? !!val.__isArray : false;\n      };\n      return isArray;\n    });\n    //! node_modules/hbjs/src/utils/validators/isUndefined.js\n    define(\"isUndefined\", function () {\n      var isUndefined = function isUndefined(val) {\n        return typeof val === \"undefined\";\n      };\n      return isUndefined;\n    });\n    //! node_modules/hbjs/src/utils/array/sort.js\n    define(\"sort\", function () {\n      function partition(array, left, right, compareFunction) {\n        var cmp = array[right - 1],\n          minEnd = left,\n          maxEnd,\n          dir = 0;\n        for (maxEnd = left; maxEnd < right - 1; maxEnd += 1) {\n          dir = compareFunction(array[maxEnd], cmp);\n          if (dir < 0) {\n            if (maxEnd !== minEnd) {\n              swap(array, maxEnd, minEnd);\n            }\n            minEnd += 1;\n          }\n        }\n        if (compareFunction(array[minEnd], cmp)) {\n          swap(array, minEnd, right - 1);\n        }\n        return minEnd;\n      }\n      function swap(array, i, j) {\n        var temp = array[i];\n        array[i] = array[j];\n        array[j] = temp;\n        return array;\n      }\n      function quickSort(array, left, right, fn) {\n        if (left < right) {\n          var p = partition(array, left, right, fn);\n          quickSort(array, left, p, fn);\n          quickSort(array, p + 1, right, fn);\n        }\n        return array;\n      }\n      return function (array, compareFunction) {\n        var result = quickSort(array, 0, array.length, compareFunction);\n        return result;\n      };\n    });\n    //! node_modules/hbjs/src/utils/async/dispatcher.js\n    define(\"dispatcher\", [\"apply\", \"isFunction\", \"dispatcherEvent\"], function (apply, isFunction, Event) {\n      function validateEvent(e) {\n        if (!e) {\n          throw Error(\"event cannot be undefined\");\n        }\n      }\n      var dispatcher = function dispatcher(target, scope, map) {\n        if (target && target.on && target.on.dispatcher) {\n          return target;\n        }\n        target = target || {};\n        var listeners = {};\n        function getIndexOfListener(event, callback) {\n          var list = listeners[event];\n          if (list) {\n            for (var i = 0; i < list.length; i += 1) {\n              if (list[i].cb === callback) {\n                return i;\n              }\n            }\n          }\n          return -1;\n        }\n        function off(event, callback) {\n          validateEvent(event);\n          var index = getIndexOfListener(event, callback),\n            list = listeners[event];\n          if (index !== -1) {\n            list.splice(index, 1);\n          }\n        }\n        function on(event, callback, priority) {\n          if (isFunction(callback)) {\n            validateEvent(event);\n            listeners[event] = listeners[event] || [];\n            listeners[event].push({\n              cb: callback,\n              priority: priority !== undefined ? priority : 10\n            });\n            listeners[event].sort(prioritySort);\n            return function () {\n              off(event, callback);\n            };\n          }\n        }\n        on.dispatcher = true;\n        function once(event, callback, priority) {\n          if (isFunction(callback)) {\n            validateEvent(event);\n            function fn() {\n              off(event, fn);\n              apply(callback, scope || target, arguments);\n            }\n            return on(event, fn, priority);\n          }\n        }\n        function prioritySort(a, b) {\n          return a.priority - b.priority;\n        }\n        function mapListeners(item, number, list) {\n          list[number] = item.cb;\n        }\n        function getListeners(event, strict) {\n          validateEvent(event);\n          var list,\n            a = \"*\";\n          if (event || strict) {\n            list = [];\n            if (listeners[a]) {\n              list = listeners[a].concat(list);\n            }\n            if (listeners[event]) {\n              list = listeners[event].concat(list);\n            }\n            list.map(mapListeners);\n            return list;\n          }\n          return listeners;\n        }\n        function removeAllListeners() {\n          listeners = {};\n        }\n        function fire(callback, args) {\n          return callback && apply(callback, target, args);\n        }\n        function dispatch(event) {\n          validateEvent(event);\n          var list = getListeners(event, true),\n            len = list.length,\n            i,\n            event = _typeof(event) === \"object\" ? event : new Event(event);\n          if (len) {\n            arguments[0] = event;\n            for (i = 0; i < len; i += 1) {\n              if (!event.immediatePropagationStopped) {\n                fire(list[i], arguments);\n              }\n            }\n          }\n          return event;\n        }\n        if (scope && map) {\n          target.on = scope[map.on] && scope[map.on].bind(scope);\n          target.off = scope[map.off] && scope[map.off].bind(scope);\n          target.once = scope[map.once] && scope[map.once].bind(scope);\n          target.dispatch = target.fire = scope[map.dispatch].bind(scope);\n        } else {\n          target.on = on;\n          target.off = off;\n          target.once = once;\n          target.dispatch = target.fire = dispatch;\n        }\n        target.getListeners = getListeners;\n        target.removeAllListeners = removeAllListeners;\n        return target;\n      };\n      return dispatcher;\n    });\n    //! node_modules/hbjs/src/utils/async/dispatcher-event.js\n    define(\"dispatcherEvent\", function () {\n      function Event(type) {\n        this.type = type;\n        this.defaultPrevented = false;\n        this.propagationStopped = false;\n        this.immediatePropagationStopped = false;\n      }\n      Event.prototype.preventDefault = function () {\n        this.defaultPrevented = true;\n      };\n      Event.prototype.stopPropagation = function () {\n        this.propagationStopped = true;\n      };\n      Event.prototype.stopImmediatePropagation = function () {\n        this.immediatePropagationStopped = true;\n      };\n      Event.prototype.toString = function () {\n        return this.type;\n      };\n      return Event;\n    });\n    //! node_modules/hbjs/src/utils/iterators/matchAll.js\n    define(\"matchAll\", [\"isMatch\"], function (isMatch) {\n      function matchAll(ary, filterObj) {\n        var result = [];\n        for (var i = 0; i < ary.length; i += 1) {\n          if (isMatch(ary[i], filterObj)) {\n            result.push(ary[i]);\n          }\n        }\n        return result;\n      }\n      return matchAll;\n    });\n    //! #################  YOUR CODE ENDS HERE  #################### //\n    finalize();\n    return global[\"util\"];\n  })(this[\"util\"] || {}, function () {\n    return exports;\n  }());\n  exports.errors = {\n    E1000: \"Datagrid cannot have a height of 0\",\n    E1001: \"RENDER STATE INVALID. The only valid render states are those on ux.datagrid.states\",\n    E1002: \"Unable to render. Invalid activeRange.\",\n    E1101: \"Script templates that are used for datagrid rows must have a height greater than 0. This may be because the grid is not yet attached to the dom preventing it from calculating heights.\",\n    E1102: \"at least one template is required. There were no row templates found for the datagrid.\"\n  };\n\n  /**\n   * ## Configs ##\n   * ux.datagrid is a highly performant scrolling list for desktop and mobile devices that leverages\n   * the browsers ability to gpu cache the dom structure with fast startup times and optimized rendering\n   * that allows the gpu to maintain its snapshots as long as possible.\n   *\n   * Create the default module of ux if it doesn't already exist.\n   */\n  var ngModule,\n    isIOS = !!navigator.userAgent.match(/(iPad|iPhone|iPod)/g);\n  var isNoInlineStyle = function () {\n    var csp = angular.$$csp();\n    if (angular.isObject(csp)) {\n      // angular: >=1.4.4\n      return csp.noInlineStyle;\n    }\n    // angular: >=1.2.0 <1.4.4\n    return csp;\n  }();\n  try {\n    ngModule = angular.module(\"ux\", [\"ng\"]);\n  } catch (e) {\n    ngModule = angular.module(\"ux\");\n  }\n\n  /**\n   * Create the datagrid namespace.\n   * add the default options for the datagrid. These can be overridden by passing your own options to each\n   * instance of the grid. In your HTML templates you can provide the object that will override these settings\n   * on a per grid basis.\n   *\n   *      <div ux-datagrid=\"mylist\"\n   *          options=\"{debug:{all:1, Flow:0}}\">...</div>\n   *\n   * These options are then available to other addons to configure them.\n   */\n  exports.datagrid = {\n    /**\n     * ###<a name=\"version\">version</a>###\n     * Current datagrid version.\n     */\n    version: \"1.6.13\",\n    /**\n     * ###<a name=\"isIOS\">isIOS</a>###\n     * iOS does not natively support smooth scrolling without a css attribute. `-webkit-overflow-scrolling: touch`\n     * however with this attribute iOS would crash if you try to change the scroll with javascript, or turn it on and off.\n     * So a [virtualScroll](#virtualScroll) was implemented for iOS to make it scroll using translate3d.\n     */\n    isIOS: isIOS,\n    /**\n     * ###<a name=\"isNoInlineStyle\">isNoInlineStyle</a>###\n     * If you're using a strict Content Securiy Policy (CSP), which forbids the use of `style`-attributes, the datagrid has to set some styles via the CSS Object Model (CSSOM).\n     */\n    isNoInlineStyle: isNoInlineStyle,\n    /**\n     * ###<a name=\"states\">states</a>###\n     *  - **<a name=\"states.BUILDING\">BUILDING</a>**: is the startup phase of the grid before it is ready to perform the first render. This may include\n     * waiting for the dom heights be available.\n     *  - **<a name=\"states.ON_READY\">ON_READY</a>**: this means that the grid is ready for rendering.\n     */\n    states: {\n      BUILDING: \"datagrid:building\",\n      READY: \"datagrid:ready\"\n    },\n    /**\n     * ###<a name=\"events\">events</a>###\n     * The events are in three categories based on if they notify of something that happened in the grid then they\n     * start with an ON_ or if they are driving the behavior of the datagrid, or they are logging events.\n     * #### Notifying Events ####\n     * - **<a name=\"events.ON_INIT\">ON_INIT</a>** when the datagrid has added the addons and is now starting.\n     * - **<a name=\"events.ON_LISTENERS_READY\">ON_LISTENERS_READY</a>** Datagrid is now listening. Feel free to fire your events that direct it's behavior.\n     * - **<a name=\"events.ON_READY\">ON_READY</a>** the datagrid is all setup with templates, viewHeight, and data and is ready to render.\n     * - **<a name=\"events.ON_STARTUP_COMPLETE\">ON_STARTUP_COMPLETE</a>** when the datagrid has finished its first render.\n     * - **<a name=\"events.ON_BEFORE_RENDER\">ON_BEFORE_RENDER</a>** the datagrid is just about to add needed chunks, perform compiling of uncompiled rows, and update and digest the active scopes.\n     * - **<a name=\"events.ON_AFTER_RENDER\">ON_AFTER_RENDER</a>** chunked dome was added if needed, active rows are compiled, and active scopes are digested.\n     * - **<a name=\"events.ON_BEFORE_UPDATE_WATCHERS\">ON_BEFORE_UPDATE_WATCHERS</a>** Before the active set of watchers is changed.\n     * - **<a name=\"events.ON_AFTER_UPDATE_WATCHERS\">ON_AFTER_UPDATE_WATCHERS</a>** After the active set of watchers is changed and digested and activeRange is updated.\n     * - **<a name=\"events.ON_BEFORE_DATA_CHANGE\">ON_BEFORE_DATA_CHANGE</a>** A data change watcher has fired. The change has not happened yet.\n     * - **<a name=\"events.ON_BEFORE_RENDER_AFTER_DATA_CHANGE\">ON_BEFORE_RENDER_AFTER_DATA_CHANGE</a>** When ever a data change is fired. Just before the render happens.\n     * - **<a name=\"events.ON_RENDER_AFTER_DATA_CHANGE\">ON_RENDER_AFTER_DATA_CHANGE</a>** When a render finishes and a data change was what caused it.\n     * - **<a name=\"events.ON_ROW_TEMPLATE_CHANGE\">ON_ROW_TEMPLATE_CHANGE</a>** When we change the template that is matched with the row.\n     * - **<a name=\"events.ON_SCROLL\">ON_SCROLL</a>** When a scroll change is captured by the datagrid.\n     * - **<a name=\"events.ON_BEFORE_RESET\">ON_BEFORE_RESET</a>** Before the dom is reset this event is fired. Every addon should listen to this event and clean up any listeners\n     * that are necessary when this happens so the dom can be cleaned up for the reset.\n     * - **<a name=\"events.ON_AFTER_RESET\">ON_AFTER_RESET</a>** After the reset the listeners from the addon can be put back on allowing the reset data to have been completely cleared.\n     */\n    events: {\n      ON_INIT: \"datagrid:onInit\",\n      ON_LISTENERS_READY: \"datagrid:onListenersReady\",\n      ON_READY: \"datagrid:onReady\",\n      ON_STARTUP_COMPLETE: \"datagrid:onStartupComplete\",\n      ON_BEFORE_RENDER: \"datagrid:onBeforeRender\",\n      ON_AFTER_RENDER: \"datagrid:onAfterRender\",\n      ON_BEFORE_UPDATE_WATCHERS: \"datagrid:onBeforeUpdateWatchers\",\n      ON_AFTER_UPDATE_WATCHERS: \"datagrid:onAfterUpdateWatchers\",\n      ON_BEFORE_DATA_CHANGE: \"datagrid:onBeforeDataChange\",\n      ON_AFTER_DATA_CHANGE: \"datagrid:onAfterDataChange\",\n      ON_BEFORE_RENDER_AFTER_DATA_CHANGE: \"datagrid:onBeforeRenderAfterDataChange\",\n      ON_RENDER_AFTER_DATA_CHANGE: \"datagrid:onRenderAfterDataChange\",\n      ON_ROW_TEMPLATE_CHANGE: \"datagrid:onRowTemplateChange\",\n      ON_SCROLL: \"datagrid:onScroll\",\n      ON_BEFORE_RESET: \"datagrid:onBeforeReset\",\n      ON_AFTER_RESET: \"datagrid:onAfterReset\",\n      ON_AFTER_HEIGHTS_UPDATED: \"datagrid:onAfterHeightsUpdated\",\n      ON_AFTER_HEIGHTS_UPDATED_RENDER: \"datagrid:onAfterHeightsUpdatedRender\",\n      ON_BEFORE_ROW_DEACTIVATE: \"datagrid:onBeforeRowDeactivate\",\n      // handy for knowing when to remove jquery listeners.\n      ON_AFTER_ROW_ACTIVATE: \"datagrid:onAFterRowActivate\",\n      // handy for turning jquery listeners back on.\n      ON_ROW_COMPILE: \"datagrid:onRowCompile\",\n      ON_SCROLL_TO_TOP: \"datagrid:onScrollToTop\",\n      ON_SCROLL_TO_BOTTOM: \"datagrid:onScrollToBottom\",\n      /**\n       * #### Driving Events ####\n       * - **<a name=\"events.RESIZE\">RESIZE</a>** tells the datagrid to resize. This will update all height calculations.\n       * - **<a name=\"events.UPDATE\">UPDATE</a>** force the datagrid to re-evaluate the data and render.\n       * - **<a name=\"events.SCROLL_TO_INDEX\">SCROLL_TO_INDEX</a>** scroll the item at that index to the top.\n       * - **<a name=\"events.SCROLL_TO_ITEM\">SCROLL_TO_ITEM</a>** scroll that item to the top.\n       * - **<a name=\"events.SCROLL_INTO_VIEW\">SCROLL_INTO_VIEW</a>** if the item is above the scroll area, scroll it to the top. If is is below scroll it to the bottom. If it is in the middle, do nothing.\n       */\n      RESIZE: \"datagrid:resize\",\n      UPDATE: \"datagrid:update\",\n      SCROLL_TO_INDEX: \"datagrid:scrollToIndex\",\n      SCROLL_TO_ITEM: \"datagrid:scrollToItem\",\n      SCROLL_INTO_VIEW: \"datagrid:scrollIntoView\",\n      /**\n       * #### Log Events ####\n       * - **<a name=\"events.LOG\">LOG</a>** An event to be picked up if the gridLogger is added to the addons or any other listener for logging.\n       * - **<a name=\"events.INFO\">INFO</a>** An event to be picked up if the gridLogger is added to the addons or any other listener for logging.\n       * - **<a name=\"events.WARN\">WARN</a>** An event to be picked up if the gridLogger is added to the addons or any other listener for logging.\n       * - **<a name=\"events.ERROR\">ERROR</a>** An event to be picked up if the gridLogger is added to the addons or any other listener for logging.\n       */\n      LOG: \"datagrid:log\",\n      INFO: \"datagrid:info\",\n      WARN: \"datagrid:warn\",\n      ERROR: \"datagrid:error\"\n    },\n    getGrid: function getGrid(scope) {\n      var result;\n      while (scope) {\n        if (scope.datagrid) {\n          return scope.datagrid;\n        } else if (scope.$$childHead) {\n          result = exports.datagrid.getGrid(scope.$$childHead);\n          if (result) {\n            return result;\n          }\n        }\n        scope = scope.$$nextSibling;\n      }\n      return null;\n    },\n    throwError: function throwError(msg) {\n      if (window.console && console.warn) {\n        console.warn(msg);\n      }\n    },\n    /**\n     * ###<a name=\"options\">options</a>###\n     */\n    options: {\n      // - **<a name=\"options.asyc\">async</a>** this changes the flow manager into not allowing async actions to allow unti tests to perform synchronously.\n      async: true,\n      // - **<a name=\"options.updateDelay\">updateDelay</a>** used by the scrollModel so that it gives cushion after the grid has stopped scrolling before rendering.\n      // while faster times on this make it render faster, it can cause it to rencer multiple times because the scrollbar is not completely stopped and may decrease\n      // scrolling performance. if < 100ms this fires too often.\n      updateDelay: 100,\n      // - **<a name=\"options.creepRender.enable\">creepRender.enable</a>** allow the rendering after the scrolling has stopped to creep in both directions away from the\n      // visible area. This can affect performance in a couple of ways. It will make it so more rows are rendered so scrolling will not have to wait for them, however if\n      // the device is slower this may affect performance in scrolling because the render has to finish before the touch events will work causing a delay in reaction to\n      // touch events.\n      creepRender: {\n        enable: true\n      },\n      // - **<a name=\"creepStartDelay\">creepStartDelay</a>**\n      // when the creep render starts. How long after the scrolling has stopped.\n      creepStartDelay: 50,\n      // - **<a name=\"options.cushion\">cushion</a>** this it used by the updateRowWatchers and what rows it will update. It can be handy for debugging to make sure only\n      // the correct rows are digesting by making the value positive it will take off space from the top and bottom of the viewport that number of pixels to match what\n      // rows are activated and which ones are not. Also a negative number will cause the grid to render past the viewable area and digest rows that are out of view.\n      // In short it is a debugging cushion about what is activated to see them working.\n      cushion: -100,\n      chunks: {\n        // - **<a name=\"options.chunks.detachDom\">chunks.detachDom</a>** this is used when you want the chunks to be absolute positioned and\n        // chunks that are out of view are hidden to minimize the gpu snapshot. Values are numbers or boolean.\n        // 100 will 100 rows above and below the viewport area. A true will evaluate to 0 above and below. A 0 will equate to false and not do a detach.\n        // So the value must be true or a whole number to enable it.\n        detachDom: null,\n        // - **<a name=\"options.chunks.size\">chunks.size</a>** this is used to determine how large each chunk should be. Chunks are made recursively\n        // so if you pass 8 items and they are chunked at 2 then you would have 2 chunks each with 2 chunks each with 2 rows.\n        size: 50,\n        // - **<a name=\"options.chunks.chunkClass\">chunks.chunkClass</a>** the class assigned to each chunk in the datagrid. This can be customized on a per grid basis since options\n        // can be overridden so that styles or selection may differ from one grid to the next.\n        chunkClass: \"datagrid-chunk\",\n        // - **<a name=\"options.chunks.chunkDisabledClass\">chunkDisabledClass</a>**\n        // a css class that is added to dom elements that are not containing visible rows.\n        chunkDisabledClass: \"datagrid-chunk-disabled\",\n        // - **<a name=\"options.chunks.chunkReadyClass\">chunks.chunkReadyClass</a>** after the chunk is added. The chunk ready class is added to all for css\n        // transitions on newly created chunks.\n        chunkReadyClass: \"datagrid-chunk-ready\"\n      },\n      scrollModel: {\n        // - **<a name=\"options.scrollModel.speed\">scrollModel.speed</a>** the factor of speed multiplication when determining how far the scroller should coast in manual mode.\n        speed: 5,\n        // - **<a name=\"options.scrollModel.manual\">scrollModel.manual</a>** if set to true then touch move events will be used to scroll and calculate coasting.\n        manual: true,\n        // - **<a name=\"options.scrollModel.simulateClick\">scrollModel.simulateClick</a>** defaulted to true for android, and false for iOS.\n        simulateClick: false,\n        // - **<a name=\"options.scrollModel.preventTouchMove\">scrollModel.preventTouchMove</a>** defaulted to false. prevent touchmove events from being thrown when enabled.\n        preventTouchMove: false\n      },\n      // - **<a name=\"options.compiledClass\">compiledClass</a>** after a row has been compiled the uncompiled class is removed and compiled is added.\n      compiledClass: \"compiled\",\n      // - **<a name=\"options.uncompiledClass\">uncompiledClass</a>** before a dom row is rendered it is compiled. The compiled row will have {{}} still in the code\n      // because the row has not been digested yet. If the user scrolls they can see this. So the uncompiledClass is used to allow the css to hide rows that are not\n      // yet compiled. Once they are compiled and digested the uncompiledClass will be removed from that dom row.\n      uncompiledClass: \"uncompiled\",\n      // - **<a name=\"contentClass\">contentClass</a>** the name of the css class assigned to the content div.\n      contentClass: \"datagrid-content\",\n      // - **<a name=\"rowClass\">rowClass</a>** the css class assigned to every row.\n      rowClass: \"datagrid-row\",\n      // - **<a name=\"options.renderThreshold\">renderThreshold</a>** this value is used by the creepRenderModel to allow the render to process for this amount of ms in\n      // both directions from the current visible area and then it will wait and process again as many rows as it can in this timeframe.\n      renderThreshold: 1,\n      // - **<a name=\"options.renderThresholdWait\">renderThresholdWait</a>** used in conjunction with options.renderThreshold this will wait this amount of time before\n      // trying to render more rows.\n      renderThresholdWait: 20,\n      // - **<a name=\"options.creepLimit\">creepLimit</a>** used with options.renderThreshold and options.renderThresholdWait this will give a maximum amount of renders\n      // that can be done before the creep render is turned off.\n      creepLimit: 500,\n      // - **<a name=\"options.smartUpdate\">smartUpdate</a>** when this is enabled if the array changes the order of things but not the templates that they render in then\n      // this will not do a normal reset, but will just re-render the visible area with the changes and as you scroll the changes will update.\n      smartUpdate: true,\n      // - **<a name=\"options.readyToRenderRetryMax\">readyToRenderRetryMax</a>** how many times the datagrid will try to get a height before it gives up.\n      readyToRenderRetryMax: 10,\n      // - **<a name=\"options.minHeight\">minHeight</a>** if a height cannot be found, the datagrid will assume this minHeight. It will then resize to whatever height the element is resized to later.\n      minHeight: 100,\n      // - **<a name=\"options.iosWebkitScrolling\">iosWebkitScrolling</a>** Smooth scrolling on ios device. Seems to sometimes be glitchy with ios devices.\n      iosWebkitScrolling: true,\n      // - **<a name=\"options.scrollEndRenderAmount\">scrollEndRenderAmount</a>**When a render stops it will force render x number of rows. It does this on a touch end and every forceRenderAfterScrollEventsCount\n      scrollEndRenderAmount: 2,\n      // - **<a name=\"options.forceRenderAfterScrollEventsCount\">forceRenderAfterScrollEventsCount</a>**When scrolling. Every forceRenderAfterScrollEventsCount of events, it will force render rows in the direction it is scrolling.\n      forceRenderAfterScrollEventsCount: 4\n    },\n    /**\n     * ###<a name=\"coreAddons\">coreAddons</a>###\n     * the core addons are the ones that are built into the angular-ux-datagrid. This array is used when the grid starts up\n     * to add all of these addons before optional addons are added. You can add core addons to the datagrid by adding these directly to this array, however it is not\n     * recommended.\n     */\n    coreAddons: []\n  };\n\n  /**\n   * ###addons###\n   * The addons module is used to pass injected names directly to the directive and then have them applied\n   * to the instance. Each of the addons is expected to be a factory that takes at least one argument which\n   * is the instance being passed to it. They can ask for additional ones as well and they will be injected\n   * in from angular's injector.\n   */\n  ngModule.factory(\"gridAddons\", [\"$injector\", function ($injector) {\n    function applyAddons(addons, instance) {\n      var i = 0,\n        len = addons.length,\n        result,\n        addon;\n      while (i < len) {\n        result = $injector.get(addons[i]);\n        if (typeof result === \"function\" || result instanceof Array) {\n          // It is expected that each addon be a function or injector array syntax. inst is the instance that is injected.\n          addon = $injector.invoke(result, instance, {\n            inst: instance\n          });\n        } else {\n          // they must have returned a null? what was the point. Throw an error.\n          throw new Error(\"Addons expect a function ($injector array supported) to pass the grid instance to.\");\n        }\n        i += 1;\n      }\n    }\n    return function (instance, addons) {\n      // addons can be a single item, array, or comma/space separated string.\n      addons = addons instanceof Array ? addons : addons && addons.replace(/,/g, \" \").replace(/\\s+/g, \" \").split(\" \") || [];\n      if (instance.addons) {\n        addons = instance.addons = instance.addons.concat(addons);\n      }\n      applyAddons(addons, instance);\n    };\n  }]);\n\n  /**\n   * **charPack** given a character it will repeat it until the amount specified.\n   * example: charPack('0', 3) => '000'\n   * @param {String} char\n   * @param {Number} amount\n   * @returns {string}\n   */\n  function charPack(char, amount) {\n    var str = \"\";\n    while (str.length < amount) {\n      str += char;\n    }\n    return str;\n  }\n\n  /**\n   * ##ux.CSS##\n   * Create custom style sheets. This has a performance increase over modifying the style on multiple dom\n   * elements because you can create the sheet or override it and then all with that classname update by the browser\n   * instead of the manual insertion into style attributes per dom node.\n   */\n  exports.css = function CSS() {\n    var customStyleSheets = {},\n      cache = {},\n      cnst = {\n        head: \"head\",\n        screen: \"screen\",\n        string: \"string\",\n        object: \"object\"\n      };\n    /**\n     * **createCustomStyleSheet** given a name creates a new styleSheet.\n     * @param {Strng} name\n     * @returns {*}\n     */\n    function createCustomStyleSheet(name) {\n      if (!getCustomSheet(name)) {\n        customStyleSheets[name] = createStyleSheet(name);\n      }\n      return getCustomSheet(name);\n    }\n    /**\n     * **getCustomSheet** get one of the custom created sheets.\n     * @param name\n     * @returns {*}\n     */\n    function getCustomSheet(name) {\n      return customStyleSheets[name];\n    }\n    /**\n     * **createStyleSheet** does the heavy lifting of creating a style sheet.\n     * @param {String} name\n     * @returns {{name: *, styleSheet: *}}\n     */\n    function createStyleSheet(name) {\n      if (!document.styleSheets) {\n        return;\n      }\n      if (document.getElementsByTagName(cnst.head).length === 0) {\n        return;\n      }\n      var styleSheet, mediaType, i, media;\n      if (document.styleSheets.length > 0) {\n        for (i = 0; i < document.styleSheets.length; i++) {\n          if (document.styleSheets[i].disabled) {\n            continue;\n          }\n          media = document.styleSheets[i].media;\n          mediaType = _typeof(media);\n          if (mediaType === cnst.string) {\n            if (media === \"\" || media.indexOf(cnst.screen) !== -1) {\n              styleSheet = document.styleSheets[i];\n            }\n          } else if (mediaType === cnst.object) {\n            if (media.mediaText === \"\" || media.mediaText.indexOf(cnst.screen) !== -1) {\n              styleSheet = document.styleSheets[i];\n            }\n          }\n          if (typeof styleSheet !== \"undefined\") {\n            break;\n          }\n        }\n      }\n      var styleSheetElement = document.createElement(\"style\");\n      styleSheetElement.type = \"text/css\";\n      styleSheetElement.title = name;\n      document.getElementsByTagName(cnst.head)[0].appendChild(styleSheetElement);\n      var index = document.styleSheets.length - 1;\n      styleSheet = document.styleSheets[index];\n      return {\n        name: name,\n        styleSheet: styleSheet\n      };\n    }\n    function removeStyleSheet(name) {\n      var sheetData = customStyleSheets[name];\n      var len = document.styleSheets.length;\n      for (var i = 0; i < len; i += 1) {\n        if (document.styleSheets[i] === sheetData.styleSheet) {\n          document.styleSheets.splice(i, 1);\n        }\n      }\n      delete customStyleSheets[name];\n      sheetData = null;\n    }\n    /**\n     * **createClass** creates a class on a custom style sheet.\n     * @param {String} sheetName\n     * @param {String} selector - example: \".datagrid\"\n     * @param {String} style - example: \"height:20px;width:40px;color:blue;\"\n     */\n    function createClass(sheetName, selector, style) {\n      var sheet = getCustomSheet(sheetName) || createCustomStyleSheet(sheetName),\n        styleSheet = sheet.styleSheet,\n        i;\n      if (styleSheet.addRule) {\n        for (i = 0; i < styleSheet.rules.length; i++) {\n          if (styleSheet.rules[i].selectorText && styleSheet.rules[i].selectorText.toLowerCase() === selector.toLowerCase()) {\n            styleSheet.rules[i].style.cssText = style;\n            return;\n          }\n        }\n        styleSheet.addRule(selector, style);\n        if (styleSheet.rules[styleSheet.rules.length - 1].cssText === selector + \" { }\") {\n          throw new Error(\"CSS failed to write\");\n        }\n      } else if (styleSheet.insertRule) {\n        for (i = 0; i < styleSheet.cssRules.length; i++) {\n          if (styleSheet.cssRules[i].selectorText && styleSheet.cssRules[i].selectorText.toLowerCase() === selector.toLowerCase()) {\n            styleSheet.cssRules[i].style.cssText = style;\n            return;\n          }\n        }\n        styleSheet.insertRule(selector + \"{\" + style + \"}\", 0);\n      }\n    }\n    /**\n     * **getSelector** given a selector this will find that selector in the stylesheets. Not just the custom ones.\n     * @param {String} selector\n     * @returns {*}\n     */\n    function getSelector(selector) {\n      var i, ilen, sheet, classes, result;\n      if (selector.indexOf(\"{\") !== -1 || selector.indexOf(\"}\") !== -1) {\n        return null;\n      }\n      if (cache[selector]) {\n        return cache[selector];\n      }\n      for (i = 0, ilen = document.styleSheets.length; i < ilen; i += 1) {\n        sheet = document.styleSheets[i];\n        classes = sheet.rules || sheet.cssRules;\n        result = getRules(classes, selector);\n        if (result) {\n          return result;\n        }\n      }\n      return null;\n    }\n    /**\n     * **getRules** given a set of classes and a selector it will get the rules for a style sheet.\n     * @param {CSSRules} classes\n     * @param {String} selector\n     * @returns {*}\n     */\n    function getRules(classes, selector) {\n      var j, jlen, cls, result;\n      if (classes) {\n        for (j = 0, jlen = classes.length; j < jlen; j += 1) {\n          cls = classes[j];\n          if (cls.cssRules) {\n            result = getRules(cls.cssRules, selector);\n            if (result) {\n              return result;\n            }\n          }\n          if (cls.selectorText) {\n            var expression = \"(\\b)*\" + selector.replace(\".\", \"\\\\.\") + \"([^-a-zA-Z0-9]|,|$)\",\n              matches = cls.selectorText.match(expression);\n            if (matches && matches.indexOf(selector) !== -1) {\n              cache[selector] = cls.style;\n              // cache the value\n              return cls.style;\n            }\n          }\n        }\n      }\n      return null;\n    }\n    /**\n     * **getCSSValue** return the css value of a property given the selector and the property.\n     * @param {String} selector\n     * @param {String} property\n     * @returns {*}\n     */\n    function getCSSValue(selector, property) {\n      var cls = getSelector(selector);\n      return cls && cls[property] !== undefined ? cls[property] : null;\n    }\n    /**\n     * **setCSSValue** overwrite a css value given a selector, property, and new value.\n     * @param {String} selector\n     * @param {String} property\n     * @param {String} value\n     */\n    function setCSSValue(selector, property, value) {\n      var cls = getSelector(selector);\n      cls[property] = value;\n    }\n    /**\n     * **ux.CSS API**\n     */\n    return {\n      createdStyleSheets: [],\n      createStyleSheet: createStyleSheet,\n      createClass: createClass,\n      getCSSValue: getCSSValue,\n      setCSSValue: setCSSValue,\n      getSelector: getSelector,\n      removeStyleSheet: removeStyleSheet\n    };\n  }();\n\n  /**\n   * ##ux.each##\n   * Like angular.forEach except that you can pass additional arguments to it that will be available\n   * in the iteration function. It is optimized to use while loops where possible instead of for loops for speed.\n   * Like Lo-Dash.\n   * @param {Array\\Object} list\n   * @param {Function} method\n   * @param {*=} data _additional arguments passes are available in the iteration function_\n   * @returns {*}\n   */\n  //_example:_\n  //\n  //      function myMethod(item, index, list, arg1, arg2, arg3) {\n  //          console.log(arg1, arg2, arg3);\n  //      }\n  //      ux.each(myList, myMethod, arg1, arg2, arg3);\n  function each(list, method, data) {\n    var i = 0,\n      len,\n      result,\n      extraArgs,\n      apl = exports.util.apply;\n    if (arguments.length > 2) {\n      extraArgs = exports.util.array.toArray(arguments);\n      extraArgs.splice(0, 2);\n    }\n    if (list && list.length) {\n      len = list.length;\n      while (i < len) {\n        result = apl(method, null, [list[i], i, list].concat(extraArgs));\n        if (result !== undefined) {\n          return result;\n        }\n        i += 1;\n      }\n    } else if (list && apl(Object.prototype.hasOwnProperty, list, [\"0\"])) {\n      while (apl(Object.prototype.hasOwnProperty, list, [i])) {\n        result = apl(method, null, [list[i], i, list].concat(extraArgs));\n        if (result !== undefined) {\n          return result;\n        }\n        i += 1;\n      }\n    } else if (!(list instanceof Array)) {\n      for (i in list) {\n        if (apl(Object.prototype.hasOwnProperty, list, [i])) {\n          result = apl(method, null, [list[i], i, list].concat(extraArgs));\n          if (result !== undefined) {\n            return result;\n          }\n        }\n      }\n    }\n    return list;\n  }\n  exports.each = each;\n\n  /**\n   * **filter** built on the same concepts as each. So that you can pass additional arguments.\n   * @param list\n   * @param method\n   * @param data\n   * @returns {Array}\n   */\n  function filter(list, method, data) {\n    var i = 0,\n      len,\n      result = [],\n      extraArgs,\n      response,\n      apl = exports.util.apply;\n    if (arguments.length > 2) {\n      extraArgs = exports.util.array.toArray(arguments);\n      extraArgs.splice(0, 2);\n    }\n    if (list && list.length) {\n      len = list.length;\n      while (i < len) {\n        response = apl(method, null, [list[i], i, list].concat(extraArgs));\n        if (response) {\n          result.push(list[i]);\n        }\n        i += 1;\n      }\n    } else {\n      for (i in list) {\n        if (apl(Object.prototype.hasOwnProperty, list, [i])) {\n          response = apl(method, null, [list[i], i, list].concat(extraArgs));\n          if (response) {\n            result.push(list[i]);\n          }\n        }\n      }\n    }\n    return result;\n  }\n  exports.filter = filter;\n\n  /**\n   * ###<a name=\"extend\">extend</a>###\n   * Perform a deep extend.\n   * @param {Object} destination\n   * @param {Object=} source\n   * return {Object|destination}\n   */\n  function extend(destination, source) {\n    var args = exports.util.array.toArray(arguments),\n      i = 1,\n      len = args.length,\n      item,\n      j;\n    while (i < len) {\n      item = args[i];\n      for (j in item) {\n        if (destination[j] && _typeof(destination[j]) === \"object\") {\n          destination[j] = extend(destination[j], item[j]);\n        } else if (item[j] instanceof Array) {\n          destination[j] = extend([], item[j]);\n        } else if (item[j] && _typeof(item[j]) === \"object\") {\n          destination[j] = extend({}, item[j]);\n        } else {\n          destination[j] = item[j];\n        }\n      }\n      i += 1;\n    }\n    return destination;\n  }\n  exports.extend = extend;\n  (function () {\n    \"use strict\";\n\n    var c = 0;\n    exports.uid = function UID() {\n      c += 1;\n      var str = c.toString(36).toUpperCase();\n      while (str.length < 6) {\n        str = \"0\" + str;\n      }\n      return str;\n    };\n  })();\n  exports.logWrapper = function LogWrapper(name, instance, theme, inst) {\n    var apl = exports.util.apply;\n    theme = theme || \"black\";\n    instance.$logName = name;\n    instance.log = instance.info = instance.warn = instance.error = function () {};\n    function dispatchFn(dispatch, args) {\n      if (typeof dispatch === \"function\") {\n        apl(dispatch, instance, args);\n      }\n    }\n    instance.log = function log() {\n      var args = [exports.datagrid.events.LOG, name, theme].concat(exports.util.array.toArray(arguments));\n      if (inst.logger) {\n        apl(inst.logger.log, inst.logger, args);\n      } else {\n        dispatchFn(inst, args);\n      }\n    };\n    instance.info = function info() {\n      var args = [exports.datagrid.events.INFO, name, theme].concat(exports.util.array.toArray(arguments));\n      if (inst.logger) {\n        apl(inst.logger.info, inst.logger, args);\n      } else {\n        dispatchFn(inst, args);\n      }\n    };\n    instance.warn = function warn() {\n      var args = [exports.datagrid.events.WARN, name, theme].concat(exports.util.array.toArray(arguments));\n      if (inst.logger) {\n        apl(inst.logger.warn, inst.logger, args);\n      } else {\n        dispatchFn(inst, args);\n      }\n    };\n    instance.error = function error() {\n      var args = [exports.datagrid.events.ERROR, name, theme].concat(exports.util.array.toArray(arguments));\n      if (inst.logger) {\n        apl(inst.logger.error, inst.logger, args);\n      } else {\n        dispatchFn(inst, args);\n      }\n    };\n    instance.destroyLogger = function () {\n      if (inst.logger) {\n        inst.log(\"destroy\");\n        inst.logger.destroy();\n        inst.logger = null;\n      }\n    };\n    return instance;\n  };\n  function Flow(inst, pauseFn, $timeout, dg) {\n    var initTime = Date.now(),\n      lifespan = 0,\n      running = false,\n      current = null,\n      list = [],\n      history = [],\n      historyLimit = 10,\n      uniqueMethods = {},\n      execStartTime,\n      execEndTime,\n      timeouts = {},\n      nextPromise,\n      consoleMethodStyle = \"color:#666666;\",\n      infin = 0;\n    function getMethodName(method) {\n      // TODO: there might be a faster way to get the function name.\n      return method.toString().split(/\\b/)[2];\n    }\n    function createItem(method, args, delay) {\n      return {\n        label: getMethodName(method),\n        method: method,\n        args: args || [],\n        delay: delay\n      };\n    }\n    function unique(method) {\n      var name = getMethodName(method);\n      uniqueMethods[name] = method;\n    }\n    function clearSimilarItemsFromList(item) {\n      var i = 1,\n        len = list.length;\n      // clearing should never remove the first one, because it is the current one.\n      while (i < len) {\n        if (list[i].label === item.label) {\n          if (list[i] === current && nextPromise) {\n            $timeout.cancel(nextPromise);\n            nextPromise = null;\n            current = null;\n            inst.warn(\"REMOVE ACTIVE FLOW ITEM %c%s\", consoleMethodStyle, item.label);\n          } else {\n            inst.info(\"remove Flow item %c%s\", consoleMethodStyle, item.label);\n          }\n          list.splice(i, 1);\n          i -= 1;\n          len -= 1;\n        }\n        i += 1;\n      }\n      if (!current) {\n        // it was cleared. So we now call next.\n        next();\n      }\n    }\n    function add(method, args, delay) {\n      var item = createItem(method, args, delay);\n      inst.info(\"add\", item.label);\n      if (uniqueMethods[item.label]) {\n        clearSimilarItemsFromList(item);\n      }\n      list.push(item);\n      if (running) {\n        next();\n      }\n    }\n    // this puts it right after the one currently running.\n    function insert(method, args, delay) {\n      list.splice(1, 0, createItem(method, args, delay));\n    }\n    function remove(method) {\n      clearSimilarItemsFromList({\n        label: getMethodName(method)\n      });\n    }\n    // timeouts that do not block the flow.\n    function timeout(method, time) {\n      var intv,\n        item = createItem(method, []),\n        startTime = Date.now(),\n        timeoutCall = function timeoutCall() {\n          inst.log(\"exec timeout method %c%s %sms (len:%s)\", consoleMethodStyle, item.label, Date.now() - startTime, list.length);\n          list.push(item);\n          // add after timeout time.\n          if (running) {\n            next();\n          }\n        };\n      inst.log(\"wait for timeout method %c%s (len:%s)\", consoleMethodStyle, item.label, list.length);\n      intv = setTimeout(timeoutCall, time);\n      // use regular timeout because we are just waiting to put it in the queue.\n      timeouts[intv] = function () {\n        clearTimeout(intv);\n        delete timeouts[intv];\n      };\n      return intv;\n    }\n    function stopTimeout(intv) {\n      if (timeouts[intv]) timeouts[intv]();\n    }\n    function getArguments(fn) {\n      var str = fn.toString(),\n        match = str.match(/\\(.*\\)/);\n      return match[0].match(/([\\$\\w])+/gm);\n    }\n    function hasDoneArg(fn) {\n      var args = getArguments(fn);\n      return !!(args && args.indexOf(\"done\") !== -1);\n    }\n    function done() {\n      execEndTime = Date.now();\n      inst.log(\"\\tfinish %c%s took %dms (len:%s)\", consoleMethodStyle, current.label, execEndTime - execStartTime, list.length);\n      current = null;\n      addToHistory(list.shift());\n      next();\n      return execEndTime - execStartTime;\n    }\n    // Keep a history of what methods were executed for debugging. Keep up to the limit.\n    function addToHistory(item) {\n      history.unshift(item);\n      while (history.length > historyLimit) {\n        history.pop();\n      }\n    }\n    function next() {\n      inst.log(\"next %s\", list.length);\n      inst.lifespan = lifespan = Date.now() - initTime;\n      if (!current && list.length) {\n        infin = 0;\n        current = list[0];\n        if (inst.async && current.delay !== undefined) {\n          inst.log(\"\\tdelay for %c%s %sms (len:%s)\", consoleMethodStyle, current.label, current.delay, list.length);\n          nextPromise = $timeout(exec, current.delay, false);\n        } else {\n          exec();\n        }\n      } else if (current && list.length && current.label === list[0].label) {\n        inst.info(\"\\tskip\", current.label);\n        if (infin > 100) {\n          inst.warn(\"Exceeded max repeat of 100 iterations on the same method. Dropping Method.\");\n          list.shift();\n        }\n        infin += 1;\n      }\n    }\n    function exec() {\n      if (!inst) {\n        return;\n      }\n      if (nextPromise) {\n        $timeout.cancel(nextPromise);\n      }\n      if (pauseFn && pauseFn()) {\n        inst.warn(\"\\twait for pauseFn\");\n        nextPromise = $timeout(exec, 0, false);\n        return;\n      }\n      var methodHasDoneArg = hasDoneArg(current.method);\n      inst.log(\"start method %c%s (len:%s)\" + (methodHasDoneArg && \" - (has done arg)\" || \"\"), consoleMethodStyle, current.label, list.length);\n      if (methodHasDoneArg) {\n        current.args.push(done);\n      }\n      try {\n        execStartTime = Date.now();\n        exports.util.apply(current.method, null, current.args);\n      } catch (e) {\n        inst.warn(e.message + \"\\n\" + (e.stack || e.stacktrace || e.backtrace));\n      } finally {\n        if (!methodHasDoneArg) {\n          done();\n        }\n      }\n    }\n    function run() {\n      running = true;\n      next();\n    }\n    function clear() {\n      var len = current ? 1 : 0,\n        item;\n      inst.info(\"clear\");\n      while (list.length > len) {\n        item = list.splice(len, 1)[0];\n        inst.log(\"\\tremove %s from flow\", item.label);\n      }\n    }\n    function length() {\n      return list.length;\n    }\n    function count(name) {\n      var c = 0;\n      for (var i = 0; i < list.length; i += 1) {\n        if (name instanceof Array && name.indexOf(list[i].label) !== -1 || list[i].label === name) {\n          c += 1;\n        }\n      }\n      return c;\n    }\n    function destroy() {\n      list.length = 0;\n      inst = null;\n    }\n    exports.logWrapper(\"Flow\", inst, \"grey\", dg || inst);\n    // if no dg. It will not log.\n    //    inst.async = exports.util.apply(Object.prototype.hasOwnProperty, inst, ['async']) ? inst.async : true;\n    inst.debug = exports.util.apply(Object.prototype.hasOwnProperty, inst, [\"debug\"]) ? inst.debug : 0;\n    inst.insert = insert;\n    inst.add = add;\n    inst.unique = unique;\n    inst.remove = remove;\n    inst.timeout = timeout;\n    inst.stopTimeout = stopTimeout;\n    inst.run = run;\n    inst.clear = clear;\n    inst.length = length;\n    inst.count = count;\n    inst.destroy = destroy;\n    return inst;\n  }\n  exports.datagrid.Flow = Flow;\n\n  /*global each, charPack, Flow, exports, ngModule */\n  /**\n   * <a name=\"ux.datagrid\"></a>\n   * ##Datagrid Directive##\n   * The datagrid manages the `core addons` to build the initial list and provide the public API necessary\n   * to communicate with other addons.\n   * Datagrid uses script templates inside of the DOM to create your elements. Addons are added to the `addon`\n   * attribute.\n   * @param {Scope} scope\n   * @param {HTMLElement} element\n   * @param {Object} attr\n   * @param {Function} $compile\n   * @returns {Datagrid}\n   * @constructor\n   */\n  function Datagrid(scope, element, attr, $compile, $timeout) {\n    // **<a name=\"flow\">flow</a>** flow management for methods of the datagrid. Keeping functions firing in the correct order especially if async methods are executed.\n    var flow;\n    // **<a name=\"waitCount\">waitCount</a>** waiting to render. If it fails too many times it will die.\n    var waitCount = 0;\n    // **<a name=\"changeWatcherSet\">changeWatcherSet</a>** flag for change watchers.\n    var changeWatcherSet = false;\n    // **<a name=\"unwatchers\">unwatchers</a>** list of scope listeners that we want to clear on destroy\n    var unwatchers = [];\n    // **<a name=\"content\">content</a>** the DOM element with all of the chunks.\n    var content;\n    // **<a name=\"oldContent\">oldContent</a>** the temporary content when the grid is being reset.\n    var oldContent;\n    // **<a name=\"scopes\">scopes</a>** the array of all scopes that have been compiled.\n    var scopes = [];\n    // **<a name=\"active\">active</a>** the scopes that are currently active.\n    var active = [];\n    // **<a name=\"lastVisibleScrollStart\">lastVisibleScrollStart</a>** cached index to improve render loop by starting where it left off.\n    var lastVisibleScrollStart = 0;\n    // **<a name=\"rowOffsets\">rowOffsets</a>** cache for the heights of the rows for faster height calculations.\n    var rowOffsets = {};\n    // **<a name=\"viewHeight\">viewHeight</a>** the visual area height.\n    var viewHeight = 0;\n    // **<a name=\"options\">options</a>** configs that are shared through the datagrid and addons.\n    var options;\n    // **[states](#states)** local reference to the states constants\n    var states = exports.datagrid.states;\n    // **[events](#events)** local reference to the events constants\n    var events = exports.datagrid.events;\n    // **<a name=\"state\">state</a>** `state` of the app. Building || Ready.\n    var state = states.BUILDING;\n    // **<a name=\"values\">values</a>** `values` is the object that is used to share data for scrolling and other shared values.\n    var values = {\n      // - <a name=\"values.dirty\"></a>if the data is dirty and a render has not happened since the data change.\n      dirty: false,\n      // - <a name=\"values.scroll\"></a>current scroll value of the grid\n      scroll: 0,\n      // - <a name=\"values.speed\"></a>current speed of the scroll\n      speed: 0,\n      // - <a name=\"values.absSpeed\"></a>current absSpeed of the grid.\n      absSpeed: 0,\n      // - <a name=\"values.scrollPercent\"></a>the current percent position of the scroll.\n      scrollPercent: 0,\n      // - <a name=\"values.touchDown\"></a>if there is currently a touch start and not a touch end. Since touch is used for scrolling on a touch device. Ignored for desktop.\n      touchDown: false,\n      // - <a name=\"values.scrollingStopIntv\"></a>interval that allows waits for checks to know when the scrolling has stopped and a render is needed.\n      scrollingStopIntv: null,\n      // - <a name=\"values.activeRange\"></a>the current range of active scopes.\n      activeRange: {\n        min: 0,\n        max: 0\n      },\n      // - <a name=\"values.direction\"></a>-1 | 0 | 1 depending on weather it is scrolling or not. Used by creepModel and scrollModel to optimize the direction of the creep rendering.\n      direction: 0\n    };\n    // <a name=\"logEvents\"></a>listing the log events so they can be ignored if needed.\n    var logEvents = [exports.datagrid.events.LOG, exports.datagrid.events.INFO, exports.datagrid.events.WARN, exports.datagrid.events.ERROR];\n    // <a name=\"inst\"></a>the instance of the datagrid that will be referenced by all addons.\n    var inst = this,\n      eventLogger = {},\n      startupComplete = false,\n      gcIntv,\n      $compileCache = {};\n    // wrap the instance for logging.\n    exports.logWrapper(\"datagrid event\", inst, \"grey\", inst);\n    // for debugging and watching the angular phase start and end.\n    // cannot use for flowPauseFn it causes lots of errors because datagrid will not flow at all\n    // during a phase with this setting a flag to use.\n    //function beforePhase() {\n    //    inst.info(\"NG-$digest START\");\n    //    $timeout(afterPhase, 0, false);\n    //}\n    //\n    //function afterPhase() {\n    //    if (inst) {// it may be destroyed after a phase. so only log if it is there.\n    //        inst.info(\"NG-$digest END\");\n    //    }\n    //}\n    //\n    //scope.$watch(beforePhase);\n    /**\n     * ###<a name=\"init\">init</a>###\n     * Initialize the datagrid. Add unique methods to the flow control.\n     */\n    function init() {\n      flow.unique(reset);\n      flow.unique(render);\n      flow.unique(updateRowWatchers);\n      flow.unique(onDataChanged);\n      flow.unique(changeData);\n    }\n    /**\n     * ###<a name=\"setupExports\">setupExports</a>###\n     * Build out the public API variables for the datagrid.\n     */\n    function setupExports() {\n      inst.uid = exports.uid();\n      inst.name = scope.$eval(attr.gridName) || \"datagrid\";\n      inst.scope = scope;\n      inst.element = element;\n      inst.attr = attr;\n      inst.rowsLength = 0;\n      inst.scopes = scopes;\n      inst.data = inst.data || [];\n      inst.unwatchers = unwatchers;\n      inst.values = values;\n      inst.start = start;\n      inst.update = update;\n      inst.reset = reset;\n      inst.isReady = isReady;\n      inst.isStartupComplete = isStartupComplete;\n      inst.forceRenderScope = forceRenderScope;\n      inst.dispatch = dispatch;\n      inst.activateScope = activateScope;\n      inst.deactivateScope = deactivateScope;\n      inst.updateLinks = updateLinks;\n      inst.render = function () {\n        flow.add(render);\n      };\n      inst.updateHeights = updateHeights;\n      inst.getOffsetIndex = getOffsetIndex;\n      inst.isActive = isActive;\n      inst.isCompiled = isCompiled;\n      inst.swapItem = swapItem;\n      inst.moveItem = moveItem;\n      inst.getScope = getScope;\n      inst.getRowItem = getRowItem;\n      inst.getRowElm = getRowElm;\n      inst.getExistingRow = getExistingRow;\n      inst.getRowIndex = inst.getIndexOf = getRowIndex;\n      inst.getRowOffset = getRowOffset;\n      inst.getRowHeight = getRowHeight;\n      inst.getViewportHeight = getViewportHeight;\n      inst.getContentHeight = getContentHeight;\n      inst.getContent = getContent;\n      inst.isDigesting = isDigesting;\n      inst.safeDigest = safeDigest;\n      inst.getRowIndexFromElement = getRowIndexFromElement;\n      inst.updateViewportHeight = updateViewportHeight;\n      inst.calculateViewportHeight = calculateViewportHeight;\n      inst.options = options = exports.extend({}, exports.datagrid.options, scope.$eval(attr.options) || {});\n      inst.flow = flow = new Flow({\n        async: exports.util.apply(Object.prototype.hasOwnProperty, options, [\"async\"]) ? !!options.async : true,\n        debug: exports.util.apply(Object.prototype.hasOwnProperty, options, [\"debug\"]) ? options.debug : 0\n      }, isDigesting, $timeout, inst.options.debug && inst.options.debug.Flow ? inst : null);\n      // this needs to be set immediately so that it will be available to other views.\n      inst.grouped = scope.$eval(attr.grouped);\n      inst.gc = forceGarbageCollection;\n      inst.throwError = exports.datagrid.throwError;\n      flow.add(init);\n      // initialize core.\n      flow.run();\n    }\n    /**\n     * ###<a name=\"createContent\">createContent</a>###\n     * The [content](#content) DOM element is the only direct child created by the datagrid.\n     * It is used to append all of the `chunks` so that it can be scrolled.\n     * If the DOM element is provided with the class [content](#content) then that DOM element will be used\n     * allowing the user to add custom classes directly to the [content](#content) DOM element.\n     * @returns {JQLite}\n     */\n    function createContent() {\n      var contents = element[0].getElementsByClassName(options.contentClass),\n        cnt,\n        classes = options.contentClass;\n      contents = exports.filter(contents, filterOldContent);\n      cnt = contents[0];\n      if (cnt) {\n        // if there is an old one. Pull the classes from it.\n        classes = cnt.className || options.contentClass;\n      }\n      if (!cnt) {\n        classes = getClassesFromOldContent() || classes;\n        cnt = angular.element('<div class=\"' + classes + '\"></div>');\n        if (inst.options.chunks.detachDom) {\n          cnt[0].style.position = \"relative\";\n        }\n        element.prepend(cnt);\n      }\n      if (!cnt[0]) {\n        cnt = angular.element(cnt);\n      }\n      return cnt;\n    }\n    /**\n     * ###<a name=\"getClassesFromOldContent\">getClassesFromOldContent</a>###\n     * If the old content exists it may have been an original DOM element passed to the datagrid. If so we want\n     * to keep that DOM element's classes in tact.\n     * @returns {string}\n     */\n    function getClassesFromOldContent() {\n      var classes, index;\n      if (oldContent) {\n        // let's get classes from it.\n        classes = exports.util.array.toArray(oldContent[0].classList);\n        index = classes.indexOf(\"old-\" + options.contentClass);\n        if (index !== -1) {\n          classes.splice(index, 1);\n        }\n        return classes.join(\" \");\n      }\n    }\n    /**\n     * ###<a name=\"filterOldContent\">filterOldContent</a>###\n     * filter the list of content DOM to remove any references to the [oldContent][#oldContent].\n     * @param cnt\n     * @param index\n     * @param list\n     * @returns {boolean}\n     */\n    function filterOldContent(cnt, index, list) {\n      return angular.element(cnt).hasClass(\"old-\" + options.contentClass) ? false : true;\n    }\n    /**\n     * ###<a name=\"getContent\">getContent</a>###\n     * return the reference to the content div.\n     */\n    function getContent() {\n      return content;\n    }\n    /**\n     * ###<a name=\"start\">start</a>###\n     * `start` is called after the addons are added.\n     */\n    function start() {\n      inst.dispatch(exports.datagrid.events.ON_INIT, inst);\n      content = createContent();\n      waitForElementReady(0);\n    }\n    /**\n     * ###<a name=\"waitForElementReady\">waitForElementReady</a>###\n     * this waits for the body element because if the grid has been constructed, but no heights are showing\n     * it is usually because the grid has not been attached to the document yet. So wait for the heights\n     * to be available, but only wait a little then exit.\n     * @param count\n     */\n    function waitForElementReady(count) {\n      if (!inst.element[0].offsetHeight) {\n        if (count < 1) {\n          // if they are doing custom compiling. They may compile before adding it to the DOM.\n          // allow a pass to happen just in case.\n          flow.add(waitForElementReady, [count + 1], 0);\n          // retry.\n          return;\n        } else {\n          flow.warn(\"Datagrid: DOM Element does not have a height.\");\n        }\n      }\n      if (options.templateModel && options.templateModel.templates) {\n        flow.add(inst.templateModel.createTemplatesFromData, [options.templateModel.templates], 0);\n      }\n      flow.add(inst.templateModel.createTemplates, null, 0);\n      // allow element to be added to DOM.\n      // if the templates have different heights then they are dynamic.\n      flow.add(function updateDynamicRowHeights() {\n        options.dynamicRowHeights = inst.templateModel.dynamicHeights();\n      });\n      flow.add(addListeners);\n    }\n    /**\n     * ###<a name=\"addListeners\">addListeners</a>###\n     * Adds listeners. Notice that all listeners are added to the unwatchers array so that they can be cleared\n     * before references are removed to avoid memory leaks with circular references and to prevent events from\n     * being listened to while the destroy is happening.\n     */\n    function addListeners() {\n      var unwatchFirstRender = scope.$on(exports.datagrid.events.ON_BEFORE_RENDER_AFTER_DATA_CHANGE, function () {\n        unwatchFirstRender();\n        flow.add(onStartupComplete);\n      });\n      window.addEventListener(\"resize\", onResize);\n      unwatchers.push(scope.$on(exports.datagrid.events.UPDATE, update));\n      unwatchers.push(scope.$on(exports.datagrid.events.ON_ROW_TEMPLATE_CHANGE, onRowTemplateChange));\n      unwatchers.push(scope.$on(\"$destroy\", destroy));\n      flow.add(setupChangeWatcher, [], 0);\n      inst.dispatch(exports.datagrid.events.ON_LISTENERS_READY);\n    }\n    function isStartupComplete() {\n      return startupComplete;\n    }\n    function onStartupComplete() {\n      startupComplete = true;\n      dispatch(exports.datagrid.events.ON_STARTUP_COMPLETE, inst);\n    }\n    /**\n     * ###<a name=\"setupChangeWatcher\">setupChangeWatcher</a>###\n     * When a change happens update the DOM.\n     */\n    function setupChangeWatcher() {\n      if (!changeWatcherSet) {\n        inst.log(\"setupChangeWatcher\");\n        changeWatcherSet = true;\n        unwatchers.push(scope.$watchCollection(attr.uxDatagrid, onDataChangeFromWatcher));\n        // force initial watcher.\n        var d = scope.$eval(attr.uxDatagrid);\n        if (d && d.length) {\n          flow.add(render);\n        }\n      }\n    }\n    /**\n     * ###<a name=\"onDataChangeFromWatcher\">onDataChangeFromWatcher</a>###\n     * when the watcher fires.\n     * @param {*} newVal\n     * @param {*} oldVal\n     */\n    function onDataChangeFromWatcher(newVal, oldVal) {\n      inst.info(\"\\tonDataChangeFromWatcher |\" + flow.lifespan + \"| new:\" + (newVal && newVal.length || 0) + \" old:\" + (oldVal && oldVal.length || 0));\n      flow.add(onDataChanged, [newVal, oldVal, flow.lifespan]);\n    }\n    /**\n     * ###<a name=\"updateViewportHeight\">updateViewportHeight</a>###\n     * This function can be used to force update the viewHeight.\n     */\n    function updateViewportHeight() {\n      viewHeight = inst.calculateViewportHeight();\n      if (!viewHeight) {\n        viewHeight = options.minHeight;\n      }\n    }\n    /**\n     * ###<a name=\"isReady\">isReady</a>###\n     * return if grid state is <a href=\"#states.READY\">states.READY</a>.\n     */\n    function isReady() {\n      return state === states.READY;\n    }\n    /**\n     * ###<a name=\"calculateViewportHeight\">calculateViewportHeight</a>###\n     * Calculate Viewport Height can be expensive. Depending on the number of DOM elements.\n     * so if you need to use this method, use it sparingly because you may experience performance\n     * issues if overused.\n     */\n    function calculateViewportHeight() {\n      return element[0].offsetHeight;\n    }\n    /**\n     * ###<a name=\"onResize\">onResize</a>###\n     * When a resize happens dispatch that event for addons to listen to so events happen after\n     * the grid has performed its changes.\n     * @param {Event} event\n     */\n    function onResize(event) {\n      forceRedraw();\n    }\n    /**\n     * ##<a name=\"swapItem\">swapItem</a>##\n     * swap out an old item with a new item without causing a data change. Quick swap of items.\n     * this will only work if the item already exists in the datagrid. You cannot add or remove items\n     * this way. Only change them to a different reference. Adding or Removing requires a re-chunking.\n     * @param {Object} oldItem\n     * @param {Object} newItem\n     * @param {Boolean=} keepTemplate\n     */\n    function swapItem(oldItem, newItem, keepTemplate) {\n      //TODO: needs unit test.\n      var index = getRowIndex(oldItem),\n        oldTpl,\n        newTpl;\n      if (exports.util.apply(Object.prototype.hasOwnProperty, inst.data, [index])) {\n        oldTpl = inst.templateModel.getTemplate(oldItem);\n        if (keepTemplate) {\n          newTpl = oldTpl;\n        } else {\n          newTpl = inst.templateModel.getTemplate(newItem);\n        }\n        inst.normalizeModel.replace(newItem, index);\n        if (oldTpl !== newTpl) {\n          inst.templateModel.setTemplate(index, newTpl.name);\n        } else {\n          // nothing changed except the reference. So just update the scope and digest.\n          scopes[index][newTpl.item] = newItem;\n          safeDigest(scopes[index]);\n        }\n      }\n    }\n    function moveItem(fromIndex, toIndex) {\n      inst.normalizeModel.move(fromIndex, toIndex);\n      changeData(inst.getOriginalData(), inst.getOriginalData());\n    }\n    /**\n     * ###<a name=\"getScope\">getScope</a>###\n     * Return the scope of the row at that index.\n     * @param {Number} index\n     * @returns {*}\n     */\n    function getScope(index) {\n      return scopes[index];\n    }\n    /**\n     * ###<a name=\"getRowItem\">getRowItem</a>###\n     * Return the data item of that row.\n     * @param {Number} index\n     * @returns {*}\n     */\n    function getRowItem(index) {\n      return this.getData()[index];\n    }\n    /**\n     * ###<a name=\"getRowElm\">getRowElm</a>###\n     * Return the DOM element at that row index.\n     * @param {Number} index\n     * @returns {JQLite|*}\n     */\n    function getRowElm(index) {\n      return angular.element(inst.chunkModel.getRow(index));\n    }\n    /**\n     * ###<a name=\"getExistingRow\">getExistingRow</a>###\n     * Return the DOM element at that row index. This will not build it if it doesn't exist.\n     * @param {Number} index\n     * @returns {element|*}\n     */\n    function getExistingRow(index) {\n      return angular.element(inst.chunkModel.getExistingRow(index));\n    }\n    /**\n     * ###<a name=\"isCompiled\">isCompiled</a>###\n     * Return if the row is compiled or not.\n     * @param {Number} index\n     * @returns {boolean}\n     */\n    function isCompiled(index) {\n      return !!scopes[index];\n    }\n    /**\n     * ###<a name=\"getRowIndex\">getRowIndex</a>###\n     * Get the index of a row from a reference the data object of a row.\n     * @param {Number} item\n     * @returns {*}\n     */\n    function getRowIndex(item) {\n      return inst.getNormalizedIndex(item, 0);\n    }\n    /**\n     * ###<a name=\"getRowIndexFromElement\">getRowIndexFromElement</a>###\n     * Get the index of a row from a reference to a DOM element that is contained within a row.\n     * @param {JQLite|DOMElement} el\n     * @returns {*}\n     */\n    function getRowIndexFromElement(el) {\n      if (element) {\n        if (el && element[0].contains(el[0] || el)) {\n          el = el.scope ? el : angular.element(el);\n          var s = el.scope();\n          if (s === inst.scope) {\n            inst.throwError(\"Unable to get row scope... something went wrong.\");\n          }\n          // make sure we get the right scope to grab the index from. We need to get it from a row.\n          while (s && s.$parent && s.$parent !== inst.scope) {\n            s = s.$parent;\n          }\n          if (s.$index === undefined) {\n            flow.warn(\"Unable to get Index from row scope. Row scope is not activated or not compiled to that row.\");\n            while (el.length && !el[0].getAttribute(\"row-id\") && el[0] !== element[0]) {\n              el = el.parent();\n            }\n            return parseInt(el[0].getAttribute(\"row-id\"), 10);\n          }\n          return s.$index;\n        } else if (el && el.attr) {\n          // if a row is detached because of detached dom. We can still get the index.\n          while (el && el.attr(\"row-id\") === undefined && el[0] !== inst.element[0] && el[0] !== document.body) {\n            el = el.parent();\n          }\n          return parseInt(el.attr(\"row-id\"), 10);\n        }\n      }\n      return -1;\n    }\n    /**\n     * ###<a name=\"getRowOffset\">getRowOffset</a>###\n     * Return the scroll offset of a row by its index. All offsets are cached. They get updated if\n     * a row template changes, because it may change the height as well.\n     * @param {Number} index\n     * @returns {*}\n     */\n    function getRowOffset(index) {\n      if (rowOffsets[index] === undefined) {\n        if (options.dynamicRowHeights) {\n          // dynamicRowHeights should be set by the templates.\n          updateHeightValues();\n        } else {\n          rowOffsets[index] = index * options.rowHeight;\n        }\n      }\n      return rowOffsets[index];\n    }\n    /**\n     * ###<a name=\"getRowHeight\">getRowHeight</a>###\n     * Return the cached height of a row by index.\n     * @param {Number} index\n     * @returns {Number}\n     */\n    function getRowHeight(index) {\n      return inst.templateModel.getRowHeight(index);\n    }\n    /**\n     * ###<a name=\"getViewportHeight\">getViewportHeight</a>###\n     * Return the height of the viewable area of the datagrid.\n     */\n    function getViewportHeight() {\n      return viewHeight;\n    }\n    /**\n     * ###<a name=\"getConentHeight\">getContentHeight</a>###\n     * Return the total height of the content of the datagrid.\n     */\n    function getContentHeight() {\n      var list = inst && inst.chunkModel && inst.chunkModel.getChunkList() || [];\n      return list && list.height || 0;\n    }\n    /**\n     * ###<a name=\"createDom\">createDom</a>###\n     * This starts off the chunking. It creates all of the DOM chunks, rows, etc for the datagrid.\n     * @param {Array} list\n     */\n    function createDom(list) {\n      inst.log(\"OVERWRITE DOM!!!\");\n      var len = list.length;\n      // this async is important because it allows the updateRowWatchers on first digest to escape the current digest.\n      inst.chunkModel.chunkDom(list, options.chunks.size, '<div class=\"' + options.chunks.chunkClass + '\">', \"</div>\", content);\n      inst.rowsLength = len;\n      inst.log(\"created %s dom elements\", len);\n    }\n    /**\n     * ###<a name=\"compileRow\">compileRow</a>###\n     * Compile a row at that index. This creates the scope for that row when compiled. It does not perform a digest.\n     * @param {Number} index\n     * @param {Object=} el\n     * @returns {*}\n     */\n    function compileRow(index, el) {\n      var s = scopes[index],\n        currentRow;\n      if (s && !s.$parent) {\n        s.$parent = scope;\n      }\n      if (!s) {\n        // fixes a bug expanding the last row and trying to scroll to it.\n        if (!scope.$$childTail && scope.$$childHead && scopes[index - 1]) {\n          scope.$$childTail = scopes[index - 1];\n        }\n        s = scope.$new();\n        // if the parent scope is isolate then the new scope will use prototypial inheritence\n        // to get this property during the destroy phase. the issue is at the point of destruction\n        // the parent scope has already been destroyed so it will bypass the destroy phase for this scope.\n        // setting it to false will ensure that it does not go up the prototype chain and properly maintains the state\n        // whether it has been destroyed.\n        s.$$destroyed = false;\n        //s.$on('$destroy', function() {\n        //   console.log('DESTROY ' + s.$id + ' index:' + s.$index);\n        //});\n        processCompilation(s, index, el);\n      } else if (s && (currentRow = getExistingRow(index)).scope() !== s) {\n        // after rows are destroyed (memory optimizer) then they need to be recompiled.\n        processCompilation(s, index, currentRow);\n      }\n      return s;\n    }\n    /**\n     * @param s\n     * @param index\n     * @param el\n     */\n    function processCompilation(s, index, el) {\n      var tplName, tpl, $c;\n      tplName = inst.templateModel.getTemplateName(inst.data[index]);\n      tpl = inst.templateModel.getTemplate(inst.data[index]);\n      tplName = tplName || tpl.name;\n      s = s || getScope(index);\n      scopes[index] = s;\n      s.$status = options.compiledClass;\n      s[tpl.item] = inst.data[index];\n      // set the data to the scope.\n      s.$index = index;\n      el = el || getRowElm(index);\n      el.removeClass(options.uncompiledClass);\n      // by keeping the $compile(el) cached this seems to be faster than $compile(el)(s) every time.\n      $c = $compileCache[tplName] || ($compileCache[tplName] = $compile(el));\n      // since compile is cached we now use the clone method to replace our dom element with the cloned one.\n      $c(s, function (clone) {\n        var indexes = inst.chunkModel.getRowIndexes(index);\n        // gets the nested indexes for the row\n        indexes.pop();\n        // pop off the index for the row, we want it's parent.\n        var parent = inst.chunkModel.getItemByIndexes(indexes).dom;\n        // get the parent by indexes.\n        var attrs = el[0].attributes,\n          len = attrs.length;\n        // we need to copy over the row-id and any other custom properties on this row.\n        // use for loop instead of each to avoid closure function overhead. Needs to be as fast as possible.\n        for (var i = 0; i < len; i += 1) {\n          var attr = attrs[i];\n          // copy the attr from el to clone\n          if (attr.name !== \"class\" && clone.attr(attr.name) !== attr.value && attr.value !== undefined && !(attr.name === \"style\" && !attr.value)) {\n            clone.attr(attr.name, attr.value);\n          }\n        }\n        parent.replaceChild(clone[0], el[0]);\n        deactivateScope(s, index);\n      });\n      if (inst.templateModel.hasVariableRowHeights()) {\n        inst.chunkModel.updateAllChunkHeights(index);\n      }\n      inst.dispatch(exports.datagrid.events.ON_ROW_COMPILE, s, el);\n      deactivateScope(s, index);\n    }\n    /**\n     * ###<a name=\"buildRows\">buildRows</a>###\n     * Set the state to <a name=\"states.BUILDING\">states.BUILDING</a>. Then build the DOM.\n     * @param {Array} list\n     * @param {Boolean=} forceRender\n     */\n    function buildRows(list, forceRender) {\n      inst.log(\"\\tbuildRows %s\", list.length);\n      state = states.BUILDING;\n      createDom(list);\n      flow.add(updateHeightValues, 0);\n      if (!isReady()) {\n        flow.add(ready);\n      }\n      if (forceRender) {\n        flow.add(render);\n      }\n    }\n    /**\n     * ###<a name=\"ready\">ready</a>###\n     * Set the state to <a href=\"states.READY\">states.READY</a> and start the first render.\n     */\n    function ready() {\n      inst.log(\"\\tready\");\n      state = states.READY;\n      flow.add(fireReadyEvent);\n      flow.add(safeDigest, [scope]);\n    }\n    /**\n     * ###<a name=\"fireReadyEvent\">fireReadyEvent</a>###\n     * Fire the <a name=\"events.ON_READY\">events.ON_READY</a>\n     */\n    function fireReadyEvent() {\n      scope.$emit(exports.datagrid.events.ON_READY);\n    }\n    function isDigesting(s) {\n      //return !!(s && (s.$$phase || s.$root.$$phase));\n      // this must be checked this way. Otherwise isolated scopes can cause the value to be missleading.\n      var ds = s || scope;\n      while (ds) {\n        if (ds.$$phase) {\n          return true;\n        }\n        ds = ds.$parent;\n      }\n      return false;\n    }\n    /**\n     * ###<a name=\"safeDigest\">safeDigest</a>###\n     * SafeDigest by checking the render phase of the scope before rendering.\n     * while this is not recommended by angular it is effective.\n     * @param {Scope} s\n     */\n    function safeDigest(s) {\n      //        s.$evalAsync();// this sometimes takes too long so I see {{}} brackets briefly.\n      if (!isDigesting(s)) {\n        s.$digest();\n        return true;\n      }\n      return false;\n    }\n    /**\n     * ###<a name=\"applyEventCounts\">applyEventCounts</a>###\n     * Take all of the counts that we have and move up the parent chain subtracting them from the totals\n     * so that event listeners do not get stuck on broadcast.\n     * @param {Scope} s\n     * @param {Object} listenerCounts\n     * @param {Function} fn\n     */\n    function applyEventCounts(s, listenerCounts, fn) {\n      while (s) {\n        for (var eventName in listenerCounts) {\n          if (exports.util.apply(Object.prototype.hasOwnProperty, listenerCounts, [eventName])) {\n            fn(s, listenerCounts, eventName);\n          }\n        }\n        s = s.$parent;\n      }\n    }\n    /**\n     * ###<a name=\"addEvents\">addEvents</a>###\n     * Take all of the counts that we have and move up the parent chain adding them from the totals\n     * so that event listeners have them back for broadcast events.\n     * @param {Scope} s\n     * @param {Object} listenerCounts\n     */\n    function addEvents(s, listenerCounts) {\n      applyEventCounts(s, listenerCounts, addEvent);\n    }\n    /**\n     * ###<a name=\"addEvent\">addEvent</a>####\n     * Add the event to the $$listenerCount.\n     * @param {Scope} s\n     * @param {Object} listenerCounts\n     * @param {String} eventName\n     */\n    function addEvent(s, listenerCounts, eventName) {\n      //console.log(\"%c%s.$$listenerCount[%s] %s + %s = %s\", \"color:#009900\", s.$id, eventName, s.$$listenerCount[eventName], listenerCounts[eventName], s.$$listenerCount[eventName] + listenerCounts[eventName]);\n      s.$$listenerCount[eventName] += listenerCounts[eventName];\n    }\n    /**\n     * ###<a name=\"subtractEvents\">subtractEvents</a>###\n     * Take all of the counts that we have and move up the parent chain subtracting them from the totals\n     * so that event listeners do not get stuck on broadcast.\n     * @param {Scope} s\n     * @param {Object} listenerCounts\n     */\n    function subtractEvents(s, listenerCounts) {\n      applyEventCounts(s, listenerCounts, subtractEvent);\n    }\n    /**\n     * ###<a name=\"subtractEvent\">subtractEvent</a>###\n     * Take the count of events away from the $$listenerCount\n     * @param {Scope} s\n     * @param {Object} listenerCounts\n     * @param {String} eventName\n     */\n    function subtractEvent(s, listenerCounts, eventName) {\n      //console.log(\"%c%s.$$listenerCount[%s] %s + %s = %s\", \"color:#990000\", s.$id, eventName, s.$$listenerCount[eventName], listenerCounts[eventName], s.$$listenerCount[eventName] + listenerCounts[eventName]);\n      s.$$listenerCount[eventName] -= listenerCounts[eventName];\n    }\n    /**\n     * ###<a name=\"deactivateScope\">deactivateScope</a>###\n     * One of the core features to the datagrid's performance is the ability to make only the scopes\n     * that are in view to render. This deactivates a scope by removing its $$watchers that angular\n     * uses to know that it needs to digest. Thus inactivating the row. We also remove all watchers from\n     * child scopes recursively storing them on each child in a separate variable to activate later.\n     * They need to be reactivated before being destroyed for proper cleanup.\n     * $$childHead and $$nextSibling variables are also updated for angular so that it will not even iterate\n     * over a scope that is deactivated. It becomes completely hidden from the digest.\n     * @param {Scope} s\n     * @param {number} index\n     * @returns {boolean}\n     */\n    function deactivateScope(s, index) {\n      // if the scope is not created yet. just skip.\n      if (s && !isActive(s)) {\n        // do not deactivate one that is already deactivated.\n        //console.log(\"\\t%cdeactivate %s index:%s\", \"color:#F60\", s.$id, s.$index);\n        // s.$emit(exports.datagrid.events.ON_BEFORE_ROW_DEACTIVATE);// not sure why anyone would need to know outside of the grid about this.\n        s.$broadcast(exports.datagrid.events.ON_BEFORE_ROW_DEACTIVATE);\n        // the row may want to set flags or remove listeners before the deactivate.\n        s.$$$watchers = s.$$watchers;\n        s.$$watchers = [];\n        s.$$$watchersCount = s.$$watchersCount;\n        s.$$watchersCount = 0;\n        s.$$$listenerCount = angular.extend({}, s.$$listenerCount);\n        subtractEvents(s, s.$$listenerCount);\n        if (index >= 0) {\n          // detach itself from others.\n          if (s.$$prevSibling) {\n            s.$$prevSibling.$$nextSibling = null;\n          } else if (s.$$nextSibling) {\n            s.$$nextSibling.$$prevSibling = null;\n          }\n          s.$parent = scope;\n          // always let the child stay linked to the parent.\n          s.$$nextSibling = null;\n          s.$$prevSibling = null;\n        }\n        return true;\n      }\n      return false;\n    }\n    /**\n     * ###<a name=\"activateScope\">activateScope</a>###\n     * Taking a scope that is deactivated the watchers that it did have are now stored on $$$watchers and\n     * can be put back to $$watchers so angular will pick up this scope on a digest. This is done recursively\n     * though child scopes as well to activate them. It also updates the linking $$childHead and $$nextSiblings\n     * to fully make sure the scope is as if it was before it was deactivated.\n     * @param {Scope} s\n     * @param {number} index\n     * @returns {boolean}\n     */\n    function activateScope(s, index, link) {\n      if (s && s.$$$watchers !== undefined) {\n        // do not activate one that is already active.\n        //console.log(\"\\t%cactivate %s index:%s\", \"color:#090\", s.$id, s.$index);\n        s.$parent = scope;\n        s.$$watchers = s.$$$watchers;\n        s.$$watchersCount = s.$$$watchersCount;\n        delete s.$$$watchers;\n        addEvents(s, s.$$$listenerCount);\n        delete s.$$$listenerCount;\n        // s.$emit(exports.datagrid.events.ON_AFTER_ROW_ACTIVATE);// does anyone need to know that this row is active?\n        // the row it'self may need to know to update values if they are not bound to functions.\n        s.$broadcast(exports.datagrid.events.ON_AFTER_ROW_ACTIVATE);\n        return true;\n      }\n      return !!(s && !s.$$$watchers);\n    }\n    /**\n     * ###<a name=\"isActive\">isActive</a>###\n     * Check a scope by index to see if it is active.\n     * @param {Number} index\n     * @returns {boolean}\n     */\n    function isActive(index) {\n      var s = scopes[index];\n      return !!(s && !s.$$$watchers);\n    }\n    /**\n     * ###<a name=\"getOffsetIndex\">getOffsetIndex</a>###\n     * Given a scroll offset, get the index that is closest to that scroll offset value.\n     * @param {Number} offset\n     * @returns {number}\n     */\n    function getOffsetIndex(offset) {\n      // updateHeightValues must be called before this.\n      var est = Math.floor(offset / inst.templateModel.averageTemplateHeight()),\n        i = 0,\n        len = inst.rowsLength;\n      if (!offset || inst.rowsLength < 2) {\n        return i;\n      }\n      if (rowOffsets[est] && rowOffsets[est] <= offset) {\n        i = est;\n      }\n      while (i < len) {\n        if (rowOffsets[i] <= offset && rowOffsets[i + 1] > offset) {\n          return i;\n        }\n        i += 1;\n      }\n      return i;\n    }\n    /**\n     * ###<a name=\"getStartingIndex\">getStartingIndex</a>###\n     * Because the datagrid can render as many as 50k rows it becomes necessary to optimize loops by\n     * determining the index to start checking for deactivated and activated scopes at instead of iterating\n     * all of the items. This greatly improves a render because it only iterates from where the last render was.\n     * It does this by taking the last first active element and then counting from there till we get to the top\n     * of the start area. So we never have to loop the whole thing.\n     * @returns {{startIndex: number, i: number, inc: number, end: number, visibleScrollStart: number, visibleScrollEnd: number}}\n     */\n    function getStartingIndex() {\n      if (values.dirty && inst.chunkModel.getChunkList() && inst.chunkModel.getChunkList().height - inst.getViewportHeight() < values.scroll) {\n        // We are trying to start the scroll off at a height that is taller than we have in the list.\n        // reset scroll to 0.\n        inst.info(\"Scroll reset because either there is no data or the scroll is taller than there is scroll area\");\n        values.scroll = 0;\n      }\n      var height = viewHeight,\n        scroll = values.scroll >= 0 ? values.scroll : 0,\n        result = {\n          startIndex: 0,\n          i: 0,\n          inc: 1,\n          end: inst.rowsLength,\n          visibleScrollStart: scroll + options.cushion,\n          visibleScrollEnd: scroll + height - options.cushion\n        };\n      result.startIndex = result.i = inst.getOffsetIndex(scroll);\n      if (inst.rowsLength && result.startIndex === result.end) {\n        result.startIndex = result.i = result.end - 1;\n        // always select at least one row.\n        inst.log(exports.errors.E1002);\n      }\n      return result;\n    }\n    /**\n     * ###<a name=\"updateHeightValues\">updateHeightValues</a>###\n     * invalidate and update all height values of the chunks and rows.\n     */\n    function updateHeightValues() {\n      var height = 0,\n        i = 0,\n        contentHeight;\n      while (i < inst.rowsLength) {\n        rowOffsets[i] = height;\n        height += inst.getRowHeight(i);\n        i += 1;\n      }\n      options.rowHeight = inst.rowsLength ? inst.templateModel.getTemplateHeight(\"default\") : 0;\n      contentHeight = getContentHeight();\n      inst.getContent()[0].style.height = contentHeight + \"px\";\n      inst.log(\"heights: viewport %s content %s\", inst.getViewportHeight(), contentHeight);\n    }\n    /**\n     * ###<a name=\"updateRowWatchers\">updateRowWatchers</a>###\n     * This is the core of the datagird rendering. It determines the range of scopes to be activated and\n     * deactivates any scopes that were active before that are not still active.\n     */\n    function updateRowWatchers() {\n      var loop = getStartingIndex(),\n        offset,\n        lastActive = [].concat(active),\n        lastActiveIndex,\n        s,\n        prevS,\n        digestLater = false,\n        rowEl;\n      if (loop.i < 0) {\n        // then scroll is negative. ignore it.\n        return;\n      }\n      inst.dispatch(events.ON_BEFORE_UPDATE_WATCHERS, loop);\n      // we only want to update stuff if we are scrolling slow.\n      resetMinMax();\n      // this needs to always be set after the dispatch of before update watchers in case they need the before activeRange.\n      active.length = 0;\n      // make sure not to reset until after getStartingIndex.\n      inst.log(\"\\tscroll %s visibleScrollStart %s visibleScrollEnd %s\", values.scroll, loop.visibleScrollStart, loop.visibleScrollEnd);\n      while (loop.i < inst.rowsLength) {\n        prevS = scope.$$childHead ? scopes[loop.i - 1] : null;\n        offset = inst.getRowOffset(loop.i);\n        // this is where the chunks and rows get created is when they are requested if they don't exist.\n        // we only want to render what is visible.\n        // however, we always want to render at least one row if possible. So if we can tell that there is one row available then render that\n        // otherwise it will not enter here if there are no rows to render and will throw an error because of an invalid range.\n        if (offset >= loop.visibleScrollStart && offset <= loop.visibleScrollEnd || loop.i === loop.startIndex && loop.i < loop.end) {\n          s = compileRow(loop.i);\n          // only compiles if it is not already compiled. Still returns the scope.\n          if (loop.started === undefined) {\n            loop.started = loop.i;\n          }\n          updateMinMax(loop.i);\n          if (s.$$$watchers && activateScope(s, loop.i, true)) {\n            rowEl = inst.getRowElm(loop.i);\n            rowEl.attr(\"status\", \"active\");\n            lastActiveIndex = lastActive.indexOf(loop.i);\n            if (lastActiveIndex !== -1) {\n              lastActive.splice(lastActiveIndex, 1);\n            }\n            // make sure to put them into active in the right order.\n            active.push(loop.i);\n            if (!safeDigest(s)) {\n              digestLater = true;\n            }\n            s.$digested = true;\n          } else {\n            active.push(loop.i);\n          }\n        }\n        loop.i += loop.inc;\n        // optimize the loop\n        if (loop.inc > 0 && offset > loop.visibleScrollEnd || loop.inc < 0 && offset < loop.visibleScrollStart) {\n          break;\n        }\n      }\n      loop.ended = loop.i - 1;\n      if (inst.rowsLength && values.activeRange.min < 0 && values.activeRange.max < 0) {\n        inst.throwError(exports.errors.E1002);\n      }\n      inst.log(\"\\tstartIndex %s endIndex %s\", loop.startIndex, loop.i);\n      deactivateList(lastActive);\n      lastVisibleScrollStart = loop.visibleScrollStart;\n      inst.log(\"\\tactivated %s\", active.join(\", \"));\n      updateLinks();\n      // update the $$childHead and $$nextSibling values to keep digest loops at a minimum count.\n      // this dispatch needs to be after the digest so that it doesn't cause {} to show up in the render.\n      // the creep render cannot be synchronous. It needs to wait till done to render.\n      if (inst.templateModel.hasVariableRowHeights()) {\n        updateHeightValues();\n      }\n      flow.add(onAfterUpdateWatchers, [loop], 0);\n      if (digestLater) {\n        flow.add(function () {\n          safeDigest(scope);\n        });\n      }\n    }\n    function onAfterUpdateWatchers(loop) {\n      inst.dispatch(events.ON_AFTER_UPDATE_WATCHERS, loop);\n    }\n    /**\n     * ###<a name=\"deactivateList\">deactivateList</a>###\n     * Deactivate a list of scopes.\n     */\n    function deactivateList(lastActive) {\n      var lastActiveIndex,\n        deactivated = [];\n      while (lastActive.length) {\n        lastActiveIndex = lastActive.pop();\n        if (active.indexOf(lastActiveIndex) === -1) {\n          deactivated.push(lastActiveIndex);\n          deactivateScope(scopes[lastActiveIndex], lastActiveIndex);\n          inst.getRowElm(lastActiveIndex).attr(\"status\", \"inactive\");\n        }\n      }\n      inst.log(\"\\tdeactivated %s\", deactivated.join(\", \"));\n    }\n    /**\n     * ###<a name=\"updateLinks\">updateLinks</a>###\n     * Updates the $$childHead, $$childTail, $$nextSibling, and $$prevSibling values from the parent scope to completely\n     * hide scopes that are deactivated from angular's knowledge so digest loops are as small as possible.\n     */\n    function updateLinks() {\n      if (active.length) {\n        var lastIndex = active[active.length - 1],\n          i = 0,\n          len = active.length,\n          s;\n        //console.log(\"activated \" + active[0] + \" to \" + active[len - 1]);\n        for (i = 0; i < len; i += 1) {\n          s = scopes[active[i]];\n          s.$$prevSibling = scopes[active[i - 1]];\n          s.$$nextSibling = scopes[active[i + 1]];\n          // will be undefined if the scope is not active.\n          s.$parent = scope;\n        }\n        scope.$$childHead = scopes[active[0]];\n        scope.$$childTail = scopes[lastIndex];\n      }\n    }\n    /**\n     * ###<a name=\"resetMinMax\">resetMinMax</a>###\n     * resets the min and max of the activeRange for what is activated.\n     */\n    function resetMinMax() {\n      values.activeRange.min = values.activeRange.max = -1;\n    }\n    /**\n     * ###<a name=\"updateMinMax\">updateMinMax</a>###\n     * takes an index that has just been activated and updates the min and max\n     */\n    function updateMinMax(activeIndex) {\n      // values for later calculations to know the range.\n      values.activeRange.min = values.activeRange.min < activeIndex && values.activeRange.min >= 0 ? values.activeRange.min : activeIndex;\n      values.activeRange.max = values.activeRange.max > activeIndex && values.activeRange.max >= 0 ? values.activeRange.max : activeIndex;\n    }\n    /**\n     * ###<a name=\"beforeRenderAfterDataChange\">beforeRenderAfterDataChange</a>###\n     * fired just before the update watchers are applied if the data has changed.\n     */\n    function beforeRenderAfterDataChange() {\n      if (values.dirty) {\n        dispatch(exports.datagrid.events.ON_BEFORE_RENDER_AFTER_DATA_CHANGE);\n      }\n    }\n    /**\n     * ###<a name=\"afterRenderAfterDataChange\">afterRenderAfterDataChange</a>###\n     * after the data has changed this is fired after the following render.\n     */\n    function afterRenderAfterDataChange() {\n      var tplHeight, oldHeight;\n      if (values.dirty && values.activeRange.max >= 0) {\n        values.dirty = false;\n        tplHeight = inst.templateModel.calculateRowHeight(getRowElm(values.activeRange.min)[0]);\n        if (flow.async && inst.getData().length && tplHeight !== (oldHeight = inst.templateModel.getRowHeight(values.activeRange.min))) {\n          if (window.console && console.warn) {\n            console.warn(\"Template height change from \" + oldHeight + \" to \" + tplHeight + \". This can cause gaps in the datagrid.\");\n          }\n          inst.templateModel.updateTemplateHeights();\n        }\n        dispatch(exports.datagrid.events.ON_RENDER_AFTER_DATA_CHANGE);\n      }\n    }\n    function whenReadyToRender() {\n      flow.add(inst.updateViewportHeight, null, waitCount);\n      // have it wait a moment for the height to change.\n      flow.add(render);\n    }\n    /**\n     * ###<a name=\"readyToRender\">readyToRender</a>###\n     * the datagrid requires a height to be able to render. If the datagrid is compiled\n     * and not added to the DOM it will not have a height until added to the DOM. If this fails it will wait until the next\n     * frame to check the height. If that fails it exits.\n     */\n    function readyToRender() {\n      updateViewportHeight();\n      if (!viewHeight) {\n        waitCount += 1;\n        if (waitCount < inst.options.readyToRenderRetryMax) {\n          inst.info(\"datagrid is waiting for element to have a height.\");\n          whenReadyToRender();\n        } else {\n          flow.warn(\"Datagrid: Unable to determine a height for the datagrid. Cannot render. Exiting.\");\n        }\n        return false;\n      }\n      if (waitCount) {\n        inst.info(\"datagrid has height of %s.\", viewHeight);\n      }\n      waitCount = 0;\n      return true;\n    }\n    /**\n     * ###<a name=\"render\">render</a>###\n     * depending on the state of the datagrid this will create necessary DOM, compile rows, or\n     * digest <a href=\"#activeRange\">activeRange</a> of rows.\n     */\n    function render() {\n      inst.info(\"render\");\n      if (readyToRender()) {\n        waitCount = 0;\n        inst.log(\"\\trender %s\", state);\n        // Where [states.BUILDING](#states.BUILDING) is used\n        if (state === states.BUILDING) {\n          buildRows(inst.data);\n        } else if (state === states.READY) {\n          inst.dispatch(exports.datagrid.events.ON_BEFORE_RENDER);\n          flow.add(beforeRenderAfterDataChange);\n          flow.add(updateRowWatchers);\n          // if we do not wait here row heights show too tall because the rows are evaluated at their height before being digetsted.\n          flow.add(afterRenderAfterDataChange);\n          //, [], 0);\n          //                flow.add(destroyOldContent);\n          flow.add(inst.dispatch, [exports.datagrid.events.ON_AFTER_RENDER]);\n        } else {\n          inst.throwError(exports.errors.E1001);\n        }\n      } else {\n        inst.log(\"\\tnot ready to render.\");\n      }\n    }\n    /**\n     * ###<a name=\"update\">update</a>###\n     * force the datagrid to fire a data change update or fire a redraw if that fails.\n     */\n    function update() {\n      if (inst) {\n        inst.warn(\"force update\");\n      }\n      if (!onDataChanged(scope.$eval(attr.uxDatagrid), inst.data)) {\n        forceRedraw();\n      }\n    }\n    /**\n     * ###<a name=\"forceUpdate\">forceUpdate</a>###\n     * force the datagrid to fire a data change update.\n     */\n    function forceRedraw() {\n      // we need to wait a moment for the browser to finish the resize, then adjust and fire the event.\n      flow.add(updateHeights, [], 100);\n    }\n    /**\n     * ###<a name=\"dirtyCheckData\">dirtyCheckData</a>###\n     * Compare the new and the old value. If the item number is the same, and no templates\n     * have changed then just update the scopes and run the watchers instead of doing a reset.\n     * @param {Array} newVal\n     * @param {Array} oldVal\n     */\n    function dirtyCheckData(newVal, oldVal) {\n      //TODO: this needs unit tested.\n      if (newVal && oldVal && newVal.length === oldVal.length) {\n        var i = 0,\n          len = newVal.length;\n        while (i < len) {\n          if (dirtyCheckItemTemplate(newVal[i], oldVal[i])) {\n            return true;\n          }\n          i += 1;\n        }\n        if (inst.data.length !== inst.normalize(newVal, inst.grouped).length) {\n          inst.log(\"\\tdirtyCheckData length is different\");\n          return true;\n        }\n        return false;\n      }\n      return true;\n    }\n    /**\n     * ###<a name=\"dirtyCheckItemTemplate\">dirtyCheckItemTemplate</a>###\n     * check to see if the template for the item has changed\n     * @param {*} newItem\n     * @param {*} oldItem\n     */\n    function dirtyCheckItemTemplate(newItem, oldItem) {\n      if (inst.templateModel.getTemplate(newItem) !== inst.templateModel.getTemplate(oldItem)) {\n        inst.log(\"\\tdirtyCheckData row template changed\");\n        return true;\n      }\n      return false;\n    }\n    /**\n     * ###<a name=\"mapData\">mapData</a>###\n     * map the new data to the old data object and update the scopes.\n     */\n    function mapData(newVal, oldVal) {\n      //TODO: there is some error here that is causing the rows now not to compile.\n      inst.log(\"\\tmapData()\");\n      var oldTemplates = [];\n      // get temp cache for templates\n      exports.each(inst.getData(), cacheOldTemplates, oldTemplates);\n      inst.data = inst.setData(newVal, inst.grouped) || [];\n      inst.chunkModel.updateList(inst.data);\n      exports.each(inst.getData(), updateScope, oldTemplates);\n      oldTemplates = null;\n      // clear temp cache for templates.\n      dispatch(exports.datagrid.events.ON_AFTER_DATA_CHANGE, inst.data, oldVal);\n    }\n    /**\n     * ###<a name=\"cacheOldTemplates>cacheOldTemplates</a>###\n     * temporarily cache old templates for mapping so we can tell if a template changed\n     * when a scope changed.\n     * @param item\n     * @param index\n     * @param list\n     * @param cache\n     */\n    function cacheOldTemplates(item, index, list, cache) {\n      cache[index] = inst.templateModel.getTemplate(item);\n    }\n    /**\n     * ###<a name=\"updateScope\">updateScope</a>###\n     * update the scope at that index with the new item.\n     */\n    function updateScope(item, index, list, oldTemplates) {\n      var tpl, oldTemplate;\n      if (scopes[index]) {\n        //            console.log(\"update scope %s\", index);\n        oldTemplate = oldTemplates[index];\n        delete scopes[index][oldTemplate.item];\n        tpl = inst.templateModel.getTemplate(item);\n        scopes[index][tpl.item] = item;\n        if (tpl !== oldTemplates[index]) {\n          //                console.log(\"\\treplace %s %s %s\", index, oldTemplate.height, tpl.height);\n          onRowTemplateChange({}, item, oldTemplates[index].name, tpl.name, [], true);\n        }\n      }\n    }\n    /**\n     * ###<a name=\"onDataChanged\">onDataChanged</a>###\n     * when the data changes. It is compared by reference, not value for speed\n     * (this is the default angular setting).\n     * @param {Array} newVal\n     * @param {Array} oldVal\n     * @returns {boolean}\n     */\n    function onDataChanged(newVal, oldVal, lifespan) {\n      inst.info(\"\\tonDataChanged |\" + lifespan + \"| new:\" + (newVal && newVal.length || 0) + \" old:\" + (oldVal && oldVal.length || 0));\n      inst.grouped = scope.$eval(attr.grouped);\n      if (oldVal !== inst.getOriginalData()) {\n        oldVal = inst.getOriginalData();\n      }\n      if (!inst.options.smartUpdate || !inst.data.length || dirtyCheckData(newVal, oldVal)) {\n        var evt = dispatch(exports.datagrid.events.ON_BEFORE_DATA_CHANGE, newVal, oldVal);\n        if (evt.defaultPrevented && evt.newValue) {\n          newVal = evt.newValue;\n        }\n        values.dirty = true;\n        flow.add(changeData, [newVal, oldVal, lifespan]);\n        return true;\n      } else if (isDataReallyChanged(newVal)) {\n        // we just want to update the data values and scope values, because no templates changed.\n        values.dirty = true;\n        mapData(newVal, oldVal);\n        flow.add(updateHeights, [], 0);\n        return true;\n      }\n      return false;\n    }\n    function isDataReallyChanged(newVal) {\n      // loop through the data and make sure it hasn't already been updated by swap.\n      var i = 0,\n        norm = inst.normalize(newVal, inst.grouped),\n        len = newVal.length;\n      while (i < len) {\n        if (inst.data[i] !== norm[i]) {\n          return true;\n        }\n        i += 1;\n      }\n      return false;\n    }\n    function changeData(newVal, oldVal, lifespan) {\n      if (inst.flow.count([\"changeData\", \"onDataChanged\"]) > 1) {\n        // the first one is this call.\n        inst.info(\"\\tSKIPPED changeData |\" + lifespan + \"| another is pending.\");\n        return;\n      }\n      inst.info(\"\\tchangeData |\" + lifespan + \"| :\" + (newVal && newVal.length || 0) + \" old:\" + (oldVal && oldVal.length || 0));\n      inst.templateModel.clearAllRowHeights();\n      dispatch(exports.datagrid.events.ON_BEFORE_RESET, inst);\n      inst.data = inst.setData(newVal, inst.grouped) || [];\n      reset();\n      flow.add(dispatch, [exports.datagrid.events.ON_AFTER_DATA_CHANGE, inst.data, oldVal]);\n    }\n    /**\n     * ###<a name=\"reset\">reset</a>###\n     * clear all and rebuild.\n     */\n    function reset() {\n      inst.info(\"reset start\");\n      flow.clear();\n      // we are going to clear all in the flow before doing a reset.\n      //        state = states.BUILDING;\n      destroyScopes();\n      // now destroy all of the dom.\n      rowOffsets = {};\n      active.length = 0;\n      scopes.length = 0;\n      // keep reference to the old content and add a class to it so we can tell it is old. We will remove it after the render.\n      content.children().unbind();\n      content.children().remove();\n      // make sure scopes are destroyed before this level and listeners as well or this will create a memory leak.\n      if (inst.chunkModel.getChunkList()) {\n        inst.chunkModel.reset(inst.data, content, scopes);\n        inst.rowsLength = inst.data.length;\n        updateHeights();\n      } else {\n        buildRows(inst.data, true);\n      }\n      flow.add(inst.info, [\"reset complete\"]);\n      flow.add(dispatch, [exports.datagrid.events.ON_AFTER_RESET, inst]);\n    }\n    /**\n     * ###<a name=\"forceRenderScope\">forceRenderScope</a>###\n     * used to force a row to render and digest that may not be within\n     * the <a href=\"#values.activeRange\">activeRange</a>\n     * @param {Number} index\n     */\n    function forceRenderScope(index) {\n      var s = scopes[index];\n      //        inst.log(\"\\tforceRenderScope %s\", index);\n      if (!s && index >= 0 && index < inst.rowsLength) {\n        s = compileRow(index);\n      }\n      if (s && !scope.$$phase) {\n        activateScope(s, index);\n        s.$digest();\n        deactivateScope(s, index);\n        s.$digested = true;\n        if (inst.templateModel.hasVariableRowHeights()) {\n          inst.chunkModel.updateAllChunkHeights(index);\n          updateHeightValues();\n        }\n      }\n    }\n    /**\n     * ###<a name=\"onRowTemplateChange\">onRowTemplateChange</a>###\n     * when changing the template for an individual row.\n     * @param {Event} evt\n     * @param {*} item\n     * @param {Object} oldTemplate\n     * @param {Object} newTemplate\n     * @param {Array} classes\n     * @param {Boolean=} skipUpdateHeights - useful to turn off when doing multiple row template changes.\n     */\n    function onRowTemplateChange(evt, item, oldTemplate, newTemplate, classes, skipUpdateHeights) {\n      var index = inst.getNormalizedIndex(item),\n        el = getExistingRow(index),\n        s = getScope(index),\n        replaceEl;\n      if (s && s !== scope) {\n        // no scope if that row was removed.\n        replaceEl = angular.element(inst.templateModel.getTemplateByName(newTemplate).template);\n        replaceEl.addClass(options.uncompiledClass);\n        while (classes && classes.length) {\n          replaceEl.addClass(classes.shift());\n        }\n        el.parent()[0].replaceChild(replaceEl[0], el[0]);\n        activateScope(s, index);\n        el.remove();\n        s.$destroy();\n        scopes[index] = null;\n        if (!skipUpdateHeights) {\n          inst.chunkModel.updateRow(index, item);\n          updateHeights(index);\n        }\n      }\n    }\n    /**\n     * ###<a name=\"updateHeights\">updateHeights</a>###\n     * force invalidation of heights and recalculate them then render.\n     * If a rowIndex is specified, only update ones affected by that row, otherwise update all.\n     * @param {Number=} rowIndex\n     */\n    function updateHeights(rowIndex) {\n      flow.add(updateViewportHeight);\n      flow.add(inst.chunkModel.updateAllChunkHeights, [rowIndex]);\n      flow.add(updateHeightValues);\n      flow.add(updateViewportHeight);\n      flow.add(function () {\n        var maxScrollHeight = inst.getContentHeight() - inst.getViewportHeight();\n        if (values.scroll > maxScrollHeight) {\n          values.scroll = maxScrollHeight;\n        }\n      });\n      flow.add(inst.dispatch, [exports.datagrid.events.ON_AFTER_HEIGHTS_UPDATED]);\n      flow.add(render);\n      flow.add(inst.dispatch, [exports.datagrid.events.ON_AFTER_HEIGHTS_UPDATED_RENDER]);\n    }\n    /**\n     * ###<a name=\"dispatch\">dispatch</a>###\n     * handle dispatching of events from the datagrid.\n     * @param {String} event\n     * @returns {Object}\n     */\n    function dispatch(event) {\n      if (inst.options.debug) eventLogger.log(\"$emit %s\", event);\n      // THIS SHOULD ONLY EMIT. Broadcast could perform very poorly especially if there are a lot of rows.\n      return exports.util.apply(scope.$emit, scope, arguments);\n    }\n    function forceGarbageCollection() {\n      // concept is to create a large object that will cause the browser to garbage collect before creating it.\n      // then since it has no reference it gets removed.\n      clearInterval(gcIntv);\n      if (!inst.shuttingDown) {\n        gcIntv = setTimeout(function () {\n          if (inst) {\n            inst.info(\"GC\");\n            var a,\n              i,\n              total = 1024 * 1024 * .5;\n            for (i = 0; i < total; i += 1) {\n              a = .5;\n            }\n          }\n        }, 5e3);\n      }\n    }\n    /**\n     * ###<a name=\"destroyScopes\">destroyScopes</a>###\n     * used to destroy the scopes of all rows in the datagrid that are compiled.\n     */\n    function destroyScopes() {\n      // because child scopes may not be in order because of rendering techniques we must loop through\n      // all scopes and destroy them manually.\n      var lastScope,\n        nextScope,\n        i = 0;\n      each(scopes, function (s, index) {\n        // listeners should be destroyed with the angular destroy.\n        if (s && !s.$$destroyed) {\n          s.$$prevSibling = lastScope || undefined;\n          i = index;\n          while (!nextScope && i < inst.rowsLength) {\n            i += 1;\n            nextScope = scopes[i] || undefined;\n          }\n          activateScope(s, index);\n          lastScope = s;\n          s.$destroy();\n        }\n      });\n      scope.$$childHead = undefined;\n      scope.$$childTail = undefined;\n      scopes.length = 0;\n    }\n    /**\n     * ###<a name=\"destroy\">destroy</a>###\n     * needs to put all watcher back before destroying or it will not destroy child scopes, or remove watchers.\n     */\n    function destroy() {\n      inst.shuttingDown = true;\n      getContent()[0].style.display = \"none\";\n      scope.datagrid = null;\n      // we have a circular reference. break it on destroy.\n      inst.log(\"destroying grid\");\n      window.removeEventListener(\"resize\", onResize);\n      clearTimeout(values.scrollingStopIntv);\n      // destroy flow.\n      flow.destroy();\n      inst.flow = undefined;\n      flow = null;\n      // destroy watchers.\n      while (unwatchers.length) {\n        unwatchers.pop()();\n      }\n      inst.destroyLogger();\n      // now remove every property on exports.\n      for (var i in inst) {\n        if (inst[i] && inst[i].hasOwnProperty(\"destroy\")) {\n          inst[i].destroy();\n          inst[i] = null;\n        }\n      }\n      //activate scopes so they can be destroyed by angular.\n      destroyScopes();\n      element.remove();\n      // this seems to be the most memory efficient way to remove elements.\n      delete scope.$parent[inst.name];\n      rowOffsets = null;\n      inst = null;\n      scope = null;\n      element = null;\n      attr = null;\n      unwatchers = null;\n      content = null;\n      active.length = 0;\n      active = null;\n      scopes.length = 0;\n      scopes = null;\n      values = null;\n      states = null;\n      events = null;\n      options = null;\n      logEvents = null;\n      $compile = null;\n    }\n    exports.logWrapper(\"datagrid\", inst, \"green\", inst);\n    exports.logWrapper(\"events\", eventLogger, \"light\", inst);\n    scope.datagrid = inst;\n    setupExports();\n    return inst;\n  }\n\n  /**\n   * ###<a name=\"uxDatagrid\">uxDatagrid</a>###\n   * define the directive, setup addons, apply core addons then optional addons.\n   */\n  ngModule.directive(\"uxDatagrid\", [\"$compile\", \"gridAddons\", \"$timeout\", function ($compile, gridAddons, $timeout) {\n    return {\n      restrict: \"AE\",\n      scope: true,\n      link: {\n        pre: function pre(scope, element, attr) {\n          var inst = new Datagrid(scope, element, attr, $compile, $timeout);\n          each(exports.datagrid.coreAddons, function (method) {\n            exports.util.apply(method, inst, [inst]);\n          });\n          gridAddons(inst, exports.datagrid.defaultAddons || \"\");\n          gridAddons(inst, attr.addons);\n        },\n        post: function post(scope, element, attr) {\n          scope.datagrid.start();\n        }\n      }\n    };\n  }]);\n\n  /**\n   * ###chunkModel###\n   * Because the browser has low performance on dom elements that exist in high numbers and are all\n   * siblings chunking is used to break them up into limits of their number and their parents and so on.\n   * So think of it as every chunk not having more than X number of children weather those children be\n   * chunks or they be rows.\n   *\n   * This speeds up the browser significantly because a resize event from a dom element will not affect\n   * all of them, but just those direct siblings and then it's parents siblings and so on up the chain.\n   *\n   * @param {Datagrid} inst\n   * @returns {{}}\n   */\n  exports.datagrid.coreAddons.chunkModel = function chunkModel(inst) {\n    var _list,\n      _rows,\n      _chunkSize,\n      _el,\n      result = exports.logWrapper(\"chunkModel\", {}, \"purple\", inst),\n      _templateStartCache,\n      _templateEndCache,\n      _cachedDomRows = [];\n    /**\n     * **getChunkList**\n     * Return the list that was created.\n     * @returns {ChunkArray}\n     */\n    function getChunkList() {\n      return _list;\n    }\n    /**\n     * Create a ChunkArray from the array of data that is passed.\n     * The array that is passed should not be multi-dimensional. This will only work with a single\n     * dimensional array.\n     * @param {Array} list\n     * @param {Number} size\n     * @param {String} templateStart\n     * @param {String} templateEnd\n     * @returns {ChunkArray}\n     */\n    function chunkList(list, size, templateStart, templateEnd) {\n      var i = 0,\n        len = list.length,\n        result = new ChunkArray(inst.options.chunks.detachDom),\n        childAry,\n        item;\n      while (i < len) {\n        item = list[i];\n        if (i % size === 0) {\n          if (childAry) {\n            childAry.updateHeight(inst.templateModel, _rows);\n          }\n          childAry = new ChunkArray(inst.options.chunks.detachDom);\n          childAry.min = item.min || i;\n          childAry.templateModel = inst.templateModel;\n          childAry.templateStart = templateStart;\n          childAry.templateEnd = templateEnd;\n          childAry.parent = result;\n          childAry.index = result.length;\n          result.push(childAry);\n        }\n        if (item instanceof ChunkArray) {\n          item.parent = childAry;\n          item.index = childAry.length;\n        }\n        childAry.push(item);\n        childAry.max = item.max || i;\n        i += 1;\n      }\n      if (childAry) {\n        childAry.updateHeight(inst.templateModel, _rows);\n      }\n      if (!result.min) {\n        result.min = result[0] ? result[0].min : 0;\n        result.max = result[result.length - 1] ? result[result.length - 1].max : 0;\n        result.templateStart = templateStart;\n        result.templateEnd = templateEnd;\n        result.updateHeight(inst.templateModel, _rows);\n        result.dirtyHeight = false;\n      }\n      return result.length > size ? chunkList(result, size, templateStart, templateEnd) : result;\n    }\n    /**\n     * ###<a name=\"updateAllChunkHeights\">updateAllChunkHeights</a>###\n     * Update rows affected by this particular index change. if rowIndex is undefined, update all.\n     * @param {Number=} rowIndex\n     */\n    function updateAllChunkHeights(rowIndex) {\n      var indexes, ary;\n      if (rowIndex === undefined || inst.options.chunks.detachDom) {\n        //TODO: unit test needed.\n        // detach dom must enter here, because it is absolute positioned so it will not push down\n        // the other chunks automatically like relative positioning will.\n        if (_list) {\n          _list.forceHeightReCalc(inst.templateModel, _rows);\n          _list.updateHeight(inst.templateModel, _rows, 1, true);\n          if (_list.detachDom) {\n            _list.updateDomHeight(1);\n          }\n        }\n      } else {\n        indexes = getRowIndexes(rowIndex, _list);\n        ary = getArrayFromIndexes(indexes, _list);\n        ary.updateHeight(inst.templateModel, _rows, -1, true);\n      }\n    }\n    /**\n     * ###<a name=\"getArrayFromIndexes\">getArrayFromIndexes</a>###\n     * Look up the chunkArray given an indexes array.\n     * @param {Array} indexes\n     * @param {ChunkArray} ary\n     * @returns {*}\n     */\n    function getArrayFromIndexes(indexes, ary) {\n      var index;\n      while (indexes.length) {\n        index = indexes.shift();\n        if (ary[index] instanceof ChunkArray) {\n          ary = ary[index];\n        }\n      }\n      return ary;\n    }\n    /**\n     * Create the chunkList so that it is ready for dom. Set properties needed to create the dom.\n     * The dom gets created when the rows are accessed.\n     * @param {Array} list // single dimensional array only.\n     * @param {Number} size\n     * @param {String} templateStart\n     * @param {String} templateEnd\n     * @param {DomElement} el\n     * @returns {DomElement}\n     */\n    function chunkDom(list, size, templateStart, templateEnd, el) {\n      result.log(\"chunkDom\");\n      _el = el;\n      _chunkSize = size;\n      _rows = list;\n      _templateStartCache = templateStart;\n      _templateEndCache = templateEnd;\n      _list = chunkList(list, size, templateStart, templateEnd);\n      updateDom(_list);\n      _list.updateDomHeight(1);\n      return el;\n    }\n    /**\n     * For quick updates that do not require rechunking.\n     * @param list\n     * @returns {*}\n     */\n    function updateList(list) {\n      if (_rows.length !== list.length) {\n        return chunkDom(list, _chunkSize, _templateStartCache, _templateEndCache, _el);\n      } else {\n        var i = 0,\n          len = list.length;\n        while (i < len) {\n          updateRow(i, list[i]);\n          i += 1;\n        }\n      }\n    }\n    /**\n     * Update the item using the normalized index to map to the chunkArray.\n     * @param {Number} rowIndex\n     * @param {Object} rowData\n     */\n    function updateRow(rowIndex, rowData) {\n      var indexes = getRowIndexes(rowIndex, _list),\n        lastIndex = indexes.pop(),\n        ca = getItemByIndexes(indexes);\n      if (ca && ca[lastIndex]) {\n        ca[lastIndex] = rowData;\n        ca.dirtyHeight = true;\n      }\n      _rows[rowIndex] = rowData;\n    }\n    /**\n     * Generate an array of indexes that point to that row.\n     * @param rowIndex\n     * @param chunkList\n     * @param indexes\n     * @returns {Array}\n     */\n    function getRowIndexes(rowIndex, chunkList, indexes) {\n      if (!chunkList) {\n        return [];\n      }\n      var i = 0,\n        len = chunkList.length,\n        chunk;\n      indexes = indexes || [];\n      while (i < len) {\n        chunk = chunkList[i];\n        if (chunk instanceof ChunkArray) {\n          if (rowIndex >= chunk.min && rowIndex <= chunk.max) {\n            indexes.push(i);\n            getRowIndexes(rowIndex, chunk, indexes);\n            break;\n          }\n        } else {\n          // we are at the end. So we just need the last index.\n          indexes.push(rowIndex % _chunkSize);\n          break;\n        }\n        i += 1;\n      }\n      return indexes;\n    }\n    /**\n     * Get the dom row element.\n     * @param rowIndex {Number}\n     * @returns {*}\n     */\n    function getRow(rowIndex) {\n      var indexes = getRowIndexes(rowIndex, _list),\n        el = buildDomByIndexes(indexes);\n      if (el && el.length && el.attr(\"row-id\") === undefined) {\n        el.attr(\"row-id\", rowIndex);\n      }\n      return el;\n    }\n    /**\n     * Get the dom row element.\n     * @param rowIndex {Number}\n     * @returns {*}\n     */\n    function getExistingRow(rowIndex) {\n      if (!_list) {\n        return undefined;\n      }\n      var indexes = getRowIndexes(rowIndex, _list);\n      return getDomRowByIndexes(indexes);\n    }\n    /**\n     * ###<a name=\"getItemByIndexes\">getItemByIndexes</a>###\n     * Get the chunk or item given the indexes.\n     * @param {Array} indexes\n     * @returns {*}\n     */\n    function getItemByIndexes(indexes) {\n      var indxs = indexes.slice(0),\n        ca = _list;\n      while (indxs.length) {\n        ca = ca[indxs.shift()];\n      }\n      return ca;\n    }\n    /**\n     * ###<a name=\"getDomRowByIndexes\">getDomRowByIndexes</a>###\n     * Get the dom element given the indexes array. This cannot be exposed because public api should use the\n     * buildDomByIndexes that is called from getRow.\n     * @param {Array} indexes\n     * @param {Function} unrendered\n     * @returns {*}\n     */\n    function getDomRowByIndexes(indexes, unrendered) {\n      var i = 0,\n        index,\n        indxs = indexes.slice(0),\n        ca = _list,\n        el = _el;\n      while (i < indxs.length) {\n        index = indxs.shift();\n        if (unrendered && (!ca.rendered || shouldRecompileDecompiledRows(ca))) {\n          unrendered(el, ca);\n          updateDom(ca);\n        }\n        if (!indxs.length) {\n          checkAllCompiled(ca);\n        }\n        ca = ca[index];\n        el = ca.rendered || angular.element(el.children()[index]);\n      }\n      return el;\n    }\n    function shouldRecompileDecompiledRows(ca) {\n      var recompile = !ca.hasChildChunks() && ca.length && ca.rendered && ca.rendered.children().length !== ca.length;\n      if (recompile) {\n        result.info(\"recompile chunk %s\", ca.getId());\n      }\n      return recompile;\n    }\n    function setStylesViaCssom(children) {\n      var length = children.length;\n      function replacement(a, $1) {\n        return $1.toUpperCase();\n      }\n      for (var i = 0; i < length; i++) {\n        var child = children[i];\n        var dataStyleAttribute = child.getAttribute(\"data-style\");\n        if (!dataStyleAttribute) {\n          continue;\n        }\n        var stylesArray = dataStyleAttribute.split(\";\");\n        var stylesArrayLength = stylesArray.length;\n        for (var j = 0; j < stylesArrayLength; j++) {\n          var style = stylesArray[j];\n          if (!style || style.indexOf(\":\") === -1) {\n            continue;\n          }\n          var css = style.split(\":\");\n          var propertyName = css[0];\n          var propertyValue = css[1];\n          var camelCasedPropertyName = propertyName.replace(/-(.)/g, replacement);\n          child.style[camelCasedPropertyName] = propertyValue;\n        }\n      }\n    }\n    /**\n     * ###<a name=\"unrendered\">unrendered</a>###\n     * How to handle array chunks that have not been rendered yet. They may copy from cache or even create new\n     * dom from html strings.\n     * @param {JQLite} el\n     * @param {ChunkArray} ca\n     */\n    function unrendered(el, ca) {\n      var children,\n        i = 0,\n        iLen;\n      el.html(ca.getChildrenStr(false, _chunkSize));\n      children = el.children();\n      ca.rendered = el;\n      if (ca.hasChildChunks()) {\n        // assign the dom element.\n        if (isNoInlineStyle) {\n          setStylesViaCssom(children);\n        }\n        iLen = children.length;\n        while (i < iLen) {\n          ca[i].dom = children[i];\n          i += 1;\n        }\n      }\n      if (ca.detachDom && ca.dirtyHeight) {\n        ca.updateDomHeight();\n      }\n      exports.each(children, computeStyles);\n      if (ca.hasChildChunks()) {\n        if (children[0].className.indexOf(inst.options.chunks.chunkClass) !== -1) {\n          // need to calculate css styles before adding this class to make transitions work.\n          children.addClass(inst.options.chunks.chunkReadyClass);\n        }\n      } else if (!ca.rendered.hasClass(inst.options.chunks.chunkReadyClass)) {\n        ca.rendered.addClass(inst.options.chunks.chunkReadyClass);\n      }\n    }\n    /**\n     * Get the domElement by indexes, create the dom if it doesn't exist.\n     * @param {Array} indexes - an array of int values.\n     * @returns {*}\n     */\n    function buildDomByIndexes(indexes) {\n      return getDomRowByIndexes(indexes, unrendered);\n    }\n    /**\n     * ##<a name=\"computedStyles\">computedStyles</a>##\n     * calculate the computed styles of each element\n     */\n    function computeStyles(elm) {\n      if (elm) {\n        var style = window.getComputedStyle(elm);\n        if (style) {\n          return style.getPropertyValue(\"top\");\n        }\n      }\n    }\n    /**\n     * ##<a name=\"checkAllCompiled\">checkAllCompiled</a>##\n     * Each ChunkArray keeps track of weather or not it's dom has been compiled. Since each\n     * ChunkArray generates the values and updates properties of the dom. The dom chunks are a\n     * reflection of the ChunkArrays.\n     * @param {ChunkArray} ca\n     * @returns {Boolean}\n     */\n    function checkAllCompiled(ca) {\n      if (!ca.compiled) {\n        ca.compiled = isCompiled(ca);\n        if (ca.compiled) {\n          if (ca.parent) {\n            // a parent cannot be compiled till it's last child is done. So don't check until\n            // a chunk child compiles.\n            checkAllCompiled(ca.parent);\n          }\n          inst.flow.add(disableNonVisibleChunks);\n        }\n      }\n      return ca.compiled;\n    }\n    /**\n     * ##<a name=\"isCompiled\">isCompiled</a>##\n     * Validate that the chunk is compiled.\n     * @param {ChunkArray} ca\n     * @returns {boolean}\n     */\n    function isCompiled(ca) {\n      var min, max;\n      if (ca[0] instanceof ChunkArray) {\n        min = 0;\n        max = ca.length;\n        while (min < max) {\n          if (!ca[min].compiled) {\n            return false;\n          }\n          min += 1;\n        }\n        return true;\n      }\n      min = ca.min;\n      max = ca.max;\n      while (min < max) {\n        if (!inst.isCompiled(min)) {\n          return false;\n        }\n        min += 1;\n      }\n      return true;\n    }\n    function updateDom(ca) {\n      ca.updateDom(inst.options.chunks.chunkDisabledClass);\n    }\n    /**\n     * ###<a name=\"reset\">reset</a>###\n     * Remove all dom, and all other references.\n     * @param {Array=} newList\n     * @param {JQLite=} content\n     * @param {Array=} scopes\n     */\n    function reset(newList, content, scopes) {\n      result.log(\"reset\");\n      _cachedDomRows.length = 0;\n      newList = newList || [];\n      //TODO: this needs to make sure it destroys things properly\n      if (_list) {\n        _list.destroy();\n        _list = null;\n        _el = null;\n        _rows = null;\n      }\n      chunkDom(newList, _chunkSize, _templateStartCache, _templateEndCache, content);\n    }\n    /**\n     * ##<a name=\"disableNonVislbieChunks\">disableNonVisibleChunks</a>##\n     * disable all chunks that are outside of the values.activeRange.min/max.\n     */\n    function disableNonVisibleChunks() {\n      var r = inst.values.activeRange,\n        o = inst.options.chunks;\n      _list.enableRange(r.min, r.max, o.chunkDisabledClass);\n      if (o.detachDom) {\n        // we need to update which chunks are compiled.\n        updateDom(_list);\n      }\n    }\n    /**\n     * ###<a name=\"destroy\">destroy</a>###\n     * Clean up the chunking and recycling.\n     */\n    function destroy() {\n      reset();\n      _list = null;\n      _rows = null;\n      _chunkSize = null;\n      _el = null;\n      _templateStartCache = null;\n      _templateEndCache = null;\n      _cachedDomRows.length = 0;\n      _cachedDomRows = null;\n      inst.chunkModel = null;\n      result.destroyLogger();\n      result = null;\n      inst = null;\n    }\n    inst.flow.unique(updateDom);\n    result.chunkDom = chunkDom;\n    result.getChunkList = getChunkList;\n    result.getRowIndexes = function (rowIndex) {\n      return getRowIndexes(rowIndex, _list);\n    };\n    result.getItemByIndexes = getItemByIndexes;\n    result.getRow = getRow;\n    result.getExistingRow = getExistingRow;\n    result.reset = reset;\n    result.updateRow = updateRow;\n    result.updateList = updateList;\n    result.updateAllChunkHeights = updateAllChunkHeights;\n    result.getRowIndexFromIndexes = getRowIndexFromIndexes;\n    result.destroy = destroy;\n    inst.scope.$on(exports.datagrid.events.ON_AFTER_UPDATE_WATCHERS, disableNonVisibleChunks);\n    // apply event dispatching.\n    exports.util.dispatcher(result);\n    inst.chunkModel = result;\n    return result;\n  };\n  exports.datagrid.coreAddons.push(exports.datagrid.coreAddons.chunkModel);\n\n  /**\n   * @param {Array.<Number>|String} indexes\n   * @param {Number} chunkSize\n   * @returns {number}\n   */\n  function getRowIndexFromIndexes(indexes, chunkSize) {\n    var rowIndex = 0;\n    if (typeof indexes === \"string\") {\n      indexes = indexes.split(\".\");\n    }\n    // don't multiply the last one, because it is a row and not a chunk\n    for (var i = 0; i < indexes.length; i += 1) {\n      indexes[i] = parseInt(indexes[i], 10);\n      if (i < indexes.length - 1) {\n        rowIndex += indexes[i] * chunkSize;\n      } else {\n        rowIndex += indexes[i];\n      }\n    }\n    return rowIndex;\n  }\n\n  /**\n   * ####ChunkArray####\n   * is an array with additional properties needed by the chunkModel to generate and access chunks\n   * of the dom with high performance.\n   * @constructor\n   */\n  function ChunkArray(detachDom) {\n    this.uid = ChunkArray.uid++;\n    this.enabled = true;\n    this.min = 0;\n    this.max = 0;\n    this.templateStart = \"\";\n    this.templateStartWithPos = \"\";\n    this.templateEnd = \"\";\n    this.parent = null;\n    this.mode = detachDom ? ChunkArray.DETACHED : ChunkArray.ATTACHED;\n    this.detachDom = detachDom;\n    this.index = 0;\n  }\n  ChunkArray.uid = 0;\n  ChunkArray.DETACHED = \"chunkArray:detached\";\n  ChunkArray.ATTACHED = \"chunkArray:attached\";\n  ChunkArray.prototype = [];\n  ChunkArray.prototype.getStub = function getStub(str) {\n    if (!this.templateStartWithPos) {\n      this.createDomTemplates();\n    }\n    return this.templateStartWithPos + str + this.templateEnd;\n  };\n  ChunkArray.prototype.inRange = function (value) {\n    return value >= this.min && value <= this.max;\n  };\n  ChunkArray.prototype.rangeOverlap = function (min, max, cushion) {\n    var overlap = false;\n    cushion = cushion > 0 ? cushion : 0;\n    min -= cushion;\n    max += cushion;\n    while (min <= max) {\n      // if min < max then a grid with only 1 items shows that row disabled.\n      if (this.inRange(min)) {\n        overlap = true;\n        break;\n      }\n      min += 1;\n    }\n    return overlap;\n  };\n  ChunkArray.prototype.each = function (method, args) {\n    var i = 0,\n      len = this.length;\n    while (i < len) {\n      exports.util.apply(method, this[i], args);\n      i += 1;\n    }\n  };\n\n  /**\n   * #####ChunkArray.prototype.getChildrenStr#####\n   * Get the HTML string representation of the children in this array.\n   * If deep then return this and all children down.\n   * @param deep\n   * @param chunkSize\n   * @returns {string}\n   */\n  ChunkArray.prototype.getChildrenStr = function (deep, chunkSize) {\n    var i = 0,\n      len = this.length,\n      str = \"\",\n      ca = this,\n      rowIndex,\n      tpl,\n      xml,\n      style;\n    while (i < len) {\n      if (ca[i] instanceof ChunkArray) {\n        str += ca[i].getStub(deep ? ca[i].getChildrenStr(deep) : \"\", chunkSize);\n      } else {\n        rowIndex = getRowIndexFromIndexes(ca._id + \".\" + i, chunkSize);\n        str += this.templateModel.getTemplate(ca[i]).template;\n      }\n      i += 1;\n    }\n    return str;\n  };\n\n  /**\n   * #####<a name=\"updateHeight\">updateHeight</a>#####\n   * Recalculate the height of this chunk.\n   * @param templateModel\n   * @param _rows\n   */\n  ChunkArray.prototype.updateHeight = function (templateModel, _rows, recurse, updateDomHeight) {\n    var i = 0,\n      len,\n      height = 0,\n      lastChild;\n    if (this[0] instanceof ChunkArray) {\n      len = this.length;\n      while (i < len) {\n        if (recurse === 1) {\n          this[i].updateHeight(templateModel, _rows, recurse, updateDomHeight);\n        }\n        height += this[i].height;\n        i += 1;\n      }\n    } else {\n      height = templateModel.getHeight(_rows, this.min, this.max);\n    }\n    if (this.height !== height) {\n      this.dirtyHeight = true;\n      this.height = height;\n    } else if (this.rendered) {}\n    if (recurse == -1 && this.dirtyHeight && this.parent) {\n      this.parent.updateHeight(templateModel, _rows, recurse, updateDomHeight);\n    }\n    if (updateDomHeight && this.dirtyHeight) {\n      this.updateDomHeight();\n    }\n  };\n  ChunkArray.prototype.getPreviousSibling = function () {\n    var prevSibling, prevIndex;\n    if (this.parent) {\n      prevIndex = this.index - 1;\n      prevSibling = this.parent[prevIndex];\n      if (!prevSibling || prevSibling.index !== this.index - 1) {\n        // we must the first in the array. so we have to jump up higher. Or we are the first item in the first chunk.\n        if (this.parent.parent) {\n          prevSibling = this.parent.getPreviousSibling();\n          if (prevSibling) {\n            prevSibling = prevSibling.last();\n          }\n        }\n      }\n    }\n    return prevSibling;\n  };\n  ChunkArray.prototype.getNextSibling = function () {\n    var nextSibling, nextIndex;\n    if (this.parent) {\n      nextIndex = this.index + 1;\n      nextSibling = this.parent[nextIndex];\n      if (!nextSibling || nextSibling.index !== this.index + 1) {\n        // we must be at the end of the array. So we need to jump up higher. Or we could be at the very end.\n        if (this.parent.parent) {\n          nextSibling = this.parent.getNextSibling();\n          if (nextSibling) {\n            nextSibling = nextSibling.first();\n          }\n        }\n      }\n    }\n    return nextSibling;\n  };\n  ChunkArray.prototype.first = function () {\n    return this[0];\n  };\n  ChunkArray.prototype.last = function () {\n    return this[this.length - 1];\n  };\n\n  /**\n   * #####<a name=\"calculateTop\">calculateTop</a>#####\n   * Calculate the top value relative to it's parent.\n   * @returns {number|top}\n   */\n  ChunkArray.prototype.calculateTop = function () {\n    var top = 0,\n      prevSibling;\n    if (this.index && this.parent) {\n      prevSibling = this.getPreviousSibling();\n      if (prevSibling) {\n        top = prevSibling.top + prevSibling.height;\n      }\n    }\n    this.top = top;\n    return this.top;\n  };\n\n  /**\n   * #####<a name=\"forceHeightReCalc\">forceHeightReCal</a>#####\n   * Ignore any cached values and update the height of this chunk.\n   * @param templateModel\n   * @param _rows\n   * @returns {number|*|height}\n   */\n  ChunkArray.prototype.forceHeightReCalc = function (templateModel, _rows) {\n    var i = 0,\n      len,\n      height = 0;\n    if (this[0] instanceof ChunkArray) {\n      len = this.length;\n      while (i < len) {\n        height += this[i].forceHeightReCalc(templateModel, _rows);\n        i += 1;\n      }\n    } else {\n      height = templateModel.getHeight(_rows, this.min, this.max);\n    }\n    if (this.height !== height) {\n      this.height = height;\n      if (this.detachDom) {\n        // we need to update all siblings if we change.\n        this.dirtySiblings();\n      } else {\n        this.setDirtyHeight();\n      }\n    }\n    return this.height;\n  };\n\n  /**\n   * #####<a name=\"setDirtyHeight\">setDirtyHeight</a>#####\n   * Set this chunk as dirty so heights need calculated.\n   */\n  ChunkArray.prototype.setDirtyHeight = function () {\n    var p = this;\n    while (p) {\n      p.dirtyHeight = true;\n      p = p.parent;\n    }\n  };\n  ChunkArray.prototype.dirtySiblings = function () {\n    this.dirtyHeight = true;\n    if (this.parent) {\n      var i = 0,\n        iLen = this.length;\n      while (i < iLen) {\n        this[i].dirtyHeight = true;\n        i += 1;\n      }\n      this.parent.dirtySiblings();\n    }\n  };\n\n  /**\n   * #####<a name=\"getId\">getId</a>#####\n   * @returns {string|*|_id}\n   */\n  ChunkArray.prototype.getId = function () {\n    if (this._index !== this.index || !this._id) {\n      var p = this,\n        s = \"\";\n      this._index = this.index;\n      // keep the last index so if it changes. We change the id.\n      while (p) {\n        s = \".\" + p.index + s;\n        p = p.parent;\n      }\n      this._id = s.substr(1, s.length);\n    }\n    return this._id;\n  };\n  ChunkArray.prototype.hasChildChunks = function () {\n    if (!this._hasChildChunks) {\n      this._hasChildChunks = this.first() instanceof ChunkArray;\n    }\n    return this._hasChildChunks;\n  };\n  ChunkArray.prototype.enableRange = function (min, max, disabledClass) {\n    if (this.rangeOverlap(min, max, this.detachDom)) {\n      this.enable(disabledClass);\n    } else {\n      this.disable(disabledClass);\n    }\n    if (this.hasChildChunks()) {\n      this.each(this.enableRange, [min, max, disabledClass]);\n    }\n  };\n  ChunkArray.prototype.enable = function (disabledClass) {\n    if (!this.enabled) {\n      this.enabled = true;\n      this.updateDom(disabledClass);\n      if (this.parent) {\n        this.parent.enable(disabledClass);\n      }\n    }\n  };\n  ChunkArray.prototype.disable = function (disabledClass) {\n    var i = 0,\n      len;\n    if (this.compiled) {\n      if (this.hasChildChunks()) {\n        len = this.length;\n        while (i < len) {\n          this[i].disable(disabledClass);\n          i += 1;\n        }\n      }\n      if (this.enabled) {\n        this.enabled = false;\n        this.updateDom(disabledClass);\n      }\n    }\n  };\n  ChunkArray.prototype.updateDom = function (disabledClass) {\n    if (this.rendered) {\n      if (this.compiled && !this.rendered.attr(\"compiled\")) {\n        this.rendered.attr(\"compiled\", true);\n      }\n      if (this.detachDom) {\n        if (this.enabled) {\n          if (this.detached) {\n            this.detached = false;\n            this.parent.rendered.append(this.rendered);\n          }\n        } else if (!this.enabled && !this.detached) {\n          if (this.parent && this.parent.compiled && this.rendered.parent().length) {\n            this.detached = true;\n            //jquery detach is just 2nd param pass true to keep data around.\n            this.rendered.remove(undefined, true);\n          }\n        }\n      } else {\n        this.rendered.attr(\"enabled\", this.enabled);\n        if (this.enabled) {\n          this.rendered.removeAttr(\"disabled\");\n          this.rendered.removeAttr(\"read-only\");\n          this.rendered.removeClass(disabledClass);\n        } else {\n          this.rendered.attr(\"disabled\", \"disabled\");\n          this.rendered.attr(\"read-only\", true);\n          this.rendered.addClass(disabledClass);\n        }\n      }\n      this.each(this.updateDom, [disabledClass]);\n    }\n  };\n  ChunkArray.prototype.updateDomHeight = function (recursiveDirection) {\n    var dom = this.rendered && this.rendered[0] || this.dom;\n    if (dom) {\n      this.dirtyHeight = false;\n      if (this.mode === ChunkArray.DETACHED) {\n        this.calculateTop();\n        dom.style.top = this.top + \"px\";\n      }\n      dom.style.height = this.height + \"px\";\n    } else {\n      this.createDomTemplates();\n    }\n    if (recursiveDirection === -1 && this.parent) {\n      this.parent.updateDomHeight(recursiveDirection);\n    } else if (recursiveDirection && this.hasChildChunks()) {\n      this.each(this.updateDomHeight, [recursiveDirection]);\n    }\n  };\n  ChunkArray.prototype.createDomTemplates = function () {\n    if (!this.templateReady && this.templateStart) {\n      var str = this.templateStart.substr(0, this.templateStart.length - 1) + (isNoInlineStyle ? ' data-style=\"' : ' style=\"');\n      if (this.mode === ChunkArray.DETACHED) {\n        this.calculateTop();\n        str += \"position:absolute;top:\" + this.top + \"px;left:0px;\";\n      }\n      this.templateStartWithPos = str + \"width:100%;height:\" + this.height + 'px;\" chunk-id=\"' + this.getId() + '\" range=\"' + this.min + \":\" + this.max + '\">';\n      this.templateReady = true;\n    }\n  };\n\n  /**\n   * Return an array of the children created from the rendered properties of the children.\n   */\n  ChunkArray.prototype.children = function () {\n    var children = [];\n    this.each(function () {\n      children.push(this.rendered);\n    }, []);\n  };\n  ChunkArray.prototype.decompile = function (chunkReadyClass) {\n    if (this.hasChildChunks()) {\n      this.each(\"decompile\", [chunkReadyClass]);\n    } else {\n      // we are going to remove all dom rows to free up memory.\n      // this can only be done if the chunk has no rows for children instead of chunks.\n      if (this.rendered) {\n        this.rendered.children().remove();\n        this.rendered.removeClass(chunkReadyClass);\n      }\n    }\n  };\n\n  /**\n   * #####<a name=\"destroy\">destroy</a>#####\n   * Perform proper cleanup.\n   */\n  ChunkArray.prototype.destroy = function () {\n    if (this.hasChildChunks()) {\n      this.each(this.destroy);\n    }\n    this.templateStart = \"\";\n    this.templateEnd = \"\";\n    this.templateModel = null;\n    this.rendered = null;\n    this.dom = null;\n    this.parent = null;\n    while (this.length) {\n      this.pop();\n    }\n    this.length = 0;\n  };\n  exports.datagrid.events.ON_RENDER_PROGRESS = \"datagrid:onRenderProgress\";\n  exports.datagrid.events.STOP_CREEP = \"datagrid:stopCreep\";\n  exports.datagrid.events.ENABLE_CREEP = \"datagrid:enableCreep\";\n  exports.datagrid.events.DISABLE_CREEP = \"datagrid:disableCreep\";\n  exports.datagrid.coreAddons.creepRenderModel = function creepRenderModel(inst) {\n    var intv = 0,\n      creepCount = 0,\n      model = exports.logWrapper(\"creepModel\", {}, \"blue\", inst),\n      min,\n      max,\n      upIndex = 0,\n      downIndex = 0,\n      waitingOnReset,\n      time,\n      lastPercent,\n      unwatchers = [],\n      forceScroll = false,\n      scrollIndex = 0,\n      scrollIndexPadding = 0,\n      MAX_SYNC_RENDER = 50;\n    // should not be more than 50.\n    function digest(index) {\n      if (inst.scope.$root.$$phase) {\n        return false;\n      }\n      var s = inst.getScope(index);\n      if (!s || !s.$digested) {\n        // just skip if already digested.\n        inst.forceRenderScope(index);\n      }\n      return true;\n    }\n    function calculatePercent() {\n      var result = {\n        count: 0\n      };\n      each(inst.scopes, calculateScopePercent, result);\n      if (result.count >= inst.rowsLength) {\n        model.disable();\n      }\n      return {\n        count: result.count,\n        len: inst.rowsLength\n      };\n    }\n    function calculateScopePercent(s, index, list, result) {\n      result.count += s ? 1 : 0;\n    }\n    function onInterval(started, ended, force) {\n      model.log(\"\\tonInterval\");\n      if (!inst.values.touchDown) {\n        if (!creepCount) {\n          // it was reset.\n          model.info(\"start creeping\", upIndex + \"..\" + downIndex + \" - \" + min + \"..\" + max);\n        }\n        waitingOnReset = false;\n        time = Date.now() + inst.options.renderThreshold;\n        upIndex = started;\n        downIndex = ended;\n        render(onComplete, force);\n      }\n    }\n    function wait(method, time) {\n      model.log(\"wait\", time);\n      var args = exports.util.array.toArray(arguments);\n      args.splice(0, 2);\n      if (inst.options.async) {\n        // clearTimeout(waitHandle);\n        model.log(\"\\tstart waiting\", time);\n        return setTimeout(function () {\n          model.log(\"\\twait HANDLE execute\");\n          // clearTimeout(waitHandle);\n          exports.util.apply(method, null, args);\n        }, time);\n      } else {\n        model.log(\"\\twait execute\");\n        exports.util.apply(method, this, args);\n      }\n    }\n    function findUncompiledIndex(index, dir) {\n      while (index >= 0 && index < inst.rowsLength && inst.isCompiled(index)) {\n        index += dir;\n      }\n      if (index >= 0 && index < inst.rowsLength) {\n        return index;\n      }\n      return dir > 0 ? inst.rowsLength : -1;\n    }\n    function render(complete, force, recur) {\n      var now = Date.now(),\n        dynamicHeights,\n        direction;\n      recur = recur || 0;\n      if (time > now && hasIndexesLeft() && recur < MAX_SYNC_RENDER) {\n        // hard limit. cannot render more than 50 synchronously.\n        dynamicHeights = inst.templateModel.hasVariableRowHeights();\n        direction = inst.values.direction;\n        model.info(\"direction\", direction);\n        applyRender(direction, force);\n        render(complete, force, recur += 1);\n        // making this async was counter effective on performance.\n        if (dynamicHeights) {\n          forceScrollToIndex();\n        }\n      } else {\n        complete();\n      }\n    }\n    function applyRender(direction, force, amount) {\n      amount = amount || 2;\n      var fn;\n      if (direction) {\n        // optimized for the direction the grid is scrolling.\n        fn = direction === -1 ? renderUp : renderDown;\n        for (var i = 0; i < amount; i += 1) {\n          if (!fn(force)) {\n            break;\n          }\n        }\n      } else {\n        // render up one and down one if not scrolling.\n        renderUp(force);\n        renderDown(force);\n      }\n    }\n    function renderUp(force) {\n      upIndex = force ? upIndex : findUncompiledIndex(upIndex, -1);\n      if (upIndex >= min) {\n        if (digest(upIndex)) {\n          if (force) {\n            model.info(\"\\trenderUp \" + upIndex);\n          }\n          upIndex -= 1;\n          return true;\n        }\n      }\n    }\n    function renderDown(force) {\n      downIndex = force ? downIndex : findUncompiledIndex(downIndex, 1);\n      if (downIndex <= max) {\n        if (digest(downIndex)) {\n          if (force) {\n            model.info(\"\\trenderDown \" + downIndex);\n          }\n          downIndex += 1;\n          return true;\n        }\n      }\n    }\n    function onComplete() {\n      model.info(\"onComplete \" + creepCount + \"/\" + inst.options.creepLimit);\n      // stop();\n      if (!hasIndexesLeft()) {\n        creepCount = 0;\n        model.disable();\n        lastPercent = 1;\n        inst.dispatch(exports.datagrid.events.ON_RENDER_PROGRESS, 1);\n      } else {\n        creepCount += 1;\n        if (!inst.values.touchDown && !inst.values.speed && hasIndexesLeft()) {\n          resetInterval(upIndex, downIndex);\n        }\n        var percent = calculatePercent();\n        if (percent !== lastPercent) {\n          inst.dispatch(exports.datagrid.events.ON_RENDER_PROGRESS, percent);\n        }\n      }\n    }\n    function hasIndexesLeft() {\n      return !!(upIndex > -1 || downIndex < inst.rowsLength);\n    }\n    function stop() {\n      model.warn(\"stop\");\n      time = 0;\n      clearTimeout(intv);\n    }\n    function resetInterval(started, ended, waitTime, forceCompileRowRender) {\n      model.info(\"resetInterval\");\n      if (creepCount < inst.options.creepLimit) {\n        model.info(\"creep \" + creepCount + \"/\" + inst.options.creepLimit);\n        clearTimeout(intv);\n        time = 0;\n        intv = wait(onInterval, waitTime || inst.options.renderThresholdWait, started, ended, forceCompileRowRender);\n      } else {\n        model.warn(\"finish creeping: \" + creepCount + \"/\" + inst.options.creepLimit, upIndex + \"..\" + downIndex + \" is creeped out\");\n      }\n    }\n    function renderLater(event, forceCompileRowRender) {\n      resetInterval(upIndex, downIndex, inst.options.creepStartDelay, forceCompileRowRender);\n    }\n    function forceScrollToIndex() {\n      forceScroll = true;\n      var scroll = inst.getRowOffset(scrollIndex) + scrollIndexPadding;\n      inst.scrollModel.scrollTo(scroll, true);\n      forceScroll = false;\n    }\n    function onBeforeRender(event) {\n      model.info(\"onBeforeRender\");\n      if (!forceScroll) {\n        if (inst.templateModel.hasVariableRowHeights()) {\n          scrollIndex = inst.getOffsetIndex(inst.values.scroll);\n          scrollIndexPadding = inst.values.scroll - inst.getRowOffset(scrollIndex);\n        }\n      }\n    }\n    function onAfterRender(event, loopData, forceCompileRowRender) {\n      model.info(\"onAfterRender\");\n      creepCount = 0;\n      upIndex = loopData.started || 0;\n      downIndex = loopData.ended || 0;\n      min = Math.max(upIndex - inst.options.creepLimit, 0);\n      // top creep should stop at\n      max = Math.min(downIndex + inst.options.creepLimit, inst.rowsLength);\n      // bottom creep should stop at\n      renderLater(event, forceCompileRowRender);\n    }\n    function onBeforeReset(event) {\n      model.info(\"onBeforeReset\");\n      onBeforeRender(event);\n      if (inst.options.creepRender && inst.options.creepRender.enable !== false) {\n        model.enable();\n      }\n    }\n    model.stop = stop;\n    // allow external stop of creep render.\n    model.forceRenderNext = function () {\n      model.info(\"forceRenderNext\");\n      applyRender(inst.values.direction, true, inst.options.scrollEndRenderAmount);\n    };\n    model.destroy = function destroy() {\n      model.disable();\n      inst = null;\n      model = null;\n    };\n    model.enable = function () {\n      if (!unwatchers.length) {\n        unwatchers.push(inst.scope.$on(exports.datagrid.events.ON_AFTER_UPDATE_WATCHERS, onAfterRender));\n      }\n    };\n    model.disable = function () {\n      stop();\n      model.info(\"creep Disabled\");\n      while (unwatchers.length) {\n        unwatchers.pop()();\n      }\n    };\n    inst.unwatchers.push(inst.scope.$on(exports.datagrid.events.DISABLE_CREEP, model.disable));\n    inst.unwatchers.push(inst.scope.$on(exports.datagrid.events.ON_BEFORE_RESET, onBeforeReset));\n    inst.unwatchers.push(inst.scope.$on(exports.datagrid.events.STOP_CREEP, stop));\n    inst.creepRenderModel = model;\n    // do not add listeners if it is not enabled.\n    if (inst.options.creepRender && inst.options.creepRender.enable) {\n      model.enable();\n    } else {\n      model.disable();\n    }\n  };\n  exports.datagrid.coreAddons.push(exports.datagrid.coreAddons.creepRenderModel);\n\n  /*global ux */\n  exports.datagrid.coreAddons.normalizeModel = function normalizeModel(inst) {\n    //TODO: this needs to be put on exp.normalizedModel\n    var originalData,\n      normalizedData,\n      result = exports.logWrapper(\"normalizeModel\", {}, \"grey\", inst);\n    /**\n     * ###<a name=\"normalize\">normalize</a>###\n     * Convert a hierarchical data structure into a flattened array so that headers, rows, and however deep the data is\n     * will all be able to represented by template rows.\n     * @param {Array} data\n     * @param {String} grouped\n     * @param {Array=} normalized\n     * @returns {Array}\n     */\n    inst.normalize = function normalize(data, grouped, normalized) {\n      data = data || [];\n      var i = 0,\n        len = data.length;\n      normalized = normalized || [];\n      while (i < len) {\n        normalized.push(data[i]);\n        if (data[i] && data[i][grouped]) {\n          inst.normalize(data[i][grouped], grouped, normalized);\n        }\n        i += 1;\n      }\n      return normalized;\n    };\n    /**\n     * ###<a name=\"setData\">setData</a>###\n     * Set the data so that it can be normalized.\n     * @param {Array} data\n     * @param {String} grouped\n     * @returns {*}\n     */\n    inst.setData = function (data, grouped) {\n      result.log(\"setData %s\", data);\n      originalData = data;\n      if (grouped) {\n        normalizedData = inst.normalize(data, grouped);\n      } else {\n        normalizedData = data && data.slice(0) || [];\n      }\n      return normalizedData;\n    };\n    /**\n     * ###<a name=\"getData\">getData</a>###\n     * Get the data the datagrid is using. This is normalized data.\n     * @returns {Array}\n     */\n    inst.getData = function () {\n      return normalizedData;\n    };\n    /**\n     * ###<a name=\"getOriginalData\">getOriginalData</a>###\n     * Get the data that the normalized data was created from.\n     * @returns {Array}\n     */\n    inst.getOriginalData = function () {\n      return originalData;\n    };\n    /**\n     * ##<a name=\"getOriginalIndexOfItem\">getOriginalIndexOfItem</a>##\n     * get the index or indexes of the item from the original data that the normalized array was created from.\n     */\n    inst.getOriginalIndexOfItem = function getOriginalIndexOfItem(item) {\n      var indexes = ux.each(originalData, findItem, item, []);\n      return indexes && indexes !== originalData ? indexes : [];\n    };\n    /**\n     * ###<a name=\"findItem\">findItem</a>###\n     * find the item in the list of items and recursively search the child arrays if they have the grouped property\n     * @param {*} item\n     * @param {Number} index\n     * @param {Array} list\n     * @param {*} targetItem\n     * @param {Array} indexes\n     * @returns {*}\n     */\n    function findItem(item, index, list, targetItem, indexes) {\n      var found;\n      indexes = indexes.slice(0);\n      indexes.push(index);\n      if (item === targetItem) {\n        return indexes;\n      } else if (item[inst.grouped] && item[inst.grouped].length) {\n        found = ux.each(item[inst.grouped], findItem, targetItem, indexes);\n        if (found && found !== item[inst.grouped]) {\n          return found;\n        }\n      }\n      return undefined;\n    }\n    /**\n     * ###<a name=\"getNormalizedIndex\">getNormalizedIndex</a>###\n     * Get the normalized index for an item.\n     * @param {*} item\n     * @param {Number=} startIndex\n     */\n    inst.getNormalizedIndex = function getNormalizedIndex(item, startIndex) {\n      var i = startIndex || 0;\n      while (i < inst.rowsLength) {\n        if (inst.data[i] === item) {\n          return i;\n        }\n        i += 1;\n      }\n      if (startIndex) {\n        i = startIndex;\n        while (i >= 0) {\n          if (inst.data[i] === item) {\n            return i;\n          }\n          i -= 1;\n        }\n      }\n      return -1;\n    };\n    function applyAction(list, index, item, action) {\n      if (action === \"replace\") {\n        list[index] = item;\n      } else if (action === \"insert\") {\n        list.splice(index, 0, item);\n      } else if (action === \"remove\") {\n        list.splice(index, 1);\n      }\n    }\n    function modifyItem(item, index, action) {\n      // first get the original item index.\n      var indexes = inst.getOriginalIndexOfItem(normalizedData[index]),\n        origItem,\n        list = originalData,\n        lastIndex;\n      while (indexes.length) {\n        lastIndex = indexes.shift();\n        origItem = list[lastIndex];\n        if (!indexes.length) {\n          if (inst.grouped && list[0] && list[0].hasOwnProperty(inst.grouped)) {\n            list = list[0][inst.grouped];\n            indexes.push(list.length);\n            lastIndex = list.length;\n          }\n          applyAction(list, lastIndex, item, action);\n          // original data\n          break;\n        }\n        if (inst.grouped) {\n          list = origItem[inst.grouped];\n        }\n      }\n      applyAction(normalizedData, index, item, action);\n    }\n    /**\n     * ###<a name=\"replace\">replace</a>###\n     * Replace at the index, the newItem.\n     * @param item\n     * @param index\n     */\n    result.replace = function (item, index) {\n      modifyItem(item, index, \"replace\");\n    };\n    result.insert = function (item, index) {\n      modifyItem(item, index, \"insert\");\n    };\n    result.remove = function (index) {\n      modifyItem(null, index, \"remove\");\n    };\n    result.move = function (fromIndex, toIndex) {\n      var item = inst.getRowItem(fromIndex);\n      if (fromIndex > toIndex) {\n        result.remove(fromIndex);\n        result.insert(item, toIndex);\n      } else if (fromIndex < toIndex) {\n        result.insert(item, toIndex);\n        result.remove(fromIndex);\n      }\n    };\n    /**\n     * ###<a name=\"destroy\">destroy</a>###\n     * Make sure all variables are cleaned up.\n     */\n    result.destroy = function destroy() {\n      result.destroyLogger();\n      originalData = null;\n      normalizedData = null;\n      inst.normalizeModel = null;\n      inst = null;\n      result = null;\n    };\n    inst.normalizeModel = result;\n    return inst;\n  };\n  exports.datagrid.coreAddons.push(exports.datagrid.coreAddons.normalizeModel);\n\n  /*global ux */\n  exports.datagrid.events.ON_SCROLL_START = \"datagrid:scrollStart\";\n  exports.datagrid.events.ON_SCROLL_STOP = \"datagrid:scrollStop\";\n  exports.datagrid.events.ON_TOUCH_DOWN = \"datagrid:touchDown\";\n  exports.datagrid.events.ON_TOUCH_UP = \"datagrid:touchUp\";\n  exports.datagrid.events.ON_TOUCH_MOVE = \"datagrid:touchMove\";\n  exports.datagrid.coreAddons.scrollModel = function scrollModel(inst) {\n    var result = exports.logWrapper(\"scrollModel\", {}, \"orange\", inst),\n      setup = false,\n      enable = true,\n      unwatchSetup,\n      waiting,\n      waitForStopIntv,\n      lastTouchUpdateTime = 0,\n      hasScrollListener = false,\n      lastScroll,\n      bottomOffset = 0,\n      // start easing\n      offsetY,\n      offsetX,\n      lastDeltaY,\n      lastDeltaX,\n      speed = 0,\n      speedX = 0,\n      scrollThresholdUpdateIntv,\n      // end easing\n      listenerData = [{\n        event: \"touchstart\",\n        method: \"onTouchStart\",\n        enabled: true\n      }, {\n        event: \"touchmove\",\n        method: \"onTouchMove\",\n        enabled: false\n      }, {\n        event: \"touchend\",\n        method: \"onTouchEnd\",\n        enabled: true\n      }, {\n        event: \"touchcancel\",\n        method: \"onTouchEnd\",\n        enabled: true\n      }];\n    /**\n     * Listen for scrollingEvents.\n     */\n    function setupScrolling() {\n      unwatchSetup();\n      if (!inst.element.css(\"overflow\") || inst.element.css(\"overflow\") === \"visible\") {\n        inst.element.css({\n          overflow: \"auto\"\n        });\n      } else if (exports.datagrid.isIOS && inst.options.iosWebkitScrolling) {\n        inst.element.css({\n          overflowY: \"scroll\",\n          webkitOverflowScrolling: \"touch\"\n        });\n      }\n      addScrollListener();\n      inst.unwatchers.push(inst.scope.$on(exports.datagrid.events.SCROLL_TO_INDEX, function (event, index) {\n        inst.scrollModel.scrollToIndex(index, true);\n      }));\n      inst.unwatchers.push(inst.scope.$on(exports.datagrid.events.SCROLL_TO_ITEM, function (event, item) {\n        inst.scrollModel.scrollToItem(item, true);\n      }));\n      inst.unwatchers.push(inst.scope.$on(exports.datagrid.events.SCROLL_INTO_VIEW, function (event, itemOrIndex) {\n        inst.scrollModel.scrollIntoView(itemOrIndex, true);\n      }));\n      addTouchEvents();\n      setup = true;\n    }\n    function addScrollListener() {\n      result.log(\"addScrollListener\");\n      hasScrollListener = true;\n      inst.element[0].addEventListener(\"scroll\", onUpdateScrollHandler, {\n        passive: true\n      });\n    }\n    function onBeforeReset() {\n      if (inst.options.scrollModel && inst.options.scrollModel.manual) {\n        listenerData[1].enabled = true;\n      }\n      if (hasScrollListener) {\n        result.removeScrollListener();\n        hasScrollListener = false;\n      }\n      result.removeTouchEvents();\n    }\n    function onAfterReset() {\n      if (!hasScrollListener) {\n        addScrollListener();\n      }\n      addTouchEvents();\n    }\n    function addTouchEvents() {\n      result.log(\"addTouchEvents\");\n      var content = inst.getContent();\n      exports.each(listenerData, function (item) {\n        if (item.enabled) {\n          result.log(\"\\tadd %s\", item.event);\n          content[0].addEventListener(item.event, result[item.method], {\n            passive: true\n          });\n        }\n      });\n    }\n    result.fireOnScroll = function fireOnScroll() {\n      if (inst.values.scroll !== lastScroll) {\n        lastScroll = inst.values.scroll;\n        inst.dispatch(exports.datagrid.events.ON_SCROLL, inst.values);\n      }\n    };\n    result.removeScrollListener = function removeScrollListener() {\n      result.log(\"removeScrollListener\");\n      hasScrollListener = false;\n      inst.element[0].removeEventListener(\"scroll\", onUpdateScrollHandler);\n    };\n    result.removeTouchEvents = function removeTouchEvents() {\n      if (setup) {\n        result.log(\"removeTouchEvents\");\n        var content = inst.getContent();\n        exports.each(listenerData, function (item) {\n          result.log(\"\\tremove %s\", item.event);\n          content[0].removeEventListener(item.event, result[item.method]);\n        });\n      }\n    };\n    function getTouches(event) {\n      return event.touches || event.originalEvent.touches;\n    }\n    result.killEvent = function (event) {\n      event.preventDefault();\n      if (event.stopPropagation) event.stopPropagation();\n      if (event.stopImmediatePropagation) event.stopImmediatePropagation();\n    };\n    result.enable = function (value) {\n      enable = !!value;\n    };\n    function getScrollTop() {\n      return inst.values.scroll;\n    }\n    function setElementScroll(value) {\n      if (!waiting) {\n        inst.element[0].scrollTop = value;\n      }\n      inst.values.scroll = value;\n    }\n    result.onTouchStart = function onTouchStart(event) {\n      if (!enable) {\n        return;\n      }\n      inst.values.touchDown = true;\n      offsetY = getTouches(event)[0].clientY || 0;\n      offsetX = getTouches(event)[0].clientX || 0;\n      if (inst.values.scroll < 0) {\n        inst.values.scroll = 0;\n      } else if (inst.values.scroll > bottomOffset) {\n        inst.values.scroll = bottomOffset;\n      }\n      inst.values.direction = 0;\n      lastDeltaY = 0;\n      lastDeltaX = 0;\n      inst.dispatch(exports.datagrid.events.ON_TOUCH_DOWN, event);\n    };\n    result.onTouchMove = function (event) {\n      if (!enable) {\n        return;\n      }\n      if (inst.options.scrollModel && inst.options.scrollModel.preventTouchMove) {\n        result.killEvent(event);\n      }\n      var now = Date.now();\n      if (now - lastTouchUpdateTime < 20) {\n        return;\n      }\n      lastTouchUpdateTime = now;\n      var y = getTouches(event)[0].clientY,\n        x = getTouches(event)[0].clientX,\n        deltaY = offsetY - y,\n        deltaX = offsetX - x;\n      if (Math.abs(deltaX) > Math.abs(deltaY)) {\n        return;\n      }\n      if (offsetY !== y) {\n        inst.values.direction = deltaY > 0 ? 1 : -1;\n        speed = deltaY;\n        offsetY = y;\n        lastDeltaY = deltaY;\n      }\n      if (deltaX !== lastDeltaX) {\n        // horizontal scrolling is not complete. prevent until completed otherwise it is firing multiple setScroll values.\n        speedX = deltaX - lastDeltaX;\n        lastDeltaX = deltaX;\n      }\n      inst.dispatch(exports.datagrid.events.ON_TOUCH_MOVE, speed, deltaY, lastDeltaY, speedX, deltaX, lastDeltaX);\n    };\n    result.onTouchEnd = function onTouchEnd(event) {\n      if (!enable) {\n        return;\n      }\n      if (!inst.values.touchDown) {\n        return;\n      }\n      inst.values.touchDown = false;\n      inst.dispatch(exports.datagrid.events.ON_TOUCH_UP, event);\n      if (listenerData[1].enabled) {\n        if (Math.abs(lastDeltaY) < 2 && Math.abs(lastDeltaX) < 2) {\n          result.click(event);\n        }\n      } else {\n        result.onUpdateScroll();\n      }\n      var sTop = getScrollTop();\n      if (sTop < 0 || inst.getContentHeight() < inst.getViewportHeight()) {\n        setElementScroll(0);\n      } else if (sTop > inst.getContentHeight() - inst.getViewportHeight()) {\n        setElementScroll(inst.getContentHeight() - inst.getViewportHeight());\n      }\n      if (inst.values.direction) {\n        // we don't want it getting in here on a click.\n        inst.creepRenderModel.forceRenderNext();\n        result.onUpdateScroll();\n      }\n    };\n    result.click = function (e) {\n      //TODO: this needs to deprecate because this has finally been fixed in android. (Feb 5th 2015)\n      // simulate click on android. Ignore on IOS.\n      if (inst.options.scrollModel.simulateClick) {\n        var target = e.target,\n          ev;\n        if (inst.options.scrollModel.simulateClick && target && !/(SELECT|INPUT|TEXTAREA)/i.test(target.tagName)) {\n          result.killEvent(e);\n        }\n        if (!inst.isDigesting(inst.$scope) && target && !/(SELECT|INPUT|TEXTAREA)/i.test(target.tagName)) {\n          ev = document.createEvent(\"MouseEvents\");\n          ev.initMouseEvent(\"click\", true, true, e.view, 1, target.screenX, target.screenY, target.clientX, target.clientY, e.ctrlKey, e.altKey, e.shiftKey, e.metaKey, 0, null);\n          ev._constructed = true;\n          try {\n            inst.creepRenderModel.stop();\n            target.dispatchEvent(ev);\n          } catch (err) {}\n        }\n      }\n    };\n    result.getScroll = function getScroll(el) {\n      if (el) {\n        return el.scrollTop;\n      }\n      return getScrollTop();\n    };\n    result.setScroll = function setScroll(value, attempt) {\n      result.warn(\"setScroll(\" + value + \")\");\n      var chunkList = inst.chunkModel.getChunkList();\n      if (inst.data.length && (!chunkList || !chunkList.height) && attempt < 20) {\n        // wait until that height is ready then scroll.\n        inst.flow.add(function () {\n          result.setScroll(value, (attempt || 0) + 1);\n        });\n      } else if (inst.getContentHeight() - inst.getViewportHeight() >= value) {\n        setElementScroll(value);\n        result.onUpdateScroll();\n      }\n    };\n    function onUpdateScrollHandler(event) {\n      clearTimeout(scrollThresholdUpdateIntv);\n      if (!event.target || inst.values.touchDown) {\n        return;\n      }\n      inst.values.scrollEventsSinceLastRender = inst.values.scrollEventsSinceLastRender || 0;\n      if (event && typeof (event.target || event.srcElement).scrollTop !== \"undefined\") {\n        result.onUpdateScroll(event);\n      }\n      inst.values.scrollEventsSinceLastRender += 1;\n      if (inst.values.scrollEventsSinceLastRender > inst.options.forceRenderAfterScrollEventsCount) {\n        inst.values.scrollEventsSinceLastRender = 0;\n        result.warn(\"direction \" + inst.values.direction);\n        inst.creepRenderModel.forceRenderNext();\n      }\n    }\n    /**\n     * When a scrollEvent is fired, recalculate the values.\n     * @param event\n     */\n    result.onUpdateScroll = function onUpdateScroll(event, force) {\n      var val = inst.scrollModel.getScroll(event && (event.target || event.srcElement));\n      var actual;\n      if (inst.values.scroll === val) {\n        if (inst.element.scrollTop && (actual = inst.element.scrollTop()) !== val) {\n          val = actual;\n        }\n      }\n      if (inst.values.scroll !== val) {\n        inst.dispatch(exports.datagrid.events.ON_SCROLL_START, val);\n        inst.values.speed = val - inst.values.scroll;\n        inst.values.absSpeed = Math.abs(inst.values.speed);\n        inst.values.direction = val > inst.values.scroll ? 1 : val < inst.values.scroll ? -1 : 0;\n        inst.values.scroll = val;\n        inst.values.scrollPercent = (inst.values.scroll / inst.getContentHeight() * 100).toFixed(2);\n        // this should only be here. Because if after, then a scroll to index will render twice.\n        // once for the immediate scroll, and once for the event listener. So the event listener\n        // should only update when it has changed.\n        inst.scrollModel.waitForStop(force);\n        result.fireOnScroll();\n      } else {\n        result.warn(\"skip fireOnScroll\");\n      }\n    };\n    result.capScrollValue = function (value) {\n      var newVal;\n      if (inst.getContentHeight() < inst.getViewportHeight()) {\n        result.log(\"\\tCAPPED scroll value from %s to 0\", value);\n        value = 0;\n      } else if (inst.getContentHeight() - value < inst.getViewportHeight()) {\n        // don't allow to scroll past the bottom.\n        newVal = inst.getContentHeight() - inst.getViewportHeight();\n        // this will be the bottom scroll.\n        result.log(\"\\tCAPPED scroll value to keep it from scrolling past the bottom. changed %s to %s\", value, newVal);\n        value = newVal;\n      }\n      return value;\n    };\n    /**\n     * Scroll to the numeric value.\n     * @param value\n     * @param {Boolean=} immediately\n     */\n    result.scrollTo = function scrollTo(value, immediately) {\n      value = result.capScrollValue(value);\n      if (value !== lastScroll) {\n        inst.scrollModel.setScroll(value);\n        if (immediately) {\n          inst.scrollModel.onScrollingStop();\n        } else {\n          inst.scrollModel.waitForStop();\n        }\n        return true;\n      }\n      return false;\n    };\n    result.clearOnScrollingStop = function clearOnScrollingStop() {\n      clearTimeout(waitForStopIntv);\n    };\n    function flowWaitForStop() {\n      inst.scrollModel.onScrollingStop();\n    }\n    /**\n     * Wait for the datagrid to slow down enough to render.\n     */\n    result.waitForStop = function waitForStop(force) {\n      var forceRender = force || false;\n      clearTimeout(waitForStopIntv);\n      waiting = true;\n      result.info(\"waitForStop scroll = %s\", inst.values.scroll);\n      if (!forceRender && (inst.flow.async || inst.values.touchDown)) {\n        waitForStopIntv = setTimeout(flowWaitForStop, inst.options.updateDelay);\n      } else {\n        flowWaitForStop();\n      }\n    };\n    /**\n     * When it stops render.\n     */\n    result.onScrollingStop = function onScrollingStop() {\n      waiting = false;\n      result.info(\"onScrollingStop %s\", inst.values.scroll);\n      result.checkForEnds();\n      inst.values.speed = 0;\n      inst.values.absSpeed = 0;\n      inst.values.direction = 0;\n      inst.values.scrollEventsSinceLastRender = 0;\n      inst.render();\n      result.fireOnScroll();\n      inst.dispatch(exports.datagrid.events.ON_SCROLL_STOP, inst.values);\n      result.calculateBottomOffset();\n    };\n    /**\n     * Scroll to the normalized index.\n     * @param index\n     * @param {Boolean=} immediately\n     */\n    result.scrollToIndex = function scrollToIndex(index, immediately) {\n      result.log(\"scrollToIndex\");\n      var offset = inst.getRowOffset(index);\n      inst.scrollModel.scrollTo(offset, immediately);\n      return offset;\n    };\n    /**\n     * Scroll to an item by finding it's normalized index.\n     * @param item\n     * @param {Boolean=} immediately\n     */\n    result.scrollToItem = function scrollToItem(item, immediately) {\n      result.log(\"scrollToItem\");\n      var index = inst.getNormalizedIndex(item);\n      if (index !== -1) {\n        return inst.scrollModel.scrollToIndex(index, immediately);\n      }\n      return inst.values.scroll;\n    };\n    /**\n     * If the item is above or below the viewable area, scroll till it is in view.\n     * @param itemOrIndex\n     * @param immediately\n     */\n    result.scrollIntoView = function scrollIntoView(itemOrIndex, immediately) {\n      result.log(\"scrollIntoView\");\n      var index = typeof itemOrIndex === \"number\" ? itemOrIndex : inst.getNormalizedIndex(itemOrIndex),\n        offset = inst.getRowOffset(index),\n        rowHeight,\n        viewHeight;\n      compileRowSiblings(index);\n      if (offset < inst.values.scroll) {\n        // it is above the view.\n        return inst.scrollModel.scrollTo(offset, immediately);\n      }\n      inst.updateViewportHeight();\n      // always update the height before calculating. onResize is not reliable\n      viewHeight = inst.getViewportHeight();\n      rowHeight = inst.templateModel.getTemplateHeight(inst.getData()[index]);\n      if (offset >= inst.values.scroll + viewHeight - rowHeight) {\n        // it is below the view.\n        return inst.scrollModel.scrollTo(offset - viewHeight + rowHeight, immediately);\n      }\n      // otherwise it is in view so do nothing.\n      return false;\n    };\n    /**\n     * scroll up one page view if available otherwise scroll to the top.\n     */\n    result.pageUp = function () {\n      var vh = inst.getViewportHeight();\n      if (inst.values.scroll - vh > 0) {\n        inst.scrollModel.scrollTo(inst.values.scroll - vh);\n      } else {\n        inst.scrollModel.scrollTo(0);\n      }\n    };\n    /**\n     * scroll down one page view if available otherwise scroll to the bottom.\n     */\n    result.pageDown = function () {\n      var vh = inst.getViewportHeight();\n      var ch = inst.getContentHeight();\n      if (inst.values.scroll + vh < ch - vh) {\n        inst.scrollModel.scrollTo(inst.values.scroll + vh);\n      } else {\n        inst.scrollModel.scrollTo(ch - vh);\n      }\n    };\n    function compileRowSiblings(index) {\n      if (inst.data[index - 1] && !inst.isCompiled(index - 1)) {\n        inst.forceRenderScope(index - 1);\n      }\n      if (inst.data[index + 1] && !inst.isCompiled(index + 1)) {\n        inst.forceRenderScope(index + 1);\n      }\n    }\n    function onAfterHeightsUpdated() {\n      if (hasScrollListener) {\n        result.log(\"onAfterHeightsUpdated force scroll to %s\", inst.values.scroll);\n        setElementScroll(inst.values.scroll);\n      }\n    }\n    /**\n     * Scroll to top.\n     * @param immediately\n     */\n    result.scrollToTop = function (immediately) {\n      result.log(\"scrollToTop\");\n      inst.scrollModel.scrollTo(0, immediately);\n    };\n    /**\n     * Scroll to bottom.\n     * @param immediately\n     */\n    result.scrollToBottom = function (immediately) {\n      result.log(\"scrollToBottom\");\n      var value = inst.getContentHeight() - inst.getViewportHeight();\n      inst.scrollModel.scrollTo(value >= 0 ? value : 0, immediately);\n    };\n    /**\n     * ###<a name=\"calculateBottomOffset\">calculateBottomOffset</a>###\n     * calculate the scroll value for when the grid is scrolled to the bottom.\n     */\n    result.calculateBottomOffset = function () {\n      if (inst.rowsLength) {\n        var i = inst.rowsLength - 1;\n        result.bottomOffset = bottomOffset = inst.getRowOffset(i) - inst.getViewportHeight() + inst.getRowHeight(i);\n      }\n    };\n    /**\n     * ###<a name=\"onUpdateScroll\">onUpdateScroll</a>###\n     * When the scroll value updates. Determine if we are at the top or the bottom and dispatch if so.\n     */\n    result.checkForEnds = function () {\n      if (inst.values.scroll && inst.values.scroll >= bottomOffset) {\n        inst.dispatch(exports.datagrid.events.ON_SCROLL_TO_BOTTOM, inst.values.speed);\n      } else if (inst.values.scroll <= 0) {\n        inst.dispatch(exports.datagrid.events.ON_SCROLL_TO_TOP, inst.values.speed);\n      }\n    };\n    function destroy() {\n      clearTimeout(waitForStopIntv);\n      result.destroyLogger();\n      unwatchSetup();\n      if (setup) {\n        result.removeScrollListener();\n        result.removeTouchEvents();\n      }\n      result = null;\n      inst = null;\n    }\n    /**\n     * Wait till the grid is ready before we setup our listeners.\n     */\n    unwatchSetup = inst.scope.$on(exports.datagrid.events.ON_READY, setupScrolling);\n    inst.unwatchers.push(inst.scope.$on(exports.datagrid.events.ON_AFTER_HEIGHTS_UPDATED, onAfterHeightsUpdated));\n    inst.unwatchers.push(inst.scope.$on(exports.datagrid.events.ON_BEFORE_RESET, onBeforeReset));\n    inst.unwatchers.push(inst.scope.$on(exports.datagrid.events.ON_AFTER_RESET, onAfterReset));\n    inst.unwatchers.push(inst.scope.$on(exports.datagrid.events.ON_RENDER_AFTER_DATA_CHANGE, result.calculateBottomOffset));\n    result.destroy = destroy;\n    inst.scrollModel = result;\n    // all models should try not to pollute the main model to keep it clean.\n    return inst;\n  };\n  exports.datagrid.coreAddons.push(exports.datagrid.coreAddons.scrollModel);\n\n  /*global angular */\n  /**\n   * ##<a name=\"templateModel\">templateModel</a>##\n   * Management of templates for the datagrid.\n   * @param inst\n   * @returns {templateModel|*|Function|templateModel|templateModel}\n   */\n  exports.datagrid.coreAddons.templateModel = function templateModel(inst) {\n    \"use strict\";\n\n    var tplNameRx = /\\#{3}[\\w\\d\\W]+\\#{3}/gi;\n    var includeTplRx = /\\#{3}include:([\\w\\d\\W]+)\\#{3}/gi;\n    var uncompiledRx = /uncompiled\\s?/;\n    function trim(str) {\n      // remove newline / carriage return\n      str = str.replace(/\\n/g, \"\");\n      // remove whitespace (space and tabs) before tags\n      str = str.replace(/[\\t ]+</g, \"<\");\n      // remove whitespace between tags\n      str = str.replace(/>[\\t ]+</g, \"><\");\n      // remove whitespace after tags\n      str = str.replace(/>[\\t ]+$/g, \">\");\n      return str;\n    }\n    inst.templateModel = function () {\n      var templates = [],\n        totalHeight,\n        defaultName = \"default\",\n        result = exports.logWrapper(\"templateModel\", {}, \"teal\", inst),\n        forcedTemplates = [],\n        templatesKey,\n        rowHeightsDirty = false,\n        overrideRowHeights,\n        options = extend({}, inst.options.templateModel);\n      function getTemplatesKey() {\n        if (!templatesKey) {\n          templatesKey = \"$$template_\" + inst.uid;\n        }\n        return templatesKey;\n      }\n      function createTemplates() {\n        result.log(\"createTemplates\");\n        var i,\n          scriptTemplates = inst.element[0].getElementsByTagName(\"script\"),\n          len = scriptTemplates.length;\n        if (!len && !templates.length) {\n          inst.throwError(exports.errors.E1102);\n        }\n        for (i = 0; i < len; i += 1) {\n          createTemplateFromScriptTemplate(scriptTemplates[i]);\n        }\n        // remove the script templates.\n        while (scriptTemplates.length) {\n          inst.element[0].removeChild(scriptTemplates[0]);\n        }\n      }\n      function createTemplateFromScriptTemplate(scriptTemplate) {\n        var name = getScriptTemplateAttribute(scriptTemplate, \"template-name\") || defaultName,\n          base = getScriptTemplateAttribute(scriptTemplate, \"template-base\") || null,\n          itemName = getScriptTemplateAttribute(scriptTemplate, \"template-item\");\n        return createTemplate(trim(angular.element(scriptTemplate).html()), name, itemName, base);\n      }\n      function createTemplatesFromData(templateData) {\n        exports.each(templateData, function (tpl) {\n          createTemplate(tpl.template, tpl.name, tpl.item, tpl.base);\n        });\n      }\n      function createTemplate(template, name, itemName, base) {\n        var originalTemplate = template,\n          wrapper = document.createElement(\"div\"),\n          templateData;\n        wrapper.className = \"grid-template-wrapper\";\n        template = result.prepTemplate(name, template, base);\n        template = angular.element(template)[0];\n        if (!base) {\n          template.className += \" \" + name + \" \" + inst.options.rowClass + \" \" + inst.options.uncompiledClass + \" {{$status}}\";\n        }\n        template.setAttribute(\"template\", name);\n        inst.getContent()[0].appendChild(wrapper);\n        wrapper.appendChild(template);\n        template = trim(wrapper.innerHTML);\n        templateData = {\n          name: name,\n          item: itemName,\n          template: template,\n          originalTemplate: originalTemplate,\n          height: calculateRowHeight(wrapper.children[0])\n        };\n        result.log(\"template: %s %o\", name, templateData);\n        if (!templateData.height) {\n          if (inst.element.css(\"display\") === \"none\") {\n            result.warn(\"Datagrid was intialized with a display:'none' value. Templates are unable to calculate heights. Grid will not render correctly.\");\n          } else if (!inst.element[0].offsetHeight) {\n            inst.throwError(exports.errors.E1000);\n          } else {\n            inst.throwError(exports.errors.E1101);\n          }\n        }\n        templates[templateData.name] = templateData;\n        templates.push(templateData);\n        inst.getContent()[0].removeChild(wrapper);\n        totalHeight = 0;\n        // reset cached value.\n        return templateData;\n      }\n      function prepTemplate(name, templateStr, base) {\n        var str = \"\",\n          baseTemplate;\n        if (base) {\n          baseTemplate = result.getTemplateByName(base);\n          str = baseTemplate.originalTemplate;\n          str = str.replace(new RegExp(\"#{3}\" + name + \"#{3}\", \"gi\"), templateStr);\n          return str;\n        } else if (templateStr.indexOf(\"###include:\") !== -1) {\n          return templateStr.replace(includeTplRx, function (m, tplName) {\n            var tpl = result.getTemplateByName(tplName);\n            return tpl && tpl.template.replace(uncompiledRx, \"\") || \"\";\n          });\n        }\n        return templateStr.replace(tplNameRx, \"\");\n      }\n      function getScriptTemplateAttribute(scriptTemplate, attrStr) {\n        var node = scriptTemplate.attributes[\"data-\" + attrStr] || scriptTemplate.attributes[attrStr];\n        return node && node.value || \"\";\n      }\n      function getTemplates() {\n        return templates;\n      }\n      /**\n       * ###<a name=\"getTemplate\">getTemplate</a>###\n       * Use the data object from each item in the array to determine the template for that item.\n       * @param data\n       */\n      result.getTemplate = function getTemplate(data) {\n        var tpl = data[getTemplatesKey()] || data._template;\n        return result.getTemplateByName(tpl);\n      };\n      //TODO: need to make this method so it can be overwritten to look up templates a different way.\n      function getTemplateName(el) {\n        if (el.attr || el.getAttribute) {\n          return el.attr ? el.attr(\"template\") : el.getAttribute(\"template\");\n        } else if (!(el instanceof HTMLElement)) {\n          // el is a data not an element.\n          return el[getTemplatesKey()] || el._template;\n        }\n      }\n      function getTemplateByName(name) {\n        if (templates[name]) {\n          return templates[name];\n        }\n        return templates[defaultName];\n      }\n      function dynamicHeights() {\n        var i, h;\n        for (i in templates) {\n          if (exports.util.apply(Object.prototype.hasOwnProperty, templates, [i])) {\n            h = h || templates[i].height;\n            if (h !== templates[i].height) {\n              return true;\n            }\n          }\n        }\n        return false;\n      }\n      function averageTemplateHeight() {\n        var i = 0,\n          len = templates.length;\n        if (!totalHeight) {\n          while (i < len) {\n            totalHeight += templates[i].height;\n            i += 1;\n          }\n        }\n        return totalHeight / len;\n      }\n      function countTemplates() {\n        return templates.length;\n      }\n      function getTemplateHeight(item) {\n        var tpl = result.getTemplate(item);\n        return tpl ? tpl.height : 0;\n      }\n      function getHeight(list, startRowIndex, endRowIndex) {\n        var i = startRowIndex,\n          height = 0;\n        if (!list.length) {\n          return 0;\n        }\n        while (i <= endRowIndex) {\n          height += result.getRowHeight(i);\n          i += 1;\n        }\n        return height;\n      }\n      function setTemplateName(item, templateName) {\n        var key = getTemplatesKey();\n        if (!exports.util.apply(Object.prototype.hasOwnProperty, item, [key]) && forcedTemplates.indexOf(item) === -1) {\n          forcedTemplates.push(item);\n        }\n        item[key] = templateName;\n      }\n      function setTemplate(itemOrIndex, newTemplateName, classes) {\n        result.info(\"setTemplate %s %s\", itemOrIndex, newTemplateName);\n        var item;\n        if (typeof itemOrIndex === \"number\") {\n          item = inst.data[itemOrIndex];\n          clearRowHeight(itemOrIndex);\n        } else {\n          item = itemOrIndex;\n        }\n        var oldTemplate = result.getTemplate(item).name;\n        result.setTemplateName(item, newTemplateName);\n        // needs to wait until after the digest.\n        inst.flow.add(inst.dispatch, [exports.datagrid.events.ON_ROW_TEMPLATE_CHANGE, item, oldTemplate, newTemplateName, classes], 0);\n      }\n      // if no value. calculate it.\n      function forceRowHeight(index, value) {\n        overrideRowHeights[index] = value;\n        rowHeightsDirty = true;\n      }\n      function clearRowHeight(index) {\n        delete overrideRowHeights[index];\n        rowHeightsDirty = true;\n      }\n      function clearAllRowHeights() {\n        overrideRowHeights = {};\n        rowHeightsDirty = true;\n      }\n      function hasOverrideHeight(index) {\n        return !!overrideRowHeights[index];\n      }\n      function getRowHeight(index) {\n        var isOverride = overrideRowHeights.hasOwnProperty(index),\n          el,\n          actualHeight;\n        var tplHeight = result.getTemplateHeight(inst.data[index]);\n        if (options.variableRowHeights && !isOverride && inst.isCompiled(index)) {\n          // dynamic heights will slow down the datagrid significantly.\n          el = inst.getExistingRow(index);\n          if (el && el.length) {\n            actualHeight = el[0].offsetHeight;\n            if (actualHeight !== overrideRowHeights[index] && actualHeight !== tplHeight) {\n              el[0].style.height = actualHeight + \"px\";\n              overrideRowHeights[index] = actualHeight;\n              isOverride = true;\n              rowHeightsDirty = true;\n            }\n          } else {\n            return tplHeight;\n          }\n        }\n        //TODO: need to reset overrideRowHeights on resize event if dynamicHeights.\n        return isOverride ? overrideRowHeights[index] : tplHeight;\n      }\n      function hasVariableRowHeights() {\n        return !!options.variableRowHeights;\n      }\n      function hasDirtyHeights() {\n        return rowHeightsDirty;\n      }\n      function clearDirtyHeights() {\n        rowHeightsDirty = false;\n      }\n      /**\n       * ###<a name=\"calculateRoHeight\">calculateRowHeight</a>###\n       * Unify any height calculations for row height.\n       * Do not use this function unless you have no choice. Overuse of this function will result in\n       * poor datagrid performance.\n       * @param el\n       */\n      function calculateRowHeight(el) {\n        var computedStyle = window.getComputedStyle(el);\n        return el.offsetHeight + parseInt(computedStyle.marginTop, 10) + parseInt(computedStyle.marginBottom, 10);\n      }\n      function updateTemplateHeights() {\n        //TODO: needs unit tested.\n        var i = inst.values.activeRange.min,\n          len = inst.values.activeRange.max - i,\n          row,\n          tpl,\n          rowHeight,\n          heightCache = {};\n        while (i < len && !rowHeightsDirty) {\n          if (!overrideRowHeights.hasOwnProperty(i)) {\n            // variable heights calculation is more expensive.\n            if (result.hasVariableRowHeights()) {\n              result.getRowHeight(i);\n            } else {\n              // much faster. exits after it finds the template.\n              tpl = result.getTemplate(inst.getData()[i]);\n              if (!heightCache[tpl.name]) {\n                row = inst.getRowElm(i);\n                rowHeight = result.calculateRowHeight(row[0]);\n                if (rowHeight !== tpl.height) {\n                  tpl.height = rowHeight;\n                  rowHeightsDirty = true;\n                }\n              }\n            }\n          }\n          i += 1;\n        }\n        if (rowHeightsDirty) {\n          inst.updateHeights();\n          clearDirtyHeights();\n        }\n      }\n      function clearTemplate(item) {\n        delete item[getTemplatesKey()];\n      }\n      function clearForcedTemplates() {\n        exports.each(forcedTemplates, clearTemplate);\n        forcedTemplates.length = 0;\n      }\n      function destroy() {\n        clearForcedTemplates();\n        result.destroyLogger();\n        result = null;\n        templates.length = 0;\n        templates = null;\n        forcedTemplates = null;\n      }\n      result.defaultName = defaultName;\n      result.prepTemplate = prepTemplate;\n      result.createTemplates = createTemplates;\n      result.createTemplatesFromData = createTemplatesFromData;\n      result.getTemplates = getTemplates;\n      result.getTemplateName = getTemplateName;\n      result.getTemplateByName = getTemplateByName;\n      result.calculateRowHeight = calculateRowHeight;\n      result.templateCount = countTemplates;\n      result.dynamicHeights = dynamicHeights;\n      result.averageTemplateHeight = averageTemplateHeight;\n      result.getHeight = getHeight;\n      result.getTemplateHeight = getTemplateHeight;\n      result.getRowHeight = getRowHeight;\n      result.hasDirtyHeights = hasDirtyHeights;\n      result.clearDirtyHeights = clearDirtyHeights;\n      result.hasVariableRowHeights = hasVariableRowHeights;\n      result.hasOverrideHeight = hasOverrideHeight;\n      result.forceRowHeight = forceRowHeight;\n      result.clearRowHeight = clearRowHeight;\n      result.clearAllRowHeights = clearAllRowHeights;\n      result.setTemplate = setTemplate;\n      result.setTemplateName = setTemplateName;\n      result.updateTemplateHeights = updateTemplateHeights;\n      result.getTemplatesKey = getTemplatesKey;\n      result.destroy = destroy;\n      return result;\n    }();\n    return inst.templateModel;\n  };\n  exports.datagrid.coreAddons.push(exports.datagrid.coreAddons.templateModel);\n})(this.ux = this.ux || {}, function () {\n  return this;\n}());"

/***/ }),
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(769);
__webpack_require__(1709);
__webpack_require__(1710);
__webpack_require__(1711);
__webpack_require__(1712);
var EmailEditorComponent = {
  templateUrl: '/emailEditor.tpl.html',
  controller: 'emailEditorController',
  bindings: {
    selectedEmailAttachments: '<',
    availableEmailAttachments: '<',
    isEmailAttachmentDropdownOpen: '<',
    options: '<',
    showAttachment: '<',
    showFooter: '<',
    readOnly: '<',
    isModeUms: '<',
    userList: '<',
    closePopup: '&',
    handleUploadAttachmentEmail: '&',
    loadEmailAttachments: '&'
  }
};
angular.module('gw-um-email-editor').component('uiEmailEditor', EmailEditorComponent);

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 1710 */
/***/ (function(module, exports) {

var path = '/emailEditor.tpl.html';
var html = "<div class=\"emailEditor\">\n\n    <div class=\"dockPanelContent collaborationContent collaborationEmailHeader\">\n\n        <div class=\"dockPanelInnerContent collaborationInnerContent\">\n\n            <div class=\"emailHeaderContainer\">\n\n                <span class=\"headerLabel\"\n                      ng-click=\"$ctrl.transformFreeFormEmailAddress('ddd')\">\n                    {{ ::$ctrl.emailI18n.to }}\n                </span>\n\n                <div class=\"recipientContainer\">\n\n                    <ui-select class=\"peoplePickerSelect to\"\n                               ng-model=\"$ctrl.toRecipients\"\n                               theme=\"bootstrap\"\n                               multiple\n                               tagging=\"transformFreeFormEmailAddress\"\n                               tagging-tokens=\";|,|ENTER\"\n                               close-on-select=\"true\"\n                               ng-change=\"$ctrl.handleChange()\"\n                               ng-disabled=\"::$ctrl.readOnly\"\n                               people-picker-save-on-blur>\n\n                        <ui-select-match allow-clear=\"true\">\n\n                            <div class=\"selectedRecipient\"\n                                 uib-tooltip=\"{{::$ctrl.invalidEmailAddressTooltip}}\"\n                                 tooltip-append-to-body=\"true\"\n                                 tooltip-enable=\"{{!$item.valid}}\">\n\n                                <ui-user-avatar class=\"emailRecipientUser\"\n                                                userid=\"{{$ctrl.getUserId($item)}}\"\n                                                ng-if=\"$item.valid\">\n                                </ui-user-avatar>\n\n                                <span class=\"glyphicon glyphicon-alert\"\n                                      ng-if=\"!$item.valid\"></span>\n\n                                {{ getValue($item) }}\n\n                            </div>\n\n                        </ui-select-match>\n\n                        <ui-select-choices group-by=\"'group'\"\n                                           refresh=\"$ctrl.filterItems($select.search)\"\n                                           refresh-delay=\"250\"\n                                           repeat=\"item in $ctrl.filteredPeoplePickerList\"\n                                           ui-disable-choice=\"item.disabled === true\">\n\n                            <span ng-bind-html=\"$ctrl.getLabel(item) | highlight: $select.search\"></span>\n\n                            <span ng-if=\"item.group !== 'User Groups' && item.roles &&  item.disabled !== true\"> ({{ item.roles }})</span>\n                        </ui-select-choices>\n\n                    </ui-select>\n                </div>\n\n                <div class=\"recipientLinkContainer\" ng-class=\"::{notAllowed: $ctrl.readOnly}\">\n\n                    <a class=\"cc\" ng-click=\"$ctrl.toggleCc()\" ng-if=\"!$ctrl.ccVisible\" ng-class=\"::{disabled: $ctrl.readOnly}\">{{ $ctrl.emailI18n.ccLink }}</a>\n\n                    <a class=\"bcc\" ng-click=\"$ctrl.toggleBcc()\" ng-if=\"!$ctrl.bccVisible\" ng-class=\"::{disabled: $ctrl.readOnly}\">{{ $ctrl.emailI18n.bccLink }}</a>\n                </div>\n            </div>\n\n            <div class=\"emailHeaderContainer\" ng-if=\"$ctrl.ccVisible\">\n\n                <span class=\"headerLabel\">{{ ::$ctrl.emailI18n.cc }}</span>\n\n                <div class=\"recipientContainer\">\n\n                    <ui-select class=\"peoplePickerSelect cc\"\n                               ng-change=\"$ctrl.handleChange()\"\n                               ng-model=\"$ctrl.ccRecipients\"\n                               theme=\"bootstrap\"\n                               multiple\n                               tagging=\"transformFreeFormEmailAddress\"\n                               tagging-tokens=\";|,|ENTER\"\n                               close-on-select=\"true\"\n                               ng-disabled=\"::$ctrl.readOnly\"\n                               people-picker-save-on-blur>\n\n                        <ui-select-match allow-clear=\"true\">\n                            <div class=\"selectedRecipient\"\n                                 uib-tooltip=\"{{::$ctrl.invalidEmailAddressTooltip}}\"\n                                 tooltip-append-to-body=\"true\"\n                                 tooltip-enable=\"{{!$item.valid}}\">\n\n                                <ui-user-avatar class=\"emailRecipientUser\"\n                                                userid=\"{{getUserId($item)}}\"\n                                                ng-if=\"$item.valid\">\n                                </ui-user-avatar>\n\n                                <span class=\"glyphicon glyphicon-alert\"\n                                      ng-if=\"!$item.valid\"></span>\n\n                                {{ getValue($item) }}\n\n                            </div>\n                        </ui-select-match>\n\n                        <ui-select-choices group-by=\"'group'\"\n                                           refresh=\"$ctrl.filterItems($select.search)\"\n                                           refresh-delay=\"250\"\n                                           repeat=\"item in $ctrl.filteredPeoplePickerList\"\n                                           ui-disable-choice=\"item.disabled === true\">\n\n                            <span ng-bind-html=\"$ctrl.getLabel(item) | highlight: $select.search\"></span>\n\n                            <span ng-if=\"item.group !== 'User Groups' && item.roles &&  item.disabled !== true\"> ({{ item.roles }})</span>\n                        </ui-select-choices>\n\n                    </ui-select>\n                </div>\n            </div>\n\n            <div class=\"emailHeaderContainer\" ng-if=\"$ctrl.bccVisible\">\n\n                <span class=\"headerLabel\">{{ ::$ctrl.emailI18n.bcc }}</span>\n\n                <div class=\"recipientContainer\">\n\n                    <ui-select class=\"peoplePickerSelect bcc\"\n                               ng-change=\"$ctrl.handleChange()\"\n                               ng-model=\"$ctrl.bccRecipients\"\n                               theme=\"bootstrap\"\n                               multiple\n                               tagging=\"transformFreeFormEmailAddress\"\n                               tagging-tokens=\";|,|ENTER\"\n                               close-on-select=\"true\"\n                               ng-disabled=\"::$ctrl.readOnly\"\n                               people-picker-save-on-blur>\n\n                        <ui-select-match allow-clear=\"true\">\n\n                            <div class=\"selectedRecipient\"\n                                 uib-tooltip=\"{{::$ctrl.invalidEmailAddressTooltip}}\"\n                                 tooltip-append-to-body=\"true\"\n                                 tooltip-enable=\"{{!$item.valid}}\">\n\n                                <ui-user-avatar class=\"emailRecipientUser\"\n                                                userid=\"{{getUserId($item)}}\"\n                                                ng-if=\"$item.valid\">\n                                </ui-user-avatar>\n\n                                <span class=\"glyphicon glyphicon-alert\"\n                                      ng-if=\"!$item.valid\"></span>\n\n                                {{ getValue($item) }}\n\n                            </div>\n                        </ui-select-match>\n\n                        <ui-select-choices group-by=\"'group'\"\n                                           refresh=\"$ctrl.filterItems($select.search)\"\n                                           refresh-delay=\"250\"\n                                           repeat=\"item in $ctrl.filteredPeoplePickerList\"\n                                           ui-disable-choice=\"item.disabled === true\">\n\n                            <span ng-bind-html=\"$ctrl.getLabel(item) | highlight: $select.search\"></span>\n\n                            <span ng-if=\"item.group !== 'User Groups' && item.roles &&  item.disabled !== true\"> ({{ item.roles }})</span>\n                        </ui-select-choices>\n\n                    </ui-select>\n                </div>\n            </div>\n\n            <div class=\"emailHeaderContainer\">\n\n                <span class=\"headerLabel subjectLabel\">{{ ::$ctrl.emailI18n.subject }}</span>\n\n                <input type=\"text\"\n                       class=\"subject\"\n                       ng-model=\"$ctrl.subject\"\n                       ng-disabled=\"::$ctrl.readOnly\"\n                       ng-change=\"$ctrl.handleChange()\"/>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"dockPanelContent collaborationContent collaborationEmailBody\">\n\n        <div class=\"dockPanelInnerContent collaborationInnerContent\">\n\n            <input type=\"text\"\n                   class=\"invisibleFocusElement\"\n                   ui-auto-focus=\"true\"\n                   ng-if=\"!$ctrl.isAttachmentDropdownOpen\">\n\n            <!--Type Selection-->\n            <ui-select class=\"dropdownFormComponent dropdownComponentSelect emailTypeCombo\"\n                       theme=\"select2\"\n                       ng-model=\"$ctrl.selectedEmailType\"\n                       ng-change=\"$ctrl.handleChange()\"\n                       ng-disabled=\"::$ctrl.readOnly\">\n\n                <ui-select-match placeholder=\"{{ ::$ctrl.emailTypePlaceholder }}\"\n                                 allow-clear=\"true\">\n\n                    <span>{{ $ctrl.selectedEmailType.name }}</span>\n                </ui-select-match>\n\n                <ui-select-choices\n                    repeat=\"item in ($ctrl.typeDataItems | filter: $select.search) track by $index\">\n\n                    <span>{{ item.name }}</span>\n                </ui-select-choices>\n\n            </ui-select>\n\n            <summernote class=\"editor\"\n                        config=\"$ctrl.optionsList\"\n                        ng-model=\"$ctrl.body\" editor=\"editor\"></summernote>\n\n            <div class=\"selectedAttachmentList\"\n                 ng-if=\"$ctrl.isAttachmentDropdownOpen\">\n\n                <ui-select ng-model=\"$ctrl.selectedAttachments\"\n                           theme=\"bootstrap\"\n                           multiple\n                           close-on-select=\"true\"\n                           ui-select-on-close=\"$ctrl.hideIfNothingSelected()\"\n                           on-remove=\"$ctrl.hideIfNothingSelected()\"\n                           ng-disabled=\"::$ctrl.readOnly\"\n                           on-select=\"$ctrl.onSelect($item, $model)\">\n\n                    <ui-select-match allow-clear=\"true\"\n                                     ui-lock-choice=\"$item.addAttachment === true\">\n\n                        <div class=\"selectedAttachment\"\n                             ng-if=\"!$item.addAttachment\">\n\n                            <span class=\"glyphicon glyphicon-file\"></span>\n\n                            <a ng-click=\"onAttachmentDownloadClick($item)\">{{ $item.name }} ({{$item.byteCountToDisplaySize}})</a>\n                        </div>\n                    </ui-select-match>\n\n                    <ui-select-choices\n                        repeat=\"item in ($ctrl.availableAttachments | filter: {name: $select.search}) track by item.id\">\n                        <span ng-class=\"{'addNewAttachment': item.addAttachment}\">{{ item.name }} {{item.byteCountToDisplaySize?'('+item.byteCountToDisplaySize+')':''}}</span>\n                    </ui-select-choices>\n\n                </ui-select>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"dockPanelContent collaborationContent collaborationEmailFooter\"\n         ng-if=\"$ctrl.showFooter\">\n\n        <div class=\"dockPanelInnerContent collaborationInnerContent subsequentCollaborationInnerContent\">\n\n            <div class=\"deleteContainer\"\n                 ng-if=\"$ctrl.canDeleteEmail\">\n\n                <a class=\"componentNoteDelete\"\n                   ng-click=\"$ctrl.onDeleteClick()\">\n                    <span class=\"glyphicon glyphicon-trash\"></span>\n                </a>\n            </div>\n\n            <div class=\"footerSpacer\"></div>\n\n            <div class=\"saveSendContainer\">\n\n                <button class=\"btn btn-link saveDraftButton\"\n                        ng-click=\"$ctrl.onSaveDraftClick()\"\n                        ng-disabled=\"!$ctrl.areRecipientsValid(false)\">{{ ::$ctrl.emailI18n.saveDraft }}\n                </button>\n\n                <button class=\"btn btn-primary btn-sm sendButton\"\n                        ng-click=\"$ctrl.onSendClick()\"\n                        ng-disabled=\"!$ctrl.areRecipientsValid(true)\">{{ ::$ctrl.emailI18n.send }}\n                </button>\n            </div>\n        </div>\n    </div>\n\n    <input type=\"email\"\n           hidden\n           class=\"recipientEmailValidator\"\n           required\n           ng-model=\"emailValidator\"/>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {var locale = __webpack_require__(769);

/*@ngInject*/
var EmailEditorController = function EmailEditorController($rootScope, $scope, $timeout, $window, $sanitize, coreConstant, coreMediator, emailMessageStatus, modalUtil, attachmentUtil, loadingBarHandler, dataSetUtil, emailEditorConstant, emailMessage) {
  this.$onInit = function () {
    var _this = this;
    this.emailI18n = locale;
    this.email = this.options.email;
    this.ccVisible = this.options.email.cc;
    this.bccVisible = this.options.email.bcc;
    this.body = _.clone(this.options.email.body);
    this.subject = _.clone(this.options.email.subject);
    this.toRecipients = [];
    this.ccRecipients = [];
    this.bccRecipients = [];
    this.peoplePickerList = [];
    this.filteredPeoplePickerList = [];
    this.submissionParticipantsList = [];
    this.addAnAttachmentText = this.emailI18n.attachmentTooltip;
    this.typeDataItems = [];
    this.selectedEmailType = null;
    this.emailTypePlaceholder = this.emailI18n.type;
    this.draftTitle = this.emailI18n.draftTitle;
    this.invalidEmailAddressTooltip = this.emailI18n.invalidEmailAddressTooltip;
    $scope.onAttachmentDownloadClick = function (attachment) {
      attachmentUtil.getAttachmentLinkURL(attachment.id, attachment.name).then(function (url) {
        $window.open(url, '_blank');
      });
    };
    $scope.validateEmailAddress = function (emailAddress) {
      var recipientEmailValidator = angular.element('.recipientEmailValidator')[0];
      recipientEmailValidator.value = emailAddress;
      return recipientEmailValidator.checkValidity();
    };
    $scope.transformFreeFormEmailAddress = function (item) {
      var recipientObject = {
        id: item,
        emailAddress: item,
        valid: $scope.validateEmailAddress(item)
      };
      return recipientObject;
    };
    $scope.getValue = function (item) {
      if (item.description) {
        return '"' + item.description + '"';
      } else if (item.name && item.emailAddress) {
        return '"' + item.name + '" <' + item.emailAddress + '>';
      } else if (item.name) {
        return '"' + item.name + '"';
      } else if (item.emailAddress) {
        return '"' + item.emailAddress + '"';
      }
    };
    $scope.$on(coreConstant.event.FILE_DROPPED, function (event, file) {
      if (file && attachmentUtil.validateAttachment(file, _.get(_this.emailI18n, 'unacceptableType'))) {
        _this.showAddNewAttachmentModal(file);
      }
    });
    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
      $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });
    $scope.$on(coreConstant.event.CLOSE_EMAIL_POPUP, function () {
      _this.onCloseClick();
    });
    $scope.$on(coreConstant.event.ATTACHMENT_UPDATED, function (event, availableAttachments, selectedAttachments, isAttachmentDropdownOpen) {
      _this.availableAttachments = availableAttachments;
      _this.selectedAttachments = selectedAttachments;
      _this.isAttachmentDropdownOpen = isAttachmentDropdownOpen;
    });
    $scope.$on(emailEditorConstant.event.PEOPLE_LIST_LOADED, function (event, userList) {
      _this.loadUserList(userList);
      _this.init();
    });
    if (this.isModeUms) {
      this.isDraftEmail = this.options.email.status === emailMessageStatus.STATUS_DRAFT;
      this.selectedAttachments = _.clone(this.selectedEmailAttachments);
      this.isAttachmentDropdownOpen = this.isEmailAttachmentDropdownOpen;
      this.availableAttachments = this.availableEmailAttachments;
      this.canDeleteEmail = this.options.canDeleteEmail;
    }
    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
    this.init();
    this.loadUserList(this.userList);
    if (this.readOnly) {
      $timeout(function () {
        $scope.editor.summernote('disable');
      }, 0);
    }
  };
  this.onDeleteClick = function () {
    var _this2 = this;
    var config = {
      cancelButtonLabel: this.emailI18n.cancel,
      confirmActionButtonLabel: this.emailI18n.confirm,
      summary: this.emailI18n.deleteConfirmationMessage,
      title: this.emailI18n.deleteConfirmationTitle
    };
    modalUtil.showGenericConfirm(config).then(function () {
      _this2.options.deleteEmail(_this2.getUpdatedEmail());
      _this2.closePopup();
    });
  };
  this.areRecipientsValid = function (checkRecipientExistence) {
    var recipientsExist = this.toRecipients.length !== 0 || this.ccRecipients.length !== 0 || this.bccRecipients.length !== 0,
      toRecipientsValid = doValidate(this.toRecipients),
      ccRecipientsValid = doValidate(this.ccRecipients),
      bccRecipientsValid = doValidate(this.bccRecipients);
    function doValidate(recipients) {
      return _.filter(recipients, function (recipient) {
        return !recipient.valid;
      }).length === 0;
    }
    return toRecipientsValid && ccRecipientsValid && bccRecipientsValid && (!checkRecipientExistence || recipientsExist);
  };
  this.userMadeChanges = function (emailType, modifiedEmailType) {
    if (this.options.email.subject !== this.subject) {
      return true;
    } else if (this.options.email.body !== this.body) {
      return true;
    } else if (this.options.email.to !== this.concatenateRecipients(this.toRecipients)) {
      return true;
    } else if (this.options.email.cc !== this.concatenateRecipients(this.ccRecipients)) {
      return true;
    } else if (this.options.email.bcc !== this.concatenateRecipients(this.bccRecipients)) {
      return true;
    } else if (!_.isEqual(this.options.email.attachments, this.selectedAttachments)) {
      return true;
    } else if (emailType !== modifiedEmailType) {
      return true;
    }
    return false;
  };
  this.onCloseClick = function () {
    var _this3 = this;
    var areRecipientsValid = this.areRecipientsValid(),
      config,
      emailType = this.options.email.type,
      modifiedEmailType = !_.isNil(this.selectedEmailType) ? this.selectedEmailType.name : null;
    if (this.userMadeChanges(emailType, modifiedEmailType) || this.options.deleteNewEmailOnCancel) {
      config = {
        cancelButtonLabel: areRecipientsValid ? this.emailI18n.closeConfirmation.cancel : this.emailI18n.closeConfirmation.alternate,
        confirmActionButtonLabel: this.emailI18n.closeConfirmation.confirm,
        summary: areRecipientsValid ? this.emailI18n.closeConfirmation.closeConfirmationMessage : this.emailI18n.closeConfirmation.invalidCloseConfirmationMessage,
        title: this.emailI18n.closeConfirmation.closeConfirmationTitle
      };
      if (areRecipientsValid) {
        config.alternateButtonLabel = this.emailI18n.closeConfirmation.alternate;
      }
      modalUtil.showGenericConfirm(config).then(function (result) {
        if (result === 'confirm' && areRecipientsValid) {
          _this3.onSaveDraftClick();
        }
        _this3.closePopup();
      });
    } else {
      this.closePopup();
    }
  };
  this.onSaveDraftClick = function () {
    this.options.saveEmail(this.getUpdatedEmail());
    this.closePopup();
  };
  this.showAddNewAttachmentModal = function (file) {
    modalUtil.showNewAttachmentModal(file, true).then(this.saveAttachment.bind(this));
  };
  this.getTitle = function () {
    return this.emailViewModel.draftTitle;
  };
  this.showAttachmentMultiSelect = function () {
    if (this.availableAttachments.length > 1) {
      this.isAttachmentDropdownOpen = true;
      $timeout(function () {
        var selectedAttachmentsUiSelectController;
        selectedAttachmentsUiSelectController = angular.element('.selectedAttachmentList .ui-select-match').controller('uiSelect');
        selectedAttachmentsUiSelectController.activate();
      }, 300);
    } else if (!this.isAttachmentDropdownOpen) {
      this.showAddNewAttachmentModal();
    }
  };
  this.hideIfNothingSelected = function () {
    if (this.selectedAttachments.length <= 0) {
      this.isAttachmentDropdownOpen = false;
    }
  };
  this.onSelect = function (item) {
    if (item.addAttachment) {
      _.remove(this.selectedAttachments, function (i) {
        return i.addAttachment === true;
      });
      this.showAddNewAttachmentModal();
    }
  };
  this.getUpdatedEmail = function () {
    var updatedEmail = _.cloneDeep(this.email);
    updatedEmail.subject = this.subject;
    updatedEmail.body = this.body;
    updatedEmail.to = this.isModeUms ? this.concatenateRecipients(this.toRecipients) : this.toRecipients;
    updatedEmail.cc = this.isModeUms ? this.concatenateRecipients(this.ccRecipients) : this.ccRecipients;
    updatedEmail.bcc = this.isModeUms ? this.concatenateRecipients(this.bccRecipients) : this.bccRecipients;
    updatedEmail.attachments = _.map(this.selectedAttachments, function (selectedAttachment) {
      delete selectedAttachment.submissionId;
      delete selectedAttachment.fieldAttachment;
      delete selectedAttachment.formTemplateDisplayName;
      delete selectedAttachment.objectUri;
      return selectedAttachment;
    });
    if (this.selectedEmailType) {
      updatedEmail.type = this.selectedEmailType.name;
    } else {
      updatedEmail.type = null;
    }
    return updatedEmail;
  };
  this.onSendClick = function () {
    this.options.sendEmail(this.getUpdatedEmail());
    this.closePopup();
  };
  this.toggleCc = function () {
    this.ccVisible = !this.ccVisible;
  };
  this.toggleBcc = function () {
    this.bccVisible = !this.bccVisible;
  };
  this.getUserId = function (item) {
    return _.isNumber(item.id) ? item.id : 0;
  };
  this.saveAttachment = function (data) {
    this.handleUploadAttachmentEmail({
      optionsData: this.options,
      data: data,
      selectedAttachments: this.selectedAttachments
    });
  };
  this.resolveRecipientObjects = function (recipients) {
    var _this4 = this;
    var recipientObjectList = [],
      recipientArray;
    if (recipients) {
      if (typeof recipients === 'string') {
        recipientArray = _.split(recipients, emailMessage.EMAIL_ADDRESS_SEPERATOR);
        if (!_.isEmpty(recipientArray)) {
          _.each(recipientArray, function (recipient) {
            recipientObjectList.push(_this4.getRecipientObject(recipient));
          });
        }
      } else {
        _.each(recipients, function (recipient) {
          recipientObjectList.push(_this4.extractRecipient(recipient));
        });
      }
    }
    return recipientObjectList;
  };
  this.extractRecipient = function (recipient) {
    var email = recipient.email,
      recipientObject = {};
    recipientObject.valid = true;
    recipientObject.id = recipient.id;
    if (!_.isNil(email)) {
      if (email.indexOf('@') > 0) {
        if (!_.isNil(recipient.name)) {
          recipientObject.name = recipient.name;
        }
      } else {
        recipientObject.name = recipient.email;
      }
      recipientObject.emailAddress = email;
      return recipientObject;
    }
  };
  this.getRecipientObject = function (recipient) {
    var recipientObject = {},
      firstIndex,
      lastIndex,
      numberOfCharacters,
      name,
      emailAddress;
    if (recipient.indexOf('<') !== -1 && recipient.indexOf('>') !== -1) {
      firstIndex = recipient.indexOf('"');
      lastIndex = recipient.lastIndexOf('"');
      numberOfCharacters = lastIndex - firstIndex - 1;
      name = recipient.substr(firstIndex + 1, numberOfCharacters);
      firstIndex = recipient.indexOf('<');
      lastIndex = recipient.lastIndexOf('>');
      numberOfCharacters = lastIndex - firstIndex - 1;
      if (!name) {
        // Some recipients might not have their name in quotes, so take the string before the <
        name = recipient.substr(0, firstIndex - 1).trim();
      }
      emailAddress = recipient.substr(firstIndex + 1, numberOfCharacters);
      recipientObject.id = recipient.id;
      recipientObject.name = name;
      recipientObject.emailAddress = emailAddress;
    } else {
      recipientObject.emailAddress = recipient;
    }
    recipientObject.valid = true;
    return recipientObject;
  };
  this.concatenateRecipients = function (recipientList) {
    var _this5 = this;
    var recipientString;
    return _.join(_.map(recipientList, function (recipient) {
      recipientString = recipient.emailAddress;
      if (recipient.name) {
        recipientString = _this5.getEmailIdentifierString(recipient.name, recipient.emailAddress);
      } else {
        recipientString = recipient.emailAddress;
      }
      return recipientString;
    }), emailMessage.EMAIL_ADDRESS_SEPERATOR);
  };
  this.getEmailIdentifierString = function (name, emailAddress) {
    return "\"".concat(name, "\" <").concat(emailAddress, ">");
  };
  this.loadUserList = function (userList) {
    if (!_.isNil(userList)) {
      this.peoplePickerList = this.getPeopleList(userList);
      this.filterItems();
      this.email = this.options.email;
      if (this.options.email.cc) {
        this.ccVisible = this.options.email.cc.length > 0;
      }
      if (this.options.email.bcc) {
        this.bccVisible = this.options.email.bcc.length > 0;
      }
      this.body = _.clone(this.options.email.body);
      this.subject = _.clone(this.options.email.subject);
      if (this.isModeUms) {
        this.isDraftEmail = this.options.email.status === emailMessageStatus.STATUS_DRAFT;
        this.selectedAttachments = _.clone(this.selectedEmailAttachments);
        this.isAttachmentDropdownOpen = this.isEmailAttachmentDropdownOpen;
        this.availableAttachments = this.availableEmailAttachments;
        this.canDeleteEmail = this.options.canDeleteEmail;
      }
    }
  };
  this.filterItems = function (searchText) {
    var filteredUsersList = [];
    var userListLength = this.peoplePickerList.length;
    var maxItems = 150;
    if (!_.isEmpty(searchText)) {
      filteredUsersList = _.filter(this.peoplePickerList, function (user) {
        return _.includes(user.name.toLowerCase(), searchText.toLowerCase());
      });
      //if after searching there are over 150 participants - still only display submissionParticipants
      if (filteredUsersList.length > maxItems) {
        filteredUsersList = this.submissionParticipantsList;
      }
    } else {
      if (userListLength > maxItems) {
        filteredUsersList = this.submissionParticipantsList;
      } else {
        filteredUsersList = this.peoplePickerList;
      }
    }
    this.filteredPeoplePickerList = filteredUsersList;
  };
  this.getPeopleList = function (users) {
    function matchRecipients(recipients, users) {
      // Match existing recipients with users in list to prevent duplicates.
      var updatedRecipients = [];
      _.each(recipients, function (recipient, index) {
        var user = null;
        user = _.find(users, function (o) {
          if (!_.isNil(o.description)) {
            return recipient.emailAddress === o.description;
          } else if (!_.isNil(recipient.name)) {
            return recipient.name && recipient.name === o.name && recipient.emailAddress === o.emailAddress;
          } else {
            return recipient.emailAddress === o.emailAddress;
          }
        });
        if (user) {
          updatedRecipients.push(user);
        } else {
          if (_.isNil(recipient['id'])) {
            recipient.id = 'a' + index;
          }
          updatedRecipients.push(recipient);
        }
      });
      return updatedRecipients;
    }
    this.toRecipients = matchRecipients(this.resolveRecipientObjects(this.options.email.to), users);
    this.ccRecipients = matchRecipients(this.resolveRecipientObjects(this.options.email.cc), users);
    this.bccRecipients = matchRecipients(this.resolveRecipientObjects(this.options.email.bcc), users);
    _.remove(users, function (user) {
      return user.group === 'User Groups';
    });
    _.map(users, function (user) {
      user.valid = true;
      user.id = null;
      return user;
    });
    var submissionParticipants = users.filter(function (user) {
      return user.group === 'Submission Participants';
    });
    this.submissionParticipantsList = submissionParticipants;
    this.submissionParticipantsList.push({
      id: this.submissionParticipantsList.length,
      name: this.emailI18n.longListMessage,
      disabled: true
    });
    return users;
  };
  this.setupToolbar = function () {
    var _this7 = this;
    var attachmentTooltip = this.addAnAttachmentText,
      inserList = [];
    var AttachmentButton = function AttachmentButton() {
      var _this6 = this;
      var ui = $.summernote.ui,
        button = ui.button({
          className: 'dropdown-toggle',
          contents: '<i class="glyphicon glyphicon-paperclip" uib-dropdown-toggle></i>',
          tooltip: attachmentTooltip,
          click: function click() {
            _this6.showAttachmentMultiSelect();
          }
        });
      return button.render();
    };
    inserList.push('link');
    if (this.showAttachment) {
      inserList.push('attachment');
    }
    this.optionsList = {
      toolbar: [['style', ['style']], ['font', ['bold', 'underline', 'italic', 'clear']], ['fontname', ['fontname']], ['color', ['color']], ['para', ['ul', 'ol', 'paragraph']], ['insert', inserList]],
      buttons: {
        attachment: AttachmentButton.bind(this)
      },
      dialogsInBody: true,
      disableResizeEditor: true,
      disableLinkTarget: true,
      defaultLinkTargetNewWindow: true,
      disableDragAndDrop: true,
      fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Helvetica', 'Impact', 'Lato', 'Tahoma', 'Times New Roman', 'Verdana'],
      callbacks: {
        onKeyup: function onKeyup() {
          $timeout(function () {
            _this7.updateEmailBody();
          }, 250);
        },
        onBlur: function onBlur() {
          $timeout(function () {
            _this7.updateEmailBody();
          }, 250);
        }
      },
      onCreateLink: function onCreateLink(linkUrl) {
        return linkUrl;
      },
      onCreateLinkText: function onCreateLinkText(linkText) {
        return linkText;
      }
    };
  };
  this.updateEmailBody = function () {
    $rootScope.$broadcast(emailEditorConstant.event.EMAIL_UPDATE_COMPLETE, this.getUpdatedEmail(), true);
  };
  this.loadAttachments = function () {
    this.loadEmailAttachments();
  };
  this.injectAddAttachmentOption = function () {
    if (this.availableAttachments) {
      if (this.availableAttachments.length > 0) {
        this.availableAttachments.push({
          name: this.addAnAttachmentText,
          addAttachment: true
        });
      }
    }
  };
  this.init = function () {
    var _this8 = this;
    this.getAttachmentTypes().then(function (result) {
      _this8.typeDataItems = result;
      _this8.selectedEmailType = _.find(result, {
        name: _this8.options.email.type
      });
    });
    this.setupToolbar();
    if (this.isModeUms) {
      this.injectAddAttachmentOption();
    }
    loadingBarHandler.hideLoadingBar();
  };
  this.getAttachmentTypes = function () {
    return dataSetUtil.getDataItems({
      name: 'Attachment Types'
    });
  };
  this.handleChange = function () {
    $rootScope.$broadcast(emailEditorConstant.event.EMAIL_UPDATE_COMPLETE, this.getUpdatedEmail(), false);
  };
  this.getLabel = function (item) {
    return item.description ? item.description : item.name ? item.name : item.emailAddress;
  };
};
EmailEditorController.$inject = ["$rootScope", "$scope", "$timeout", "$window", "$sanitize", "coreConstant", "coreMediator", "emailMessageStatus", "modalUtil", "attachmentUtil", "loadingBarHandler", "dataSetUtil", "emailEditorConstant", "emailMessage"];
angular.module('gw-um-email-editor').controller('emailEditorController', EmailEditorController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4)))

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var PropertiesFilter = function PropertiesFilter() {
  return function (items, props) {
    var out = [];
    if (_.isArray(items)) {
      var keys = Object.keys(props);
      _.each(items, function (item) {
        var itemMatches = false,
          prop,
          text;
        for (var i = 0; i < keys.length; i++) {
          prop = keys[i];
          text = props[prop].toLowerCase();
          if (!_.isNil(item[prop]) && item[prop].toString().toLowerCase().indexOf(text) !== -1) {
            itemMatches = true;
            break;
          }
        }
        if (itemMatches) {
          out.push(item);
        }
      });
    } else {
      // Let the output be the input untouched
      out = items;
    }
    return out;
  };
};
angular.module('gw-um-email-editor').filter('propertiesFilter', PropertiesFilter);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 1714 */
/***/ (function(module) {

module.exports = JSON.parse("{}");

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 1716 */
/***/ (function(module, exports) {

var path = '/header.tpl.html';
var html = "<div class=\"appHeader\" app-mode-configuration>\n\n    <div class=\"navContainer leftSide\">\n\n        <div class=\"logo navElement\">\n\n            <span class=\"logoElement\"\n                  ui-logo\n                  logo-url=\"{{ ::$ctrl.logoUrl }}\"\n                  logo-configured-file-name=\"{{ ::$ctrl.logoConfiguredFileName }}\">\n            </span>\n        </div>\n\n        <div ng-transclude=\"leftSide\"></div>\n\n        <admin-function-header-buttons></admin-function-header-buttons>\n    </div>\n\n    <div class=\"navContainer rightSide\">\n        <div ng-transclude=\"rightSide\"></div>\n\n        <ui-user-profile-button show-chat-icon=\"$ctrl.showChatIcon\"\n                                menu-items=\"$ctrl.menuItems\"></ui-user-profile-button>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1717 */
/***/ (function(module, exports) {

var HeaderComponent = {
  templateUrl: '/header.tpl.html',
  controller: 'headerController',
  transclude: {
    leftSide: 'uiHeaderLeftSide',
    rightSide: 'uiHeaderRightSide'
  },
  bindings: {
    logoConfiguredFileName: '<',
    logoUrl: '<',
    menuItems: '<',
    showChatIcon: '<'
  }
};
angular.module('gw-um-header').component('uiHeader', HeaderComponent);

/***/ }),
/* 1718 */
/***/ (function(module, exports) {

/*@ngInject*/
var HeaderController = function HeaderController() {};
angular.module('gw-um-header').controller('headerController', HeaderController);

/***/ }),
/* 1719 */
/***/ (function(module, exports) {

/*@ngInject*/
var HeaderUtil = function HeaderUtil($state) {
  this.isActiveNavElement = function (type) {
    return $state.current.name.indexOf(type) !== -1;
  };
};
HeaderUtil.$inject = ["$state"];
angular.module('gw-um-header').service('headerUtil', HeaderUtil);

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 1721 */
/***/ (function(module, exports) {

var path = '/help/help.tpl.html';
var html = "<div class=\"help\"\n     ng-click=\"$ctrl.onIconClick($event)\"\n     uib-tooltip=\"{{ ::$ctrl.i18n.tooltip }}\"\n     tooltip-popup-delay=\"500\"\n     tooltip-append-to-body=\"true\"\n     tooltip-placement=\"bottom\">\n    <i class=\"fa fa-question-circle-o helpIcon\"\n       aria-hidden=\"true\"></i>\n</div>\n\n<div ng-if=\"$ctrl.isOpen\"\n     class=\"arrowUp\"></div>\n\n<div ng-if=\"$ctrl.isOpen\"\n     class=\"helpPopout\"\n     ui-auto-close\n     on-close=\"$ctrl.onIconClick()\"\n     is-open=\"$ctrl.isOpen\">\n\n    <ul class=\"content\">\n        <li class=\"menuRow helpMenuRow\"\n            ng-click=\"$ctrl.showOnlineHelp($ctrl.topic)\">\n\n            <span class=\"glyphicon glyphicon-question-sign\"></span>\n            <span>{{ ::$ctrl.i18n.helpMenu.onlineHelp }}</span>\n        </li>\n\n        <li class=\"menuRow helpMenuRow\"\n            ng-click=\"$ctrl.showAboutUms()\">\n\n            <span class=\"glyphicon glyphicon-info-sign\"></span>\n            <span>{{ ::$ctrl.aboutUmsLabel }}</span>\n        </li>\n    </ul>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1722 */
/***/ (function(module, exports) {

var HelpComponent = {
  templateUrl: '/help/help.tpl.html',
  controller: 'helpController',
  bindings: {
    topic: '@'
  }
};
angular.module('gw-um-header').component('uiHelp', HelpComponent);

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var locale = __webpack_require__(770);

/*@ngInject*/
var HelpController = function HelpController($uibModal, $window, appTypeConfigurationModel, coreMediator, coreConstant) {
  this.i18n = locale;
  this.isOpen = false;
  this.$onInit = function () {
    var consoleType = appTypeConfigurationModel.getConsoleType();
    switch (consoleType) {
      case coreConstant.authorization.CONSOLE_TYPE_UM:
      case coreConstant.authorization.CONSOLE_TYPE_UM_AGENT:
        this.aboutUmsLabel = this.i18n.helpMenu.aboutUm;
        break;
      case coreConstant.authorization.CONSOLE_TYPE_UM_STUDIO:
        this.aboutUmsLabel = this.i18n.helpMenu.aboutUmStudio;
        break;
    }
  };
  this.onIconClick = function () {
    this.isOpen = !this.isOpen;
  };
  this.showAboutUms = function () {
    coreMediator.getUmVersionNumber().then(function (versionNumberDetail) {
      coreMediator.getRevision().then(function (revisionDetail) {
        $uibModal.open({
          templateUrl: '/help/aboutUmsModal/aboutUmsModal.tpl.html',
          controller: 'aboutUmsModalController',
          backdrop: 'static',
          windowClass: 'aboutUmsModal',
          resolve: {
            options: function options() {
              return {
                revNumber: revisionDetail.revNumber,
                umVersionNumber: versionNumberDetail.customerReleaseName
              };
            }
          }
        });
      });
    });
    this.isOpen = !this.isOpen;
  };
  this.showOnlineHelp = function (topic) {
    var url = "../".concat(this.i18n.url.prefix, "/").concat(_.get(this.i18n.url, appTypeConfigurationModel.getUserType()), "/").concat(this.i18n.url.index);
    if (!_.isEmpty(topic)) {
      url += '#cshid=' + topic;
    }
    $window.open(url, '_blank');
    this.isOpen = !this.isOpen;
  };
};
HelpController.$inject = ["$uibModal", "$window", "appTypeConfigurationModel", "coreMediator", "coreConstant"];
angular.module('gw-um-header').controller('helpController', HelpController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 1725 */
/***/ (function(module, exports) {

var path = '/help/aboutUmsModal/aboutUmsModal.tpl.html';
var html = "<base-modal\n    modal-title=\"viewModel.title\"\n    ok=\"i18n.okButton\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\">\n\n    <div class=\"aboutUmsModal\">\n\n        <div class=\"drawer\">\n\n            <div class=\"drawerRow\">\n\n                <div class=\"drawerCol svnRevisionLabel\">\n                    <label class=\"svnRevisionLabel\">{{ ::i18n.svnRevision }}</label>\n                </div>\n\n                <div class=\"drawerCol\">\n                    <label class=\"svnRevisionValue\">{{ ::viewModel.svnRevision }}</label>\n                </div>\n            </div>\n\n            <div class=\"drawerRow\">\n\n                <div class=\"drawerCol browserInfoLabel\">\n                    <label class=\"browserInfoLabel\">{{ ::i18n.browserInfo }}</label>\n                </div>\n\n                <div class=\"drawerCol\">\n                    <label class=\"browserInfoValue\">{{ ::viewModel.browserType }}</label>\n                </div>\n            </div>\n\n            <div class=\"drawerRow\">\n\n                <div class=\"drawerCol versionNumberValue\">\n                    <label>{{ ::viewModel.versionNumberLabel }}</label>\n                </div>\n\n                <div class=\"drawerCol\">\n                    <label class=\"versionNumberValue\">{{ ::viewModel.umVersionNumber }}</label>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"copyRight\" ng-bind-html=\"viewModel.message\"></div>\n\n    </div>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

var locale = __webpack_require__(771);

/*@ngInject*/
var AboutUmsModalController = function AboutUmsModalController($rootScope, $scope, coreConstant, options, appTypeConfigurationModel, browserUtil) {
  $scope.i18n = locale;
  $scope.viewModel = {
    svnRevision: options.revNumber,
    browserType: browserUtil.getBrowserInfo(),
    umVersionNumber: options.umVersionNumber,
    versionNumberLabel: options.versionNumberLabel,
    message: locale.copyright
  };
  function init() {
    var consoleType = appTypeConfigurationModel.getConsoleType();
    switch (consoleType) {
      case coreConstant.authorization.CONSOLE_TYPE_UM:
      case coreConstant.authorization.CONSOLE_TYPE_UM_AGENT:
        $scope.viewModel.title = $scope.i18n.titleUM;
        $scope.viewModel.versionNumberLabel = $scope.i18n.umVersionNumber;
        break;
      case coreConstant.authorization.CONSOLE_TYPE_UM_STUDIO:
        $scope.viewModel.title = $scope.i18n.titleUMStudio;
        $scope.viewModel.versionNumberLabel = $scope.i18n.umStudioVersionNumber;
        break;
    }
  }
  $scope.onConfirm = function () {
    $scope.$close();
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
  init();
};
AboutUmsModalController.$inject = ["$rootScope", "$scope", "coreConstant", "options", "appTypeConfigurationModel", "browserUtil"];
angular.module('gw-um-header').controller('aboutUmsModalController', AboutUmsModalController);

/***/ }),
/* 1727 */
/***/ (function(module) {

module.exports = JSON.parse("{}");

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 1729 */
/***/ (function(module, exports) {

var path = '/adminFunctionHeaderButtons/adminFunctionHeaderButtons.tpl.html';
var html = "<div class=\"adminFunctionHeaderButtons\">\n\n    <div class=\"navigationDropdown {{::item.name}}\"\n         ng-repeat=\"item in $ctrl.tabList track by item.name\"\n         uib-dropdown\n         ng-class=\"{'active': $ctrl.isNavElementSelected(item.name)}\">\n\n        <div uib-dropdown-toggle>\n            {{ ::item.name }}\n        </div>\n\n        <ul uib-dropdown-menu>\n            <li ng-repeat=\"subTab in item.subTabs\"\n                ng-click=\"$ctrl.onNavigationItemClick(item.name, subTab)\">\n\n                <button class=\"btn btn-link\"\n                        ng-disabled=\"$ctrl.isNavElementDisabled(item.name, subTab)\">\n                    {{ ::subTab }}\n                </button>\n            </li>\n        </ul>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1730 */
/***/ (function(module, exports) {

var AdminFunctionHeaderButtonsComponent = {
  templateUrl: '/adminFunctionHeaderButtons/adminFunctionHeaderButtons.tpl.html',
  controller: 'adminFunctionHeaderButtonsController',
  bindings: {}
};
angular.module('gw-um-header').component('adminFunctionHeaderButtons', AdminFunctionHeaderButtonsComponent);

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var AdminFunctionHeaderButtonsController = function AdminFunctionHeaderButtonsController($state, headerUtil, adminFunctionHeaderButtonsMediator, userType, navigationStateModel, adminFunctionHeaderButtonsModel) {
  this.tabList = [];
  this.loadAvailableActions = function () {
    var _this = this;
    adminFunctionHeaderButtonsMediator.getAvailableAdminFunctions().then(function (actions) {
      _.each(actions, function (value, key) {
        var item = {};
        item.name = key;
        item.subTabs = actions[key];
        _this.tabList.push(item);
      });
    });
  };
  this.isNavElementDisabled = function (tabName, subTabName) {
    return !adminFunctionHeaderButtonsModel.getStateMappings(tabName, subTabName);
  };
  this.isNavElementSelected = function (name) {
    var active = false;
    _.each(adminFunctionHeaderButtonsModel.navigationMappings[name], function (state) {
      if (headerUtil.isActiveNavElement(state.state)) {
        active = true;
        return false;
      }
    });
    return active;
  };
  this.onNavigationItemClick = function (tabName, subTabName) {
    var newState = adminFunctionHeaderButtonsModel.getStateMappings(tabName, subTabName);
    var userState, navigationState;
    if (newState.state === 'userList') {
      userState = "".concat(newState.state, ":").concat(newState.params.userType);
      navigationState = navigationStateModel.restoreViewState(userState);
    } else {
      navigationState = navigationStateModel.restoreViewState(newState.state);
    }
    if (!_.isNil(navigationState)) {
      if (navigationState.parentState === newState.state || navigationState.parentState === userState) {
        if (!_.isNil(navigationState.currentState) && !_.isNil(navigationState.data)) {
          $state.go(navigationState.currentState, navigationState.data);
        }
      }
    } else {
      $state.go(newState.state, newState.params);
    }
  };
  this.loadAvailableActions();
};
AdminFunctionHeaderButtonsController.$inject = ["$state", "headerUtil", "adminFunctionHeaderButtonsMediator", "userType", "navigationStateModel", "adminFunctionHeaderButtonsModel"];
angular.module('gw-um-header').controller('adminFunctionHeaderButtonsController', AdminFunctionHeaderButtonsController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 1732 */
/***/ (function(module, exports) {

/*@ngInject*/
var AdminFunctionHeaderButtonsMediator = function AdminFunctionHeaderButtonsMediator(adminFunctionHeaderButtonsRepository) {
  this.getAvailableAdminFunctions = function () {
    return adminFunctionHeaderButtonsRepository.getAvailableAdminFunctions();
  };
};
AdminFunctionHeaderButtonsMediator.$inject = ["adminFunctionHeaderButtonsRepository"];
angular.module('gw-um-header').service('adminFunctionHeaderButtonsMediator', AdminFunctionHeaderButtonsMediator);

/***/ }),
/* 1733 */
/***/ (function(module, exports) {

/*@ngInject*/
var AdminFunctionHeaderButtonsRepository = function AdminFunctionHeaderButtonsRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getAvailableAdminFunctions = function (userId) {
    var url = '/rest/AdminFunction/availableAdminFunctions';
    return this.get(url);
  };
};
AdminFunctionHeaderButtonsRepository.$inject = ["baseRepository"];
angular.module('gw-um-header').service('adminFunctionHeaderButtonsRepository', AdminFunctionHeaderButtonsRepository);

/***/ }),
/* 1734 */
/***/ (function(module, exports) {

/*@ngInject*/
var AdminFunctionHeaderButtonsModel = function AdminFunctionHeaderButtonsModel(adminFunctionConstants, userType, organizationType) {
  this.tabList = [];
  this.navigationMappings = {};
  this.navigationMappings[adminFunctionConstants.CONFIGURATION_TAB] = {};
  this.navigationMappings[adminFunctionConstants.USERS_TAB] = {};
  this.navigationMappings[adminFunctionConstants.ORGANIZATIONS_TAB] = {};
  this.navigationMappings[adminFunctionConstants.NOTIFICATIONS_TAB] = {};
  this.navigationMappings[adminFunctionConstants.PERMISSIONS_TAB] = {};
  this.navigationMappings[adminFunctionConstants.PREFERENCES_TAB] = {};
  this.setupStateMappings = function () {
    this.navigationMappings[adminFunctionConstants.CONFIGURATION_TAB][adminFunctionConstants.CONFIGURATION_FORMS] = {
      state: 'configuration.formTemplateBrowser',
      params: {}
    };
    this.navigationMappings[adminFunctionConstants.CONFIGURATION_TAB][adminFunctionConstants.CONFIGURATION_DATA_SETS] = {
      state: 'configuration.dataSetBrowser',
      params: {}
    };
    this.navigationMappings[adminFunctionConstants.CONFIGURATION_TAB][adminFunctionConstants.CONFIGURATION_RULES] = {
      state: 'configuration.rulesBrowser'
    };
    this.navigationMappings[adminFunctionConstants.CONFIGURATION_TAB][adminFunctionConstants.CONFIGURATION_PRODUCTS] = {
      state: 'configuration.productTemplateBrowser',
      params: {}
    };
    this.navigationMappings[adminFunctionConstants.CONFIGURATION_TAB][adminFunctionConstants.CONFIGURATION_SECTIONS] = {
      state: 'configuration.sectionTemplateBrowser',
      params: {}
    };
    this.navigationMappings[adminFunctionConstants.CONFIGURATION_TAB][adminFunctionConstants.CONFIGURATION_SCORING_RULES] = {
      state: 'configuration.scoringRulesBrowser',
      params: {}
    };
    this.navigationMappings[adminFunctionConstants.CONFIGURATION_TAB][adminFunctionConstants.CONFIGURATION_RATE_STATUS] = {
      state: 'configuration.rateStatus',
      params: {}
    };
    this.navigationMappings[adminFunctionConstants.USERS_TAB][adminFunctionConstants.USERS_AGENCY_BROKERAGE_USERS] = {
      state: 'userList',
      params: {
        userType: userType.AGENCY_BROKERAGE
      }
    };
    this.navigationMappings[adminFunctionConstants.USERS_TAB][adminFunctionConstants.USERS_UNDERWRITERS] = {
      state: 'userList',
      params: {
        userType: userType.UNDERWRITER
      }
    };
    this.navigationMappings[adminFunctionConstants.USERS_TAB][adminFunctionConstants.SERVICE_TEAM_USERS] = {
      state: 'userList',
      params: {
        userType: userType.SERVICE
      }
    };
    this.navigationMappings[adminFunctionConstants.USERS_TAB][adminFunctionConstants.SYSTEM_USERS] = {
      state: 'userList',
      params: {
        userType: userType.SYSTEM
      }
    };
    this.navigationMappings[adminFunctionConstants.USERS_TAB][adminFunctionConstants.USERS_USER_GROUPS] = {
      state: 'userGroups',
      params: {
        userType: userType.USERS_USER_GROUPS
      }
    };
    this.navigationMappings[adminFunctionConstants.USERS_TAB]['userSubTab'] = {
      state: 'manageUser.form'
    };
    this.navigationMappings[adminFunctionConstants.ORGANIZATIONS_TAB][adminFunctionConstants.ORGANIZATIONS_AGENCY_BROKERAGE] = {
      state: 'configuration.organizationBrowser',
      params: {
        organizationType: organizationType.AGENCY
      }
    };
    this.navigationMappings[adminFunctionConstants.ORGANIZATIONS_TAB][adminFunctionConstants.ORGANIZATIONS_MGA_AGENCY_BROKERAGE] = {
      state: 'configuration.organizationBrowser',
      params: {
        organizationType: organizationType.MGA_AGENCY
      }
    };
    this.navigationMappings[adminFunctionConstants.ORGANIZATIONS_TAB][adminFunctionConstants.ORGANIZATIONS_CARRIER_ORGANIZATION] = {
      state: 'configuration.organizationBrowser',
      params: {
        organizationType: organizationType.CARRIER
      }
    };
    this.navigationMappings[adminFunctionConstants.ORGANIZATIONS_TAB][adminFunctionConstants.ORGANIZATIONS_MGA_ORGANIZATION] = {
      state: 'configuration.organizationBrowser',
      params: {
        organizationType: organizationType.MGA_CARRIER
      }
    };
    this.navigationMappings[adminFunctionConstants.PERMISSIONS_TAB][adminFunctionConstants.PERMISSIONS_AGENCY_BROKERAGE] = {
      state: 'configuration.permissionsEditor',
      params: {
        userType: userType.AGENCY_BROKERAGE
      }
    };
    this.navigationMappings[adminFunctionConstants.PERMISSIONS_TAB][adminFunctionConstants.PERMISSIONS_SERVICE_TEAM] = {
      state: 'configuration.permissionsEditor',
      params: {
        userType: userType.SERVICE
      }
    };
    this.navigationMappings[adminFunctionConstants.PERMISSIONS_TAB][adminFunctionConstants.PERMISSIONS_SYSTEM] = {
      state: 'configuration.permissionsEditor',
      params: {
        userType: userType.SYSTEM
      }
    };
    this.navigationMappings[adminFunctionConstants.PERMISSIONS_TAB][adminFunctionConstants.PERMISSIONS_UNDERWRITING] = {
      state: 'configuration.permissionsEditor',
      params: {
        userType: userType.UNDERWRITER
      }
    };
    this.navigationMappings[adminFunctionConstants.NOTIFICATIONS_TAB][adminFunctionConstants.NOTIFICATIONS_EMAIL] = {
      state: 'configuration.emailBrowser',
      params: {}
    };
    this.navigationMappings[adminFunctionConstants.NOTIFICATIONS_TAB][adminFunctionConstants.NOTIFICATIONS_POP_UP] = {
      state: 'configuration.popupBrowser',
      params: {}
    };
    this.navigationMappings[adminFunctionConstants.PREFERENCES_TAB][adminFunctionConstants.PREFERENCES_GENERAL] = {
      state: 'configuration.systemPreferencesManager',
      params: {}
    };
    this.navigationMappings[adminFunctionConstants.PREFERENCES_TAB][adminFunctionConstants.PREFERENCES_FILES_AND_ICONS] = {
      state: 'configuration.filesAndIconsManager',
      params: {}
    };
  };
  this.getStateMappings = function (name, subTab) {
    return this.navigationMappings[name][subTab];
  };
  this.setupStateMappings();
};
AdminFunctionHeaderButtonsModel.$inject = ["adminFunctionConstants", "userType", "organizationType"];
angular.module('gw-um-header').service('adminFunctionHeaderButtonsModel', AdminFunctionHeaderButtonsModel);

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 1736 */
/***/ (function(module, exports) {

var path = '/userProfileButton/userProfileButton.tpl.html';
var html = "<div class=\"user\">\n\n    <div class=\"userIcon\"\n         ng-click=\"$ctrl.onIconClick($event)\"\n         uib-tooltip=\"{{ ::$ctrl.i18n.tooltip }}\"\n         tooltip-popup-delay=\"500\"\n         tooltip-append-to-body=\"true\"\n         tooltip-placement=\"bottom\">\n\n        <ui-user-avatar userid=\"{{ $ctrl.userId }}\"\n                        disablebusinesscard=\"true\"></ui-user-avatar>\n\n        <div class=\"userEnv\">\n\n            <div class=\"nameOnlineStatus\">\n\n                <div class=\"firstName\">{{ $ctrl.firstName }}</div>\n\n                <span ng-if=\"$ctrl.visibleForChat && $ctrl.showChatIcon\"\n                      class=\"glyphicon glyphicon-online\"></span>\n\n                <span ng-if=\"!$ctrl.visibleForChat && $ctrl.showChatIcon\"\n                      class=\"glyphicon glyphicon-offline\"></span>\n            </div>\n\n            <ui-environment></ui-environment>\n        </div>\n    </div>\n\n    <div ng-if=\"$ctrl.isOpen\"\n         class=\"arrowUp\"></div>\n\n    <div ng-show=\"$ctrl.isOpen\"\n         class=\"userPopout\"\n         ui-auto-close\n         on-close=\"$ctrl.onIconClick()\"\n         is-open=\"$ctrl.isOpen\">\n\n        <ui-user-profile-dropdown menu-items=\"$ctrl.menuItems\"></ui-user-profile-dropdown>\n    </div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1737 */
/***/ (function(module, exports) {

var UserProfileButtonComponent = {
  templateUrl: '/userProfileButton/userProfileButton.tpl.html',
  controller: 'userProfileButtonController',
  bindings: {
    showChatIcon: '<',
    menuItems: '<'
  }
};
angular.module('gw-um-header').component('uiUserProfileButton', UserProfileButtonComponent);

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

var locale = __webpack_require__(772);

/*@ngInject*/
var UserProfileButtonController = function UserProfileButtonController($scope, $element, $window, loginRepository, headerConstant, coreMediator, coreConstant, preferenceModel, userStateModel) {
  var _this2 = this;
  this.i18n = locale;
  $element.addClass('userProfileButton');
  this.isOpen = false;
  this.visibleForChat = userStateModel.isVisibleForChat();
  window.onunload = function () {
    console.log("onunload...");
    fetch('/rest/Session/preDestroy', {
      method: 'post',
      headers: {
        "Authorization": coreMediator.getLoginTokenAuthorizationHeader()
      },
      keepalive: true // this is important to make sure the request is sent!
    });
  };
  this.onIconClick = function () {
    this.isOpen = !this.isOpen;
  };
  this.loadProfileInfo = function () {
    var _this = this;
    coreMediator.loadUserProfile().then(function (userProfile) {
      _this.userId = userProfile.userId;
      _this.firstName = userProfile.firstName;
    });
  };
  $scope.$on(coreConstant.event.CHAT_VISIBILITY_CHANGED, function () {
    _this2.visibleForChat = userStateModel.isVisibleForChat();
  });
  $scope.$on(headerConstant.event.CLOSE_USER_PROFILE_DROPDOWN, function () {
    _this2.isOpen = false;
  });
  this.loadProfileInfo();
};
UserProfileButtonController.$inject = ["$scope", "$element", "$window", "loginRepository", "headerConstant", "coreMediator", "coreConstant", "preferenceModel", "userStateModel"];
angular.module('gw-um-header').controller('userProfileButtonController', UserProfileButtonController);

/***/ }),
/* 1739 */
/***/ (function(module) {

module.exports = JSON.parse("{}");

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

var path = '/userProfileButton/environment/environment.tpl.html';
var html = "<div class=\"env\"\n     ng-if=\"$ctrl.showEnvironment\">\n    {{ ::$ctrl.environment }}\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1742 */
/***/ (function(module, exports) {

var EnvironmentComponent = {
  templateUrl: '/userProfileButton/environment/environment.tpl.html',
  controller: 'environmentController',
  bindings: {}
};
angular.module('gw-um-header').component('uiEnvironment', EnvironmentComponent);

/***/ }),
/* 1743 */
/***/ (function(module, exports) {

/*@ngInject*/
var EnvironmentController = function EnvironmentController(preferenceModel, appTypeConfigurationModel) {
  var isDemoEnvironment = preferenceModel.get('system.environment.demo'),
    isProdEnvironment = preferenceModel.get('system.environment.production'),
    isDevelopment = isDemoEnvironment === 'false' && isProdEnvironment === 'false' ? true : false,
    isProduction = isProdEnvironment === 'true' ? true : false,
    isSystemUser = appTypeConfigurationModel.getUserType() === 'SystemUser' ? true : false,
    isUnderwritingUser = appTypeConfigurationModel.isUnderwriterWorkstation() || appTypeConfigurationModel.isAgentConsole();
  this.environment = preferenceModel.get('system.environment.name');
  this.showEnvironment = isUnderwritingUser && isDevelopment || isSystemUser && (isDevelopment || isProduction);
};
EnvironmentController.$inject = ["preferenceModel", "appTypeConfigurationModel"];
angular.module('gw-um-header').controller('environmentController', EnvironmentController);

/***/ }),
/* 1744 */
/***/ (function(module) {

module.exports = JSON.parse("{}");

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 1746 */
/***/ (function(module, exports) {

var path = '/userProfileButton/userProfileDropdown/userProfileDropdown.tpl.html';
var html = "<ul class=\"content\">\n\n    <li ng-repeat=\"menuItem in $ctrl.menuItems track by $index\"\n        ng-if=\"menuItem.enabled\"\n        class=\"menuRow userProfileMenuRow {{ ::menuItem.identifier }}MenuItem\"\n        ng-click=\"$ctrl.onClick(menuItem)\">\n\n        <span class=\"glyphicon {{ ::menuItem.iconClass }}\"></span>\n\n        <span>{{ ::menuItem.label }}</span>\n    </li>\n\n    <iframe src=\"about:blank\" class=\"ieMaskFrame\" ui-browser-detection></iframe>\n</ul>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1747 */
/***/ (function(module, exports) {

var UserProfileDropdownComponent = {
  templateUrl: '/userProfileButton/userProfileDropdown/userProfileDropdown.tpl.html',
  controller: 'userProfileDropdownController',
  bindings: {
    menuItems: '<'
  }
};
angular.module('gw-um-header').component('uiUserProfileDropdown', UserProfileDropdownComponent);

/***/ }),
/* 1748 */
/***/ (function(module, exports) {

/*@ngInject*/
var UserProfileDropdownController = function UserProfileDropdownController($rootScope, headerConstant) {
  this.onClick = function (menuItem) {
    $rootScope.$broadcast(headerConstant.event.CLOSE_USER_PROFILE_DROPDOWN);
    menuItem.action();
  };
};
UserProfileDropdownController.$inject = ["$rootScope", "headerConstant"];
angular.module('gw-um-header').controller('userProfileDropdownController', UserProfileDropdownController);

/***/ })
])]);